import { registerLocaleData, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import * as i1 from '@ngx-translate/core';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import localeBG from '@angular/common/locales/bg';
import localeEN from '@angular/common/locales/en';
import localeCS from '@angular/common/locales/cs';
import localeDA from '@angular/common/locales/da';
import localeDE from '@angular/common/locales/de';
import localeEL from '@angular/common/locales/el';
import localeES from '@angular/common/locales/es';
import localeET from '@angular/common/locales/et';
import localeFI from '@angular/common/locales/fi';
import localeFR from '@angular/common/locales/fr';
import localeHR from '@angular/common/locales/hr';
import localeHU from '@angular/common/locales/hu';
import localeIT from '@angular/common/locales/it';
import localeLT from '@angular/common/locales/lt';
import localeLV from '@angular/common/locales/lv';
import localeNB from '@angular/common/locales/nb';
import localeNL from '@angular/common/locales/nl';
import localePL from '@angular/common/locales/pl';
import localePT from '@angular/common/locales/pt';
import localeRO from '@angular/common/locales/ro';
import localeSL from '@angular/common/locales/sl';
import localeSV from '@angular/common/locales/sv';
import localeAR from '@angular/common/locales/ar';

var about$m = {
	contribute: "Ако желаете да дадете своя принос за превода на софтуера на друг език или  да подобрите съществуващите преводи, препоръчваме Ви да  <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">read the page describing the steps to follow</a>.",
	description: "Този инструмент е първоначално създаден от  <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, френският надзорен орган по защита на данните, с цел да помогне на обработващите лични данни да постигнат съответствие с Общия регламент относно защитата на данните (ОРЗД). Той е разработен от <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Този софтуер е безплатен и свободно достъпен. Ако искате да се включите в проекта, можете да изтеглите изходния код от Github, да го модифицирате и да го споделите с общността.",
	licences: "Лицензи на библиотеки:",
	title: "Относно инструмента ОВЗД",
	translators: "Софтуерът за ОВЗД в момента е наличен на различни езици. Версиите на френски и английски са осигурени от CNIL. Останалите езикови версии са резултат от приноса на следните лица:",
	translators_name: "<ul><li>Български : <a target=\"_blank\" href=\"https://github.com/AlexanderTonev\">Александър Тонев</a>;</li><li>Хърватски : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Чешки : Jiří Grohmann, Manuel d’Orso ;</li><li>Датски : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Нидерландски : Ruud van Driel, Manuel d’Orso ;</li><li>Английски : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Естонски : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Фински : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Немски  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Гръъцки : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Унгарски : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Италиански : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Литовски : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Норвежки : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Полски : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Португалски : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Румънски : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Испански : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Номер на версията"
};
var action_plan$m = {
	acceptable_measures: "Приемливи мерки",
	edit: "Редактирайте",
	improvable_measures: "Мерки които може да се подобрят",
	measures: "Планирани или съществуващи мерки",
	no_action_plan: "Не е записан план за действие.",
	placeholder_person_in_charge: "Отговорен за прилагането",
	principles: "Основни принципи",
	risk1: "Незаконен достъп до данните",
	risk2: "Нежелани изменения на данните",
	risk3: "Изчезване на данните",
	risks: "Рискове",
	title: "Преглед"
};
var authentication$m = {
	"12_characters": "12 символа",
	account_recovery: "Възстановяване на паролата",
	activation_code: "Код за активиране",
	cancel: "Отмени",
	confirm: "Потвърди",
	confirmation: "Потвърждение",
	"continue": "Продължи",
	activate_account: "Активирай акаунта",
	create_account: "Създаване на акаунт",
	create_account2: "Създай акаунт",
	description: "Този софтуер, предоставен от <strong>френския надзорен орган по защита на данните (CNIL)</strong> е предназначен да подпомогне администраторите на данни в постигане и демонстриране на съответствие с ОРЗД. Той съдейства за правилно извършване на оценка на въздействието върху защитата на данните чрез прилагане на метода за оценка, разработен от френския надзорен орган CNIL.",
	email: "Електронна поща",
	email_placeholder: "Електронна поща",
	forgotten_password: "Забравена парола?",
	login: "Влизане",
	lowercase: "Малки букви",
	password: "Парола",
	password_security: "Сигурност на паролата",
	recovery_code: "Код за възстановяване",
	recovery_code_message: "Писмо съдържащо код беше изпратено на този електронен адрес. Моля въведете кода в полето по-долу.",
	recovery_code_not_sent: "Не е получен код?",
	saved_password: "Паролата ви е запазена. Можете да се впишете и влезете в програмата.",
	sign_in: "Влизане",
	sign_in_button: "Влезте",
	sign_out_button: "Отпишете се",
	special_character: "Специални символи (!@#$%^&*()?...)",
	number: "Число",
	start: "Старт",
	start_app: "Достъп до софтуера за ОВЗД (Beta)",
	subtitle1: "Платформа за създаване <br> и управление на вашите ОВЗД",
	subtitle2: "Инструменти за достъп и обяснения на термините",
	title: "Оценка на въздействието върху защитата на данните",
	transaction_error: "Искането ви не може да бъде изпълнено.",
	uppercase: "Главни букви",
	wrong_activation_code: "(грешно)",
	wrong_confirmation: "Паролите не съвпадат",
	wrong_email: "Грешен адрес на електронна поща",
	sso: "SSO връзка",
	errors: {
		sign_in: {
			"400": "Грешен адрес на електронна поща или парола."
		},
		create_account: {
			uuid: {
				"404": "Грешен код за активиране",
				"406": "Този акаунт вече е активиран"
			},
			password: {
				"404": "Не е намерен такъв потребител",
				"406": "Паролата не отговаря на изискванията на политиката за пароли."
			}
		},
		account_recovery: {
			email: {
				"404": "Не е намерен такъв потребител",
				"423": "Акаунтът е заключен"
			},
			uuid: {
				"404": "Грешен код за възстановяване"
			},
			password: {
				"404": "Не е намерен такъв потребител",
				"406": "Паролата не отговаря на изискванията на политиката за пароли."
			}
		},
		unauthorized: "Нямате разрешение за достъп до този ресурс.",
		incompatibility: "Несъвместимост на версиите между сървъра ви (pia-back) и приложението (pia). Моля обърнете се към вашия IT отдел."
	}
};
var cartography$m = {
	important: "Важно",
	legend1: "Планирани или съществуващи мерки",
	legend2: "С приложени коригиращи мерки",
	legend3: "(I)Незаконен (Д)остъп до данните",
	legend4: "(U)(Н)ежелани изменения в данните",
	legend5: "(D)(И)зчезване на данните",
	likelihood_axe: "Вероятност на риска",
	limited: "Ограничена",
	maximal: "Максимална",
	negligible: "Пренебрежима",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Сериозност на риска"
};
var comments$m = {
	comment: "Коментар",
	written_by: "Създадена от",
	comments_count: "Коментар(и)",
	new_comment: "Коментар",
	placeholder_new_comment: "Направете коментар",
	send: "Изпрати"
};
var conflict$m = {
	keep_initial: "Запази първоначалното съдържание",
	keep_new: "Актуализирай с ново съдържание",
	initial_content: "Първоначално съдържание",
	merge: "Съчетай двете съдържания",
	new_content: "Ново съдържание",
	title: "Открит е конфликт"
};
var date$m = {
	april: "Април",
	august: "Август",
	december: "Декември",
	"earlier-in-this-month": "По-рано този месец",
	"earlier-in-this-week": "По-рано тази седмица",
	february: "Февруари",
	january: "Януари",
	july: "Юли",
	june: "Юни",
	march: "Март",
	may: "Май",
	november: "Ноември",
	october: "Октомври",
	september: "Септември",
	today: "Днес",
	yesterday: "Вчера"
};
var errors$m = {
	content: "Ако срещнете други проблеми или имате предложения за подобрение,<br>можете да ги изпратите чрез тази форма: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Страницата не е намерена."
};
var evaluations$m = {
	acceptable: "Приемлива",
	action_plan_comment: "План за действие / коригиращи действия",
	evaluation_comment: "Коментар за оценката",
	gauges: {
		"0": "(Неопределена)",
		"1": "Пренебрежима",
		"2": "Ограничена",
		"3": "Важна",
		"4": "Максимална",
		likelihood: "Отчитайки плана за действие, как ще оцените отново <span class='red-highlight'>likelihood of this risk</span>?",
		seriousness: "Очитайки плана за действие, как ще оцените отново <span class='red-highlight'>seriousness of this risk</span>?"
	},
	improvable: "Може да се подобри",
	placeholder_acceptable: "Съгласно наличната информация, приложените мерки са адекватни на изискванията за защита на данните.",
	placeholder_improvable1: "Съгласно наличната информация, трябва да се приложат допълнителни мерки за да се подобри защитата на данните при обработването им.",
	placeholder_improvable2: "Направете коментарите си.",
	placeholder_to_correct: "Наличната информация не е достатъчна за да се оценят правилно. Изпратете обратно на редактора за да се направи подобрение на първоначалния вариант.",
	status: [
		"Все още нерешен",
		"Да се коригира",
		"Може да се подобри",
		"Приемлив"
	],
	title: "Оценка",
	to_correct: "Да се коригира"
};
var header$m = {
	archives: "Архив на ОВЗД",
	current_pias: "Текущи ОВЗД",
	exit_full_screen_mode: "Натиснете F11 за да излезете от цял екран.",
	help: {
		issue_reporting: "Докладвайте нередност",
		manual: "Ръководство за работа",
		pia_example_link: "Примерна ОВЗД",
		title: "Помощ"
	},
	homepage_link: "Моите ОВЗД",
	knowledge_base_link: "База знания",
	languages: {
		ar: "Арабски",
		bg: "Български",
		cnil_translations: "Предоставени от CNIL преводи",
		community_translations: "Преводи предоставени от общността",
		cz: "Чешки",
		de: "Немски",
		dk: "Датски",
		dpa_translations: "Преводи, ревизирани от европейския надзорен орган по защита на данните",
		el: "Гръцки",
		en: "Английски",
		es: "Испански",
		et: "Естонски",
		fi: "Фински",
		fr: "Френски",
		hr: "Хърватски",
		hu: "Унгарски",
		it: "Италиански",
		lt: "Литовски",
		lv: "Латвийски",
		nl: "Нидерландски",
		no: "Норвежки",
		official_translation: "Оригинална версия",
		pl: "Полски",
		pt: "Португалски",
		ro: "Румънски",
		sl: "Словенски",
		sv: "Шведски"
	},
	logo_subtitle: "",
	logo_title: "Оценка на въздействието върху поверителността (Оценка на въздействието върху защитата на данните)",
	structures: "Образци на ОВЗД",
	tools: {
		about: "Относно",
		accessibility: "Достъп при нарушено зрение (високо контрастни цветове, далтонизъм)",
		onboarding: "Рестартирайте ръководството за ползване",
		settings: "Настройки",
		url_setting: "Конфигурация на URL сървъра",
		users: "Потребители"
	}
};
var help$m = {
	definition: {
		data1: {
			content: "Съдържанието се пише",
			title: "Използвайте инструмента за ОВЗД"
		},
		data2: {
			qa1: {
				content: "Когато се сблъскате с такива проблеми с изображението, затворете приложението и го стартирайте отново. Обикновено проблемът изчезва. Няма да загубите информацията която вече сте въвели ; тя се запазва автоматично докато я въвеждате.",
				title: "Имам проблеми с изображението, при които иконите остават в едно положение или липсват елементи от интерфейса"
			},
			qa2: {
				content: "Този проблем е известен и в момента се работи по отстраняаването му. Ако го срещнете, препоръчваме да попълните в полето за обосноваване на избраното прогнозно ниво на сила на въздействие и /или вероятността. Когато проблемът бъде отстранен, ще можете да редактирате ска́лата.",
				title: "Не мога да редактирам ска́лата за нивата на силата на въздействие и вероятността на риска"
			},
			qa3: {
				content: "Установено е наличието на няколко проблема при импортиране на ОВЗД, по-специално - ска́лите за нивата на силата на въздействие и вероятността на риска е възможно да изчезнат. В такъв случай вижте гореописания проблем. Също така, ОВЗД може да не се появи на началния екран на програмата след импортирането му. Това е проблем с показването и трябва просто да опресните (презаредите) страницата.",
				title: "Срещам проблеми при импортиране на ОВЗД"
			},
			qa4: {
				content: "Това е проблем само с изобразяването и няма да се отрази на текста който попълвате в полето. Проблемът ще бъде отстранен скоро.",
				title: "Когото копирам или вмъквам текст (copy / paste), той е акцентиран с цвят."
			},
			qa5: {
				content: "За да може да се направи оценка на даден раздел, задължително трябва да се попълнят всички полета. Моля проверете дали това не е причината в дадения случай. Когато редактирате даден риск, трябва да имате поне една техническа или организационна мярка, която намалява риска, за да се иска оценяването му.",
				title: "Не мога да направя оценка на даден раздел"
			},
			qa6: {
				content: "Моля затворете ОВЗД което редактирате и отново го отворете. Сега съдържанието трябва да се покаже на езика, който сте избрали.",
				title: "Когато превключвам езика, текстовете не са преведени"
			},
			qa7: {
				content: "Понастоящем, иконите в менюто за навигация не се опресняват след като ОВЗД е отхвърлено/ отказано. Трябва да проверите всеки раздел, да промените информацията в него и съответната оценка съгласно причината за отхвърляне на ОВЗД. След като всички раздели са били повторно прегледани, би трябвало да можете да поискате валидиране на ОВЗД отново.",
				title: "Отказах да валидирам ОВЗД и не знам какво да правя след това"
			},
			title: "Възможни проблеми"
		},
		footer: "АКо срещнете други проблеми или имате предложения за промени, може да посетите нашата <a target=\"_blank\" href=\"https://github.com/LINCnil/pia\">Github resository</a> и да изпратите идентифициран проблем или предложение за корекция."
	},
	title: "Помощ"
};
var homepage$m = {
	cards: {
		author: "Редактиране",
		category: "Категория",
		creation_status: "Създаване",
		date: "Дата",
		evaluation: "Преглеждане",
		guest: "Гост(и)",
		import_pia: "Импортиране на ОВЗД",
		import_structure: "Импортиране на примерна ОВЗД",
		item: {
			consult_pia: "Консултиране",
			consult_structure: "Консултиране с примерна ОВЗД",
			edit_pia: "Редактиране",
			edit_structure: "Редактиране на примерна ОВЗД",
			tools: {
				action_plan: "Показване на <br>план за действие",
				archive: "Архивиране",
				duplicate: "Създаване на копие",
				"export": "Експортиране",
				more_options: "Други опции",
				pia: "Показване на <br>ОВЗД",
				remove: "Изтриване",
				unarchive: "Разархивиране"
			},
			validate_pia: "Валидиране"
		},
		knowledges: {
			edit: "Редактиране на базата знания",
			"import": "Импортиране на база знания",
			"new": "Създаване на база знания",
			placeholder_author: "Автор",
			placeholder_contributors: "Лица с принос",
			placeholder_entry_number: "Брой позиции",
			placeholder_name: "Наименование на базата знания"
		},
		knowledges_entry: {
			all_sections: "Всички раздели",
			choose_category: "Изберете категория",
			contents: "Съдържание",
			create: "Създайте този елемент",
			linked_to: "Свързан към",
			"new": "Създайте елемент",
			placeholder_category: "Категория",
			placeholder_description: "Вашето описание тук...",
			placeholder_name: "Име на елемента",
			placeholder_updated_at: "Последно актуализирана"
		},
		new_pia: "Нова ОВЗД",
		new_structure: "Нова примерна ОВЗД",
		or: "или",
		pia_name: "ОВЗД",
		placeholder_author: "Име, фамилия",
		placeholder_category: "Категория",
		placeholder_evaluation: "Име, фамилия",
		placeholder_import_knowledgeBase: "Импортирайте база знания",
		placeholder_import_pia: "Импортиране на ОВЗД",
		placeholder_import_structure: "Импортиране на ОВЗД",
		placeholder_new_knowledgeBase: "Нова база знания",
		placeholder_new_pia: "Нова ОВЗД",
		placeholder_new_structure: "Нова примерна ОВЗД",
		placeholder_pia_name: "Наименование на ОВЗД",
		placeholder_sector_name: "Име на свързания раздел",
		placeholder_start: "Всички полета трябва да са попълнени",
		placeholder_structure: "Примерна ОВЗД по подразбиране",
		placeholder_structure_name: "Наименование на примерната ОВЗД",
		placeholder_validation: "Име, фамилия",
		sector_name: "Сектор",
		start: "Старт",
		status: "Статус",
		structure: "Примерна ОВЗД",
		structure_name: "Наименование на примерната ОВЗД",
		title_close_creation: "Затваряне",
		validation: "Валидиране"
	},
	filters: {
		assessor: "Извършващ прегледа",
		author: "Автор",
		card: "Изглед с прозорци/пана́",
		card_rocket_content: "Започнете !<br>За начало на ОВЗД,<br> натиснете върху +",
		card_rocket_content_structure: "Започнете ! За начало на <br>примерна ОВЗД, натиснете върху +",
		category: "Категория",
		date: "Дата",
		import_pia: "Импортиране на ОВЗД",
		import_structure: "Импортиране на примерна ОВЗД",
		list: "Списъчен изглед",
		list_rocket_content: "Започнете ! <br>За начало на ОВЗД, натиснете върху +",
		list_rocket_content_structure: "Започнете ! За начало на <br>примерна ОВЗД, натиснете върху +",
		name: "Име",
		new_pia: "Нова ОВЗД",
		new_structure: "Нова примерна ОВЗД",
		sector_name: "Свързан сектор",
		sort: "Сортиране",
		sort_by: "от",
		status: "Статус",
		validator: "Утвърдил"
	},
	lists: {
		column_actions: "Действия",
		column_author: "Редактиране",
		column_category: "Категория",
		column_creation: "Създадено",
		column_evaluation: "Преглед",
		column_pia: "ОВЗД",
		column_progression: "Прогрес",
		column_sector_name: "Свързан сектор",
		column_status: "Статус",
		column_structure: "Примерна ОВЗД",
		column_structure_name: "Примерна ОВЗД",
		column_updated_at: "Последно отварян",
		column_validation: "Утвърждаване",
		item: {
			tools: {
				action_plan: "Показване на плана за действие",
				archive: "Архивиране",
				consult: "Консултиране",
				duplicate: "Създаване на копие",
				edit: "Редактиране",
				"export": "Експортиране",
				pia: "Показване на ОВЗД",
				remove: "Изтриване",
				unarchive: "Разархивиране"
			}
		}
	},
	search_filter: "Търсене",
	no_entries: {
		pia: "Не е създадена или не е използвана съществуваща ОВЗД",
		archive: "Няма ОВЗД архив"
	}
};
var knowledge_base$m = {
	add_measure: "Добави",
	add_measure_hint: "Можете да добавите мярка и от базата от знания.",
	category: {
		definition: "Дефиниция",
		example: "Пример",
		general_measure: "Контрол на физическата сигурност",
		measure_on_data: "Контрол на общата сигурност",
		method: "Методология",
		organizational_measure: "Организационни мерки",
		principle: "Принцип"
	},
	choose_knowledge_base: "Изберете база знания",
	default_knowledge_base: "База знания на CNIL",
	filters: {
		all: "Всички",
		definitions: "Определения",
		general_measures: "Контрол на физическата сигурност",
		measures_on_data: "Контрол на общата сигурност",
		no_result: "Няма намерени резултати.",
		organizational_measures: "Организационни мерки",
		title: "Филтри"
	},
	placeholder_add_measure: "Добавете тази мярка",
	placeholder_help: "Помощни средства при въвеждане",
	search: "Търсене",
	slugs: {
		PIA_DEF_ACC: {
			description: "Субектът на данни има право да получи потвърждение от администратора потвърждение дали се обработват негови лични данни и ако да, достъп до тези данниa и информацията, описана в <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Чл. 15 of [GDPR]</a>",
			name: "Право на достъп",
			source: "ОРЗД Чл. 15"
		},
		PIA_DEF_ANO: {
			description: "Процес който премахва възможностите за идентификация от личните данни. За да оцените надеждността на процеса на анонимизация, вижте <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Анонимизация",
			source: "Насоки на работната група по чл. 29 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Процес на съхраняване и управление на електронни архиви, съдържащи лични данни, целящ да запази тяхната стойност (най-вече правната стойност) за целия необходим срок (прехвърляне, съхранение, мигриране, достъпност, унищожаване, политика за архивиране, поверителност и т.н.).",
			name: "Архивиране",
			source: "Правила за архивиране на САЩ"
		},
		PIA_DEF_AUTH: {
			description: "Всяко лице с легитимен достъп до личните данни (служители, контрагенти и други трети лица) трябва да се идентифицира с уникален идентификатор. Изберете метод за идентификация при започване на сесия, който е подходящ на съдържанието, нивото на риска и прогнозната надеждност. Препоръки: Ако рисковете са малки, може да се използва парола; при по-големи рискове използвайте еднократни пароли от токен, или изпратени чрез SMS, или от карта с ПИН код, електронен сертификат или друга форма гарантираща коректна автентификация.",
			name: "Автентификация",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Мерки, които правят личните данни невъзможни за разчитане от всеки без право на достъп (симетрично или асиметрично криптиране, използване на публични алгоритми със силна степен на защита, сертификати за автентификация и т.н.).",
			name: "Криптиране",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Методи за организиране на данните, които намаляват възможността данните да бъдат свързани с даден субекти, както и да настъпи нарушение в сигурността на данните. Например, чрез идентифициране на личните данни, необходими за различните процеси на обработване и логическото им разделянеce.",
			name: "Разделяне на данните",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: " „Всяко свободно изразено, конкретно, информирано и недвусмислено указание за волята на субекта на данните, посредством изявление или ясно потвърждаващо действие, което изразява съгласието му свързаните с него лични данни да бъдат обработени .<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.10 of [GDPR]</a>",
			name: "Съгласие",
			source: "ОРЗД чл. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Мерки, приложени с цел ограничаване на риска неоторизирани лица да получат достъп до личните данни, съхранявани в електронен формат, изискващ, освен другото, и : <br>- <strong>управление на потребителските профили</strong> чрез разделяне на задачите и отговорностите (за предпочитане на ниво предприятие), да ограничи достъпа само за оторизирани потребители чрез прилагане на принципа \"необходимост да се знае\" и \"минимална привилегия\" ;<br>- <strong> спиране на правата за достъп на служители, представители на контрагенти и други  трети лица, когато вече няма причина те да посещават помещения или да ползват ресурси</strong> или когато <strong>договорът им приключи или изтече</strong>.",
			name: "Контрол на достъпа",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Всяка информация, свързана с идентифицирано физическо лице или физическо лице, което може да бъде идентифицирано („субект на данни“); физическо лице, което може да бъде идентифицирано, е лице, което може да бъде идентифицирано, пряко или непряко, по-специално чрез идентификатор като име, идентификационен номер, данни за местонахождение, онлайн идентификатор или по един или повече признаци, специфични за физическата, физиологичната, генетичната, психическата, умствената, икономическата, културната или социална идентичност на това физическо лице. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.1 of [GDPR]</a> ",
			name: "Лични данни",
			source: "ОРЗД чл. 4.1"
		},
		PIA_DEF_DEST: {
			description: "физическо или юридическо лице, публичен орган, агенция или друга структура, пред която се разкриват личните данни, независимо дали е трета страна или не. Същевременно публичните органи, които могат да получават лични данни в рамките на конкретно разследване в съответствие с правото на Съюза или правото на държава членка, не се считат за „получатели“; обработването на тези данни от посочените публични органи отговаря на приложимите правила за защита на данните съобразно целите на обработването. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.9 of [GDPR]</a>",
			name: "Получател",
			source: "ОРЗД чл. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Субектът на данни има правото да поиска от администратора изтриване на свързаните с него лични данни без ненужно забавяне, а администраторът има задължението да изтрие без ненужно забавяне личните данни, виж <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 17 of [GDPR]</a>",
			name: "Право на изтриване",
			source: "ОРЗД чл 17"
		},
		PIA_DEF_ENJ: {
			description: "Expected benefits (for the organisation, for the data subjects, for society in general, etc.).",
			name: "Stakes",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Личните данни трябва да са точни и при необходимост да бъдат поддържани в актуален вид; трябва да се предприемат всички разумни мерки, за да се гарантира своевременното изтриване или коригиране на неточни лични данни, като се имат предвид целите, за които те се обработват („точност“). <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 d) of [GDPR]</a>",
			name: "Качество на данните",
			source: "ОРЗД чл. 5.1, буква г)"
		},
		PIA_DEF_GRV: {
			description: "Силата на въздействие представлява големината на риска. Тя зависи основно от характера на вредните последствия.",
			name: "Сила на въздействие",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Субектът на данните има право да изиска от администратора ограничаване на обработването, виж <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 18 of [GDPR]</a>",
			name: "Право на ограничаване на обработването",
			source: "ОРЗД чл. 18"
		},
		PIA_DEF_LOG: {
			description: "Използвайте система за регистриране на влизанията в информационните системи (журнални/ лог файлове), чрез която своевременно да можете да откривате инциденти, свързани с личните данни и даваща информация за анализ или доказателства при разследвания.",
			name: "Журнални записи",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Начин на действие, състоящ се от едно или повече враждебни въздействия върху активите, използвани при обработването на данните. Използва се, съзнателно или не, от източниците на риска и може да причини нежелано събитие.",
			name: "Заплаха",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Заплахи, свързани с:<strong>Хардуер</strong>: използван по неподходящ начин, наблюдаван, променен, изгубен (при използване или пренасяне на чувствителен хардуер за лични нужди, наблюдаване на екрана на устройството от други хора без знанието на потребителя му във влака, проследяване чрез хардуерен регистратор (скимиращо устройство, кийлогър) и др.) <br> - <strong>Софтуер</strong>: използван по неподходящ начин, наблюдаван, променен (достъп над правомощията, придобиване на конфигурационните данни, инфектиране чрез зловреден код) и др.подобни<br>- <strong>Комуникационни канали</strong>: наблюдаване (прихващане на информационния трафик и др.)<br>- <strong>Хора</strong>: наблюдаване, манипулиране, загуба (несъзнателно разкриване на информация, социално инженерство, промяна на възложените задачи)<br>- <strong>Хартиени документи</strong>: наблюдаване, изгубване (четене или кражба на пощенска кореспонденция и др.)<br>- <strong>Придвижване на хартиени документи</strong>: наблюдаване (четене на книга с образци от подписи и др.)",
			name: "Заплахи, които могат да доведат до незаконен достъп",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Заплахи, свързани с: </strong><br>- <strong>Хардуер</strong> : използван по неподходящ начин, претоварен, изменен, повреден, изгубен (запълване на паметта, претоварване на процесора, свързване на несъвместим хардуер, водещо до повреда, пожар, кражба или изгубване на информационен актив и др.)<br>- <strong>Софтуер</strong> : използван по неподходящ начин, претоварване, промяна, повреда, изгубване (изтриване на данни, превишаване на капацитета на базата данни, логическа бомба, неподновяване на лиценз за софтуер и др.)<br>- <strong>Комуникациони канали</strong> : претоварване, промяна, изгубване (неоторизирано изтегляне, загуба на връзка с интернет и др.)<br>- <strong>Хора</strong> : претоварване, повреда, загуба (неумело боравене, болест, пенсиониране и др.)<br>- <strong>Хартиени документи</strong> : използване по неподходящ начин, повреждане, загуба (унищожаване, остаряване на архивирани документи, кражба или изгубване и др.)<br>- <strong>Придвижване на документи</strong> : претоварване, повреждане, промяна, загуба (доставка на пощенски пратки спряна поради стачка, организационна промяна – преместване в нови помещения, загубване на пратки от куриерската компания, реорганизация на дейността по придвижване и др.)",
			name: "Заплахи, които могат да доведат до загуба на лични данни",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Заплахи, отнасящи се до: </strong><br>- <strong>Хардуер</strong>: промяна (добавяне на несъвместим хардуер водещо до загуба на работоспособност, отстраняване на съществени компоненти и др. )<br>- <strong>Софтуер</strong>: използван по неподходящ начин или променен (нежелано модифициране на данни в базите данни, грешки на операторите и др.)<br>- <strong>Комуникационни канали</strong>: използвани по неподходящ начин (препращане или прихващане на данни и др.)<br>- <strong>Хора</strong>: претоварване или манипулиране (възлагане на задачи, които не са по силите, стрес или негативни промени в работните условия, влияние и др.)<br> Хартиени документи, които са били променени (промяна на цифри в документ, подмяна на оригинал с фалшификат и др.)<br>- <strong>Придвижване на документи</strong> които вече не са актуални (преминаване към нова книга с образци на подписи, изпращане на документи които са в конфликт помежду си и др.)",
			name: "Заплахи които могат да доведат до нежелана промяна на личните данни",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Да се изберат измежду мерките, налични в раздел \"Планирани или съществуващи мерки\", като ако е необходимо, можете да ги допълните.",
			name: "Мерки",
			source: "Няма"
		},
		PIA_DEF_MIN1: {
			description: "Когато се импортират данни, различни видове метаданни (като EXIF данните на приложение с имиджов файл) могат да се съберат несъзнателно. <br>Такива метаданни трябва да се идентифицират и изтрият ако не са нужни за целта на обработване.",
			name: "Филтриране и премахване",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Ако са получени чувствителни данни като част от по-обща информация или са предназначени само за статистически цели, те могат да бъдат преобразувани в по-малко чувствителна информация или псевдонимизирани. Например : <br>- ако системата събира IP адреса с цел установяване местоположението на потребителя за статистически цели, IP адресът може да бъде изтрит след като името на града или областта са извлечени<br>- ако системата получава видео данни от камери за наблюдение, тя може да разпознае стоящи или движещи се хора и да замъгли образите им <br>- ако системата използва \"умен\" измерителен прибор, използването на енергия може да се агрегира за определен период, без да се прави запис в реално време",
			name: "Намаляване на чувствителността чрез преобразуване",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Системата осигурява следното: <br>- потребителят може да използва ресурсите или услугата без риск от разкриване на самоличността (анонимизирани данни) <br>- потребителят може да използва ресурсите или услугата без риск от разкриване на самоличността, но може да бъде идентифициран и отговорен за това използване (псевдонимизирани данниp)<br>- потребителят може да използва ресурсите или услугата многократно, без риск данните от това използване да могат да бъдат свързани помежду си (не може да се направи корелация)<br>- потребителят може да използва ресурсите или услугата без риск други, по-специално трети страни, да могат наблюдават използването на ресурса или услугата <br>Изборът на метод от горния списък трябва да бъде направен въз основа на идентифицираните заплахи. За някои заплахи за поверителността, псевдонимизацията ще е по-подходяща в сравнение с анонимизацията (например, ако е необходимо отчитане на използването). В допълнение, някои заплахи за поверителността следва да се адресират чрез комбинация от методи.",
			name: "Намаляване на възможността за идентифициране",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Системата може да бъде организирана на независими части с различен контрол на достъпа. Също така, данните могат да се разпределят в тези независими подсистеми и контролирани от всяка подсистема чрез използване на различни механизми за контрол на достъпа. В случай, че някоя от подсистемите е компрометирана, негативното влияние върху данните като цяло, ще бъде редуцирано.",
			name: "Намаляване на натрупването на данни",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Системата може да ограничи достъпа до данните съгласно принципа \"необходимост да се знае\". Системата може да отдели чувствителните данни и да приложи специфични политики за контрол на достъпа. Системата може да криптира чувствителните данни за да защити тяхната поверителност при съхранение и изпращане. Достъпът до временните \"бисквитки\" (cookies), които се създават при обработването на данните също трябва да бъде защитен.",
			name: "Ограничаване на достъпа до данните",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Намаляване на въздействието на риска чрез ограничаване на количеството на лични данни до строго необходимото за достигане на определената цел, като в противен случай данните няма да се събират.",
			name: "Минимизиране на количеството лични данни",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Намаляване на въздействието на риска чрез минимизиране на самите данни чрез мерки, насочени към намаляване на чувствителността им, като филтриране и премахване на ненужните данни, псевдонимизиране и др.",
			name: "Минимизиране на данните",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Субектът на данните има право, по всяко време и на основания, свързани с неговата конкретна ситуация, на възражение срещу обработване на лични данни, отнасящи се до него, съгласно <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 21 of [GDPR]</a>",
			name: "Право на възражение",
			source: "ОРЗД чл. 21"
		},
		PIA_DEF_PBDS: {
			description: "Мерки, взети с цел интегриране на защитата на личните данни във всички нови операции по обработване (авторитетни експерти, насоки, методология на CNIL за управление на риска или други вътрешни методологии).",
			name: "Управление на проектите",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Лице, с което са свързани данните които се обработват.",
			name: "Субект на данните",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " Субектът на данните има право да получи личните данни, които го засягат и които той е предоставил на администратор, в структуриран, широко използван и пригоден за машинно четене формат и има правото да прехвърли тези данни на друг администратор без възпрепятстване от администратора, на когото личните данни са предоставени, виж <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 20 of [GDPR]</a>",
			name: "Право на преносимост на данните",
			source: "ОРЗД чл. 20"
		},
		PIA_DEF_PSEU: {
			description: "Обработването на лични данни по такъв начин, че личните данни не могат повече да бъдат свързвани с конкретен субект на данни, без да се използва допълнителна информация, при условие че тя се съхранява отделно и е предмет на технически и организационни мерки с цел да се гарантира, че личните данни не са свързани с идентифицирано физическо лице или с физическо лице, което може да бъде идентифицирано.<br>Псевдонимизацията намалява възможността да се свърже набор от данни с оригиналната самоличност на даден субек на данни; поради това, тя е полезна мярка за сигурност но не е метод за анонимизиране.",
			name: "Псевдонимизация",
			source: "ОРЗД чл. 4.5 и насоки на работната група по чл. 29 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Паролите трябва да се състоят от минимум осем знака; трябва да се променят ако има и най-малко съмнение че може да са компрометирани и ако е възможно, периодично (на всеки шест месеца или веднъж годишно) и трябва да включват минимум три от четирите вида знаци (главни букви, малки букви, цифри и специални символи); при промяна на парола, да не се използват отново последните пет използвани пароли; една и съща парола да не се използва за различни акаунти; паролите не трябва да са свързани с лична информация (включително име и дата на раждане). Трябва да има определен максимален брой опити за влизане в акаунт, след които да се генерира аларма и се блокира достъпът (временно или до ръчното му отблокиране).",
			name: "Парола",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Субектът на данни има право да поиска от администратора да коригира без ненужно забавяне неточните лични данни, свързани с него. Като се имат предвид целите на обработването субектът на данните има право непълните лични данни да бъдат попълнени, включително чрез добавяне на декларация.",
			name: "Право на коригиране",
			source: "ОРЗД чл. 16"
		},
		PIA_DEF_RGPD: {
			description: "Регламент относно защитата на физическите лица във връзка с обработването на лични данни и относно свободното движение на такива данни и за отмяна на Директива 95/46/ЕО (Общ регламент относно защитата на данните, ОРЗД).",
			name: "ОРЗД (Общ регламент относно защитата на данните)",
			source: "Наименование на ОРЗД"
		},
		PIA_DEF_RT: {
			description: ") „администратор“ означава физическо или юридическо лице, публичен орган, агенция или друга структура, която сама или съвместно с други определя целите и средствата за обработването на лични данни; когато целите и средствата за това обработване се определят от правото на Съюза или правото на държава членка, администраторът или специалните критерии за неговото определяне могат да бъдат установени в правото на Съюза или в правото на държава членка.<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.7 of [GDPR]</a>",
			name: "Администратор",
			source: "ОРЗД чл. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Човешки или друг вид източник, който може да причини риск. Източникът може да действа несъзнателно или целенасочено.",
			name: "Източник на риска",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Физическо или юридическо лице, публичен орган, агенция или друга структура, която обработва лични данни от името на администратора, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 of [GDPR]</a>.<br> Обработващият лични данни и всяко лице, действащо под ръководството на администратора или на обработващия лични данни, което има достъп до личните данни, обработва тези данни само по указание на администратора, освен ако обработването не се изисква от правото на Съюза или правото на държава членка, виж <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 29 of [GDPR]</a>.",
			name: "Обработващ",
			source: "ОРЗД чл. 4.8 и 29"
		},
		PIA_DEF_SUPT: {
			description: "Материали и помощни средства, свързани с обработването на личните данни. Това може да е хардуер, софтуер, мрежи, хора, хартиени документи или процедури",
			name: "Активи използвани при обработването",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Нарушение на сигурността, което води до случайно или неправомерно унищожаване, загуба, промяна, неразрешено разкриване или достъп до лични данни, които се предават, съхраняват или обработват по друг начин.",
			name: "Нарушение на сигурността на лични данни",
			source: "ОРЗД чл. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Вероятността изразява възможността рискът да се случи. Зависи основно от нивото на уязвимостите в активите, използвани при обработването, при наличие на заплаха и нивото на способност на източниците на риска да използват уязвимостите.",
			name: "Вероятност",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Данни за системата за оценка, резултат от прилагане на оценката....",
			name: "Калкулирани данниa"
		},
		PIA_EX_DCPC: {
			description: "<strong>Данни за идентификация</strong> : Гражданско състояние, ЕГН, възраст и др. <br><strong>Личен живот</strong> : начин на живот, семейно положение и др.<br><strong>Професионален живот </strong> : трудова биография (CV), образование и квалификация, постижения и др. <br><strong>Данни за свързаност</strong> : IP адреси, журнални файлове и др.<br><strong>Данни за местоположение</strong> : пътувания, геолокация, данни от мобилно устройство и др.<br><strong>Други</strong> : телефонен номер, адрес на електронна поща и др.",
			name: "Обикновени лични данни",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Расов или етнически произход, политически възгледи, религиозни или философски убеждения или членство в синдикални организации, данни за здравословното състояние или данни за сексуалния живот или сексуалната ориентация на физическото лице; присъди и нарушения или със свързаните с тях мерки за сигурност, виж <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Присъди и чувствителни лични данни"
		},
		PIA_EX_DCPS: {
			description: "Социалноосигурителен номер, биометрични данни, банкови данни",
			name: "Лични данни, считани за чувствителни"
		},
		PIA_EX_HUME: {
			description: "Може да бъде някое от следните:<br>- злонамерен или наивен съсед, използващ физическата близост и достъпващ данните в различни устройства;<br>- хакер, атакуващ субекта, използвайки информация, която е придобил за нея/него;<br>- хакер, атакуващ компания, използвайки информация, която е придобил за нея и която може да подрони имиджа й;<br>- упълномощено трето лице, което използва предоставения му достъп за неправомерно сдобиване с информация.",
			name: "Външна човешка намеса"
		},
		PIA_EX_HUMI: {
			description: "Може да бъде някое от следните:<br>- небрежен или злонамерен служител, използващ достъпа си до системите, уменията, правата и наличното време; евентуална липса на умения и бдителност<br>- небрежен или злонамерен потребител, член на семейството или близък, имащ достъп до услугата.<br> Възможните мотиви са разнообразни, включително: непохватност, грешка, небрежност, злонамереност, отмъщение, шпиониране",
			name: "Външна човешка намеса"
		},
		PIA_EX_IMPI: {
			description: "Субектите на данни може да понесат значителни последствия, които може да са способни да преодолеят, но на цената на значителни затруднения и усилия. Например: <br>- Физически: сериозни наранявания, с дългосрочни последствия (влошаване на здравето поради неподходящо лечение или пренебрегване на противопоказания), загуба на пълна физическа дееспособност вслествие например на нападение, битов инцидент, трудова злополука и др.<br>- Материални: загуба на средства, пропускане на уникални възможности (ипотечен заем, отказ за образование и обучение, отказ за наемане на работа, допускане до изпит), загуба на жилището, на работа и др.;<br>- Морални : сериозни психологически заболявания (депресия, развиване на фобии), чувство за нахлуване в личния живот, водещо до необратими вреди, жертва на изнудване, кибер тормоз и др.",
			name: "Значително въздействие"
		},
		PIA_EX_IMPL: {
			description: "Субектите на данни могат да изпитат значителни неудобства, които могат да преодолеят въпреки някои затруднения. Например:<br>- Физически: незначителни физически неразположения (незначителни заболявания дължащи се на пренебрегване на противопоказания), клевета, довела до физическо отмъщение или психологическа атака и др.;<br>- Материални: непредвидени разходи (неправилно наложени глоби), отказ на достъп до административни или търговски услуги, получаване на адресирани рекламни съобщения които може да навредят на репутацията на субекта и др.;<br>- Морални: неголеми но обективни психологически вреди, чувство за нахлуване в личния живот но без необратими вреди, заплахи в социалните мрежи и др.",
			name: "Ограничено въздействие"
		},
		PIA_EX_IMPM: {
			description: "Субектите на данни може да понесат значителни, дори необратими, последствия, които е възможно да не могат да преодолеят. Например:<br>- Физически: дълготрайни или постоянни физически заболявания,  инвалидност, смърт;<br>- Материални: финансов риск, значителни дългове, неспособност за работа, невъзможност за промяна на местоживеенето, загуба на доказателства при съдебен процес, лишаване от достъп до жизненоважна инфраструктура (вода, електричество), etc.<br>- Морални: дълготрайни или постоянни психически заболявания, криминални присъди, отвличане, сриване на семейните отношения, невъзможност за съдебни искове, промяна на административния статус и/ или загуба на юридическа дееспособност (поставяне под попечителство) и др.",
			name: "Максимално въздействие"
		},
		PIA_EX_IMPN: {
			description: "Субектите на данни няма да бъдат засегнати или ще изпитат незначителни неудобства, които ще могат да преодолеят без проблем. Например:<br>- Физически: краткотрайно главоболие;<br>- Материални: загуба на време за повтарящи се формалности или чакане за изпълнение на такива, получаване на непоискани търговски съобщения (например спам), изпращане на адресирани търговски съобщения с информация, която е публикувана и на уебсайт и др.;<br>- Морални: изпитване на досада, чувство на нахлуване в личния живот без наличие на реални вради (търговски пътници и реклами) и др.",
			name: "Незначително въздействие"
		},
		PIA_EX_NHUM: {
			description: "Инцидент или повреда в поддържащите системи (прекъсване на електрозахранването, пожар, наводнение и др.)",
			name: "Материални ресурси"
		},
		PIA_EX_VRAI: {
			description: "Изглежда възможно визираните източници на риск да материализират заплахата чрез възползване от особеностите на активите, използвани при обработването (например кражба на хартиени документи, съхранявани на места, до които е невъзможно да се достигне без минаване през рецепция).",
			name: "Значителна вероятност"
		},
		PIA_EX_VRAL: {
			description: "Изглежда трудно за визираните източници на риск да материализират заплахата чрез възползване от особеностите на активите, използвани при обработването (например кражба на хартиени документи от помещение, в което се влиза с карта за достъп).",
			name: "Ограничена вероятност"
		},
		PIA_EX_VRAM: {
			description: "Изглежда съвсем лесно за визираните източници на риск да материализират заплахата чрез възползване от особеностите на активите, използвани при обработването (например кражба на хартиени документи съхранявани в помещение без ограничение на достъпа (например фоайе на обществена сграда).",
			name: "Максимална вероятност"
		},
		PIA_EX_VRAN: {
			description: "Изглежда невъзможно за визираните източници на риск да материализират заплахата чрез възползване от особеностите на активите, използвани при обработването (например кражба на хартиени документи, съхранявани в помещение, в което се влиза с карта за достъп и набиране на код).",
			name: "Незначителна вероятност"
		},
		PIA_LGL_CONS: {
			description: "Позволете на субектите на данни да направят свободен, конкретен и информиран избор. Проверете дали обработката не се основава на друго правно основание, съдържащо се в чл. 6 на ОРЗД, вместо на съгласие <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Получаване на съгласие",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Определете и опишете обхвата в подробности:<br>- видовете лични данни, техните получатели и срока на съхранение<br>- описание на процесите и активите, използвани при обработването, за целия жизнен цикъл на личните данни (от събирането до изтриването).",
			name: "Обработвани данни",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Представете кратко описание на предвидения процес на обработване, характера му, обхвата, контекста, целите и основанията. Идентифицирайте администратора на лични данни и всички обработващи. Опишете всички нормативни документи, имащи отношение към обработването или чиито изисквания трябва да се спазят, включително кодекси за поведение (виж чл. 40 от ОРЗД <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) и сертифицирането свързано със защитата на данните (виж чл. 42 от ОРЗД <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Описание на обработването",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Физическо или юридическо лице, публичен орган, агенция или друга структура, пред която се разкриват личните данни, независимо дали е трета страна или не. Същевременно публичните органи, които могат да получават лични данни в рамките на конкретно разследване в съответствие с правото на Съюза или правото на държава членка, не се считат за „получатели“; обработването на тези данни от посочените публични органи отговаря на приложимите правила за защита на данните съобразно целите на обработването. Виж чл. 4.9 от ОРЗД <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Получател",
			source: "ОРЗД чл. 4.9"
		},
		PIA_LGL_DUR: {
			description: "Срокът за съхранение трябва да е определен за всеки вид данни и аргументиран съгласно нормативни изисквания и/ или нуждите на обработването. Прави се разлика между данни и архивирани данни, до които достъп могат да имат само имащи право на това страни. Трябва да е предвиден и механизъм за архивиране, респективно изтриване на данните след изтичане на срока на съхранение. Включително за журналните файлове, които също не може да се съхраняват за неопределен срок. ",
			name: "Срок на съхранение",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Личните данни са събирани за конкретни, изрично указани и легитимни цели и<strong> не се обработват по-нататък по начин, несъвместим с тези цели.</strong> <br>Виж <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) of [GDPR]</a>",
			name: "Принципи, свързани с обработването на лични данни",
			source: "ОРЗД чл. 5.1 б)"
		},
		PIA_LGL_FOND: {
			description: "- Субектът на данните е дал съгласие за обработване на личните му данни за една или повече конкретни цели <br>- Обработването е необходимо за изпълнението на договор, по който субектът на данните е страна, или за предприемане на стъпки по искане на субекта на данните преди сключването на договор <br>- Обработването е необходимо за спазването на законово задължение, което се прилага спрямо администратора<br>- Обработването е необходимо, за да бъдат защитени жизненоважните интереси на субекта на данните или на друго физическо лице<br>- Обработването е необходимо за изпълнението на задача от обществен интерес или при упражняването на официални правомощия, които са предоставени на администратора<br>- Обработването е необходимо за целите на легитимните интереси на администратора или на трета страна, освен когато пред такива интереси преимущество имат интересите или основните права и свободи на субекта на данните, които изискват защита на личните данни, по-специално когато субектът на данните е дете<br> Виж <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 6 of [GDPR]</a> ",
			name: "Законосъобразност на обработването",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Осигурете информирането на субектите. Уверете се че обработването не попада в обхвата на някое изключение или на специални условия.",
			name: "Информиране на субектите на данни",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Важно е да се намали силата на риска чрез свеждане до минимум на категориите лични данни, които ще се обработват, като тези данни се ограничават само до такива, които са строго необходими за целите на обработването (в противен случай изобщо не трябва да се събират). Въможно е и да се минимизират самите данни чрез мерки, които намаляват тяхната чувствителност.",
			name: "Свеждане на данните до минимум",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Договорът между администратор и обработващ/и трябва да е подписан от всички обработващи и да включва всички изисквания, съдържащи се в чл. 28 на ОРЗД: продължителност, обхват, цел, документирани указания за обработване, правата на обработващия, осигуряване на цялата документация, доказваща съответствие с ОРЗД, адекватно известяване при нарушения в сигурността на личните данни и т.н.",
			name: "Договори с обработващи",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Актив, който се използва за обработване на личните данни. Забележка: това може да е хардуер, софтуер, мрежи, хора, хартиен документ или процедура.",
			name: "Актив, използван при обработването",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "В зависимост от избора на конкретната държава, например предлагаща услуги по съхранение на данни, може да се наложи да приложите подходящи гаранции, така че да се осигури адекватна защита на субектите на данни при предаването на лични данни на трети лица или международни организации. Възможностите са:<br>- Европейски съюз<br>- Държава, за която ЕС счита че осигурява адекватно ниво на защита<br>- Трансфер до САЩ до компания, която участва в Privacy Shield<br>- Друга държава <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 to 49 of [GDPR]</a>",
			name: "Трансфери",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "Плановите контроли са тези, които са предвидени първоначално, преди извършване на анализ от оценителя. Коригиращите мерки, предложени от оценителя, ще се опишат в плана за действие и ще дадат възможност за второ оценяване на въздействието и вероятността на риска.",
			name: "Планови и коригиращи контроли",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Наличие на политика и процеси, чрез които администраторът да постигне управление и контрол върху личните данни, обработвани от него.",
			name: "Надзор",
			placeholder: "Посочете тук дали ефективността и адекватността на контрола върху контролите над защитата се следят.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Наличие на политика и процеси, намаляващи риска, който легитимният достъп до лични данни от трети лица може да създаде за правата и свободите на субектите на данни.",
			name: "Отношения с трети лица",
			placeholder: "Посочете тук контролите за сигурност и споразуменията с обработващи лични данни, касаещи достъпа на обработващите до личните данни.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Посочете дали има отговорник за прилагането на нормативната уредба, отнасяща се до защитата на личните данни. Посочете дали има комитет за мониторинг (или еквивалентно звено), отговорен за управление и контрол на дейността, свързана със защитата на личните данни.",
			name: "Организация на дейността",
			placeholder: "Посочете дали ролите и отгворностите за защита на данните са дефинирани.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Наличие на политика, предназначена да интегрира защитата на личните данни във всички нови процеси.",
			name: "Интегриране на защитата на данните в проектите",
			placeholder: "Опишете тук как защитата на данните се интегрира в проектите",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Наличие на политика, описваща как мерките за повишаване на осведомеността се прилагат към нови служители и какви мерки се вземат при напускане на служители, които са имали достъп до лични данни.",
			name: "Управление на персонала",
			placeholder: "Посочете тук какви мерки за повишаване на осведомеността се прилагат към служителите.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Залагане на важните моменти при защитата на личните данни в документите на организацията, създавайки политика за защита на личните данни, обхващаща дейността изцяло  - всички аспекти (рискове, основни принципи, цели, правила и т.н.), както и всички участници (потребители, IT отдел, автори на документите на организацията и т.н.).",
			name: "Политика",
			placeholder: "Опишете тук документалната база, регламентираща целите и правилата при защитата на данните.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Политика, описваща процесите чрез които се контролира рискът, който операциите по обработване на лични данни от организацията поражда за правата и свободите на субектите на данни (изработване на карта на рисковете и т.н.).",
			name: "Управление на рисковете за защитата на данните",
			placeholder: "Опишете тук процесите, чрез които се контролират рисковете, които операциите по обработване на лични данни от организацията пораждат за правата и свободите на субектите на данни.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Наличие на оперативна организация на дейността, която може да открие и третира нарушения в сигурността на личните данни, които представляват заплаха за правата и свободите на субектите на данни.",
			name: "Управление на нарушенията в сигурността на личните данни",
			placeholder: "Посочете тук дали IT инцидентите се третират съгласно документирана и тествана процедура за управлението им.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Политики и средства, които се прилагат с цел осигуряване на наличността и/ или целостта на личните данни, същевременно запазвайки конфиденциалността им.",
			name: "Резервни копия",
			placeholder: "Посочете тук как се управляват резервните копия. Уточнете дали се съхраняват на сигурно място.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Мерки, приложени върху работните станции (автоматично заключване, редовно актуализиране, конфигурация, физическа сигурност и т.н.) с цел намаляване на възможността за атакуване на софтуера (операционни системи, бизнес приложения и др.) с отрицателен ефект върху личните данни.",
			name: "Управление на работните станции",
			placeholder: "Опишете тук мерките, които се прилагат върху работните станции",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "<strong>Използвайте само обработващи, които предоставяте достатъчно гаранции </strong> (специално по отношение на експертни познания, надеждност и ресурси). Изискайте от доставчиците на услуги да представят политиките си за сигурност на информационните системи преди да подпишете договор с тях. <br>Въведете и документирайте мерки (одити, посещения при инсталиране и т.н.) за да се  <strong>осигури ефективността на гаранциите, предожени от обработващия</strong> по отношение защитата на данните. Тези гаранции включват: <br>- криптиране на данните в зависимост от тяхната чувствителност или, най-малко, наличие на процедура която да гарантира че субконтракторът няма достъп до данните; <br>- криптиране на предаването на данни (например свързване чрез HTTPS, VPN и т.н.); <br>- гаранции по отношение защитата на мрежите, проследяемост (лог файлове, одити), управление на правата за достъп, автентификация и др. <br><strong>Подпишете договор с обработващия </strong>, който дефинира предмета, продължителността и целта на обработването, както и задълженията на всяка страна. Погрижете се той да съдържа, по-специално клаузи, регламентиращи: <br>- задълженията му относно <strong>поверителността на личните данни, до които има достъп</strong>;<br>- <strong>минимални стандарти при автентификация на потребителите</strong>;<br>- <strong>условията на връщане на данните и/ или тяхното унищожаване при приключване на договорните отношения</strong>;<br>- <strong>правила за третиране на нарушенията в сигурността и уведомяването за тях. </strong> Те трябва да включват уведомяване на администратора винаги когато се установи инциденти или нарушение в сигурността, като уведомяването трябва да се случи възможно най-бързо ако става въпрос за лични данни.",
			name: "Договари с обработващи",
			placeholder: "Опишете тук специфичните мерки по отношение на обработващите (били те осигуряващи сървърно пространство, сервизираща организация, доставчик на специализирани услуги и т.н.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Приложени политики за намаляване на вероятността от и въздействието на рисковете за активите, използвани при обработването на лични данни.",
			name: "Сигурност на информационните системи",
			placeholder: "Опишете тук как се извършва актуализирането на софтуера (операционни системи, приложения и т.н.) и прилагането на коригиращи мерки за сигурност.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Мониторинг на системите за засичане на непозволен достъп и системите за предотвратяване на непозволен достъп с цел анализ на мрежовия (кабелни мрежи, Wi-Fi, радиочестотни мрежи, оптични и т.н.) трафик в реално време и откриване на подозрителна активност, насочваща към сценарий за кибер атака.",
			name: "Мониторинг на мрежавата активност",
			placeholder: "Посочете тук средствата и контролите, приложени за откриване на нарушения, свързани с лични данни",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Политики, описващи как се управляват физическата поддръжка на хардуера, като се посочва дали се използват външни доставчици.<br> Посочете дали е позволено обслужване на приложенията чрез отдалечен достъп и по силата на какви решения. Посочете дали има специална процедура за дефектирало оборудване.",
			name: "Поддръжка",
			placeholder: "Опишете тук как се управлява физическата поддръжка на хардуера",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Контроли, приложени върху работните станции и сървърите за защита от зловреден софтуер при свързване с мрежи с по-ниска степен на сигурност.",
			name: "Възпиране на зловреден софтуер",
			placeholder: "Опишете тук контролите, които се прилагат за намаляване на рисковете при връзка с мрежи с по-ниска степен на сигурност.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Посочете тук контролите, които се отнасят до физическата сигурност на сървърите и работните станции (съхранение, кабелни мрежи, логически филтри, сигурно изтриване преди бракуване на хардуера.).",
			name: "Сигурност на хардуера",
			placeholder: "Посочете тук контролите, отнасящи се до физическата сигурност на сървърите и работните станции",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "В зависимост от вида на мрежата, която се използва при обработването на данни (изолирана, частна или интернет). Уточнете какви защитни стени (firewall), системи за засичане на непозволен достъп или други активни или пасивни устройства се използват за осигуряване на мрежовата сигурност.",
			name: "Мрежова сигурност",
			placeholder: "Посочете тук контролите за сигурност на мрежите, които се използват за обработване на данни",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Политики, чрез които се осигурява физическата сигурност (зониране, придружаване на посетителите, носене на баджове-карти за достъп, заключени врати и т.н.). Посочете дали се извършва известяване (аларма) в случай на непозволено проникване.",
			name: "Контрол на физическия достъп",
			placeholder: "Посочете тук как се извършва физическият контрол на достъпа до помещения, където се извършва обработването на данни.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Политики, описващи средствата за противопожарна защита – установяване и противодействие. Където е приложимо, посочете средствата за защита от наводнение. Посочете и как се контролира захранването с електроенергия и стабилността му.",
			name: "Защита срещу източници на риск, в които няма човешки фактор",
			placeholder: "Посочете тук средствата, които се използват за избягване или ограничаване на източниците на риск, в които няма човешки фактор.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Обосновававане на избора на място за обработване на данните, което не би трябвало да се намира в зона с повишен риск от природни бедствия (наводнения, близост до химическа индустрия, земетръсна или вулканична зона и т.н.). Посочете и ако в близост се съхраняват опасни вещества.",
			name: "Избягване на източниците на риск",
			placeholder: "Посочете тук взети ли са мерки да се избягнат места с голям риск за природни бедствия",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Прилагане на изискванията на ANSSI's (Национална агенция на Франция за сигурността на информационните системи) за сигурността на интернет страниците.",
			name: "Сигурност на интернет страниците",
			placeholder: "Посочете тук контролите, приложени за защита на интернет страниците.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Посочете тук дали са приложени механизми за анонимизация, кои са. <br>Помнете да правите ясно разграничаване между анонимизирани и псевдонимизирани данни.",
			name: "Анонимизиране",
			placeholder: "Посочете тук приложените механизми за анонимизация",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Доколкото е приложимо, опишете тук процесите при управление на архивирането (предаване, съхранение, консултиране и т.н.), за които носите отговорност. Уточнете ролите (отдели, от които идват документите; отговорници за предаването и т.н.) и политиката за архивиране. Посочете ако някои от данните подлежат на предаване в обществени архиви.",
			name: "Архивиране",
			placeholder: "Посочете тук дали се прилагат механизми за контрол на целостта на съхраняваните данни, кои са те.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Способи, приложени за  <strong>осигуряване на поверителността</strong> на съхраняваните данни (в база данни, във файлове, резервни копия и т.н.), кaкто и процедурата за управление на криптографските ключове (създаване, съхранение, промяна в случай че има подозрение за компрометирането им и т.н.).<br> Опишете методите на криптиране, прилагани при предаването на данните на разстояние (VPN, TLS и т.н.), когато има такова при обработването.",
			name: "Криптиране",
			placeholder: "Опишете тук мерките, приложени за осигуряване на поверителността на данните",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Прилагането на разделяне на данните допринася за намаляване на вероятността личните данни да могат да се свържат, както и да се случи нарушение с целия набор от данни.",
			name: "Разделяне на данните",
			placeholder: "Посочете тук дали е предвидено разделяне на данните и как ще се извърши.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Методи за дефиниране и присвояване на потребителски профили. Посочете използваните методи за <strong>автентификация</strong>. Където е приложимо, посочете правилата за създаване на пароли (минимална дължина, задължителни знаци,период на валидност, брой на неуспешните опити преди блокиране на достъпа и т.н.).",
			name: "Контрол на достъпа до информационните системи",
			placeholder: "Посочете тук как се дефинират и присвояват потребителските профили.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Политики, които дефинират проследяването и управлението на журналните файлове (логове).",
			name: "Проследяване (лог файлове)",
			placeholder: "Посочете тук дали събитията се отразяват в журнални файлове (логове) и колко дълго се съхраняват тези файлове.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Може да се използват следните методи: Филтриране и премахване, намаляване на чувствителността чрез преобразуване, намаляване на възможността за идентифициране чрез конкретните данни, намаляване натрупването на данни, ограничаване на достъпа",
			name: "Минимизиране на количеството на личните данни",
			placeholder: "Посочете способите, приложени за намаляване на въздействието от риска чрез ограничаване на количеството на личните данни",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Когато при обработването се използват хартиени документи, посочете тук как се отпечатват, съхраняват, унищожават и обменят.",
			name: "Сигурност на хартиените документи",
			placeholder: "Посочете тук дали се използват механизми за контрол на целостта на хартиените документи и ако да – кои.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Коригиращите мерки, предложени от оценителя в предишните стъпки, начертаване на план за действие; за всяко от действията – мениджър, честота, трудност, цена и прогрес.",
			name: "План за действие",
			source: "Няма"
		},
		PIA_VAL_CART: {
			description: "Графика, илюстрираща добрите практики за сигурност, със стойност на съответствие присвоена на на всяка въз основа на оценката от предишните стъпки.",
			name: "Картографиране на рисковете",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: " Когато е целесъобразно, администраторът се обръща към субектите на данните или техните представители за становище относно планираното обработване, без да се засяга защитата на търговските или обществените интереси или сигурността на операциите по обработване. Виж чл. 35.9 на <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> Тези становища могат да се съберат по различни начини, в зависимост от контекста (вътрешно или външно проучване на методите и целите на обработване, обръщане към представители на персонала или синдикалните организации, проучване сред бъдещи клиенти). <strong>Ако администраторът реши да не се съобрази със становището на субектите на данни</strong>, той трябва да отрази <strong> аргументите си за това решение</strong>. Ако администраторът счита, че <strong>искането на становището на субектите на данни не е релевантно, той също трябва да отрази аргументитете си в това отношение</strong>.",
			name: "Становище на субектите на данни",
			source: "ОРЗД чл. 35.9 и PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "При извършването на оценка на въздействието върху защитата на данните администраторът иска становището на длъжностното лице по защита на данните, когато такова е определено. Виж чл. 35.2 от  <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>Това становище може да е против извършването на въпросното обработване, без да е задължително за окончателното решение на администратора </strong>.",
			name: "Становище на ДЛЗД",
			source: "ОРЗД чл. 35.2 и PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Решете дали избраните мерки, остатъчни рискове и план за действие са приемливи, като се аргументирате, вземайки предвид определените преди това цели становище на заинтересованите страни. По този начин, ОВЗД може да бъде:<br>- validated<br>- подлежаща на на подобрения (обяснете по какъв начин)<br>- отхвърлен (заедно с разглеждания процес по обработване). Ако е необходимо, повторете предишните стъпки за да може ОВЗД да бъде валидирана. Това решение не засяга оценката за съответствие, която се извършва, където е приложимо, от надзорния орган по защита на личните данни (КЗЛД в България), например като част от предварителни формалности или проверки.",
			name: "Формално валидиране",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "База от знания"
};
var measures$m = {
	add: "Добавете мярка (или използвайте такава от базата данни)",
	default_placeholder: "Опишете съществуващите или планирани мерки за осигуряване защитата на личните данни.",
	edit: "Редактирайте мярката",
	placeholder_title: "Наименование на мярката",
	remove: "Изтрийте мярката"
};
var misc$m = {
	display: "Покажи / Скрий"
};
var modals$m = {
	abandon_pia: {
		additional_text: "Архивирането не е ясно описано и ОВЗД може да се върне към него ако е необходимо.",
		content: "Искате ли да се откажете от обработването?"
	},
	action_plan_no_evaluation: {
		content: "Необходимо е да започнете преглед на анализа за да създадете план за действие.",
		review_section: "Преглед на радела"
	},
	archive: "Архивиране",
	archive_pia: {
		archive: "Архивиране на ОВЗД",
		content: "<span class='strong'>Предупреждение,</span><br>Сигурни ли сте че искате да архивирате тази ОВЗД ?"
	},
	ask_for_evaluation: {
		content: "Този раздел е готов за преглед."
	},
	back_to_edition: {
		content: "Този раздел е върнат за редактиране.<br> Някои полета трябва да бъдат коригирани<br> за да може да се направи преглед."
	},
	back_to_evaluation: {
		content: "Този раздел е върнат за преглед.<br> Някои полета трябва да се преразгледат<br> за да може да се валидира."
	},
	back_to_home: "Обратно към началото",
	cancel: "Отмяни",
	close: "Затвори",
	completed_edition: {
		content: "ОВЗД е напълно редактирана, следва да бъде прегледана."
	},
	completed_evaluation: {
		content: "ОВЗД е напълно прегледана и може да бъде валидирана."
	},
	"continue": "Продължете",
	declare_measures: {
		content: "Преди да оцените рисковете,<br>трябва да изложите <br>съществуващите или планираните мерки.",
		declare: "Декларирайте съществуващите или планирани мерки"
	},
	dpo_missing_evaluations: {
		comment: "Коментар",
		content: "Трябва да завършите прегледа на анализа за да стигнете до етапа с ДЛЗД.",
		remove: "Премахни",
		review_section: "Прегледайте раздела"
	},
	general_error: {
		content: "Много съжаляваме, възникна грешка."
	},
	import_wrong_pia_file: {
		content: "Импортираният файл не съответства на файла с доклада за ОВЗД."
	},
	import_wrong_structure_file: {
		content: "Импортираният файл не съответства на файла с примерна ОВЗД."
	},
	knowledge: {
		content: "Сигурни ли сте че искате да изтриете този елемент?",
		remove: "Изтрий този елемент"
	},
	knowledges: {
		content: "Сигурни ли сте че искате да изтриете тази база знания?",
		remove: "Изтрий тази база знания"
	},
	modal_select_text_pia: {
		content: "Съдържанието на ОВЗД е копирано в буферната памет на компютъра (клипборда)."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Предупреждение,</span><br>Поне една мярка трябва да бъде вписана: изтриването не е възможно."
	},
	recover_version: {
		"continue": "Продължете",
		message: "Ако продължите, ще възстановите версията на този доклад от: {{date}}.<br><br>Сегашната версия ще бъде запазена.",
		title: "Възстановяване на предишна версия"
	},
	refuse_pia: {
		content: "Тъй като сте отхвърлили ОВЗД, тя е върната за преглед за да се направят необходимите промени."
	},
	remove_attachment: {
		comment: "Коментар",
		content: "<span class='strong'>Предупреждение,</span><br>Сигурни ли сте че искате да<br>премахнете приложения обект?",
		keep: "Запази",
		remove: "Премахни"
	},
	remove_measure: {
		content: "<span class='strong'>Предупреждение,</span><br>Сигурни ли сте че искате да <br>премахнете тази мярка?",
		keep: "Запазете тази <br>мярка",
		remove: "Премахнете тази <br>мярка"
	},
	remove_pia: {
		content: "<span class='strong'>Предупреждение,</span><br>Сигурни ли сте, че <br>премахнете тази ОВЗД за постоянно?",
		remove: "Премахни тази ОВЗД"
	},
	remove_question: {
		content: "Сигурни ли сте че искате да изтриете този въпрос?",
		keep: "Отмени",
		remove: "Изтрий"
	},
	remove_structure: {
		content: "<span class='strong'>Предупреждение,</span><br>Сигурни ли сте че искате<br>да изтриете тази примерна ОВЗД?",
		remove: "Изтрий примерната ОВЗД"
	},
	same_comment: {
		content: "<span class='strong'>Предупреждение,</span><br>Моля впишете коментар, който е различен от последния записан."
	},
	signed_pia_validation: {
		content: "За да одобрите ОВЗД, прикачете подписания доклад.",
		download_pia: "Изтеглете доклада"
	},
	simple_pia_validation: {
		content: "Одобрихте ОВЗД."
	},
	start_evaluation: "Започнете преглед",
	unarchive_pia: {
		content: "<span class='strong'>Предупреждение,</span><br>Сигурни ли сте че искате да<br>разархивирате тази ОВЗД?",
		unarchive: "Разархивирай ОВЗД"
	},
	update_server_url_nok: {
		content: "Връзката със сървъра не е възможна: моля, проверете попълнения URL адрес.",
		introspect: "Клиентският идентификатор и клиентската тайна не са били потвърдени от сървъра, моля, проверете ги."
	},
	update_server_url_ok: {
		content: "Адресът на сървъра беше актуализиран."
	},
	validate_evaluation: {
		content: "Този раздел е готов за валидиране на ОВЗД."
	},
	validate_evaluation_to_correct: {
		content: "Съжаляваме,<br>Някои полета трябва да бъдат коригирани.<br>Върнете се в режим на редактиране<br> за да направите корекциите."
	},
	users: {
		"delete": {
			content: "<span class='strong'>Предупреждение,</span><br>Сигурни ли сте че искате да <br>изтриете този потребител?",
			confirm: "Изтрий този потребител",
			pia_exist: "Този потребител е свързан с една или повече ОВЗД, така че ще трябва да им сложите потребители."
		}
	}
};
var onboarding$m = {
	dashboard: {
		step1: {
			description: "TНатиснете <strong>+</strong> за да създадете първата си ОВЗД.",
			title: "Създайте ОВЗД"
		},
		step2: {
			description: "<p><strong>Редакторите</strong> написват първата версия на оценката.</p><p>Те например са мениджърите на проекта, свързан с обработване на данни.</p>",
			title: "Роли в ОВЗД"
		},
		step3: {
			description: "<p><strong>Проверяващите</strong> се включват във втората фаза.</p><p>Те използват юридическата или техническата си експертиза за проверка на качеството и съответствието на обработването.</p><p>Те са, например, длъжностните лица по защита на данните, юрисконсулти, ...</p>",
			title: "Роли в ОВЗД"
		},
		step4: {
			description: "<p><strong>Утвърждаващият</strong> приема или отхвърля прилагането на обработването. Той трябва да подпише оценката.</p><p>Той е администраторът на данни, например изпълнителният директор.</p>",
			title: "Роли в ОВЗД"
		},
		step5: {
			description: "<p><strong>Образците</strong> са допълнително удобство. Те се използват за създаване на предварително попълнена база за оценка.</p><p>Можете да създадете образци като отидете на съответния раздел достъпен от горното меню.</p>",
			title: "Образци"
		}
	},
	entry: {
		step1: {
			description: "За да се прехвърлите от една част на оценката в друга, използвайте лявото навигационно меню.",
			title: "Прелистване"
		},
		step2: {
			description: "Това се използва се за да се обясни целта на обработването и как ще бъде приложено.",
			title: "Контекст"
		},
		step3: {
			description: "Тези имат за цел да гарантират че обработването съответства на ОРЗД (GDPR).",
			title: "Основни принципи"
		},
		step4: {
			description: "Тези описват мерките за защита които вече са планирани за операцията по обработването и дават възможност да се оцени потенциалното й въздействие върху субектите на данни.",
			title: "Рискове"
		},
		step5: {
			description: "Това дава възможност на ДЛЗД да изрази мнението си относно прилагането на обработването и администраторът да го приеме или отхвърли.",
			title: "Валидиране"
		},
		step6: {
			description: "<p>Осигурява контекстово съдействие при извършване на оценката и е базирано на ОРЗД, наръчниците с мерки за защита и извършване на ОВЗД на CNIL</p><p>В допълнение на това съдържание, можете да създадете собствена база знания за лесен достъп до информация, специфична за организацията ви.</p>",
			title: "База знания"
		},
		step7: {
			description: "По всяко време при извършване на оценката, можета да го разтоварите в различни формати и да го споделите с колегите си.",
			title: "Експортирайте вашата ОВЗД"
		}
	},
	evaluation: {
		step1: {
			description: "Оценяването може да вземе предвид цял раздел, или да се извърши за всеки елементи от даден раздел.",
			title: "Оценете ОВЗД"
		},
		step2: {
			description: "Това оценяване информира редакторите че има липсващи елементи необходими да се извърши съответна преценка.</p><p>Оценяващият трябва да посочи това в съответното поле за <strong>коментар</strong>. Редакторът ще нанесе необходимите корекции.</p>",
			title: "Да се коригира"
		},
		step3: {
			description: "<p>Тази оценка означава че разглежданите елементи трябва да се преразгледат. Те са детайлизирани в полето с <strong>плана за действие / коригиращи мерки</strong> .</p><p>Тези мерки ще се добавят автоматично към частта от оценката на въздействието, съдържаща плана за действие. Необходимо е те да се приложат възможно най-скоро.</p>",
			title: "За подобряване"
		},
		step4: {
			description: "Тази оценка означава че тази част от обработването може да се приложи без промяна.",
			title: "Приемлива"
		},
		step5: {
			description: "Ако оценката на даден раздел все още не е започнала, искането за оценяване може да се отмени за да се направят промени в описанието на обработването.",
			title: "Отменете искането"
		}
	},
	general: {
		done: "Потвърди",
		next: "Следващо",
		skip: "Пропусни"
	},
	validated: {
		step1: {
			description: "С всяка завършена и валидирана ОВЗД може да се направи консултиране по всяко време посредством предназначения за това интерфейс.",
			title: "Консултирайте се с валидирана ОВЗД"
		},
		step2: {
			description: "Необходимо е на всяка ОВЗД да се извършва редовен преглед. Можете да я редактирате или копирате по всяко време за да прегледате съдържанието й в зависимост от промените в обработването.",
			title: "Актуализирайте валидирана (утвърдена) ОВЗД"
		}
	}
};
var opinions$m = {
	content: ", имайте предвид следното:",
	dpo_lock: "Моля завършете останалите раздели, за да можете да попълните становището на ДЛЗД",
	dpo_opinion: "Становище на ДЛЗД",
	edit: "Редактирай",
	people_opinion: "Становище на заинтересованите лица",
	placeholder_concerned_people_name: "Име(на) на заинтересованите лица",
	placeholder_dpo_name: "Име(на) на ДЛЗД",
	placeholder_dpo_opinion: "Отбележете причините за избора си.",
	placeholder_people_opinion: "Опишете как са взети становищата и как са анализирани. Ако становищата не са взети предвид, отбележете причините.",
	placeholder_search_content: "Аргументирайте причината да не е потърсено становището на заинтересованите лица.",
	treatment_lock: "Моля завършете другите раздели за да можете да впишете становището на заинтересованите лица.",
	treatment_nok: "Обработването не трябва да се извършва.",
	treatment_ok: "Обработването може да се извършва."
};
var pia$m = {
	attachments: {
		add: "Добави",
		download: "Изтеглете приложения обект",
		loading: "Качване...",
		remove: "Премахни",
		title: "Приложени обекти",
		no_attachment: "Няма налични прикачени обекти"
	},
	footer: {
		ask_evaluation: "Поискайте преглед",
		mandatory_fields: "Всички полета трябва да са попълнени",
		structure_add_question: "Добавете въпрос",
		subsection_validated: "Подразделът е прегледан, очаква окончателно валидиране",
		validate_evaluation: "Валидирайте прегледа"
	},
	header: {
		display_action_plan: "Покажи <br>плана за действие",
		edition: "Редакция от",
		evaluation: "Оценяване",
		preview: "Първоначален преглед"
	},
	sections: {
		based_on_structure_name: "Базиран на примерната ОВДЗ:",
		homepage_link: "Обратно към началния екран",
		refuse_pia: "Отхвърлена ОВЗД",
		status: {
			evaluation: {
				cancel: "Отмяна на искане за преглед.",
				cancel_button: "Отмени искането за преглед",
				content: "На тази част все още не е извършен преглед. Ако искате да редактирате съдържанието, изпратено за преглед, трябва да ",
				title: "Очаква преглед."
			},
			validation: {
				cancel: "Отмяна на искането за валидиране.",
				cancel_button: "Отмени искането за валидиране",
				content: "На тази част е извършен преглед и очаква валидиране на цялостната оценка на ОВЗД. Ако искате да промените извършения преглед, трябва да ",
				title: "Очаква валидиране."
			}
		},
		validate_pia: "Валидирайте ОВЗД"
	},
	statuses: [
		"В процес на извършване",
		"Отхвърлена",
		"Валидиране",
		"Подписано валидиране",
		"Архивирана",
		"Очаква валидиране"
	]
};
var questions$m = {
	edit: "Редактирайте въпроса",
	gauges: [
		"(Неопределена)",
		"Пренбрежима",
		"Ограничена",
		"Значителна",
		"Максимална"
	],
	placeholder_title: "Заглавие на въпроса (задължително)",
	remove: "Изтрийте въпроса"
};
var rejection_page$m = {
	applied_adjustments: "Предложени корекции",
	applied_adjustments_placeholder: "Опишете промените, които са направени в ОВЗД.",
	button: {
		abandon_treatment: "Откажете се от обработването",
		reject_pia: "Отхвърлете ОВЗД",
		send_for_validation: "Отново изпратено за одобрение"
	},
	previous_rejection: "Предишно отхвърляне",
	rejection_reason: "Причина за отхвърлянето",
	rejection_reason_placeholder: "Опишете причините за отхвърлянето на ОВЗД.",
	title: "Валидиране на историята"
};
var sections$m = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Направете кратко описание на обработването: наименованието му, целта, основанията, контекста на обработването и т.н.",
						title: "Какво е обработването, за което става въпрос?"
					},
					"2": {
						placeholder: "Опишете отговорностите на заинтересованите страни: администраторът на личните данни, възможните обработващи и съвместни администратори.",
						title: "Какви са отговорностите, свързани с обработването?"
					},
					"3": {
						placeholder: "Избройте съответните стнадарти, които са приложими за обработването, особено одобрени кодекси за поведение и сертификати за защита на данните.",
						title: "Има ли стандарти приложими за обработването?"
					}
				},
				short_help: "В тази част идентифицирате и представяте целта на изследването.",
				title: "Общ преглед"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Избройте категориите данни, които (ще) се събират и обработват. За всяка категория определете срока на съхранение, получателите и лицата с достъп до данните.",
						title: "Какви данни (ще) се обработват?"
					},
					"2": {
						placeholder: "Представете продукта и опишете най-общо как работи (от събирането на данните до унищожаването им, различните етапи на процеса, съхранението и т.н.), като използвате например диаграма с потоците данни (можете да я добавите като прикачен обект), както и детайлно описание на процесите, които се извършват при обработването.",
						title: "Как се случва жизненият цикъл на данните и процесите?"
					},
					"3": {
						placeholder: "Избройте активите, използавни при обработването (операционни системи, софтуерни приложения, системи за управление на бази данни, софтуерни офис пакети, протоколи, конфигурации и т.н.)",
						title: "Кои са активите, които се използват при обработването?"
					}
				},
				short_help: "Тази част ви дава възможност да дефинирате и опишете обхвата на обработването в детайли.",
				title: "Данни, процеси и използвани при обработването активи"
			}
		},
		short_help: "Този раздел ви дава ясна представа за обработването/ обработванията на лични данни, за което става въпрос.",
		title: "Контекст"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Обяснете как процесите на обработване се извършват законосъобразно, добросъвестно и по прозрачен начин.",
						short_title: "Цели",
						title: "Целите на обработване определени ли са законосъобразно, добросъвестно и по прозрачен начин?"
					},
					"2": {
						placeholder: "Опишете какво е/ са правното основание за обработването (например: съгласие, изпълнение на договор, изпълнение на правно задължение, защита на жизненоважни интереси и т.н.)",
						short_title: "Правно основание",
						title: "Какво правно основание прави процеса на обработване законосъобразен?"
					},
					"3": {
						placeholder: "Обяснете защо всяка от категориите данни, които се събират, е необходима за целта на обработването.",
						short_title: "Подходящи данни",
						title: "Може ли да се твърди, че данните, които се събират, са подходящи, свързани със и ограничени до необходимото във връзка с целите, за които се обработват („свеждане на данните до минимум“)?"
					},
					"4": {
						placeholder: "Опишете какви стъпки са предприети за да се осигури качеството на данните.",
						short_title: "Точност на данните",
						title: "Данните точни и актуални ли са?"
					},
					"5": {
						placeholder: "Обяснете как сроковете за съхранение кореспондират със законовите изисквания и/или нуждите на обработването.",
						short_title: "Срок на съхранение",
						title: "Какви са сроковете за съхранение на данните?"
					}
				},
				short_help: "В тази част демонстрирате законосъобразността на обработването и на избраните категории данни.",
				title: "Пропорционалност и необходимост"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Опишете каква информация се предоставя на субектите на данни и по какви начини.",
						short_title: "Информация, която се предоставя на субектите на данни",
						title: "Как субектите на данни биват информирани за обработването?"
					},
					"2": {
						placeholder: "Опишете мерките, които гарантират, че е получено съгласието на потребителите.",
						short_title: "Получаване на съгласие",
						title: "Ако е приложимо, как се получава съгласието на субектите на данни?"
					},
					"3": {
						placeholder: "Опишете мерките, които се прилагат, така че субектите на данни да могат да упражнят правото си на достъп до данните и правото на преносимост.",
						short_title: "Право на достъп и на преносимост на данните",
						title: "Как субектите на данни могат да упражнят правата си на достъп и на преносимост на данните?"
					},
					"4": {
						placeholder: "Опишете мерките, които се прилагат така, че субектите на данни да могат да упражнят правото си на коригиране и правото на изтриване на личните им данни.",
						short_title: "Право на коригиране и право на изтриване",
						title: "Как субектите на данни могат да упражнят правата си на коригиране и на изтриване?"
					},
					"5": {
						placeholder: "Опишете мерките, които се прилагат, така че субектите на данни да могат да упражнят правото си на ограничаване на обработването си и правото на възражение.",
						short_title: "Право на ограничаване на обработването и право на възражение",
						title: "Как субектите на данни могат да упражнят правата си на ограничаване на обработването и на възражение?"
					},
					"6": {
						placeholder: "За всеки обработващ, опишете отговорностите му (продължителност, обхват, цел, документирани указания, предварително одобрение) и представете договорите, кодекси за поведение и сертификати, определящи задачите и задълженияте му.",
						short_title: "Обработващ(и) личните данни",
						title: "Може ли да се твърди, че задълженията на обработващия са ясно определени и обвързани с договор?"
					},
					"7": {
						placeholder: "За всяка държава извън ЕС в която се изпращат данни за обработване или съхранение, посочете името ѝ и дали е призната за държава с адекватно ниво на защита; респективно, опишете гаранциите, които са предвидени при предаването на данни.",
						short_title: "Предаване на данни",
						title: "В случай на предаване на данни извън Европейския съюз, данните защитени ли са адекватно?"
					}
				},
				short_help: "В тази част демонстрирате, че сте приложили всички необходими мерки субектите на данни да могат да упражнят правата си.",
				title: "Мерки за защита на правата на субектите на данни"
			}
		},
		short_help: "В този раздел изграждате цялостната рамка за съвместимост с изискванията за защита на личните данни.",
		title: "Основни принципи"
	},
	"3": {
		items: {
			"1": {
				short_help: "В този раздел идентифицирате мерките (съществуващи или планирани) които допринасят за сигурността на данните.",
				title: "Планирани или съществуващи мерки"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Впишете потенциалните въздействия",
						title: "Кои биха били главните <span class='green-highlight'>въздействия върху субектите на данни</span> ако рискът се реализира?"
					},
					"2": {
						placeholder: "Попълнете заплахите",
						title: "Кои са главните <span class='green-highlight'>заплахи</span> които водят до риска?"
					},
					"3": {
						placeholder: "Попълнете източниците на риск",
						title: "Кои са <span class='green-highlight'>източниците</span> на риск?"
					},
					"4": {
						placeholder: "Натиснете тук за избор на контроли за третиране на риска.",
						title: "Кои от идентифицираните <span class='green-highlight'>планирани мерки</span> допринасят за третиране на риска?"
					},
					"5": {
						placeholder: "Аргументирайте тук оценката на прогнозната сериозност на риска.",
						title: "Каква очаквате да е <span class='green-highlight'>сериозността на риска</span>, особено предвид потенциалното въздействие и планираните мерки?"
					},
					"6": {
						placeholder: "Аргументирайте тук оценката на прогнозната вероятност.",
						title: "Как оценявате прогнозната <span class='green-highlight'>вероятност на риска</span>, особено предвид заплахите, източниците на риск и планираните мерки?"
					}
				},
				short_help: "Анализирайте причините и последствията от незаконен достъп до данните и оценете прогнозната сериозност и вероятността на събитието.",
				title: "Незаконен достъп до данните"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Впишете потенциалните въздействия",
						title: "Какво би било главното <span class='green-highlight'>въздействие върху субектите на данни</span> ако рискът се реализира?"
					},
					"2": {
						placeholder: "Впишете заплахите",
						title: "Кои са главните <span class='green-highlight'>заплахи</span> които водят до риска?"
					},
					"3": {
						placeholder: "Впишете източниците на риск",
						title: "Кои са <span class='green-highlight'>източниците</span> на риск?"
					},
					"4": {
						placeholder: "Натиснете тук за избор на контроли които третират риска.",
						title: "Кои от идентифицираните <span class='green-highlight'>контроли</span> допринасят за третиране на риска?"
					},
					"5": {
						placeholder: "Аргументирайте тук оценката на прогнозната сериозност на риска.",
						title: "Как оценявате прогнозната <span class='green-highlight'>сериозност на риска</span>, особено предвид потенциалните въздействия и планираните мерки?"
					},
					"6": {
						placeholder: "Аргументирайте тук оценката на прогнозната вероятност.",
						title: "Как оценявате прогнозната <span class='green-highlight'>вероятност на риска risk</span>, особено предвид заплахите, източниците на риска и планираните контроли (мерки)?"
					}
				},
				short_help: "Анализирайте причините и последствията от нежелана промяна на данните и оценете прогнозната сериозност и вероятността на събитието.",
				title: "Нежелана промяна на данните"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Впишете потенциалното въздействие",
						title: "Какво биха били главните <span class='green-highlight'>въздействия върху субектите на данни</span> ако рискът се реализира?"
					},
					"2": {
						placeholder: "Впишете заплахите",
						title: "Кои са главните <span class='green-highlight'>заплахи</span> които водят до риска?"
					},
					"3": {
						placeholder: "Впишете източниците на риск",
						title: "Кои са <span class='green-highlight'>източниците</span> на риск?"
					},
					"4": {
						placeholder: "Натиснете тук за да изберете контроли за третиране на риска.",
						title: "Кои от идентифицираните <span class='green-highlight'>контроли</span> допринасят за третиране на риска?"
					},
					"5": {
						placeholder: "Аргументирайте тук оценката на прогнозната сериозност на риска.",
						title: "Как оценявате прогнозната <span class='green-highlight'>сериозност на риска</span>, особено предвид потенциалните въздействия и планираните контроли (мерки)?"
					},
					"6": {
						placeholder: "Аргументирайте тук оценката на прогнозната вероятност.",
						title: "Како оценявате прогнозната <span class='green-highlight'>вероятност на риска</span>, особено предвид заплахите, източниците на риск и планираните контроли (мерки)?"
					}
				},
				short_help: "Анализирайте причините и последствията от загуба на данни и оценете прогнозната сериозност и вероятност на събитието.",
				title: "Загуба на данните"
			},
			"5": {
				short_help: "Чрез тази визуализация имате глобален и синтезиран поглед върху ефекта от контролите които третират рисковете.",
				title: "Общ преглед на рисковете"
			}
		},
		short_help: "В този раздел оценявате рисковете за поверителността, вземайки предвид съществуващите или планирани контроли (мерки).",
		title: "Risks"
	},
	"4": {
		items: {
			"1": {
				short_help: "Чрез тази визуализация сравнявате състоянието на рисковете преди и след прилагането на допълнителните контроли (мерки).",
				title: "Картографиране на рисковете"
			},
			"2": {
				short_help: "Планирайте в детайли прилагането на допълнителните контроли (мерки) идентифицирани при извършването на ОВЗД. Планът за действие се актуализира автоматично при оценяване на различните елементи, от които се състои ОВЗД.",
				title: "План за действие"
			},
			"3": {
				short_help: "Изложете становището на лицето, отговарящо за защитата на личните данните и поверителността (длъжностното лице по защита на данните, ако има такова). Изложете становищата на субектите на данни или техните представители.",
				title: "Становища на ДЛЗД и субектите на данни"
			},
			"4": {
				title: "Валидирайте/утвърдете ОВЗД"
			},
			"5": {
				title: "Отхвърлете ОВЗД"
			}
		},
		short_help: "В този раздел подготвяте и формализирате валидирането на ОВЗД.",
		title: "Валидиране"
	}
};
var settings$m = {
	content: "Моля, посочете адреса (URL) на отдалечения сървър:",
	title: "Настройки",
	update: "Актуализирайте URL"
};
var summary$m = {
	action_plan: {
		fundamental_principles: "Основни принципи",
		implementation_date: "Очаквана дата на прилагане",
		implementation_responsible: "Отговорен за прилагането",
		measures: "Съществуващи или планирани мерки",
		no_action_plan: "Няма записан план за действие.",
		risks: "Рискове",
		title: "План за действие"
	},
	actions: {
		complete_download: "Изтеглете пълния доклад",
		complete_download_desc: "Експортирайте в .zip архив цялото съдържание на доклада (.doc и изображения), прикачените обекти и плана за действие в .csv формат.",
		individual_download: "Изтеглете елементите на доклада",
		individual_download_desc: "Експортирайте специфични елементи от доклада.",
		individual_download_pdf: "Доклад за ОВЗД (.pdf)",
		individual_download_doc: "Текстове (.doc)",
		individual_download_images: "Визуални елементи (.png) включително прегледа на риска, картографирането на риска и плана за действие.",
		individual_download_json: "Импортирайте доклада в инструмента за ОВЗД (.json файл)",
		individual_download_select: "Изберете елементи за експортиране:",
		individual_to_download: "Изтеглете",
		print: "Отпечатайте доклада",
		print_and_download: "Отпечатайте и изтеглете"
	},
	attachments: "Прикачени обекти",
	concerned_people_name: "Имена на заинтересованите лица",
	concerned_people_opinion: "Становища на заинтересованите лица",
	concerned_people_searched_opinion: "Искане на становище от заинтересованите лица",
	concerned_people_status: "Статус на заинтересованите лица",
	concerned_people_unsearched_opinion_comment: "Причини поради които не е потърсено становището на заинтересованите лица",
	content_choice: [
		"Обработването не трябва да се извършва.",
		"Обработването може да се извършва."
	],
	creation_date: "Дата на създаване",
	csv_action_plan_comment: "Коментар към плана за действие",
	csv_evaluation_comment: "Коментар към оценката",
	csv_file_title: "План за действие",
	csv_implement_date: "Прогнозна дата на прилагане",
	csv_people_in_charge: "Отговорно лице",
	csv_section: "Раздел",
	csv_title_object: "Заглавие",
	download_csv: "План за действие (.csv)",
	dpo_name: "Име на ДЛЗД",
	dpo_opinion: "Становище на ДЛЗД",
	dpo_status: "Статус на ДЛДЗ",
	gauges: {
		"1": "Пренебрежима",
		"2": "Ограничена",
		"3": "Значителна",
		"4": "Максимална"
	},
	modification_made: "Извършени промени",
	people_search_status_nok: "Не е потърсено становището на заинтересованите лица.",
	people_search_status_ok: "Потърсено е становището на заинтересованите лица.",
	pia_assessor: "Име на извършващия оценката",
	pia_author: "Име на автора",
	pia_name: "ОВЗД",
	pia_validator: "Име на валидиращия",
	preview_dpo_opinion: "Становища на ДЛЗД и субектите на данни",
	preview_edition: "Редактиране",
	preview_evaluation: "Оценка",
	preview_no_data: "Няма данни за показване.",
	preview_status: "Статус",
	preview_subtitle: "Обща информация",
	preview_title: "Първоначален преглед",
	preview_validation: "Валидиране",
	preview_validation_section: "Валидиране",
	preview_guests: "Гости",
	previous_page: "Назад към предишната страница",
	rejection_reason: "Причина за отхвърлянето",
	revision: {
		current_version: "Сегашна версия",
		pia_version: "Версии на ОВЗД",
		restore_version: "Възстанови",
		revision: "Версии и ревизии",
		save: "Създай нова версия",
		show: "Покажи {{length}} версиите"
	},
	risks_cartography_title: "Картографиране на риска",
	risks_overview_title: "Общ преглед на рисковете",
	title: "Информация за ОВЗД"
};
var users$m = {
	add_new_user: "Добави нов потребител",
	cancel: "Отмени",
	choose_profile: "Изберете профил за този потребител",
	"continue": "Продължи",
	data: "Данни",
	edit_user: "Редактирай потребител",
	email: "Електронна поща",
	first_name: "Малко име",
	functional_admin: "Функционален администратор",
	last_name: "Фамилия",
	new_user_button: "Нов потребител",
	profile: "Профил",
	remove: "Изтрий",
	remove_current_user_error_message: "Не можете да изтриете собствения си акаунт.",
	remove_last_functional_admin_error_message: "Не можете да изтриете този потребител тъй като трябва да остане поне един акаунт на технически (функционален) администратор.",
	remove_user_with_linked_pias_error_message: "Няколко ОВЗД са свързани с този потребител и поради това не можете да го изтриете.",
	technical_admin: "Технически администратор",
	update: "Актуализирай",
	user: "Потребител",
	state: "Състояние на акаунта",
	errors: {
		edit_user: {
			"406": "Информацията предоставена при създаване на акаунта е невалидна."
		}
	},
	"delete": {
		confirm: "Премахни потребителя",
		content: "Сигурни ли сте че искате да изтриете този потребител?"
	},
	access_locked: {
		"false": "Активна",
		"true": "Чака активиране"
	},
	role: {
		label: "Роля(и)",
		author: "Автор",
		evaluator: "Оценяващ",
		validator: "Валидиращ/утвърждаващ",
		guest: "Гост"
	}
};
var validation_page$m = {
	add_signed_pia: "Прикачете подписаната ОВЗД",
	after_reading: "След изчитане на пълната ОВЗД за обработването на лични данни, свързано с ",
	button: {
		rejection: "Отхвърлям ОВЗД",
		signed_validation: "Одобрявам ОВЗД <br>(подписана)",
		simple_validation: "Одобрявам ОВЗД <br>(директно)"
	},
	confirmation1: "Удостоверявам, че описаното в ОВЗД обработване на лични данни съответства на действителната ситуация.",
	confirmation2: "Удостоверявам, че съм наясно относно рисковете, които са породени от съществуващите или планирани мерки.",
	confirmation3: "Одобрявам коригиращите мерки, предложени в плана за действие.",
	confirmation4: "Задължавам се да приложа предложените мерки без излишно забавяне.",
	latest_signed_attachment: "Последен подписан прикачен обект",
	mandatory_fields: "Всички кутийки трябва да са отбелязани",
	remove_attachment: "Премахни прикачения обект",
	responsible: "Лица, отговорни за валидирането на ОВЗД: ",
	signed_attachments_history: "История на подписаните прикачени обекти",
	tools: {
		dashboard: "Начален екран",
		display_pia: "Покажи доклада"
	},
	validated_pia_with_signature: "Одобрена",
	waiting_for_signature: "Очаква подпис"
};
var bg = {
	about: about$m,
	action_plan: action_plan$m,
	authentication: authentication$m,
	cartography: cartography$m,
	comments: comments$m,
	conflict: conflict$m,
	date: date$m,
	errors: errors$m,
	evaluations: evaluations$m,
	header: header$m,
	help: help$m,
	homepage: homepage$m,
	knowledge_base: knowledge_base$m,
	measures: measures$m,
	misc: misc$m,
	modals: modals$m,
	onboarding: onboarding$m,
	opinions: opinions$m,
	"overview-risks": {
	important: "Важно",
	limited: "Ограничено",
	maximal: "Максимално",
	measures: "Мерки",
	negligible: "Пренебрежимо",
	potential_impacts: "Потенциални въздействия",
	"risk-access_x": "Сериозност",
	"risk-access_y": "Вероятност",
	"risk-change_x": "Сериозност",
	"risk-change_y": "Вероятност",
	"risk-disappearance_x": "Сериозност",
	"risk-disappearance_y": "Вероятност",
	sources: "Източници",
	threat: "Заплахи"
},
	pia: pia$m,
	questions: questions$m,
	rejection_page: rejection_page$m,
	sections: sections$m,
	settings: settings$m,
	summary: summary$m,
	users: users$m,
	validation_page: validation_page$m
};

var about$l = {
	contribute: "If you wish to contribute to the translation of the software in another language or improve the existing translations, we recommend you to <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">read the page describing the steps to follow</a>.",
	description: "This tool is originally designed by the <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, the French Data Protection Authority, to help data processor to be compliant with the GDPR. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>This software is free and open. If you wish to get involved in this project, you are welcome to download the source code from Github, modify it and share it with the community.",
	licences: "Library licences:",
	title: "O nástroji AIIA",
	translators: "The PIA software is currently available in eighteen languages. The French and English versions are provided by the CNIL. The others versions result from the contributions of the following individuals:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Číslo verze"
};
var action_plan$l = {
	acceptable_measures: "Přijatelná opatření",
	edit: "Upravit",
	improvable_measures: "Opravitelná opatření",
	measures: "Plánovaná nebo stávající opatření",
	no_action_plan: "Nebyl zaznamenán žádný akční plán.",
	placeholder_person_in_charge: "Zodpovědná implementace",
	principles: "Základní zásady",
	risk1: "Nelegitimní přístup k údajům",
	risk2: "Nežádoucí modifikace dat",
	risk3: "Ztráta dat",
	risks: "Rizika",
	title: "Přehled"
};
var authentication$l = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Tento software od <strong>Francouzského Úřadu pro Ochranu Údajů (CNIL)</strong> je určen k tomu, aby vedl Správce údajů při vytváření a prokazování shody s GDPR. Pomáhá správně provádět hodnocení dopadu ochrany údajů usnadněním používání metody PIA vyvinuté CNIL.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Start",
	start_app: "Přístup k softwaru PIA (Beta)",
	subtitle1: "Platforma pro vytváření a správu vašich AIIA",
	subtitle2: "Přístupové nástroje a glosáře",
	title: "Posouzení dopadů na soukromí",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$l = {
	important: "Důležité",
	legend1: "Plánovaná nebo stávající opatření",
	legend2: "S prováděnými nápravnými opatřeními",
	legend3: "(NPU) Nelegitimní přístup k údajům",
	legend4: "(NMD) Nežádoucí modifikace dat",
	legend5: "(ZD) Ztráta dat",
	likelihood_axe: "Pravděpodobnost rizika",
	limited: "Omezené",
	maximal: "Maximální",
	negligible: "Zanedbatelné",
	risk1_access: "(NPU)",
	risk2_modification: "(NMD)",
	seriousness_axe: "Vážnost rizika"
};
var comments$l = {
	comment: "Komentář",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "komentář(e)",
	new_comment: "Komentář",
	placeholder_new_comment: "Zanechat komentář",
	send: "Send"
};
var conflict$l = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$l = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$l = {
	content: "If you encounter other problems or if you have suggestions for improvement,<br>you can send them back via this form: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Stránka nebyla nalezena."
};
var evaluations$l = {
	acceptable: "Přijatelné",
	action_plan_comment: "Akční plán/Nápravná opatření",
	evaluation_comment: "Komentář k hodnocení",
	gauges: {
		"0": "(Nedefinováno)",
		"1": "Zanedbatelné",
		"2": "Omezené",
		"3": "Důležité",
		"4": "Maximální",
		likelihood: "Pokud vezmeme v úvahu akční plán, jak přehodnotíte <span class='red-highlight'>pravděpodobnost tohoto rizika </span>?",
		seriousness: "Pokud vezmeme v úvahu akční plán, jak přehodnotit <span class='red-highlight'>závažnost tohoto rizika </span>?"
	},
	improvable: "Vylepšitelné",
	placeholder_acceptable: "TO BE TRANSLATED - According to the available information, the measures implemented are adequate to properly meet the requirements for protecting the data.",
	placeholder_improvable1: "TO BE TRANSLATED - According to the available information, additional measures are to be implemented in order to improve the data protection of the processing.",
	placeholder_improvable2: "TO TRANSLATE - Enter your comments.",
	placeholder_to_correct: "TO BE TRANSLATED - The information provided are not sufficient to properly evaluate them. Send back to the editor to improve the original submission.",
	status: [
		"Čeká",
		"Opravit",
		"Vylepšit",
		"Přijato"
	],
	title: "Hodnocení",
	to_correct: "Opravit"
};
var header$l = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "PIA příklad",
		title: "Nápověda"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Znalostní báze",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "TO BE TRANSLATED - CNIL provided translations",
		community_translations: "TO BE TRANSLATED - Community provided translations",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "TO BE TRANSLATED - Translation revised by European DPA",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "TO BE TRANSLATED - Original version",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "PIA - privacy impact assessment",
	logo_title: "Posouzení dopadů na soukromí",
	structures: "TO TRANSLATE - PIA templates",
	tools: {
		about: "O nás",
		accessibility: "Dostupnost pro zrakově postižené (barvy s vysokým kontrastem, daltonismem)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "TO TRANSLATE - Settings",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$l = {
	definition: {
		data1: {
			content: "Obsah je psán",
			title: "Použít nástroj PIA"
		},
		data2: {
			qa1: {
				content: "When encountering those display issues, close the application and reload it. It usually fixes the issue. You won’t lose the information you have entered ; it is  automatically saved as you type.",
				title: "I get display issues such as icons being stuck in one state or missing elements from the interface"
			},
			qa2: {
				content: "This known issue is currently being fixed. If you encounter this problem, we recommend that you fill in the justification field of the estimated level of severity and / or likelihood. You will be able to edit the gauge once the bug is fixed.",
				title: "I can’t edit the gauges for evaluating the severity and likelihood of a risk"
			},
			qa3: {
				content: "Several bugs have been observed when importing a PIA, and in particular the level gauges for evaluating the severity and likelihood of a risk may disappear. In this case, please refer to the above mentioned issue. Besides, a PIA may not appear on the dashboard after importing it. This is a display issue and you just need to refresh the page.",
				title: "I encounter issues when importing a PIA"
			},
			qa4: {
				content: "This is only a display bug and it has no effect on the text you enter in a field. This visual problem will be fixed soon.",
				title: "When I copy / paste text, it is highlighted."
			},
			qa5: {
				content: "In order to evaluate a section, it is mandatory to fill in all the fields. Please check if this is the case. When editing a risk, you must have at least one technical or organizational measure that mitigates the risk in order to ask for an evaluation of the risk.",
				title: "I can’t evaluate a section"
			},
			qa6: {
				content: "Please close the PIA you are editing and re-open it. The content should then be displayed in the language you have selected.",
				title: "When switching language, the texts are not translated"
			},
			qa7: {
				content: "For the moment, the navigation menu icons are not refreshed after refusing a PIA. You have to check each section and change the information and/or evaluation according to the reasons for refusing the PIA. Once all section have been reviewed, you should be able to request PIA validation again.",
				title: "I have refused to validate a PIA but I don’t know what to do now"
			},
			title: "Známé problémy"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Nápověda"
};
var homepage$l = {
	cards: {
		author: "Upravil",
		category: "TO TRANSLATE - Category",
		creation_status: "Vytvořeno",
		date: "Datum",
		evaluation: "Posouzení",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Importovat AIIA",
		import_structure: "TO TRANSLATE - Import template",
		item: {
			consult_pia: "TO TRANSLATE - Consult",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Upravit",
			edit_structure: "TO TRANSLATE - Edit template",
			tools: {
				action_plan: "Zobrazit<br>akční plán",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Duplikovat",
				"export": "Exportovat",
				more_options: "Více voleb",
				pia: "Zobrazit<br>PIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Nová AIIA",
		new_structure: "TO TRANSLATE - New template",
		or: "nebo",
		pia_name: "PIA",
		placeholder_author: "Křestní jméno, Příjmení",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Křestní jméno, Příjmení",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Importovat AIIA",
		placeholder_import_structure: "TO TRANSLATE - Import template",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Nová AIIA",
		placeholder_new_structure: "TO TRANSLATE - New template",
		placeholder_pia_name: "PIA název",
		placeholder_sector_name: "TO TRANSLATE - Associated sector's name",
		placeholder_start: "Všechna pole musí být vyplněna",
		placeholder_structure: "TO TRANSLATE - Default template",
		placeholder_structure_name: "TO TRANSLATE - Template's title",
		placeholder_validation: "Křestní jméno, Příjmení",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		start: "Start",
		status: "Stav",
		structure: "TO TRANSLATE - Template",
		structure_name: "TO TRANSLATE - Template's name",
		title_close_creation: "Zavřít",
		validation: "Validation"
	},
	filters: {
		assessor: "Posuzovatel",
		author: "Autora",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Začínáme! <br><br>Chcete-li iniciovat PIA,<br> klikněte na Nová AIIA",
		card_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous !<br><br>Pour commencer<br>un modèle, cliquez<br> sur le +",
		category: "TO TRANSLATE - Category",
		date: "Datumu",
		import_pia: "Importovat AIIA",
		import_structure: "TO BE TRANSLATED - Importer modèle",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Začínáme! Chcete-li zahájit PIA, klikněte na tlačítko +",
		list_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous ! Pour commencer<br>un modèle, cliquez sur le +",
		name: "Názvu",
		new_pia: "Nová AIIA",
		new_structure: "TO BE TRANSLATED - Nouveau modèle",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		sort: "Seřadit",
		sort_by: "podle",
		status: "Stavu",
		validator: "Validátora"
	},
	lists: {
		column_actions: "Akce",
		column_author: "Úpravy",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Vytvořeno",
		column_evaluation: "Posouzení",
		column_pia: "PIA",
		column_progression: "Postup",
		column_sector_name: "TO TRANSLATE - Associated sector",
		column_status: "Stav",
		column_structure: "TO TRANSLATE - Template",
		column_structure_name: "TO TRANSLATE - Template",
		column_updated_at: "Naposledy otevřeno",
		column_validation: "Validace",
		item: {
			tools: {
				action_plan: "Zobrazit akční plán",
				archive: "TO TRANSLATE - Archive",
				consult: "TO BE TRANSLATED - Consult",
				duplicate: "Duplikovat",
				edit: "Upravit",
				"export": "Exportovat",
				pia: "Zobrazit AIIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$l = {
	add_measure: "Přidat",
	add_measure_hint: "Můžete také přidat opatření z databáze znalostí.",
	category: {
		definition: "Definice",
		example: "Příklad",
		general_measure: "Fyzická bezpečnostní kontrola",
		measure_on_data: "Logická bezpečnostní kontrola",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Organizační kontrola",
		principle: "Zásada"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Vše",
		definitions: "Definice",
		general_measures: "Kontroly fyzické bezpečnosti",
		measures_on_data: "Logické bezpečnostní prvky",
		no_result: "Nebyl nalezen žádný výsledek.",
		organizational_measures: "Organizační kontroly",
		title: "Filtry"
	},
	placeholder_add_measure: "Přidat toto opatření",
	placeholder_help: "Vstupní pomůcky",
	search: "Vyhledat",
	slugs: {
		PIA_DEF_ACC: {
			description: "The data subject shall have the right to obtain from the controller confirmation as to whether or not personal data concerning him or her are being processed, and, where that is the case, access to the personal data and the information described in <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 15 of [GDPR]</a>",
			name: "Right of access",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Process removing the identifying characteristics from personal data. To assess the robustness of an anonymisation processes, see the <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Anonymisation",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Procedures preserving and managing the electronic archives containing the personal data intended to ensure their value (specifically, their legal value) throughout the entire period necessary (transfer, storage, migration, accessibility, elimination, archiving policy, protection of confidentiality, etc.).",
			name: "Archiving",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Every person with legitimate access to personal data (employees, contracting parties and other third parties) should be identified by a unique identifier. Choose an authentication method to open sessions that is appropriate to the context, the risk level and the robustness expected. Recommendations: if the risks are not elevated, a password may be used; however, if the risks are higher, use a one-time password token but change the default activation password, or, when part of the password is sent by SMS, a card with a PIN code, an electronic certificate or any other form of strong authentication.",
			name: "Authentication",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Measure making personal data unintelligible to anyone without access authorization (symmetric or asymmetric encryption, use of public algorithms known to be strong, authentication certificate, etc.).",
			name: "Encryption",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Data organisation methods that reduce the possibility that personal data can be correlated and that a breach of all personal data may occur. For instance, by identifying the personal data useful only to each business process and logically separating them.",
			name: "Data partitioning",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Any freely given, specific, informed and unambiguous indication of the data subject's wishes by which he or she, by a statement or by a clear affirmative action, signifies agreement to the processing of personal data relating to him or her.<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 4.10 of [GDPR]</a>",
			name: "consent",
			source: "GDPR Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Means implemented to limit the risks that unauthorized persons will access personal data electronically, it requires among other things to : <br>- <strong>Manage users' profiles</strong> by separating tasks and areas of responsibility (preferably in centralised fashion) to limit access to personal data exclusively to authorised users by applying need-to-know and least-privilege principles.<br>- <strong>Withdraw the rights of employees, contracting parties and other third parties when they are no longer authorised to access a premises or a resource</strong> or when their <strong>employment contract ends</strong>.",
			name: "Logical access controls",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Any information relating to an identified or identifiable natural person (‘data subject’); an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 4.1 of [GDPR]</a>",
			name: "Personal data",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Natural or legal person, public authority, agency or another body, to which the personal data are disclosed, whether a third party or not. However, public authorities which may receive personal data in the framework of a particular inquiry in accordance with Union or Member State law shall not be regarded as recipients; the processing of those data by those public authorities shall be in compliance with the applicable data protection rules according to the purposes of the processing. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 4.9 of [GDPR]</a>",
			name: "Recipient",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: " The data subject shall have the right to obtain from the controller the erasure of personal data concerning him or her without undue delay and the controller shall have the obligation to erase personal data without undue delay, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 17 of [GDPR]</a>",
			name: "Right to erasure",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Expected benefits (for the organisation, for the data subjects, for society in general, etc.).",
			name: "Stakes",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Personal data shall be accurate and, where necessary, kept up to date; every reasonable step must be taken to ensure that personal data that are inaccurate, having regard to the purposes for which they are processed, are erased or rectified without delay (‘accuracy’). <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 5.1 d) of [GDPR]</a>",
			name: "Quality of data",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Severity represents the magnitude of a risk. It primarily depends on the prejudicial nature of the potential impacts.",
			name: "Severity",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "The data subject shall have the right to obtain from the controller restriction of processing, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 18 of [GDPR]</a>",
			name: "Right to restricting of processing",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Set up a logging architecture to allow early detection of incidents involving personal data and to have information that can be used to analyze them or provide proof in connection with investigations.",
			name: "Surveillance",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Procedure comprising one or more individual actions on data supporting assets. It is used, intentionally or otherwise, by risk sources and may cause a feared event.",
			name: "Threat",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Threats regarding: - <strong>Hardware</strong>, used inappropriately, observed, altered, lost (use or transportation of sensitive hardware for personal purposes, watching a person's screen without their knowledge while on the train, tracking by a hardware-based key logger, etc.)<br> - <strong>Software</strong>, used inappropriately, observed, altered (raising of privileges, collection of configuration data, infection by malicious code, etc.)<br>- <strong>Computer channels</strong> observed (Interception of Ethernet traffic, etc.)<br>- <strong>People</strong>, observed, manipulated, lost (Unintentional disclosure of information, social engineering, assignment changes)<br>- <strong>Paper documents</strong> observed, lost (reading, theft of mail, etc.)<br>- <strong>Paper transmission channels</strong> observed (reading of signature books in circulation, etc.)",
			name: "Threats that can lead to an illegitimate access",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Threats regarding : </strong><br>- <strong>Hardware</strong> : used inappropriately, overloaded, altered, damaged, lost (storage unit full, processing capacity overload, addition of incompatible hardware resulting in malfunctions,  fire, theft or loss of an asset, etc.)<br>- <strong>Software</strong> : used inappropriately, overloaded, altered, damaged, lost (erasure of data, exceeding of database size, logic bomb, non-renewal of the licence for software used to access data, etc.)<br>- <strong>Computer channels</strong> : overloaded, altered, lost (unauthorised downloading, loss of Internet connection, etc.)<br>- <strong>People</strong> : overloaded, damaged, lost (poor use of skills, disease, retirement, etc.)<br>- <strong>Paper documents</strong> : used inappropriately, damaged, lost (erasure, aging of archived documents, theft or loss of documents, etc.)<br>- <strong>Paper transmission channels</strong> : overloaded, damaged, altered, lost (mail delivery halted by a strike, reassignment of offices or premises, loss of a document delivery company, reorganisation of paper transmission channels, etc.)",
			name: "Threats that can lead to a disappearance of personal data",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Threats regarding : </strong><br>- <strong>Hardware</strong> altered (addition of incompatible hardware resulting in malfunctions, removal of essential components, etc.)<br>- <strong>Software</strong> used inappropriately or altered (Unwanted modifications to data in databases, operator errors that modify data, etc.)<br>- <strong>Computer channels</strong> used inappropriately (resending of intercepted data, etc.)<br>- <strong>People</strong> overloaded or manipulates (assignment of staff to tasks beyond their abilities, stress or negative changes in working conditions, influence, etc.)<br>- Paper documents that have been altered (changes to figures in a file, replacement of an original by a forgery, etc.)<br>- <strong>Paper transmission channels</strong> that have been altered (change from one signature book to another, sending of multiple conflicting documents, etc.)",
			name: "Threats that can lead to an unwanted modification of personal data",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "To be chosen among those available in section \"Existing or planned measures\", which you may complete if needed.",
			name: "Measures",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "When data are being imported, different types of metadata (such as EXIF data with an image file attached) can unintentionally be collected. <br>Such metadata must be identified and eliminated if they are unnecessary for the purposes specified.",
			name: "Filtering and removal",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Once sensitive data have been received, as part of a series of general information or transmitted for statistical purposes only, these can be converted into a less sensitive form or pseudonymised. For example : <br>- if the system collects the IP address to determine the user's location for a statistical purpose, the IP address can be deleted once the city or district has been deduced<br>- if the system receives video data from surveillance cameras, it can recognise people who are standing or moving in the scene and blur them<br>- if the system is a smart meter, it can aggregate the use of energy over a certain period, without recording it in real time",
			name: "Reducing sensitivity via conversion",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "The system can ensure that: <br>- the user can use a resource or service without the risk of disclosing his/her identity (anonymous data)<br>- the user can use a resource or service without the risk of disclosing his/her identity, but remain identifiable and responsible for this use (pseudonymous data)<br>- the user can make multiple uses of resources or services without the risk of these different uses being linked together (data cannot be correlated)<br>- the user can use a resource or service without the risk of others, third parties in particular, being able to observe that the resource or service is being used (non-observability)<br>The choice of a method from the list above must be made on the basis of the threats identified. For some types of threat to privacy, pseudonymization will be more appropriate than anonymisation (for example, if there is a traceability need). In addition, some threats to privacy will be addressed using a combination of methods.",
			name: "Reducing the identifying nature of data",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "The system can be organised into independent parts with separate access control functions. The data can also be divided between these independent sub-systems and controlled by each sub-system using different access control mechanisms. If a sub-system is compromised, the impacts on all of the data can thus be reduced.",
			name: "Reducing data accumulation",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "The system can limit data access according to the \"need to know\" principle. The system can separate the sensitive data and apply specific access control policies. The system can also encrypt sensitive data to protect their confidentiality during transmission and storage. Access to temporary cookies which are produced during the data processing must also be protected.",
			name: "Restricting data access",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Reduce the severity of risks by limiting the amount of personal data to what is strictly necessary to achieve a defined purpose, otherwise the data shall be not collected.",
			name: "Minimising the amount of personal data",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "TO BE TRANSLATED - Reduce the severity of risks by minimizing the data themselves, by taking measures aimed at reducing their sensitivity such as filtering and removing unnecessary data, pseudonymising data, etc.",
			name: "TO BE TRANSLATED - Minimization of data themselves",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "The data subject shall have the right to object, on grounds relating to his or her particular situation, at any time to processing of personal data concerning him or her, pursuant to <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 21 of [GDPR]</a>",
			name: "Right to object",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Measures taken to integrate the protection of personal data in all new processing operations (trusted names, guidelines, CNIL methodology for risk management or other internal methodology).",
			name: "Project Management",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Persons to whom the data covered by the processing relate.",
			name: "Data subject",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " The data subject shall have the right to receive the personal data concerning him or her, which he or she has provided to a controller, in a structured, commonly used and machine-readable format and have the right to transmit those data to another controller without hindrance from the controller to which the personal data have been provided, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 20 of [GDPR]</a>",
			name: "Right to data portability",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "processing of personal data in such a manner that the personal data can no longer be attributed to a specific data subject without the use of additional information, provided that such additional information is kept separately and is subject to technical and organisational measures to ensure that the personal data are not attributed to an identified or identifiable natural person.<br>Pseudonymisation  reduces  the  linkability  of  a  dataset  with  the  original  identity  of  a  data subject; as such, it is a useful security measure but not a method of anonymisation.",
			name: "Pseudonymisation",
			source: "GDPR Art. 4.5 and guidelines G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Passwords shall be composed of a minimum of eight characters; must be renewed if there is the least concern that they may have been compromised and, possibly, periodically (every six months or once a year) and must include a minimum of three of the four kinds of characters (capital letters, lower case letters, numerals and special characters); when a password is changed, the last five passwords may not be reused; the same password should not be used for different accesses; passwords should not be related to one's personal information (including name or date of birth.). Define a maximum number of attempts beyond which a warning is issued and authentication is blocked (temporarily or until it is manually unblocked).",
			name: "Password",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "The data subject shall have the right to obtain from the controller without undue delay the rectification of inaccurate personal data concerning him or her. Taking into account the purposes of the processing, the data subject shall have the right to have incomplete personal data completed, including by means of providing a supplementary statement.",
			name: "Right to rectification",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Regulation on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC.",
			name: "GDPR (General Data Protection Regulation",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Natural or legal person, public authority, agency or other body which, alone or jointly with others, determines the purposes and means of the processing of personal data; where the purposes and means of such processing are determined by Union or Member State law, the controller or the specific criteria for its nomination may be provided for by Union or Member State law.<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 4.7 of [GDPR]</a>",
			name: "Controller",
			source: "GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Person or non-human source that can cause a risk. This source may act accidentally or deliberately.",
			name: "Risk source",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Natural or legal person, public authority, agency or other body which processes personal data on behalf of the controller, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 4.8 of [GDPR]</a>.<br>The processor and any person acting under the authority of the controller or of the processor, who has access to personal data, shall not process those data except on instructions from the controller, unless required to do so by Union or Member State law, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 29 of [GDPR]</a>.",
			name: "Processor",
			source: "GDPR Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Asset on which personal data rely. This may be hardware, software, networks, people, paper or paper transmission channels",
			name: "Supporting assets",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Breach of security leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, personal data transmitted, stored or otherwise processed.",
			name: "Personal data breach",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "likelihood expresses the possibility of a risk occurring. It primarily depends on the level of vulnerabilities of the supporting assets when under threat and the level of capabilities of the risk sources to exploit them.",
			name: "Likelihood",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Identification data</strong> : Civil status, identity, age, etc. <br><strong>Personal life</strong> : living habits, marital status, etc. <br><strong>Professional life </strong> : résumé, education and professional training, awards, etc. <br><strong>Connection data </strong> : IP addresses, event logs, etc.<br><strong>Location data</strong> : travels, GPS data, GSM data, etc.<br><strong>Others</strong> : phone number, email address, etc.",
			name: "Common personal data",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Philosophical, political, religious and trade-union views, sex life, health data, racial or ethnic origin, data concerning health or sex life, offenses, convictions, security measures, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Convictions and sensitive personal data"
		},
		PIA_EX_DCPS: {
			description: "Social security number (NIR), biometric data, bank data",
			name: "Personal data perceived as sensitive"
		},
		PIA_EX_HUME: {
			description: "It could be either:<br>- a rogue or naive neighbor, by having a physical proximity, hacking into the device's data;<br>- a hacker targeting a user by using the knowledge he/she has of the user and some of the information concerning him/her;<br>- a hacker targeting one of the companies by using the knowledge he/she has of the companies that can undermine their image;<br>- an authorised third party company using its privileged access to illegitimately access information.",
			name: "External human sources"
		},
		PIA_EX_HUMI: {
			description: "It could be either:<br>- a negligent or rogue employee, proximity of the system, skills, privileges and available time are potentially high, possible lack of training and awareness<br>- Negligent or rogue user or people around<br> Various motives are possible, including : clumsiness, error, negligence game, malicious intent, revenge, spying",
			name: "Internal human sources"
		},
		PIA_EX_IMPI: {
			description: "Data subjects may encounter significant consequences, which they should be able to overcome albeit with real and serious difficulties<br>Examples: <br>- physical : serious physical ailments causing long-term harm (worsening of health due to improper care, or disregard of contraindications), lteration of physical integrity for example following an assault, an accident at home, work, etc.<br>- material : misappropriation of money not compensated, targeted, unique and non-recurring, lost opportunities  (home loan, refusal of studies, internships or employment, examination ban), loss of housing, loss of employment, etc.<br>- moral : serious psychological ailments (depression, development of a phobia), feeling of invasion of privacy with irreversible damage, victim of blackmailing, cyberbullying and harassment, etc.",
			name: "High impact"
		},
		PIA_EX_IMPL: {
			description: "Data subjects may encounter significant inconveniences, which they will be able to overcome despite a few difficulties<br>Examples :<br>- physical : minor physical ailments (minor illness due to disregard of contraindications), defamation resulting in physical or psychological retaliation, etc.<br>- material : Unanticipated payments (fines imposed erroneously), denial of access to administrative or commercial services , Receipt of unsolicited targeted mailings likely to damage the reputation of data subjects, etc.<br>- moral : minor but objective psychological ailments, feeling of invasion of privacy without irreversible damage, intimidation on social networks, etc.",
			name: "Limited impact"
		},
		PIA_EX_IMPM: {
			description: "Data subjects may encounter severe, or even irreversible, consequences, which they may not overcome. For example:<br>- physical : long-term or permanent physical ailments, permanent impairment of physical integrity, death;<br>- material : financial risk, substantial debts, inability to work, inability to relocate, loss of evidence in the context of litigation, loss of access to vital infrastructure (water, electricity), etc.<br>- moral : long-term or permanent psychological ailments, criminal penalty, abduction, loss of family ties, inability to sue, change of administrative status and/or loss of legal autonomy (guardianship), etc.<br>-prohibited discrimination or bias: subliminal techniques beyond a person’s consciousness or purposefully manipulative or deceptive techniques; exploitative of the vulnerabilities of a natural person or a specific group of persons due to their age, disability or a specific social or economic situation; evaluation or classification of natural persons or groups of persons over a certain period of time based on their social behaviour or known, inferred or predicted personal or personality characteristics; predicting the risk of a natural person committing a criminal offence, based solely on the profiling of a natural person or on assessing their personality traits and characteristics; untargeted scraping of facial images from the internet or CCTV footage; infer emotions of a natural person in the areas of workplace and education institutions; use of biometric categorisation systems that categorise individually natural persons based on their biometric data to deduce or infer their race, political opinions, trade union membership, religious or philosophical beliefs, sex life or sexual orientation; use of ‘real-time’ remote biometric identification systems in publicly accessible spaces for the purposes of law enforcement, unless it is dtrictly necessary.",
			name: "Severe, critical or prohibited impact"
		},
		PIA_EX_IMPN: {
			description: "Data subjects either will not be affected or may encounter a few inconveniences, which they will overcome without any problem.<br>Examples:<br>- physical : transient headaches<br>- material : loss of time in repeating formalities or waiting for them to be fulfilled, receipt of unsolicited mail (e.g.: spams), reuse of data published on websites for the purpose of targeted advertising , etc.,<br>- moral : mere annoyance, feeling of invasion of privacy without real or objective harm (commercial intrusion), etc.",
			name: "Negligible impact"
		},
		PIA_EX_NHUM: {
			description: "Incident or damage at one of the organisation (power cut, fire, flood, etc.)",
			name: "Non-human sources"
		},
		PIA_EX_VRAI: {
			description: "It seems possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in offices that cannot be accessed without first checking in at the reception).",
			name: "Significant likelihood"
		},
		PIA_EX_VRAL: {
			description: "It seems difficult for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader).",
			name: "Limited likelihood"
		},
		PIA_EX_VRAM: {
			description: "It seems extremely easy for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in the public lobby).",
			name: "Maximum likelihood"
		},
		PIA_EX_VRAN: {
			description: "It does not seem possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader and access code).",
			name: "Negligible likelihood"
		},
		PIA_LGL_CONS: {
			description: "Allow data subjects to make a free, specific and informed choice. Determine whether the processing relies on a legal basis other than consent pursuant to Art. 6 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">[GDPR]</a>",
			name: "Consent",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Define and describe the scope in detail:<br>- the personal data concerned, their recipients and storage durations<br>- description of the processes and personal data supporting assets for the entire personal data life cycle (from collection to erasure).",
			name: "Data and processes",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Present a brief outline of the processing under consideration, its nature, scope, context, purposes and stakes. Identify the data controller and any processors. List the standard references applicable to the processing, which are necessary or must be complied with , not least the approved codes of conduct (see Art. 40 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">[GDPR]</a>) and certifications regarding data protection (see Art. 42 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">[GDPR]</a>)",
			name: "Processing's description",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Natural or legal person, public authority, agency or another body, to which the personal data are disclosed, whether a third party or not. However, public authorities which may receive personal data in the framework of a particular inquiry in accordance with Union or Member State law shall not be regarded as recipients; the processing of those data by those public authorities shall be in compliance with the applicable data protection rules according to the purposes of the processing. see Art. 4.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">[GDPR]</a>",
			name: "Recipient",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "A storage duration must be defined for each type of data and justified by the legal requirements and/or processing needs. Thus a distinction is made between common data and archived data, to which access will be limited to only the stakeholders concerned. An erasure mechanism must be implemented to archive common data or purge archived data at the end of their storage duration. Functional traces will also have to be purged, as will technical logs which may not be stored indefinitely",
			name: "Storage Durations",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Personal data shall be collected for specified, explicit and legitimate purposes and <strong>not further processed in a manner that is incompatible with those purposes.</strong> <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">Art. 5.1 b) of [GDPR]</a>",
			name: "Principles relating to processing of personal data",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- The data subject has given consent  to the processing of his or her personal data for one or more specific purposes <br>- Processing is necessary for the performance of a contract to which the data subject is party or in order to take steps at the request of the data subject prior to entering into a contract <br>-Processing is necessary for compliance with a legal obligation to which the controller is subject <br>- Processing is necessary in order to protect the vital interests of the data subject or of another natural person <br>- Processing is necessary for the performance of a task carried out in the public interest or in the exercise of official authority vested in the controller <br>- Processing is necessary for the purposes of the legitimate interests pursued by the controller or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject which require protection of personal data, in particular where the data subject is a child<br> See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">art. 6 of [GDPR]</a> ",
			name: "Justification of lawfulness",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Ensure that the subjects are informed. Confirm that the processing is not covered by an exception and is not subject to specific conditions.",
			name: "Informing data subjects",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "It is important to reduce the severity of the risks by minimising the number of personal data that will be processed, by limiting such data to what is strictly necessary for the purposes for which they are processed (otherwise they should not be collected). Then, it also becomes possible to minimise the data themselves, via controls aimed at reducing their sensitivity.",
			name: "Data minimisation",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "A processing contract must be signed with each processor, setting out all of the aspects stipulated in Art. 28 of the [GDPR]: duration, scope, purpose, documented processing instructions, prior authorisation where a processor is engaged, provision of any documentation providing evidence of compliance with the [GDPR], prompt notification of any data breach, etc.",
			name: "Subcontracting",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Asset on which personal data rely. Note: this may be hardware, software, networks, people, paper or paper transmission channels.",
			name: "Supporting asset",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Depending on the country in question, you will have to justify the choice of remote hosting and indicate the legal supervision arrangements implemented in order to ensure adequate protection of the data subject to a cross-border transfer. That is :<br>- European Union<br>- Country recognised as providing adequate protection by the EU<br>- Transfer to the United States to a company which has joined the Privacy Shield<br>- Other country <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">art. 44 to 49 of [GDPR]</a>",
			name: "Transfers",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Existence of a policy and processes to obtain an organisation able to manage and control the protection of personal data held within it.",
			name: "Supervision",
			placeholder: "Indicate here whether the effectiveness and adequacy of privacy controls are monitored.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Existence of a policy and processes reducing the risk that legitimate access to personal data by third parties may pose to the data subjects' civil liberties and privacy.",
			name: "Relations with third parties",
			placeholder: "Indicate here, for processors requiring access to data, the security controls and arrangements carried out as regards such access.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Specify whether a person is responsible for the enforcement of privacy laws and regulations. Specify whether there is a monitoring committee (or equivalent) responsible for the guidance and follow-up of actions concerning the protection of privacy.",
			name: "Organisation",
			placeholder: "Indicate if the roles and responsibilities for data protection are defined.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Existence of a policy designed integrate the protection of personal data in all new processing operations.",
			name: "Integrating privacy protection in projects",
			placeholder: "Describe here how privacy protection is integrated in projects",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Existence of a policy describing awareness-raising controls are carried out with regard to a new recruit and what controls are carried out when persons who have been accessing data leave their job.",
			name: "Personnel management",
			placeholder: "Indicate here what awareness-raising controls are carried out with regard to employees.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Set out important aspects relating to data protection within a documentary base making up the data protection policy and in a form suited to each type of content (risks, key principles to be followed, target objectives, rules to be applied, etc.) and each communication target (users, IT department, policymakers, etc.).",
			name: "Policy",
			placeholder: "Describe here the documentary base setting out data protection objectives and rules.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Policy describing processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects (building a map of the risks, etc.).",
			name: "Managing privacy risks",
			placeholder: "Describe here processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Existence of an operational organisation that can detect and treat incidents that may affect the data subjects' civil liberties and privacy.",
			name: " Managing personal data violations",
			placeholder: "Indicate here whether IT incidents are subject to a documented and tested management procedure.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Policies and means implemented to ensure the availability and/or integrity of the personal data, while maintaining their confidentiality.",
			name: "Backups",
			placeholder: "Indicate here how backups are managed. Clarify whether they are stored in a safe place.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Controls implemented on workstations (automatic locking, regular updates, configuration, physical security, etc.) to reduce the possibility to exploit software properties (operating systems, business applications etc.) to adversely affect personal data.",
			name: "Managing workstations",
			placeholder: "Describe here the controls implemented on workstations",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "Regulate the procurement relations via a contract signed intuitu persona.<br>- Require the processor to forward its Information Systems Security Policy (PSSI) along with all supporting documents of its information security certifications and append said documents to the contract. Ensure that the measures pursuant to its PSSI comply with the CNIL's recommendations in this respect.<br>- Precisely determine and set, on a contractual basis, the operations that the processor will be required to carry out on personal data: <br> 1) The data to which it will have access or which will be transmitted to it.<br> 2) The operations it must carry out on the data.<br> 3) The duration for which it may store the data.<br> 4) Any recipients to which the data controller requires it to transmit the data.<br> 5) The operations to be carried out at the end of the service (permanent deletion of data or return of the data in the context of reversibility then destruction of data at the processor's).<br> 6) The security objectives set by the data controller. <br>- Determine, on a contractual basis, the division of responsibility regarding the legal processes aimed at allowing the data subjects to exercise their rights.<br>- Explicitly prohibit or regulate use of tier-2 processors.<br>- Clarify in the contract that compliance with the data protection obligations is a binding requirement of the contract.",
			name: "Processing contracts",
			placeholder: "Describe here specific measures for processors (host, maintenance company, administrator, specialist service providers, etc.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Policies implemented to reduce the possibility and the impact of risks on assets supporting personal data.",
			name: "Operating security",
			placeholder: "Describe here how the software updates (operating systems, applications, etc.) and application of security corrective controls patches are carried out.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Monitor intrusion detection systems and intrusion prevention systems in order to analyze network (wired networks, Wi-Fi, radio waves, fiber optics, etc.) traffic in real time and detect any suspicious activity suggestive of a cyber attack scenario.",
			name: "Monitoring network activity",
			placeholder: "Indicate here means and controls implemented to detect incidents involving personal data",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Policies describing how physical maintenance of hardware is managed, stating whether this is contracted out.<br> Indicate whether the remote maintenance of apps is authorized, and according to what arrangements. Specify whether defective equipment is managed in a specific manner.",
			name: "Maintenance",
			placeholder: "Describe here how physical maintenance of hardware is managed",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controls implemented on workstations and servers to protect them from malicious software while accessing less secure networks.",
			name: "Clamping down on malicious software",
			placeholder: "Describe here the controls implemented to reduce risks while accessing less secure networks.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Indicate here the controls bearing on the physical security of servers and workstations (secure storage, security cables, confidentiality filters, secure erasure prior to scrapping, etc.).",
			name: "Hardware security",
			placeholder: "Indicate here the controls bearing on the physical security of servers and workstations",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Depending on the type of network on which the processing is carried out (isolated, private or Internet). Specify which firewall system, intrusion detection systems or other active or passive devices are in charge of ensuring network security.",
			name: "Network security",
			placeholder: "Indicate here the security controls of network on which the processing is carried out",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Policies to ensure physical security (zoning, escorting of visitors, wearing of passes, locked doors and so on).Indicate whether there are warning procedures in place in the event of a break-in.",
			name: "Physical access control",
			placeholder: "Indicate here how physical access control is carried out regarding the premises accommodating the processing.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Policies describing the means of fire prevention, detection and fighting. Where applicable, indicate the means of preventing water damage.Also specify the means of power supply monitoring and relief.",
			name: "Protecting against non-human sources of risks",
			placeholder: "Indicate here means to avoid to limit non-human sources of risks.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Documentation on implantation area, which should not be subject to environmental disasters (flood zone, proximity to chemical industries, earthquake or volcanic zone, etc.).Specify if dangerous products are stored in the same area.",
			name: "Avoiding sources of risk",
			placeholder: "Indicate here whether the implantation area is subject to environmental disasters",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementation of ANSSI's Recommendations for securing websites.",
			name: "Website security",
			placeholder: "Indicate here controls implemented to protect websites.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Indicate here whether anonymisation mechanisms are implemented, which ones and for what purpose. <br>Remember to clearly distinguish between anonymous and pseudonymous data.",
			name: "Anonymisation",
			placeholder: "Indicate here implemented anonymisation mechanisms",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Where applicable, describe here the processes of archive management (delivery, storage, consultation, etc.) under your responsibility. Specify the archiving roles (offices of origin, transferring agencies, etc.) and the archiving policy. State if data may fall within the scope of public archives.",
			name: "Archiving",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of stored data, which ones and for what purpose.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Means implemented for <strong>ensuring the confidentiality</strong> of data stored (in the database, in flat files, backups, etc.), as well as the procedure for managing encryption keys (creation, storage, change in the event of suspected cases of data compromise, etc.).<br> Describe the encryption means employed for data flows (VPN, TLS, etc.) implemented in the processing systems.",
			name: "Encryption",
			placeholder: "Describe here the means implemented for ensuring the confidentiality of data",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Implementation of data partitioning helps to reduce the possibility that personal data can be correlated and that a breach of all personal data may occur.",
			name: "Partitioning data",
			placeholder: "Indicate here if processing partitioning is planned, and how this is carried out.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Methods to define and attribute users profiles. Specify the <strong>authentication</strong> means implemented . Where applicable, specify the rules applicable to passwords (minimum length, required characters, validity duration, number of failed attempts before access to account is locked, etc.).",
			name: "Logical access control",
			placeholder: "Indicate here how users profiles are defined and attributed.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Policies that define traceability and log management.",
			name: "Traceability (logging)",
			placeholder: "Indicate here whether events are logged and how long these traces are stored for.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "The following methods could be used : Filtering and removal, Reducing sensitivity via conversion, Reducing the identifying nature of data, Reducing data accumulation, Restricting data access",
			name: "Minimising the amount of personal data",
			placeholder: "Indicate here means implemented to reduce the severity of risks by limiting the amount of personal data",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Where paper documents containing data are used during the processing, indicate here how they are printed, stored, destroyed and exchanged.",
			name: "Paper document security",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of paper documents, which ones and for what purpose.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "corrective controls suggested by the assessor in previous steps, drawing up an action plan setting out, for each action, its manager, frequency, difficulty, cost and progress.",
			name: "Action plan",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Graph illustrating the good security practices, with a conformity value attributed to each on the basis of its assessment in previous steps.",
			name: "Mapping of risks",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Where appropriate, the controller shall seek the views of data subjects or their representatives on the intended processing, without prejudice to the protection of commercial or public interests or the security of processing operations. See Art. 39.2 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">[GDPR]</a><br>These views may be gathered by diverse means, depending on the context (internal or external study on the processing methods and purpose, question for the attention of staff representatives or trade unions, survey among future customers of the data processor). <strong>Where the data controller decides to go against the views of the data subjects</strong>, he must note down <strong>the justification for this decision</strong>. Where the data controller considers that <strong>gathering the views of the data subjects is not relevant, he must also note down the justification thereof</strong>.",
			name: "Data subject's opinion",
			source: "GDPR Art. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "The controller shall seek the advice of the data protection officer, where designated, when carrying out a data protection impact assessment. See Art. 39.2 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/CS/TXT/HTML/?uri=CELEX:32016R0679&from=CS\">[GDPR]</a><br> <strong>This view may be against the processing being implemented, without restricting the decision of the data controller for all that</strong>.",
			name: "DPO's opinion",
			source: "GDPR Art. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Decide on whether the selected controls, residual risks and action plan are acceptable, with justifications, in view of the previously identified stakes and views of the stakeholders. In this way, the PIA may be:<br>- validated<br>- conditional on improvement (explain in what way)<br>- refused (along with the processing under consideration). Where necessary, repeat the previous steps so that the PIA can be validated. This decision does not prejudge the compliance assessment which may be carried out, where applicable, by the Data Protection Authority (the CNIL in France), as part of preliminary formalities or checks for example.",
			name: "Formal validation",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Znalostní báze"
};
var measures$l = {
	add: "Přidat prázdné opatření (jinak použijte znalostní bázi)",
	default_placeholder: "Popište existující nebo plánovaná opatření k zajištění bezpečnosti dat.",
	edit: "Upravit opatření",
	placeholder_title: "Název opatření",
	remove: "Odstranit opatření"
};
var misc$l = {
	display: "Zobrazit / Skrýt"
};
var modals$l = {
	abandon_pia: {
		additional_text: "TO BE TRANSLATED - Archiving is not definitive and the PIA can go back to it if needed.",
		content: "TO BE TRANSLATED - Do you wish to give up the processing?"
	},
	action_plan_no_evaluation: {
		content: "TO BE TRANSLATED - You need to begin the review of the analysis to create the action plan.",
		review_section: "TO BE TRANSLATED - Review a section"
	},
	archive: "Archivovat",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "TO BE TRANSLATED - This section is ready to be reviewed."
	},
	back_to_edition: {
		content: "TO BE TRANSLATED - This section has been sent back for editing.<br> Several fields must be corrected<br> to enable its proper review."
	},
	back_to_evaluation: {
		content: "TO BE TRANSLATED - This section has been sent back for review.<br> Several fields must be reviewed<br> to enable its proper validation."
	},
	back_to_home: "Zpět na úvod",
	cancel: "Zrušit",
	close: "Zavřít",
	completed_edition: {
		content: "TO BE TRANSLATED - The PIA has been fully edited and has to be reviewed."
	},
	completed_evaluation: {
		content: "TO BE TRANSLATED - The PIA has been fully reviewed and can be validated."
	},
	"continue": "Pokračovat",
	declare_measures: {
		content: "Než vyhodnotíte rizika,<br>musíte ohlásit stávající<br>nebo plánovaná opatření.",
		declare: "Oznámit stávající nebo plánovaná opatření"
	},
	dpo_missing_evaluations: {
		comment: "TO BE TRANSLATED - Comment",
		content: "TO BE TRANSLATED - You need to complete the review of the analysis to access the DPO page.",
		remove: "Odebrat",
		review_section: "TO BE TRANSLATED - Review a section"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type PIA"
	},
	import_wrong_structure_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type Modèle"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "TO BE TRANSLATED - The content of the PIA has been copied to clipboard."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Upozornění,</span><br>Musí být vyplněno alespoň jedno opatření: není možné smazání."
	},
	recover_version: {
		"continue": "Pokračovat",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "TO BE TRANSLATED - As you have rejected the PIA, it is sent back for review to make the required changes."
	},
	remove_attachment: {
		comment: "TO BE TRANSLATED - Comment",
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>remove this attachment?",
		keep: "Ponechat",
		remove: "Odebrat"
	},
	remove_measure: {
		content: "<span class='strong'>Upozornění,</span><br>Opravdu chcete odstranit toto opatření?",
		keep: "Ponechat toto <br>opatření",
		remove: "Odebrat toto <br>opatření"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Odstranit tuto PIA"
	},
	remove_question: {
		content: "TO BE TRANSLATED - Souhaitez-vous supprimer la question ?",
		keep: "TO BE TRANSLATED - Annuler",
		remove: "TO BE TRANSLATED - Supprimer"
	},
	remove_structure: {
		content: "TO BE TRANSLATED - <span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer ce modèle ?",
		remove: "TO BE TRANSLATED - Supprimer ce modèle"
	},
	same_comment: {
		content: "<span class='strong'>Upozornění,</span><br>Prosím zadejte komentář odlišný od posledního zaznamenaného."
	},
	signed_pia_validation: {
		content: "TO BE TRANSLATED - To approve the PIA, attach the signed report.",
		download_pia: "Stáhnout zprávu"
	},
	simple_pia_validation: {
		content: "TO BE TRANSLATED - You have approved the PIA."
	},
	start_evaluation: "TO BE TRANSLATED - Start review",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "TO BE TRANSLATED - The server address has been updated."
	},
	validate_evaluation: {
		content: "TO BE TRANSLATED - This section is ready for validating the PIA."
	},
	validate_evaluation_to_correct: {
		content: "Sorry,<br>Několik polí musí být opraveno.<br>Návrat do edice režimu a opravy."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$l = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$l = {
	content: ", zvažte, že :",
	dpo_lock: "Vyplňte prosím další části, než budete moci vyplnit stanoviska DPO Pověřence osobních údajů.",
	dpo_opinion: "Stanovisko  DPO Pověřence osobních údajů",
	edit: "Upravit",
	people_opinion: "Názor dotčených osob",
	placeholder_concerned_people_name: "Jméno(a) dotčených osob",
	placeholder_dpo_name: "Jméno(a) DPO Pověřence osobních údajů",
	placeholder_dpo_opinion: "Zadejte důvody pro váš výběr.",
	placeholder_people_opinion: "Popište, jak byly stanoviska shromážděny a jaká je analýza. Pokud nebyly požadovány stanoviska, uveďte důvody.",
	placeholder_search_content: "Uveďte důvod, proč nebylo vyžádáno stanovisko dotčených osob.",
	treatment_lock: "Vyplňte prosím další části, než budete moci naplnit stanoviska dotčených osob.",
	treatment_nok: "Úprava nemůže být použita.",
	treatment_ok: "Úprava může být implementována"
};
var pia$l = {
	attachments: {
		add: "Přidat",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Odebrat",
		title: "Přílohy",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Požádat o kontrolu",
		mandatory_fields: "Všechna pole musí být vyplněna",
		structure_add_question: "TO BE TRANSLATED - Ajouter une question",
		subsection_validated: "Subsekce schválená, čeká na konečné ověření",
		validate_evaluation: "Ověřit kontrolu"
	},
	header: {
		display_action_plan: "Zobrazit<br> akční plán",
		edition: "TO BE TRANSLATED - Edition",
		evaluation: "TO BE TRANSLATED - Evaluation",
		preview: "Náhled"
	},
	sections: {
		based_on_structure_name: "TO BE TRANSLATED - Basé sur le modèle :",
		homepage_link: "Zpět na Hlavní panel",
		refuse_pia: "Odmítnutá AIIA",
		status: {
			evaluation: {
				cancel: "TO BE TRANSLATED - cancel the review request.",
				cancel_button: "TO BE TRANSLATED - Cancel the review request",
				content: "TO BE TRANSLATED - This part has not yet been reviewed. If you wish to edit the content submitted for review you have to ",
				title: "TO BE TRANSLATED - Waiting for review."
			},
			validation: {
				cancel: "TO BE TRANSLATED - cancel the validation request.",
				cancel_button: "TO BE TRANSLATED - Cancel the validation request",
				content: "TO BE TRANSLATED - This part has been reviewed and is waiting for the overall PIA validation. If you wish to change the review, you have to ",
				title: "TO BE TRANSLATED - Waiting for validation."
			}
		},
		validate_pia: "Ověřit PIA"
	},
	statuses: [
		"Probíhá",
		"Odmítnuto",
		"Jednoduché ověření",
		"Podepsané ověření",
		"Archivováno",
		"Čekání na ověření"
	]
};
var questions$l = {
	edit: "Upravit otázku",
	gauges: [
		"(Nedefinováno)",
		"Zanedbatelné",
		"Omezeno",
		"Důležité",
		"Maximální"
	],
	placeholder_title: "TO BE TRANSLATED - Titre de la question (obligatoire)",
	remove: "TO BE TRANSLATED - Supprimer la question"
};
var rejection_page$l = {
	applied_adjustments: "TO BE TRANSLATED - Adjustments proposed",
	applied_adjustments_placeholder: "TO BE TRANSLATED - Describe the changes brought to the PIA.",
	button: {
		abandon_treatment: "TO BE TRANSLATED - Abandon processing",
		reject_pia: "TO BE TRANSLATED - Reject AIIA",
		send_for_validation: "TO BE TRANSLATED - Resend for approval"
	},
	previous_rejection: "TO BE TRANSLATED - Previous refusal",
	rejection_reason: "TO BE TRANSLATED - Refusal reason",
	rejection_reason_placeholder: "TO BE TRANSLATED - Describe the reasons for refusing the PIA.",
	title: "TO BE TRANSLATED - Validation history"
};
var sections$l = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Uveďte stručný popis zpracování: jeho název, účely, důvody, kontext použití atd.",
						title: "Které zpracování se zvažuje?"
					},
					"2": {
						placeholder: "Popište odpovědnosti zúčastněných stran: správce údajů, případné zpracovatele dat a společní správci.",
						title: "Jaké jsou odpovědnosti spojené se zpracováním?"
					},
					"3": {
						placeholder: "Seznam příslušných norem platných pro zpracování, zejména schválených kodexů chování a osvědčení o ochraně údajů.",
						title: "Existují platné normy pro zpracování?"
					}
				},
				short_help: "Tato část umožňuje identifikovat a prezentovat předmět studie.",
				title: "Přehled"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Seznam shromážděných a zpracovávaných dat. Definujte pro každou dobu trvání úložiště, příjemce a osoby s přístupem k němu.",
						title: "Jaké údaje zpracováváte?"
					},
					"2": {
						placeholder: "Prezentujte a popište, jak produkt obecně funguje (od sběru dat až po smazání dat, různé fáze zpracování, úložiště atd.), například pomocí diagramu datových toků (přidejte jej jako přílohu) a podrobný popis provedených procesů.",
						title: "Jak funguje životní cyklus dat a procesů?"
					},
					"3": {
						placeholder: "Seznam Podpůrných aktiv, pro data (operační systémy, obchodní aplikace, systémy pro správu databází, kancelářské sady, protokoly, konfigurace apod.)",
						title: "Jaká jsou Podpůrná aktiva pro data?"
					}
				},
				short_help: "Tato část umožňuje podrobně definovat a popsat rozsah zpracování.",
				title: "Data, procesy a podpůrná aktiva"
			}
		},
		short_help: "Tato část poskytuje jasný přehled o zacházení s dotyčnými osobními údaji.",
		title: "Kontext"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Vysvětlete, proč jsou účely zpracování specifikovány, explicitní a legitimní.",
						short_title: "Účely",
						title: "Jsou procesy specifikovány, explicitní a legitimní?"
					},
					"2": {
						placeholder: "Překlad probíhá",
						short_title: "Právní základ",
						title: "Jaké jsou právní základy pro zákonné zpracování?"
					},
					"3": {
						placeholder: "Vysvětlete, proč jsou všechny shromážděné údaje nezbytné pro účely zpracování.",
						short_title: "Přiměřená data",
						title: "Jsou shromážděná data přiměřená, relevantní a omezená na to, co je nezbytné ve vztahu k účelům, pro které jsou zpracovávány (\"minimalizace dat\")?"
					},
					"4": {
						placeholder: "Popište, jaké jsou kroky k zajištění kvality dat.",
						short_title: "Přesnost dat",
						title: "Jsou data přesná a aktuální?"
					},
					"5": {
						placeholder: "Vysvětlete, podle čeho je doba skladování odůvodněna, jakými zákonnými požadavky a/nebo požadavky na zpracování.",
						short_title: "Doba ukládání",
						title: "Jaká je doba uložení dat?"
					}
				},
				short_help: "Tato část vám umožňuje prokázat legitimitu vašich účelů a zpracovávaných dat.",
				title: "Proporcionalita a nezbytnost"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Popište, jaké jsou informace poskytnuté osobám údajů a jaké jsou prostředky k jejich provedení.",
						short_title: "Informace pro subjekty údajů",
						title: "Jak jsou subjekty údajů informovány o zpracování?"
					},
					"2": {
						placeholder: "Popište kontrolní prvky určené k zajištění souhlasu uživatelů.",
						short_title: "Získání souhlasu",
						title: "Jak jste získaly souhlas subjektů údajů?"
					},
					"3": {
						placeholder: "Popište kontrolní prvky určené k tomu, aby subjekty údajů mohly přistupovat, přijímat a přenášet svá data.",
						short_title: "Právo na přístup a přenositelnost dat",
						title: "Jak mohou subjekty údajů uplatňovat svá práva na přístup a přenositelnost dat?"
					},
					"4": {
						placeholder: "Popište kontrolní prvky určené k tomu, aby si subjekty údajů mohly opravit a vymazat data.",
						short_title: "Právo na opravu a vymazání",
						title: "Jak mohou subjekty údajů uplatňovat svá práva na opravu a vymazání?"
					},
					"5": {
						placeholder: "Popište kontrolní prvky určené k tomu, aby subjekty údajů, mohly omezit a namítnout zpracování jejich dat.",
						short_title: "Právo na omezení a námitku",
						title: "Jak mohou subjekty údajů uplatňovat svá práva na omezení a námitky?"
					},
					"6": {
						placeholder: "Pro každého zpracovatele popište jeho odpovědnosti (trvání, rozsah, účel, zdokumentované pokyny pro zpracování, předchozí povolení) a uveďte smlouvy, kodexy chování a certifikace, které určují jeho poslání a povinnosti.",
						short_title: "Subdodávky",
						title: "Jsou povinnosti zpracovatelů jasně identifikovány a řízeny smlouvou?"
					},
					"7": {
						placeholder: "Pro každou zemi mimo Evropskou unii, kde jsou data uložena nebo zpracovávána, pojmenujte ji a ujistěte se, že je uznáváno jako nabízející odpovídající úroveň ochrany údajů nebo popište ustanovení týkající se převodu.",
						short_title: "Převody",
						title: "V případě přenosu dat mimo Evropskou unii jsou údaje dostatečně chráněny?"
					}
				},
				short_help: "Tato část vám umožňuje prokázat, že provádíte potřebné prostředky, které umožňují dotčeným osobám vykonávat svá práva.",
				title: "Kontroly na ochranu osobních práv subjektů údajů"
			}
		},
		short_help: "Tato část umožňuje vytvořit rámec souladu se zásadami ochrany osobních údajů.",
		title: "Základní zásady"
	},
	"3": {
		items: {
			"1": {
				short_help: "Tato část umožňuje identifikovat kontrolní prvky (existující nebo plánované), které přispívají k zabezpečení dat.",
				title: "Plánovaná nebo stávající opatření"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Zadejte potenciální dopady",
						title: "Jaké by mohly být hlavní dopady na subjekty údajů, pokud by k takovému riziku došlo?"
					},
					"2": {
						placeholder: "Zadejte hrozby",
						title: "Jaké jsou hlavní hrozby, které by mohly vést k riziku?"
					},
					"3": {
						placeholder: "Zadejte zdroje rizika",
						title: "Jaké jsou zdroje rizika?"
					},
					"4": {
						placeholder: "Klikněte zde pro výběr ovládacích prvků, které řeší riziko.",
						title: "Která z identifikovaných kontrol přispívá k řešení rizika?"
					},
					"5": {
						placeholder: "Zde odůvodněte odhadovanou závažnost rizika.",
						title: "Jak odhadujete závažnost rizika, zejména podle možných dopadů a plánovaných kontrol?"
					},
					"6": {
						placeholder: "Zde odůvodněte odhadovanou pravděpodobnost.",
						title: "Jak odhadujete pravděpodobnost rizika, zejména pokud jde o hrozby, zdroje rizika a plánované kontroly?"
					}
				},
				short_help: "Analyzujte příčiny a důsledky nezákonného přístupu k datům a odhadněte jejich závažnost a pravděpodobnost.",
				title: "Nelegitimní přístup k údajům"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Zadejte potenciální dopady",
						title: "Jaké by mohly být hlavní dopady na subjekty údajů, pokud by k takovému riziku došlo?"
					},
					"2": {
						placeholder: "Zadejte hrozby",
						title: "Jaké jsou hlavní hrozby, které by mohly vést k riziku?"
					},
					"3": {
						placeholder: "Zadejte zdroje rizika",
						title: "Jaké jsou zdroje rizika?"
					},
					"4": {
						placeholder: "Klikněte zde pro výběr ovládacích prvků, které řeší riziko.",
						title: "Která z identifikovaných kontrol přispívá k řešení rizika?"
					},
					"5": {
						placeholder: "Zde odůvodněte odhadovanou závažnost rizika.",
						title: "Jak odhadujete závažnost rizika, zejména podle možných dopadů a plánovaných kontrol?"
					},
					"6": {
						placeholder: "Zde odůvodněte odhadovanou pravděpodobnost.",
						title: "Jak odhadujete pravděpodobnost rizika, zejména pokud jde o hrozby, zdroje rizika a plánované kontroly?"
					}
				},
				short_help: "Analyzujte příčiny a důsledky nežádoucí modifikace dat a odhadněte jejich závažnost a pravděpodobnost.",
				title: "Nežádoucí modifikace dat"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Zadejte potenciální dopady",
						title: "Jaké by mohly být hlavní dopady na subjekty údajů, pokud by k takovému riziku došlo?"
					},
					"2": {
						placeholder: "Zadejte hrozby",
						title: "Jaké jsou hlavní hrozby, které by mohly vést k riziku?"
					},
					"3": {
						placeholder: "Zadejte zdroje rizika",
						title: "Jaké jsou zdroje rizika?"
					},
					"4": {
						placeholder: "Klikněte zde pro výběr ovládacích prvků, které řeší riziko.",
						title: "Která z identifikovaných kontrol přispívá k řešení rizika?"
					},
					"5": {
						placeholder: "Zde odůvodněte odhadovanou závažnost rizika.",
						title: "Jak odhadujete závažnost rizika, zejména podle možných dopadů a plánovaných kontrol?"
					},
					"6": {
						placeholder: "Zde odůvodněte odhadovanou pravděpodobnost.",
						title: "Jak odhadujete pravděpodobnost rizika, zejména pokud jde o hrozby, zdroje rizika a plánované kontroly?"
					}
				},
				short_help: "Analyzujte příčiny a důsledky ztráty dat a odhadněte jejich závažnost a pravděpodobnost.",
				title: "Ztráta dat"
			},
			"5": {
				short_help: "Tato vizualizace vám umožní mít globální a syntetický pohled na kontrolní prvky vlivu na rizika, která řeší.",
				title: "Přehled rizik"
			}
		},
		short_help: "Tato část vám umožňuje zhodnotit rizika týkající se ochrany osobních údajů s přihlédnutím k existujícím nebo plánovaným kontrolám.",
		title: "Rizika"
	},
	"4": {
		items: {
			"1": {
				short_help: "Tato vizualizace umožňuje porovnat umístění rizik mezi nimi před a po aplikaci doplňkových kontrolních prvků.",
				title: "Mapování rizik"
			},
			"2": {
				short_help: "Naplánujte podrobně implementaci dalších kontrolních prvků zjištěných během PIA.",
				title: "Akční plán"
			},
			"3": {
				short_help: "Prezentujte názory osoby zodpovědné za ochranu údajů a soukromí (delegát ochrany údajů, pokud existuje). Prezentujte názory subjektů údajů nebo jejich zástupců.",
				title: "Názory DPO-Pověřence osobních údajů a dotčených osob"
			},
			"4": {
				title: "TO BE TRANSLATED - Validate the PIA"
			},
			"5": {
				title: "TO BE TRANSLATED - Rejected PIA"
			}
		},
		short_help: "Tato část vám umožňuje připravit a formalizovat ověření PIA.",
		title: "Validace"
	}
};
var settings$l = {
	content: "Uveďte adresu (URL) vzdáleného serveru:",
	title: "Nastavení",
	update: "Aktualizovat URL"
};
var summary$l = {
	action_plan: {
		fundamental_principles: "Základní principy",
		implementation_date: "Předpokládaný datum implementace",
		implementation_responsible: "Odpovědný za implementaci",
		measures: "Stávající nebo plánovaná opatření",
		no_action_plan: "Nebyl zaznamenán žádný akční plán.",
		risks: "Rizika",
		title: "Akční plán"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Přílohy",
	concerned_people_name: "Jména dotčených osob",
	concerned_people_opinion: "Názory dotčených osob",
	concerned_people_searched_opinion: "Hledání názoru dotčených osob",
	concerned_people_status: "Stavy dotčených osob",
	concerned_people_unsearched_opinion_comment: "Důvod, proč nebyl požadován zájem osob",
	content_choice: [
		"Léčba by neměla být prováděna.",
		"Léčba by mohla být provedena."
	],
	creation_date: "Datum vytvoření",
	csv_action_plan_comment: "TO BE TRANSLATED - Action plan comment",
	csv_evaluation_comment: "TO BE TRANSLATED - Evaluation comment",
	csv_file_title: "TO BE TRANSLATED - action-plan",
	csv_implement_date: "TO BE TRANSLATED - Estimated implementation date",
	csv_people_in_charge: "TO BE TRANSLATED - Person in charge",
	csv_section: "TO BE TRANSLATED - Section",
	csv_title_object: "TO BE TRANSLATED - Title",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Jméno DPO Poběřence osobních údajů",
	dpo_opinion: "Stanovisko DPO Poběřence osobních údajů",
	dpo_status: "Stav DPO Poběřence osobních údajů",
	gauges: {
		"1": "Zanedbatelné",
		"2": "Omezené",
		"3": "Důležité",
		"4": "Maximální"
	},
	modification_made: "Provedené úpravy",
	people_search_status_nok: "Nebyli požadovány názory zainteresovaných osob.",
	people_search_status_ok: "Požaduje se názor zainteresovaných osob.",
	pia_assessor: "Jméno Posuzovatele",
	pia_author: "Jméno Autora",
	pia_name: "PIA",
	pia_validator: "Jméno Validátora",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Zpět na předchozí stránku",
	rejection_reason: "Důvod odmítnutí",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "TO BE TRANSLATED - Risk mapping",
	risks_overview_title: "TO BE TRANSLATED - Risks overview",
	title: "Informace PIA"
};
var users$l = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$l = {
	add_signed_pia: "TO BE TRANSLATED - Add the signed AIIA",
	after_reading: "TO BE TRANSLATED - After reading full PIA relating to the data processing linked to ",
	button: {
		rejection: "TO BE TRANSLATED - Reject AIIA",
		signed_validation: "TO BE TRANSLATED - Approve PIA <br>(signed)",
		simple_validation: "TO BE TRANSLATED - Approve PIA <br>(direct)"
	},
	confirmation1: "TO BE TRANSLATED - I attest that the context of the processing described in the PIA is consistent with the reality.",
	confirmation2: "TO BE TRANSLATED - I attest that I am aware of the risks depending on the existing or planned measures.",
	confirmation3: "TO BE TRANSLATED - I ratify the corrective actions indicated in the action plan.",
	confirmation4: "TO BE TRANSLATED - I commit to implement as quickly as possible the indicated corrective actions.",
	latest_signed_attachment: "TO BE TRANSLATED - Last signed attachment",
	mandatory_fields: "TO BE TRANSLATED - All boxes must be checked",
	remove_attachment: "TO BE TRANSLATED - Remove the attachment",
	responsible: "TO BE TRANSLATED - Person accountable for validating the PIA: ",
	signed_attachments_history: "TO BE TRANSLATED - Signed attachments history",
	tools: {
		dashboard: "TO BE TRANSLATED - Dashboard",
		display_pia: "TO BE TRANSLATED - Display report"
	},
	validated_pia_with_signature: "TO BE TRANSLATED - Approved",
	waiting_for_signature: "TO BE TRANSLATED - Pending signed PIA"
};
var cz = {
	about: about$l,
	action_plan: action_plan$l,
	authentication: authentication$l,
	cartography: cartography$l,
	comments: comments$l,
	conflict: conflict$l,
	date: date$l,
	errors: errors$l,
	evaluations: evaluations$l,
	header: header$l,
	help: help$l,
	homepage: homepage$l,
	knowledge_base: knowledge_base$l,
	measures: measures$l,
	misc: misc$l,
	modals: modals$l,
	onboarding: onboarding$l,
	opinions: opinions$l,
	"overview-risks": {
	important: "Důležité",
	limited: "Omezené",
	maximal: "Maximální",
	measures: "Measures",
	negligible: "Zanedbatelné",
	potential_impacts: "Potential impacts",
	"risk-access_x": "Severity",
	"risk-access_y": "Likelihood",
	"risk-change_x": "Severity",
	"risk-change_y": "Likelihood",
	"risk-disappearance_x": "Severity",
	"risk-disappearance_y": "Likelihood",
	sources: "Sources",
	threat: "Threat"
},
	pia: pia$l,
	questions: questions$l,
	rejection_page: rejection_page$l,
	sections: sections$l,
	settings: settings$l,
	summary: summary$l,
	users: users$l,
	validation_page: validation_page$l
};

var about$k = {
	contribute: "Wenn Sie zur Übersetzung des Tools oder zur Verbesserung der bereits vorgeschlagenen beitragen möchten, laden wir Sie ein, <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">die Seite mit den folgenden Schritten zu lesen</a>.",
	description: "Dieses Tool wurde ursprünglich von der französischen Datenschutzbehörde <a target=\"_blank\" href=\"https://www.cnil.fr\"> Nationale Kommission für Informatik und Freiheit (CNIL) </a> entwickelt, um dem Verantwortlichen zu helfen, mit der DS-GVO konform zu sein. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Diese Software ist kostenlos und offen. Wenn Sie sich an diesem Projekt beteiligen möchten, können Sie den Quellcode von Github herunterladen, ändern und mit anderen in der Community teilen.",
	licences: "Bibliothekslizenzen:",
	title: "Über das Werkzeug AIIA",
	translators: "Das Tool ist derzeit in achtzehn Sprachen verfügbar. Die französische und die englische Version werden von der CNIL bereitgestellt. Die anderen Versionen sind das Ergebnis der Beiträge der folgenden Personen:",
	translators_name: "<ul><li>Deutsch : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) , Helmut Karnath ;</li><li>Dänisch : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Englisch : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estnisch : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnisch : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>Französisch : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Griechisch : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a>  ;</li><li>Italienisch : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Kroatisch : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Litauisch : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Niederländisch : Ruud van Driel, Manuel d’Orso ;</li><li>Norwegisch : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polnisch : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portugiesisch : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Rumänisch : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanisch : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a>  ;</li><li>Tschechisch : Jiří Grohmann, Manuel d’Orso ;</li><li>Ungarisch : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a>.</li></ul>",
	version_number: "Versionsnummer"
};
var action_plan$k = {
	acceptable_measures: "Akzeptable Maßnahmen",
	edit: "Bearbeiten",
	improvable_measures: "Verbesserbare Maßnahmen",
	measures: "Geplante oder bestehende Maßnahmen",
	no_action_plan: "Kein Aktionsplan festgelegt.",
	placeholder_person_in_charge: "Umsetzungsverantwortlich",
	principles: "Grundlegende Prinzipien",
	risk1: "Unrechtmäßiger Zugriff auf Daten",
	risk2: "Unerwünschte Veränderung von Daten",
	risk3: "Datenverlust",
	risks: "Risiken",
	title: "Übersicht"
};
var authentication$k = {
	"12_characters": "12 Zeichen",
	account_recovery: "Kennwort wiederherstellen",
	activation_code: "Aktivierungscode",
	cancel: "Abbrechen",
	confirm: "Bestätigen",
	confirmation: "Bestätigung",
	"continue": "Weiter",
	activate_account: "Konto aktivieren",
	create_account: "Anlegen",
	create_account2: "Benutzerkonto anlegen",
	description: "Diese Software der <strong>französischen Datenschutzbehörde (CNIL)</strong> soll den Datenverantwortlichen bei der Erstellung und dem Nachweis der Einhaltung der DS-GVO helfen. Sie hilft bei der Durchführung einer Datenschutz-Folgenabschätzung, indem sie die Verwendung der von der CNIL entwickelten PIA-Methode erleichtert.",
	email: "E-Mail",
	email_placeholder: "E-Mail",
	forgotten_password: "Vergessen?",
	login: "Anmeldung",
	lowercase: "Kleinbuchstaben",
	password: "Kennwort",
	password_security: "Kennwort Sicherheit",
	recovery_code: "Wiederherstellungscode",
	recovery_code_message: "Es wurde eine E-Mail mit einem Wiederherstellungscode an diese Mailadresse gesendet. Bitte geben Sie den Code in das untenstehende Feld ein.",
	recovery_code_not_sent: "Wiederherstellungscode nicht erhalten?",
	saved_password: "Kennwort wurde gespeichert. Sie können sich nun anmelden.",
	sign_in: "Anmelden",
	sign_in_button: "Anmelden",
	sign_out_button: "Abmelden",
	special_character: "Sonderzeichen",
	number: "Nummer",
	start: "Starten",
	start_app: "Zugriff auf die PIA-Software (Beta)",
	subtitle1: "Eine Plattform zum Erstellen<br>und Verwalten Ihrer DSFAs",
	subtitle2: "Zugriff auf Tools und Glossare",
	title: "Datenschutz-Folgenabschätzung",
	transaction_error: "Die Anforderung kann nicht bearbeitet werden.",
	uppercase: "Großbuchstaben",
	wrong_activation_code: "(falsch)",
	wrong_confirmation: "Die Kennwörter stimmen nicht überein.",
	wrong_email: "falsche E-Mail-Adresse",
	errors: {
		sign_in: {
			"400": "Falsche E-Mail-Adresse oder falsches Kennwort."
		},
		create_account: {
			uuid: {
				"404": "Falscher Aktivierungscode",
				"406": "Dieses Konto ist bereits aktiviert."
			},
			password: {
				"404": "Benutzer nicht gefunden",
				"406": "Das Kennwort entspricht nicht den Anforderungen der Kennwortrichtlinie."
			}
		},
		account_recovery: {
			email: {
				"404": "Benutzer nicht gefunden",
				"423": "Benutzerkonto gesperrt"
			},
			uuid: {
				"404": "Falscher Wiederherstellungscode"
			},
			password: {
				"404": "Benutzer nicht gefunden",
				"406": "Das Kennwort entspricht nicht den Anforderungen der Kennwortrichtlinie."
			}
		},
		unauthorized: "Der Zugriff auf diese resource ist Ihnen nicht gestattet.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$k = {
	important: "Substantiell",
	legend1: "Geplante oder bestehende Maßnahmen",
	legend2: "Mit den eingeleiteten Korrekturmaßnahmen",
	legend3: "(Z) Unrechtmäßiger Zugriff auf Daten",
	legend4: "(V) Unerwünschte Veränderung von Daten",
	legend5: "(D) Datenverlust",
	likelihood_axe: "Eintrittswahrscheinlichkeit des Risikos",
	limited: "Überschaubar",
	maximal: "Groß",
	negligible: "Geringfügig",
	risk1_access: "(Z)",
	risk2_modification: "(V)",
	seriousness_axe: "Schweregrad des Risikos"
};
var comments$k = {
	comment: "Kommentar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "Kommentar(e)",
	new_comment: "Kommentieren",
	placeholder_new_comment: "Hinterlassen Sie einen Kommentar",
	send: "Senden"
};
var conflict$k = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$k = {
	april: "April",
	august: "August",
	december: "Dezember",
	"earlier-in-this-month": "Anfang des Monats",
	"earlier-in-this-week": "Anfang der Woche",
	february: "Februar",
	january: "Januar",
	july: "Juli",
	june: "Juni",
	march: "März",
	may: "Mai",
	november: "November",
	october: "Oktober",
	september: "September",
	today: "Heute",
	yesterday: "Gestern"
};
var errors$k = {
	content: "Wenn Sie auf andere Probleme stoßen oder Verbesserungsvorschläge haben, können Sie diese über das folgende Formular zurücksenden: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Seite nicht gefunden."
};
var evaluations$k = {
	acceptable: "akzeptabel",
	action_plan_comment: "Aktionsplan / Korrekturmaßnahmen",
	evaluation_comment: "Bewertungskommentar",
	gauges: {
		"0": "(Nicht definiert)",
		"1": "Geringfügig",
		"2": "Überschaubar",
		"3": "Substantiell",
		"4": "Groß",
		likelihood: "Unter Berücksichtigung des Aktionsplans, wie bewerten Sie die <span class='red-highlight'> Wahrscheinlichkeit dieses Risikos </span>?",
		seriousness: "Wie bewerten Sie unter Berücksichtigung des Aktionsplans die <span class='red-highlight'> Höhe dieses Risikos </span>?"
	},
	improvable: "verbesserungsfähig",
	placeholder_acceptable: "Soweit aus den zur Verfügung gestellten Informationen ersichtlich, reichen die durchgeführten Maßnahmen aus, um die Datenschutzanforderungen zu erfüllen.",
	placeholder_improvable1: " Soweit aus den zur Verfügung gestellten Informationen ersichtlich, müssen zusätzliche Maßnahmen hinzugefügt werden, um den Schutz der verarbeiteten Daten zu verbessern.",
	placeholder_improvable2: "Geben Sie Ihre Kommentare ein.",
	placeholder_to_correct: "Die bereitgestellten Informationen sind nicht ausreichend für eine vollständige Bewertung. Die DSFA wird zurück an den Bearbeiter verwiesen, um den ursprünglichen Vorschlag zu ergänzen.",
	status: [
		"unerledigt",
		"zu korrigieren",
		"verbesserungsfähig",
		"akzeptabel"
	],
	title: "Bewertung",
	to_correct: "zu berichtigen"
};
var header$k = {
	archives: "DSFA Archiv",
	current_pias: "Aktuelle DSFAs",
	exit_full_screen_mode: "Drücken Sie F11, um den Vollbildmodus zu verlassen.",
	help: {
		issue_reporting: "Ein Problem melden",
		manual: "Benutzerhandbuch",
		pia_example_link: "Beispiel DSFA",
		title: "Hilfe"
	},
	homepage_link: "Meine DSFAs",
	knowledge_base_link: "Wissensbasis",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Von der CNIL bereitgestellte Übersetzungen",
		community_translations: "Von der Community bereitgestellte Übersetzungen",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Von europäischen Aufsichtsbehörden bereitgestellte Übersetzungen",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Originalversion",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "PIA - privacy impact assessment",
	logo_title: "DSFA - Datenschutz-Folgenabschätzung",
	structures: "DSFA-Vorlagen",
	tools: {
		about: "Über",
		accessibility: "Unterstützung für Sehbehinderte (kontrastreiche Farben, bei Rot-Grün-Sehschwäche)",
		onboarding: "Benutzerhandbuch wieder aufbauen",
		settings: "Einstellungen",
		url_setting: "Server-URL-Konfiguration",
		users: "Benutzer"
	}
};
var help$k = {
	definition: {
		data1: {
			content: "Inhalt ist in Bearbeitung",
			title: "Verwenden Sie das DSFA-Tool"
		},
		data2: {
			qa1: {
				content: "Schließen Sie die Anwendung, wenn diese Anzeigeprobleme auftreten, und starten Sie sie erneut. Normalerweise behebt es das Problem. Die von Ihnen eingegebenen Informationen gehen nicht verloren; Diese werden automatisch während der Eingabe gespeichert.",
				title: "Ich habe Probleme mit der Anzeige, z. B. dass Symbole in einem Status hängen bleiben oder Elemente der Schnittstelle fehlen"
			},
			qa2: {
				content: "Dieses bekannte Problem wird derzeit behoben. Wenn Sie auf dieses Problem stoßen, empfehlen wir, dass Sie das Begründungsfeld des geschätzten Schweregrads und / oder der Eintrittswahrscheinlichkeit ausfüllen. Sie können die Skala bearbeiten, sobald der Fehler behoben ist.",
				title: "Ich kann die Skala nicht bearbeiten, um den Schweregrad und die Eintrittswahrscheinlichkeit eines Risikos zu bewerten"
			},
			qa3: {
				content: "Beim Import einer DSFA wurden mehrere Fehler beobachtet, und insbesondere die Skalen für die Bewertung des Schweregrads und der Eintrittswahrscheinlichkeit eines Risikos können verschwinden. Bitte beachten Sie in diesem Fall das oben genannte Problem. Außerdem wird eine DSFA nach dem Importieren möglicherweise nicht in der Übersicht angezeigt. Dies ist ein Anzeigeproblem und Sie müssen nur die Seite aktualisieren.",
				title: "Beim Importieren einer DSFA treten Probleme auf"
			},
			qa4: {
				content: "Dies ist nur ein Anzeigefehler und hat keine Auswirkung auf den Text, den Sie in ein Feld eingeben. Dieses visuelle Problem wird bald behoben sein.",
				title: "Wenn ich Text kopiere / einfüge, wird er markiert."
			},
			qa5: {
				content: "Um einen Abschnitt zu überprüfen oder zu bestätigen, müssen alle Felder ausgefüllt werden. Bitte prüfen Sie, ob dies der Fall ist. Wenn Sie ein Risiko bearbeiten, müssen Sie mindestens eine technische oder organisatorische Maßnahme haben, die das Risiko mindert, um nach einer Risikobewertung zu fragen. ",
				title: "Ich kann einen Abschnitt nicht überprüfen / bestätigen"
			},
			qa6: {
				content: "Bitte schließen Sie die DSFA, die Sie bearbeiten, und öffnen Sie sie erneut. Der Inhalt sollte dann in der von Ihnen gewählten Sprache angezeigt werden.",
				title: "Beim Wechseln der Sprache werden die Texte nicht übersetzt"
			},
			qa7: {
				content: "Im Moment werden die Navigationsmenüsymbole nicht aktualisiert, nachdem eine DSFA abgelehnt wurde. Sie müssen jeden Abschnitt überprüfen und die Informationen und / oder Bewertungen entsprechend den Gründen für die Verweigerung der DSFA ändern. Sobald alle Abschnitte überprüft wurden, sollten Sie die DSFA-Bestätigung erneut anfordern können.",
				title: "Ich habe mich geweigert, eine DSFA zu bestätigen, aber ich weiß nicht, was ich jetzt tun soll"
			},
			title: "Bekannte Probleme"
		},
		footer: "Wenn Sie weitere Probleme haben oder Verbesserungsvorschläge haben, können Sie diese über dieses Formular an uns zurückmelden: <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Hilfe"
};
var homepage$k = {
	cards: {
		author: "Bearbeiter",
		category: "Kategorie",
		creation_status: "Anlegen",
		date: "Datum",
		evaluation: "Prüfer",
		guest: "Gast",
		import_pia: "DSFA importieren",
		import_structure: "Vorlage importieren",
		item: {
			consult_pia: "Ansehen",
			consult_structure: "Vorlage anzeigen",
			edit_pia: "Bearbeiten",
			edit_structure: "Bearbeiten der Vorlage",
			tools: {
				action_plan: "Aktionsplan<br>anzeigen",
				archive: "Archivieren",
				duplicate: "Kopieren",
				"export": "Exportieren",
				more_options: "Weitere Optionen",
				pia: "DSFA<br>anzeigen",
				remove: "Löschen",
				unarchive: "Wiederherstellen"
			},
			validate_pia: "Prüfen"
		},
		knowledges: {
			edit: "Wissensdatenbank ändern",
			"import": "Wissensdatenbank importieren",
			"new": "Neue Wissensdatenbank",
			placeholder_author: "Autor",
			placeholder_contributors: "Mitwirkende",
			placeholder_entry_number: "Anzahl Einträge",
			placeholder_name: "Name der Wissensdatenbank"
		},
		knowledges_entry: {
			all_sections: "Alle Abschnitte",
			choose_category: "Kategorie auswählen",
			contents: "Inhalt",
			create: "Diesen Eintrag anlegen",
			linked_to: "Verknüpft mit",
			"new": "Eintrag anlegen",
			placeholder_category: "Kategorie",
			placeholder_description: "Beschreibung...",
			placeholder_name: "Name des Eintrags",
			placeholder_updated_at: "Letzte Aktualisierung"
		},
		new_pia: "Neue DSFA",
		new_structure: "Neue Vorlage",
		or: "oder",
		pia_name: "DSFA",
		placeholder_author: "Vorname Nachname",
		placeholder_category: "Kategorie",
		placeholder_evaluation: "Vorname Nachname",
		placeholder_import_knowledgeBase: "Wissensdatenbank importieren",
		placeholder_import_pia: "DSFA importieren",
		placeholder_import_structure: "Vorlage importieren",
		placeholder_new_knowledgeBase: "Neue Wissensdatenbank",
		placeholder_new_pia: "Neue DSFA",
		placeholder_new_structure: "Neue Vorlage",
		placeholder_pia_name: "DSFA-Titel",
		placeholder_sector_name: "Titel des zugehörigen Abschnitts",
		placeholder_start: "Es müssen alle Felder ausgefüllt sein",
		placeholder_structure: "Standardvorlage",
		placeholder_structure_name: "Titel der Vorlage",
		placeholder_validation: "Vorname Nachname",
		sector_name: "Zugehöriger Abschnitt",
		start: "Start",
		status: "Status",
		structure: "Vorlage",
		structure_name: "Name der Vorlage",
		title_close_creation: "Schließen",
		validation: "Bestätigender"
	},
	filters: {
		assessor: "Überprüft von",
		author: "Bearbeitet von",
		card: "Rasteransicht",
		card_rocket_content: "Für eine neue DSFA,<br> klicken Sie auf \"+\"",
		card_rocket_content_structure: "Fangen Sia an!<br><br>Um eine Vorlage<br>zu beginnen, klicken Sie auf<br> auf das +.",
		category: "Kategorie",
		date: "Datum",
		import_pia: "DSFA importieren",
		import_structure: "Vorlage importieren",
		list: "Listansicht",
		list_rocket_content: "Fangen Sie an! Um eine DSFA anzulegen, klicken Sie auf \"Neue DSFA\"",
		list_rocket_content_structure: "Fangen Sie an! Um eine Vorlage<br>zu beginnen, klicken Sie auf die Schaltfläche +.",
		name: "Name",
		new_pia: "Neue DSFA",
		new_structure: "Neue Vorlage",
		sector_name: "Zugehöriger Abschnitt",
		sort: "Sortieren",
		sort_by: "nach",
		status: "Status",
		validator: "Bestätigt von"
	},
	lists: {
		column_actions: "Aktionen",
		column_author: "Bearbeitet von",
		column_category: "Kategorie",
		column_creation: "Bearbeitet",
		column_evaluation: "Überprüft von",
		column_pia: "DSFA",
		column_progression: "Fortschritt",
		column_sector_name: "Zugehöriger Abschnitt",
		column_status: "Status",
		column_structure: "Vorlage",
		column_structure_name: "Vorlage",
		column_updated_at: "Zuletzt geöffnet",
		column_validation: "Bestätigt von",
		item: {
			tools: {
				action_plan: "Aktionsplan anzeigen",
				archive: "Archivieren",
				consult: "Ansehen",
				duplicate: "Kopieren",
				edit: "Bearbeiten",
				"export": "Exportieren",
				pia: "DSFA anzeigen",
				remove: "Löschen",
				unarchive: "Wiederherstellen"
			}
		}
	},
	search_filter: "Suchen",
	no_entries: {
		pia: "Keine Datenschutz-Folgeabschätzung (DSFA) erstellt und/oder zugewiesen.",
		archive: "Keine archivierte Datenschutz-Folgeabschätzung (DSFA) gefunden."
	}
};
var knowledge_base$k = {
	add_measure: "Hinzufügen",
	add_measure_hint: "Sie können auch eine Maßnahme aus der Wissensdatenbank hinzufügen.",
	category: {
		definition: "Definition",
		example: "Beispiel",
		general_measure: "Physische Sicherheitsmaßnahme",
		measure_on_data: "Logische Sicherheitsmaßnahme",
		method: "Methodik",
		organizational_measure: "Organisationsmaßnahme",
		principle: "Prinzip"
	},
	choose_knowledge_base: "Wähle die eigene Wissensdatenbank",
	default_knowledge_base: "CNILs Wissensdatenbank",
	filters: {
		all: "Alle",
		definitions: "Definitionen",
		general_measures: "Physische Sicherheitsmaßnahmen",
		measures_on_data: "Logische Sicherheitsmaßnahmen",
		no_result: "Keine Einträge gefunden.",
		organizational_measures: "Organisationsmaßnahmen",
		title: "Filter"
	},
	placeholder_add_measure: "Füge diese Maßnahme hinzu",
	placeholder_help: "Eingabehilfen",
	search: "Suche",
	slugs: {
		PIA_DEF_ACC: {
			description: "Die betroffene Person hat das Recht, eine Bestätigung des für die Verarbeitung Verantwortlichen zu erhalten, dass sie betreffende personenbezogene Daten verarbeitet werden oder nicht und, soweit verfügbar, Zugang zu diesen personenbezogenen Daten und anderen Daten. Informationen, die im <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 15 der [DS-GVO]</a> angegeben sind.<br>Es gibt Besonderheiten in Bezug auf den Zugang zu medizinischen Aufzeichnungen und bei der Ausübung des Rechts auf Zugang für Erziehungsberechtigte, für Minderjährige oder deren gesetzlichen Vertreter und für Personen, die unter Vormundschaft stehen.",
			name: "Recht auf Auskunft",
			source: "DS-GVO Art. 15 pour la définition et WIKI Exercice_des_droits_d’accès_et_à_la_portabilité pour les exceptions du droit Français"
		},
		PIA_DEF_ANO: {
			description: "Der Zweck einer Anonymisierungslösung besteht darin, dass personenbezogene Daten ihren identifizierenden Charakter verlieren. Eine Anonymisierungslösung muss von Fall zu Fall erstellt und an die beabsichtigten Verwendungszwecke angepasst werden. Eine Hilfe für die Bewertung einer guten Lösung, bietet die <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_de.pdf\">Art.29-Gruppe</a>.Sie nennt drei Kriterien:<br><strong>die Individualisierung:</strong> es ist noch immer möglich, eine individuelle Person zu isolieren<br>- <strong>die Korrelation:</strong> es ist möglich, getrennte Datensätze für dasselbe Individuum miteinander zu verknüpfen<br>- <strong>die Schlussfolgerung:</strong>hier ist es  möglich, aus den Informationen über eine Person auf deren Identität zu schließen.<br><strong>Eine Gruppe von Daten, für die es unmöglich ist, zu individualisieren oder zu korrelieren oder abzuleiten, ist a priori anonym.</strong><br><strong>Wird eines der drei Kriterien nicht eingehalten,</strong> kann nur nach einer erneuten eingehenden Analyse der Risiken einer Einordnung als anonym vorgenommen werden.",
			name: "Anonymisierung",
			source: "WIKI pour la première phrase, site CNIL pour la description des recommandations du G29 https://www.cnil.fr/fr/le-g29-publie-un-avis-sur-les-techniques-danonymisation-0"
		},
		PIA_DEF_ARCH: {
			description: "Daten, die nicht mehr täglich verwendet werden, aber noch nicht ihre Aufbewahrungsfrist erreicht haben, beispielsweise weil sie für den Fall eines Rechtsstreits aufbewahrt werden, sollten archiviert werden.<br><strong>Archive müssen sicher und der Zugang eingeschränkt sein</strong>, insbesondere wenn es sich bei den archivierten Daten um sensible Daten oder um Daten handelt, die schwerwiegende Auswirkungen auf die betroffenen Personen haben können.",
			name: "Archivierung",
			source: "Guide Bleu 2017 p17"
		},
		PIA_DEF_AUTH: {
			description: "Die Authentifizierung ist eine <strong>Operation, durch die der Benutzer seine Identität beweist</strong>. Jeder berechtigte Benutzer sollte hierbei eindeutig identifiziert werden. Hierfür können mehrere Mechanismen unterschieden werden:<br>-Wissen: zum Beispiel ein Passwort;<br>- Besitz: zum Beispiel eine Smartcard;<br>- Biometrie: ein Merkmal, das für uns einzigartig ist, zum Beispiel ein Fingerabdruck oder die Möglichkeit, eine handschriftliche Unterschrift zu leisten.<br>Zur Erinnerung: nach der DS-GVO ist die  Verwendung der Biometrie nur aufgrund eines gesetzlichen Erlaubnistatbestands zulässig.<br><strong>Die Authentifizierung eines Benutzers ist als stark gekennzeichnet, wenn eine Kombination aus mindestens zwei dieser Kategorien verwendet wird.</strong>",
			name: "Authentifizierung",
			source: "Guide Bleu p7"
		},
		PIA_DEF_CHIF: {
			description: "Durch das Verschlüsseln einer Nachricht wird sichergestellt, dass nur der Absender und der / die rechtmäßige(n) Empfänger einer Nachricht den Inhalt kennen. Es ist eine Art digital versiegelter Umschlag. Nach der Verschlüsselung ist eine Nachricht weder für Personen noch Maschinen zugänglich oder lesbar, wenn sie nicht über den spezifischen Schlüssel verfügen.<br>Es gibt zwei große Familien der Verschlüsselung : symmetrische und asymmetrische.<br>- <strong>Symmetrische Verschlüsselung</strong> Inhalte werden mit dem gleichen Schlüssel verschlüsselt und entschlüsselt, genannt der \"geheimen Schlüssel\". Die symmetrische Verschlüsselung ist besonders schnell, erfordert jedoch, dass der Sender und der Empfänger sich auf einen gemeinsamen geheimen Schlüssel einigen oder ihn über einen anderen Kanal übertragen. Dieser muss sorgfältig ausgewählt werden, da sonst der Schlüssel von den falschen Leuten zurückgewonnen werden könnte und die Vertraulichkeit der Nachricht kompromittiert wird.<br-<strong>Asymmetrische Verschlüsselung</strong> Sie geht davon aus, dass der (zukünftige) Empfänger ein Schlüsselpaar (privater Schlüssel, öffentlicher Schlüssel) hat und hat sicherstellt, dass der potentielle Absender Zugriff auf seinen öffentlichen Schlüssel hat. In diesem Fall verwendet der Absender den öffentlichen Schlüssel des Empfängers zum Verschlüsseln der Nachricht, während der Empfänger seinen privaten Schlüssel zum Entschlüsseln verwendet. Es ist von Vorteil, dass der öffentliche Schlüssel allen bekannt ist und veröffentlicht werden kann. Aber Vorsicht: es ist notwendig, dass die Sender das Vertrauen in der Herkunft des öffentlichen Schlüssels haben und sicher sind , dass er in der Tat vom Empfänger stammt. Ein weiterer Pluspunkt: Sie müssen nicht den gleichen geheimen Schlüssel teilen! Die asymmetrische Verschlüsselung macht es möglich, darauf zu verzichten, aber sie ist langsamer.",
			name: "Verschlüsselung",
			source: "Guide Bleu 2017 p23 https://www.cnil.fr/fr/comprendre-les-grands-principes-de-la-cryptologie-et-du-chiffrement"
		},
		PIA_DEF_CLO: {
			description: "Methoden zur Reduzierung der Möglichkeiten, personenbezogene Daten zu korrelieren und eine Kompromittierung aller gespeicherten Daten zu verhindern, indem beispielsweise die spezifischen Daten der jeweiligen Geschäftsprozesses identifiziert und logisch getrennt werden.",
			name: "Datentrennung",
			source: "WIKI Cloisonnement_des_données_(par_rapport_au_reste_du_système_d’information)"
		},
		PIA_DEF_CONS: {
			description: "Einwilligung der betroffenen Personen jede freiwillig für den bestimmten Fall, in informierter Weise und unmissverständlich abgegebene Willensbekundung in Form einer Erklärung oder einer sonstigen eindeutigen bestätigenden Handlung, mit der die betroffene Person zu verstehen gibt, dass sie mit der Verarbeitung der sie betreffenden personenbezogenen Daten einverstanden ist.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 4.11 der [DS-GVO]</a>",
			name: "Einwilligung des Betroffenen",
			source: "DS-GVO Art. 4.11"
		},
		PIA_DEF_CTLA: {
			description: "Es geht darum, die Risiken des Zugriffs unbefugter Personen auf personenbezogene Daten in digitaler Form zu begrenzen.<br> Um dies zu tun, empfiehlt es sich:<br>- <strong>Berechtigungsprofile / -konzepte</strong> zu definieren, die durch die Trennung von Aufgaben und Verantwortungsbereichen den Zugriff der Benutzer auf diejenigen Daten beschränken, die für die Erfüllung ihrer Aufgaben unbedingt erforderlich sind.<br>- <strong>Entziehen Sie Benutzern Zugriffsrechte, sobald diese nicht mehr berechtigt sind, auf eine lokale oder IT-resource zuzugreifen</strong>sowie <strong>am Ende ihres Vertrags.</strong><br>- <strong>Führen Sie eine jährliche Überprüfung der Berechtigungen durch</strong>, um nicht verwendete Konten zu identifizieren und zu löschen und die Rechte neu zuzuweisen, die für die Funktionen jedes Nutzers gewährt werden.",
			name: "Logische Zugriffskontrollen",
			source: "WIKI Contrôle_des_accès_logiques et Guide Bleu 2017 p9 pour les précautions"
		},
		PIA_DEF_DCP: {
			description: "Alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person (im Folgenden „betroffene Person“) beziehen; als identifizierbar wird eine natürliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren besonderen Merkmalen, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identität dieser natürlichen Person sind, identifiziert werden kann.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 4.1 der [DS-GVO]</a>",
			name: "Personenbezogene Daten",
			source: "DS-GVO Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Eine natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle, der personenbezogene Daten offengelegt werden, unabhängig davon, ob es sich bei ihr um einen Dritten handelt oder nicht. Behörden, die im Rahmen eines bestimmten Untersuchungsauftrags nach dem Unionsrecht oder dem Recht der Mitgliedstaaten möglicherweise personenbezogene Daten erhalten, gelten jedoch nicht als Empfänger; die Verarbeitung dieser Daten durch die genannten Behörden erfolgt im Einklang mit den geltenden Datenschutzvorschriften gemäß den Zwecken der Verarbeitung.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 4.9 der [DS-GVO]</a>",
			name: "Empfänger",
			source: "DS-GVO Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Die betroffene Person hat das Recht, von dem Verantwortlichen zu verlangen, dass sie betreffende personenbezogene Daten unverzüglich gelöscht werden, und der Verantwortliche ist verpflichtet, personenbezogene Daten unverzüglich zu löschen, soweit die gesetzlich geregelten Gründe zutreffen.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 17 der [DS-GVO]</a>",
			name: "Recht auf Löschung",
			source: "DS-GVO Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Gründe für die Umsetzung der Verarbeitung, die erwarteten Vorteile (für die Organisation, für die betroffenen Personen, für die Gesellschaft im Allgemeinen ...). ",
			name: "Zweck der Verarbeitung",
			source: "PIA1 p6 (note 8 en bas de page)"
		},
		PIA_DEF_EXA: {
			description: "Personenbezogene Daten müssen sachlich richtig und erforderlichenfalls auf dem neuesten Stand sein; es sind alle angemessenen Maßnahmen zu treffen, damit personenbezogene Daten, die im Hinblick auf die Zwecke ihrer Verarbeitung unrichtig sind, unverzüglich gelöscht oder berichtigt werden (\"Richtigkeit\").<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 5.1 d) der [DS-GVO]</a>",
			name: "Richtigkeit von Daten",
			source: "DS-GVO Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Der Schweregrad bemisst die Tragweite eines Risikos. Er hängt im Wesentlichen von dem potenziellen Schaden ab, den der Eintritt des Risikos bewirkt.",
			name: "Schweregrad",
			source: "PIA1 page 9"
		},
		PIA_DEF_LIM: {
			description: "Die betroffene Person hat das Recht, von dem Verantwortlichen die Einschränkung der Verarbeitung zu verlangen.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 18 der [DS-GVO]</a>",
			name: "Recht auf Einschränkung der Verarbeitung",
			source: "DS-GVO Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Aufzeichnung von Aktionen, die auf dem IT-system ausgeführt werden, um <strong>betrügerischen Zugriff</strong> oder <strong>Missbrauch</strong> von persönlichen Daten zu erkennen sowie den Verursacher eines Vorfalls. Zu diesem Zweck muss ein Trace- und Incident-Management-System eingerichtet werden. Es sollte <strong>relevante Ereignisse aufzeichnen</strong>und <strong>sicherstellen, dass diese Datensätze nicht manipuliert werden können.</strong> In jedem Fall sollten Sie <strong>diese Datensätze nur für einen gewissen Zeitraum und nicht exzessiv lange aufbewahrt werden.</strong>",
			name: "Protokollierung, Rückverfolgbarkeit",
			source: "Guide Bleu 2017 p10"
		},
		PIA_DEF_MEN: {
			description: "Vorgang, der die datenverarbeitenden Systeme und gespeicherten Daten gefährdet und zu Schäden für den Betroffenen führen kann. Die Bedrohung kann absichtlich oder unabsichtlich durch Risikoquellen genutzt werden und kann ein schadhaftes Ereignis auslösen.",
			name: "Bedrohung",
			source: "PIA1 p11"
		},
		PIA_DEF_MENA: {
			description: "Bedrohungen in Bezug auf:<br>- <strong>Komponenten</strong>, unangemessene Verwendung, Ausspähung, ungewollte Veränderung oder Verlust (Verwendung von Medien mit sensiblen Daten aus persönlichen Gründen oder deren Transport ohne entsprechende Sicherheitsmaßnahmen, Ausspähen von Bildschirmen, Einschleusen von Hardware zum Abruf von Daten, usw.)<br>- <strong>Software </strong>, unangemessene Verwendung, Ausspähung, ungewollte Veränderung (Erweiterung von Berechtigungen, Sammlung von Konfigurationsdaten, Installation eines Remote-Tools usw.)<br>-<strong>Computernetzwerke</strong>, die ausgespäht werden (Überwachung von Netzwerkflüssen, etc.) <br>- <strong>Personen</strong> durch Ausspähung, Unterschlagung oder Verlust (unfreiwillige Offenlegung, Social Engineering, Wechsel des Arbeitgebers, etc.)<br>-<strong> Papierdokumente</strong> durch Ausspähung oder Verlust (Fotokopien, vergessene Ausdrucke, Wiederherstellung von verworfenen Dokumente, Maildiebstahl, etc.)<br>- <strong>Postversand </strong> durch Ausspähung",
			name: "Bedrohungen, die zu einem unrechtmäßigem Zugriff führen können",
			source: "WIKI Menaces_pouvant_mener_à_un_accès_illégitime_à_des_données synthétisé"
		},
		PIA_DEF_MENI: {
			description: "Bedrohungen in Bezug auf <br>- <strong>Komponenten</strong>: Missbrauch, Überlastung, Veränderung, Zerstörung, Verlust (Speicherüberlastung, DOS-Angriff, Änderung, die zu einem Absturz führt, Feuer , Diebstahl oder Verlust, etc.)<br>- <strong>Software</strong>: unangemessene Verwendung, Überlastung, Veränderung, Zerstörung, Verlust (Datenlöschung, Einschmuggeln von Daten, logische Bombe, Lizenz nicht erneuert, etc.)<br>- <strong>Computernetzwerke</strong>: Überlastung, Beschädigung, Verlust (Download nicht möglich, Internet-Zugang usw.)<br> -<strong>Personen</strong> : Überlastung, Beeinflussung, Abwesenheit (Missbrauch von Fähigkeiten, Abwesenheit, Abreise usw.)<br>- <strong>Papierdokumente </strong>: missbräuchliche Nutzung, Beschädigung, Verlust (Zerstörung, Diebstahl oder Verlust usw.)<br>- <strong>Postversand</strong>: Beschädigung, Veränderung, Verlust (Poststreik, Änderung der Räumlichkeiten, Verschwinden eines Dokumententrägers, Reorganisation des Versands usw.)",
			name: "Bedrohungen, die zum Verlust personenbezogener Daten führen können",
			source: "WIKI Menaces_pouvant_mener_à_une_disparition_de_données"
		},
		PIA_DEF_MENM: {
			description: " Bedrohungen in Bezug auf <br>- <strong>Komponenten</strong>, die geändert werden (Hinzufügen von inkompatibler Hardware, Entfernen wichtiger Komponenten usw.)<br>- <strong >Software</strong>, die unangemessen verwendet oder modifiziert wird (Bedienfehler, ungewollte Änderungen, etc.)<br>- <strong>Computernetzwerke</strong>, die unangemessen verwendet werden (Weiterversand von abgefangenen Daten, etc.)<br> - <strong>Personen</strong> durch Überarbeitung oder Beeinflussung (unkontrollierte Tätigkeit, störende Arbeitsbedingungen, Einflussnahme, etc.)<br> - Geänderte Papierdokumente (Veränderung , Ersatz durch eine Fälschung, etc.)<br>- <strong>Postversand</strong>, durch Manipulation (Austausch von Abzeichnungen, Versendung widersprüchlicher Briefe usw.)",
			name: "Bedrohungen, die zu einer unerwünschten Veränderung personenbezogener Daten führen können",
			source: "WIKI Menaces_pouvant_mener_à_une_modification_non_désirées_de_données"
		},
		PIA_DEF_MES: {
			description: "Wählen Sie Maßnahmen aus den im Abschnitt \"Vorhandene oder geplante Maßnahmen\" verfügbaren aus, ergänzen Sie diese bei Bedarf.",
			name: "Maßnahmen",
			source: "keine"
		},
		PIA_DEF_MIN1: {
			description: "Beim Importieren von Daten können verschiedene Arten von Metadaten (z. B. EXIF-Daten, die an eine Bilddatei angehängt sind) unbeabsichtigt erfasst werden.<br>Diese Metadaten müssen identifiziert und verworfen werden, wenn sie nicht für die angegebenen Zwecke erforderlich sind.",
			name: "Filterung und Löschung",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN2: {
			description: "Nach dem Empfang sensibler Daten im Rahmen allgemeiner Informationen oder zu statistischen Zwecken können diese in eine weniger sensible oder pseudonymisierte Form umgewandelt werden. Zum Beispiel:<br>- Wenn das System die IP-Adresse sammelt, um den Standort des Benutzers für statistische Zwecke zu ermitteln, kann die IP-Adresse nach Ermittlung der Stadt oder des Bezirks gelöscht werden;<br>- Wenn das System Videodaten von Überwachungskameras empfängt, kann es Personen, die in der Szene stehen oder sich bewegen, erkennen und unscharf machen;<br>- Wenn das System ein intelligentes Messgerät ist, kann es die Energienutzung über einen bestimmten Zeitraum hinweg aggregieren, ohne ihn in Echtzeit zu erfassen.",
			name: "Verringerung der Sensibilität durch Umwandlung",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN3: {
			description: "Das System kann sicherstellen, dass:<br>- Der Benutzer eine resource oder einen Dienstes ohne das Risiko der Offenlegung seiner / ihrer Identität (anonyme Daten) verwenden kann.<br>- Der Benutzer eine resource oder Dienstleistung ohne Offenlegung seiner / ihrer Identität benutzen kann. Er bleibt aber identifizierbar und verantwortlich für diese Nutzung (pseudonymisierte Daten).<br>- Der Benutzer kann resourcen oder Dienste mehrfach nutzen, ohne dass diese Nutzungen miteinander verknüpft werden können (nicht korrelierbare / verkettbare Daten).<br>- Der Benutzer kann eine resource oder Dienstleistung ohne Risiko nutzen, dass andere, insbesondere Dritte, in der Lage sind, zu beobachten, dass die resource oder Dienstleistung genutzt wird (Nichtbeobachtbarkeit).<br>Eine Methode aus der obigen Liste muss von den erkannten Bedrohungen abhängen. Für einige Arten von Datenschutzbedrohungen ist die Pseudonymisierung geeigneter als die Anonymisierung (z. B. wenn Nachverfolgbarkeit erforderlich ist). Darüber hinaus werden einige Datenschutzbedrohungen durch eine Kombination mehrerer Methoden behoben.",
			name: "Verringerung der identifizierenden Natur der Daten",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN4: {
			description: "Das System kann in unabhängige Teile mit separaten Zugriffssteuerungsfunktionen strukturiert sein. Die Daten können auch auf diese unabhängigen Teilsysteme verteilt und von jedem Teilsystem unter Verwendung verschiedener Zugriffssteuerungsmechanismen gesteuert werden. Wenn ein Subsystem kompromittiert wird, hat dies keine Auswirkungen auf den gesamten Datenbestand. ",
			name: "Nichtverkettbarkeit",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN5: {
			description: "Das System kann den Zugriff auf Daten nach dem \"need to know\"-Prinzip einschränken. Das System kann vertrauliche Daten von den sonstigen Daten trennen und spezifische Zugriffsrichtlinien anwenden.<br>Das System kann sensible Daten verschlüsseln, um die Vertraulichkeit während der Übertragung und Speicherung zu schützen. Der Zugriff auf temporäre Dateien, die während der Datenverarbeitung erzeugt werden, sollte ebenfalls geschützt werden.",
			name: "Beschränkung des Datenzugriffs",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MINC: {
			description: "Verringerung der Schwere von Risiken, indem die Anzahl der erfassten personenbezogenen Daten auf das Minimum dessen begrenzt wird, was für einen bestimmten Zweck unbedingt erforderlich ist; Vermeiden Sie die Sammlung unnötiger Daten, die Verwendung von Daten, die nichts mit dem Zweck zu tun haben, und die exzessive Auswirkungen auf Einzelpersonen haben können.",
			name: "Minimierung der Datenmenge",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Verringern Sie die Schwere von Risiken, indem Sie die Anzahl Daten selbst minimieren und Maßnahmen ergreifen, um deren Sensibilität zu verringern.",
			name: "Minimierung der Daten selbst",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_OPP: {
			description: "Die betroffene Person hat das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f erfolgt, Widerspruch einzulegen.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 21 der [DS-GVO]</a>",
			name: "Recht auf Widerspruch",
			source: "DS-GVO Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Maßnahmen zur Berücksichtigung des Schutzes personenbezogener Daten bereits bei der Konzeption einer neuen Verarbeitung (Zertifizierungen, anerkannte Verhaltensregeln, Risikomanagement für die betreffende Person gemäß der Methodik der CNIL oder einer internen Methode usw.), einschließlich:<br>- Nutzen Sie den Risikomanagementansatz der CNIL, sobald ein Dienst oder eine Anwendung entwickelt wird.<br>– Setzen Sie in den Bereichen IT auf Zertifizierungen (für Verfahren, Produkte, Managementsysteme, Organisationen, Personen usw.).<br>- Verwenden Sie bewährte und anerkannte Verhaltensregeln und Standards.",
			name: "Projektmanagement",
			source: "WIKI Gestion_des_projets - les recommandations ne sont pas citées"
		},
		PIA_DEF_PC: {
			description: "Person, deren Daten verarbeitet werden.",
			name: "Betroffener",
			source: "PIA1 p11"
		},
		PIA_DEF_PORT: {
			description: "Die betroffene Person hat das Recht, die sie betreffenden personenbezogenen Daten, die sie einem Verantwortlichen bereitgestellt hat, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten, und sie hat das Recht, diese Daten einem anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem die personenbezogenen Daten bereitgestellt wurden, zu übermitteln.<br> Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 20 der [DS-GVO]</a>",
			name: "Recht auf Datenübertragbarkeit",
			source: "DS-GVO Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Verarbeitung personenbezogener Daten in einer Weise, dass sie nicht ohne die Verwendung zusätzlicher Informationen einer bestimmten Person zugeordnet werden können. Sofern diese zusätzlichen Informationen getrennt aufbewahrt werden und technischen und organisatorischen Maßnahmen unterliegen, die sicherzustellen, dass personenbezogene Daten nicht einer bestimmten oder identifizierbaren natürlichen Person zugeordnet werden.<br>Pseudonymisierung verringert das Risiko der Korrelation eines Datensatzes mit der ursprünglichen Identität einer betroffenen Person. Daher ist sie <strong>eine nützliche Sicherheitsmaßnahme, aber keine Methode der Anonymisierung.</strong>.",
			name: "Pseudonymisierung",
			source: "DS-GVO Art. 4.5 und Empfehlungen der Art.29.Gruppe S. 24 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_de.pdf"
		},
		PIA_DEF_PWD: {
			description: "Basierend auf der Verwaltung eines Geheimnisses ist die Authentifizierung durch Benutzername und Kennwort eine einfache und kostengünstige Möglichkeit, um den Zugriff zu kontrollieren. Diese Authentifizierungsmethode weist jedoch ein niedriges Sicherheitsniveau auf.<br>Die Mindestanforderungen der CNIL in Bezug auf Länge und Komplexität des Kennworts hängen von den zusätzlichen Maßnahmen ab, die implementiert werden, um den Authentifizierungsprozess zuverlässiger zu machen:<br>Wenn also eine Authentifizierung ausschließlich auf einem Kennwort basiert, bedeutet dies zumindest die Verwendung eines komplexen Kennwortes mit mindestens 12 Zeichen bestehend aus Großbuchstaben, Ziffern und Sonderzeichen. Zusätzliche Maßnahmen zur Eingabe eines Kennworts (Beschränkungen des Zugriffs, Einbezug anderer Daten, eigene Unterstützung durch den Benutzer) können die Länge und Komplexität des Kennworts aufgrund dieser Maßnahmen verringern. Sie stellen ein Sicherheitsniveau sicher, das äquivalent zu einem Kennwort ist.",
			name: "Verwendung von Kennwörtern",
			source: "Guide Bleu 2017 p7 : https://www.cnil.fr/fr/authentification-par-mot-de-passe-les-mesures-de-securite-elementaires synthétisé"
		},
		PIA_DEF_RECT: {
			description: "Die betroffene Person hat das Recht, von dem Verantwortlichen unverzüglich die Berichtigung sie betreffender unrichtiger personenbezogener Daten zu verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung hat die betroffene Person das Recht, die Vervollständigung unvollständiger personenbezogener Daten — auch mittels einer ergänzenden Erklärung — zu verlangen. Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 16 der [DS-GVO]</a>",
			name: "Recht auf Berichtigung",
			source: "DS-GVO Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates zum Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten, zum freien Datenverkehr und zur Aufhebung der Richtlinie 95/46/EG",
			name: "DS-GVO (Datenschutz-Grundverordnung)",
			source: "DS-GVO title"
		},
		PIA_DEF_RT: {
			description: "Die natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet; sind die Zwecke und Mittel dieser Verarbeitung durch das Unionsrecht oder das Recht der Mitgliedstaaten vorgegeben, so kann der Verantwortliche beziehungsweise können die bestimmten Kriterien seiner Benennung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten vorgesehen werden;<br>Weitere Informationen zu den Pflichten des für die Verarbeitung Verantwortlichen finden Sie  unter <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 4.7 der [DS-GVO]</a>",
			name: "Verantwortlicher",
			source: "DS-GVO Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Person (intern oder extern), die zufälliger oder vorsätzlicher Weise handelt oder eine nichtmenschliche Quelle (z.B. Wasser, gefährliche Stoffe, Computerviren), die ein Risiko für die Datenverarbeitung verursacht(z. B. IT-Administrator, Benutzer, externer Angreifer, Mitbewerber).",
			name: "Risikoquelle",
			source: "PIA1 p12 et WIKI Types_et_exemples_de_sources_de_risques synthétisés"
		},
		PIA_DEF_ST: {
			description: "Natürliche oder juristische Personen, Behörden, Dienste oder andere Stellen, die personenbezogene Daten im Auftrag des für die Verarbeitung Verantwortlichen verarbeiten, gemäß <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 4.8 der [DS-GVO]</a><br>Der Auftragsverarbeiter und jede Person, die unter der Aufsicht des für die Verarbeitung Verantwortlichen oder des Auftragsverarbeiters handelt und Zugang zu personenbezogenen Daten hat, können diese Daten nur auf Anweisung der für die Daten Verantwortlichen verarbeiten. Es sei denn, dies ist durch das Unionsrecht oder das Recht eines Mitgliedstaats vorgeschrieben, gemäß <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 29 der [DS-GVO]</a>.",
			name: "Auftragsverarbeiter",
			source: "DS-GVO Art. 4.8 und 29"
		},
		PIA_DEF_SUPT: {
			description: "<strong>Hardware und elektronische Datenträger</strong>: Computer, Kommunikationsgeräte, USB-Sticks, Festplatten ...<br><strong>Software</strong>: Betriebssysteme, Messagingsysteme, Datenbanken, Business-Anwendungen ...<br><strong>IT-Netzwerke </strong>: Kabel, WLAN, Glasfaser<br><br> <strong>Personen</strong>: Benutzer, IT-Administratoren, Entscheidungsträger ...<br><strong>Papierdokumente</strong>: Ausdrucke, Fotokopien, handschriftliche Dokumente ...<br><strong>Übertragung von Papierdokumenten</strong>: Postversand, Umlaufmappen ...",
			name: "Unterstützung der Verarbeitung",
			source: "WIKI Types_et_exemples_de_supports_des_données"
		},
		PIA_DEF_VIOL: {
			description: "Eine Verletzung der Sicherheit, die, ob unbeabsichtigt oder unrechtmäßig, zur Vernichtung, zum Verlust, zur Veränderung, oder zur unbefugten Offenlegung von beziehungsweise zum unbefugten Zugang zu personenbezogenen Daten führt, die übermittelt, gespeichert oder auf sonstige Weise verarbeitet wurden.",
			name: "Verletzung des Schutzes personenbezogener Daten",
			source: "DS-GVO Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Die Wahrscheinlichkeit spiegelt die Möglichkeit wieder, dass ein Risiko eintritt. Es hängt hauptsächlich von den Angreifbarkeit der eingesetzten Betriebsmittel hinsichtlich der Bedrohungen und Risikoquellen ab.",
			name: "Eintrittswahrscheinlichkeit",
			source: "PIA1 page 12"
		},
		PIA_EX_DC: {
			description: "Daten eines Scoringsystems, Ergebnisse aus der Anwendung von Scores ...",
			name: "Scoring"
		},
		PIA_EX_DCPC: {
			description: "<strong>Identifikationsdaten</strong>: Familienstand, Alter, Staatsangehörigkeit, doppelte Staatsbürgerschaft, Postanschrift, Rechtsfähigkeit ...<br><strong>Privatleben</strong>: Familienstand, Anzahl der Kinder , Wohnort, Wohnungstyp, Wohnsituation, Wohndauer ...<br><strong>Berufsleben</strong>: Anstellungsverhältnis, Vertragsart, Name des Arbeitgebers, Beschäftigungsdauer, Arbeitslosigkeit ...<br><strong>Login-Daten </strong>: IP-Adresse, Ereignisprotokolle ...<br><strong>Standortdaten </strong>: Bewegungsdaten, GPS, GSM-Daten ...<br><strong>Andere</strong>: Telefonnummer, E-Mail-Adresse ...",
			name: "Allgemeine Daten",
			source: "WIKI Types_de_données"
		},
		PIA_EX_DCPR: {
			description: "Weltanschauliche, politische, religiöse, gewerkschaftliche Überzeugungen und Beziehungen, Sexualleben, Gesundheitsdaten, Rasse oder ethnische Herkunft, Straftaten, Sicherheitsauflagen.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\"> Art. 9 und 10 der [DS-GVO]</a>.",
			name: "Besondere Kategorien personenbezogener Daten "
		},
		PIA_EX_DCPS: {
			description: " Weltanschauliche, politische, religiöse, gewerkschaftliche Überzeugungen und Beziehungen, Sexualleben, Gesundheitsdaten, Rasse oder ethnische Herkunft, Straftaten, Sicherheitsauflagen.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\"> Art. 9 und 10 der [DS-GVO]</a>.",
			name: "Sensible Daten"
		},
		PIA_EX_HUME: {
			description: "Das kann sein:<br>- ein böswilliger oder unwissender Dritter, der seine physische Nähe nutzt, um betrügerisch auf den Dienst zuzugreifen<br>- ein Angreifer, der einen Benutzer des Systems mit Hilfe seines Wissens über diesen Benutzer zum Ziel nimmt<br>- ein Angreifer, der eine der Firmen, die für die Verarbeitung verantwortlich sind angreift, um Informationen zu gewinnen oder den Ruf des Unternehmens zu schädigen<br>- eine dritte Partei, die ihren autorisierten Zugang zu anderen Zwecken wie z.B. dem illegalem Zugang zu Informationen nutzt.<br>Die Motive können vielfältig sein:<br>Nervenkitzel, Verärgerung, Böswilligkeit, Rache, Spionage, Gier, Beschaffung von Daten, um sie auszunutzen.",
			name: "Externe menschliche Risikoquellen"
		},
		PIA_EX_HUMI: {
			description: "Das kann sein:<br>- ein böswilliger bzw. nachlässiger Mitarbeiter, der seine / ihre Nähe zum System, seine Fähigkeiten, Rechte und möglicherweise ausreichend verfügbare Zeit nutzt oder aufgrund eines möglichen Mangels an Schulung und Bewusstsein nachlässig ist.<br>- ein böswilliger bzw. nachlässiger Benutzer oder sein Umfeld, mit Zugang zu den Diensten.<br>Die Motivationen können vielfältig sein: Ungeschicklichkeit, Fehler, Nachlässigkeit, Rache, Böswilligkeit, Gier, Spionage.",
			name: "Interne menschliche Risikoquellen"
		},
		PIA_EX_IMPI: {
			description: "Die Betroffenen können erhebliche Konsequenzen erleiden, die sie nur mit erheblichen Schwierigkeiten überwinden können.<br>Beispiele für Auswirkungen:<br>- körperlich: ernsthafte körperliche Beeinträchtigung, die zu langfristigem Schaden führen (Verschlimmerung von Gesundheitszustand aufgrund von schlechter Pflege, oder Nichteinhaltung von Kontraindikationen), Verletzung der körperlichen Unversehrtheit, etc.<br>- materiell: nicht kompensierbarer Verlust von Geldern, Verlust einzigartiger und nicht wiederkehrender Möglichkeiten (Hypothek, Studien, Praktika oder Beschäftigung, Prüfungsverbot), Verlust der Wohnung, Verlust des Arbeitsplatzes, etc.<br>- psychisch: schwere psychische Störung (Depression, Phobie), Gefühl der irreparablen Beeinträchtigung der Privatsphäre, Opfer von Erpressung, Cybermobbing und Mobbing usw.",
			name: "Schweregrad: substantiell"
		},
		PIA_EX_IMPL: {
			description: "Die Betroffenen können deutliche Unannehmlichkeiten erfahren, die sie jedoch trotz einiger Schwierigkeiten überwinden können.<br>Beispiele für Auswirkungen:<br>- körperlich: geringfügige körperliche Beeinträchtigung (z. B. leichte Erkrankung nach Nichteinhaltung von Kontraindikationen), üble Nachrede, die physische und psychische Auswirkungen hat.<br>- materiell: ungeplante Zahlungen (z. B. unberechtigte Bußgelder), Verweigerung des Zugangs zu administrativen oder kommerziellen Dienstleistungen, gezielte Online-Werbung zu einem ein Aspekt, der seitens des Betroffenen vertraulich bleiben sollte, etc.<br>- psychisch: geringe aber objektiv verstellbare psychische Beeinträchtigung, Gefühl der Verletzung der Privatsphäre ohne irreparablen Schaden, Einschüchterung in sozialen Netzwerken, etc.",
			name: "Schweregrad: überschaubar"
		},
		PIA_EX_IMPM: {
			description: "Die Betroffenen können erhebliche und auch nicht rückgängig zu machende Folgen erleiden.<br>Beispiele für Auswirkungen:<br>- körperlich: dauerhafte oder längerfristige körperliche Beeinträchtigung, dauerhafte Beeinträchtigung der körperlichen Unversehrtheit, Tod<br>- materiell: finanzielles Risiko, hohe Verschuldung, Arbeitsunfähigkeit, Unfähigkeit umzuziehen, Verlust von Beweisen bei Rechtsstreitigkeiten, Verlust des Zugangs zu lebenswichtiger Infrastruktur (Wasser, Strom), etc.<br >- psychisch: langfristige oder dauerhafte psychische Beeinträchtigung, strafrechtliche Sanktion, Entführung, Verlust der Familienbande, Unmöglichkeit, vor Gericht zu erscheinen, Änderung des Verwaltungsstatus und / oder Verlust der rechtlichen Autonomie (Vormundschaft) usw.",
			name: "Schweregrad: groß"
		},
		PIA_EX_IMPN: {
			description: "Die Betroffenen werden nicht gar nicht beeinträchtigt oder haben einige temporäre Unannehmlichkeiten, die sie ohne Schwierigkeiten überwinden können.<br> Beispiele für Auswirkungen:<br> - Körperlich: flüchtige Kopfschmerzen<br>- materiell: Zeitverschwendung, durch Wiederholung von Formalitäten oder durch Warten auf deren Durchführung, Empfang von Spam-Mails, Verwendung öffentlich zugänglicher Daten für gezielte Werbung etc.,<br>- psychisch: einfaches Ärgernis, Gefühl des Eindringens ins Privatleben ohne wirklichen Schaden (Werbung) usw.",
			name: "Schweregrad: geringfügig"
		},
		PIA_EX_NHUM: {
			description: "Dies kann ein Vorfall oder eine Katastrophe in einer der für die Verarbeitung verantwortlichen Organisationen sein (Stromausfall, Feuer, Überschwemmung, technische Fehler usw.)",
			name: "Nichtmenschliche Risikoquellen"
		},
		PIA_EX_VRAI: {
			description: "Für die ausgewählten Risikoquellen scheint es möglich, einen Schaden für den Betroffenen zu verursachen (z.B. Diebstahl von Papierdokumenten, die in den Büros einer Organisation gespeichert sind, deren Zugang von einer Person an der Rezeption kontrolliert wird).",
			name: "Eintrittswahrscheinlichkeit: substantiell"
		},
		PIA_EX_VRAL: {
			description: "Für die ausgewählten Risikoquellen scheint es schwer möglich, einen Schaden für den Betroffenen zu verursachen (z.B. Diebstahl von Papierdokumenten aus einem Raum, dessen Zutritt mit Kartenleser geschützt ist).",
			name: "Eintrittswahrscheinlichkeit: überschaubar"
		},
		PIA_EX_VRAM: {
			description: "Für die ausgewählten Risikoquellen scheint es sehr einfach, einen Schaden für den Betroffenen zu verursachen (z.B. Diebstahl von Papierdokumenten in der öffentlichen Lobby aufbewahrt werden).",
			name: "Eintrittswahrscheinlichkeit: groß"
		},
		PIA_EX_VRAN: {
			description: " Für die ausgewählten Risikoquellen scheint es nicht möglich, einen Schaden der Betroffenen zu verursachen (z.B. Diebstahl von Papierdokumenten aus einem Raum, dessen Zutritt mit Kartenleser und Zugangscode geschützt ist).",
			name: "Eintrittswahrscheinlichkeit: geringfügig"
		},
		PIA_LGL_CONS: {
			description: "Es geht darum, eine freie, spezifische und informierte Wahl zu ermöglichen. Stellen Sie fest, ob die Verarbeitung auf einer anderen Rechtsgrundlage als der Zustimmung gemäß <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 6 der [DS-GVO]</a> erfolgt.",
			name: "Erfassung der Einwilligung des Nutzers eines Dienstes",
			source: "WIKI Recueil_du_consentement"
		},
		PIA_LGL_DATA: {
			description: "Definieren und beschreiben Sie die verarbeiteten Daten und Prozesse im Detail:<br>-die betroffenen personenbezogenen Daten, ihre Empfänger und ihre Aufbewahrungsdauer<br>-eine Beschreibung der Prozesse und Betriebsmittel, die die Verarbeitung personenbezogener Daten über den gesamten Lebenszyklus (von der Erfassung bis zur Löschung) unterstützen.",
			name: "Daten und Prozesse",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Geben Sie einen kurzen Überblick über die geplante Verarbeitung, ihre Art, ihren Umfang, ihren Kontext, ihre Zwecke und ihre Beteiligten. Identifizieren Sie den Verantwortlichen und alle Auftragsverarbeiter. Listen Sie die für die Verarbeitung geltenden Standards und Normen auf, die erforderlich sind oder eingehaltenwerden müssen, nicht zuletzt die genehmigten Verhaltensregeln (<a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">vgl. Art. 40 der [DS-GVO]</a>) und Zertifizierungen zum Datenschutz (<a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">vgl. Art. 42 [DS-GVO]</a>)",
			name: "Beschreibung der Verarbeitung",
			source: "PIA1 p6"
		},
		PIA_LGL_DEST: {
			description: "Eine natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle, der personenbezogene Daten offengelegt werden, unabhängig davon, ob es sich bei ihr um einen Dritten handelt oder nicht. Behörden, die im Rahmen eines bestimmten Untersuchungsauftrags nach dem Unionsrecht oder dem Recht der Mitgliedstaaten möglicherweise personenbezogene Daten erhalten, gelten jedoch nicht als Empfänger; die Verarbeitung dieser Daten durch die genannten Behörden erfolgt im Einklang mit den geltenden Datenschutzvorschriften gemäß den Zwecken der Verarbeitung.<br>Siehe <a target=\"_blank\"href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 4.9 der DS-GVO]</a>",
			name: "Empfänger",
			source: "DS-GVO Art 4.9"
		},
		PIA_LGL_DUR: {
			description: "Für jede Art von Daten muss eine Speicherdauer definiert und durch die gesetzlichen Anforderungen und / oder Verarbeitungsanforderungen gerechtfertigt sein. Dabei wird zwischen aktuellen Daten und archivierten Daten unterschieden. Der Zugriff auf letztere muss auf einen engen Kreis von zuständigen Akteure beschränkt werden. Ein Löschmechanismus muss implementiert werden, um aktuelle Daten zu archivieren oder archivierte Daten am Ende der Speicherdauer zu löschen. Funktionelle Spuren müssen ebenso bereinigt werden wie technische Protokolle, die nicht unbegrenzt gespeichert werden dürfen.",
			name: "Speicherdauer",
			source: "PIAF Connected Objects p10"
		},
		PIA_LGL_FIN: {
			description: "Personenbezogene Daten müssen für festgelegte, eindeutige und legitime Zwecke erhoben werden und dürfen nicht in einer mit diesen Zwecken nicht zu vereinbarenden Weise weiterverarbeitet werden; eine Weiterverarbeitung für im öffentlichen Interesse liegende Archivzwecke, für wissenschaftliche oder historische Forschungszwecke oder für statistische Zwecke gilt gemäß Artikel 89 Absatz 1 nicht als unvereinbar mit den ursprünglichen Zwecken (\"Zweckbindung\").</strong><br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 5.1 b) der [DS-GVO]</a>",
			name: "Zweckbindung",
			source: "DS-GVO Art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "Die Verarbeitung ist nur rechtmäßig, wenn mindestens eine der nachstehenden Bedingungen erfüllt ist:<br>Die betroffene Person hat ihre Einwilligung zu der Verarbeitung der sie betreffenden personenbezogenen Daten für einen oder mehrere bestimmte Zwecke gegeben;<br>die Verarbeitung ist für die Erfüllung eines Vertrags, dessen Vertragspartei die betroffene Person ist, oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, die auf Anfrage der betroffenen Person erfolgen;<br>die Verarbeitung ist zur Erfüllung einer rechtlichen Verpflichtung erforderlich, der der Verantwortliche unterliegt;<br>die Verarbeitung ist erforderlich, um lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen Person zu schützen;<br>die Verarbeitung ist für die Wahrnehmung einer Aufgabe erforderlich, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde;<br>die Verarbeitung ist zur Wahrung der berechtigten Interessen des Verantwortlichen oder eines Dritten erforderlich, sofern nicht die Interessen oder Grundrechte und Grundfreiheiten der betroffenen Person, die den Schutz personenbezogener Daten erfordern, überwiegen, insbesondere dann, wenn es sich bei der betroffenen Person um ein Kind handelt.<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 6 der [DS-GVO]</a>",
			name: "Rechtmäßigkeit der Verarbeitung",
			source: "PIA2 p4/WIKI Fondement_:_licéité_du_traitement,_interdiction_du_détournement_de_finalité"
		},
		PIA_LGL_INFO: {
			description: "Stellen Sie sicher, dass die Betroffenen informiert werden. Stellen Sie sicher, dass die Verarbeitung nicht durch eine Ausnahme abgedeckt ist und nicht besonderen Bedingungen unterliegt.",
			name: "Information der Betroffenen",
			source: "WIKI Information_des_personnes_concernées_(traitement_loyal_et_transparent)"
		},
		PIA_LGL_MINI: {
			description: "Ziel ist es, die Schwere der Risiken zu verringern, indem die Erhebung personenbezogener Daten auf das für den Zweck der Verarbeitung erforderliche Mindestmaß beschränkt wird; vermeiden Sie die Sammlung unnötiger Daten bzw. die Verwendung von Daten, die nichts mit dem Zweck der Verarbeitung zu tun haben, und übermäßige Auswirkungen auf den Betroffenen hätten.",
			name: "Datenminimierung",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_LGL_ST: {
			description: "Mit jedem Auftragsverarbeiter muss ein Auftragsverarbeitungsvertrag unterzeichnet werden, der alle in Art. 28 der DS-GVO genannte Aspekte darlegt: Dauer, Umfang, Zweck, dokumentierte Verarbeitungsanweisungen, vorherige Genehmigung, wenn ein Subunternehmer beschäftigt wird, Bereitstellung von Dokumentationen zum Nachweis der Einhaltung der DS-GVO, unverzügliche Benachrichtigung über Datenschutzverletzungen usw..",
			name: "Auftragsverarbeitung",
			source: "PIA2 p10/WIKI Sous-traitance_:_identifiée_et_contractualisée"
		},
		PIA_LGL_SUPT: {
			description: "Betriebsmittel, die die Verarbeitung personenbezogener Daten unterstützen. Hierbei kann es sich um Hardware, Software, Netzwerke, Personen, Papiermedien oder um die Übermittlung von Papier handeln.",
			name: "Unterstützung der Verarbeitung",
			source: "PIA1 p12"
		},
		PIA_LGL_TRAN: {
			description: "Geben Sie die Länder an, in denen Daten verarbeitet werden. Je nach Land müssen Sie die Datenübermittlung rechtfertigen und die rechtlichen Rahmenbedingungen und Überwachungsmaßnahmen angeben, die für einen angemessenen Schutz der Daten, die Gegenstand einer grenzüberschreitenden Übertragung sind. zu erreichen. Zu unterscheiden sind:<br>- Europäische Union<br>- Staat, der ein durch EU anerkanntes angemessene Schutzniveau hat<br>- Transfer in die Vereinigten Staaten zu einem Unternehmen, das dem Privacy Shield beigetreten ist<br>- Andere Länder<br>Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 44 bis 49 der [DS-GVO]</a>",
			name: "Datenübermittlung in Drittländer",
			source: "WIKI Transferts_:_respect_des_obligations_en_mati%C3%A8re_de_transfert_de_donn%C3%A9es_en_dehors_de_l%E2%80%99Union_europ%C3%A9enne et PIAF Objets connectés p17"
		},
		PIA_METHOD_MES: {
			description: "Geplante Maßnahmen sind die ursprünglich eingeführten Maßnahmen vor einer Analyse durch den Prüfer. Die vom Gutachter empfohlenen Korrekturmaßnahmen werden im Aktionsplan aufgeführt und ermöglichen eine zweite Bewertung der Schwere und Wahrscheinlichkeit des Risikos.",
			name: "Geplante und korrigierende Maßnahmen",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Vorhandensein von Maßnahmen, um einen globalen und aktuellen Überblick über den Stand des Datenschutzes und die Einhaltung der DS-GVO zu erhalten (Überprüfung der Einhaltung von Verarbeitungen, Zielen und Indikatoren, Verantwortlichkeiten usw.).",
			name: "Überwachung der Datenschutzmaßnahmen",
			placeholder: "Geben Sie hier an, wie die Wirksamkeit und Angemessenheit der Datenschutzmaßnahmen überwacht werden.",
			source: "WIKI Supervision"
		},
		PIA_ORG_EXT: {
			description: "Vorliegen von Regelungen und Maßnahmen zur Verringerung der Risiken, die der legitime Zugang zu Daten durch Dritte für die Freiheiten und die Privatsphäre der betroffenen Personen darstellen kann (Festlegung der Dritten, Auftragsverarbeitungsvertrag, Verpflichtungen, BCR usw.) .",
			name: "Sicherheitsmaßnahmen und -regelungen für Dritte",
			placeholder: "Geben Sie hier die Sicherheitsmaßnahmen und -regelungen an, denen Dritte in Bezug auf Ihren Zugang unterliegen.",
			source: "WIKI Relations_avec_les_tiers"
		},
		PIA_ORG_ORG: {
			description: "Vorhandensein einer Organisationseinheit, die in der Lage ist, den Schutz personenbezogener Daten innerhalb der Organisation zu steuern und zu kontrollieren (Benennung eines DSB, Einrichtung eines Teams für das Datenschutzmanagement usw.). ",
			name: "Datenschutzorganisation",
			placeholder: "Geben Sie an, wie die Rollen und Verantwortlichkeiten für den Datenschutz in Ihrer Organisation definiert sind.",
			source: "WIKI Organisation"
		},
		PIA_ORG_PBD: {
			description: "Vorhandene Verfahren zur Beschreibung der Methoden zur Berücksichtigung des Schutzes personenbezogener Daten bei jeder neuen Verarbeitung (Zertifizierungen, Normen, Risikomanagement für die betreffende Person nach der CNIL-Methode oder eine interne Methode usw.).",
			name: "Integration des Schutzes der Privatsphäre in Projekte",
			placeholder: "Beschreiben Sie hier die Methoden, um den Schutz personenbezogener Daten ab Beginn eines neuen Projekts zu berücksichtigen.",
			source: "WIKI Gestion_des_projets"
		},
		PIA_ORG_PERS: {
			description: "Vorhandene Regelungen zur Schulung und <strong>Sensibilisierung</strong> von (neuen) Mitarbeitern bei Antritt ihrer (neuen) Funktion sowie für Personen, die Zugriff auf personenbezogene Daten hatten beim Ausscheiden aus der Organisation</strong>.",
			name: "Sensibilisierungsmaßnahmen",
			placeholder: "Geben Sie hier an, welche Sensibilisierungsmaßnahmen in Bezug auf die Mitarbeiter durchgeführt werden.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Der für die Verarbeitung Verantwortliche muss über eine Dokumentation verfügen, in der die Zielegruppen und Regeln für die Umsetzung des \"Datenschutzes\" festgelegt sind (Aktionsplan, regelmäßige Überarbeitung der Datenschutzrichtlinien usw.).",
			name: "Datenschutzrichtlinien",
			placeholder: "Beschreiben Sie hier die Dokumentation, die Datenschutzziele und -regeln festlegt.",
			source: "WIKI Politique_(gestion_des_règles)"
		},
		PIA_ORG_RMGT: {
			description: "Vorhandene Regelung und Verfahren zum Management der Risiken, die die Verarbeitungen der Organisation für die Rechte und Freiheiten der betroffenen Personen darstellen (Identifizierung der Verarbeitungsverfahren, der verarbeitenden Daten, Betriebsmittel, Risikobewertung, Ermittlung bestehender oder geplanter Maßnahmen usw.).",
			name: "Management von Datenschutzrisiken",
			placeholder: "Beschreiben Sie hier die Prozesse zum Umgang mit den Risiken, die die von der Organisation durchgeführten Verarbeitungsvorgänge für den Datenschutz und die Privatsphäre der betroffenen Personen mit sich bringen.",
			source: "WIKI Gestion_des_risques"
		},
		PIA_ORG_VIOL: {
			description: "Existenz einer operativen Einheit zur Aufdeckung und Behandlung von Ereignissen, die die Freiheiten und die Privatsphäre der betroffenen Personen beeinträchtigen können (Definition von Verantwortlichkeiten, Reaktionsplan, Charakterisierung von Verstößen, etc.).",
			name: " Umgang mit Datenschutzverletzungen",
			placeholder: "Beschreiben Sie hier die operativen Prozesse, die dazu dienen, Datenschutzverletzungen zu erkennen und mit ihnen umzugehen.",
			source: "WIKI Gestion_des_incidents_et_des_violations_de_données"
		},
		PIA_SEC_BKP: {
			description: "Vorhandensein einer Backup-Richtlinie, um die Verfügbarkeit und / oder Integrität von personenbezogenen Daten zu gewährleisten und gleichzeitig deren Vertraulichkeit zu schützen (Regelmäßigkeit der Backups, Verschlüsselung des Datenübertragung, Integritätstest usw.).",
			name: "Datensicherungen",
			placeholder: "Geben Sie hier an, wie Datensicherungen (Backups) verwaltet werden. Stellen Sie sicher, dass sie an einem sicheren Ort aufbewahrt werden.",
			source: "WIKI Sauvegardes"
		},
		PIA_SEC_COMP: {
			description: "Maßnahmen, die ergriffen wurden, um zu verhindern, dass die Eigenschaften der Software (Betriebssysteme, Geschäftsanwendungen, Bürosoftware, Einstellungen usw.) dazu genutzt werden, personenbezogene Daten zu kompromittieren (Aktualisierungen, physischer Schutz und Zugriff, Arbeiten in einem gesicherten Netzwerkbereich, Integritätstest, Protokollierung usw.).",
			name: "Arbeitsplatzverwaltung",
			placeholder: "Beschreiben Sie hier die Maßnahmen, die getroffen wurden, um das Risiko von Angriffen auf die Software auf den Arbeitsplätzen zu verringern",
			source: "WIKI Gestion_des_postes_de_travail"
		},
		PIA_SEC_CTR: {
			description: "Personenbezogene Daten, die an Auftragsverarbeiter übermittelt oder von diesen verwaltet werden, müssen ausreichende Garantien aufweisen. Hierzu sind vertragliche Regelungen erforderlich <strong>Verwenden Sie nur Auftragsverarbeiter mit ausreichender Zuverlässigketi</strong> (insbesondere in Bezug auf Fachwissen, Zuverlässigkeit und resourcen). Fordern Sie die Sicherheitsrichtlinie für das Informationssystem des Anbieters ein.<br>Ergreifen und dokumentieren Sie die Maßnahmen (Sicherheitsaudits, Besuche von Einrichtungen usw.), um <strong>die Wirksamkeit der Garantien zu gewährleisten, die der Auftragsverarbeiter</strong> im Hinblick auf den Datenschutz bietet. Diese Garantien umfassen:<br>- die Verschlüsselung von Daten entsprechend ihrer Sensibilität oder, falls dies nicht der Fall ist, die Existenz von Verfahren, die gewährleisten, dass das Dienstleistungsunternehmen keinen Zugang zu den ihm anvertrauten Daten hat,<br>- die Verschlüsselung von Übertragungen von Daten (z.B.: HTTPS-Verbindung, VPN, etc.)<br>- Garantien in Bezug auf Netzwerkschutz, Rückverfolgbarkeit (Protokolle, Audits), Autorisierungsverwaltung, Authentifizierung, usw. <strong>Bereitstellung eines Vertrags mit dem Auftragsverarbeiter </strong>, der den Zweck, die Dauer, den Zweck der Verarbeitung und die Verpflichtungen der Parteien definiert. Stellen Sie sicher, dass er insbesondere Bestimmungen enthält, die Folgendes enthalten:<br>- ihre Verpflichtung zur Vertraulichkeit personenbezogener Daten, die ihr anvertraut sind<br>- Mindestanforderungen an die Benutzerauthentifizierung<br>- die Bedingungen für die Rückgabe und / oder Vernichtung / Löschung von Daten am Ende des Vertrags<br>- die Regeln der Handhabung und die Benachrichtigung bei Datenschutzvorfällen. Diese sollten im Falle einer Sicherheitsverletzung oder eines Sicherheitsvorfalls Informationen des für die Verarbeitung Verantwortlichen enthalten, und dies im Falle einer Verletzung des Schutzes personenbezogener Daten so schnell wie möglich.<br>- Bei Einsatz eines Cloud-Anbieters:<br>\t1. Benennen Sie eindeutig die Daten und die Verarbeitung, die in die Cloud ausgelagert werden;<br>\t2. Definition eigener technischer und rechtlicher Sicherheitsanforderungen;<br>\t3. Führen Sie eine Risikostudie durch, um geeignete Sicherheitsmaßnahmen zu ermitteln;<br>\t4. Identifizieren des relevante Art der Cloud für die beabsichtigte Verarbeitung;<br>\t5. Wählen Sie einen Anbieter mit ausreichenden Garantien;<br>\t6. Überprüfen Sie die interne Sicherheitsrichtlinie;<br>\t7. Überwachen Sie Änderungen während der Laufzeit.",
			name: "Auftragsverarbeitungsvertrag",
			placeholder: "Beschreiben Sie hier die vertraglichen Regelungen für den Schutz personenbezogener Daten, die einem Auftragsverarbeiter anvertraut sind.",
			source: "Guide Bleu 2017 p19 et https://www.cnil.fr/fr/cloud-computing-les-conseils-de-la-cnil-pour-les-entreprises-qui-utilisent-ces-nouveaux-services"
		},
		PIA_SEC_EXP: {
			description: "Richtlinien zur Begrenzung der Eintrittswahrscheinlichkeit hinsichtlich von Risiken bezüglich der Betriebsmittel (Dokumentation der Betriebsverfahren, Inventarisierung und Aktualisierung von Software und Hardware, Behebung von Sicherheitslücken, Duplizierung von Daten, Beschränkung des physischen Zugriffs auf Materialien usw.).",
			name: "Betriebssicherheit",
			placeholder: "Beschreiben Sie hier, wie Softwareaktualisierungen (Betriebssysteme, Anwendungen usw.) und Patches zur Sicherheitskorrektur durchgeführt werden.",
			source: "WIKI Sécurité_de_l'exploitation"
		},
		PIA_SEC_LOG: {
			description: "Vorhandensein von Maßnahmen zur Überwachung der Netzwerkaktivitäten (in drahtlosen wie drahtgebundenen Netzen) in Echtzeit, um Vorfälle in Bezug auf personenbezogene Daten frühzeitig zu erkennen und verwertbare Informationen zu deren Untersuchung oder zur Bereitstellung von Nachweisen zu liefern.",
			name: "Überwachen der Netzwerkaktivität",
			placeholder: "Geben Sie hier die Maßnahmen an, die zur Erkennung von Vorfällen mit personenbezogenen Daten im Netzwerk eingesetzt werden",
			source: "WIKI Surveillance"
		},
		PIA_SEC_MAIN: {
			description: "Richtlinien, die beschreiben, wie die physische Wartung undSicherheit von Hardware durchgeführt wird, unter Angabe der möglichen Verwendung von Unterauftragsverarbeitern.<br>Geben Sie an, ob eine Fernwartung und unter welchen Vorkehrungen diese vorgesehen ist. Geben Sie an, wie mit fehlerhaften Geräten umgegangen wird. ",
			name: "Hardware-/ Gerätewartung",
			placeholder: "Beschreiben Sie hier, wie die physische Wartung von Hardware und Geräten organisiert ist.",
			source: "PIAF Connected Objects p25"
		},
		PIA_SEC_MAL: {
			description: "Maßnahmen zum Schutz des Zugangs zu öffentlichen (Internet-) oder unkontrollierten (Partner-) Netzwerken sowie Arbeitsplatzrechnern und Servern gegen bösartigen Code, der die Sicherheit der personenbezogenen Daten beeinträchtigen könnte.",
			name: "Bekämpfung von Malware",
			placeholder: "Beschreiben Sie hier die implementierten Maßnahmen, um Risiken beim Zugriff auf weniger sichere Netzwerke zu reduzieren.",
			source: "WIKI Lutte_contre_les_logiciels_malveillants"
		},
		PIA_SEC_MAT: {
			description: " Maßnahmen, die ergriffen wurden, um die Möglichkeit zu verringern, dass die eingesetzten Systeme (Server, Workstations, Laptops, Peripheriegeräte, Kommunikationsgeräte, Wechselmedien usw.) zur Beschädigung personenbezogener Daten verwendet werden (Inventarisierung, Trennung, physische Redundanz, Zugangsbeschränkungen usw.).",
			name: "Hardware-Sicherheit",
			placeholder: "Geben Sie hier die Sicherheitsmaßnahmen für die verwendeten Hardware-Komponenten an.",
			source: "WIKI Sécurité_des_matériels"
		},
		PIA_SEC_NET: {
			description: "Je nach Art des Netzwerks, auf dem die Verarbeitung ausgeführt wird (isoliert, privat oder Internet), muss der Verantwortliche angemessene Schutzsysteme installieren: Firewalls, Intrusion Detection Systeme oder andere aktive oder passive Geräte, die für die Sicherstellung der Netzwerksicherheit verwendet werden.",
			name: "Netzwerksicherheit",
			placeholder: "Geben Sie hier die Sicherheitsmaßnahmen des Netzwerks an, in dem die Verarbeitung ausgeführt wird.",
			source: "PIAF Objets connectés p25"
		},
		PIA_SEC_PHY: {
			description: "Vorhandensein einer physischen Zugangskontrolle zu den Räumlichkeiten, in denen die Verarbeitung durchgeführt wird (Zonierung, Begleitung der Besucher, Tragen von Abzeichen, verschlossene Türen usw.) - Geben Sie an, ob bei einem Einbruch Alarm ausgelöst werden kann.",
			name: "Zugangskontrolle",
			placeholder: "Geben Sie hier an, wie die Zugangskontrolle zu den Räumlichkeiten durchgeführt wird, in denen die Verarbeitung stattfindet.",
			source: "PIAF Connected Objects p25"
		},
		PIA_SEC_PROT: {
			description: "Vorhandensein von Maßnahmen zur Verringerung oder Vermeidung von Risiken in Verbindung mit nichtmenschlichen Quellen (Klimaphänomene, Feuer, Wasserschäden, interne oder externe Unfälle, Tiere usw.), die die Sicherheit personenbezogener Daten beeinträchtigen könnten (Präventivmaßnahmen, Erkennung, Schutz usw.).",
			name: "Schutz vor nichtmenschlichen Risikoquellen",
			placeholder: "Beschreiben Sie hier die ergriffenen Maßnahmen, um Risiken aus nichtmenschlichen Quellen zu reduzieren oder zu vermeiden.",
			source: "WIKI Protection_contre_les_sources_de_risques_non_humaines"
		},
		PIA_SEC_SRC: {
			description: "Vorhandensein von Maßnahmen zur Vermeidung von menschlichen oder nichtmenschlichen Risikoquellen für den Schutz personenbezogener Daten (gefährliche Produkte, gefährliche geografische Gebiete, Datenübermittlung außerhalb der EU usw.).",
			name: "Vermeidung von Risikoquellen",
			placeholder: "Beschreiben Sie die Maßnahmen, die zur Vermeidung möglicher Risikoquellen eingerichtet wurden.",
			source: "WIKI Éloignement_des_sources_de_risques"
		},
		PIA_SEC_WEB: {
			description: "Maßnahmen, um zu verhindern, dass die Eigenschaften von Websites zur Verletzung personenbezogener Daten missbraucht werden (allgemeine Sicherheitsrichtlinien, TLS-Verschlüsselung von Übermittlungen, Cookie-Richtlinien, Sicherheits-Audits usw.).",
			name: "Schutz des Internetauftritts",
			placeholder: "Beschreiben Sie hier die Maßnahmen, die zum Schutz des Internetauftritts implementiert wurden.",
			source: "WIKI Sécurité_des_sites_web"
		},
		PIA_TEC_ANO: {
			description: "Beschreibung der Mechanismen der Anonymisierung, wie sie ausgestaltet sind und zu welchem Zweck sie umgesetzt werden und wie sie eine mögliche Reidentifikation verhindern. Beachten Sie den Unterschied zwischen Anonymisierung und Pseudonymisierung ",
			name: "Anonymisierung",
			placeholder: "Geben Sie hier die implementierten Anonymisierungsmechanismen an",
			source: "keine"
		},
		PIA_TEC_ARCH: {
			description: "Beschreiben Sie die Aufbewahrungsrichtlinien sowie die Prozesse zur Verwaltung von Archiven, die personenbezogene Daten enthalten (Anlieferung von Daten, Speicherung, Zugriffsrechte, Aussonderung). Beschreiben Sie die Rollen und rechtlichen Grundlagen und Sicherheitsmaßnahmen der Archivierung. Falls erforderlich, beschreiben Sie die Regelungen zur Abgabe an staatliche Archive.",
			name: "Archivierung",
			placeholder: "Geben Sie hier an, welche Mechanismen zur Archivierung und Integritätsprüfung von gespeicherten Daten implementiert sind und welchem Zweck sie dienen?",
			source: "WIKI Archivage"
		},
		PIA_TEC_CHIF: {
			description: "Maßnahmen, die für die <strong>Gewährleistung der Vertraulichkeit</strong> der gespeicherten Daten (in der Datenbank, in unstrukturierten Dateien, Backups usw.) sowie das Verfahren zur Verwaltung der verwendeten kryptographischen Schlüssel (Erstellung, Speicherung, Änderung bei Verdacht auf Datengefährdung, Zugriffschutz usw.) implementiert sind.<br>Beschreiben Sie die für die Datenübermittlung verwendeten Verschlüsselungsverfahren (VPN, TLS usw.).",
			name: "Verschlüsselung",
			placeholder: "Beschreiben Sie hier die Maßnahmen, die zur Gewährleistung der Vertraulichkeit der Daten implementiert wurden",
			source: "keine"
		},
		PIA_TEC_CLO: {
			description: "Die Implementierung einer Datentrennung trägt dazu bei, die Möglichkeit zu verringern, dass personenbezogene Daten verknüpft werden können und reduzieren so das Risiko eines unbefugten Zuriffs auf sämtliche gespeicherten personenbezogenen Daten.",
			name: "Datentrennung",
			placeholder: "Geben Sie hier an, ob eine Datentrennung geplant ist und wie diese durchgeführt wird.",
			source: "PIAF Connected Objects p23"
		},
		PIA_TEC_CTLA: {
			description: "Beschreiben Sie die Definition und Zuweisung von Benutzerprofilen, Rollen und Rechten. Zudem ist es erforderlich, die verwendeten <strong>Authentifizierungsmethoden</strong> detailliert zu spezifizieren und gegebenenfalls die für Kennwörter geltenden Regeln anzugeben (Mindestlänge, obligatorische Struktur, Gültigkeitsdauer, Anzahl der erfolglosen Versuche bevor das Konto gesperrt wird, etc.).",
			name: "Logische Zugriffskontrolle",
			placeholder: "Geben Sie hier an, wie Benutzerprofile definiert und zugeordnet werden.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Maßnahmen zur Sicherstellung der Revisioinsfähigkeit von Verarbeitungsvorgängen, insbesondere Protokollierungs- und Auswertungsrichtlinien.",
			name: "Rückverfolgbarkeit (Protokollierung)",
			placeholder: "Geben Sie hier an, ob Ereignisse protokolliert werden und wie lange diese Aufzeichnungen gespeichert werden.",
			source: "keine"
		},
		PIA_TEC_MINI: {
			description: "Der Umfang der Daten und damit die Sensibilität kann u.a. mit den folgenden Methoden reduziert werden: Filterung und Entfernung, Verringerung der Sensibilität durch Transformationen, Reduzierung des identifizierenden Merkmale der Daten, Aggregation von Daten, Beschränkung des Zugangs zu Daten.",
			name: "Datenminimierung",
			placeholder: "Geben Sie hier an, welche Maßnahmen Sie implementiert haben, um den Schweregrad der Risiken durch Datenminimierung personenbezogener Daten zu reduzieren.",
			source: "PIAF Connected Objects p41"
		},
		PIA_TEC_PAP: {
			description: "Soweit Papierdokumente verarbeitet werden, sollte es entsprechende Richtlinien geben. Sie sollten beschreiben, wie Dokumente gedruckt, gelagert, vernichtet und übermittelt werden.",
			name: "Papierdokumentensicherheit",
			placeholder: "Geben Sie hier an, welche Mechanismen zur Aufbewahrung von Papierunterlagen und zur Integritätsprüfung implementiert sind und welchem Zweck sie dienen?",
			source: "PIAF Connected Objects p21"
		},
		PIA_VAL_ACT: {
			description: "Der Aktionsplan ist die Auflistung der in den vorherigen Schritten vom Prüfer vorgeschlagenen Maßnahmen, resourcen und Zuständigkeiten, die zur Umsetzung der festgelegten Korrekturmaßnahmen erfolgen müssen. Für jede Aufgabe ist es notwendig, einen Verantwortlichen zu benennen und Fristen zu setzen.",
			name: "Aktionsplan",
			source: "keine"
		},
		PIA_VAL_CART: {
			description: "Diese Grafik zeigt die durch die Verarbeitung entstehenden Risiken und die Restrisiken unter Berücksichtigung aller Korrekturmaßnahmen. Sie zeigt, dass bei einer angemessenen Umsetzung der im Aktionsplan beschriebenen ergänzenden Maßnahmen die Wahrscheinlichkeit und / oder der Schweregrad der Restrisiken verringert werden kann.",
			name: "Risikokartierung",
			source: "keine"
		},
		PIA_VAL_CONC: {
			description: "Der Verantwortliche holt gegebenenfalls den Standpunkt der betroffenen Personen oder ihrer Vertreter über die beabsichtigte Verarbeitung, unbeschadet des Schutzes der gewerblichen oder öffentlichen Interessen oder der Sicherheit der Verarbeitungsvorgänge ein. Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 35 Abs. 9 der [DS-GVO]</a><br>Diese Stellungnahme kann auf verschiedene Weise erhoben werden, je nach Kontext (interne oder externe Studie über den Zweck und die Mittel der Verarbeitung, die Frage an die Mitarbeitervertretung, die Untersuchung der künftigen Kunden des Verantwortlichen).<br><strong>Entscheidet sich der Verantwortliche</strong> gegen die Meinung der betroffenen Personen, so muss er <strong>die Begründung seiner Entscheidung dokumentieren.</strong><br>Ist der Verantwortliche der Auffassung, dass die<br>die Einholung der Stellungnahme der betroffenen Personen nicht erforderlich ist, so muss er auch hier <strong>die Begründung dokumentieren.</strong>",
			name: "Stellungnahme der Betroffenen",
			source: "DS-GVO Art. 35.9 and PIAF Connected Objects p39"
		},
		PIA_VAL_DPO: {
			description: "Der Verantwortliche hat bei der Durchführung einer Datenschutz-Folgenabschätzung den Rat des Datenschutzbeauftragten einzuholen. Siehe <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE\">Art. 35 Abs 2. der [DS-GVO]</a><br> <strong>Seine Stellungnahme kann sich gegen die Durchführung der Verarbeitung aussprechen, ohne den Entscheidungsspielraum des Verantwortlichen zu beschränken</strong>.",
			name: "Stellungnahme des DSB",
			source: "DS-GVO Art. 35.2 and PIAF Connected Objects p36"
		},
		PIA_VAL_RT: {
			description: "<strong>Der Verantwortliche entscheidet förmlich</strong>, ob die ausgewählten Maßnahmen, die Restrisiken und der festgelegte Aktionsplan im Hinblick auf die zuvor festgestellten Probleme und den Standpunkt der betroffenen Personen akzeptabel sind. Die DSFA kann sein:<br>- bestätigt;<br>- zu verbessern (erklären Sie in welcher Weise)<br>- abgelehnt (somit auch die geplante Verarbeitung).<br>Bei Bedarf sollten die vorherigen Schritte noch einmal überprüft und ergänzt werden, damit die DSFA bestätigt werden kann.<br>Diese Entscheidung berührt in keiner Weise die Bewertung, die gegebenenfalls von der Datenschutzbehörde, z. B. im Rahmen einer Vorabkontrolle vorgenommen werden kann.",
			name: "Bestätigung der DSFA",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Wissensbasis"
};
var measures$k = {
	add: "Erstellen Sie eine Maßnahme (oder fügen Sie eine aus der Wissensbasis auf der rechten Seite hinzu)",
	default_placeholder: "Beschreiben Sie die bestehenden oder beabsichtigten Maßnahmen zur Gewährleistung der Datensicherheit.",
	edit: "Maßnahme bearbeiten",
	placeholder_title: "Maßnahmentitel",
	remove: "Maßnahme löschen"
};
var misc$k = {
	display: "Anzeigen / Ausblenden"
};
var modals$k = {
	abandon_pia: {
		additional_text: "Die Archivierung ist nicht endgültig. Sie können die Analyse später bei Bedarf fortsetzen.",
		content: "Sind Sie sicher, dass Sie diese Verarbeitung aufgeben wollen?"
	},
	action_plan_no_evaluation: {
		content: "Sie müssen mit der Überprüfung der Analyse beginnen, um den Aktionsplan zu erstellen.",
		review_section: "Überprüfen Sie einen Abschnitt"
	},
	archive: "Archivieren",
	archive_pia: {
		archive: "DSFA archivieren",
		content: "<span class='strong'>Warning,</span><br>Sind Sie sicher, dass Sie<br>diese DSFA archivieren möchten?"
	},
	ask_for_evaluation: {
		content: "Der Unterabschnitt steht jetzt zur Überprüfung bereit."
	},
	back_to_edition: {
		content: "Dieser Abschnitt wurde zur Bearbeitung zurückgeschickt.<br>Einige Felder müssen korrigiert werden,<br>damit sie ordnungsgemäß überprüft werden können."
	},
	back_to_evaluation: {
		content: "Dieser Abschnitt wurde zur Überprüfung zurückgeschickt.<br>Einige Felder müssen überprüft werden,<br>um ihre ordnungsgemäße Validierung zu ermöglichen."
	},
	back_to_home: "Zurück zur Startseite",
	cancel: "Abbrechen",
	close: "Schließen",
	completed_edition: {
		content: "Die DSFA wurde vollständig bearbeitet, sie muss überprüft werden."
	},
	completed_evaluation: {
		content: "Die DSFA wurde vollständig überprüft, sie muss bestätigt werden."
	},
	"continue": "Fortsetzen",
	declare_measures: {
		content: "Entschuldigung,<br>bevor Sie Risiken bewerten,<br>müssen Sie die bestehenden oder geplanten Maßnahmen melden.",
		declare: "Benennen Sie bestehende oder geplante Maßnahmen"
	},
	dpo_missing_evaluations: {
		comment: "Kommentieren",
		content: "Sie müssen die Überprüfung der Analyse abschließen, um auf die DSB-Seite zugreifen zu können.",
		remove: "Entfernen",
		review_section: "Überprüfen Sie einen Abschnitt"
	},
	general_error: {
		content: "Entschuldigung, es ist ein Fehler aufgetreten."
	},
	import_wrong_pia_file: {
		content: "Die importierte Datei entspricht nicht dem Dateityp einer DSFA."
	},
	import_wrong_structure_file: {
		content: "Die importierte Datei entspricht nicht dem Dateityp einer Vorlage."
	},
	knowledge: {
		content: "Sind Sie sicher, dass Sie diesen Eintrag löschen wollen?",
		remove: "Eintrag löschen"
	},
	knowledges: {
		content: "Sind Sie sicher, dass Sie diese Wissensdatenbank löschen wollen?",
		remove: "Wissensdatenbank löschen"
	},
	modal_select_text_pia: {
		content: "Der Inhalt der DSFA wurde in die Zwischenablage kopiert."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Warnung, </span><br>Es muss mindestens eine Maßnahme angegeben werden: keine Löschung möglich."
	},
	recover_version: {
		"continue": "Fortsetzen",
		message: "Beim Fortsetzen wird diese Report-Version wiederhergestellt: {{date}}.<br><br>Die aktuelle Version wird gesichert.",
		title: "Vorherige Version wiederherstellen"
	},
	refuse_pia: {
		content: "Nach Ihrer Ablehnung wird vom Analyse-<br>in den Überprüfungsmodus zurückgesetzt,<br>um die notwendigen Änderungen vorzunehmen."
	},
	remove_attachment: {
		comment: "Kommentieren",
		content: "<span class='strong'> Warnung, </span><br>Sind Sie sicher, dass Sie diesen Anhang entfernen möchten?",
		keep: "Behalten",
		remove: "Entfernen"
	},
	remove_measure: {
		content: "<span class='strong'>Warnung, </span><br>Sind Sie sicher, dass Sie diese Maßnahme entfernen möchten?",
		keep: "Behalten Sie<br>diese Maßnahme",
		remove: "Entfernen Sie<br>diese Maßnahme"
	},
	remove_pia: {
		content: "<span class='strong'>Warnung!</span><br>Sind Sie sicher, dass Sie<br>diese DSFA endgültig löschen möchten?",
		remove: "Diese DSFA entfernen"
	},
	remove_question: {
		content: "Möchten Sie die Frage löschen?",
		keep: "Abbrechen",
		remove: "Löschen"
	},
	remove_structure: {
		content: "<span class='strong'>Achtung,</span><br>Sind Sie sicher, dass Sie dieses Modell löschen wollen?",
		remove: "Diese Vorlage löschen"
	},
	same_comment: {
		content: "<span class='strong'>Warnung, </span><br>Bitte geben Sie einen anderen Kommentar als den zuletzt angegebenen ein."
	},
	signed_pia_validation: {
		content: "<span class='strong'>Die DSFA wird akzeptiert</span><br>Schließen Sie die Bestätigung der DSFA ab, indem Sie den unterschriebenen Bericht an die zuständige Person anhängen.",
		download_pia: "Laden Sie die DSFA herunter"
	},
	simple_pia_validation: {
		content: "Die DSFA wurde bestätigt."
	},
	start_evaluation: "Beginnen Sie die Überprüfung",
	unarchive_pia: {
		content: "<span class='strong'>Warnung!</span><br>Sind Sie sicher, dass Sie<br>diese DSFA wiederherstellen möchten?",
		unarchive: "DSFA wiederherstellen"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Die Serveradresse wurde aktualisiert."
	},
	validate_evaluation: {
		content: "Der Unterabschnitt steht jetzt zur Bestätigung der Analyse bereit."
	},
	validate_evaluation_to_correct: {
		content: "Entschuldigung,<br>mehrere Felder müssen korrigiert werden.<br>Zum Bearbeitungsmodus zurückkehren und Korrekturen vornehmen."
	},
	users: {
		"delete": {
			content: "<span class='strong'>Warnung,</span><br>Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
			confirm: "Diesen Benutzer löschen?",
			pia_exist: "Diesem/Dieser Benutzer*in sind eine oder mehrere PIAs zugewiesen. Diesen müssen Sie neue Benutzer*innen zuweisen."
		}
	}
};
var onboarding$k = {
	dashboard: {
		step1: {
			description: "Auf das <strong>+</strong> klicken, um die erste DSFA anzulegen.",
			title: "DSFA anlegen"
		},
		step2: {
			description: "<p>Der/Die <strong>Redakteur*inn</strong> schreiben die erste Version der Analyse.</p><p>Sie sind z.B. die mit der Datenverarbeitung verbundenen Projektleitung.</p>",
			title: "DSFA Rollen"
		},
		step3: {
			description: "<p>Der/Die<strong>Beurteiler*in</strong> sind in einer zweiten Phase involviert.</p><p>Sie nutzen ihr juristisches oder technisches Fachwissen, um die Qualität und Konformität der Verarbeitung zu überprüfen.</p><p>Sie sind zum Beispiel Datenschutzbeauftragte*r oder Jurist*innen.</p>",
			title: "DSFA Rollen"
		},
		step4: {
			description: "<p>Der/Die <strong>Gutachter*in</strong> nimmt die Durchführung der Verarbeitung an oder lehnt sie ab. Er muss die Analyse unterschreiben.</p><p>Er ist der für die Verarbeitung Verantwortliche, z.B. der Geschäftsleitung.</p>",
			title: "DSFA Rollen"
		},
		step5: {
			description: "<p><strong>Vorlagen</strong> sind eine erweiterte Funktion. Sie werden verwendet, um eine vorausgefüllte Basis für die Analyse zu erstellen.</p><p>Sie können Vorlagen erstellen, indem Sie auf den entsprechenden Abschnitt im oberen Menü zugreifen.</p>",
			title: "Vorlagen"
		}
	},
	entry: {
		step1: {
			description: "Um von einem Teil der Analyse zu einem anderen zu gelangen, verwenden Sie das linke Navigationsmenü.",
			title: "Durchsuchen"
		},
		step2: {
			description: "Hier wird der Zweck der Verarbeitung und die Art und Weise ihrer Implementation erläutert.",
			title: "Zusammenhang"
		},
		step3: {
			description: "Diese sollen sicherstellen, dass die Verarbeitung im Einklang mit der DSGVO steht.",
			title: "Grundlegende Prinzipien"
		},
		step4: {
			description: "Hier werden die bereits für die Verarbeitung vorgesehenen Sicherheitsmaßnahmen beschrieben und die möglichen Auswirkungen auf die betroffenen Personen beurteilt.",
			title: "Risiken"
		},
		step5: {
			description: "Hier kann der DSB seine Meinung zur Durchführung der Verarbeitung äußern und der Verantwortliche kann sie akzeptieren oder ablehnen.",
			title: "Prüfung"
		},
		step6: {
			description: "<p>Die Wissensdatenbank bietet kontextbezogene Unterstützung bei der Durchführung der DSFA, basierend auf der DSGVO, dem Sicherheitsleitfaden und den DSFA-Leitfäden der CNIL.</p><p>Zusätzlich zu diesen Inhalten können Sie auch Ihre eigenen Wissensdatenbanken erstellen, um einfach auf Informationen zuzugreifen, die für Ihre Organisation relevant sind.</p>",
			title: "Wissensdatenbank"
		},
		step7: {
			description: "Während der Analyse können Sie diese jederzeit in verschiedenen Formaten herunterladen, um sie mit Ihren Kollegen zu teilen.",
			title: "DSFA exportieren"
		}
	},
	evaluation: {
		step1: {
			description: "Die Bewertung kann einen gesamten Abschnitt oder jedes einzelne Element eines Abschnitts umfassen.",
			title: "DSFA bewerten"
		},
		step2: {
			description: "<p>Diese Bewertung bedeutet, dass Elemente fehlen, um eine abschließende Beurteilung vornehmen zu können.</p><p>Der Bewerter muss diese in dem zugehörigen <strong>Kommentarfeld</strong> der Bewertung angeben. Daraufhin müssen die erforderlichen Korrekturen vorgenommen werden.</p>",
			title: "Zu korrigieren"
		},
		step3: {
			description: "<p>Diese Bewertung gibt an, welche Verarbeitungselemente überarbeitet werden müssen. Sie sind im Feld <strong>Maßnahmenplan/Korrekturmaßnahmen</strong> aufgeführt.</p><p>Diese Maßnahmen werden automatisch in den Maßnahmenplan aufgenommen. Sie sollten so schnell wie möglich umgesetzt werden.</p>",
			title: "Verbesserungswürdig"
		},
		step4: {
			description: "Diese Bewertung bedeutet, dass dieser Teil der Verarbeitung ohne Änderungen übernommen werden kann.",
			title: "Akzeptabel"
		},
		step5: {
			description: "Wenn die Bewertung eines Abschnitts noch nicht begonnen hat, kann die Bewertungsanfrage zurückgenommen werden, um Änderungen an der Bearbeitungsbeschreibung vorzunehmen.",
			title: "Bewertungsanfrage zurücknehmen"
		}
	},
	general: {
		done: "Bestätigen",
		next: "Nächste",
		skip: "Überspringen"
	},
	validated: {
		step1: {
			description: "Eine vollständige und validierte Analyse kann jederzeit über eine spezielle Schnittstelle abgerufen werden.",
			title: "Konsultieren Sie eine validierte DSFA."
		},
		step2: {
			description: "Es ist notwendig, eine Analyse regelmäßig zu überprüfen. Sie können sie jederzeit bearbeiten oder duplizieren, um ihren Inhalt entsprechend der Entwicklung der Verarbeitung zu überprüfen.",
			title: "Aktualisieren Sie eine validierte DSFA."
		}
	}
};
var opinions$k = {
	content: ", ist folgender Ansicht:",
	dpo_lock: "Bitte füllen Sie die anderen Abschnitte aus, bevor Sie die Stellungnahme des DSB ausfüllen können.",
	dpo_opinion: "Stellungnahme des DSB",
	edit: "Bearbeiten",
	people_opinion: "Stellungnahme der Betroffenen",
	placeholder_concerned_people_name: "Namen der Betroffenen",
	placeholder_dpo_name: "Name des DSB",
	placeholder_dpo_opinion: "Geben Sie die Gründe für Ihre Entscheidung an.",
	placeholder_people_opinion: "Beschreiben Sie, wie die Stellungnahme eingeholt wurde und was das Ergebnis der Analyse ist. Falls keine Stellungnahme eingeholt wurden, geben Sie die Gründe an.",
	placeholder_search_content: "Begründen Sie, warum die Stellungnahme der Betroffenen nicht eingeholt wurde",
	treatment_lock: "Bitte füllen Sie die anderen Abschnitte aus, bevor Sie die Stellungnahme der betroffenen Personen ausfüllen können.",
	treatment_nok: "Die Verarbeitung sollte nicht verwendet werden.",
	treatment_ok: "Die Verarbeitung kann umgesetzt werden."
};
var pia$k = {
	attachments: {
		add: "Hinzufügen",
		download: "Anlage herunterladen",
		loading: "Anlage wird hochgeladen",
		remove: "Löschen",
		title: "Anlagen",
		no_attachment: "Kein Anhang verfügbar."
	},
	footer: {
		ask_evaluation: "Bitte um Überprüfung",
		mandatory_fields: "Es müssen alle Felder ausgefüllt sein",
		structure_add_question: "Eine Frage hinzufügen",
		subsection_validated: "Unterabschnitt überprüft, wartet auf endgültige Bestätigung",
		validate_evaluation: "Bitte um Bestätigung"
	},
	header: {
		display_action_plan: "Aktionsplan<br>anzeigen",
		edition: "Bearbeitung",
		evaluation: "Auswertung",
		preview: "Vorschau"
	},
	sections: {
		based_on_structure_name: "Basierend auf der Vorlage:",
		homepage_link: "Zurück zur Übersicht",
		refuse_pia: "DSFA ablehnen",
		status: {
			evaluation: {
				cancel: "die Überprüfungssanfrage zurückziehen.",
				cancel_button: "Die Überprüfungssanfrage zurückziehen",
				content: "Die Überprüfung dieses Teils hat noch nicht begonnen. Wenn Sie den Inhalt im Bearbeitungsmodus bearbeiten möchten, müssen Sie ",
				title: "Warten auf Überprüfung"
			},
			validation: {
				cancel: "die Bestätigungsanfrage zurückziehen.",
				cancel_button: "Die Bestätigungsanfrage zurückziehen",
				content: "Die Bewertung dieses Teils ist abgeschlossen und wartet auf die endgültige Bestätigung der Analyse. Wenn Sie die Bewertungen ändern möchten, müssen Sie",
				title: "Warten auf Bestätigung"
			}
		},
		validate_pia: "DSFA bestätigen"
	},
	statuses: [
		"In Bearbeitung",
		"Abgelehnt",
		"Einfache Bestätigung",
		"Bestätigung per Unterschrift",
		"Archiviert",
		"Warten auf Bestätigung"
	]
};
var questions$k = {
	edit: "Frage bearbeiten",
	gauges: [
		"(Nicht definiert)",
		"Geringfügig",
		"Überschaubar",
		"Substantiell",
		"Groß"
	],
	placeholder_title: "Titel der Frage (erforderlich)",
	remove: "Löschen Sie die Frage"
};
var rejection_page$k = {
	applied_adjustments: "Vorgenommene Änderungen",
	applied_adjustments_placeholder: "Beschreibe die Änderungen, die an der DSFA vorgenommen wurden.",
	button: {
		abandon_treatment: "Aufgabe der Verarbeitung",
		reject_pia: "DSFA ablehnen",
		send_for_validation: "Zurück zur Bestätigung"
	},
	previous_rejection: "Vorherige Ablehnung",
	rejection_reason: "Grund für die Ablehnung",
	rejection_reason_placeholder: "Beschreiben Sie die Gründe für die Ablehung der Bestätigung dieser DSFA.",
	title: "Bestätigungshistorie"
};
var sections$k = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Geben Sie einen kurzen Überblick über die Verarbeitung: Name, Zweck, Einsatzgebiet, Nutzer usw.",
						title: "Welche Verarbeitung ist geplant?"
					},
					"2": {
						placeholder: "Beschreiben Sie die Zuständigkeiten der Beteiligten: Des Verantwortlichen, der möglichen Auftragsverarbeiter und der gemeinsam Verantwortlichen.",
						title: "Welche Zuständigkeiten bestehen für die Verarbeitung?"
					},
					"3": {
						placeholder: "Nennen Sie die relevanten Normen und Standards für die Verarbeitung, insbesondere die anerkannten Richtlinien und Verhaltensregeln (codes of conduct) und die Datenschutzzertifizierung.",
						title: "Gibt es Normen oder Standards für die Verarbeitung?"
					}
				},
				short_help: "Dieser Teil ermöglicht es Ihnen, den Gegenstand Untersuchung zu identifizieren und zu beschreiben",
				title: "Überblick"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Listen Sie die gesammelten und verarbeiteten Daten auf. Definieren Sie je Datenkategorie die Speicherdauer, die Empfänger und die zugriffsberechtigten Personen.",
						title: "Welche Daten werden verarbeitetet?"
					},
					"2": {
						placeholder: "Präsentieren und beschreiben Sie die Funktionsweise und den Ablauf der Datenverarbeitung (von der Datensammlung bis zur Datenlöschung, sowie die verschiedenen Verarbeitungsschritte, Speicherung, etc.) zum Beispiel mit Hilfe eines Diagramm der Datenflüsse (fügen Sie es als Anhang hinzu) und einer detaillierten Beschreibung der Prozesse.",
						title: "Wie verläuft der Lebenszyklus von Daten und Prozessen?"
					},
					"3": {
						placeholder: "Listen Sie die entsprechenden IT-Systeme und andere Betriebsmittel auf (Betriebssysteme, Server, Fachanwendungen, Datenbankverwaltungssysteme, Office-Suites, Netze, Protokolle, Konfigurationen usw.).",
						title: "Mit Hilfe welcher Betriebsmittel erfolgt die Datenverarbeitung?"
					}
				},
				short_help: "In diesem Teil können Sie den Umfang der Verarbeitung detailliert definieren und beschreiben.",
				title: "Daten, Prozesse und Unterstützung"
			}
		},
		short_help: "Dieser Abschnitt gibt Ihnen einen Überblick über die Verarbeitung(en) der betreffenden personenbezogenen Daten.",
		title: "Kontext"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Erklären Sie, warum die Verarbeitungszwecke bestimmt, eindeutig und legitim sind.",
						short_title: "Zwecke",
						title: "Sind die Verarbeitungszwecke eindeutig definiert und rechtmäßig?"
					},
					"2": {
						placeholder: "Beschreiben Sie die rechtlichen Grundlage(n) Ihrer Verarbeitung (z. B. Einwilligung, Vertragserfüllung, rechtliche Verpflichtung, lebenswichtige Interessen usw.).",
						short_title: "Rechtsgrundlage",
						title: "Aufgrund welcher Rechtsgrundlage erfolgt die Verarbeitung?"
					},
					"3": {
						placeholder: "Erläutern Sie, warum alle Daten für Ihre Verarbeitung benötigt werden.",
						short_title: "Erforderlichkeit der Daten",
						title: "Sind die erhobenen Daten erforderlich, relevant und auf das für die Datenverarbeitung Notwendige beschränkt?"
					},
					"4": {
						placeholder: "Beschreiben Sie, welche Schritte unternommen wurden, um die Qualität der Daten sicherzustellen.",
						short_title: "Korrektheit der Daten",
						title: "Sind die Daten korrekt und auf dem neuesten Stand?"
					},
					"5": {
						placeholder: "Erklären Sie, warum die Speicherdauer durch gesetzliche Anforderungen, andere Regelungen und / oder Verarbeitungsbedürfnisse gerechtfertigt ist.",
						short_title: "Speicherdauer",
						title: "Welche Speicherdauer haben die Daten?"
					}
				},
				short_help: "In diesem Teil können Sie nachweisen, dass Sie ausreichende Maßnahmen zur Umsetzung der Rechte der Betroffenen ergriffen haben.",
				title: "Verhältnismäßigkeit und Notwendigkeit"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Beschreiben Sie, welche Informationen den betroffenen Personen auf welche Art und Weise zur Verfügung gestellt werden.",
						short_title: "Information der Betroffenen",
						title: "Wie werden die betroffenen Personen über die Verarbeitung informiert?"
					},
					"2": {
						placeholder: "Beschreiben Sie die Maßnahmen, die sicherstellen sollen, dass die Einwilligung der Betroffenen eingeholt wurde.",
						short_title: "Einholung der Einwilligung",
						title: "Wenn anwendbar, wie wird die Einwilligung der betroffenen Personen eingeholt?"
					},
					"3": {
						placeholder: "Beschreiben Sie die Maßnahmen, mit denen betroffene Personen Einsicht in ihre Daten nehmen sowie diese erhalten und übermitteln können.",
						short_title: "Recht auf Auskunft und Datenübertragbarkeit",
						title: "Wie können Betroffene ihre Recht auf Auskunft und Datenübertragbarkeit ausüben?"
					},
					"4": {
						placeholder: "Beschreiben Sie die Regelungen, mit denen betroffene Personen ihre Daten berichtigen und löschen können.",
						short_title: "Recht auf Berichtigung und Löschung",
						title: "Wie können betroffene Personen ihr Recht auf Berichtigung und Löschung (Recht auf Vergessenwerden) ausüben?"
					},
					"5": {
						placeholder: "Beschreiben Sie die Regelungen, mit denen betroffene Personen die Verarbeitung ihrer Daten einschränken und ihr widersprechen können.",
						short_title: "Recht auf Einschränkung und auf Widerspruch",
						title: "Wie können betroffene Personen ihre Rechte auf Einschränkung oder Widerspruch der Verarbeitung ausüben?"
					},
					"6": {
						placeholder: "Beschreiben Sie für jeden Auftragsverarbeiter seine Zuständigkeiten und Aufgaben (Dauer, Umfang, Zweck, dokumentierte Verarbeitungsanweisungen, vorherige Genehmigung) und stellen Sie die Verträge, Verhaltensregeln (codes of conduct) und Zertifizierungen bereit, die seine Aufgaben und Verpflichtungen bestimmen.",
						short_title: " Auftragsverarbeitung",
						title: "Sind die Verpflichtungen der Auftragsverarbeiter klar definiert und vertraglich geregelt?"
					},
					"7": {
						placeholder: "Listen Sie jedes Land außerhalb der Europäischen Union, in dem Daten gespeichert oder verarbeitet werden und geben Sie an, ob dieses anerkanntermaßen ein angemessenes Datenschutzniveau bietet oder beschreiben Sie die (Vertrags-)Bedingungen, die den Transfer regeln.",
						short_title: "Übermittlung in Drittländer",
						title: "Soweit Datenübermittlungen in Länder außerhalb der Europäischen Union stattfinden, werden die Daten angemessen geschützt?"
					}
				},
				short_help: " In diesem Teil können Sie nachweisen, dass Sie ausreichende Maßnahmen zur Umsetzung der Rechte der Betroffenen ergriffen haben.",
				title: "Maßnahmen zum Schutz der Persönlichkeitsrechte der betroffenen Personen"
			}
		},
		short_help: "In diesem Abschnitt können Sie die Maßnahmen zur Sicherstellung der Konformität mit den Grundprinzipien des Datenschutz darlegen.",
		title: "Grundlegende Prinzipien"
	},
	"3": {
		items: {
			"1": {
				short_help: "In diesem Abschnitt können Sie Maßnahmen (vorhanden oder geplant) identifizieren, die zur Datensicherheit beitragen.",
				title: "Geplante oder bestehende Maßnahmen"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Geben Sie die möglichen Auswirkungen ein",
						title: "Was könnten die wesentlichen Auswirkungen für die betroffenen Personen sein, wenn das Risiko eintritt?"
					},
					"2": {
						placeholder: "Geben Sie die Bedrohungen ein",
						title: "Was sind die Hauptbedrohungen, die zu dem Risiko führen könnten?"
					},
					"3": {
						placeholder: "Geben Sie die Risikoquellen ein",
						title: "Was sind die Risikoquellen?"
					},
					"4": {
						placeholder: "Klicken Sie hier, um Maßnahmen auszuwählen, die das Risiko adressieren.",
						title: "Welche der identifizierten Maßnahmen tragen zur Bewältigung des Risikos bei?"
					},
					"5": {
						placeholder: "Begründen Sie hier den vermuteten Schweregrad des Risikos.",
						title: "Wie schätzen Sie den Risikoschweregrad ein, insbesondere hinsichtlich der möglichen Auswirkungen und geplanten Maßnahmen?"
					},
					"6": {
						placeholder: "Begründen Sie hier die vermutete Eintrittswahrscheinlichkeit.",
						title: "Wie schätzen Sie die Eintrittswahrscheinlichkeit des Risikos ein, insbesondere hinsichtlich der Bedrohungen, Risikoquellen und geplante Maßnahmen?"
					}
				},
				short_help: "Analysieren Sie die Ursachen und Folgen von unrechtmäßigen Zugriffen auf Daten und schätzen Sie deren Schweregrad und Eintrittswahrscheinlichkeit ein.",
				title: "Unrechtmäßiger Zugriff auf Daten"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Geben Sie die potenziellen Auswirkungen ein",
						title: "Was könnten die wesentlichen Auswirkungen für die betroffenen Personen sein, wenn das Risiko eintritt?"
					},
					"2": {
						placeholder: "Geben Sie die Bedrohungen ein",
						title: "Was sind die Hauptbedrohungen, die zu dem Risiko führen könnten?"
					},
					"3": {
						placeholder: "Geben Sie die Risikoquellen ein",
						title: "Was sind die Risikoquellen?"
					},
					"4": {
						placeholder: "Klicken Sie hier, um Maßnahmen auszuwählen, die das Risiko adressieren.",
						title: "Welche der identifizierten Maßnahmen tragen zur Bewältigung des Risikos bei?"
					},
					"5": {
						placeholder: " Begründen Sie hier den vermuteten Schweregrad des Risikos.",
						title: " Wie schätzen Sie den Risikoschweregrad ein, insbesondere hinsichtlich der möglichen Auswirkungen und geplanten Maßnahmen?"
					},
					"6": {
						placeholder: " Begründen Sie hier die vermutete Eintrittswahrscheinlichkeit.",
						title: " Wie schätzen Sie die Eintrittswahrscheinlichkeit des Risikos ein, insbesondere hinsichtlich der Bedrohungen, Risikoquellen und geplante Maßnahmen?"
					}
				},
				short_help: "Analysieren Sie die Ursachen und Folgen einer unerwünschten Veränderung der Daten und schätzen Sie deren Schweregrad und Eintrittswahrscheinlichkeit ein.",
				title: "Unerwünschte Veränderung von Daten"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Geben Sie die möglichen Auswirkungen ein",
						title: "Was könnten die wesentlichen Auswirkungen für die betroffenen Personen sein, wenn das Risiko eintritt?"
					},
					"2": {
						placeholder: "Geben Sie die Bedrohungen ein",
						title: "Was sind die Hauptbedrohungen, die zu dem Risiko führen könnten?"
					},
					"3": {
						placeholder: "Geben Sie die Risikoquellen ein",
						title: "Was sind die Risikoquellen?"
					},
					"4": {
						placeholder: "Klicken Sie hier, um Maßnahmen auszuwählen, die das Risiko adressieren.",
						title: "Welche der identifizierten Maßnahmen tragen zur Bewältigung des Risikos bei?"
					},
					"5": {
						placeholder: " Begründen Sie hier den vermuteten Schweregrad des Risikos.",
						title: " Wie schätzen Sie den Risikoschweregrad ein, insbesondere hinsichtlich der möglichen Auswirkungen und geplanten Maßnahmen?"
					},
					"6": {
						placeholder: " Begründen Sie hier die vermutete Eintrittswahrscheinlichkeit.",
						title: " Wie schätzen Sie die Eintrittswahrscheinlichkeit des Risikos ein, insbesondere hinsichtlich der Bedrohungen, Risikoquellen und geplante Maßnahmen?"
					}
				},
				short_help: "Analysieren Sie die Ursachen und Folgen von Datenverlusten und schätzen Sie deren Schweregrad und Eintrittswahrscheinlichkeit ein.",
				title: "Datenverlust"
			},
			"5": {
				short_help: "Diese Visualisierung ermöglicht Ihnen eine globale und kompakte Übersicht über die Auswirkungen der vorgesehenen Maßnahmen auf die Risiken, die von der Verarbeitung ausgehen.",
				title: "Risikoübersicht"
			}
		},
		short_help: "In diesem Abschnitt können Sie die Datenschutzrisiken unter Berücksichtigung bestehender oder geplanter Maßnahmen bewerten.",
		title: "Risiken"
	},
	"4": {
		items: {
			"1": {
				short_help: "Diese Visualisierung ermöglicht es Ihnen, die Positionierung der Risiken vor und nach der Anwendung der jeweiligen ergänzenden Maßnahmen zu vergleichen.",
				title: "Risikokartierung"
			},
			"2": {
				short_help: "Planen Sie detailliert die Umsetzung der ergänzenden Maßnahmen, die während der DSFA identifiziert wurden. Der Aktionsplan wird automatisch aktualisiert, sobald im Rahmen der Überprüfung der DSFA Ergänzungen vorgenommen werden.",
				title: "Aktionsplan"
			},
			"3": {
				short_help: "Legen Sie den Rat des Datenschutzbeauftragten dar. Dokumentieren Sie den Standpunkt der betroffenen Personen oder ihren Vertreter.",
				title: "Stellungnahmen des Datenschutzbeauftragten und der Betroffenen"
			},
			"4": {
				title: "Bestätigen Sie die DSFA"
			},
			"5": {
				title: "DSFA wird zurückgewiesen"
			}
		},
		short_help: "In diesem Abschnitt können Sie die DSFA-Bestätigung vorbereiten und formalisieren.",
		title: "Bestätigung"
	}
};
var settings$k = {
	content: "Bitte geben Sie die Adresse (URL) des Remote-Servers an:",
	title: "Einstellungen",
	update: "URL aktualisieren"
};
var summary$k = {
	action_plan: {
		fundamental_principles: "Grundlegende Prinzipien",
		implementation_date: "Voraussichtliches Datum der Umsetzung",
		implementation_responsible: "Verantwortlich für die Umsetzung",
		measures: "Bestehende oder geplante Maßnahmen",
		no_action_plan: "Kein Aktionsplan festgelegt.",
		risks: "Risiken",
		title: "Aktionsplan"
	},
	actions: {
		complete_download: "Den vollständigen Bericht herunterladen",
		complete_download_desc: "Exportieren des gesamten Berichtsinhaltes (DOC und Bilder), Anhänge und den Aktionsplan im CSV-Format, in ein ZIP-Archiv.",
		individual_download: "Elemente des Berichts herunterladen",
		individual_download_desc: "Bestimmte Elemente des Berichts exportieren.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "Texte (.doc)",
		individual_download_images: "Visuelle Elemente (.png), einschließlich der Risikoübersicht, der Risikokartierung und des Aktionsplans.",
		individual_download_json: "Herunterladen (.json)",
		individual_download_select: "Zu exportierenden Elemente auswählen:",
		individual_to_download: "Herunterladen",
		print: "Den Bericht drucken",
		print_and_download: "Drucken und herunterladen"
	},
	attachments: "Anlagen",
	concerned_people_name: "Namen der Betroffenen",
	concerned_people_opinion: "Auffassungen der Betroffenen",
	concerned_people_searched_opinion: "Einholung der Meinung der Betroffenen",
	concerned_people_status: "Feststellungen der Betroffenen",
	concerned_people_unsearched_opinion_comment: "Grund, warum die Meinung der Betroffenen nicht erfragt wurde",
	content_choice: [
		"Die Verarbeitung sollte nicht durchgeführt werden.",
		"Die Verarbeitung kann umgesetzt werden."
	],
	creation_date: "Bearbeitungsdatum",
	csv_action_plan_comment: "Aktionsplankommentar",
	csv_evaluation_comment: "Bewertungskommentar",
	csv_file_title: "Aktionsplan",
	csv_implement_date: "Geschätztes Umsetzungsdatum",
	csv_people_in_charge: "Verantwortlicher",
	csv_section: "Abschnitt",
	csv_title_object: "Titel",
	download_csv: "Aktonsplan (.csv)",
	dpo_name: "Name des DSB",
	dpo_opinion: "Gutachten des DSB",
	dpo_status: "Feststellung des DSB",
	gauges: {
		"1": "Geringfügig",
		"2": "Überschaubar",
		"3": "Substantiell",
		"4": "Groß"
	},
	modification_made: "Vorgenommene Änderungen",
	people_search_status_nok: "Meinung der Betroffenen wurde nicht eingeholt.",
	people_search_status_ok: "Meinung der Betroffenen wurde eingeholt.",
	pia_assessor: "Name des Prüfers",
	pia_author: "Name des Bearbeiters",
	pia_name: "DSFA",
	pia_validator: "Name des Bestätigers",
	preview_dpo_opinion: "Stellungnahme des Datenschutzbeauftragten und der Betroffenen",
	preview_edition: "Bearbeitung",
	preview_evaluation: "Auswertung",
	preview_no_data: "Keine anzuzeigenden Daten.",
	preview_status: "Status",
	preview_subtitle: "Allgemeine Informationen",
	preview_title: "Vorschau",
	preview_validation: "Überprüfung",
	preview_validation_section: "Überprüfung",
	preview_guests: "Gäste",
	previous_page: "Zurück zur vorherigen Seite",
	rejection_reason: "Ablehnungsgrund",
	revision: {
		current_version: "Aktuelle Version",
		pia_version: "DSFA Versionen",
		restore_version: "Wiederherstellen",
		revision: "Versionen und Revision",
		save: "Neue Version anlegen",
		show: "Anzeigen der {{length}} Versionen"
	},
	risks_cartography_title: "Risikokartierung",
	risks_overview_title: "Risikokübersicht",
	title: "Information zur DSFA"
};
var users$k = {
	add_new_user: "Neuen Benutzer hinzufügen",
	cancel: "Abbrechen",
	choose_profile: "Profil für den Benutzer auswählen",
	"continue": "Weiter",
	data: "Daten",
	edit_user: "Benutzer ändern",
	email: "E-Mail",
	first_name: "Vorname",
	functional_admin: "Administrator",
	last_name: "Name",
	new_user_button: "Benutzer anlegen",
	profile: "Profil",
	remove: "Löschen",
	remove_current_user_error_message: "Das eigene Benutzerkonto kann nicht gelöscht werden.",
	remove_last_functional_admin_error_message: "Löschen des Benutzers nicht möglich, da mindestens ein Administrator angelegt sein muss.",
	remove_user_with_linked_pias_error_message: "Diverse DSFAs sind diesem Benutzer zugeordnet, löschen nicht möglich.",
	technical_admin: "Technischer Administrator",
	update: "Ändern",
	user: "Benutzer",
	state: "Kontostatus",
	errors: {
		edit_user: {
			"406": "Die bei der Erstellung des Kontos angegebenen Informationen sind ungültig."
		}
	},
	"delete": {
		confirm: "Benutzer entfernen",
		content: "Sind Sie sicher, diesen Benutzer zu löschen?"
	},
	access_locked: {
		"false": "Aktiv.",
		"true": "Warten auf die Aktivierung."
	},
	role: {
		label: "Rolle(n)",
		author: "Autor*innen",
		evaluator: "Beurteiler*in",
		validator: "Prüfer*in",
		guest: "Gast"
	}
};
var validation_page$k = {
	add_signed_pia: "Fügen Sie die unterschriebene DSFA hinzu",
	after_reading: "Nach vollständiger Durchsicht der DSFA bezüglich der Verarbeitung von Daten im Rahmen von:",
	button: {
		rejection: "Bestätigung ablehnen",
		signed_validation: "Unterschriebene Bestätigung",
		simple_validation: "Einfache Bestätigung"
	},
	confirmation1: "Bestätige ich, dass der Kontext der Datenverarbeitung, so wie er in der DSFA beschrieben wurde, der Realität entspricht.",
	confirmation2: "Bestätige ich, dass mir die nach den aktuell umgesetzten oder geplanten Maßnahmen verbleibenden Risiken bewusst sind.",
	confirmation3: "Billige ich die angegebenen Korrekturmaßnahmen.",
	confirmation4: "Verpflichte ich mich, die angegebenen Korrekturmaßnahmen so schnell wie möglich umzusetzen.",
	latest_signed_attachment: "Letzter hinzugefügter Anhang",
	mandatory_fields: "Alle Felder müssen markiert sein",
	remove_attachment: "Anhang löschen",
	responsible: "Verantwortlich für die Bestätigung der DSFA: ",
	signed_attachments_history: "Historie der hinzugefügten Anhänge",
	tools: {
		dashboard: "Übersicht",
		display_pia: "DSFA anzeigen"
	},
	validated_pia_with_signature: "Bestätigt",
	waiting_for_signature: "Warten auf die Unterschrift der DSFA"
};
var de = {
	about: about$k,
	action_plan: action_plan$k,
	authentication: authentication$k,
	cartography: cartography$k,
	comments: comments$k,
	conflict: conflict$k,
	date: date$k,
	errors: errors$k,
	evaluations: evaluations$k,
	header: header$k,
	help: help$k,
	homepage: homepage$k,
	knowledge_base: knowledge_base$k,
	measures: measures$k,
	misc: misc$k,
	modals: modals$k,
	onboarding: onboarding$k,
	opinions: opinions$k,
	"overview-risks": {
	important: "Substantiell",
	limited: "Überschaubar",
	maximal: "Groß",
	measures: "Maßnahmen",
	negligible: "Geringfügig",
	potential_impacts: "Mögliche Auswirkungen",
	"risk-access_x": "Schweregrad",
	"risk-access_y": "Eintrittswahrscheinlichkeit",
	"risk-change_x": "Schweregrad",
	"risk-change_y": "Eintrittswahrscheinlichkeit",
	"risk-disappearance_x": "Schweregrad",
	"risk-disappearance_y": "Eintrittswahrscheinlichkeit",
	sources: "Ursachen",
	threat: "Bedrohung"
},
	pia: pia$k,
	questions: questions$k,
	rejection_page: rejection_page$k,
	sections: sections$k,
	settings: settings$k,
	summary: summary$k,
	users: users$k,
	validation_page: validation_page$k
};

var about$j = {
	contribute: "Hvis du ønsker at bidrage til oversættelsen af værktøjet eller til forbedring af de allerede foreslåede, inviterer vi dig til <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">læs siden, der beskriver de trin, der skal følges</a>.",
	description: "Dette værktøj er oprindeligt designet af <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, den franske databeskyttelsesmyndighed med henblik på at bistå dataansvarlige i efterlevelse af GDPR kravene. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Dette værktøj er gratis og åbent, under GPLv3-licens. Du kan bidrage ved at hente kildekoden, ændre den og omfordele den til fællesskabet.",
	licences: "Bibliotekslicenser:",
	title: "Om PIA værktøjet",
	translators: "Værktøjet er i øjeblikket tilgængeligt på atten sprog. De franske og engelske versioner leveres af CNIL. De andre versioner er resultatet af bidrag fra følgende personer:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Version nummer"
};
var action_plan$j = {
	acceptable_measures: "Godtaget foranstaltninger",
	edit: "redigere",
	improvable_measures: "Foranstaltninger der kan forbedres",
	measures: "Planlagte eller eksisterende foranstaltninger",
	no_action_plan: "Ingen handlingsplan registreret.",
	placeholder_person_in_charge: "Ansvarlige for implementering",
	principles: "Fundamentale principper",
	risk1: "Uautoriseret adgang til personoplysninger",
	risk2: "Uønsket ændringer",
	risk3: "Tab af personoplysninger",
	risks: "Risici",
	title: "Oversigt"
};
var authentication$j = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Denne applikation af det <strong>Franske Datatilsyn (CNIL)</strong>, er stillet tilrådig for at bistå og vejlede dataansvarlige til at opbygge og vedligeholde compliance til persondataforordningen (GDPR). Applikationen hjælper med at udføre konsekvensanalyser ved brug af en analyse methode udviklet af CNIL.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Start",
	start_app: "Start Konsekvensanalysen (Beta)",
	subtitle1: "En platform til at skabe <br> og styre PIA konsekvensanalyser (Privacy Impact Assessment)",
	subtitle2: "Adgang til værktøjer og ordforråd",
	title: "Konsekvensanalyse vedrørende beskyttelse af privatlivet",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$j = {
	important: "Alvorlig",
	legend1: "Planlagte eller eksisterende foranstaltninger",
	legend2: "Med de korrigerende foranstaltninger implementeret",
	legend3: "(U)autoriseret adgang til personoplysninger",
	legend4: "(Æ)ndringer der er uønsket",
	legend5: "(T)ab af personoplysninger",
	likelihood_axe: "Risiko sandsynlighed",
	limited: "Betydelig",
	maximal: "Katastrofal",
	negligible: "Ubetydelig",
	risk1_access: "(U)",
	risk2_modification: "(Æ)",
	seriousness_axe: "Risiko alvorlighed"
};
var comments$j = {
	comment: "Kommentar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "Kommentarer (antal)",
	new_comment: "Kommentarer",
	placeholder_new_comment: "Skriv en kommentar",
	send: "Send"
};
var conflict$j = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$j = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$j = {
	content: "Hvis du støder på andre problemer, eller hvis du har forslag til forbedringer, <br> kan du sende dem tilbage via denne formular: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Siden er ikke fundet."
};
var evaluations$j = {
	acceptable: "Godkendt",
	action_plan_comment: "Handlingsplan / forbedringer",
	evaluation_comment: "Evaluerings kommentar",
	gauges: {
		"0": "(Udefinet)",
		"1": "Ubetydelig",
		"2": "Betydelig",
		"3": "Alvorlig",
		"4": "Katastrofal",
		likelihood: "Under hensyntagen til handlingsplanen, hvordan vurderer du <span class='red-highlight'>sandsynligheden for denne risiko</span>?",
		seriousness: "Under hensyntagen til handlingsplanen, hvordan vurderer du<span class='red-highlight'>alvorligheden af denne risiko</span>?"
	},
	improvable: "Kan forbedres",
	placeholder_acceptable: "Ifølge de foreliggende oplysninger er de gennemførte foranstaltninger tilstrækkelige til at opfylde kravene til databeskyttelse.",
	placeholder_improvable1: "Ifølge de foreliggende oplysninger skal yderligere foranstaltninger gennemføres for at databeskyttelsen i behandlingen er fyldestgørende.",
	placeholder_improvable2: "Skriv dine kommentarer.",
	placeholder_to_correct: "Oplysningerne er ikke fyldstgørende for en evalution. Send tilbage til redaktøren/forfatter af denne PIA, for at forbedre de oprindelige indsendte oplysninger.",
	status: [
		"Afventning",
		"Rette",
		"Forbedre",
		"Godkendt"
	],
	title: "Evaluering",
	to_correct: "At rette"
};
var header$j = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "PIA exempel",
		title: "Hjælp"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Vidensbase",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Oversættelser af CNILs",
		community_translations: "Community oversættelser",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Oversættelser af europæisk DPA",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Original version",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "PIA Konsekvensanalyse",
	structures: "PIA skabelon",
	tools: {
		about: "Om applikationen",
		accessibility: "Øget tilgængelighed (høje kontrast farver, daltonism)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Konfiguration",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$j = {
	definition: {
		data1: {
			content: "Indhold under forberedelse",
			title: "Bruge PIA værktøjet"
		},
		data2: {
			qa1: {
				content: "Når du støder på skærmproblemer, skal du afslutte programmet og genstarte det. Dette hjælper normalt med at rette op på sådanne problemer. Dine data gemmes i realtid, så du vil ikke miste de indtastede oplysninger.",
				title: "Jeg har skærmproblemer,  f.eks. ikoner der ikke opdaterer eller mangler i menuer og brugergrænseflade"
			},
			qa2: {
				content: "Denne fejl er kendt og afhjælpning i gang. Hvis du støder på dette problem, skal du angive niveauet af sværhedsgrad eller sandsynlighed, som du vurderer ud over begrundelsen for dette estimat i feltet Justification.",
				title: "Jeg kan ikke redigere sandsynligheden og konsekvens af risici"
			},
			qa3: {
				content: "Flere fejl blev observeret under importen af en PIA, især forsvinder måling og vurdering af konsekvens og sandsynligheden for en risiko. I dette tilfælde henvises til det foregående spørgsmål. Hvis du ikke kan se din PIA instrumentbrættet i PIA'erne, skal du genopfriske siden.",
				title: "Jeg har problemer med at importere en PIA"
			},
			qa4: {
				content: "Dette er kun en visuel fejl og kompromitterer ikke de oplysninger, der er indtastet i PIA. Dette problem vil blive rettet hurtigt.",
				title: "Når jeg kopierer og indsætter, vises min tekst fremhævet."
			},
			qa5: {
				content: "For at anmode om en del-evaluering skal alle felter udfyldes. Kontrollér, at dette er tilfældet. Ved redigering af en risiko er det obligatorisk at angive mindst en teknisk eller organisatorisk foranstaltning, der omhandler risikoen.",
				title: "Jeg kan ikke bede om en del-evaluering"
			},
			qa6: {
				content: "Luk PIA'en, du redigerer og åbner den igen. Indholdet bliver derefter vist på det valgte sprog.",
				title: "Ved sprogskift oversættes teksterne ikke"
			},
			qa7: {
				content: "PT. opdateres ikonerne i den venstre navigationsmenu ikke efter et valideringsafslag. Du skal besøge hvert afsnit igen, kontrollere oplysningerne og evalueringen i henhold til årsagerne til afslaget og anmode om en validering igen. Når alle sektioner er blevet gennemgået, vil det være muligt at returnere PIA for validering.",
				title: "Jeg afviste godkendelse af en PIA, men ved ikke hvad jeg skal gøre derefter"
			},
			title: "Kendte problemer"
		},
		footer: "Hvis du støder på andre problemer, eller hvis du har forslag til forbedringer, kan du sende dem tilbage via denne formular <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Hjælp"
};
var homepage$j = {
	cards: {
		author: "Editing",
		category: "TO TRANSLATE - Category",
		creation_status: "Kreation",
		date: "Dato",
		evaluation: "Review",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Importere AIIA",
		import_structure: "Importere skabelon",
		item: {
			consult_pia: "Konsultere",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Redigere",
			edit_structure: "Redigere skabelon",
			tools: {
				action_plan: "Vis<br>handlingsplan",
				archive: "TO TRANSLATE - Archive",
				duplicate: "duplikere",
				"export": "Exportere",
				more_options: "Flere optioner",
				pia: "Vis<br>PIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Ny AIIA",
		new_structure: "Ny skabelon",
		or: "or",
		pia_name: "PIA",
		placeholder_author: "Fornavn, efternavn",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Fornavn, efternavn",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Importere AIIA",
		placeholder_import_structure: "Importere skabelon",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Ny AIIA",
		placeholder_new_structure: "Ny skabelon",
		placeholder_pia_name: "PIA's titel",
		placeholder_sector_name: "Navn på sektion",
		placeholder_start: "Alle felter skal fyldes",
		placeholder_structure: "Standard skabelon",
		placeholder_structure_name: "Skabelon titel",
		placeholder_validation: "Fornavn, efternavn",
		sector_name: "Tilhørende sektion",
		start: "Start",
		status: "Status",
		structure: "Skabelon",
		structure_name: "Titel på skabelon",
		title_close_creation: "Luk",
		validation: "Validation"
	},
	filters: {
		assessor: "Analytiker",
		author: "Forfatter",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Begynd !<br><br>For at starte en PIA,<br> klik på Ny AIIA",
		card_rocket_content_structure: "Begynd ! For at starte <br>en skabelon, klik på +",
		category: "TO TRANSLATE - Category",
		date: "Dato",
		import_pia: "Importere AIIA",
		import_structure: "Importere skabelon",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Begynd ! For at starte <br>en PIA, klik på +",
		list_rocket_content_structure: "Begynd ! For at starte <br>en skabelon, klik på +",
		name: "Navn",
		new_pia: "Ny AIIA",
		new_structure: "Ny skabelon",
		sector_name: "Tilhørende sektion",
		sort: "Sortere",
		sort_by: "ved",
		status: "Status",
		validator: "Godkender"
	},
	lists: {
		column_actions: "Aktioner",
		column_author: "Redigere",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Skabt",
		column_evaluation: "Evaluere",
		column_pia: "PIA",
		column_progression: "Progression",
		column_sector_name: "Tilhørende sektion",
		column_status: "Status",
		column_structure: "Skabelon",
		column_structure_name: "Skabelon",
		column_updated_at: "Sidst åben",
		column_validation: "Godkende",
		item: {
			tools: {
				action_plan: "Vis handlingsplan",
				archive: "TO TRANSLATE - Archive",
				consult: "Konsultere",
				duplicate: "Duplikere",
				edit: "Redigere",
				"export": "Exportere",
				pia: "Vis AIIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$j = {
	add_measure: "Tilføj",
	add_measure_hint: "Du kan også tilføje en sikkerhedsforanstaltning fra vidensbasen.",
	category: {
		definition: "Definitioner",
		example: "Eksempel",
		general_measure: "Fysisk sikkerhedsforanstaltning",
		measure_on_data: "Logisk sikkerhedsforanstaltning",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Organisatorisk foranstaltning",
		principle: "Principper"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Alle",
		definitions: "Definitioner",
		general_measures: "Fysisk Sikkerhedsforanstaltning",
		measures_on_data: "Logisk sikkerhedsforanstaltning",
		no_result: "Ingen resultater fundet.",
		organizational_measures: "Organisationelle foranstaltninger",
		title: "Filters"
	},
	placeholder_add_measure: "Tilføj denne sikkerhedsforanstaltning",
	placeholder_help: "Hjælp",
	search: "Søge",
	slugs: {
		PIA_DEF_ACC: {
			description: "Den registrerede har ret til at få den dataansvarliges bekræftelse på, om personoplysninger vedrørende den pågældende behandles, og i givet fald få adgang til personoplysningerne som beskrevet i <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 af [GDPR]</a>",
			name: "Den registreredes indsigtsret",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Proces der fjerner personhenførbar personoplysninger. Personoplysninger, der er gjort anonyme, således at ingen fysiske personer kan identificeres ud fra oplysningerne eller i kombination med andre oplysninger, er ikke længere beskyttet af databeskyttelsesreglerne.",
			name: "Anonymisering",
			source: "Ingen"
		},
		PIA_DEF_ARCH: {
			description: "Lovmæssige krav for bevarelse af elektroniske arkiver der indeholder personoplysninger skal efterleves. Det skal sikres at arkiver også har passende sikkerhedsforanstaltninger implementeret (kryptering, fysisk adgangskontrol, osv.).",
			name: "Arkivering",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Alle brugere med adgangsrettigheder til personoplysninger skal have en unik brugeridentitet. Vælg en autentificerings metode tilpasset konteksten, risiko niveau, mm. Anbefalinger: Hvis risikoniveauet er lavt, kan passwords muligvis bruges, hvorimod følsomme personoplysninger der indbær en høj risiko typisk vil have multi-faktor autentificering såsom; engangskodeord, SMS koder, digitale certificater, biometri eller anden form for stærk autentification.",
			name: "Autentificering",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Foranstaltning der ved hjælp af kryptering, blandt andet tillader fortrolighed i elektroniske kommunikationer, f.eks. digital signatur. En elektronisk underskrift sikrer, at du (underskriveren) er den, du giver dig ud for at være, når du underskriver i forbindelse med elektronisk kommunikation.",
			name: "Kryptering",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Opdeling og segmentering af personoplysninger kan forbedre beskyttelsen ved sikkerhedsbrud. Hvis et delsystem er kompromitteret, kan konsekvenserne på datasættet mindskes.",
			name: "Segmentering af personoplysninger",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Enhver frivillig, specifik, informeret og utvetydig viljestilkendegivelse fra den registrerede, hvorved den registrerede ved erklæring eller klar bekræftelse indvilliger i, at personoplysninger, der vedrører den pågældende, gøres til genstand for behandling.<br>Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.10 af [GDPR]</a>",
			name: "Samtykke",
			source: "GDPR Art. 4.11"
		},
		PIA_DEF_CTLA: {
			description: "Adgang for brugere og supportpersonale til brugersystemers funktioner og informationer skal begrænses i overensstemmelse med organisationens politikker og informationernes klassifikation. Logisk adgangskontrol hindre uautoriseret adgang til eller anvendelse af personoplysninger eller af det udstyr, der anvendes til behandlingen, det kræver blandt andet : <br>- <strong>styring af bruger profiler</strong> ved adskillelse af opgaver og ansvar (central styring er foretrukket) for at kun autoriserede brugere med gyldigt belæg (need-to-know) kan tilgå personoplysninger. Brugere skal kun have adgang til de tjenester, de er autoriseret til at benytte (least-privilege principles);<br>- <strong> adgangsrettigheder afsluttes ved medarbejders ansættelsesophør, udløb af freelance og anden parts kontrakt</strong> samt adgangsrettigheder revurderes når en medarbejder skifter rolle eller ved ved organisatoriske ændringer.",
			name: "Logisk adgangskontrol",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "enhver form for information om en identificeret eller identificerbar fysisk person (»den registrerede«); ved identificerbar fysisk person forstås en fysisk person, der direkte eller indirekte kan identificeres, navnlig ved en identifikator som f.eks. et navn, et identifikationsnummer, lokaliseringsdata, en onlineidentifikator eller et eller flere elementer, der er særlige for denne fysiske persons fysiske, fysiologiske, genetiske, psykiske, økonomiske, kulturelle eller sociale identitet. <br>Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.1 af [GDPR]</a>",
			name: "Personoplysninger",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "en fysisk eller juridisk person, en offentlig myndighed, en institution eller et andet organ, hvortil personoplysninger videregives, uanset om det er en tredjemand eller ej. Offentlige myndigheder, som vil kunne få meddelt personoplysninger som led i en isoleret forespørgsel i henhold til EU-retten eller medlemsstaternes nationale ret, anses dog ikke for modtagere; de offentlige myndigheders behandling af disse oplysninger skal overholde de gældende databeskyttelsesregler afhængigt af formålet med behandlingen. <br>Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.9 af [GDPR]</a>",
			name: "Modtager",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Den registrerede har ret til at få personoplysninger om sig selv slettet af den dataansvarlige uden unødig forsinkelse, som beskrevet i <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 17 af [GDPR]</a>",
			name: "Ret til sletning",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Forventede fordele (for organisationen, for de registrerede, for samfundet generelt, osv.).",
			name: "Udfordringer",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Personoplysninger skal være korrekte og, om nødvendigt, ajourført; så vidt muligt sikres det at urigtige personoplysninger, i forhold til behandlingsformålet, straks slettes eller berigtiges (»rigtighed«). <br>Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 d) af [GDPR]</a>",
			name: "Qualitet af personoplysninger",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Alvorlighed repræsentere størrelsen af en risiko. Det afhænger primært af den skadelige karakter af de potentielle virkninger.",
			name: "Alvorlighed",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Den registrerede har ret til fra den dataansvarlige at opnå begrænsning af behandling, se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 18 af [GDPR]</a>",
			name: "Ret til begrænsning af behandling",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Organisationen overvåger kritiske komponeneter af informationssystemet med henblik på at opdage og spore cyberangreb og mistænksomme hændelser ved indsamling af log og event. Behandling og adgang til personoplysninger skal logges således at i tilfælde af sikkerhedshændelser, en undersøgelse kan påvise hvem der har tilgået hvilke informationer på hvilke tidspunkter. Bemærk at log og events med personhenførbare oplysninger kun må opbevares i en rimelig periode.",
			name: "Logning og sporbarhed",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "En situation hvor en eller flere individuelle aktioner påvirker et informationsaktiv. Brugt frivilligt eller ej af en risiko kilde, og kan udløse en uønsket begivenhed.",
			name: "Trussel",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Trussler for: - <strong>Hardware</strong>, uhensigtsmæssigt brug, observeret, ændret, tabt (transport eller brug af følsomt HW for personligt brug, observere en anden persons skærm, spionage ved brug a HW key logger, osv.)<br> - <strong>Software</strong>, misbrug, observeret, ændret (eskalation af privilegier, indsamling af konfigurations data, malware infektion, osv.)<br>- <strong>Computer kanaler</strong> observeret (aflytning eller genspilning af Ethernet-trafik, osv.)<br>- <strong>Mennesker</strong>, observeret, manipuleret, tabt (ufrivillig deling af informationer, social engineering, rolle ændring)<br>- <strong>Papir dokumenter</strong> observeret eller tabt (fotokopier, tyveri, tyveri af breve, osv.)<br>- <strong>Papir transmissions kanaler</strong> observeret (læsning af underskriftsmapper, osv.)",
			name: "Trusseler der kan lede til uautoriseret adgang",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Trussler for: </strong><br>- <strong>Hardware</strong> : brugt uhensigtsmæssigt, overbelastet, ændret, beskadiget, tabt (lagringsenhed fuld, overbelastning af computer, tilføjelse af inkompatibel hardware, der resulterer i funktionsfejl, brand, tyveri eller tab af et informationsaktiv osv.)<br>- <strong>Software</strong> : brugt uhensigtsmæssigt, overbelastet, ændret, beskadiget, tabt (sletning af data, overskridelse af databasestørrelse, logisk bombe, ugyldig software licensen, osv.)<br>- <strong>Computer kanaler</strong> : overbelastning, ændring, tab (uautoriseret overførsel, mangel på Internet opkobling, osv.)<br>- <strong>Mennesker</strong> : overbelastning, ændret, tab (mangel på kompetencer, sygdom, pensionering, osv.)<br>- <strong>Papir dokumenter</strong> : brugt uhensigtsmæssigt, beskadiget, tabt (sletning, aldring af arkiverede dokumenter, tyveri eller tab af dokumenter osv.)<br>- <strong>Papir transmissions kanaler</strong> : overbelastet, beskadiget, ændret, tabt (postlevering stoppet af strejke, omplacering af kontorer eller lokaler, omorganisering af papirtransmissionskanaler, osv.)",
			name: "Trusler, der kan føre til utilgængelighed af personoplysninger",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Trussler for: </strong><br>- <strong>Hardware</strong> ændringer (tilføjelse af inkompatibel hardware der resulterer i funktionsfejl, fjernelse af væsentlige komponenter, osv.)<br>- <strong>Software</strong> uhensigtsmæssigt brug eller ændret (Uønskede ændringer af informationer i databaser, operatørfejl der ændrer informationer, osv.)<br>- <strong>Computer kanaler</strong> misbrug (aflytning eller genspilning af Ethernet-trafik, osv.)<br>- <strong>Mennesker</strong> overbelastet eller manipuleret (tildeling af opgaver der overstiger arbejdsevner, stress eller negative ændringer i arbejdsvilkårene, indflydelse, osv.)<br>- Forfalskede papir dokumenter (ændringer af informationer, udveksling med falske dokumenter, osv.)<br>- <strong>Papir transmissions kanaler</strong> uønsket ændringer (skift fra en signaturmappe til en anden, afsendelse af flere modstridende dokumenter, osv.)",
			name: "Trusseler der kan lede til uønsket ændring af personoplysninger",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Skal vælges blandt de til rådige foranstaltninger i sektionen \"Planlagte eller eksiterende foranstaltninger\", der kan udbygges hvis nødvendigt.",
			name: "Foranstaltninger",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "Når informationer modtages kan forskellige typer metadata (såsom EXIF data i vedlagt billed) ufrivilligt blive indsamlet. <br>Sådanne informationer skal identifiseres og bortskaffes hvis de er irrelevante for behandlingen.",
			name: "Filtering og bortskaffelse",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Når følsomme personoplysninger modtages, enten som et standard datasæt eller for statistisk brug, kan disse eventuelt konverteres til et lavere følsomhedsniveau eller pseudonymiseret. For eksemple : <br>- Hvis systemet indsamler en IP addresse for at kende en geografisk placering med henblik på geostatistik, kan IP addressen slettes når by eller region er afklaret<br>- Hvis et system modtager videooptagelser for overvågningskamerarer, og personer kan genkendes, så kan disse sløres<br>- Hvis systemet er et smartmeter, kan energi informationer aggregeres over tid, uden realtidsoptagelser",
			name: "Formindske følsomhed ved konversion",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Systemet sikre at: <br>- brugeren kan bruge en resource eller tjeneste uden risiko for at afgive sin identitet (anonymitet)<br>- brugeren kan bruge en resource eller tjeneste, men forbliver identificeret og ansvarlig for denne brug (pseudonym data)<br>- brugeren kan bruge en resource eller tjeneste, forbliver identificeret men uden at personoplysningerne bliver korreleret (pseudonym data)<br>- brugeren kan bruge en resource eller tjeneste uden risiko for, at andre, især tredjeparter, er i stand til at observere, at resourcen eller tjenesten bliver brugt (ikke-observerbarhed)<br>Valget af en metode fra listen ovenfor afhænger af de identificerede trusler. For nogle typer af trusler for privatlivet, vil pseudonymisering være mere passende end anonymisering (for eksempel hvis der er behov for sporbarhed). Derudover vil nogle trusler for beskyttelse af privatlivet blive behandlet af en kombination af flere metoder.",
			name: "Reduktion af personoplysningernes henførbarhed",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Systemet kan struktureres i uafhængige dele med separate adgangskontrolfunktioner. Personoplysninger kan også fordeles mellem disse uafhængige delsystemer og hvor hvert delsystem har forskellige adgangskontrolmekanismer. Hvis et delsystem er kompromitteret, kan konsekvenserne på datasættet reduceres.",
			name: "Formindske akkumulering af personoplysninger",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Systemet kan begrænse adgangen til data i henhold til need-to-know princippet. Systemet kan adskille følsomme personoplysninger og anvende specifikke adgangskontrolpolitikker. Systemet kan også kryptere følsomme personoplysninger for at beskytte deres fortrolighed under transmission og opbevaring. Adgang til midlertidige skjulte filer, der produceres under databehandling, bør også beskyttes.",
			name: "Begræning af adgang til personoplysninger",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Minimering af indsamling mindsker risiko niveauet for registerede ved kun at indsamle nødvendige personoplysninger til et specifikt behandlingsformål, ellers skal oplysningerne ikke indsamles.",
			name: "Minimering ved indsamling af personoplysninger",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Risiko niveauet for registerede formindskes ved minimering af personoplysninger. Personoplynsingernes følsomhed kan mindskes, irellevante personoplysninger slettes, personoplysninger kan pseudonymiseres, osv.",
			name: "Minimering af personoplysninger",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Den registrerede har til enhver tid ret til af grunde, der vedrører den pågældendes særlige situation, at gøre indsigelse mod behandling af sine personoplysninger, jf. <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 21 af [GDPR]</a>",
			name: "Ret til indsigelse",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Foranstaltninger, der træffes for at inkorporere beskyttelsen af personoplysninger i alle nye behandlingsoperationer (retningslinjer, metoder til risikostyring).",
			name: "Projekt styring",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Person, den registrerede, der ejer personoplysningerne indeholdt i behandlingen.",
			name: "Data subject",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " Den registrerede har ret til i et struktureret, almindeligt forståeligt og maskinlæsbart format at modtage personoplysninger om sig selv, som vedkommende har givet til en dataansvarlig, og har ret til at transmittere disse oplysninger til en anden dataansvarlig uden hindring fra den dataansvarlige, som personoplysningerne er blevet givet til, se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 20 of [GDPR]</a>",
			name: "Ret til dataportabilitet",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Pseudonymisering er i databeskyttelsesforordningen defineret som behandling af personoplysninger på en sådan måde, at personoplysningerne ikke længere kan henføres til en bestemt registreret uden brug af supplerende oplysninger, forudsat at sådanne supplerende oplysninger opbevares separat og er underlagt tekniske og organisatoriske foranstaltninger for at sikre, at personoplysningerne ikke henføres til en identificeret eller identificerbar fysisk person.<br>Pseudonymisering reducerer linkbarheden af et datasæt med den registrerede persons oprindelige identitet; som sådan er det en nyttig sikkerhedsforanstaltning, men ikke en metode til anonymisering.",
			name: "Pseudonymisering",
			source: "GDPR Art. 4.5"
		},
		PIA_DEF_PWD: {
			description: "Det anbefales at definere krav til adgangskoder (Passwords) afhængig af følsomheden af informationer der skal beskyttes. Således kan en Password politik sætte regler og krav til organisationens brug af passwords : længde, brug af specialkaraktere, forbud med brug af personoplysninger, levetid, genbrug af samme passwords, maximum login fejl, sikker reset procedure, osv.",
			name: "Password",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Den registrerede har ret til at få urigtige personoplysninger om sig selv berigtiget af den dataansvarlige uden unødig forsinkelse. Den registrerede har under hensyntagen til formålene med behandlingen ret til få fuldstændiggjort ufuldstændige personoplysninger, bl.a. ved at fremlægge en supplerende erklæring.",
			name: "Ret til berigtigelse",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "FORORDNING om beskyttelse af fysiske personer i forbindelse med behandling af personoplysninger og om fri udveksling af sådanne oplysninger og om ophævelse af direktiv 95/46/EF (generel forordning om databeskyttelse).",
			name: "GDPR (General Data Protection Regulation)",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "En fysisk eller juridisk person, en offentlig myndighed, en institution eller et andet organ, der alene eller sammen med andre afgør, til hvilke formål og med hvilke hjælpemidler der må foretages behandling af personoplysninger; hvis formålene og hjælpemidlerne til en sådan behandling er fastlagt i EU-retten eller medlemsstaternes nationale ret, kan den dataansvarlige eller de specifikke kriterier for udpegelse af denne fastsættes i EU-retten eller medlemsstaternes nationale ret.<br>Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.7 af [GDPR]</a>",
			name: "Dataansvarlig",
			source: "GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Person eller ikke-menneskelige kilde der præsentere en risiko. En sådan kilde kan agere frivilligt eller ufrivilligt.",
			name: "risikokilde",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "En fysisk eller juridisk person, en offentlig myndighed, en institution eller et andet organ, der behandler personoplysninger på den dataansvarliges vegne, se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 af [GDPR]</a>.<br>Databehandleren og enhver, der udfører arbejde for den dataansvarlige eller databehandleren, og som har adgang til personoplysninger, behandler kun disse oplysninger efter instruks fra den dataansvarlige, medmindre det kræves i henhold til EU-retten eller medlemsstaternes nationale ret, se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 29 af [GDPR]</a>.",
			name: "Processor",
			source: "GDPR Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "strong>Enheder til lagring af data</strong> : Computere, router, USB nøgler, hard diske...<br><strong>Software</strong> : operativ systemer, e-mail, databaser, fagsystemer...<br><strong>Kommunikations kanaler</strong> : Kabler, WiFi, optiske fibre<br><br><strong>Personer</strong> : brugere, system administratorer, ledere...<br><strong>Papier dokumenter</strong> : print, fotokopier, håndskrevet dokumenter...<br><strong>Papir transmission</strong> : fysiske breve, fax, underskriftsmapper...",
			name: "Understøttende informationsaktiver",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Brud på sikkerheden, der fører til utilsigtet eller ulovlig destruktion, tab, ændring, uautoriseret offentliggørelse af eller adgang til personoplysninger, der overføres, opbevares eller på anden måde behandles.",
			name: "Sikkerhedsbrud",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Sandsynlighed udtrykker muligheden for at en risiko udløses. Det afhænger først og fremmest af de sårbarheder, der er forbundet med de understøttende aktiver, når de er truet, og risikokildenes kapacitet til at udnytte disse trusler.",
			name: "Sandsynlighed",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Data for et scoringssystem, applikationens scorings resultat....",
			name: "Udregnet data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Identifikations oplynsinger</strong> : Civilstand, alder, nationalitet, dobbelt statsborgerskab, postadresse, osv. <br><strong>Privatliv</strong> : civilstand, antal børn, bopæl, boligtype, boligsituation, osv. <br><strong>Karriere oplysninger </strong> : ansættelse, kontrakttype, arbejdsgiver navn, anciennitet i beskæftigelse, ledighed, osv. <br><strong>Kommunikations oplysninger</strong> : IP addresse, event logs, osv.<br><strong>Geografiske oplysninger</strong> : rejser, GPS data, GSM data, osv.<br><strong>Andet</strong> : Telefon, email addresse, osv.",
			name: "Normale personoplysninger",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Race eller etnisk oprindelse, politisk, religiøs eller filosofisk overbevisning, fagforeningsmæssigt tilhørsforhold, helbredsoplysninger, seksuelle forhold, seksuelle orientering, se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 og 10 af [GDPR]</a>.",
			name: "Følsomme personoplysninger og straffedomme, lovovertrædelser"
		},
		PIA_EX_DCPS: {
			description: ", biometriske oplysninger, finansielle (bank) oplysninger",
			name: "Særlige kategorier af personoplysninger"
		},
		PIA_EX_HUME: {
			description: "Det kan være enten:<br>- en ondsindet eller uvidende tredjepart, der bruger sin fysiske nærhed til bedragerisk adgang til tjenesten;<br>- en angriber målrettet mod en bruger ved hjælp af dennes kendskab til brugeren og oplysninger om ham/hende;<br>- en angriber målrettet mod en af de virksomheder, der har ansvaret for behandlingen, ved at bruge dennes viden om de virksomheder, der kunne tillade at angribe deres ry;<br>- en autoriseret tredjepartsorganisation, der bruger sin privilegerede adgang til uautoriseret adgang til oplysninger. Der findes adskellige motivationer: gambling, gener, ondskabsfuldhed, hævn, spionage, grådighed, erhvervelse af data for at udnytte dem.",
			name: "Extern menneskelig trussels kilde"
		},
		PIA_EX_HUMI: {
			description: "Det kan være enten:<br>- en ondsindet eller uvidende tredjepart, der bruger sin fysiske nærhed til uautoriseret adgang til tjenesten;<br>- en angriber målrettet mod en kollega ved hjælp af dennes kendskab til medarbejderen;<br>- en angriber målrettet mod en kunde/bruger af organisationen;<br>- en autoriseret tredjepartsorganisation, der bruger sin privilegerede adgang til ulovlig adgang til oplysninger. Der findes adskellige motivationer: gener, ondskabsfuldhed, hævn, spionage, grådighed, erhvervelse af data for at udnytte dem.",
			name: "Intern menneskelig trussels kilde"
		},
		PIA_EX_IMPI: {
			description: "Konsekvenserne for de berørte personer er betydelige, som de burde kunne overvinde, men med reelle og betydelige vanskeligheder, for eksempel: <br>- Fysisk: alvorlig fysisk tilstand, der forårsager langvarig skade (forværring af helbredstilstand på grund af dårlig håndtering eller manglende overholdelse af kontraindikationer), alvorlig svækkelse af kroppen osv.<br>- materialistisk : ukompenseret økonomisk misbrug, målrettede muligheder - unikke og ikke-tilbagevendende, tab (pant, studier, praktikophold eller beskæftigelse, eksamensforbud), tab af bolig, jobtab osv.;<br>- moralsk : alvorlig psykologisk lidelse (depression, fobi), følelser af invasion af privatlivets fred og uoprettelig skade, offer for afpressning, cyberbulning og mobbing osv.",
			name: "Alvorlig konsekvens"
		},
		PIA_EX_IMPL: {
			description: "De berørte personer kan opleve betydelige ulemper, som de kan overvinde på trods af nogle vanskeligheder, for eksempel:<br>- Fysisk: mangel på fysisk velvære (f.eks. mild sygdom på grund af manglende overholdelse af kontraindikationer), ærekrænkelse, der resulterer i fysisk gengældelse (hævn) osv.;<br>- materialistisk : uplanlagte betalinger (f.eks. fejlagtige bøder), nægtelse af adgang til administrative eller kommercielle tjenester, målrettet onlineannoncering på et privatlivsspørgsmål, som personen ønskede at holde fortrolige osv.;<br>- moralsk : mindre men objektiv psykologisk udfordring, følelse af invasion af privatlivets fred uden uoprettelig skade, intimidering på sociale netværk osv.",
			name: "Betydelig konsekvens"
		},
		PIA_EX_IMPM: {
			description: "De berørte personer kan have betydelige eller endog uoprettelige konsekvenser, som de måske ikke overvinder, for eksempel:<br>- Fysisk : langvarig eller permanent kritisk tilstand, permanent kritisk helbred, død;<br>- materialistisk : finansiel risiko, stor gæld, manglende arbejdsevne, manglende bolig, tab af retssager, tab af adgang til vitale resourcer (vand, elektricitet).<br>- moralsk : Kristisk psykologisk tilstand, strafferetlig sanktion, kidnapning, tab af familierelationer, manglende evne til at vidne i retten, sat under værgemål, osv.",
			name: "katastrofal konsekvens"
		},
		PIA_EX_IMPN: {
			description: "De berørte personer vil ikke blive påvirket eller måske opleve nogle få ulemper, som de vil overvinde uden vanskeligheder, for eksemple:<br>- Fysisk: forbigående hovedpine;<br>- materiel : tidsspild pga. gentagne forsøg eller systemventetid, uønsket e-mails, (f.eks.: spams), osv.;<br>- moralsk : følelse af invasion af privatlivets fred uden reel skade (misbrug af personoplysninger til marketing, osv.)",
			name: "Ubetydelig konsekvens"
		},
		PIA_EX_NHUM: {
			description: "Det kan være en hændelse eller katastrofe i en af de organisationer, der har ansvaret for behandlingen (strømafbrydelse, brand, oversvømmelse, osv.)",
			name: "ikke-menneskelige trussels kilder"
		},
		PIA_EX_VRAI: {
			description: "Det forekommer muligt at udvalgte/relevante risiko kilder kan realiseres ved udnyttelse af understøttende aktivers sårbarheder (f.eks: tyveri af papirdokumenter og medier opbevaret i en organisations lokaler, hvis adgang styres af en person i receptionen).",
			name: "Sandsynligt"
		},
		PIA_EX_VRAL: {
			description: "Det er ikke særlig sandsynligt at udvalgte/relvante risiko kilder kan realiseres ved udnyttelse af understøttende aktivers sårbarheder (f.eks: tyveri af papirdokumenter og medier opbevaret i et rum beskyttet af en badge læser).",
			name: "Mindre sandsynligt"
		},
		PIA_EX_VRAM: {
			description: "Det forekommer højest sandsynligt at at udvalgte/relevante risiko kilder realiseres ved udnyttelse af understøttende aktivers sårbarheder (f.eks: tyveri af papirdokumenter og medier uden overvågning i en offentlig tilgængelig ventesal).",
			name: "Forventet"
		},
		PIA_EX_VRAN: {
			description: "Det forekommer ikke muligt, at udvalgte/relevante risiko kilder kan realiseres ved udnyttelse understøttende aktivers sårbarheder (f.eks: tyveri af papirdokumenter og medier aflåst i organisationens lokale, hvor adgang styres af sikkerhedsbadge og kode adgang).",
			name: "Usandsynligt"
		},
		PIA_LGL_CONS: {
			description: "Tillader registrerede at give en frivillig, specifik, informeret og utvetydig viljestilkendegivelse; det skal kontrolers om behandlingen beror på anden juridisk base end samtykke jf. Art. 6 af <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Samtykke",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Beskriv i detaljer omfanget af behandlingen:<br>- Kategorier af personoplysninger, hvem oplysningerne vidergives til og hvor lang tid de opbevares<br>- beskriv behandlingsprocessen og de understøttende informationsaktiver under hele livscyklusen af personoplysningerne (fra indsamling til sletning).",
			name: "behandlede personoplysninger",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Beskriv behandlingsaktiviteten overordnet, såsom formål og omfang. Angiv dataansvarlige og eventuelle databehandler. Angiv de nødvendige og relevante krav for behandlingen og/eller passende adfærdskodekser og certificering (se Art. 40 af <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) og certificeringer for databeskyttelse (se Art. 42 af <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Behandlingsbeskrivelse",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "En fysisk eller juridisk person, en offentlig myndighed, en institution eller et andet organ, hvortil personoplysninger videregives, uanset om det er en tredjemand eller ej. Offentlige myndigheder, som vil kunne få meddelt personoplysninger som led i en isoleret forespørgsel i henhold til EU-retten eller medlemsstaternes nationale ret, anses dog ikke for modtagere; de offentlige myndigheders behandling af disse oplysninger skal overholde de gældende databeskyttelsesregler afhængigt af formålet med behandlingen. se Art. 4.9 af <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Modtagere",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "Opbevaringsperioden skal defineres under hensyntagen til behandlingens karakter, omfang og formål eller kategorier af behandling samt gældende lovmæssige krav. Dog skelnes der mellem oplysninger og arkiverede oplysninger, der kun kan tilgåes af relevante personer. En sletningsmekanisme skal implementeres ved arkivering af oplysninger eller ved sletning af arkiverede oplysninger efter endt opbevaringsperiode. Funktionelle og tekniske logs skal også slettes, de må ikke opbevares uendeligt.",
			name: "Opbevaringsperiode",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Personoplysninger skal indsamles til udtrykkeligt angivne og legitime formål og <strong>må ikke viderebehandles på en måde, der er uforenelig med disse formål.</strong> <br>See <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) af [GDPR]</a>",
			name: "Formålet med indsamling og behandling af personoplysninger",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Den registrerede har givet samtykke til behandling af sine personoplysninger til et eller flere specifikke formål <br>- Behandling er nødvendig af hensyn til opfyldelse af en kontrakt, som den registrerede er part i, eller af hensyn til gennemførelse af foranstaltninger, der træffes på den registreredes anmodning forud for indgåelse af en kontrakt <br>- Behandling er nødvendig for at overholde en retlig forpligtelse, som påhviler den dataansvarlige <br>- Behandling er nødvendig for at beskytte den registreredes eller en anden fysisk persons vitale interesser <br>- Behandling er nødvendig af hensyn til udførelse af en opgave i samfundets interesse eller som henhører under offentlig myndighedsudøvelse, som den dataansvarlige har fået pålagt <br>- Behandling er nødvendig for, at den dataansvarlige eller en tredjemand kan forfølge en legitim interesse, medmindre den registreredes interesser eller grundlæggende rettigheder og frihedsrettigheder, der kræver beskyttelse af personoplysninger, går forud herfor, navnlig hvis den registrerede er et barn<br> Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 6 af [GDPR]</a> ",
			name: "Lovligheden af behandlingen",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Sikre at registrerede informeres ved indsamling og behandling af personoplysninger. Bekræfter at behandlingen ikke er omfattet af undtagelser eller specifikke omstædnigheder.",
			name: "Oplysning til registrerede om brug af personoplysninger",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Det drejer sig om at reducere risici ved at undgå indsamling og behandling af unødvedige personoplysninger i en behandlingsaktivitet. Ved brug af dataminimering kan den overordnede risiko også reduceres for de registrerede ved at fjerne følsomme oplysninger når de er irrelevante for behandlingen.",
			name: "Dataminimering",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "En behandlingskontrakt skal underskrives med hver Underleverandør der agere som databehandler, og skal tilfredsstiller alle krav som beskrevet i GDPR Art. 28: varighed, anvendelsesområde, formål, dokumenterede behandlingsinstrukser, forudgående godkendelsen af underleverandører, stiller nødvendig dokumentation til rådighed for at påvise compliance med [GDPR], underretter straks i tilfælde af sikkerhedsbrud, osv.",
			name: "Underleverandører",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Aktiver som personoplysningerne afhænger af. Note: dette kan være hardware, software, netværk, medarbejdere, papir eller kanaler til overførsel af papir.",
			name: "Understøttende informationsaktiver",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Det dokumenteres hvor personoplysninger geografisk befinder sig. Hvis personoplysningerne befinder sig i lande der ikke har et tilstrækeligt beskyttelsesniveau, skal det juridiske grundlag for overførsel dokumenteres således at registrerede har de fornødne garantier, og at deres rettigheder kan håndhæves. Det vil sige :<br>- Lande i den Europæiske Union<br>- Lande med tilstrækkeligt beskyttelsesniveau (anerkendt af EU)<br>- Overførseler til amerikanske organisationer tilsluttet Privacy Shield<br>- Andre lande <br>Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 til 49 af [GDPR]</a>",
			name: "Overførsel af personoplysninger",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Findes der en politik og procedure der sikre organisationens styring af compliance til GDPR, der sikre fuldt overblik over behandlingsaktiviteter og efterlevelse af forordningens krav (f.eks. igennem effektivt tilsyn og revision).",
			name: "Monitorering af beskyttelse af privatlivet",
			placeholder: "Beskriv her procedurer der sikre at behandlingsaktiviteter efterlever forordningens krav om beskyttelse af privatlivet.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Findes der en politik der mindsker risiko for databehandlernes autoriseret adgang til personoplysninger (identitet af medarbejdere, databehandleraftale, tekniske og organisatoriske tiltag, BCR, osv.).",
			name: "Adgangskontrol for databehandlere",
			placeholder: "Beskriv her krav og regler for adgangskontrol ved databehandlernes adgang til personoplysninger.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Beskriv om en person er udpeget og ansvarlig for opfølgning af compliance til persondataforordningen. Angiv om sikkerhedskomiteen (eller tilsvarende) tager ansvar for rådgivning, følger op på sikkerhed, sikre afhjælpning og beskyttelse af personoplysninger.",
			name: "Organisationen",
			placeholder: "Beskriv om roller og ansvar for beskyttelse af personoplysninger er defineret.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Findes der en Privacy-by-Design politik der påkræver at princippet om beskyttelse af privatlivet og personoplysninger håndhæves ved alle nye behandlingsaktiviteter.",
			name: "Integration af privatlivsbeskyttelse i projekter",
			placeholder: "Beskriv her hvordan beskyttelse af privatlivet inkorporeres i nye projekter",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Findes der en politik der definerer et awarenessprogram for ansatte og nyansatte. Er der en procedure for afvikling af adgang til personoplysninger ved ansættelsesophør eller justering af adgang ved skifte af job eller rolle i organisationen.",
			name: "Styring af medarbejdere",
			placeholder: "Beskriv her de foranstaltninger i HR politikken relevante for beskyttelse af privatlivet og personoplysninger.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Dataansvarlige i organisationen skal have klare politikker og regelsæt til sin rådighed jf. persondataforordningens krav (risici og konsekvensanalyse, politikker, processer, osv.).",
			name: "Politikker for persondatabeskyttelse",
			placeholder: "Beskriv hvordan processer for persondatabeskyttelse er implementeret i organisationen",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Politik der beskriver en process for risiko styring for registrerede ved organisationens behandling af personoplysninger (hvilke behandlinger, omfanget af personoplysninger, understøttende informationsaktiver, risiko analyse, nuværende eller planlagte sikkerhedsforanstaltninger, osv.).",
			name: "Styring af risiko for privatlivet",
			placeholder: "Beskriv her processer for styring af risiko for registrerede ved behandling af personoplysninger.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Findes der en operationel enhed i organisationen der håndterer sikkerhedshændelser og brud på registeredes privatliv (ansvarsfordeling, procedure, handlingsplan, kommunikationsplan, osv.).",
			name: " Styring af sikkerhedsbrud på personoplysninger",
			placeholder: "Angiv her om hvorvidt håndtering af sikkerhedshændelser har en dokumenteret og testet procedure.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Findes der en Politik der sikre til rådighed og integritet igennem backup, alt imens fortrolighed er varetaget (regelmæssig backup, restaurations test, kryptering af backupmedie.",
			name: "Backup",
			placeholder: "Beskriv hvordan backup er styret og fysisk sikret.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Beskyttende foranstaltninger installeret på PC arbejdsstationer (automatisk skærmlåsning, opdateringer af operativ system og applikationer, konfigurationer, backup, fysisk sikkerhed, osv.) der mindsker muligheden for at udnytte sårbarheder der kan kompromitere fortrolighed, integritet og til rådighed af personoplysninger.",
			name: "Styring af PC og arbejdsstationer",
			placeholder: "Beskriv beskyttende foranstaltninger installeret på PC arbejdsstationer",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "Databehandler eller anden part der modtager eller behandler personoplysninger <strong>skal stille de nødvendige garantier</strong> (f.eks. ved specialiseret viden, pålidelighed af resourcer). Stille krav til databehandler om at udlevere sikkerhedspolitikker for relevante informationssystemer. <br>Modtage og dokumentere at sikkerhedspolitikkerne er effektive (sikkerheds revision, tilsyn af support, data og behandlingscentre, osv.) for at kunne <strong>påvise effektiviteten af databehandlerens garantier<strong> for beskyttelse af personoplysninger. Disse garantier inkludere exempelvis :<br> - kryptering af personoplysninger ifølge sensitiviteten eller dokumenterede procedurer der sikre at databehandler ikke har adgang til personoplysningerne<br>- krypteringle af data i bevægelse (f.eks. kommunikation over HTTPS, VPN, osv.)<br>- garantier for beskyttelse af netværk, logning (journal og event audits), styring af adgangsrettigheder, brugergodkendelse, osv.<br><strong>Etablere en kontrakt med databehandler</strong>, der indeholder omfanget, tidslængde, formålet af behandlingen og parternes obligationer. Sikre at kontrakten indeholder klasuler for :<br>- fortrolighedserklæring for informationer og personoplysninger<br>- minimumskrav til brugergodkendelse<br>- tilbagelevering og/eller sletning ved udløb af kontrakten<br>- regler for rapportering af sikkerhedshændelser. Nødvendige informationer kommunikeres snarest til dataansvarlige i tilfælde af sikkerhedshændelser, og straks ved sikkerhedsbrud af personoplysninger.<br>- Ved brug af cloud leverandører :<br>\t1. identificere alle oplysninger der behandles i cloud ;<br>\t2. definere passende tekniske og juridiske krav ;<br>\t3. udføre en risikoanalyse for at identificere nødvendige sikkerhedsforanstaltninger ;<br>\t4. identificere en passende cloud model (Privat, community, Public - IaaS, PaaS, SaaS, Hybrid) relevant for den planlagte behandling ;<br>\t5. vælge en databehandler der kan stille de nødvendige garantier ;<br>\t6. Gennemse og eventuelt opdatere sin interne sikkerhedspolitik ;<br>\t7. overvåge forandringer og evolution igennem kontraktens levetid.",
			name: "Databehandler kontrakt",
			placeholder: "Ved brug af databehandler, beskriv de kontraktuelle garantier",
			source: "Digitaliseringsstyrelsen; Sådan stiller du krav til leverandører om informationssikkerhed <a target=\"_blank\" href=\"https://digst.dk/styring/standardkontrakter/klausuler-til-informationssikkerhed/kravkatalog-til-leverandoerer\">kravkatalog til leverandoerer</a>"
		},
		PIA_SEC_EXP: {
			description: "Politikker der mindsker operationelle risici for informationsaktiver der indeholder personoplysninger (operationelle procedurer, register over aktiver, afhjælpning af sårbarheder, undgå duplikater af data, skærpet adgangskontrol til informationsaktiver, osv.",
			name: "Operationel sikkerhed",
			placeholder: "Beskriv hvordan software opdateringer (operativ systemer, applikationer, osv.) og implementation af sikkerheds korrektiver og patches foretages.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Fortages der overvågning af infrastruktur og applikationer med hjælp af detektionssystemer (IDS, IPS, NDIS, endpoint, osv.) med henblik på at spore og opdage cyberangreb og mistænksomme hændelser ved brug af log og event korrelation i kritiske komponenter (netværks, Wi-Fi, radiobølger, optisk fiber, computere, appliances, printere, applikationer, osv.).",
			name: "Overvågning og sporing",
			placeholder: "Beskriv foranstaltninger der kan spore og opdage sikkerhedshændelser",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Politikker der beskriver hvordan fysiks vedligeholdelse af hardware er styret, om hvorvidt det er udliciteret.<br> Beskriv hvordan udtjente komponenter der kunne indeholde personoplysninger er beskyttet inden destruktion og hvordan de er detrueret.",
			name: "Vedligeholdelse",
			placeholder: "Beskriv hvordan fysisk vedligeholdelse af hardware er styret",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Beskyttende foranstaltninger ved adgang til usikre netværk (Internet) og leverandør netværk, Beskyttende foranstaltninger mod malware installeret på computere (PC, server, mobilenheder) ved adgang igennem usikre netværker.",
			name: "Beskyttelse mod malware",
			placeholder: "Beskriv beskyttende foranstaltninger mod malware ved adgang igennem og/eller brug af usikre netværk.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Hvordan sikres den fysiske sikkerhed af server, arbejdsstationer og bærbare (sikker opbevaring, sikkerhedskabler, skærpet adgangskontrol, sikker destruktion af udtjent HW, osv.).",
			name: "Sikkerhed af hardware",
			placeholder: "Beskriv fysiske sikkerhedsforanstaltninger af server og PC arbejdsstationer",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Afhængig af netværket hvor behandlingen fortages (isoleret, privat eller Internet), beskriv hvilken firewall systemer, intrusion detection systemer (IDS/IPS), eller andre aktive/passive løsninger, der er iværksat for sikkerheden på netværket.",
			name: "Netværkssikkerhed",
			placeholder: "Beskriv her sikkerhedsforanstaltninger på netværket hvor behandlingen foregår",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Politikker der sikre fysisk sikkerhed (sikkerhedszoner, besøgende skal ledsages, synlig ID badge, aflåste døre, osv.). Beskriv eventuelle indbrudsalarmsystemer og hvad de beskytter.",
			name: "Fysisk adgangskontrol",
			placeholder: "Beskriv de fysiske sikkerhedsforanstaltninger hvor behandlingen foregår.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Politikker der beskriver forebyggelse og bekæmpelse af f.eks. brand. Angiv foranstaltninger der forebygger vandskader og andre farer der præsentere risici for personoplysninger.",
			name: "Beskyttelse mod ikke-menneskelige risici",
			placeholder: "Beskriv her foranstaltninger der mindsker ikke-menneskelige risici.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Indhent Dokumentation for risikoanalyse af potentielle naturkatastrofer der hvor behandlingen af personoplysninger finder sted, så vidt muligt undgås geografiske zoner med risiko for naturkatastrofer (oversvømmelser, kemiske industriområder, jordskælv eller vulkanisk zone, osv.). Beskriv om farlige produkter er lagret i samme område.",
			name: "Undgåelse af naturkatastrofer",
			placeholder: "Beskriv om miljø og naturkatastrofe risici så vidt muligt er undgået der hvor behandlingen finder sted",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Beskriv sikkerhedsforanstaltninger der medvirker til beskyttelse af personoplysninger på websites (hardening igennem konfiguration, TLS kryptering, styring af cookies, styring af API'er, sikkerheds test, osv).",
			name: "Website sikkerhed",
			placeholder: "Beskriv foranstaltninger til beskyttelse af websites.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Beskriv om hvorvidt anonymiseringsmeknismer er til rådighed, hvilken metode og formål. <br>Husk at skelne mellem anonymisering og pseudonymisering af personoplysninger.",
			name: "Anonymisering",
			placeholder: "Beskriv her mekanismen for anonymisering",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Hvis relevant, beskriv politikken og/eller processen for arkivstyring (levering, lagring, konsultation, osv.) under ansvar. Beskriv arkiverings roller (lagring, overførsel, sletning, osv.). Beskriv om der er lovmæssige krav til overførsel til offentlig arkiver.",
			name: "Arkivering",
			placeholder: "Beskriv hvilken metode der bruges for konservering og arkivering af personoplysninger.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Foranstaltninger der <strong>sikre fortrolighed</strong> af lagret personoplysnsinger (i databaser, filer, backup osv.), ligeledes procedure for håndtering og beskyttelse af krypteringsnøgler (skabelse, lagring, fornyelse (f.eks. ved mistanke om kompromiteret data, osv.).<br> Beskriv behandlingens krypteringsforanstaltninger for data i bevægelse (HTTPS, TLS, VPN, , etc.).",
			name: "Kryptering",
			placeholder: "Beskriv her de foranstaltninger der sikre fortrolighed af personoplysninger",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Systemet kan struktureres i uafhængige dele med separate adgangskontrolfunktioner. Personoplysninger kan også fordeles mellem disse uafhængige delsystemer hvor hvert delsystem styres ved hjælp af forskellige adgangskontrolmekanismer. Hvis et delsystem er kompromitteret, kan konsekvenserne på datasættet reduceres",
			name: "Opdeling af personoplysninger",
			placeholder: "Beskriv om hvorvidt segmentering (opdeling) af personoplysninger er planlagt, og hvordan det er implementeret.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Beskriv hvorledes bruger profiler er defineret og tildelt. Uddyb hvilken <strong>Autentifikation</strong> der bruges. Hvis relevant, beskriv reglerne for password (minimiums længde, kompleksitet, levetid, antallet af fejlforsøg inden bruger konto låses, osv.).",
			name: "Logisk adgangskontrol",
			placeholder: "Beskriv hvorledes bruger profiler er defineret og tildelt.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Politikker for logning og jounalisering af begivenheder (system, netværk, applikation, osv.) og logstyring.",
			name: "Journalisering (logning)",
			placeholder: "Beskriv hvordan begivenheder bliver logget og hvor lang tid de lagres.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Sensitiviteten af personoplysninger kan mindskes med følgende metoder:  Filtrering og sletning, mindske sensitiviteten ved konversion, mindske omfanget af personhenførbare oplysninger, restriktion af adgang til personoplysningerne",
			name: "Minimering af personoplysninger",
			placeholder: "Beskriv hvordan risici mindskes ved dataminimering af personoplysninger",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Politikker for papirdokumenter med personoplysninger der indgår i behandlingen, beskriv hvordan de bliver printet, lagret, destrueret og eventuelt udvekslet.",
			name: "Sikkehed for papir dokumenter",
			placeholder: "For håndtering af personoplysninger på papirdokumenter, beskriv hvilke procedurer der er i brug samt formålet.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Handlingsplanen beskriver strategien, midler og resourcer for effektiv implementation af de afhjælpende sikkerhedsforanstaltninger. Hver opgave tildeles en ansvarlig og forventede tidsplan for implementation.",
			name: "Handlingsplan",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Denne grafik illustrere risici relevante for behandlingsaktiviteten med de afhjælpende sikkerhedsforanstaltninger implementeret. Den viser med andre ord, at behandlingens risci mindskes når de afhjælpende tiltag er implementeret.",
			name: "Risici oversigt",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Den dataansvarlige indhenter, hvis det er relevant, de registreredes eller deres repræsentanters synspunkter vedrørende den planlagte behandling, uden at det berører beskyttelse af kommercielle eller samfundsmæssige interesser eller behandlingsaktiviteternes sikkerhed. Se Art. 35.9 af <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br>Disse synspunkter kan indsamles ved forskellige metoder, afhængig af konteksten (Intern eller extern analyse af behandlingsmetoden og formål, spørgsmål til tillidsrepræsentanter eller fagorganisationer, meningsmåling blandt fremtidige kunder af databehandlere). <strong>Hvis den dataansvarlige beslutter at gå imod de registreredes synspunkter</strong>, skal denne dokumentere <strong>beslutningsgrundlaget</strong>. Når den dataansvarlige beslutter ikke at indsamle de registreredes synspunkt <strong>skal begrundelsen dokumenteres</strong>.",
			name: "Registreredes synspunkt",
			source: "GDPR Art. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "Den dataansvarlige rådfører sig med databeskyttelsesrådgiveren, hvis en sådan er udpeget, når der foretages en konsekvensanalyse vedrørende databeskyttelse. Se Art. 39.2 af <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/DA/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>Dennes holdning kan fraråde iværksættelsen af behandlingen, dog uden myndighed i forhold til den dataansvarliges beslutning</strong>.",
			name: "Databeskyttelsesrådgiverens holdning",
			source: "GDPR Art. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Den dataansvarlige afgøre om hvorvidt de valgte foranstaltninger, tilbageværende riscici og afhjælpningsplan er acceptabel, dette dokumenteres udfra en forudgående forståelse/analyse og de involverede partners synspunkter. Således kan PIA konsekvensanalysen blive :<br>- godkendt<br>- godkendelse betinget af forbedringer (forklare hvorledes)<br>- Afslået (sammen med den pågældende behandling), hvis nødvendigt, gentages og forbedres de foregående etaper således at PIA'en kan godkendes. Denne afgørelse foregriber ikke en compliancevurdering der eventuelt fortages af tilsynsmyndigheden (Datatilsynet i Danmark), som del af standard aftaler eller tilsyn/revision.",
			name: "Dataansvarliges validation",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Vidensbase"
};
var measures$j = {
	add: "Indsæt en ny sikkerhedsforanstaltning (ellers brug vidensbasen)",
	default_placeholder: "Beskriv eksiterende eller planlagte sikkerhedsforanstaltning til beskyttelse af personoplysninger.",
	edit: "Ændre sikkerhedsforanstaltning",
	placeholder_title: "Sikkerhedsforanstaltning titel",
	remove: "Slette sikkerhedsforanstaltning"
};
var misc$j = {
	display: "Vis / Gem"
};
var modals$j = {
	abandon_pia: {
		additional_text: "Arkiveringen er ikke definitiv og du kan genoptage behandlingen af PIA'en hvis ønsket.",
		content: "Vil du opgive behandlingen?"
	},
	action_plan_no_evaluation: {
		content: "Start venligst evalueringen af analysen for at skabe handlingsplanen.",
		review_section: "Evaluerings sektionen"
	},
	archive: "Arkiver",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "Denne sektion er klar til evaluering."
	},
	back_to_edition: {
		content: "Dette afsnit redigeres,<br> oplysninger skal tilføjes for at tillade evaluering af afsnittet."
	},
	back_to_evaluation: {
		content: "Dette afsnit redigeres,<br> oplysninger skal vurderes igen for at tillade validering af afsnittet."
	},
	back_to_home: "Tilbage til oversigt",
	cancel: "Fortryd",
	close: "Luk",
	completed_edition: {
		content: "Alle dele er redigeret.<br>Analysen skal nu evalueres."
	},
	completed_evaluation: {
		content: "PIA er blevet fuldt gennemgået og godkendt."
	},
	"continue": "Fortsæt",
	declare_measures: {
		content: "Før du vurderer risiciene, <br> skal du erklære de eksisterende<br> eller planlagte foranstaltninger.",
		declare: "Erklære eksisterende eller planlagte foranstaltninger"
	},
	dpo_missing_evaluations: {
		comment: "Kommentarer",
		content: "Udfyld evalueringen af analysen for at få adgang til DPO-siden.",
		remove: "Slet",
		review_section: "Evaluere sektionen"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Den importerede fil relaterer ikke til en PIA rapport fil"
	},
	import_wrong_structure_file: {
		content: "Den importerede fil relaterer ikke til en PIA skabelon fil"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Indholdet af PIA er kopieret til clipboard."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Warning,</span><br>Mindst en foranstaltning skal udfyldes: ingen sletning er mulig."
	},
	recover_version: {
		"continue": "Fortsæt",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "Efter din afvisning, returneres analysen til evaluering for at foretage de nødvendige ændringer."
	},
	remove_attachment: {
		comment: "Kommentarer",
		content: "<span class='strong'>Warning,</span><br>Er du sikker på at du vil<br>slette denne vedhæftelse?",
		keep: "Behold",
		remove: "Slet"
	},
	remove_measure: {
		content: "<span class='strong'>Advarsel,</span><br>Er du sikker på, at du vil slette denne foranstaltning?",
		keep: "Behold denne<br>foranstaltning",
		remove: "Slet denne<br>foranstaltning"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Slet denne PIA"
	},
	remove_question: {
		content: "Er du sikker på at du vil slette spørgsmålet?",
		keep: "Behold",
		remove: "Slet"
	},
	remove_structure: {
		content: "<span class='strong'>Advarsel,</span><br>Er du sikker på at du vil <br>slette skabelonen?",
		remove: "Slet skabelon"
	},
	same_comment: {
		content: "<span class='strong'>Advarsel,</span><br>Indtast venligst en andenledes kommentar end den forrige (gemte)."
	},
	signed_pia_validation: {
		content: "For at godkende PIA'en skal du vedhæfte den underskrevne rapport.",
		download_pia: "Hent rapporten"
	},
	simple_pia_validation: {
		content: "Du har godkendt PIA'en."
	},
	start_evaluation: "Start evaluering",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Serveradressen er blevet opdateret."
	},
	validate_evaluation: {
		content: "Denne sektion er klar for godkendelse af PIA."
	},
	validate_evaluation_to_correct: {
		content: "Undskyld,<br>Alle felter skal korrigeres.<br>Tilbage til redigeringsstatus<br>for at korriger."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$j = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$j = {
	content: ", overveje at :",
	dpo_lock: "Udfyld de øvrige afsnit, inden du kan udfylde DPO synspunkt.",
	dpo_opinion: "DPO holdning",
	edit: "Redigere",
	people_opinion: "Berørte personers synspunkter",
	placeholder_concerned_people_name: "Berørte personers navn(e)",
	placeholder_dpo_name: "DPO navn(e)",
	placeholder_dpo_opinion: "Uddyb begrundelse for valg.",
	placeholder_people_opinion: "Beskriv hvordan synspunkterne blev samlet og hvad analysen er. I det tilfælde, hvor udtalelserne ikke blev efterspurgt, angiv årsagerne.",
	placeholder_search_content: "Beskriv hvorfor de pågældende personers synspunkter ikke blev efterspurgt.",
	treatment_lock: "Udfyld venligst de øvrige afsnit, inden de berørte personers synspunkt angives.",
	treatment_nok: "Behandlingen bør ikke gennemføres.",
	treatment_ok: "Denne Behandling kan gennemføres."
};
var pia$j = {
	attachments: {
		add: "Tilføj",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Slet",
		title: "Vedhæftelser",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Bede om evaluering",
		mandatory_fields: "Alle felter skal udfyldes",
		structure_add_question: "Tilføj et",
		subsection_validated: "Delvist evalueret, venter på endelig godkendelse",
		validate_evaluation: "Acceptere evaluering"
	},
	header: {
		display_action_plan: "Vis<br>handlingsplan",
		edition: "Redigere",
		evaluation: "Evaluation",
		preview: "Preview"
	},
	sections: {
		based_on_structure_name: "Baseret på skabelon",
		homepage_link: "Tilbage til oversigt",
		refuse_pia: "Afvise AIIA",
		status: {
			evaluation: {
				cancel: "Fortryd forspørgslen om evaluering.",
				cancel_button: "Fortryd forspørgslen om evaluering",
				content: "Denne del har endnu ikke været evalueret. Hvis du ønsker at redigere det foreslået indhold skal du ",
				title: "Venter på evaluering."
			},
			validation: {
				cancel: "Fortryd forspørgslen om evaluering.",
				cancel_button: "Fortryd forspørgslen om evaluering",
				content: "Denne del er evalueret og venter på overordnet PIA validation. Hvis du ønsker at ændre evalueringen , skal du ",
				title: "Venter på godkendelse."
			}
		},
		validate_pia: "Godkend PIA"
	},
	statuses: [
		"Under behandling",
		"Afvist",
		"Simpel godkendelse",
		"Signered godkendelse",
		"Arkiveret",
		"Venter på godkendelse"
	]
};
var questions$j = {
	edit: "Redigere spørgsmål",
	gauges: [
		"(Udefinet)",
		"Ubetydelig",
		"Betydelig",
		"Alvorlig",
		"Katastrofal"
	],
	placeholder_title: "Titel på spørgsmål (obligatorisk)",
	remove: "Slet spørgsmål"
};
var rejection_page$j = {
	applied_adjustments: "Foreslået forbedringer",
	applied_adjustments_placeholder: "Beskriv ændringer til PIA'en.",
	button: {
		abandon_treatment: "Forlad behandlingen",
		reject_pia: "Afvis AIIA",
		send_for_validation: "Send igen til validering"
	},
	previous_rejection: "Foregående afvisning",
	rejection_reason: "Begrundelse for afvisning",
	rejection_reason_placeholder: "Begrundelse for afvisning af PIA.",
	title: "Valideringshistorik"
};
var sections$j = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Præsentere behandlingen på en syntetisk måde: dets navn, dets formål, dets indsats (forventede bidrag), dets anvendelsesmåde osv.",
						title: "Hvad er den behandling, der er genstand for undersøgelsen?"
					},
					"2": {
						placeholder: "Beskriv ansvarsfordelingen for behandlingen: dataansvarlige, eventuel databehandler og fælles dataansvarlige.",
						title: "Hvordan er ansvaret for behandlingen fordelt?"
					},
					"3": {
						placeholder: "Beskriv relevante standarder for behandlingen, især godkendte adfærdskodekser og databeskyttelse normer eller certifikationer.",
						title: "Er der gældende standarder for behandlingen?"
					}
				},
				short_help: "Dette afsnit giver dig mulighed for at identificere og præsentere formålet med undersøgelsen.",
				title: "Oversigt"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Angiv de indsamlede og behandlede kategorier af personoplysninger. Angiv opbevaringsperioder, modtagere og de personer, der har adgang til dem.",
						title: "Hvilke personoplysninger behandles?"
					},
					"2": {
						placeholder: "Beskriv personoplysningernes livscyklus (fra samling til sletning gennem lagring, forskellige behandlingstrin, arkivering osv.), F.eks. ved hjælp af et dataflowskema (der kan tilføjes som en vedhæftet fil) og en beskrivelse af hver implementeret proces.",
						title: "Hvordan er personoplysningernes livscyklus (funktionel beskrivelse)?"
					},
					"3": {
						placeholder: "Angiv informationsaktiver for behandlingen (computersystemer, servere, software, netværk, mennesker, papir, osv.)",
						title: "Hvilke informationsaktiver understøtter behandlingen?"
					}
				},
				short_help: "Dette afsnit giver dig mulighed for at afgrænse og beskrive den behandlingen i detaljer.",
				title: "Data, processer og informationsaktiver"
			}
		},
		short_help: "Dette afsnit giver dig et klart billede af behandlingsaktiveter med personoplysninger.",
		title: "Kontekst"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Forklar, hvordan behandlingen har udtrykkeligt angivne og legitime formål.",
						short_title: "Formålet",
						title: "Er formålet med behandlingen bestemt, eksplicit og legitimt?"
					},
					"2": {
						placeholder: "Angiv grundlaget for din behandling (f.eks. samtykke, opfyldelse af en kontrakt, retlig forpligtelse, vitale interesser, offentlig myndighedsudøvelse, legitim interesse).",
						short_title: "Lovlig behandling",
						title: "Hvad er det lovmæssige hjemmel for behandlingen?"
					},
					"3": {
						placeholder: "Forklar, hvordan hver enkelt indsamlet personoplysning er nødvendigt for behandlingen.",
						short_title: "Data minimering",
						title: "Er dataindsamlingen tilstrækkelig, relevant og begrænset til det, der er nødvendigt for de formål, som det behandles for (data minimering)?"
					},
					"4": {
						placeholder: "Beskriv de planlagte foranstaltninger for at sikre kvaliteten og integriteten af personoplysningerne.",
						short_title: "Rigtighed",
						title: "Er personoplysningerne nøjagtige og ajourførte?"
					},
					"5": {
						placeholder: "Forklar, hvordan den påtænkte opbevaringsperiode for hver enkel personoplysning er nødvendig for at opfylde formålene med behandlingen, foruden at dokumentere hvis andre lovmæssige forpligtelser kræver en specifik opbevaringsperiode.",
						short_title: "Opbevaringsbegrænsning",
						title: "Hvor længe opbevares personoplysningerne?"
					}
				},
				short_help: "Dette afsnit giver dig mulighed for at demonstrere legitimiteten af din behandling og de behandlede personoplysninger.",
				title: "Proportionalitet og nødvendighed"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Beskriv de oplysninger, der skal gives til de berørte personer og hvordan de formidles.",
						short_title: "Oplysning til registerede",
						title: "Hvordan oplyses de registrerede om behandlingen af personoplysninger?"
					},
					"2": {
						placeholder: "Beskriv vilkårene for opnåelse af de pågældende personers samtykke.",
						short_title: "Indsamling af samtykke",
						title: "Hvorledes opnås samtykke fra de berørte personer, hvis det er relevant?"
					},
					"3": {
						placeholder: "Beskriv, hvordan registrerede kan anmode om adgang til deres personoplysninger og modtage eller overføre deres oplysninger.",
						short_title: "Ret til indsigt og dataportabilitet",
						title: "Hvordan kan de registrerede udøve deres ret til indsigt og ret til dataportabilitet?"
					},
					"4": {
						placeholder: "Beskriv hvordan de registrerede kan rette og hvis relevant, slette eller minimere deres personoplysninger.",
						short_title: "Ret til berigtigelse og sletning",
						title: "Hvordan kan registrerede udøve deres ret til berigtigelse og retten til at blive slettet (ret til at blive glemt)?"
					},
					"5": {
						placeholder: "Beskriv hvordan man giver de registrerede mulighed for at anmode om begrænsning af behandlingen af deres personoplysninger og hvis relevant, modsætte sig behandlingen.",
						short_title: "Ret til begrænsning og indsigelse",
						title: "Hvordan kan de registrerede udøve deres ret til begrænsning af behandling og ret til indsigelses?"
					},
					"6": {
						placeholder: "For hver databehandler beskrives omfanget af dennes ansvar og der angives henvisninger til kontrakter, adfærdskodekser compliancedokumenter og certificeringer, der fastsætter databehandler forpligtelser.",
						short_title: "Udlicitering og databehandlere",
						title: "Er forpligtelser klart defineret og kontraktliggjort for databehandlere?"
					},
					"7": {
						placeholder: "For hvert land uden for EU, hvor personoplysninger lagres eller behandles, skal landet identificeres og det angives om landet er anerkendt for at have et tilstrækkeligt beskyttelsesniveau, eller beskrive de bestemmelser der gælder for overførslen.",
						short_title: "Overførsler",
						title: "Hvis personoplysninger overføres udenfor EU (tredjeland eller en international organisation), er personoplysningerne beskyttet på tilsvarende vis?"
					}
				},
				short_help: "Dette afsnit giver mulighed for at påvise, at nødvendige foranstaltninger og processer for udøvelse af registreredes rettigheder er tilsteder.",
				title: "Foranstaltninger for beskyttelse af de registreredes rettigheder"
			}
		},
		short_help: "Dette afsnit giver dig mulighed for at opbygge mekanismer for efterlevelse af principperne om beskyttelse af personoplysninger.",
		title: "Fundamentale principper"
	},
	"3": {
		items: {
			"1": {
				short_help: "Dette afsnit giver dig mulighed for at identificere de foranstaltninger (eksisterende eller planlagte), der bidrager til sikkerhed af personoplysninger.",
				title: "Eksisterende eller planlagte foranstaltninger"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Beskriv den potentielle konsekvens +",
						title: "Hvad kan være den vigtigste <span class='green-highlight'>indvirkning på de berørte personer</span> hvis risikoen opstod?"
					},
					"2": {
						placeholder: "Beskriv trusslerne +",
						title: "Hvilke er de vigtigste <span class='green-highlight'>trussler</span> der kan føre til risiko?"
					},
					"3": {
						placeholder: "Beskriv risiko kilder +",
						title: "Hvilke risiko <span class='green-highlight'>kilder</span>?"
					},
					"4": {
						placeholder: "Klik for at vælge de foranstaltninger der formindsker risikoen.",
						title: "Hvilke af de identificerede <span class='green-highlight'>foranstaltninger</span> medvirker til at formindske risikoen?"
					},
					"5": {
						placeholder: "Beskriv her den vurderede alvorlighed af risikoen.",
						title: "Hvordan vurdere du <span class='green-highlight'>risiko alvorligheden</span>, især i henhold til potentielle trussler, risiko kilder og planlagte foranstaltninger?"
					},
					"6": {
						placeholder: "Beskriv her den vurderede sandsynlighed.",
						title: "Hvordan vurdere du <span class='green-highlight'>sandsynligheden af riskoen</span>, især i henhold til trusler, risikokilder og planlagte foranstaltninger?"
					}
				},
				short_help: "Analyser årsagerne og konsekvenserne af ulovlig adgang til personoplysninger, og vurder alvorlighed og sandsynlighed.",
				title: "Uautoriseret adgang til personoplysninger"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Beskriv den potentielle konsekvens +",
						title: "Hvad kan være den vigtigste <span class='green-highlight'>indvirkning på de berørte personer</span> hvis risikoen opstod?"
					},
					"2": {
						placeholder: "Beskriv trusslerne +",
						title: "Hvilke er de vigtigste <span class='green-highlight'>trussler</span> der kan føre til risiko?"
					},
					"3": {
						placeholder: "Beskriv risiko kilder +",
						title: "Hvilke risiko <span class='green-highlight'>kilder</span>?"
					},
					"4": {
						placeholder: "Klik for at vælge de foranstaltninger der formindsker risikoen.",
						title: "Hvilke af de identificerede <span class='green-highlight'>foranstaltninger</span> medvirker til at formindske risikoen?"
					},
					"5": {
						placeholder: "Beskriv her den vurderede alvorlighed af risikoen.",
						title: "Hvordan vurderer du <span class='green-highlight'>risiko alvorligheden</span>, især i henhold til potentielle trussler, risiko kilder og planlagte foranstaltninger?"
					},
					"6": {
						placeholder: "Beskriv her den vurderede sandsynlighed.",
						title: "Hvordan vurderer du <span class='green-highlight'>sandsynligheden af riskoen</span>, især i henhold til trusler, risikokilder og planlagte foranstaltninger?"
					}
				},
				short_help: "Analysere årsagerne og konsekvenserne af en uønsket ændring i personoplysninger, og vurder dets alvorlighed og sandsynlighed.",
				title: "Uønsket ændring af personoplysninger"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Beskriv den potentielle konsekvens +",
						title: "Hvad kan være den vigtigste <span class='green-highlight'>indvirkning på de berørte personer</span> hvis risikoen opstod?"
					},
					"2": {
						placeholder: "Beskriv trusslernes +",
						title: "Hvilke er de vigtigste <span class='green-highlight'>trussler</span> der kan føre til risiko?"
					},
					"3": {
						placeholder: "Beskriv risiko kilder +",
						title: "Hvilke risiko <span class='green-highlight'>kilder</span>?"
					},
					"4": {
						placeholder: "Klik for at vælge de foranstaltninger der formindsker risikoen.",
						title: "Hvilke af de identificerede <span class='green-highlight'>foranstaltninger</span> medvirker til at formindske risikoen?"
					},
					"5": {
						placeholder: "Beskriv her den vurderede alvorlighed af risikoen.",
						title: "Hvordan vurderer du <span class='green-highlight'>risiko alvorligheden</span>, især i henhold til potentielle trussler, risiko kilder og planlagte foranstaltninger?"
					},
					"6": {
						placeholder: "Beskriv her den vurderede sandsynlighed.",
						title: "Hvordan vurderer du <span class='green-highlight'>sandsynligheden af riskoen</span>, især i henhold til trusler, risikokilder og planlagte foranstaltninger?"
					}
				},
				short_help: "Analysere kilden og konsekvensen for tab af personoplysninger, vurdere alvorligheden og sandsynligheden.",
				title: "Tab af personoplysninger"
			},
			"5": {
				short_help: "Denne visualisering giver dig mulighed for at få et globalt og syntetisk billede af foranstaltningerne i forhold til de risici, de bidrager til at afhjælpe.",
				title: "Risiko oversigt"
			}
		},
		short_help: "Dette afsnit giver dig mulighed for at vurdere risikoen for beskyttelse af privatlivet under hensyntagen til eksisterende eller planlagte foranstaltninger.",
		title: "Risiko"
	},
	"4": {
		items: {
			"1": {
				short_help: "Denne visualisering gør det muligt at sammenligne risici, før og efter anvendelse af yderligere foranstaltninger.",
				title: "Risikokortlægning"
			},
			"2": {
				short_help: "Planlæg her, i detaljer, gennemførelsen af yderligere foranstaltninger, der blev identificeret under PIA. Dette afsnit opdateres automatisk i henhold til evalueringen af hver enkelt element i konsekvensanalysen.",
				title: "Handlingsplan"
			},
			"3": {
				short_help: "Præsentere holdningen fra den person, der har ansvaret for compliance til databeskyttelsesforordningen (GDPR) (delegeret til databeskyttelsesrådgiveren, hvis udpeget). Fremsætter de berørte personers eller deres repræsentants sysnpunkter.",
				title: "Udtalelse fra DPO og de berørte personer"
			},
			"4": {
				title: "Godkend PIA"
			},
			"5": {
				title: "Afvis PIA"
			}
		},
		short_help: "Dette afsnit giver dig mulighed for at forberede og formalisere valideringen af PIA.",
		title: "Godkendelse"
	}
};
var settings$j = {
	content: "Venligst angiv adressen (URL) for den eksterne server:",
	title: "Konfiguration",
	update: "Updatere URL"
};
var summary$j = {
	action_plan: {
		fundamental_principles: "Fundamentale principper",
		implementation_date: "Forventet implementerings dato",
		implementation_responsible: "Ansvarlig for gennemførelsen",
		measures: "Existerende eller planlagte foranstaltninger",
		no_action_plan: "Ingen handlingsplan registreret.",
		risks: "Risici",
		title: "Handlingsplan"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Vedhæftelser",
	concerned_people_name: "Navn på de berørte personer",
	concerned_people_opinion: "Berørte personers synspunkter",
	concerned_people_searched_opinion: "Søger de berørte personers synspunkter",
	concerned_people_status: "Berørte personers status",
	concerned_people_unsearched_opinion_comment: "Hvorfor de pågældende personers synspunkt ikke blev efterspurgt",
	content_choice: [
		"Behandlingen bør ikke gennemføres.",
		"Behandlingen kan gennemføres."
	],
	creation_date: "Dato for kreation",
	csv_action_plan_comment: "Handlingsplans kommentarer",
	csv_evaluation_comment: "Evaluations kommentarer",
	csv_file_title: "Handlingsplan",
	csv_implement_date: "Forventet dato for implementation",
	csv_people_in_charge: "Ansvarlig for gennemførelsen",
	csv_section: "Sektion",
	csv_title_object: "Titel",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "DPO's navn",
	dpo_opinion: "DPO's holdning",
	dpo_status: "DPO's status",
	gauges: {
		"1": "Ubetydeligt",
		"2": "Betydeligt",
		"3": "Alvorligt",
		"4": "Katastrofalt"
	},
	modification_made: "Ændringer",
	people_search_status_nok: "Den pågældende persons synspunkt blev ikke efterspurgt.",
	people_search_status_ok: "De pågældende personers synspunkt blev anmodet om.",
	pia_assessor: "Analytikers navn",
	pia_author: "Forfatterens navn",
	pia_name: "PIA",
	pia_validator: "Godkenders navn",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "tilbage til forgående side",
	rejection_reason: "Begrundelse for afvisning",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Risikokortlægning",
	risks_overview_title: "Risiko oversigt",
	title: "PIA information"
};
var users$j = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$j = {
	add_signed_pia: "Tilføj underskrevet AIIA",
	after_reading: "Efter fuld læsning af PIA vedrørende behandling af personoplysninger relateret til aktiviteten af ",
	button: {
		rejection: "Afvis AIIA",
		signed_validation: "Godkend PIA <br>(signatur)",
		simple_validation: "Godkend PIA <br>(direkte)"
	},
	confirmation1: "Jeg bekræfter, at beskrivelsen af sammenhængen i min behandling er i overensstemmelse med virkeligheden.",
	confirmation2: "Jeg bekræfter, at jeg har noteret de eksisterende risici i henhold til de foranstaltninger, der i øjeblikket gennemføres eller planlægges.",
	confirmation3: "Jeg godkender de angivne korrigerende tiltag indikeret i handlingsplanen.",
	confirmation4: "Jeg forpligter mig til at gennemføre de korrigerende foranstaltninger, der er angivet, så hurtigt som muligt.",
	latest_signed_attachment: "Sidste underskrevet vedhæftelse",
	mandatory_fields: "Alle felter skal checkes (udfyldes)",
	remove_attachment: "Fjern vedhæftet dokument",
	responsible: "Ansvarlig for godkendelse af PIA: ",
	signed_attachments_history: "Log af Underskrevet vedhæftelser",
	tools: {
		dashboard: "Oversigt",
		display_pia: "Vis rapporter"
	},
	validated_pia_with_signature: "Godkendt",
	waiting_for_signature: "Afventende PIA signatur"
};
var dk = {
	about: about$j,
	action_plan: action_plan$j,
	authentication: authentication$j,
	cartography: cartography$j,
	comments: comments$j,
	conflict: conflict$j,
	date: date$j,
	errors: errors$j,
	evaluations: evaluations$j,
	header: header$j,
	help: help$j,
	homepage: homepage$j,
	knowledge_base: knowledge_base$j,
	measures: measures$j,
	misc: misc$j,
	modals: modals$j,
	onboarding: onboarding$j,
	opinions: opinions$j,
	"overview-risks": {
	important: "Alvorlig",
	limited: "Betydelig",
	maximal: "Katastrofal",
	measures: "Foranstaltninger",
	negligible: "Ubetydelig",
	potential_impacts: "Potentielle konsekvenser",
	"risk-access_x": "Alvorlighed",
	"risk-access_y": "Sandsynlighed",
	"risk-change_x": "Alvorlighed",
	"risk-change_y": "Sandsynlighed",
	"risk-disappearance_x": "Alvorlighed",
	"risk-disappearance_y": "Sandsynlighed",
	sources: "Kilder",
	threat: "Trussler"
},
	pia: pia$j,
	questions: questions$j,
	rejection_page: rejection_page$j,
	sections: sections$j,
	settings: settings$j,
	summary: summary$j,
	users: users$j,
	validation_page: validation_page$j
};

var about$i = {
	contribute: "Αν θέλετε να συμβάλλετε στη μετάφραση του λογισμικού σε άλλη γλώσσα ή να βελτιώσετε τις υπάρχουσες μεταφράσεις, σας συνιστούμε <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">να διαβάσετε τη σελίδα που περιγράφει τα βήματα που πρέπει να ακολουθήσετε</a>.",
	description: "Αυτό το εργαλείο σχεδιάστηκε αρχικά από την <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, τη γαλλική Αρχή Προστασίας Δεδομένων, για να βοηθήσει τον υπεύθυνο επεξεργασίας προσωπικών δεδομένων να συμμορφωθεί με τον ΓΚΠΔ. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Αυτό το λογισμικό είναι ελεύθερο και ανοιχτό. Αν θέλετε να συμμετάσχετε σε αυτό το έργο, μπορείτε να κατεβάσετε τον πηγαίο κώδικα από το Github, να τον τροποποιήσετε και να τον μοιραστείτε με την κοινότητα.",
	licences: "Άδειες βιβλιοθήκης:",
	title: "Σχετικά με το εργαλείο ΕΑ",
	translators: "Το λογισμικό PIA διατίθεται επί του παρόντος σε δεκαοχτώ γλώσσες. Η γαλλική και η αγγλική εκδοχή παρέχονται από την CNIL. Οι άλλες εκδοχές προκύπτουν από τις συνεισφορές των ακόλουθων ατόμων:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Αριθμός έκδοσης"
};
var action_plan$i = {
	acceptable_measures: "Μέτρα αποδεκτά",
	edit: "Επεξεργασία",
	improvable_measures: "Μέτρα δεκτικά βελτίωσης",
	measures: "Προγραμματισμένα ή υπάρχοντα μέτρα",
	no_action_plan: "Δεν καταγράφηκε κανένα σχέδιο δράσης.",
	placeholder_person_in_charge: "Υπεύθυνος εφαρμογής",
	principles: "Θεμελιώδεις αρχές",
	risk1: "Αθέμιτη πρόσβαση στα προσωπικά δεδομένα",
	risk2: "Ανεπιθύμητη τροποποίηση των προσωπικών δεδομένων",
	risk3: "Εξαφάνιση προσωπικών δεδομένων",
	risks: "Κίνδυνοι",
	title: "Επισκόπηση"
};
var authentication$i = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Αυτό το λογισμικό από τη <strong>Γαλλική Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (CNIL)</strong> έχει σκοπό να καθοδηγήσει τους υπεύθυνους επεξεργασίας στη δημιουργία και απόδειξη συμμόρφωσης στον ΓΚΠΔ. Βοηθάει στην ορθή εκτέλεση μιας εκτίμησης αντικτύπου διευκολύνοντας τη χρήση της μεθόδου ΕΑ που αναπτύχθηκε από την CNIL.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Έναρξη",
	start_app: "Πρόσβαση στην εφαρμογή ΕΑ (Beta)",
	subtitle1: "Μια πλατφόρμα για να δημιουργήσετε <br> και να διαχειριστείτε τις ΕΑ σας",
	subtitle2: "Πρόσβαση στα εργαλεία και το γλωσσάρι",
	title: "Εκτίμηση Αντικτύπου",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$i = {
	important: "Σημαντικό",
	legend1: "Προγραμματισμένα ή υπάρχοντα μέτρα",
	legend2: "Με εφαρμοσμένα τα διορθωτικά μέτρα",
	legend3: "(Α)θέμιτη πρόσβαση στα προσωπικά δεδομένα",
	legend4: "(Μ)η επιθύμητη τροποποίηση των προσωπικών δεδομένων",
	legend5: "(Ε)ξαφάνιση προσωπικών δεδομένων",
	likelihood_axe: "Πιθανότητα κινδύνου",
	limited: "Περιορισμένο",
	maximal: "Μέγιστο",
	negligible: "Αμελητέο",
	risk1_access: "(Α)",
	risk2_modification: "(Μ)",
	seriousness_axe: "Σοβαρότητα κινδύνου"
};
var comments$i = {
	comment: "Σχόλιο",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "σχόλιο/α",
	new_comment: "Σχόλιο",
	placeholder_new_comment: "Αφήστε ένα σχόλιο",
	send: "Αποστολή"
};
var conflict$i = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$i = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$i = {
	content: "Εάν αντιμετωπίζετε άλλα προβλήματα ή εάν έχετε προτάσεις για βελτίωση,<br>μπορείτε να τα στείλετε ξανά μέσω αυτής της φόρμας: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Η σελίδα δεν βρέθηκε."
};
var evaluations$i = {
	acceptable: "Αποδεκτό",
	action_plan_comment: "Σχέδιο δράσης / διορθωτικές ενέργειες",
	evaluation_comment: "Σχόλιο αξιολόγησης",
	gauges: {
		"0": "(Απροσδιόριστη)",
		"1": "Αμελητέα",
		"2": "Περιορισμένη",
		"3": "Σημαντική",
		"4": "Μέγιστη",
		likelihood: "Λαμβάνοντας υπόψη το σχέδιο δράσης, πώς επαναξιολογείτε την <span class='red-highlight'>πιθανότητα αυτού του κινδύνου</span>;",
		seriousness: "Λαμβάνοντας υπόψη το σχέδιο δράσης, πώς επαναξιολογείτε τη <span class='red-highlight'>σοβαρότητα αυτού του κινδύνου</span>;"
	},
	improvable: "Δεκτικό βελτίωσης",
	placeholder_acceptable: "Σύμφωνα με τις διαθέσιμες πληροφορίες, τα μέτρα που εφαρμόζονται είναι επαρκή ώστε να πληρούν σωστά τις απαιτήσεις για την προστασία των δεδομένων.",
	placeholder_improvable1: "Σύμφωνα με τις διαθέσιμες πληροφορίες, πρέπει να εφαρμοστούν πρόσθετα μέτρα προκειμένου να βελτιωθεί η προστασία των δεδομένων της επεξεργασίας.",
	placeholder_improvable2: "Εισάγετε τα σχόλιά σας.",
	placeholder_to_correct: "Οι παρεχόμενες πληροφορίες δεν επαρκούν για την ορθή αξιολόγηση τους. Επιστρέψτε στο πρόγραμμα επεξεργασίας για να βελτιώσετε την αρχική υποβολή.",
	status: [
		"Εκκρεμής",
		"Προς διόρθωση",
		"Δεκτικό βελτίωσης",
		"Αποδεκτό"
	],
	title: "Αξιολόγηση",
	to_correct: "Προς διόρθωση"
};
var header$i = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "Πατήστε F11 για έξοδο από την πλήρη οθόνη.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Παράδειγμα ΕΑ",
		title: "Βοήθεια"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Βάση γνώσεων",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Μεταφράσεις που παρείχε η CNIL",
		community_translations: "Μεταφράσεις που παρείχε η κοινότητα",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Μετάφραση αναθεωρημένη από ευρωπαϊκή ΑΠΔ",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Αρχική έκδοση",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Εκτίμηση αντικτύπου",
	structures: "Υπoδείγματα ΕΑ",
	tools: {
		about: "Σχετικά",
		accessibility: "Προσβασιμότητα με προβλήματα όρασης (χρώματα υψηλής αντίθεσης, δαλτονισμός)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Ρυθμίσεις",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$i = {
	definition: {
		data1: {
			content: "Καταγραφή περιεχομένου",
			title: "Χρησιμοποιείστε το εργαλείο ΑΕ"
		},
		data2: {
			qa1: {
				content: "Όταν αντιμετωπίζετε αυτά τα ζητήματα εμφάνισης στην οθόνη, κλείστε την εφαρμογή και φορτώστε την ξανά. Αυτό συνήθως διορθώνει το πρόβλημα. Δεν θα χάσετε τις πληροφορίες που έχετε εισάγει· αποθηκεύονται αυτόματα καθώς πληκτρολογείτε.",
				title: "Παρουσιάζονται ζητήματα εμφάνισης στην οθόνη, όπως εικονίδια που έχουν κολλήσει σε μια κατάσταση ή στοιχεία που λείπουν από τη διεπαφή"
			},
			qa2: {
				content: "Αυτό το γνωστό πρόβλημα επιδιορθώνεται επί του παρόντος. Εάν αντιμετωπίσετε αυτό το πρόβλημα, σας συνιστούμε να συμπληρώσετε το πεδίο αιτιολόγησης για το εκτιμώμενο επίπεδο σοβαρότητας ή / και πιθανότητας. Θα μπορείτε να επεξεργαστείτε τον δείκτη μόλις επιδιορθωθεί το σφάλμα του προγράμματος.",
				title: "Δεν μπορώ να επεξεργαστώ τους δείκτες μέτρησης για την αξιολόγηση της σοβαρότητας και της πιθανότητας ενός κινδύνου"
			},
			qa3: {
				content: "Αρκετά σφάλματα έχουν παρατηρηθεί κατά την εισαγωγή μιας ΕΑ και, ειδικότερα, οι δείκτες στάθμης για την αξιολόγηση της σοβαρότητας και της πιθανότητας κινδύνου μπορεί να εξαφανιστούν. Σε αυτή την περίπτωση, ανατρέξτε στο παραπάνω θέμα. Εκτός αυτού, ενδέχεται μια ΑΕ να μην εμφανίζεται στον Πίνακα Ελέγχου μετά την εισαγωγή της. Αυτό είναι ένα ζήτημα εμφάνισης και απλά πρέπει να ανανεώσετε τη σελίδα.",
				title: "Αντιμετωπίζω προβλήματα κατά την εισαγωγή μια ΑΕ"
			},
			qa4: {
				content: "Αυτό είναι μόνο ένα σφάλμα εμφάνισης και δεν έχει καμία επίδραση στο κείμενο που εισάγετε σε ένα πεδίο. Αυτό το οπτικό πρόβλημα θα επιδιορθωθεί σύντομα.",
				title: "Όταν αντιγράφω / επικολλάω κείμενο, επισημαίνεται."
			},
			qa5: {
				content: "Για να αξιολογήσετε ένα τμήμα, είναι υποχρεωτικό να συμπληρώσετε όλα τα πεδία. Ελέγξτε αν αυτό όντως έχει γίνει. Κατά την επεξεργασία ενός κινδύνου, πρέπει να έχετε τουλάχιστον ένα τεχνικό ή οργανωτικό μέτρο που μετριάζει τον κίνδυνο για να ζητήσετε αξιολόγηση του κινδύνου.",
				title: "Δεν μπορώ να αξιολογήσω ένα τμήμα"
			},
			qa6: {
				content: "Παρακαλούμε κλείστε την ΕΑ που επεξεργάζεστε και ανοίξτε την εκ νέου. Το περιεχόμενο θα πρέπει στη συνέχεια να εμφανίζεται στη γλώσσα που έχετε επιλέξει.",
				title: "Όταν αλλάζετε γλώσσα, τα κείμενα δεν εμφανίζονται μεταφρασμένα"
			},
			qa7: {
				content: "Προς το παρόν, τα εικονίδια του μενού περιήγησης δεν ανανεώνονται μετά την απόρριψη μιας ΕΑ. Πρέπει να ελέγξετε κάθε τμήμα και να αλλάξετε τις πληροφορίες και / ή την αξιολόγηση σύμφωνα με τους λόγους απόρριψης της ΕΑ. Αφού επανεξεταστούν όλες οι ενότητες, θα πρέπει να μπορείτε να ζητήσετε ξανά την επικύρωση της ΕΑ.",
				title: "Έχω αρνηθεί να επικυρώσω μια ΕΑ αλλά δεν ξέρω τι να κάνω τώρα"
			},
			title: "Γνωστά Προβλήματα"
		},
		footer: "Αν έχετε οποιαδήποτε άλλα προβλήματα ή υποδείξεις βελτίωσης, μπορείτε να τα στείλετε σε μας μέσω αυτής της φόρμας <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Βοήθεια"
};
var homepage$i = {
	cards: {
		author: "Επεξεργασία",
		category: "TO TRANSLATE - Category",
		creation_status: "Δημιουργία",
		date: "Ημερομηνία",
		evaluation: "Αξιολόγηση",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Εισαγωγή ΕΑ",
		import_structure: "Εισαγωγή υποδείγματος",
		item: {
			consult_pia: "Συμβουλευθείτε την",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Επεξεργασία",
			edit_structure: "Επεξεργασία υποδείγματος",
			tools: {
				action_plan: "Εμφάνιση<br>σχεδίου δράσης",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Διπλότυπο",
				"export": "Εξαγωγή",
				more_options: "Περισσότερες επιλογές",
				pia: "Εμφάνιση<br>ΕΑ",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Νέα ΕΑ",
		new_structure: "Νέο υπόδειγμα",
		or: "ή",
		pia_name: "ΕΑ",
		placeholder_author: "Όνομα, επίθετο",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Όνομα, επίθετο",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Εισαγωγή ΕΑ",
		placeholder_import_structure: "Εισαγωγή υποδείγματος",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Νέα ΕΑ",
		placeholder_new_structure: "Νέο υπόδειγμα",
		placeholder_pia_name: "Τίτλος ΕΑ",
		placeholder_sector_name: "Όνομα σχετικού τομέα",
		placeholder_start: "Όλα τα πεδία πρέπει να συμπληρωθούν",
		placeholder_structure: "Προεπιλεγμένο υπόδειγμα",
		placeholder_structure_name: "Τίτλος υποδείγματος",
		placeholder_validation: "Όνομα, επίθετο",
		sector_name: "Σχετικός τομέας",
		start: "Έναρξη",
		status: "Κατάσταση",
		structure: "Υπόδειγμα",
		structure_name: "Όνομα υποδείγματος",
		title_close_creation: "Κλείσιμο",
		validation: "Επικύρωση"
	},
	filters: {
		assessor: "Αξιολογητής",
		author: "Συντάκτης",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Αρχίστε !<br><br>Για να ξεκινήσετε μια ΕΑ,<br> κάντε κλικ στο Νέα ΕΑ",
		card_rocket_content_structure: "Αρχίστε ! Για να ξεκινήσετε <br>ένα υπόδειγμα, κάντε κλικ στο +",
		category: "TO TRANSLATE - Category",
		date: "Ημερομηνία",
		import_pia: "Εισαγωγή ΕΑ",
		import_structure: "Εισαγωγή υποδείγματος",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Αρχίστε ! Για να ξεκινήσετε <br>μια ΕΑ, κάντε κλικ στο +",
		list_rocket_content_structure: "Αρχίστε ! Για να ξεκινήσετε <br>ένα υπόδειγμα, κάντε κλικ στο +",
		name: "Όνομα",
		new_pia: "Νέα ΕΑ",
		new_structure: "Νέο υπόδειγμα",
		sector_name: "Σχετικός τομέας",
		sort: "Ταξινόμηση",
		sort_by: "κατά",
		status: "Κατάσταση",
		validator: "Επικυρών"
	},
	lists: {
		column_actions: "Ενέργειες",
		column_author: "Σύνταξη",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Δημιουργία",
		column_evaluation: "Αξιολόγηση",
		column_pia: "ΕΑ",
		column_progression: "Πρόοδος",
		column_sector_name: "Σχετικός τομέας",
		column_status: "Κατάσταση",
		column_structure: "Υπόδειγμα",
		column_structure_name: "Υπόδειγμα",
		column_updated_at: "Τελευταίο άνοιγμα",
		column_validation: "Επικύρωση",
		item: {
			tools: {
				action_plan: "Εμφάνιση σχεδίου δράσης",
				archive: "TO TRANSLATE - Archive",
				consult: "Συμβουλή",
				duplicate: "Δημιουργία διπλότυπου",
				edit: "Επεξεργασία",
				"export": "Εξαγωγή",
				pia: "Εμφάνιση ΕΑ",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$i = {
	add_measure: "Προσθήκη",
	add_measure_hint: "Μπορείτε επίσης να προσθέσετε ένα μέτρο από τη γνωσιακή βάση.",
	category: {
		definition: "Ορισμός",
		example: "Παράδειγμα",
		general_measure: "Μέτρο ασφαλείας του συστήματος",
		measure_on_data: "Μέτρο για τα δεδομένα",
		method: "Μεθοδολογία",
		organizational_measure: "Οργανωτικό μέτρο",
		principle: "Αρχή"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Όλα",
		definitions: "Ορισμοί",
		general_measures: "Μέτρα ασφαλείας του συστήματος",
		measures_on_data: "Μέτρα για τα δεδομένα",
		no_result: "Δεν βρέθηκε αποτέλεσμα.",
		organizational_measures: "Οργανωτικά μέτρα",
		title: "Φίλτρα"
	},
	placeholder_add_measure: "Προσθήκη αυτού του μέτρου",
	placeholder_help: "Βοηθήματα εισαγωγής",
	search: "Αναζήτηση",
	slugs: {
		PIA_DEF_ACC: {
			description: " Το υποκείμενο των δεδομένων έχει το δικαίωμα να λαμβάνει από τον υπεύθυνο επεξεργασίας επιβεβαίωση για το κατά πόσον ή όχι τα δεδομένα προσωπικού χαρακτήρα που το αφορούν υφίστανται επεξεργασία και, εάν συμβαίνει τούτο, το δικαίωμα πρόσβασης στα δεδομένα προσωπικού χαρακτήρα και στις πληροφορίες που περιγράφονται στο <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 15 του [ΓΚΔΠ]</a>",
			name: "Δικαίωμα πρόσβασης του υποκειμένου των δεδομένων",
			source: "ΓΚΠΔ Άρθ. 15"
		},
		PIA_DEF_ANO: {
			description: "Διαδικασία αφαίρεσης των χαρακτηριστικών ταυτοποίησης από προσωπικά δεδομένα. Για να αξιολογήσετε την ανθεκτικότητα των διαδικασιών ανωνυμοποίησης, ανατρέξτε στις <a target=\"_blank\" href=\"https://cnpd.public.lu/content/dam/cnpd/fr/publications/groupe-art29/wp216_en.pdf\">κατευθυντήριες γραμμές της ΟΕ29</a>.",
			name: "Ανωνυμοποίηση",
			source: "Measures_US and G29 guidelines https://cnpd.public.lu/content/dam/cnpd/fr/publications/groupe-art29/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Διαδικασίες διατήρησης και διαχείρισης των ηλεκτρονικών αρχείων που περιέχουν τα προσωπικά δεδομένα που αποσκοπούν στη διασφάλιση της αξίας τους (συγκεκριμένα, της νομικής τους αξίας) καθόλη τη διάρκεια της αναγκαίας περιόδου (μεταφορά, αποθήκευση, μετανάστευση, διαθεσιμότητα, εξάλειψη, πολιτική αρχειοθέτησης, προστασία εχεμύθειας, κ.λπ.",
			name: "Αρχειοθέτηση",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Κάθε πρόσωπο με νόμιμη πρόσβαση σε προσωπικά δεδομένα (εργαζόμενοι, συμβαλλόμενα μέρη και άλλα τρίτα μέρη) θα πρέπει να αναγνωρίζεται με ένα μοναδικό αναγνωριστικό. Επιλέξτε μια μέθοδο ελέγχου ταυτότητας για να ανοίξετε τις περιόδους σύνδεσης που είναι κατάλληλες για το περιβάλλον, το επίπεδο κινδύνου και την αναμενόμενη αντοχή. Συστάσεις: Εάν οι κίνδυνοι δεν είναι αυξημένοι, μπορεί να χρησιμοποιηθεί ένας κωδικός πρόσβασης. Ωστόσο, εάν οι κίνδυνοι είναι υψηλότεροι, χρησιμοποιήστε ένα κωδικό μίας χρήσης για κωδικό πρόσβασης αλλά αλλάξτε τον προεπιλεγμένο κωδικό ενεργοποίησης ή όταν αποστέλλεται με SMS ένα μέρος του κωδικού, μια κάρτα με κωδικό PIN, ηλεκτρονικό πιστοποιητικό ή οποιαδήποτε άλλη μορφή ισχυρής πιστοποίησης ταυτότητας.",
			name: "Πιστοποίηση ταυτότητας",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Μέτρο που καθιστά τα προσωπικά δεδομένα ακατανόητα σε οποιονδήποτε χωρίς άδεια πρόσβασης (συμμετρική ή ασύμμετρη κρυπτογράφηση, χρήση δημόσιων αλγορίθμων που είναι αναγνωρισμένα ισχυροί, πιστοποιητικό ελέγχου ταυτότητας, κ.λπ.).",
			name: "Κρυπτογράφηση",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Μέθοδοι οργάνωσης δεδομένων που μειώνουν την πιθανότητα συσχέτισης των προσωπικών δεδομένων και παραβίασης όλων των προσωπικών δεδομένων. Για παράδειγμα, με το να προσδιοριστούν τα προσωπικά δεδομένα που είναι χρήσιμα μόνο για την κάθε επιχειρηματική διαδικασία και με το να διαχωριστούν αυτά λογικά.",
			name: "Διαχωρισμός των δεδομένων",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Οποιαδήποτε ελεύθερη, συγκεκριμένη, ρητή και εν πλήρει επιγνώσει ένδειξη της συμφωνίας του υποκειμένου των δεδομένων υπέρ της επεξεργασίας των δεδομένων που το αφορούν, για παράδειγμα με γραπτή δήλωση, μεταξύ άλλων με ηλεκτρονικά μέσα, ή με προφορική δήλωση.<br>Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 4.10 του [ΓΚΔΠ]</a>",
			name: "Συγκατάθεση",
			source: "ΓΚΠΔ Άρθ. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Μέσα που εφαρμόζονται για τον περιορισμό των κινδύνων ότι μη εξουσιοδοτημένα πρόσωπα θα αποκτήσουν, ηλεκτρονικά, πρόσβαση σε προσωπικά δεδομένα. Απαιτεί μεταξύ άλλων:<br>- <strong>διαχείριση προφίλ χρηστών</strong> διαχωρίζοντας τα καθήκοντα και τους τομείς ευθύνης (κατά προτίμηση με κεντρικό τρόπο), προκειμένου η πρόσβαση στα προσωπικά δεδομένα να περιοριστεί αποκλειστικά στους χρήστες που είναι απολύτως απαραίτητο να τα γνωρίζουν για την εκτέλεση των καθηκόντων τους και με τη διαβάθμιση προνομίων πρόσβασης. <br> - <strong> κατάργηση των δικαιωμάτων πρόσβασης σε εργαζόμενους, συμβαλλόμενους και άλλους τρίτους όταν δεν έχουν πλέον άδεια πρόσβασης σε χώρο ή σε πόρο</strong> ή όταν λήξει η σύμβαση εργασίας τους</strong>.",
			name: "Μέτρα λογικής πρόσβασης",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Κάθε πληροφορία που αφορά ταυτοποιημένο ή ταυτοποιήσιμο φυσικό πρόσωπο («υποκείμενο των δεδομένων»)· το ταυτοποιήσιμο φυσικό πρόσωπο είναι εκείνο του οποίου η ταυτότητα μπορεί να εξακριβωθεί, άμεσα ή έμμεσα, ιδίως μέσω αναφοράς σε αναγνωριστικό στοιχείο ταυτότητας, όπως όνομα, σε αριθμό ταυτότητας, σε δεδομένα θέσης, σε επιγραμμικό αναγνωριστικό ταυτότητας ή σε έναν ή περισσότερους παράγοντες που προσιδιάζουν στη σωματική, φυσιολογική, γενετική, ψυχολογική, οικονομική, πολιτιστική ή κοινωνική ταυτότητα του εν λόγω φυσικού προσώπου. <br>Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 4.1 του [ΓΚΔΠ]</a>",
			name: "Δεδομένα προσωπικού χαρακτήρα",
			source: "ΓΚΠΔ Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Το φυσικό ή νομικό πρόσωπο, η δημόσια αρχή, η υπηρεσία ή άλλος φορέας, στα οποία κοινολογούνται τα δεδομένα προσωπικού χαρακτήρα, είτε πρόκειται για τρίτον είτε όχι. Ωστόσο, οι δημόσιες αρχές που ενδέχεται να λάβουν δεδομένα προσωπικού χαρακτήρα στο πλαίσιο συγκεκριμένης έρευνας σύμφωνα με το δίκαιο της Ένωσης ή κράτους μέλους δεν θεωρούνται ως αποδέκτες· η επεξεργασία των δεδομένων αυτών από τις εν λόγω δημόσιες αρχές πραγματοποιείται σύμφωνα με τους ισχύοντες κανόνες προστασίας των δεδομένων ανάλογα με τους σκοπούς της επεξεργασίας. <br>Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 4.9 του [ΓΚΔΠ]</a>",
			name: "Αποδέκτης",
			source: "ΓΚΠΔ Άρθ. 4.9"
		},
		PIA_DEF_EFF: {
			description: " Το υποκείμενο των δεδομένων έχει το δικαίωμα να ζητήσει από τον υπεύθυνο επεξεργασίας τη διαγραφή δεδομένων προσωπικού χαρακτήρα που το αφορούν χωρίς αδικαιολόγητη καθυστέρηση και ο υπεύθυνος επεξεργασίας υποχρεούται να διαγράψει δεδομένα προσωπικού χαρακτήρα χωρίς αδικαιολόγητη καθυστέρηση, βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 17 του [ΓΚΔΠ]</a>",
			name: "Δικαίωμα διαγραφής",
			source: "ΓΚΠΔ Άρθ. 17"
		},
		PIA_DEF_ENJ: {
			description: "Αναμενόμενα οφέλη (για τον οργανισμό, για τα υποκείμενα των δεδομένων, για την κοινωνία εν γένει, κ.λπ.).",
			name: "Διακυβεύματα",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Τα προσωπικά δεδομένα πρέπει να είναι ακριβή και, όταν είναι αναγκαίο, επικαιροποιούνται· πρέπει να λαμβάνονται όλα τα εύλογα μέτρα για την άμεση διαγραφή ή διόρθωση δεδομένων προσωπικού χαρακτήρα τα οποία είναι ανακριβή, σε σχέση με τους σκοπούς της επεξεργασίας («ακρίβεια»). <br>Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 5.1 δ) του [ΓΚΔΠ]</a>",
			name: "Ποιότητα δεδομένων",
			source: "ΓΚΠΔ Άρθ. 5.1 δ)"
		},
		PIA_DEF_GRV: {
			description: "Η σοβαρότητα αντιπροσωπεύει το μέγεθος ενός κινδύνου. Εξαρτάται κυρίως από την ζημιογόνο φύση των πιθανών επιπτώσεων.",
			name: "Σοβαρότητα",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: " Το υποκείμενο των δεδομένων δικαιούται να εξασφαλίζει από τον υπεύθυνο επεξεργασίας τον περιορισμό της επεξεργασίας, βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 18 του [ΓΚΔΠ]</a>",
			name: "Δικαίωμα περιορισμού της επεξεργασίας",
			source: "ΓΚΠΔ Άρθ. 18"
		},
		PIA_DEF_LOG: {
			description: "Ορίστε μια αρχιτεκτονική καταγραφής που θα επιτρέψει την έγκαιρη ανίχνευση περιστατικών που αφορούν δεδομένα προσωπικού χαρακτήρα και θα έχει πληροφορίες που μπορούν να χρησιμοποιηθούν για την ανάλυσή τους ή για την παροχή αποδείξεων σε σχέση με έρευνες.",
			name: "Παρακολούθηση",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Διαδικασία που συνίσταται σε μία ή περισσότερες μεμονωμένες ενέργειες επί των υποστηρικτικών στοιχείων των προσωπικών δεδομένων. Χρησιμοποιείται εκ προθέσεως ή ακούσια από πηγές κινδύνου και μπορεί να προκαλέσει ένα επαπειλούμενο γεγονός.",
			name: "Απειλή",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Απειλές σχετικά με: - <strong>Τεχνολογικό υλικό</ strong>, που χρησιμοποιείται ακατάλληλα, βρίσκεται υπό παρακολούθηση, έχει δεχθεί τροποποίηση, έχει χαθεί (χρήση ή μεταφορά ευαίσθητου τεχνολογικού υλικού για προσωπικούς σκοπούς, παρακολούθηση της οθόνης ενός ατόμου χωρίς τη γνώση τους ενώ βρίσκεστε σε αμαξοστοιχία, παρακολούθηση μέσω ενός καταγραφέα πληκτρολόγησης που βασίζεται σε τεχνολογικό υλικό, κλπ.)<br> - <strong>Λογισμικό </strong>, που χρησιμοποιείται ακατάλληλα, βρίσκεται υπό παρακολούθηση, έχει δεχθεί τροποποίηση (αύξηση προνομίων, συλλογή δεδομένων διαμόρφωσης, μόλυνση από κακόβουλο κώδικα, κ.λπ.)<br>- <strong>Δίαυλοι υπολογιστών</strong> που παρακολουθούνται (Παρακολούθηση της κίνησης Ethernet, κ.λπ.)<br> - <strong>Άτομα</ strong> που παρακολουθούνται, χειραγωγούνται, εκλείπουν (ακούσια αποκάλυψη πληροφοριών, κοινωνική μηχανική, αλλαγή θέσης ή εργοδότη, κ.λπ.)<br>- <strong>Έντυπα έγγραφα</strong> που παρατηρούνται, έχουν χαθεί (ανάγνωση, κλοπή αλληλογραφίας, φωτοτυπίες, ξεχασμένες εκτυπώσεις, ανάκτηση απορριφθέντων εγγράφων, κλπ.)<br>- <strong>Κανάλια μετάδοσης χαρτιού</strong> που παρακολουθούνται (ανάγνωση βιβλίων υπογραφών σε κυκλοφορία, κ.λπ.)",
			name: "Απειλές που μπορούν να οδηγήσουν σε αθέμιτη πρόσβαση",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Απειλές σχετικά με: </strong><br>- <strong>Τεχνολογικό υλικό</strong> που χρησιμοποιείται με μη ενδεικνυόμενο τρόπο, έχει υπερφορτωθεί, έχει δεχθεί τροποποίηση, έχει υποστεί ζημιά, έχει χαθεί (γεμάτη μονάδα αποθήκευσης, υπερφόρτωση χωρητικότητας επεξεργασίας, προσθήκη ασυμβίβαστου υλικού που έχει ως αποτέλεσμα δυσλειτουργίες, πυρκαγιά, κλοπή ή απώλεια ενός περιουσιακού στοιχείου, κ.λπ.)<br>- <strong>Λογισμικό</strong>: που χρησιμοποιείται με μη ενδεικνυόμενο τρόπο, έχει υπερφορτωθεί, έχει δεχθεί τροποποίηση, έχει υποστεί ζημιά, έχει χαθεί (διαγραφή δεδομένων, υπέρβαση του μεγέθους της βάσης δεδομένων, λογική βόμβα, μη ανανέωση της άδειας χρήσης λογισμικού που χρησιμοποιείται για την πρόσβαση σε δεδομένα, κ.λπ.)<br>- <strong>Δίαυλοι υπολογιστών</strong>: που έχουν υπερφορτωθεί, έχουν δεχθεί τροποποίηση, έχουν χαθεί (μη εξουσιοδοτημένη λήψη, απώλεια σύνδεσης με το Διαδίκτυο, κ.λπ.)<br>- <strong>Άτομα</strong>: που έχουν υπερφορτωθεί, έχουν ζημιωθεί, έχουν χαθεί (κακή χρήση δεξιοτήτων, ασθένειες, συνταξιοδότηση, κλπ.)<br>- <strong>Έντυπα έγγραφα</strong>: που χρησιμοποιούνται με μη ενδεικνυόμενο τρόπο, έχουν υποστεί ζημιές, έχουν χαθεί (διαγραφή, παλαίωση αρχειοθετημένων εγγράφων, κλοπή ή απώλεια εγγράφων, κ.λπ.)<br>- <strong>Κανάλια μετάδοσης χαρτιού</strong>: που έχουν υπερφορτωθεί, έχουν υποστεί ζημιές, έχουν τροποποιηθεί, έχουν χαθεί (παράδοση ταχυδρομείου που σταμάτησε λόγω απεργίας, αλλαγή θέσεων εργασίας ή χώρων, απώλεια μιας εταιρείας παράδοσης εγγράφων, αναδιοργάνωση των καναλιών μετάδοσης χαρτιού, κ.λπ.)",
			name: "Απειλές που μπορούν να οδηγήσουν σε εξαφάνιση προσωπικών δεδομένων",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Απειλές σχετικά με: </strong><br>- <strong>Τεχνολογικό υλικό</strong> που έχει δεχθεί τροποποίηση (προσθήκη ασύμβατου υλικού που έχει ως αποτέλεσμα δυσλειτουργίες, αφαίρεση ουσιωδών εξαρτημάτων, κ.λπ.)<br>- <strong>Λογισμικό</strong> που χρησιμοποιείται με μη ενδεικνυόμενο τρόπο ή αλλοιωμένο (Ανεπιθύμητες τροποποιήσεις δεδομένων σε βάσεις δεδομένων, σφάλματα χειριστών που τροποποιούν δεδομένα, κ.λπ.)<br>- <strong>>Δίαυλοι υπολογιστών</strong> που χρησιμοποιούνται με μη ενδεικνυόμενο τρόπο (επανεκπομπή δεδομένων που έχουν υποκλαπεί, κ.λπ.)<br>- <strong>Άτομα</strong> υπερφορτωμένα ή χειραγωγημένα (ανάθεση σε προσωπικό καθηκόντων πέρα από τις ικανότητές του, άγχος ή αρνητικές αλλαγές στις συνθήκες εργασίας, επήρεια, κ.λπ.)<br>- <strong>Έντυπα έγγραφα</strong> που έχουν τροποποιηθεί (μεταβολές σε αριθμητικά στοιχεία μέσα σε ένα αρχείο, αντικατάσταση ενός πρωτοτύπου με ένα πλαστό, κ.λπ.)<br>- <strong>Κανάλια μετάδοσης χαρτιού</strong> που έχουν τροποποιηθεί (αλλαγή από ένα βιβλίο υπογραφής σε άλλο, αποστολή πολλαπλών αντικρουόμενων εγγράφων, κ.λπ.)",
			name: "Απειλές που μπορούν να οδηγήσουν σε ανεπιθύμητη τροποποίηση των προσωπικών δεδομένων",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Διαλογή μεταξύ αυτών που διατίθενται στην ενότητα \"Προγραμματιζόμενα ή υπάρχοντα μέτρα\", τα οποία μπορείτε να συμπληρώσετε εάν χρειάζεται.",
			name: "Μέτρα",
			source: "Καμία"
		},
		PIA_DEF_MIN1: {
			description: "Όταν εισάγονται δεδομένα, μπορούν να συλλεχθούν ακούσια διαφορετικοί τύποι μεταδεδομένων (όπως τα δεδομένα EXIF με συνημμένο αρχείο εικόνας). <br>Τέτοια μεταδεδομένα πρέπει να αναγνωρίζονται και να εξαλείφονται εάν δεν είναι απαραίτητα για τους καθορισμένους σκοπούς.",
			name: "Φιλτράρισμα και αφαίρεση",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Μόλις ληφθούν ευαίσθητα δεδομένα, ως μέρος μιας σειράς γενικών πληροφοριών ή διαβιβασθούν μόνο για στατιστικούς σκοπούς, αυτά μπορούν να μετατραπούν σε λιγότερο ευαίσθητη μορφή ή σε ψευδώνυμοποιημένα. Για παράδειγμα: <br>- εάν το σύστημα συλλέγει τη διεύθυνση IP για να καθορίσει τη θέση του χρήστη για στατιστικούς σκοπούς, η διεύθυνση IP μπορεί να διαγραφεί μόλις συμπεραίνεται η πόλη ή η περιοχή<br>- εάν το σύστημα λαμβάνει δεδομένα βίντεο από κάμερες παρακολούθησης, μπορεί να αναγνωρίσει τους ανθρώπους που στέκονται ή κινούνται στη σκηνή και να τους θολώσει<br>- εάν το σύστημα είναι ένας έξυπνος μετρητής, μπορεί να συγκεντρώσει τη χρήση ενέργειας κατά μια ορισμένη χρονική περίοδο, χωρίς να την καταγράψει σε πραγματικό χρόνο",
			name: "Μείωση της ευαισθησίας μέσω μετατροπής",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Το σύστημα μπορεί να διασφαλίσει ότι: <br>- ο χρήστης μπορεί να χρησιμοποιήσει έναν πόρο ή μια υπηρεσία χωρίς τον κίνδυνο αποκάλυψης της ταυτότητάς του (ανώνυμα δεδομένα)<br>- ο χρήστης μπορεί να χρησιμοποιήσει έναν πόρο ή μια υπηρεσία χωρίς τον κίνδυνο αποκάλυψης της ταυτότητάς του, αλλά παραμένει προσδιορίσιμος και υπεύθυνος για αυτήν τη χρήση (ψευδώνυμα δεδομένα)<br>- ο χρήστης μπορεί να κάνει πολλαπλές χρήσεις πόρων ή υπηρεσιών χωρίς τον κίνδυνο να συνδέονται αυτές οι διαφορετικές χρήσεις (τα δεδομένα δεν μπορούν να συσχετιστούν)<br>- ο χρήστης μπορεί να χρησιμοποιήσει έναν πόρο ή μια υπηρεσία χωρίς τον κίνδυνο άλλοι, ιδιαίτερα τρίτοι, να μπορούν να παρατηρήσουν ότι ο πόρος ή η υπηρεσία χρησιμοποιείται (μη παρατηρησιμότητα)<br>Η επιλογή μιας μεθόδου από τον παραπάνω κατάλογο πρέπει να γίνεται με βάση τις απειλές που εντοπίστηκαν. Για ορισμένους τύπους απειλών κατά της ιδιωτικής ζωής, η ψευδωνυμοποίηση θα είναι πιο κατάλληλη από την ανωνυμία (για παράδειγμα, αν υπάρχει ανάγκη ανίχνευσης). Επιπλέον, ορισμένες απειλές κατά της ιδιωτικής ζωής θα αντιμετωπιστούν χρησιμοποιώντας έναν συνδυασμό μεθόδων.",
			name: "Μείωση της προσδιοριστικής φύσης των προσωπικών δεδομένων",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Το σύστημα μπορεί να οργανωθεί σε ανεξάρτητα μέρη με ξεχωριστές λειτουργίες ελέγχου πρόσβασης. Τα προσωπικά δεδομένα μπορούν επίσης να διαιρεθούν μεταξύ αυτών των ανεξάρτητων υποσυστημάτων και να ελέγχονται από κάθε υποσύστημα χρησιμοποιώντας διαφορετικούς μηχανισμούς ελέγχου πρόσβασης. Σε περίπτωση που εκτεθεί ένα υποσύστημα, οι επιπτώσεις σε όλα τα δεδομένα μπορούν με αυτόν τον τρόπο να μειωθούν.",
			name: "Μείωση της συσσώρευσης προσωπικών δεδομένων",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Το σύστημα μπορεί να περιορίσει την πρόσβαση σε δεδομένα σύμφωνα με την αρχή του «απολύτως απαραίτητου της γνώσης». Το σύστημα μπορεί να διαχωρίσει τα ευαίσθητα προσωπικά δεδομένα και να εφαρμόσει συγκεκριμένες πολιτικές ελέγχου πρόσβασης. Το σύστημα μπορεί επίσης να κρυπτογραφήσει ευαίσθητα προσωπικά δεδομένα για να προστατεύσει την εμπιστευτικότητα τους κατά τη μεταφορά και αποθήκευση. Η πρόσβαση σε προσωρινά cookies που παράγονται κατά τη διάρκεια της επεξεργασίας προσωπικών δεδομένων πρέπει επίσης να προστατεύεται.",
			name: "Περιορισμός πρόσβασης στα προσωπικά δεδομένα",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Μειώστε τη σοβαρότητα των κινδύνων περιορίζοντας την ποσότητα των προσωπικών δεδομένων σε αυτό που είναι απολύτως απαραίτητο για την επίτευξη ενός καθορισμένου σκοπού, αλλιώς τα δεδομένα δεν συλλέγονται.",
			name: "Ελαχιστοποίηση του αριθμού των δεδομένων προσωπικού χαρακτήρα",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Μειώστε τη σοβαρότητα των κινδύνων με την ελαχιστοποίηση των ίδιων των δεδομένων, με τη λήψη μέτρων που αποσκοπούν στη μείωση της ευαισθησίας τους, όπως το φιλτράρισμα και την αφαίρεση περιττών δεδομένων, την ψευδωνυμοποίηση δεδομένων, κ.λπ..",
			name: "Ελαχιστοποίηση των ίδιων των δεδομένων",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Το υποκείμενο των δεδομένων δικαιούται να αντιτάσσεται, ανά πάσα στιγμή και για λόγους που σχετίζονται με την ιδιαίτερη κατάστασή του, στην επεξεργασία δεδομένων προσωπικού χαρακτήρα που το αφορούν,σύμφωνα με το <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 21 του [ΓΚΔΠ]</a>",
			name: "Δικαίωμα εναντίωσης",
			source: "ΓΚΠΔ Άρθ. 21"
		},
		PIA_DEF_PBDS: {
			description: "Μέτρα που έχουν ληφθεί για την ενσωμάτωση της προστασίας των δεδομένων προσωπικού χαρακτήρα σε όλες τις νέες εργασίες επεξεργασίας (πιστοποιήσεις, κατευθυντήριες γραμμές, μεθοδολογία CNIL για τη διαχείριση κινδύνου ή άλλη εσωτερική μεθοδολογία).",
			name: "Διαχείριση έργου",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Πρόσωπο στο οποίο αναφέρονται τα δεδομένα που καλύπτονται από την επεξεργασία.",
			name: "Υποκείμενο δεδομένων",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: "Το υποκείμενο των δεδομένων έχει το δικαίωμα να λαμβάνει τα δεδομένα προσωπικού χαρακτήρα που το αφορούν, και τα οποία έχει παράσχει σε υπεύθυνο επεξεργασίας, σε δομημένο, κοινώς χρησιμοποιούμενο και αναγνώσιμο από μηχανήματα μορφότυπο, καθώς και το δικαίωμα να διαβιβάζει τα εν λόγω δεδομένα σε άλλον υπεύθυνο επεξεργασίας χωρίς αντίρρηση από τον υπεύθυνο επεξεργασίας στον οποίο παρασχέθηκαν τα δεδομένα προσωπικού χαρακτήρα, βλέπετε το <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 20 του [ΓΚΔΠ]</a>",
			name: "Δικαίωμα στη φορητότητα των δεδομένων",
			source: "ΓΚΠΔ Άρθ. 20"
		},
		PIA_DEF_PSEU: {
			description: "Επεξεργασία δεδομένων προσωπικού χαρακτήρα κατά τρόπο ώστε τα δεδομένα να μην μπορούν πλέον να αποδοθούν σε συγκεκριμένο υποκείμενο των δεδομένων χωρίς τη χρήση συμπληρωματικών πληροφοριών, εφόσον οι εν λόγω συμπληρωματικές πληροφορίες διατηρούνται χωριστά και υπόκεινται σε τεχνικά και οργανωτικά μέτρα προκειμένου να διασφαλιστεί ότι δεν μπορούν να αποδοθούν σε ταυτοποιημένο ή ταυτοποιήσιμο φυσικό πρόσωπο.<br>Η ψευδωνυμοποίηση μειώνει τη δυνατότητα σύνδεσης ενός συνόλου δεδομένων με την αρχική ταυτότητα ενός υποκειμένου δεδομένων· ως τέτοιο, είναι ένα χρήσιμο μέτρο ασφαλείας αλλά όχι μια μέθοδος ανωνυμοποίησης.",
			name: "Ψευδωνυμοποίηση",
			source: "ΓΚΠΔ Άρθ. 4.5 and guidelines G29 p22 https://cnpd.public.lu/content/dam/cnpd/fr/publications/groupe-art29/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Οι κωδικοί πρόσβασης αποτελούνται από τουλάχιστον οκτώ χαρακτήρες· πρέπει να ανανεώνονται εάν υπάρχει η ελάχιστη ανησυχία ότι ενδέχεται να έχουν τεθεί σε κίνδυνο και, ενδεχομένως, περιοδικά (κάθε έξι μήνες ή μία φορά το χρόνο) και πρέπει να περιλαμβάνουν τουλάχιστον τρία από τα τέσσερα είδη χαρακτήρων (κεφαλαία γράμματα, μικρά γράμματα, αριθμούς και ειδικούς χαρακτήρες). Όταν αλλάξει ένας κωδικός πρόσβασης, οι τελευταίοι πέντε κωδικοί πρόσβασης δεν επιτρέπεται να επαναχρησιμοποιηθούν· ο ίδιος κωδικός πρόσβασης δεν πρέπει να χρησιμοποιείται για διαφορετικές προσβάσεις· οι κωδικοί πρόσβασης δεν πρέπει να σχετίζονται με τα προσωπικά σας στοιχεία (συμπεριλαμβανομένου του ονόματος ή της ημερομηνίας γέννησης.). Καθορίστε έναν μέγιστο αριθμό προσπαθειών πέραν του οποίου εκδίδεται μια προειδοποίηση και αποκλείεται ο έλεγχος ταυτότητας (προσωρινά ή μέχρι να ξεκλειδωθεί χειροκίνητα).",
			name: "Κωδικός πρόσβασης",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Το υποκείμενο των δεδομένων έχει το δικαίωμα να απαιτήσει από τον υπεύθυνο επεξεργασίας χωρίς αδικαιολόγητη καθυστέρηση τη διόρθωση ανακριβών δεδομένων προσωπικού χαρακτήρα που το αφορούν. Έχοντας υπόψη τους σκοπούς της επεξεργασίας, το υποκείμενο των δεδομένων έχει το δικαίωμα να απαιτήσει τη συμπλήρωση ελλιπών δεδομένων προσωπικού χαρακτήρα, μεταξύ άλλων μέσω συμπληρωματικής δήλωσης.",
			name: "Δικαίωμα διόρθωσης",
			source: "ΓΚΠΔ Άρθ. 16"
		},
		PIA_DEF_RGPD: {
			description: "Κανονισμός για την προστασία των φυσικών προσώπων έναντι της επεξεργασίας των δεδομένων προσωπικού χαρακτήρα και για την ελεύθερη κυκλοφορία των δεδομένων αυτών και την κατάργηση της οδηγίας 95/46/ΕΚ.",
			name: "ΓΚΠΔ (Γενικός Κανονισμός για την Προστασία Δεδομένων)",
			source: "Τίτλος ΓΚΠΔ"
		},
		PIA_DEF_RT: {
			description: "Το φυσικό ή νομικό πρόσωπο, η δημόσια αρχή, η υπηρεσία ή άλλος φορέας που, μόνα ή από κοινού με άλλα, καθορίζουν τους σκοπούς και τον τρόπο της επεξεργασίας δεδομένων προσωπικού χαρακτήρα· όταν οι σκοποί και ο τρόπος της επεξεργασίας αυτής καθορίζονται από το δίκαιο της Ένωσης ή το δίκαιο κράτους μέλους, ο υπεύθυνος επεξεργασίας ή τα ειδικά κριτήρια για τον διορισμό του μπορούν να προβλέπονται από το δίκαιο της Ένωσης ή το δίκαιο κράτους μέλους.<br>Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 4.7 του [ΓΚΔΠ]</a>",
			name: "Υπεύθυνος επεξεργασίας",
			source: "ΓΚΠΔ Άρθ. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Πρόσωπο ή μη ανθρώπινη πηγή που μπορεί να προκαλέσει κίνδυνο. Αυτή η πηγή μπορεί να ενεργήσει κατά λάθος ή σκόπιμα.",
			name: "Πηγή κινδύνου",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "φυσικό ή νομικό πρόσωπο, η δημόσια αρχή, η υπηρεσία ή άλλος φορέας που επεξεργάζεται δεδομένα προσωπικού χαρακτήρα για λογαριασμό του υπευθύνου της επεξεργασίας, βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 4.8 του [ΓΚΔΠ]</a>.<br>Ο εκτελών την επεξεργασία και κάθε πρόσωπο που ενεργεί υπό την εποπτεία του υπευθύνου επεξεργασίας ή του εκτελούντος την επεξεργασία, το οποίο έχει πρόσβαση σε δεδομένα προσωπικού χαρακτήρα, επεξεργάζεται τα εν λόγω δεδομένα μόνον κατ’ εντολή του υπευθύνου επεξεργασίας, εκτός εάν υποχρεούται προς τούτο από το δίκαιο της Ένωσης ή του κράτους μέλους, βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 29 του [ΓΚΔΠ]</a>.",
			name: "Εκτελών την επεξεργασία",
			source: "ΓΚΠΔ Άρθ. 4.8 και 29"
		},
		PIA_DEF_SUPT: {
			description: "Στοιχεία πάνω στα οποία στηρίζονται προσωπικά δεδομένα. Μπορεί να είναι τεχνολογικό υλικό, λογισμικό, δίκτυα, άνθρωποι, χαρτί ή κανάλια διαβίβασης χαρτιού.",
			name: "Υποστηρικτικά στοιχεία",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Παραβίαση της ασφάλειας που οδηγεί σε τυχαία ή παράνομη καταστροφή, απώλεια, μεταβολή, άνευ άδειας κοινολόγηση ή πρόσβαση δεδομένων προσωπικού χαρακτήρα που διαβιβάστηκαν, αποθηκεύτηκαν ή υποβλήθηκαν κατ’ άλλο τρόπο σε επεξεργασία.",
			name: "Παραβίαση δεδομένων προσωπικού χαρακτήρα",
			source: "ΓΚΠΔ Άρθ. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Η πιθανότητα εκφράζει τη δυνατότητα εμφάνισης κινδύνου. Εξαρτάται κυρίως από το επίπεδο ευπάθειας των υποστηρικτικών στοιχείων όταν απειλούνται και το επίπεδο των ικανοτήτων των πηγών κινδύνου για την εκμετάλλευσή τους.",
			name: "Πιθανότητα",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Δεδομένα για ένα σύστημα αξιολόγησης, αποτέλεσμα της εφαρμογής του σκορ ...",
			name: "Scoring"
		},
		PIA_EX_DCPC: {
			description: "<strong>Στοιχεία αναγνώρισης</strong>: Οικογενειακή κατάσταση, ταυτότητα, ηλικία, κ.λπ. <br><strong>Προσωπική ζωή</strong>: συνήθειες διαβίωσης, οικογενειακή κατάσταση, κλπ. <br><strong>Επαγγελματική ζωή</strong>: βιογραφικό σημείωμα, εκπαίδευση και επαγγελματική κατάρτιση, βραβεία, κλπ. <br><strong>Δεδομένα σύνδεσης </strong>: Διευθύνσεις IP, αρχεία καταγραφής συμβάντων, κ.λπ.<br><strong>Δεδομένα τοποθεσίας</strong>: ταξίδια, δεδομένα GPS, δεδομένα GSM, κ.λπ.<br><strong>Άλλα</strong>: αριθμός τηλεφώνου, διεύθυνση ηλεκτρονικού ταχυδρομείου, κ.λπ.",
			name: "Συνηθισμένα προσωπικά δεδομένα",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Φιλοσοφικές, πολιτικές, θρησκευτικές και συνδικαλιστικές γνώμες, σεξουαλική ζωή, δεδομένα για την υγεία, φυλετική ή εθνοτική καταγωγή, δεδομένα σχετικά με την υγεία ή τη σεξουαλική ζωή, αδικήματα, καταδίκες, μέτρα ασφαλείας, βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 9 and 10 του [ΓΚΔΠ]</a>.",
			name: "Καταδίκες και ευαίσθητα προσωπικά δεδομένα"
		},
		PIA_EX_DCPS: {
			description: "Βιομετρικά δεδομένα, τραπεζικά δεδομένα",
			name: "Προσωπικά δεδομένα που θεωρούνται ευαίσθητα"
		},
		PIA_EX_HUME: {
			description: "Μπορεί να είναι είτε:<br>- ένας κακόβουλος ή αφελής τρίτος, που, χρησιμοποιεί την φυσική εγγύτητά του για να αποκτήσει πρόσβαση στα δεδομένα της συσκευής·<br>- ένας εισβολέας που στοχεύει έναν χρήστη χρησιμοποιώντας τις γνώσεις που έχει για τον χρήστη και μερικές πληροφορίες που τον αφορούν·<br>- ένας εισβολέας που στοχεύει μία από τις εταιρείες που είναι υπεύθυνες για την επεξεργασία, χρησιμοποιώντας τις γνώσεις που έχει για τις εταιρείες αυτές για να επιτεθεί στη φήμη τους·<br>- ένας εξουσιοδοτημένος τρίτος που χρησιμοποιεί την προνομιακή του πρόσβαση για να αποκτήσει αθέμιτη πρόσβαση σε πληροφορίες.<br> Τα κίνητρα μπορεί να είναι πολλαπλά: τυχερά παιχνίδια, ενόχληση, δόλος, εκδίκηση, κατασκοπεία, απληστία, απόκτηση δεδομένων για την εκμετάλλευσή τους.",
			name: "Εξωτερικές ανθρώπινες πηγές"
		},
		PIA_EX_HUMI: {
			description: "Μπορεί να είναι είτε:<br>- ένας κακόβουλος υπάλληλος, που χρησιμοποιεί την εγγύτητά του στο σύστημα, τις δεξιότητές του, τα προνόμια και τον ενδεχομένως υπερβολικό διαθέσιμο χρόνο του, ή ένας αμελής υπάλληλος λόγω έλλειψης κατάρτισης και ευαισθητοποίησης<br>- ένας αμελής ή κακόβουλος χρήστης, μέλος της οικογένειας ή φίλος του που έχει πρόσβαση στην υπηρεσία.<br> Τα κίνητρά του μπορεί να είναι πολλαπλά: αδεξιότητα, σφάλμα, αμέλεια, δόλος, εκδίκηση, κατασκοπεία",
			name: "Εσωτερικές ανθρώπινες πηγές"
		},
		PIA_EX_IMPI: {
			description: "Τα υποκείμενα των δεδομένων ενδέχεται να αντιμετωπίσουν σημαντικές συνέπειες, τις οποίες θα πρέπει να μπορούν να ξεπεράσουν, αν και με πραγματικές και σοβαρές δυσκολίες. Για παράδειγμα:<br>- σωματικές: σοβαρές σωματικές παθήσεις που προκαλούν μακροχρόνια βλάβη (επιδείνωση της υγείας λόγω ακατάλληλης φροντίδας ή παράβλεψης αντενδείξεων), αλλοίωση της σωματικής ακεραιότητας π.χ. μετά από επίθεση, ατύχημα στο σπίτι, στην εργασία, κ.λπ.·<br>- υλικές: κατάχρηση χρημάτων που δεν αποζημιώνονται, στοχοθετημένες, μοναδικές και μη επαναλαμβανόμενες, χαμένες ευκαιρίες (στεγαστικό δάνειο, άρνηση σπουδών, πρακτική άσκηση ή απασχόληση, απαγόρευση εξέτασης), απώλεια στέγης, απώλεια απασχόλησης, κ.λπ.·<br>- ηθικές: σοβαρές ψυχολογικές ασθένειες (κατάθλιψη, ανάπτυξη φοβίας), αίσθηση εισβολής στην ιδιωτική ζωή με μη αναστρέψιμες βλάβες, θύμα εκβιασμού, παρενόχληση στον κυβερνοχώρο και παρενόχληση, κ.λπ.",
			name: "Σημαντικός αντίκτυπος"
		},
		PIA_EX_IMPL: {
			description: "Τα υποκείμενα των δεδομένων ενδέχεται να αντιμετωπίσουν σημαντικές ενοχλήσεις, τις οποίες θα μπορέσουν να ξεπεράσουν σε πείσμα ορισμένων δυσκολιών. Για παράδειγμα:<br>- σωματικές: μικρές σωματικές παθήσεις (ελάσσονες ασθένειες που οφείλονται στην παράβλεψη αντενδείξεων), δυσφήμιση που προκαλεί σωματικά ή ψυχολογικά αντίποινα κλπ.·<br>- υλικές: απρόβλεπτες πληρωμές (πρόστιμα που έχουν επιβληθεί εσφαλμένα), άρνηση πρόσβασης σε διοικητικές ή εμπορικές υπηρεσίες, λήψη ανεπιθύμητων στοχευμένων αποστολών που ενδέχεται να βλάψουν τη φήμη των υποκειμένων των δεδομένων, κ.λπ.·<br>- ηθικές: ελάσσονος σημασίας αλλά αντικειμενικές ψυχολογικές ασθένειες, αίσθηση εισβολής στην ιδιωτική ζωή χωρίς ανεπανόρθωτες ζημιές, εκφοβισμός σε κοινωνικά δίκτυα, κ.λπ.",
			name: "Περιορισμένος αντίκτυπος"
		},
		PIA_EX_IMPM: {
			description: "Τα υποκείμενα των δεδομένων ενδέχεται να αντιμετωπίσουν σημαντικές ή ακόμη και μη αναστρέψιμες συνέπειες, τις οποίες ενδέχεται να μην υπερνικήσουν. Για παράδειγμα:<br>- σωματικές: μακροχρόνιες ή μόνιμες σωματικές παθήσεις, μόνιμη βλάβη της σωματικής ακεραιότητας, θάνατος·<br>- υλικές: χρηματοοικονομικός κίνδυνος, σημαντικά χρέη, ανικανότητα προς εργασία, αδυναμία μετεγκατάστασης, απώλεια αποδεικτικών στοιχείων στο πλαίσιο δικαστικών διαδικασιών, απώλεια πρόσβασης σε ζωτικής σημασίας υποδομές (νερό, ηλεκτρική ενέργεια), κ.λπ.·<br>- ηθικές: μακροχρόνιες ή μόνιμες ψυχολογικές παθήσεις, ποινική κύρωση, απαγωγή, απώλεια οικογενειακών δεσμών, αδυναμία να ασκήσει αγωγή, αλλαγή διοικητικού καθεστώτος ή / και απώλεια νομικής αυτονομίας (κηδεμονία), κλπ.",
			name: "Μέγιστος αντίκτυπος"
		},
		PIA_EX_IMPN: {
			description: "Τα υποκείμενα δεδομένων είτε δεν θα επηρεαστούν είτε ενδέχεται να αντιμετωπίσουν μερικές ενοχλήσεις, τις οποίες θα ξεπεράσουν χωρίς κανένα πρόβλημα. Για παράδειγμα:<br>- σωματικές: παροδικοί πονοκέφαλοι·<br>- υλικές: απώλεια χρόνου σε επαναλαμβανόμενες διατυπώσεις ή αναμονή για την συμπλήρωσή τους, παραλαβή ανεπιθύμητης αλληλογραφίας (π.χ. spam), επαναχρησιμοποίηση δεδομένων που δημοσιεύονται σε δικτυακούς τόπους με σκοπό τη στοχευμένη διαφήμιση, κλπ.·<br>- ηθικές: απλή ενόχληση, αίσθηση εισβολής στην ιδιωτική ζωή χωρίς πραγματική ή αντικειμενική βλάβη (εμπορική εισβολή), κλπ.",
			name: "Αμελητέος αντίκτυπος"
		},
		PIA_EX_NHUM: {
			description: "Περιστατικό ή ζημιά σε έναν οργανισμό (διακοπή ρεύματος, πυρκαγιά, πλημμύρα, κ.λπ.)",
			name: "Μη ανθρώπινες πηγές"
		},
		PIA_EX_VRAI: {
			description: "Φαίνεται ότι οι επιλεγμένες πηγές κινδύνου μπορούν να υλοποιήσουν την απειλή με την εκμετάλλευση των ιδιοτήτων των υποστηρικτικών στοιχείων (π.χ. κλοπή έντυπων εγγράφων που είναι αποθηκευμένα σε γραφεία που δεν είναι προσβάσιμα αν δεν γίνει πρώτα έλεγχος στην υποδοχή).",
			name: "Σημαντική πιθανότητα"
		},
		PIA_EX_VRAL: {
			description: "Φαίνεται δύσκολο για τις επιλεγμένες πηγές κινδύνου να υλοποιήσουν την απειλή με την εκμετάλλευση των ιδιοτήτων των υποστηρικτικών στοιχείων (π.χ.: κλοπή έντυπων εγγράφων αποθηκευμένων σε δωμάτιο που προστατεύεται από συσκευή ανάγνωσης αναγνωριστικής κονκάρδας).",
			name: "Περιορισμένη πιθανότητα"
		},
		PIA_EX_VRAM: {
			description: "Φαίνεται εξαιρετικά εύκολο για τις επιλεγμένες πηγές κινδύνου να υλοποιήσουν την απειλή με την εκμετάλλευση των ιδιοτήτων των υποστηρικτικών στοιχείων (π.χ. κλοπή έντυπων εγγράφων αποθηκευμένων στον χώρο αναμονής).",
			name: "Μέγιστη πιθανότητα"
		},
		PIA_EX_VRAN: {
			description: "Δεν φαίνεται δυνατόν οι επιλεγμένες πηγές κινδύνου να υλοποιήσουν την απειλή με την εκμετάλλευση των ιδιοτήτων των υποστηρικτικών στοιχείων (π.χ.: κλοπή έντυπων εγγράφων αποθηκευμένων σε δωμάτιο που προστατεύεται από συσκευή ανάγνωσης αναγνωριστικής κονκάρδας και κωδικό πρόσβασης).",
			name: "Αμελητέα πιθανότητα"
		},
		PIA_LGL_CONS: {
			description: "Να επιτρέπετε στα υποκείμενα των δεδομένων να κάνουν ελεύθερη, συγκεκριμένη και ενημερωμένη επιλογή. Προσδιορίστε εάν η επεξεργασία βασίζεται σε νομική βάση διαφορετική από τη συγκατάθεση σύμφωνα με το Άρθ. 6 του <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">[ΓΚΠΔ]</a>",
			name: "Συγκατάθεση",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Καθορίστε και περιγράψτε το πεδίο εφαρμογής λεπτομερώς:<br>- τα σχετικά προσωπικά δεδομένα, τους παραλήπτες τους και τις διάρκειες αποθήκευσής τους<br>- περιγραφή των διαδικασιών και των υποστηρικτικών στοιχείων για τα προσωπικά δεδομένα για ολόκληρο τον κύκλο ζωής των προσωπικών δεδομένων (από τη συλλογή έως τη διαγραφή).",
			name: "Προσωπικά δεδομένα και διαδικασίες",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Παρουσιάστε μια σύντομη περιγραφή της εξεταζόμενης επεξεργασίας προσωπικών δεδομένων, της φύσης, του πεδίου εφαρμογής, του πλαισίου, των σκοπών και του διακυβεύματός της. Προσδιορίστε τον υπεύθυνο επεξεργασίας και τους εκτελούντες την επεξεργασία. Να αναφερθούν οι τυποποιημένες αναφορές που ισχύουν για την επεξεργασία των προσωπικών δεδομένων, οι οποίες είναι απαραίτητες ή πρέπει να τηρούνται, μεταξύ των οποίων και οι εγκεκριμένοι κώδικες δεοντολογίας (βλέπετε Άρθ. 40 του <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">[ΓΚΠΔ]</a>) και πιστοποιήσεις σχετικά με την προστασία δεδομένων (βλέπετε Άρθ. 42 του <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">[ΓΚΠΔ]</a>)",
			name: "Περιγραφή της επεξεργασίας",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Το φυσικό ή νομικό πρόσωπο, η δημόσια αρχή, η υπηρεσία ή άλλος φορέας, στα οποία κοινολογούνται τα δεδομένα προσωπικού χαρακτήρα, είτε πρόκειται για τρίτον είτε όχι. Ωστόσο, οι δημόσιες αρχές που ενδέχεται να λάβουν δεδομένα προσωπικού χαρακτήρα στο πλαίσιο συγκεκριμένης έρευνας σύμφωνα με το δίκαιο της Ένωσης ή κράτους μέλους δεν θεωρούνται ως αποδέκτες· η επεξεργασία των δεδομένων αυτών από τις εν λόγω δημόσιες αρχές πραγματοποιείται σύμφωνα με τους ισχύοντες κανόνες προστασίας των δεδομένων ανάλογα με τους σκοπούς της επεξεργασίας. Βλέπετε Άρθ. 4.9 του <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">[ΓΚΠΔ]</a>",
			name: "Αποδέκτης",
			source: "ΓΚΠΔ Άρθ. 4.9"
		},
		PIA_LGL_DUR: {
			description: "Περίοδος αποθήκευσης πρέπει να ορίζεται για κάθε είδος δεδομένων και να δικαιολογείται από τις νομικές απαιτήσεις ή / και τις ανάγκες επεξεργασίας. Έτσι γίνεται διάκριση μεταξύ των κοινών δεδομένων και των αρχειοθετημένων δεδομένων, στα οποία η πρόσβαση θα περιορίζεται μόνο στους ενδιαφερόμενους φορείς. Ένας μηχανισμός διαγραφής πρέπει να υλοποιηθεί για την αρχειοθέτηση κοινών δεδομένων ή την διαγραφή των αρχειοθετημένων δεδομένων στο τέλος της περιόδου αποθήκευσής τους. Τα λειτουργικά ίχνη θα πρέπει επίσης να διαγραφούν, καθώς και τα τεχνικά αρχεία καταγραφής που δεν μπορούν να αποθηκευτούν επ' αόριστον.",
			name: "Περίοδοι αποθήκευσης",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Τα δεδομένα προσωπικού χαρακτήρα πρέπει να συλλέγονται για συγκεκριμένους, σαφείς και νόμιμους σκοπούς και <strong>να μην υποβάλλονται σε περαιτέρω επεξεργασία με τρόπο ασυμβίβαστο προς τους σκοπούς αυτούς.</strong> <br>Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 5.1 β) του [ΓΚΔΠ]</a>",
			name: "Αρχές σχετικά με την επεξεργασία δεδομένων προσωπικού χαρακτήρα",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Το υποκείμενο των δεδομένων έχει συναινέσει στην επεξεργασία των δεδομένων προσωπικού χαρακτήρα του για έναν ή περισσότερους συγκεκριμένους σκοπούς <br>- Η επεξεργασία είναι απαραίτητη για την εκτέλεση σύμβασης της οποίας το υποκείμενο των δεδομένων είναι συμβαλλόμενο μέρος ή για να ληφθούν μέτρα κατ’ αίτηση του υποκειμένου των δεδομένων πριν από τη σύναψη σύμβασης <br>- Η επεξεργασία είναι απαραίτητη για τη συμμόρφωση με έννομη υποχρέωση του υπευθύνου επεξεργασίας <br>- Η επεξεργασία είναι απαραίτητη για τη διαφύλαξη ζωτικού συμφέροντος του υποκειμένου των δεδομένων ή άλλου φυσικού προσώπου <br>- Η επεξεργασία είναι απαραίτητη για την εκπλήρωση καθήκοντος που εκτελείται προς το δημόσιο συμφέρον ή κατά την άσκηση δημόσιας εξουσίας που έχει ανατεθεί στον υπεύθυνο επεξεργασίας <br>- Η επεξεργασία είναι απαραίτητη για τους σκοπούς των έννομων συμφερόντων που επιδιώκει ο υπεύθυνος επεξεργασίας ή τρίτος, εκτός εάν έναντι των συμφερόντων αυτών υπερισχύει το συμφέρον ή τα θεμελιώδη δικαιώματα και οι ελευθερίες του υποκειμένου των δεδομένων που επιβάλλουν την προστασία των δεδομένων προσωπικού χαρακτήρα, ιδίως εάν το υποκείμενο των δεδομένων είναι παιδί<br> Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 6 του [ΓΚΠΔ]</a> ",
			name: "Νομιμότητα της επεξεργασίας",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Βεβαιωθείτε ότι τα υποκείμενα των δεδομένων είναι ενημερωμένα. Βεβαιωθείτε ότι η επεξεργασία προσωπικών δεδομένων δεν καλύπτεται από εξαίρεση και δεν υπόκειται σε συγκεκριμένες προϋποθέσεις.",
			name: "Ενημέρωση των υποκειμένων των δεδομένων",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Είναι σημαντικό να μειωθεί η σοβαρότητα των κινδύνων μέσω της ελαχιστοποίησης του αριθμού των δεδομένων προσωπικού χαρακτήρα που θα υποβληθούν σε επεξεργασία, μέσω του περιορισμού των δεδομένα αυτών στο απολύτως απαραίτητο για τους σκοπούς για τους οποίους υποβάλλονται σε επεξεργασία (διαφορετικά δεν θα πρέπει να συλλέγονται). Στη συνέχεια, γίνεται επίσης δυνατή η ελαχιστοποίηση των ίδιων των δεδομένων, μέσω ελέγχων που αποσκοπούν στη μείωση της ευαισθησίας τους.",
			name: "Ελαχιστοποίηση των δεδομένων",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Μια σύμβαση επεξεργασίας πρέπει να υπογράφεται με κάθε εκτελούντα την επεξεργασία, αναφέροντας όλες τις πτυχές που ορίζονται στο Άρθ. 28 του [ΓΚΠΔ]: διάρκεια, πεδίο εφαρμογής, σκοπό, καταγεγραμμένες οδηγίες επεξεργασίας, προηγούμενη έγκριση όπου εμπλέκεται ένας εκτελών την επεξεργασία, παροχή οποιασδήποτε τεκμηρίωσης που να αποδεικνύει συμμόρφωση με τον [ΓΚΠΔ], άμεση ειδοποίηση οποιασδήποτε παραβίασης δεδομένων, κ.λπ.",
			name: "Υπεργολαβία",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Στοιχείο πάνω στο οποίο βασίζονται προσωπικά δεδομένα. Σημείωση: αυτό μπορεί να είναι τεχνολογικό υλικό, λογισμικό, δίκτυα, άνθρωποι, χαρτί ή κανάλια διαβίβασης χαρτιού.",
			name: "Υποστηρικτικό στοιχείο",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Ανάλογα με την εν λόγω χώρα, θα πρέπει να δικαιολογήσετε την επιλογή της απομακρυσμένης φιλοξενίας και να υποδείξετε τα εφαρμοζόμενα μέτρα νομικής εποπτείας προκειμένου να διασφαλίσετε την επαρκή προστασία του υποκειμένου των δεδομένων σε διασυνοριακή μεταφορά. Αυτό είναι: <br>- Ευρωπαϊκή Ένωση<br>- Χώρα που αναγνωρίζεται ότι παρέχει επαρκή προστασία από την ΕΕ<br>- Μεταφορά στις Ηνωμένες Πολιτείες σε εταιρεία που έχει προσχωρήσει στην Ασπίδα Προστασίας Προσωπικών Δεδομένων<br>- Άλλη χώρα <br>Βλέπετε <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">Άρθ. 44 έως 49 του [ΓΚΔΠ]</a>",
			name: "Μεταφορές",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "Τα προγραμματισμένα μέτρα είναι εκείνα που είχαν αρχικά τεθεί σε εφαρμογή, πριν από οποιαδήποτε ανάλυση από τον αξιολογητή. Τα συμπληρωματικά ή διορθωτικά μέτρα που συμβουλεύει ο αξιολογητής θα αναφέρονται στο σχέδιο δράσης και θα επιτρέπουν μια δεύτερη αξιολόγηση της σοβαρότητας και της πιθανότητας του κινδύνου.",
			name: "Προγραμματισμένα και διορθωτικά μέτρα",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Ύπαρξη μιας πολιτικής και διαδικασιών για την απόκτηση μιας οργάνωσης ικανής να διαχειρίζεται και να ελέγχει την προστασία των προσωπικών δεδομένων που τηρούνται σε αυτήν.",
			name: "Παρακολούθηση των μέτρων προστασίας δεδομένων",
			placeholder: "Αναφέρετε εδώ εάν ελέγχεται η αποτελεσματικότητα και η επάρκεια των μέτρων προστασίας των δεδομένων.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Ύπαρξη μιας πολιτικής και διαδικασιών που μειώνουν τον κίνδυνο που η νόμιμη επεξεργασία προσωπικών δεδομένων από τρίτους ενδέχεται να ενέχει για τα τις ατομικές ελευθερίες και την ιδιωτική ζωή των υποκειμένων των δεδομένων.",
			name: "Σχέσεις με τρίτους",
			placeholder: "Αναφέρετε εδώ, για τους εκτελούντες την επεξεργασία που απαιτούν πρόσβαση στα δεδομένα, τους ελέγχους ασφαλείας και τα μέτρα που διενεργούνται όσον αφορά στην πρόσβαση αυτή.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Καθορίστε εάν ένα πρόσωπο είναι υπεύθυνο για την εφαρμογή των νόμων και των κανονισμών περί προστασίας προσωπικών δεδομένων. Να διευκρινιστεί εάν υπάρχει επιτροπή παρακολούθησης (ή ισοδύναμη) αρμόδια για την καθοδήγηση και την παρακολούθηση των δράσεων που αφορούν στην προστασία προσωπικών δεδομένων.",
			name: "Οργάνωση της πολιτικής προστασίας προσωπικών δεδομένων",
			placeholder: "Αναφέρατε κατά πόσο καθορίζονται οι ρόλοι και οι ευθύνες για την προστασία προσωπικών δεδομένων.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Ύπαρξη διαδικασιών που περιγράφουν τις μεθόδους που πρέπει να λαμβάνονται υπόψη για την προστασία των δεδομένων προσωπικού χαρακτήρα σε οποιαδήποτε νέα επεξεργασία (πιστοποιήσεις, πρότυπα, διαχείριση κινδύνου για το υποκείμενο των δεδομένων σύμφωνα με τη μεθοδολογία CNIL ή με εσωτερική μέθοδο, κ.λπ.).",
			name: "Ενσωμάτωση της προστασίας της ιδιωτικής ζωής σε έργα",
			placeholder: "Περιγράψτε εδώ πώς ενσωματώνεται η προστασία της ιδιωτικής ζωής σε έργα",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Ύπαρξη ενός σχεδίου που πλαισιώνει τα <strong>μέτρα ευαισθητοποίησης</strong> που λαμβάνονται κατά την ανάληψη ενός νέου ρόλου από ένα άτομο και μια διαδικασία που περιγράφει τα <strong>μέτρα που λαμβάνονται από τα άτομα που έχουν πρόσβαση στα δεδομένα</strong>.",
			name: "Διαχείριση προσωπικού",
			placeholder: "Αναφέρετε εδώ ποιές διαδικασίες αύξησης της ευαισθητοποίησης εκτελούνται σε σχέση με τους υπαλλήλους.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Ο υπεύθυνος επεξεργασίας πρέπει να διαθέτει μια βάση τεκμηρίωσης που να επισημαίνει τους στόχους και τους κανόνες που πρέπει να εφαρμόζονται στον τομέα της «Προστασίας δεδομένων» (σχέδιο δράσης, τακτική αναθεώρηση της πολιτικής «Προστασίας δεδομένων», κ.λπ.)",
			name: "Διαχειριστείτε την πολιτική προστασίας δεδομένων",
			placeholder: "Περιγράψτε εδώ τις μεθόδους που χρησιμοποιούνται για τη διαχείριση της βάσης εγγράφων για την οργάνωση της προστασίας προσωπικών δεδομένων στον οργανισμό σας.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Ύπαρξη διαδικασιών για την περιγραφή των μεθόδων λήψης υπόψη της προστασίας των δεδομένων προσωπικού χαρακτήρα σε κάθε νέα επεξεργασία (πιστοποιήσεις, πρότυπα, διαχείριση κινδύνου για το ενδιαφερόμενο πρόσωπο με τη μέθοδο CNIL ή με εσωτερική μέθοδο, κ.λπ.).",
			name: "Διαχείριση κινδύνων ιδιωτικής ζωής",
			placeholder: "Περιγράψτε εδώ διαδικασίες για τον έλεγχο των κινδύνων που συνεπάγονται οι διαδικασίες επεξεργασίας που εκτελεί ο οργανισμός για την προστασία δεδομένων και την προστασία της ιδιωτικής ζωής των υποκειμένων των δεδομένων.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Ύπαρξη επιχειρησιακής οργάνωσης που μπορεί να ανιχνεύει και να αντιμετωπίζει περιστατικά που ενδέχεται να επηρεάσουν τις ατομικές ελευθερίες και την ιδιωτική ζωή των υποκειμένων των δεδομένων.",
			name: "Διαχείριση παραβιάσεων προσωπικών δεδομένων",
			placeholder: "Αναφέρετε εδώ εάν τα περιστατικά πληροφορικής υπόκεινται σε τεκμηριωμένη και δοκιμασμένη διαδικασία διαχείρισης.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Πολιτικές και μέσα που εφαρμόζονται για τη διασφάλιση της διαθεσιμότητας ή / και της ακεραιότητας των προσωπικών δεδομένων, διατηρώντας ταυτόχρονα την εμπιστευτικότητα τους.",
			name: "Αντίγραφα ασφαλείας",
			placeholder: "Υποδείξτε εδώ τον τρόπο διαχείρισης των αντιγράφων ασφαλείας. Διασαφηνίστε εάν αποθηκεύονται σε ασφαλές μέρος.",
			source: "PIAF Connected Objects p23 & PIA3 p27 - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Μέτρα που εφαρμόζονται σε σταθμούς εργασίας (αυτόματο κλείδωμα, τακτικές ενημερώσεις, διαμόρφωση, φυσική ασφάλεια, κ.λπ.) προκειμένου να μειωθεί η δυνατότητα εκμετάλλευσης των ιδιοτήτων του λογισμικού (λειτουργικά συστήματα, επιχειρηματικές εφαρμογές, κ.λπ.) να επηρρεάσει αρνητικά τα προσωπικά δεδομένα.",
			name: "Διαχείριση σταθμών εργασίας",
			placeholder: "Περιγράψτε εδώ τα μέτρα που εφαρμόζονται σε σταθμούς εργασίας",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "<strong>Να χρησιμοποιείτε μόνο υπεργολάβους που παρέχουν επαρκείς εγγυήσεις</strong> (ιδίως από πλευράς εμπειρογνωμοσύνης, αξιοπιστίας και πόρων). Να απαιτήσετε οι πάροχοι υπηρεσιών να σας γνωστοποιήσουν την πολιτική ασφαλείας των πληροφοριακών συστημάτων τους πριν υπογράψετε σύμβαση μαζί τους. <br>Να λάβετε και να καταγράψετε τα μέτρα (έλεγχοι ασφαλείας, επισκέψεις σε εγκαταστάσεις, κ.λπ.) που εφαρμόζονται για την <strong>εξασφάλιση της αποτελεσματικότητας των εγγυήσεων που προσφέρει ο υπεργολάβος</strong> για την προστασία των προσωπικών δεδομένων. Στις εγγυήσεις αυτές περιλαμβάνονται: <br>- η κρυπτογράφηση δεδομένων ανάλογα με την ευαισθησία τους ή, κατ' ελάχιστον, η ύπαρξη διαδικασιών που εγγυώνται ότι η εταιρεία που παρέχει την υπηρεσία δεν έχει πρόσβαση στα δεδομένα· <br>- η κρυπτογράφηση της μετάδοσης δεδομένων (π.χ. σύνδεση τύπου HTTPS, VPN, κ.λπ.)· <br>- εγγυήσεις όσον αφορά στην προστασία του δικτύου, στην ιχνηλασιμότητα (αρχεία καταγραφής - logs, τακτικοί και έκτακτοι έλεγχοι), στη διαχείριση αδειών πρόσβασης, στην πιστοποίηση της ταυτότητας, κ.λπ.· <br><strong>Να υπογράψετε σύμβαση με τους υπεργολάβους</strong>, η οποία καθορίζει το αντικείμενο, τη διάρκεια, τον σκοπό της επεξεργασίας καθώς και τις υποχρεώσεις εκάστου μέρους. Διασφαλίστε ότι περιέχει, ειδικότερα, διατάξεις που καθορίζουν: <br>- την υποχρέωσή τους όσον αφορά <strong>στην εμπιστευτικότητα των προσωπικών δεδομένων που τους έχουν εμπιστευθεί</strong>· <br>- <strong>τις ελάχιστες απαιτήσεις όσον αφορά στην πιστοποίηση της ταυτότητας των χρηστών</strong>· <br>- <strong>τους όρους ανάκτησης ή / και καταστροφής δεδομένων στο τέλος της σύμβασης</strong>· <br>- <strong>τους κανόνες για τη διαχείριση και την αναφορά περιστατικών.</strong> Αυτοί θα πρέπει να περιλαμβάνουν, όποτε ανακαλύπτεται παραβίαση της ασφάλειας ή περιστατικό ασφαλείας, ειδοποίηση του υπεύθυνου επεξεργασίας, η οποία θα πρέπει να συμβεί το συντομότερο δυνατόν αν αφορά σε προσωπικά δεδομένα.",
			name: "Συμβάσεις επεξεργασίας",
			placeholder: "Περιγράψτε εδώ συγκεκριμένα μέτρα για τους εκτελούντες την επεξεργασία (πάροχος φιλοξενίας ιστοσελίδας, εταιρεία συντήρησης, διαχειριστής, πάροχοι ειδικών υπηρεσιών, κ.λπ.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Πολιτικές που εφαρμόζονται προκειμένου να μειωθεί η πιθανότητα και ο αντίκτυπος των κινδύνων στα στοιχεία που υποστηρίζουν προσωπικά δεδομένα.",
			name: "Λειτουργική ασφάλεια",
			placeholder: "Περιγράψτε εδώ πώς πραγματοποιούνται οι ενημερώσεις λογισμικού (λειτουργικά συστήματα, εφαρμογές, κ.λπ.) και η εφαρμογή των διορθωτικών εκδόσεων λογισμικού σχετικά με την ασφαλεία.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Παρακολουθήστε τα συστήματα ανίχνευσης εισβολής και τα συστήματα πρόληψης εισβολής για να αναλύσετε την κυκλοφορία δικτύου (καλωδιακά δίκτυα, Wi-Fi, ραδιοκύματα, οπτικές ίνες, κ.λπ.) σε πραγματικό χρόνο και για να ανιχνεύσετε οποιαδήποτε ύποπτη δραστηριότητα που υποδηλώνει ένα σενάριο κυβερνοεπίθεσης.",
			name: "Παρακολούθηση δραστηριότητας δικτύου",
			placeholder: "Αναφέρετε εδώ τα μέσα και τις διαδικασίες που εφαρμόζονται για την ανίχνευση συμβάντων που αφορούν σε προσωπικά δεδομένα",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Πολιτικές που περιγράφουν πώς γίνεται η διαχείριση της φυσικής συντήρησης του τεχνολογικού υλικού, δηλώνοντας εάν αυτό ανατίθεται με σύμβαση.<br> Αναφέρετε αν επιτρέπεται η απομακρυσμένη συντήρηση εφαρμογών και σύμφωνα με ποιες προβλέψεις. Καθορίστε αν γίνεται διαχείριση ελαττωματικού εξοπλισμού με συγκεκριμένο τρόπο.",
			name: "Συντήρηση",
			placeholder: "Περιγράψτε εδώ πώς γίνεται η διαχείριση της φυσικής συντήρησης του τεχνολογικού υλικού",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Μέτρα που εφαρμόζονται σε σταθμούς εργασίας και διακομιστές για την προστασία τους από κακόβουλο λογισμικό κατά την πρόσβαση σε λιγότερο ασφαλή δίκτυα.",
			name: "Καταστολή κακόβουλου λογισμικού",
			placeholder: "Περιγράψτε εδώ τα μέτρα που εφαρμόζονται για τη μείωση των κινδύνων κατά την πρόσβαση σε λιγότερο ασφαλή δίκτυα.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Αναφέρετε εδώ τις διαδικασίες που αφορούν στη φυσική ασφάλεια των διακομιστών και των σταθμών εργασίας (ασφαλής αποθήκευση, καλώδια ασφαλείας, φίλτρα εμπιστευτικότητας, ασφαλής διαγραφή πριν την απόσυρση, κ.λπ.).",
			name: "Ασφάλεια τεχνολογικού υλικού",
			placeholder: "Αναφέρετε εδώ τις διαδικασίες που αφορούν στη φυσική ασφάλεια των διακομιστών και των σταθμών εργασίας",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Ανάλογα με τον τύπο του δικτύου στο οποίο πραγματοποιείται η επεξεργασία (απομονωμένο, ιδιωτικό ή Διαδίκτυο). Καθορίστε ποιο σύστημα τείχους προστασίας, συστήματα ανίχνευσης εισβολών ή άλλα ενεργά ή παθητικά βοηθήματα είναι υπεύθυνα για την εξασφάλιση της ασφάλειας του δικτύου.",
			name: "Ασφάλεια δικτύου",
			placeholder: "Υποδείξτε εδώ τις διαδικασίες ασφαλείας του δικτύου στο οποίο πραγματοποιείται η επεξεργασία",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Πολιτικές για τη διασφάλιση της φυσικής ασφάλειας (χωροθέτηση, συνοδεία επισκεπτών, άδειες εισόδου ως μέρος της αμφίεσης, κλειδωμένες πόρτες και ούτω καθεξής). Αναφέρατε εάν υπάρχουν τεθειμένες διαδικασίες προειδοποίησης σε περίπτωση διάρρηξης.",
			name: "Έλεγχος φυσικής πρόσβασης",
			placeholder: "Αναφέρετε εδώ πώς διεξάγεται ο έλεγχος στην φυσική πρόσβαση σχετικά με τους χώρους όπου στεγάζεται η επεξεργασία.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Ύπαρξη μέτρων για τη μείωση ή την αποφυγή κινδύνων που σχετίζονται με μη ανθρώπινες πηγές (κλιματικά φαινόμενα, πυρκαγιές, ζημιές από νερό, εσωτερικά ή εξωτερικά ατυχήματα, ζώα, κ.λπ.) που θα μπορούσαν να επηρεάσουν την ασφάλεια των προσωπικών δεδομένων (προληπτικά μέτρα, ανίχνευση, προστασία, κ.λπ.).",
			name: "Προστασία από πηγές κινδύνων πλην του ανθρώπου",
			placeholder: "Περιγράψτε τα μέτρα που λήφθηκαν για τη μείωση ή την αποφυγή κινδύνων από μη ανθρώπινες πηγές.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Ύπαρξη μέτρων για την πρόληψη ενδεχόμενων πηγών κινδύνων, ανθρώπινων ή μη, εις βάρος προσωπικών δεδομένων (επικίνδυνα προϊόντα, επικίνδυνες γεωγραφικές περιοχές, μεταφορά δεδομένων εκτός της ΕΕ, κλπ.).",
			name: "Αποφυγή πηγών κινδύνου",
			placeholder: "Περιγράψτε τις μεθόδους και τα μέσα που έχουν τεθεί σε εφαρμογή για να αποφύγετε πιθανές πηγές κινδύνου",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Εφαρμογή των Συστάσεων του ANSSI για την ασφάλεια ιστοσελίδων.",
			name: "Ασφάλεια ιστοσελίδων",
			placeholder: "Αναφέρετε εδώ τα μέτρα που εφαρμόζονται για την προστασία των ιστοσελίδων.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Αναφέρετε εδώ αν εφαρμόζονται μηχανισμοί ανωνυμοποίησης, ποιοί και για ποιο σκοπό. <br>Θυμηθείτε να διακρίνετε σαφώς τα ανώνυμα και τα ψευδώνυμα προσωπικά δεδομένα.",
			name: "Ανωνυμοποίηση",
			placeholder: "Αναφέρετε εδώ τους μηχανισμούς ανωνυμοποίησης που εφαρμόζονται",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Όπου χρειάζεται, περιγράψτε εδώ τις διαδικασίες διαχείρισης αρχείων (παράδοση, αποθήκευση, διαβούλευση, κ.λπ.) υπό την ευθύνη σας. Καθορίστε τους ρόλους αρχειοθέτησης (γραφεία προέλευσης, φορείς μεταφοράς, κ.λπ.) και την πολιτική αρχειοθέτησης. Αναφέρετε εάν τα δεδομένα ενδέχεται να εμπίπτουν στο πεδίο εφαρμογής των δημόσιων αρχείων.",
			name: "Αρχειοθέτηση",
			placeholder: "Υποδείξτε εδώ αν εφαρμόζονται μηχανισμοί για την παρακολούθηση της ακεραιότητας των αποθηκευμένων προσωπικών δεδομένων, ποια και για ποιο σκοπό.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Μέσα που εφαρμόζονται για <strong>τη διασφάλιση της εμπιστευτικότητας</strong> των προσωπικών δεδομένων που αποθηκεύονται (σε βάση δεδομένων, σε επίπεδα αρχεία, αντίγραφα ασφαλείας, κ.λπ.), καθώς και τη διαδικασία διαχείρισης κλειδιών κρυπτογράφησης (δημιουργία, αποθήκευση, αλλαγή σε περίπτωση υποψίας περιπτώσεων παραβίασης προσωπικών δεδομένων, κ.λπ.). <br>Περιγράψτε τα μέτρα κρυπτογράφησης που χρησιμοποιούνται για ροές δεδομένων (VPN, TLS, etc.) που εφαρμόζονται στην επεξεργασία.",
			name: "Κρυπτογράφηση",
			placeholder: "Περιγράψτε εδώ τα μέσα που εφαρμόζονται για τη διασφάλιση της εμπιστευτικότητας των προσωπικών δεδομένων",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Η εφαρμογή διαχωρισμού/καταμερισμού δεδομένων συμβάλλει στη μείωση της πιθανότητας συσχετισμού των προσωπικών δεδομένων και της πιθανότητας παραβίασης όλων των προσωπικών δεδομένων.",
			name: "Διαχωρισμός προσωπικών δεδομένων",
			placeholder: "Αναφέρετε εδώ αν σχεδιάζεται διαχωρισμός προσωπικών δεδομένων και πώς γίνεται αυτό.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Μέθοδοι για τον ορισμό και την απόδοση προφίλ χρηστών. Καθορίστε τα μέσα <strong>επαλήθευσης της ταυτότητας</strong> που εφαρμόζονται. Κατά περίπτωση, καθορίστε τους κανόνες που ισχύουν για τους κωδικούς πρόσβασης (ελάχιστο μήκος, απαιτούμενοι χαρακτήρες, διάρκεια ισχύος, αριθμός αποτυχημένων προσπαθειών πριν κλειδωθεί η πρόσβαση στον λογαριασμό, κλπ.).",
			name: "Μέτρο λογικής πρόσβασης",
			placeholder: "Υποδείξτε εδώ πώς καθορίζονται και αποδίδονται τα προφίλ των χρηστών.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Πολιτικές που καθορίζουν την ιχνηλασιμότητα και τη διαχείριση των καταχωρίσεων.",
			name: "Ανιχνευσιμότητα (καταγραφή)",
			placeholder: "Υποδείξτε εδώ αν τα συμβάντα καταγράφονται και για πόσο χρόνο αποθηκεύονται τα ίχνη αυτά.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Οι ακόλουθες μέθοδοι θα μπορούσαν να χρησιμοποιηθούν: Φιλτράρισμα και αφαίρεση, Μείωση ευαισθησίας μέσω μετατροπής, Μείωση της φύσης προσδιορισμού ταυτότητας των δεδομένων, Μείωση της συσσώρευσης δεδομένων, Περιορισμός πρόσβασης στα δεδομένα",
			name: "Ελαχιστοποίηση του αριθμού των δεδομένων προσωπικού χαρακτήρα",
			placeholder: "Ορίστε εδώ τα μέσα που εφαρμόζονται για να μειωθεί η σοβαρότητα των κινδύνων μέσω του περιορισμού της ποσότητας των προσωπικών δεδομένων",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Όταν κατά τη διάρκεια της επεξεργασίας χρησιμοποιούνται έγγραφα που περιέχουν προσωπικά δεδομένα, υποδείξτε εδώ τον τρόπο με τον οποίο εκτυπώνονται, αποθηκεύονται, καταστρέφονται και ανταλλάσσονται.",
			name: "Ασφάλεια εγγράφων",
			placeholder: "Υποδείξτε εδώ αν εφαρμόζονται μηχανισμοί για την παρακολούθηση της ακεραιότητας των δεδομένων σε έγχαρτη μορφή, ποια και για ποιο σκοπό.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Ρυθμίσεις διόρθωσης που πρότεινε ο αξιολογητής σε προηγούμενα βήματα, καταρτίζοντας ένα σχέδιο δράσης που καθορίζει, για κάθε δράση, τον διαχειριστή του, τη συχνότητα, τη δυσκολία, το κόστος και την πρόοδο.",
			name: "Σχέδιο δράσης",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Γράφημα που απεικονίζει τις καλές πρακτικές ασφαλείας, με αξία συμμόρφωσης να αποδίδεται σε καθένα βάσει της αξιολόγησής του σε προηγούμενα βήματα.",
			name: "Χαρτογράφηση των κινδύνων",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Όπου ενδείκνυται, ο υπεύθυνος επεξεργασίας αναζητεί τις γνώμες των υποκειμένων των δεδομένων ή των εκπροσώπων τους σχετικά με την προβλεπόμενη επεξεργασία, χωρίς προκατάληψη για την προστασία των εμπορικών ή δημόσιων συμφερόντων ή την ασφάλεια των εργασιών επεξεργασίας. Βλέπετε Άρθ. 39.2 του <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">[ΓΚΠΔ]</a><br>Αυτές οι γνώμες μπορούν να συγκεντρωθούν με ποικίλα μέσα, ανάλογα με το πλαίσιο (εσωτερική ή εξωτερική μελέτη των μεθόδων και του σκοπού της επεξεργασίας, ερώτηση που απευθύνεται στους εκπροσώπους του προσωπικού ή των συνδικάτων, έρευνα μεταξύ μελλοντικών πελατών του εκτελούντα την επεξεργασία). <strong>Όπου ο υπεύθυνος επεξεργασίας αποφασίζει να αντιταχθεί στις γνώμες των υποκειμένων των δεδομένων</strong>, πρέπει να σημειώσει <strong>την αιτιολόγηση αυτής της απόφασης</ strong>. Όταν ο υπεύθυνος επεξεργασίας θεωρεί ότι η <strong>συγκέντρωση των απόψεων των υποκειμένων των δεδομένων δεν είναι σχετική, πρέπει επίσης να σημειώσει την αιτιολόγησή σχετικά με αυτό</strong>.",
			name: "Γνώμη του υποκειμένου των δεδομένων",
			source: "ΓΚΠΔ Άρθ. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "Ο υπεύθυνος επεξεργασίας ζητά τη συμβουλή του υπευθύνου προστασίας δεδομένων, εφόσον αυτός έχει οριστεί, κατά την εκτέλεση της εκτίμησης αντικτύπου των επιπτώσεων στην προστασία των προσωπικών δεδομένων. Βλέπετε Άρθ. 39 παρ. 2 του <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/EL/TXT/HTML/?uri=CELEX:32016R0679&from=EL\">[ΓΚΠΔ]</a><br> <strong>Αυτή η γνώμη μπορεί να είναι αντίθετη με την υλοποίηση της επεξεργασίας, χωρίς να περιορίζεται η απόφαση του υπεύθυνου επεξεργασίας για όλα αυτά</strong>.",
			name: "Γνώμη του ΥΠΔ",
			source: "ΓΚΠΔ Άρθ. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Αποφασίστε εάν οι επιλεγμένοι έλεγχοι, οι υπολειπόμενοι κίνδυνοι και το σχέδιο δράσης είναι αποδεκτά, με αιτιολόγηση, ενόψει των ήδη πρσδιορισθέντων διακυβευμάτων και των απόψεων των ενδιαφερομένων. Με αυτόν τον τρόπο, η ΕΑ μπορεί να είναι:<br>- επικυρωμένη<br>- εξαρτώμενη από βελτίωση (εξηγήστε με ποιόν τρόπο)<br>- απορριφθείσα (μαζί με την υπό εξέταση επεξεργασία). Όπου είναι απαραίτητο, επαναλάβετε τα προηγούμενα βήματα ώστε να είναι δυνατή η επικύρωση της ΕΑ. Η απόφαση αυτή δεν προδικάζει την εκτίμηση της συμμόρφωσης, η οποία μπορεί, ενδεχομένως, να πραγματοποιηθεί από την Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (την ΑΠΔΠΧ στην Ελλάδα, την CNIL στη Γαλλία), στο πλαίσιο προκαταρκτικών διατυπώσεων ή ελέγχων, για παράδειγμα.",
			name: "Επίσημη επικύρωση",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Γνωσιακή βάση"
};
var measures$i = {
	add: "Προσθήκη ενός μέτρου (ειδάλλως, χρησιμοποιείστε τη γνωσιακή βάση)",
	default_placeholder: "Περιγράψτε τα υφιστάμενα ή προοριζόμενα μέτρα για να εξασφαλίσετε την ασφάλεια των προσωπικών δεδομένων.",
	edit: "Επεξεργασία μέτρου",
	placeholder_title: "Τίτλος μέτρου",
	remove: "Διαγραφή μέτρου"
};
var misc$i = {
	display: "Εμφάνιση / Απόκρυψη"
};
var modals$i = {
	abandon_pia: {
		additional_text: "Η αρχειοθέτηση δεν είναι οριστική και μπορείτε να επιστρέψετε στην EA εάν χρειαστεί.",
		content: "Είστε βέβαιοι ότι θέλετε να <br>παραιτηθείτε από αυτή την επεξεργασία;"
	},
	action_plan_no_evaluation: {
		content: "Πρέπει να ξεκινήσετε την αξιολόγηση της ανάλυσης για να δημιουργήσετε το σχέδιο δράσης.",
		review_section: "Αξιολόγηση ενός τμήματος"
	},
	archive: "Αρχειοθέτηση",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "<span class='strong'>Συγχαρητήρια,</span><br>η υποενότητα είναι τώρα<br>διαθέσιμη για αξιολόγηση."
	},
	back_to_edition: {
		content: "Αυτό το τμήμα έχει σταλεί πίσω για επεξεργασία.<br> Αρκετά πεδία πρέπει να διορθωθούν<br> για να επιτραπεί η ορθή αξιολόγησή του."
	},
	back_to_evaluation: {
		content: "Αυτό το τμήμα έχει σταλεί πίσω για αξιολόγηση.<br> Αρκετά πεδία πρέπει να αξιολογηθούν<br> για να επιτραπεί η ορθή επικύρωσή του."
	},
	back_to_home: "Επιστροφή στην αρχή",
	cancel: "Ακύρωση",
	close: "Κλείσιμο",
	completed_edition: {
		content: "Έχει ολοκληρωθεί η επεξεργασία της ΕΑ, πρέπει να αξιολογηθεί."
	},
	completed_evaluation: {
		content: "Έχει ολοκληρωθεί η αξιολόγηση της ΕΑ, πρέπει να επικυρωθεί."
	},
	"continue": "Συνέχεια",
	declare_measures: {
		content: "Συγγνώμη,<br>πριν από την αξιολόγηση των κινδύνων,<br>πρέπει να αναφέρετε τα<br>υφιστάμενα ή προγραμματισμένα μέτρα.",
		declare: "Δηλώστε τα υφιστάμενα ή προγραμματισμένα μέτρα"
	},
	dpo_missing_evaluations: {
		comment: "Σχόλιο",
		content: "Πρέπει να ολοκληρώσετε την αξιολόγηση της ανάλυσης για να αποκτήσετε πρόσβαση στη σελίδα του ΥΠΔ.",
		remove: "Αφαίρεση",
		review_section: "Αξιολόγηση ενός τμήματος"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Το εισαγόμενο αρχείο δεν αντιστοιχεί σε ένα αρχείο ΕΑ."
	},
	import_wrong_structure_file: {
		content: "Το εισαγόμενο αρχείο δεν αντιστοιχεί σε ένα αρχείο Υποδείγματος."
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Το περιεχόμενο της ΕΑ έχει αντιγραφεί στο πρόχειρο."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Προσοχή,</span><br>Πρέπει να συμπληρωθεί τουλάχιστον ένα μέτρο: δεν είναι δυνατή η διαγραφή."
	},
	recover_version: {
		"continue": "Συνέχεια",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "<span class='strong'>Απορριφθείσα ΕΑ,</span><br>Αρκετά πεδία πρέπει να διορθωθούν.<br>Επιστροφή στη λειτουργία αξιολόγησης<br>για να κάνετε διορθώσεις."
	},
	remove_attachment: {
		comment: "Σχόλιο",
		content: "<span class='strong'>Προσοχή,</span><br>Είστε βέβαιοι ότι θέλετε να <br>αφαιρέσετε αυτό το συνημμένο;",
		keep: "Διατήρηση",
		remove: "Αφαίρεση"
	},
	remove_measure: {
		content: "<span class='strong'>Προσοχή,</span><br>Είστε βέβαιοι ότι θέλετε να <br>καταργήσετε αυτό το μέτρο;",
		keep: "Διατήρηση αυτού του <br>μέτρου",
		remove: "Κατάργηση αυτού του <br>μέτρου"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Αφαίρεση αυτής της ΕΑ"
	},
	remove_question: {
		content: "Είστε βέβαιοι ότι θέλετε να διαγράψετε το ερώτημα;",
		keep: "Ακύρωση",
		remove: "Διαγραφή"
	},
	remove_structure: {
		content: "<span class='strong'>Προσοχή,</span><br>Είστε βέβαιοι ότι θέλετε να <br>διαγράψετε το υπόδειγμα;",
		remove: "Διαγραφή του υποδείγματος"
	},
	same_comment: {
		content: "<span class='strong'>Προσοχή,</span><br> παρακαλώ εισάγετε ένα σχόλιο διαφορετικό από το τελευταίο."
	},
	signed_pia_validation: {
		content: "<span class='strong'>Η ΕΑ έχει γίνει αποδεκτή</span><br>Ολοκληρώστε την επικύρωση της ΕΑ επισυνάπτοντας<br>την υπογεγραμμένη αναφορά του υπευθύνου.",
		download_pia: "Κατεβάστε την αναφορά της ΕΑ"
	},
	simple_pia_validation: {
		content: "Η ΕΑ επικυρώθηκε."
	},
	start_evaluation: "Έναρξη αξιολόγησης",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Η διεύθυνση του διακομιστή έχει ενημερωθεί."
	},
	validate_evaluation: {
		content: "<span class='strong'>Συγχαρητήρια,</span><br>ολοκληρώσατε την αξιολόγηση αυτής της ενότητας.<br>Άλλα τμήματα της ΕΑ πρέπει επίσης να αξιολογηθούν για να είναι δυνατή η επικύρωση της ΕΑ."
	},
	validate_evaluation_to_correct: {
		content: "Συγγνώμη,<br>Αρκετά πεδία πρέπει να διορθωθούν.<br>Επιστροφή στη λειτουργία επεξεργασίας<br> για να κάνετε διορθώσεις."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$i = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$i = {
	content: ", λαμβάνοντας υπόψη :",
	dpo_lock: "Συμπληρώστε τα υπόλοιπα τμήματα για να μπορέσετε να συμπληρώσετε τη γνώμη του ΥΠΔ.",
	dpo_opinion: "γνώμη του ΥΠΔ",
	edit: "Επεξεργασία",
	people_opinion: "Γνώμη των ενδιαφερόμενων",
	placeholder_concerned_people_name: "Όνομα/ονόματα των ενδιαφερόμενων",
	placeholder_dpo_name: "όνομα/ονόματα ΥΠΔ",
	placeholder_dpo_opinion: "Καθορίστε τους λόγους για την επιλογή σας.",
	placeholder_people_opinion: "Περιγράψτε τον τρόπο συλλογής των γνωμών και την ανάλυση. Εάν δεν έχουν ζητηθεί οι γνώμες, δηλώστε τους λόγους.",
	placeholder_search_content: "Αιτιολογήστε τον λόγο για τον οποίο δεν ζητήθηκε η γνώμη των ενδιαφερομένων.",
	treatment_lock: "Παρακαλώ ολοκληρώστε τα υπόλοιπα τμήματα πρωτού συμπληρώσετε τις γνώμες των ενδιαφερομένων.",
	treatment_nok: "Η επεξεργασία δεν μπορεί να διεξαχθεί.",
	treatment_ok: "Η επεξεργασία μπορεί να διεξαχθεί."
};
var pia$i = {
	attachments: {
		add: "Προσθήκη",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Αφαίρεση",
		title: "Συνημμένα",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Αίτηση ελέγχου",
		mandatory_fields: "Όλα τα πεδία πρέπει να συμπληρωθούν",
		structure_add_question: "Προσθήκη ερωτήματος",
		subsection_validated: "Το υποτμήμα ελέγχθηκε, σε αναμονή τελικής επικύρωσης",
		validate_evaluation: "Επικύρωση ελέγχου"
	},
	header: {
		display_action_plan: "Εμφάνιση<br>σχεδίου δράσης",
		edition: "Έκδοση",
		evaluation: "Αξιολόγηση",
		preview: "Προεπισκόπηση"
	},
	sections: {
		based_on_structure_name: "Με βάση το υπόδειγμα:",
		homepage_link: "Επιστροφή στον πίνακα ελέγχου",
		refuse_pia: "Απορριφθείσες ΕΑ",
		status: {
			evaluation: {
				cancel: "ακυρώσετε το αίτημα ελέγχου.",
				cancel_button: "Ακύρωση αιτήματος ελέγχου",
				content: "Αυτό το τμήμα δεν έχει ακόμη ελεγχθεί. Αν επιθυμείτε να επεξεργαστείτε το περιεχόμενο που έχει υποβληθεί για έλεγχο, πρέπει να ",
				title: "Σε αναμονή ελέγχου."
			},
			validation: {
				cancel: "ακυρώσετε το αίτημα επικύρωσης.",
				cancel_button: "Ακύρωση αιτήματος επικύρωσης",
				content: "Αυτό το τμήμα έχει ελεγχθεί και αναμένει τη συνολική επικύρωση της ΕΑ. Αν επιθυμείτε να αλλάξετε τον έλεγχο, πρέπει να ",
				title: "Σε αναμονή επικύρωσης."
			}
		},
		validate_pia: "Επικύρωση ΕΑ"
	},
	statuses: [
		"Σε εξέλιξη",
		"Απορρίφθηκε",
		"Απλή επικύρωση",
		"Υπογεγραμμένη επικύρωση",
		"Αρχειοθετημένη",
		"Σε αναμονή επικύρωσης"
	]
};
var questions$i = {
	edit: "Επεξεργασία ερωτήματος",
	gauges: [
		"(Απροσδιόριστο)",
		"Αμελητέο",
		"Περιορισμένο",
		"Σημαντικό",
		"Μέγιστο"
	],
	placeholder_title: "Τίτλος ερωτήματος (υποχρεωτικό)",
	remove: "Διαγραφή ερωτήματος"
};
var rejection_page$i = {
	applied_adjustments: "Προτεινόμενες προσαρμογές",
	applied_adjustments_placeholder: "Περιγράψτε τις αλλαγές που έγιναν στην ΕΑ.",
	button: {
		abandon_treatment: "Εγκατάλειψη επεξεργασίας",
		reject_pia: "Απόρριψη ΕΑ",
		send_for_validation: "Επανάληψη αποστολής για έγκριση"
	},
	previous_rejection: "Προηγούμενη άρνηση",
	rejection_reason: "Αιτιολογία απόρριψης",
	rejection_reason_placeholder: "Περιγράψτε τις αιτίες για την απόρριψη της ΕΑ",
	title: "Ιστορικό επικυρώσεων"
};
var sections$i = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Παρουσιάστε ένα σύντομο περίγραμμα της επεξεργασίας: το όνομά του, τους σκοπούς, τα διακυβεύματα, το πλαίσιο χρήσης, κ.λπ..",
						title: "Ποια είναι η υπό εξέταση επεξεργασία;"
					},
					"2": {
						placeholder: "Περιγράψτε τις ευθύνες των ενδιαφερομένων: του υπεύθυνου επεξεργασίας, ενδεχομένως των εκτελούντων την επεξεργασία και των από κοινού υπεύθυνων επεξεργασίας.",
						title: "Ποιες είναι οι ευθύνες που συνδέονται με την επεξεργασία;"
					},
					"3": {
						placeholder: "Αναφέρατε τα σχετικά πρότυπα που ισχύουν για την επεξεργασία, ειδικά εγκεκριμένους κώδικες δεοντολογίας και πιστοποιήσεις προστασίας δεδομένων.",
						title: "Υπάρχουν πρότυπα που ισχύουν για την επεξεργασία;"
					}
				},
				short_help: "Αυτό το τμήμα σας επιτρέπει να προσδιορίσετε και να παρουσιάσετε το αντικείμενο της μελέτης.",
				title: "Επισκόπηση"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Καταγράψτε τα δεδομένα που συλλέγονται και τυγχάνουν επεξεργασίας. Καθορίστε για κάθε ένα τη διάρκεια αποθήκευσης, τους αποδέκτες και τα άτομα που έχουν πρόσβαση σε αυτά.",
						title: "Ποιά προσωπικά δεδομένα υφίστανται επεξεργασία;"
					},
					"2": {
						placeholder: "Παρουσιάστε και περιγράψτε τον κύκλο ζωής των δεδομένων (από τη συλλογή δεδομένων έως την καταστροφή δεδομένων, τα διάφορα στάδια επεξεργασίας, την αρχειοθέτηση, κ.λπ.), για παράδειγμα, χρησιμοποιώντας ένα διάγραμμα ροών δεδομένων (προσθέστε το ως συνημμένο) και μια λεπτομερή περιγραφή των διαδικασιών που διεξήχθη.",
						title: "Πώς λειτουργεί ο κύκλος ζωής των δεδομένων και των διαδικασιών;"
					},
					"3": {
						placeholder: "Καταχωρίστε τα στοιχεία που υποστηρίζουν τα δεδομένα (λειτουργικά συστήματα, επιχειρηματικές εφαρμογές, συστήματα διαχείρισης βάσεων δεδομένων, σουίτες γραφείου, πρωτόκολλα, διαμορφώσεις, κ.λπ.)",
						title: "Ποια είναι τα στοιχεία που υποστηρίζουν τα δεδομένα;"
					}
				},
				short_help: "Αυτό το τμήμα σας επιτρέπει να ορίσετε και να περιγράψετε λεπτομερώς το αντικείμενο της επεξεργασίας.",
				title: "Δεδομένα, διαδικασίες και υποστηρικτικά στοιχεία"
			}
		},
		short_help: "Αυτή η ενότητα σας παρέχει μια σαφή εικόνα της επεξεργασίας των εν λόγω προσωπικών δεδομένων.",
		title: "Γενικό πλαίσιο"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Εξηγήστε γιατί οι σκοποί της επεξεργασίας, είναι σαφείς, ρητοί και νόμιμοι.",
						short_title: "Σκοποί",
						title: "Είναι σαφείς, ρητοί και νόμιμοι οι σκοποί επεξεργασίας;"
					},
					"2": {
						placeholder: "Περιγράψτε ποια είναι η νομική βάση της επεξεργασίας σας (π.χ.: συγκατάθεση, εκτέλεση συμβολαίου, συμμόρφωση με νομική υποχρέωση, προστασία ζωτικών συμφερόντων, κ.λπ.)",
						short_title: "Νομική βάση",
						title: "Ποια είναι η νομική βάση που καθιστά την επεξεργασία νόμιμη;"
					},
					"3": {
						placeholder: "Εξηγήστε γιατί κάθε ένα από τα δεδομένα που συλλέγονται είναι απαραίτητο για τους σκοπούς της επεξεργασίας σας.",
						short_title: "Επαρκή δεδομένα",
						title: "Τα προσωπικά δεδομένα που συλλέγονται είναι επαρκή, συναφή και περιορίζονται σε όσα είναι απαραίτητα σε σχέση με τους σκοπούς για τους οποίους υποβάλλονται σε επεξεργασία («ελαχιστοποίηση των δεδομένων»);"
					},
					"4": {
						placeholder: "Περιγράψτε ποια είναι τα μέτρα που έχουν ληφθεί για τη διασφάλιση της ποιότητας των δεδομένων.",
						short_title: "Ακρίβεια δεδομένων",
						title: "Τα δεδομένα είναι ακριβή και ενημερωμένα;"
					},
					"5": {
						placeholder: "Εξηγήστε γιατί οι διάρκειες αποθήκευσης δικαιολογούνται από τις νομικές απαιτήσεις ή / και τις ανάγκες της επεξεργασίας.",
						short_title: "Διάρκεια αποθήκευσης",
						title: "Ποια είναι η διάρκεια αποθήκευσης των δεδομένων;"
					}
				},
				short_help: "Αυτό το τμήμα σας επιτρέπει να αποδείξετε τη νομιμότητα της επεξεργασίας σας και των δεδομένων που υποβάλλονται σε επεξεργασία.",
				title: "Αναλογικότητα και αναγκαιότητα"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Περιγράψτε ποιες είναι οι πληροφορίες που δίνονται στα υποκείμενα των δεδομένων και ποια είναι τα μέσα για να γίνει αυτό.",
						short_title: "Πληροφορίες για τα υποκείμενα των δεδομένων",
						title: "Πώς ενημερώνονται τα υποκείμενα των δεδομένων σχετικά με την επεξεργασία;"
					},
					"2": {
						placeholder: "Περιγράψτε τα μέτρα που αποσκοπούν στη διασφάλιση της συγκατάθεσης των χρηστών.",
						short_title: "Λήψη συγκατάθεσης",
						title: "Εάν ισχύει, πώς επιτυγχάνεται η συγκατάθεση των υποκειμένων των δεδομένων;"
					},
					"3": {
						placeholder: "Περιγράψτε τα μέτρα που προορίζονται για να επιτρέψετε στα υποκείμενα δεδομένων να έχουν πρόσβαση, να λαμβάνουν και να διαβιβάζουν τα δεδομένα τους.",
						short_title: "Δικαίωμα στην πρόσβασης και φορητότητας",
						title: "Πώς μπορούν τα υποκείμενα δεδομένων να ασκήσουν τα δικαιώματά τους πρόσβασης και φορητότητας προσωπικών δεδομένων;"
					},
					"4": {
						placeholder: "Περιγράψτε τους ελέγχους που προορίζονται για να επιτρέψετε στα υποκείμενα δεδομένων να διορθώνουν και να διαγράφουν τα δεδομένα τους.",
						short_title: "Δικαίωμα διόρθωσης και διαγραφής",
						title: "Πώς μπορούν τα υποκείμενα δεδομένων να ασκήσουν τα δικαιώματά τους διόρθωσης και διαγραφής;"
					},
					"5": {
						placeholder: "Περιγράψτε τα μέτρα που προορίζονται να επιτρέψουν στα υποκείμενα των δεδομένων να περιορίζουν και να αντιτίθενται στην επεξεργασία των δεδομένων τους.",
						short_title: "Δικαίωμα περιορισμού και εναντίωσης",
						title: "Πώς μπορούν τα υποκείμενα δεδομένων να ασκήσουν τα δικαιώματά τους περιορισμού και εναντίωσης;"
					},
					"6": {
						placeholder: "Για κάθε εκτελούντα την επεξεργασία, περιγράψτε τις ευθύνες του (διάρκεια, πεδίο εφαρμογής, σκοπό, τεκμηριωμένες οδηγίες επεξεργασίας, προηγούμενη έγκριση) και προσκομίστε τις συμβάσεις, τους κώδικες δεοντολογία και τις πιστοποιήσεις που καθορίζουν τις αποστολές και τις υποχρεώσεις του.",
						short_title: "Υπεργολαβία",
						title: "Οι υποχρεώσεις των εκτελούντων την επεξεργασία προσδιορίζονται σαφώς και διέπονται από σύμβαση;"
					},
					"7": {
						placeholder: "Για κάθε χώρα εκτός της Ευρωπαϊκής Ένωσης όπου αποθηκεύονται ή υποβάλλονται σε επεξεργασία δεδομένα, ονομάστε την και δηλώστε εάν αναγνωρίζεται ότι προσφέρει επαρκές επίπεδο προστασίας δεδομένων ή περιγράψτε τις προβλέψεις που αφορούν στη μεταφορά.",
						short_title: "Μεταφορές",
						title: "Σε περίπτωση μεταφοράς δεδομένων εκτός της Ευρωπαϊκής Ένωσης, τα προσωπικά δεδομένα προστατεύονται επαρκώς;"
					}
				},
				short_help: "Αυτό το τμήμα σας επιτρέπει να αποδείξετε ότι εφαρμόζετε τα απαραίτητα μέσα που θα επιτρέψουν στα ενδιαφερόμενα άτομα να ασκήσουν τα δικαιώματά τους.",
				title: "Μέτρα για την προστασία των προσωπικών δικαιωμάτων των υποκειμένων των δεδομένων"
			}
		},
		short_help: "Αυτή η ενότητα σας επιτρέπει να δημιουργήσετε το πλαίσιο συμμόρφωσης για τις αρχές απορρήτου.",
		title: "Θεμελιώδεις αρχές"
	},
	"3": {
		items: {
			"1": {
				short_help: "Αυτή η ενότητα σας επιτρέπει να εντοπίσετε μέτρα (υπάρχοντα ή προγραμματισμένα) που συμβάλλουν στην ασφάλεια των δεδομένων.",
				title: "Προγραμματισμένα ή υπάρχοντα μέτρα"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Καταχωρίστε τις πιθανές επιπτώσεις",
						title: "Ποιες θα μπορούσαν να είναι οι κύριες <span class='green-highlight'>επιπτώσεις στα υποκείμενα δεδομένων</span> αν επέρχονταν ο κίνδυνος;"
					},
					"2": {
						placeholder: "Καταχωρίστε τις απειλές",
						title: "Ποιες είναι οι κύριες <span class='green-highlight'>απειλές</span> που θα μπορούσαν να οδηγήσουν στην επέλευση του κινδύνου;"
					},
					"3": {
						placeholder: "Καταχωρίστε τις πηγές κινδύνου",
						title: "Ποιές είναι οι <span class='green-highlight'>πηγές</span> κινδύνου;"
					},
					"4": {
						placeholder: "Κάντε κλικ για να επιλέξετε μέτρα που αφορούν στον κίνδυνο.",
						title: "Ποιά από τα εντοπισθέντα <span class='green-highlight'>μέτρα</span> συμβάλλουν στην αντιμετώπιση του κινδύνου;"
					},
					"5": {
						placeholder: "Αιτιολογήστε εδώ την εκτιμώμενη σοβαρότητα του κινδύνου.",
						title: "Πώς υπολογίζετε τη <span class='green-highlight'>σοβαρότητα του κινδύνου</span>, ειδικά ανάλογα με τις πιθανές επιπτώσεις και τα προγραμματισμένα μέτρα;"
					},
					"6": {
						placeholder: "Αιτιολογήστε εδώ την εκτιμώμενη πιθανότητα επέλευσης του κινδύνου.",
						title: "Πώς υπολογίζετε την <span class='green-highlight'>πιθανότητα του κινδύνου</span>, ειδικά ανάλογα με τις πιθανές επιπτώσεις και τα προγραμματισμένα μέτρα;"
					}
				},
				short_help: "Αναλύστε τα αίτια και τις συνέπειες της αθέμιτης πρόσβασης στα προσωπικά δεδομένα και εκτιμήστε τη σοβαρότητα και την πιθανότητά της.",
				title: "Αθέμιτη πρόσβαση στα δεδομένα"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Καταχωρίστε τις πιθανές επιπτώσεις",
						title: "Ποιές θα μπορούσαν να είναι οι κύριες <span class='green-highlight'>επιπτώσεις στα υποκείμενα των δεδομένων</span> σε περίπτωση επέλευσης του κινδύνου;"
					},
					"2": {
						placeholder: "Καταχωρίστε τις απειλές",
						title: "Ποιες είναι οι κύριες <span class='green-highlight'>απειλές</span> που θα μπορούσαν να οδηγήσουν στην επέλευση του κινδύνου;"
					},
					"3": {
						placeholder: "Καταχωρίστε τις πηγές κινδύνου",
						title: "Ποιές είναι οι <span class='green-highlight'>πηγές</span> κινδύνου;"
					},
					"4": {
						placeholder: "Κάντε κλικ εδώ για να επιλέξετε τα μέτρα που αφορούν στον κίνδυνο.",
						title: "Ποιά από τα προσδιορισθέντα <span class='green-highlight'>μέτρα</span> συμβάλλουν στην αντιμετώπιση του κινδύνου;"
					},
					"5": {
						placeholder: "Αιτιολογήστε εδώ την εκτιμώμενη σοβαρότητα του κινδύνου.",
						title: "Πώς εκτιμάτε τη <span class='green-highlight'>σοβαρότητα του κινδύνου</span>, ιδίως ανάλογα με τις πιθανές επιπτώσεις και τα προγραμματισμένα μέτρα;"
					},
					"6": {
						placeholder: "Αιτιολογήστε εδώ την εκτιμώμενη πιθανότητα επέλευσης του κινδύνου.",
						title: "Πώς εκτιμάτε την <span class='green-highlight'>πιθανότητα του κινδύνου</span>, ιδίως σε σχέση με τις απειλές, τις πηγές κινδύνου και τα προγραμματισμένα μέτρα;"
					}
				},
				short_help: "Αναλύστε τα αίτια και τις συνέπειες μιας ανεπιθύμητης αλλαγής των δεδομένων και εκτιμήστε τη σοβαρότητα και την πιθανότητά της.",
				title: "Ανεπιθύμητη τροποποίηση των δεδομένων"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Καταχωρίστε τις πιθανές επιπτώσεις",
						title: "Ποιές θα μπορούσαν να είναι οι κύριες <span class='green-highlight'>επιπτώσεις στα υποκείμενα των δεδομένων</span> σε περίπτωση επέλευσης του κινδύνου;"
					},
					"2": {
						placeholder: "Καταχωρίστε τις απειλές",
						title: "Ποιές είναι οι κύριες <span class='green-highlight'>απειλές</span>που θα μπορούσαν να οδηγήσουν στην επέλευση του κινδύνου;"
					},
					"3": {
						placeholder: "Καταχωρίστε τις πηγές κινδύνου",
						title: "Ποιές είναι οι <span class='green-highlight'>πηγές</span> κινδύνου;"
					},
					"4": {
						placeholder: "Κάντε κλικ εδώ για να επιλέξετε τα μέτρα που αφορούν στον κίνδυνο.",
						title: "Ποιά από τα προσδιορισθέντα <span class='green-highlight'>μέτρα</span> συμβάλλουν στην αντιμετώπιση του κινδύνου;"
					},
					"5": {
						placeholder: "Αιτιολογήστε εδώ την εκτιμώμενη σοβαρότητα του κινδύνου.",
						title: "Πώς εκτιμάτε τη <span class='green-highlight'>σοβαρότητα του κινδύνου</span>, ιδίως ανάλογα με τις πιθανές επιπτώσεις και τα προγραμματισμένα μέτρα;"
					},
					"6": {
						placeholder: "Αιτιολογήστε εδώ την εκτιμώμενη πιθανότητα επέλευσης του κινδύνου.",
						title: "Πώς εκτιμάτε την <span class='green-highlight'>πιθανότητα του κινδύνου</span>, ιδίως σε σχέση με τις απειλές, τις πηγές κινδύνου και τα προγραμματισμένα μέτρα;"
					}
				},
				short_help: "Αναλύστε τα αίτια και τις συνέπειες της απώλειας δεδομένων και εκτιμήστε τη σοβαρότητα και την πιθανότητά τους.",
				title: "Εξαφάνιση δεδομένων"
			},
			"5": {
				short_help: "Αυτή η απεικόνιση σας παρέχει μια σφαιρική και συνθετική άποψη των επιπτώσεων των μέτρων στους κινδύνους που προέρχονται από την επεξεργασία. ",
				title: "Επισκόπηση κινδύνων"
			}
		},
		short_help: "Αυτή η ενότητα σας επιτρέπει να αξιολογήσετε τους κινδύνους που αφορούν στην ιδιωτική ζωή, λαμβάνοντας υπόψη υπάρχοντα ή προγραμματισμένα μέτρα.",
		title: "Κίνδυνοι"
	},
	"4": {
		items: {
			"1": {
				short_help: "Αυτή η απεικόνιση σας επιτρέπει να έχετε μια συνολική και συνθετική άποψη των κινδύνων, πριν και μετά την εφαρμογή των συμπληρωματικών μέτρων.",
				title: "Χαρτογράφηση κινδύνων"
			},
			"2": {
				short_help: "Σχεδιάστε λεπτομερώς την εφαρμογή των πρόσθετων μέτρων που εντοπίστηκαν κατά τη διάρκεια της ΕΑ. Το σχέδιο δράσης ενημερώνεται αυτόματα κατά την αξιολόγηση των διαφόρων στοιχείων που περιλαμβάνονται στην ΕΑ.",
				title: "Σχέδιο δράσης"
			},
			"3": {
				short_help: "Παρουσιάστε τις συμβουλές του υπεύθυνου προστασίας δεδομένων και προστασίας της ιδιωτικής ζωής (εκπρόσωπος προστασίας δεδομένων εάν υπάρχει). Παρουσιάστε τις απόψεις των υποκειμένων των δεδομένων ή των εκπροσώπων τους.",
				title: "Γνώμες ΥΠΔ και ενδιαφερόμενων προσώπων"
			},
			"4": {
				title: "Επικύρωση της ΕΑ"
			},
			"5": {
				title: "Απορριφθείσα ΕΑ"
			}
		},
		short_help: "Αυτή η ενότητα σας επιτρέπει να προετοιμάσετε και να επισημοποιήσετε την επικύρωση της ΕΑ.",
		title: "Επικύρωση"
	}
};
var settings$i = {
	content: "Παρακαλώ, καταχωρίστε τη διεύθυνση (URL) του απομακρυσμένου διακομιστή:",
	title: "Ρυθμίσεις",
	update: "Ανανέωση του URL"
};
var summary$i = {
	action_plan: {
		fundamental_principles: "Θεμελιώδεις αρχές",
		implementation_date: "Αναμενόμενη ημερομηνία εφαρμογής",
		implementation_responsible: "Υπεύθυνος εφαρμογής",
		measures: "Υφιστάμενα ή προγραμματισμένα μέτρα",
		no_action_plan: "Δεν καταγράφηκε κανένα σχέδιο δράσης.",
		risks: "Κίνδυνοι",
		title: "Σχέδιο δράσης"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Συνημμένα",
	concerned_people_name: "Ονόματα των ενδιαφερομένων",
	concerned_people_opinion: "Γνώμες των ενδιαφερομένων",
	concerned_people_searched_opinion: "Αναζήτηση της γνώμης των ενδιαφερόμενων ανθρώπων",
	concerned_people_status: "Καθεστώς των ενδιαφερομένων",
	concerned_people_unsearched_opinion_comment: "Ο λόγος για τον οποίο δεν ζητήθηκε η γνώμη των πολιτών",
	content_choice: [
		"Η επεξεργασία δεν πρέπει να διεξάγεται.",
		"Η επεξεργασία θα μπορούσε να διεξαχθεί."
	],
	creation_date: "Ημερομηνία δημιουργίας",
	csv_action_plan_comment: "Σχόλιο σχεδίου δράσης",
	csv_evaluation_comment: "Σχόλιο αξιολόγησης",
	csv_file_title: "action-plan",
	csv_implement_date: "Εκτιμώμενη ημερομηνία υλοποίησης",
	csv_people_in_charge: "Επικεφαλής",
	csv_section: "Ενότητα",
	csv_title_object: "Τίτλος",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Όνομα του ΥΠΔ",
	dpo_opinion: "Γνώμη του ΥΠΔ",
	dpo_status: "Καθεστώς του ΥΠΔ",
	gauges: {
		"1": "Αμελητέο",
		"2": "Περιορισμένο",
		"3": "Σημαντικό",
		"4": "Μέγιστο"
	},
	modification_made: "Τροποποιήσεις που έγιναν",
	people_search_status_nok: "Δεν ζητήθηκε η γνώμη των ενδιαφερόμενων.",
	people_search_status_ok: "Ζητήθηκε η γνώμη των ενδιαφερόμενων.",
	pia_assessor: "Όνομα αξιολογητή",
	pia_author: "Όνομα συντάκτη",
	pia_name: "ΕΑ",
	pia_validator: "Όνομα επικυρωτή",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Επιστροφή στην προηγούμενη σελίδα",
	rejection_reason: "Λόγος απόρριψης",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Χαρτογράφηση κινδύνων",
	risks_overview_title: "Επισκόπηση κινδύνων",
	title: "Πληροφορίες ΕΑ"
};
var users$i = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several AIIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$i = {
	add_signed_pia: "Προσθήκη υπογεγραμμένης ΕΑ",
	after_reading: "Μετά την ανάγνωση της πλήρους ΕΑ που σχετίζεται με την επεξεργασία δεδομένων που συνδέεται με ",
	button: {
		rejection: "Απόρριψη ΕΑ",
		signed_validation: "Έγκριση ΕΑ <br>(υπογεγραμμένη)",
		simple_validation: "Έγκριση ΕΑ <br>(άμεση)"
	},
	confirmation1: "Βεβαιώνω ότι το πλαίσιο της επεξεργασίας προσωπικών δεδομένων που περιγράφεται στην ΕΑ είναι συνεπές με την πραγματικότητα.",
	confirmation2: "Βεβαιώνω ότι γνωρίζω τους κινδύνους ανάλογα με τα υπάρχοντα ή τα προγραμματισμένα μέτρα.",
	confirmation3: "Επικυρώνω τα διορθωτικά μέτρα που αναφέρονται στο σχέδιο δράσης.",
	confirmation4: "Δεσμεύομαι να υλοποιήσω το συντομότερο δυνατόν τις υποδεδειγμένες διορθωτικές ενέργειες.",
	latest_signed_attachment: "Τελευταίο υπογεγραμμένο συνημμένο",
	mandatory_fields: "Όλα τα κουτιά πρέπει να συμπληρωθούν",
	remove_attachment: "Αφαίρεση συνημμένου",
	responsible: "Άτομο υπεύθυνο για την επικύρωση της ΕΑ: ",
	signed_attachments_history: "Ιστορικό υπογεγραμμένων συνημμένων",
	tools: {
		dashboard: "Πίνακας Ελέγχου",
		display_pia: "Εμφάνιση ΕΑ"
	},
	validated_pia_with_signature: "Εγκρίθηκε",
	waiting_for_signature: "Εκκρεμεί υπογραφή EA"
};
var el = {
	about: about$i,
	action_plan: action_plan$i,
	authentication: authentication$i,
	cartography: cartography$i,
	comments: comments$i,
	conflict: conflict$i,
	date: date$i,
	errors: errors$i,
	evaluations: evaluations$i,
	header: header$i,
	help: help$i,
	homepage: homepage$i,
	knowledge_base: knowledge_base$i,
	measures: measures$i,
	misc: misc$i,
	modals: modals$i,
	onboarding: onboarding$i,
	opinions: opinions$i,
	"overview-risks": {
	important: "Σημαντικός",
	limited: "Περιορισμένο",
	maximal: "Μέγιστο",
	measures: "Μέτρα",
	negligible: "Αμελητέο",
	potential_impacts: "Πιθανές επιπτώσεις",
	"risk-access_x": "Σοβαρότητα",
	"risk-access_y": "Πιθανότητα",
	"risk-change_x": "Σοβαρότητα",
	"risk-change_y": "Πιθανότητα",
	"risk-disappearance_x": "Σοβαρότητα",
	"risk-disappearance_y": "Πιθανότητα",
	sources: "Πηγές",
	threat: "Απειλές"
},
	pia: pia$i,
	questions: questions$i,
	rejection_page: rejection_page$i,
	sections: sections$i,
	settings: settings$i,
	summary: summary$i,
	users: users$i,
	validation_page: validation_page$i
};

var about$h = {
	contribute: "If you wish to provide feedback, email us.",
	description: "This tool was originally developed for the <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, the French Data Protection Authority, to assist data controllers, processors, providers, deployers and others comply with the GDPR. It is now expanded to include the AI Act.",
	licences: "Library licences:",
	title: "About the AIIA Tool",
	translators: "<br />The AIIA software is currently available in English.",
	translators_name: "",
	version_number: "Version number"
};
var action_plan$h = {
	acceptable_measures: "Acceptable measures",
	edit: "Edit",
	improvable_measures: "Improvable measures",
	measures: "Existing or planned measures",
	no_action_plan: "No action plan recorded.",
	placeholder_person_in_charge: "Person responsible",
	principles: "Risk Identification",
	risk1: "Ineffective performance",
	risk2: "Unethical behaviour",
	risk3: "Diminished stewardship",
	risks: "Risks",
	title: "Overview"
};
var authentication$h = {
	"12_characters": "12 characters",
	account_recovery: "Password recovery",
	activation_code: "Activation code",
	cancel: "Cancel",
	confirm: "Confirm",
	confirmation: "Confirmation",
	"continue": "Continue",
	activate_account: "activate account",
	create_account: "Sign up",
	create_account2: "Create account",
	description: "This software has been designed to guide data controllers, processors, providers, deployers and all operators in building and demonstrating compliance to the AI Act and GDPR. It assists to properly carry out data protection and fundamental rights impact assessments by facilitating the use of the AIIA methodology.",
	email: "Email",
	email_placeholder: "Email",
	forgotten_password: "Forgotten ?",
	login: "Login",
	lowercase: "Lowercase",
	password: "Password",
	password_security: "Password security",
	recovery_code: "Reset code",
	recovery_code_message: "An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "Unreceived code?",
	saved_password: "Your password is saved. You can now sign in.",
	sign_in: "Sign in",
	sign_in_button: "Sign in",
	sign_out_button: "Sign out",
	special_character: "Special character (!@#$%^&*()?...)",
	number: "Number",
	start: "Start",
	start_app: "START AN AI IMPACT ASSESSMENT",
	subtitle1: "",
	subtitle2: "",
	title: "Artificial intelligence impact assessment",
	transaction_error: "Unable to process your request.",
	uppercase: "Uppercase",
	wrong_activation_code: "(wrong)",
	wrong_confirmation: "Passwords are not the same",
	wrong_email: "Wrong email",
	sso: "SSO connection",
	errors: {
		sign_in: {
			"400": "Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "Wrong activation code",
				"406": "This account is already activated"
			},
			password: {
				"404": "User not found",
				"406": "The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "User not found",
				"423": "Account locked"
			},
			uuid: {
				"404": "Wrong recovery code"
			},
			password: {
				"404": "User not found",
				"406": "The password does not meet the password policy requirements."
			}
		},
		unauthorized: "You are not allowed to access this resource.",
		incompatibility: "Version incompatibility between your server (aiia-back) and your application (aiia). Please contact your IT department."
	}
};
var cartography$h = {
	important: "High",
	legend1: "Existing or planned measures",
	legend2: "With the corrective measures implemented",
	legend3: "(I)neffective performance",
	legend4: "(U)nethical behaviour",
	legend5: "(D)iminished stewardship",
	likelihood_axe: "Risk likelihood",
	limited: "Moderate",
	maximal: "Unacceptable",
	negligible: "Unlikely",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Severity of harm"
};
var comments$h = {
	comment: "Comment",
	written_by: "Written by",
	comments_count: "comment(s)",
	new_comment: "Comment",
	placeholder_new_comment: "Leave a comment",
	send: "Send"
};
var conflict$h = {
	keep_initial: "Keep initial content",
	keep_new: "Update with new content",
	initial_content: "Initial content",
	merge: "Merge both contents",
	new_content: "New content",
	title: "Conflict detected"
};
var date$h = {
	april: "April",
	august: "August",
	december: "December",
	"earlier-in-this-month": "Earlier this month",
	"earlier-in-this-week": "Earlier this week",
	february: "February",
	january: "January",
	july: "July",
	june: "June",
	march: "March",
	may: "May",
	november: "November",
	october: "October",
	september: "September",
	today: "Today",
	yesterday: "Yesterday"
};
var errors$h = {
	content: "If you encounter other problems or if you have suggestions for improvement,<br>you can send them back to us.</a>",
	title: "Page not found."
};
var evaluations$h = {
	acceptable: "Acceptable",
	action_plan_comment: "Action plan / corrective actions",
	evaluation_comment: "Evaluation comment",
	gauges: {
		"0": "(Undefined)",
		"1": "Negligible",
		"2": "Moderate",
		"3": "High",
		"4": "Unacceptable",
		likelihood: "Taking into account the action plan, how do you re-evaluate the <span class='red-highlight'>likelihood of this risk</span>?",
		seriousness: "Taking into account the action plan, how do you re-evaluate the <span class='red-highlight'>seriousness of this risk</span>?"
	},
	improvable: "Improvable",
	placeholder_acceptable: "According to the available information, the measures implemented are adequate to properly meet the requirements for protecting the data.",
	placeholder_improvable1: "According to the available information, additional measures are to be implemented in order to improve the data protection of the processing.",
	placeholder_improvable2: "Enter your comments.",
	placeholder_to_correct: "The information provided are not sufficient to properly evaluate them. Send back to the editor to improve the original submission.",
	status: [
		"Pending",
		"To correct",
		"Improvable",
		"Acceptable"
	],
	title: "Evaluation",
	to_correct: "To correct"
};
var header$h = {
	archives: "AIIA Archives",
	current_pias: "Current AIIAs",
	exit_full_screen_mode: "Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "Report an issue",
		manual: "User manual",
		pia_example_link: "AIIA example",
		title: "Help"
	},
	homepage_link: "My AIIAs",
	knowledge_base_link: "Knowledge base",
	languages: {
		ar: "العربية",
		bg: "Български",
		cnil_translations: "CNIL provided translations",
		community_translations: "Community provided translations",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Translation revised by European DPA",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Original version",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "...",
	logo_title: "Artificial intelligence impact assessment",
	structures: "AIIA templates",
	tools: {
		about: "About",
		accessibility: "Visually impaired accessibility (high contrast colors, daltonism)",
		onboarding: "Restart tutorial",
		settings: "Settings",
		url_setting: "Server URL configuration",
		users: "Users"
	}
};
var help$h = {
	definition: {
		data1: {
			content: "Content being written",
			title: "Use the AIIA tool"
		},
		data2: {
			qa1: {
				content: "When encountering those display issues, close the application and reload it. It usually fixes the issue. You won’t lose the information you have entered ; it is  automatically saved as you type.",
				title: "I get display issues such as icons being stuck in one state or missing elements from the interface"
			},
			qa2: {
				content: "This known issue is currently being fixed. If you encounter this problem, we recommend that you fill in the justification field of the estimated level of severity and / or likelihood. You will be able to edit the gauge once the bug is fixed.",
				title: "I can’t edit the gauges for evaluating the severity and likelihood of a risk"
			},
			qa3: {
				content: "Several bugs have been observed when importing an AIIA, and in particular the level gauges for evaluating the severity and likelihood of a risk may disappear. In this case, please refer to the above mentioned issue. Besides, an AIIA may not appear on the dashboard after importing it. This is a display issue and you just need to refresh the page.",
				title: "I encounter issues when importing an AIIA"
			},
			qa4: {
				content: "This is only a display bug and it has no effect on the text you enter in a field. This visual problem will be fixed soon.",
				title: "When I copy / paste text, it is highlighted."
			},
			qa5: {
				content: "In order to evaluate a section, it is mandatory to fill in all the fields. Please check if this is the case. When editing a risk, you must have at least one technical or organizational measure that mitigates the risk in order to ask for an evaluation of the risk.",
				title: "I can’t evaluate a section"
			},
			qa6: {
				content: "Please close the AIIA you are editing and re-open it. The content should then be displayed in the language you have selected.",
				title: "When switching language, the texts are not translated"
			},
			qa7: {
				content: "For the moment, the navigation menu icons are not refreshed after refusing an AIIA. You have to check each section and change the information and/or evaluation according to the reasons for refusing the AIIA. Once all section have been reviewed, you should be able to request AIIA validation again.",
				title: "I have refused to validate an AIIA but I don’t know what to do now"
			},
			title: "Known Issues"
		},
		footer: "If you have any other problems or suggestions for improvement, you can visit our <a target=\"_blank\" href=\"https://github.com/LINCnil/pia\">Github resository</a> and submit an issue or a pull request."
	},
	title: "Help"
};
var homepage$h = {
	cards: {
		author: "Editing",
		category: "Category",
		creation_status: "Creation",
		date: "Date",
		evaluation: "Review",
		guest: "Guest(s)",
		import_pia: "Import AIIA",
		import_structure: "Import template",
		item: {
			consult_pia: "Consult",
			consult_structure: "Consult template",
			edit_pia: "Edit",
			edit_structure: "Edit template",
			tools: {
				action_plan: "Display<br>action plan",
				archive: "Archive",
				duplicate: "Duplicate",
				"export": "Export",
				more_options: "More options",
				pia: "Display<br>AIIA",
				remove: "Delete",
				unarchive: "Unarchive"
			},
			validate_pia: "Validate"
		},
		knowledges: {
			edit: "Edit the base",
			"import": "Import a base",
			"new": "Create a base",
			placeholder_author: "Author",
			placeholder_contributors: "Contributors",
			placeholder_entry_number: "Number of entries",
			placeholder_name: "Base's name"
		},
		knowledges_entry: {
			all_sections: "All sections",
			choose_category: "Choose a category",
			contents: "Contents",
			create: "Create this element",
			linked_to: "Linked to",
			"new": "Create an element",
			placeholder_category: "Category",
			placeholder_description: "Your description here...",
			placeholder_name: "Element's name",
			placeholder_updated_at: "Last updated"
		},
		new_pia: "New AIIA",
		new_structure: "New template",
		or: "or",
		pia_name: "AIIA",
		placeholder_author: "Firstname, lastname",
		placeholder_category: "Category",
		placeholder_evaluation: "Firstname, lastname",
		placeholder_import_knowledgeBase: "Import base",
		placeholder_import_pia: "Import AIIA",
		placeholder_import_structure: "Import template",
		placeholder_new_knowledgeBase: "New base",
		placeholder_new_pia: "New AIIA",
		placeholder_new_structure: "New template",
		placeholder_pia_name: "AIIA's title",
		placeholder_sector_name: "Associated sector's name",
		placeholder_start: "All fields must be filled",
		placeholder_structure: "Default template",
		placeholder_structure_name: "Template's title",
		placeholder_validation: "Firstname, lastname",
		sector_name: "Sector",
		start: "Start",
		status: "Status",
		structure: "Template",
		structure_name: "Template's name",
		title_close_creation: "Close",
		validation: "Validation"
	},
	filters: {
		assessor: "Reviewer",
		author: "Author",
		card: "Card view",
		card_rocket_content: "Get started !<br>To initiate an AIIA,<br> click on the +",
		card_rocket_content_structure: "Get started ! To initiate <br>a template, click on the +",
		category: "Category",
		date: "Date",
		import_pia: "Import AIIA",
		import_structure: "Import template",
		list: "List view",
		list_rocket_content: "Get started ! <br>To initiate an AIIA, click on the +",
		list_rocket_content_structure: "Get started ! To initiate <br>a template, click on the +",
		name: "Name",
		new_pia: "New AIIA",
		new_structure: "New template",
		sector_name: "Associated sector",
		sort: "Sort",
		sort_by: "by",
		status: "Status",
		validator: "Validator"
	},
	lists: {
		column_actions: "Actions",
		column_author: "Editing",
		column_category: "Category",
		column_creation: "Created",
		column_evaluation: "Review",
		column_pia: "AIIA",
		column_progression: "Progress",
		column_sector_name: "Associated sector",
		column_status: "Status",
		column_structure: "Template",
		column_structure_name: "Template",
		column_updated_at: "Last opened",
		column_validation: "Validation",
		item: {
			tools: {
				action_plan: "Display action plan",
				archive: "Archive",
				consult: "Consult",
				duplicate: "Duplicate",
				edit: "Edit",
				"export": "Export",
				pia: "Display AIIA",
				remove: "Delete",
				unarchive: "Unarchive"
			}
		}
	},
	search_filter: "Search",
	no_entries: {
		pia: "No AIIA created and/or assigned",
		archive: "No AIIA archive"
	}
};
var knowledge_base$h = {
	add_measure: "Add",
	add_measure_hint: "You can also add a measure from the knowledge base.",
	category: {
		definition: "Definition",
		example: "Example",
		general_measure: "Fundamental principles",
		measure_on_data: "Fundamental rights",
		method: "AI Act and GDPR",
		organizational_measure: "Internal controls",
		principle: "Principle or Right"
	},
	choose_knowledge_base: "Choose your knowledge base",
	default_knowledge_base: "AIIA knowledge base",
	filters: {
		all: "All",
		definitions: "Definitions",
		general_measures: "Fundamental principle controls",
		measures_on_data: "Fundamental right controls",
		no_result: "No result found.",
		organizational_measures: "Internal controls",
		title: "Filters"
	},
	placeholder_add_measure: "Add this measure",
	placeholder_help: "Entry aids",
	search: "Search",
	slugs: {
        PIA_DEF_AIM: {
            description: "The AI measure described in <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 of [GDPR]</a>",
            name: "Artificial intelligence",
            source: "AI Act Art. ..."
        },
        PIA_DEF_AIP: {
            description: "The AI principle described in <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 of [GDPR]</a>",
            name: "Artificial intelligence",
            source: "AI Act Art. ..."
        },
		PIA_DEF_ACC: {
			description: "The data subject shall have the right to obtain from the controller confirmation as to whether or not personal data concerning him or her are being processed, and, where that is the case, access to the personal data and the information described in <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 of [GDPR]</a>",
			name: "Right of access",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Process removing the identifying characteristics from personal data. To assess the robustness of an anonymisation processes, see the <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Anonymisation",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Procedures preserving and managing the electronic archives containing the personal data intended to ensure their value (specifically, their legal value) throughout the entire period necessary (transfer, storage, migration, accessibility, elimination, archiving policy, protection of confidentiality, etc.).",
			name: "Archiving",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Every person with legitimate access to personal data (employees, contracting parties and other third parties) should be identified by a unique identifier. Choose an authentication method to open sessions that is appropriate to the context, the risk level and the robustness expected. Recommendations: if the risks are not elevated, a password may be used; however, if the risks are higher, use a one-time password token but change the default activation password, or, when part of the password is sent by SMS, a card with a PIN code, an electronic certificate or any other form of strong authentication.",
			name: "Authentication",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Measure making personal data unintelligible to anyone without access authorization (symmetric or asymmetric encryption, use of public algorithms known to be strong, authentication certificate, etc.).",
			name: "Encryption",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Data organisation methods that reduce the possibility that personal data can be correlated and that a breach of all personal data may occur. For instance, by identifying the personal data useful only to each business process and logically separating them.",
			name: "Data partitioning",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Any freely given, specific, informed and unambiguous indication of the data subject's wishes by which he or she, by a statement or by a clear affirmative action, signifies agreement to the processing of personal data relating to him or her.<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.10 of [GDPR]</a>",
			name: "Consent",
			source: "GDPR Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Means implemented to limit the risks that unauthorized persons will access personal data electronically, it requires among other things to : <br>- <strong>manage users' profiles</strong> by separating tasks and areas of responsibility (preferably in centralised fashion) to limit access to personal data exclusively to authorised users by applying need-to-know and least-privilege principles;<br>- <strong>withdraw the rights of employees, contracting parties and other third parties when they are no longer authorised to access a premises or a resource</strong> or when their <strong>employment contract ends</strong>.",
			name: "Logical access controls",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Any information relating to an identified or identifiable natural person (‘data subject’); an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.1 of [GDPR]</a>",
			name: "Personal data",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Natural or legal person, public authority, agency or another body, to which the personal data are disclosed, whether a third party or not. However, public authorities which may receive personal data in the framework of a particular inquiry in accordance with Union or Member State law shall not be regarded as recipients; the processing of those data by those public authorities shall be in compliance with the applicable data protection rules according to the purposes of the processing. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.9 of [GDPR]</a>",
			name: "Recipient",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: " The data subject shall have the right to obtain from the controller the erasure of personal data concerning him or her without undue delay and the controller shall have the obligation to erase personal data without undue delay, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 17 of [GDPR]</a>",
			name: "Right to erasure",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Expected benefits (for the organisation, for the data subjects, for society in general, etc.).",
			name: "Benefits",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Personal data shall be accurate and, where necessary, kept up to date; every reasonable step must be taken to ensure that personal data that are inaccurate, having regard to the purposes for which they are processed, are erased or rectified without delay (‘accuracy’). <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 d) of [GDPR]</a>",
			name: "Quality of data",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Severity represents the magnitude of a risk. It primarily depends on the prejudicial nature of the potential impacts.",
			name: "Severity",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "The data subject shall have the right to obtain from the controller restriction of processing, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 18 of [GDPR]</a>",
			name: "Right to restricting of processing",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Set up a logging architecture to allow early detection of incidents involving personal data and to have information that can be used to analyze them or provide proof in connection with investigations.",
			name: "Surveillance",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Procedure comprising one or more individual actions on data supporting assets. It is used, intentionally or otherwise, by risk sources and may cause a feared event.",
			name: "Threat",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Threats regarding: - <strong>Hardware</strong>, used inappropriately, observed, altered, lost (use or transportation of sensitive hardware for personal purposes, watching a person's screen without their knowledge while on the train, tracking by a hardware-based key logger, etc.)<br> - <strong>Software</strong>, used inappropriately, observed, altered (raising of privileges, collection of configuration data, infection by malicious code, etc.)<br>- <strong>Computer channels</strong> observed (Interception of Ethernet traffic, etc.)<br>- <strong>People</strong>, observed, manipulated, lost (Unintentional disclosure of information, social engineering, assignment changes)<br>- <strong>Paper documents</strong> observed, lost (reading, theft of mail, etc.)<br>- <strong>Paper transmission channels</strong> observed (reading of signature books in circulation, etc.)",
			name: "Threats that can lead to an illegitimate access",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Threats regarding : </strong><br>- <strong>Hardware</strong> : used inappropriately, overloaded, altered, damaged, lost (storage unit full, processing capacity overload, addition of incompatible hardware resulting in malfunctions,  fire, theft or loss of an asset, etc.)<br>- <strong>Software</strong> : used inappropriately, overloaded, altered, damaged, lost (erasure of data, exceeding of database size, logic bomb, non-renewal of the licence for software used to access data, etc.)<br>- <strong>Computer channels</strong> : overloaded, altered, lost (unauthorised downloading, loss of Internet connection, etc.)<br>- <strong>People</strong> : overloaded, damaged, lost (poor use of skills, disease, retirement, etc.)<br>- <strong>Paper documents</strong> : used inappropriately, damaged, lost (erasure, aging of archived documents, theft or loss of documents, etc.)<br>- <strong>Paper transmission channels</strong> : overloaded, damaged, altered, lost (mail delivery halted by a strike, reassignment of offices or premises, loss of a document delivery company, reorganisation of paper transmission channels, etc.)",
			name: "Threats that can lead to a disappearance of personal data",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Threats regarding : </strong><br>- <strong>Hardware</strong> altered (addition of incompatible hardware resulting in malfunctions, removal of essential components, etc.)<br>- <strong>Software</strong> used inappropriately or altered (Unwanted modifications to data in databases, operator errors that modify data, etc.)<br>- <strong>Computer channels</strong> used inappropriately (resending of intercepted data, etc.)<br>- <strong>People</strong> overloaded or manipulates (assignment of staff to tasks beyond their abilities, stress or negative changes in working conditions, influence, etc.)<br>- Paper documents that have been altered (changes to figures in a file, replacement of an original by a forgery, etc.)<br>- <strong>Paper transmission channels</strong> that have been altered (change from one signature book to another, sending of multiple conflicting documents, etc.)",
			name: "Threats that can lead to an unwanted modification of personal data",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "To be chosen among those available in section \"Existing or planned measures\", which you may complete if needed.",
			name: "Measures",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "When data are being imported, different types of metadata (such as EXIF data with an image file attached) can unintentionally be collected. <br>Such metadata must be identified and eliminated if they are unnecessary for the purposes specified.",
			name: "Filtering and removal",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Once sensitive data have been received, as part of a series of general information or transmitted for statistical purposes only, these can be converted into a less sensitive form or pseudonymised. For example : <br>- if the system collects the IP address to determine the user's location for a statistical purpose, the IP address can be deleted once the city or district has been deduced<br>- if the system receives video data from surveillance cameras, it can recognise people who are standing or moving in the scene and blur them<br>- if the system is a smart meter, it can aggregate the use of energy over a certain period, without recording it in real time",
			name: "Reducing sensitivity via conversion",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "The system can ensure that: <br>- the user can use a resource or service without the risk of disclosing his/her identity (anonymous data)<br>- the user can use a resource or service without the risk of disclosing his/her identity, but remain identifiable and responsible for this use (pseudonymous data)<br>- the user can make multiple uses of resources or services without the risk of these different uses being linked together (data cannot be correlated)<br>- the user can use a resource or service without the risk of others, third parties in particular, being able to observe that the resource or service is being used (non-observability)<br>The choice of a method from the list above must be made on the basis of the threats identified. For some types of threat to privacy, pseudonymization will be more appropriate than anonymisation (for example, if there is a traceability need). In addition, some threats to privacy will be addressed using a combination of methods.",
			name: "Reducing the identifying nature of data",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "The system can be organised into independent parts with separate access control functions. The data can also be divided between these independent sub-systems and controlled by each sub-system using different access control mechanisms. If a sub-system is compromised, the impacts on all of the data can thus be reduced.",
			name: "Reducing data accumulation",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "The system can limit data access according to the \"need to know\" principle. The system can separate the sensitive data and apply specific access control policies. The system can also encrypt sensitive data to protect their confidentiality during transmission and storage. Access to temporary cookies which are produced during the data processing must also be protected.",
			name: "Restricting data access",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Reduce the severity of risks by limiting the amount of personal data to what is strictly necessary to achieve a defined purpose, otherwise the data shall be not collected.",
			name: "Minimising the amount of personal data",
			source: "PIA3 p64"
		},
		PIA_DEF_MIND: {
			description: "Reduce the severity of risks by minimizing the data themselves, by taking measures aimed at reducing their sensitivity such as filtering and removing unnecessary data, pseudonymising data, etc.",
			name: "Minimization of data themselves",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "The data subject shall have the right to object, on grounds relating to his or her particular situation, at any time to processing of personal data concerning him or her, pursuant to <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 21 of [GDPR]</a>",
			name: "Right to object",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Measures taken to integrate the protection of personal data in all new processing operations (trusted names, guidelines, CNIL methodology for risk management or other internal methodology).",
			name: "Project Management",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Persons to whom the data covered by the processing relate.",
			name: "Data subject",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " The data subject shall have the right to receive the personal data concerning him or her, which he or she has provided to a controller, in a structured, commonly used and machine-readable format and have the right to transmit those data to another controller without hindrance from the controller to which the personal data have been provided, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 20 of [GDPR]</a>",
			name: "Right to data portability",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Processing of personal data in such a manner that the personal data can no longer be attributed to a specific data subject without the use of additional information, provided that such additional information is kept separately and is subject to technical and organisational measures to ensure that the personal data are not attributed to an identified or identifiable natural person.<br>Pseudonymisation  reduces  the  linkability  of  a  dataset  with  the  original  identity  of  a  data subject; as such, it is a useful security measure but not a method of anonymisation.",
			name: "Pseudonymisation",
			source: "GDPR Art. 4.5 and guidelines G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Passwords shall be composed of a minimum of eight characters; must be renewed if there is the least concern that they may have been compromised and, possibly, periodically (every six months or once a year) and must include a minimum of three of the four kinds of characters (capital letters, lower case letters, numerals and special characters); when a password is changed, the last five passwords may not be reused; the same password should not be used for different accesses; passwords should not be related to one's personal information (including name or date of birth.). Define a maximum number of attempts beyond which a warning is issued and authentication is blocked (temporarily or until it is manually unblocked).",
			name: "Password",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "The data subject shall have the right to obtain from the controller without undue delay the rectification of inaccurate personal data concerning him or her. Taking into account the purposes of the processing, the data subject shall have the right to have incomplete personal data completed, including by means of providing a supplementary statement.",
			name: "Right to rectification",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Regulation on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC.",
			name: "GDPR (General Data Protection Regulation",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Natural or legal person, public authority, agency or other body which, alone or jointly with others, determines the purposes and means of the processing of personal data; where the purposes and means of such processing are determined by Union or Member State law, the controller or the specific criteria for its nomination may be provided for by Union or Member State law.<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.7 of [GDPR]</a>",
			name: "Controller",
			source: "GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Person or non-human source that can cause a risk. This source may act accidentally or deliberately.",
			name: "Risk source",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Natural or legal person, public authority, agency or other body which processes personal data on behalf of the controller, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 of [GDPR]</a>.<br>The processor and any person acting under the authority of the controller or of the processor, who has access to personal data, shall not process those data except on instructions from the controller, unless required to do so by Union or Member State law, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 29 of [GDPR]</a>.",
			name: "Processor",
			source: "GDPR Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Asset on which personal data rely. This may be hardware, software, networks, people, paper or paper transmission channels",
			name: "Supporting assets",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Breach of security leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, personal data transmitted, stored or otherwise processed.",
			name: "Personal data breach",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Likelihood expresses the possibility of a risk occurring. It primarily depends on the level of vulnerabilities of the supporting assets when under threat and the level of capabilities of the risk sources to exploit them.",
			name: "Likelihood",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Data for a score system, result of the application of the score....",
			name: "Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Identification data</strong> : Civil status, identity, age, etc. <br><strong>Personal life</strong> : living habits, marital status, etc. <br><strong>Professional life </strong> : résumé, education and professional training, awards, etc. <br><strong>Connection data </strong> : IP addresses, event logs, etc.<br><strong>Location data</strong> : travels, GPS data, GSM data, etc.<br><strong>Others</strong> : phone number, email address, etc.",
			name: "Common personal data",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Philosophical, political, religious and trade-union views, sex life, health data, racial or ethnic origin, data concerning health or sex life, offenses, convictions, security measures, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Convictions and sensitive personal data"
		},
		PIA_EX_DCPS: {
			description: "National ID number, social security number (NIR), biometric data, bank data",
			name: "Personal data perceived as sensitive"
		},
		PIA_EX_HUME: {
			description: "It could be either:<br>- a rogue or naive neighbor, by having a physical proximity, hacking into the device's data;<br>- a hacker targeting a user by using the knowledge he/she has of the user and some of the information concerning him/her;<br>- a hacker targeting one of the companies by using the knowledge he/she has of the companies that can undermine their image;<br>- an authorised third party company using its privileged access to illegitimately access information.",
			name: "External human sources"
		},
		PIA_EX_HUMI: {
			description: "It could be either:<br>- a negligent or rogue employee, proximity of the system, skills, privileges and available time are potentially high, possible lack of training and awareness<br>- negligent or rogue user, family member or friend having access to the service.<br> Various motives are possible, including : clumsiness, error, negligence game, malicious intent, revenge, spying",
			name: "Internal human sources"
		},
		PIA_EX_IMPI: {
			description: "Data subjects may encounter significant consequences, which they should be able to overcome albeit with real and serious difficulties. For example: <br>- physical : serious physical ailments causing long-term harm (worsening of health due to improper care, or disregard of contraindications), lteration of physical integrity for example following an assault, an accident at home, work, etc.<br>- material : misappropriation of money not compensated, targeted, unique and non-recurring, lost opportunities  (home loan, refusal of studies, internships or employment, examination ban), loss of housing, loss of employment, etc.;<br>- moral : serious psychological ailments (depression, development of a phobia), feeling of invasion of privacy with irreversible damage, victim of blackmailing, cyberbullying and harassment, etc.",
			name: "Significant (high) impact"
		},
		PIA_EX_IMPL: {
			description: "Data subjects may encounter significant inconveniences, which they will be able to overcome despite a few difficulties. For example:<br>- physical : minor physical ailments (minor illness due to disregard of contraindications), defamation resulting in physical or psychological retaliation, etc.;<br>- material : unanticipated payments (fines imposed erroneously), denial of access to administrative or commercial services, receipt of unsolicited targeted mailings likely to damage the reputation of data subjects, etc.;<br>- moral : minor but objective psychological ailments, feeling of invasion of privacy without irreversible damage, intimidation on social networks, etc.",
			name: "Limited (medium) impact"
		},
		PIA_EX_IMPM: {
			description: "Data subjects may encounter severe, or even irreversible, consequences, which they may not overcome. For example:<br>- physical : long-term or permanent physical ailments, permanent impairment of physical integrity, death;<br>- material : financial risk, substantial debts, inability to work, inability to relocate, loss of evidence in the context of litigation, loss of access to vital infrastructure (water, electricity), etc.<br>- moral : long-term or permanent psychological ailments, criminal penalty, abduction, loss of family ties, inability to sue, change of administrative status and/or loss of legal autonomy (guardianship), etc.<br>-prohibited discrimination or bias: subliminal techniques beyond a person’s consciousness or purposefully manipulative or deceptive techniques; exploitative of the vulnerabilities of a natural person or a specific group of persons due to their age, disability or a specific social or economic situation; evaluation or classification of natural persons or groups of persons over a certain period of time based on their social behaviour or known, inferred or predicted personal or personality characteristics; predicting the risk of a natural person committing a criminal offence, based solely on the profiling of a natural person or on assessing their personality traits and characteristics; untargeted scraping of facial images from the internet or CCTV footage; infer emotions of a natural person in the areas of workplace and education institutions; use of biometric categorisation systems that categorise individually natural persons based on their biometric data to deduce or infer their race, political opinions, trade union membership, religious or philosophical beliefs, sex life or sexual orientation; use of ‘real-time’ remote biometric identification systems in publicly accessible spaces for the purposes of law enforcement, unless it is dtrictly necessary.",
			name: "Catastrophic and prohibited impact"
		},
		PIA_EX_IMPN: {
			description: "Data subjects either will not be affected or may encounter a few inconveniences, which they will overcome without any problem. For example:<br>- physical : transient headaches;<br>- material : loss of time in repeating formalities or waiting for them to be fulfilled, receipt of unsolicited mail (e.g.: spams), reuse of data published on websites for the purpose of targeted advertising , etc.;<br>- moral : mere annoyance, feeling of invasion of privacy without real or objective harm (commercial intrusion), etc.",
			name: "Negligible impact"
		},
		PIA_EX_NHUM: {
			description: "Incident or damage at one of the organisation (power cut, fire, flood, etc.)",
			name: "Non-human sources"
		},
		PIA_EX_VRAI: {
			description: "It seems possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in offices that cannot be accessed without first checking in at the reception).",
			name: "Likelihood is High"
		},
		PIA_EX_VRAL: {
			description: "It seems difficult for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader).",
			name: "Likelihood is Limited"
		},
		PIA_EX_VRAM: {
			description: "It seems extremely easy for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in the public lobby).",
			name: "Likelihood is Very High"
		},
		PIA_EX_VRAN: {
			description: "It does not seem possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader and access code).",
			name: "Likelihood is Remote"
		},
		PIA_LGL_CONS: {
			description: "Allow data subjects to make a free, specific and informed choice. Determine whether the processing relies on a legal basis other than consent pursuant to Art. 6 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Consent",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Define and describe the scope in detail:<br>- the personal data concerned, their recipients and storage durations<br>- description of the processes and personal data supporting assets for the entire personal data life cycle (from collection to erasure).",
			name: "Data and processes",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Present a brief outline of the processing under consideration, its nature, scope, context, purposes and benefits. Identify the data controller and any processors. List the standard references applicable to the processing, which are necessary or must be complied with , not least the approved codes of conduct (see Art. 40 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) and certifications regarding data protection (see Art. 42 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Processing's description",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Natural or legal person, public authority, agency or another body, to which the personal data are disclosed, whether a third party or not. However, public authorities which may receive personal data in the framework of a particular inquiry in accordance with Union or Member State law shall not be regarded as recipients; the processing of those data by those public authorities shall be in compliance with the applicable data protection rules according to the purposes of the processing. see Art. 4.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Recipient",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "A storage duration must be defined for each type of data and justified by the legal requirements and/or processing needs. Thus a distinction is made between common data and archived data, to which access will be limited to only the stakeholders concerned. An erasure mechanism must be implemented to archive common data or purge archived data at the end of their storage duration. Functional traces will also have to be purged, as will technical logs which may not be stored indefinitely",
			name: "Storage Durations",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Personal data shall be collected for specified, explicit and legitimate purposes and <strong>not further processed in a manner that is incompatible with those purposes.</strong> <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) of [GDPR]</a>",
			name: "Principles relating to processing of personal data",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- The data subject has given consent  to the processing of his or her personal data for one or more specific purposes <br>- Processing is necessary for the performance of a contract to which the data subject is party or in order to take steps at the request of the data subject prior to entering into a contract <br>-Processing is necessary for compliance with a legal obligation to which the controller is subject <br>- Processing is necessary in order to protect the vital interests of the data subject or of another natural person <br>- Processing is necessary for the performance of a task carried out in the public interest or in the exercise of official authority vested in the controller <br>- Processing is necessary for the purposes of the legitimate interests pursued by the controller or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject which require protection of personal data, in particular where the data subject is a child<br> See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 6 of [GDPR]</a> ",
			name: "Justification of lawfulness",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Ensure that the subjects are informed. Confirm that the processing is not covered by an exception and is not subject to specific conditions.",
			name: "Informing data subjects",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "It is important to reduce the severity of the risks by minimising the number of personal data that will be processed, by limiting such data to what is strictly necessary for the purposes for which they are processed (otherwise they should not be collected). Then, it also becomes possible to minimise the data themselves, via controls aimed at reducing their sensitivity.",
			name: "Data minimisation",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "A processing contract must be signed with each processor, setting out all of the aspects stipulated in Art. 28 of the [GDPR]: duration, scope, purpose, documented processing instructions, prior authorisation where a processor is engaged, provision of any documentation providing evidence of compliance with the [GDPR], prompt notification of any data breach, etc.",
			name: "Subcontracting",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Asset on which personal data rely. Note: this may be hardware, software, networks, people, paper or paper transmission channels.",
			name: "Supporting asset",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Depending on the country in question, you will have to justify the choice of remote hosting and indicate the legal supervision arrangements implemented in order to ensure adequate protection of the data subject to a cross-border transfer. That is :<br>- European Union<br>- Country recognised as providing adequate protection by the EU<br>- Transfer to the United States to a company which has joined the Privacy Shield<br>- Other country <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 to 49 of [GDPR]</a>",
			name: "Transfers",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Existence of a policy and processes to obtain an organisation able to manage and control the protection of personal data held within it.",
			name: "Supervision",
			placeholder: "Indicate here whether the effectiveness and adequacy of privacy controls are monitored.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Existence of a policy and processes reducing the risk that legitimate access to personal data by third parties may pose to the data subjects' civil liberties and privacy.",
			name: "Relations with third parties",
			placeholder: "Indicate here, for processors requiring access to data, the security controls and arrangements carried out as regards such access.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Specify whether a person is responsible for the enforcement of privacy laws and regulations. Specify whether there is a monitoring committee (or equivalent) responsible for the guidance and follow-up of actions concerning the protection of privacy.",
			name: "Organisation",
			placeholder: "Indicate if the roles and responsibilities for data protection are defined.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Existence of a policy designed integrate the protection of personal data in all new processing operations.",
			name: "Integrating privacy protection in projects",
			placeholder: "Describe here how privacy protection is integrated in projects",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Existence of a policy describing awareness-raising controls are carried out with regard to a new recruit and what controls are carried out when persons who have been accessing data leave their job.",
			name: "Personnel management",
			placeholder: "Indicate here what awareness-raising controls are carried out with regard to employees.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Set out important aspects relating to data protection within a documentary base making up the data protection policy and in a form suited to each type of content (risks, key principles to be followed, target objectives, rules to be applied, etc.) and each communication target (users, IT department, policymakers, etc.).",
			name: "Policy",
			placeholder: "Describe here the documentary base setting out data protection objectives and rules.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Policy describing processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects (building a map of the risks, etc.).",
			name: "Managing privacy risks",
			placeholder: "Describe here processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Existence of an operational organisation that can detect and treat incidents that may affect the data subjects' civil liberties and privacy.",
			name: " Managing personal data violations",
			placeholder: "Indicate here whether IT incidents are subject to a documented and tested management procedure.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Policies and means implemented to ensure the availability and/or integrity of the personal data, while maintaining their confidentiality.",
			name: "Backups",
			placeholder: "Indicate here how backups are managed. Clarify whether they are stored in a safe place.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Controls implemented on workstations (automatic locking, regular updates, configuration, physical security, etc.) to reduce the possibility to exploit software properties (operating systems, business applications etc.) to adversely affect personal data.",
			name: "Managing workstations",
			placeholder: "Describe here the controls implemented on workstations",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "<strong>Only use subcontractors which are able to provide sufficient guarantees</strong> (in particular in terms of specialised knowledge, reliability and resources). Require service providers to communicate their information system security policy before signing a contract with them. <br>Take and document the means (security audits, installation visits, etc.) used to <strong>ensure the effectiveness of the guarantees offered by the subcontractor</strong> in terms of data protection. These guarantees include: <br>- encryption of data according to its sensitivity or, at least, the existence of procedures guaranteeing that the service company does not have access to the data; <br>- encryption of data transmissions (e.g.: HTTPS type connection, VPN, etc.); <br>- guarantees in terms of network protection, traceability (logs, audits), access rights management, authentication, etc. <br><strong>Sign a contract with the subcontractors</strong>, which defines the subject, the length and the purpose of the processing, as well as obligations of each party. Ensure that it contains, in particular, provisions targeting: <br>- their obligation in terms of <strong>confidentiality of the entrusted personal data</strong>;<br>- <strong>minimal standards in terms of user authentication</strong>;<br>- <strong>conditions of restitution of data and/or its destruction at end of the contract</strong>;<br>- <strong>incident management and notification rules. </strong> They should include notification of the data controller whenever a security breach or a security incident is discovered, which should happen as soon as possible when it concerns personal data.",
			name: "Processing contracts",
			placeholder: "Describe here specific measures for processors (host, maintenance company, administrator, specialist service providers, etc.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Policies implemented to reduce the possibility and the impact of risks on assets supporting personal data.",
			name: "Operating security",
			placeholder: "Describe here how the software updates (operating systems, applications, etc.) and application of security corrective controls patches are carried out.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Monitor intrusion detection systems and intrusion prevention systems in order to analyze network (wired networks, Wi-Fi, radio waves, fiber optics, etc.) traffic in real time and detect any suspicious activity suggestive of a cyber attack scenario.",
			name: "Monitoring network activity",
			placeholder: "Indicate here means and controls implemented to detect incidents involving personal data",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Policies describing how physical maintenance of hardware is managed, stating whether this is contracted out.<br> Indicate whether the remote maintenance of apps is authorized, and according to what arrangements. Specify whether defective equipment is managed in a specific manner.",
			name: "Maintenance",
			placeholder: "Describe here how physical maintenance of hardware is managed",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controls implemented on workstations and servers to protect them from malicious software while accessing less secure networks.",
			name: "Clamping down on malicious software",
			placeholder: "Describe here the controls implemented to reduce risks while accessing less secure networks.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Indicate here the controls bearing on the physical security of servers and workstations (secure storage, security cables, confidentiality filters, secure erasure prior to scrapping, etc.).",
			name: "Hardware security",
			placeholder: "Indicate here the controls bearing on the physical security of servers and workstations",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Depending on the type of network on which the processing is carried out (isolated, private or Internet). Specify which firewall system, intrusion detection systems or other active or passive devices are in charge of ensuring network security.",
			name: "Network security",
			placeholder: "Indicate here the security controls of network on which the processing is carried out",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Policies to ensure physical security (zoning, escorting of visitors, wearing of passes, locked doors and so on).Indicate whether there are warning procedures in place in the event of a break-in.",
			name: "Physical access control",
			placeholder: "Indicate here how physical access control is carried out regarding the premises accommodating the processing.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Policies describing the means of fire prevention, detection and fighting. Where applicable, indicate the means of preventing water damage. Also specify the means of power supply monitoring and relief.",
			name: "Protecting against non-human sources of risks",
			placeholder: "Indicate here means to avoid to limit non-human sources of risks.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Documentation on implantation area, which should not be subject to environmental disasters (flood zone, proximity to chemical industries, earthquake or volcanic zone, etc.).Specify if dangerous products are stored in the same area.",
			name: "Avoiding sources of risk",
			placeholder: "Indicate here whether the implantation area is subject to environmental disasters",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementation of ANSSI's Recommendations for securing websites.",
			name: "Website security",
			placeholder: "Indicate here controls implemented to protect websites.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_AIX: {
			description: "Describe here whether anonymisation mechanisms are implemented.",
			name: "AI",
			placeholder: "Indicate here",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ANO: {
			description: "Indicate here whether anonymisation mechanisms are implemented, which ones and for what purpose. <br>Remember to clearly distinguish between anonymous and pseudonymous data.",
			name: "Anonymisation",
			placeholder: "Indicate here implemented anonymisation mechanisms",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Where applicable, describe here the processes of archive management (delivery, storage, consultation, etc.) under your responsibility. Specify the archiving roles (offices of origin, transferring agencies, etc.) and the archiving policy. State if data may fall within the scope of public archives.",
			name: "Archiving",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of stored data, which ones and for what purpose.",
			source: "PIAF Connected Objects p22 - WIKI"
        },
        PIA_TEC_AIX: {
            description: "Where is.",
            name: "Archiving",
            placeholder: "Describe here ...",
            source: "PIAF Connected Objects p22 - WIKI"
        },
		PIA_TEC_CHIF: {
			description: "Means implemented for <strong>ensuring the confidentiality</strong> of data stored (in the database, in flat files, backups, etc.), as well as the procedure for managing encryption keys (creation, storage, change in the event of suspected cases of data compromise, etc.).<br> Describe the encryption means employed for data flows (VPN, TLS, etc.) implemented in the processing operations.",
			name: "Encryption",
			placeholder: "Describe here the means implemented for ensuring the confidentiality of data",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Implementation of data partitioning helps to reduce the possibility that personal data can be correlated and that a breach of all personal data may occur.",
			name: "Partitioning data",
			placeholder: "Indicate here if processing partitioning is planned, and how this is carried out.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Methods to define and attribute users profiles. Specify the <strong>authentication</strong> means implemented . Where applicable, specify the rules applicable to passwords (minimum length, required characters, validity duration, number of failed attempts before access to account is locked, etc.).",
			name: "Logical access control",
			placeholder: "Indicate here how users profiles are defined and attributed.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Policies that define traceability and log management.",
			name: "Traceability (logging)",
			placeholder: "Indicate here whether events are logged and how long these traces are stored for.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "The following methods could be used : Filtering and removal, Reducing sensitivity via conversion, Reducing the identifying nature of data, Reducing data accumulation, Restricting data access",
			name: "Minimising the amount of personal data",
			placeholder: "Indicate here means implemented to reduce the severity of risks by limiting the amount of personal data",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Where paper documents containing data are used during the processing, indicate here how they are printed, stored, destroyed and exchanged.",
			name: "Paper document security",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of paper documents, which ones and for what purpose.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "corrective controls suggested by the assessor in previous steps, drawing up an action plan setting out, for each action, its manager, frequency, difficulty, cost and progress.",
			name: "Action plan",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Graph illustrating the good security practices, with a conformity value attributed to each on the basis of its assessment in previous steps.",
			name: "Mapping of risks",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Where appropriate, the controller shall seek the views of data subjects or their representatives on the intended processing, without prejudice to the protection of commercial or public interests or the security of processing operations. See Art. 35.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br>These views may be gathered by diverse means, depending on the context (internal or external study on the processing methods and purpose, question for the attention of staff representatives or trade unions, survey among future customers of the data processor). <strong>Where the data controller decides to go against the views of the data subjects</strong>, he must note down <strong>the justification for this decision</strong>. Where the data controller considers that <strong>gathering the views of the data subjects is not relevant, he must also note down the justification thereof</strong>.",
			name: "Data subject's opinion",
			source: "GDPR Art. 35.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "The data controller (or the deployer if it is an AI system) shall seek the advice of the data protection officer, where designated, when carrying out a data protection impact assessment. See Art. 35.2 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>This view may be against the processing being implemented, without restricting the decision of the data controller for all that</strong>.",
			name: "DPO's opinion",
			source: "GDPR Art. 35.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Decide on whether the selected controls, residual risks and action plan are acceptable, with justifications, in view of the previously identified  and views of the stakeholders. In this way, the AIIA may be:<br>- validated<br>- conditional on improvement (explain in what way)<br>- refused (along with the processing under consideration). Where necessary, repeat the previous steps so that the AIIA can be validated. This decision does not prejudge the compliance assessment which may be carried out by a Data Protection Authority.",
			name: "Formal validation",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Knowledge base"
};
var measures$h = {
	add: "Add an empty measure (otherwise, use the knowledge base)",
	default_placeholder: "Describe the existing or intended measures to ensure responsible stewardship.",
	edit: "Edit measure",
	placeholder_title: "Measure title",
	remove: "Delete measure"
};
var misc$h = {
	display: "Show / Hide"
};
var modals$h = {
	abandon_pia: {
		additional_text: "Archiving is not definitive and the AIIA can go back to it if needed.",
		content: "Do you wish to give up the processing?"
	},
	action_plan_no_evaluation: {
		content: "You need to begin the review of the analysis to create the action plan.",
		review_section: "Review a section"
	},
	archive: "Archive",
	archive_pia: {
		archive: "Archive AIIA",
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this AIIA ?"
	},
	ask_for_evaluation: {
		content: "This section is ready to be reviewed."
	},
	back_to_edition: {
		content: "This section has been sent back for editing.<br> Several fields must be corrected<br> to enable its proper review."
	},
	back_to_evaluation: {
		content: "This section has been sent back for review.<br> Several fields must be reviewed<br> to enable its proper validation."
	},
	back_to_home: "Back to home",
	cancel: "Cancel",
	close: "Close",
	completed_edition: {
		content: "The AIIA has been fully edited and has to be reviewed."
	},
	completed_evaluation: {
		content: "The AIIA has been fully reviewed and can be validated."
	},
	"continue": "Continue",
	declare_measures: {
		content: "Before evaluating risks,<br>you must report the<br>existing or planned measures.",
		declare: "Declare existing or planned measures"
	},
	dpo_missing_evaluations: {
		comment: "Comment",
		content: "You need to complete the review of the analysis to access the DPO page.",
		remove: "Remove",
		review_section: "Review a section"
	},
	general_error: {
		content: "All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "The imported file doesn't correspond to an AIIA report file."
	},
	import_wrong_structure_file: {
		content: "The imported file doesn't correspond to an AIIA template file."
	},
	knowledge: {
		content: "Are you sure you want to delete this element?",
		remove: "Delete this element"
	},
	knowledges: {
		content: "Are you sure you want to delete this knowledge base?",
		remove: "Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "The content of the AIIA has been copied to clipboard."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Warning,</span><br>At least one measure must be filled: no deletion possible."
	},
	recover_version: {
		"continue": "Continue",
		message: "By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "Restore a previous version"
	},
	refuse_pia: {
		content: "As you have rejected the AIIA, it is sent back for review to make the required changes."
	},
	remove_attachment: {
		comment: "Comment",
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>remove this attachment?",
		keep: "Keep",
		remove: "Remove"
	},
	remove_measure: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to <br>remove this measure?",
		keep: "Keep this <br>measure",
		remove: "Remove this <br>measure"
	},
	remove_pia: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this AIIA?",
		remove: "Remove this AIIA"
	},
	remove_question: {
		content: "Are you sure you want to delete the question?",
		keep: "Cancel",
		remove: "Delete"
	},
	remove_structure: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want<br>to delete the template?",
		remove: "Delete template"
	},
	same_comment: {
		content: "<span class='strong'>Warning,</span><br>Please enter a comment different from the last recorded."
	},
	signed_pia_validation: {
		content: "To approve the AIIA, attach the signed report.",
		download_pia: "Download report"
	},
	simple_pia_validation: {
		content: "You have approved the AIIA."
	},
	start_evaluation: "Start review",
	unarchive_pia: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this AIIA ?",
		unarchive: "Unarchive AIIA"
	},
	update_server_url_nok: {
		content: "The connection with the server is not possible: please check the filled URL.",
		introspect: "The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "The server address has been updated."
	},
	validate_evaluation: {
		content: "This section is ready for validating the AIIA."
	},
	validate_evaluation_to_correct: {
		content: "Sorry,<br>Several fields must be corrected.<br>Return to edition mode<br>to make corrections."
	},
	users: {
		"delete": {
			content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "Delete this user",
			pia_exist: "This user is assigned to one or more AIIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$h = {
	dashboard: {
		step1: {
			description: "Click on the <strong>+</strong> to create your first AIIA.",
			title: "Create an AIIA"
		},
		step2: {
			description: "<p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "AIIA roles"
		},
		step3: {
			description: "<p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "AIIA roles"
		},
		step4: {
			description: "<p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "AIIA roles"
		},
		step5: {
			description: "<p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "Templates"
		}
	},
	entry: {
		step1: {
			description: "To move from one part of the analysis to another, use the left navigation menu.",
			title: "Browse"
		},
		step2: {
			description: "This is used to explain the purpose of the processing and how it will be implemented.",
			title: "Nature, Scope, Context and Purpose"
		},
		step3: {
			description: "These aim to ensure that the processing complies with the GDPR and EU AI Act, where applicable.",
			title: "Risk Indentification"
		},
		step4: {
			description: "These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "Risks"
		},
		step5: {
			description: "This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "Validation"
		},
		step6: {
			description: "<p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's AIIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "The knowledge base"
		},
		step7: {
			description: "At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "Export your AIIA"
		}
	},
	evaluation: {
		step1: {
			description: "The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "Evaluate the AIIA"
		},
		step2: {
			description: "<p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "To correct"
		},
		step3: {
			description: "<p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "Improvable"
		},
		step4: {
			description: "This assessment means that this part of the processing can be implemented without modification.",
			title: "Acceptable"
		},
		step5: {
			description: "If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "Cancel a request"
		}
	},
	general: {
		done: "Confirm",
		next: "Next",
		skip: "Skip"
	},
	validated: {
		step1: {
			description: "A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "Consult a validated AIIA"
		},
		step2: {
			description: "It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "Update a validated AIIA"
		}
	}
};
var opinions$h = {
	content: ", consider that :",
	dpo_lock: "Please complete the other sections before you can fill the DPO opinion.",
	dpo_opinion: "DPO opinion",
	edit: "Edit",
	people_opinion: "Affected person's  opinion",
	placeholder_concerned_people_name: "Affected person's  name(s)",
	placeholder_dpo_name: "DPO name(s)",
	placeholder_dpo_opinion: "Specify the reasons for your choice.",
	placeholder_people_opinion: "Describe how the opinions were collected and what the analysis is. If the opinions have not been sought, state the reasons.",
	placeholder_search_content: "Justify the reason why the opinion of the persons concerned has not been requested.",
	treatment_lock: "Please complete the other sections before you can fill the opinions of the persons concerned.",
	treatment_nok: "The processing operation should not be used.",
	treatment_ok: "The processing operation could be implemented."
};
var pia$h = {
	attachments: {
		add: "Add",
		download: "Download the attachment",
		loading: "Uploading...",
		remove: "Remove",
		title: "Attachments",
		no_attachment: "No attachment available"
	},
	footer: {
		ask_evaluation: "Ask for review",
		mandatory_fields: "All fields must be filled",
		structure_add_question: "Add a question",
		subsection_validated: "Subsection reviewed, awaiting final validation",
		validate_evaluation: "Validate review"
	},
	header: {
		display_action_plan: "Display<br>action plan",
		edition: "Edition",
		evaluation: "Evaluation",
		preview: "Preview"
	},
	sections: {
		based_on_structure_name: "Based on template:",
		homepage_link: "Back to dashboard",
		refuse_pia: "Refused AIIA",
		status: {
			evaluation: {
				cancel: "cancel the review request.",
				cancel_button: "Cancel the review request",
				content: "This part has not yet been reviewed. If you wish to edit the content submitted for review you have to ",
				title: "Waiting for review."
			},
			validation: {
				cancel: "cancel the validation request.",
				cancel_button: "Cancel the validation request",
				content: "This part has been reviewed and is waiting for the overall AIIA validation. If you wish to change the review, you have to ",
				title: "Waiting for validation."
			}
		},
		validate_pia: "Validate AIIA"
	},
	statuses: [
		"In progress",
		"Rejected",
		"Simple validation",
		"Signed validation",
		"Archived",
		"Waiting for validation"
	]
};
var questions$h = {
	edit: "Edit question",
	gauges: [
		"(Undefined)",
		"Negligible",
		"Limited",
		"High",
		"Maximum/Prohibited"
	],
	placeholder_title: "Question title (mandatory)",
	remove: "Delete question"
};
var rejection_page$h = {
	applied_adjustments: "Adjustments proposed",
	applied_adjustments_placeholder: "Describe the changes brought to the AIIA.",
	button: {
		abandon_treatment: "Abandon processing",
		reject_pia: "Reject AIIA",
		send_for_validation: "Resend for approval"
	},
	previous_rejection: "Previous refusal",
	rejection_reason: "Refusal reason",
	rejection_reason_placeholder: "Describe the reasons for refusing the AIIA.",
	title: "Validation history"
};
var sections$h = {
	"1": {
		items: {
			"1": {
				questions: {
                    "1": {
                        placeholder: "Present a brief outline of the processing operation.",
                        title: "Provide an overview of the processing to be assessed."
                    },
                    "2": {
                        placeholder: "Describe the nature of the processing. ",
                        title: "What is the nature of the processing?"
                    },
                    "3": {
                        placeholder: "Describe the scope of the processing.",
                        title: "What is the scope of the processing."
                    },
                    "4": {
                        placeholder: "Describe the context for the processing.",
                        title: "What is the context for the processing?"
                    },
                    "5": {
                        placeholder: "Describe the intended purposes for the processing.",
                        title: "What are the intended purposes for the processing?"
                    },
                    "6": {
                        placeholder: "Describe the expected outcomes and processing benefits for individuals and/or wider society.",
                        title: "What are the expected outcomes and processing benefits for individuals or wider society?"
                    },
                    "7": {
                        placeholder: "Describe the responsibilities of the stakeholders: the data controller, provider, deployer, possible data processors, joint controllers and authorised representatives.",
                        title: "What are the organisational responsibilities applicable to the processing?"
                    },
                    "8": {
                        placeholder: "Describe the legal, statutory, regulatory and/or contractial obligations applicable to the processing.",
                        title: "What are the legal, statutory, regulatory and/or contractial obligations applicable to the processing?"
                    },
                    "9": {
                        placeholder: "Describe the ethical and/or social norms applicable to the processing.",
                        title: "What are the ethical and/or social norms applicable to the processing?"
                    },
                    "10": {
                        placeholder: "Describe the standards, codes of conduct and/or certifications applicable to the processing.",
                        title: "What are the standards, codes of conduct and/or certifications applicable to the processing?"
                    }
				},
				short_help: "List the data (end-user, common, training data, test data, functional, diagnostic, telemetry) collected and processed. Define for each the storage durations, the recipients and persons with access thereto.",
				title: "Nature, scope, context and purpose"
			},
			"2": {
				questions: {
                    "1": {
                        placeholder: "Provide an accurate and sufficiently granular visual representation of the processing activities of a system, product, process or service for a supervisory authority or data subject to recognise, trace, and verify the purpose, and where necessary, a change in purpose for processing personal data. To ensure clarity and comprehensiveness, it is essential to explicitly identify the processing activities and core components (including data, processes, technical infrastructure, and organisational measures) within the scope of the processing operation.",
                        title: "Provide a systematic description of the processing."
                    },
                    "2": {
                        placeholder: "Provide a complete, traceable and sufficiently detailed functional description of all aspects of this processing that are relevant to regulation. This includes, in particular, the processing of personal data during design, development, training, testing, deployment, operation, monitoring and decommissioning. It must encompass all relevant processing activities from collection to destruction, such as data preparation, entry, validation, editing, authorisation, generation, sharing, storage, retrieval, categorisation, aggregation, sharing, distribution, international transfer and effective erasure, and be sufficiently known, documented and traceable to specified, explicit purposes.",
                        title: "Provide a functional description of the processing."
                    },
                    "3": {
                        placeholder: "List the data collected and the intended purposes thereof. Define for each data element processed the core system elements, supporting assets, components, sources, recipients, data exchanges, persons with authorised access, international transfers and storage duration.",
                        title: "List the data processed, purposes, core system elements, supporting assets, components, sources, recipients and persons with authorised access."
                    },
                     "4": {
                        placeholder: "List the special categories of personal data collected, processed, and distributed. For each data item (data element) record the legal basis for processing, where used, recipients, persons with access, retention periods, and the legal bases for retention.",
                        title: "What are the special personal data, data categories, data subject categories, data recipients and storage durations?"
                    },
                    "5": {
                        placeholder: "List the personal data of children (minors under 16 years old) collected, processed, and distributed. For each data item (data element) record the persons with access, recipients, retention periods, and legal bases for retention.",
                        title: "What are the personal data of children, data categories, data subject categories, data recipients and storage durations?"
                    },
                    "6": {
                        placeholder: "List the personal data relating to criminal convictions and offences collected, processed, and distributed by an official authority or authorised by Union or Member State law. For each data item (data element) record the persons with access, recipients, retention periods, and legal bases for retention.",
                        title: "What are the personal data relating to criminal convictions and offences, data categories, data subject categories, data recipients and storage durations?"
                    },
                    "7": {
                        placeholder: "List the data supporting assets (operating systems, system components, models, training data, test data, models, AI systems, business applications, database management systems, protocols, configurations, etc.)",
                        title: "What are the processes and supporting assets for the processing operations?"
                    },
                    "8": {
                        placeholder: "Provide a general description of the AI system: AI system name, name of provider, version number, intended purposes, all forms of deployment, system hardware, interaction with other hardware and software, external visual features, user interface and general user instructions", 
                        title: "General description of the AI system: Technical Description (AI Act - Art. 11 and Annex IV 1a)."
                    },
                    "9": {
                        placeholder: "Provide the Instructions for Use of the AI system",
                        title: "Instructions for using the AI system (AI Act - Art. 13(3) and Annex IV 1(h))."
                    },
                    "10": {
                        placeholder: "Describe in detail the AI system development process, method,	pretrained systems or tools, testing, change log and version control.",
                        title: "AI system development process (AI Act - Annex IV 2(a))."
                    },
                    "11": {
                        placeholder: "Describe in detail all the elements of the AI system.",
                        title: "Elements of the AI system (AI Act - Annex IV 2(b))."
                    },
                    "12": {
                        placeholder: "Describe the system architecture. Explain how software components build on or feed into each other and integrate into the overall processing.",
                        title: "AI system architecture (AI Act - Annex IV 2(c)')."
                    },
                    "13": {
                        placeholder: "Provide details of the methodologies, techniques and training data set requirements for training.",
                        title: "Requirements for training (AI Act - Annex IV 2(d))."
                    },
                    "14": {
                        placeholder: "Provide details of the human oversight measures.",
                        title: "Human oversight measures  (AI Act - Annex IV 2(e))."
                    },
                    "15": {
                        placeholder: "Maintain a log of pre-determined changes to the AI system and its performance measures.",
                        title: "Change control (AI Act - Annex IV 2(f))."
                    },
                    "16": {
                        placeholder: "Validation and testing procedures used for each system element, control objectives, test objectives and test data.",
                        title: "Validation and testing procedures (AI Act - Annex IV 2(g))."
                    },
                    "17": {
                        placeholder: "Provide details of the cybersecurity measures implemented taking into account the state of knowledge, the costs of implementation and the nature, scope, context and purposes of the processing as well as the risks, the degree of probability and severity of which varies, for the rights and freedoms of natural persons.",
                        title: "Cyber security  (AI Act - Annex IV 2(h))."
                    },
                    "18": {
                        placeholder: "Document the post-market monitoring plan.",
                        title: "Post-market monitoring plan (AI Act - Art. 72(3))."
                    },
                    "19": {
                        placeholder: "Provide details about the monitoring, functioning and control of the AI system Capabilities and Limitations.",
                        title: "Monitoring, functioning and control of AI systems (AI Act - Annex IV 3)."
                    },
                    "20": {
                        placeholder: "Provide details about overall expected level of Accuracy in relation to intended purposes.",
                        title: "Expected level of accuracy (AI Act - Annex IV 3)."
                    },
                    "21": {
                        placeholder: "Maintain a register of foreseeable Unintended Outcomes.",
                        title: "Register of unintended outcomes and sources of risk (AI Act - Annex IV 3)."
                    },
                    "22": {
                        placeholder: "Document information about the monitoring, functioning and control of the AI system capabilities: Human Oversight measures.",
                        title: "Capabilities and limitations in human oversight (AI Act - Annex IV 3)."
                    },
                    "23": {
                        placeholder: "Document the specifications for Output Interpretation, parameters, variables, measures and interpretation.",
                        title: "Specifications for output interpretation (AI Act - Annex IV 3)."
                    },
                    "24": {
                        placeholder: "Document the specifications of Input Data, control objectives and control techniques.",
                        title: "Specifications of input data (AI Act - Annex IV 3)."
                    },
                    "25": {
                        placeholder: "Document the Functional Controls for the AI system.",
                        title: "Functional controls for AI systems (AI Act - Annex IV 3)."
                    },
                    "26": {
                        placeholder: "Attach a copy of the provider’s declaration of conformity (Article 47 and Annex IV 8).",
                        title: "EU declaration of conformity (AI Act - Annex V}."
                    },    
                    "27": {
                        placeholder: "Describe in detail the system in place to evaluate the AI system performance in the post-market phase.",
                        title: "AI system post-market placement performance monitoring plan (AI Act - Art. 72 and Annex IV 9)."
                    },
                    "28": {
                        placeholder: "Examine the approved quality management system for the design, development and testing of AI systems to verify its application.",
                        title: "Internal controls when conformity assessment is based on a quality management system (AI Act - Art. 47 & Annex VI 2)."
                    },
                    "29": {
                        placeholder: "Maintain a record of findings from the provider’s examination of the information contained in the technical documentation in order to assess the compliance of the AI system with the relevant essential requirements set out in Articles 8 to 15 (Chapter III, Section 2).",
                        title: "Internal controls when conformity assessment is based on compliance with essential requirements (AI Act - Annex VI 3)."
                    },
                    "30": {
                        placeholder: "Verify that the design and development process of the AI system (described in 1.4.3) and its post-market monitoring (1.4.11) as referred to in Article 72 is consistent with the technical documentation.",
                        title: "Internal controls when conformity assessment is based on design and development process, and post-market monitoring system (AI Act - Art. 72)."
                    },
                    "31": {
                        placeholder: "Examine the approved quality management system for the design, development and testing of AI systems pursuant to Article 17 to verify the lodged application.",
                        title: "Conformity assessment of the QMS (AI Act - Annex. VII 3)."
                    },
                    "32": {
                        placeholder: "Examine the technical documentation of the AI system against the application lodged with a notified body by the provider for the assessment of the technical documentation relating to the AI system which the provider intends to place on the market or put into service and which is covered by the quality management system.",
                        title: "Conformity assessment of the control of technical documentation (AI Act - Annex. VII 4)."
                    },
					"33": {
                        placeholder: "List 33.",
                        title: "Are there 1.2.33?"
					},
					"34": {
                        placeholder: "List 34.",
                        title: "Are there 1.2.34?"
					},
					"35": {
                        placeholder: "List 35.",
                        title: "Are there 1.2.35?"
                    }
 				},
				short_help: "Document the personal data, training data, functional and diagnostic data, telemetry, logs, processing operations, systems, components, models, algorithms, technical documentation, instructions for use and monitoring.",
				title: "Data, processing, systems, models, algorithms and supporting assets"
			}
		},
		short_help: "Document the nature, scope, context and the intended purposes of the processing to be assessed.",
		title: "Context"
	},
	"2": {
		items: {
            "1": {
                questions: {
                    "1": {
                        placeholder: "Explain which processing purposes are specified, explicit and legitimate during each phase of the life cycle of the system, product, or process, including training, testing, acceptance and release into production phases.",
                        short_title: "Intended purposes",
                        title: "Are the processing purposes specified, explicit and legitimate?"
                    },
                    "2": {
                        placeholder: "<img src='https://aiia.services/aa/assets/images/favicon-16x16.png'>Explain which processing purposes are specified, explicit and legitimate during each phase of the life cycle of the system, product, or process, including design, development, training, testing, acceptance and release into production phases  that are applicable.",
                        short_title: "Purpose limitation",
                        title: "What are the specified, explicit and legitimate purposes for processing data during the life cycle?"
                    },
                    "3": {
                        placeholder: "Explain the transparency measures taken to inform data subjects about the processing of their personal data.",
                        short_title: "Transparent",
                        title: "What measures are used to guarantee transparency throughout the processing life cycle?"
                    },
                    "4": {
                        placeholder: "Describe what the legal basis of the processing is (ex: consent, performance of a contract, compliance with a legal obligation, protecting the vital intests, etc.) during each phase of the life cycle of the system, product, or process, including design, development, training, testing, acceptance and release into production phases that are applicable.",
                        short_title: "Lawful and fair",
                        title: "What are the legal bases for the processing of personal data during the life cycle lawful?"
                      },
                    "5": {
                        placeholder: "Explain why each data element collected (during each relevant processing life cycle phase) is adequate, relevant and is limited to what is necessary for the purposes of the processing and the severity of risk is reduced through effective measures.",
                        short_title: "Data minimisation",
                        title: "What are the measures taken promoting personal data minimisation?"
                    },
                    "6": {
                        placeholder: "Describe the measures taken, including preparation, validation and internal controls to ensure the completeness, accuracy, validity and currency of the data and data processing.",
                        short_title: "Data quality",
                        title: "Are the measures for ensuring data quality and currency?"
                    },
                    "7": {
                        placeholder: "Justify the storage durations for all types of personal data thta is retained and provides details of exemptions from storage limitation obligations.",
                        short_title: "Storage duration",
                        title: "What are the storage duration of the data?"
                    },
                    "8": {
                        placeholder: "Describe the organisational and technical measures taken, including protection against unauthorised or unlawful processing and against accidental loss, destruction or damage, of the data and data processing.",
                        short_title: "Integrity and confidentiality",
                        title: "Which measures ensure appropriate security of the personal data?"
                    },
                    "9": {
                        placeholder: "Assess the controls guaranteeing the proportionality and necessity of the processing",
                        short_title: "Assess proportionality and necessity",
                        title: "Do the described controls guarantee the proportionality and necessity of the processing effective?"
                    },
                    "10": {
                        placeholder: "Describe the measures",
                        short_title: "No more",
                        title: "Not needed 10 2015?"
                    }
				},
				short_help: "This part allows you to demonstrate the legitimacy of the processing and of the data processed.",
				title: "Lawful, Effective, Ethical & Accountable"
			},
			"2": {
				questions: {
                    "1": {
                        placeholder: "Describe what information is given to the data subjects, when, and what the means are to do it.",
                        short_title: "Informing data subjects",
                        title: "How are the data subjects informed about the processing of their personal data?"
                    },
                    "2": {
                        placeholder: "Describe the control measures used to ensure that the data controller's legitimate interest is valid.",
                        short_title: "Valid legitimate interest",
                        title: "If applicable, why is the data controller's legitimate interest valid?"
                    },
                    "3": {
                        placeholder: "Describe the control measures used to ensure that data subject valid consent has been obtained.",
                        short_title: "Obtaining valid consent",
                        title: "If applicable, how is the consent of data subjects obtained?"
                    },
                    "4": {
                        placeholder: "Describe the controls enabling data subjects to access, receive and transmit their data.",
                        short_title: "Right of access and to data portability",
                        title: "How can data subjects exercise their rights of access and to data portability?"
                    },
                    "5": {
                        placeholder: "Describe the controls enabling data subjects to rectify and erase their data.",
                        short_title: "Right to rectification and erasure",
                        title: "How can data subjects exercise their rights to rectification and erasure?"
                    },
                    "6": {
                        placeholder: "Describe the controls enabling data subjects to restrict and to object to the processing of their data.",
                        short_title: "Right to restriction and to object",
                        title: "How can data subjects exercise their rights to restriction and to object?"
                    },
                    "7": {
                        placeholder: "For each processor, describe his responsibilities (duration, scope, purpose, documented processing instructions, prior authorisation) and provide the contracts, codes of conduct and certifications determining its missions and obligations.",
                        short_title: "Subcontracting",
                        title: "Which obligations of processors are clearly identified and governed by a contract?"
                    },
                    "8": {
                        placeholder: "For each country outside the European Union where data are stored or processed, name it and tell if it is acknowledged as offering an adequate level of data protection or describe the provisions concerning the transfer.",
                        short_title: "Transfers",
                        title: "How is the data transferred outside the European Union adequately protected?"
                    },
                    "9": {
                        placeholder: "For each 9.",
                        short_title: "Next 9",
                        title: "Are the controls protecting processing by general-purpose AI models effective?"
                    },
                    "10": {
                        placeholder: "Describe the measures.",
                        short_title: "Health and safety",
                        title: "What measures prevent potential adverse impacts on fundamental rights?"
                    },
                    "11": {
                        placeholder: "Describe the measures.",
                        short_title: "Fundamental rights",
                        title: "What measures prevent potential adverse impacts on fundamental rights?"
                    },
                    "12": {
                        placeholder: "Describe the measures.",
                        short_title: "Internal governance",
                        title: "What effective internal governance mechanisms are in place to minimise the possibility of harm or adverse impact on intended purposes, health, safety or fundamental rights?"
                    },
                   "13": {
                        placeholder: "Describe the measures.",
                        short_title: "Complaint handling",
                        title: "What complaint handling mechanisms are in place in the event that risks of harm or adverse impact on intended purposes, health, safety, or fundamental rights materialise?"
                    },
                    "14": {
                         placeholder: "Describe the measures.",
                         short_title: "Risk for system users",
                         title: "What measures are taken by the deployer to ensure the materialisation of risks does not hinder the intended purposes being achieved?"
                    },
                    "15": {
                        placeholder: "Describe the measures",
                        short_title: "Quality management system",
                        title: "Assess the completeness and effectiveness of the QMS controls for ensuring compliance with the EU AI Act?"
                    },
                    "16": {
                        placeholder: "Describe the measures.",
                        short_title: "Risk management system",
                        title: "Assess the suitability and completeness of the risk management system practices for high-risk AI systems?"
                    },
                    "17": {
                        placeholder: "Describe the measures.",
                        short_title: "True to purpose",
                        title: "Assess controls guaranteeing achievement of intended purposes?"
                    },
                    "18": {
                        placeholder: "Describe the measures.",
                        short_title: "Strategy for regulatory compliance",
                        title: "Strategy for regulatory compliance and conformity?"
                    },
                    "19": {
                        placeholder: "Describe the measures.",
                        short_title: "Change control measures",
                        title: "Change control measures?"
                    },
                    "20": {
                        placeholder: "Describe the measures.",
                        short_title: "Design and development",
                        title: "Methodologies and techniques for the design and development of AI systems?"
                    },
                    "21": {
                        placeholder: "Describe the measures.",
                        short_title: "Test and validate",
                        title: "Procedures to examine, test and validate high-risk AI systems?"
                    },
                    "22": {
                        placeholder: "Describe the measures.",
                        short_title: "Approved, preferred technical specifications",
                        title: "Approved, preferred technical specifications"
                    },
                    "23": {
                        placeholder: "Describe the measures.",
                        short_title: "Information security",
                        title: "Security practices that enable and protect achievement of intended purposes?"
                    },
                    "24": {
                        placeholder: "Describe the measures.",
                        short_title: "General security controls",
                        title: "General security controls regarding the system in which the processing is carried out?"
                    },
                    "25": {
                        placeholder: "Describe the measures.",
                        short_title: "Organisational controls",
                        title: "Organisational controls regarding the system in which the processing is carried out?"
                    },
                    "26": {
                        placeholder: "Describe the measures.",
                        short_title: "GDPR compliance",
                        title: "Compliance with the General Data Protection Regulation?"
                    },
                    "27": {
                        placeholder: "Describe the measures.",
                        short_title: "Compliance with the AI Act",
                        title: "Compliance with the AI Act?"
                    },
                    "28": {
                        placeholder: "Describe the measures.",
                        short_title: "Regulatory obligation compliance",
                        title: "Compliance with other regulatory obligations applicable to the intended purposes?"
                    },
                    "29": {
                        placeholder: "Describe the measures.",
                        short_title: "Value generation",
                        title: "Controls guaranteeing value generation?"
                    },
                    "30": {
                        placeholder: "Describe the measures.",
                        short_title: "Stakeholder expectations",
                        title: "30. Controls maintaining alignment with organisational policies and stakeholder expectations?"
                    },
                    "31": {
                        placeholder: "Describe the measures.",
                        short_title: "System logging for misuse",
                        title: "31. System logging to detect foreseeable misuse?"
                    },
                    "32": {
                        placeholder: "Describe the measures.",
                        short_title: "Post-market monitoring for misuse",
                        title: "32. Post-market monitoring to detect foreseeable misuse?"
                    },
                    "33": {
                        placeholder: "Describe the measures.",
                        short_title: "Preventing foreseeable misuse",
                        title: "33. Cybersecurity to prevent foreseeable misuse?"
                    },
                    "34": {
                        placeholder: "Describe the measures.",
                        short_title: "Remaining viable",
                        title: "Controls and practices enhancing propect of remaining viable?"
                    },
                    "35": {
                        placeholder: "Describe the measures.",
                        short_title: "Energy efficiency",
                        title: "Controls and practices enhancing energy efficiency?"
                    },
                    "36": {
                        placeholder: "Describe the measures.",
                        short_title: "Data centre efficiency",
                        title: "Controls and practices enhancing data centre efficiency?"
                    },
                    "37": {
                        placeholder: "Describe the measures.",
                        short_title: "Algorithm efficiency",
                        title: "Controls and practices enhancing algorithm efficiency?"
                    },
                    "38": {
                        placeholder: "Describe the measures.",
                        short_title: "Eco-friendly components and suppliers",
                        title: "Controls and practices ensuring eco-friendly components and suppliers?"
                    },
                    "39": {
                        placeholder: "Describe the measures.",
                        short_title: "Avoiding wasteful expenditure",
                        title: "Controls and practices to avoid wasteful expenditure?"
                    },
                    "40": {
                        placeholder: "Describe the measures.",
                        short_title: "Recycling and disposal",
                        title: "Controls and practices supporting recycling and disposal?"
                    },
                    "41": {
                        placeholder: "Describe the measures.",
                        short_title: "Preventing resource depletion",
                        title: "Controls and practices preventing resource depletion?"
                    },
                    "42": {
                        placeholder: "Describe the measures.",
                        short_title: "Unnecessary emissions",
                        title: "Controls and practices preventing unnecessary CO2 emissions?"
                    },
                    "43": {
                        placeholder: "Describe the measures.",
                        short_title: "Specialised hardware",
                        title: "Controls and practices for procuring specialised hardware (e.g. GPUs, accelerators, etc.)?"
                    },
                    "44": {
                        placeholder: "Describe the measures.",
                        short_title: "Software and tools",
                        title: "Controls and practices procuring software, tools and libraries?"
                    },
                    "45": {
                        placeholder: "Describe the measures.",
                        short_title: "Data acquisition costs",
                        title: "Controls and practices for managing data acquisition costs?"
                    },
                    "46": {
                        placeholder: "Describe the measures.",
                        short_title: "Talent acquisition",
                        title: "Controls and practices for managing talent acquisition?"
                    },
                    "47": {
                        placeholder: "Describe the measures.",
                        short_title: "Recycling and disposal",
                        title: "Controls and practices supporting recycling and disposal?"
                    },
                    "48": {
                        placeholder: "Describe the measures.",
                        short_title: "Managing ongoing costs",
                        title: "Controls and practices for managing ongoing costs (i.e. maintenance and upgrades)?"
                    },
                    "49": {
                        placeholder: "Describe the measures.",
                        short_title: "Accepted principles",
                        title: "Controls promoting and enforcing accepted principles?"
                    },
                    "50": {
                        placeholder: "Describe the measures.",
                        short_title: "Accepted values",
                        title: "Controls promoting and enforcing accepted values?"
                    },
                    "51": {
                        placeholder: "Describe the measures.",
                        short_title: "Ethical behaviour",
                        title: "Controls promoting and enforcing ethical behaviour?"
                    },
                    "52": {
                        placeholder: "Describe the measures.",
                        short_title: "Assigned responsibility",
                        title: "Controls enforcing assigned responsibility?"
                    },
                    "53": {
                        placeholder: "Describe the measures.",
                        short_title: "Enhancing trust",
                        title: "Controls enhancing trust?"
                    },
                    "54": {
                        placeholder: "Describe the measures.",
                        short_title: "Enhancing reliability",
                        title: "Controls enhancing reliability?"
                    },
                    "55": {
                        placeholder: "Describe the measures.",
                        short_title: "Enhancing relationships",
                        title: "Controls enhancing relationships?"
                    },
                    "56": {
                        placeholder: "Describe the measures.",
                        short_title: "Transparency and explainability",
                        title: "Controls promoting social wellbeing and safeguards through enhanced transparency and explainability?"
                    },
                    "57": {
                        placeholder: "Describe the measures.",
                        short_title: "Mitigating bias",
                        title: "Controls promoting social wellbeing and safeguards through mitigating bias?"
                    },
                    "58": {
                        placeholder: "Describe the measures.",
                        short_title: "Human oversight",
                        title: "Controls ensuring effective human oversight?"
                    },
                    "59": {
                        placeholder: "Describe the measures.",
                        short_title: "Environmental protection",
                        title: "Controls guaranteeing protection of the environment?"
                    },
                    "60": {
                        placeholder: "Describe the measures.",
                        short_title: "Guaranteeing health",
                        title: "Controls guaranteeing protection of health of concerned individuals and groups?"
                    },
                    "61": {
                        placeholder: "Describe the measures.",
                        short_title: "Guaranteeing safety",
                        title: "Controls guaranteeing safety of concerned individuals?"
                    },
                    "62": {
                        placeholder: "Describe the measures.",
                        short_title: "Preventing jailbreaking",
                        title: "Controls preventing jailbreaking (i.e. circumventing the filters and safeguards)?"
                    },
                    "63": {
                        placeholder: "Describe the measures.",
                        short_title: "Guaranteeing fundamental rights",
                        title: "Controls guaranteeing fundamental rights of concerned individuals and groups?"
                    },
                    "64": {
                        placeholder: "Describe the measures.",
                        short_title: "Next 64",
                        title: "Are 2.2.64?"
                    },
                    "65": {
                        placeholder: "Describe the measures.",
                        short_title: "Next 65",
                        title: "Are 2.2.65?"
                    }
				},
				short_help: "Describe the current measures that demonstrate protection of fundamental data protection principles and human rights rights.",
				title: "Current controls protecting principles and rights"
			}
		},
		short_help: "This section allows you to build the compliance framework for protecting fundamental rights and ensuring regulatory compliance.",
		title: "Current measures"
	},
    "3": {
        items: {
            "1": {
                short_help: "This section allows you to identify control measures (existing or planned) that contribute to resource stewardship.",
                title: "Existing or planned measures"
            },
            "2": {
                questions: {
                    "1": {
                        placeholder: "Enter the potential impacts",
                        title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
                    },
                    "2": {
                        placeholder: "Enter the threats",
                        title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
                    },
                    "3": {
                        placeholder: "Enter the risk sources",
                        title: "What are the risk <span class='green-highlight'>sources</span>?"
                    },
                    "4": {
                        placeholder: "Click here to select controls which address the risk.",
                        title: "Which of the identified <span class='green-highlight'>planned control measures</span> contribute to addressing the risk?"
                    },
                    "5": {
                        placeholder: "Justify here the estimated severity of the risk.",
                        title: "How do you estimate the <span class='green-highlight'>severity</span>, after taking into account the potential impacts and planned control measures?"
                    },
                    "6": {
                        placeholder: "Justify here the estimated likelihood.",
                        title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned control measures?"
                    }
                },
                short_help: "Analyze the causes and consequences of <span class='green-highlight'>ineffective performance</span>, and estimate its severity and likelihood.",
                title: "Ineffective performance"
            },
            "3": {
                questions: {
                    "1": {
                        placeholder: "Enter the potential impacts",
                        title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
                    },
                    "2": {
                        placeholder: "Enter the threats",
                        title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
                    },
                    "3": {
                        placeholder: "Enter the risk sources",
                        title: "What are the risk <span class='green-highlight'>sources</span>?"
                    },
                    "4": {
                        placeholder: "Click here to select controls which address the risk.",
                        title: "Which of the identified <span class='green-highlight'>control measures</span> contribute to addressing the risk?"
                    },
                    "5": {
                        placeholder: "Justify here the estimated severity of the risk.",
                        title: "How do you estimate the <span class='green-highlight'>severity</span>, after taking into account the potential impacts and planned control measures?"
                    },
                    "6": {
                        placeholder: "Justify here the estimated likelihood.",
                        title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned control measures?"
                    }
                },
                short_help: "Analyze the causes and consequences of an <span class='green-highlight'>unethical behaviour</span>, and estimate its severity and likelihood.",
                title: "Unethical behaviour"
            },
            "4": {
                questions: {
                    "1": {
                        placeholder: "Enter the potential impacts",
                        title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
                    },
                    "2": {
                        placeholder: "Enter the threats",
                        title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
                    },
                    "3": {
                        placeholder: "Enter the risk sources",
                        title: "What are the risk <span class='green-highlight'>sources</span>?"
                    },
                    "4": {
                        placeholder: "Click here to select controls which address the risk.",
                        title: "Which of the identified <span class='green-highlight'>control measures</span> contribute to addressing the risk?"
                    },
                    "5": {
                        placeholder: "Justify here the estimated severity of the risk.",
                        title: "How do you estimate the <span class='green-highlight'>severity</span>, after taking into account the potential impacts and planned control measures?"
                    },
                    "6": {
                        placeholder: "Justify here the estimated likelihood.",
                        title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned control measures?"
                    }
                },
                short_help: "Analyse the causes and consequences of <span class='green-highlight'>diminished stewardship</span>, and estimate its severity and likelihood.",
                title: "Diminished Stewardship"
            },
            "5": {
                short_help: "This visualisation provides an overview of how different controls impact specific risks. It assists you gain insights into the effectiveness of controls in managing risks they address.",
                title: "Risk summary"
            }
        },
        short_help: "This section allows you to assess the risks to fundamental principles and rights, taking into account existing or planned controls.",
        title: "Mitigate risk"
    },
	"4": {
		items: {
			"1": {
				short_help: "This visualisation presents a comparison of the positioning of the risks, both before and after the application of the complementary controls.",
				title: "Risk mapping"
			},
			"2": {
				short_help: "Review and validate the impact assessment. The action plan is automatically updated when evaluating the different elements comprised in the AIIA.",
				title: "Action plan"
			},
			"3": {
				short_help: "Present the advice of the person in charge of data protection and fundamental rights issues (data protection officer if there is one). Present the views of the data subjects or their representatives.",
				title: "DPO and data subjects' opinions"
			},
			"4": {
				title: "Validate the AIIA"
			},
			"5": {
				title: "Rejected AIIA"
			}
		},
		short_help: "Review and validate the impact assessment.",
		title: "Validation"
	}
};
var settings$h = {
	content: "Please, provide the address (URL) of the remote server:",
	title: "Settings",
	update: "Update URL"
};
var summary$h = {
	action_plan: {
		fundamental_principles: "Fundamental principles and rights",
		implementation_date: "Expected date of implementation",
		implementation_responsible: "Person responsible",
		measures: "Existing or planned measures",
		no_action_plan: "No action plan recorded.",
		risks: "Risks",
		title: "Action plan"
	},
	actions: {
		complete_download: "Download the full report",
		complete_download_desc: "Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "Download elements of the report",
		individual_download_desc: "Export specific elements of the report.",
		individual_download_pdf: "AIIA report (.pdf)",
		individual_download_doc: "Texts (.doc)",
		individual_download_images: "Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the AIIA tool (.json file)",
		individual_download_select: "Select elements to export:",
		individual_to_download: "Download",
		print: "Print the report",
		print_and_download: "Print and download"
	},
	attachments: "Attachments",
	concerned_people_name: "Affected persons",
	concerned_people_opinion: "Affected persons' opinions",
	concerned_people_searched_opinion: "Search of affected persons' opinions",
	concerned_people_status: "Affected persons' statuses",
	concerned_people_unsearched_opinion_comment: "Reason why affected persons' opinions weren't requested",
	content_choice: [
		"The processing operation should not be used.",
		"The processing operation could be implemented."
	],
	creation_date: "Creation date",
	csv_action_plan_comment: "Action plan comment",
	csv_evaluation_comment: "Evaluation comment",
	csv_file_title: "action-plan",
	csv_implement_date: "Estimated implementation date",
	csv_people_in_charge: "Person in charge",
	csv_section: "Section",
	csv_title_object: "Title",
	download_csv: "Action plan (.csv)",
	dpo_name: "DPO's name",
	dpo_opinion: "DPO's opinion",
	dpo_status: "DPO's status",
	gauges: {
		"1": "Negligible",
		"2": "Normal",
		"3": "High",
		"4": "Very high"
	},
	modification_made: "Modifications made",
	people_search_status_nok: "Affected person's opinion wasn't requested.",
	people_search_status_ok: "Affected person's  opinion was requested.",
	pia_assessor: "Assessor's name",
	pia_author: "Author's name",
	pia_name: "AIIA",
	pia_validator: "Validator's name",
	preview_dpo_opinion: "DPO and data subjects opinion",
	preview_edition: "Editing",
	preview_evaluation: "Evaluation",
	preview_no_data: "No data to display.",
	preview_status: "Status",
	preview_subtitle: "General information",
	preview_title: "Preview",
	preview_validation: "Validation",
	preview_validation_section: "Validation",
	preview_guests: "Guests",
	previous_page: "Back to previous page",
	rejection_reason: "Rejection reason",
	revision: {
		current_version: "Current version",
		pia_version: "AIIA versions",
		restore_version: "Restore",
		revision: "Versions and revision",
		save: "Create a new version",
		show: "Display the {{length}} versions"
	},
	risks_cartography_title: "Risk mapping",
	risks_overview_title: "Risks overview",
	title: "AIIA information"
};
var users$h = {
	add_new_user: "Add a new user",
	cancel: "Cancel",
	choose_profile: "Choose a profile for this user",
	"continue": "Continue",
	data: "Data",
	edit_user: "Edit an user",
	email: "Email",
	first_name: "First name",
	functional_admin: "Functional administrator",
	last_name: "Last name",
	new_user_button: "New user",
	profile: "Profile",
	remove: "Delete",
	remove_current_user_error_message: "You can't delete your own account.",
	remove_last_functional_admin_error_message: "You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "Several AIIAs are attached to this user, so you cannot delete him.",
	technical_admin: "Technical administrator",
	update: "Update",
	user: "User",
	state: "Account's state",
	errors: {
		edit_user: {
			"406": "The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "Remove user",
		content: "Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "Active",
		"true": "Waiting for activation"
	},
	role: {
		label: "Role(s)",
		author: "Author",
		evaluator: "Evaluator",
		validator: "Validator",
		guest: "Guest"
	}
};
var validation_page$h = {
	add_signed_pia: "Add the signed AIIA",
	after_reading: "After reading full AIIA relating to the data processing linked to ",
	button: {
		rejection: "Reject AIIA",
		signed_validation: "Approve AIIA <br>(signed)",
		simple_validation: "Approve AIIA <br>(direct)"
	},
	confirmation1: "I attest that the context of the processing described in the AIIA is consistent with the reality.",
	confirmation2: "I attest that I am aware of the risks depending on the existing or planned measures.",
	confirmation3: "I ratify the corrective actions indicated in the action plan.",
	confirmation4: "I commit to implement as quickly as possible the indicated corrective actions.",
	latest_signed_attachment: "Last signed attachment",
	mandatory_fields: "All boxes must be checked",
	remove_attachment: "Remove the attachment",
	responsible: "Person accountable for validating the AIIA: ",
	signed_attachments_history: "Signed attachments history",
	tools: {
		dashboard: "Dashboard",
		display_pia: "Display report"
	},
	validated_pia_with_signature: "Approved",
	waiting_for_signature: "Pending signed AIIA"
};
var en = {
	about: about$h,
	action_plan: action_plan$h,
	authentication: authentication$h,
	cartography: cartography$h,
	comments: comments$h,
	conflict: conflict$h,
	date: date$h,
	errors: errors$h,
	evaluations: evaluations$h,
	header: header$h,
	help: help$h,
	homepage: homepage$h,
	knowledge_base: knowledge_base$h,
	measures: measures$h,
	misc: misc$h,
	modals: modals$h,
	onboarding: onboarding$h,
	opinions: opinions$h,
	"overview-risks": {
	important: "High",
	limited: "Normal",
	maximal: "Unacceptable",
	measures: "Measures",
	negligible: "Negligible",
	potential_impacts: "Potential impacts",
	"risk-access_x": "Severity",
	"risk-access_y": "Likelihood",
	"risk-change_x": "Severity",
	"risk-change_y": "Likelihood",
	"risk-disappearance_x": "Severity",
	"risk-disappearance_y": "Likelihood",
	sources: "Sources",
	threat: "Threats"
},
	pia: pia$h,
	questions: questions$h,
	rejection_page: rejection_page$h,
	sections: sections$h,
	settings: settings$h,
	summary: summary$h,
	users: users$h,
	validation_page: validation_page$h
};

var about$g = {
	contribute: "Si usted desea contribuir a la traducción del software en otro idioma mejorar las traducciones existentes, le recomendamos al <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">leer la página que describe los pasos</a>.",
	description: "Esta herramienta está diseñada originalmente por la CNIL, la autoridad francesa de protección de datos, y se trata de un software que ayuda al cumplimiento del GDPR. Fue desarrollado por <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Es libre y de código abierto. Si usted desea colaborar en este proyecto, usted es libre de descargar el código de fuente de Github, modificar y compartir con la comunidad.",
	licences: "Library licenses:",
	title: "Sobre la herramientan AIIA",
	translators: "El software del AIIA está actualmente disponible en dieciocho idiomas. Las versiones francesas e inglesas son proporcionadas por el CNIL. Las otras versiones resultan de las contribuciones de los individuos siguientes:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jirí Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"https://garanteprivacy.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/antoniormesa\">antoniormesa</a> .</li></ul>",
	version_number: "Número de versión"
};
var action_plan$g = {
	acceptable_measures: "Medidas Aceptables",
	edit: "Corrija",
	improvable_measures: "Medidas Mejorables",
	measures: "Planificadas o medidas existentes",
	no_action_plan: "No hay plan de acción",
	placeholder_person_in_charge: "Responsable de la implementación",
	principles: "Principios Fundamentales",
	risk1: "Acceso ilegítimo a los datos",
	risk2: "Modificación no deseada de datos",
	risk3: "Desaparición de datos",
	risks: "Riesgos",
	title: "Descripción General"
};
var authentication$g = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Este software de la <strong> Autoridad Francesa de Protección de Datos (CNIL) </strong> está destinado a ayudar al controlador de datos a procesar datos personales de acuerdo con el RGPD para el uso de la metodología AIIA desarrollada por CNIL.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Comenzar",
	start_app: "Acceda al software AIIA (Beta)",
	subtitle1: "Una plataforma para crear <br> y para manejar sus PIAs",
	subtitle2: "Acceso a las herramientas y glosarios",
	title: "Evaluación de impacto de privacidad",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$g = {
	important: "Importante",
	legend1: "Planificado o existente medidas",
	legend2: "Medidas correctivas implementadas",
	legend3: "(I) acceso ilegítimo a los datos ",
	legend4: "(U) modificación no deseada de datos",
	legend5: "(D) desaparición de datos",
	likelihood_axe: "Probabilidad del riesgo",
	limited: "Limitado",
	maximal: "Máximo",
	negligible: "Insignificante",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Riesgo gravedad"
};
var comments$g = {
	comment: "Comentario",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "comentarios",
	new_comment: "Comentario",
	placeholder_new_comment: "Deje un comentario",
	send: "Envíe"
};
var conflict$g = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$g = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$g = {
	content: "Si encuentra otros problemas o si tiene sugerencias para mejorar, <br>puede enviarlos de regreso a través de este formulario: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Página no encontrada."
};
var evaluations$g = {
	acceptable: "Aceptable",
	action_plan_comment: "Plan de acción / Acciones correctivas",
	evaluation_comment: "Comentario de evaluación",
	gauges: {
		"0": "Indefinido",
		"1": "Insignificante",
		"2": "Limitado",
		"3": "Importante",
		"4": "Máximo",
		likelihood: "Teniendo en cuenta el plan de acción, ¿cómo se vuelve a evaluar la <span class='red-highlight'>probabilidad de que este riesgo</span>?",
		seriousness: "Teniendo en cuenta el plan de acción, ¿cómo se vuelve a evaluar la <span class='red-highlight'>gravedad de este riesgo</span>?"
	},
	improvable: "Mejorable",
	placeholder_acceptable: "Según la información disponible, las medidas adoptadas son suficientes para satisfacer adecuadamente los requisitos para la protección de los datos.",
	placeholder_improvable1: "Según la información disponible, medidas adicionales son a implementarse para mejorar la protección de datos del proceso.",
	placeholder_improvable2: "Introduzca sus comentarios",
	placeholder_to_correct: "La información proporcionada no es suficiente para evaluarlos correctamente. Enviar al editor para mejorar la comunicación original. ",
	status: [
		"Pendiente",
		"Para corregir",
		"Mejorable",
		"Aceptable"
	],
	title: "Evaluación",
	to_correct: "Para corregir"
};
var header$g = {
	archives: "TO TRANSLATE - AIIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "Pulse F11 para salir del modo de pantalla completa.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Ejemplo de AIIA",
		title: "Ayuda"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Base de conocimientos",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Traducciones del CNIL",
		community_translations: "Traducciones de la comunidad",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Traducción revisada por la Autoridad de protección de datos de la UE",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Versión oficial",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Evaluación de impacto de la privacidad",
	structures: "Modelos AIIA",
	tools: {
		about: "Acerca de",
		accessibility: "Accesibilidad para personas con discapacidad visual (colores de alto contraste, daltonismo)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Ajustes",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$g = {
	definition: {
		data1: {
			content: "Contenido escrito",
			title: "Usa el PIA"
		},
		data2: {
			qa1: {
				content: "Cuando encuentre algún problema, cierre la aplicación y reinicielo. Generalmente soluciona el problema. No perderás la información que has ingresado; se guarda automáticamente mientras se escribe.",
				title: "Me da problemas de visualización como iconos de ser pegados en un estado o falta de elementos de la interfaz"
			},
			qa2: {
				content: "Este problema conocido actualmente que es fijo. Si encuentra este problema, recomendamos que rellene el campo de la justificación del nivel estimado de severidad y probabilidad. Usted será capaz de editar el medidor una vez que el error es fijo.",
				title: "No puedo editar los indicadores para la evaluación de la severidad y la probabilidad de un riesgo"
			},
			qa3: {
				content: "Se han observado varios errores al importar un PIA, y en particular los indicadores de nivel para evaluar la severidad y la probabilidad de un riesgo pueden desaparecer. En este caso, consulte el tema mencionado. Además, un AIIA no aparece en el tablero de instrumentos después de importarlo. Este es un tema de pantalla y solo tienes que recargar la página.",
				title: "Encuentro problemas al importar un PIA"
			},
			qa4: {
				content: "Esto es sólo un error de la pantalla y no tiene ningún efecto en el texto que introduzca en un campo. Este problema visual se solucionará pronto.",
				title: "Cuando copio y pego el texto, se destaca."
			},
			qa5: {
				content: "Para evaluar una sección, es obligatorio rellenar todos los campos. Por favor comprueba si es el caso. Al editar un riesgo, usted debe tener al menos una medida técnica u organizativa que mitiga el riesgo para solicitar una evaluación del riesgo.",
				title: "No puedo evaluar una sección"
			},
			qa6: {
				content: "Cierre el PIA que está editando y vuelva a abrirlo. El contenido debe mostrarse en el idioma que haya seleccionado.",
				title: "Al cambiar el idioma, los textos no se traducen"
			},
			qa7: {
				content: "Por el momento, los iconos del menú de navegación no son renovados después de negarse un PIA. Usted tiene que comprobar cada sección y cambiar la información y/o la evaluación según las razones para rechazar el PIA. Una vez que han revisado toda la sección, podrá solicitar convalidación de PIA otra vez.",
				title: "Me he negado a validar un PIA pero no sé qué hacer ahora"
			},
			title: "Problemas conocidos"
		},
		footer: "En caso de tener cualquier otro problema o sugerencias de mejora, puede enviárnoslas a traves de este formulario <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Ayuda"
};
var homepage$g = {
	cards: {
		author: "Autor",
		category: "TO TRANSLATE - Category",
		creation_status: "Creación",
		date: "Fecha",
		evaluation: "Revisado por",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Importación AIIA",
		import_structure: "Importar plantilla",
		item: {
			consult_pia: "Consultar AIIA",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Modificar AIIA",
			edit_structure: "Editar plantilla",
			tools: {
				action_plan: "Mostrar<br>plan de acción",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Duplicar",
				"export": "Exportar",
				more_options: "Más opciones",
				pia: "Mostrar<br>PIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Nuevo AIIA",
		new_structure: "Nueva plantilla",
		or: "o",
		pia_name: "PIA",
		placeholder_author: "Nombre y apellidos",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Nombre y apellidos",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Importación AIIA",
		placeholder_import_structure: "Importar plantilla",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Nuevo AIIA",
		placeholder_new_structure: "Nueva plantilla",
		placeholder_pia_name: "Nombre del AIIA",
		placeholder_sector_name: "Nombre del sector asociado",
		placeholder_start: "Todos los campos son obligatorios",
		placeholder_structure: "Plantilla por defecto",
		placeholder_structure_name: "Título de la plantilla",
		placeholder_validation: "Nombre y apellidos",
		sector_name: "Sector asociado",
		start: "Comenzar",
		status: "Estado",
		structure: "Plantilla",
		structure_name: "Nombre de la plantilla",
		title_close_creation: "Cerrar",
		validation: "Validado por"
	},
	filters: {
		assessor: "Revisado por",
		author: "Autor",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "¡Comencemos! <br><br>Para iniciar un PIA, <br> clic en Nuevo AIIA",
		card_rocket_content_structure: "¡Comencemos!<br><br>Para iniciar<br>un modelo, haga clic<br> en la +",
		category: "Categoría",
		date: "Fecha",
		import_pia: "Importar AIIA",
		import_structure: "Importar plantilla",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "¡Comencemos! Para iniciar <br>un PIA, haga clic en el +",
		list_rocket_content_structure: "¡Comencemos! Para iniciar<br>un modelo, haga clic en el +",
		name: "Nombre",
		new_pia: "Nuevo AIIA",
		new_structure: "Nueva plantilla",
		sector_name: "Sector asociado",
		sort: "Ordenar",
		sort_by: "por",
		status: "Estado",
		validator: "Validado por"
	},
	lists: {
		column_actions: "Acciones",
		column_author: "Autor",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Creado",
		column_evaluation: "Revisado por",
		column_pia: "PIA",
		column_progression: "Progreso",
		column_sector_name: "Sector asociado",
		column_status: "Estado",
		column_structure: "Plantilla",
		column_structure_name: "Plantilla",
		column_updated_at: "Último acceso",
		column_validation: "Validado por",
		item: {
			tools: {
				action_plan: "Mostrar<br>plan de acción",
				archive: "TO TRANSLATE - Archive",
				consult: "Consultar",
				duplicate: "Duplicar",
				edit: "Modificar",
				"export": "Exportar",
				pia: "Mostrar AIIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$g = {
	add_measure: "Añadir",
	add_measure_hint: "Usted también puede Añadir una medida de la base de conocimientos.",
	category: {
		definition: "Definición",
		example: "Ejemplo",
		general_measure: "Controles de seguridad físicos",
		measure_on_data: "Controles de seguridad lógicos",
		method: "Metodología",
		organizational_measure: "Controles organizativos",
		principle: "Principio"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Todo",
		definitions: "Definiciones",
		general_measures: "Controles de seguridad físicos",
		measures_on_data: "Controles de seguridad lógicos",
		no_result: "Sin resultados.",
		organizational_measures: "Controles organizativos",
		title: "Filtrar"
	},
	placeholder_add_measure: "Añadir esta medida",
	placeholder_help: "Ayudas de entrada",
	search: "Buscar",
	slugs: {
		PIA_DEF_ACC: {
			description: "El interesado tendrá derecho a obtener del responsable del tratamiento confirmación de si se están tratando o no datos personales que le conciernen y, en tal caso, derecho de acceso a los datos personales y a la siguiente información <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">arte. 15 de [GDPR]</a>",
			name: "Derecho de acceso",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Proceso que elimina las características de identificación de los datos personales. Para evaluar la solidez de los procesos de anonimización, ve e target= del <a target=\"_blank \" href= \"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Anonimización",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Los procedimientos que preservaban y que manejaban los archivos electrónicos que contenían los datos personales se propusieron asegurar su valor (específicamente, su valor legal) a través del período entero necesario (transferencia, almacenaje, migración, accesibilidad, eliminación, archivando la política, la protección del secreto, el etc.). ",
			name: "El archivar",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Cada persona con el acceso legítimo a los datos personales (empleados, contratantes y otros terceros) debe ser identificada por un identificador único. Elija un método de la autentificación para abrir sesiones que sea apropiado al contexto, al nivel del riesgo y a la robustez esperados. Recomendaciones: si los riesgos no se elevan, una contraseña puede ser utilizada; sin embargo, si los riesgos son más altos, utilice un símbolo de una sola vez de la contraseña pero cambie la contraseña de la activación del defecto, o, cuando la parte de la contraseña es enviada por SMS, una tarjeta con un PERNO código, un certificado electrónico o cualquier otra forma de autentificación fuerte.",
			name: "Autenticación",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Medir hacer que los datos personales ininteligible para cualquier persona sin autorización de acceso (cifrado simétrico o asimétrico, el uso de algoritmos públicos conocidos por ser fuerte, certificado de autenticación, etc.) ",
			name: "Cifrado",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Métodos de organización de datos que reducen la posibilidad de que los datos personales puedan correlacionarse y que pueda producirse una violación de todos los datos personales. Por ejemplo, al identificar los datos personales útiles solo para cada proceso comercial y separarlos lógicamente. ",
			name: "Partición de datos",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Cualquier indicación libremente dada, específica, informada y sin ambigüedades de los deseos del sujeto de datos por la cual él o ella, por una declaración o por una acción afirmativa clara, significa estar de acuerdo con el tratamiento de datos personales relacionados con él o ella.<br>Ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">Art. 4.10 de [GDPR]</a>",
			name: "El consentimiento",
			source: "GDPR Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Medios implementados para limitar los riesgos de que personas no autorizadas accedan a los datos personales electrónicamente, requiere entre otras cosas: <br> - <strong> administrar los perfiles de los usuarios </strong> separando tareas y áreas de responsabilidad ( preferiblemente de forma centralizada) para limitar el acceso a los datos personales exclusivamente a usuarios autorizados mediante la aplicación de los principios de necesidad de conocer y privilegio mínimo; <br> - <strong> retirar los derechos de los empleados, las partes contratantes y otros terceros cuando estén ya no está autorizado para acceder a un local o un recurso </strong> o cuando finaliza su <strong> contrato de trabajo </strong>.",
			name: "Controles de acceso lógico",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "toda información sobre una persona física identificada o identificable («el interesado»); se considerará persona física identificable toda persona cuya identidad pueda determinarse, directa o indirectamente, en particular mediante un identificador, como por ejemplo un nombre, un número de identificación, datos de localización, un identificador en línea o uno o varios elementos propios de la identidad física, fisiológica, genética, psíquica, económica, cultural o social de dicha persona. <br>Ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">Art. 4.1 [GDPR]</a>",
			name: "Datos personales",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "la persona física o jurídica, autoridad pública, servicio u otro organismo al que se comuniquen datos personales, se trate o no de un tercero. No obstante, no se considerarán destinatarios las autoridades públicas que 4.5.2016 L 119/33 Diario Oficial de la Unión Europea ES puedan recibir datos personales en el marco de una investigación concreta de conformidad con el Derecho de la Unión o de los Estados miembros; el tratamiento de tales datos por dichas autoridades públicas será conforme con las normas en materia de protección de datos aplicables a los fines del tratamiento. <br>Ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">Art. 4.9 de [GDPR]</a>",
			name: "Destinatario",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: " El interesado tendrá derecho a obtener sin dilación indebida del responsable del tratamiento la supresión de los datos personales que le conciernan, el cual estará obligado a suprimir sin dilación indebida los datos personales cuando concurra alguna de las circunstancias siguientes, ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">Art. 17 [GDPR]</a>",
			name: "Derecho de supresión",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Los beneficios esperados (para la organización, para los interesados, para la sociedad en general, etcetera.).",
			name: "Apuestas",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Los datos personales serán: exactos y, si fuera necesario, actualizados; se adoptarán todas las medidas razonables para que se supriman o rectifiquen sin dilación los datos personales que sean inexactos con respecto a los fines para los que se tratan («exactitud») . <br>Ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">Art. 5,1 d) de [GDPR]</a>",
			name: "Calidad de los datos",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "La severidad representa la magnitud de un riesgo. Principalmente depende de la naturaleza perjudicial de los impactos potenciales. ",
			name: "Gravedad",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "El interesado tendrá derecho a obtener del responsable del tratamiento la limitación del tratamiento de los datos, ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">Art. 18 [GDPR]</a>",
			name: "Derecho a la limitación del tratamiento",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Instalado una arquitectura de registración para permitir la detección temprana de los incidentes que implican datos personales y para tener información que se puede utilizar para analizarlos o para proporcionar la prueba con respecto a investigaciones.",
			name: "Vigilancia",
			source: "Measures_US Vigilancia"
		},
		PIA_DEF_MEN: {
			description: "Procedimiento que comprende una o más acciones individuales de datos activos. Se utiliza, intencionalmente o no, por las fuentes de riesgo y puede causar un evento temido. ",
			name: "Amenaza",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Amenazas con respecto a: - <strong> Hardware </strong>, usado de manera inapropiada, observado, alterado, perdido (uso o transporte de hardware sensible para fines personales, ver la pantalla de una persona sin su conocimiento mientras está en el tren, seguimiento por un hardware key logger, etc.) <br> - <strong> Software </strong>, usado de manera inapropiada, observado, alterado (aumento de privilegios, recopilación de datos de configuración, infección por código malicioso, etc.) <br> - <strong> Canales de computadora </strong> observados (Intercepción del tráfico de Ethernet, etc.) <br> - <strong> Personas </strong>, observados, manipulados, perdidos (Divulgación involuntaria de información, ingeniería social, cambios de asignación) <br> - <strong> Documentos en papel </strong> observados, perdidos (lectura, robo de correo, etc.) <br>- <strong> Canales de transmisión en papel </strong> observados (lectura de libros de firmas en circulación, etc.) ",
			name: "Las amenazas que pueden conducir a un acceso ilegítimo",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong> Amenazas relacionadas con: </strong> <br> - <strong> Hardware </strong>: usado de manera inapropiada, sobrecargado, alterado, dañado, perdido (unidad de almacenamiento llena, sobrecarga de capacidad de procesamiento, además de incompatible hardware que resulta en mal funcionamiento, incendio, robo o pérdida de un activo, etc.) <br> <strong> Software </strong>: se usa de manera inapropiada, sobrecargado, alterado, dañado, perdido (borrado de datos, excediendo el tamaño de la base de datos, bomba lógica, no renovación de la licencia del software utilizado para acceder a los datos, etc.) <br> <strong> Canales informáticos </strong>: sobrecargado, alterado, perdido (descarga no autorizada, pérdida de conexión a Internet, etc.) <br> - <strong> Personas </strong>: sobrecargado, dañado, perdido (mal uso de habilidades, enfermedad, jubilación, etc.) <br>- <strong> Documentos en papel </strong>: usado de manera inapropiada, dañado, perdido (borrado, antigüedad de documentos archivados, robo o pérdida de documentos, etc.) <br> - <strong> Canales de transmisión de papel </strong>: sobrecargado , dañado, alterado, perdido (entrega de correo detenida por una huelga, reasignación de oficinas o locales, pérdida de una compañía de entrega de documentos, reorganización de canales de transmisión de papel, etc.) ",
			name: "Las amenazas que pueden conducir a una desaparición de los datos personales",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong> Amenazas relacionadas con: </strong> <br> - <strong> Hardware </strong> alterado (adición de hardware incompatible que resulta en mal funcionamiento, eliminación de componentes esenciales, etc.) <br> - <strong> Software </ fuerte> usado inapropiadamente o alterado (Modificaciones no deseadas de datos en bases de datos, errores del operador que modifican datos, etc.) <br> - <strong> Canales de computadora </strong> usado inapropiadamente (reenvío de datos interceptados, etc.) <br> - <strong> Personas </strong> sobrecargadas o manipuladas (asignación del personal a tareas más allá de sus capacidades, estrés o cambios negativos en las condiciones de trabajo, influencia, etc.) <br> - Documentos en papel que han sido alterados (cambios en las cifras en un archivo, reemplazo de un original por una falsificación, etc.) <br> - <strong>Canales de transmisión en papel </strong> que han sido alterados (cambio de un libro de firmas a otro, envío de múltiples documentos en conflicto, etc.) ",
			name: "Las amenazas que pueden conducir a una modificación no deseada de los datos personales",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "A elegir entre los disponibles en la sección \"Planificado o medidas\" existentes, que se puede completar si es necesario.",
			name: "Medidas",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "Cuando los datos están siendo importados, diferentes tipos de metadatos (como los datos EXIF con un archivo de imagen adjunto) se puede recoger. <br>Estos metadatos deben ser identificado y eliminado si son innecesarios para los fines previstos. ",
			name: "Filtrado y eliminación",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Una vez que se han recibido datos confidenciales, como parte de una serie de información general o transmitidos solo con fines estadísticos, estos se pueden convertir en una forma menos confidencial o seudonimizados. Por ejemplo: <br> - si el sistema recopila la dirección IP para determinar la ubicación del usuario con fines estadísticos, la dirección IP se puede eliminar una vez que se haya deducido la ciudad o el distrito <br> - si el sistema recibe datos de video de cámaras de vigilancia, puede reconocer a las personas que están de pie o en movimiento en la escena y difuminarlos <br> - si el sistema es un medidor inteligente, puede agregar el uso de energía durante un cierto período, sin registrarlo en tiempo real",
			name: "Reducción de la sensibilidad mediante conversión",
			source: "Objetos conectados PIAF p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "El sistema puede garantizar que: <br> - el usuario puede usar un recurso o servicio sin el riesgo de revelar su identidad (datos anónimos) <br> - el usuario puede usar un recurso o servicio sin el riesgo de revelar su / su identidad, pero sigue siendo identificable y responsable de este uso (datos seudónimos) <br> - el usuario puede hacer múltiples usos de recursos o servicios sin el riesgo de que estos diferentes usos estén vinculados entre sí (los datos no se pueden correlacionar) <br> - el el usuario puede usar un recurso o servicio sin el riesgo de que otros, en particular de terceros, puedan observar que el recurso o servicio se está utilizando (no observabilidad) <br> Se debe elegir un método de la lista anterior. sobre la base de las amenazas identificadas. Para algunos tipos de amenazas a la privacidad, La seudonimización será más apropiada que la anonimización (por ejemplo, si existe una necesidad de trazabilidad). Además, algunas amenazas a la privacidad se abordarán mediante una combinación de métodos.",
			name: "Reducción de la naturaleza de identificación de los datos",
			source: "Objetos conectados PIAF p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "El sistema puede organizarse en partes independientes con funciones de control de acceso separadas. Los datos también pueden dividirse entre estos subsistemas independientes y controlarse por cada subsistema utilizando diferentes mecanismos de control de acceso. Si un subsistema es comprometida, los impactos sobre todos los datos de este modo se pueden reducir.",
			name: "Reducción de la acumulación de datos",
			source: "Objetos conectados PIAF p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "El sistema puede limitar el acceso a los datos de acuerdo con el principio de 'necesidad de saber' . El sistema puede separar los datos confidenciales y aplicar políticas de control de acceso específicas. El sistema también puede cifrar datos confidenciales para proteger su confidencialidad durante la transmisión y el almacenamiento. el acceso a las cookies temporales que se producen durante el tratamiento de datos también debe ser protegido.",
			name: "Restricción del acceso a datos",
			source: "Objetos conectados PIAF p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Reducir la gravedad de los riesgos mediante la limitación de la cantidad de datos personales a lo estrictamente necesario para alcanzar un propósito definido, de lo contrario los datos no se recogen.",
			name: "Minimizando la cantidad de datos personales",
			source: "WIKI Minimisation_des_données _: _ adéquates, _pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "PARA SER TRADUCIDO - Reduzca la gravedad de los riesgos minimizando los datos en sí mismos, tomando medidas destinadas a reducir su sensibilidad, como filtrar y eliminar datos innecesarios, seudonimizar datos, etc.",
			name: "A SER TRADUCIDO - Minimización de los datos mismos",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "El interesado tendrá derecho a oponerse, por motivos relacionados con su situación particular, en cualquier momento al tratamiento de datos personales que le conciernen, de conformidad con <a target = \" _blank \" href = \" http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN \" > Art. 21 de [GDPR] </a>",
			name: "Derecho a objetar",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Medidas tomadas para integrar la protección de datos personales en todas las nuevas operaciones de tratamiento (nombres confiables, directrices, metodología CNIL para la gestión de riesgos u otra metodología interna)",
			name: "Gestión de proyectos",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Personas a las que se refieren los datos cubiertos por el tratamiento",
			name: "Sujeto de datos",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: "El interesado tiene derecho a recibir los datos personales que le conciernen, que ha proporcionado a un controlador, en un formato estructurado, de uso común y legible por máquina, y tiene el derecho de transmitirlos datos a otro controlador sin obstáculos del controlador al que se han proporcionado los datos personales, consulte <a target = \" _blank \" href = \" http://eur-lex.europa.eu/legal-content/EN/ TXT / HTML /? Uri = CELEX: 32016R0679 & from = ES \" > Art. 20 de [GDPR] </a>",
			name: "Derecho a la portabilidad de datos",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "tratamiento de datos personales de tal manera que los datos personales ya no se puedan atribuir a un sujeto de datos específico sin el uso de información adicional, siempre que dicha información adicional se mantenga por separado y esté sujeta a medidas técnicas y organizativas para garantizar que los datos personales no se atribuyan a una persona física identificada o identificable. <br> La seudonimización reduce la vinculación de un conjunto de datos con la identidad original de un sujeto de datos; como tal, es una medida de seguridad útil pero no un método de anonimización",
			name: "Pseudonimización",
			source: "GDPR Art. 4.5 y directrices G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Las contraseñas deben estar compuestas por un mínimo de ocho caracteres; deben renovarse si existe la menor preocupación de que puedan haber sido comprometidas y, posiblemente, periódicamente (cada seis meses o una vez al año) y deben incluir un mínimo de tres de los cuatro tipos de caracteres (letras mayúsculas, minúsculas, números y caracteres especiales); cuando se cambia una contraseña, no se pueden reutilizar las últimas cinco contraseñas; la misma contraseña no debe usarse para diferentes accesos; las contraseñas deben no estar relacionado con la propia información personal (incluyendo nombre o fecha de nacimiento.). Definir un número máximo de intentos más allá del cual se emite una advertencia y la autenticación se bloquea (temporal o hasta que se desbloquee manualmente).",
			name: "Contraseña",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "El interesado tendrá derecho a obtener del controlador sin demora indebida la rectificación de los datos personales inexactos que le conciernen. Teniendo en cuenta los fines del tratamiento, el interesado tendrá derecho a tener información incompleta datos personales completado, incluso por medio de proporcionar una declaración complementaria.",
			name: "Derecho a la rectificación",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Reglamento sobre la protección de las personas físicas en lo que respecta al tratamiento de datos personales ya la libre circulación de estos datos, y se deroga la Directiva 95/46 / CE.",
			name: "GDPR (Reglamento general de protección de datos",
			source: "Título GDPR"
		},
		PIA_DEF_RT: {
			description: "Persona física o jurídica, autoridad pública, agencia u otro organismo que, solo o junto con otros, determina los propósitos y medios del tratamiento de datos personales; donde los propósitos y medios de dicho tratamiento son determinados por la Unión o La ley del Estado miembro, el controlador o los criterios específicos para su nominación pueden ser establecidos por la ley de la Unión o del Estado miembro. <br> Ver <a target = \" _blank \" href = \" http: //eur-lex.europa .eu / legal-content / EN / TXT / HTML /? uri = CELEX: 32016R0679 & from = EN \" > Art. 4.7 de [GDPR] </a>",
			name: "Controlador",
			source: "GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Persona o fuente no humana que puede causar un riesgo. Esta fuente puede actuar accidental o deliberadamente",
			name: "Fuente de riesgo",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Persona física o jurídica, autoridad pública, agencia u otro organismo que procesa datos personales en nombre del controlador, consulte <a target = \" _blank \" href = \" http: //eur-lex.europa .eu / legal-content / EN / TXT / HTML /? uri = CELEX: 32016R0679 & from = EN \" > Art. 4.8 de [GDPR] </a>. <br> El procesador y cualquier persona que actúe bajo la autoridad del el controlador o el procesador, que tiene acceso a datos personales, no procesará esos datos, excepto por instrucciones del controlador, a menos que así lo exija la legislación de la Unión o del Estado miembro, consulte <a target = \" _blank \" href = \"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN \" > Art. 29 de la [GDPR] </a>.",
			name: "Procesador",
			source: "GDPR Art. 4.8 y 29"
		},
		PIA_DEF_SUPT: {
			description: "Activo en el que se basan los datos personales. Puede ser hardware, software, redes, personas, papel o canales de transmisión de papel",
			name: "Activos de apoyo",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Infracción de seguridad que conduce a la destrucción accidental o ilegal, pérdida, alteración, divulgación no autorizada o acceso a datos personales transmitidos, almacenados o procesados ??de otra manera",
			name: "Violación de datos personales",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: ". Probabilidad expresa la posibilidad de ocurrencia de un riesgo que depende principalmente del nivel de las vulnerabilidades de los activos de apoyo cuando están bajo amenaza y el nivel de las capacidades de las fuentes de riesgo de explotación de los mismos",
			name: "Probabilidad",
			source: "PIA1 página 6"
		},
		PIA_EX_DC: {
			description: "Datos utilizados para un sistema de scoring, resultado de la aplicación del scoring....",
			name: "Datos calculados"
		},
		PIA_EX_DCPC: {
			description: "Datos de Identificación, Estado civil, identidad, edad, etcétera. <br><strong>Vida personal</strong> : hábitos de vida, estado civil, etcétera. <br><strong>Vida profesional</strong> : currículum, educación y formación profesional, premios, etcétera. Datos de conexión, Direcciones IP, registros de eventos, etcétera.<br><strong>Datos de localización</strong> : viajes, datos GPS, datos GSM, etcétera.<br><strong>Otros</strong> : número de teléfono, dirección de correo electrónico, etcétera. ",
			name: "Datos personales comunes",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Opiniones filosóficas, políticas, religiosas y sindicales, vida sexual, datos de salud, origen racial o étnico, datos referentes a salud de vida, sexo, delitos, condenas, medidas de seguridad, consulte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">arte. 9 y 10 de [GDPR]</a>. ",
			name: "Convicciones y datos personales sensibles"
		},
		PIA_EX_DCPS: {
			description: "Número de Seguro Social, datos biométricos, datos del Banco",
			name: "Datos de carácter personal perciben como sensible"
		},
		PIA_EX_HUME: {
			description: "Podría ser cualquiera:<br>-un pícaro o ingenuo vecino, por tener una cercanía física, piratería en los datos del dispositivo;<br>-un hacker dirigidos a un usuario mediante el uso de los conocimientos que tiene el usuario y la información relativa a él;<br>-un hacker a una de las empresas utilizando el conocimiento que se tiene de las empresas que pueden socavar su imagen;<br>-una empresa de terceros autorizados con su privilegiado acceso ilegítimamente para acceder a información. ",
			name: "Fuentes humanas externas"
		},
		PIA_EX_HUMI: {
			description: "Podría ser cualquiera:<br>-un empleado negligente o pícaro, proximidad del sistema, capacidades, privilegios y tiempo disponible son potencialmente altos, posible falta de formación y sensibilización<br>-no fiables o negligencia del usuario, familiar o amigo teniendo acceso al servicio.<br>Son posibles varios motivo, incluyendo: torpeza, error, negligencia, mala intención, venganza, espionaje ",
			name: "Fuentes humanas internas"
		},
		PIA_EX_IMPI: {
			description: "Los interesados pueden encontrar consecuencias significativas, que deben ser capaces de superar con dificultades reales y graves. Por ejemplo: <br>-físicos: dolencias físicas graves que causa a largo plazo dañar alteration (empeoramiento de la salud debido al cuidado incorrecto, o la indiferencia de contraindicaciones), integridad física, por ejemplo después de un asalto, un accidente en su casa, trabajo, etcétera.<br>-material: apropiación indebida de dinero no compensado, específico, único y no recurrente, pérdidas de oportunidades (préstamo, denegación de empleo o estudios, pasantías, prohibición de examen), pérdida de la vivienda, pérdida de empleo, etcétera.;<br>-moral: graves enfermedades psicológicas (depresión, desarrollo de una fobia), sensación de invasión de la privacidad con un daño irreversible, víctima de chantaje, intimidación y acoso, etcétera. ",
			name: "Impacto significativo"
		},
		PIA_EX_IMPL: {
			description: "Los interesados pueden encontrar inconvenientes importantes, que sean capaces de superar a pesar de algunas dificultades. Por ejemplo:<br>-físicos: dolencias físicas de menor importancia (menor enfermedad debido al caso omiso de las contraindicaciones), difamación, dando lugar a represalias físicas o psicológicas, etcetera.;<br>-material: pagos imprevistos (multas erróneamente), denegación de acceso a los servicios administrativos o comerciales, recepción de mailings segmentados dañen la reputación de los interesados, etcetera.;<br>-moral: dolencias psicológicas menores pero objetivo, sentimiento de invasión de la privacidad sin daño irreversible, intimidación en redes sociales, etcetera. ",
			name: "Impacto limitado"
		},
		PIA_EX_IMPM: {
			description: "Los interesados pueden encontrar significativas o incluso irreversibles, consecuencias, que no pueden superar. Por ejemplo:<br>-físicos: dolencias físicas a largo plazo o permanentes, incapacidad permanente de la integridad física, la muerte;<br>-material: riesgo financiero, deudas substanciales, incapacidad, incapacidad para trasladarse, pérdida de la evidencia en el contexto del litigio, pérdida de acceso a infraestructuras vitales (agua, electricidad), etcétera.<br>-moral: dolencias psicológicas a largo plazo o permanentes, sanción penal, secuestro, pérdida de lazos familiares, incapacidad para demandar el cambio de situación administrativa o pérdida de autonomía legal (tutela), etcétera. ",
			name: "Impacto Máximo"
		},
		PIA_EX_IMPN: {
			description: "Los interesados no se verán afectados o pueden surgir algunos inconvenientes que se superan sin ningún problema. Por ejemplo:<br>-físicos: dolores de cabeza transitorios;<br>-material: pérdida de tiempo en la repetición de trámites o esperando que se cumplan, recepción de correo no solicitado (por ejemplo: spam), reutilización de los datos publicados en sitios web con el fin de la publicidad dirigida, etcétera.;<br>-moral: mera molestia, sensación de invasión de la privacidad sin daño real u objetiva (intrusión comercial), etcétera. ",
			name: "Impacto insignificante"
		},
		PIA_EX_NHUM: {
			description: "Incidente o daño, en uno de la organización (corte de energía, incendios, inundaciones, etcetera.)",
			name: "Fuentes no humanos"
		},
		PIA_EX_VRAI: {
			description: "Es posible que las fuentes seleccionadas del riesgo materialicen la amenaza explotando las características de apoyar activos (e.g.: hurto de los documentos de papel almacenados en las oficinas que no pueden ser alcanzadas sin primero llegar en la recepción). ",
			name: "Probabilidad significativa"
		},
		PIA_EX_VRAL: {
			description: "Es difícil que las fuentes seleccionadas del riesgo materialicen la amenaza explotando las características de apoyar activos (e.g.: hurto de los documentos de papel almacenados en un cuarto protegido por un lector de divisa).",
			name: "Probabilidad limitada"
		},
		PIA_EX_VRAM: {
			description: "Es extremadamente fácil que las fuentes seleccionadas del riesgo materialicen la amenaza explotando las características de apoyar activos (e.g.: hurto de los documentos de papel almacenados en el pasillo público).",
			name: "Probabilidad máxima"
		},
		PIA_EX_VRAN: {
			description: "No es posible que las fuentes seleccionadas del riesgo materialicen la amenaza explotando las características de apoyar activos (e.g.: hurto de los documentos de papel almacenados en un cuarto protegido por un lector de divisa y un código de acceso). ",
			name: "Probabilidad insignificante"
		},
		PIA_LGL_CONS: {
			description: "Se deberá garantizar que la recogida de datos se realiza de forma libre, específica e informada. Se determinará si el tratamiento dispone de una base legal en la que no sea necesario el consentimiento, de conformidad con el art. 6 de <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">[GDPR]</a>",
			name: "Consentimiento",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Se definirá y describirá con detalle el alcance del tratamiento: <br> - datos personales recabados, destinatarios, encargados del tratamiento, tiempo de retención y otras consideraciones<br> - descripción de los procesos, medios y soportes que se utilizan durante todo el ciclo de vida de los datos personales (desde su recogida hasta su borrado). ",
			name: "Datos y procesos",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Se describirá brevemente el tratamiento objeto de evaluación: naturaleza, alcance, contexto, propósitos y riesgos. Identificar al responsable y encargados del tratamiento. Identificar las normas aplicables al tratamiento, que sean necesarias o deban cumplirse,en particular, los códigos de conducta aprobados por el regulador (ver Art. 40 de la <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">[GDPR]</a> ) y las certificaciones relacionadas con la protección de datos (ver Art. 42 de la <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">[GDPR] ]</a>)",
			name: "Descripción del tratamiento",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "La persona física o jurídica, autoridad pública, servicio u otro organismo al que se comuniquen datos personales, se trate o no de un tercero. No obstante, no se considerarán destinatarios las autoridades públicas que 4.5.2016 ES Diario Oficial de la Unión Europea L 119/33  puedan recibir datos personales en el marco de una investigación concreta de conformidad con el Derecho de la Unión o de los Estados miembros; el tratamiento de tales datos por dichas autoridades públicas será conforme con las normas en materia de protección de datos aplicables a los fines del tratamiento. ver Art. 4.9 de la <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">[GDPR]</a>",
			name: "Destinatario",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "Se deberá definir un período de retención para cada tipo de datos, justificado por las necesidades de tratamiento y/o los requisitos legales. Esto diferencia datos actuales y datos archivados, cuyo acceso estará restringido. Se deberá implementar un mecanismo de eliminación para archivar datos actuales o depurar los datos archivados al final de su período de retención. Los rastros funcionales también deben purgarse, así como los registros técnicos que no se almacenarán indefinidamente. ",
			name: "Período de retención de los datos",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Los datos personales serán recogidos con fines determinados, explícitos y legítimos, y <strong> no serán tratados ulteriormente de manera incompatible con dichos fines.</strong> <br>Ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">Art. 5.1 b) de [GDPR]</a>",
			name: "Principios relacionados con el tratamiento de datos personales",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- El interesado ha dado su consentimiento para el tratamiento de sus datos personales para uno o más fines específicos<br>- El tratamiento forma parte de los pasos previos o necesarios para la ejecución de un contrato en el que el interesado es parte.<br>- El tratamiento es necesario para dar cumplimiento a una obligación legal a la que el responsable del tratamiento está sujeto<br>- El tratamiento es necesario para proteger a los intereses vitales del interesado o de otra persona física.<br>- El tratamiento es necesario para el desempeño de una misión de interés público o en el ejercicio del poder público conferido al responsable del tratamiento<br>- El tratamiento es necesario para los intereses legítimos que persigue el responsable del tratamiento o un tercero, a menos que los intereses o los derechos fundamentales y libertades del interesado requieran la protección de los datos de carácter personal, en particular cuando la persona interesada es un niño.<br>Ver <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">art. 6 de [GDPR]</a></a>",
			name: "Justificación legal",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Se deberá garantizar que los interesados están informados y evitar la recogida de datos sin su consentimiento. Se deberá de verificar que el tratamiento no está sujeto a una excepción o a condiciones especiales.",
			name: "Informar a los interesados",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "El objetivo es reducir la gravedad de los riesgos limitando la recopilación de datos personales a lo estrictamente necesario para los fines para los que se procesan (de lo contrario, no deberían recopilarse). Es posible minimizar los datos a través de controles destinados a reducir su sensibilidad.",
			name: "Minimización de datos",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Se deberá realizar un contrato de delegación del tratamiento con cada encargado del tratamiento, especificando todos los elementos previstos en el art. 28 del RGPD: duración, alcance, propósito, instrucciones para el tratamiento, autorización previa en caso de uso de subcontratación, disponibilidad y acceso a la documentación que proporcione evidencia del cumplimiento con el RGPD, notificación inmediata de brechas o violación de datos, etc.",
			name: "Subcontratación",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Activos de los que depende el tratamiento de los datos personales. Nota: Dispositivos físicos, programas, redes, personas, archivos y canales de comunicación de papel, etc. ",
			name: "Activos del tratamiento",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Se deberá detallar la ubicación geográfica de los lugares donde se realiza el tratamiento. Dependiendo del país en cuestión, se deberá justificar la elección del alojamiento fuera de la Unión Europea e indicar el marco legal implementado para garantizar la protección adecuada de los datos sujetos a transferencia transfronteriza.<br> Indicando si es:<br>- Unión Europea<br>-Un país reconocido como adecuado por la Unión Europea<br>- Estados Unidos, compañía adherida al Privacy Shield<br>-Otro país<br>Ver<a target=\" _blank \" href= \"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">art. 44 a 49 de [GDPR]</a>",
			name: "Transferencias internacionales",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Existencia de una política y procesos para obtener una organización capaz de gestionar y controlar la protección de datos de carácter personal mantenidos dentro de ella.",
			name: "Supervisión",
			placeholder: "Indicar aquí si se monitorean la efectividad y la adecuación de los controles de privacidad.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Existencia de una política y procesos reduciendo el riesgo de que el legítimo acceso a los datos personales por parte de terceros puede representar para las libertades civiles y la privacidad de los sujetos de datos.",
			name: "Relaciones con terceras partes",
			placeholder: "Indican que, para los procesadores que requieren acceso a datos, los controles de seguridad y arreglos realizados con respecto a dicho acceso.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Especificar si una persona es responsable de la aplicación de las leyes de privacidad y los reglamentos. Especificar si existe un Comité de vigilancia (o equivalente) responsable de la orientación y seguimiento de las acciones relativas a la protección de la privacidad. ",
			name: "Organización",
			placeholder: "Indicar si se definen las funciones y responsabilidades para la protección de datos.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Existencia de una política, integrar la protección de datos personales en todas las operaciones de tratamiento nuevas.",
			name: "Integración de la protección de la privacidad en los proyectos",
			placeholder: "Describir aquí cómo protección de la privacidad está integrada en los proyectos",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Existencia de una política que describe controles de sensibilización se llevan a cabo con respecto a un nuevo empleado y qué controles se llevan a cabo cuando las personas que han tenido acceso a datos dejan su trabajo.",
			name: "Gestión de personal",
			placeholder: "Indicar aquí qué controles de sensibilización se llevan a cabo en relación con los empleados.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Establecen aspectos importantes relativos a la protección de los datos dentro de una fabricación base documental, la política de protección de datos y en una forma adecuada para cada tipo de contenido (riesgos, principios fundamentales a seguir, apuntar los objetivos, las reglas a aplicar, etc.) y cada uno objetivo de comunicación (usuarios, IT Departamento, las autoridades, etcétera). ",
			name: "Política",
			placeholder: "Describir aquí el documental base estableciendo reglas y objetivos de protección de datos.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Política que describe los procesos para controlar los riesgos que plantean las operaciones de tratamiento realizadas por la organización sobre protección de datos y la privacidad de los interesados (construyendo un mapa de riesgos, etcétera).",
			name: "Gestión de riesgos de la privacidad",
			placeholder: "Describir aquí procesos para controlar los riesgos que plantean las operaciones de tratamiento realizadas por la organización sobre protección de datos y la privacidad de los interesados.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Existencia de una organización operativa que puede detectar y tratar los incidentes que puedan afectar las libertades civiles y la privacidad de los sujetos de datos",
			name: " Gestión de las violaciones de datos personales",
			placeholder: "Indicar aquí si son indicencias sometidas a un procedimiento de gestión documentado y probado.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Políticas y medios implementan para asegurar la disponibilidad o integridad de los datos personales, manteniendo su confidencialidad.",
			name: "Copias de Seguridad",
			placeholder: "Indicar aquí cómo se manejan copias de seguridad. Aclarar si se almacenan en un lugar seguro. ",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Controles en estaciones de trabajo (fijación automática, actualizaciones regulares, configuración, seguridad física, etc.) para reducir la posibilidad de explotar propiedades de software (sistemas operativos, aplicaciones, etc.) para afectar a datos personales",
			name: "Gestión de estaciones de trabajo",
			placeholder: "Describir aquí los controles implementados en estaciones de trabajo",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "<strong>Utilice sólo Encargados de Tratamiento que son capaces de ofrecer garantías suficientes</strong> (en particular en términos de conocimiento especializado, fiabilidad y recursos). Solicite a los prestadores de servico que le comuniquen su política de seguridad de sistemas antes de firmar un contrato con ellos. <br> Tome y documente estos medios (auditorías de seguridad, visitas a las instalaciones, etc.) utilizados para <strong>asegurar la efectividad de las garantías ofrecidas por el Encargado</strong> en términos de protección de datos. Estas garantías incluyen: <br>- encriptación de los datos en función de su sensibilidad o, al menos, la existencia de procedimientos que garanticen que el prestador de servicio no tiene acceso a los datos; <br>- encriptación de las comunicaciones de datos (ej.: conexiones tipo HTTPS, VPN, etc.); <br>- garantías en términos de red, trazabilidad (logs, auditorías), administración de permisos de acceso, autenticación, etc. <br><strong>Firme un contrato con los Encargados</strong>, que defina el objeto, la duración y la finalidad del tratamiento, así como las obligaciones de cada una de las partes. Asegúrese de que contiene, en particular, disposiciones específicas relativas a: <br>- sus obligaciones en términos de <strong>confidencialidad del personal con acceso autorizado a datos</strong>;<br>- <strong>criterios básicos en términos de autenticación de usuarios</strong>;<br>- <strong>procedimientos de recuperación de datos y/o su destrucción a la finalización del contrato</strong>;<br>- <strong>procedimiento de gestión de incidencias y notificación. </strong> Deben incluir la notificación a la Autoridad de Control cuando se conozca una brecha o incidencia de seguridad, tan pronto como sea posible cuando se vean afectados datos de carácter personal.",
			name: "Contratos de tratamiento",
			placeholder: "Describir aquí las medidas específicas para los procesadores (host, empresa de mantenimiento, administrador, proveedores de servicios de especialista, etcétera.)",
			source: "Measures_US Procurement: Identificada y marcada en un contrato"
		},
		PIA_SEC_EXP: {
			description: "Las políticas implementadas para reducir la posibilidad y el impacto de riesgos en activos apoyando datos personales.",
			name: "Operación de seguridad",
			placeholder: "Describir aquí cómo realizan las actualizaciones de software (sistemas operativos, aplicaciones, etc.) y la aplicación de parches de seguridad de controles correctivos.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Controlar sistemas de detección de intrusos y sistemas de prevención, con el fin de analizar la red (cableado de redes, Wi-Fi, radio ondas, fibra óptica, etc.) del tráfico en tiempo real y detectar cualquier actividad sospechosa de un escenario de ataque cibernético.",
			name: "Supervisando la actividad de la red",
			placeholder: "Indicar aquí los medios y controles implementados para detectar incidentes de datos de carácter personal",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Las políticas que describen el mantenimiento cómo físico de hardware son administradas, indicando si ésta es contratada.<br>Indican si está autorizado el mantenimiento remoto de aplicaciones y según qué modalidades. Especificar si el equipo defectuoso se gestiona de una manera específica. ",
			name: "Mantenimiento",
			placeholder: "Describir aquí cómo se gestiona el mantenimiento físico de hardware",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controles implementados en las estaciones de trabajo y servidores para protegerse de software malicioso al acceder a redes menos seguras.",
			name: "Reducción de software malicioso",
			placeholder: "Describa aquí los controles implementados para reducir los riesgos al acceder a redes menos seguras.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Indique aquí los controles relacionados con la seguridad física de los servidores y las estaciones de trabajo (almacenamiento seguro, cables de seguridad, filtros de confidencialidad, borrado seguro antes del desguace, etc.).",
			name: "Seguridad del hardware",
			placeholder: "Indique aquí los controles relacionados con la seguridad física de los servidores y las estaciones de trabajo",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Dependiendo del tipo de red en la que se realiza el tratamiento (aislado, privado o Internet). Especifique qué sistema de firewall, sistemas de detección de intrusos u otros dispositivos activos o pasivos se encargan de garantizar la seguridad de la red. ",
			name: "Seguridad de la red",
			placeholder: "Indique aquí los controles de seguridad de la red en la que se realiza el tratamiento.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Políticas para garantizar la seguridad física (zonificación, acompañamiento de visitantes, uso de pases, puertas cerradas y así sucesivamente). Indicar si existen procedimientos de advertencia en caso de un robo. ",
			name: "Control de acceso físico",
			placeholder: "Indique aquí cómo se realiza el control de acceso físico con respecto a las instalaciones que alojan el tratamiento.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Las políticas que describen los medios de prevención, detección y lucha En su caso, indicar los medios de impedir que el agua damage.Also especifica los medios de vigilancia de la fuente de alimentación y alivio... ",
			name: "Protección contra fuentes no humanas de riesgos",
			placeholder: "Indicar aquí significa evitar limitar las fuentes de riesgo no humanas.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Documentación sobre el área de implantación, que no debe estar sujeta a desastres ambientales (zona de inundación, proximidad a industrias químicas, terremoto o zona volcánica, etc.). Especifique si se almacenan productos peligrosos en la misma área. ",
			name: "Evitar fuentes de riesgo",
			placeholder: "Indique aquí los controles implementados para proteger los sitios web",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Indique aquí los controles implementados para proteger los sitios web ",
			name: "Seguridad del sitio web",
			placeholder: "Indique aquí los controles implementados para proteger los sitios web ",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Indique aquí si se implementan mecanismos de anonimización, cuáles y con qué propósito. <br> Recuerde distinguir claramente entre datos anónimos y seudónimos. ",
			name: "Anonimización",
			placeholder: "Indique aquí los mecanismos de anonimización implementados",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "En su caso, describa aquí los procesos de gestión de archivos (entrega, almacenamiento, consulta, etc.) bajo su responsabilidad. Especifique las funciones de archivo (oficinas de origen, agencias de transferencia, etc.) y la política de archivo. Estado si los datos pueden caer dentro del alcance de los archivos públicos. ",
			name: "Archivando",
			placeholder: "Indicar aquí si están implementado los mecanismos para el monitoreo de integridad de los datos almacenados, cuáles y para qué.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Medios implementados para <strong> garantizar la confidencialidad </strong> de los datos almacenados (en la base de datos, en archivos planos, copias de seguridad, etc.), así como el procedimiento para administrar las claves de cifrado (creación, almacenamiento, cambio en caso de sospecha de compromiso de datos, etc.). Describa los medios de cifrado empleados para los flujos de datos (VPN, TLS, etc.) implementados en el tratamiento. ",
			name: "Cifrado",
			placeholder: "Describa aquí los medios implementados para garantizar la confidencialidad de los datos",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "La implementación del particionamiento de datos ayuda a reducir la posibilidad de que los datos personales puedan correlacionarse y que pueda producirse una violación de todos los datos personales.",
			name: "Datos de partición",
			placeholder: "Indique aquí si se planifica el particionamiento de tratamiento y cómo se lleva a cabo.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Métodos para definir y atribuir perfiles de usuarios. Especifique los medios de <strong> autenticación </strong> implementados. En su caso, especifique las reglas aplicables a las contraseñas (longitud mínima, caracteres requeridos, duración de validez, número de intentos fallidos antes el acceso a la cuenta está bloqueado, etc.) ",
			name: "Control de acceso lógico",
			placeholder: "Indique aquí cómo se definen y atribuyen los perfiles de los usuarios.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Políticas que definen la trazabilidad y la gestión de registros.",
			name: "Trazabilidad (registro)",
			placeholder: "Indique aquí si los eventos se registran y durante cuánto tiempo se almacenan estos rastreos.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Se podrían utilizar los siguientes métodos: filtrado y eliminación, reducción de la sensibilidad mediante conversión, reducción de la naturaleza de identificación de los datos, reducción de la acumulación de datos, restricción del acceso a los datos",
			name: "Minimizando la cantidad de datos personales",
			placeholder: "Indicar aquí significa implementado para reducir la gravedad de los riesgos limitando la cantidad de datos personales",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Cuando se utilizan documentos de papel que contienen los datos durante el tratamiento, indique aquí la forma en que se imprimir, almacenar, destruyeron e intercambiaron.",
			name: "Seguridad de documentos en papel",
			placeholder: "Indique aquí si se implementan mecanismos para el monitoreo de integridad de documentos en papel, cuáles y con qué propósito.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "controles correctivos sugeridos por el asesor en pasos anteriores, elaborando un plan de acción que establece, para cada acción, su gerente, frecuencia, dificultad, costo y progreso.",
			name: "Plan de acción",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Gráfico que ilustra las buenas prácticas de seguridad, con un valor de conformidad atribuido a cada uno en función de su evaluación en los pasos anteriores.",
			name: "Mapeo de riesgos",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "En su caso, el controlador buscará las opiniones de los interesados o sus representantes sobre el tratamiento previsto, sin perjuicio de la protección de los intereses comerciales o públicos o la seguridad de las operaciones de tratamiento. Ver Art. 39.2 de la <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">[GDPR]</a> <br> Estos puntos de vista pueden reunirse por diversos medios, dependiendo del contexto (estudio interno o externo sobre los métodos de tratamiento y el propósito, la pregunta para la atención de los representantes del personal o los sindicatos, la encuesta entre los futuros clientes del procesador de datos). <strong>Donde el controlador de datos decide ir en contra de las opiniones de los interesados</strong>, debe anotar <strong>la justificación de esta decisión</strong>. Cuando el controlador de datos considere que <strong>reuniendo las opiniones de los sujetos de los datos es no relevante, él debe también anotar la justificación de los mismos</strong>. ",
			name: "Opinión del interesado",
			source: "GDPR Art. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "El controlador buscará el asesoramiento del oficial de protección de datos, cuando así se designe, cuando realice una evaluación de impacto de protección de datos. Ver Art. 39.2 de la <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679&from=ES\">[GDPR]</a> <br> <strong>Esta opinión puede ser contraria al tratamiento que se está implementando, sin que ello limite la decisión final del responsable del tratamiento.</strong> ",
			name: "Opinión de DPO",
			source: "GDPR Art. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Decidir si los controles seleccionados, los riesgos residuales y el plan de acción son aceptables, con justificaciones, en vista de los intereses y puntos de vista previamente identificados de las partes interesadas. De esta manera, el PIA puede ser: <br> - validado <br> - condicional a la mejora (explique de qué manera) <br> - rechazado (junto con el tratamiento bajo consideración). Cuando sea necesario, repita los pasos anteriores para que el PIA pueda ser validado. Esta decisión no prejuzga la evaluación de cumplimiento que puede ser llevado a cabo, en su caso, por la Autoridad de protección de datos (la CNIL en Francia), como parte de los trámites preliminares o cheques, por ejemplo. ",
			name: "Validación formal",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Base de conocimientos"
};
var measures$g = {
	add: "Agregar una acción (de lo contrario, utilice la base de conocimiento)",
	default_placeholder: "Describir las medidas existentes o previstas para garantizar la seguridad de la información.",
	edit: "Editar medida",
	placeholder_title: "Nombre de la medida",
	remove: "Eliminar la medida"
};
var misc$g = {
	display: "Mostrar /Ocultar"
};
var modals$g = {
	abandon_pia: {
		additional_text: "El archivado no es definitivo, puede reanudar el PIA de ser necesario.",
		content: "¿Desea finalizar el tratamiento?"
	},
	action_plan_no_evaluation: {
		content: "Debe comenzar la evaluación del análisis para crear el plan de acción.",
		review_section: "Evaluar una sección"
	},
	archive: "Archivar",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "Esta sección está lista para ser revisada."
	},
	back_to_edition: {
		content: "Esta sección se ha devuelto para su edición.<br> Se deben corregir diversos campos<br> para permitir su adecuada revisión."
	},
	back_to_evaluation: {
		content: "Esta sección se ha devuelto para su revisión.<br> Se deben revisar diversos campos<br> para permitir su adecuada validación."
	},
	back_to_home: "Volver a inicio",
	cancel: "Cancelar",
	close: "Cerrar",
	completed_edition: {
		content: "El PIA ha sido completamente editado y debe ser evaluado."
	},
	completed_evaluation: {
		content: "El PIA ha sido completamente evaluado y puede ser validado ."
	},
	"continue": "Continuar",
	declare_measures: {
		content: "Antes de evaluar los riesgos, <br> debe informar las medidas existentes o planificadas.",
		declare: "Declarar medidas existentes o planificadas"
	},
	dpo_missing_evaluations: {
		comment: "Inserte un comentario",
		content: "Debe completar la revisión del análisis para acceder a la página DPO.",
		remove: "Eliminar",
		review_section: "Evaluar una sección"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "El archivo importado no corresponde con un archivo de tipo PIA"
	},
	import_wrong_structure_file: {
		content: "El archivo importado no coincide con un archivo de plantilla"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "El contenido del PIA se ha copiado al portapapeles."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'> Advertencia, </ span> <br> Se debe completar al menos una medida: no es posible la eliminación."
	},
	recover_version: {
		"continue": "Continuar",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "Como ha rechazado el PIA, se devuelve para su validación con el fin de realizar los cambios necesarios."
	},
	remove_attachment: {
		comment: "Inserte un comentario",
		content: "Advertencia,<br>¿Está seguro de que quiere<br>eliminar este archivo adjunto?",
		keep: "Mantener",
		remove: "Eliminar"
	},
	remove_measure: {
		content: "Advertencia,<br>¿Está seguro de que quiere<br>eliminar esta medida?",
		keep: "Mantener este<br>medida",
		remove: "Eliminar esto<br>medida"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Eliminar este PIA"
	},
	remove_question: {
		content: "¿Quiere eliminar la pregunta?",
		keep: "Mantener",
		remove: "Eliminar"
	},
	remove_structure: {
		content: "<span class='strong'>Atención,</span><br>¿Está seguro de que desea<br> eliminar este modelo?",
		remove: "Eliminar esta plantilla"
	},
	same_comment: {
		content: "Advertencia,<br>Ingrese un comentario diferente al último registrado."
	},
	signed_pia_validation: {
		content: "Para aprobar el PIA, adjunte el informe firmado.",
		download_pia: "Descargar el informe"
	},
	simple_pia_validation: {
		content: "Has aprobado el PIA."
	},
	start_evaluation: "Iniciar evaluación",
	unarchive_pia: {
		content: "<span class='strong'>Aviso,</span><br>¿Está seguro que quiere<br>desarchivar este PIA ?",
		unarchive: "Desarchivar PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "La dirección del servidor ha sido actualizada."
	},
	validate_evaluation: {
		content: "Esta sección está lista para validar el PIA."
	},
	validate_evaluation_to_correct: {
		content: "Lo siento,<br>Se deben corregir varios campos. <br> Volver al modo de edición<br>para realizar correcciones"
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$g = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$g = {
	content: ", considera que:",
	dpo_lock: "Complete las otras secciones antes de poder completar la opinión de DPO",
	dpo_opinion: "Opinión de DPO",
	edit: "Editar",
	people_opinion: "Opinión de personas interesadas",
	placeholder_concerned_people_name: "Nombre (s) de las personas interesadas",
	placeholder_dpo_name: "Nombre (s) de DPO",
	placeholder_dpo_opinion: "Especifique los motivos de su elección.",
	placeholder_people_opinion: "Describa cómo se recopilaron las opiniones y cuál es el análisis. Si no se han buscado los avisos, indique los motivos. ",
	placeholder_search_content: "Justifique la razón por la cual no se ha solicitado la opinión de las personas interesadas.",
	treatment_lock: "Complete las otras secciones antes de poder completar las opiniones de las personas interesadas.",
	treatment_nok: "El tratamiento no debe usarse. ",
	treatment_ok: "El tratamiento podría implementarse"
};
var pia$g = {
	attachments: {
		add: "Añadir",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Eliminar",
		title: "Adjuntos",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Solicitar revisión",
		mandatory_fields: "Todos los campos son obligatorios",
		structure_add_question: "Añadir una pregunta",
		subsection_validated: "Subsección revisada, en espera de validación final",
		validate_evaluation: "Validar revisión"
	},
	header: {
		display_action_plan: "Mostrar<br>Plan de acción",
		edition: "Edición",
		evaluation: "Evaluación",
		preview: "Vista Previa"
	},
	sections: {
		based_on_structure_name: "Basado en el modelo :",
		homepage_link: "Volver al Escritorio",
		refuse_pia: "Rechazar AIIA",
		status: {
			evaluation: {
				cancel: "Cancelar la solicitud de revisión.",
				cancel_button: "Cancelar la revisión",
				content: "Esta parte aún no ha sido tratada. Si desea editar el contenido enviado para su procesamiento, debe",
				title: "Revisión pendiente"
			},
			validation: {
				cancel: "Cancelar la solicitud de validación.",
				cancel_button: "Cancelar la validación",
				content: "Esta parte ha sido revisada y está pendiente de la validación final del PIA. Si desea cambiar la revisión, debe",
				title: "Validación pendiente"
			}
		},
		validate_pia: "Validar PIA"
	},
	statuses: [
		"En progreso",
		"Rechazado",
		"Validado",
		"Validado y confirmado",
		"Archivado",
		"Validación pendiente"
	]
};
var questions$g = {
	edit: "Corrija la pregunta",
	gauges: [
		"(Indefinido)",
		"Insignificante",
		"Limitado",
		"Importante",
		"Máximo"
	],
	placeholder_title: "Título de la pregunta (obligatorio)",
	remove: "Eliminar la pregunta"
};
var rejection_page$g = {
	applied_adjustments: "Cambios realizados",
	applied_adjustments_placeholder: "Describir los cambios realizados en el PIA.",
	button: {
		abandon_treatment: "Detener el tratamiento",
		reject_pia: "Rechazar el AIIA",
		send_for_validation: "Reenviar para aprobación"
	},
	previous_rejection: "PIA ya rechazada",
	rejection_reason: "Motivos de rechazo del AIIA",
	rejection_reason_placeholder: "Describa las razones para rechazar el PIA.",
	title: "Historial de la validación"
};
var sections$g = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Presente un breve resumen del tratamiento: su nombre, propósitos, apuestas, contexto de uso, etc.",
						title: "¿Cuál es el tratamiento bajo consideración? "
					},
					"2": {
						placeholder: "Describe las responsabilidades de las partes interesadas:. El controlador de datos, los posibles procesadores de datos y controladores conjuntas.",
						title: "¿Cuáles son las responsabilidades vinculadas al tratamiento?"
					},
					"3": {
						placeholder: "Enumere las normas pertinentes aplicables al tratamiento, especialmente los códigos de conducta aprobados y las certificaciones de protección de datos.",
						title: "¿Hay estándares aplicables al tratamiento? "
					}
				},
				short_help: "Esta parte le permite identificar y presentar el objeto del estudio ",
				title: "Descripción General"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Lista de los datos recogidos y tratados definir para cada las duraciones de almacenamiento, los recipientes y las personas con acceso a la misma.",
						title: "¿Cuáles son los datos procesados? "
					},
					"2": {
						placeholder: "Presente y describa cómo funciona generalmente el producto (desde la recopilación de datos hasta la destrucción de datos, las diferentes etapas de tratamiento, almacenamiento, etc.), utilizando, por ejemplo, un diagrama de flujos de datos (agréguelo como archivo adjunto) y una descripción detallada de los procesos llevados a cabo.",
						title: "¿Cómo funciona el ciclo de vida de los datos y procesos?"
					},
					"3": {
						placeholder: "Listar los activos de soporte de datos (sistemas operativos, aplicaciones comerciales, sistemas de gestión de bases de datos, suites de oficina, protocolos, configuraciones, etc.)",
						title: "¿Cuáles son los activos de soporte de los datos?"
					}
				},
				short_help: "Esta parte le permite definir y describir el alcance del tratamiento en detalle.",
				title: "Datos, procesos y activos de soporte"
			}
		},
		short_help: "Esta sección le ofrece una visión clara de los tratamientos de los datos personales en cuestión.",
		title: "Contexto"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Explica por qué los propósitos de tratamiento son específicos, explícitos y legítimos.",
						short_title: "Propósitos ",
						title: "¿Son los propósitos de tratamiento especificados, explícitos y legítimos?"
					},
					"2": {
						placeholder: "Describe cuál es / son la base legal de su tratamiento (por ejemplo: consentimiento, cumplimiento de un contrato, cumplimiento de una obligación legal, protección de los intereses vitales, etc.)",
						short_title: "Base jurídica",
						title: "¿Cuáles son las bases legales que hacen que el tratamiento sea legal?"
					},
					"3": {
						placeholder: "Explicar por qué cada uno de los datos recogidos es necesario para los fines de su tratamiento.",
						short_title: "Datos adecuados",
						title: "¿Los datos recopilados son adecuados, relevantes y limitados a lo que es necesario en relación con los fines para los que se procesan ('minimización de datos')? "
					},
					"4": {
						placeholder: "Describa cuáles son los pasos dados para garantizar la calidad de los datos.",
						short_title: "Precisión de datos",
						title: "¿Los datos son precisos y están actualizados?"
					},
					"5": {
						placeholder: "Explica por qué las duraciones de almacenamiento están justificadas por requisitos legales y / o necesidades de tratamiento.",
						short_title: "Duración del almacenamiento",
						title: "¿Cuál es la duración de almacenamiento de los datos?"
					}
				},
				short_help: "Esta parte le permite demostrar la legitimidad de su tratamiento y de los datos procesados.",
				title: "Proporcionalidad y necesidad"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Describa cuál es la información dada a los interesados ??y cuáles son los medios para hacerlo.",
						short_title: "Información para los interesados",
						title: "¿Cómo se informa a los interesados sobre el tratamiento?"
					},
					"2": {
						placeholder: "Describa los controles destinados a garantizar que se ha obtenido el consentimiento de los usuarios.",
						short_title: "Obtención de consentimiento",
						title: "Si corresponde, ¿cómo se obtiene el consentimiento de los interesados?"
					},
					"3": {
						placeholder: "Describe los controles destinados a permitir a los interesados ??acceder, recibir y transmitir sus datos.",
						short_title: "Derecho de acceso y portabilidad de datos",
						title: "¿Cómo pueden los interesados ejercen sus derechos de acceso y de portabilidad de datos?"
					},
					"4": {
						placeholder: "Describe los controles destinados a permitir que los interesados ??rectifiquen y borren sus datos.",
						short_title: "Derecho a rectificación y borrado",
						title: "¿Cómo pueden los interesados ??ejercer sus derechos de rectificación y borrado?"
					},
					"5": {
						placeholder: "Describe los controles destinados a permitir a los interesados ??restringir y oponerse al tratamiento de sus datos.",
						short_title: "Derecho a restricción y a objetar",
						title: "¿Cómo pueden los interesados ??ejercer sus derechos de restricción y de objeción?"
					},
					"6": {
						placeholder: "Para cada procesador, describir sus responsabilidades (duración, alcance, propósito, instrucciones de tratamiento documentados, autorización previa) y proporcionar los contratos, códigos de conducta y certificaciones que determinan sus misiones y obligaciones.",
						short_title: "Subcontratación",
						title: "¿Las obligaciones de los procesadores están claramente identificadas y regidas por un contrato?"
					},
					"7": {
						placeholder: "Para cada país fuera de la Unión Europea donde se almacenan o procesan los datos, el nombre y decir si es reconocido como ofrecer un nivel adecuado de protección de datos o describir las disposiciones relativas a la transferencia.",
						short_title: "Transferencias",
						title: "En el caso de transferencia de datos fuera de la Unión Europea, ¿están los datos adecuadamente protegidos?"
					}
				},
				short_help: "Esta parte le permite demostrar que va a implementar los medios necesarios para que los beneficiarios puedan ejercer sus derechos.",
				title: "Controles para proteger los derechos personales de los interesados"
			}
		},
		short_help: "Esta sección le permite crear el marco de cumplimiento para los principios de privacidad.",
		title: "Principios fundamentales"
	},
	"3": {
		items: {
			"1": {
				short_help: "Esta sección le permite identificar controles (existentes o planificados) que contribuyen a la seguridad de los datos.",
				title: "Medidas planificadas o existentes"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Ingrese los posibles impactos",
						title: "¿Cuáles podrían ser los principales impactos en los sujetos de los datos si ocurriera el riesgo?"
					},
					"2": {
						placeholder: "Ingrese las amenazas",
						title: "¿Cuáles son las principales amenazas que podrían conducir al riesgo?"
					},
					"3": {
						placeholder: "Ingrese las fuentes de riesgo",
						title: "¿Cuáles son las fuentes de riesgo?"
					},
					"4": {
						placeholder: "Haga clic para seleccionar controles que aborden el riesgo",
						title: "¿Cuál de los controles identificados contribuyen a abordar el riesgo?"
					},
					"5": {
						placeholder: "Justifique aquí la gravedad estimada del riesgo.",
						title: "¿Cómo que calcular la gravedad del riesgo, especialmente según los impactos potenciales y controles previstos?"
					},
					"6": {
						placeholder: "Justificar aquí la probabilidad estimada.",
						title: "¿Cómo calcula la severidad del riesgo de, especialmente de acuerdo con los impactos potenciales y los controles planificados?"
					}
				},
				short_help: "Analizar las causas y consecuencias de un acceso ilegítimo a los datos y estimar su gravedad y la probabilidad.",
				title: "Acceso ilegítimo a los datos"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Ingrese los posibles impactos",
						title: "Lo que podría ser los impactos principales sobre los temas de datos si el riesgo se produce?"
					},
					"2": {
						placeholder: "Ingrese las amenazas",
						title: "¿Cuáles son las principales amenazas que podrían conducir al riesgo?"
					},
					"3": {
						placeholder: "Ingrese las fuentes de riesgo",
						title: "¿Cuáles son las fuentes de riesgo?"
					},
					"4": {
						placeholder: "Haga clic aquí para seleccionar controles que aborden el riesgo.",
						title: "¿Cuál de los controles identificados contribuyen a abordar el riesgo?"
					},
					"5": {
						placeholder: "Justifique aquí la gravedad estimada del riesgo.",
						title: "¿Cómo calcula la severidad del riesgo, especialmente de acuerdo con los impactos potenciales y los controles planificados? "
					},
					"6": {
						placeholder: "Justifique aquí la probabilidad estimada.",
						title: "¿Cómo calcula la probabilidad, especialmente con respecto a las amenazas, las fuentes de riesgo y los controles planificados?"
					}
				},
				short_help: "Analizar las causas y consecuencias de un cambio no deseado en los datos, y estimar su gravedad y la probabilidad",
				title: "Modificación no deseada de los datos"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Ingrese los posibles impactos",
						title: "¿Cuáles podrían ser los principales impactos en los sujetos de los datos si ocurriera el riesgo?"
					},
					"2": {
						placeholder: "Ingrese las amenazas",
						title: "¿Cuáles son las principales amenazas que podrían conducir al riesgo?"
					},
					"3": {
						placeholder: "Ingrese las fuentes de riesgo",
						title: "¿Cuáles son las fuentes de riesgo?"
					},
					"4": {
						placeholder: "Haga clic aquí para seleccionar controles que aborden el riesgo.",
						title: "¿Cuáles de los controles identificados contribuyen a abordar el riesgo?"
					},
					"5": {
						placeholder: "Justifique aquí la gravedad estimada del riesgo.",
						title: "¿Cómo calcula la severidad del riesgo, especialmente de acuerdo con los impactos potenciales y los controles planificados?"
					},
					"6": {
						placeholder: "Justifique aquí la probabilidad estimada.",
						title: "¿Cómo calcula la probabilidad de <abarcan clase = 'green-highlight'> del riesgo </span>, especialmente con respecto a las amenazas, las fuentes de riesgo y los controles planificados? "
					}
				},
				short_help: "Analiza las causas y consecuencias de la pérdida de datos, y estima su seriedad y probabilidad",
				title: "Desaparición de datos"
			},
			"5": {
				short_help: "Esta visualización le permite tener una visión global y sintética de los efectos de los controles sobre los riesgos que abordan.",
				title: "Resumen de riesgos"
			}
		},
		short_help: "Esta sección le permite evaluar los riesgos de privacidad, teniendo en cuenta los controles existentes o planificados.",
		title: "Riesgos"
	},
	"4": {
		items: {
			"1": {
				short_help: "Esta visualización le permite comparar el posicionamiento de los riesgos entre ellos, antes y después de la aplicación de los controles complementarios.",
				title: "Mapeo de riesgos"
			},
			"2": {
				short_help: "Planifique en detalle la implementación de los controles adicionales identificados durante el PIA. El plan de acción se actualiza automáticamente al evaluar los diferentes elementos incluidos en el PIA.",
				title: "Plan de acción"
			},
			"3": {
				short_help: "Presentar el asesoramiento de la persona encargada de la protección de datos y privacidad (delegado de protección de datos si es que existe) Presentar los puntos de vista de los interesados o de sus representantes.",
				title: "DPO y opiniones de personas interesadas"
			},
			"4": {
				title: "Validar el PIA"
			},
			"5": {
				title: "PIA Rechazado"
			}
		},
		short_help: "Esta sección le permite preparar y formalizar la validación de PIA.",
		title: "Validación"
	}
};
var settings$g = {
	content: "Proporcione la dirección (URL) del servidor remoto:",
	title: "Configuración ",
	update: "Actualizar URL"
};
var summary$g = {
	action_plan: {
		fundamental_principles: "Principios fundamentales",
		implementation_date: "Fecha esperada de implementación",
		implementation_responsible: "Responsable de la implementación",
		measures: "Existente o medidas previstas",
		no_action_plan: "No se ha registrado ningún plan de acción",
		risks: "Riesgos",
		title: "Plan de acción"
	},
	actions: {
		complete_download: "Descargar el informe completo",
		complete_download_desc: "Exporar a un archivo .zip todo el contenido del informe (.doc e imágenes), adjuntos y el plan de acción en formato .csv.",
		individual_download: "Descarga elementos del informe",
		individual_download_desc: "Exporta elementos específicos del informe.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "Textos (.doc)",
		individual_download_images: "Elementos visuales (.png) incluyendo resumen de riesgos, mapa de riesgos y plan de acción.",
		individual_download_json: "Informe para importar en la herramienta PIA (fichero .json)",
		individual_download_select: "Selecciona elementos a exportar:",
		individual_to_download: "Descarga",
		print: "Imprimir el informe",
		print_and_download: "Imprimir y descargar"
	},
	attachments: "Adjuntos",
	concerned_people_name: "Opiniones en cuestión de la gente",
	concerned_people_opinion: "Opiniones en cuestión de la gente",
	concerned_people_searched_opinion: "Búsqueda de la opinión en cuestión de la gente",
	concerned_people_status: "Estados en cuestión de la gente",
	concerned_people_unsearched_opinion_comment: "Razone por las que una opinión en cuestión de la gente no fue pedida",
	content_choice: [
		"El tratamiento no debería utilizarse.",
		"El tratamiento podría ser puesto en ejecución."
	],
	creation_date: "Fecha de creación",
	csv_action_plan_comment: "Comentario sobre el plan de acción",
	csv_evaluation_comment: "Comentario sobre la evaluación",
	csv_file_title: "Plan de acción",
	csv_implement_date: "Fecha estimada de implementación",
	csv_people_in_charge: "Persona responsable",
	csv_section: "Sección",
	csv_title_object: "Título",
	download_csv: "Plan de acción (.csv)",
	dpo_name: "Nombre de DPO",
	dpo_opinion: "Opinión de DPO",
	dpo_status: "Estado de DPO",
	gauges: {
		"1": "Insignificante",
		"2": "Limitado",
		"3": "Importante",
		"4": "Máximo"
	},
	modification_made: "Modificaciones hechas",
	people_search_status_nok: "No se solicitó la opinión de las personas interesadas.",
	people_search_status_ok: "Se solicitó la opinión de las personas interesadas.",
	pia_assessor: "Nombre del asesor",
	pia_author: "Nombre del autor",
	pia_name: "PIA",
	pia_validator: "Nombre del validador",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Volver a la página anterior",
	rejection_reason: "Razón del rechazo",
	revision: {
		current_version: "Versión actual",
		pia_version: "Versiones AIIA",
		restore_version: "Restaurar esta version",
		revision: "Versiones and revisión",
		save: "Crear una nueva version",
		show: "Mostrar {{length}} versiones"
	},
	risks_cartography_title: "Mapa de riesgos",
	risks_overview_title: "Resumen de riesgos",
	title: "Información del PIA"
};
var users$g = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$g = {
	add_signed_pia: "Agregue el PIA firmado",
	after_reading: "Después de leer el PIA completo relacionado con el tratamiento de datos vinculado a ",
	button: {
		rejection: "Rechazar AIIA",
		signed_validation: "Aprobar PIA <br> (firmado)",
		simple_validation: "Aprobar PIA <br> (directo)"
	},
	confirmation1: "Doy fe de que el contexto del tratamiento descrito en el PIA es consistente con la realidad",
	confirmation2: "Doy fe de que soy consciente de los riesgos dependiendo de las medidas existentes o planificadas.",
	confirmation3: "Ratifico las acciones correctivas indicadas en el plan de acción.",
	confirmation4: "Me comprometo a implementar lo más rápido posible las acciones correctivas indicadas.",
	latest_signed_attachment: "Último archivo adjunto firmado",
	mandatory_fields: "Todas las casillas deben estar marcadas",
	remove_attachment: "Eliminar el archivo adjunto",
	responsible: "Persona responsable de validar el PIA: ",
	signed_attachments_history: "Historial de archivos adjuntos firmados",
	tools: {
		dashboard: "Tablero",
		display_pia: "Mostrar informe"
	},
	validated_pia_with_signature: "Aprobado",
	waiting_for_signature: "Pendiente de PIA firmado"
};
var es = {
	about: about$g,
	action_plan: action_plan$g,
	authentication: authentication$g,
	cartography: cartography$g,
	comments: comments$g,
	conflict: conflict$g,
	date: date$g,
	errors: errors$g,
	evaluations: evaluations$g,
	header: header$g,
	help: help$g,
	homepage: homepage$g,
	knowledge_base: knowledge_base$g,
	measures: measures$g,
	misc: misc$g,
	modals: modals$g,
	onboarding: onboarding$g,
	opinions: opinions$g,
	"overview-risks": {
	important: "Importante",
	limited: "Limitado",
	maximal: "Máximo",
	measures: "Medidas",
	negligible: "Insignificante",
	potential_impacts: "Impactos potenciales",
	"risk-access_x": "Gavedad",
	"risk-access_y": "Probabilidad",
	"risk-change_x": "Gravedad",
	"risk-change_y": "Probabilidad",
	"risk-disappearance_x": "Gravedad",
	"risk-disappearance_y": "Probabilidad",
	sources: "Fuentes",
	threat: "Amenaza"
},
	pia: pia$g,
	questions: questions$g,
	rejection_page: rejection_page$g,
	sections: sections$g,
	settings: settings$g,
	summary: summary$g,
	users: users$g,
	validation_page: validation_page$g
};

var about$f = {
	contribute: "Kui soovite panustada tarkvara eestikeelse tõlke paremaks tegemiseks soovitame lugeda<a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">, kus selgitatakse mida on vaja selleks teha</a>.",
	description: "Käesolev abivahend on loodud<a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, Prantsusmaa andmekaitse järelevalve asutus, abistamaks isikuandmete töötlemise vastavusse viimiseks Euroopa Liidu isikuandmete kaitse üldmääruse (EL) 2016/679 nõuetele ja nõuetele vastavuse tõendamiseks. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>See on vabavara. Kui soovite panustada projekti, siis olete teretulnud ja võite lähtekoodi allalaadida Github-ist ning täiendada ja jagada seda.",
	licences: "Raamatukogu litsents:",
	title: "Andmekaitse mõjuhinnangu tarkvarast",
	translators: "Tarkvara on hetkel saadaval 18 keeles. Prantsus- ja ingliskeelne versioon on loodud CNIL-i poolt. Tõlked teistesse keeltesse on tehtud järgnevate panustajate poolt:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Version number"
};
var action_plan$f = {
	acceptable_measures: "Vastuvõetavad meetmed",
	edit: "Redigeeri",
	improvable_measures: "Parandatavad meetmed",
	measures: "Kavandatavad või olemasolevad meetmed",
	no_action_plan: "Ükski tegevuskava pole registreeritud.",
	placeholder_person_in_charge: "Vastutav rakendamise eest",
	principles: "Põhiprintsiibid",
	risk1: "Ebaseaduslik juurdepääs andmetele",
	risk2: "Andmete soovimatu muutmine",
	risk3: "Andmete kadumine",
	risks: "Riskid",
	title: "Ülevaade"
};
var authentication$f = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Prantsusmaa andmekaitse järelevalveasutuse (CNIL) loodud tarkvara on mõeldud vastutava töötleja abistamiseks isikuandmete töötlemise vastavusse viimiseks  Euroopa Liidu isikuandmete kaitse üldmääruse nõuetele ja nõuetele vastavuse tõendamiseks. Tarkvara aitab läbi viia andmekaitsealase mõjuhinnangu hõlbustades kasutades CNIL’i poolt loodud metoodikat",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Alusta",
	start_app: "Juurdepääs mõjuhinnangu tarkvarale (Beta)",
	subtitle1: "Platvorm mõjuhinnangu loomiseks <br> ja haldamiseks",
	subtitle2: "Juurdepääsu tööriistad ja sõnastik",
	title: "Andmekaitsealane mõjuhinnang",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$f = {
	important: "Oluline",
	legend1: "Kavandatavad või olemasolevad meetmed",
	legend2: "Rakendatud parandusmeetmetega",
	legend3: "(E)baseaduslik juurdepääs andmetele",
	legend4: "((A)ndmete soovimatu muutmine",
	legend5: "(A)ndmete kadumine",
	likelihood_axe: "Riski tõenäosus",
	limited: "Piiratud",
	maximal: "Maksimaalne",
	negligible: "Ebaoluline",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Riski tõsidus"
};
var comments$f = {
	comment: "Kommentaar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "kommentaari",
	new_comment: "Kommentaar",
	placeholder_new_comment: "Sisesta kommentaar",
	send: "Saada"
};
var conflict$f = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$f = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$f = {
	content: "Kui teil tekib muid probleeme või kui teil on soovitusi, <br>võite need saata järgneva vormi kaudu: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Lehekülge ei leitud."
};
var evaluations$f = {
	acceptable: "Vastuvõetav",
	action_plan_comment: "Tegevuskava / parandavad meetmed",
	evaluation_comment: "Hindaja kommentaar",
	gauges: {
		"0": "(Määratlemata)",
		"1": "Ebaoluline",
		"2": "Piiratud",
		"3": "Oluline",
		"4": "Maksimaalne",
		likelihood: "Arvestades tegevuskava, kuidas Te hindaks ümber <span class='red-highlight'>riski tõenäosust</span>?",
		seriousness: "Arvestades tegevuskava, kuidas Te hindaks ümber <span class='red-highlight'>riski tõsidust</span>?"
	},
	improvable: "Parandatav",
	placeholder_acceptable: "Arvestades olemasolevat teavet on rakendatud meetmed kohased tagamaks andmeturve.",
	placeholder_improvable1: "Arvestades olemasolevat teavet on vaja rakendada täiendavaid meetmeid tagamaks andmeturve.",
	placeholder_improvable2: "Sisesta kommentaar.",
	placeholder_to_correct: "Esitatud teabest ei piisa hinnangu andmiseks. Saada täiendamiseks koostajale tagasi.",
	status: [
		"Ootel",
		"Saadetud täiendamiseks",
		"Täiendatava",
		"Vastuvõetav"
	],
	title: "Hinnang",
	to_correct: "Saadetud täiendamiseks"
};
var header$f = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Mõjuhinnangu näidis",
		title: "Abi"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Teadmiste pagas",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "CNIL’i  esitatud tõlge",
		community_translations: "Kogukondade tehtud tõlked",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Järelvalveasutuse kontrollitud tõlge",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Originaal versioon",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Andmekaitsealane mõjuhinnag",
	structures: "Vormid",
	tools: {
		about: "Tarkvarast",
		accessibility: "Vaegnägijale",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Seaded",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$f = {
	definition: {
		data1: {
			content: "Sisu lisatakse",
			title: "Kasuta mõjuhinnangu abivahendit"
		},
		data2: {
			qa1: {
				content: "Nende kuvamise probleemide puhul sulgege rakendus ja avage uuesti. See tavaliselt parandab vea. Teave ei lähe kaotsi, sest see salvestatakse sisestamisel automaatselt.",
				title: "Kuvamisprobleemid. N: ikoonid ei avane või liideses puuduvad elemendid"
			},
			qa2: {
				content: "Praeguseks parandatud. Probleemi tekkimisel soovitame põhjenduste märkida lahtrisse hinnanguline tõsiduse ja / või tõenäosuse tase. Saate mõõte muuta pärast vea parandamist.",
				title: "Ma ei saa muuta mõõte riski tõsiduse ja tõenäosuse hindamiseks"
			},
			qa3: {
				content: "Mõjuhinnangu importimisel on ilmnenud mitmed vead. Näiteks improtimisel kaovad riskide tõsiduse või tõenäosuse muudatused. Sellisel juhul soovitame põhjenduste märkida lahtrisse hinnanguline tõsiduse ja / või tõenäosuse tase. Saate mõõte muuta pärast vea parandamist. Samuti võib mõjuhinnang peale importimist mitte ilmuda töölauale. Sellisel juhul värskendage lehekülge.",
				title: "Probleemid mõjuhinnangu importimisel"
			},
			qa4: {
				content: "See on ainult kuvamise viga ja ei mõjuta teksti sisestamist. Viga on parandamisel.",
				title: "Kopeerimisel / kleepimisel tõstetakse tekst esile."
			},
			qa5: {
				content: "Sektsiooni hindamisel pevad olema kõik lahtrid täidetud. Palun kontrollige kas on. Riskide toimetamisel peab olema vähemalt üks tehniline või organistasiooniline mõõde sisestatud, et seda saaks hinnata.",
				title: "Ma ei saa sektsiooni hinnata "
			},
			qa6: {
				content: "Sulgege toimetamisel olev mõjuhinnang ja avage uuesti. Mõjuhinnang peaks nüüd avanema valitud keeles.",
				title: "Keele vahetamisel see ei muutu"
			},
			qa7: {
				content: " Hetkel navigeerimismenüü ikoone ei värskendata peale mõjuhinnagu tagasilükakmist. Tuleb kontrollida iga sektsiooni ja muuta teavet ja/või hinnangu, mis põhjustasid mõjuhinnangu tagasilükamise. Peale seda on uuesti võimalik uuesti otustada mõjuhinnangu kinniatamine.",
				title: "Ei kinnitanud mõjuhinnagut. Kuidas seda muuta?"
			},
			title: "Teadaolevad probleemid"
		},
		footer: "Ettepanekud ja probleemi kirjeldused palun sisetage siia <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Abi"
};
var homepage$f = {
	cards: {
		author: "Toimeta",
		category: "TO TRANSLATE - Category",
		creation_status: "Loomine",
		date: "Kuupäev",
		evaluation: "Ülevaade",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Impordi mõjuhinnang",
		import_structure: "Impordi mõjuhinnang",
		item: {
			consult_pia: "TO TRANSLATE - Consult",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "TO TRANSLATE - Edit",
			edit_structure: "Toimeta mõjuhinnagut",
			tools: {
				action_plan: "Näita<br>tegevuskava",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Dubleeri",
				"export": "Ekspordi",
				more_options: "Rohkem valikuid",
				pia: "Näita<br>mõjuhinnagut",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Uus mõjuhinnag",
		new_structure: "Uus mõjuhinnag",
		or: "või",
		pia_name: "Mõjuhinnang",
		placeholder_author: "Eesnimi, perenimi",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Eesnimi, perenimi",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Impordi mõjuhinnang",
		placeholder_import_structure: "Impordi mõjuhinnang",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Uus mõjuhinnag",
		placeholder_new_structure: "Uus mõjuhinnag",
		placeholder_pia_name: "Pealkiri",
		placeholder_sector_name: "Isikuandmete töötlemissektor",
		placeholder_start: "Kõik väljad peavad olema täidetud",
		placeholder_structure: "Mõjuhinangu põhi",
		placeholder_structure_name: "Põhja nimi",
		placeholder_validation: "Eesnimi, perenimi",
		sector_name: "Kaasatud sektor",
		start: "Alusta",
		status: "Seisund",
		structure: "Põhi",
		structure_name: "Põhja nimi",
		title_close_creation: "Sulge",
		validation: "Kinnitamine"
	},
	filters: {
		assessor: "Hindaja",
		author: "Läbiviija",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "<br><br>uue alustamiseks vajuta Uus mõjuhinnag",
		card_rocket_content_structure: "<br><br>Alustamiseks<br>vajutage<br> nuppu +",
		category: "TO TRANSLATE - Category",
		date: "Kuupäev",
		import_pia: "Impordi mõjuhinnang",
		import_structure: "Impordi mõjuhinnang",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Uue <br>alustamiseks vajuta +",
		list_rocket_content_structure: "Alustamiseks<br>vajutage nuppu +",
		name: "Nimi",
		new_pia: "Uus mõjuhinnang",
		new_structure: "Uus mõjuhinnang",
		sector_name: "Kaasatud sektor",
		sort: "Sorteeri",
		sort_by: "Sorteerimis valikud",
		status: "Seisund",
		validator: "Kinnitaja"
	},
	lists: {
		column_actions: "Tegevused",
		column_author: "Toimetamine",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Loodud",
		column_evaluation: "Ülevaade",
		column_pia: "Mõjuhinnang",
		column_progression: "Kulg",
		column_sector_name: "Kaasatud sektor",
		column_status: "Seisund",
		column_structure: "Põhi",
		column_structure_name: "Põhi",
		column_updated_at: "Viimati avatud",
		column_validation: "Kehtivus",
		item: {
			tools: {
				action_plan: "Näita tegevuskava",
				archive: "TO TRANSLATE - Archive",
				consult: "Konsulteeri",
				duplicate: "Dubleeri",
				edit: "Toimeta",
				"export": "Ekspordi",
				pia: "Näita mõjuhinnagut",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$f = {
	add_measure: "Lisa",
	add_measure_hint: "Võid lisada meetmee ka teadmiste pagasist.",
	category: {
		definition: "Mõisted",
		example: "Näide",
		general_measure: "Füüsiline turbekontroll",
		measure_on_data: "Loogiline turbekontroll",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Organisatsiooniline kontroll",
		principle: "Põhimõte"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Kõik",
		definitions: "Mõisted",
		general_measures: "Füüsiline turbekontroll",
		measures_on_data: "Loogiline turbekontroll",
		no_result: "Vasted puuduvad.",
		organizational_measures: "Organisatsiooniline kontroll",
		title: "Filtrid"
	},
	placeholder_add_measure: "Lisa see meede",
	placeholder_help: "Sisestamise abivahend",
	search: "Otsi",
	slugs: {
		PIA_DEF_ACC: {
			description: "Andmesubjektil on õigus saada vastutavalt töötlejalt kinnitust selle kohta, kas teda käsitlevaid isikuandmeid töödeldakse, ning sellisel juhul tutvuda isikuandmete ja järgneva teabega <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 15</a>",
			name: "Õigus tutvuda andmetega",
			source: "Üldmääruse 2016/679 Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Protsess, mis eemaldab identifitseeritavad omadused isikuandmetelt. Protsessi robsustsuse hindamiseks vt <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 juhised</a>.",
			name: "Anonüümsus",
			source: "WP29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Protseduurid, mis säilitavad ja haldavad elektroonilisi arhiive, mis sisaldavad nende väärtust tagavaid isikuandmeid (eriti õiguslikku väärtust) kogu vajaliku perioodi vältel (ülekandmine, hoiustamine, migratsioon, ligipääs, eemaldamine, arhiveerimispoliitika, konfidentsiaalsuse kaitse, jne).",
			name: "Arhiveerimine",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Kõik ligipääsuga isikuandmetele (töötajad, lepingupooled ja kolmandad isikud) õigustatud isikud peaksid olema tuvastatud ainulaadse tuvastaja poolt. Vali autentimise meetod, et avada sessioonid, mis on konteksti, riski taset ja eeldatavat robustsust arvesse võttes sobivad. Soovitused: kui ei esine kõrgendatud riske võib kasutada salasõna; kuid, kui riskid on kõrgemad tuleb kasutada ühekordset salasõna ning tuleb vaikimisi muuta aktiveerimissalasõna, samuti kui osa salasõnast saadetakse SMS-iga, kaart koos PIN koodiga, elektrooniline sertifikaat või ükskõik milline teine tugev autentimise meede.",
			name: "Autentimine",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Meede, mis muudab isikuandmed juurdepääsuõiguseta isikule loetamatuks (sümmeetriline või asümmeetriline krüpteerimine, teadaolevalt tugevate avalike algoritmide kasutamine, autentimise tõend, jne.).",
			name: "Krüpteerimine",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Andmehaldusmeetodid, mis vähendavad isikuandmete korreleerimisvõimalust, seeläbi vähendades kõigi isikuandmete rikkumist. Näiteks tuvastades isikuandmed, mis on vajalikud ainult kindlaks äriprotsessiks ning eraldades need loogiliselt.",
			name: "Andmete eraldamine",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Iga vabatahtlik, konkreetne, teadlik ja ühemõtteline tahteavaldus, millega andmesubjekti kas avalduse vormis või selge nõusolekut väljendava tegevusega nõustub tema kohta käivate isikuandmete töötlemisega.<br>Vt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 4.10</a>",
			name: "Nõusolek",
			source: "Üldmääruse 2016/679Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Meetmed, mida rakendatakse selleks, et piirata volitamata isikute elektroonilist juurdepääsu isikuandmetele, mis nõuab mh järgnevat : <br>- <strong>kasutajate profiilide haldamist</strong> ülesannete erladamist vastutusaladest (eelistatavalt tsentraliseeritult), et võimaldada ainult volitatud kasutajatele ligipääs isikuandmetele kohaldades vajalikke põhimõtteid;<br>- <strong>tühistada töötajate, lepinguosaliste ja kolmandate isikute õigused, kui neil enam ei ole õigust pääseda ligi teatud valdustele ja ressurssidele </strong> või kui nende <strong>tööleping on lõppenud</strong>.",
			name: "Loogiline juurdepääsu kontroll",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Igasugune teave, mis on seotud tuvastatud või tuvastatava füüsilise isikuga ('andmesubjekt'); tuvastatav isik on see, keda saab tuvastada, otseselt või kaudselt, eelkõige viitega identifikaatorile nagu nimi, isikukood, asukohanamded, tuvastusnumber arvutivõrgus või ühe või rohkem kui ühe faktori, mis on spetsiifiline selle füüsilise isiku füüsilisele, psühholoogilisele, geneetilisele, vaimsele, majanduslikule, kultuurilisele või sotsiaalsele identiteedile. <br>Vaata <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 4.1 </a>",
			name: "Isikuandmed",
			source: "Üldmääruse 2016/679 art. 4.1"
		},
		PIA_DEF_DEST: {
			description: "Füüsiline või juriidiline isik, riigiasutus, amet või muu üksus, millele isikuandmeid avaldatakse kas kolmanda isikuna või mitte. Vaatmata sellele, riigiasutust, mis saab isikuandmeid konkreetse päringu raames kooskõlas Euroopa Liidu liikmesriigi õigusega, ei loeta vastuvõtjaks; selle teabe käitlus selle riigiasutuse poolt peab olema vastavuses kohalduvate andmekaitsereeglitega tulenevalt andmete käitluse eesmärkidest. <br>Vaata <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=E\">Üldmääruse 2016/679 Art. 4.9 </a>",
			name: "Vastuvõtja",
			source: "Üldmääruse 2016/679 art. 4.9"
		},
		PIA_DEF_EFF: {
			description: " Andmesubjektil on õigus nõuda, et vastutav töötleja kustutaks põhjendamatu viivituseta teda puudutavad isikuandmed ja vastutav töötleja on kohustatud kustutama isikuandmed põhjendamatu viivituseta, vt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 17 </a>",
			name: "Õigus andmete kustutamisele",
			source: "Üldmääruse 2016/679 Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Eeldatav kasu (organisatsioonile, andmesubjektidele, ühiskonnale üldiselt, jne.).",
			name: "Panused",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Isikuandmed peavad olema õiged ja kui vajalik kaasajastatud; tarvitusele peab olema võetud kõik mõistlikud meetmed, et ebaõiged andmed oleks viivituseta eemaldatud või parandatud lähtudes andmete käitluse eesmärgist (õigsus). <br>Vaata <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\"> üldmääruse 2016/679 art. 5.1 d)</a>",
			name: "Andmete kvaliteet",
			source: "Üldmääruse art.5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Tõsidus kujutab endast riski ulatust. See sõltub eelkõige potentsiaalsete mõjutajate kahjulikust iseloomust.",
			name: "Tõsidus",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Andmesubjektil on õigus nõuda vastutavalt töötlejalt isikuandmete töötlemise piiramist, vt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 18 </a>",
			name: "Õigus andmete töötlemise piiramisele",
			source: "Üldmääruse 2016/679 Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Seadista logimissüsteem, mis võimaldab isikuandmetega seotud juhtumite varajast avastamist ning saada teavet, mida saab kasutada selliste juhtumite analüüsimisel või tõendeid uurimistegevuse jaoks esitada.",
			name: "Järelevalve",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Protseduur, mis hõlmab ühe või enama isiku toimingut andmeid toetavate vahendite kohta. Seda kasutatakse tahtlikult või muul viisil riskiallikate abil ning võib põhjustada välditava sündmuse.",
			name: "Ähvardavad ohud",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Ohud seoses: - <strong>riistvaraga</strong>, mida kasutatakse sobimatult, mida jälgitakse, muudetakse või on kaotsi läinud (tundliku riistvara transportimine või kasutamine isiklikuks otstarbeks, teise isiku isikliku ekraani vaatamine ilma tema teadmata rongil viibides, jälgimine riistvaralise keylogger-iga, jne.)<br> - <strong>tarkvara</strong>, mida kasutatakse sobimatult, mida jälgitakse või muudetakse (privileegide tõstmine, konfiguratsiooniandmete kogumine, nakatamine pahatahtliku koodi poolt jne.)<br>- <strong>Arvuti kanalid</strong>, mida jälgitakse (Etherneti liikluse pealtkuulamine jne.)<br>- <strong>Inimese</strong>, keda jälgitakse, manipuleeritakse või kes kaovad (informatsiooni tahtmatu avalikustamine, sotsiaaltehnoloogia, ülesannete muutused)<br>- <strong>Dokumendid paberil</strong> mida jälgitakse või lähevad kaotsi (seoses meili vargusega, jne.)<br>- <strong>Paberi ülekande kanalid</strong> mida jälgitakse (ringluses olevate allkirjaartiklite lugemine, jne.)",
			name: "Ohud, mis võivad viia ebaseadusliku ligipääsuni",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Ohud seoses : </strong><br>- <strong>riistvaraga</strong> : mida kasutatakse sobimatult, koormatakse üle, muudetakse, kahjustatakse või mis lähevad kaotsi (ladustamisüksus on täis, töötlemisvõimsus on ülekoormatud, ühildumatu riistvara lisamine, mis põhjustb rikkeid, tulekahju, vahendi vargus või kaotsiminek, jne.)<br>- <strong>tarkvara</strong> : mida kasutatakse sobimatult, mis on ülekoormatud, muudetud, kahjustatud või kaotsi läinud (andmete kustutamine, andmebaasi suuruse ületamine, loogikapomm, andmete litsentsimiseks kasutatava tarkvara loa uuendamata jätmine, jne.)<br>- <strong>arvuti kanalid</strong> : mis on ülekoormatud, muudetud või kaotsi läinud (volitamata allalaadimine, interneti ühenduse kadumine, jne.)<br>- <strong>inimesed</strong> : kes on ülekoormatud, kahjustatud või kaotsi läinud (oskuste halb rakendamine, haigused, pensionile jäämine, jne.)<br>- <strong>paberdokumendid</strong> : mida on sobimatult kasutatud, mis on kahjustunud või kaotsi läinud (kustutamine, arhinveeritud dokumentide vananemine, dokumentide vargus või kaotsi minek, jne.)<br>- <strong>Paberi ülekande kanalid</strong> : mis on ülekoormatud, muudetud või kaotsi läinud (meilie kättetoimetamise peatamine streigi tõttu, kontorite või ruumide ümberpaigutamine, dokumente kättetoimetava ettevõtte kaotamine, paberkanalite ümberkorraldamine, jne.)",
			name: "Ohud, mis võivad kaasa tuua isikuandmete kadumise",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Ohud seoses : </strong><br>- <strong>riistvaraga</strong>, mida on muudetud (ühildumatu riistvara lisamine, mis põhjustab rikkeid, oluliste komponentide eemaldamine, jne.)<br>- <strong>tarkvara</strong>, mida kasutatakse sobimatult või muudetakse (andmebaasis olevate andmete soovimatud muudatused, operaatorivead, mis muudavad andmeid, jne.)<br>- <strong>arvuti kanalid</strong>, mida kasutatakse sobimatult (katkestatud andmete edasisaatmine, jne.)<br>- <strong>inimesed</strong>, kes on ülekoormatud või manipuleeritud (töötajatele ülesannete jagamine, mis ületavad töötajate võimeid, stress või negatiivsed muutused töötingimustes, mõjutused, jne.)<br>- Paberdokumendid, mida on muudetud (failis olevate arvude muutmine, originaali asendamine võltsinguga, jne.)<br>- <strong>Paberi ülekande kanalid</strong> mida on muudetud (muutus ühelt allkirja raamatult teisele, mitme vastuolulise dokumendi saatmine, jne.)",
			name: "Ohud, mis võivad viia isikuandmete soovimatu muutmiseni",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Valige \"Kavandatavad või olemasolevad meetmed\"osast etteantud meetmete hulgast, kuhu saate juurde lisada kui see peaks olema vajalik.",
			name: "Meetmed",
			source: "Puudub"
		},
		PIA_DEF_MIN1: {
			description: "Andmeid importides võidakse tahtmatult koguda metaandmeid (nt EXIF andmeid koos lisatud pildifailiga). <br>Sellised metaandmed tuleb identifitseerida ja eemaldada, kui need ei ole põhitegevuse otstarbeks vajalikud.",
			name: "Filtreerimine ja eemaldamine",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Kui tundlikud andmed on saadud üldise teabe seeria osana või edastatud üksnes statistilisteks eesmärkideks, on võimalik neid konverteerida vähem tundlikusse vormi või pseudonümiseerida. Näiteks : <br>- kui süsteem kogub IP-aadressi kasutaja asukoha kindlaksmääramiseks statistilisel eesmärgil, saab IP-aadressi kustutada pärast linna või piirkonna tuvastamist<br>- kui süsteem tunnustab vidoematerjali valvekaameratest, tunneb ta ära inimesed, kes seisavad või liiguvad pildil ning saab need hägustada<br>- kui süsteem on arukas mõõtja saab ta kokku koguda energiakulu teatud aja jooksul seda reaalajas salvestamata",
			name: "Tundlikkuse vähendamine läbi konverteerimise ",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Süsteem saab kindlustada, et : <br>- kasutaja saab kasutada ressurssi või teenust ilma riskita oma identiteeti avalikustada (anonüümsed andmed)<br>- kasutaja saab kasutada ressurssi või teenust ilma riskita oma identiteeti avalikustada, kuid võib olla tuvstatav ja vastutav selle kasutamise eest (pseudonüümsed andmed)<br>- kasutaja saab ressursse või teenuseid mitmel otstarbel kasutada ilma riskita, et neid erinevaid kasutusviise oleks võimalik omavahel siduda (andmeid ei saa korreleerida)<br>- kasutaja saab kasutada ressurssi või teenust ilma ohuta, et keegi teine eelkõige kolmandad isikud saaksid jälgida, et ressurssi või teenust kasutatakse (mitte-jälitavus)<br>Eespool loetletud meetodi valik tuleb teha tuvastatud ohtude põhjal. Mõne ohu puhul eraelu puutumatusele on pseudonümiseerimine sobivam kui anonüümseks muutmine (nt, kui on vajadus jälgida tegevusi). Lisaks käsitletakse mõnda ohtu eraelu puutumatusele meetodeid kombineerides.",
			name: "Andmete identifitseeritava olemuse vähendamine",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Süsteemi saab jagada eraldiseisvateks osadeks eraldi juurdepääsuga kontrolli funktsioonidele. Andmeid saab ka jagada iseseisvate allsüsteemide vahel ja kontrollida iga allsüsteemiga kasutades erinevaid juurdepääsu kontrollmehhanisme. Kui allsüsteem on ohustatud, siis võib väheneda mõju ülejäänud andmetel.",
			name: "Andmete kogumise vähendamine",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Süsteem saab piirata juurdepääsu vastavalt \"vaja teada\" põhimõttele. Süsteem saab eristada tundlikud andmed ning rakendada konkreetseid juurdepääsu kontrollimise eeskirju. Süsteem saab ka krüpteerida tundlikud andmed, et kaitsta nende konfidentsiaalsust edastamise ja salvestamise vältel. Samuti tuleb kaitsta juurdepääs andmetöötluse käigus toodetud ajutistele küpsistele.",
			name: "Andmetele juurdepääsu piiramine",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Vähenda riskide tõsidust vähendades ka isikuandmete kogust rangelt vajalikuni, et saavutada määratletud eesmärk. Vastasel juhul  andmeid ei koguta.",
			name: "Isikuandmete koguse vähendamine",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Vähenda riskide tõsidust vähendades andmeid, võttes meetmeid, mis on suunatud andmete tundlikuse vähendamisele nagu filtreerimine ja ebavajalike andmete eemaldamine, andmete pseudonümiseerimine jne.",
			name: "Andmete vähendamine",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Andmesubjektil on õigus oma konkreetsest olukorrast lähtudes esitada igal ajal vastuväiteid teda puudutavate isikuandmete töötlemise suhtes, vastavalt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 21 </a>",
			name: "Õigus esitada vastuväiteid",
			source: "Üldmääruse 2016/679 Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Meetmed, mis on võetud isikuandmete kaitse integreerimiseks kõikidesse uutesse töötlemistoimingutesse (usaldatud nimed, juhised, riskijuhtumise metoodika või muu sisemine metoodika).",
			name: "Projekti juhtimine",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Isikud, kellega seonduvad töödeldavad andmed.",
			name: "Andmesubjekt",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " Andmesubjektil on õigus saada teda puudutavaid isikuandmeid, mida andmesubjkt on vastutavale töötajale esitanud, struktureeritud, üldkasutavas vormingus ning masinloetaval kujul ning õigus edastada need andmed teisele vastutavale töötlejale, ilma et vastutav töötleja, kellele kõnealused isikuandmed on esitatud, seda takistaks, vt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 20 </a>",
			name: "Andmete ülekandmise õigus",
			source: "Üldmääruse 2016/679 Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Isikuandmete töötlemine sellisel viisil, et isikuandmeid ei saa enam täiendavat teavet kasutamata seostada konkreetse andmesubjektiga, tingimusel et sellist täiendavat teavet hoitakse eraldi ja andmete tuvastatud või tuvastatava füüsilise isikuga seostamise välitmiseks võetakse tehnilisi ja korralduslikke meetmeid.<br>Pseudonümiseerimine vähendab andmestiku seostatavust andmesubjekti esialgse identiteediga. Sellisena on pseudonümiseerimine kasulik turvameede, kuid mitte anonüümseks muutmise meetod.",
			name: "Pseudonümiseerimine",
			source: "Üldmääruse 2016/679 Art. 4.5 and WP29 juhise p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Salasõnad koosnevad vähemalt minimaalsest etteanutd tähemärkide hulgast; peavad olema uuendatud kui esineb kahtlus, et nad võivad olla ohustatud ja võimaluse korral perioodiliselt (iga kuue kuu tagant või kord aastas) ning peavad sisaldama vähemalt kolme tähmärki neljast sordist (suurtähed, väiketähed, numbrid ja erilised tähemärgid); kui salasõna muudetakse ei tohi viimaseid viit salasõna taaskasutada; sama salasõna ei tohi kasutada erinevate ligipääsude puhul; salasõnad ei tohiks olla seotud isiku isiklike andmetega (st nimi või sünniaasta). Määratle maksimaalne katsete arv, mida ületades esineb hoiatus ning autentimise blokeerimine (ajutiselt või kuni blokeering manuaalselt eemaldatakse).",
			name: "Salasõna",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Andmesubjektil on õigus nõuda, et vastutav töötleja parandaks põhjendamatu viivituseta teda puudutavad ebaõiged isikuandmed. Võttes arvesse andmete töötlemise eesmärke, on andmesubjektil õigus nõuda mittetäielike isikuandmete täiendamist, sealhulgas täiendava õiendi esitamise teel.",
			name: "Õigus andmete parandamisele",
			source: "Üldmääruse 2016/679 Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Regulatsioon, mis käsitleb füüsiliste isikute kaitset seoses iskuandmete töötlemisega ja selliste andmete vaba liikumist ning direktiivi 95/46/EÜ kehtetuks tunnistamisega.",
			name: "Isikuandmete kaitse üldmäärus 2016/679",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Füüsiline või juriidiline isik, avalik-õiguslik isik, amet või muu üksus, kes üksi või koos teistega, määrab isikuandmete käitluse eesmärgid ja vahendid; kui eesmärgid ja vahendid selliseks käitluseks on määratud Euroopa Liidu liikmesriigi õigusega, siis revident või spetsiifilised tingimused tema nimetamiseks peavad olema määratud Euroopa liidu liikmestiigi õigusega.<br>Vaata <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 4.7 </a>",
			name: "Vastutav töötleja",
			source: "Üldmääruse 2016/679 art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Inimene või mitte-inimene, mis võib ohu luua. Selline allikas võib toimida tahtlikult või tahtmatult.",
			name: "Riski allikas",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Füüsiline või juriidiline isik, riigiasutus, esindus või muu organ, kes töötleb isikuandmeid vastutava töötleja nimel, vt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 of [GDPR]</a>.<br>Töötleja ja mistahes vastutav töötleja või töötleja alluvuses olev isik, kelle on juurdepääs isikuandmetele, ei töötle neid anmdeid kui vastutav töötleja ei ole andnud juhiseid ning juhul, kui see ei ole nõutav liidu või liikmesriigi õiguses , vt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">Üldmääruse 2016/679 Art. 29 </a>.",
			name: "Töötleja",
			source: "Üldmääruse 2016/679Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Vahendid, millest isikuandmete töötlemine sõltub. Need võivad olla riistvara, võrgud, inimesed, paber või paberi edasiandmise kanalid",
			name: "Toetavad vahendid",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Turvanõuete rikkumine, mille tulemuseks on isikuandmete tahtmatu või ebaseaduslik hävitamine, kadu, muutmine, volitamata avlikustamine või ligipääs isikuandmetele, mida hoitakse või töödeldakse.",
			name: "Isikuandmete töötlemise seotud rikkumine",
			source: "Üldmääruse 2016/679 Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Tõenäosuse väljendab riski tekkimise võimalikkust. See sõltub peamiselt toetava vara haavatavuse tasemest, kui see on ohus.",
			name: "Tõenäosus",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Hindamissüsteemi andmed....",
			name: "Arvestatud andmed"
		},
		PIA_EX_DCPC: {
			description: "<strong>Andmete tuvastamine</strong> : tsiviilstaatus, identiteet, vanus, jne. <br><strong>eraelu</strong> : elamisharjumused, perekonnaseis, jne. <br><strong>Kutseline elu</strong> : resümee, haridus ja professionaalne koolitus, auhinnad, jne. <br><strong>Ühendavad andmed </strong> : IP aadressid, sündmuste logid, jne.<br><strong>Asukoha andmed</strong> : reisid, GPS-i andmed, GSM andmed, jne.<br><strong>Muu</strong> : telefoni number, emaili aadress, jne.",
			name: "Ühised isikuandmed",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Filosoofilised- poliitilised- usu- ja ametiühingu vaated, seksuaalelu, terviseandmed, rassiline või etniline päritolu, andmed tervise või seksuaalelu kohta, süüteod, süüdimõistmised, julgeolekumeetmed, vt <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Süüdimõistmised ja eriliiki isikuandmed "
		},
		PIA_EX_DCPS: {
			description: "Isikukood, panga andmed jms",
			name: "Isikuandmed, mida peetakse tundlikuks "
		},
		PIA_EX_HUME: {
			description: "Need võivad olla:<br>- petlik või naiivne naaber, kes on füüsiliselt lähedal ja häkib seadme andmeid;<br>- häkker, kes sihib kasutajaid kasutades teadmisi kasutaja kohta ja kasutajat puudutavat informatsiooni;<br>- häkker, kes sihib ühte ettevõtet kasutades teadmisi ettevõtte kohta, mis võiksid ettevõtte mainet kahjustada;<br>- volitatud kolmanda osapoole ettevõte kasutab oma privilegeeritud juurdepääsu ebaseaduslikult teabele ligi pääsemiseks.",
			name: "Välised inimallikad"
		},
		PIA_EX_HUMI: {
			description: "Need võivad olla:<br>- hooletu või petlik töötaja, süsteemi lähedus, oskused, privileegid ja vaba aega on potentsiaalselt palju, koolituse ja teadlikkuse puudumine <br>- hooletu või petlik kasutaja, pereliige, kellel on juurdepääs teenusele.<br> Mitmed motiivid on võimalikud, sh : kohmakus, viga, hooletus, pahatahtlik kavatsus, kättemaks, luuramine.",
			name: "Sisemised inimallikad"
		},
		PIA_EX_IMPI: {
			description: "Andmesubjektid võivad kokku puutuda märkmisväärsete tagajärgedega, millede ületamine võib kujutada tõsiseid raskusi. Näiteks: <br>- füüsilised : tõsised füüslised tervishäired, mis põhjustavad pikaajalist kahju (tervise halvenemine sobimatu hoolduse või vastnäidustuste eiramise tõttu), kehalise puutumatuse riive ründe tagajärjel, õnnetus kodus, tööl jane.<br>- materiaalsed : varaline kaotus, kaotatud võimalused (laenust, õppimisvõimalustest, praktikast, töölevõtmisest, eksamile lubamisest keeldumine, elu- või töökoha kaotus jne.;<br>- mittevaralised : tõsised vimsed tervisehäired (depressioon, foobiate tekkimine või areng), pöördumatute kahjustustega eraelu riive tunen, väljapressimise, küberkiusamise või ahistamise ohvriks langemien jne.",
			name: "Oluline mõju"
		},
		PIA_EX_IMPL: {
			description: "Andmesubjektid võivad tunda märkimisväärset ebamugavust, millest nad saava üle vaatamata mõnedele raskustele. Näiteks:<br>- füüsilised : kerged füüsilised haigused vasunäidustuste eiramise tõttu, jms;<br>- materiaall : etenägematud maksed (ekslilult määratud tarhv), keeldumine haldus- või kommertsteenustest, soovimatud postiused, mis võivad kahjustada andmesubjekti mainet, jms;<br>- mittevaralised : väikesed kud objektiivsed psühholoogolised vaevused, privaatsuse riive tunne ilma pöördumatu kahjuta, hirmutamine sotsiaalvõrgustikes jms.",
			name: "Piiratud mõju"
		},
		PIA_EX_IMPM: {
			description: "Andmesubjektid võivad tunda märkimisväärseid või pöördumatuid tagajärgi, mida nad ei pruugi suuta ületada. Näiteks:<br>- füüsilised : pikaajalised või pöördumatud terviskahjustused, füüsilise puutumatuse püsiv halvenemine, surm;<br>- materiaalsed : finantsrisk, olulised võlad, võimatus töötada, võimatus ümberasuda, õigusnõudeks vajalike tõendite kaotamine, juurdepääsu kaotamine eluks vajalikule taristule (vesi, elekter), jms.<br>- mittevaraline : pikaajaline või krooniline psühholoogoline haigus, kriminaalkaristus, perekondlike sidemete kaotus, võiamtus pöörduda kohtusse, eestkoste õiguse kaotamine, jms.",
			name: "Maksimaalne mõju"
		},
		PIA_EX_IMPN: {
			description: "Andmesubjektid ei ole mõjutatud, võivad tekkida mõned ebamugavused, kuid neid saab ilma probleemideta lahendada .Näiteks:<br>- füüsilised : põgusad peavalud;<br>- materiaalsed : ajakaotus korrates formaalsusi või oodates nende täitumist, soovimatu posti saamine (nt.: spämm), sihitus reklaami eesmärgil veebilehtedel avaldatud andmete taaskasutamine , jne.;<br>- moraalsed : häirivus, tunne, et eraelu riivatakse ilma tegeliku või objektiivse kahjuta (kaubanduslik sissetung), jne.",
			name: "Ebaoluline mõju"
		},
		PIA_EX_NHUM: {
			description: "Intsidenti või kahju tekkimine organisatisoonis (elektrikatkestus, tulekahju, üleujutus, jne.)",
			name: "Mitte-inimallikad"
		},
		PIA_EX_VRAI: {
			description: "Riskiallikad võimaldavad ohtudel realiseeruda (N: dokumentide vargus büroost, kuhu saab siseneda ainult peale registreerimist).",
			name: "Oluline tõenäosus"
		},
		PIA_EX_VRAL: {
			description: "Riskiallikate puhul on raske näha ohu realiseerumist (N: dokumendi vargus ruumist, kuhu sissepääs on võimalik ainult personaalset sissepääsu vahendit, kiip või kaart, kasutades).",
			name: "Piiratud tõenäosus"
		},
		PIA_EX_VRAM: {
			description: "Riskiallikate puhul on lihtne näha ohu realiseerumist (N: dokumendi vargus piiramata sissepääsuga ruumist).",
			name: "Maksimaalne tõenäosus"
		},
		PIA_EX_VRAN: {
			description: "Riskiallikate puhul ei tundu ohu realiseerumine olla võimalik (N: dokumendi vargus ruumist, kuhu sissepääs on võimalik ainult personaalset sissepääsu vahendit, kaart või kiip, ja sissepääsu koodi kasutades).",
			name: "Vähene tõenäosus"
		},
		PIA_LGL_CONS: {
			description: "Võimalda andmesubjektil teha vabatahtlik ja teadvustatud valik. Tee kindlaks, kas töötlmine võib toimuda mõnel muul õiguslikul alusel, kui nõusolek. Vaata <a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art. 6.</a>",
			name: "Nõusolek",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Määratle ja kirjelda põhjalikult töötlemise ulatus:<br>- töödeldavad andmed, vastuvõtjad ja säilitamise kestus<br>- töötlemistoimingute ja andmekandjate kirjeldused kogu isikuandmete elutsükli jooksul (kogumisest kuni kustutamiseni).",
			name: "Andmed ja töötlemine",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Hinnatava töötlemise lühiülevaade, selle olemus, ulatus, sisu, eesmärk ja vajadus. Määratle vastutav töötje ja volitatud töötlejad. Töötlemisele kohaldatavad toimisjuhendid (Vaata < a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art. 40</a>) mis on vajalikud või kohustuslikud ja töötlemise sertifitseerimine toimisjuhendid (Vaata < a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art. 42</a>)",
			name: "Töötlemise kirjeldus",
			source: "Üldmääruse 2016/679 art. 42"
		},
		PIA_LGL_DEST: {
			description: "Füüsiline või juriidiline isik, avaliku sektori asutus, amet või muu organ, kellele isikuandmed avaldatakse, olenemata sellest, kas tegemist on kolmanda isikuga või mitte. Vastuvõtjaiks ei ole avaliku sektori asutused, kes võivad kooskõlas liidu või liikmesriigi õigusega saada isikuandmeid seoses konkreetse päringuga; nimetatud avaliku sektori asutused töötlevad kõnealuseid andmeid kooskõlas kohaldatavate andmekaitsenormidega vastavalt töötlemise eesmärkidele. Näiteks ei ole Maksu- ja Tolliamet vastvõtja, kui ta teeb päringu maksukaasust uurides. Vaata <a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art. 4.9</a>",
			name: "Vastuvõtja",
			source: "Üldmäärus 2016/679 art. 4.9"
		},
		PIA_LGL_DUR: {
			description: "Andmete säilitamise kestus peab olema määratud kõigile isikuandmetele ja peab vastama õigusaktides sätestatud tähtaegadele ja/või andmetöötluse vajadustele. Tähtajad võivad olla erinevad aktiivses kasutuses ja arhiveeritud andmetel.  Süsteem peab võimaldama andmete kustutamist, kas igakordse käsuga või automaatselt säilitamistähtaja lõppemisel. Samuti peab olema võimalik kustutada isikuandmete töötlemise toimingute logid, mida ei säilitata igavesti.",
			name: "Andmete säilitamise kestus",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Isikuandmeid võib koguda täpselt ja selgelt kindlaksmääratud ning õiguspärastel eesmärkidel ning neid ei töödelda hiljem viisil, mis on nende eesmärkidega vastuolus. .</strong> <br>Vaata< a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art. 5.1.b)</a>",
			name: "Isikuandmete töötlemise põhimõtted",
			source: "Üldmääruse 2016/679 art. 5.1.b)"
		},
		PIA_LGL_FOND: {
			description: "- Andmesubjekt  on andnud nõusoleku töödelda oma isikuandmeid ühel või mitmel konkreetsel eesmärgil<br>- isikuandmete töötlemine on vajalik andmesubjekti osalusel sõlmitud lepingu täitmiseks või lepingu sõlmimisele eelnevate meetmete võtmiseks vastavalt andmesubjekti taotlusele<br>-isikuandmete töötlemine on vajalik vastutava töötleja seadusejärgse kohustuse täitmiseks<br>-isikuandmete töötlemine on vajalik andmesubjekti või mõne muu füüsilise isiku eluliste huvide kaitsmiseks<br>-isikuandmete töötlemine on vajalik avalikes huvides oleva ülesande täitmiseks või vastutava töötleja avaliku võimu teostamiseks<br>-isikuandmete töötlemine on vajalik vastutava töötleja või kolmanda isiku õigustatud huvi korral, välja arvatud juhul, kui sellise huvi kaaluvad üles andmesubjekti huvid või põhiõigused ja -vabadused, mille nimel tuleb kaitsta isikuandmeid, eriti juhul kui andmesubjekt on laps<br>Vaata< a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art.6</a> ",
			name: "Seaduslikkuse alus",
			source: "Üldmääruse 2016/679 art.6"
		},
		PIA_LGL_INFO: {
			description: "Kindlusta, et andmesubjekt oleks teavitatud vastavalt üldmääruse 2016/679 nõuetele.",
			name: "Andmesubjektide teavitamine",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Vähendamaks riske on oluline töödelda võimalikult vähe isikuandmeid, st ainult sellisel hulgas, mis on minimaalselt vajalik eesmärkide saavutamiseks.",
			name: "Võimalikult väheste andmete kogumine",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Volitatud töötlejaga sõlmitud töötlemisleping peab sisaldama üldmääruse 2016/679 art.28 loetletud tingimusi: töötlemise kestvus, maht, eesmärk, vastutava töötleja juhised, ettenähtud juhtudel järelevalveasutusest eelneva loa taotlemine, tõendite esitamine tõendamaks töötlemise vastavust üldmääruse 2016/679 nõuetele, rikkumistest viivitamata teatamine jne.",
			name: "Volitatud töötlemine",
			source: "Üldmääruse 2016/679 art.28"
		},
		PIA_LGL_SUPT: {
			description: "Andmekandjad, millel isikuandmed asuvad. N: riistvara, tarkvara, võrgustik, paberkandja või paberkandja edastamise vahendid jms.",
			name: "Andmekandjad",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Olenevalt sihtriigist tuleb põhjendada andmete organisatsiooniväliselt hoiustamist ja osutada õiguslikule järelvele, et tagada andmesubjekti küllaldane kaitse andmete piiriülesel edastamisel. Vaata< a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art. 44 - 49</a> ",
			name: "Edastamine",
			source: "Üldmääruse 2016/679 art. 44 - 48"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Meetmete ja tegevuste olemasolu, mis võimaldavad organisatsioonil juhtida ja tagada tema poolt käideldavate isikuandmete kaitset.",
			name: "Järelvalve",
			placeholder: "Näidake siin kas isikuandmete kaitse meetmete tõhusust ja sobivust seiratakse.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Meetmete ja tegevuste olemasolu, mis vähendavad ohte andmesubjektide põhiõigustele ja isikuandmetele tulenevalt kolmandate isikute õiguspärasest juurdepääsust isikuandmetele.",
			name: "Suhted kolmandate osapooltega",
			placeholder: "Näidake siin turvakontroll ja -meetmed, mida rakendatakse töötlejale, kellelt eeldatakse juurdepääsu isikuandmetele.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Täpsustage kas keegi isiklikult on vastutav privaatsust ja isikuandmete kaitset puudutava seadusandluse ning reeglite rakendamise eest. Täpsustage, kas oragnisatsioonis on privaatsus- ja isikuandmete kaitse seire komitee (või samaväärne), mis vastutaks juhiste andmise ja järelkontrolli eest.",
			name: "Organisatsioon",
			placeholder: "Näidake kas andmekaitserollid ja -vastutus on määratletud.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Isikuandmete kaitse kõigisse uutesse tegevustesse lõimimise meetmete olemasolu.",
			name: "Isikuandmete kaitse lõimimine organisatsiooni tegevustesse",
			placeholder: "Kirjeldage siin kuidas isikuandmete kaitse on lõimitud organisatsiooni tegevustesse",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Teadlikkust tõstavate meetmete olemasolu, mida kasutatakse töölesaabujate ja isikuandmetega kokkupuutuvate töötajate puhul ning olukorras, kus töölt lahkub töötaja, kel oli juurdepääs isikuandmetele.",
			name: "Personali teadlikkus",
			placeholder: "Näidake, kas töötajate hulgas toimuvad teadlkikkust tõstvad tegevused.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Tooge välja olulised andmekaitseaspektid seoses õiguslike alustega, mis määravad igale aspektile sobivad meetmed (ohud, aluspõhimõtted mida järgida, eesmärgid, rakendatavad reeglid jne.) igale sihtrühmale (kasutajad, IT-osakond, meetmete kujundajad jt.).",
			name: "Meetodid",
			placeholder: "Loetlege siin andmekaitse eesmärke ja reegleid sätestavad õigusaktid ja muud dokumendid.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Meetmed, millega ohjatakse organisatsiooni tegevusega isikuandmete kaitsele ja privaatsusele põhjustatavaid ohte (ohtude kaardistamine jne.)",
			name: "Privaatsus iskide ohjamine",
			placeholder: "Kirjeldage siin isikuandmete töötlemisele ja privaatsusele tekkivate ohtude ohjemeetmeid.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Teovõimelise üksuse või tegutsemisreeglite olemasolu vahejuhtumite, mis võivad mõjutada andmesubjektide põhiõigusi ja privaatsust, menetluseks.",
			name: "Isikuandmetega seotud rikkumiste menetlus",
			placeholder: "Näidake siin, kas IT vahejuhtumeid käsitletakse kirjalikes ja katsetatud juhtimismenetlustes.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Kasutavad meetodid ja vahendid, millega tagatakse isikuandmete kättesaadavus ja/või terviklikkus samaaegselt säilitades nende konfidentsiaalsust.",
			name: "Varukoopiad",
			placeholder: "Näidake siin kuidas käideldakse varukoopiaid. Täpsustage kuidas on tagtud varukoopiate turvaline säilitamine.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Tööjaamade kaitseks rakendatud meetmed (automaatne lukustumine, korrapärased tarkvarauuendused, konfiguratsioon, füüsiline turvalisus jms.) vähendamaks tarkvara kuritarvitamist (operatsioonisüsteemid, ärirakendused jms.) isikuandmete kahjulikuks mõjutamiseks.",
			name: "Tööjaamade haldus",
			placeholder: "Kirjeldage siin tööjaamade kaitseks rakendatavaid meetmeid",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "<strong>Kasutage ainult alltöövõtjaid, kes annavad piisavad tagatised</strong> (eelkõige eriteadmiste, usaldusväärsuse ja ressursside osas). Nõudke vastavat teavet enne lepingu sõlmimist. <br>Kontrollige ja dokumenteerige kõik vahendid mida alltöövõtja kasutab andmekaitse tagamiseks. Tagatised võivad olla: <br>- andmete krüpeerimine vastavuses nende tundlikusele või protseduuride olemasolu, mis välistavad juhusliku isikuandmetele ligipääsu teenuse osutamisel; <br>- krüpeerimine andmete edastamisel (N: HTTPS ühendus, VPN, jne.); <br>- võrgu kaitse, jälgitavus (logid, auditid), juurdepääsu õiguste haldamine, autentimine, jms. <br><strong>Leping peab sisaldama muuhulgas töötlemise kestust ja eesmärki ning poolt kohustusi. Jälgige, et leping sisaldaks: <br>- alltöövõtja kohustusi isikuandmete <strong>konfidentsiaalsuse osas</strong>;<br>- <strong>minimaalsed nõuded kasutajate audentimiseks</strong>;<br>- <strong>andmete taastamise ja/või hävitamise sh lepingu lõppemisel</strong>;<br>- <strong>intsidentide haldamise ja nendest teavitamise tingimused. </strong> Leping peaks sisaldama kohustust teavitada vastutavat töötlejat rikkumistst ja turvaintsidentidest, kui need puudutavad isikunadmeid.",
			name: "Protsessiga seotud lepingud",
			placeholder: "Kirjeldage siin erimeetmeid protsessiosalistele (serverimajutaja, hooldaja, administraator, eriteenuste pakkujad jt.)",
			source: "Lepinguga näidatud ja määratud meetmed"
		},
		PIA_SEC_EXP: {
			description: "Isikuandmeid säilitavate vahenditele rakendatud meetodid vähendamaks riskide tõenäosust ja mõju.",
			name: "Toimeturvalisus",
			placeholder: "Kirjeldage siin kuidas teostatakse tarkvarauuendusi (operatsioonisüsteemidele, rakendustele jt.) ja andmeturbe parandavaid meetmeid.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Seirake sissemurdmist tuvastavaid ja ennetavaid süsteeme, et analüüsida võrguliiklust (juhtmega võrgud, juhtmevabad võrgud, raadiolained, fiiberoptiline jne.) reaalajas tuvastamaks kahtlasi tegevusi, mis viitavad küberrünnakule.",
			name: "Võrgutegevuse seire",
			placeholder: "Näidake siin isikuandmetega juhtunud vahejuhtumite tuvastamise meetodid ja vahendid",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Meetmed kirjeldamaks kuidas riistvara füüsilist hooldust korraldatakse, märkides, kas seda tellitakse organisatsiooniväliselt lepingupartnerilt.<br> Näidake, kas on lubatud rakenduste kaughooldus ja kui on, siis milliste kokkulepete alusel. Täpsustage, kuidas käideldakse rikkis riistvara.",
			name: "Hooldus",
			placeholder: "Kirjeldage siin kuidas korraldatakse riistvara füüsilist hooldust",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Tööjaamades ja serverites rakendatavad meetmed kaitsmaks neid pahavara eest vähemturvaliste võrkudega suhtlemisel.",
			name: "Pahavara tõkestamine",
			placeholder: "Kirjeldage siin meetmeid, millega vähendatakse vähemturvaliste võrkudega suhtlemisel tekkivat riski.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Näidake siin meetmed, mis tagavad serverite ja tööjaamade füüsilise turvalisuse (turvaline hoiukoht, kaablite turvalisus, konfidentsiaalsusfiltrid, turvalisuskontroll enne utiliseerimist jne.).",
			name: "Riistvara turvalisus",
			placeholder: "Näidake siin meetmed, mis tagavad serverite ja tööjaamade füüsilise turvalisuse",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Meetmed sõltuvad andmetöötluseks kasutatava võrgu tüübist (isoleeritud, privaatne või Internett). Täpsustage tulemüüri liik, ründe tuvastuse süsteemid või muud aktiivsed või passiivsed vahendid, mis on rakendatud võrguturvalisuse tagamiseks.",
			name: "Võrguturvalisus",
			placeholder: "Näidake siin turvameetmeid võrgus, kus anmdetöötlus toimub",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Füüsilise turvalisuse tagamise meetmed (tsoneerimine, külastajate saatmine, sissepääsulubade kandmine, lukustatud uksed jne.). Näidake kas sissemurdmise tuvastamiseks kasutatakse häiresüsteemi.",
			name: "Füüsilise juurdepääsu kontrollimine",
			placeholder: "Näidake siin kuidas kontrollitakse füüsilist juurdepääsu andmetöötluse alale.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Tulekahju ärahoidmise, avastamise ja tõrjumise meetmed. Kui asjakohane, märkige veekahjustuse ennetamise meetmed. Samuti täpsustage elektrivarustuse jälgimise ja tagamise meetmed.",
			name: "Kaitse mitte-inimtekkeliste riskide eest",
			placeholder: "Näidake siin meetodid hoidumaks mitte-inimtekkelistest riskidest.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Tegevuskoha dokumenteerimine, milles tuvastatakse, et piirkond ei ole looduskatastroofi ohus (üleujutus, keemiatööstuse lähedus, maavärin või vulkaaniline tegevus jne.). Märkige samal alal hoitavad ohtlikud ained.",
			name: "Riskiallikate vältimine",
			placeholder: "Näidake siin, kas tegevuskohas on loodukatastroofide ohtu",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Võrgulehekülgede kaitseks rakendatud meetmed.",
			name: "Võrgulehekülgede turvalisus",
			placeholder: "Näidake rakendatud võrgulehekülgede kaitsemeetemid.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Näidake siin kas anonümiseerimise meetmed on kasutusele võetud, kui on, siis millised ja milleks. <br>Ärge unustage selgelt eristada anaonüümseid ja pseudoanonüümseid andmeid.",
			name: "Anonümiseerimine",
			placeholder: "Näidake siin kasutatavaid anonümiseerimise mehhanisme",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Kui asjakohane, siis kirjeldage arhiivihalduse tegevusi (vastuvõtt, säilitamine, päringud jt.) mille eest vastutate. Määratlege arhiveerimisrollid (looja, vahendaja jt.) ja arhiveerimismeetodid. Märkige kui andmed võivad sattuda avalikku arhiivi.",
			name: "Arhiveerimine",
			placeholder: "Näidake siin kas kasutatakse säilitatavate andmete terviklikkuse kontrollimise meetmeid, milliseid ja millisel eesmärgil.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Kasutuselevõetud meetmed, et <strong> säilitatud andmed (andmebaasis, tagavarakoopias jm), samuti krüpteerimisvõtmete haldus (loomine, säilitamine, muutmine andmete kompromiteerimise kahtluse korral jne).<br> Kirjeldage andmevoole rakendatud krüteerimismeetmeid (VPN, TLS jt) kasutatud andmetöötlusel.",
			name: "Krüpteerimine",
			placeholder: "Kirjeldage siin andmete kofidentsiaalsust tagavad meetmed",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Andmete eraldamine aitab vähendada isikuandmete kokkuviimise võimalust ja kõigi isikuandmete avalikuks tuleku võimalust.",
			name: "Andmete eraldamine",
			placeholder: "Siin näidake ära kas eraldamine protsess on kavandatud ja kuidas kuidas seda läbi viiakse.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Kasutajakontode moodustamise ja isikule omistamise meetodid. Täpsustage milliseid <strong>autentimis</strong> meetmeid kasutatakse. Kui asjakohane, tooge välja salasõnadele kehtivad reeglid (vähim pikkus, nõutavad koostisosad, kehtivusaeg, ebaõnnestunud autentimiskordade arv, kuni juurdepääs lukustatakse jms.).",
			name: "Loogiline juurdepääsu kontroll",
			placeholder: "Näidake siin kuidas on kasutajaprofiilid moodustatud ja isikule omistatud.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Jälgitavust ja logide käitlust määravad meetmed.",
			name: "Jälgitavus (logimine)",
			placeholder: "Näidake siin kas sündmusi logitakse ja kui kaua neid logisid säilitatakse.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Kasutada võib järgnevaid meetmeid: väljasõelumine ja eemaldamine, muutmisega tundlikkuse vähendamine, tuvastava loomuse vähendamine, andmete hajutamine, andmetele juurdepääsu piiramine",
			name: "Isikuandmete koguse minimeerimine",
			placeholder: "Näidake siin isikuandmete kasutamise meetmeid, mida rakendatakse riskide tõsiduse vähendamiseks",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Näidake kus ja kuidas isikuandmeid sisaldavaid paberdokumente välja trükitakse, säilitatakse, hävitatakse ja asendatakse.",
			name: "Paberdokumentide turvalisus",
			placeholder: "Näidake kas on rakendatud paberdokumentide terviklikkuse seire meetmed, millised ja mis eesmärgil.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "hindaja poolt soovitatud korrigeerivad meetmed, tegevuskava koostamisel määratakse igale tegevusele vastutav isik, sagedus, keerulisus, maksumus ja edenemine",
			name: "Tegevuskava",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Joonis illustreerib head turvalisuspraktikat, vastausväärtusega, mis on lisatud igale eelmisele sammule neile antud hinnangute põhjal.",
			name: "Riskide kaardistamine",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Vajaduse korral küsib vastutav töötleja andmesubjektide või nende esindajate seisukohti kavandatava töötlemise kohta, ilma et see piiraks äri- või avalike huvide kaitset või isikuandmete töötlemise toimingute turvalisust. Vaata <a target=\"_blank\" href=\" https://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\">üldmääruse 2016/679 art. 35.9</a><br>Arvamuse kogumine võib sõltuda töötlemise kontekstist (sise- või välisuuringud töötlemise meetodite ja eesmärkide kohta, küsimused töötajate esindajatele või ametiühingule, küsitlused võimalike tulevaste klientide hulgas). <strong>Kui töötleja ei arvesta arvamust või kavatseb tegutseda selle vastaselt, siis tuleb märkida selle põhjendus</strong>. Kui vastutav töötleja leiab, et<strong>andmesubjekti arvamus ei ole asjakohane, siis tuleb see samuti ära märkida</strong>.",
			name: "Andmesubjekti arvamus",
			source: "Üldmääruse 2016/679 art 35.9"
		},
		PIA_VAL_DPO: {
			description: "Vastutav töötleja peab küsima andmekaitsespetsialisti arvamust mõjuhinnangu kohta. Vaata art. 35.2 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/ET/TXT/HTML/?uri=CELEX:32016R0679&from=ET\"</a><br> <strong>.",
			name: "Andmekaitsespetsialisti arvamus",
			source: "Üldmääruse 2016/679 art.35.2"
		},
		PIA_VAL_RT: {
			description: "Otsustage, kas valitud meetmed, jääkriskid ja tegevuskavad on vastuvõetavad arvestades varemtuvastatud asjaolusid ja asjaosaliste vaatekohti. Nii võib tegevuskava olla:<br>- heaks kiidetud<br>- tingimisi parandamisel (selgitage mil moel)<br>- tagasi lükatud (asjaolude arvessevõtmiseks). Korrake vajadusel eelnevaid samme kuni tegevuskava on heaks kiidetud. See otsus ei mõjuta võimalikku andmekaitse asutuse (AKI Eestis) näiteks eelhindamise käigus läbiviidava vastavushindamise tulemust.",
			name: "Ametlik kinnitamine",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Teadmiste pagas"
};
var measures$f = {
	add: "Lisa meede (või kasuta teadmiste pagasit)",
	default_placeholder: "Kirjelda andmeturbe tagamiseks kasutatavat olemasolevat või planeeritavat meedet.",
	edit: "Toimeta meedet",
	placeholder_title: "Meeteme nimi",
	remove: "Kustuta meede"
};
var misc$f = {
	display: "Näita / Peida"
};
var modals$f = {
	abandon_pia: {
		additional_text: "Arhiveerimine ei ole lõpetatud ja selle juurde saab vajadusel tagasi pöörduda.",
		content: "Kas soovite katkestada?"
	},
	action_plan_no_evaluation: {
		content: "Te peate alustama analüüsi ülevaadet tegevuskava koostamiseks.",
		review_section: "Vaadake jaotis üle"
	},
	archive: "Arhiiv",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "See osa on valmis ülevaatamiseks."
	},
	back_to_edition: {
		content: "See jaotis on saadetud tagasi redigeerimisse. <br>Paljud väljad tuleb korrigeerida, <br>et võimaldada selle nõuetekohane ülevaade."
	},
	back_to_evaluation: {
		content: "See jaotis on saadetud tagasi redigeerimisse. <br>Paljud väljad tuleb korrigeerida, <br>et võimaldada selle nõuetekohane kinnitamine."
	},
	back_to_home: "Tagasi",
	cancel: "Tühista",
	close: "Sule",
	completed_edition: {
		content: "Mõjuhinnangu koostamine on lõpetatud ja vajab ülevaatamist."
	},
	completed_evaluation: {
		content: "Mõjuhinnang on ülevaadatud ja valmis kinnitamiseks."
	},
	"continue": "Jätka",
	declare_measures: {
		content: "Enne riskide hindamist<br> peate teatama olemasolevatest <br>või kavandatud meetmetest.",
		declare: "Olemasolevate või kavandatud meetmete deklareerimine."
	},
	dpo_missing_evaluations: {
		comment: "Kommenteeri",
		content: "Te peate viima lõpule analüüsi ülevaatuse, et pääseda andmekaitsespetsilisti lehele.",
		remove: "Eemalda",
		review_section: "Vaadake jaotis üle"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Imporditu ei vasta mõjuhinnangu failile"
	},
	import_wrong_structure_file: {
		content: "Imporditu ei vasta mudelile"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Mõjuhinnangu sisu on kopeeritud lõikelauale."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Hoiatus,</span><br>Vähemalt üks meede tuleb täita: kustutamine pole võimalik."
	},
	recover_version: {
		"continue": "Jätka",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "Kunas lükkasite mõjuhinnagu tagasi, siis tagastatakse see ülevaatamiseks ja muudatuste tegemiseks."
	},
	remove_attachment: {
		comment: "Kommenteeri",
		content: "<span class='strong'>Warning,</span><br>Kas oled kindel, et sa tahad <br>seda manust eemaldada?",
		keep: "Jäta alles",
		remove: "Eemalda"
	},
	remove_measure: {
		content: "<span class='strong'>Hoiatus,</span><br>Kas olete kindel, et soovite <br>selle meetme eemaldada?",
		keep: "Hoia alles <br>see meede",
		remove: "Eemalda <br>see meede"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Eemalda see mõjuhinnang"
	},
	remove_question: {
		content: "Kas soovite küsimuse kustutada?",
		keep: "Tühista",
		remove: "Kustuta"
	},
	remove_structure: {
		content: "<span class='strong'>Hoiatus,</span><br>Kas olete kindel, et soovite<br>seda kustutada?",
		remove: "Kustuta"
	},
	same_comment: {
		content: "<span class='strong'>Hoiatus,</span><br>Palun sisestage kommentaar, mis erineb viimasest kirjapandust."
	},
	signed_pia_validation: {
		content: "Mõjuhinnagu kinnitamiseks lisa raport.",
		download_pia: "Lae raport alla"
	},
	simple_pia_validation: {
		content: "Mõjuhinnang on kinnitatud."
	},
	start_evaluation: "Alusta ülevaatamist",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Serveri aadress on uuendatud."
	},
	validate_evaluation: {
		content: "See jaotis on valmis mõjuhinnangu kinnitamiseks."
	},
	validate_evaluation_to_correct: {
		content: "Vabandust, <br>paljud väljad tuleb parandada. <br>Paranduste tegemiseks minge <br>redigeerimisvaatesse."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$f = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$f = {
	content: ", arvesta et:",
	dpo_lock: "Palun täitke teised jaotised, enne kui asute täitma mõjuhinnangu arvamust.",
	dpo_opinion: "Andmekaitsespetsilisti arvamus",
	edit: "Redigeeri",
	people_opinion: "Puudutatud isikute arvamus",
	placeholder_concerned_people_name: "Puudutatud isikute nimed",
	placeholder_dpo_name: "Andmekaitsespetsilisti nimi",
	placeholder_dpo_opinion: "Täpsustage oma valikute põhjused.",
	placeholder_people_opinion: "Kirjeldage kuidas arvamusi koguti ja milline on nende analüüs. Kui arvamusi pole taotletud, põhjendage miks.",
	placeholder_search_content: "Põhjenda miks ei ole asjaomaste isikute arvamust taotletud.",
	treatment_lock: "Palun täitke teised jaotised, enne kui asute täitma puudutatud isiku arvamust.",
	treatment_nok: "Muudatust ei või rakendada",
	treatment_ok: "Muudatust võib rakendada"
};
var pia$f = {
	attachments: {
		add: "Lisa",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Eemalda",
		title: "Manused",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Küsi ülevaatust",
		mandatory_fields: "Kõik väljad peavad olema täidetud",
		structure_add_question: "Lisage küsimus",
		subsection_validated: "Alajaotus ülevaadatud, ootab viimast kinnitamist",
		validate_evaluation: "Kinnita ülevaatus"
	},
	header: {
		display_action_plan: "Näita<br>tegevuskava",
		edition: "Versioon",
		evaluation: "Hinnang",
		preview: "Eelvaade"
	},
	sections: {
		based_on_structure_name: "Tuginedes:",
		homepage_link: "Tagasi töölauale",
		refuse_pia: "Lükka tagasi",
		status: {
			evaluation: {
				cancel: "tühistama ülevaatamise taotluse.",
				cancel_button: "Tühista ülevaatamise taotlus",
				content: "See osa ei ole veel ülevaadatud. Kui soovid toimetada ülevaatamiseks esitatut, pead ",
				title: "Ülevaatamise ootel."
			},
			validation: {
				cancel: "tühistada kinnitamise taotlus",
				cancel_button: "Tühista kinnitamise taotlus",
				content: "See osa on ülevaadatud ja ootab kinnitamist. Ülevaatamise muutmiseks tuleb",
				title: "Kinnitamise ootel."
			}
		},
		validate_pia: "Kinnita mõjuhinnang"
	},
	statuses: [
		"Koostamisel",
		"Tagasilükatud",
		"Lihtne kinnitamine",
		"Allkirjastatud kinnitamine",
		"Arhiveeritud",
		"Ootab kinnitamist"
	]
};
var questions$f = {
	edit: "Muuda küsimust",
	gauges: [
		"(Määratlemata)",
		"Ebaoluline",
		"Piiratud",
		"Oluline",
		"Maksimaalne"
	],
	placeholder_title: "Küsimus (kohustuslik)",
	remove: "Eemalda"
};
var rejection_page$f = {
	applied_adjustments: "Pakutud parandused",
	applied_adjustments_placeholder: "Kirjeldage mõjuhinnagusse tehtud muudatusi.",
	button: {
		abandon_treatment: "Lõpeta",
		reject_pia: "Lükka tagasi",
		send_for_validation: "Saada uuesti kinnitamiseks"
	},
	previous_rejection: "Eelnev keeldumine",
	rejection_reason: "Keeldumise põhjus",
	rejection_reason_placeholder: "Kirjelda tagasilükkamise põhjuseid.",
	title: "Kinnitamise ajalugu"
};
var sections$f = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Esitage töötlemise lühike ülevaade: selle nimi, eesmärgid, panused, kasutuskontekstid jne.",
						title: "Mis on vaadeldav protsess?"
					},
					"2": {
						placeholder: "Kirjeldage sidusrühmade vastutust: andmetöötleja, võimaliku andmetöötlusprotsessori ja ühiste töötlejate.",
						title: "Millised on töötlemisega seotud kohustused?"
					},
					"3": {
						placeholder: "Loetlege töötlemiseks kohaldatavad asjakohased standardid, eriti heakskiidetud tegevusjuhendid ja andmekaitsetunnistused.",
						title: "Kas töötlemisele kohalduvad teatud standardid?"
					}
				},
				short_help: "See osa võimaldab uuringu objekti identifitseerida ja esitada.",
				title: "Ülevaade"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Loetlege kogutud ja töödeldud andmed. Määratlege iga säilitamise kestus, adressaadid ja neile juurdepääsetavad isikud.",
						title: "Milliseid andmeid töödeldakse?"
					},
					"2": {
						placeholder: "Esitage ja kirjeldage, kuidas toode üldjuhul töötab (andmete kogumisest andmete hävitamiseni, erinevaid töötlemise etappe, ladustamist jne), kasutades näiteks andmevoogude diagrammi (lisage see manusena) ja kirjeldage üksikasjalikult läbiviidud protsesse.",
						title: "Kuidas andmete ja töötluste elutsükkel toimib?"
					},
					"3": {
						placeholder: " Nimetle andmeid toetavad funktsioonid ja detailid (operatsioonisüsteem, ärirakendused, protokollid, konfiguratsioonid jne.)",
						title: "Millised on andmeid toetavad detailid?"
					}
				},
				short_help: "See osa võimaldab teil üksikasjalikult määratleda ja kirjeldada töötlemise ulatust.",
				title: "Andmed, protsessid ja toetavad varad."
			}
		},
		short_help: "See jaotis annab selge ülevaate kõnealuste isikuandmete töötlemisest.",
		title: "Sisu"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Kirjeldage palun, millisel moel on andmetöötluse eesmärgid seaduslikud, täpsed ja selgesõnaliselt esitletud?",
						short_title: "Eesmärgid",
						title: "Kas andmetöötluse eesmärgid on seaduslikud, määratletud täpselt ja selgesõnaliselt ja"
					},
					"2": {
						placeholder: "Palun kirjeldage ja nimetleg, millised on andmetöötluse seaduslikud alused (andmesubjekti nõusolek, lepingu täitmine, oluliste huvide kaitse jms)",
						short_title: "Seaduslik alus",
						title: "Milised on andmetöötluse seaduslikud alused?"
					},
					"3": {
						placeholder: "Palun kirjelda, miks on kogutud andmed vajalikud andmete töötlemise eesmärgi jaoks.",
						short_title: "Kogutud andmete asjakohasus",
						title: "Kas kogutud andmed on asjakohased, olulised ja piiratud sellega, mis on vajalik nende töötlemise eesmärgi seisukohalt (\"võimalikult väheste andmete kogumine\")?"
					},
					"4": {
						placeholder: "Kirjelda palun, milliseid samme on ette võetud, et kindlustada andmete õigsus ja kvaliteet",
						short_title: "Andmete õigsus",
						title: "Kas kogutud andmed on täpsed ja faktilised õiged (õigsus?"
					},
					"5": {
						placeholder: "Palun selgita, miks on andmete säilitamise ajaline kestvus vajalik seaduslike nõuete või töötluse seisukohast",
						short_title: "Andmete säilitamise kestvus",
						title: "Millised on andmete säilitamise tähtajad?"
					}
				},
				short_help: "See alasektsioon võimaldab Teil esitleda oma töödeldud andmete ja andmetöötluse seaduslikkust ning nende töötlemise proportsionnaalsust ja vajalikkust tulenevalt isikuandmete töötlemise eesmärkidest",
				title: "Propotsionaalsus ja vajalikkus"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Kirjeldage, millist teavet jagatakse andmesubjektile ja milliste vahenditega.",
						short_title: "Teava, mis jagatakse andmesubjektile",
						title: "Kuidas teavitatakse andmesubjekte andmete töötlemisest?"
					},
					"2": {
						placeholder: "Kirjelda meetmeid, mis kindlustavad selle, et kasutajatelt on saadud nõusolek",
						short_title: "Nõusoleku saamine",
						title: "Kuidas toimub andmesubjektidelt nõusoleku saamine adnmete töötlemiseks?"
					},
					"3": {
						placeholder: "Kirjadega meetmeid, mis võimaldavad andmesubjektidel andmetega tutvuda, andmeid endale saada ja neid andmeid edastada",
						short_title: "Andmesubjekti õigus tutvuda andmetega ja õigus nende ülekandmisele",
						title: "Kuidas on tagatudd andmesubjektide õigused, andmete ülekandmisele ja nendega tutvumisel?"
					},
					"4": {
						placeholder: "Palun kirjelda, millised meetmed on ette nähtud, et andmesubjektid saaksid enda kohta käivaid andmeid parandada ja kustada?",
						short_title: "Õigus andmete parandamisele ja nende kustutamisele",
						title: "Kuidas saavad andmesubjektid teostada oma õigust andmete parandamisele ja nende kustatamisele õigus olla unustatud?"
					},
					"5": {
						placeholder: "Kirjeldage rakendatud meetmeid, mis võimaldavad andmesubjektidel kasutada õigust andmete töötlemise piiramisele ja õigust esitada vastuväiteid?",
						short_title: "Õigus isikuandmete töötlemise piiramisele ja õigus esitada vastuväited",
						title: "Kuidas saavad andmesubjektid kasutada oma õigusi isikuandmete töötlemise piiramisele ja õigusele esitada vastuväiteid?"
					},
					"6": {
						placeholder: "Kirjelda iga alltöövõtja kohustusi (kohustuste kestvus, eesmärk, kohaldamisala, töötlemise juhised) ja samuti esita töötlemise aluseks olevad lepingud ja tööjuhised.",
						short_title: "Alltöövõtt",
						title: "Kas volitatud töötleja kohustused on lepingus määratletud selgesõnaliselt?"
					},
					"7": {
						placeholder: "Nimeta millistes Euroopa Liidu välistes riikides hoiustatakse andmeid, samuti selgita palun, kas nimetatud andmete hoiustamise puhul tagatakse andmete piisava kaitse.",
						short_title: "Edastamised",
						title: "Kas andmete edastamise puhul väljastpoolt Euroopa Liitu on andmed adekvaatselt kaitstud?"
					}
				},
				short_help: "Käesoleva osa võimaldab Sul näidata, et sa rakendad vajaminevaid õigusi, et andmesubjektid ja teised puudatud isikud saaksid kasutada vajamineval määral oma õigusi",
				title: "Abinõud ja vajaminevad mehhanismid kaitsmaks andmesubjektide õigusi"
			}
		},
		short_help: "See alasektsioon võimaldab Teile luua raamvõrgustik andmekaitse printsiipidele ja aluspõhimõtetele",
		title: "Olulised printsiibid ja aluspõhimõtted"
	},
	"3": {
		items: {
			"1": {
				short_help: "See alapeatükk võimaldab sul nimetada olemasolevad või planeeritavad meetmed, mis on mõeldud andmekaitse jaoks.",
				title: "Planeeritavad või olemasolevad kaitsemeetmed"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Nimeta selle potentsiaalsed tagajärjed ja mõjud",
						title: "Millised on peamised <span class='green-highlight'>mõjud andmesubjektile</span> kui risk peaks esinema?"
					},
					"2": {
						placeholder: "Nimeta ohud",
						title: "Millised on peamised <span class='green-highlight'>ohud</span> mis võivad viia riski esinemiseks?"
					},
					"3": {
						placeholder: "Nimeta riskide allikad",
						title: "Millised on riskide <span class='green-highlight'>allikad</span>?"
					},
					"4": {
						placeholder: "Kliki siin, et valida kaitsemeetmed, mis riske ohjavad.",
						title: "Millised tuvastatud <span class='green-highlight'>kaitsemeetmed</span> aitavad kaasa riskide käsitlemisele?"
					},
					"5": {
						placeholder: "Nimeta riskide tõsidust.",
						title: "Kuidas hindate <span class='green-highlight'>riski tõsidust </span>, vastavalt võimalikele mõjudele ja planeeritavatele kaitsemeetmetele?"
					},
					"6": {
						placeholder: "Põhjenda siin antud tõenäosuse hinnangut.",
						title: "Kuidas hindate <span class='green-highlight'>riski tõenäosust</span>, arvestades ohte, riskide allikaid ja kavandatavaid kaitsemeetmeid?"
					}
				},
				short_help: "Analüüsi andmelekke võimalikke põhjuseid ja tagajärgi, samuti.",
				title: "Ebaseaduslik andmetele ligipääs ja nendega tutvumine"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Sisesta võimalikud mõjud",
						title: "Millised võivad olla <span class='green-highlight'>mõjud andmesubjektile</span> kui riskid ilmnevad?"
					},
					"2": {
						placeholder: "Sisesta võimalikud ohud",
						title: "Millised võivad olla <span class='green-highlight'>ohud</span> mis võivad riskini viia?"
					},
					"3": {
						placeholder: "Sisesta riskide allikad",
						title: "Millised on riskide <span class='green-highlight'>allikad</span>?"
					},
					"4": {
						placeholder: "Vajuta, et valida riskile vastavad kaitsemeetmed.",
						title: "Millised on <span class='green-highlight'>kaitsemeetmed</span> vastavalt riskidele?"
					},
					"5": {
						placeholder: "Põhjenda riski raskusastet.",
						title: "Kuidas hindate <span class='green-highlight'>riski raskusastet</span>, vastalt võimalikule mõjule ja kavandatavatele kaitsemeetmetele?"
					},
					"6": {
						placeholder: "Põhjenda riski tõenäosust.",
						title: "Kudas hindate <span class='green-highlight'>riski tõenäosust</span>, arvestades ohte, riskide allikaid ja kavandatavaid kaitsemeetmeid?"
					}
				},
				short_help: "Analüüsige andmete soovimatu muutmise põhjuseid ja tagajärgi ning hinnake selle tõsidust ja tõenäosust.",
				title: "Soovimatu andmete muutmine"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Sisetage võimalikud mõjud",
						title: "Milised võivad olla <span class='green-highlight'>mõjud andmesubjektile</span> kui riskid ilmnevad?"
					},
					"2": {
						placeholder: "Sisestage võimalikud ohud",
						title: "Milised võivad olla <span class='green-highlight'>ohud</span> kui riskid ilmnevad?"
					},
					"3": {
						placeholder: "Sisestage ohtude allikad",
						title: "Milised võivad olla ohtude <span class='green-highlight'>allikad</span>?"
					},
					"4": {
						placeholder: "Valige ohtudele vastavad kaitsemeetmed.",
						title: "Millised on <span class='green-highlight'>kaitsemeetmed</span> mis vastavad ohtudele?"
					},
					"5": {
						placeholder: "Põhjenda riski raskusastet.",
						title: "Kuidas hindate <span class='green-highlight'>riski raskusastet</span>, vastalt võimalikule mõjule ja kavandatavatele kaitsemeetmetele?"
					},
					"6": {
						placeholder: "Põhjenda riski tõenäosust.",
						title: "Kudas hindate <span class='green-highlight'>riski tõenäosust</span>, arvestades ohte, riskide allikaid ja kavandatavaid kaitsemeetmeid?"
					}
				},
				short_help: "Analüüsige andmete kadumise põhjuseid ja tagajärgi ning hinnake selle tõsidust ja tõenäosust.",
				title: "Andmete kaotsiminek"
			},
			"5": {
				short_help: "Annab ülevaate kaitsemeetmete mõjudest riskidel, millega nad on seotud.",
				title: "Riskide ülevaade"
			}
		},
		short_help: "See alapeatükk võimaldab analüüsida privaatsus/andmekaitse riske arvestades olemasolevaid või planeeritavaid kaitsemeetmeid.",
		title: "Riskid"
	},
	"4": {
		items: {
			"1": {
				short_help: "Võimaldab riskide positsioneerimsit enne ja pärast täiendavate kaitsemeetmete rakendamist.",
				title: "Riskide kaardistamine"
			},
			"2": {
				short_help: "Planeerige üksikasjaliselt mõjuhinnanguga tuvastatud täiendavate kaitsemeetmete rakendamine. Tegevuskava uuendatakse automaatselt mõjuhinnangu täiendamisel.",
				title: "Tegevuskava"
			},
			"3": {
				short_help: "Esitage andmekaitsespetsialisti või isikuandmete kaitse eest vastutava töötaja seisukoht. Esitage andmesubjektide või nende esindajate seisukoht.",
				title: "Andmekaitsespetsialist ja teised puudutatud isikud"
			},
			"4": {
				title: "Kinnita mõjuhinnang"
			},
			"5": {
				title: "Lükka tagasi"
			}
		},
		short_help: "Siin saate koostada ja vormistada mõjuhinnagu kinnitamise.",
		title: "Kinnitamine"
	}
};
var settings$f = {
	content: "Sisestage kaugserveri aadress (URL):",
	title: "Sätted",
	update: "Uuenda URL"
};
var summary$f = {
	action_plan: {
		fundamental_principles: "Põhiprintsiibid",
		implementation_date: "Oodatav rakendamise kuupäev",
		implementation_responsible: "Vastutab rakendamise eest,",
		measures: "lemasolevad või kavandatavad meetmed",
		no_action_plan: "Ükski tegevuskava pole registreeritud.",
		risks: "Riskid",
		title: "Tegevuskava"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Manused",
	concerned_people_name: "Puudutatud isikute arvmused",
	concerned_people_opinion: "Puudutatud isikute arvamused",
	concerned_people_searched_opinion: "Puudutatud isikute arvamuse otsimine",
	concerned_people_status: "Puudutatud isikute staatused",
	concerned_people_unsearched_opinion_comment: "Põhjus miks puudutatud isikute arvamust ei ole küsitud",
	content_choice: [
		"Ravi ei tohiks kasutada",
		"Ravi võib rakendada"
	],
	creation_date: "Loomise kuupäev",
	csv_action_plan_comment: "Kommenteeri tegevuskava",
	csv_evaluation_comment: "Kommenteeri hindamist",
	csv_file_title: "Teguskava",
	csv_implement_date: "Hinnanguline rakendamise kuupäev",
	csv_people_in_charge: "Vastutav isik",
	csv_section: "Jaotis",
	csv_title_object: "Pealkiri",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Mõjuhinnangu nimi",
	dpo_opinion: "Andmekaitsespetsialisti arvamus",
	dpo_status: "Mõjuhinnangu staatus",
	gauges: {
		"1": "Ebaoluline",
		"2": "Piiratud",
		"3": "Oluline",
		"4": "Maksimaalne"
	},
	modification_made: "Tehtud muudatused",
	people_search_status_nok: "Puudatud isikute arvmus ei ole küsitud",
	people_search_status_ok: "Puudutatud isikute arvamus on küsitud",
	pia_assessor: "Hindaja nimi",
	pia_author: "Autori nimi",
	pia_name: "Mõjuhinnang",
	pia_validator: "Valideerija nimi",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Tagasi eelmisele lehele",
	rejection_reason: "Tagasilükkamise põhjus",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Riskide kaarditamine",
	risks_overview_title: "Riskide ülevaade",
	title: "Mõjuhinnangu informatsioon"
};
var users$f = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$f = {
	add_signed_pia: "Lisa allkirjastatud mõjuhinnang",
	after_reading: "Peale mõjuhinnaguga tutvumist ",
	button: {
		rejection: "Lükkan tagasi",
		signed_validation: "Kinnitan <br>(allkiri)",
		simple_validation: "Kinnitan <br>(direct)"
	},
	confirmation1: "Kinnitan, et mõjuhinnagus kirjeldatu on kooskõlas tegelikkusega.",
	confirmation2: "Kinniatn, et olen kursis olemasolevate ja/või planeeritavate toimingutega seotud sohtude ja riskidega.",
	confirmation3: "Kinnitan tegevuskavas märgitud parandusmeetmed.",
	confirmation4: "Rakendan osutatud parandusmeetmed.",
	latest_signed_attachment: "Viimane allkirjastatud manus",
	mandatory_fields: "Kõik lahtrid peavad olema täidetud",
	remove_attachment: "Eemalda manus",
	responsible: "Mõjuhinnagu kinnitamise eest vastutav isik: ",
	signed_attachments_history: "Allkirjastatud manuste ajalugu",
	tools: {
		dashboard: "Töölaud",
		display_pia: "Näita raportit"
	},
	validated_pia_with_signature: "Kinnitanud",
	waiting_for_signature: "Allirjastamise ootel"
};
var et = {
	about: about$f,
	action_plan: action_plan$f,
	authentication: authentication$f,
	cartography: cartography$f,
	comments: comments$f,
	conflict: conflict$f,
	date: date$f,
	errors: errors$f,
	evaluations: evaluations$f,
	header: header$f,
	help: help$f,
	homepage: homepage$f,
	knowledge_base: knowledge_base$f,
	measures: measures$f,
	misc: misc$f,
	modals: modals$f,
	onboarding: onboarding$f,
	opinions: opinions$f,
	"overview-risks": {
	important: "Oluline",
	limited: "Piiratud",
	maximal: "Maksimaalne",
	measures: "Meetmed",
	negligible: "Ebaoluline",
	potential_impacts: "Võimalikud mõjud",
	"risk-access_x": "Raskusaste",
	"risk-access_y": "Tõenäosus",
	"risk-change_x": "Raskusaste",
	"risk-change_y": "Tõenäosus",
	"risk-disappearance_x": "Raskusaste",
	"risk-disappearance_y": "Tõenäosus",
	sources: "Allikad",
	threat: "Ohud"
},
	pia: pia$f,
	questions: questions$f,
	rejection_page: rejection_page$f,
	sections: sections$f,
	settings: settings$f,
	summary: summary$f,
	users: users$f,
	validation_page: validation_page$f
};

var about$e = {
	contribute: "Jos haluat osallistua ohjelmiston kääntämiseen tai olemassa olevien käännösten parantamiseen, lue <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">ohjeet tältä sivulta</a>.",
	description: "Ranskan tietosuojaviranomainen, <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, kehitti tämän työkalun auttamaan rekisterinpitäjiä täyttämään yleisen tietosuoja-asetuksen vaatimukset. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Ohjelmisto on ilmainen ja sen lähdekoodi on avointa. Jos haluat osallistua projektiin, voit ladata sen lähdekoodin Githubista, muokata sitä ja jakaa sen yhteisön kanssa.",
	licences: "Kirjastolisenssit:",
	title: "Tietoa tietosuojaa koskevasta vaikutustenarviointityökalusta",
	translators: "Vaikutustenarviointiohjelmisto on tällä hetkellä saatavilla 18 kielellä. CNIL on laatinut työkalun ranskan- ja englanninkieliset versiot. Muut kieliversiot ovat seuraavien henkilöiden työn tulosta:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Versio"
};
var action_plan$e = {
	acceptable_measures: "Hyväksyttävät toimenpiteet",
	edit: "Muokkaa",
	improvable_measures: "Parannuksia vaativat toimenpiteet",
	measures: "Suunnitellut tai toteutetut toimenpiteet",
	no_action_plan: "Toimintasuunnitelmaa ei ole kirjattu.",
	placeholder_person_in_charge: "Toteuttamisen vastuuhenkilöt",
	principles: "Perusperiaatteet",
	risk1: "Luvaton tietojen käyttö",
	risk2: "Ei-toivottu tietojen muuttaminen",
	risk3: "Tietojen katoaminen",
	risks: "Riskit",
	title: "Yleiskatsaus"
};
var authentication$e = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Tämä <strong>Ranskan tietosuojaviranomaisen (CNIL)</strong> laatima ohjelmisto on tarkoitettu avustamaan rekisterinpitäjiä yleisen tietosuoja-asetuksen vaatimusten täyttämisessä ja sen osoittamisessa. Ohjelmisto mahdollistaa tietosuojaa koskevan vaikutustenarvioinnin tekemisen CNIL:n kehittämällä menetelmällä.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Aloita",
	start_app: "Tietosuojaa koskevan vaikutustenarvioinnin ohjelmisto (beeta)",
	subtitle1: "Alusta tietosuojaa koskevien <br>  vaikutustenarviointien luomiseen ja hallintaan",
	subtitle2: "Työkalut ja sanastot",
	title: "Tietosuojaa koskeva vaikutustenarviointi",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$e = {
	important: "Merkittävä",
	legend1: "Suunnitellut tai toteutetut toimenpiteet",
	legend2: "Kun korjaavat toimenpiteet on tehty",
	legend3: "(L)uvaton tietojen käyttö",
	legend4: "(E)i-toivottu tietojen muuttaminen",
	legend5: "(T)ietojen katoaminen",
	likelihood_axe: "Riskin todennäköisyys",
	limited: "Rajattu",
	maximal: "Suurin",
	negligible: "Vähäinen",
	risk1_access: "(L)",
	risk2_modification: "(E)",
	seriousness_axe: "Riskin vakavuus"
};
var comments$e = {
	comment: "Kommentti",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "Kommentit",
	new_comment: "Kommentti",
	placeholder_new_comment: "Jätä kommentti",
	send: "Lähetä"
};
var conflict$e = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$e = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$e = {
	content: "Jos kohtaat muita ongelmia tai sinulla on parannusehdotuksia,<br>voit olla meihin yhteydessä tällä lomakkeella: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Sivua ei löytynyt."
};
var evaluations$e = {
	acceptable: "Hyväksyttävä",
	action_plan_comment: "Toimintasuunnitelma / korjaavat toimenpiteet",
	evaluation_comment: "Arviointikommentti",
	gauges: {
		"0": "(Määrittelemätön)",
		"1": "Vähäinen",
		"2": "Rajattu",
		"3": "Merkittävä",
		"4": "Suurin",
		likelihood: "Kuinka arvioisit toimintasuunnitelman valossa <span class='red-highlight'>tämän riskin todennäköisyyden</span>?",
		seriousness: "Kuinka arvioisit toimintasuunnitelman valossa <span class='red-highlight'>tämän riskin vakavuuden</span>?"
	},
	improvable: "Kehitettävä",
	placeholder_acceptable: "Käytettävissä olevien tietojen perusteella toimenpiteet ovat riittäviä henkilötietojen asianmukaiseksi suojaamiseksi.",
	placeholder_improvable1: "Käytettävissä olevien tietojen perusteella henkilötietojen käsittelyn tietosuojaa on parannettava lisätoimenpiteillä.",
	placeholder_improvable2: "Kirjoita kommenttisi tähän.",
	placeholder_to_correct: "Annetut tiedot ovat liian puutteellisia arvioitaviksi. Palauta asiakirja muokkaajalle parannettavaksi.",
	status: [
		"Vireillä",
		"Korjattava",
		"Kehitettävä",
		"Hyväksyttävä"
	],
	title: "Arviointi",
	to_correct: "Korjattava"
};
var header$e = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Esimerkki vaikutustenarvioinnista",
		title: "Ohje"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Tietopankki",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "CNIL:n tarjoamat käännökset",
		community_translations: "Epäviralliset käännökset",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Eurooppalaisen tietosuojaviranomaisen tarkistama käännös",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Viralliset käännökset",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Tietosuojaa koskeva vaikutustenarviointi",
	structures: "PIA templates",
	tools: {
		about: "Tietoa ohjelmasta",
		accessibility: "Visuaaliset helppokäyttöisyysasetukset (suuri kontrasti, värisokeus)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Asetukset",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$e = {
	definition: {
		data1: {
			content: "Sisältöä kirjoitetaan",
			title: "Käytä tietosuojaa koskevan vaikutustenarvioinnin työkalua"
		},
		data2: {
			qa1: {
				content: "Sovelluksen sulkeminen ja käynnistäminen uudelleen korjaa yleensä ongelmat. Et menetä syöttämiäsi tietoja; ne tallentuvat automaattisesti syötön yhteydessä.",
				title: "Näkymässä on ongelmia; esimerkiksi kuvakkeiden tila ei vaihdu tai käyttöliittymästä puuttuu elementtejä"
			},
			qa2: {
				content: "Ongelma on tiedossa, ja sitä korjataan parhaillaan. Jos kohtaat ongelman, suosittelemme syöttämään riskin arvioidun vakavuuden ja todennäköisyyden perustelut-kenttään. Voit muokata asteikkoa, kun virhe on korjattu.",
				title: "Riskin vakavuuden ja todennäköisyyden asteikkojen päivittäminen ei onnistu"
			},
			qa3: {
				content: "Vaikutustenarviointien tuonnin yhteydessä on havaittu useita virheitä, erityisesti riskien vakavuuden ja todennäköisyyden asteikkojen on raportoitu katoavan näytöltä. Katso yllä oleva ratkaisu. Lisäksi vaikutustenarvioinnit eivät aina näy ohjauspaneelissa tuonnin jälkeen. Kyseessä on puhtaasti näkymää koskeva ongelma, jonka pitäisi korjaantua, kun sivu ladataan uudelleen.",
				title: "Tietosuojaa koskevan vaikutustenarvioinnin tuonnissa on ongelmia"
			},
			qa4: {
				content: "Tämä on puhtaasti graafinen virhe eikä vaikuta kenttään syötettyyn tekstiin. Virhettä korjataan parhaillaan.",
				title: "Kopioitu/liitetty teksti on korostettu"
			},
			qa5: {
				content: "Kaikki osion kentät on täytettävä ennen arviointia. Tarkista vielä, onko kaikki kentät täytetty. Riskin arviointia voi pyytää vasta, kun sille on määritelty vähintään yksi riskiä lieventävä tekninen tai organisatorinen toimenpide.",
				title: "Osion arviointi ei onnistu"
			},
			qa6: {
				content: "Sulje tietosuojaa koskeva vaikutustenarviointi ja avaa se uudelleen. Sisällön pitäisi nyt näkyä valitsemallasi kielellä.",
				title: "Tekstit eivät muutu, kun vaihdan kieltä"
			},
			qa7: {
				content: "Navigaatiovalikon kuvakkeet eivät tällä hetkellä päivity vaikutustenarvioinnin hylkäämisen jälkeen. Sinun on tarkistettava jokainen osio erikseen ja muutettava tiedot ja/tai arvioinnit vaikutustenarvioinnin hylkäämisen syiden mukaisesti. Kun kaikki osiot on tarkastettu, validoinnin pyytämisen pitäisi taas olla mahdollista.",
				title: "Hylkäsin tietosuojaa koskevan vaikutustenarvioinnin, mitä seuraavaksi pitää tehdä?"
			},
			title: "Tiedossa olevat ongelmat"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Ohje"
};
var homepage$e = {
	cards: {
		author: "Muokkaus",
		category: "TO TRANSLATE - Category",
		creation_status: "Luonti",
		date: "Päiväys",
		evaluation: "Tarkasta",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Tuo vaikutustenarviointi",
		import_structure: "TO TRANSLATE - Import template",
		item: {
			consult_pia: "TO TRANSLATE - Consult",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "TO TRANSLATE - Edit",
			edit_structure: "TO TRANSLATE - Edit template",
			tools: {
				action_plan: "Näytä<br>toimintasuunnitelma",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Kahdenna",
				"export": "Vie",
				more_options: "Lisää valintoja",
				pia: "Näytä<br>Tietosuojaa koskeva vaikutustenarviointi",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Uusi vaikutustenarviointi",
		new_structure: "TO TRANSLATE - New template",
		or: "tai",
		pia_name: "Tietosuojaa koskeva vaikutustenarviointi",
		placeholder_author: "Etunimi, sukunimi",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Etunimi, sukunimi",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Tuo vaikutustenarviointi",
		placeholder_import_structure: "TO TRANSLATE - Import template",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Uusi vaikutustenarviointi",
		placeholder_new_structure: "TO TRANSLATE - New template",
		placeholder_pia_name: "Vaikutustenarvioinnin otsikko",
		placeholder_sector_name: "TO TRANSLATE - Associated sector's name",
		placeholder_start: "Kaikki kentät tulee täyttää",
		placeholder_structure: "TO TRANSLATE - Default template",
		placeholder_structure_name: "TO TRANSLATE - Template's title",
		placeholder_validation: "Etunimi, sukunimi",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		start: "Aloita",
		status: "Tila",
		structure: "TO TRANSLATE - Template",
		structure_name: "TO TRANSLATE - Template's name",
		title_close_creation: "Sulje",
		validation: "Validointi"
	},
	filters: {
		assessor: "Tarkastaja",
		author: "Laatija",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Aloitetaan!<br><br>Luo vaikutustenarviointi<br>  napsauttamalla Uusi vaikutustenarviointi -painiketta",
		card_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous !<br><br>Pour commencer<br>un modèle, cliquez<br> sur le +",
		category: "TO TRANSLATE - Category",
		date: "Päiväys",
		import_pia: "Tuo vaikutustenarviointi",
		import_structure: "TO BE TRANSLATED - Importer modèle",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Aloitetaan! Luo vaikutustenarviointi <br> napsauttamalla +-painiketta",
		list_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous ! Pour commencer<br>un modèle, cliquez sur le +",
		name: "Nimi",
		new_pia: "Uusi vaikutustenarviointi",
		new_structure: "TO BE TRANSLATED - Nouveau modèle",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		sort: "Lajittele",
		sort_by: "kriteeri",
		status: "Tila",
		validator: "Hyväksyjä"
	},
	lists: {
		column_actions: "Toiminnat",
		column_author: "Muokkaus",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Luotu",
		column_evaluation: "Tarkasta",
		column_pia: "Tietosuojaa koskeva vaikutustenarviointi",
		column_progression: "Edistyminen",
		column_sector_name: "TO TRANSLATE - Associated sector",
		column_status: "Tila",
		column_structure: "TO TRANSLATE - Template",
		column_structure_name: "TO TRANSLATE - Template",
		column_updated_at: "Viimeksi avattu",
		column_validation: "Validointi",
		item: {
			tools: {
				action_plan: "Näytä toimintasuunnitelma",
				archive: "TO TRANSLATE - Archive",
				consult: "Kysy neuvoa",
				duplicate: "Kahdenna",
				edit: "Muokkaa",
				"export": "Vie",
				pia: "Näytä vaikutustenarviointi",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$e = {
	add_measure: "Lisää",
	add_measure_hint: "Voit myös lisätä toimenpiteen tietopankista.",
	category: {
		definition: "Määritelmä",
		example: "Esimerkki",
		general_measure: "Fyysinen suojaustoimi",
		measure_on_data: "Looginen suojaustoimi",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Organisatorinen suojaustoimi",
		principle: "Periaate"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Kaikki",
		definitions: "Määritelmät",
		general_measures: "Fyysiset suojaustoimet",
		measures_on_data: "Loogiset suojaustoimet",
		no_result: "Hakutuloksia ei löytynyt.",
		organizational_measures: "Organisatoriset suojaustoimet",
		title: "Suodattimet"
	},
	placeholder_add_measure: "Lisää tämä toimenpide",
	placeholder_help: "Täytön aputyökalut",
	search: "Haku",
	slugs: {
		PIA_DEF_ACC: {
			description: "Rekisteröidyllä on oikeus saada rekisterinpitäjältä vahvistus siitä, että häntä koskevia henkilötietoja käsitellään tai että niitä ei käsitellä, ja jos näitä henkilötietoja käsitellään, oikeus saada pääsy henkilötietoihin sekä <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">15 artiklassa  [GDPR] kuvatut tiedot.</a>",
			name: "Oikeus saada pääsy tietoihin",
			source: "Yleisen tietosuoja-asetuksen  15 artikla"
		},
		PIA_DEF_ANO: {
			description: "Tunnistetietojen poistaminen henkilötiedoista. Anonymisointiprosessien riittävyyttä voi arvioida <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_fi.pdf\">WP29:n ohjeen</a> avulla.",
			name: "Anonymisointi",
			source: "Measures_US ja ohje G29 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_fi.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Henkilötiedot sisältävien sähköisten arkistojen säilytys- ja hallintamenetelmät, joilla varmistetaan tietojen arvon (laillisen arvon) säilyminen tarvittavaksi ajaksi (siirto, säilytys, migraatio, käytettävyys, tuhoaminen, arkistointipolitiikka, luottamuksellisuuden turvaaminen jne.).",
			name: "Arkistointi",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Jokainen henkilö, jolla on käyttöoikeudet henkilötietoihin (työntekijät, rekisterinpitäjän lukuun toimivat käsittelijät ja kolmannet osapuolet) tulee tunnistaa yksilöllisellä tunnisteella. Valitse asiayhteyden, riskitason ja vaadittavan vahvuuden mukainen todentamismenetelmä, jolla käyttäjät kirjautuvat istuntoon. Suositukset: jos riskitaso ei ole kohonnut, salasanan käyttö on mahdollista. Korkeampien riskien tapauksessa tulee kuitenkin käyttää käyttäjän itse valitseman salasanan lisäksi kertakäyttöisiä salasanoja tai tekstiviestillä lähetettävää salasanaa, PIN-koodikorttia, sähköistä sertifikaattia tai muuta vahvan todentamisen menetelmää.",
			name: "Todentaminen",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Henkilötietojen koodaaminen sellaiseen muotoon, että vain valtuutetut henkilöt voivat lukea niitä (symmetrinen tai epäsymmetrinen salaus, vahvoiksi tiedettyjen julkisten algoritmien käyttö, todentamissertifikaatti jne.).",
			name: "Salaus",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Tietojen järjestämismenetelmiä, jotka pienentävät henkilötietojen yhdistelemisen ja kaikkia henkilötietoja  koskevan tietoturvaloukkauksen mahdollisuutta. Esimerkki hajauttamisesta olisi vain kunkin liiketoimintaprosessin kannalta hyödyllisten henkilötietojen määritteleminen ja looginen erottaminen muista tiedoista.",
			name: "Henkilötietojen hajauttaminen",
			source: "PIA3 s. 19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Mikä tahansa vapaaehtoinen, yksilöity, tietoinen ja yksiselitteinen tahdonilmaisu, jolla rekisteröity hyväksyy henkilötietojensa käsittelyn antamalla suostumusta ilmaisevan lausuman tai toteuttamalla selkeästi suostumusta ilmaisevan toimen.<br>Ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">4 artiklan 10 kohta, [GDPR]</a>",
			name: "Suostumus",
			source: "Yleisen tietosuoja-asetuksen  4 artiklan 10 kohta"
		},
		PIA_DEF_CTLA: {
			description: "Keinot, joilla rajoitetaan henkilötietojen luvattoman käytön riskiä. Se edellyttää muun muassa: <br>- <strong>käyttäjäprofiilien hallintaa</strong> tehtävien ja vastuualueiden (mieluiten keskitetyn) avulla, joilla rajoitetaan henkilötietojen käyttöoikeudet määritetyille käyttäjille työtehtävien mukaan, ja<br>- <strong>henkilöstön, rekisterinpitäjän lukuun toimivien käsittelijöiden ja kolmansien osapuolten oikeuksien peruuttamista, kun heillä ei enää ole oikeutta käyttää tiloja tai resurssia</strong> tai kun <strong>heidän työsopimuksensa päättyy</strong>.",
			name: "Pääsynvalvonta",
			source: "PIA3 s. 43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Kaikki tunnistettuun tai tunnistettavissa olevaan luonnolliseen henkilöön (rekisteröity), liittyvät tiedot; tunnistettavissa olevana pidetään luonnollista henkilöä, joka voidaan suoraan tai epäsuorasti tunnistaa erityisesti tunnistetietojen, kuten nimen, henkilötunnuksen, sijaintitiedon, verkkotunnistetietojen taikka yhden tai useamman hänelle tunnusomaisen fyysisen, fysiologisen, geneettisen, psyykkisen, taloudellisen, kulttuurillisen tai sosiaalisen tekijän perusteella. <br>Ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">4 artiklan 1 kohta, [GDPR]</a>",
			name: "Henkilötiedot",
			source: "Yleisen tietosuoja-asetuksen 4 artiklan 1 kohta"
		},
		PIA_DEF_DEST: {
			description: "Luonnollinen henkilö tai oikeushenkilö, viranomainen, virasto tai muu elin, jolle henkilötietoja luovutetaan, oli kyseessä kolmas osapuoli tai ei. Viranomaisia, joille luovutetaan henkilötietoja määrätyn, unionin oikeuteen tai jäsenvaltion lainsäädäntöön perustuvan selvitystyön tekemiseksi, ei pidetä tietosuoja-asetuksen määritelmän mukaisina vastaanottajina. Viranomaisten on käsiteltävä tietoja käsittelyn tarkoitusten mukaisesti ja tietosuojasääntöjä noudattaen. <br>Ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">4 artiklan 9 kohta, [GDPR]</a>",
			name: "Vastaanottaja",
			source: "Yleisen tietosuoja-asetuksen  4 artiklan 9 kohta"
		},
		PIA_DEF_EFF: {
			description: " Rekisteröidyllä on oikeus saada rekisterinpitäjä poistamaan rekisteröityä koskevat henkilötiedot ilman aiheetonta viivytystä, ja rekisterinpitäjällä on velvollisuus poistaa henkilötiedot ilman aiheetonta viivytystä; ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">17  artikla, [GDPR].</a>",
			name: "Oikeus tietojen poistamiseen",
			source: "Yleisen tietosuoja-asetuksen  17 artikla"
		},
		PIA_DEF_ENJ: {
			description: "Odotetut edut (organisaatiolle, rekisteröidyille, yhteiskunnalle jne.).",
			name: "Intressi",
			source: "PIA1 s. 4, alaviite 8"
		},
		PIA_DEF_EXA: {
			description: "Henkilötietojen on oltava täsmällisiä ja tarvittaessa päivitettyjä; on toteutettava kaikki mahdolliset kohtuulliset toimenpiteet sen varmistamiseksi, että käsittelyn tarkoituksiin nähden epätarkat ja virheelliset henkilötiedot poistetaan tai oikaistaan viipymättä (”täsmällisyys”). <br>Ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">5 artiklan 1 kohdan d alakohta, [GDPR]</a>",
			name: "Tietojen laatu",
			source: "Yleisen tietosuoja-asetuksen 5 artiklan 1 kohdan d alakohta"
		},
		PIA_DEF_GRV: {
			description: "Vakavuus kuvaa riskin suuruutta. Se määräytyy pääasiassa mahdollisten vaikutusten haitallisuuden mukaan.",
			name: "Vakavuus",
			source: "PIA1 s. 6"
		},
		PIA_DEF_LIM: {
			description: "Rekisteröidyllä on oikeus siihen, että rekisterinpitäjä rajoittaa käsittelyä; ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">18  artikla, [GDPR]</a>",
			name: "Oikeus käsittelyn rajoittamiseen",
			source: "Yleisen tietosuoja-asetuksen  18 artikla"
		},
		PIA_DEF_LOG: {
			description: "Laatikaa lokiarkkitehtuuri, joka mahdollistaa henkilötietojen tietoturvaloukkausten varhaisen havaitsemisen ja jonka tiedot auttavat loukkausten analysoimisessa tai voivat toimia todisteina tutkimuksissa.",
			name: "Valvonta",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Menettely, joka on ristiriidassa yhden tai useamman tietoturvamenettelyn kanssa. Riskitekijät, jotka voivat aiheuttaa tahallisesti tai tahattomasti ei-toivotun tapahtuman.",
			name: "Uhka",
			source: "PIA1 s. 12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Uhkia: - <strong>Laitteiston</strong> asiaton käyttö, tarkkailu, muuntelu, häviäminen (arkaluonteisen laitteiston käyttö tai kuljettaminen henkilökohtaisiin tarkoituksiin, toisen henkilön laitteen ruudun katseleminen junassa, laitteistopohjaisen key logger -ohjelman avulla jäljittäminen jne.)<br> - <strong>Ohjelmiston</strong> asiaton käyttö, tarkkailu, muuntelu (käyttöoikeuksien tason korottaminen, konfiguraatiotietojen kerääminen, haitallisella koodilla tartuttaminen jne.)<br>- <strong>Tietokonekanavien</strong> tarkkailu (Ethernet-liikenteen sieppaaminen jne.)<br>- <strong>Ihmisten</strong> tarkkailu, manipulaatio, katoaminen (tietojen tahaton paljastaminen, sosiaalinen tiedustelu, työtehtävien muutokset)<br>- <strong>Paperiasiakirjojen</strong> tarkkailu, katoaminen (lukeminen, postivarkaus jne.)<br>- <strong>Paperisten asiakirjojen lähetyskanavien</strong> tarkkailu (kierrossa olevien allekirjoituskappaleiden lukeminen jne.)",
			name: "Uhat, jotka voivat johtaa luvattomaan käyttöön",
			source: "PIAF Connected Objects s. 40 ja 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Uhkia: </strong><br>- <strong>Laitteisto</strong>: asiaton käyttö, ylikuormittuminen, muuntelu, vahingoittuminen, katoaminen (tallennusväline täynnä, käsittelykapasiteetin ylikuormittuminen, yhteensopimattomien laitteiden kytkemisestä aiheutuvat viat, tulipalo, varkaus tai resurssien menetys jne.)<br>- <strong>Ohjelmisto</strong>: asiaton käyttö, ylikuormittuminen, muuntelu, vahingoittuminen, katoaminen (tietojen pyyhkiytyminen, tietokannan kapasiteetin ylittyminen, looginen pommi, tietojen käyttämiseen tarvittavan ohjelmiston lisenssin uusimatta jättäminen jne.)<br>- <strong>Tietokonekanavat</strong>: ylikuormittuminen, muuntelu, katoaminen (luvaton lataus, internet-yhteyden katkeaminen jne.)<br>- <strong>Ihmiset</strong>: ylikuormittuminen, tapaturmat, katoaminen (taitojen huono hyödyntäminen, sairaudet, eläköityminen jne.)<br>- <strong>Paperiset asiakirjat</strong>: asiaton käyttö, vahingoittuminen, katoaminen (tekstin poistaminen, arkistoitujen asiakirjojen ikääntyminen, asiakirjojen varkaus tai katoaminen jne.)<br>- <strong>Paperisten asiakirjojen lähetyskanavat</strong>: ylikuormittuminen, vahingoittuminen, muuntelu, katoaminen (postinkuljetuksen keskeytyminen lakon vuoksi, toimitilojen muuttaminen, asiakirjojen hukkaaminen kuljetusyhtiön toimesta, paperisten asiakirjojen lähetyskanavien uudelleenjärjestely jne.)",
			name: "Uhkien toteutuminen voi johtaa henkilötietojen katoamiseen",
			source: "PIAF Connected Objects s. 44 ja 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Uhkia: </strong><br>- <strong>Laitteiston</strong> muokkaus (yhteensopimattomien laitteiden lisäämisen aiheuttamat viat, välttämättömien komponenttien irrottaminen jne.)<br>- <strong>Ohjelmiston</strong> asiaton käyttö tai muokkaus (ei-toivotut muutokset tietokannoissa oleviin tietoihin, käyttäjän virheet, jotka aiheuttavat tietoihin muutoksia jne.)<br>- <strong>Tietokonekanavien</strong> asiaton käyttö (kaapattujen tietojen lähettäminen eteen päin jne.)<br>- <strong>Ihmisten</strong> ylikuormittaminen tai manipulaatio (henkilökunnan kapasiteetin ylittävien tehtävien antaminen, stressi tai negatiiviset muutokset työympäristössä, vaikutusvalta jne.)<br>- Paperisten asiakirjojen muuttaminen (lukujen peukalointi, vaihtaminen väärennökseen jne.)<br>- <strong>Paperisten asiakirjojen lähetyskanavien</strong> muuntelu (siirtäminen allekirjoituskansiosta toiseen, useiden ristiriitaisten asiakirjojen lähettäminen jne.)",
			name: "Uhat, jotka voivat johtaa henkilötietojen ei-toivottuun muokkaamiseen",
			source: "PIAF Connected Objects s. 43 ja 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Valitaan kohdassa ”Suunnitellut tai tehdyt toimenpiteet” luetelluista toimenpiteistä. Kohtaa voi täydentää tarvittaessa.",
			name: "Toimenpiteet",
			source: "Ei ole"
		},
		PIA_DEF_MIN1: {
			description: "Tietojen tuomisen yhteydessä voi tallentua tahattomasti metadataa. <br>Tällainen metadata on tunnistettava ja poistettava, jos se ei ole välttämätöntä tietojen käsittelyn määriteltyä tarkoitusta varten.",
			name: "Suodatus ja poistaminen",
			source: "PIAF Connected Objects s. 42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Yleisten tietojen osana tai yksinomaan tilastollisia tarkoituksia varten saadut arkaluonteiset tiedot voidaan muuntaa vähemmän arkaluonteiseen muotoon tai pseudonymisoida. Esimerkiksi: <br>- Jos järjestelmä tallentaa IP-osoitteen käyttäjän sijainnin määrittelemiseksi tilastoja varten, IP-osoite voidaan poistaa, kun kaupunki tai kaupunginosa on määritelty<br>- Videotietoja valvontakameroista vastaanottava järjestelmä voi tunnistaa kuvassa seisovat tai liikkuvat ihmiset ja sumentaa heidät tunnistamattomiksi<br>- Älykäs kulutusmittari voi koostaa tietyn aikavälin energiankulutustiedot tallentamatta niitä reaaliaikaisesti",
			name: "Tietojen arkaluonteisuuden vähentäminen",
			source: "PIAF Connected Objects s. 42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Järjestelmä voi varmistaa, että: <br>- käyttäjä voi käyttää resursseja tai palveluita ilman vaaraa hänen henkilöllisyytensä paljastumisesta (anonyymit tiedot)<br>- käyttäjä voi käyttää resursseja tai palveluita ilman vaaraa hänen henkilöllisyytensä paljastumisesta, mutta olla kuitenkin tunnistettavissa ja vastuussa käytöstä (pseudonymisoidut tiedot)<br>- käyttäjä voi käyttää useita resursseja tai palveluita ilman, että käyttökertoja voi liittää toisiinsa (tietoja ei voi yhdistellä)<br>- käyttäjä voi käyttää resursseja tai palveluita ilman, että muut tahot ja erityisesti kolmannet osapuolet voivat havaita, että resurssia tai palvelua käytetään (havaitsemattomuus)<br>Yllä olevasta listasta tulee valita tunnistettujen uhkien mukaiset menetelmät. Pseudonymisointi sopii joihinkin yksityisyyteen kohdistuviin uhkiin paremmin kuin anonymisointi (esimerkiksi jos käytön on oltava jäljitettävissä). Jotkut yksityisyyteen kohdistuvat uhat vaativat usean menetelmän yhdistelmää.",
			name: "Tietojen tunnistettavuuden vähentäminen",
			source: "PIAF Connected Objects s. 42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Järjestelmä voidaan järjestää itsenäisiin osiin, joilla on erilliset pääsynvalvontatoiminnot. Tiedot voidaan myös jakaa näiden itsenäisten alijärjestelmien välillä, ja jokainen alijärjestelmä voi käyttää tietoja erillisillä pääsynvalvontamekanismeilla. Tällöin yhden alijärjestelmän vaarantuminen ei vaikuta yhtä paljon tietoihin kokonaisuutena.",
			name: "Tietojen kertymisen vähentäminen",
			source: "PIAF Connected Objects s. 42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Järjestelmä voi rajoittaa tietojen käyttöoikeudet käyttäjille, jotka tarvitsevat tietoja. Järjestelmä kykenee erottelemaan erityiset henkilötietoryhmät ja soveltamaan niihin erillisiä pääsynvalvontakäytänteitä. Järjestelmä pystyy suojelemaan erityisten henkilötietoryhmien luottamuksellisuutta siirron ja varastoinnin aikana salaamalla tiedot. Myös henkilötietojen käsittelyn yhteydessä syntyvät väliaikaiset evästeet on suojattava.",
			name: "Tietojen käyttöoikeuksien rajoittaminen",
			source: "PIAF Connected Objects s. 42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Riskien pienentäminen rajoittamalla käsiteltävien henkilötietojen määrä tietoihin, jotka ovat käsittelyn määriteltyä tarkoitusta varten ehdottoman välttämättömiä. Muita tietoja ei tule kerätä.",
			name: "Henkilötietojen määrän minimointi",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Pienennä henkilötietietojen käsittelyyn liittyvää riskiä minimoimalla käsiteltävät henkilötiedot. Henkilötietoja voidaan minimoida esimerkiksi vähentämällä tiedon arkaluonteisuutta suodattamalla, pseudonymisoimalla ja poistamalla kaikki tarpeettomat tiedot.",
			name: "Henkilötietojen minimointi",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Rekisteröidyllä on oikeus henkilökohtaiseen erityiseen tilanteeseensa liittyvällä perusteella milloin tahansa vastustaa häntä koskevien henkilötietojen käsittelyä <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">21  artiklan, [GDPR] mukaisesti.</a>",
			name: "Vastustamisoikeus",
			source: "Yleisen tietosuoja-asetuksen  21 artikla"
		},
		PIA_DEF_PBDS: {
			description: "Toimenpiteet, joilla henkilötietojen suojaus toteutetaan kaikissa uusissa käsittelyoperaatioissa (luotetut henkilöt, ohjeet, riskienhallintamenetelmät tai muut sisäiset käytänteet).",
			name: "Projektinhallinta",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Henkilö, johon käsiteltävät tiedot liittyvät.",
			name: "Rekisteröity",
			source: "PIA1 s. 9"
		},
		PIA_DEF_PORT: {
			description: " Rekisteröidyllä on oikeus saada häntä koskevat henkilötiedot, jotka hän on toimittanut rekisterinpitäjälle, jäsennellyssä, yleisesti käytetyssä ja koneellisesti luettavassa muodossa, ja oikeus siirtää kyseiset tiedot toiselle rekisterinpitäjälle sen rekisterinpitäjän estämättä, jolle henkilötiedot on toimitettu; ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">20  artikla [GDPR].</a>",
			name: "Oikeus siirtää tiedot järjestelmästä toiseen",
			source: "Yleisen tietosuoja-asetuksen  20 artikla"
		},
		PIA_DEF_PSEU: {
			description: "Henkilötietojen käsitteleminen siten, että henkilötietoja ei voida enää yhdistää tiettyyn rekisteröityyn käyttämättä lisätietoja, edellyttäen että tällaiset lisätiedot säilytetään erillään ja niihin sovelletaan teknisiä ja organisatorisia toimenpiteitä, joilla varmistetaan, ettei henkilötietojen yhdistämistä tunnistettuun tai tunnistettavissa olevaan luonnolliseen henkilöön tapahdu.<br>Pseudonymisointi vähentää tietojoukon liitettävyyttä rekisteröidyn alkuperäiseen henkilöllisyyteen ja on näin ollen hyödyllinen suojatoimenpide, muttei anonymisoi tietoja.",
			name: "Pseudonymisointi",
			source: "Yleisen tietosuoja-asetuksen  4 artiklan 5 kohta ja ohje G29, s. 22 http://ec.europa.eu/justice/article-29/documentation/opinion-recommendation/files/2014/wp216_fi.pdf"
		},
		PIA_DEF_PWD: {
			description: "Salasanojen tulee sisältää vähintään kahdeksan merkkiä. Salasanat tulee vaihtaa, jos niiden paljastumisesta on pienintäkään epäilystä, ja lisäksi mahdollisesti väliajoin (puolen vuoden tai vuoden välein). Salasanojen tulee sisältää vähintään kolmea tai neljää merkkityyppiä (isot kirjaimet, pienet kirjaimet, numerot ja erikoismerkit). Kun salasana vaihdetaan, uudeksi salasanaksi ei saa valita mitään viidestä edellistä salasanasta. Samaa salasanaa ei tule käyttää eri järjestelmiin. Salasanoja ei pidä johtaa henkilökohtaisista tiedoista (kuten nimestä tai syntymäajasta). Määrittele sallittujen kirjautumisyritysten määrä, ennen kuin käyttäjälle lähetetään varoitus ja tili lukitaan (väliaikaisesti tai kunnes se avataan manuaalisesti).",
			name: "Salasana",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Rekisteröidyllä on oikeus vaatia, että rekisterinpitäjä oikaisee ilman aiheetonta viivytystä rekisteröityä koskevat epätarkat ja virheelliset henkilötiedot. Ottaen huomioon tarkoitukset, joihin tietoja käsiteltiin, rekisteröidyllä on oikeus saada puutteelliset henkilötiedot täydennettyä, muun muassa toimittamalla lisäselvitys.",
			name: "Oikeus tietojen oikaisemiseen",
			source: "Yleisen tietosuoja-asetuksen  16 artikla"
		},
		PIA_DEF_RGPD: {
			description: "Euroopan parlamentin ja neuvoston asetus (EU) 2016/679 luonnollisten henkilöiden suojelusta henkilötietojen käsittelyssä sekä näiden tietojen vapaasta liikkuvuudesta ja direktiivin 95/46/EY kumoamisesta.",
			name: "GDPR (Yleinen tietosuoja-asetus)",
			source: "Yleisen tietosuoja-asetuksen otsikko"
		},
		PIA_DEF_RT: {
			description: "Luonnollinen henkilö tai oikeushenkilö, viranomainen, virasto tai muu elin, joka yksin tai yhdessä toisten kanssa määrittelee henkilötietojen käsittelyn tarkoitukset ja keinot; jos tällaisen käsittelyn tarkoitukset ja keinot määritellään unionin tai jäsenvaltioiden lainsäädännössä, rekisterinpitäjä tai tämän nimittämistä koskevat erityiset kriteerit voidaan vahvistaa unionin oikeuden tai jäsenvaltion lainsäädännön mukaisesti.<br>Ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">4 artiklan 7 kohta, [GDPR]</a>",
			name: "Rekisterinpitäjä",
			source: "Yleisen tietosuoja-asetuksen  4 artiklan 7 kohta"
		},
		PIA_DEF_SRC: {
			description: "Henkilö tai ei-inhimillinen tekijä, joka voi aiheuttaa riskin. Riskitekijän toiminta voi olla tahatonta tai tahallista.",
			name: "Riskitekijä",
			source: "PIA1 s. 11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Luonnollinen henkilö tai oikeushenkilö, viranomainen, virasto tai muu elin, joka käsittelee henkilötietoja rekisterinpitäjän lukuun; ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">4 artiklan  8 kohta, [GDPR]</a>.<br>Henkilötietojen käsittelijä tai kukaan rekisterinpitäjän tai henkilötietojen käsittelijän alaisuudessa toimiva henkilö, jolla on pääsy henkilötietoihin, ei saa käsitellä niitä muuten kuin rekisterinpitäjän ohjeiden mukaisesti, ellei unionin oikeudessa tai jäsenvaltion lainsäädännössä niin vaadita; ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">29 artikla,  [GDPR]</a>.",
			name: "Henkilötietojen käsittelijä",
			source: "Yleisen tietosuoja-asetuksen  4 artiklan 8 kohta ja 29 artikla "
		},
		PIA_DEF_SUPT: {
			description: "Resurssit, joita henkilötietojen käsittely vaatii. Ne voivat sisältää laitteistoja, ohjelmistoja, verkostoja, henkilöitä, asiakirjoja ja asiakirjojen välittämiseen käytettäviä kanavia.",
			name: "Tietojen käsittelyyn käytettävät resurssit",
			source: "PIA1 s. 10"
		},
		PIA_DEF_VIOL: {
			description: "Tietoturvaloukkaus, jonka seurauksena on siirrettyjen, tallennettujen tai muuten käsiteltyjen henkilötietojen vahingossa tapahtuva tai lainvastainen tuhoaminen, häviäminen, muuttaminen, luvaton luovuttaminen taikka pääsy tietoihin.",
			name: "Henkilötietojen tietoturvaloukkaus",
			source: "Yleisen tietosuoja-asetuksen  4 artiklan 12 kohta"
		},
		PIA_DEF_VRA: {
			description: "Todennäköisyys kuvaa riskin toteutumisen mahdollisuutta. Se riippuu pääasiassa käsittelyssä käytettävien resurssien haavoittuvuudesta uhille ja riskitekijöiden kyvyistä hyödyntää niiden haavoittuvuuksia.",
			name: "Todennäköisyys",
			source: "PIA1 s. 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Tunnistetiedot</strong>: Kansallisuus, henkilöllisyys, ikä jne. <br><strong>Yksityiselämä</strong>: elintavat, siviilisääty jne. <br><strong>Työelämä</strong>: ansioluettelo, koulutus ja ammatillinen koulutus, palkinnot jne. <br><strong>Yhteyden tiedot</strong>: IP-osoitteet, tapahtumalokit jne.<br><strong>Sijaintitiedot</strong>: matkustelu, GPS-tiedot, GSM-tiedot jne.<br><strong>Muut</strong>: puhelinnumero, sähköpostiosoite jne.",
			name: "Yleiset henkilötiedot",
			source: "PIA2:n vanha versio - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Filosofinen, poliittinen ja uskonnollinen vakaumus, ammattiliiton jäsenyys, seksuaalinen käyttäytyminen ja suuntautuminen, terveystiedot, rodullinen tai etninen alkuperä, terveyttä ja seksuaalielämää koskevat tiedot, rikostuomioita ja rikkomuksia tai niihin liittyviin turvaamistoimiin liittyvät henkilötiedot; ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">9 ja  10 artikla, [GDPR]</a>.",
			name: "Rikkomuksia ja tuomioita sekä erityisiä henkilötietoryhmiä koskevat tiedot"
		},
		PIA_EX_DCPS: {
			description: "Henkilötunnus, biometriset tiedot, pankkitiedot",
			name: "Erityistä suojaamista edellyttävät henkilötiedot"
		},
		PIA_EX_HUME: {
			description: "Tähän kategoriaan sisältyvät:<br>- arvaamaton tai naiivi naapuri, joka tunkeutuu laitteen tietoihin fyysisen läheisyyden turvin<br>- hakkeri, jolla on hallussaan tietoa käyttäjästä ja joka hyökkää sen avulla käyttäjää vastaan<br>- hakkeri, joka pyrkii vahingoittamaan yrityksen julkisuuskuvaa hallussaan olevilla tiedoilla<br>- ulkopuolinen yritys, jolla on järjestelmän käyttöoikeus ja joka käyttää oikeuksiensa avulla tietoja luvattomasti",
			name: "Ulkoiset inhimilliset riskitekijät"
		},
		PIA_EX_HUMI: {
			description: "Tähän kategoriaan sisältyvät:<br>- huolimattomat tai arvaamattomat työntekijät, järjestelmän läheisyys, potentiaalisesti runsaat taidot, käyttöoikeudet ja käytettävissä oleva aika, mahdollinen koulutuksen ja ymmärryksen puute<br>- huolimattomat tai arvaamattomat käyttäjät, perheenjäsenet tai ystävät, joilla on pääsy palveluun<br> Toiminnalle on useita mahdollisia syitä, kuten taitamattomuus, virheet, huolimattomuus, pelit, vihamieliset aikomukset, kosto ja vakoilu.",
			name: "Sisäiset inhimilliset riskitekijät"
		},
		PIA_EX_IMPI: {
			description: "Rekisteröidyille voi aiheutua vakavia seurauksia, joista he selviytyvät vain todellisten ja vakavien vaikeuksien jälkeen. Esimerkiksi: <br>- Fyysinen: vakava fyysinen sairaus, joka aiheuttaa pitkäaikaista vahinkoa (terveyden heikkeneminen väärän hoidon seurauksena), fyysisistä vammoista toipuminen esim. pahoinpitelyn, onnettomuuden tai työtapaturman jälkeen jne.<br>- Aineellinen: korvaamatta jäävä varojen kavallus, rekisteröidyn ainutlaatuisten ja kertaluonteisten mahdollisuuksien menetykset (asuntolaina, opiskelu-, harjoittelu- tai työpaikan epääminen, kokeesta tai tentistä sulkeminen), asunnon menetys, työpaikan menetys jne.;<br>- Henkinen: vakavat psykiatriset häiriöt (masennus, fobia), tunne yksityisyyden loukkauksesta ja peruuttamatonta vahinkoa, joutuminen kiristyksen, kyberkiusaamisen tai häirinnän uhriksi jne.",
			name: "Merkittävä vaikutus"
		},
		PIA_EX_IMPL: {
			description: "Rekisteröidyille voi aiheutua merkittävää vaivaa, josta he voivat kuitenkin selvitä kohtuullisin vaikeuksin. Esimerkiksi:<br>- Fyysinen: lievät fyysiset vaivat, herjaus josta seuraa fyysinen tai psykologinen kosto jne.<br>- Aineellinen: odottamattomat maksut (virheellisesti määrätyt sakot), hallinnollisten tai kaupallisten palveluiden käytön epääminen, rekisteröidyn mainetta todennäköisesti vahingoittavien ei-toivottujen ja kohdennettujen sähköpostien saaminen jne.<br>- Henkinen: lievät mutta objektiivisesti todetut psykiatriset häiriöt, yksityisyyden loukkauksen tunne ilman peruuttamatonta vahinkoa, uhkailu sosiaalisissa verkostoissa jne.",
			name: "Rajoitettu vaikutus"
		},
		PIA_EX_IMPM: {
			description: "Rekisteröidyille voi aiheutua merkittäviä, jopa peruuttamattomia, seurauksia, joista he eivät välttämättä selviä. Esimerkiksi:<br>- Fyysinen: pitkittyneet tai pysyvät fyysiset sairaudet, pysyvä toimintakyvyn aleneminen, kuolema<br>- Aineellinen: taloudelliset riskit, merkittävät velat, työkyvyttömyys, liikkuvuuden menetys, todistusaineiston menetys oikeuskäsittelyssä, elintärkeän infrastruktuurin (vesi, sähkö) käytön estyminen jne.<br>- Henkinen: pitkittyneet tai pysyvät psykiatriset häiriöt, rikostuomio, kaapatuksi joutuminen, perhesiteiden katkeaminen, oikeustoimikelvottomuus ja/tai laillisen itsemääräämisoikeuden menetys (holhous) jne.",
			name: "Suurin vaikutus"
		},
		PIA_EX_IMPN: {
			description: "Tapahtumalla ei ole rekisteröityihin mitään vaikutusta, tai se aiheuttaa heille vain vähäistä vaivaa, josta on helppo selvitä. Esimerkiksi:<br>- Fyysinen: ohimenevä päänsärky<br>- Aineellinen: muodollisuuksien toistamisen tai täyttämisen odottamisen aiheuttama ajanhukka, ei-toivottujen sähköpostien (roskaposti) saaminen, verkkosivuilla julkaistujen tietojen käyttö kohdennettuun mainontaan jne.<br>- Henkinen: lievä mielipaha, tunne yksityisyyden loukkauksesta ilman todellista tai objektiivista haittaa (kaupallinen viestintä) jne.",
			name: "Vähäinen vaikutus"
		},
		PIA_EX_NHUM: {
			description: "Onnettomuus tai välikohtaus organisaation toimitiloissa (sähkökatkos, tulipalo, tulva jne.)",
			name: "Ei-inhimilliset riskitekijät"
		},
		PIA_EX_VRAI: {
			description: "Valittujen riskitekijöiden vaikuttaisi olevan mahdollista toteuttaa uhka hyödyntämällä henkilötietojen käsittelyssä käytettävien resurssien ominaisuuksia (esim. paperisten asiakirjojen varkaus toimistosta, johon pääsy edellyttää ilmoittautumista aulassa).",
			name: "Merkittävä todennäköisyys"
		},
		PIA_EX_VRAL: {
			description: "Valittujen riskitekijöiden vaikuttaisi olevan vaikeaa toteuttaa uhka hyödyntämällä henkilötietojen käsittelyssä käytettävien resurssien ominaisuuksia (esim. paperisten asiakirjojen varkaus kulkukortinlukijalla varustetusta huoneesta).",
			name: "Rajallinen todennäköisyys"
		},
		PIA_EX_VRAM: {
			description: "Valittujen riskitekijöiden vaikuttaisi olevan erittäin helppoa toteuttaa uhka hyödyntämällä henkilötietojen käsittelyssä käytettävien resurssien ominaisuuksia (esim. paperisten asiakirjojen varkaus julkisesta aulasta).",
			name: "Suurin todennäköisyys"
		},
		PIA_EX_VRAN: {
			description: "Ei vaikuta mahdolliselta, että valitut riskitekijät voisivat toteuttaa uhan hyödyntämällä henkilötietojen käsittelyssä käytettävien resurssien ominaisuuksia (esim. paperisten asiakirjojen varkaus kulkukortinlukijalla ja koodilukolla varustetusta huoneesta).",
			name: "Vähäinen todennäköisyys"
		},
		PIA_LGL_CONS: {
			description: "Suostumuksen tulee olla vapaaehtoinen, yksilöity, tietoinen ja yksiselitteinen tahdonilmaisu, jolla rekisteröity hyväksyy henkilötietojensa käsittelyn. Selvitä, nojautuuko henkilötietojen käsittely muuhun oikeusperusteeseen kuin 6 artiklaan, <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR].</a>",
			name: "Suostumus",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Määrittele ja kuvaa tietojenkäsittelyn laajuus yksityiskohtaisesti:<br>- käsiteltävät henkilötiedot sekä niiden vastaanottajat ja säilytysajat<br>- henkilötietojen käsittelyyn käytettävien prosessien ja resurssien kuvaukset tietojen koko elinkaaren ajalta (keräämisestä tuhoamiseen)",
			name: "Tiedot ja prosessit",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Esitä lyhyt kuvaus suunnitellusta henkilötietojen käsittelystä sekä sen luonteesta, laajuudesta, asiayhteydestä, tarkoituksesta ja intresseistä. Ilmoita rekisterinpitäjä ja mahdolliset muut henkilötietojen käsittelijät. Luettele tietojen käsittelyyn sovellettavat, tarvittavat tai pakolliset standardit, erityisesti hyväksytyt käytännesäännöt (ks. 40 artikla, <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) ja tietosuojatodistukset (ks. 42 artikla, <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>).",
			name: "Henkilötietojen käsittelyn kuvaus",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Luonnollinen henkilö tai oikeushenkilö, viranomainen, virasto tai muu elin, jolle henkilötietoja luovutetaan, oli kyseessä kolmas osapuoli tai ei. Viranomaisia, joille luovutetaan henkilötietoja määrätyn, unionin oikeuteen tai jäsenvaltion lainsäädäntöön perustuvan selvitystyön tekemiseksi, ei pidetä tietosuoja-asetuksen määritelmän mukaisina vastaanottajina. Viranomaisten on käsiteltävä tietoja käsittelyn tarkoitusten mukaisesti ja tietosuojasääntöjä noudattaen. Ks. 4 artiklan 9 kohta, [GDPR]).",
			name: "Vastaanottaja",
			source: "Yleisen tietosuoja-asetuksen 4 artiklan 9 kohta"
		},
		PIA_LGL_DUR: {
			description: "Jokaiselle kerättyjen henkilötietojen tyypille on määriteltävä säilytysaika, joka on perusteltava lainsäädännön vaatimuksilla ja/tai käsittelytarpeilla. Näin erotellaan alkuperäiseen käyttötarkoitukseen kerätyt tiedot niistä tiedoista, joita on säilytettävä pidemmän aikaa lainsäädännön perusteella. Tiedot on tuhottava määritetyn säilytysajan jälkeen. Määritä, miten tiedot poistetaan tarpeellisuusvaatimuksen ja määritettyjen säilytysaikojen mukaisesti.",
			name: "Säilytysajat",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Henkilötietoja on kerättävä tiettyä, nimenomaista ja laillista tarkoitusta varten, <strong>eikä niitä saa käsitellä myöhemmin näiden tarkoitusten kanssa yhteensopimattomalla tavalla.</strong> <br>Ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">5 artiklan 1 kohdan b alakohta, [GDPR]</a>",
			name: "Henkilötietojen käsittelyyn liittyvät periaatteet",
			source: "Yleisen tietosuoja-asetuksen 5 artiklan 1 kohdan b alakohta"
		},
		PIA_LGL_FOND: {
			description: "- Rekisteröity on antanut suostumuksensa henkilötietojensa käsittelyyn yhtä tai useampaa erityistä tarkoitusta varten <br>- Käsittely on tarpeen sellaisen sopimuksen täytäntöön panemiseksi, jossa rekisteröity on osapuolena, tai sopimuksen tekemistä edeltävien toimenpiteiden toteuttamiseksi rekisteröidyn pyynnöstä <br>- Käsittely on tarpeen rekisterinpitäjän lakisääteisen velvoitteen noudattamiseksi <br>- Käsittely on tarpeen rekisteröidyn tai toisen luonnollisen henkilön elintärkeiden etujen suojaamiseksi <br>- Käsittely on tarpeen yleistä etua koskevan tehtävän suorittamiseksi tai rekisterinpitäjälle kuuluvan julkisen vallan käyttämiseksi <br>- Käsittely on tarpeen rekisterinpitäjän tai kolmannen osapuolen oikeutettujen etujen toteuttamiseksi, paitsi milloin henkilötietojen suojaa edellyttävät rekisteröidyn edut tai perusoikeudet ja -vapaudet syrjäyttävät tällaiset edut, erityisesti jos rekisteröity on lapsi<br> Katso <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">6 artikla , [GDPR]</a> ",
			name: "Lainmukaisuusperuste",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Pidä huoli, että rekisteröityjä informoidaan heidän henkilötietojensa keräämisestä ja käsittelystä. Varmista, ettei informoinnin osalta ole säädetty poikkeuksia.",
			name: "Rekisteröityjen informointi",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Henkilötietojen käsittelyyn liittyviä riskejä tulee vähentää minimoimalla käsiteltävien henkilötietojen määrä eli rajoittamalla käsiteltävät henkilötiedot sellaisiin tietoihin, joiden käsittely on välttämätöntä käsittelyn tarkoituksen toteutumisella (muita henkilötietoja ei tule kerätä). Henkilötietojen arkaluonteisuutta on mahdollista vähentää minimoinnin avulla.",
			name: "Tietojen minimointi",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Jokaisen rekisterinpitäjän lukuun henkilötietoja käsittelevän käsittelijän on allekirjoitettava kirjallinen sopimus, jossa määritellään kaikki 28 artiklassa{j} [GDPR] määrätyt seikat: käsittelyn kohde ja kesto, käsittelyn luonne ja tarkoitus, henkilötietojen tyyppi ja rekisteröityjen ryhmät, rekisterinpitäjän velvollisuudet ja oikeudet, rekisterinpitäjän kirjalliset käsittelyohjeet, osoitusvelvollisuutta koskevien asiakirjojen toimittaminen, tietoturvaloukkauksista ilmoittaminen jne.",
			name: "Käsittely rekisterinpitäjän lukuun",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Resurssit, joita henkilötietojen käsittely vaatii. Huom: resurssit voivat sisältää laitteistoja, ohjelmistoja, verkostoja, henkilöitä, asiakirjoja ja asiakirjojen välittämiseen käytettäviä kanavia.",
			name: "Tietojen käsittelyyn käytettävät resurssit",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Riippuen siitä, mihin maahan siirrät tiedot, sinun on perusteltava valintasi ja osoitettava rekisteröidyn oikeuksien suojaamiseksi tarvittavat suojatoimet ja niiden toteutumisen valvonta. Maaryhmät ovat:<br>- Euroopan unioni<br>- Maat, joiden tietosuojatason riittävyyden EU on vahvistanut<br>- Tietojen siirto Yhdysvalloissa sijaitsevalle yritykselle, joka on liittynyt Privacy Shield -järjestelyyn<br>- Muu valtio <br>Ks. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">44–49 artikla , [GDPR]</a>",
			name: "Kansainväliset tietojen siirrot",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Onko organisaatiolla toimintaohjetta ja prosesseja organisaation säilyttämien henkilötietojen tietosuojan hallintaan ja valvontaan?",
			name: "Valvonta",
			placeholder: "Valvotaanko yksityisyyden suojausmenetelmien tehokkuutta ja riittävyyttä?",
			source: "PIA3 s. 76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Onko organisaatiolla toimintaohjetta ja prosesseja, joilla pienennetään riskiä, jota henkilötietojen luovutukset kolmansille osapuolille voivat aiheuttaa (esim. käyttöehdot)?",
			name: "Suhteet kolmansiin osapuoliin",
			placeholder: "Kuvaile tässä ne turvatoimenpiteet ja järjestelyt, joita sovelletaan henkilötietoja käsitteleviin työntekijöihin.",
			source: "PIA3 s. 48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Onko tietosuojalakien ja -asetusten noudattamiselle määritelty vastuuhenkilöä? Onko organisaatiossa yksityisyyden suojaan liittyvistä ohjeista ja seurannasta vastaavaa valvontaryhmää tai henkilöä?",
			name: "Organisaatio",
			placeholder: "Onko tietosuojaan liittyvät roolit ja vastuut määritelty?",
			source: "PIAF Connected Objects s. 24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Onko organisaatiolla toimintaohjetta siitä, kuinka henkilötietojen suojaaminen otetaan huomioon kaikissa uusissa käsittelyoperaatioissa?",
			name: "Yksityisyyden suojan integrointi projekteihin",
			placeholder: "Kuvaile tässä, kuinka yksityisyyden suoja on otettu huomioon organisaation projekteissa",
			source: "PIA3 s. 79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Onko organisaatiolla toimintaohjetta uusien työntekijöiden perehdyttämisestä tietosuoja-asioihin? Mitä suojatoimia tehdään, kun tietoja työssään käsitellyt henkilö jättää tehtävänsä?",
			name: "Henkilöstönhallinta",
			placeholder: "Kuvaile tässä, kuinka henkilökunta perehdytetään tietosuoja-asioihin.",
			source: "PIAF Connected Objects s. 24"
		},
		PIA_ORG_POL: {
			description: "Määrittele organisaation tietosuojapolitiikka asiakirjoilla, jotka kuvaavat tietosuojan keskeiset osa-alueet sisällön tyypin (riskit, avainperiaatteet, tavoitteet, sovellettavat säännöt jne.) ja viestinnän kohderyhmän (käyttäjät, IT-osasto, päättäjät jne.) mukaan.",
			name: "Toimintaohje",
			placeholder: "Kuvaile tässä asiakirjat, joihin tietosuojan tavoitteet ja säännöt perustuvat.",
			source: "PIA3 s. 78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Toimintaohje, jossa kuvaillaan prosessit, joilla hallitaan riskejä, joita organisaation suorittama henkilötietojen käsittely aiheuttaa rekisteröityjen yksityisyydelle ja tietosuojalle (riskikartoitus jne.).",
			name: "Tietosuojariskien hallinta",
			placeholder: "Kuvaile tässä prosessit, joilla hallitaan riskejä, joita organisaation suorittama henkilötietojen käsittely aiheuttaa rekisteröityjen yksityisyydelle ja tietosuojalle.",
			source: "PIA3 s. 77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Onko organisaatiolla operatiivista yksikköä, joka kykenee havaitsemaan ja käsittelemään poikkeamat, jotka voivat vaikuttaa rekisteröityjen perusoikeuksiin tai yksityisyyteen?",
			name: " Henkilötietoja koskevien tietomurtojen hallinta",
			placeholder: "Onko IT-poikkeamille dokumentoitu ja testattu hallintamenettely?",
			source: "PIAF Connected Objects s. 24 ja PIA3 s. 36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Henkilötietojen käytettävyyden ja/tai eheyden takaamiseksi sekä niiden luottamuksellisuuden säilyttämiseksi laaditut toimintaohjeet ja tehdyt toimenpiteet.",
			name: "Varmuuskopiot",
			placeholder: "Kuvaile tässä, kuinka varmuuskopiointia hallitaan. Ilmoita, säilytetäänkö varmuuskopioita turvallisessa paikassa.",
			source: "PIAF Connected Objects s. 23 &amp; PIA3 s. 27 - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Työasemien suojausmenetelmät (automaattinen lukitus, säännölliset päivitykset, konfiguraatiot, fyysinen turvallisuus jne.), joilla vähennetään mahdollisuuksia hyödyntää ohjelmistojen ominaisuuksia (käyttöjärjestelmät, liiketoimintasovellukset jne.) henkilötietojen tietoturvan loukkaamiseen.",
			name: "Työasemien hallinta",
			placeholder: "Kuvaile työasemien suojausmenetelmät tässä",
			source: "PIAF Connected Objects s. 22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "TO BE TRANSLATED - <strong>Only use subcontractors which are able to provide sufficient guarantees</strong> (in particular in terms of specialised knowledge, reliability and resources). Require service providers to communicate their information system security policy before signing a contract with them. <br>Take and document the means (security audits, installation visits, etc.) used to <strong>ensure the effectiveness of the guarantees offered by the subcontractor</strong> in terms of data protection. These guarantees include: <br>- encryption of data according to its sensitivity or, at least, the existence of procedures guaranteeing that the service company does not have access to the data; <br>- encryption of data transmissions (e.g.: HTTPS type connection, VPN, etc.); <br>- guarantees in terms of network protection, traceability (logs, audits), access rights management, authentication, etc. <br><strong>Sign a contract with the subcontractors</strong>, which defines the subject, the length and the purpose of the processing, as well as obligations of each party. Ensure that it contains, in particular, provisions targeting: <br>- their obligation in terms of <strong>confidentiality of the entrusted personal data</strong>;<br>- <strong>minimal standards in terms of user authentication</strong>;<br>- <strong>conditions of restitution of data and/or its destruction at end of the contract</strong>;<br>- <strong>incident management and notification rules. </strong> They should include notification of the data controller whenever a security breach or a security incident is discovered, which should happen as soon as possible when it concerns personal data.",
			name: "Sopimusten käsittely",
			placeholder: "Kuvaile tässä henkilötietojen käsittelijöihin sovellettavat toimenpiteet (isäntäpalvelin, huoltoyhtiö, pääkäyttäjä, erikoistuneet palveluntarjoajat jne.)",
			source: "Measures_US Procurement: tunnistettu ja sopimuksella säädelty"
		},
		PIA_SEC_EXP: {
			description: "Henkilötietojen käsittelyssä käytettäviä resursseja koskevien riskien vaikutuksia ja toteutumisen todennäköisyyttä vähentävät toimenpiteet.",
			name: "Käyttöturvallisuus",
			placeholder: "Kuvaile tässä, kuinka ohjelmistopäivitykset (käyttöjärjestelmät, sovellukset jne.) ja tietoturvapäivitykset on toteutettu.",
			source: "PIAF Connected Objects s. 22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Verkkoliikenteen (kiinteät verkot, langattomat verkot, radioaallot, valokuidut jne.) reaaliaikainen analysointi ja kyberhyökkäykseen viittaavien merkkien havaitseminen tietomurtohälyttimiä ja tunkeutumisenestojärjestelmiä tarkkailemalla.",
			name: "Verkon toiminnan valvonta",
			placeholder: "Kuvaile tässä menetelmät ja valvontakeinot, joilla henkilötietojen tietoturvaloukkaukset havaitaan",
			source: "PIA3 s. 67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Laitteiston fyysistä huoltoa koskevat toimintaohjeet, joista ilmenee, onko huolto ulkoistettu.<br> Ilmoita, onko sovellusten etäylläpito sallittu ja kuvaile sen järjestelyt. Onko viallisille laitteille erityisiä hallintamenetelmiä?",
			name: "Huolto",
			placeholder: "Kuvaile tässä, kuinka laitteistojen fyysinen huolto on järjestetty",
			source: "PIAF Connected Objects s. 23"
		},
		PIA_SEC_MAL: {
			description: "Menetelmät, joilla huonommin suojattuihin verkkoihin yhdistetyt työasemat ja palvelimet on suojattu haittaohjelmilta.",
			name: "Haittaohjelmistoilta suojautuminen",
			placeholder: "Kuvaa vähemmän turvallisten verkkojen käyttöön liittyvien riskien torjumisen toimenpiteet tässä.",
			source: "PIAF Connected Objects s. 22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Kuvaile tässä menetelmät, joilla palvelinten ja työasemien fyysinen turvallisuus (suojattu sijainti, turvakaapelit, luottamuksellisten tietojen suodattimet, tietojen tyhjentäminen ennen laitteiden hävittämistä jne.) on varmistettu.",
			name: "Laitteistoturvallisuus",
			placeholder: "Kuvaile tässä palvelinten ja työasemien fyysisen turvallisuuden varmistamismenetelmät.",
			source: "PIAF Connected Objects s. 23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Riippuu sen verkon tyypistä (erillisverkko, yksityinen verkko tai internet), jossa henkilötietoja käsitellään. Määrittele palomuurijärjestelmät, tietomurtohälyttimet ja muut aktiiviset tai passiiviset laitteet, joilla verkon suojaus on varmistettu.",
			name: "Verkon turvallisuus",
			placeholder: "Kuvaile tässä sen verkon suojaustoimet, jossa henkilötietojen käsittely tapahtuu",
			source: "PIAF Connected Objects s. 23"
		},
		PIA_SEC_PHY: {
			description: "Fyysisen turvallisuuden varmistamisen menetelmät (alueet, vierailijoiden saattaminen, kulkulupien pitäminen esillä, lukitut ovet jne.). Ilmoita, onko tiloissa murtohälyttimet.",
			name: "Fyysinen pääsynvalvonta",
			placeholder: "Kuvaile tässä, kuinka fyysinen kulunvalvonta on järjestetty tiloissa, joissa henkilötietoja käsitellään.",
			source: "PIAF Connected Objects s. 23"
		},
		PIA_SEC_PROT: {
			description: "Tulipalojen ehkäisemisen, havaitsemisen ja sammutuksen toimintaohjeet. Kuvaile tarvittaessa vesivahinkojen estämiseksi suoritetut toimenpiteet. Määrittele myös sähkönsaannin tarkkailumenetelmät ja varavoimanlähteet.",
			name: "Ei-inhimillisiltä riskeiltä suojautuminen",
			placeholder: "Kuvaile tässä keinot, joilla ei-inhimillisten riskien todennäköisyyttä on pienennetty.",
			source: "PIAF Connected Objects s. 23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Henkilötietojen käsittelypaikan dokumentaatio; alueella ei tulisi olla ympäristökatastrofien riskiä (tulva-alue, kemian teollisuuden laitosten läheisyys, maanjäristys- tai vulkaaninen alue jne.). Ilmoita, varastoidaanko samalla alueella vaarallisia aineita.",
			name: "Riskien välttäminen",
			placeholder: "Ilmoita tässä, onko henkilötietojen käsittelypaikalla ympäristökatastrofien mahdollisuutta.",
			source: "PIAF Connected Objects s. 23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Kyberturvallisuuskeskuksen ja Viestintäviraston ohjeistusten soveltaminen.",
			name: "Verkkosivujen turvallisuus",
			placeholder: "Kuvaa tässä verkkosivujen suojauskeinot.",
			source: "PIAF Connected Objects s. 22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Kuvaile mahdollisesti käytetyt anonymisointimenetelmät ja niiden tarkoitus tässä. <br>Muista tehdä selvä ero anonymisoidun ja pseudonymisoidun tiedon välille.",
			name: "Anonymisointi",
			placeholder: "Kuvaa käytetyt anonymisointimenetelmät tässä .",
			source: "PIAF Connected Objects s. 21"
		},
		PIA_TEC_ARCH: {
			description: "Kuvaile tässä arkistonhallinnan prosessit (toimitus, varastointi, tietojenhaku jne.). Määrittele arkistoinnin roolit (tietoja toimittavat virastot, tietoja siirtävät virastot jne.) ja toimintaohjeet. Ilmoita, siirretäänkö tietoja muihin arkistoihin.",
			name: "Arkistointi",
			placeholder: "Kuvaile tässä säilytettävien tietojen eheyden valvontamekanismit ja niiden tarkoitus.",
			source: "PIAF Connected Objects s. 22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Säilytettävien tietojen (tietokannassa, erillistiedostoissa, varmuuskopioissa jne.) <strong>luottamuksellisuuden varmistamiseksi</strong> tehdyt toimenpiteet sekä salausavainten hallintamenettelyt (luominen, säilytys, muuttaminen tietomurtoepäilyjen tapauksessa jne.).<br> Kuvaa käsiteltävien tietovirtojen salausmenetelmät (VPN, TLS jne.).",
			name: "Salaus",
			placeholder: "Kuvaa tietojen luottamuksellisuuden varmistamiseksi tehdyt toimenpiteet tässä.",
			source: "PIAF Connected Objects s. 21"
		},
		PIA_TEC_CLO: {
			description: "Tietojen hajauttaminen pienentää henkilötietojen yhdistelemisen ja kaikkia henkilötietoja  koskevan tietomurron mahdollisuutta.",
			name: "Henkilötietojen hajauttaminen",
			placeholder: "Ilmoita tässä, aiotaanko henkilötietojen käsittely hajauttaa ja kuinka se toteutetaan.",
			source: "PIAF Connected Objects s. 21"
		},
		PIA_TEC_CTLA: {
			description: "Käyttäjäprofiilien ja niiden ominaisuuksien määrittelyn menetelmät. Määrittele käytetyt <strong>todentamismenetelmät</strong>. Määrittele tarvittaessa salasanoja koskevat säännöt (vähimmäispituus, edellytetyt merkit, voimassaoloaika, epäonnistuneiden kirjautumisyritysten sallittu määrä ennen tilin lukitsemista jne.).",
			name: "Looginen pääsynvalvonta",
			placeholder: "Kuvaile eri käsittelijöiden roolit, käyttäjäprofiilien määrittely ja ominaisuudet tässä.",
			source: "PIAF Connected Objects s. 21"
		},
		PIA_TEC_LOG: {
			description: "Jäljitettävyyttä ja lokien hallintaa säätelevät toimintaohjeet.",
			name: "Jäljitettävyys (lokit)",
			placeholder: "Ilmoita tässä, kirjataanko tapahtumia lokiin ja kuinka kauan kyseisiä lokeja säilytetään.",
			source: "PIAF Connected Objects s. 22"
		},
		PIA_TEC_MINI: {
			description: "Muun muassa seuraavia menetelmiä voidaan käyttää: suodattaminen ja poistaminen, arkaluonteisuuden vähentäminen konversion avulla, tietojen tunnistettavuuden vähentäminen, tietojen kertymisen rajoittaminen, tietojen käyttöoikeuden rajoittaminen",
			name: "Henkilötietojen määrän minimointi",
			placeholder: "Kuvaile tässä, kuinka henkilötietojen käsittelyyn liittyviä riskejä on pyritty lieventämään käsiteltäviä henkilötietoja rajoittamalla",
			source: "PIAF Connected Objects s. 40"
		},
		PIA_TEC_PAP: {
			description: "Jos henkilötietojen käsittelyssä käytetään painettuja, henkilötietoja sisältäviä asiakirjoja, selvitä niiden painamisen, säilytyksen, tuhoamisen ja vaihtamisen menetelmät tässä.",
			name: "Paperiasiakirjojen suojaus",
			placeholder: "Kuvaile tässä paperiasiakirjojen eheyden valvontamekanismit ja niiden tarkoitus.",
			source: "PIAF Connected Objects s. 22"
		},
		PIA_VAL_ACT: {
			description: "Arvioijan aikaisemmissa vaiheissa ehdottamat korjaavat toimenpiteet. Toimintasuunnitelmassa kuvataan jokaisen toiminnan vastuuhenkilö, suoritustiheys, vaikeusaste, kustannukset ja edistyminen.",
			name: "Toimintasuunnitelma",
			source: "Ei ole"
		},
		PIA_VAL_CART: {
			description: "Kaavio, jossa on kuvattu hyvät suojauskäytännöt, joista jokaiselle on annettu vaatimustenmukaisuusarvo aikaisemmissa vaiheissa tehtyjen arviointien perusteella.",
			name: "Riskien kartoitus",
			source: "PIAF Connected Objects s. 34"
		},
		PIA_VAL_CONC: {
			description: "Rekisterinpitäjän tulee pyrkiä selvittämään rekisteröityjen tai heidän edustajiensa mielipide suunnitellusta henkilötietojen käsittelystä. Ks. 39 artiklan  2 kohta, <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br>Mielipiteet voidaan selvittää lukuisilla eri tavoilla asiayhteydestä riippuen (sisäinen tai ulkoinen selvitys henkilötietojen käsittelyn menetelmistä ja tarkoituksesta, henkilökunnan tai ammattiliiton edustajille suunnattu kysely, henkilötietojen käsittelijän tuleville asiakkaille suunnattu kysely). <strong>Jos rekisterinpitäjä päättää toimia vastoin rekisteröityjen mielipidettä</strong>, päätöksen perustelut <strong>on kirjattava</strong>. Jos rekisterinpitäjä ei pidä <strong>rekisteröityjen mielipiteiden selvittämistä oleellisena, myös tämän päätöksen perustelut on kirjattava</strong>.",
			name: "Rekisteröidyn mielipide",
			source: "Yleisen tietosuoja-asetuksen 39 artiklan 9 kohta ja PIAF Connected Objects s. 38"
		},
		PIA_VAL_DPO: {
			description: "Jos organisaatiolle on nimetty tietosuojavastaava, rekisterinpitäjän tulee pyytää tämän neuvoa tietosuojaa koskevan vaikutustenarvioinnin tekemisessä. Ks. 39 artiklan 2 kohta, <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>Tietosuojavastaavan eriävä näkemys henkilötietojen käsittelystä tulee dokumentoida</strong>.",
			name: "Tietosuojavastaavan mielipide",
			source: "Yleisen tietosuoja-asetuksen 39 artiklan 2 kohta ja PIAF Connected Objects s. 37"
		},
		PIA_VAL_RT: {
			description: "Arvioi, ovatko valitut suojausmenetelmät, jäännösriskit ja toimintasuunnitelma perustellusti hyväksyttäviä suhteessa aikaisemmin tunnistettuihin intresseihin ja sidosryhmien mielipiteisiin. Tässä suhteessa vaikutustenarviointi voidaan:<br>- validoida<br>- hyväksyä ehdollisesti, jos siihen tehdään parannuksia (määriteltävä)<br>- hylätä (yhdessä suunnitellun henkilötietojen käsittelyn kanssa) Toista ne aikaisemmat vaiheet, joita vaikutustenarvioinnin validointi edellyttää. Tämä päätös ei vaikuta tietosuojaviranomaisen mahdollisesti suorittamaan vaatimustenmukaisuusarviointiin.",
			name: "Virallinen validointi",
			source: "PIAF Connected Objects s. 40"
		}
	},
	title: "Tietopankki"
};
var measures$e = {
	add: "Lisää tyhjä toimenpide (tai käytä tietopankkia)",
	default_placeholder: "Kuvaile tietosuojan varmistamiseksi toteutettuja tai suunniteltuja toimenpiteitä.",
	edit: "Muokkaa toimenpidettä",
	placeholder_title: "Toimenpiteen nimi",
	remove: "Poista toimenpide"
};
var misc$e = {
	display: "Näytä/piilota"
};
var modals$e = {
	abandon_pia: {
		additional_text: "Arkistointi ei ole lopullinen. Vaikutustenarviointiin voi tarvittaessa palata.",
		content: "Haluatko varmasti<br>lopettaa käsittelyn?"
	},
	action_plan_no_evaluation: {
		content: "Aloita analyysin tarkistus laatiaksesi toimintasuunnitelman.",
		review_section: "Tarkista osio"
	},
	archive: "Arkistoi",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "<span class='strong'>Erinomaista,</span><br>tämä alaosio on nyt<br>valmis arvioitavaksi."
	},
	back_to_edition: {
		content: "Osio on lähetetty muokattavaksi.<br> Useat kentät vaativat korjaamista,<br> jotta osiota voidaan tarkastella."
	},
	back_to_evaluation: {
		content: "Osio on lähetetty muokattavaksi.<br> Useat kentät vaativat korjaamista,<br> jotta osiota voidaan tarkastella."
	},
	back_to_home: "Takaisin alkuun",
	cancel: "Peruuta",
	close: "Sulje",
	completed_edition: {
		content: "Vaikutustenarviointi on valmis tarkistettavaksi."
	},
	completed_evaluation: {
		content: "Vaikutustenarviointi on tarkistettu ja valmis validoitavaksi."
	},
	"continue": "Jatka",
	declare_measures: {
		content: "Pahoittelut,<br>ennen riskien arviointia<br>sinun on raportoitava<br>toteutetut tai suunnitellut toimenpiteet.",
		declare: "Ilmoita toteutetut tai suunnitellut toimenpiteet"
	},
	dpo_missing_evaluations: {
		comment: "Kommentoi",
		content: "Päätä analyysi jatkaaksesi Tietosuojavastaava-sivulle.",
		remove: "Poista",
		review_section: "Tarkista osio"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type PIA"
	},
	import_wrong_structure_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type Modèle"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Vaikutustenarvioinnin sisältö on kopioitu leikepöydälle."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Varoitus,</span><br>Kentässä on oltava vähintään yksi toimenpide: poistaminen ei ole mahdollista."
	},
	recover_version: {
		"continue": "Jatka",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "<span class='strong'>Tietosuojaa koskeva vaikutustenarviointi on hylätty,</span><br>Useiden kenttien sisältöä on korjattava.<br>Palaa arviointitilaan<br>ja tee korjaukset."
	},
	remove_attachment: {
		comment: "Kommentoi",
		content: "<span class='strong'>Varoitus,</span><br>Haluatko varmasti<br>poistaa tämän liitteen?",
		keep: "Säilytä",
		remove: "Poista"
	},
	remove_measure: {
		content: "<span class='strong'>Varoitus,</span><br>Haluatko varmasti <br>poistaa tämän toimenpiteen?",
		keep: "Säilytä tämä <br>toimenpide",
		remove: "Poista tämä <br>toimenpide"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Poista tämä tietosuojaa koskeva vaikutustenarviointi"
	},
	remove_question: {
		content: "TO BE TRANSLATED - Souhaitez-vous supprimer la question ?",
		keep: "TO BE TRANSLATED - Annuler",
		remove: "TO BE TRANSLATED - Supprimer"
	},
	remove_structure: {
		content: "TO BE TRANSLATED - <span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer ce modèle ?",
		remove: "TO BE TRANSLATED - Supprimer ce modèle"
	},
	same_comment: {
		content: "<span class='strong'>Varoitus,</span><br>Syötä kommentti, joka ei ole sama kuin edellinen tallennettu kommentti."
	},
	signed_pia_validation: {
		content: "<span class='strong'>Tietosuojaa koskeva vaikutustenarviointi on hyväksytty</span><br>Viimeistele tietosuojaa koskevan vaikutustenarvioinnin validointi liittämällä<br> hyväksyjän allekirjoittama raportti.",
		download_pia: "Lataa tietosuojaa koskevan vaikutustenarvioinnin raportti"
	},
	simple_pia_validation: {
		content: "Tietosuojaa koskeva vaikutustenarviointi on validoitu."
	},
	start_evaluation: "Aloita tarkistaminen",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Palvelimen osoite on päivitetty."
	},
	validate_evaluation: {
		content: "<span class='strong'>Erinomaista,</span><br>tietosuojaa koskeva vaikutustenarviointi odottaa yleistä validointia."
	},
	validate_evaluation_to_correct: {
		content: "Pahoittelut,<br>Useiden kenttien sisältöä on korjattava.<br>Palaa muokkaustilaan<br>ja tee korjaukset."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$e = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$e = {
	content: ", toteavat näkemyksinään:",
	dpo_lock: "Täytä muut osiot ennen tietosuojavastaavan mielipidettä.",
	dpo_opinion: "Tietosuojavastaavan mielipide",
	edit: "Muokkaa",
	people_opinion: "Asianomaisten mielipiteet",
	placeholder_concerned_people_name: "Asianomaisten nimet",
	placeholder_dpo_name: "Tietosuojavastaavien nimet",
	placeholder_dpo_opinion: "Kerro päätöksesi syyt.",
	placeholder_people_opinion: "Kerro, kuinka mielipiteet on kerätty ja analysoitu. Jos tiedoksiantoja ei ole pyydetty, ilmoita syy.",
	placeholder_search_content: "Perustele, miksei asianomaisten mielipidettä ole kysytty.",
	treatment_lock: "Täytä muut osiot ennen asianomaisten mielipiteitä.",
	treatment_nok: "Henkilötietojen käsittelyä ei pidä toteuttaa.",
	treatment_ok: "Henkilötietojen käsittelyn voi toteuttaa."
};
var pia$e = {
	attachments: {
		add: "Lisää",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Poista",
		title: "Liitteet",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Pyydä tarkastusta",
		mandatory_fields: "Kaikki kentät tulee täyttää",
		structure_add_question: "TO BE TRANSLATED - Ajouter une question",
		subsection_validated: "Osa-alue tarkastettu, odottaa lopullista validointia",
		validate_evaluation: "Validoi tarkastus"
	},
	header: {
		display_action_plan: "Näytä<br>toimintasuunnitelma",
		edition: "Editio",
		evaluation: "Arviointi",
		preview: "Esikatselu"
	},
	sections: {
		based_on_structure_name: "TO BE TRANSLATED - Basé sur le modèle :",
		homepage_link: "Takaisin ohjauspaneeliin",
		refuse_pia: "Hylätty vaikutustenarviointi",
		status: {
			evaluation: {
				cancel: "Peruuta tarkistuspyyntö.",
				cancel_button: "Peruuta tarkistuspyyntöt",
				content: "Tätä osiota ei ole vielä tarkistettu. Jos haluat muokata tarkistettavaksi lähetettyä sisältöä, sinun täytyy ",
				title: "Odottaa tarkistusta."
			},
			validation: {
				cancel: "Peruuta validointipyyntö.",
				cancel_button: "Peruuta validointipyyntö",
				content: "Tämä osio on tarkistettu ja odottaa vaikutustenarvioinnin validointia. Jos haluat muokata tarkistusta, sinun täytyy ",
				title: "Odottaa validointia."
			}
		},
		validate_pia: "Validoi vaikutustenarviointi"
	},
	statuses: [
		"Käynnissä",
		"Hylätty",
		"Yksinkertainen validointi",
		"Allekirjoitettu validointi",
		"Arkistoitu",
		"Odottaa validointia"
	]
};
var questions$e = {
	edit: "Muokkaa kysymystä",
	gauges: [
		"(Määrittelemätön)",
		"Vähäinen",
		"Rajattu",
		"Merkittävä",
		"Suurin"
	],
	placeholder_title: "TO BE TRANSLATED - Titre de la question (obligatoire)",
	remove: "TO BE TRANSLATED - Supprimer la question"
};
var rejection_page$e = {
	applied_adjustments: "Tehdyt muokkaukset",
	applied_adjustments_placeholder: "käännettävä",
	button: {
		abandon_treatment: "Lopeta käsittely",
		reject_pia: "Hylkää tietosuojaa koskeva vaikutustenarviointi",
		send_for_validation: "Lähetä uuteen validointiin"
	},
	previous_rejection: "Edellinen hylkäys",
	rejection_reason: "Hylkäyksen syy",
	rejection_reason_placeholder: "käännettävä",
	title: "Validointihistoria"
};
var sections$e = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Esitä lyhyt kuvaus henkilötietojen käsittelystä: käsittelytoiminnan nimike, intressit, käytön asiayhteys jne.",
						title: "Minkälaista henkilötietojen käsittelyä suunnitellaan?"
					},
					"2": {
						placeholder: "Kuvaile sidosryhmien vastuut: rekisterinpitäjä sekä mahdolliset henkilötietojen käsittelijät ja yhteisrekisterinpitäjät.",
						title: "Mitä vastuita käsittelyyn liittyy?"
					},
					"3": {
						placeholder: "Luettele käsittelyyn sovellettavat standardit, erityisesti hyväksytyt käytännesäännöt ja tietosuojasertifikaatit.",
						title: "Onko henkilötietojen käsittelystä laadittu standardeja?"
					}
				},
				short_help: "Tässä osiossa voit määritellä ja esitellä arvioinnin kohteen.",
				title: "Yleiskatsaus"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Luettele kerättävät ja käsiteltävät henkilötiedot. Määrittele tietojen säilytysajat, vastaanottajat ja henkilöt, joilla on oikeus käyttää tietoja.",
						title: "Mitä henkilötietoja käsitellään?"
					},
					"2": {
						placeholder: "Kuvaile tuotteen toiminta (tiedon keräämisestä sen tuhoamiseen sekä käsittelyn, varastoinnin jne. eri vaiheet) esimerkiksi tietovuokaaviolla (liitä se vaikutustenarviointiin) ja yksityiskohtaisella prosessien kuvauksella.",
						title: "Kuinka henkilötietojen ja prosessien elinkaaret on toteutettu?"
					},
					"3": {
						placeholder: "Luettele tietojen käsittelyyn käytettävät resurssit (käyttöjärjestelmät, liiketoimintasovellukset, tietokantojen hallintajärjestelmät, toimisto-ohjelmistot, protokollat, konfiguraatiot jne.)",
						title: "Mitä resursseja tietojen käsittelyyn käytetään?"
					}
				},
				short_help: "Tässä osassa voit määritellä ja kuvailla henkilötietojen käsittelyn laajuutta yksityiskohtaisemmin.",
				title: "Tiedot, prosessit ja tietojen käsittelyyn käytettävät resurssit"
			}
		},
		short_help: "Osio antaa selkeän kuvan kyseessä olevien henkilötietojen käsittelystä.",
		title: "Asiayhteys"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Selitä, miksi käsittelyn tarkoitukset ovat nimenomaisesti määritettyjä ja lainmukaisia.",
						short_title: "Tarkoitukset",
						title: "Ovatko käsittelyn tarkoitukset nimenomaisesti määritettyjä ja lainmukaisia?"
					},
					"2": {
						placeholder: "Kuvaile henkilötietojen käsittelyn oikeusperusteet (esim. suostumus, sopimuksen täytäntöönpano, lakisääteisen velvoitteen noudattaminen, elintärkeiden etujen turvaaminen jne.)",
						short_title: "Oikeusperuste",
						title: "Mikä oikeusperuste tekee henkilötietojen käsittelystä lainmukaista?"
					},
					"3": {
						placeholder: "Selitä, miksi käsiteltävien henkilötietojen kerääminen on välttämätöntä käsittelyn tarkoituksen kannalta.",
						short_title: "Tietojen asianmukaisuus",
						title: "Ovatko kerätyt henkilötiedot asianmukaisia ja olennaisia ja rajoitettuja siihen, mikä on tarpeellista suhteessa niihin tarkoituksiin, joita varten niitä käsitellään (”tietojen minimointi”)?"
					},
					"4": {
						placeholder: "Kuvaile toimenpiteet, joilla henkilötietojen laatu varmistetaan.",
						short_title: "Tietojen täsmällisyys",
						title: "Ovatko tiedot täsmällisiä ja ajantasaisia?"
					},
					"5": {
						placeholder: "Perustele säilytysaika lainsäädännön vaatimuksilla ja/tai käsittelytarpeilla.",
						short_title: "Säilytysaika",
						title: "Kuinka kauan henkilötietoja säilytetään?"
					}
				},
				short_help: "Tässä osassa voit osoittaa henkilötietojen ja niiden käsittelyn lainmukaisuuden.",
				title: "Suhteellisuus ja tarpeellisuus"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Kerro, mitä tietoja rekisteröidyille annetaan ja millä tavoin.",
						short_title: "Rekisteröidyille annettavat tiedot",
						title: "Kuinka rekisteröidyille ilmoitetaan henkilötietojen käsittelystä?"
					},
					"2": {
						placeholder: "Kuvaile varotoimet, joilla varmistetaan, että rekisteröityjen suostumus on hankittu.",
						short_title: "Suostumuksen hankkiminen",
						title: "Kuinka rekisteröityjen suostumus hankitaan, jos se on tarpeen?"
					},
					"3": {
						placeholder: "Kuvaile toimenpiteet, joilla varmistetaan rekisterinpitäjien mahdollisuudet saada pääsy tietoihinsa sekä vastaanottaa ja lähettää niitä.",
						short_title: "Oikeus saada pääsy tietoihin ja siirtää tiedot järjestelmästä toiseen",
						title: "Kuinka rekisteröidyt voivat käyttää oikeuksiaan saada pääsy henkilötietoihin ja siirtää tiedot järjestelmästä toiseen?"
					},
					"4": {
						placeholder: "Kuvaile toimenpiteet, joilla varmistetaan rekisterinpitäjien mahdollisuudet oikaista ja poistaa tietojaan.",
						short_title: "Oikeus tietojen oikaisemiseen ja poistamiseen",
						title: "Kuinka rekisteröidyt voivat käyttää oikeuttaan oikaista tai poistaa henkilötiedot?"
					},
					"5": {
						placeholder: "Kuvaile toimenpiteet, joilla varmistetaan rekisterinpitäjien mahdollisuudet rajoittaa ja vastustaa henkilötietojensa käsittelyä.",
						short_title: "Oikeus käsittelyn rajoittamiseen ja henkilötietojen käsittelyn vastustamiseen",
						title: "Kuinka rekisteröidyt voivat käyttää oikeuttaan käsittelyn rajoittamiseen ja vastustamiseen?"
					},
					"6": {
						placeholder: "Kuvaile jokaisen henkilötietojen käsittelijän vastuut (kesto, laajuus, tarkoitus, kirjalliset käsittelyohjeet, ennakkolupa) ja liitä sopimukset, käytännesäännöt ja sertifioinnit, joissa käsittelijöiden tehtävät ja velvoitteet on määritelty.",
						short_title: "Alihankinta",
						title: "Onko henkilötietojen käsittelijöiden velvoitteet ilmoitettu selkeästi ja määritetty sopimuksella?"
					},
					"7": {
						placeholder: "Nimeä jokainen Euroopan unionin ulkopuolien valtio, jossa henkilötietoja säilytetään tai käsitellään ja ilmoita, onko komissio päättänyt, että se tarjoaa riittävän tietosuojan tai kuvaile tietojen siirtoa koskevat ehdot.",
						short_title: "Tietojen siirrot",
						title: "Onko Euroopan unionin ulkopuolelle siirrettävät tiedot suojattu asianmukaisesti?"
					}
				},
				short_help: "Tässä osassa voit osoittaa, että rekisteröidyille tarjotaan tarvittavat keinot heidän oikeuksiensa käyttämiseen.",
				title: "Rekisteröityjen oikeuksien turvaamiskeinot"
			}
		},
		short_help: "Tässä osiossa voit laatia yksityisyyden suojan periaatteita koskevan vaatimustenmukaisuuskehikon.",
		title: "Perusperiaatteet"
	},
	"3": {
		items: {
			"1": {
				short_help: "Tässä osiossa voit kuvailla tietoturvaa tukevia (toteutettuja tai suunniteltuja) suojaustoimia.",
				title: "Suunnitellut tai toteutetut toimenpiteet"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Syötä mahdolliset vaikutukset +",
						title: "Mitkä olisivat riskien ilmenemisen pääasialliset vaikutukset rekisteröityihin?"
					},
					"2": {
						placeholder: "Syötä uhat +",
						title: "Mitkä ovat pääasialliset uhat, jotka voisivat aiheuttaa riskin toteutumisen?"
					},
					"3": {
						placeholder: "Määrittele riskitekijät +",
						title: "Mitkä ovat riskitekijät?"
					},
					"4": {
						placeholder: "Valitse riskiä vastaan suojelevat suojaustoimet hiirellä.",
						title: "Mitkä määritellyistä suojaustoimista suojelevat riskiä vastaan?"
					},
					"5": {
						placeholder: "Perustele riskin vakavuusarvio tässä.",
						title: "Miten vakavaksi arvioit riskin, erityisesti suhteessa mahdollisiin vaikutuksiin ja suunniteltuihin suojaustoimiin?"
					},
					"6": {
						placeholder: "Perustele arviosi riskin todennäköisyydestä tässä.",
						title: "Kuinka todennäköisenä pidät riskin toteutumista, erityisesti suhteessa uhkiin, riskitekijöihin ja suunniteltuihin suojaustoimiin?"
					}
				},
				short_help: "Analysoi tietojen luvattoman käytön syitä ja seurauksia ja arvioi riskin vakavuus sekä todennäköisyys.",
				title: "Luvaton tietojen käyttö"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Syötä mahdolliset vaikutukset +",
						title: "Mitkä olisivat riskien ilmenemisen pääasialliset vaikutukset rekisteröityihin?"
					},
					"2": {
						placeholder: "Syötä uhat +",
						title: "Mitkä ovat pääasialliset uhat, jotka voisivat aiheuttaa riskin toteutumisen?"
					},
					"3": {
						placeholder: "Määrittele riskitekijät +",
						title: "Mitkä ovat riskitekijät?"
					},
					"4": {
						placeholder: "Napsauta tästä ja valitse riskiä vastaan suojelevat suojaustoimet.",
						title: "Mitkä määritellyistä suojaustoimista suojelevat riskiä vastaan?"
					},
					"5": {
						placeholder: "Perustele riskin vakavuusarvio tässä.",
						title: "Miten vakavaksi arvioit riskin, erityisesti suhteessa mahdollisiin vaikutuksiin ja suunniteltuihin suojaustoimiin?"
					},
					"6": {
						placeholder: "Perustele arviosi riskin todennäköisyydestä tässä.",
						title: "Kuinka todennäköisenä pidät riskin toteutumista, erityisesti suhteessa uhkiin, riskitekijöihin ja suunniteltuihin suojaustoimiin?"
					}
				},
				short_help: "Analysoi tietojen ei-toivotun muutoksen syitä ja seurauksia ja arvioi riskin vakavuus sekä todennäköisyys.",
				title: "Ei-toivottu tietojen muuttaminen"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Syötä mahdolliset vaikutukset +",
						title: "Mitkä olisivat riskien ilmenemisen pääasialliset vaikutukset rekisteröityihin?"
					},
					"2": {
						placeholder: "Syötä uhat +",
						title: "Mitkä ovat pääasialliset uhat, jotka voisivat aiheuttaa riskin toteutumisen?"
					},
					"3": {
						placeholder: "Määrittele riskitekijät +",
						title: "Mitkä ovat riskitekijät?"
					},
					"4": {
						placeholder: "Napsauta tästä ja valitse riskiä vastaan suojelevat suojaustoimet.",
						title: "Mitkä määritellyistä suojaustoimista suojelevat riskiä vastaan?"
					},
					"5": {
						placeholder: "Perustele riskin vakavuusarvio tässä.",
						title: "Miten vakavaksi arvioit riskin, erityisesti suhteessa mahdollisiin vaikutuksiin ja suunniteltuihin suojaustoimiin?"
					},
					"6": {
						placeholder: "Perustele arviosi riskin todennäköisyydestä tässä.",
						title: "Kuinka todennäköisenä pidät riskin toteutumista, erityisesti suhteessa uhkiin, riskitekijöihin ja suunniteltuihin suojaustoimiin?"
					}
				},
				short_help: "Analysoi tietojen häviämisen syitä ja seurauksia ja arvioi riskin vakavuus sekä todennäköisyys.",
				title: "Tietojen katoaminen"
			},
			"5": {
				short_help: "Kuva antaa kokonaisnäkymän suojaustoimien vaikutuksista riskeihin.",
				title: "Riskien yleiskatsaus"
			}
		},
		short_help: "Tässä osiossa voit arvioida yksityisyyden suojaan kohdistuvia riskejä, toteutetut tai suunnitellut suojaustoimet huomioon ottaen.",
		title: "Riskit"
	},
	"4": {
		items: {
			"1": {
				short_help: "Tämän kuvan avulla voit vertailla riskien keskinäisiä suhteita ennen ja jälkeen suojaustoimien toteuttamisen.",
				title: "Riskikartoitus"
			},
			"2": {
				short_help: "Suunnittele vaikutustenarvioinnissa tunnistettujen tarpeellisten lisäsuojatoimenpiteiden toteuttaminen käytännössä. Toimintasuunnitelma päivittyy automaattisesti, kun tietosuojaa koskevan vaikutustenarvioinnin eri elementtejä arvioidaan.",
				title: "Toimintasuunnitelma"
			},
			"3": {
				short_help: "Esitä tietosuojasta ja yksityisyyden suojasta vastaavan henkilön (tai tietosuojaryhmän, jos sellainen on nimetty) suositukset. Esitä rekisteröityjen tai heidän edustajiensa mielipiteet.",
				title: "Tietosuojavastaavan ja asianomaisten mielipiteet"
			},
			"4": {
				title: "Validoi tietosuojaa koskeva vaikutustenarviointi"
			},
			"5": {
				title: "Tietosuojaa koskeva vaikutustenarviointi on hylätty"
			}
		},
		short_help: "Tässä osiossa voit laatia tietosuojaa koskevan vaikutustenarvioinnin validoinnin ja viimeistellä sen.",
		title: "Validointi"
	}
};
var settings$e = {
	content: "Anna etäpalvelimen osoite (URL):",
	title: "Asetukset",
	update: "Päivitä URL"
};
var summary$e = {
	action_plan: {
		fundamental_principles: "Perusperiaatteet",
		implementation_date: "Suunniteltu toteuttamispäivä",
		implementation_responsible: "Toteuttamisen vastuuhenkilöt",
		measures: "Toteutetut tai suunnitellut toimenpiteet",
		no_action_plan: "Toimintasuunnitelmaa ei ole kirjattu.",
		risks: "Riskit",
		title: "Toimintasuunnitelma"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Liitteet",
	concerned_people_name: "Asianomaisten mielipiteet",
	concerned_people_opinion: "Asianomaisten mielipiteet",
	concerned_people_searched_opinion: "Asianomaisten mielipiteiden selvittäminen",
	concerned_people_status: "Asianomaisten tilat",
	concerned_people_unsearched_opinion_comment: "Syy, miksi asianomaisten mielipidettä ei ole kysytty",
	content_choice: [
		"Henkilötietojen käsittelyä ei pidä toteuttaa.",
		"Henkilötietojen käsittelyn voi toteuttaa."
	],
	creation_date: "Laadintapäivä",
	csv_action_plan_comment: "Toimintasuunnitelman kommentti",
	csv_evaluation_comment: "Arvioinnin kommentti",
	csv_file_title: "action-plan",
	csv_implement_date: "Arvioitu käyttöönottopäivä",
	csv_people_in_charge: "Vastuuhenkilö",
	csv_section: "Osio",
	csv_title_object: "Otsikko",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Tietosuojavastaavan nimi",
	dpo_opinion: "Tietosuojavastaavan mielipide",
	dpo_status: "Tietosuojavastaavan tila",
	gauges: {
		"1": "Vähäinen",
		"2": "Rajattu",
		"3": "Merkittävä",
		"4": "Suurin"
	},
	modification_made: "Tehdyt muutokset",
	people_search_status_nok: "Asianomaisten mielipidettä ei ole kysytty.",
	people_search_status_ok: "Asianomaisten mielipidettä on kysytty.",
	pia_assessor: "Arvioijan nimi",
	pia_author: "Laatijan nimi",
	pia_name: "Tietosuojaa koskeva vaikutustenarviointi",
	pia_validator: "Hyväksyjän nimi",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Takaisin edelliselle sivulle",
	rejection_reason: "Hylkäyksen syy",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Riskien kartoitus",
	risks_overview_title: "Riskien yleiskatsaus",
	title: "Tietosuojaa koskevan vaikutustenarvioinnin tiedot"
};
var users$e = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$e = {
	add_signed_pia: "Lisää allekirjoitettu tietosuojaa koskeva vaikutustenarviointi",
	after_reading: "Luettuani koko tietosuojaa koskevan vaikutustenarvioinnin, joka liittyy seuraavaan henkilötietojen käsittelyyn: ",
	button: {
		rejection: "Hylkää<br>validointi",
		signed_validation: "Allekirjoitus<br>validointi",
		simple_validation: "Yksinkertainen validointi"
	},
	confirmation1: "Vahvistan, että käsittelyn asiayhteyden kuvaus vastaa todellisuutta.",
	confirmation2: "Vahvistan, että olen arvioinut käsittelyyn liittyvät riskit suunniteltujen tai toteutettujen toimenpiteiden valossa.",
	confirmation3: "Hyväksyn esitetyt korjaavat toimenpiteet.",
	confirmation4: "Sitoudun toteuttamaan ilmoitetut korjaavat toimenpiteet mahdollisimman pian.",
	latest_signed_attachment: "Viimeisin allekirjoitettu liite",
	mandatory_fields: "Kaikki kentät tulee täyttää",
	remove_attachment: "Poista liite",
	responsible: "Tietosuojaa koskevan vaikutustenarvioinnin hyväksyjä: ",
	signed_attachments_history: "Kaikki allekirjoitetut liitteet",
	tools: {
		dashboard: "Ohjauspaneeli",
		display_pia: "Näytä vaikutustenarviointi"
	},
	validated_pia_with_signature: "Validoitu",
	waiting_for_signature: "Tietosuojaa koskeva vaikutustenarviointi odottaa allekirjoitusta"
};
var fi = {
	about: about$e,
	action_plan: action_plan$e,
	authentication: authentication$e,
	cartography: cartography$e,
	comments: comments$e,
	conflict: conflict$e,
	date: date$e,
	errors: errors$e,
	evaluations: evaluations$e,
	header: header$e,
	help: help$e,
	homepage: homepage$e,
	knowledge_base: knowledge_base$e,
	measures: measures$e,
	misc: misc$e,
	modals: modals$e,
	onboarding: onboarding$e,
	opinions: opinions$e,
	"overview-risks": {
	important: "Merkittävä",
	limited: "Rajattu",
	maximal: "Suurin",
	measures: "Toimenpiteet",
	negligible: "Vähäinen",
	potential_impacts: "Mahdolliset vaikutukset",
	"risk-access_x": "Vakavuus",
	"risk-access_y": "Todennäköisyys",
	"risk-change_x": "Vakavuus",
	"risk-change_y": "Todennäköisyys",
	"risk-disappearance_x": "Vakavuus",
	"risk-disappearance_y": "Todennäköisyys",
	sources: "Riskitekijät",
	threat: "Uhka"
},
	pia: pia$e,
	questions: questions$e,
	rejection_page: rejection_page$e,
	sections: sections$e,
	settings: settings$e,
	summary: summary$e,
	users: users$e,
	validation_page: validation_page$e
};

var about$d = {
	contribute: "Si vous souhaitez contribuer à votre tour à la traduction de l’outil ou à l’amélioration de celles déjà proposées, nous vous invitons à <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">lire la page décrivant les étapes à suivre</a>.",
	description: "Cet outil est originellement conçu par la <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale de l'Informatique et des Libertés (CNIL)</a>, l’autorité de protection des données française, dans une volonté d’accompagnement des responsables de traitement dans leur démarche de conformité au RGPD. Il a été développé par <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Cet outil est libre et ouvert, sous licence GPLv3. Vous pouvez y contribuer en téléchargeant le code source, en le modifiant et en le redistribuant auprès de la communauté.",
	licences: "Licences des librairies :",
	title: "A propos de l'Outil AIIA",
	translators: "L’outil est actuellement disponible en dix-huit langues. Les versions française et anglaise sont fournies par la CNIL. Les autres versions sont le résultat des contributions des personnes suivantes :",
	translators_name: "<ul><li>Allemand : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Anglais : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Croate : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Danois <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Espagnol : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> ;</li><li>Estonien : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnois : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>Français : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Grec :  <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hongrois : <a target=\"_blank\" href=\"https://naih.hu\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italien : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lituanien : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Néerlandais : Ruud van Driel, Manuel d’Orso ;</li><li>Norvégien : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polonais : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portugais : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Roumain : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Tchèque : Jiří Grohmann, Manuel d’Orso.</li></ul>",
	version_number: "Numéro de version"
};
var action_plan$d = {
	acceptable_measures: "Mesures acceptables",
	edit: "Éditer",
	improvable_measures: "Mesures améliorables",
	measures: "Mesures existantes ou prévues",
	no_action_plan: "Aucun plan d'action enregistré.",
	placeholder_person_in_charge: "Responsable de la mise en oeuvre",
	principles: "Principes fondamentaux",
	risk1: "Accès illégitime à des données",
	risk2: "Modification non désirée de données",
	risk3: "Disparition de données",
	risks: "Risques",
	title: "Vue d'ensemble"
};
var authentication$d = {
	"12_characters": "12 caractères",
	account_recovery: "Récupération de compte",
	activation_code: "Code d'activation",
	cancel: "Annuler",
	confirm: "Confirmer",
	confirmation: "Confirmation",
	"continue": "Continuer",
	activate_account: "Activer un compte",
	create_account: "Créer un compte",
	create_account2: "Créer le compte",
	description: "Le logiciel PIA de la <strong>Commission Nationale de l'Informatique et des Libertés (CNIL)</strong> s'inscrit dans une démarche d'accompagnement des responsables de traitement dans la mise en œuvre des obligations du RGPD. Il accompagne la conduite d'une analyse d'impact relative à la protection des données et vise aussi à faciliter l'appropriation des guides PIA de la CNIL.",
	email: "Email",
	email_placeholder: "Adresse email",
	forgotten_password: "Oublié ?",
	login: "Login",
	lowercase: "Minuscule",
	password: "Mot de passe",
	password_security: "Sécurité du mot de passe",
	recovery_code: "Code de réinitialisation",
	recovery_code_message: "Un email contenant un code a été envoyé à l'adresse indiquée. Veuillez entrer le code dans le champ ci-dessous.",
	recovery_code_not_sent: "Code non reçu ?",
	saved_password: "Votre mot de passe a été enregistré. Vous pouvez dès à présent vous connecter.",
	sign_in: "S'identifier",
	sign_in_button: "Se connecter",
	sign_out_button: "Se déconnecter",
	special_character: "Caractère spécial (!@#$%^&*()?...)",
	number: "Chiffre",
	start: "Commencer",
	start_app: "Accéder à l'outil PIA (Beta)",
	subtitle1: "Une plateforme pour créer <br> et administrer vos AIIA",
	subtitle2: "Accéder aux outils et glossaires",
	title: "Analyse d'impact sur <br> la protection des données",
	transaction_error: "Impossible de traiter votre demande.",
	uppercase: "Majuscule",
	wrong_activation_code: "(erroné)",
	wrong_confirmation: "Les mots de passe ne sont pas identiques",
	wrong_email: "Email invalide",
	sso: "Connexion SSO",
	errors: {
		sign_in: {
			"400": "Email ou mot de passe erroné."
		},
		create_account: {
			uuid: {
				"404": "code d'activation erroné",
				"406": "Ce compte est déjà activé"
			},
			password: {
				"404": "Utilisateur non trouvé",
				"406": "Le mot de passe ne respecte pas les exigences de sécurité nécessaires."
			}
		},
		account_recovery: {
			email: {
				"404": "Utilisateur non trouvé",
				"423": "Ce compte utilisateur n'a pas encore été activé"
			},
			uuid: {
				"404": "code de réinitialisation erroné"
			},
			password: {
				"404": "Utilisateur non trouvé",
				"406": "Le mot de passe ne respecte pas les exigences de sécurité nécessaires."
			}
		},
		unauthorized: "Vous n'avez pas l'autorisation d'accéder à cette resource.",
		incompatibility: "Incompatibilité de version entre le serveur (pia-back) et l'application (pia). Veuillez contacter votre service informatique."
	}
};
var cartography$d = {
	important: "Importante",
	legend1: "Mesures prévues ou existantes",
	legend2: "Avec les mesures correctives mises en oeuvre",
	legend3: "(A)ccès illégitime à des données",
	legend4: "(M)odification non désirée de données",
	legend5: "(D)isparition de données",
	likelihood_axe: "Vraisemblance du risque",
	limited: "Limitée",
	maximal: "Maximale",
	negligible: "Négligeable",
	risk1_access: "(A)",
	risk2_modification: "(M)",
	seriousness_axe: "Gravité du risque"
};
var comments$d = {
	comment: "Commentaire",
	written_by: "Écrit par",
	comments_count: "commentaire(s)",
	new_comment: "Commenter",
	placeholder_new_comment: "Laissez un commentaire",
	send: "Envoyer"
};
var conflict$d = {
	keep_initial: "Conserver le contenu initial",
	keep_new: "Mettre à jour avec le nouveau contenu",
	initial_content: "Contenu initial",
	merge: "Fusionner les deux contenus",
	new_content: "Nouveau contenu",
	title: "Conflit détecté"
};
var date$d = {
	april: "Avril",
	august: "Août",
	december: "Décembre",
	"earlier-in-this-month": "Plus tôt ce mois-ci",
	"earlier-in-this-week": "Plus tôt cette semaine",
	february: "Février",
	january: "Janvier",
	july: "Juillet",
	june: "Juin",
	march: "Mars",
	may: "Mai",
	november: "Novembre",
	october: "Octobre",
	september: "Septembre",
	today: "Aujourd'hui",
	yesterday: "Hier"
};
var errors$d = {
	content: "Si vous rencontrez d’autres problèmes ou si vous avez des suggestions d’amélioration,<br>vous pouvez nous les faire remonter via ce formulaire : <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Page introuvable."
};
var evaluations$d = {
	acceptable: "Acceptable",
	action_plan_comment: "Plan d'action / mesures correctives",
	evaluation_comment: "Commentaire d'évaluation",
	gauges: {
		"0": "(Non définie)",
		"1": "Négligeable",
		"2": "Limitée",
		"3": "Importante",
		"4": "Maximale",
		likelihood: "Prenant en compte le plan d'action, comment ré-évaluez-vous la <span class='red-highlight'>vraisemblance de ce risque</span> ?",
		seriousness: "Prenant en compte le plan d'action, comment ré-évaluez-vous la <span class='red-highlight'>gravité de ce risque</span> ?"
	},
	improvable: "Améliorable",
	placeholder_acceptable: "Entrer vos commentaires pour expliquer en quoi les mesures mises en œuvre sont suffisantes pour répondre aux exigences de protections des données.",
	placeholder_improvable1: "Entrez vos commentaires pour expliquer quelles mesures additionnelles sont à ajouter afin d'améliorer la protection des données du traitement.",
	placeholder_improvable2: "Entrez vos commentaires.",
	placeholder_to_correct: "Entrez vos commentaires pour expliquer pourquoi les informations fournies ne sont pas suffisantes pour pouvoir les évaluer. Cette partie sera renvoyée en édition pour enrichir la proposition initiale.",
	status: [
		"En attente",
		"À corriger",
		"Améliorable",
		"Acceptable"
	],
	title: "Évaluation",
	to_correct: "À corriger"
};
var header$d = {
	archives: "PIAs Archivés",
	current_pias: "PIAs Actifs",
	exit_full_screen_mode: "Appuyer sur F11 pour quitter le mode plein écran.",
	help: {
		issue_reporting: "Signaler un bug",
		manual: "Manuel d'utilisation",
		pia_example_link: "Exemple de AIIA",
		title: "Aide"
	},
	homepage_link: "Mes PIAs",
	knowledge_base_link: "Base de connaissances",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Traductions fournies par la CNIL",
		community_translations: "Traductions fournies par la communauté",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Traduction révisée par les ADP européenne",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Version originelle",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Analyse d'impact sur la protection des données",
	structures: "Modèles de AIIA",
	tools: {
		about: "À propos",
		accessibility: "Accessibilité malvoyants (couleurs à contraste fort, adapté daltonisme)",
		onboarding: "Relancer le tutoriel",
		settings: "Paramètres",
		url_setting: "Configuration URL serveur",
		users: "Utilisateurs"
	}
};
var help$d = {
	definition: {
		data1: {
			content: "Contenu en cours d'écriture",
			title: "Utiliser l'Outil PIA"
		},
		data2: {
			qa1: {
				content: "Lorsque vous rencontrez des problèmes d’affichage, quitter l’application et relancer la. Cela permet en général de corriger ce type de problèmes. Vos données sont sauvegardées en temps réel, vous ne perdrez donc aucune information saisie.",
				title: "Je rencontre des problèmes d’affichage, comme par exemple des icônes ne se rafraîchissant pas ou des éléments de l’interface manquants."
			},
			qa2: {
				content: "Ce bug est connu et en cours de traitement. Si vous rencontrez ce problème indiquer dans le champ de justification le niveau de gravité ou vraisemblance que vous estimez, en plus de la justification de cette estimation.",
				title: "Je n’arrive pas à éditer les jauges de vraisemblance et gravité des risques"
			},
			qa3: {
				content: "Plusieurs bugs ont été observés lors de l’import d’un PIA, en particulier la disparition des jauges d’évaluation de la gravité et vraisemblance d’un risque. Dans ce cas référez-vous à la question précédente. Si vous ne voyez pas votre PIA apparaître sur le dashboard des PIAs, rafraichissez la page et celui-ci apparaitra.",
				title: "Je rencontre des problèmes à l’import d’un PIA"
			},
			qa4: {
				content: "Ceci est juste un bug d’affichage et ne compromet en rien les informations saisies dans le PIA. Ce problème sera corrigé rapidement.",
				title: "Lorsque je fais des copier-coller, mon texte apparait surligné"
			},
			qa5: {
				content: "Pour demander l’évaluation d’une partie, tous les champs doivent être remplis. Veuillez vérifier que cela est le cas. Lors de l’édition d’un risque, il est obligatoire d’indiquer au moins une mesure technique ou organisationnelle traitant le risque.",
				title: "Je n’arrive pas à demander l’évaluation d’une partie"
			},
			qa6: {
				content: "Fermer le PIA que vous éditez et ouvrez-le de nouveau. Les contenus devraient alors apparaitre dans la langue sélectionnée.",
				title: "Au changement de langue, les textes ne sont pas traduits"
			},
			qa7: {
				content: "Actuellement, les icônes du menu de navigation de gauche ne se rafraîchissent pas après un refus de validation. Vous devez visiter de nouveau chaque section, vérifier les informations et évaluation en fonction des motifs du refus et demander une nouvelle fois une validation. Une fois toutes les sections revues, il sera possible de repasser le PIA pour validation.",
				title: "J’ai refusé de valider un PIA, mais ne sait pas quoi faire ensuite"
			},
			title: "Bugs connus"
		},
		footer: "Si vous rencontrez d’autres problèmes ou si vous avez des suggestions d’amélioration, vous pouvez nous les faire remonter via ce formulaire <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Aide"
};
var homepage$d = {
	cards: {
		author: "Saisie",
		category: "Catégorie",
		creation_status: "Création",
		date: "Date",
		evaluation: "Évaluation",
		guest: "Invité(s)",
		import_pia: "Importer AIIA",
		import_structure: "Importer modèle",
		item: {
			consult_pia: "Consulter",
			consult_structure: "Consulter le modèle",
			edit_pia: "Éditer",
			edit_structure: "Éditer le modèle",
			tools: {
				action_plan: "Afficher le<br>plan d'action",
				archive: "Archiver",
				duplicate: "Dupliquer",
				"export": "Exporter",
				more_options: "Plus d'options",
				pia: "Afficher le<br>PIA",
				remove: "Supprimer",
				unarchive: "Désarchiver"
			},
			validate_pia: "Valider"
		},
		knowledges: {
			edit: "Éditer la base",
			"import": "Importer une base",
			"new": "Créer une base",
			placeholder_author: "Auteur",
			placeholder_contributors: "Contributeurs",
			placeholder_entry_number: "Nombre d'entrées",
			placeholder_name: "Nom de la base"
		},
		knowledges_entry: {
			all_sections: "Toutes les sections",
			choose_category: "Choisissez une catégorie",
			contents: "Contenus",
			create: "Créer l'élément",
			linked_to: "Lié à",
			"new": "Créer un élément",
			placeholder_category: "Catégorie",
			placeholder_description: "Votre description ici...",
			placeholder_name: "Nom de l'élément",
			placeholder_updated_at: "Modifié le"
		},
		new_pia: "Nouveau AIIA",
		new_structure: "Nouveau modèle",
		or: "ou",
		pia_name: "PIA",
		placeholder_author: "Prénom, nom",
		placeholder_category: "Catégorie",
		placeholder_evaluation: "Prénom, nom",
		placeholder_import_knowledgeBase: "Importer une base",
		placeholder_import_pia: "Importer AIIA",
		placeholder_import_structure: "Importer modèle",
		placeholder_new_knowledgeBase: "Créer une base",
		placeholder_new_pia: "Nouveau AIIA",
		placeholder_new_structure: "Nouveau modèle",
		placeholder_pia_name: "Intitulé du AIIA",
		placeholder_sector_name: "Intitulé du Secteur associé",
		placeholder_start: "Tous les champs doivent être remplis",
		placeholder_structure: "Modèle par défaut",
		placeholder_structure_name: "Intitulé du modèle",
		placeholder_validation: "Prénom, nom",
		sector_name: "Secteur associé",
		start: "Commencer",
		status: "Statut",
		structure: "Modèle",
		structure_name: "Nom du modèle",
		title_close_creation: "Fermer",
		validation: "Validation"
	},
	filters: {
		assessor: "Évaluateur",
		author: "Éditeur",
		card: "Affichage carte",
		card_rocket_content: "Lancez-vous !<br><br>Pour commencer<br>un PIA, cliquez<br> sur le +",
		card_rocket_content_structure: "Lancez-vous !<br><br>Pour commencer<br>un modèle, cliquez<br> sur le +",
		category: "Catégorie",
		date: "Date",
		import_pia: "Importer AIIA",
		import_structure: "Importer modèle",
		list: "Affichage liste",
		list_rocket_content: "Lancez-vous ! Pour commencer<br>un PIA, cliquez sur le +",
		list_rocket_content_structure: "Lancez-vous ! Pour commencer<br>un modèle, cliquez sur le +",
		name: "Nom",
		new_pia: "Nouveau AIIA",
		new_structure: "Nouveau modèle",
		sector_name: "Secteur associé",
		sort: "Trier",
		sort_by: "par",
		status: "Statut",
		validator: "Validateur"
	},
	lists: {
		column_actions: "Actions",
		column_author: "Saisie",
		column_category: "Catégorie",
		column_creation: "Création",
		column_evaluation: "Évaluation",
		column_pia: "PIA",
		column_progression: "Progression",
		column_sector_name: "Secteur associé",
		column_status: "Statut",
		column_structure: "Modèle",
		column_structure_name: "Modèle",
		column_updated_at: "Modifié le",
		column_validation: "Validation",
		item: {
			tools: {
				action_plan: "Afficher le plan d'action",
				archive: "Archiver",
				consult: "Consulter",
				duplicate: "Dupliquer",
				edit: "Éditer",
				"export": "Exporter",
				pia: "Afficher le AIIA",
				remove: "Supprimer",
				unarchive: "Désarchiver"
			}
		}
	},
	search_filter: "Chercher",
	no_entries: {
		pia: "Aucun PIA créé et/ou assigné",
		archive: "Aucun PIA archivé"
	}
};
var knowledge_base$d = {
	add_measure: "Ajouter",
	add_measure_hint: "Ajoutez aussi une mesure à partir de la base de connaissances.",
	category: {
		definition: "Définition",
		example: "Exemple",
		general_measure: "Mesure générale de sécurité du système",
		measure_on_data: "Mesure sur les données",
		method: "Méthodologie",
		organizational_measure: "Mesure organisationnelle",
		principle: "Principe"
	},
	choose_knowledge_base: "Sélectionnez votre base de connaissances",
	default_knowledge_base: "Base de connaissances CNIL",
	filters: {
		all: "Tout",
		definitions: "Définitions",
		general_measures: "Mesures générales de sécurité du système",
		measures_on_data: "Mesures sur les données",
		no_result: "Aucun résultat trouvé.",
		organizational_measures: "Mesures organisationnelles",
		title: "Filtres"
	},
	placeholder_add_measure: "Ajouter cette mesure",
	placeholder_help: "Aide à la saisie",
	search: "Rechercher",
	slugs: {
		PIA_DEF_ACC: {
			description: "La personne concernée a le droit d'obtenir du responsable du traitement la confirmation que des données à caractère personnel la concernant sont ou ne sont pas traitées et, lorsqu'elles le sont, l'accès auxdites données à caractère personnel ainsi que d'autres informations précisées à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article15\">article 15 du RGPD</a>.<br>Il existe des particularités concernant l'accès au dossiers médicaux, voir <a target=\"_blank\" href=\"https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000773559\">Décret 2002-637</a>, et l'exercice du droit d'accès par les titulaires de l'autorité parentale, pour les mineurs, ou le représentant légal, pour les personnes faisant l'objet d'une mesure de tutelle voir <a target=\"_blank\" href=\"https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000886460\">Article 58 de la loi Informatique et Libertés</a>.",
			name: "Droit d'accès",
			source: "RGPD Article 15 pour la définition et WIKI Exercice_des_droits_d’accès_et_à_la_portabilité pour les exceptions du droit Français"
		},
		PIA_DEF_ANO: {
			description: "Le but d'une solution d'anonymisation est de faire perdre le caractère identifiant des données à caractère personnel. Une solution d’anonymisation doit être construite au cas par cas et adaptée aux usages prévus. Pour aider à évaluer une bonne solution d’anonymisation, le <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_fr.pdf\">G29</a> propose trois critères :<br>- <strong>L’individualisation : </strong>est-il toujours possible d’isoler un individu ?<br>- <strong>La corrélation : </strong>est-il possible de relier entre eux des ensembles de données distincts concernant un même individu ?<br>- <strong>L’inférence :</strong> peut-on déduire de l’information sur un individu ? <br>Ainsi : <strong>un ensemble de données pour lequel il n’est possible ni d’individualiser ni de corréler ni d’inférer est a priori anonyme</strong> ;<br>un ensemble de données pour lequel <strong>au moins un des trois critères n’est pas respecté </strong>ne pourra être considéré comme anonyme qu’à la suite d’une analyse détaillée des risques de ré-identification.",
			name: "Anonymisation",
			source: "WIKI pour la première phrase, site CNIL pour la description des recommandations du G29 https://www.cnil.fr/fr/le-g29-publie-un-avis-sur-les-techniques-danonymisation-0"
		},
		PIA_DEF_ARCH: {
			description: "Les données qui ne sont plus utilisées au quotidien mais qui n’ont pas encore atteint leur durée limite de conservation, par exemple parce qu’elles sont conservées en cas de contentieux, devraient être archivées.<br><br><strong>Les archives doivent être sécurisées </strong>notamment si les données archivées sont des données sensibles, ou des données qui pourraient avoir des impacts graves sur les personnes concernées.",
			name: "Archivage",
			source: "Guide Bleu 2017 p17"
		},
		PIA_DEF_AUTH: {
			description: "L'authentification est une <strong>opération par laquelle l'utilisateur apporte la preuve de son identité</strong>, pour cela il existe plusieurs mécanismes catégorisés selon qu’ils font intervenir :<br>- ce que l’on sait, par exemple un mot de passe ;<br>- ce que l’on a, par exemple une carte à puce ;<br>- une caractéristique qui nous est propre, par exemple une empreinte digitale ou encore la manière de rédiger une signature manuscrite.<br>Pour rappel, la loi Informatique et Libertés subordonne l’utilisation de la biométrie à l’autorisation préalable de la CNIL<br><strong>L’authentification d’un utilisateur est qualifiée de forte lorsqu’elle a recours à une combinaison d’au moins deux de ces catégories.</strong>",
			name: "Authentification",
			source: "Guide Bleu p7"
		},
		PIA_DEF_CHIF: {
			description: "Le chiffrement d’un message permet de garantir que seuls l’émetteur et le(s) destinataire(s) légitime(s) d’un message en connaissent le contenu. C’est une sorte d’enveloppe scellée numérique. Une fois chiffré, faute d'avoir la clé spécifique, un message est inaccessible et illisible, que ce soit par les humains ou les machines.<br>Il existe deux grandes familles de chiffrement : le chiffrement symétrique et le chiffrement asymétrique.<br>- <strong>Le chiffrement symétrique</strong> permet de chiffrer et de déchiffrer un contenu avec la même clé, appelée alors la « clé secrète ». Le chiffrement symétrique est particulièrement rapide mais nécessite que l’émetteur et le destinataire se mettent d’accord sur une clé secrète commune ou se la transmettent par un autre canal. Celui-ci doit être choisi avec précautions, sans quoi la clé pourrait être récupérée par les mauvaises personnes, ce qui n’assurerait plus la confidentialité du message.<br>- <strong>Le chiffrement asymétrique</strong> suppose que le (futur) destinataire est muni d’une paire de clés (clé privée, clé publique) et qu’il a fait en sorte que les émetteurs potentiels aient accès à sa clé publique. Dans ce cas, l’émetteur utilise la clé publique du destinataire pour chiffrer le message tandis que le destinataire utilise sa clé privée pour le déchiffrer. Parmi ses avantages, la clé publique peut être connue de tous et publiée. Mais attention : il est nécessaire que les émetteurs aient confiance en l’origine de la clé publique, qu’ils soient sûrs qu’il s’agit bien de celle du destinataire. Autre point fort : plus besoin de partager une même clé secrète ! Le chiffrement asymétrique permet de s’en dispenser mais il est plus lent.",
			name: "Chiffrement",
			source: "Guide Bleu 2017 p23 https://www.cnil.fr/fr/comprendre-les-grands-principes-de-la-cryptologie-et-du-chiffrement"
		},
		PIA_DEF_CLO: {
			description: "Ensemble de méthodes permettant de réduire la possibilité de corréler des données à caractère personnel et de provoquer une violation de l’ensemble des données .<br>On pourra par exemple identifier les données propres à chaque métier, les séparer logiquement, etc.",
			name: "Cloisonnement",
			source: "WIKI Cloisonnement_des_données_(par_rapport_au_reste_du_système_d’information)"
		},
		PIA_DEF_CONS: {
			description: "toute manifestation de volonté, libre, spécifique, éclairée et univoque par laquelle la personne concernée accepte, par une déclaration ou par un acte positif clair, que des données à caractère personnel la concernant fassent l'objet d'un traitement.",
			name: "Consentement de la personne concernée",
			source: "RGPD Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Il consiste à limiter les risques que des personnes non autorisées accèdent aux données à caractère personnel sous forme numérique.<br>Pour cela, il convient de :<br>- <strong>définir des profils d’habilitation</strong> dans les systèmes en séparant les tâches et les domaines de responsabilité, afin de limiter l’accès des utilisateurs aux seules données strictement nécessaires à l’accomplissement de leurs missions. <br>- <strong>supprimer les permissions d’accès des utilisateurs dès qu’ils ne sont plus habilités à accéder à un local ou à une resource informatique</strong>, ainsi qu’<strong>la fin de leur contrat.</strong> <br>- <strong> Réaliser une revue annuelle des habilitations</strong> afin d’identifier et de supprimer les comptes non utilisés et de réaligner les droits accordés sur les fonctions de chaque utilisateur.",
			name: "Contrôle d'accès logique",
			source: "WIKI Contrôle_des_accès_logiques et Guide Bleu 2017 p9 pour les précautions"
		},
		PIA_DEF_DCP: {
			description: "Toute information se rapportant à une personne physique identifiée ou identifiable (ci-après dénommée «personne concernée»); est réputée être une «personne physique identifiable» une personne physique qui peut être identifiée, directement ou indirectement, notamment par référence à un identifiant, tel qu'un nom, un numéro d'identification, des données de localisation, un identifiant en ligne, ou à un ou plusieurs éléments spécifiques propres à son identité physique, physiologique, génétique, psychique, économique, culturelle ou sociale.",
			name: "Données à caractère personnel (DCP)",
			source: "RGPD Art. 4.1"
		},
		PIA_DEF_DEST: {
			description: "Personne physique ou morale, l'autorité publique, le service ou tout autre organisme qui reçoit communication de données à caractère personnel, qu'il s'agisse ou non d'un tiers. Toutefois, les autorités publiques qui sont susceptibles de recevoir communication de données à caractère personnel dans le cadre d'une mission d'enquête particulière conformément au droit de l'Union ou au droit d'un État membre ne sont pas considérées comme des destinataires; le traitement de ces données par les autorités publiques en question est conforme aux règles applicables en matière de protection des données en fonction des finalités du traitement.",
			name: "Destinataires des données",
			source: "RGPD Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "La personne concernée a le droit d'obtenir du responsable du traitement l'effacement, dans les meilleurs délais, de données à caractère personnel la concernant et le responsable du traitement a l'obligation d'effacer ces données à caractère personnel dans les meilleurs délais, conformément à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article17\">article 17 du RGPD</a>",
			name: "Droit à l'effacement (droit à l'oubli)",
			source: "RGPD Art. 17 (tronqué)"
		},
		PIA_DEF_ENJ: {
			description: "Il s'agit des motivations menant à la mise en oeuvre du traitement, les bénéfices attendus (pour l’organisme, pour les personnes concernées, pour la société en général…).",
			name: "Enjeux du traitement",
			source: "PIA1 p6 (note 8 en bas de page)"
		},
		PIA_DEF_EXA: {
			description: "Les données à caractère personnel doivent être exactes et, si nécessaire, tenues à jour; toutes les mesures raisonnables doivent être prises pour que les données à caractère personnel qui sont inexactes, eu égard aux finalités pour lesquelles elles sont traitées, soient effacées ou rectifiées sans tarder (exactitude), conformément à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article5\">article 5.1 d)</a>.",
			name: "Qualité des données",
			source: "RGPD Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "La gravité représente l’ampleur d’un risque. Elle dépend essentiellement du caractère préjudiciable des impacts potentiels",
			name: "Gravité",
			source: "PIA1 p9"
		},
		PIA_DEF_LIM: {
			description: "La personne concernée a le droit d'obtenir du responsable de traitement la limitation du traitement conformément à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article18\">article 18 du RGPD</a>",
			name: "Droit à la limitation",
			source: "RGPD Art. 18 (tronqué)"
		},
		PIA_DEF_LOG: {
			description: "Dispositif permettant d’enregistrer des actions effectuées sur le système informatique afin de pouvoir <strong>identifier un accès frauduleux</strong> ou <strong>une utilisation abusive</strong> de données personnelles, ou de déterminer l’origine d’un incident. Il convient d’enregistrer certaines des actions effectuées sur les systèmes informatiques. Pour ce faire, un dispositif de gestion des traces et des incidents doit être mis en place. Celui-ci doit <strong>enregistrer les évènements pertinents</strong> et <strong>garantir que ces enregistrements ne peuvent être altérés.</strong> Dans tous les cas, il ne faut <strong>pas conserver ces éléments pendant une durée excessive.</strong>",
			name: "Journalisation",
			source: "Guide Bleu 2017 p10"
		},
		PIA_DEF_MEN: {
			description: "Mode opératoire composé d'une ou plusieurs actions unitaires sur des supports de données. La menace peut être utilisée, volontairement ou non, par des sources de risques, et peut alors provoquer un événement redouté.",
			name: "Menace",
			source: "PIA1 p11"
		},
		PIA_DEF_MENA: {
			description: "Menaces concernant : </strong><br>- <strong>Les matériels</strong>, utilisés de manière inadaptée, observés, modifiés ou perdus (utilisation d'un support contenant des données sensibles pour des raisons personnelles ou lors d'un transport pour lequel il n'est pas adapté, observation d'un écran, ajout d'un matériel destiné à récupérer des données etc.)<br>- <strong>Les logiciels</strong>, utilisés de manière inadaptée, observés ou modifiés (élévation de privilèges, collecte de données de configuration, installation d'un outil de prise de main à distance, etc.)<br>- <strong>Les canaux informatiques</strong> qui sont observés (interception de flux réseau, etc.)<br>- <strong>Les personnes</strong>, observées, détournées ou perdues (divulgation involontaire, à la suite de pressions ou grâce à de l'hameçonnage, changement d'employeur, etc.)<br>- <strong>Les documents papier</strong>, observés ou perdus (photocopies, impressions oubliées, récupération de documents au rebut, vol de courrier, etc.)<br>- <strong>Les canaux papier</strong> qui sont observés",
			name: "Menaces pouvant conduire à un accès illégitime aux données",
			source: "WIKI Menaces_pouvant_mener_à_un_accès_illégitime_à_des_données synthétisé"
		},
		PIA_DEF_MENI: {
			description: "<strong>Menaces concernant : </strong><br>- <strong>Les matériels</strong> : utilisés de manière inadaptée, surchargés, modifiés, détériorés, perdus (stockage saturé, attaque DOS, modification menant à une panne,  incendie, vol ou perte, etc.)<br>- <strong>Les logiciels</strong> : utilisés de manière inadaptée, surchargés, modifiés, détériorés, perdus (effacement de données, injection de données, bombe logique, licence non renouvelée, etc.)<br>- <strong>Les canaux informatiques</strong> : surchargés, détériorés, perdus (téléchargement non autorisé, coupure d’accès Internet, etc.)<br>- <strong>Les personnes</strong> : surchargées, détériorées, perdues (mauvaise utilisation des compétences, absence, départ, etc.)<br>- <strong>Les documents papier</strong> : utilisés de manière inadaptée, détériorés, perdus (effacement, destruction, vol ou perte, etc.)<br>- <strong>Les canaux papier</strong> : détériorés, modifiés, perdus (grève des postes, changement de locaux, disparition d'un transporteur de documents, réorganisation, etc.)",
			name: "Menaces pouvant conduire à une indisponibilité des données",
			source: "WIKI Menaces_pouvant_mener_à_une_disparition_de_données"
		},
		PIA_DEF_MENM: {
			description: "<strong>Menaces concernant : </strong><br>- <strong>Les matériels</strong> qui ont été modifiés (ajout d'un matériel incompatible, retrait d'un indispensable, etc.)<br>- <strong>Les logiciels</strong> utilisés de manière inadaptée ou modifiés (erreur de manipulation, modifications inopportunes, etc.)<br>- <strong>Les canaux informatiques</strong> qui sont utilisés de manière inadaptée (réémission de flux intercepté, etc.)<br>- <strong>Les personnes</strong> surchargées ou détournées (tâche non maîtrisée, perturbation des conditions de travail, influence, etc.)<br>- Les documents papier qui ont été modifiés (modification de document, remplacement par un faux, etc.)<br>- <strong>Les canaux papier</strong> qui ont été modifiés (échange de parapheur, envoi de courriers contradictoires, etc.)",
			name: "Menaces pouvant conduire à une modification illégitime aux données",
			source: "WIKI Menaces_pouvant_mener_à_une_modification_non_désirées_de_données"
		},
		PIA_DEF_MES: {
			description: "A choisir parmi celles disponibles dans la section \"Mesures existantes ou prévues\", que vous pouvez compléter si nécessaire.",
			name: "Mesure",
			source: "Aucune"
		},
		PIA_DEF_MIN1: {
			description: "Lors de l'importation de données, différents types de métadonnées (par exemple, des données EXIF attachées avec un fichier d'image) peuvent être involontairement collectés.<br>Ces métadonnées doivent être identifiées et éliminées si elles ne sont pas nécessaires aux finalités spécifiées.",
			name: "Filtrage et retrait",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN2: {
			description: "Après réception de données sensibles, faisant partie d’un lot d’informations générales ou transmises à des fins statistiques uniquement, celles-ci peuvent être converties en une forme moins sensible ou pseudonymisée. Par exemple :<br>- si le système collecte l’adresse IP pour déterminer l'emplacement de l’utilisateur dans un but statistique, l’adresse IP peut être supprimées après déduction de la ville ou du quartier ;<br>- si le système reçoit des données vidéo à partir de caméras de surveillance, il peut reconnaître les personnes debout ou en mouvement dans la scène et les flouter ;<br>- si le système est un compteur intelligent, il peut agréger l'utilisation de l'énergie sur une certaine période, sans l’enregistrer en temps réel.",
			name: "Réduction de la sensibilité par transformations",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN3: {
			description: "Le système peut faire en sorte que :<br>- l’utilisateur peut utiliser une resource ou un service sans risque de divulguer son identité (données anonymes) ;<br>- l’utilisateur peut utiliser une resource ou un service sans divulguer son identité, mais reste identifiable et responsable de cette utilisation (données pseudonymes) ;<br>- l’utilisateur peut faire de multiples utilisations des resources ou des services sans risque que ces utilisations puissent être reliées ensemble (données non corrélables) ;<br>- l’utilisateur peut utiliser une resource ou un service sans risque que d’autres, en particulier des tiers, puissent être en mesure d'observer que la resource ou le service est utilisé (non-observabilité).<br>Le choix d'une méthode de la liste ci-dessus doit dépendre des menaces identifiées. Pour certains types de menaces sur la vie privée, la pseudonymisation sera plus appropriée que l'anonymisation (par exemple, s'il y a un besoin de traçabilité). En outre, certaines menaces sur la vie privée seront traitées par une combinaison de plusieurs méthodes.",
			name: "Réduction du caractère identifiant des données",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN4: {
			description: "Le système peut être structuré en parties indépendantes avec des fonctions de contrôle d'accès distinctes. Les données peuvent également être réparties entre ces sous-systèmes indépendants et contrôlées par chaque sous-système en utilisant différents mécanismes de contrôle d'accès. Si un sous-système est compromis, les impacts sur l’ensemble des données peuvent ainsi être réduits.",
			name: "Réduction de l'accumulation de données",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN5: {
			description: "Le système peut limiter l'accès aux données selon le principe du « besoin d’en connaître ». Le système peut séparer les données sensibles et appliquer des politiques de contrôle d'accès spécifiques.<br>Le système peut aussi chiffrer les données sensibles pour protéger leur confidentialité lors de la transmission et du stockage. L’accès aux fichiers cachés temporaires qui sont produits au cours du traitement des données devrait également être protégé.",
			name: "Restriction de l’accès aux données",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MINC: {
			description: "Réduire la gravité des risques en limitant la collecte des données à caractère personnel au strict nécessaire au regard d’une finalité définie; éviter la collecte de données non nécessaires, l'utilisation de données sans lien avec la finalité et des impacts excessifs pour les personnes.",
			name: "Minimisation de la collecte",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Réduire la gravité des risques en minimisant les données elles-mêmes, par des mesures destinées à réduire leur sensibilité, par exemple filtrer et retirer les données inutiles, pseudonymiser les données, etc.",
			name: "Minimisation des données elles-mêmes",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_OPP: {
			description: "La personne concernée a le droit de s'opposer à tout moment, pour des raisons tenant à sa situation particulière, à un  traitement  des  données à  caractère personnel la  concernant conformément à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article21\">article 21 du RGPD</a>.",
			name: "Droit à l'opposition",
			source: "RGPD Art. 21 (tronqué)"
		},
		PIA_DEF_PBDS: {
			description: "Démarche consistant à prendre en compte la protection des données à caractère personnel dans tout nouveau traitement (labels de confiance, référentiels, gestion des risques pour la personne concernée selon la méthodologie de la CNIL ou une méthode interne, etc.), notamment :<br>- Utiliser la démarche de gestion des risques de la CNIL dès l’élaboration d’un service ou la conception d’une application.<br>- Privilégier le recours à des labels de confiance dans les domaines de la SSI et « Informatique et libertés » (procédures, produits, systèmes de management, organismes, personnes, etc.).<br>- Privilégier le recours à des référentiels éprouvés et reconnus.",
			name: "Gestion de projet",
			source: "WIKI Gestion_des_projets - les recommandations ne sont pas citées"
		},
		PIA_DEF_PC: {
			description: "Personne à laquelle se rapportent les données qui font l'objet du traitement.",
			name: "Personne concernée",
			source: "PIA1 p11"
		},
		PIA_DEF_PORT: {
			description: "Les personnes concernées ont le droit de recevoir les données à caractère personnel les concernant qu'elles ont fournies à un responsable du traitement, dans un format structuré, couramment utilisé et lisible par machine, et ont le droit de transmettre ces données à un autre responsable du traitement sans que le responsable du traitement auquel les données à caractère personnel ont été communiquées y fasse obstacle sous les conditions décrites à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article20\">Article 20 du RGPD</a>.",
			name: "Droit à la portabilité",
			source: "RGPD Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Traitement des données à caractère personnel de telle façon que celles-ci ne puissent plus être attribuées à une personne concernée précise sans avoir recours à des informations supplémentaires, pour autant que ces informations supplémentaires soient conservées séparément et soumises à des mesures techniques et organisationnelles afin de garantir que les données à caractère personnel ne sont pas attribuées à une personne physique identifiée ou identifiable.<br>La pseudonymisation réduit le risque de mise en corrélation d’un ensemble de données avec l’identité  originale d’une personne concernée; à ce titre, <strong>c’est une mesure de sécurité utile, mais non une méthode d'anonymisation.</strong>",
			name: "Pseudonymisation",
			source: "RGPD Art. 4.5 pour la définition, guidelines G29 p22 pour le distinction avec l'anonymisation http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_fr.pdf"
		},
		PIA_DEF_PWD: {
			description: "Basée sur la gestion d’un secret, l’authentification par identifiant et mot de passe est un moyen simple et peu coûteux à déployer pour contrôler un accès. Toutefois, cette méthode d’authentification présente un niveau de sécurité faible.<br>Les exigences minimales de la CNIL en termes de taille et de complexité du mot de passe varient en fonction des mesures complémentaires mises en place pour fiabiliser le processus d’authentification :<br>ainsi, si une authentification est basée exclusivement sur un mot de passe, cela implique a minima l’utilisation d’un mot de passe complexe d’au moins 12 caractères composé de majuscules de minuscules, de chiffres et de<br>caractères spéciaux.  Des mesures complémentaires à la saisie d’un mot de passe (restrictions, d’accès, collecte d’autres donnée, support détenu en propre par l’utilisateur) permettent de réduire la longueur et la complexité du mot de passe, car ces mesures permettent d’assurer un niveau de sécurité équivalent au mot de passe seul.",
			name: "Mot de passe",
			source: "Guide Bleu 2017 p7 : https://www.cnil.fr/fr/authentification-par-mot-de-passe-les-mesures-de-securite-elementaires synthétisé"
		},
		PIA_DEF_RECT: {
			description: "La personne concernée a le droit d'obtenir du responsable du traitement, dans les meilleurs délais, la rectification des données à caractère personnel la concernant qui sont inexactes.<br>Compte tenu des finalités du traitement, la personne concernée a le droit d'obtenir que les données à caractère personnel incomplètes soient complétées, y compris en fournissant une déclaration complémentaire.",
			name: "Droit à la rectification",
			source: "RGPD Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Règlement relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données (<a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/FR/TXT/PDF/?uri=CELEX:32016R0679&from=DE\">UE 2016-679</a>), adopté le 27 avril 2016 par l'Union Européenne, il entrera en application  le 25/05/2018, abrogeant la directive 95/46/CE.",
			name: "RGPD (Règlement Général sur la Protection des Données)",
			source: "RGPD en-tête"
		},
		PIA_DEF_RT: {
			description: "La personne physique ou morale, l'autorité publique, le service ou un autre organisme qui, seul ou conjointement avec d'autres, détermine les finalités et les moyens du traitement; lorsque les finalités et les moyens de ce traitement sont déterminés par le droit de l'Union ou le droit d'un État membre, le responsable du traitement peut être désigné ou les critères spécifiques applicables à sa désignation peuvent être prévus par le droit de l'Union ou par le droit d'un État membre.<br>Pour plus d'informations sur les obligations du responsable de traitement, se référer au <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Section1\">chap. IV du [RGPD]</a>",
			name: "Responsable de traitement",
			source: "RGPD Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Personne, interne ou externe à l'organisme, agissant de manière accidentelle ou délibérée (ex : administrateur informatique, utilisateur, attaquant externe, concurrent), ou source non humaine (ex : eau, matériaux dangereux, virus informatique non ciblé) qui peut être à l’origine d’un risque.",
			name: "Source de risque",
			source: "PIA1 p12 et WIKI Types_et_exemples_de_sources_de_risques synthétisés"
		},
		PIA_DEF_ST: {
			description: "Personne physique ou morale, autorité publique, service ou un autre organisme qui traite des données à caractère personnel pour le compte du responsable du traitement <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre1#Article4\">Article 4.8 du RGPD</a>. <br>Le sous-traitant et toute personne agissant sous l'autorité du responsable du traitement ou sous celle du sous-traitant, qui a accès à des données à caractère personnel, ne peut pas traiter ces données, excepté sur instruction du responsable du traitement, à moins d'y être obligé par le droit de l'Union ou le droit d'un État membre <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article29\">Article 29 du RGPD</a>.",
			name: "Sous-traitant",
			source: "RGPD articles 4.8 et 29"
		},
		PIA_DEF_SUPT: {
			description: "<strong>Matériels et supports de données électroniques</strong> : ordinateurs, relais de communication, clés USB, disques durs...<br><strong>Logiciels</strong> : systèmes d’exploitation, messagerie, bases de données, applications métier...<br><strong>Canaux informatiques</strong> : câbles, WiFi, fibre optique<br><br><strong>Personnes</strong> : utilisateurs, administrateurs informatiques, décideurs...<br><strong>Supports papier</strong> : impressions, photocopies, documents manuscrits...<br><strong>Canaux de transmission papier</strong> : envoi postal, circuit de validation...",
			name: "Typologie des supports de DCP",
			source: "WIKI Types_et_exemples_de_supports_des_données"
		},
		PIA_DEF_VIOL: {
			description: "Violation de la sécurité entraînant, de manière accidentelle ou illicite, la destruction, la perte, l'altération, la divulgation non autorisée de données à caractère personnel transmises, conservées ou traitées d'une autre manière, ou l'accès non autorisé à de telles données.",
			name: "Violation de données",
			source: "RGPD Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "La vraisemblance traduit la possibilité qu’un risque se réalise. Elle dépend essentiellement des vulnérabilités des supports face aux menaces et des capacités des sources de risques à les exploiter.",
			name: "Vraisemblance",
			source: "PIA1 p12"
		},
		PIA_EX_DC: {
			description: "Données pour un système de score, résultat de l’application du score...",
			name: "Données calculées"
		},
		PIA_EX_DCPC: {
			description: "<strong>Données d’identification</strong> : état civil, age, nationalité, double nationalité, adresse postale, capacité juridique... <br><strong>Vie personnelle</strong> : situation maritale, nombre d’enfants, département de résidence, type d’habitation, situation de logement, ancienneté dans le logement, CSP... <br><strong>Vie professionnelle</strong> : emploi, type de contrat, CSP, nom de l’employeur, ancienneté dans l’emploi, chômage... <br><strong>Données de connexion</strong> : adresse IP, journaux d'événements...<br><strong>Données de localisation</strong> : déplacement, données GPS, GSM...<br><strong>Autre</strong> : numéro de téléphone, adresse électronique...",
			name: "Données courantes",
			source: "WIKI Types_de_données"
		},
		PIA_EX_DCPR: {
			description: "Opinions philosophiques, politiques, religieuses, syndicales, vie sexuelle, données de santé, origine raciales ou ethniques, relatives à la santé ou à la vie sexuelle, infractions, condamnations, mesures de sécurité.<br>Se référer aux <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article9\">art. 9</a> <br> et <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article10\">art.10</a> du [RGPD]",
			name: "Données d’infraction et données sensibles"
		},
		PIA_EX_DCPS: {
			description: "Numéro de sécurité sociale (NIR), données biométriques, données bancaires...",
			name: "Données perçues comme sensibles"
		},
		PIA_EX_HUME: {
			description: "Il peut s'agir :<br>- d'un tiers malintentionné ou ignorant utilisant sa proximité physique pour accéder frauduleusement au service<br>- d'un attaquant ciblant un utilisateur en utilisant sa connaissance de l’utilisateur et de certaines des informations le concernant<br>- d'un attaquant ciblant une des sociétés en charge du traitement utilisant sa connaissance des sociétés pouvant permettre d’attenter à leur image<br>- d'un organisme tiers autorisé utilisant ses accès privilégiés pour accéder illégitimement à des informations. Les motivations peuvent être multiples : jeu, nuisance, malveillance, vengeance, espionnage, appât du gain, acquisition de données en vue de les exploiter",
			name: "Source humaine externe"
		},
		PIA_EX_HUMI: {
			description: "Il peut s'agir :<br>- d'un employé, malintentionné, utilisant sa proximité du système, ses compétences, ses privilèges et un temps disponible potentiellement élevés ou commettant une négligence due à un possible manque de formation et de sensibilisation.<br>- d'un utilisateur ou de son entourage, négligent ou malintentionné, ayant accès au service.<br>Ses motivations peuvent être multiples : maladresse, erreur, négligence, vengeance, volonté d’alerter, malveillance, appât du gain, espionnage",
			name: "Source humaine interne"
		},
		PIA_EX_IMPI: {
			description: "Les personnes concernées pourraient connaître des conséquences significatives, qu’elles devraient pouvoir surmonter, mais avec des difficultés réelles et significatives<br>Exemples d'impacts :<br>- corporels : affection physique grave causant un préjudice à long terme (aggravation de l’état de santé suite à une mauvaise prise en charge, ou au non respect de contre-indications), altération de l’intégrité corporelle, etc.<br>- matériels : détournements d’argent non indemnisé, opportunités ciblées, uniques et non récurrentes, perdues (prêt immobilier, études, stages ou emploi, interdiction d’examen), perte de logement, perte d’emploi, etc.<br>- moraux : Affection psychologique grave (dépression, phobie), sentiment d’atteinte à la vie privée et de préjudice irrémédiable, victime de chantage, cyberbullying et harcèlement moral, etc.",
			name: "Impact Important"
		},
		PIA_EX_IMPL: {
			description: "Les personnes concernées pourraient connaître des désagréments significatifs, qu’elles pourront surmonter malgré quelques difficultés<br>Exemples d'impacts :<br>- corporels : affection physique mineure (ex. : maladie bénigne suite au non respect de contre-indications), diffamation donnant lieu à des représailles physiques, etc.<br>- matériels : paiements non prévus (ex. : amendes erronées), refus d’accès à des services administratifs ou commerciaux, publicité ciblée en ligne sur un aspect vie privée que la personne souhaitait garder confidentiel , etc.<br>- moraux : affection psychologique mineure mais objective, sentiment d’atteinte à la vie privée sans préjudice irrémédiable, intimidation sur les réseaux sociaux, etc.",
			name: "Impact limité"
		},
		PIA_EX_IMPM: {
			description: "Les personnes concernées pourraient connaître des conséquences significatives, voire irrémédiables, qu’elles pourraient ne pas surmonter<br>Exemples d'impacts :<br>- corporels : affection physique de longue durée ou permanente, altération définitive de l’intégrité physique, décès<br>- matériels : péril financier, dettes importantes, impossibilité de travailler, impossibilité de se reloger, perte de preuves dans le cadre d’un contentieux, perte d’accès à une infrastructure vitale (eau, électricité),etc.<br>- moraux : affection psychologique de longue durée ou permanente, sanction pénale, enlèvement, perte de lien familial, impossibilité d’ester en justice, changement de statut administratif et/ou perte d’autonomie juridique (tutelle), etc.",
			name: "Impact maximal"
		},
		PIA_EX_IMPN: {
			description: "Les personnes concernées ne seront pas impactées ou pourraient connaître quelques désagréments, qu’elles surmonteront sans difficulté.<br>Exemples d'impacts :<br>- corporels : maux de tête passagers<br>- matériels : perte de temps pour réitérer des démarches ou pour attendre de les réaliser, réutilisation des données à des fins de publicité ciblée pour des produits de consommation courante, etc.,<br>- moraux : simple contrariété, sentiment d'atteinte à la vie privée sans préjudice réel (intrusion commerciale), etc.",
			name: "Impact négligeable"
		},
		PIA_EX_NHUM: {
			description: "Il peut s'agir d'un incident ou sinistre chez un des organismes en charge du traitement (coupure de courant, incendie, inondation, etc.)",
			name: "Source non humaine"
		},
		PIA_EX_VRAI: {
			description: "il semble possible pour les sources de risques retenues de réaliser la menace en s’appuyant sur les caractéristiques des supports (ex. : vol de supports papiers stockés dans les bureaux d’un organisme dont l’accès est contrôlé par une personne à l’accueil).",
			name: "Vraisemblance importante"
		},
		PIA_EX_VRAL: {
			description: "Il semble difficile pour les sources de risques retenues de réaliser la menace en s’appuyant sur les caractéristiques des supports (ex. : vol de supports papiers stockés dans un local de l’organisme dont l’accès est contrôlé par badge).",
			name: "Vraisemblance limitée"
		},
		PIA_EX_VRAM: {
			description: "il semble extrêmement facile pour les sources de risques retenues de réaliser la menace en s’appuyant sur les caractéristiques des supports (ex. : vol de supports papier stockés dans le hall public de l’organisme).",
			name: "Vraisemblance maximale"
		},
		PIA_EX_VRAN: {
			description: "Il ne semble pas possible que les sources de risques retenues puissent réaliser la menace en s’appuyant sur les caractéristiques des supports (ex. : vol de supports papiers stockés dans un local de l’organisme dont l’accès est contrôlé par badge et code d’accès).",
			name: "Vraisemblance négligeable"
		},
		PIA_LGL_CONS: {
			description: "Il s'agit de permettre un choix libre, spécifique et éclairé; vérifier que l'une des bases légales du traitement est le consentement, tel que prévu à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article6\">article 6 du RGPD</a> (obligation légale, sauvegarde de la vie, mission de service public, contrat ou mesures prises avec la personne, intérêt légitime).",
			name: "Recueil du consentement de l'utilisateur du service",
			source: "WIKI Recueil_du_consentement"
		},
		PIA_LGL_DATA: {
			description: "Délimiter et décrire le périmètre de manière détaillée : <br> - les données personnelles concernées, leurs destinataires et durées de conservation ;<br> - une description des processus et des supports de données pour l’ensemble du cycle de vie des données (depuis leur collecte jusqu’à leur effacement).",
			name: "Données traitées",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Présenter le traitement considéré, les finalités et les enjeux de manière synthétique. Identifier le responsable du traitement et les éventuels sous-traitants. Recenser les référentiels applicables au traitement, utiles ou à respecter , notamment les codes de conduite approuvés<br>Cf. <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article40\">art. 40 du [RGPD]</a>) <br>et certifications en matière de protection des données (cf. <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article42\">art. 42 du [RGPD]</a>).",
			name: "Description du traitement",
			source: "PIA1 p6"
		},
		PIA_LGL_DEST: {
			description: "Personne physique ou morale, l'autorité publique, le service ou tout autre organisme qui reçoit communication de données à caractère personnel, qu'il s'agisse ou non d'un tiers. Toutefois, les autorités publiques qui sont susceptibles de recevoir communication de données à caractère personnel dans le cadre d'une mission d'enquête particulière conformément au droit de l'Union ou au droit d'un État membre ne sont pas considérées comme des destinataires; le traitement de ces données par les autorités publiques en question est conforme aux règles applicables en matière de protection des données en fonction des finalités du traitement. Comme mentionné à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre1#Article4\">art. 4.9 du [RGPD]</a>",
			name: "Destinataires",
			source: "RGPD Art. 4.9"
		},
		PIA_LGL_DUR: {
			description: "Une durée de conservation doit être définie pour chaque type de données et justifiée par les besoins du traitement et/ou des contraintes légales. On distingue ainsi les données courantes et les données archivées dont l’accès sera restreint aux seuls acteurs concernées. Un mécanisme de suppression doit être implémenté pour archiver les données courantes ou purger les données archivées à la fin de leur période de conservation. Les traces fonctionnelles devront également être purgées, tout comme les logs techniques qui ne pourront pas être conservés indéfiniment.",
			name: "Durée de conservation des données",
			source: "PIAF Objets connectés p10"
		},
		PIA_LGL_FIN: {
			description: "Les données à caractère personnel doivent être collectées pour des finalités déterminées, explicites et légitimes et <strong>ne sont pas traitées ultérieurement de manière incompatible avec ces finalités</strong>; <br> Comme mentionné à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article5\">art. 5b du [RGPD]</a>",
			name: "Finalités de la collecte et de l'utilisation des données",
			source: "RGPD Art. 5b"
		},
		PIA_LGL_FOND: {
			description: "- La personne concernée a consenti au traitement de ses données à caractère personnel pour une ou plusieurs finalités spécifiques <br> - Le traitement est nécessaire à l'exécution d'un contrat auquel la personne concernée est partie ou à l'exécution de mesures précontractuelles prises à la demande de celle-ci <br> - Le traitement est nécessaire au respect d'une obligation légale, définie par le droit de l’Union ou le droit de l’état membre auquel le responsable de traitement est soumis, à laquelle le responsable du traitement est soumis <br> - Le traitement est nécessaire à la sauvegarde des intérêts vitaux de la personne concernée ou d'une autre personne physique <br> - Le traitement est nécessaire à l'exécution d'une mission d'intérêt public ou relevant de l'exercice de l'autorité publique dont est investi le responsable du traitement <br> - Le traitement est nécessaire aux fins des intérêts légitimes poursuivis par le responsable du traitement ou par un tiers, à moins que ne prévalent les intérêts ou les libertés et droits fondamentaux de la personne concernée qui exigent une protection des données à caractère personnel, notamment lorsque la personne concernée est un enfant. Se référer à l'<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article6\">art. 6 du [RGPD]</a>",
			name: "Fondement juridique",
			source: "PIA2 p4/WIKI Fondement_:_licéité_du_traitement,_interdiction_du_détournement_de_finalité"
		},
		PIA_LGL_INFO: {
			description: "Il s'agit de garantir l’information des personnes et donc éviter la collecte de données à leur insu; vérifier que le traitement ne fait pas l’objet d’une exception ou de conditions particulières.",
			name: "Information de l'utilisateur du service au sujet de l'utilisation de ses données",
			source: "WIKI Information_des_personnes_concernées_(traitement_loyal_et_transparent)"
		},
		PIA_LGL_MINI: {
			description: "Il s'agit de  réduire la gravité des risques en limitant la collecte des données à caractère personnel au strict nécessaire au regard d’une finalité définie ; éviter la collecte de données non nécessaires, l'utilisation de données sans lien avec la finalité et des impacts excessifs pour les personnes.",
			name: "Minimisation des données",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_LGL_ST: {
			description: "Un contrat de sous-traitance doit être conclu avec chacun des sous-traitants, précisant l’ensemble des éléments prévus à l’art. 28 du RGPD : durée, périmètre, finalité, des instructions de traitement documentées, l’autorisation préalable en cas de recours à un sous-traitant, mise à disposition de toute documentation apportant la preuve du respect du RGPD, notification dans les meilleurs délais de toute violation de données, etc.",
			name: "Sous-traitance",
			source: "PIA2 p10/WIKI Sous-traitance_:_identifiée_et_contractualisée"
		},
		PIA_LGL_SUPT: {
			description: "Bien sur lequel reposent des données. Note: il peut s’agir de matériels, de logiciels, de canaux informatiques, de personnes, de supports papier ou de canaux de transmission papier.",
			name: "Support des données",
			source: "PIA1 p12"
		},
		PIA_LGL_TRAN: {
			description: "Détailler le lieu géographique de stockage des différentes données du traitement. En fonction du pays concerné, vous devrez justifier le choix d’un hébergement hors de l'Union Européenne et indiquer les modalités d’encadrement juridique mises en œuvre afin d’assurer une protection adéquate aux données faisant l’objet d’un transfert transfrontalier. <br> C'est à dire : <br> - Dans un pays de l'Union Européenne <br> - Dans un pays reconnu adéquat par l'Union Européenne <br> - Transfert aux Etats-Unis à une société adhérant Privacy Shield <br>- Autres pays <br> Conformément aux <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre5#Article44\">articles 44 à 49 du [RGPD]</a>",
			name: "Transferts",
			source: "WIKI Transferts_:_respect_des_obligations_en_mati%C3%A8re_de_transfert_de_donn%C3%A9es_en_dehors_de_l%E2%80%99Union_europ%C3%A9enne et PIAF Objets connectés p17"
		},
		PIA_METHOD_MES: {
			description: "Les mesures initiales sont les mesures prévues à l'origine, avant l'analyse faite par l’évaluateur. Les mesures complémentaires ou correctrices préconisées par l’évaluateur seront énoncées dans le plan d’action et permettront de procéder à une deuxième évaluation de la gravité et de la vraisemblance.",
			name: "Mesures initiales et mesures correctrices",
			source: "WIKI Menaces_pouvant_mener_à_une_modification_non_désirées_de_données"
		},
		PIA_ORG_AUD: {
			description: "Existence de mesures permettant de disposer d’une vision globale et à jour de l’état de protection des données et de la conformité au RGPD (contrôler la conformité des traitements, objectifs et indicateurs, responsabilités, etc.).",
			name: "Superviser la protection de la vie privée",
			placeholder: "Décrivez ici les processus qui assurent un contrôle régulier des traitements de données.",
			source: "WIKI Supervision"
		},
		PIA_ORG_EXT: {
			description: "Existence d'une procédure visant à réduire les risques que les accès légitimes aux données par des tiers peuvent faire peser sur les libertés et la vie privée des personnes concernées (identification des tiers, contrat de sous-traitance, convention, BCR, etc.).",
			name: "Gestion des tiers accédant aux données.",
			placeholder: "Indiquez ici, pour les tiers amenés à avoir accès aux données, les modalités et les mesures de sécurité mises en œuvre pour ces accès.",
			source: "WIKI Relations_avec_les_tiers"
		},
		PIA_ORG_ORG: {
			description: "Existence d’une organisation apte à diriger et contrôler la protection des données à caractère personnel au sein de l’organisme (désignation d'un un CIL/DPD, création d'un comité de suivi, etc.).",
			name: "Organisation de la politique de protection de la vie privée",
			placeholder: "Décrivez ici l'organisation de la protection de la vie privée au sein de votre organisme.",
			source: "WIKI Organisation"
		},
		PIA_ORG_PBD: {
			description: "Existence de procédures décrivant les méthodes destinées à prendre en compte la protection des données à caractère personnel dans tout nouveau traitement (labels de confiance, référentiels, gestion des risques pour la personne concernée selon la méthodologie CNIL ou une méthode interne, etc.).",
			name: "Intégrer la protection de la vie privée dans les projets",
			placeholder: "Décrivez ici les méthodes assurant la prise en compte de la protection des données à caractère personnel dès l'initiation d'un nouveau projet.",
			source: "WIKI Gestion_des_projets"
		},
		PIA_ORG_PERS: {
			description: "Existence d'un plan encadrant les <strong>mesures de sensibilisation</strong> prises à l’arrivée d’une personne dans sa fonction et d'une procédure décrivant les <strong>mesures prises au départ des personnes accédant aux données</strong>.",
			name: "Gestion des personnels",
			placeholder: "Indiquez ici les mesures de votre politique de resource humaine répondant aux problématiques informatique et libertés dans votre organisme.",
			source: "PIAF Objets connectés p24"
		},
		PIA_ORG_POL: {
			description: "Le Responsable de traitement doit disposer d’une base documentaire formalisant les objectifs et les règles à appliquer dans le domaine « Informatique et libertés » (plan d'action, révision régulière de la politique « Informatique et libertés », etc.).",
			name: "Gérer la politique de protection de la vie privée",
			placeholder: "Décrivez ici les méthodes de gestion de la base documentaire encadrant l'organisation de la protection de la vie privée au sein de votre organisme.",
			source: "WIKI Politique_(gestion_des_règles)"
		},
		PIA_ORG_RMGT: {
			description: "Existence d'une politique définissant les processus destinés à maîtriser les risques que les traitements de l’organisme font peser sur les droits et libertés des personnes concernées (recensement des traitements de données à caractère personnel, des données, des supports, appréciation des risques, déterminer les mesures existantes ou prévues, etc.).",
			name: "Gérer les risques",
			placeholder: "Décrivez ici les processus destinés à maîtriser les risques que les traitements de l’organisme font peser sur les droits et libertés des personnes concernées.",
			source: "WIKI Gestion_des_risques"
		},
		PIA_ORG_VIOL: {
			description: "Existence d’une organisation opérationnelle permettant de détecter et de traiter les événements susceptibles d’affecter les libertés et la vie privée des personnes concernées (définition des responsabilités, plan de réaction, qualifier les violations, etc.).",
			name: "Gérer les incidents de sécurité et les violations de données",
			placeholder: "Décrivez ici les processus opérationnels destinés à détecter et traiter les événements susceptibles d’affecter les libertés et la vie privée des personnes concernées.",
			source: "WIKI Gestion_des_incidents_et_des_violations_de_données"
		},
		PIA_SEC_BKP: {
			description: "Existence d'une politique de sauvegarde permettant d'assurer la disponibilité et/ou l’intégrité des données à caractère personnel, tout en protégeant leur confidentialité (régularité des sauvegardes, chiffrement du canal de transmission des données, test d'intégrité, etc.).",
			name: "Sauvegarde des données",
			placeholder: "Indiquez ici comment les sauvegardes sont gérées et conservées.",
			source: "WIKI Sauvegardes"
		},
		PIA_SEC_COMP: {
			description: "Mesures prises afin de diminuer la possibilité que les caractéristiques des logiciels (systèmes d’exploitation,applications métiers, logiciels bureautiques, paramétrages…) ne soient exploitées pour porter atteinte aux données à caractère personnel (mises à jour, protection physique et des accès, travail sur un espace réseau sauvegardé, contrôleurs d’intégrité, journalisation, etc.).",
			name: "Gestion des postes de travail",
			placeholder: "Décrivez ici les mesures prises afin de diminuer les risques d'attaques contre les logiciels exploités par le traitement.",
			source: "WIKI Gestion_des_postes_de_travail"
		},
		PIA_SEC_CTR: {
			description: "Les données à caractère personnel communiquées à ou gérées par des sous-traitants doivent bénéficier de garanties suffisantes. <strong>Faire appel uniquement à des sous-traitants présentant des garanties suffisantes</strong> (notamment en termes de connaissances spécialisées, de fiabilité et de resources). Exiger la communication par le prestataire de sa politique de sécurité des systèmes d’information. <br>Prendre et documenter les moyens (audits de sécurité, visite des installations, etc.) permettant d’<strong>assurer l’effectivité des garanties offertes par le sous-traitant</strong> en matière de protection des données. Ces garanties incluent notamment :<br> - le chiffrement des données selon leur sensibilité ou à défaut l’existence de procédures garantissant que la société de prestation n’a pas accès aux données qui lui sont confiées<br>- le chiffrement des transmissions de données (ex : connexion de type HTTPS, VPN, etc.)<br>- des garanties en matière de protection du réseau, de traçabilité (journaux, audits), de gestion des habilitations, d’authentification, etc.<br><strong>Prévoir un contrat avec les sous-traitants</strong>, qui définit notamment l’objet, la durée, la finalité du traitement et les obligations des parties. S’assurer qu’il contient en particulier des dispositions fixant :<br>- leur obligation en matière de confidentialité des données personnelles confiées<br>- des contraintes minimales en matière d’authentification des utilisateurs<br>- les conditions de restitution et/ou de destruction des données en fin du contrat<br>- les règles de gestion et de notification des incidents. Celles-ci devraient comprendre une information du responsable de traitement en cas de découverte de faille de sécurité ou d’incident de sécurité et cela dans les plus brefs délais lorsqu’il s’agit d’une violation de données à caractère personnel.<br>- Dans le cas de l’utilisation de fournisseur de cloud computing :<br>\t1. identifier clairement les données et les traitements qui passeront dans le cloud ;<br>\t2. définir ses propres exigences de sécurité technique et juridique ;<br>\t3. conduire une étude de risques afin d'identifier les mesures de sécurité appropriées ;<br>\t4. identifier le type de cloud pertinent pour le traitement envisagé ;<br>\t5. choisir un prestataire présentant des garanties suffisantes ;<br>\t6. revoir la politique de sécurité interne ;<br>\t7. surveiller les évolutions dans le temps.",
			name: "Contrat de sous-traitance",
			placeholder: "Décrivez ici les garanties contractuelles assurant la protection des données à caractère personnel confiées à des sous traitant.",
			source: "Guide Bleu 2017 p19 et https://www.cnil.fr/fr/cloud-computing-les-conseils-de-la-cnil-pour-les-entreprises-qui-utilisent-ces-nouveaux-services"
		},
		PIA_SEC_EXP: {
			description: "Politiques permettant de limiter la vraisemblance et la gravité des risques visant les biens supports utilisés en exploitation (documenter les procédures d'exploitation, inventaire et mise à jour des logiciels et matériels, correction des vulnérabilités, duplication des données, limiter l'accès physique au matériel, etc.).",
			name: "Sécurisation de l'exploitation",
			placeholder: "Décrivez ici les moyens mis en oeuvre pour garantir la mise à jour et le niveau de sécurité des logiciels utilisés.",
			source: "WIKI Sécurité_de_l'exploitation"
		},
		PIA_SEC_LOG: {
			description: "Existence de mesures mises en place pour être capable de détecter les incidents concernant des données à caractère personnel de façon précoce et de disposer d’éléments exploitables pour les étudier ou pour fournir des preuves dans le cadre d’enquêtes  (architecture et politique de journalisation, respect des obligation en matière de protection des données à caractère personnel, etc.).",
			name: "Traçabilité",
			placeholder: "Décrivez ici les mesures mises en place pour être capable de détecter les incidents concernant des données à caractère personnel.",
			source: "WIKI Surveillance"
		},
		PIA_SEC_MAIN: {
			description: "Existence d'une politique de maintenance physique des équipements, précisant le recours éventuel à la sous-traitance.<br>Elle devra encadrer la maintenance à distance si elle est autorisée, et préciser les méthodes de gestion des matériels défectueux.",
			name: "Maintenance",
			placeholder: "Décrivez ici comment est gérée la maintenance physique des équipements.",
			source: "PIAF Objets connectés p25"
		},
		PIA_SEC_MAL: {
			description: "Mesures destinées à protéger les accès vers des réseaux publics (Internet) ou non maîtrisés (partenaires), ainsi que les postes de travail et les serveurs contre les codes malveillants qui pourraient affecter la sécurité les données à caractère personnel.",
			name: "Lutte contre les logiciels malveillants",
			placeholder: "Décrivez ici les mesures de protection contre les codes malveillants lors d'accès à des réseaux d'un niveau de sécurité moindre.",
			source: "WIKI Lutte_contre_les_logiciels_malveillants"
		},
		PIA_SEC_MAT: {
			description: "Existence de mesures prises pour diminuer la possibilité que les caractéristiques des matériels (serveurs, postes fixes, ordinateurs portables, périphériques, relais de communication, supports amovibles, etc.) soient exploitées pour porter atteinte aux données à caractère personnel (inventaire, cloisonnement, redondance matérielle, limiter l'accès, etc.).",
			name: "Sécurisation des matériels",
			placeholder: "Décrivez ici les méthodes et moyens mis en place pour limiter les risques d'attaques contre le matériel utilisé par le traitement.",
			source: "WIKI Sécurité_des_matériels"
		},
		PIA_SEC_NET: {
			description: "En fonction du type de réseau sur lequel le traitement est mis en œuvre (isolé, privé, ou Internet), le responsable de traitement doit mettre en place des systèmes de protection adéquats : pare-feu, sondes de détection d'intrusion ou autres dispositifs actifs ou passifs sont chargés d'assurer la sécurité du réseau.",
			name: "Sécurisation des canaux informatiques",
			placeholder: "Indiquez ici sur quel type de réseau le traitement est mis en œuvre et les équipements assurant sa sécurisation.",
			source: "PIAF Objets connectés p25"
		},
		PIA_SEC_PHY: {
			description: "Existence d'un contrôle des accès physique aux locaux hébergeant le traitement (zonage, accompagnement des visiteurs, port de badge, portes verrouillées, etc.).<br>Indiquez s’il existe des moyens d’alerte en cas d’effraction.",
			name: "Sécurité physique",
			placeholder: "Indiquez ici la manière dont est réalisée le contrôle d’accès physique aux locaux hébergeant le traitement.",
			source: "PIAF Objets connectés p25"
		},
		PIA_SEC_PROT: {
			description: "Existence de mesures pour réduire ou éviter les risques liés à des sources non humaines (phénomènes climatiques, incendie, dégât des eaux, accidents internes ou externes, animaux, etc.) qui pourraient affecter la sécurité des données à caractère personnel  (mesures de prévention, détection, protection, etc.).",
			name: "Protection contre les sources de risques non humaines",
			placeholder: "Décrivez ici les mesures prises pour réduire ou éviter les risques liés à des sources non humaines.",
			source: "WIKI Protection_contre_les_sources_de_risques_non_humaines"
		},
		PIA_SEC_SRC: {
			description: "Existence de mesures pour éviter que des sources de risques, humaines ou non humaines, auxquelles il est possible de ne pas être confronté, portent atteinte aux données à caractère personnel (produits dangereux, zones géographiques dangereuses, transfert des données en dehors de l'UE, etc.).",
			name: "Eloignement des sources de risques",
			placeholder: "Décrivez les méthodes et moyens mis en place pour éviter les risques qui peuvent l'être.",
			source: "WIKI Éloignement_des_sources_de_risques"
		},
		PIA_SEC_WEB: {
			description: "Méthodes et moyens mis en place pour diminuer la possibilité que les caractéristiques des sites web soient exploitées pour porter atteinte aux données à caractère personnel (référentiel général de sécurité, chiffrement TLS des flux, politique de dépôt de cookies, audits de sécurité, etc.).",
			name: "Protection des sites web",
			placeholder: "Décrivez ici les méthodes et moyens mis en oeuvre pour protéger les sites web.",
			source: "WIKI Sécurité_des_sites_web"
		},
		PIA_TEC_ANO: {
			description: "Description des mécanismes d’anonymisation, des garanties qu'ils apportent contre une réidentification éventuelle et à quelle fin ils sont mis en oeuvre.",
			name: "Anonymisation",
			placeholder: "Décrivez ici les mécanismes d’anonymisation mis en oeuvre",
			source: "Aucune"
		},
		PIA_TEC_ARCH: {
			description: "Politique de conservation et gestion d’archives électroniques contenant des données à caractère personnel destinées à garantir leur valeur, notamment juridique, pendant toute la durée nécessaire (versement, stockage, migration, accessibilité, élimination, politique d'archivage, protection de la confidentialité, etc.).",
			name: "Archivage",
			placeholder: "Indiquez ici l'ensemble des modalités de conservation et gestion d’archives électroniques contenant des données à caractère personnel.",
			source: "WIKI Archivage"
		},
		PIA_TEC_CHIF: {
			description: "Moyens mis en œuvre pour <strong>assurer la confidentialité des données</strong> conservées (en base de données, dans des fichiers plats, dans les sauvegardes, etc.) ainsi que les modalités de gestion des clés de chiffrement (création, conservation, modification en cas de suspections de compromission, etc.). <br><br> Détaillez les moyens de chiffrement employés pour les flux de données (VPN, TLS, etc.) intégrés dans le traitement.",
			name: "Chiffrement",
			placeholder: "Décrivez ici les moyens cryptographiques mis en œuvre pour assurer la confidentialité et l'intégrité des données",
			source: "PIAF objets connectés p23"
		},
		PIA_TEC_CLO: {
			description: "Méthodes utilisées pour cloisonner le traitement.",
			name: "Cloisonnement",
			placeholder: "Indiquez ici si un cloisonnement du traitement est prévu, et comment il est réalisé.",
			source: "Aucune"
		},
		PIA_TEC_CTLA: {
			description: "Description de la manière dont les profils utilisateurs sont définis et attribués. Il conviendra de détailler les moyens d’<strong>authentification</strong> mis en œuvre en précisant, le cas échéant précisez les règles applicables aux mots de passe (longueur minimale, structure obligatoire, durée de validité, nombre de tentatives infructueuses avant blocage du compte, etc.).",
			name: "Contrôle des accès logiques",
			placeholder: "Indiquez ici comment les profils utilisateurs sont définis et attribués.",
			source: "PIAF Objets connectés p21"
		},
		PIA_TEC_LOG: {
			description: "Politiques de journalisation des événements et de conservation des traces qui en résultent.",
			name: "Journalisation",
			placeholder: "Indiquez ici si des événements sont journalisés et la durée de conservation de ces traces.",
			source: "Aucune"
		},
		PIA_TEC_MINI: {
			description: "La sensibilité des données peut être réduite à l'aide des méthodes suivantes : filtrage et retrait, réduction de la sensibilité par transformation, réduction du caractère identifiant des données, réduction de l'accumulation de données, restriction de l’accès aux données",
			name: "Minimisation des données",
			placeholder: "Décrivez ici les méthodes mises en oeuvre pour réduire la sensibilité des données.",
			source: "PIAF objets connectés p41"
		},
		PIA_TEC_PAP: {
			description: "Politiques concernant les documents papiers contenant des données sont utilisés dans le cadre du traitement. Elles décrivent comment ils sont imprimés, stockés, détruits et échangés.",
			name: "Sécurisation des documents papier",
			placeholder: "Indiquez ici les procédures concernant le cycle de vie des documents papier contenant des données à caractère personnel.",
			source: "PIAF Objets connectés p21"
		},
		PIA_VAL_ACT: {
			description: "Le plan d'action est la description de la stratégie, des moyens et des effectifs à mettre en oeuvre pour que les mesures correctives définies entrent en fonction. Pour chaque tâche il convient de désigner un responsable et de définir des délais.",
			name: "Le plan d'action",
			source: "Aucune"
		},
		PIA_VAL_CART: {
			description: "Ce graphique représente les risques engendrés par le traitement et les risques résiduels compte tenu de l’ensemble des mesures correctives. Il démontre que si les mesures complémentaires décrites dans le plan d'action sont correctement mises en œuvre, la vraisemblance et/ou la gravité des risques résiduels devraient réduire.",
			name: "La cartographie des risques",
			source: "Aucune"
		},
		PIA_VAL_CONC: {
			description: "L'article <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article35\">35-9 du RGPD</a>, dispose que le responsable de traitement demande l'avis des personnes concernées le cas échéant.<br>Cet avis peut être recueilli par divers moyens, selon le contexte (étude interne ou externe concernant la finalité et les moyens du traitement, question aux représentants du personnel ou aux syndicats, enquête auprès des futurs clients du responsable de traitement.<br><strong>Si le responsable de traitement décide de passer outre</strong> l’avis des personnes concernées, il doit <strong>consigner la justification de sa décision.</strong><br>Si le responsable de traitement considère que <br>recueillir l’avis des personnes concernées n’est pas pertinent</strong>, il doit également en <strong>consigner la justification.</strong>",
			name: "Avis des personnes concernées",
			source: "PIAF Objets connectés p39"
		},
		PIA_VAL_DPO: {
			description: "L'article <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article35\">35-2 du RGPD</a>, dispose que le responsable de traitement demande conseil au délégué à la protection des données lors d'une analyse d'impact relative à la protection des données.<br><strong>Cet avis peut être défavorable à la mise en œuvre du traitement, sans pour autant contraindre la décision du responsable de traitement.</strong>",
			name: "Avis du délégué à la protection des données",
			source: "PIAF Objets connectés p36"
		},
		PIA_VAL_RT: {
			description: "<strong>Le responsable de traitement décide formellement</strong> de l’acceptabilité des mesures choisies, des risques résiduels et du plan d'action, de manière argumentée, au regard des enjeux préalablement identifiés et de l'avis des parties prenantes. Le PIA peut ainsi être :<br>- validé ;<br>- à améliorer (expliquer en quoi) ;<br>- refusé (ainsi que le traitement considéré).<br>Le cas échéant, il conviendra de revoir les étapes précédentes pour que le PIA puisse être validé.<br>Cette décision ne préjuge en rien de l’évaluation de conformité qui peut être faite, le cas échéant, par l'autorité de protection des données (en France, la CNIL), par exemple dans le cadre de formalités préalables ou de contrôles.",
			name: "Validation du responsable de traitement",
			source: "PIAF Objets connectés p 40"
		}
	},
	title: "Base de connaissances"
};
var measures$d = {
	add: "Créer une mesure (ou en ajouter une proposée dans la base de connaissances à droite)",
	default_placeholder: "Décrivez les mesures existantes ou prévues pour garantir la sécurité des données.",
	edit: "Éditer la mesure",
	placeholder_title: "Titre de la mesure",
	remove: "Supprimer la mesure"
};
var misc$d = {
	display: "Afficher / Masquer"
};
var modals$d = {
	abandon_pia: {
		additional_text: "L'archivage n'est pas définitif et vous pouvez<br>reprendre l'analyse plus tard si besoin.",
		content: "Souhaitez-vous abandonner<br>le traitement ?"
	},
	action_plan_no_evaluation: {
		content: "Veuillez commencer l'évaluation de l'analyse pour génerer le plan d'actions.",
		review_section: "Évaluer une section"
	},
	archive: "Archiver",
	archive_pia: {
		archive: "Archiver ce AIIA",
		content: "<span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>archiver ce PIA ?"
	},
	ask_for_evaluation: {
		content: "La partie est disponible<br>pour évaluation."
	},
	back_to_edition: {
		content: "La partie est renvoyée en édition,<br>des informations doivent être ajoutées<br>pour permettre son évaluation."
	},
	back_to_evaluation: {
		content: "La partie est renvoyée en évaluation,<br>des informations doivent être réévaluées<br>pour permettre sa validation."
	},
	back_to_home: "Retour à l'accueil",
	cancel: "Annuler",
	close: "Fermer",
	completed_edition: {
		content: "Toutes les parties sont éditées.<br>L'analyse doit maintenant être évaluée."
	},
	completed_evaluation: {
		content: "Toutes les parties sont évaluées.<br>L'analyse peut être validée."
	},
	"continue": "Continuer",
	declare_measures: {
		content: "Avant d'évaluer les risques,<br>vous devez déclarer les mesures<br>existantes ou prévues.",
		declare: "Déclarer les mesures existantes ou prévues"
	},
	dpo_missing_evaluations: {
		comment: "Commentaire",
		content: "Veuillez compléter l'évaluation de l'analyse pour accéder à la page des DPO.",
		remove: "Supprimer",
		review_section: "Évaluer une section"
	},
	general_error: {
		content: "Une erreur est survenue.<br>veuillez nous excuser pour ce désagrément."
	},
	import_wrong_pia_file: {
		content: "Le fichier importé ne correspond pas à un fichier de type PIA"
	},
	import_wrong_structure_file: {
		content: "Le fichier importé ne correspond pas à un fichier de type Modèle"
	},
	knowledge: {
		content: "Êtes-vous sûr de vouloir supprimer cet élément ?",
		remove: "Supprimer cet élément"
	},
	knowledges: {
		content: "Êtes-vous sûr de vouloir supprimer cette base de connaissances ?",
		remove: "Supprimer cette base"
	},
	modal_select_text_pia: {
		content: "Le contenu du Rapport PIA a été copié dans votre presse-papier."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Attention,</span><br>Au moins une mesure doit être renseignée : suppression impossible."
	},
	recover_version: {
		"continue": "Continuer",
		message: "En continuant, vous allez restaurer la version du {{date}} de cette analyse.<br><br>La version actuelle sera sauvegardée.",
		title: "Restaurer une ancienne version"
	},
	refuse_pia: {
		content: "Suite à votre refus, l'analyse est<br> renvoyée en évaluation pour effectuer<br>les modifications nécessaires."
	},
	remove_attachment: {
		comment: "Commentaires",
		content: "<span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer cette pièce jointe ?",
		keep: "Conserver",
		remove: "Supprimer"
	},
	remove_measure: {
		content: "<span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer cette mesure ?",
		keep: "Conserver cette <br>mesure",
		remove: "Supprimer cette <br>mesure"
	},
	remove_pia: {
		content: "<span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer définitivement ce PIA ?",
		remove: "Supprimer ce PIA"
	},
	remove_question: {
		content: "Souhaitez-vous supprimer la question ?",
		keep: "Annuler",
		remove: "Supprimer"
	},
	remove_structure: {
		content: "<span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer ce modèle ?",
		remove: "Supprimer ce modèle"
	},
	same_comment: {
		content: "<span class='strong'>Attention,</span><br>Veuillez saisir un commentaire différent du dernier enregistré."
	},
	signed_pia_validation: {
		content: "Pour finaliser la validation de l'analyse,<br>attachez en pièce-jointe le rapport signé.",
		download_pia: "Afficher le rapport"
	},
	simple_pia_validation: {
		content: "Vous venez de valider l'analyse."
	},
	start_evaluation: "Commencer l'évaluation",
	unarchive_pia: {
		content: "<span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>désarchiver ce PIA ?",
		unarchive: "Désarchiver ce PIA"
	},
	update_server_url_nok: {
		content: "Connexion impossible au serveur : veuillez vérifier l'URL saisie.",
		introspect: "Les informations Client ID et Client SECRET n'ont pas été validées par le serveur, veuillez les vérifier s'il vous plait."
	},
	update_server_url_ok: {
		content: "L'adresse du serveur à été mise à jour."
	},
	validate_evaluation: {
		content: "La partie est prête pour<br>la validation de l'analyse."
	},
	validate_evaluation_to_correct: {
		content: "Désolé,<br>Plusieurs champs doivent être corrigés.<br>Retour au mode d'édition<br>pour apporter des corrections."
	},
	users: {
		"delete": {
			content: "<span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer cet utilisateur ?",
			confirm: "Supprimer cet utilisateur",
			pia_exist: "Cet utilisateur est affecté à un ou plusieurs PIA, il faudra penser à ré-affecter des utilisateurs dessus"
		}
	}
};
var onboarding$d = {
	dashboard: {
		step1: {
			description: "Cliquez sur le <strong>+</strong> pour créer votre première AIPD.",
			title: "Créer une AIPD"
		},
		step2: {
			description: "<p>Les <strong>rédacteurs</strong> rédigent la première version de l'analyse.</p><p>Ce sont par exemple les chefs de projet associés au traitement.</p>",
			title: "Les rôles autour de l'AIPD"
		},
		step3: {
			description: "<p>Les <strong>évaluateurs</strong> interviennent dans un second temps.</p><p>Ils contrôlent, grâce à leur expertise juridique ou technique, la qualité et la conformité du traitement.</p><p>Ce sont par exemple le RSSI, des juristes, ...</p>",
			title: "Les rôles autour de l'AIPD"
		},
		step4: {
			description: "<p>Le <strong>validateur</strong> accepte ou non la mise en oeuvre du traitement. Il doit signer l'analyse.</p><p>Il s'agit du responsable de traitement, par exemple le CEO.</p>",
			title: "Les rôles autour de l'AIPD"
		},
		step5: {
			description: "<p>Les <strong>modèles</strong> sont une fonctionnalité avancée. Ils permettent de créer une base pré-remplie pour l'analyse.</p><p>Vous pouvez créer des modèles en allant dans la section associée depuis le menu du haut.</p>",
			title: "Les modèles"
		}
	},
	entry: {
		step1: {
			description: "Pour passer d'une partie à l'autre de l'analyse, utilisez le menu de navigation de gauche.",
			title: "Naviguer"
		},
		step2: {
			description: "Il sert à expliquer l'objectif du traitement et comment il sera mis en oeuvre.",
			title: "Le contexte"
		},
		step3: {
			description: "Ils permettent de s'assurer que le traitement est conforme au RGPD.",
			title: "Les principes fondamentaux"
		},
		step4: {
			description: "Ils décrivent les mesures de sécurité déjà prévues pour le traitement et permettent d'évaluer ses impacts potentiels sur les personnes concernées.",
			title: "Les risques"
		},
		step5: {
			description: "Elle permet au DPO d'exprimer son avis sur la mise en oeuvre du traitement et au responsable de traitement de l'accepter ou de la refuser.",
			title: "La validation"
		},
		step6: {
			description: "<p>Elle fournit une aide contextuelle à la réalisation de l'analyse et s'appuie sur le RGPD, le guide sécurité et les guides AIPD de la CNIL.</p><p>En plus de ces contenus, vous pouvez également créer vos propres bases de connaissances pour accéder facilement à des informations spécifiques à votre organisme.</p>",
			title: "La base de connaissances"
		},
		step7: {
			description: "À tout moment lors de la réalisation de l'analyse, vous pouvez télécharger l'analyse sous divers formats pour la partager avec vos collaborateurs.",
			title: "Exporter son AIPD"
		}
	},
	evaluation: {
		step1: {
			description: "L'évaluation peut se faire au niveau d'une section entière, ou bien au niveau de chaque élément d'une section.",
			title: "Évaluer l'AIPD"
		},
		step2: {
			description: "<p>Cette évaluation indique aux rédacteurs que des éléments sont manquants pour pouvoir faire une évaluation pertinente.</p><p>L'évaluateur doit indiquer ceux-ci dans le champ <strong>commentaire d'évaluation</strong> associé. Le rédacteur apportera les corrections nécessaires.</p>",
			title: "À corriger"
		},
		step3: {
			description: "<p>Cette évaluation indique les points du traitement à réviser. Ils sont détaillés dans le champ <strong>plan d'action / mesures correctives</strong>.</p><p>Ces mesures seront ajoutées automatiquement à la partie plan d'action de l'analyse. Il est nécessaire de les mettre en oeuvre dans les plus brefs délais.</p>",
			title: "Améliorable"
		},
		step4: {
			description: "Cette évaluation signifie que ce point du traitement peut être mis en oeuvre sans y apporter de modifications.",
			title: "Acceptable"
		},
		step5: {
			description: "Si l'évaluation d'une section n'a pas encore commencé, il est possible d'annuler la demande d'évaluation pour apporter des modifications à la description du traitement.",
			title: "Annuler une demande"
		}
	},
	general: {
		done: "Terminer",
		next: "Suivant",
		skip: "Passer"
	},
	validated: {
		step1: {
			description: "Une analyse faite dans son intégralité et validée peut être consultée à tout moment via une interface dédiée.",
			title: "Consulter une AIPD validée"
		},
		step2: {
			description: "Il est nécessaire de réviser son analyse régulièrement. Vous pouvez à tout moment l'éditer ou la dupliquer pour revoir son contenu en fonction des évolutions du traitement.",
			title: "Mettre à jour une AIPD validée"
		}
	}
};
var opinions$d = {
	content: ", considère(nt) que :",
	dpo_lock: "Veuillez remplir les autres sections avant de pouvoir saisir l'avis du DPD.",
	dpo_opinion: "Avis du DPD",
	edit: "Éditer",
	people_opinion: "Avis des personnes concernées",
	placeholder_concerned_people_name: "Nom(s) de la(des) personne(s) concernée(s)",
	placeholder_dpo_name: "Nom(s) du(des) DPD",
	placeholder_dpo_opinion: "Précisez les raisons de votre choix",
	placeholder_people_opinion: "Décrivez comment les avis ont été collectés et quelle en est l'analyse. Dans le cas où les avis n'ont pas été recherchés, en préciser les raisons.",
	placeholder_search_content: "Justifier la raison pour laquelle l’avis des personnes concernées n’a pas été demandé.",
	treatment_lock: "Veuillez remplir les autres sections avant de pouvoir saisir l'avis des personnes concernées.",
	treatment_nok: "Le traitement ne devrait pas être mis en oeuvre.",
	treatment_ok: "Le traitement pourrait être mis en oeuvre."
};
var pia$d = {
	attachments: {
		add: "Ajouter",
		download: "Télécharger la pièce jointe",
		loading: "Dépot en cours...",
		remove: "Supprimer",
		title: "Pièces jointes",
		no_attachment: "Aucune pièce jointe"
	},
	footer: {
		ask_evaluation: "Demander l'évaluation",
		mandatory_fields: "Tous les champs doivent être remplis",
		structure_add_question: "Ajouter une question",
		subsection_validated: "Partie évaluée, en attente de la validation finale",
		validate_evaluation: "Valider l'évaluation"
	},
	header: {
		display_action_plan: "Afficher le<br>plan d'action",
		edition: "Édition",
		evaluation: "Évaluation",
		preview: "Aperçu"
	},
	sections: {
		based_on_structure_name: "Basé sur le modèle :",
		homepage_link: "Retourner à l'accueil",
		refuse_pia: "PIA refusé",
		status: {
			evaluation: {
				cancel: " annuler la demande d'évaluation.",
				cancel_button: "Annuler la demande d'évaluation",
				content: "L'évaluation de cette partie n'a pas encore commencé. Si vous souhaitez modifier les contenus en mode édition, il faut",
				title: "En attente d'évaluation"
			},
			validation: {
				cancel: " annuler la demande de validation.",
				cancel_button: "Annuler la demande de validation",
				content: "L'évaluation de cette partie est terminée et en attente de validation finale de l'analyse. Si vous souhaitez modifier les évaluations, il faut",
				title: "En attente de validation"
			}
		},
		validate_pia: "Valider le PIA"
	},
	statuses: [
		"En cours",
		"Refusé",
		"Validation simple",
		"Validation avec signature",
		"Archivé",
		"En attente de validation"
	]
};
var questions$d = {
	edit: "Éditer la question",
	gauges: [
		"(Non définie)",
		"Négligeable",
		"Limitée",
		"Importante",
		"Maximale"
	],
	placeholder_title: "Titre de la question (obligatoire)",
	remove: "Supprimer la question"
};
var rejection_page$d = {
	applied_adjustments: "Modifications apportées",
	applied_adjustments_placeholder: "Décrivez les modifications apportées au PIA.",
	button: {
		abandon_treatment: "Abandonner le traitement",
		reject_pia: "Refuser le AIIA",
		send_for_validation: "Renvoyer pour validation"
	},
	previous_rejection: "Refus précédent",
	rejection_reason: "Motif du refus",
	rejection_reason_placeholder: "Décrivez les motifs de refus de validation du PIA.",
	title: "Historique de validation"
};
var sections$d = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Présentez le traitement de manière synthétique : son nom, sa finalité, ses enjeux (apports attendus), son contexte d'utilisation, etc.",
						title: "Quel est le traitement qui fait l'objet de l'étude ?"
					},
					"2": {
						placeholder: "Décrivez les responsabilités des parties prenantes : le responsable du traitement, les potentiels sous-traitants et les potentiels co-responsables.",
						title: "Quelles sont les responsabilités liées au traitement ?"
					},
					"3": {
						placeholder: "Recensez les référentiels applicables au traitement, utiles ou à respecter, notamment les codes de conduite approuvés et certifications en matière de protection des données.",
						title: "Quels sont les référentiels applicables ?"
					}
				},
				short_help: "Cette partie vous permet d'identifier et de présenter l'objet de l'étude.",
				title: "Vue d'ensemble"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Listez les données collectées et traitées en indiquant les durées de conservation, les destinataires et les personnes pouvant y accéder.",
						title: "Quelles sont les données traitées ?"
					},
					"2": {
						placeholder: "Décrivez le cycle de vie des données (de leur collecte à leur destruction en passant par leur stockage, les différentes étapes de traitements, l'archivage, etc.), par exemple à l'aide d'un schéma des flux de données (vous pouvez l'ajouter en pièce jointe) et d'une description de chaque processus mis en œuvre.",
						title: "Comment le cycle de vie des données se déroule-t-il (description fonctionnelle) ?"
					},
					"3": {
						placeholder: "Listez les supports des données de votre traitement (systèmes informatiques, serveurs, logiciels, réseaux, personnes, supports papier, etc.).",
						title: "Quels sont les supports des données ?"
					}
				},
				short_help: "Cette partie vous permet de délimiter et décrire le traitement considéré de manière détaillée.",
				title: "Données, processus et supports"
			}
		},
		short_help: "Cette section vous permet d'obtenir une vision claire du(des) traitement(s) de données à caractère personnel considéré(s).",
		title: "Contexte"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Expliquez en quoi les finalités du traitement sont déterminées, explicites et légitimes.",
						short_title: "Finalités",
						title: "Les finalités du traitement sont-elles déterminées, explicites et légitimes ?"
					},
					"2": {
						placeholder: "Présentez le(s) fondement(s) de votre traitement (ex : consentement, exécution d'un contrat, obligation légale, intérêts vitaux, etc.).",
						short_title: "Fondement",
						title: "Quel(s) est(sont) les fondement(s) qui rend(ent) votre traitement licite ?"
					},
					"3": {
						placeholder: "Expliquez en quoi chaque donnée collectée est nécessaire aux finalités de votre traitement.",
						short_title: "Données adéquates",
						title: "Les données collectées sont-elles adéquates, pertinentes et limitées à ce qui est nécessaire au regard des finalités pour lesquelles elles sont traitées (minimisation des données) ?"
					},
					"4": {
						placeholder: "Décrivez les mesures prévues pour vous assurer de la qualité des données.",
						short_title: "Données exactes",
						title: "Les données sont-elles exactes et tenues à jour ?"
					},
					"5": {
						placeholder: "Expliquez en quoi la durée de conservation prévue pour chaque donnée est nécessaire à l'accomplissement des finalités de votre traitement, à défaut d'une autre obligation légale imposant une conservation spécifique.",
						short_title: "Durée de conservation",
						title: "Quelle est la durée de conservation des données ?"
					}
				},
				short_help: "Cette partie vous permet de démontrer la légitimité de votre traitement et des données traitées.",
				title: "Proportionnalité et nécessité"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Décrivez l'information qu'il est prévu d'apporter aux personnes concernées et les moyens choisis pour cette information.",
						short_title: "Information des personnes",
						title: "Comment les personnes concernées sont-elles informées à propos du traitement ?"
					},
					"2": {
						placeholder: "Décrivez les modalités prévues pour obtenir le consentement des personnes concernées.",
						short_title: "Recueil du consentement",
						title: "Si applicable, comment le consentement des personnes concernées est-il obtenu ?"
					},
					"3": {
						placeholder: "Décrivez les modalités prévues pour permettre aux personnes concernées d'accéder à leurs données et de recevoir ou transmettre leurs données.",
						short_title: "Droit d'accès et à la portabilité",
						title: "Comment les personnes concernées peuvent-elles exercer leurs droit d'accès et droit à la portabilité ?"
					},
					"4": {
						placeholder: "Décrivez les modalités prévues pour permettre aux personnes concernées de rectifier et d'effacer leurs données.",
						short_title: "Droit de rectification et d'effacement",
						title: "Comment les personnes concernées peuvent-elles exercer leurs droit de rectification et droit à l'effacement (droit à l'oubli) ?"
					},
					"5": {
						placeholder: "Décrivez les modalités prévues pour permettre aux personnes concernées de limiter le traitement de leurs données et de s'opposer au traitement de leurs données.",
						short_title: "Droit de limitation et d'opposition",
						title: "Comment les personnes concernées peuvent-elles exercer leurs droit de limitation et droit d'opposition ?"
					},
					"6": {
						placeholder: "Pour chaque sous-traitant, décrivez le périmètre de ses responsabilités et indiquez les références aux contrats, codes de conduite et certifications qui fixent ses obligations.",
						short_title: "Sous-traitance",
						title: "Les obligations des sous-traitants sont-elles clairement définies et contractualisées ?"
					},
					"7": {
						placeholder: "Pour chaque pays en dehors de l'Union européenne où des données sont stockées ou traitées, identifiez-le et indiquez s'il est reconnu comme adéquat ou décrivez les clauses qui encadrent le transfert.",
						short_title: "Transferts",
						title: "En cas de transfert de données en dehors de l'Union européenne, les données sont-elles protégées de manière équivalente ?"
					}
				},
				short_help: "Cette partie vous permet de démontrer que vous mettez en œuvre les moyens nécessaires pour permettre aux personnes concernées d'exercer leurs droits.",
				title: "Mesures protectrices des droits"
			}
		},
		short_help: "Cette section vous permet de bâtir le dispositif de conformité aux principes de protection de la vie privée.",
		title: "Principes fondamentaux"
	},
	"3": {
		items: {
			"1": {
				short_help: "Cette partie vous permet de recenser les mesures (existantes ou prévues) contribuant à la sécurité des données.",
				title: "Mesures existantes ou prévues"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Saisissez les impacts potentiels",
						title: "Quels pourraient être les principaux <span class='green-highlight'>impacts sur les personnes concernées</span> si le risque se produisait ?"
					},
					"2": {
						placeholder: "Saisissez les menaces",
						title: "Quelles sont les principales <span class='green-highlight'>menaces</span> qui pourraient permettre la réalisation du risque ?"
					},
					"3": {
						placeholder: "Saisissez les sources de risques",
						title: "Quelles <span class='green-highlight'>sources</span> de risques pourraient-elles en être à l'origine ?"
					},
					"4": {
						placeholder: "Cliquez ici pour sélectionner les mesures contribuant à traiter ce risque.",
						title: "Quelles sont les <span class='green-highlight'>mesures initiales</span>, parmi celles identifiées, qui contribuent à traiter le risque ?"
					},
					"5": {
						placeholder: "Justifiez ici la gravité estimée.",
						title: "Comment estimez-vous la <span class='green-highlight'>gravité du risque</span>, notamment en fonction des impacts potentiels et des mesures prévues ?"
					},
					"6": {
						placeholder: "Justifiez ici la vraisemblance estimée.",
						title: "Comment estimez-vous la <span class='green-highlight'>vraisemblance du risque</span>, notamment au regard des menaces, des sources de risques et des mesures prévues ?"
					}
				},
				short_help: "Analysez les causes et conséquences d'un accès illégitime à des données, et estimez sa gravité et sa vraisemblance.",
				title: "Accès illégitime à des données"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Saisissez les impacts potentiels",
						title: "Quels pourraient être les principaux <span class='green-highlight'>impacts sur les personnes concernées</span> si le risque se produisait ?"
					},
					"2": {
						placeholder: "Saisissez les menaces",
						title: "Quelles sont les principales <span class='green-highlight'>menaces</span> qui pourraient permettre la réalisation du risque ?"
					},
					"3": {
						placeholder: "Saisissez les sources de risques",
						title: "Quelles <span class='green-highlight'>sources</span> de risques pourraient-elles en être à l'origine ?"
					},
					"4": {
						placeholder: "Cliquez ici pour sélectionner les mesures contribuant à traiter ce risque.",
						title: "Quelles sont les <span class='green-highlight'>mesures</span>, parmi celles identifiées, qui contribuent à traiter le risque ?"
					},
					"5": {
						placeholder: "Justifiez ici la gravité estimée.",
						title: "Comment estimez-vous la <span class='green-highlight'>gravité du risque</span>, notamment en fonction des impacts potentiels et des mesures prévues ?"
					},
					"6": {
						placeholder: "Justifiez ici la vraisemblance estimée.",
						title: "Comment estimez-vous la <span class='green-highlight'>vraisemblance du risque</span>, notamment au regard des menaces, des sources de risques et des mesures prévues ?"
					}
				},
				short_help: "Analysez les causes et conséquences d'une modification non désirée de données, et estimez sa gravité et sa vraisemblance.",
				title: "Modification non désirées de données"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Saisissez les impacts potentiels",
						title: "Quels pourraient être les principaux <span class='green-highlight'>impacts sur les personnes concernées</span> si le risque se produisait ?"
					},
					"2": {
						placeholder: "Saisissez les menaces",
						title: "Quelles sont les principales <span class='green-highlight'>menaces</span> qui pourraient permettre la réalisation du risque ?"
					},
					"3": {
						placeholder: "Saisissez les sources de risques",
						title: "Quelles <span class='green-highlight'>sources</span> de risques pourraient-elles en être à l'origine ?"
					},
					"4": {
						placeholder: "Cliquez ici pour sélectionner les mesures contribuant à traiter ce risque.",
						title: "Quelles sont les <span class='green-highlight'>mesures</span>, parmi celles identifiées, qui contribuent à traiter le risque ?"
					},
					"5": {
						placeholder: "Justifiez ici la gravité estimée.",
						title: "Comment estimez-vous la <span class='green-highlight'>gravité du risque</span>, notamment en fonction des impacts potentiels et des mesures prévues ?"
					},
					"6": {
						placeholder: "Justifiez ici la vraisemblance estimée.",
						title: "Comment estimez-vous la <span class='green-highlight'>vraisemblance du risque</span>, notamment au regard des menaces, des sources de risques et des mesures prévues ?"
					}
				},
				short_help: "Analysez les causes et conséquences d'une disparition de données, et estimez sa gravité et sa vraisemblance.",
				title: "Disparition de données"
			},
			"5": {
				short_help: "Cette visualisation vous permet d’avoir une vue globale et synthétique de l’action des mesures sur les composants des risques qu’elles contribuent à traiter.",
				title: "Vue d'ensemble des risques"
			}
		},
		short_help: "Cette section vous permet d'apprécier les risques sur la vie privée, compte tenu des mesures existantes ou prévues.",
		title: "Risques"
	},
	"4": {
		items: {
			"1": {
				short_help: "Cette visualisation vous permet de comparer le positionnement des risques entre eux, avant et après application des mesures complémentaires.",
				title: "Cartographie des risques"
			},
			"2": {
				short_help: "Planifiez en détail la mise en œuvre des mesures complémentaires déterminées au cours du PIA. Cette partie est automatiquement mise à jour en fonction des évaluations faites de chaque élément composant l'analyse d'impact.",
				title: "Plan d'action"
			},
			"3": {
				short_help: "Présentez le conseil de la personne en charge des aspects informatique et libertés (délégué à la protection des données s'il existe). Présentez l'avis des personnes concernées ou de leurs représentants.",
				title: "Avis du DPD et des personnes concernées"
			},
			"4": {
				title: "Valider le PIA"
			},
			"5": {
				title: "PIA refusé"
			}
		},
		short_help: "Cette section vous permet de préparer et de formaliser la validation du PIA.",
		title: "Validation"
	}
};
var settings$d = {
	content: "S'il vous plaît, veuillez fournir l'adresse (URL) du serveur distant :",
	title: "Paramètres",
	update: "Mettre à jour l'URL"
};
var summary$d = {
	action_plan: {
		fundamental_principles: "Principes fondamentaux",
		implementation_date: "Date prévue de mise en œuvre",
		implementation_responsible: "Responsable de la mise en œuvre",
		measures: "Mesures existantes ou prévues",
		no_action_plan: "Aucun plan d'action enregistré.",
		risks: "Risques",
		title: "Plan d'action"
	},
	actions: {
		complete_download: "Télécharger l'ensemble de l'analyse",
		complete_download_desc: "Exporte dans une archive .zip les contenus de l'analyse (.doc et images), les pièces-jointes associées et le plan d'action au format .csv.",
		individual_download: "Téléchargement",
		individual_download_desc: "Exporte des éléments spécifiques de l'analyse.",
		individual_download_pdf: "Rapport PIA (.pdf)",
		individual_download_doc: "Contenus textuels (fichier .doc)",
		individual_download_images: "Éléments visuels (fichiers .png) : vue d'ensemble des risques, cartographie des risques, plan d'action",
		individual_download_json: "Analyse à importer dans l'outil PIA (fichier.json)",
		individual_download_select: "Sélectionnez les éléments à exporter :",
		individual_to_download: "Télécharger",
		print: "Imprimer l'analyse",
		print_and_download: "Impression et téléchargement"
	},
	attachments: "Pièces jointes",
	concerned_people_name: "Noms des personnes concernées",
	concerned_people_opinion: "Opinions des personnes concernées",
	concerned_people_searched_opinion: "Recherche de l'avis des personnes concernées",
	concerned_people_status: "Statuts des personnes concernées",
	concerned_people_unsearched_opinion_comment: "Raison pour laquelle l'avis des personnes concernées n'a pas été demandé",
	content_choice: [
		"Le traitement ne devrait pas être mis en oeuvre.",
		"Le traitement pourrait être mis en oeuvre."
	],
	creation_date: "Date de création",
	csv_action_plan_comment: "Commentaires du plan d'actions",
	csv_evaluation_comment: "Commentaires d'évaluation",
	csv_file_title: "plan-d-action",
	csv_implement_date: "Date d'implémentation estimée",
	csv_people_in_charge: "Responsable de la mise en oeuvre",
	csv_section: "Section",
	csv_title_object: "Titre de l'objet concerné",
	download_csv: "Plan d'action (fichier .csv)",
	dpo_name: "Nom du DPD",
	dpo_opinion: "Opinion du DPD",
	dpo_status: "Statut du DPD",
	gauges: {
		"1": "Négligeable",
		"2": "Limitée",
		"3": "Importante",
		"4": "Maximale"
	},
	modification_made: "Modifications apportées",
	people_search_status_nok: "L'avis des personnes concernées n'a pas été demandé.",
	people_search_status_ok: "L'avis des personnes concernées a été demandé.",
	pia_assessor: "Nom de l'évaluateur",
	pia_author: "Nom de l'auteur",
	pia_name: "Nom du AIIA",
	pia_validator: "Nom du validateur",
	preview_dpo_opinion: "Avis du DPD et des personnes concernées",
	preview_edition: "Saisie",
	preview_evaluation: "Évaluation",
	preview_no_data: "Aucune information à afficher.",
	preview_status: "Statut",
	preview_subtitle: "Informations générales",
	preview_title: "Aperçu de l'analyse",
	preview_validation: "Validation",
	preview_validation_section: "Validation",
	preview_guests: "Invités",
	previous_page: "Retour à la page précédente",
	rejection_reason: "Raison du refus",
	revision: {
		current_version: "Version actuelle",
		pia_version: "Versions du AIIA",
		restore_version: "Restaurer",
		revision: "Versions et révision",
		save: "Créer une nouvelle version",
		show: "Afficher les {{length}} version(s)"
	},
	risks_cartography_title: "Cartographie des risques",
	risks_overview_title: "Vue d'ensemble des risques",
	title: "Informations du PIA"
};
var users$d = {
	add_new_user: "Ajouter un utilisateur",
	cancel: "Annuler",
	choose_profile: "Choisir le profil de l'utilisateur",
	"continue": "Continuer",
	data: "Informations",
	edit_user: "Éditer un utilisateur",
	email: "Adresse email",
	first_name: "Prénom",
	functional_admin: "Administrateur fonctionnel",
	last_name: "Nom",
	new_user_button: "Nouvel utilisateur",
	profile: "Profil",
	remove: "Supprimer",
	remove_current_user_error_message: "Vous ne pouvez pas vous supprimer votre propre compte.",
	remove_last_functional_admin_error_message: "Impossible de supprimer cet utilisateur car il doit rester au moins un compte Administrateur technique.",
	remove_user_with_linked_pias_error_message: "Plusieurs PIA sont rattachés à cet utilisateur, vous ne pouvez donc pas le supprimer.",
	technical_admin: "Administrateur technique",
	update: "Mettre à jour",
	user: "Utilisateur",
	state: "Statut du compte",
	errors: {
		edit_user: {
			"406": "Les informations fournies lors de la création du compte sont invalides."
		}
	},
	"delete": {
		confirm: "Supprimer",
		content: "Voulez vous vraiment supprimer cet utilisateur ?"
	},
	access_locked: {
		"false": "Activé",
		"true": "En attente d'activation"
	},
	role: {
		label: "Rôle(s)",
		author: "Auteur",
		evaluator: "Évaluateur",
		validator: "Validateur",
		guest: "Invité"
	}
};
var validation_page$d = {
	add_signed_pia: "Ajouter le rapport PIA signé",
	after_reading: "Après lecture intégrale du PIA concernant le traitement des données liées à l'activité de : ",
	button: {
		rejection: "Refuser la validation",
		signed_validation: "Faire signer le PIA par le responsable",
		simple_validation: "Validation simple"
	},
	confirmation1: "Je confirme que la description du contexte de mon traitement est conforme à la réalité.",
	confirmation2: "Je confirme avoir pris connaissance des risques existants en fonction des mesures actuellement mises en oeuvre ou prévues.",
	confirmation3: "Je valide les mesures correctives indiquées.",
	confirmation4: "Je m'engage à mettre en oeuvre dans les plus brefs délais les mesures correctives indiquées.",
	latest_signed_attachment: "Dernière pièce jointe signée",
	mandatory_fields: "Tous les champs doivent être cochés",
	remove_attachment: "Supprimer",
	responsible: "Responsable de la validation du PIA : ",
	signed_attachments_history: "Historique des pièces jointes signées",
	tools: {
		dashboard: "Accueil",
		display_pia: "Afficher le rapport"
	},
	validated_pia_with_signature: "Validé",
	waiting_for_signature: "En attente de la signature du rapport PIA"
};
var fr = {
	about: about$d,
	action_plan: action_plan$d,
	authentication: authentication$d,
	cartography: cartography$d,
	comments: comments$d,
	conflict: conflict$d,
	date: date$d,
	errors: errors$d,
	evaluations: evaluations$d,
	header: header$d,
	help: help$d,
	homepage: homepage$d,
	knowledge_base: knowledge_base$d,
	measures: measures$d,
	misc: misc$d,
	modals: modals$d,
	onboarding: onboarding$d,
	opinions: opinions$d,
	"overview-risks": {
	important: "Importante",
	limited: "Limitée",
	maximal: "Maximale",
	measures: "Mesures",
	negligible: "Négligeable",
	potential_impacts: "Impacts potentiels",
	"risk-access_x": "Gravité",
	"risk-access_y": "Vraisemblance",
	"risk-change_x": "Gravité",
	"risk-change_y": "Vraisemblance",
	"risk-disappearance_x": "Gravité",
	"risk-disappearance_y": "Vraisemblance",
	sources: "Sources",
	threat: "Menaces"
},
	pia: pia$d,
	questions: questions$d,
	rejection_page: rejection_page$d,
	sections: sections$d,
	settings: settings$d,
	summary: summary$d,
	users: users$d,
	validation_page: validation_page$d
};

var about$c = {
	contribute: "Ako želite pridonijeti prijevodu softvera na drugi jeziku ili poboljšati postojeće prijevode, preporučujemo vam da <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">pročitate stranicu koja opisuje korake koje je potrebno slijediti.</a>.",
	description: "Ovaj alat izvorno je osmišljen od strane <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, francuskog tijela za zaštitu podataka, kako bi pomogao izvršiteljima obrade da budu sukladni s OUZP-om. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Ovaj softver je besplatan i otvoren. Ako se želite uključiti u ovaj projekt, dobrodošli ste preuzeti izvorni kod tvrtke Github, mijenjati ga i dijeliti s zajednicom.",
	licences: "Licence biblioteka:",
	title: "O alatu za PUP AIIA",
	translators: "Softver za PUP trenutno je dostupan na osamnaest jezika. Inačice na francuskom i engleskom jeziku omogućio je CNIL. Druge inačice rezultat su doprinosa sljedećih pojedinaca:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Verzija broj"
};
var action_plan$c = {
	acceptable_measures: "Prihvatljive mjere",
	edit: "Uredi",
	improvable_measures: "Mjere koje se daju poboljšati",
	measures: "Planirane ili postojeće mjere",
	no_action_plan: "Nije zabilježen akcijski plan.",
	placeholder_person_in_charge: "Odgovoran za provedbu",
	principles: "Temeljna načela",
	risk1: "Nezakonit pristup podacima",
	risk2: "Neželjena izmjena podataka",
	risk3: "Nestanak podataka",
	risks: "Rizici",
	title: "Pregled"
};
var authentication$c = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Ovaj softver koji je izradio <strong>French Data Protection Authority (CNIL)</strong> namijenjen je kao smjernica voditeljima obrade u stvaranju i dokazivanju usklađenosti s OUZP-om. On pomaže pravilno provesti procjenu učinka na zaštitu podataka olakšavanjem korištenja metode za PUP koja je razvijena od strane CNIL-a.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Početak",
	start_app: "Pristupite softveru za PUP (Beta)",
	subtitle1: "Platforma za stvaranje <br> i upravljanje Vašim PUP-ovima",
	subtitle2: "Pristupni alati i rječnici",
	title: "Procjena učinka na privatnost",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$c = {
	important: "Važan",
	legend1: "Postojeće ili planirane mjere",
	legend2: "Uz provođenje korektivnih mjera",
	legend3: "(N)ezakonit pristup podacima",
	legend4: "Neželjena (i)zmjena podataka",
	legend5: "Nestanak (p)odataka",
	likelihood_axe: "Vjerojatnost rizika",
	limited: "Ograničen",
	maximal: "Maksimalan",
	negligible: "Nizak",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Ozbiljnost rizika"
};
var comments$c = {
	comment: "Komentar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "komentar(a)",
	new_comment: "Komentar",
	placeholder_new_comment: "Ostavi komentar",
	send: "Pošalji"
};
var conflict$c = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$c = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$c = {
	content: "IAko naiđete na druge probleme ili ako imate prijedloge za poboljšanje, <br> možete ih poslati putem ovog obrasca:: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Stranica nije pronađena."
};
var evaluations$c = {
	acceptable: "Prihvatljiv",
	action_plan_comment: "Akcijski plan / aktivnosti ispravljanja",
	evaluation_comment: "Komentar procjene",
	gauges: {
		"0": "(Nedefinirano)",
		"1": "Zanemariva",
		"2": "Ograničena",
		"3": "Važna",
		"4": "Maksimalna",
		likelihood: "Uzimajući u obzir akcijski plan, koju bi novu procjenu dali <span class='red-highlight'> vjerojatnosti ovog rizika</span>?",
		seriousness: "Uzimajući u obzir akcijski plan, koju bi novu procjenu dali <span class='red-highlight'> ozbiljnosti ovog rizika</span>?"
	},
	improvable: "Može se poboljšati",
	placeholder_acceptable: "Prema dostupnim informacijama, primijenjene mjere odgovaraju pravilnom ispunjavanju zahtjeva za zaštitu podataka.",
	placeholder_improvable1: "Prema raspoloživim informacijama, potrebno je provesti dodatne mjere kako bi se poboljšala zaštita podataka obrade.",
	placeholder_improvable2: "Unesite svoje komentare.",
	placeholder_to_correct: "Dostavljene informacije nisu dovoljne njihovo ispravno procjenjivanje. Pošaljite natrag uređivaču kako bi poboljšao izvorni podnesak.",
	status: [
		"Rješava se",
		"Za ispraviti",
		"Može se poboljšati",
		"Prihvatljiv"
	],
	title: "Procjena",
	to_correct: "Za ispraviti"
};
var header$c = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Primjer PUP-a",
		title: "Pomoć"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Baza znanja",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Prijevodi od strane CNIL-a",
		community_translations: "Prijevodi od strane zajednice",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Prijevod revidiran od strane europskog tijela za zaštitu podataka",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Izvorna verzija",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Procjena učinka na privatnost",
	structures: "PIA templates",
	tools: {
		about: "O programu",
		accessibility: "Pristupačnost za slabovidne osobe (boje visokog kontrasta, daltonizam)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Postavke",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$c = {
	definition: {
		data1: {
			content: "Sadržaj se piše",
			title: "Koristite alat za PUP"
		},
		data2: {
			qa1: {
				content: "Prilikom susreta s problemima u prikazu zatvorite aplikaciju i ponovno je učitajte. To obično rješava problem. Nećete izgubiti informacije koje ste unijeli, jer se one automatski spremaju dok ih upisujete.",
				title: "Imam problema kod prikaza, tako da su ikona zaglavljene u nekom statusu ili nedostaju elementi sučelja"
			},
			qa2: {
				content: "Ovaj poznati problem trenutačno se rješava. Ako naiđete na taj problem, preporučujemo da popunite polje opravdanja ocijenjene razine ozbiljnosti i/ili vjerojatnosti. Mjeru ćete moći uređivati nakon što problem bude otklonjen.",
				title: "Ne mogu uređivati mjeru procjene ozbiljnosti i vjerojatnosti rizika"
			},
			qa3: {
				content: "Tijekom uvoza PUP-a uočeno je nekoliko pogrešaka u programu, a naročito mogu nestati mjere za procjenu ozbiljnosti i vjerojatnosti rizika, te u tom slučaju molimo pogledajte gore navedeni problem. Također, PUP se možda neće pojaviti na kontrolnoj ploči nakon uvoza. Ovo je problem u prikazu i potrebno je samo osvježiti stranicu.",
				title: "Susrećem se s problemima pri uvozu PUP-a"
			},
			qa4: {
				content: "Ovo je samo grešak u prikazu i nema utjecaja na tekst koji unesete u polje. Taj vizualni problem uskoro će biti riješen.",
				title: "Kada kopiram / zaljepljujem tekst, on je istaknut."
			},
			qa5: {
				content: "Da biste procijenili odjeljak, obavezno ispunite sva polja. Provjerite je li to slučaj. Prilikom uređivanja rizika morate imati barem jednu tehničku ili organizacijsku mjeru koja smanjuje rizik kako bi zatražili procjenu rizika.",
				title: "Ne mogu dati procjenu za odjeljak"
			},
			qa6: {
				content: "Zatvorite PUP koji uređujete i ponovno ga otvorite. Sadržaj bi trebao biti prikazan na jeziku koji ste odabrali.",
				title: "Pri prebacivanju na drugi jezik, tekstovi nisu prevedeni"
			},
			qa7: {
				content: "Ikone navigacijskih izbornika trenutno se ne osvježavaju nakon odbijana PUP-a. Morate provjeriti svaki odjeljak i promijeniti informacije i/ili procjenu prema razlozima za odbijanje PUP-a. Nakon što su svi odjeljci pregledani, trebali biste biti u mogućnosti ponovno zatražiti potvrdu PUP-a.",
				title: "Odbio sam potvrditi PUP, ali ne znam što sada moram raditi"
			},
			title: "Poznati problemi"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Pomoć"
};
var homepage$c = {
	cards: {
		author: "Uređivanje",
		category: "TO TRANSLATE - Category",
		creation_status: "Stvaranje",
		date: "Datum",
		evaluation: "Pregled",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Uvezi PUP",
		import_structure: "Uvezi obrazac",
		item: {
			consult_pia: "Pogledaj",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Uredi",
			edit_structure: "Uredi obrazac",
			tools: {
				action_plan: "Prikaži<br>akcijski plan",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Stvori kopiju",
				"export": "Izvezi",
				more_options: "Više opcija",
				pia: "Prikaži<br>PUP",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Novi PUP",
		new_structure: "Novi obrazac",
		or: "ili",
		pia_name: "PUP",
		placeholder_author: "Ime, prezime",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Ime, prezime",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Uvezi PUP",
		placeholder_import_structure: "Uvezi obrazac",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Novi PUP",
		placeholder_new_structure: "Novi obrazac",
		placeholder_pia_name: "Naziv PUP-a",
		placeholder_sector_name: "Naziv sektora",
		placeholder_start: "Sva polja moraju biti popunjena",
		placeholder_structure: "Zadani obrazac",
		placeholder_structure_name: "Naziv obrasca",
		placeholder_validation: "Ime, prezime",
		sector_name: "Pridruženi sektor",
		start: "Početak",
		status: "Status",
		structure: "Obrazac",
		structure_name: "Naziv obrasca",
		title_close_creation: "Zatvori",
		validation: "Potvrda"
	},
	filters: {
		assessor: "Recenzentu",
		author: "Autoru",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Započnite!<br><br>Kako bi započeli s PUP-om,<br> kliknite na Novi PUP",
		card_rocket_content_structure: "Započnite! Kako bi započeli s <br>obrascem, kliknite na +",
		category: "TO TRANSLATE - Category",
		date: "Datumu",
		import_pia: "Uvezi PUP",
		import_structure: "Uvezi obrazac",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Započnite! Kako bi započeli s <br>PUP-om, kliknite na +",
		list_rocket_content_structure: "Započnite! Kako bi započeli s <br>obrascem, kliknite na +",
		name: "Imenu",
		new_pia: "Novi PUP",
		new_structure: "Novi obrazac",
		sector_name: "Pridruženi sektor",
		sort: "Sortiraj",
		sort_by: "po",
		status: "Statusu",
		validator: "Potvrditelju"
	},
	lists: {
		column_actions: "Radnje",
		column_author: "Uređivanje",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Stvoren",
		column_evaluation: "Pregled",
		column_pia: "PUP",
		column_progression: "Napredak",
		column_sector_name: "Pridruženi sektor",
		column_status: "Status",
		column_structure: "Obrazac",
		column_structure_name: "Obrazac",
		column_updated_at: "Zadnje otvoren",
		column_validation: "Potvrda",
		item: {
			tools: {
				action_plan: "Prikaži akcijski plan",
				archive: "TO TRANSLATE - Archive",
				consult: "Pogledaj",
				duplicate: "Stvori kopiju",
				edit: "Uredi",
				"export": "Izvezi",
				pia: "Prikaži PUP",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$c = {
	add_measure: "Dodaj",
	add_measure_hint: "Dodati možete i mjere iz baze znanja.",
	category: {
		definition: "Definicija",
		example: "Example",
		general_measure: "Kontrole fizičke sigurnosti",
		measure_on_data: "Kontrole logičke sigurnosti",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Organizacijske kontrole",
		principle: "Princip"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Sve",
		definitions: "Definicije",
		general_measures: "Kontrole fizičke sigurnosti",
		measures_on_data: "Kontrole logičke sigurnosti",
		no_result: "Pretraga nije dala rezultata.",
		organizational_measures: "Organizacijske kontrole",
		title: "Filteri"
	},
	placeholder_add_measure: "Dodaj ovu mjeru",
	placeholder_help: "Pomoći kod unosa",
	search: "Traži",
	slugs: {
		PIA_DEF_ACC: {
			description: "Ispitanik ima pravo dobiti od voditelja obrade potvrdu obrađuju li se osobni podaci koji se odnose na njega te ako se takvi osobni podaci obrađuju, pristup osobnim podacima i informacijama opisanim u <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 of [GDPR]</a>",
			name: "Pravo na pristup",
			source: "OUZP čl. 15"
		},
		PIA_DEF_ANO: {
			description: "Postupak uklanjanja identifikacijskih osobina iz osobnih podataka. Da biste procijenili robusnost postupka anonimizacije, pogledajte <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Anonimizacija",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Postupci za čuvanje i upravljanje elektroničkim arhivima koji sadrže osobne podatke kojima se osigurava njihova vrijednost (posebice njihova pravna vrijednost) tijekom cijelog potrebnog razdoblja (prijenos, pohrana, migracija, pristupačnost, uklanjanje, pravila arhiviranja, zaštita povjerljivosti itd..).",
			name: "Arhiviranje",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Svaku osobu koja ima legitiman pristup osobnim podacima (zaposlenici, ugovorne strane i ostale treće strane) treba identificirati jedinstvenim identifikatorom. Odaberite način autentikacije za otvaranje sjednica prikladan za kontekst, razinu rizika i očekivanu robusnost. Preporuke: ako rizici nisu povišeni, može se koristiti lozinka; Međutim, ako su rizici veći, upotrijebite jednokratnu token lozinku, ali promijenite zadanu lozinku za aktivaciju ili, kada se dio lozinke šalje SMS-om, karticom s PIN-om, elektroničkim certifikatom ili bilo kojim drugim oblikom jake autentikacije.",
			name: "Autentikacija",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Mjera činjenja osobnih podataka nerazumljivim bilo kome bez odobrenja za pristup (simetrična ili asimetrična enkripcija, korištenje javnih algoritama za koje se zna da su jaki, autentikacijski certifikati, itd.).",
			name: "Enkripcija",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Metode organizacije podataka koje smanjuju mogućnost da se osobni podaci mogu povezati i da se može dogoditi povreda svih osobnih podataka. Na primjer, prepoznavanjem osobnih podataka koji su korisni samo za pojedini poslovni proces i njihovo logičko razdvajanje.",
			name: "Particioniranje podataka",
			source: "pia3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Svako dobrovoljno, posebno, informirano i nedvosmisleno izražavanje želja ispitanika kojim on izjavom ili jasnom potvrdnom radnjom daje privolu za obradu osobnih podataka koji se na njega odnose.<br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.10 of [GDPR]</a>",
			name: "Privola",
			source: "OUZP čl. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Sredstva koja se primjenjuju kako bi ograničili rizici da će neovlaštene osobe pristupiti osobnim podacima elektroničkim putem; to, između ostalog, zahtijeva: <br> - <strong> upravljanje profilima korisnika </ strong> odvajanjem zadataka i područja odgovornosti (po mogućnosti na centraliziran način) radi ograničavanja pristupa osobnim podacima isključivo na ovlaštene korisnike primjenom načela nužnog znanja i najmanjih ovlasti, <br> - <strong> povlačenje prava zaposlenika, ugovornih strana i drugih trećih osoba kada više nemaju ovlasti za pristup prostorima ili resursu </ strong> ili kada završi njihov ugovor o radu <strong></strong>.",
			name: "Kontrole logičkog pristupa",
			source: "pia3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Svi podaci koji se odnose na pojedinca čiji je identitet utvrđen ili se može utvrditi (\"ispitanik\"); pojedinac čiji se identitet može utvrditi jest osoba koja se može identificirati izravno ili neizravno, osobito uz pomoć identifikatora kao što su ime, identifikacijski broj, podaci o lokaciji, mrežni identifikator ili uz pomoć jednog ili više čimbenika svojstvenih za fizički, fiziološki, genetski, mentalni, ekonomski, kulturni ili socijalni identitet tog pojedinca. <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.1 of [GDPR]</a>",
			name: "Osobni podaci",
			source: "OUZP čl. 4.1"
		},
		PIA_DEF_DEST: {
			description: "Fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo kojem se otkrivaju osobni podaci, neovisno o tome je li on treća strana. Međutim, tijela javne vlasti koja mogu primiti osobne podatke u okviru određene istrage u skladu s pravom Unije ili države članice ne smatraju se primateljima; obrada tih podataka koju obavljaju ta tijela javne vlasti mora biti u skladu s primjenjivim pravilima o zaštiti podataka prema svrhama obrade. <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Čl. 4.9 of [GDPR]</a>",
			name: "Primatelj",
			source: "OUZP čl. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Ispitanik ima pravo od voditelja obrade ishoditi brisanje osobnih podataka koji se na njega odnose bez nepotrebnog odgađanja te voditelj obrade ima obvezu obrisati osobne podatke bez nepotrebnog odgađanja, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 17 of [GDPR]</a>",
			name: "Pravo na brisanje",
			source: "OUZP čl. 17"
		},
		PIA_DEF_ENJ: {
			description: "Očekivane prednosti (za organizaciju, za ispitanike, za društvo općenito, itd.).",
			name: "Ulozi",
			source: "pia1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Osobni moraju biti točni i prema potrebi ažurni; mora se poduzeti svaka razumna mjera radi osiguravanja da se osobni podaci koji nisu točni, uzimajući u obzir svrhe u koje se obrađuju, bez odlaganja izbrišu ili isprave („točnost”). <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">čl. 5.1 d) of [GDPR]</a>",
			name: "Kvaliteta podataka",
			source: "OUZP čl. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Ozbiljnost predstavlja jačinu rizika. Ona prvenstveno ovisi o štetnoj prirodi potencijalnih utjecaja.",
			name: "Ozbiljnost",
			source: "pia1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Ispitanik ima pravo od voditelja obrade ishoditi ograničenje obrade, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 18 of [GDPR]</a>",
			name: "Pravo na ograničenje obrade",
			source: "OUZP čl. 18"
		},
		PIA_DEF_LOG: {
			description: "Postavite arhitekturu zapisivanja kako bi se omogućilo rano otkrivanje incidenta koji uključuju osobne podatke i koje se može koristiti za njihovu analizu ili dokazivanje u vezi s istragama.",
			name: "Nadziranje",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Postupak koji obuhvaća jednu ili više pojedinačnih radnji na pomoćnim sredstvima za podatke. Upotrebljavaju je, namjerno ili na neki drugi način, izvori rizika i može izazvati strahovani događaj.",
			name: "Prijetnja",
			source: "pia1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Prijetnje vezane uz: - <strong> Hardver </ strong> koji je korišten neprikladno, promatran, izmijenjen, izgubljen (upotreba ili prijevoz osjetljivog hardvera u osobne svrhe, gledanje zaslona osobe bez njenog znanja tijekom putovanja vlakom, praćenje putem hardverskog snimača ključeva itd.) <br> - <strong> Softver </ strong> koji je korišten neprikladno, promatran, promijenjen (podizanje ovlasti, prikupljanje konfiguracijskih podataka, infekcija zlonamjernim kodom itd.) <br>- <strong> Računalne kanale </strong> koji su promatrani (Presretanje Ethernet prometa, itd.)<br>- Ljude </ strong> koji su promatrani, manipulirani, izgubljeni (nenamjerno otkrivanje informacija, socijalni inženjering, promjene u zadacima) <br>- <strong> Papirnate dokumente </strong> koji su promatrani, izgubljeni (čitanje, krađa pošte itd.) <br>- <strong> Papirnate prijenosne kanale </ strong> (čitanje knjiga potpisa u optjecaju i sl.)",
			name: "Prijetnje koje mogu dovesti do nezakonitog pristupa",
			source: "piaF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Prijetnje vezane uz: </strong> <br> - <strong> Hardver </strong>: upotrebljava se neprikladno, preopterećen je, izmijenjen, oštećen ili izgubljen (jedinica za pohranu puna, preopterećenje kapaciteta obrade, dodavanje nekompatibilnog hardvera što rezultira kvarovima, ili gubitak imovine itd.) <br> - <strong> Softver </strong>: upotrebljava se neprikladno, preopterećen je, izmijenjen, oštećen ili izgubljen (brisanje podataka, prekoračenje veličine baze podataka, logička bomba, <strong> Računalne kanale </strong>: preopterećeni, izmijenjeni, izgubljeni (neovlašteno preuzimanje, gubitak internetske veze i sl.) <br>- <strong> Ljude </strong> : preopterećeni, oštećeni ili izgubljeni (loša upotreba vještina, bolesti, mirovina, itd.)<br>- <strong> Papirnate dokumente </strong>: korišteni neprikladno, oštećeni, izgubljeni (brisanje, starenje arhiviranih dokumenata, krađa ili gubitak dokumenata, itd.)<br>- <strong> Papirnate prijenosne kanale </strong>: preopterećeni, oštećeni, izmijenjeni, izgubljeni (dostava pošte zaustavljena štrajkom, preraspodjelama unutar ureda ili prostorija, gubitak tvrtke za dostavu dokumenata, reorganizacije paprirnatih prijenosnih kanala itd.)",
			name: "Prijetnje koje mogu dovesti do nestanka osobnih podataka",
			source: "piaF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Prijetnje vezane uz: </strong><br> - <strong>Hardver </strong> izmijenjen (dodavanje nekompatibilnog hardvera koji je doveo do kvarova, uklanjanja nužnih komponenti itd.) <br>- <strong>Softver</strong> korišten neprimjereno ili izmijenjen (neželjene izmjene podataka u bazama podataka, pogreške operatera koje mijenjaju podatke itd.) <br>- <strong> Računalne kanale </strong> korištene neprimjereno (ponovno slanje presretanih podataka itd.) <br>- <strong>Ljude </strong> preopterećene ili manipulirane (dodjeljivanje osoblju zadataka izvan njihovih sposobnosti, stres ili negativne promjene uvjeta rada, utjecaja itd.) <br> - Papirnate dokumente koji su izmijenjeni (izmjene brojeva u datoteci, zamjena izvornika krivotvorinom, itd.) <br>- <strong> Papirnate prijenosne kanale </ strong> koji su izmijenjeni (promjena iz jedne potpisne knjige u drugu, slanje više proturječnih dokumenata itd..)",
			name: "Prijetnje koje mogu dovesti do neželjenih izmjena osobnih podataka",
			source: "piaF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Treba ih odabrati između onih dostupnih u odjeljku \"Planirane ili postojeće mjere\", koji možete dopuniti ako je potrebno.",
			name: "Mjere",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "Kad se uvoze podaci, mogu se nenamjerno prikupljati različite vrste metapodataka (kao što su EXIF podaci kod slikovnih datoteka). <br> Takvi metapodaci moraju biti identificirani i uklonjeni ako nisu potrebni za navedene svrhe.",
			name: "Filtriranje i uklanjanje",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Nakon što su primljeni osjetljivi podaci, kao dio niza općih informacija ili koji se prenose samo u statističke svrhe, oni se mogu pretvoriti u manje osjetljivi oblik ili pseudonimizirani. Na primjer: <br> - ako sustav prikuplja IP adresu kako bi utvrdio lokaciju korisnika za statističku svrhu, IP adresa može biti izbrisana nakon što je donesen zaključak o gradu ili okrugu - <br> ako sustav prima video podatke iz nadzornih kamera može prepoznati ljude koji stoje ili se kreću na sceni i zamutiti ih<br> - ako je sustav pametno brojilo, može skupljati energiju tijekom određenog razdoblja, a da je ne snima u stvarnom vremenu",
			name: "Smanjenje osjetljivosti putem pretvorbe",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Sustav može osigurati da: <br>- korisnik može koristiti resurs ili uslugu bez rizika otkrivanja identiteta (anonimnih podataka) <br>- korisnik može koristiti resurs ili uslugu bez rizika otkrivanja njegovog/njezinog identiteta, ali ostaju prepoznatljivi i odgovorni za to korištenje (pseudonimni podaci) <br>- korisnik može izvršiti višestruku upotrebu resursa ili usluga bez rizika da se te različite upotrebe povezuju zajedno (podaci se ne mogu povezati) <br>- korisnik može koristiti resurs ili uslugu bez rizika od drugih, osobito trećih osoba, koje mogu primijetiti korištenje resursa ili usluge (neobavezanost) <br> Izbor metode s gornjeg popisa mora biti napravljen na temelju utvrđenih prijetnji. Za neke vrste prijetnji po privatnost, pseudonimizacija će biti prikladnija od anonimizacije (na primjer, ako postoji potreba za sljedivosti). Osim toga, neke prijetnje po privatnost riješit će se pomoću kombinacije metoda.",
			name: "Smanjenje identificirajuće prirode podataka",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Sustav se može organizirati u nezavisne dijelove s posebnim funkcijama kontrole pristupa. Podaci se također mogu podijeliti između tih nezavisnih podsustava i svaki podsustav može ih kontrolirati koristeći različite mehanizme kontrole pristupa. Ako je podsustav kompromitiran, utjecaji na cjelokupne podatke mogu se smanjiti.",
			name: "Smanjenje akumulacije podataka",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Sustav može ograničiti pristup podacima prema principu \"nužnog znanja\". Sustav može odvojiti osjetljive podatke i primijeniti određene politike kontrole pristupa. Sustav također može enkriptirati osjetljive podatke kako bi zaštitila njihova povjerljivost tijekom prijenosa i pohrane. Također je potrebno zaštititi pristup privremenim kolačićima koji se proizvode tijekom obrade podataka.",
			name: "Ograničavanje pristupa podacima",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Smanjite ozbiljnost rizika smanjivanjem količine osobnih podataka koji će se obrađivati ograničavanjem tih podataka na samo one koji su strogo nužni u svrhe za koje se obrađuju (inače ih se ne smije prikupljati).",
			name: "Smanjenje količine podataka",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Reduce the severity of risks by minimizing the data themselves, by taking measures aimed at reducing their sensitivity such as filtering and removing unnecessary data, pseudonymising data, etc.",
			name: "Smanjenje količine samih podataka",
			source: "pia3 p64"
		},
		PIA_DEF_OPP: {
			description: "Ispitanik ima pravo na temelju svoje posebne situacije u svakom trenutku uložiti prigovor na obradu osobnih podataka koji se odnose na njega, sukladno <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 21 of [GDPR]</a>",
			name: "Pravo na prigovor",
			source: "OUZP čl. 21"
		},
		PIA_DEF_PBDS: {
			description: "Mjere poduzete za integraciju zaštite osobnih podataka u sve nove aktivnosti obrade (pouzdana imena, smjernice, CNIL metodologija za upravljanje rizikom ili druga interna metodologija).",
			name: "Upravljanje projektima",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Osobe na koje se odnose podaci obuhvaćeni obradom.",
			name: "Ispitanik",
			source: "pia1 p9"
		},
		PIA_DEF_PORT: {
			description: "Ispitanik ima pravo zaprimiti osobne podatke koji se odnose na njega, a koje je pružio voditelju obrade u strukturiranom, uobičajeno upotrebljavanom i strojno čitljivom formatu te ima pravo prenijeti te podatke drugom voditelju obrade bez ometanja od strane voditelja obrade kojem su osobni podaci pruženi, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 20 of [GDPR]</a>",
			name: "Pravo na prenosivost podataka",
			source: "OUZP čl. 20"
		},
		PIA_DEF_PSEU: {
			description: "Obrada osobnih podataka na način da se osobni podaci više ne mogu pripisati određenom ispitaniku bez uporabe dodatnih informacija, pod uvjetom da se takve dodatne informacije drže odvojeno te da podliježu tehničkim i organizacijskim mjerama kako bi se osiguralo da se osobni podaci ne mogu pripisati pojedincu čiji je identitet utvrđen ili se može utvrditi.<br>Pseudonimizacija smanjuje povezivost skupova podataka s izvornim identitetom ispitanika; kao takva je korisna mjera sigurnosti, ali ne i metoda anonimizacije.",
			name: "Pseudonimizacija",
			source: "OUZP čl. 4.5 i smjernice G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Lozinke moraju biti sastavljene od najmanje osam znakova; moraju se obnoviti ako postoji najmanja zabrinutost da bi one mogli biti ugrožene, a eventualno i povremeno (svakih šest mjeseci ili jednom godišnje) i moraju sadržavati najmanje tri od četiri vrste znakova (velika slova, mala slova, brojevi i posebni znakovi); kada se promijeni lozinka, posljednjih pet lozinki ne smiju se ponovno koristiti; istu lozinku ne smije se koristiti za različite pristupe; lozinke ne bi trebale biti povezane s osobnim podacima (uključujući ime ili datum rođenja). Odredite maksimalni broj pokušaja nakon kojih se izdaje upozorenje i autentikacija blokira (privremeno ili dok se ručno ne deblokira).",
			name: "Lozinka",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Ispitanik ima pravo bez nepotrebnog odgađanja ishoditi od voditelja obrade ispravak netočnih osobnih podataka koji se na njega odnose. Uzimajući u obzir svrhe obrade, ispitanik ima pravo dopuniti nepotpune osobne podatke, među ostalim i davanjem dodatne izjave.",
			name: "Pravo na ispravak",
			source: "OUZP čl. 16"
		},
		PIA_DEF_RGPD: {
			description: "Uredba o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ.",
			name: "OUZP (Opća uredba o zaštiti podataka, engl. GDPR - General Data Protection Regulation",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo koje samo ili zajedno s drugima određuje svrhe i sredstva obrade osobnih podataka; kada su svrhe i sredstva takve obrade utvrđeni pravom Unije ili pravom države članice, voditelj obrade ili posebni kriteriji za njegovo imenovanje mogu se predvidjeti pravom Unije ili pravom države članice.<br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">čl. 4.7 [GDPR]</a>",
			name: "Voditelj obrade",
			source: "OUZP čl. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Osoba ili ne-ljudski izvor koji može uzrokovati rizik. Taj izvor može djelovati slučajno ili namjerno.",
			name: "Izvor rizika",
			source: "pia1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo koje obrađuje osobne podatke u ime voditelja obrade, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 of [GDPR]</a>.<br>Izvršitelj obrade i bilo koja osoba koja djeluje pod vodstvom voditelja obrade ili izvršitelja obrade koja ima pristup osobnim podacima, ne obrađuje te podatke ako to ne zatraži voditelj obrade, osim ako to nalaže pravo Unije ili pravo države članice, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 29 of [GDPR]</a>.",
			name: "Izvršitelj obrade",
			source: "OUZP čl. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Sredstvo na koje se osobni podaci oslanjaju. To može biti hardver, softver, mreže, ljudi, papir ili papirnati prijenosni kanali",
			name: "Pomoćna sredstva",
			source: "pia1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Povreda sigurnosti koja dovodi do slučajnog ili nezakonitog uništenja, gubitka, izmjene, neovlaštenog otkrivanja ili pristupa osobnim podacima koji su preneseni, pohranjeni ili na drugi način obrađeni.",
			name: "Povreda osobnih podataka",
			source: "OUZP čl. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Vjerojatnost izražava mogućnost nastanka rizika. Ona prvenstveno ovisi o razini ranjivosti pomoćnih sredstava prilikom prijetnji i razini sposobnosti izvora rizika da ih iskoriste.",
			name: "Vjerojatnost",
			source: "pia1 page 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Podaci o identitetu </strong>: građanski status, identitet, dob, itd. <strong> Osobni život </strong>: životne navike, bračni status, <strong> Podaci o vezi </strong>: IP adrese, zapisi o događajima itd. <br> <strong> Podaci o lokaciji </strong>: putovanja, GPS podaci, GSM podaci itd. <Strong> Ostalo </strong>: telefonski broj, adresa e-pošte itd.",
			name: "Zajednički osobni podaci",
			source: "pia2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Filozofski, politički, vjerski i sindikalni stavovi, seksualni život, podaci o zdravlju, rasno ili etničko podrijetlo, podaci o zdravlju ili seksualnom životu, kaznena djela, osude, sigurnosne mjere, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Kaznene osude i osjetljivi osobni podaci"
		},
		PIA_EX_DCPS: {
			description: "Broj socijalnog osiguranja (NIR), biometrijski podaci, bankovni podaci",
			name: "Osobni podaci koji se percipiraju kao osjetljivi"
		},
		PIA_EX_HUME: {
			description: "To mogu biti: <br>- odmetnuti ili naivan susjed koji uslijed fizičke blizine hakira podatke uređaja;<br>- haker koji cilja korisnika pomoću znanja koje ima o korisniku i nekih od informacija o njemu/njoj;<br>- haker koji cilja jednu tvrtku pomoću znanja koje posjeduje o tvrtkama koje može potkopati njihov ugled;<br>- ovlaštena tvrtka treće strane koja koristi povlašteni pristup za nezakonit pristup informacijama.",
			name: "Vanjski ljudski izvori"
		},
		PIA_EX_HUMI: {
			description: "Mogu biti ili:<br>- zaposlenik koji je nemaran ili se odmetnuo, blizina sustava, vještine, ovlasti i vrijeme koje je na raspolaganju su potencijalno visoki, mogući nedostatak obuke i svjesnosti<br>- nepažljiv ili odmetnuti korisnik, član obitelji ili prijatelj koji ima pristup usluzi.<br> Mogući su različiti motivi, uključujući: nespretnost, pogrešku, igru nemarnosti, zlu namjeru, osvetu, špijunažu",
			name: "Unutarnji ljudski izvori"
		},
		PIA_EX_IMPI: {
			description: "Ispitanici mogu imati značajne posljedice koje bi trebali biti u stanju nadvladati, ali s pravim i ozbiljnim poteškoćama. Na primjer: <br>- fizičke: ozbiljna tjelesna oboljenja koje uzrokuju dugotrajnu štetu (pogoršanje zdravlja zbog nepravilne skrbi ili zanemarivanja kontraindikacija), izmjena fizičkog integriteta, primjerice nakon napada, nesreće kod kuće, rada itd. <br>- materijalne: zloupotreba novca koji nije nadoknađen, ciljana, jedinstvena i neponavljajuća, izgubljene mogućnosti (kućni zajam, odbijanje studija, stažiranja ili zapošljavanja, zabrana izlaska na ispit), gubitak stanovanja, gubitak zaposlenja itd.;<br>- moralne: ozbiljne psihičke bolesti (depresija, razvoj fobije), osjećaj invazije privatnosti s nepovratnim oštećenjem, žrtva ucjene, internetskog zlostavljanja i uznemiravanja itd.",
			name: "Značajan utjecaj"
		},
		PIA_EX_IMPL: {
			description: "Ispitanici mogu naići na značajne neugodnosti, koje će moći nadvladati unatoč nekoliko poteškoća. Na primjer:<br>- fizičke: manja tjelesna oboljenja (manje bolesti zbog nepoštivanja kontraindikacija), gubitka ugleda koji rezultira fizičkom ili psihološkom odmazdom itd.;<br>- materijalne: neočekivana plaćanja (pogrešno nametnute novčane kazne), uskraćivanje pristupa administrativnim ili komercijalnim uslugama, primanje neželjene ciljane pošte koja bi mogla oštetiti ugled ispitanika, itd.;<br>- moralne: manje, ali objektivne psihološke boli, osjećaj invazije privatnosti bez nepovratne štete, zastrašivanje na društvenim mrežama itd..",
			name: "Ograničen utjecaj"
		},
		PIA_EX_IMPM: {
			description: "Ispitanici se mogu se susresti sa značajnim ili čak nepovratnim posljedicama koje oni ne mogu nadvladati. Na primjer:<br>- fizičkim: dugotrajna ili trajna fizička oboljenja, trajno oštećenje tjelesne cjelovitosti, smrt;<br>- materijalnim: financijski rizik, znatna dugovanja, nemogućnost rada, nemogućnost preseljenja, gubitak dokaza u kontekst parnica, gubitak pristupa vitalnoj infrastrukturi (voda, struja), itd.<br>- moralnim: dugotrajna ili trajna psihička oboljenja, kaznene sankcije, otmica, gubitak obiteljskih veza, nemogućnost tužbe, promjena upravnog statusa i/ili gubitak pravne autonomije (skrbništvo) itd.",
			name: "Maksimalan utjecaj"
		},
		PIA_EX_IMPN: {
			description: "Ispitanici ili neće biti pogođeni ili mogu naići na par neugodnosti koje će nadvladati bez ikakvih problema. Na primjer:<br>- fizičke: prolazne glavobolje;<br>- materijalne: gubitak vremena u ponavljanju formalnosti ili čekanju na njihovo ispunjavanje, primanje neželjenih pošte (npr. spam pošta), ponovna upotreba podataka objavljenih na web stranicama za svrhe ciljanog oglašavanja, itd.;<br>- moral: puka smetnja, osjećaj invazije privatnosti bez stvarne ili objektivne štete (komercijalni upad) itd.",
			name: "Zanemariv utjecaj"
		},
		PIA_EX_NHUM: {
			description: "Incident ili oštećenje u jednoj od organizacija (struja, požar, poplava itd.)",
			name: "Ne-ljudski izvori"
		},
		PIA_EX_VRAI: {
			description: "Čini se mogućim da bi odabrani izvori rizika ostvarili prijetnju iskorištavanjem svojstava pomoćnih sredstava (npr. krađe papirnatih dokumenata pohranjenih u uredima kojima se ne može pristupiti bez prijave na recepciji).",
			name: "Značajna vjerojatnost"
		},
		PIA_EX_VRAL: {
			description: "Čini se da bi odabrani izvori rizika teško mogli ostvariti prijetnju iskorištavanjem svojstava pomoćnih sredstava (npr. krađa papirnatih dokumenata pohranjenih u prostoriji zaštićenoj čitačem značke).",
			name: "Ograničena vjerojatnost"
		},
		PIA_EX_VRAM: {
			description: "Čini se da bi odabrani izvori rizika iznimno lako mogli ostvariti prijetnju iskorištavanjem svojstava prateće imovine (npr. krađe papirnatih dokumenata pohranjenih u javnom predvorju).",
			name: "Maksimalna vjerojatnost"
		},
		PIA_EX_VRAN: {
			description: "Ne čini se mogućim da bi odabrani izvori rizika mogli ostvariti prijetnju iskorištavanjem svojstava pomoćnih sredstava (npr. krađa papirnatih dokumenata pohranjenih u prostoriji zaštićenoj čitačem značke i pristupnim kodom).",
			name: "Zanemariva vjerojatnost"
		},
		PIA_LGL_CONS: {
			description: "Dopustite ispitanicima naprave slobodan, specifičan i informirani izbor. Utvrditi da li se obrada temelji na pravnoj osnovi, osim privole na temelju čl. 6. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Privola",
			source: "pia3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Detaljno definirajte i opišite opseg :<br>- predmetne osobne podatke, njihove primatelje i trajanja pohrane<br>- opis postupaka i pomoćnih sredstava za osobne podatke tijekom cijelog životno ciklusa osobnih podataka (od prikupljanja do brisanja).",
			name: "Podaci i postupci",
			source: "pia1 p6"
		},
		PIA_LGL_DESC: {
			description: "Navedite kratak pregled razmatrane obrade, njegnu prirodu, opseg, kontekst, svrhe i uloge. Odredite voditelja obrade i sve izvršitelje obrade. Navedite standardne reference koje se primjenjuju na tu obradu, a koje su nužne ili se moraju poštovati, ne zanemarujući odobrene kodekse ponašanja (pogledajte članak 40. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) and certifications regarding data protection (see Art. 42 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Opis obrade",
			source: "pia1 p4"
		},
		PIA_LGL_DEST: {
			description: "Fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo kojem se otkrivaju osobni podaci, neovisno o tome je li on treća strana. Međutim, tijela javne vlasti koja mogu primiti osobne podatke u okviru određene istrage u skladu s pravom Unije ili države članice ne smatraju se primateljima; obrada tih podataka koju obavljaju ta tijela javne vlasti mora biti u skladu s primjenjivim pravilima o zaštiti podataka prema svrhama obrade. see Art. 4.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Primatelj",
			source: "OUZP čl. 4.9"
		},
		PIA_LGL_DUR: {
			description: "Trajanje pohrane mora biti definirano za svaku vrstu podataka i opravdano pravnim zahtjevima i/ili potrebama obrade. Dakle, postoji razlika između zajedničkih podataka i arhiviranih podataka, kojima će pristup imati samo zainteresirani dionici. Potrebno je uvesti mehanizam brisanja za arhiviranje zajedničkih podataka ili čišćenja arhiviranih podataka na kraju njihovog trajanja pohrane. Također, očistiti se moraju i funkcionalni tragovi, kao i tehnički zapisi koji se ne smiju pohranjivati na neodređeno vrijeme",
			name: "Trajanje pohrane",
			source: "piaF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Osobni podaci prikupljaju se u posebne, izričite i zakonite svrhe te se dalje ne smiju obrađivati na način koji nije u skladu s tim svrhama.</strong> <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) of [GDPR]</a>",
			name: "Načela koja se odnose na obradu osobnih podataka",
			source: "OUZP čl. 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Ispitanik je dao privolu za obradu njegovih ili njezinih osobnih podataka za za jednu ili više specifičnih svrha <br> - Obrada je neophodna za izvršenje ugovora u kojem je ispitanik ugovorna strana ili kako bi se poduzeli koraci na zahtjev ispitanika prije sklapanja ugovora <br> - Obrada je neophodna za ispunjavanje zakonske obveze koja obvezuje voditelja obrade <br>- Obrada je neophodna kako bi se zaštitili vitalni interesi ispitanika ili druge fizičke osobe <br>- Obrada je neophodna za obavljanje zadatka koji se obavlja u javnom interesu ili u obavljanju službene ovlasti koja je dana voditelju obrade <br>- Obrada je neophodna u svrhu legitimnih interesa voditelja obrade ili treće strane, osim ako su takvi interesi nadjačani interesima ili temeljnim pravima i slobodama ispitanika koje zahtijevaju zaštitu osobnih podataka, osobito ako je ispitanik  dijete<br> Pogledaj <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 6 of [GDPR]</a> ",
			name: "Opravdanje zakonitosti",
			source: "pia2 p4"
		},
		PIA_LGL_INFO: {
			description: "Osigurajte da su ispitanici obaviješteni. Potvrdite da obrada nije obuhvaćena iznimkom i ne podliježe posebnim uvjetima.",
			name: "Obavještavanje ispitanika",
			source: "pia3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Važno je smanjiti ozbiljnost rizika smanjivanjem količine osobnih podataka koji će se obrađivati ograničavanjem tih podataka na samo one koji su strogo nužni u svrhe za koje se obrađuju (inače ih se ne smije prikupljati). Nadalje, također postaje moguće smanjiti i same podatke, putem kontrola usmjerenih na smanjenje njihove osjetljivosti.",
			name: "Načelo smanjenja količine podataka",
			source: "piaF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Ugovor o obradi mora biti potpisan sa svakim izvršiteljem obrade i navoditi aspekte propisane čl. 28. [GDPR]: trajanje, opseg, svrhu, dokumentirane upute za obradu, prethodno odobrenje kad je angažiran izvršitelj obrade, pružanje bilo koje dokumentacije koja dokazuje sukladnost s [GDPR], promptno obavještavanje o povredi podataka itd..",
			name: "Podizvođači",
			source: "pia2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Sredstvo na koje se osobni podaci oslanjaju. Napomena: ovo može biti hardver, softver, mreže, ljudi, papir ili papirnati prijenosni kanali.",
			name: "Pomoćno sredstvo",
			source: "pia1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Ovisno o državi u pitanju, morat ćete opravdati izbor udaljenog hostinga i naznačiti aranžmane nadzora zakonitosti koji su provedeni kako bi se osigurala odgovarajuća zaštita podataka podložnih prekograničnom prijenosu. To jest: <br> - Europska unija <br> - Država priznata od strane EU-a kao ona koja pruža odgovarajuće zaštitu <br> - Prijenos u Sjedinjene Države društvu koje se pridružilo Privacy Shield okviru <br> - Druga država <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 to 49 of [GDPR]</a>",
			name: "Prijenosi",
			source: "piaF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Postojanje pravila i postupaka za dobivanje organizacije koja može upravljati i kontrolirati zaštitu osobnih podataka koji se kod nje nalaze.",
			name: "Nadzor",
			placeholder: "Ovdje navedite da li se nadzire učinkovitost i primjerenost kontrola privatnosti.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Postojanje pravila i postupaka koji smanjuju rizik da legitimni pristup osobnim podacima od strane trećih osoba može predstavljati rizik za građanske slobode i privatnost ispitanika.",
			name: "Odnosi s trećim stranama",
			placeholder: "Ovdje za izvršitelje obrade koji zahtijevaju pristup podacima navedite sigurnosne kontrole i dogovore koji se provode u vezi s takvim pristupom.",
			source: "pia3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Navedite da li postoji osoba odgovorna za provođenje zakona i propisa o privatnosti. Navedite postoji li nadzorni odbor (ili slično tijelo) odgovoran za usmjeravanje i praćenje radnji vezanih uz zaštitu privatnosti.",
			name: "Organizacija",
			placeholder: "Ovdje navedite da li su definirane uloge i odgovornosti za zaštitu podataka.",
			source: "piaF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Postojanje pravila osmišljenih za integriranje zaštite osobnih podataka u sve nove aktivnosti obrade.",
			name: "Integriranje zaštite privatnosti u projektima",
			placeholder: "Ovdje opišite kako je zaštita privatnosti integrirana u projekte",
			source: "pia3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Postojanje pravila koja opisuju kontrolu podizanja svijesti i provode se prilikom novog zapošljavanja i koje se kontrole provode kada osobe koje imaju pristup podacima napuštaju svoj posao.",
			name: "Upravljanje osobljem",
			placeholder: "Ovdje navedite koje se kontrole podizanja svijesti provode u odnosu na zaposlenike.",
			source: "piaF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Navedite važne aspekte koji se odnose na zaštitu podataka u dokumentarnoj bazi koji čine pravila o zaštiti podataka i u obliku koji odgovara svakoj vrsti sadržaja (rizici, ključna načela koje treba slijediti, zadani ciljevi, pravila koja se primjenjuju, itd.) i svakom cilju komunikacije (korisnici, informatički odjel, stvaratelji pravila, itd.).",
			name: "Pravila",
			placeholder: "Ovdje opišite dokumentarnu bazu koja navodi ciljeve i pravila zaštite podataka.",
			source: "pia3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Pravila koja opisuju postupke kojima se kontroliraju rizici koji uslijed aktivnosti obrade koje provodi organizacija nastaju za zaštitu podataka i privatnost ispitanika (izgradnja karte rizika itd.).",
			name: "Upravljanje rizicima za privatnost",
			placeholder: "Ovdje opišite postupke za kontrolu rizika koje aktivnosti obrade koju organizacija provodi predstavljaju za zaštitu podataka i privatnost ispitanika.",
			source: "pia3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Postojanje operativne organizacije koja može otkriti i popravljati incidente koji mogu utjecati na građanske slobode i privatnost ispitanika.",
			name: " Upravljanje povredama osobnih podataka",
			placeholder: "Ovdje navedite jesu li IT incidenti podložni dokumentiranom i testiranom postupku upravljanja.",
			source: "piaF Connected Objects p24 and pia3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Pravila i sredstva koja se provode kako bi se osigurala dostupnost i/ili cjelovitost osobnih podataka uz istovremeno zadržavanje njihove tajnosti.",
			name: "Sigurnosne kopije",
			placeholder: "Ovdje navedite kako se upravlja sigurnosnim kopijama. Pojasnite jesu li pohranjene na sigurnom mjestu.",
			source: "piaF Connected Objects p23 & pia3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Kontrole implementirane na radnim stanicama (automatsko zaključavanje, redovita ažuriranja, konfiguracija, fizička sigurnost itd.) kako bi se smanjila mogućnost iskorištavanja softverskih svojstava (operativni sustavi, poslovne aplikacije i sl.) s nepovoljnim utjecajem na osobne podatke.",
			name: "Upravljanje radnim stanicama",
			placeholder: "Ovdje opišite kontrole koje se provode na radnim stanicama",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "TO BE TRANSLATED - Les données à caractère personnel communiquées à ou gérées par des sous-traitants doivent bénéficier de garanties suffisantes. <strong>Faire appel uniquement à des sous-traitants présentant des garanties suffisantes</strong> (notamment en termes de connaissances spécialisées, de fiabilité et de resources). Exiger la communication par le prestataire de sa politique de sécurité des systèmes d’information. <br>Prendre et documenter les moyens (audits de sécurité, visite des installations, etc.) permettant d’<strong>assurer l’effectivité des garanties offertes par le sous-traitant<strong> en matière de protection des données. Ces garanties incluent notamment :<br> - le chiffrement des données selon leur sensibilité ou à défaut l’existence de procédures garantissant que la société de prestation n’a pas accès aux données qui lui sont confiées<br>- le chiffrement des transmissions de données (ex : connexion de type HTTPS, VPN, etc.)<br>- des garanties en matière de protection du réseau, de traçabilité (journaux, audits), de gestion des habilitations, d’authentification, etc.<br><strong>Prévoir un contrat avec les sous-traitants</strong>, qui définit notamment l’objet, la durée, la finalité du traitement et les obligations des parties. S’assurer qu’il contient en particulier des dispositions fixant :<br>- leur obligation en matière de confidentialité des données personnelles confiées<br>- des contraintes minimales en matière d’authentification des utilisateurs<br>- les conditions de restitution et/ou de destruction des données en fin du contrat<br>- les règles de gestion et de notification des incidents. Celles-ci devraient comprendre une information du responsable de traitement en cas de découverte de faille de sécurité ou d’incident de sécurité et cela dans les plus brefs délais lorsqu’il s’agit d’une violation de données à caractère personnel.<br>- Dans le cas de l’utilisation de fournisseur de cloud computing :<br>\t1. identifier clairement les données et les traitements qui passeront dans le cloud ;<br>\t2. définir ses propres exigences de sécurité technique et juridique ;<br>\t3. conduire une étude de risques afin d'identifier les mesures de sécurité appropriées ;<br>\t4. identifier le type de cloud pertinent pour le traitement envisagé ;<br>\t5. choisir un prestataire présentant des garanties suffisantes ;<br>\t6. revoir la politique de sécurité interne ;<br>\t7. surveiller les évolutions dans le temps.",
			name: "Ugovori o izvršavanju obrade",
			placeholder: "Ovdje opišite specifične mjere za izvršitelje obrade (društvo koje pruža usluge poslužitelja, drušvo za održavanje, administrator, specijalizirani pružatelji usluga itd.)",
			source: "Mjere_SAD nabava: identificirane i podložne ugovoru"
		},
		PIA_SEC_EXP: {
			description: "Pravila uvedena kako bi se smanjla mogućnost i učinak rizika na sredstva koja podupiru osobne podatke.",
			name: "Operativna sigurnost",
			placeholder: "Ovdje opišite kako se provode ažuriranja softvera (operativnih sustava, aplikacija itd.) i primjena sigurnosnih ispravljajućih zakrpa za sigurnosne ispravke.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Nadzor sustava za otkrivanje upada i sustava za sprečavanje upada radi analiziranja mrežnog prometa (žičane mreže, Wi-Fi, radio valovi, svjetlovodi itd.) u stvarnom vremenu i otkrivanje sumnjivih aktivnosti koje ukazuju na scenarij kibernetičkog napada.",
			name: "Praćenje aktivnosti mreže",
			placeholder: "Ovdje navedite sredstva i kontrole koje se provode za otkrivanje incidenta koji uključuju osobne podatke",
			source: "pia3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Pravila koja opisuju kako se upravlja fizičkim održavanjem hardvera, navodeći je li to podugovoreno. <br> Navedite je li dopušteno daljinsko održavanje aplikacija i prema kakvim dogovorima. Navedite da li se defektnom opremom upravlja na određeni način.",
			name: "Održavanje",
			placeholder: "Ovdje opišite kako se upravlja fizičkim održavanjem hardvera",
			source: "piaF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Kontrole implementirane na radnim stanicama i poslužiteljima kako bi ih zaštitili od zlonamjernog softvera dok se pristupaju manje sigurnim mrežama.",
			name: "Suzbijanje zlonamjernog softvera",
			placeholder: "Ovdje opišite kontrole koje se provode kako bi se smanjili rizici pri pristupu manje sigurnim mrežama.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Ovdje navedite kontrole od utjecaja na fizičku sigurnost poslužitelja i radnih stanica (sigurnosna pohrana, sigurnosni kabeli, filtri povjerljivosti, sigurnosno brisanje prije uklanjanja, itd.).",
			name: "Sigurnost hardvera",
			placeholder: "Ovdje navedite kontrole koje su od utjecaja na fizičku sigurnost poslužitelja i radnih stanica",
			source: "piaF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Ovisno o vrsti mreže na kojoj se obrada izvršava (izolirana, privatna ili internetska). Navedite koji je sustav vatrozida, odnosno koji su sustavi za otkrivanje upada ili drugi aktivni ili pasivni uređaji zaduženi za osiguranje sigurnosti mreže.",
			name: "Mrežna sigurnost",
			placeholder: "Ovdje navedite sigurnosne kontrole mreže na kojoj se obrada izvršava",
			source: "piaF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Pravila kako bi se osigurala fizička sigurnost (zoniranje, pratnja za posjetitelje, nošenje kartica za prolaz, zaključana vrata itd.). Navedite postoje li postupci upozoravanja u slučaju provale.",
			name: "Kontrola fizičkog pristupa",
			placeholder: "Ovdje navedite kako se provodi kontrola fizičkog pristupa u prostorijama u kojima se obrada izvršava.",
			source: "piaF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Pravila koja opisuju sredstva za sprečavanje, otkrivanje i borbu protiv požara. Ako je primjenjivo, navedite sredstva za sprečavanje oštećenja od vode. Također navedite sredstva za nadzor napajanja i pomoć.",
			name: "Zaštita od ne-ljudskih izvora rizika",
			placeholder: "Ovdje navedite sredstva za ograničavanje ne-ljudskih izvora rizika.",
			source: "piaF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Dokumentacija o području implantacije, koje ne bi trebalo biti podložno katastrofama u okolišu (zona poplava, blizina kemijskih industrija, potresi ili vulkanske zone itd.) Navedite da li su na istom području pohranjeni opasni proizvodi.",
			name: "Izbjegavanje izvora rizika",
			placeholder: "Ovdje navedite je li područje implantacije podložno ekološkim katastrofama",
			source: "piaF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementacija preporuka ANSSI-ja za osiguravanje mrežnih stranica.",
			name: "Sigurnost mrežnih stranica",
			placeholder: "Ovdje navedite kontrole provedene za zaštitu mrežnih stranica.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Ovdje navedite da li se provode mehanizmi anonimizacije, koji oni i za koju svrhu. <br> Ne zaboravite jasno razlikovati anonimizirane i pseudonimizirane podatke.",
			name: "Anonimizacija",
			placeholder: "Ovdje navedite implementirane anonimizacijske mehanizme",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Gdje je to moguće, ovdje opišite postupke upravljanja arhivom (isporuka, pohrana, pregled, itd.) koji su pod Vašom odgovornošću. Navedite uloge arhiviranja (uredi podrijetla, agencije za prijenos, itd.) i pravila arhiviranja. Navedite da li podaci padaju unutar okvira javnih arhiva.",
			name: "Arhiviranje",
			placeholder: "Ovdje navedite da li su uvedeni mehanizmi za praćenje integriteta pohranjenih podataka, kojih i u koju svrhu.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Sredstva implementirana za <strong> osiguravanje povjerljivosti </ strong>  pohranjenih podataka (u bazi podataka, ravnim datotekama, sigurnosnim kopijama itd.), kao i postupak za upravljanje enkripcijskim ključevima (stvaranje, pohrana, promjena u slučaju sumnja na slučajeve kompromitiranja podataka i sl.). <br> Opišite načine enkripcije koji se koriste za tokove podataka (VPN, TLS, itd.), a koji su implementirani u obradi.",
			name: "Enkripcija",
			placeholder: "Opišite ovdje provedena sredstva za osiguranje povjerljivosti podataka",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Provedba particioniranja podataka pomaže smanjiti mogućnost da se osobni podaci mogu povezati i da se može pojaviti povreda svih osobnih podataka.",
			name: "Particioniranje podataka",
			placeholder: "Ovdje navedite da li se planira particioniranje obrade i kako se ono provodi.",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Metode za definiranje i pripisivanje korisničkih profila. Navedite način <strong> autentikacije </ strong> Gdje je to moguće, odredite pravila koja se primjenjuju na zaporke (minimalna duljina, zahtijevani znakovi, trajanje valjanosti, broj neuspjelih pokušaja prije zaključavanja pristupa računu i sl.).",
			name: "Kontrola logičkog pristupa",
			placeholder: "Ovdje navedite kako su definirani i kako se pripisuju korisnički profili.",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Pravila koja uređuju sljedivost i upravljanje zapisnicima.",
			name: "Sljedivost (stvaranje zapisa)",
			placeholder: "Ovdje navedite da li događaji bilježe i koliko dugo se ti tragovi čuvaju.",
			source: "piaF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Mogu se koristiti sljedeće metode: Filtriranje i uklanjanje, smanjenje osjetljivosti putem pretvorbe, smanjenje otkrivajuće prirode podataka, smanjenje akumulacije podataka, ograničavanje pristupa podacima",
			name: "Smanjenje količine osobnih podataka",
			placeholder: "Ovdje navedite sredstva koja su provedena kako bi se smanjila ozbiljnost rizika ograničavanjem količine osobnih podataka",
			source: "piaF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Tamo gdje se tijekom obrade koriste papirnati dokumenti koji sadrže podatke, ovdje navedite kako se ispisuju, pohranjuju, uništavaju i razmjenjuju.",
			name: "Sigurnost papirnatih dokumenata",
			placeholder: "Ovdje navedite jesu li uvedeni mehanizmi za praćenje integriteta papirnatih dokumenata, koji su i za koju svrhu.",
			source: "piaF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "korektivne kontrole koje predlaže procjenitelj u prijašnjim koracima, uz izradu akcijskog plana kojim se određuje, za svaku radnju, njen voditelj, učestalost, težina, trošak i napredak.",
			name: "Akcijski plan",
			source: "Ne postoji"
		},
		PIA_VAL_CART: {
			description: "Grafikon koji ilustrira dobre sigurnosne prakse, s vrijednostima usklađenosti koje se dodjeljuju svakoj od njih na temelju njihove procjene u prijašnjim koracima.",
			name: "Mapiranje rizika",
			source: "piaF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Gdje je to primjereno, voditelj obrade zatražit će mišljenja ispitanika ili njihovih predstavnika o namjeravanoj obradi, ne dovodeći u pitanje zaštitu komercijalnih ili javnih interesa ili sigurnost postupaka obrade. Vidi čl. 35 st. 9 od <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> Ta se mišljenja mogu prikupljati različitim sredstvima, ovisno o kontekstu (unutarnje ili vanjsko istraživanje o metodama obrade i svrsi, pitanja za predstavnike osoblja ili sindikate, ankete među budućim klijentima voditelja obrade. <strong> Kada voditelj obrade odluči ići protiv stavova ispitanika </ strong>, on mora zabilježiti <strong> opravdanje ove odluke </ strong>. Ako voditelj obrade smatra da <strong> prikupljanje mišljenja ispitanika nije relevantno, mora također zabilježiti opravdanje za to</strong>.",
			name: "Mišljenje ispitanika",
			source: "OUZP čl. 35.9 and piaF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "Voditelj obrade tražit će savjet službenika za zaštitu podataka, kad je određen, pri provođenju procjene učinka na zaštitu podataka. Pogledajte čl. 35. st. 2 <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>Ovo gledište može biti protiv obrade koja se provodi, bez ograničavanja odluke voditelja obrade za to</strong>.",
			name: "Mišljenje SZP-a",
			source: "OUZP čl. 35.2 and piaF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Odlučite jesu li odabrane kontrole, rezidualni rizici i akcijski plan prihvatljivi, s opravdanjima, s obzirom na prethodno utvrđene uloge i mišljenja dionika. Na taj način, PUP može biti: <br>- potvrđen<br>- uvjetovan poboljšanjem (objasniti na koji način) <br> - odbijen (uz obradu koja je predmetom razmatranja). Tamo gdje je potrebno, ponovite prethodne korake kako bi PUP bio potvrđen. Ova odluka ne prejudicira ocjenu sukladnosti koja se može provesti, ako je to primjenjivo, od strane Tijela za zaštitu podataka (CNIL u Francuskoj), kao dio preliminarnih formalnosti ili provjera, na primjer.",
			name: "Formalna potvrda",
			source: "piaF Connected Objects p40"
		}
	},
	title: "Baza znanja"
};
var measures$c = {
	add: "Dodaj praznu mjeru (u suprotnom koristi bazu znanja)",
	default_placeholder: "Opišite postojeće ili namjeravane mjere kako bi osigurali sigurnost podataka.",
	edit: "Uredi mjeru",
	placeholder_title: "Naziv mjere",
	remove: "Izbriši mjeru"
};
var misc$c = {
	display: "Prikaži / sakrij"
};
var modals$c = {
	abandon_pia: {
		additional_text: "Arhiviranje nije definitivno i PUP se može vratiti ako je potrebno.",
		content: "Želite li odustati od obrade?"
	},
	action_plan_no_evaluation: {
		content: "Morate započeti pregled analize kako biste izradili akcijski plan.",
		review_section: "Pregledajte odjeljak"
	},
	archive: "Arhiviraj",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "Ovaj odjeljak spreman je za pregled."
	},
	back_to_edition: {
		content: "Ovaj odjeljak poslan je nazada na uređivanje.<br> Potrebno je ispraviti nekoliko polja<br> kako bi se omogućio pravilan pregled."
	},
	back_to_evaluation: {
		content: "Ovaj odjeljak poslan je nazada na pregled.<br> Potrebno je pregledati nekoliko polja<br> kako bi se omogućilo pravilno potvrđivanje."
	},
	back_to_home: "Povratak kući",
	cancel: "Poništi",
	close: "Zatvori",
	completed_edition: {
		content: "PUP je u potpunosti uređen i treba ga pregledati."
	},
	completed_evaluation: {
		content: "PUP je u potpunosti pregledan i može ići na potvrdu."
	},
	"continue": "Nastavi",
	declare_measures: {
		content: "Prije procjene rizika,<br> morate prijaviti postojeće ili planirane mjere.",
		declare: "Objavi postojeće ili planirane mjere"
	},
	dpo_missing_evaluations: {
		comment: "Komentar",
		content: "Morate dovršiti pregled analize da biste pristupili stranici SZP-a.",
		remove: "Ukloni",
		review_section: "Pregledajte odjeljak"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Uvezena datoteka ne odgovara datoteci izvještaja PUP-a"
	},
	import_wrong_structure_file: {
		content: "Uvezena datoteka ne odgovara datoteci obrasca PUP-a"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Sadržaj PUP-a kopiran je u međuspremnik."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Warning,</span><br>Upozorenje, </ span> <br> barem jedna mjera mora biti unesena: brisanje nije moguće."
	},
	recover_version: {
		"continue": "Nastavi",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "Kako ste odbili PUP, on je ponovno poslan na pregled kako bi se izvršile potrebne promjene."
	},
	remove_attachment: {
		comment: "Komentar",
		content: "<span class='strong'>Upozorenje, </span><br> Jeste li sigurni da želite ukloniti ovaj privitak?",
		keep: "Zadrži",
		remove: "Ukloni"
	},
	remove_measure: {
		content: "<span class='strong'>Upozorenje,</span><br> jeste li sigurni da želite<br> ukloniti ovu mjeru?",
		keep: "Zadrži ovu <br>mjeru",
		remove: "Ukloni ovu <br>mjeru"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Ukloni ovaj PUP"
	},
	remove_question: {
		content: "Jeste li sigurni da želite obrisati pitanje?",
		keep: "Poništi",
		remove: "Izbriši"
	},
	remove_structure: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want<br>to delete the template?",
		remove: "Delete template"
	},
	same_comment: {
		content: "<span class='strong'>Upozorenje,</span><br> molimo unesite komentar koji se razlikuje od posljednje zabilježenog."
	},
	signed_pia_validation: {
		content: "Da biste odobrili PUP, priložite potpisano izvješće.",
		download_pia: "Preuzmi izvješće"
	},
	simple_pia_validation: {
		content: "Odobrili ste PUP."
	},
	start_evaluation: "Započni pregled",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Adresa poslužitelja je ažurirana."
	},
	validate_evaluation: {
		content: "Ovaj odjeljak spreman je za potvrdu PUP-a."
	},
	validate_evaluation_to_correct: {
		content: "Žao nam je,<br> potrebno je ispraviti nekoliko polja.<br>Povratak na način uređivanja<br> radi unošenja ispravaka."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$c = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$c = {
	content: ", razmotrite sljedeće :",
	dpo_lock: "Molimo ispunite ostale odjeljke prije ispunjavanja mišljenja SZP-a.",
	dpo_opinion: "Mišljenje SZP-a",
	edit: "Uredi",
	people_opinion: "Mišljenje dotičnih osoba",
	placeholder_concerned_people_name: "Ime(na) dotičnih osoba",
	placeholder_dpo_name: "Ime(na) SZP-a",
	placeholder_dpo_opinion: "Navedite razloge za vaš izbor.",
	placeholder_people_opinion: "Opišite kako su mišljenja prikupljena i koja je analiza. Ako se obavijesti ne traže, navedite razloge.",
	placeholder_search_content: "Opravdajte razlog zašto mišljenje dotičnih osoba nije zatraženo.",
	treatment_lock: "Molimo ispunite ostale odjeljke prije ispunjavanja mišljenja dotičnih osoba.",
	treatment_nok: "Tretman se ne smije koristiti.",
	treatment_ok: "Tretman se ne može provesti."
};
var pia$c = {
	attachments: {
		add: "Dodaj",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Ukloni",
		title: "Prilozi",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Zatraži pregled",
		mandatory_fields: "Sva polja moraju biti popunjena",
		structure_add_question: "Dodaj",
		subsection_validated: "Pododjeljak je pregledan i očekuje konačnu potvrdu",
		validate_evaluation: "Izvrši potvrdu pregleda"
	},
	header: {
		display_action_plan: "Prikaži<br>akcijski plan",
		edition: "Izdanje",
		evaluation: "Evaluacija",
		preview: "Kratki pregled"
	},
	sections: {
		based_on_structure_name: "Na temelju obrasca:",
		homepage_link: "Povratak na kontrolnu ploču",
		refuse_pia: "Odbijeni PUP",
		status: {
			evaluation: {
				cancel: "poništi zahtjev za pregled.",
				cancel_button: "Poništi zahtjev za pregled",
				content: "Ovaj dio još nije pregledan. Ako želite urediti sadržaj koji je poslan na pregled, morate",
				title: "Čeka na pregled."
			},
			validation: {
				cancel: "poništiti zahtjev za potvrdu.",
				cancel_button: "Poništi zahtjev za potvrdu",
				content: "Ovaj dio je pregledan, te čeka na potvrdu cjelokupnog PUP-a. Ako želite izmijeniti pregled, morate",
				title: "Čeka na potvrdu."
			}
		},
		validate_pia: "Potvrdi  PUP"
	},
	statuses: [
		"U tijeku",
		"Odbijen",
		"Jednostavna potvrda",
		"Potpisana potvrda",
		"Arhiviran",
		"Čeka na potvrdu"
	]
};
var questions$c = {
	edit: "Uredi pitanje",
	gauges: [
		"(Nedefinirano)",
		"Zanemariv",
		"Ograničen",
		"Bitan",
		"Maksimalan"
	],
	placeholder_title: "Question title (mandatory)",
	remove: "Delete question"
};
var rejection_page$c = {
	applied_adjustments: "Predložene prilagodbe",
	applied_adjustments_placeholder: "Opišite promjene koje su unesene u PUP.",
	button: {
		abandon_treatment: "Obustavi obradu",
		reject_pia: "Odbij PUP",
		send_for_validation: "Pošalji na ponovno odobrenje"
	},
	previous_rejection: "Prethodno odbijanje",
	rejection_reason: "Razlog odbijanja",
	rejection_reason_placeholder: "Opišite razloge za odbijanje PUP-a.",
	title: "Povijest potvrđivanja"
};
var sections$c = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Prikažite kratak pregled obrade: njegovo ime, svrhe, uloge, kontekst uporabe itd.",
						title: "Koja je obrada koja se razmatra?"
					},
					"2": {
						placeholder: "Opišite odgovornosti dionika: voditelja obrade, mogućih izvršitelja obrade i zajedničkih voditelja obrade.",
						title: "Koje su odgovornosti povezane s obradom?"
					},
					"3": {
						placeholder: "Navedite relevantne standarde primjenjive na obradu, posebno odobrene kodekse ponašanja i certifikate zaštite podataka.",
						title: "Postoje li standardi primjenjivi na obradu?"
					}
				},
				short_help: "Ovaj dio vam omogućuje prepoznavanje i predstavljanje objekta razmatranja.",
				title: "Pregled"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Popišite prikupljene i obrađene podatke. Za svaki odredite trajanje pohrane, primatelje i osobe kojima je dan pristup.",
						title: "Koji se podaci obrađuju?"
					},
					"2": {
						placeholder: "Prikažite i opišite kako proizvod općenito funkcionira (od prikupljanja podataka do uništavanja podataka, različitih faza obrade, pohrane itd.), na primjer pomoću dijagrama tokova podataka (dodajte ih kao privitak) i detaljnog opisa provedenih postupaka.",
						title: "Kako funkcionira životni ciklus podataka i postupaka?"
					},
					"3": {
						placeholder: "Navedite podatke o pomoćnim sredstvima (operativni sustavi, poslovne aplikacije, sustavi za upravljanje bazama podataka, uredske stanice, protokoli, konfiguracije itd.)",
						title: "O kojim se pomoćnim sredstvima radi?"
					}
				},
				short_help: "Ovaj vam dio omogućuje detaljno definiranje i opis opsega obrade.",
				title: "Podaci, procesi i pomoćna sredstva"
			}
		},
		short_help: "Ovaj odjeljak daje jasan pregled tretmana osobnih podataka u pitanju.",
		title: "Kontekst"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Objasnite zašto su svrhe obrade posebne, izričite i zakonite.",
						short_title: "Svrhe",
						title: "Da li je svrha obrade posebna, izričita i zakonita?"
					},
					"2": {
						placeholder: "Opišite koja je pravna osnova vaše obrade (npr. privola, izvršenje ugovora, poštovanje zakonske obveze, zaštita vitalnih interesa, itd.)",
						short_title: "Pravna osnova",
						title: "Koja je pravna osnova koja obradu čini zakonitom?"
					},
					"3": {
						placeholder: "Objasnite zašto je svaki prikupljeni podatak nužan za potrebe vaše obrade.",
						short_title: "Adekvatni podaci",
						title: "Da li su prikupljeni podaci primjereni, relevantni i ograničeni na ono što je nužno u odnosu na svrhe u koje se obrađuju ('smanjenje količine podataka')?"
					},
					"4": {
						placeholder: "Opišite koji su koraci poduzeti kako bi se osigurala kvaliteta podataka.",
						short_title: "Točnost podataka",
						title: "Jesu li podaci točni i ažurni?"
					},
					"5": {
						placeholder: "Objasnite zašto su trajanja pohrane opravdana zakonskim zahtjevima i/ili potrebama za obradom.",
						short_title: "Trajanje pohrane",
						title: "Koliko je trajanje pohrane podataka?"
					}
				},
				short_help: "Ovaj dio vam omogućuje da pokažete zakonitost vašeg tretmana i obrađenih podataka.",
				title: "Proporcionalnost i nužnost"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Opišite koje su informacije dane ispitanicima i koja su sredstva za to.",
						short_title: "Informacije za ispitanike",
						title: "Kako su voditelji obrade obaviješteni o obradi?"
					},
					"2": {
						placeholder: "Opišite kontrole namijenjene za osiguranje privole ispitanika.",
						short_title: "Dobivanje privole",
						title: "Ako je primjenjivo, kako se dobiva privola ispitanika?"
					},
					"3": {
						placeholder: "Opišite kontrole namijenjene za omogućavanje ispitanicima da pristupe svojim podacima, da ih prime i da ih prenesu.",
						short_title: "Pravo pristupa i prenosivosti podataka",
						title: "Kako ispitanici mogu ostvariti svoja prava pristupa i prenosivosti podataka?"
					},
					"4": {
						placeholder: "Opišite kontrole namijenjene omogućavanju ispitanicima da isprave i izbrišu svoje podatke.",
						short_title: "Pravo na ispravak i brisanje",
						title: "Kako ispitanici mogu ostvariti svoja prava na ispravak i brisanje?"
					},
					"5": {
						placeholder: "Opišite kontrole namijenjene omogućavanju ispitanicima da ograniče i prigovore obradi njihovih podataka.",
						short_title: "Pravo na ograničenje i prigovor",
						title: "Kako ispitanici mogu ostvariti svoja prava na ograničenje i prigovor?"
					},
					"6": {
						placeholder: "Za svakog izvršitelja obrade, opišite njegove odgovornosti (trajanje, opseg, svrhu, dokumentirane upute za obradu i prethodno odobrenje) te navedite ugovore, kodekse ponašanja i certifikate koji određuju njegove zadaće i obveze.",
						short_title: "Podugovaranje",
						title: "Jesu li obveze izvršitelja obrade jasno identificirane i uređene ugovorom?"
					},
					"7": {
						placeholder: "Navedite svaku državu izvan Europske unije gdje se podaci pohranjuju ili obrađuju, te navedite je li priznato da ona nudi odgovarajuću razinu zaštite podataka ili opišite odredbe o prijenosu.",
						short_title: "Prijenosi",
						title: "U slučaju prijenosa podataka izvan Europske unije, jesu li podaci primjereno zaštićeni?"
					}
				},
				short_help: "Ovaj dio vam omogućuje da pokažete da provodite neophodna sredstva kako bi omogućili dotičnim osobama da ostvaruju svoja prava.",
				title: "Kontrole radi zaštite osobnih prava nositelja podataka"
			}
		},
		short_help: "Ovaj odjeljak omogućuje vam izgradnju okvira usklađenosti za načela privatnosti.",
		title: "Temeljna načela"
	},
	"3": {
		items: {
			"1": {
				short_help: "Ovaj odjeljak omogućuje vam da navedete kontrole (postojeće ili planirane) koje pridonose sigurnosti podataka.",
				title: "Planirane ili postojeće mjere"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Unesite moguće utjecaje +",
						title: "Koji bi mogli biti glavni <span class='green-highlight'> utjecaji na ispitanike </span> ako se rizik pojavi?"
					},
					"2": {
						placeholder: "Unesite prijetnje +",
						title: "Koje su glavne <span class='green-highlight'> prijetnje </span> koje bi mogle dovesti do rizika?"
					},
					"3": {
						placeholder: "Unesite izvore rizika +",
						title: "Koji su izvori <span class='green-highlight'> rizika </span>"
					},
					"4": {
						placeholder: "Kliknite da biste odabrali kontrole koje odgovaraju na rizik.",
						title: "Koja od navedenih <span class='green-highlight'> kontrola </span> doprinosi odgovoru na rizik?"
					},
					"5": {
						placeholder: "Ovdje opravdajte procijenjenu ozbiljnost rizika.",
						title: "Kako procjenjujete <span class='green-highlight'> ozbiljnost rizika </span>, posebno prema potencijalnim utjecajima i planiranim kontrolama?"
					},
					"6": {
						placeholder: "Ovdje opravdajte procijenjenu vjerojatnost.",
						title: "Kako procjenjujete vjerojatnost rizika <span class='green-highlight'> </span>, posebno u odnosu na prijetnje, izvore rizika i planirane kontrole?"
					}
				},
				short_help: "Analizirajte uzroke i posljedice nezakonitog pristupa podacima i procijenite njegovu ozbiljnosti i vjerojatnost.",
				title: "Nezakoniti pristup podacima"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Unesite moguće utjecaje +",
						title: "Koji bi mogli biti glavni <span class='green-highlight'> utjecaji na ispitanike </span> ako se rizik pojavi?"
					},
					"2": {
						placeholder: "Unesite prijetnje +",
						title: "Koje su glavne <span class='green-highlight'> prijetnje </span> koje bi mogle dovesti do rizika?"
					},
					"3": {
						placeholder: "Unesite izvore rizika +",
						title: "Koji su izvori <span class='green-highlight'> rizika </span>?"
					},
					"4": {
						placeholder: "Kliknite ovdje za odabir kontrola koje odgovaraju na rizik.",
						title: "Koja od navedenih <span class='green-highlight'> kontrola </span> doprinosi odgovoru na rizik?"
					},
					"5": {
						placeholder: "Ovdje opravdajte procijenjenu ozbiljnost rizika.",
						title: "Kako procjenjujete <span class='green-highlight'> ozbiljnost rizika </span>, posebno u odnosu na potencijalne utjecaje i planirane kontrole?"
					},
					"6": {
						placeholder: "Ovdje opravdajte procijenjenu vjerojatnost.",
						title: "Kako procjenjujete <span class='green-highlight'> vjerojatnost rizika </span>, posebno u odnosu na prijetnje, izvore rizika i planirane kontrole?"
					}
				},
				short_help: "Analizirajte uzroke i posljedice neželjenih izmjena u podacima i procijenite njihovu ozbiljnost i vjerojatnost.",
				title: "Neželjena izmjena podataka"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "unesite moguće utjecaje +",
						title: "Koji bi mogli biti glavni <span class='green-highlight'> utjecaji na ispitanike </span> ako se rizik pojavi?"
					},
					"2": {
						placeholder: "Unesite prijetnje +",
						title: "Koje su glavne <span class='green-highlight'> prijetnje </span> koje bi mogle dovesti do rizika?"
					},
					"3": {
						placeholder: "Upišite izvore rizika +",
						title: "Koji su izvori <span class='green-highlight'> rizika </span>?"
					},
					"4": {
						placeholder: "Kliknite ovdje za odabir kontrola koje odgovaraju na rizik.",
						title: "Koja od navedenih <span class='green-highlight'> kontrola </span> doprinosi odgovoru na rizik?"
					},
					"5": {
						placeholder: "Ovdje opravdajte procijenjenu ozbiljnost rizika.",
						title: "Kako procjenjujete <span class='green-highlight'> ozbiljnost rizika </span>, posebno u odnosu na potencijalne utjecaje i planirane kontrole?"
					},
					"6": {
						placeholder: "Ovdje opravdajte procijenjenu vjerojatnost.",
						title: "Kako procjenjujete <span class='green-highlight'> vjerojatnost rizika </span>, posebno u odnosu na prijetnje, izvore rizika i planirane kontrole?"
					}
				},
				short_help: "Analizirajte uzroke i posljedice gubitka podataka i procijenite njegovu ozbiljnost i vjerojatnost.",
				title: "Nestanak podataka"
			},
			"5": {
				short_help: "Ova vizualizacija omogućuje vam globalno i sintetičko gledanje na učinke kontrola na rizike na koje odgovaraju.",
				title: "Pregled rizika"
			}
		},
		short_help: "Ovaj odjeljak omogućuje vam procjenu rizika privatnosti, uzimajući u obzir postojeće ili planirane kontrole.",
		title: "Rizici"
	},
	"4": {
		items: {
			"1": {
				short_help: "Ova vizualizacija omogućuje usporedbu položaja rizika između njih međusobno, te prije i poslije primjene komplementarnih kontrola.",
				title: "Mapiranje rizika"
			},
			"2": {
				short_help: "Detaljno isplanirajte provedbu dodatnih kontrola utvrđenih tijekom PUP-a. Akcijski plan se automatski ažurira prilikom procjene različitih elemenata od kojih se PUP sastoji.",
				title: "Akcijski plan"
			},
			"3": {
				short_help: "Prikažite savjet osobe zadužene za zaštitu podataka i pitanja privatnosti (službenik za zaštitu podataka ako postoji). Prikažite stavove ispitanika ili njihovih predstavnika.",
				title: "SZP i mišljenja dotičnih osoba"
			},
			"4": {
				title: "Potvrdite PUP"
			},
			"5": {
				title: "Odbijeni PUP"
			}
		},
		short_help: "Ovaj odjeljak omogućuje Vam pripremu i formalizaciju potvrda za PUP.",
		title: "Potvrda"
	}
};
var settings$c = {
	content: "Molimo navedite adresu (URL) udaljenog poslužitelja:",
	title: "Postavke",
	update: "Ažuriraj URL"
};
var summary$c = {
	action_plan: {
		fundamental_principles: "Temeljna načela",
		implementation_date: "Očekivani datum provedbe",
		implementation_responsible: "Odgovoran za provedbu",
		measures: "Postojeće ili planirane mjere",
		no_action_plan: "Nije zabilježen akcijski plan.",
		risks: "Rizici",
		title: "Akcijski plan"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Prilozi",
	concerned_people_name: "Mišljenja dotičnih osoba",
	concerned_people_opinion: "Mišljenja dotičnih osoba",
	concerned_people_searched_opinion: "Traženje mišljenja dotičnih osoba",
	concerned_people_status: "Statusi dotičnih osoba",
	concerned_people_unsearched_opinion_comment: "Razlog zašto nije zatraženo mišljenje dotične osobe",
	content_choice: [
		"Tretman se ne smije koristiti.",
		"Tretman bi se mogao provesti."
	],
	creation_date: "Datum stvaranja",
	csv_action_plan_comment: "Komentar akcijskog plana",
	csv_evaluation_comment: "Komentar procjene",
	csv_file_title: "Akcijski plan",
	csv_implement_date: "Procijenjeni datum provedbe",
	csv_people_in_charge: "Odgovorna osoba",
	csv_section: "Odjeljak",
	csv_title_object: "Naslov",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Ime SZP-a",
	dpo_opinion: "Mišljenje SZP-a",
	dpo_status: "Status SZP-a",
	gauges: {
		"1": "Zanemariv",
		"2": "Ograničen",
		"3": "Važan",
		"4": "Maksimalan"
	},
	modification_made: "Izmjene napravljene",
	people_search_status_nok: "Nije zatraženo mišljenje dotične osobe.",
	people_search_status_ok: "Zatraženo je mišljenje dotične osobe.",
	pia_assessor: "Ime procjenitelja",
	pia_author: "Ime autora",
	pia_name: "PUP",
	pia_validator: "Ime potvrditelja",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Natrag na prethodnu stranicu",
	rejection_reason: "Razlog odbijanja",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Mapiranje rizika",
	risks_overview_title: "Pregled rizika",
	title: "Informacije o PUP-u"
};
var users$c = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$c = {
	add_signed_pia: "Dodaj potpisani PUP",
	after_reading: "Nakon čitanja cijelog PUP-a koji se odnosi na obradu podataka povezanih s",
	button: {
		rejection: "Odbij PUP",
		signed_validation: "Odobri PUP <br>(uz potpis)",
		simple_validation: "Odobri PUP <br>(izravno)"
	},
	confirmation1: "Potvrđujem da je kontekst obrade opisan u PUP-u u skladu sa stvarnosti.",
	confirmation2: "Potvrđujem da sam svjestan rizika, ovisno o postojećim ili planiranim mjerama.",
	confirmation3: "Potvrđujem korektivne radnje navedene u akcijskom planu.",
	confirmation4: "Obvezujem se što brže provesti navedene korektivne radnje.",
	latest_signed_attachment: "Zadnji potpisani privitak",
	mandatory_fields: "Sve kućice moraju biti označene",
	remove_attachment: "Ukloni privitak",
	responsible: "Osoba odgovorna za potvrđivanje PUP-a: ",
	signed_attachments_history: "Povijest potpisanih privitaka",
	tools: {
		dashboard: "Kontrolna ploča",
		display_pia: "Prikaži izvještaj"
	},
	validated_pia_with_signature: "Odobreno",
	waiting_for_signature: "Čeka se na potpis PUP-a"
};
var hr = {
	about: about$c,
	action_plan: action_plan$c,
	authentication: authentication$c,
	cartography: cartography$c,
	comments: comments$c,
	conflict: conflict$c,
	date: date$c,
	errors: errors$c,
	evaluations: evaluations$c,
	header: header$c,
	help: help$c,
	homepage: homepage$c,
	knowledge_base: knowledge_base$c,
	measures: measures$c,
	misc: misc$c,
	modals: modals$c,
	onboarding: onboarding$c,
	opinions: opinions$c,
	"overview-risks": {
	important: "Važan",
	limited: "Ograničen",
	maximal: "Maksimalan",
	measures: "Mjere",
	negligible: "Zanemariv",
	potential_impacts: "Potencijalni utjecaji",
	"risk-access_x": "Ozbiljnost",
	"risk-access_y": "Vjerojatnost",
	"risk-change_x": "Ozbiljnost",
	"risk-change_y": "Vjerojatnost",
	"risk-disappearance_x": "Ozbiljnost",
	"risk-disappearance_y": "Vjerojatnost",
	sources: "Izvori",
	threat: "Prijetnje"
},
	pia: pia$c,
	questions: questions$c,
	rejection_page: rejection_page$c,
	sections: sections$c,
	settings: settings$c,
	summary: summary$c,
	users: users$c,
	validation_page: validation_page$c
};

var about$b = {
	contribute: "Amennyiben hozzá szeretne járulni a szoftver más nyelvekre történő lefordításához, vagy a meglévő fordításokat szeretné fejleszteni, javasoljuk, <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">kövesse a megadott weboldalon található instrukciókat</a>.",
	description: "Ezt az eszközt a francia adatvédelmi hatóság (CNIL) <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a> fejlesztette ki, hogy segítse az adatkezelőket a GDPR alkalmazásában. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Ez a software ingyenesen és szabadon használható. Ha részt kíván venni a projektben, töltse le a forráskódot a Githubról, módosítsa, és ossza meg a közösségével.",
	licences: "Könyvtári engedélyek:",
	title: "Az DPIA-eszközről",
	translators: "Az DPIA-software jelenleg tizennyolc nyelven áll rendelkezésre. A francia és az angol változatot a CNIL készítette. A többi változat a következők közreműködésével készült:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Verziószám"
};
var action_plan$b = {
	acceptable_measures: "Elfogadható intézkedések",
	edit: "Szerkesztés",
	improvable_measures: "Korrekciós intézkedések",
	measures: "Tervezett vagy meglévő intézkedések",
	no_action_plan: "Nincs bejelentett intézkedés",
	placeholder_person_in_charge: "Végrehajtásért felelős",
	principles: "Alapelvek",
	risk1: "Adatokhoz való jogosulatlan hozzáférés",
	risk2: "Az adatok véletlen vagy jogellenes megváltoztatása",
	risk3: "Adatvesztés",
	risks: "Kockázatok",
	title: "Áttekintés"
};
var authentication$b = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "A francia adatvédelmi hatóság (CNIL) által kifejlesztett szoftver célja iránymutatást adni az adatkezelőknek a GDPR betartásához, valamint az annak rendelkezéseivel való összhang igazolásához.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Kezdés",
	start_app: "Hozzáférés a DPIA-software-hez (Beta)",
	subtitle1: "Adatvédelmi hatásvizsgálat létrehozására és kezelésére alkalmas felület",
	subtitle2: "Hozzáférés az eszköztárhoz és szószedetekhez",
	title: "Adatvédelmi hatásvizsgálat <br> Data Protection Impact Assessment (DPIA)",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$b = {
	important: "Jelentős",
	legend1: "Tervezett vagy meglévő intézkedések figyelembevételével",
	legend2: "A korrekciós intézkedéseket is tekintetbe véve",
	legend3: "(A)Adatokhoz való jogosulatlan hozzáférés",
	legend4: "(M)Az adatok véletlen vagy jogellenes megváltoztatása",
	legend5: "(D)Adatvesztés",
	likelihood_axe: "Kockázat valószínűsége",
	limited: "Korlátozott",
	maximal: "Maximális",
	negligible: "Elhanyagolható",
	risk1_access: "(A)",
	risk2_modification: "(M)",
	seriousness_axe: "Kockázat súlyossága"
};
var comments$b = {
	comment: "Megjegyzés",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "Megjegyzés(ek)",
	new_comment: "Megjegyzés",
	placeholder_new_comment: "Tegyen megjegyzést",
	send: "Küldés"
};
var conflict$b = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$b = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$b = {
	content: "Amennyiben más problémákkal találkozik, vagy a szoftver fejlesztésre irányuló javaslatai vannak, azt az alábbi űrlap visszaküldésével jelezheti:  <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Az oldal nem található."
};
var evaluations$b = {
	acceptable: "Elfogadható",
	action_plan_comment: "Intézkedési terv / korrekciós intézkedések",
	evaluation_comment: "Megjegyzés",
	gauges: {
		"0": "(n/a)",
		"1": "Elhanyagolható",
		"2": "Korlátozott",
		"3": "Jelentős",
		"4": "Maximális",
		likelihood: "Az intézkedési terv alapján hogyan értékeli át a <span class='red-highlight'>kockázat valószínűségét</span> (annak értékét)?",
		seriousness: "Az intézkedési terv alapján hogyan értékeli át a <span class='red-highlight'>kockázatot</span> (annak értékét)?"
	},
	improvable: "Korrekciós intézkedés bevezetése szükséges",
	placeholder_acceptable: "A rendelkezésre álló információ alapján a bevezetett intézkedések megfelelnek az adatvédelem követelményeinek.",
	placeholder_improvable1: "A rendelkezésre álló információ alapján további intézkedések szükségesek az adatvédelem javítása érdekében az adatkezelés során.",
	placeholder_improvable2: "Megjegyzés bevitele.",
	placeholder_to_correct: "A megadott információk nem alkalmasak az értékelés elvégzéséhez. Vissza kell küldeni a szerkesztőnek, hogy javítsa ki az eredeti kitöltést .",
	status: [
		"Elintézés alatt",
		"Javítandó",
		"Javítható",
		"Elfogadható"
	],
	title: "Véleményezés",
	to_correct: "Visszaküldés javításra"
};
var header$b = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "DPIA-példa",
		title: "Segítség"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Tudásbázis",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "A CNIL által biztosított fordítások",
		community_translations: "Nem hivatalos fordítások",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Az illetékes felügyeleti hatóság által felülvizsgált fordítás",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Hivatalos fordítások",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Adatvédelmi hatásvizsgálat",
	structures: "PIA templates",
	tools: {
		about: "Rólunk",
		accessibility: "Hozzáférés látássérülteknek (erős színkontraszt, daltonizmus)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Beállítások",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$b = {
	definition: {
		data1: {
			content: "Tartalom szerkesztés alatt",
			title: "Használja az DPIA eszközét"
		},
		data2: {
			qa1: {
				content: "Ha képernyőproblémák adódnak, zárja be az applikációt, és töltse be újra. Ez többnyire kijavítja a hibát. A bevitt adatokat nem veszíti el, a mentés automatikus gépelés közben.",
				title: "Képernyőproblémáim vannak, az ikonok beragadnak, elemek hiányoznak a csatlakozási felületről."
			},
			qa2: {
				content: "Ez az ismert probléma javítás alatt van. Ha jelentkezik, javasoljuk, töltse ki a súlyosság és/vagy valószínűség becsült szintjéhez tartozó mezőt. A hiba javítása után szerkesztheti a kijelzőt.",
				title: "Nem tudom szerkeszteni a kockázatsúlyosság és -valószínűség értékeinek kijelzőit."
			},
			qa3: {
				content: "Több hibát is megfigyeltek DPIA-importálás közben, különösen gyakran előfordulhat, hogy eltűnnek a súlyosságot és a valószínűséget értékelő szintkijelzők.",
				title: "Ez a probléma DPIA-importáláskor jelentkezik."
			},
			qa4: {
				content: "Ez csak kijelzőhiba, nem befolyásolja a mezőbe bevitt szöveget. Kiküszöbölésére hamarosan sor kerül.",
				title: "Másolás-beillesztés közben a szöveg kiemelődik."
			},
			qa5: {
				content: "Egy szakasz értékeléséhez valamennyi mezőt ki kell tölteni. Kérjük, ellenőrizze, hogy ez megtörtént-e. Kockázat szerkesztésekor legalább egy kockázatcsökkentő műszaki vagy szervezeti intézkedést meg kell adni a kockázat értékeléséhez.",
				title: "Nem tudom értékelni a szakaszt."
			},
			qa6: {
				content: "Kérjük, zárja be az DPIA-t, amit szerkeszt, és nyissa meg újra. Ekkor a tartalomnak a kiválasztott nyelven kell megjelennie.",
				title: "Nyelvváltáskor a szövegek fordítása nem jelenik meg."
			},
			qa7: {
				content: "A navigációs menü ikonjai egy DPIA elutasítása után pillanatnyilag nem frissülnek. Ellenőrizzen minden egyes szakaszt, változtassa meg az információt és/vagy értékelést az DPIA elutasítása okainak megfelelően. Az összes szakasz áttekintését követően újra lehetővé válik a DPIA jóváhagyása.",
				title: "Nem hagytam jóvá egy DPIA-t, de nem tudom, mi a további teendőm."
			},
			title: "Az ismert problémák"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Segítség"
};
var homepage$b = {
	cards: {
		author: "Szerkesztés",
		category: "TO TRANSLATE - Category",
		creation_status: "Létrehozás",
		date: "Dátum",
		evaluation: "Véleményezés",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "DPIA importálása",
		import_structure: "TO TRANSLATE - Import template",
		item: {
			consult_pia: "Áttekintése",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Szerkesztése",
			edit_structure: "TO TRANSLATE - Edit template",
			tools: {
				action_plan: "Intézkedési terv megmutatása",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Másolat készítése",
				"export": "Exportálás",
				more_options: "További lehetőségek",
				pia: "DPIA megmutatása",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Új DPIA",
		new_structure: "TO TRANSLATE - New template",
		or: "Vagy",
		pia_name: "DPIA",
		placeholder_author: "Vezetéknév, utónév",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Vezetéknév, utónév",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "DPIA importálása",
		placeholder_import_structure: "TO TRANSLATE - Import template",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Új DPIA",
		placeholder_new_structure: "TO TRANSLATE - New template",
		placeholder_pia_name: "DPIA címe",
		placeholder_sector_name: "TO TRANSLATE - Associated sector's name",
		placeholder_start: "Minden mezőt ki kell tölteni",
		placeholder_structure: "TO TRANSLATE - Default template",
		placeholder_structure_name: "TO TRANSLATE - Template's title",
		placeholder_validation: "Vezetéknév, utónév",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		start: "Start",
		status: "Állapot",
		structure: "TO TRANSLATE - Template",
		structure_name: "TO TRANSLATE - Template's name",
		title_close_creation: "Bezárás",
		validation: "Jóváhagyás"
	},
	filters: {
		assessor: "Véleményező",
		author: "Szerző",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Kezdjen hozzá! Kattintson az Új DPIA-ra az DPIA elindításához",
		card_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous !<br><br>Pour commencer<br>un modèle, cliquez<br> sur le +",
		category: "TO TRANSLATE - Category",
		date: "Dátum",
		import_pia: "DPIA importálása",
		import_structure: "TO BE TRANSLATED - Importer modèle",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Kezdjen hozzá! Kattintson a + jelre az DPIA elindításához",
		list_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous ! Pour commencer<br>un modèle, cliquez sur le +",
		name: "Név",
		new_pia: "Új DPIA",
		new_structure: "TO BE TRANSLATED - Nouveau modèle",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		sort: "Válogatás",
		sort_by: "Válogatás valami szerint",
		status: "Státusz",
		validator: "Jóváhagyó"
	},
	lists: {
		column_actions: "Műveletek",
		column_author: "Szerkesztő neve",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Létrehozás",
		column_evaluation: "Véleményező neve",
		column_pia: "DPIA",
		column_progression: "Előrehaladás",
		column_sector_name: "TO TRANSLATE - Associated sector",
		column_status: "Állapot",
		column_structure: "TO TRANSLATE - Template",
		column_structure_name: "TO TRANSLATE - Template",
		column_updated_at: "Legutóbb megnyitott hatásvizsgálat",
		column_validation: "Jóváhagyó neve",
		item: {
			tools: {
				action_plan: "Intézkedési terv megmutatása",
				archive: "TO TRANSLATE - Archive",
				consult: "Konzultáció",
				duplicate: "Másolat készítése",
				edit: "Szerkesztés",
				"export": "Exportálás",
				pia: "DPIA megmutatása",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$b = {
	add_measure: "Hozzáadás",
	add_measure_hint: "A tudásbázisból kiválasztott intézkedést is hozzáádhat.",
	category: {
		definition: "Mit jelent?",
		example: "Példa",
		general_measure: "Fizikai biztonságvédelem",
		measure_on_data: "Logikai biztonságvédelem",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Szervezeti védelmi intézkedések",
		principle: "Útmutatás"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Mind",
		definitions: "Mit jelent?",
		general_measures: "Fizikai védelmi intézkedések",
		measures_on_data: "Logikai védelmi intézkedések",
		no_result: "Nincs találat.",
		organizational_measures: "Adminisztratív védelmi intézkedések",
		title: "Szűrők"
	},
	placeholder_add_measure: "Az intézkedés hozzáadása",
	placeholder_help: "Segítség bevitele",
	search: "Keresés",
	slugs: {
		PIA_DEF_ACC: {
			description: "Az érintett jogosult arra, hogy az adatkezelőtől visszajelzést kapjon arra vonatkozóan, hogy személyes adatainak kezelése folyamatban van-e, és ha ilyen adatkezelés folyamatban van, jogosult arra, hogy a személyes adatokhoz és a GDPR 15. cikkében megállapított információkhoz hozzáférést kapjon. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\">GDPR 15. cikkét</a>.",
			name: "Hozzáférési jog",
			source: "A GDPR 15. cikke"
		},
		PIA_DEF_ANO: {
			description: "Anonimizálás olyan technika, amelyet a személyes adatok személyazonosításra való alkalmatlanná tétele céljából alkalmaznak, lásd: <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 iránymutatások</a>.",
			name: "Anonimizálás",
			source: "Intézkedések és a 29-es munkacsoport iránymutatása http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "A személyes adatokat tartalmazó elektronikus archívumok megőrzését és kezelését, azok minőségét (főként jogi minőségét) az egész érintett időszakban biztosító eljárások (továbbítás, tárolás, áthelyezhetőség, hozzáférhetőség, eltávolítás, archiválási elvek, bizalmas kezelés védelme stb.).",
			name: "Archiválás",
			source: "Intézkedések archiválás"
		},
		PIA_DEF_AUTH: {
			description: "Minden olyan személynek, aki jogszerűen hozzáférhet személyes adatokhoz (alkalmazottak, szerződő és egyéb harmadik felek), egyedi azonosítóval kell rendelkeznie. Olyan hitelesítési (beléptetési) módszert kell kiválasztani egy munkamenet elindításához, amely megfelel a körülményeknek, a kockázati szintnek és a veszélyek várható erejének. Ajánlások: ha a kockázat nem nagy, a jelszó használható; ha viszont magasabb a kockázati szint, egyszeri jelszavas jogosultságot kell használni, és meg kell változtatni az alapértelmezett aktiválási jelszót, ha pedig SMS-ben megy ki a jelszó egyik része, PIN-kódos kártyát, elektronikus igazolást vagy egyéb erős hitelesítő eljárást kell alkalmazni.",
			name: "Hitelesítés",
			source: "Intézkedések - Logikai hozzáférésvédelem"
		},
		PIA_DEF_CHIF: {
			description: "Személyes adatokat az illetéktelenek számára felismerhetetlenné tevő intézkedés (szimmetrikus vagy aszimmetrikus titkosítás, a köztudottan erős, nyilvános algoritmusok, hitelesítő tanúsítványok stb. használata).",
			name: "Titkosítás",
			source: "Titkosítás intézkedések"
		},
		PIA_DEF_CLO: {
			description: "Amennyiben a különböző adatokat elválasztva kezelik, csökkenhet annak az esélye, hogy a személyes adatok egymással összefüggésbe hozhatók legyenek egy esetleges adatvédelmi incidens bekövetkezése esetén.",
			name: "Az adatok különválasztása",
			source: "DPIA3, 19. o. - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Az érintett akaratának önkéntes, konkrét és megfelelő tájékoztatáson alapuló és egyértelmű kinyilvánítása, amellyel az érintett nyilatkozat vagy a megerősítést félreérthetetlenül kifejező cselekedet útján jelzi, hogy beleegyezését adja az őt érintő személyes adatok kezeléséhez. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\">GDPR 4. cikkének 11. pontját</a>.",
			name: "Hozzájárulás",
			source: "A GDPR 4. cikkének 11. pontja "
		},
		PIA_DEF_CTLA: {
			description: "Olyan kockázatcsökkentő eszközök, amelyek meggátolják az illetéktelenek személyes adatokhoz való hozzáférését, és amelyek egyebek közt a következőket feltételezik: a felhasználói profilok kezelése a feladatok és felelősségi körök elválasztásával (lehetőség szerint központosítottan) azért, hogy csak az illetékes felhasználók – a szükséges ismeret és legkisebb jogosultság elveinek betartásával – férhessenek hozzá a személyes adatokhoz; továbbá a munkavállalók, a szerződő és a harmadik felek jogosultságainak megvonása, ha azok már nem jogosultak hozzáférni a hivatali eszközökhöz, illetve ha már lejárt a munkaszerződésük.",
			name: "Logikai hozzáférésvédelem",
			source: "DPIA3, 43. o. - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Azonosított vagy azonosítható természetes személyre („érintett”) vonatkozó bármely információ; azonosítható az a természetes személy, aki közvetlen vagy közvetett módon, különösen valamely azonosító, például név, szám, helymeghatározó adat, online azonosító vagy a természetes személy testi, fiziológiai, genetikai, szellemi, gazdasági, kulturális vagy szociális azonosságára vonatkozó egy vagy több tényező alapján azonosítható. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 4. cikkének 1. pontját</a>",
			name: "Személyes adat",
			source: "A GDPR 4. cikkének 1. pontja"
		},
		PIA_DEF_DEST: {
			description: "Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, akivel vagy amellyel a személyes adatot közlik, függetlenül attól, hogy harmadik fél-e. Azon közhatalmi szervek, amelyek egy egyedi vizsgálat keretében az uniós vagy a tagállami joggal összhangban férhetnek hozzá személyes adatokhoz, nem minősülnek címzettnek; az említett adatok e közhatalmi szervek általi kezelése meg kell, hogy feleljen az adatkezelés céljainak megfelelően az alkalmazandó adatvédelmi szabályoknak. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 4. cikkének 9. pontját </a>",
			name: "Címzett",
			source: "A GDPR 4. cikkének 9. pontja"
		},
		PIA_DEF_EFF: {
			description: " Az érintett jogosult arra, hogy kérésére az adatkezelő indokolatlan késedelem nélkül törölje a rá vonatkozó személyes adatokat, az adatkezelő pedig köteles arra, hogy az érintettre vonatkozó személyes adatokat indokolatlan késedelem nélkül törölje. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\">GDPR 17. cikkét</a>.",
			name: "A törléshez való jog",
			source: "A GDPR 17. cikke "
		},
		PIA_DEF_ENJ: {
			description: "Várható előnyök (a szervezet, az érintettek és általában a társadalom stb. számára).",
			name: "Érdekek",
			source: "DPIA1, 4. o."
		},
		PIA_DEF_EXA: {
			description: "A személyes adatoknak pontosnak és szükség esetén naprakésznek kell lenniük; minden észszerű intézkedést meg kell tenni annak érdekében, hogy az adatkezelés céljai szempontjából pontatlan személyes adatokat haladéktalanul töröljék vagy helyesbítsék („pontosság”)<br> Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 5. cikk (1) bekezdésének d.) pontját. </a>",
			name: "Adatminőség",
			source: "a GDPR 5. cikke (1) bekezdésének d) pontja"
		},
		PIA_DEF_GRV: {
			description: "A súlyosság jelöli a kockázat mértékét. Elsősorban a lehetséges behatások ártalmas jellegén múlik.",
			name: "Súlyosság",
			source: "DPIA1, 6. o."
		},
		PIA_DEF_LIM: {
			description: "Az érintett jogosult arra, hogy kérésére az adatkezelő korlátozza az adatkezelést, lásd <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\">GDPR 18. cikkét</a>.",
			name: "Az adatkezelés korlátozásához való jog",
			source: "A GDPR 18. cikke"
		},
		PIA_DEF_LOG: {
			description: "Alakítson ki naplózó rendszert, amely lehetővé teszi az adatvédelmi incidensek korai észlelését, illetve olyan információk gyűjtését, amelyek alapján elemzéseket lehet végezni, illetve amelyek bizonyítékul szolgálhatnak.",
			name: "Nyomon követés",
			source: "Intézkedés megfigyelés"
		},
		PIA_DEF_MEN: {
			description: "Egy vagy több cselekvésből álló eljárás az adatok kezelésére szolgáló eszközökön, mely megvalósulhat szándékosan vagy más módon.",
			name: "Fenyegető veszély",
			source: "DPIA1, 12. o. - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Veszélyek: hardware nem rendeltetésszerű használata, megfigyelése, módosítása, elvesztése (érzékeny hardware személyes célokra való használata vagy szállítása, megfigyelés hardware alapú billentyűleütés-naplózóval stb.); software nem rendeltetésszerű használata, megfigyelése, módosítása (jogosultságbővítés, konfigurációs adatok gyűjtése, fertőzés rosszindulatú kód által stb.); számítógépes csatornák megfigyelése (Ethernet-adatáramlás kiszűrése); személyek megfigyelése, manipulálása, elvesztése (akaratlan információközlés, lélektani manipuláció, feladatkiosztás megváltoztatása); papír alapú dokumentumok megfigyelése, elvesztése (olvasása, postai levelek ellopása stb.); papír alapú dokumentumok továbbítási csatornáinak megfigyelése (köröztetett iratátvételi könyvek elolvasása stb.).",
			name: "Az illetéktelen hozzáférés veszélyei",
			source: "DPIAF Összekapcsolt tárgyak, 44. és 45. o."
		},
		PIA_DEF_MENI: {
			description: "A következő veszélyek: hardware nem rendeltetésszerű használata, túlterhelése, megváltoztatása, sérülése, elvesztése (a tárolóegység telítődése, az adatkezelő kapacitás túlterhelése, inkompatibilis hardware-rel való, meghibásodást okozó kiegészítés, tűz, valamely eszköz eltulajdonítása vagy elvesztése stb.); software nem rendeltetésszerű használata, túlterhelése, módosítása, károsítása, elvesztése (adattörlés, adatbázis méretének meghaladása, logikai bomba, az adatokhoz való hozzáféréshez használt software engedélyének meg nem újítása; számítógépes csatornák túlterhelése, módosítása, elvesztése (engedély nélküli letöltés, internetkapcsolat elvesztése stb.); személyek túlterhelése, sérülése, elvesztése (készségek meg nem felelő használata, betegség, nyugdíjba vonulás stb.); papír alapú dokumentumok nem rendeltetésszerű használata, sérülése, elvesztése (törlés, archivált dokumentumok kopása, dokumentumok lopása és elvesztése stb.); papír alapú dokumentumok továbbítási csatornáinak túlterhelése, sérülése, módosítása, elvesztése (kézbesítés késlekedése sztrájk miatt, iroda vagy hivatali épület cseréje, postai szolgáltató elvesztése, papír alapú dokumentumok továbbítási csatornáinak átszervezése stb.).",
			name: "Személyes adatok eltünésével fenyegető veszélyek",
			source: "DPIAF Összekapcsolt tárgyak, 44. és 45. o., WIKI"
		},
		PIA_DEF_MENM: {
			description: "Veszélyek: hardware módosítása (inkompatibilis hardware telepítése, ami meghibásodást idéz elő; lényegi elemek eltávolítása stb.); software nem rendeltetésszerű használata vagy módosítása (adatbázisok akaratlan módosítása, kezelő adatmódosítást eredményező hibái stb.",
			name: "Az adatok véletlen vagy jogellenes megváltoztatásának veszélyei",
			source: "DPIAF Összekapcsolt tárgyak, 43. és 44. o. WIKI"
		},
		PIA_DEF_MES: {
			description: "Válasszon a „Tervezett vagy meglévő intézkedések” c. rész lehetőségei közül, amelyeket, ha szükséges, kitölthet.",
			name: "Intézkedések",
			source: "Nincs"
		},
		PIA_DEF_MIN1: {
			description: "Adatimportálás esetén a gyűjtés akaratlanul is kiterjedhet különböző metaadatokra (pl. EXIF-adatok képállomány-melléklettel). Az ilyen metaadatokat azonosítani kell, és el kell távolítani, ha nem szükségesek a meghatározott célokra.",
			name: "Szűrés és eltávolítás",
			source: "DPIAF Összekapcsolt tárgyak, 42. o. - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Amennyiben érzékeny adatok birtokába jutnak, ezek átalakíthatók kevésbé érzékeny adatokká, illetve álnevesíthetők. Ha például a rendszer IP-cím alapján állapítja meg a használó tartózkodási helyét, az IP-cím törölhető a város vagy kerület azonosítása után; ha a rendszer videóadatokat kap megfigyelő kameráktól, azonosíthatja és elhomályosíthatja az álló vagy mozgó személyeket; ha okos fogyasztásmérőről van szó, az összesítheti az adott időszak energiahasználatát anélkül, hogy valósidőben rögzítené.",
			name: "Személyes adatok érzékenységének csökkentése átalakítással",
			source: "DPIAF, Összekapcsolt tárgyak, 42. o. - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "A rendszer biztosítani tudja a következőket: a felhasználó igénybe vehet valamely eszközt vagy szolgáltatást anélkül, hogy vállalná a személyazonossága közlésével járó kockázatot (anonim adatok), de azonosítható marad, és felelősséget vállal a használatért (álnevesített adat); a felhasználó többször is igénybe veheti az eszközöket vagy szolgáltatásokat anélkül, hogy a különböző használatok összekapcsolódnának (az adatokat nem lehet összekapcsolni); a felhasználó igénybe vehet valamely eszközt vagy szolgáltatást anélkül, hogy mások, különösen harmadik felek megfigyelhetnék az eszköz vagy szolgáltatás használatát (megfigyelhetetlenség). A fenti listából az azonosított veszélyek alapján kell a módszert kiválasztani. A személyes adatok bizonyos veszélyek esetén az álnevesítés alkalmasabb, mint az anonimizálás (ha például szükség van nyomon követésre). Ezen túlmenően a magánszférára vonatkozó kockázatokat több módszer együttes alkalmazásával kell kezelni.",
			name: "Az adatok személyazonosításra alkalmas jellegének csökkentése",
			source: "DPIAF Összekapcsolt tárgyak, 42. o. - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "A rendszer egymástól független részekre osztható, melyek mindegyike külön hozzáférés-védelmi funkcióval rendelkezik. Az adatok szintén eloszthatók a független alrendszerek között, és az egyes alrendszerek külön, különböző hozzáférés-védelmi mechanizmusokat használnak. Ha valamelyik alrendszer sérül, akkor az incidens hatása korlátok közé szorítható.",
			name: "Az adatfelhalmozás korlátozása",
			source: "DPIAF Összekapcsolt tárgyak, 42. o. - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "A rendszer korlátozhatja az adatokhoz való hozzáférést a szükséges ismeret elve alapján. A rendszer el tudja különíteni az érzékeny adatokat, és meghatározott hozzáférés-védelmi eljárásokat alkalmaz. A rendszer képes továbbá titkosítani az érzékeny adatokat, bizalmasan kezeli azokat továbbítás és tárolás során. Az adatkezelés során keletkező sütikhez való hozzáférést szintén védeni kell.",
			name: "Az adatokhoz való hozzáférés korlátozása",
			source: "DPIAF Összekapcsolt tárgyak, 42. o. - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Csökkentse a kockázatok súlyosságát azáltal, hogy a kezelt személyes adatok körét azon adatokra szűkíti, amelyek feltétlenül szükségesek az adatkezelés céljai szempontjából (ezen túlmenően nem szabad gyűjteni azokat).",
			name: "Adatminimalizálás",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "A kockázatok súlyosságának csökkentése az adatok minimalizálása által (az adatok érzékenységének csökkentése például azok szűrésével, az adatkezelés célja szempontjából szükséges adatokon túlmenő adatok eltávolítása, álnevesítés stb.).",
			name: "Adatminimalizálás",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Az érintett jogosult arra, hogy a saját helyzetével kapcsolatos okokból bármikor tiltakozzon személyes adatainak a kezelése ellen <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\">GDPR 21. cikkét</a>.",
			name: "A tiltakozáshoz való jog",
			source: "a GDPR 21. cikke szerint"
		},
		PIA_DEF_PBDS: {
			description: "Az egyes újonnan bevezetett adatkezelési műveletek esetán a személyes adatok védelmét integráló intézkedések  (megbízható nevek, iránymutatások, módszertanok).",
			name: "Projektmenedzsment",
			source: "Intézkedések "
		},
		PIA_DEF_PC: {
			description: "Azon személyek, akikre a kezelt adatok vonatkoznak.",
			name: "Érintettek",
			source: "DPIA, 9. o."
		},
		PIA_DEF_PORT: {
			description: " Az érintett jogosult arra, hogy a rá vonatkozó, általa egy adatkezelő rendelkezésére bocsátott személyes adatokat tagolt, széles körben használt, géppel olvasható formátumban megkapja, továbbá jogosult arra, hogy ezeket az adatokat egy másik adatkezelőnek továbbítsa anélkül, hogy ezt akadályozná az az adatkezelő, amelynek a személyes adatokat a rendelkezésére bocsátotta. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\">GDPR 20. cikkét</a>.",
			name: "Adathordozhatósághoz való jog",
			source: "A GDPR 20. cikke"
		},
		PIA_DEF_PSEU: {
			description: "A személyes adatok olyan módon történő kezelése, amelynek következtében további információk felhasználása nélkül többé már nem állapítható meg, hogy a személyes adat mely konkrét természetes személyre vonatkozik. Ennek feltétele, hogy az ilyen további információt külön tárolják, és technikai és szervezési intézkedések megtételével biztosított, hogy azonosított vagy azonosítható természetes személyekhez ezt a személyes adatot nem lehet kapcsolni.",
			name: "Álnevesítés",
			source: "A GDPR 4. cikkének 5. pontja, illetve a 29-es munkacsoport iránymutatása 22. o. http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "A jelszónak legalább nyolc karakterből kell állnia, újat kell megadni a veszély legcsekélyebb gyanúja esetén, illetve lehetőleg rendszeresen (félévente vagy évente); a négy karaktertípusból legalább hármat kell tartalmaznia (kis- és nagybetű, szám és egyéb jel); jelszó cseréjekor az utolsó öt nem használható újra; ugyanaz a jelszó nem használható más hozzáférés esetén; a jelszó ne kapcsolódjon személyes adatokhoz (beleértve a nevet vagy a születési időt). Meg kell határozni a belépési kísérletek maximális számát, amelynek elérése után figyelmeztetést kell küldeni, és a belépést megtagadni.",
			name: "Jelszó",
			source: "Intézkedés "
		},
		PIA_DEF_RECT: {
			description: "Az érintett jogosult arra, hogy kérésére az adatkezelő indokolatlan késedelem nélkül helyesbítse a rá vonatkozó pontatlan személyes adatokat. Figyelembe véve az adatkezelés célját, az érintett jogosult arra, hogy kérje a hiányos személyes adatok – egyebek mellett kiegészítő nyilatkozat útján történő – kiegészítését.",
			name: "A helyesbítéshez való jog",
			source: "A GDPR 16. cikke "
		},
		PIA_DEF_RGPD: {
			description: "A természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről szóló rendelet.",
			name: "Általános adatvédelmi rendelet (GDPR)",
			source: "A GDPR címe"
		},
		PIA_DEF_RT: {
			description: "Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely a személyes adatok kezelésének céljait és eszközeit önállóan vagy másokkal együtt meghatározza; ha az adatkezelés céljait és eszközeit az uniós vagy a tagállami jog határozza meg, az adatkezelőt vagy az adatkezelő kijelölésére vonatkozó különös szempontokat az uniós vagy a tagállami jog is meghatározhatja. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 4. cikkének 7. pontját</a>",
			name: "Adatkezelő",
			source: "A GDPR 4. cikkének 7. pontja"
		},
		PIA_DEF_SRC: {
			description: "Kockázatot okozó személy vagy egyéb forrás, mely lehet véletlenül vagy szándékosan előidézett kockázatforrás.",
			name: "Kockázatforrás",
			source: "DPIA1, 11. o. - WIKI"
		},
		PIA_DEF_ST: {
			description: "Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely az adatkezelő nevében személyes adatokat kezel, lásd: a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 4. cikkének 8. pontját </a>.<br>Az adatfeldolgozó és bármely, az adatkezelő vagy az adatfeldolgozó irányítása alatt eljáró, a személyes adatokhoz hozzáféréssel rendelkező személy ezeket az adatokat kizárólag az adatkezelő utasításának megfelelően kezelheti, kivéve, ha az ettől való eltérésre őt uniós vagy tagállami jog kötelezi. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 29. cikkét </a>.",
			name: "Adatfeldolgozó",
			source: "A GDPR 4. cikkének (8) bekezdésese és 29. cikke"
		},
		PIA_DEF_SUPT: {
			description: "A személyes adatok kezelésére szolgáló eszközök. Lehet hardware, software, hálózat, személy, irat vagy papír alapú iratokat továbbító csatorna.",
			name: "Az adatok kezelésére szolgáló eszközök",
			source: "DPIA1, 10. o. "
		},
		PIA_DEF_VIOL: {
			description: "A biztonság olyan sérülése, amely a továbbított, tárolt vagy más módon kezelt személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését, megváltoztatását, jogosulatlan közlését vagy az azokhoz való jogosulatlan hozzáférést eredményezi.",
			name: "Adatvédelmi incidens",
			source: "A GDPR 4. cikkének 12. pontja"
		},
		PIA_DEF_VRA: {
			description: "A valószínűség a kockázat bekövetkezésének a lehetőségét jelöli. Elsősorban a veszélynek kitett eszközök sérülékenységén és a kockázatforrások mértékén múlik.",
			name: "Valószínűség",
			source: "DPIA1, 6. o."
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "Személyazonosító adatok: családi állapot, személyazonosság, életkor stb.; Személyes élet: szokások, családi állapot stb.; Szakmai élet: életrajz, iskolai végzettség, szakmai képzettség, díjak stb.; Kapcsolattartási adatok: IP-címek, naplóbejegyzések; Tartózkodási adatok: utak, GPS-adatok, GSM-adatok; Egyebek: telefonszám, e-mailcím stb.",
			name: "Általános személyes adatok",
			source: "DPIA2, korábbi változat - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Politikai, világnézeti, vallási és szakszervezetekkel kapcsolatos vélemény, nemi élet, egészségügyi adat, illetve etnikai vagy faji származásra, egészségi állapotra vagy szexuális életre, büntetőjogi felelősség megállapítására, illetve bűncselekményekre vagy ezekhez kapcsolódó biztonsági intézkedésekre vonatkozó adat. Lásd: <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Meggyőződések és érzékeny személyes adatok"
		},
		PIA_EX_DCPS: {
			description: "Társadalombiztosítási szám, biometrikus adatok, banki adatok",
			name: "Érzékenynek vélt személyes adatok"
		},
		PIA_EX_HUME: {
			description: "Ezen kockázatforrásra példaként szolgálhatnak a következők: tisztességtelen vagy naiv szomszéd, aki a fizikai közelség miatt meghekkeli az eszköz adatait; a hekker azért szemeli ki a felhasználót, mert vannak háttérinformáiói a kiszemelt felhasználóval kapcsolatban; a hekker azért szemel ki egy vállalatot, mert olyan ismeret birtokában van, amellyel alááshatja annak jóhírnevét stb.",
			name: "Szervezeten kívüli emberi tényezők"
		},
		PIA_EX_HUMI: {
			description: "Ezen kockázatforrásra példaként szolgálhatnak a következők: hanyag vagy tisztességtelen munkavállaló; képzetlenség és tájékozatlanság; hanyag vagy tisztességtelen felhasználó, családtag vagy barát, aki hozzáfér a rendszerhez. Több indíték is lehetséges: ilyenek lehetnek pélául ügyetlenség, hiba, hanyagság, játék, rosszindulat, bosszú, kémkedés.",
			name: "Szervezeten belüli emberi tényezők"
		},
		PIA_EX_IMPI: {
			description: "Az érintettek komoly következményekkel szembesülhetnek, amelyeken ugyan túlteszik magukat, de jelentős és valós nehézségek árán. Ilyenek például a testi következmény: komoly betegségek hosszú távú következményekkel (egészségromlás szakszerűtlen gondozás vagy az ellenjavallatok be nem tartása miatt), a testi épség megváltozása például erőszak, otthoni vagy munkahelyi baleset folytán; anyagi következmény: pénz hűtlen kezelése kártalanítás nélkül, tervezett, egyedi és meg nem ismételhető lehetőségek elvesztése (lakáshitel, tanulmányi, gyakornoki vagy munkahelyi felvétel elutasítása, eltiltás vizsgázástól), lakás vagy állás elvesztése stb.; komoly pszichológia betegség (depresszió, fóbia kialakulása), a magánszféra megsértésének érzése maradandó sérelemmel, zsarolás, kibermegfélemlítés és zaklatás áldozatává válás stb.",
			name: "Jelentős kihatás/következmények"
		},
		PIA_EX_IMPL: {
			description: "Az érintettek jelentős kellemetlenségeket tapasztalhatnak, de néhány nehézség ellenére túlteszik magukat rajtuk. Például: testi kellemetlenség (enyhe betegség az ellenjavallatok be nem tartása miatt); becsületsértés, amely fizikai vagy pszichológiai megtorláshoz vezet stb.; anyagi kellemetlenségek: váratlan költségek (tévesen kiszabott bírságok), közigazgatási vagy kereskedelmi szolgáltatások igénybevételétől való eltiltás; kéretlen üzenetek érkezése, ami árt az érintettek jóhírnevének; erkölcsi kellemetlenségek: kisebb, de objektív pszichés betegség, a magánszféra megsértésének érzése visszafordíthatatlan sérelem nélkül, megalázás közösségi hálókon stb.",
			name: "Korlátozott kihatás/következmények"
		},
		PIA_EX_IMPM: {
			description: "Az érintettek komoly, akár maradandó következményekkel is szembesülhetnek, melyeken nem tudják túltenni magukat. Ilyen például: az egészségkárosodás: hosszú távú vagy állandó testi betegség, a testi épség maradandó károsodása, halál; anyagi következmény: pénzügyi kockázat, adósság, munkaképtelenség, áthelyezkedésre való képtelenség, bizonyítékvesztés peres eljárásban, létfontosságú közművektől való elzárás stb.; erkölcsi következmény: hosszú távú vagy állandó pszichológiai betegség, büntetőjogi szankció, emberrablás áldozatává válás, családi kötelékek elvesztése, jogállás megváltozása és/vagy jogi önállóság elvesztése (gyámság) stb.",
			name: "Maximális kihatás/következmények"
		},
		PIA_EX_IMPN: {
			description: "Az érintettek nem szenvednek kárt, vagy néhány kellemetlenséget kell csupán elviselniük, amelyen könnyen túlteszik magukat. Ilyenek például: fizikai/testi következmény: átmeneti fejfájás; anyagi következmény: időveszteség a formaságok ismétlése vagy teljesítése miatt, kéretlen levelek (pl. spamek) érkezése, weboldalakon közölt adatok újbóli felhasználása célzott reklámok küldése céljából stb.; erkölcsi következmények: egyszerű bosszúság, magánszférába való beavatkozás érzése valóságos vagy objektív sérelem nélkül stb.",
			name: "Elhanyagolható következmények "
		},
		PIA_EX_NHUM: {
			description: "Ezen kockázatforrásra példaként szolgálhat valamely szervezetet sújtó incidens vagy káresemény (áramszünet, tűz, árvíz stb.)",
			name: "Nem emberi tényezők"
		},
		PIA_EX_VRAI: {
			description: "Valószínű, hogy a kockázatforrások a személyes adatok kezelésére szolgáló eszközöket kihasználó valós veszélyt jelentenek (pl. papír alapú iratok eltulajdonítása olyan helyiségből, amelybe csak a recepciónál való bejelentkezés után lehet belépni).",
			name: "Nagy valószínűség"
		},
		PIA_EX_VRAL: {
			description: "Kicsi a valószínűsége annak, hogy a kockázatforrások a személyes adatok kezelésére szolgáló eszközöket kihasználó valós veszélyt jelentenének (pl. papír alapú iratok eltulajdonítása belépőkártyával és belépési kóddal védett helyiségből).",
			name: "Korlátozott valószínűség"
		},
		PIA_EX_VRAM: {
			description: "A kockázatforrások könnyen jelentenek a személyes adatok kezelésére szolgáló eszközöket kihasználó valós veszélyt (pl. papír alapú iratok eltulajdonítása nyilvános előtérből).",
			name: "Maximális valószínűség"
		},
		PIA_EX_VRAN: {
			description: "Nem látszik valószínűnek, hogy a kockázatforrások a személyes adatok kezelésére szolgáló eszközöket kihasználó valós veszélyt jelentenének (pl. papír alapú iratok eltulajdonítása belépőkártyával és belépési kóddal védett helyiségből).",
			name: "Csekély valószínűség"
		},
		PIA_LGL_CONS: {
			description: "Biztosítsa, hogy az érintettek önkéntesen, kifejezetten és tájékozott módon döntsenek. Állapítsa meg, hogy az adatkezelésnek van-e olyan jogalapja, amely eltér a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR  6. cikke szerinti </a> hozzájárulástól.",
			name: "Hozzájárulás",
			source: "GPIA3, 11. o. - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Részletesen határozza meg és mutassa be: <br> – az érintett személyes adatokat, a címzettjeiket és a tárolásuk időtartamát <br> – az adatkezelést és a személyes adatok kezelésére szolgáló eszközöket a személyes adatok kezelésének egész folyamata során (a gyűjtéstől a törlésig).",
			name: "Adatok és adatkezelési folyamatok",
			source: "DPIA1 6. o."
		},
		PIA_LGL_DESC: {
			description: "Mutassa be röviden a tervezett adatkezelést, az adatkezelés célját, jogalapját, a kezelt személyes adatok körét, valamint az adatkezelés egyéb jellemzőit. Azonosítsa az adatkezelőt, továbbá - igénybevételük esetén - az adatfeldolgozó(ka)t. Sorolja fel az adatkezelésre vonatkozó alapvető, szükséges vagy betartandó előírásokat, beleértve a jóváhagyott magatartási kódexeket is (lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR  40. cikkét </a>), illetve az adatvédelmi tanúsítványokat (lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 42. cikkét </a>).",
			name: "Az adatkezelés leírása",
			source: "DPIA1 4. o."
		},
		PIA_LGL_DEST: {
			description: "Az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, akivel vagy amellyel a személyes adatot közlik, függetlenül attól, hogy harmadik fél-e. Azon közhatalmi szervek, amelyek egy egyedi vizsgálat keretében az uniós vagy a tagállami joggal összhangban férhetnek hozzá személyes adatokhoz, nem minősülnek címzettnek; az említett adatok e közhatalmi szervek általi kezelése meg kell, hogy feleljen az adatkezelés céljainak megfelelően az alkalmazandó adatvédelmi szabályoknak. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\"> GDPR 4. cikkének 9. pontját </a>.",
			name: "Címzett",
			source: "4.9 cikk GDPR"
		},
		PIA_LGL_DUR: {
			description: "Az adatkezelés tárgyát képező személyes adatok minden típusa esetén meg kell határozni az adatmegőrzés időtartamát, és azt törvényes követelmények és/vagy adatkezelési szükségletek szerint kell igazolni. Meg kell különböztetni ezért az általános és az archivált adatokat, amely utóbbiakhoz csak az érintett felek férhetnek hozzá. Olyan törlési mechanizmust kell kialakítani, amely archiválja az általános adatokat, illetve a tárolás időtartamának lejártával megszűri az archiváltakat. A logikai- és naplóbejegyzésekből is törölni kell a személyes adatokat.",
			name: "Adatmegőrzési határidő",
			source: "PIAF Összekapcsolt tárgyak, 12. o."
		},
		PIA_LGL_FIN: {
			description: "A személyes adatok gyűjtése csak meghatározott, egyértelmű és jogszerű célból történhet, és azokat ne kezeljék ezekkel a célokkal össze nem egyeztethető módon. </strong> <br>Lásd <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> a GDPR 5. cikk (1) bekezdésének b) pontját</a>.",
			name: "Célhoz kötöttség elve",
			source: "5.1 szakasz b)"
		},
		PIA_LGL_FOND: {
			description: "- Az érintett hozzájárulását adta személyes adatainak egy vagy több konkrét célból történő kezeléséhez; <br> - Az adatkezelés olyan szerződés teljesítéséhez szükséges, amelyben az érintett az egyik fél, vagy az a szerződés megkötését megelőzően az érintett kérésére történő lépések megtételéhez szükséges; <br> - Az adatkezelés az adatkezelőre vonatkozó jogi kötelezettség teljesítéséhez szükséges; <br> - Az adatkezelés az érintett vagy egy másik természetes személy létfontosságú érdekeinek védelme miatt szükséges; <br> - Az adatkezelés közérdekű vagy az adatkezelőre ruházott közhatalmi jogosítvány gyakorlásának keretében végzett feladat végrehajtásához szükséges; <br> - Az adatkezelés az adatkezelő vagy egy harmadik fél jogos érdekeinek érvényesítéséhez szükséges, kivéve, ha ezen érdekekkel szemben elsőbbséget élveznek az érintett olyan érdekei vagy alapvető jogai és szabadságai, amelyek személyes adatok védelmét teszik szükségessé, különösen, ha az érintett gyermek. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\">GDPR 6. cikkét</a>.",
			name: "Jogszerűség igazolása",
			source: "DPIA2 4. o."
		},
		PIA_LGL_INFO: {
			description: "Gondoskodjon az érintettek - <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 12-14. cikkeiben </a> meghatározottak szerinti - tájékoztatásáról.",
			name: "Az érintettek tájékoztatása",
			source: "GPIA 8. o. - WIKI"
		},
		PIA_LGL_MINI: {
			description: "A kezelt személyes adatok az adatkezelés céljai szempontjából megfelelőek és relevánsak kell, hogy legyenek, továbbá a személyes adatok körét azon adatokra kell szűkíteni, amelyek feltétlenül szükségesek az adatkezelés céljai szempontjából (ezen túlmenően nem szabad gyűjteni azokat).",
			name: "Adattakarékosság",
			source: "DPIAF Összekapcsolt tárgyak, 10. o. - WIKI"
		},
		PIA_LGL_ST: {
			description: "Minden adatfeldolgozóval adatfeldolgozási szerződést kell kötni, amely megszabja mindazokat a feltételeket, amelyeket a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> GDPR 28. cikke </a> előír, úgymint: az adatkezelés tárgya, időtartama, jellege és célja, a személyes adatok típusai, az érintettek kategóriái, az adatkezelésre vonatkozó írásbeli utasítások stb.",
			name: "Adatfeldolgozók igénybevétele",
			source: "DPIA2 10. o."
		},
		PIA_LGL_SUPT: {
			description: "A személyes adatok kezelésére szolgáló eszközök lehetnek például: hardware, software, hálózat, irat vagy papír alapú iratokat továbbító csatorna.",
			name: "Az adatok kezelésére szolgáló eszközök",
			source: "DPIA1 10. o."
		},
		PIA_LGL_TRAN: {
			description: "Azt figyelembe véve, hogy földrajzilag hova kerülnek továbbításra a személyes adatok - az Európai Unióba; az Unió által elismerten megfelelő védelmet nyújtó országba; az Egyesült Államokba, az EU-USA adatvédelmi pajzshoz (Privacy Shield) csatlakozott szervezet részére; vagy egyéb országba -, olyan jogi kereteket kell biztosítani, amelyek megfelelő szintű védelmet biztosítanak a személyes adatok határokon átnyúló továbbítása esetén.  Lásd <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> a GDPR 44-49. cikkeit </a>.",
			name: "Adattovábbítás",
			source: "DPIAF által összekapcsolt tárgyak 18. o."
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Van-e arra nézve elv és eljárás, hogy olyan szervezetet kell bevonni, amely képes az általa kezelt személyes adatok védelmét ellátni?",
			name: "Felügyelet",
			placeholder: "Jelezze, ellenőrzik-e az adatvédelem hatékonyságát és alkalmasságát.",
			source: " DPIA3, 76.o. - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Rendelkeznek-e olyan szabályzattal és eljárásrenddel, amely csökkenti a személyes adatokhoz való jogszerű hozzáférés nyomán keletkező, az érintettek polgári jogait és magánszféráját fenyegető kockázatokat?",
			name: "Kapcsolat harmadik felekkel",
			placeholder: "Ismertesse, hogy az adatokhoz való hozzáférést kérő adatfeldolgozóknak milyen biztonsági intézkedéseknek kell megfelelniük a hozzáférés tekintetében.",
			source: "DPIA3, 48. o. - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Ismertesse, van-e az adatvédelmi jogszabályoknak és egyéb előírások érvényesítésének felelőse, továbbá kijelöltek-e a szervezetrendszeren belül olyan bizottságot (vagy más hasonló egység), amely mintegy ellenőrző mechanizmusként működve, az adatvédelmi vonatkozású tevékenységek kapcsán iránymutatással szolgál és felel az utánkövetésért is.",
			name: "Szervezet",
			placeholder: "Ismertesse, hogy az adatvédelemmel összefüggő feladat-és felelősségi körök meg vannak-e határozva.",
			source: "DPIAF Összekapcsolt tárgyak, 24. o. - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Kidolgoztak-e arra vonatkozó eljárásrendet, hogy az adatvédelmi megfontolásokat minden újonnan megkezdett adatkezelési művelet esetén beépítsék a folyamataikba?",
			name: "Az adatvédelem beépítése a projektekbe",
			placeholder: "Mutassa be, hogyan építik be az adatvédelem követelményeit a projektekbe.",
			source: " DPIA3, 79. o. - WIKI "
		},
		PIA_ORG_PERS: {
			description: "Van-e arra nézve eljárásuk, hogy az újonnan felvett alkalmazottak esetében milyen adatvédelmi ismereteiket bővítő és adatvédelmi tudatosságukat növelő mechanizmusokat kell alkalmazni, továbbá milyen intézkedéseket alkalmaznak abban az esetben, amikor felmond egy olyan munkavállaló, aki hozzáféréssel rendelkezik az adatokhoz?",
			name: "Humánerőforrás-menedzsment",
			placeholder: "Mutassa be, milyen módszereket alkalmaznak a munkavállalók adatvédelmi tudatosságának növelése érdekében.",
			source: "DPIAF Összekapcsolt tárgyak, 24. o."
		},
		PIA_ORG_POL: {
			description: "Foglalja össze az adatvédelem, a dokumentumokban előírt adatvédelmi eljárások legfontosabb vonatkozásait az egyes kategóriáknak (kockázatok, betartandó alapelvek, célok, alkalmazandó szabályok stb.) és kommunikációs céloknak (használók, IT-osztály, eljárások kidolgozói stb.) megfelelően.",
			name: "Szabályzatok",
			placeholder: "Írja le az adatvédelmi célokat és szabályokat magában foglaló dokumentumokat.",
			source: "GPIA3, 78. o. - WIKI "
		},
		PIA_ORG_RMGT: {
			description: "Azok a rendelkezések, amelyek megállapítják a szervezet által végzett, az adatkezelésre és az érintettek magánszférájára kockázatot jelentő adatkezelési műveletek megvizsgálására irányuló eljárásrendeket (kockázatok feltérképezése stb.).",
			name: "Adatvédelmi kockázatok kezelése",
			placeholder: "Írja le azokat az eljárásokat, amelyek a szervezet által végzett adatkezelés adatvédelmi, az érintettek magánszféráját érintő kockázataival szemben nyújtanak védelmet.",
			source: " DPIA3, 77. o. - WIKI "
		},
		PIA_ORG_VIOL: {
			description: "Van-e olyan operatív szervezet, amely észleli és kezeli az érintettek polgári jogait és magánszféráját érintő incidenseket?",
			name: " A személyes adatokkal kapocsolatos jogsértések  kezelése",
			placeholder: "Ismertesse, hogy rendelkeznek-e dokumentált és tesztelt eljárásrenddel informatikai incidensekre vonatkozóan.",
			source: " DPIAF Összekapcsolt tárgyak, 24. o. és DPIA 36. o. - WIKI"
		},
		PIA_SEC_BKP: {
			description: "A személyes adatok rendelkezésre állását és/vagy sértetlenségét és egyben bizalmas kezelésüket biztosító eljárások és eszközök.",
			name: "Biztonsági mentés",
			placeholder: "Tüntesse fel a biztonsági mentések kezelési módját. Nyilatkozzon arra vonatkozóan,  hogy biztonságos helyen tárolják-e azokat.",
			source: "DPIAF Összekapcsolt tárgyak, 23. o. és PIA+ 27. o. - WIKI "
		},
		PIA_SEC_COMP: {
			description: "Munkaállomásokra telepített védelmi eszközök (automatikus zárás, rendszeres frissítés, konfiguráció, fizikai biztonság stb.), amely csökkenti a software tulajdonságainak (operációs rendszerek, üzleti applikációk stb.) a személyes adatokra ártalmas kihasználhatóságát.",
			name: "A munkaállomások kezelése",
			placeholder: "Írja le a munkaállomásokra telepített védelmi eszközöket.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "Az adatfeldolgozók által kezelt személyes adatoknak megfelelő védelemmel kell rendelkezniük. Kizárólag olyan adatfeldolgozók vehetők igénybe, akik ehhez megfelelő garanciát biztosítanak (különösen a szakértelem, megbízhatóság és a megfelelő források terén). <br>Az adatfeldolgozóknak dokumentálniuk kell a garanciák hatékonyságának biztosítását. Ezek a garanciák a következők: <br>- személyes adatok titkosítása; <br> -adatátvitel titkosítása (pl HTTPS kapcsolat, VPN, stb); <br>- hálózati védelem, nyomon követhetőség, jogosultságkezelés, hitelesítés, stb. <br>Az adatfeldolgozóval alkalmazzon olyan szerződést, ami kiterjed különösen a következőkre: az adatkezelés tárgya, célja, időtartama, a felek kötelezettségei. <br>Térjen ki emellett az alábbiakra is: <br>- a személyes adatok titkosságával kapcsolatos kötelezettsége; <br> - a felhasználói hitelesítés minimális követelményei; <br> - az adat visszaszolgáltatásának és / vagy megsemmisítésének feltételei a szerződés végén; <br>- az incidensek kezelésére és jelentésére vonatkozó szabályok. <br>Felhő szolgáltatás használata esetén az alábbiakra is szükséges kitérnie: <br>1. Annak meghatározása, hogy pontosan mely személyes adatokat, milyen módon kezelik a felhőben; <br>2. Saját technikai és jogi biztonsági követelmények meghatározása; <br>3. Kockázatelemzés a megfelelő biztonsági intézkedések meghatározása érdekében; <br>4. A tervezett adatkezelés szempontjából releváns felhő típusának azonosítása; <br>5. Olyan szolgáltató választása, amely elegendő garanciával rendelkezik; <br>6. A belső biztonságpolitika áttekintése; <br>7. A változások rendszeres követése.",
			name: "Adatfeldolgozók igénybevétele során alkalmazandó követelmények",
			placeholder: "Ismertesse az adatfeldolgozókra vonatkozó különleges intézkedéseket (hosting szolgáltatás, üzemeltetési szolgáltatás, adminisztrátor, egyéb speciális szolgáltatók stb.).",
			source: "Beszerzési intézkedések: szerződésben meghatározva és irányítva "
		},
		PIA_SEC_EXP: {
			description: "A személyes adatok kezelésére szolgáló eszközök kockázati kitettségét csökkentő intézkedések.",
			name: "Üzembiztonság",
			placeholder: "Írja le, hogy történnek a software-frissítések (operációs rendszerek, alkalmazások stb.), és hogyan alkalmaznak biztonságvédelmi hibákat javító programokat.",
			source: "DPIAF Összekapcsolt tárgyak, 22. o. - WIKI"
		},
		PIA_SEC_LOG: {
			description: "A behatolásészlelő és -megelőző rendszerek által végzett ellenőrzés révén elemezze a hálózati (vezetékes hálózatok, Wi-Fi, rádióhullám, száloptika) valós idejű forgalmát, és így észlelje a kibertámadás-gyanús tevékenységeket.",
			name: "Hálózati tevékenységek megfigyelése",
			placeholder: "Tüntesse fel az adatvédelmi incidensek észlelésére alkalmazott eszközöket és intézkedéseket.",
			source: " DPIA3, 67.o. - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "A hardware karbantartásának eljárása, jelezve, hogy azt kiszervezik-e. Közölje, engedélyezik-e az applikációk távoli karbantartását, és milyen feltételekkel. Részletezze, hogy a meghibásodott berendezések kezelésére van-e külön eljárás.",
			name: "Karbantartás",
			placeholder: "Írja le a hardware fizikai karbantartásának módját",
			source: "DPIAF Összekapcsolt tárgyak, 23. o. "
		},
		PIA_SEC_MAL: {
			description: "A munkaállomásokra és a szerverekre telepített, a rosszindulatú software-ekkel szemben védő eszközök a kevésbé biztonságos hálózatókhoz való csatlakozás esetén.",
			name: "Rosszindulatú software-ek kiszűrése",
			placeholder: "Írja le, milyen védelmi intézkedésekkel csökkentik a kockázatokat kevésbé biztonságos hálózatokhoz való csatlakozás esetén.",
			source: "DPIAF Összekapcsolt tárgyak, 22. o. - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Tüntesse fel a szerverek és a munkaállomások fizikai biztonságát befolyásoló védelmi intézkedéseket (biztonságos tárolás, biztonsági kábelek, titkossági szűrők, biztonsági törlés szemétbe dobás előtt stb.).",
			name: "Hardwarebiztonság",
			placeholder: "Tüntesse fel a szerverek és a munkaállomások fizikai biztonságát befolyásoló védelmi intézkedéseket",
			source: "DPIAF Összekapcsolt tárgyak, 23. o. - WIKI"
		},
		PIA_SEC_NET: {
			description: "Az adatkezelést szolgáló hálózattól (elkülönült, magánhálózat vagy Internet) függően adja meg, milyen tűzfal-, behatolásérzékelő, illetve egyéb aktív vagy passzív rendszer gondoskodik a hálózatbiztonságról.",
			name: "Hálózatbiztonság",
			placeholder: "Adja meg az adatkezelést szolgáló hálózat védelmi eszközeit.",
			source: "DPIAF Összekapcsolt tárgyak, 23. o. "
		},
		PIA_SEC_PHY: {
			description: "Fizikai biztonsági intézkedések (az épület szakaszolása, vendégek kísérete, belépők viselése, ajtók zárása stb.). Ismertesse, hogy alkalmaznak-e olyan eljárásokat, amelyek révén illetéktelen behatolás esetén figyelmeztető jelzést kapnak.",
			name: "Fizikai hozzáférésvédelem",
			placeholder: "Adja meg, az adatkezelés helyszínét milyen fizikai védelemmel biztosítják.",
			source: "DPIAF Összekapcsolt tárgyak, 23. o."
		},
		PIA_SEC_PROT: {
			description: "A tűzvédelmi eszközök, tűzjelző és tűzoltó berendezések leírása. Ha van ilyen, mutassa be a vízkár elleni védelem eszközeit. Jelölje meg továbbá az áramellátás ellenőrzésére szolgáló eszközöket és a kármentesítés eszközeit.",
			name: "A nem emberi eredetű kockázatokkal szembeni védelem",
			placeholder: "Tüntesse fel a nem emberi eredetű kockázatok csökkentésének vagy korlátozásának eszközeit.",
			source: "A DPIAF Összekapcsolt tárgyak, 23. o. - WIKI"
		},
		PIA_SEC_SRC: {
			description: "A telepítési helyszín dokumentációja, az ugyanis nem lehet kitéve környezeti katasztrófáknak (ártér, vegyiművek közelsége, földrengéses vagy vulkanikus térség stb.). Jelezze, tárolnak-e ugyanezen területen veszélyes anyagokat.",
			name: "A kockázatforrások elkerülése",
			placeholder: "Tüntesse fel, hogy a telepítési helyszín ki van-e téve környezeti katasztrófáknak.",
			source: "A DPIAF Összekapcsolt tárgyak, 23. o. - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Az ANSSI webheybiztonsági ajánlásainak alkalmazása.",
			name: "Webhelybiztonság",
			placeholder: "Tüntesse fel, fel milyen eszközöket alkalmaznak a webhelyek védelmére.",
			source: "DPIAF Összekapcsolt tárgyak, 22. o. - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Amennyiben alkalmaznak anonimizálási technikákat, ismertesse, hogy melyeket és mely célból alkalmazzák. Leírásában különítse el az anonimizált módon és az álnevesítés útján kezelt adatokat.",
			name: "Anonimizálás",
			placeholder: "Ismertesse az alkalmazott anonimizálási mechanizmust",
			source: "DPIAF Összekapcsolt tárgyak, 21. o."
		},
		PIA_TEC_ARCH: {
			description: "Amennyiben rendelkezik ilyennel, ismertesse a felelősségi körébe tartozó archiválás folyamatait (átadás, tárolás, egyeztetés stb.). Adja meg az archiválás szereplőit (átadó osztályok, adattovábbító ügynökségek stb.), illetve az archiválásra vonatkozó irányelveket. Jelezze, ha az adatok az állami levéltári nyilvántartás hatókörébe tartozhatnak.",
			name: "Archiválás",
			placeholder: "Ismertesse, alkalmaznak-e a tárolt adatok sértetlenségét ellenőrző mechanizmusokat, melyeket és milyen célra.",
			source: "DPIAF Összekapcsolt tárgyak, 22. o. - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Adatbázisban, fájl szinten, illetve biztonsági mentésként tárolt adatok bizalmasságának megőrzése érdekében használt eljárás. <br> Ismertesse az alkalmazott titkosítási eljárásokat (VPN, TLS stb.).",
			name: "Titkosítás",
			placeholder: "Ismertesse az adatok bizalmas kezelésére alkalmazott eszközöket",
			source: "DPIAF Összekapcsolt tárgyak, 21. o."
		},
		PIA_TEC_CLO: {
			description: "Amennyiben a különböző adatokat elválasztva kezeljük, csökkenhet annak az esélye, hogy a személyes adatok egymással összefüggésbe hozhatók legyenek egy esetleges adatvédelmi incidens bekövetkezése esetén.",
			name: "Az adatok különválasztása",
			placeholder: "Jelezze, hogy tervezik-e az adatok különválasztását, és ezt miként hajtják végre.",
			source: "DPIAF Összekapcsolt tárgyak, 21. o."
		},
		PIA_TEC_CTLA: {
			description: "A felhasználók profiljának definiálása, kezelése. Ismertesse a hitelesítési eljárást. Határozza meg a jelszóhasználati szabályokat (minimum hossz, használható karakterek, érvényesség időtartama, téves jelszóhasználatok száma a fiók zárolása előtt).",
			name: "Logikai hozzáférés szabályozás",
			placeholder: "Mutassa be, hogyan határozzák meg és azonosítják a felhasználói profilokat.",
			source: "DPIAF Összekapcsolt tárgyak, 21. o. "
		},
		PIA_TEC_LOG: {
			description: "A nyomon követhetőség és naplózás irányelvei.",
			name: "Nyomon követhetőség (naplózás)",
			placeholder: "Ismertesse, készülnek-e ezekről az eseményekről bejegyzések, és ezeket a bejegyzéseket meddig tárolják.",
			source: "DPIAF Összekapcsolt tárgyak, 22. o."
		},
		PIA_TEC_MINI: {
			description: "A következő módszerek alkalmazhatók: szűrés, eltávolítás, érzékenységcsökkentés átalakítással, az adatok személyazonosításra alkalmas jellegének csökkentése, az adatfelhalmozás korlátozása, az adatokhoz való hozzáférés korlátozása.",
			name: "Adatminimalizálás",
			placeholder: "Ismertesse, milyen kockázatcsökkentő eszközöket alkalmaznak a személyes adatok mennyiségének korlátozása céljából.",
			source: "DPIAF Összekapcsolt tárgyak, 40. o."
		},
		PIA_TEC_PAP: {
			description: "Ha papír alapú dokumentumok is használnak az adatkezelés során, jelezze, hogyan történik a nyomtatásuk, tárolásuk, megsemmisítésük, illetve kicserélésük.",
			name: "Papír alapú dokumentumok biztonsága",
			placeholder: ": Ismertesse, hogy alkalmaznak-e a papír alapú dokumentumok sértetlenségét ellenőrző mechanizmusokat, és amennyiben igen, melyeket és milyen célra.",
			source: "DPIAF Összekapcsolt tárgyak, 22. o."
		},
		PIA_VAL_ACT: {
			description: "Az értékelő által a korábbi lépések során javasolt hibajavító intézkedések, amelyek akciótervet képeznek, kijelölik a feladatokat, felelőseiket, gyakoriságukat, költségeiket és ütemezésüket.",
			name: "Intézkedési terv",
			source: "Nincs"
		},
		PIA_VAL_CART: {
			description: "Kockázatszámítást bemutató grafikon, ahol az egyes értékek a korábbi lépésekben elvégzett értékelésen alapulnak.",
			name: "A kockázatok feltérképezése",
			source: "DPIAF Összekapcsolt tárgyak, 34. o."
		},
		PIA_VAL_CONC: {
			description: "Az adatkezelő adott esetben – a kereskedelmi érdekek vagy a közérdek védelmének vagy az adatkezelési műveletek biztonságának sérelme nélkül – kikéri az érintettek vagy képviselőik véleményét a tervezett adatkezelésről. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> a GDPR 35. cikk (9) bekezdését </a>. <br> A körülményektől függően a véleményeket többféle módon lehet begyűjteni (többek között az adatkezelés céljára és egyéb lényeges körülményeire irányuló belső vagy külső vizsgálattal, a munkavállalók képviselőinek vagy a szakszervezeteknek feltett kérdéssel, illetve az adatkezelő majdani ügyfeleire irányuló felméréssel). Ha az adatkezelő szembehelyezkedik az érintettek véleményével </strong>, feljegyzést kell készítenie döntése indoklásáról. Ha az adatkezelő úgy véli, nincs jelentősége az érintettek véleménye beszerzésének, ennek indoklását szintén feljegyzésbe kell foglalnia.",
			name: "Az érintett véleménye",
			source: "GDPR 35 cikkének 9. bekezdése és DPIAF Összekapcsolt tárgyak, 38. o."
		},
		PIA_VAL_DPO: {
			description: "Ha van kijelölt adatvédelmi tisztviselő, az adatkezelő az adatvédelmi hatásvizsgálat elvégzésekor az adatvédelmi tisztviselő szakmai tanácsát köteles kikérni. Lásd a <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=CELEX:32016R0679&qid=1520586769024&from=HU\"> a GDPR 35. cikkének (2) bekezdését</a>. <br>Az adatvédelmi tisztviselő által adott vélemény kifogásolhatja a folyamatban lévő adatkezelést, mégsem korlátozza az adatkezelő döntését.",
			name: "Az adatvédelmi tisztviselő szakmai tanácsa",
			source: "A GDPR 35. cikkének (2) bekezdése és DPIAF Összekapcsolt tárgyak, 37. o."
		},
		PIA_VAL_RT: {
			description: "Döntse el, hogy a választott intézkedések, a maradvány kockázat, valamint az intézkedési terv elfogadható-e.  Mindezek alapján a hatásvizsgálat eredménye lehet: jóváhagyott – feltételektől függően jóváhagyható (ebben az esetben ismertesse, hogy milyen korrekciókra van szükség) – elutasított (az alapul szolgáló tervezett adatkezeléssel egyetemben). <br> Ez a döntés nem befolyásolja az adatvédelmi hatóság (Magyarországon a NAIH) vizsgálódását a GDPR rendelkezéseinek történő megfelelés tekintetében.",
			name: "Jóváhagyás",
			source: "DPIAF Összekapcsolt tárgyak, 40. o."
		}
	},
	title: "Tudásbázis"
};
var measures$b = {
	add: "Intézkedés hozzáadása",
	default_placeholder: "Mutassa be a kockázatok kezelését célzó meglévő vagy tervezett intézkedéseket.",
	edit: "Intézkedés szerkesztése",
	placeholder_title: "Intézkedés neve",
	remove: "Intézkedés törlése"
};
var misc$b = {
	display: "Megjelenítés / Elrejtés"
};
var modals$b = {
	abandon_pia: {
		additional_text: "Az arhiválás nem végleges, van lehetőség a módosításra.",
		content: "Biztosan abba akarja hagyni ezt a munkamenetet?"
	},
	action_plan_no_evaluation: {
		content: "Az intézkedési terv létrehozása előtt tekintse át a vizsgálat eredményét.",
		review_section: "Szakasz áttekintése"
	},
	archive: "Archiválás",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "Ez a rész készen áll véleményzésre."
	},
	back_to_edition: {
		content: "Ez a rész vissza lett küldve szerkesztésre.<br> Több mezőt javítani kell<br> a teljes értékelés eléréséhez."
	},
	back_to_evaluation: {
		content: "Ez a rész vissza lett küldve felülvizsgálatra.<br> Több mezőt felül kell vizsgálni<br> a teljes jóváhagyáshoz."
	},
	back_to_home: "Vissza a kezdőlapra",
	cancel: "Mégsem",
	close: "Bezárás",
	completed_edition: {
		content: "A DPIA teljes szerkesztése befejeződött, véleményezés szükséges."
	},
	completed_evaluation: {
		content: "A DPIA teljes véleményezése megtörtént, jóváhagyásra vár."
	},
	"continue": "Folytatás",
	declare_measures: {
		content: "Sajnáljuk, a kockázatértékelés előtt meg kell adnia a meglévő vagy tervezett intézkedéseket.",
		declare: "A meglévő/tervezett intézkedések bejelentése"
	},
	dpo_missing_evaluations: {
		comment: "Komment",
		content: "Az adatvédelmi tisztviselő menüpontjához történő továbblépés előtt át kell tekintenie a vizsgálat eredményét.",
		remove: "Eltávolítás",
		review_section: "Szakasz áttekintése"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type PIA"
	},
	import_wrong_structure_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type Modèle"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "A DPIA tartalma a vágólapra másolva."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Figyelmeztetés:</span><br>legalább egy intézkedést meg kell adni: nincs törlési lehetőség."
	},
	recover_version: {
		"continue": "Folytatás",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "<span class='strong'>DPIA elutasítva,</span><br>Több mezőt is ki kell javítani. Visszatérés az értékelésmódba a javításokhoz."
	},
	remove_attachment: {
		comment: "Komment",
		content: "<span class='strong'>Figyelmeztetés:</span><br>Biztosan el akarja távolítani a mellékletet?",
		keep: "Megtartás",
		remove: "Eltávolítás"
	},
	remove_measure: {
		content: "<span class='strong'>Figyelmeztetés:</span><br>Biztosan el akarja távolítani az intézkedést?",
		keep: "Intézkedés megtartása",
		remove: "Az intézkedés eltávolítása"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "A DPIA eltávolítása"
	},
	remove_question: {
		content: "TO BE TRANSLATED - Souhaitez-vous supprimer la question ?",
		keep: "TO BE TRANSLATED - Annuler",
		remove: "TO BE TRANSLATED - Supprimer"
	},
	remove_structure: {
		content: "TO BE TRANSLATED - <span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer ce modèle ?",
		remove: "TO BE TRANSLATED - Supprimer ce modèle"
	},
	same_comment: {
		content: "<span class='strong'>Figyelmeztetés:</span><br>kérjük, a legutóbbihoz képest más megjegyzést vigyen be."
	},
	signed_pia_validation: {
		content: "<span class='strong'>A DPIA jóváhagyása megtörtént.</span><br>A jóváhagyás véglegesítéséhez csatolja a felelős vezető által aláírt jelentést.",
		download_pia: "A DPIA-jelentés letöltése "
	},
	simple_pia_validation: {
		content: "A hatásvizsgálat jóváhagyása megtörtént."
	},
	start_evaluation: "Véleményezés kezdése",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "A szerver címét frissítették."
	},
	validate_evaluation: {
		content: "A DPIA jóváhagyására vár."
	},
	validate_evaluation_to_correct: {
		content: "Sajnáljuk, térjen vissza a szerkesztési módba további javítások elvégzéséhez."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$b = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$b = {
	content: "álláspontja szerint:",
	dpo_lock: "Kérjük, töltse ki a többi részt is, csak utána írhatja be az adatvédelmi tisztviselő-véleményt.",
	dpo_opinion: "Az adatvédelmi tisztviselő szakmai tanácsa",
	edit: "Szerkesztés",
	people_opinion: "Érintettek véleménye",
	placeholder_concerned_people_name: "Érintettek neve",
	placeholder_dpo_name: "Adatvédelmi tisztviselő  neve",
	placeholder_dpo_opinion: "Nevezze meg választása okait.",
	placeholder_people_opinion: "Ismertesse a vélemények összegyűjtésének és elemzésének módját. Amennyiben nem kérték ki az érintettek véleményét, fejtse ki ennek indokait.",
	placeholder_search_content: "Indokolja, miért nem kérték ki az érintettek véleményét.",
	treatment_lock: "Kérjük, töltse ki a többi részt is, csak utána írhatja be az érintettek véleményét.",
	treatment_nok: "Az alkalmazott intézkedések nem voltak megfelelőek.",
	treatment_ok: "Az alkalmazott intézkedések megfelelőek voltak."
};
var pia$b = {
	attachments: {
		add: "Csatolás",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Eltávolítás",
		title: "Mellékletek",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Véleményezés kérése",
		mandatory_fields: "Minden mezőt ki kell tölteni",
		structure_add_question: "TO BE TRANSLATED - Ajouter une question",
		subsection_validated: "Rész véleményezve, jóváhagyásra vár",
		validate_evaluation: "Véleményezés befejezése"
	},
	header: {
		display_action_plan: "Intézkedési terv megmutatása",
		edition: "Szerkesztés",
		evaluation: "Értékelés",
		preview: "Előnézet"
	},
	sections: {
		based_on_structure_name: "TO BE TRANSLATED - Basé sur le modèle :",
		homepage_link: "Vissza a vezérlőpulthoz",
		refuse_pia: "Hatásvizsgálat elutasítása",
		status: {
			evaluation: {
				cancel: "törölni kell a véleményezési igényt.",
				cancel_button: "Véleményezési igény törlése",
				content: "Ez a rész nem lett véleményezve. Ha szerkeszteni kívánja a véleményezésre szánt részt, úgy ",
				title: "Véleményezésre várva."
			},
			validation: {
				cancel: "törölni kell a jóváhagyási igényt.",
				cancel_button: "Jóváhagyási igény törlése",
				content: "Ez a rész értékelve lett és a DPIA átfogó jóváhagyására vár. Amennyiben változtatna az értékelésen, úgy ",
				title: "Jóváhagyásra várva."
			}
		},
		validate_pia: "Hatásvizsgálat jóváhagyása"
	},
	statuses: [
		"Folyamatban lévő",
		"Elutasítva",
		"Előzetes jóváhagyás",
		"Végleges (aláírt) jóváhagyás",
		"Archiválva",
		"Jóváhagyásra vár"
	]
};
var questions$b = {
	edit: "Kérdés szerkesztése",
	gauges: [
		"(n/a)",
		"Elhanyagolható",
		"Korlátozott",
		"Jelentős",
		"Maximális"
	],
	placeholder_title: "TO BE TRANSLATED - Titre de la question (obligatoire)",
	remove: "TO BE TRANSLATED - Supprimer la question"
};
var rejection_page$b = {
	applied_adjustments: "Kiegészítések",
	applied_adjustments_placeholder: "Részletezze ezen DPIA elfogadott részeit",
	button: {
		abandon_treatment: "Visszalépés",
		reject_pia: "DPIA elutasítása",
		send_for_validation: "Küldés újbóli jóváhagyásra"
	},
	previous_rejection: "Korábbi elutasítás",
	rejection_reason: " Elutasítás okai",
	rejection_reason_placeholder: "Részletezze a DPIA elutasításának okait.",
	title: "Jóváhagyás előzményei"
};
var sections$b = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Mutassa be röviden az adatkezelést, ennek körében ismertesse különösen a személyes adatok kezelésének célját, jogalapját, a kezelt személyes adatok körét és az adatkezelés egyéb lényeges körülményeit.",
						title: "Az adatkezelés rövid bemutatása"
					},
					"2": {
						placeholder: "Ismertesse az adatkezelésben közreműködő felek – az adatkezelő, az esetleges adatfeldolgozók és a közös adatkezelők – egymáshoz való viszonyát az adatkezelésért való felelősség viselésének szempontjából .",
						title: "Az adatkezeléshez kapcsolódó felelősségi viszonyok bemutatása"
					},
					"3": {
						placeholder: "Sorolja fel az adatkezelésre vonatkozó szabványokat, jóváhagyott magatartási kódexeket és adatvédelmi tanúsítványokat, amennyiben ilyennel rendelkezik.",
						title: "Rendelkezik-e az adatkezelésre alkalmazandó valamilyen szabvánnyal?"
					}
				},
				short_help: "Ez a rész áttekintést nyújt a személyes adatok kezelésének főbb ismérveiről.",
				title: "Áttekintés"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Sorolja fel a gyűjtött és kezelt adatokat. Egyenként határozza meg a tárolás időtartamát, a címzetteket és azokat a személyeket, akik az adatokhoz hozzáférnek.",
						title: "A kezelt személyes adatok köre"
					},
					"2": {
						placeholder: "Mutassa be az adatkezelés folyamatát (az adatgyűjtéstől az adatok megsemmisítéséig, az adatkezelés különböző szakaszait, a tárolást stb.), használjon például a személyes adatok útját - adatfolyamot -  bemutató ábrát (melyet mellékletként feltölthet).",
						title: "Az adatkezelési folyamatok bemutatása"
					},
					"3": {
						placeholder: "Sorolja fel a személyes adatok kezelésére szolgáló eszközöket (operációs rendszerek, alkalmazások, adatbázis-kezelő rendszerek, helyiségek, egyéb eszközök stb.)",
						title: "Melyek a személyes adatok kezelésére szolgáló eszközök?"
					}
				},
				short_help: "Ez a rész magában foglalja az adatkezelés hatókörének meghatározását és részletes ismertetését.",
				title: "Adatok, az adatkezelés folyamata, az adatok kezelésére szolgáló eszközök"
			}
		},
		short_help: "Ez a menüpont áttekintést nyújt a hatásvizsgálat alá vont adatkezelésről.",
		title: "Összegzés"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Fejtse ki, hogy mitől meghatározottak, egyértelműek és jogszerűek az adatkezelés céljai.",
						short_title: "Célok",
						title: "Az adatkezelés céljai meghatározottak-e, egyértelműek-e és jogszerűek-e?"
					},
					"2": {
						placeholder: "Ismertesse az adatkezelés jogalapját (hozzájárulás, szerződés teljesítése, jogi kötelezettség teljesítése, létfontosságú érdekek védelme stb.)",
						short_title: "Jogalap",
						title: "Mi az adatkezelés jogalapja?"
					},
					"3": {
						placeholder: "Mutassa be, hogy az egyes gyűjtött adatok miért szükségesek az adatkezelés céljára.",
						short_title: "Megfelelő adatok",
						title: "A gyűjtött adatok az adatkezelés céljai szempontjából megfelelőek és relevánsak-e, valamint a szükségesre korlátozódnak-e (adattakarékosság)?"
					},
					"4": {
						placeholder: "Ismertesse az adatminőséget biztosító intézkedéseket.",
						short_title: "Pontosság",
						title: "Pontosak-e az adatok, naprakész állapotban tartják-e azokat?"
					},
					"5": {
						placeholder: "Mutassa be, hogy milyen jogi követelmények és/vagy adatkezelési szükségletek indokolják a tárolás időtartamát.",
						short_title: "Adatmegőrzési határidő",
						title: "Mi az adatmegőrzés időtartama?"
					}
				},
				short_help: "Ezen rész alatt lehetősége van annak igazolására, hogy az adatok kezelésére jogszerűen kerül sor.",
				title: "Arányosság és szükségesség"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Ismertesse az érintetteknek adott tájékoztatást és annak módját.",
						short_title: "Az érintettek tájékoztatása",
						title: "Milyen módon tájékoztatják az érintetteket az adatkezelésről?"
					},
					"2": {
						placeholder: "Mutassa be az annak biztosítására szolgáló eljárásokat, hogy az érintettek hozzájárulásának beszerzése megtörténik.",
						short_title: "A hozzájárulás megszerzése",
						title: "Amennyiben az adatkezelés hozzájáruláson alapul, milyen módon szerzik be az érintettek hozzájárulását?"
					},
					"3": {
						placeholder: "Ismertesse azokat az intézkedéseket, amelyek biztosítják, hogy az érintettek hozzáférhessenek az adataikhoz, megkapják és továbbíthassák azokat.",
						short_title: "Az adatokhoz való hozzáférés joga és az adathordozhatósághoz való jog",
						title: "Milyen módon érvényesíthetik az érintettek a hozzáférési, illetve az adathordozhatósághoz való jogukat?"
					},
					"4": {
						placeholder: "Ismertesse azokat az intézkedéseket, amelyek biztosítják, hogy az érintettek helyesbíttethessék és töröltethessék adataikat.",
						short_title: "A helyesbítéshez és a törléshez való jog",
						title: "Hogyan gyakorolhatják az érintettek a helyesbítéshez és törléshez való jogukat?"
					},
					"5": {
						placeholder: "Ismertesse azokat az intézkedéseket, amelyek biztosítják, hogy az érintettek kérhessék az adatkezelés korlátozását, illetve tiltakozhassanak személyes adataik kezelése ellen.",
						short_title: "Az adatkezelés korlátozáshoz és a tiltakozáshoz való jog",
						title: "Hogyan gyakorolhatják az érintettek az adatkezelés korlátozásához, valamint tiltakozáshoz való jogukat?"
					},
					"6": {
						placeholder: "Ismertesse az egyes adatfeldolgozók kötelezettségeit (időtartam, hatáskör, célok, dokumentált utasítások a feldolgozóknak stb.), illetve jelölje meg azok feladatait és kötelezettségeit meghatározó szerződéseket, magatartási kódexeket és tanúsítványokat.",
						short_title: "Adatfeldolgozók igénybevétele",
						title: "Az adatfeldolgozók kötelezettségeit egyértelműen rögzíti-e az adatfeldolgozási szerződés?"
					},
					"7": {
						placeholder: "Nevezze meg mindazokat az Európai Unión kívüli országokat, amelyekben adatkezelés és -tárolás  történik, továbbá jelölje meg, hogy azok megfelelő védelmi szintet biztosítanak -e (más esetben is írja le az adattovábbításra vonatkozó rendelkezéseket)",
						short_title: "Adattovábbítások",
						title: "Az Európai Unión kívülre történő adattovábbítás esetén megfelelő védelemben részesülnek-e a személyes adatok?"
					}
				},
				short_help: "Ez a rész az érintettek jogérvényesítésének biztosítása érdekében alkalmazott eszközök ismertetését tartalmazza.",
				title: "Az érintettek jogainak biztosítására szolgáló intézkedések"
			}
		},
		short_help: "Ez a menüpont az adatvédelmi elveknek való megfelelés kereteinek bemutatására szolgál.",
		title: "Alapelvek"
	},
	"3": {
		items: {
			"1": {
				short_help: "Ez a rész tartalmazza azon meglévő vagy tervezett intézkedéseket, amelyek hozzájárulnak az adatbiztonság megteremtéséhez.",
				title: "Tervezett vagy meglévő intézkedések"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Írja be a lehetséges következményeket",
						title: "Milyen főbb <span class='green-highlight'>következményekkel járna az érintettekre</span>, ha a kockázat bekövetkezne?"
					},
					"2": {
						placeholder: "Írja be a fenyegető veszélyeket",
						title: "Mely fő <span class='green-highlight'>fenyegető veszélyek</span> idézhetik elő a kockázatot?"
					},
					"3": {
						placeholder: "Írja be kockázatok forrásait",
						title: "Melyek a kockázat <span class='green-highlight'>forrásai</span>?"
					},
					"4": {
						placeholder: "Kattintson rá a kockázatkezelő intézkedésre.",
						title: "A megadott <span class='green-highlight'>intézkedések</span> közül melyek szolgálnak a kockázat kezelésére?"
					},
					"5": {
						placeholder: "A csúszka elmozdításával mutassa be a kockázat becsült súlyosságát, továbbá szövegesen fejtse ki annak indokát.",
						title: "Hogyan becsüli meg a <span class='green-highlight'>kockázat súlyosságát</span>, különösen a lehetséges következményekre és a kockázatok kezelését célzó tervezett intézkedésekre való tekintettel?"
					},
					"6": {
						placeholder: "A csúszka elmozdításával mutassa be a kockázat becsült valószínűségét, továbbá szövegesen fejtse ki annak indokát.",
						title: "Hogyan becsüli meg a <span class='green-highlight'>kockázat valószínűségét</span>, különösen a fenyegető veszélyekre, a kockázatforrásokra és a kockázatok kezelését célzó tervezett intézkedésekre való tekintettel?"
					}
				},
				short_help: "Elemezze az adatokhoz való jogosulatlan hozzáférés okait és következményeit, becsülje meg annak súlyosságát, illetve valószínűségét.",
				title: "Az adatokhoz való jogosulatlan hozzáférés"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Írja be a lehetséges következményeket",
						title: "Milyen főbb <span class='green-highlight'>következményekkel járna az érintettekre</span>, ha a kockázat bekövetkezne?"
					},
					"2": {
						placeholder: "Írja be a fenyegető veszélyeket",
						title: "Milyen fő <span class='green-highlight'>fenyegető veszélyek</span> idézhetik elő a kockázatot?"
					},
					"3": {
						placeholder: "Írja be a kockázat forrásait",
						title: "Melyek a kockázat <span class='green-highlight'>forrásai</span>?"
					},
					"4": {
						placeholder: "Kattintson a kockázatkezelő intézkedésre.",
						title: "A megadott intézkedések közül melyek <span class='green-highlight'>megfelelőek</span> a kockázatok kezelésére?"
					},
					"5": {
						placeholder: "A csúszka elmozdításával mutassa be a kockázat becsült súlyosságát, továbbá szövegesen fejtse ki annak indokát.",
						title: "Hogyan becsüli meg a <span class='green-highlight'>kockázat súlyosságát</span>, különösen a lehetséges következményekre és a kockázatok kezelését célzó tervezett intézkedésekre való tekintettel?"
					},
					"6": {
						placeholder: "A csúszka elmozdításával mutassa be a kockázat becsült valószínűségét, továbbá szövegesen fejtse ki annak indokát.",
						title: "Hogyan becsüli meg a <span class='green-highlight'>kockázat valószínűségét</span>, különösen a fenyegető veszélyekre, a kockázatforrásokra és a kockázatok kezelését célzó tervezett intézkedésekre való tekintettel?"
					}
				},
				short_help: "Elemezze a nem kívánt adatmódosítás okait és következményeit, becsülje meg a súlyosságát és valószínűségét.",
				title: "Az adatok véletlen vagy jogellenes megváltoztatása"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Írja be a lehetséges következményeket",
						title: "Milyen főbb <span class='green-highlight'>következményekkel járna az érintettekre,</span> ha a kockázat bekövetkezne?"
					},
					"2": {
						placeholder: "Írja be a fenyegető veszélyeket",
						title: "Milyen fő <span class='green-highlight'>fenyegető veszélyek</span> idézhetik elő a kockázatot?"
					},
					"3": {
						placeholder: "Írja be kockázat forrásait",
						title: "Melyek a kockázat <span class='green-highlight'>forrásai</span>?"
					},
					"4": {
						placeholder: "Kattintson a kockázatkezelő intézkedésekre.",
						title: "A megadott <span class='green-highlight'>intézkedések</span> közül melyek szolgálnak a kockázat kezelésére?"
					},
					"5": {
						placeholder: "A csúszka elmozdításával mutassa be a kockázat becsült súlyosságát, továbbá szövegesen fejtse ki annak indokát.",
						title: "Hogyan becsüli meg a <span class='green-highlight'>kockázat súlyosságát</span>, különösen a lehetséges következményekre és a kockázatok kezelését célzó tervezett intézkedésekre való tekintettel?"
					},
					"6": {
						placeholder: "A csúszka elmozdításával mutassa be a kockázat a becsült valószínűségét, továbbá szövegesen fejtse ki annak indokát.",
						title: "Hogyan becsüli meg a <span class='green-highlight'>kockázat valószínűségét</span>, különösen a fenyegető veszélyekre, a kockázatforrásokra és a kockázatok kezelését célzó tervezett intézkedésekre való tekintettel?"
					}
				},
				short_help: "Elemezze az adatvesztés okait és következményeit, becsülje meg a súlyosságát és valószínűségét.",
				title: "Adatvesztés"
			},
			"5": {
				short_help: "Ezzel az ábrával teljes és összefoglaló képet alkothat arról, hogy a kockázatok kezelését célzó intézkedések milyen hatást fejtenek ki az általuk célzott kockázatokra.",
				title: "A kockázatok áttekintése"
			}
		},
		short_help: "Ez a menüpont lehetőséget ad az adatkezelés kockázatainak felmérésére a meglévő vagy tervezett intézkedések figyelembevételével .",
		title: "Kockázatok"
	},
	"4": {
		items: {
			"1": {
				short_help: "Az ábra segít összevetni a kockázatok elhelyezkedését egymás közt, a védelmi intézkedések alkalmazása előtt és után.",
				title: "A kockázatok feltérképezése"
			},
			"2": {
				short_help: "Készítsen részletes ütemtervet a hatásvizsgálat lefolytatása során kitűzött további intézkedésekről. Az intézkedési terv automatikusan naprakész állapotba kerül az adatvédelmi hatásvizsgálatban foglalt különböző elemek értékelésekor.",
				title: "Intézkedési terv"
			},
			"3": {
				short_help: " Mutassa be az adatvédelmi ügyekért felelős személyek (amennyiben kijelölésre került, az adatvédelmi tisztviselő) tanácsait, továbbá az érintettek vagy képviselőik véleményét.",
				title: "Adatvédelmi tisztviselő és az érintettek véleménye"
			},
			"4": {
				title: "A hatásvizsgálat jóváhagyása"
			},
			"5": {
				title: "A hatásvizsgálat elutasítása"
			}
		},
		short_help: "Ez a menüpont tartalmazza az adatvédelmi hatásvizsgálat jóváhagyásának előkészítő lépéseit.",
		title: "Jóváhagyás"
	}
};
var settings$b = {
	content: "Kérjük, adja meg a távoli szerver címét (URL):",
	title: "Beállítások",
	update: "URL frissítése"
};
var summary$b = {
	action_plan: {
		fundamental_principles: "Alapelvek",
		implementation_date: "Végrehajtás várható dátuma",
		implementation_responsible: "Végrehajtásért felelős",
		measures: "Meglévő vagy tervezett intézkedések",
		no_action_plan: "Nincs bejelentett intézkedési terv.",
		risks: "Kockázatok",
		title: "Intézkedési terv"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Mellékletek.",
	concerned_people_name: "Az érintettek véleménye.",
	concerned_people_opinion: "Az érintettek véleménye.",
	concerned_people_searched_opinion: "Érintettek véleményének kikérése.",
	concerned_people_status: "Az érintettek státusza.",
	concerned_people_unsearched_opinion_comment: "Azon ok megjelölése, ami alapján az érintettek véleményének kikérésére nem került sor.",
	content_choice: [
		"Az intézkedések megfelelőek, ennek következtében alkalmazhatóak.",
		"Az intézkedések nem megfelelőek, ezért alkalmazásukra nem kerülhet sor."
	],
	creation_date: "Létrehozás dátuma.",
	csv_action_plan_comment: "Intézkedési terv vélemények",
	csv_evaluation_comment: "Értékelés vélemények",
	csv_file_title: "intézkedési terv",
	csv_implement_date: "Teljesítés várható dátuma",
	csv_people_in_charge: "Felelős személy",
	csv_section: "Szakasz",
	csv_title_object: "Cím",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Adatvédelmi tisztviselő neve",
	dpo_opinion: "Adatvédelmi tisztviselő véleménye",
	dpo_status: "Adatvédelmi tisztviselő státusza",
	gauges: {
		"1": "Elhanyagolható",
		"2": "Korlátozott",
		"3": "Jelentős",
		"4": "Maximális"
	},
	modification_made: "Elvégzett módosítások.",
	people_search_status_nok: "Az érintettek véleményének kikérésére nem került sor.",
	people_search_status_ok: "Az érintettek véleményének kikérésére sor került.",
	pia_assessor: "Értékelő neve",
	pia_author: "Szerző neve",
	pia_name: "DPIA",
	pia_validator: "Jóváhagyó neve",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Vissza az előző oldalra",
	rejection_reason: "Elutasítás oka.",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "A kockázatok feltérképezése",
	risks_overview_title: "A kockázatok áttekintése",
	title: "DPIA-információ"
};
var users$b = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$b = {
	add_signed_pia: "Az aláírt DPIA csatolása",
	after_reading: "Az adatkezelésről készült DPIA végigolvasása után ",
	button: {
		rejection: "Jóváhagyás elutasítása",
		signed_validation: "Végleges jóváhagyás",
		simple_validation: "Előzetes jóváhagyás"
	},
	confirmation1: "Igazolom, hogy az adatkezelés körülményeinek a leírása megfelel a valóságnak.",
	confirmation2: "Igazolom, hogy a kockázatokat a tervezett és meglévő intézkedések szerint vettem tekintetbe.",
	confirmation3: "Jóváhagyom a jelzett korrekciós intézkedéseket.",
	confirmation4: "Vállalom a jelzett korrekciós intézkedések mihamarabbi megvalósítását.",
	latest_signed_attachment: "Utoljára aláírt csatolmány",
	mandatory_fields: "Minden mezőt ki kell tölteni",
	remove_attachment: "Melléklet törlése",
	responsible: "A hatásvizsgálat jóváhagyásáért felelős személy: ",
	signed_attachments_history: "Aláírt csatolmány előzmények",
	tools: {
		dashboard: "Vezérlőpult ",
		display_pia: "DPIA megjelenítése"
	},
	validated_pia_with_signature: "Jóváhagyva",
	waiting_for_signature: "A DPIA aláírásra vár"
};
var hu = {
	about: about$b,
	action_plan: action_plan$b,
	authentication: authentication$b,
	cartography: cartography$b,
	comments: comments$b,
	conflict: conflict$b,
	date: date$b,
	errors: errors$b,
	evaluations: evaluations$b,
	header: header$b,
	help: help$b,
	homepage: homepage$b,
	knowledge_base: knowledge_base$b,
	measures: measures$b,
	misc: misc$b,
	modals: modals$b,
	onboarding: onboarding$b,
	opinions: opinions$b,
	"overview-risks": {
	important: "Jelentős",
	limited: "Korlátozott",
	maximal: "Maximális",
	measures: "Intézkedések",
	negligible: "Elhanyagolható",
	potential_impacts: "Lehetséges következmények",
	"risk-access_x": "Súlyosság",
	"risk-access_y": "Valószínűség",
	"risk-change_x": "Súlyosság",
	"risk-change_y": "Valószínűség",
	"risk-disappearance_x": "Súlyosság",
	"risk-disappearance_y": "Valószínűség",
	sources: "Források",
	threat: "Fenyegető veszély"
},
	pia: pia$b,
	questions: questions$b,
	rejection_page: rejection_page$b,
	sections: sections$b,
	settings: settings$b,
	summary: summary$b,
	users: users$b,
	validation_page: validation_page$b
};

var about$a = {
	contribute: "If you wish to contribute to the translation of the software in another language or improve the existing translations, we recommend you to <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">read the page describing the steps to follow</a>.",
	description: "This tool is originally designed by the <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, the French Data Protection Authority, to help data processor to be compliant with the GDPR. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>This software is free and open. If you wish to get involved in this project, you are welcome to download the source code from Github, modify it and share it with the community.",
	licences: "Library licences:",
	title: "Informazioni",
	translators: "The PIA software is currently available in eighteen languages. The French and English versions are provided by the CNIL. The others versions result from the contributions of the following individuals:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Version number"
};
var action_plan$a = {
	acceptable_measures: "Misure accettabili",
	edit: "Modifica",
	improvable_measures: "Misure migliorabili",
	measures: "Misure esistenti o pianificate",
	no_action_plan: "Nessun piano d'azione registrato",
	placeholder_person_in_charge: "Responsabile dell'implementazione",
	principles: "Principi fondamentali",
	risk1: "Accesso illegittimo ai dati",
	risk2: "Modifiche indesiderate dei dati",
	risk3: "Perdita di dati",
	risks: "Rischi",
	title: "Panoramica"
};
var authentication$a = {
	"12_characters": "12 caratteri",
	account_recovery: "Recupera password",
	activation_code: "Codice di attivazione",
	cancel: "Annulla",
	confirm: "Conferma",
	confirmation: "Conferma",
	"continue": "Continua",
	activate_account: "Attiva account",
	create_account: "Registrati",
	create_account2: "Crea un account",
	description: "Questo software creato dall'<strong>autorità francese per la protezione dei dati (CNIL)</strong> ha lo scopo di guidare i titolari del trattamento dei dati nell'adempimento degli obblighi del GDPR. Aiuta a svolgere correttamente una valutazione dell'impatto sulla protezione dei dati facilitando l'uso del metodo sviluppato dalla CNIL per affrontare la AIIA",
	email: "Email",
	email_placeholder: "Email",
	forgotten_password: "Password dimenticata?",
	login: "Login",
	lowercase: "Minuscolo",
	password: "Password",
	password_security: "Sicurezza della password",
	recovery_code: "Resetta il codice",
	recovery_code_message: "Una email contenete un codice è stata inviata a questa email. Per favore inserisci il codice nel campo qui sotto.",
	recovery_code_not_sent: "Non hai ricevuto il codice?",
	saved_password: "La tua password è stata salvata. Ora puoi fare il login",
	sign_in: "Entra",
	sign_in_button: "Entra",
	sign_out_button: "Esci",
	special_character: "Caratteri speciali (!@#$%^&*()?...)",
	number: "Numero",
	start: "Avvio",
	start_app: "Accedi al software PIA (Beta)",
	subtitle1: "Una piattaforma per creare <br>e gestire le tue AIIA",
	subtitle2: "Accesso ai tool e glossari",
	title: "Valutazione d'impatto sulla protezione dei dati",
	transaction_error: "Impossibile processare la tua richiesta",
	uppercase: "Maiuscolo",
	wrong_activation_code: "(sbagliato)",
	wrong_confirmation: "Le password non coincidono",
	wrong_email: "Email errata",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "L'email o la password sono errate."
		},
		create_account: {
			uuid: {
				"404": "Codice di attivazione sbagliato",
				"406": "Questo account è stato già attivato"
			},
			password: {
				"404": "Utente non trovato",
				"406": "La password non soddisfa i requisiti di sicurezza."
			}
		},
		account_recovery: {
			email: {
				"404": "Utente non trovato",
				"423": "Account bloccato"
			},
			uuid: {
				"404": "Il codice di recupero è errato"
			},
			password: {
				"404": "Utente non trovato",
				"406": "La password non soddisfa i requisiti di sicurezza."
			}
		},
		unauthorized: "Non sei autorizzato ad accedere a questa risorsa.",
		incompatibility: "La versione del tuo server (pia-back) non è compatibile con la versione della tua applicazione (pia). Si prega di contattare il proprio dipartimento IT."
	}
};
var cartography$a = {
	important: "Importante",
	legend1: "Misure pianificate o esistenti",
	legend2: "Con le misure correttive implementate",
	legend3: "(A)ccesso illegittimo ai dati",
	legend4: "(M)odifiche indesiderate dei dati",
	legend5: "(P)erdita di dati",
	likelihood_axe: "Probabilità del rischio",
	limited: "Limitata",
	maximal: "Massima",
	negligible: "Trascurabile",
	risk1_access: "(A)",
	risk2_modification: "(M)",
	seriousness_axe: "Gravità del rischio"
};
var comments$a = {
	comment: "Commenta",
	written_by: "Scritto da",
	comments_count: "commenti",
	new_comment: "Commento",
	placeholder_new_comment: "Lascia un commento",
	send: "Invia"
};
var conflict$a = {
	keep_initial: "Mantieni il contenuto iniziale",
	keep_new: "Aggiorna con il nuovo contenuto",
	initial_content: "Contenuto iniziale",
	merge: "Uniusci (merge) i contenuti",
	new_content: "Nuovo contenuto",
	title: "Riscontrato conflitto"
};
var date$a = {
	april: "Aprile",
	august: "Agosto",
	december: "Dicembre",
	"earlier-in-this-month": "All'inizio di questo mese",
	"earlier-in-this-week": "All'inizio di questa settimana",
	february: "Febbraio",
	january: "Gennaio",
	july: "Luglio",
	june: "Giugno",
	march: "Marzo",
	may: "Maggio",
	november: "Novembre",
	october: "Ottobre",
	september: "Settembre",
	today: "Oggi",
	yesterday: "Ieri"
};
var errors$a = {
	content: "In caso di altri problemi o se avete suggerimenti migliorativi, <br>potete segnalarceli con questo modulo: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Pagina non trovata."
};
var evaluations$a = {
	acceptable: "Accettabile",
	action_plan_comment: "Piano d'azione / misure correttive",
	evaluation_comment: "Commento di valutazione",
	gauges: {
		"0": "(Indefinito)",
		"1": "Trascurabile",
		"2": "Limitata",
		"3": "Importante",
		"4": "Massima",
		likelihood: "Alla luce del piano d'azione, come valutate la <span class='red-highlight'>probabilità di questo rischio</span>?",
		seriousness: "Alla luce del piano d'azione, come valutate la <span class='red-highlight'>gravità di questo rischio</span>?"
	},
	improvable: "Migliorabile",
	placeholder_acceptable: "Inserite i vostri commenti per spiegare in che modo le misure implementate siano sufficienti a far fronte alle esigenze di protezione dei dati",
	placeholder_improvable1: "Inserite i vostri commenti per spiegare quali misure ulteriori devono essere aggiunte per migliorare la protezione dei dati oggetto di trattamento.",
	placeholder_improvable2: "Inserire i commenti",
	placeholder_to_correct: "Inserite i vostri commenti per spiegare perché le informazioni fornite non sono sufficienti ai fini della loro valutazione. Questa parte sarà riproposta per modifica al fine di integrare la presentazione iniziale",
	status: [
		"In sospeso",
		"Da correggere",
		"Migliorabile",
		"Accettabile"
	],
	title: "Valutazione",
	to_correct: "Da correggere"
};
var header$a = {
	archives: "Archivio PIAs",
	current_pias: "PIAs recenti",
	exit_full_screen_mode: "Premi F11 per uscire dalla modalità schermo intero.",
	help: {
		issue_reporting: "Segnala un problema",
		manual: "Manuale utente",
		pia_example_link: "Esempio AIIA",
		title: "Aiuto"
	},
	homepage_link: "Le mie PIAs",
	knowledge_base_link: "Basi di conoscenza",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Traduzioni fornite da CNIL",
		community_translations: "Traduzioni fornite da soggetti diversi",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Traduzioni revisionate da Autorità protezione dati UE",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Versione originale",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Valutazione d'impatto sulla protezione dei dati",
	structures: "Modelli AIIA",
	tools: {
		about: "Informazioni",
		accessibility: "Accessibilità per ipovedenti (colori ad alto contrasto, daltonismo)",
		onboarding: "Riavvia il tutorial",
		settings: "Impostazioni",
		url_setting: "Configurazione Server remoto",
		users: "Utenti"
	}
};
var help$a = {
	definition: {
		data1: {
			content: "Aggiornamenti in corso",
			title: "Uso dello strumento PIA"
		},
		data2: {
			qa1: {
				content: "Quando si incontrano questi errori di visualizzazione, chiudere l'applicazione e farla ripartire. Di solito ciò basta a risolvere il problema. Non perderete alcun dato inserito poiché i dati sono salvati automaticamente mentre si scrive.",
				title: "Visualizzo errori come icone bloccate in uno stato o elementi mancanti dall'interfaccia"
			},
			qa2: {
				content: "Questo problema è noto ed è in corso di risoluzione. Vi consigliamo di indicare nel campo destinato alle spiegazioni il livello stimato di gravità o probabilità e la relativa motivazione.",
				title: "Non posso modificare i gradi di valutazione della gravità e probabilità del rischio"
			},
			qa3: {
				content: "Sono stati osservati diversi bug di importazione, in particolare la scomparsa dei gradi di valutazione di gravità e probabilità del rischio. In questo caso fare riferimento alla domanda precedente. Se non visualizzate la vostra PIA sulla bacheca, ricaricate la pagina e vi comparirà.",
				title: "Incontro problemi di importazione della PIA"
			},
			qa4: {
				content: "Questo è solo un problema di visualizzazione e non ha effetti sul testo inserito. Il problema verrà risolto a breve.",
				title: "Quando faccio copia/incolla il testo appare sottolineato."
			},
			qa5: {
				content: "Per valutare una sezione, è obbligatorio riempire tutti i campi. Verificate di aver completato tutti i campi. Quando si modifica un rischio, occorre specificare almeno una misura tecnica o organizzativa che mitighi quel rischio.",
				title: "Non riesco a chiedere di valutare una sezione"
			},
			qa6: {
				content: "Chiudere e riavviare l'applicazione PIA. Il contenuto dovrebbe essere mostrato nella lingua selezionata.",
				title: "Se cambio lingua, il testo non è tradotto"
			},
			qa7: {
				content: "Per il momento, le icone di navigazione del menu a sinistra non sono ricaricate in caso sia negata la convalida della PIA. Occorre visitare nuovamente ogni sezione, verificare le informazioni e le valutazioni alla luce delle motivazioni di tale mancata convalida, e chiedere una nuova validazione. Una volta che tutte le sezioni siano state riviste, sarà possibile chiedere nuovamente la convalida della PIA.",
				title: "Ho rifiutato di convalidare un PIA ma non so cosa fare a questo punto"
			},
			title: "Problemi noti"
		},
		footer: "In caso di altri problemi o se avete suggerimenti migliorativi, potete segnalarceli tramite questo modulo <a target=\\\"_blank\\\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\\\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>"
	},
	title: "Aiuto"
};
var homepage$a = {
	cards: {
		author: "Autore",
		category: "Categoria",
		creation_status: "Inizializzazione",
		date: "Data",
		evaluation: "Revisore",
		guest: "Ospiti",
		import_pia: "Importa AIIA",
		import_structure: "Importa modello",
		item: {
			consult_pia: "Visualizza AIIA",
			consult_structure: "Consulta modello",
			edit_pia: "Modifica AIIA",
			edit_structure: "Modifica modello",
			tools: {
				action_plan: "Mostra<br>il piano d'azione",
				archive: "Archivia",
				duplicate: "Crea una copia",
				"export": "Esporta",
				more_options: "Altre opzioni",
				pia: "Mostra<br>PIA",
				remove: "Elimina",
				unarchive: "Togli dall'archivio"
			},
			validate_pia: "Convalida"
		},
		knowledges: {
			edit: "Modifica la base di conoscenza",
			"import": "Importa una base di conoscenza",
			"new": "Crea una base di conoscenza",
			placeholder_author: "Autore",
			placeholder_contributors: "Contributori",
			placeholder_entry_number: "Numero di elementi",
			placeholder_name: "Nome della base di conoscenza"
		},
		knowledges_entry: {
			all_sections: "Tutte le sezioni",
			choose_category: "Scegli una categoria",
			contents: "Contenuti",
			create: "Crea questo elemento",
			linked_to: "Collegato a",
			"new": "Crea un elemento",
			placeholder_category: "Categoria",
			placeholder_description: "Inserisci qui la tua descrizione...",
			placeholder_name: "Nome dell'elemento",
			placeholder_updated_at: "Ultimo aggiornamento"
		},
		new_pia: "Nuova AIIA",
		new_structure: "Nuovo modello",
		or: "oppure",
		pia_name: "PIA",
		placeholder_author: "Cognome, nome",
		placeholder_category: "Categoria",
		placeholder_evaluation: "Cognome, nome",
		placeholder_import_knowledgeBase: "Importa una base di conoscenza",
		placeholder_import_pia: "Importa AIIA",
		placeholder_import_structure: "Importa modello",
		placeholder_new_knowledgeBase: "Crea una nuova base di conoscenza",
		placeholder_new_pia: "Nuova AIIA",
		placeholder_new_structure: "Nuovo modello",
		placeholder_pia_name: "Nome della AIIA",
		placeholder_sector_name: "Nome del settore associato",
		placeholder_start: "Tutti i campi sono obbligatori",
		placeholder_structure: "Modello predefinito",
		placeholder_structure_name: "Titolo del modello",
		placeholder_validation: "Cognome, nome",
		sector_name: "Settore collegato",
		start: "Avvio",
		status: "Stato",
		structure: "Modello",
		structure_name: "Nome del modello",
		title_close_creation: "Chiudi",
		validation: "Validatore"
	},
	filters: {
		assessor: "Revisore",
		author: "Autore",
		card: "Mostra come schede",
		card_rocket_content: "Inizia! Per impostare <br>una PIA, clicca sul +",
		card_rocket_content_structure: "Inizia!<br><br>Per creare<br>un modello, fai click<br> sul simbolo +",
		category: "Categoria",
		date: "Data",
		import_pia: "Importa AIIA",
		import_structure: "Importa un modello",
		list: "Mostra come lista",
		list_rocket_content: "Inizia! Per impostare <br>una PIA, clicca sul +",
		list_rocket_content_structure: "Inizia! Per creare<br>un modello, fai click<br> sul simbolo +",
		name: "Nome",
		new_pia: "Nuova AIIA",
		new_structure: "Nuovo modello",
		sector_name: "Settore associato",
		sort: "Ordina",
		sort_by: "per",
		status: "Stato",
		validator: "Validatore"
	},
	lists: {
		column_actions: "Azioni",
		column_author: "Autore",
		column_category: "Categoria",
		column_creation: "Creato",
		column_evaluation: "Revisore",
		column_pia: "PIA",
		column_progression: "Avanzamento",
		column_sector_name: "Settore associato",
		column_status: "Stato",
		column_structure: "Modello",
		column_structure_name: "Modello",
		column_updated_at: "Cronologia",
		column_validation: "Validatore",
		item: {
			tools: {
				action_plan: "Mostra il piano d'azione",
				archive: "Archivia",
				consult: "Visualizza",
				duplicate: "Crea una copia",
				edit: "Modifica",
				"export": "Esporta",
				pia: "Mostra AIIA",
				remove: "Elimina",
				unarchive: "Togli dall'archivio"
			}
		}
	},
	search_filter: "Cerca",
	no_entries: {
		pia: "Non è stata creata e/o assegnata una AIIA",
		archive: "Nessun archivio PIA"
	}
};
var knowledge_base$a = {
	add_measure: "Aggiungi",
	add_measure_hint: "È possibile aggiungere anche una misura dall'archivio.",
	category: {
		definition: "Definizione",
		example: "Esempio",
		general_measure: "Misure generali di sicurezza dei sistemi ",
		measure_on_data: "Misure applicate ai dati ",
		method: "Metodologia",
		organizational_measure: "Misure organizzative",
		principle: "Principio"
	},
	choose_knowledge_base: "Scegli la tua base di conoscenza",
	default_knowledge_base: "Base di conoscenza del CNIL",
	filters: {
		all: "Tutti",
		definitions: "Definizioni",
		general_measures: "Misure generali di sicurezza dei sistemi",
		measures_on_data: "Misure applicate ai dati",
		no_result: "Nessun risultato trovato.",
		organizational_measures: "Misure organizzative",
		title: "Filtri"
	},
	placeholder_add_measure: "Aggiungi questa misura",
	placeholder_help: "Guida all'inserimento",
	search: "Ricerca",
	slugs: {
		PIA_DEF_ACC: {
			description: "L'interessato ha diritto di ottenere dal titolare del trattamento la conferma che sia o meno in corso un trattamento di dati personali che lo riguardano e, in tal caso, di ottenere l'accesso ai dati personali e altre informazioni specificate nell'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 15 del [GDPR]</a>.<br>Disposizioni particolari si applicano all'accesso ai dati sanitari, in base al diritto nazionale, e anche all'esercizio del diritto di accesso da parte dei titolari della potestà genitoriale, per i minori, ovvero da parte del rappresentante legale, per i soggetti sottoposti a misure di tutela",
			name: "Diritto di accesso",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "L'anonimizzazione mira a eliminare il carattere identificativo dei dati personali. L'approccio all'anonimizzazione deve essere definito caso per caso in rapporto agli utilizzi previsti. Per meglio valutare la bontà di un approccio di anonimizzazione, il <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_fr.pdf\">G29</a> propone tre criteri :<br>- <strong>Individuazione: </strong>resta possibile distinguere un individuo all'interno di un gruppo?<br>- <strong>Correlabilità: </strong>è possibile collegare reciprocamente insiemi di dati distinti riferiti a uno stesso individuo?<br>- <strong>Deduzione:</strong> è possibile dedurre informazioni su un determinato individuo? <br>Pertanto: <strong>un insieme di dati rispetto ai quali non siano possibili né l'individuazione né la correlazione o la deduzione è, a priori, un insieme anonimo</strong>;<br>un insieme di dati rispetto ai quali <strong>non sia rispettato anche solo uno dei tre criteri suddetti </strong>potrà essere considerato anonimo solo in base a un'analisi dettagliata dei rischi di reidentificazione.",
			name: "Anonimizzazione",
			source: "WIKI, site CNIL pour la description des recommandations du G29 https://www.cnil.fr/fr/le-g29-publie-un-avis-sur-les-techniques-danonymisation-0"
		},
		PIA_DEF_ARCH: {
			description: "I dati che non sono più di utilizzo corrente, ma il cui periodo di conservazione non è ancora terminato, per esempio poiché sono conservati in previsione di eventuali contenziosi, dovrebbero essere archiviati.<br><br><strong>Gli archivi devono essere protetti </strong>in particolare se i dati archiviati sono dati sensibili ovvero se possono comportare gravi effetti negativi per gli interessati.",
			name: "Archiviazione",
			source: "Guide Bleu 2017 p17"
		},
		PIA_DEF_AUTH: {
			description: "L'autenticazione è una<strong>operazione con cui l'utente fornisce prova della propria identità</strong>, attraverso vari meccanismi classificati in base agli elementi utilizzati:<br>- qualcosa che l'utente conosce, per esempio una password ;<br>- qualcosa che l'utente detiene, per esempio una tessera a microchip ;<br>- una caratteristica propria dell'utente, per esempio un'impronta digitale o le caratteristiche grafometriche della sua firma.<br><strong>Si definisce 'forte' una procedura di autenticazione dell'utente basata sulla combinazione di almeno due degli elementi sopra indicati.</strong>",
			name: "Autenticazione",
			source: "Guide Bleu p7"
		},
		PIA_DEF_CHIF: {
			description: "La cifratura di un messaggio permette di garantire che solo il mittente e il/i destinatari(o) di tale messaggio ne conosca(no) il contenuto. Si tratta di una sorta di busta digitale sigillata. Una volta cifrato, se non si dispone della chiave specifica, il messaggio resta inaccessibile e illeggibile sia per le persone sia per le macchine.<br>Si distingue fra cifratura (o crittografia) simmetrica e cifratura (o crittografia) asimmetrica.<br>- <strong>La cifratura simmetrica</strong> consente di cifrare e decifrare un determinato contenuto utilizzando una sola chiave, detta in tal caso 'chiave segreta'. La cifratura simmetrica ha il pregio della rapidità, ma mittente e destinatario devono concordare una chiave segreta comune, ovvero devono utilizzare un diverso canale per trasmettersi reciprocamente tale chiave. La scelta del canale di trasmissione richiede particolare cautela per evitare che terzi malintenzionati entrino in possesso della chiave violando, quindi, la riservatezza del messaggio.<br>- <strong>La cifratura asimmetrica</strong> prevede che il (futuro) destinatario sia provvisto di una coppia di chiavi (chiave privata e chiave pubblica) e consenta ai potenziali mittenti di accedere alla sua chiave pubblica. In tal caso, il mittente usa la chiave pubblica del destinatario per cifrare il messaggio, e parallelamente il destinatario utilizzerà la sua chiave privata per decifrarlo. Fra i vantaggi di tale sistema, c'è il fatto che la chiave pubblica può essere pubblicata ed è di dominio pubblico. Tuttavia, occorre che i mittenti si fidino dell'origine della chiave pubblica, e siano certi che si tratti effettivamente della chiave pubblica del destinatario. Un altro vantaggio è che non vi è più necessità di condividere una stessa chiave segreta: la cifratura asimmetrica permette di evitarlo, ma è più lenta.",
			name: "Cifratura",
			source: "Guide Bleu 2017 p23 https://www.cnil.fr/fr/comprendre-les-grands-principes-de-la-cryptologie-et-du-chiffrement"
		},
		PIA_DEF_CLO: {
			description: "Metodiche che riducono la possibilità di correlazioni fra i dati personali e di una compromissione a carico della totalità dei dati.<br>Per esempio, si potranno  identificare i dati specifici per ogni attività separandoli logicamente, ecc.",
			name: "Partizionamento dei dati",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Qualsiasi manifestazione di volontà libera, specifica, informata e inequivocabile dell'interessato con la quale lo stesso manifesta il proprio assenso, mediante dichiarazione o azione positiva inequivocabile, che i dati personali che lo riguardano siano oggetto di trattamento. Vedi <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 4.10 del [GDPR]</a>",
			name: "Consenso dell'interessato",
			source: "GDPR Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Consiste nel limitare i rischi di accesso di persone non autorizzate ai dati personali in forma digitale. Per fare ciò è consigliabile - <strong> definire profili di autorizzazione </strong> nei sistemi separando le attività e le aree di responsabilità per limitare l'accesso degli utenti ai soli dati strettamente necessari per portare a termine i rispettivi compiti. <br>- <strong> rimuovere le autorizzazioni di accesso non appena un utente cessi di essere abilitato ad accedere a una risorsa locale o IT</strong>, ovvero <strong>allo scadere del contratto </strong> <br>- <strong> Realizzare una revisione annuale delle abilitazioni </strong> per identificare ed eliminare gli account non utilizzati e riallineare i privilegi concessi alle funzioni di ciascun utente.",
			name: "Controllo degli accessi logici",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Qualsiasi informazione riguardante una persona fisica identificata o identificabile (di seguito \"interessato\"); si considera identificabile la persona fisica che può essere identificata, direttamente o indirettamente, in particolare con riferimento a un identificativo come il nome, un numero di identificazione, dati relativi all'ubicazione, un identificativo online o a uno o più elementi caratteristici della sua identità fisica, fisiologica, genetica, psichica, economica, culturale o sociale.\nVedi <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 4.1 del [GDPR]</a>",
			name: "Dati personali",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "La persona fisica o giuridica, l'autorità pubblica, il servizio o un altro organismo che riceve comunicazione di dati personali, che si tratti o meno di terzi. Tuttavia, le autorità pubbliche che possono ricevere comunicazione di dati personali nell'ambito di una specifica indagine conformemente al diritto dell'Unione o degli Stati membri non sono considerate destinatari. Il trattamento di tali dati da parte di dette autorità pubbliche è conforme alle norme applicabili in materia di protezione dei dati secondo le finalità del trattamento. \nVedi <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">Art. 4.9 del [GDPR]</a>",
			name: "Destinatario",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "L'interessato ha il diritto di ottenere dal titolare del trattamento la cancellazione dei dati personali che lo riguardano senza ingiustificato ritardo e il titolare del trattamento ha l'obbligo di cancellare senza ingiustificato ritardo tali dati personali in conformità con l'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 17 del [GDPR]</a>",
			name: "Diritto alla cancellazione (diritto all'oblio)",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Le motivazioni che portano all'attuazione del trattamento, i benefici attesi (per l'organizzazione, per gli interessati, per la società in generale).",
			name: "Risultati attesi dal trattamento",
			source: "PIA1 p4 nota 8"
		},
		PIA_DEF_EXA: {
			description: "I dati personali devono essere esatti e, ove necessario, aggiornati; devono essere adottate tutte le misure ragionevoli per cancellare o rettificare tempestivamente i dati personali inesatti rispetto alle finalità per le quali sono trattati  (esattezza), in conformità con <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 5.1 d) del [GDPR]</a>",
			name: "Qualità dei dati",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "La gravità rappresenta l'entità del rischio. Dipende principalmente dalla natura pregiudizievole del potenziale impatto.",
			name: "Gravità",
			source: "PIA1 pg 6"
		},
		PIA_DEF_LIM: {
			description: "L'interessato ha il diritto di ottenere dal titolare del trattamento la limitazione del trattamento, vedi l'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 18 del [GDPR]</a>",
			name: "Diritto di limitazione del trattamento",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Meccanismo che consente di registrare le operazioni effettuate sul sistema informatico al fine di <strong>identificare un accesso abusivo</strong> ovvero <strong>un utilizzo abusivo</strong> di dati personali, oppure per stabilire la causa di un incidente. È opportuno tenere traccia di alcune delle operazioni effettuate sui sistemi informatici; a tale scopo, occorre implementare un meccanismo di gestione dei log (le tracce) e degli incidenti che sia in grado di <strong>registrare gli eventi pertinenti</strong> e <strong>garantire l'inalterabilità di tali registrazioni.</strong> In ogni caso, si deve evitare di <strong>conservare queste informazioni per un periodo eccessivo.</strong>",
			name: "Logging",
			source: "Guide Bleu 2017 p10"
		},
		PIA_DEF_MEN: {
			description: "Modalità operativa comprendente una o più azioni individuali sulle risorse che supportano i dati. La minaccia può essere utilizzata, intenzionalmente o meno, da fonti di rischio e può quindi causare un evento pericoloso.",
			name: "Minaccia",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Minacce relative a: <br>- <strong> Hardware </strong>, utilizzato in modo improprio, violato, modificato o smarrito (utilizzo di supporti multimediali contenenti dati sensibili per motivi personali o durante un trasporto per il quale non sono idonei, osservazione di una schermata, aggiunta di un hardware destinato a recuperare dati, ecc.)<br>- <strong> Software </strong> utilizzato in modo improprio, violato o alterato (innalzamento di privilegi, raccolta di dati di configurazione, installazione di uno strumento di controllo da remoto ecc.) <br>- <strong> Canali informatici </strong> che vengono violati (intercettazioni dei flussi di rete, ecc.) <br>- <strong> Persone </strong> sorvegliate, fuorviate o sfuggite al controllo (divulgazione involontaria, a seguito di pressioni o phishing, passaggio ad altro datore di lavoro ecc.) <br>- <strong> Documenti cartacei </strong> violati o smarriti (fotocopie, scansioni dimenticate, acquisizione di documenti scartati, furto di plichi postali, ecc.) <br>- <strong> Canali cartacei</strong> che possono essere violati",
			name: "Minacce che possono dar luogo a un accesso illegittimo ai dati",
			source: "PIAF Oggetti Connessi p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "Minacce relative a: <br>- <strong>Hardware</strong> utilizzato in modo improprio, sovraccaricato, modificato, danneggiato, smarrito (sovraccarico di memoria, attacco DoS, modifiche che generano un guasto, incendio, furto o smarrimento ecc.) <br>- <strong> Software </strong> utilizzato in modo improprio, sovraccaricato, modificato, danneggiato, smarrito (cancellazione di dati, iniezione di dati, bomba logica), licenza non rinnovata ecc.) <br>- <strong> Canali informatici </strong> : sovraccaricati, danneggiati, persi (download non autorizzato, blocco dell'accesso a Internet, ecc.)<br>Persone </strong> : oberate di lavoro, deteriorate, sfuggite al controllo (errato utilizzo delle competenze, assenza, dimissioni, ecc.) <br>- <strong>Documenti Cartacei </strong>usati in modo improprio, deteriorati, persi (cancellazione, distruzione, furto o smarrimento ecc.) <br>- <strong>Canali cartacei </strong> deteriorati, modificati, persi (scioperi postali, cambio di sede, scomparsa di porta-documenti, riorganizzazione, ecc.)",
			name: "Minacce che possono dar luogo all'indisponibilità di dati personali",
			source: "PIAF Oggetti Connessi p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "Minacce relative a: <br>- <strong> Hardware </strong> che è stato alterato (aggiunta di hardware incompatibile, rimozione di un elemento indispensabile, ecc.) <br>- <strong> Software </strong> utilizzato in modo improprio o alterato (errori di gestione, modifiche inappropriate ecc.) <br>- <strong> Canali informatici </strong> utilizzati in modo improprio (intercettazione di flussi di ritorno, ecc.) <br>- <strong> Persone </strong> oberate di lavoro o fuorviate (attività non controllata, turbative delle condizioni di lavoro, influenze esterne, ecc.) <br>- Documenti cartacei oggetto di alterazioni (modifiche apportate a un documento, sostituzione con un falso ecc.) <br>- <strong> Canali cartacei </strong> oggetto di alterazioni (scambio di fascicoli, invio di messaggi contraddittori ecc. )",
			name: "Minacce che possono dar luogo a modifiche illegittime di dati personali",
			source: "PIAF Oggetti Connessi p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Da scegliere tra quelle disponibili nella sezione \"Misure pianificate o esistenti\", e che possono essere integrate se necessario.",
			name: "Misure",
			source: "Nessuna"
		},
		PIA_DEF_MIN1: {
			description: "Quando i dati sono importati, possono essere raccolti involontariamente vari tipi di metadati (come dati EXIF allegati ad una immagine). <br>Tali metadati devono essere identificati ed eliminati se non sono necessari per le specifiche  finalità.",
			name: "Filtraggio e rimozione",
			source: "PIAF Oggetti Connessi p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Dopo aver ricevuto dati sensibili, in quanto parte di un set di informazioni generali ovvero trasmessi solo a fini statistici, questi possono essere convertiti in un modulo meno sensibile oppure essere pseudonimizzati, per esempio: <br>- se il sistema raccoglie l'indirizzo IP per determinare la posizione dell'utente a fini statistici, l'indirizzo IP può essere eliminato una volta dedotti la città o il quartiere <br>- se il sistema riceve dati video da telecamere di sorveglianza, può riconoscere le persone immobili o in movimento nella scena e sfocarle; <br>- se il sistema è un contatore intelligente, può aggregare i dati sul consumo energetico lungo un determinato arco temporale senza registrarli in tempo reale",
			name: "Riduzione della sensibilità tramite conversione",
			source: "PIAF Oggetti Connessi p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Il sistema può consentire che: <br>- l'utente utilizzi una risorsa o un servizio senza rivelare la propria identità (dati anonimi) <br>- l'utente utilizzi una risorsa o un servizio senza rivelare la propria identità, ma rimanendo identificabile e responsabile di tale utilizzo (dati pseudonimi) <br>- l'utente effettui molteplici utilizzi di risorse o servizi senza che tali utilizzi siano reciprocamente correlati (dati non correlabili) <br>- l'utente utilizzi una risorsa o un servizio senza che altri, in particolare terze parti, siano in grado di osservare che la risorsa o il servizio è in uso (non osservabilità).<br>La scelta di un metodo fra quelli sopra elencati deve dipendere dalle minacce identificate e, per alcuni tipi di minacce alla riservatezza, la pseudonimizzazione sarà più idonea dell'anonimizzazione (ad esempio se vi sono esigenze di tracciabilità). Inoltre, alcune minacce alla privacy saranno affrontate associando più metodi",
			name: "Riduzione della natura identificativa dei dati",
			source: "PIAF Oggetti Connessi p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Il sistema può essere strutturato in parti (partizioni) indipendenti con funzioni distinte di controllo degli accessi. I dati possono anche essere distribuiti tra questi sottosistemi indipendenti ed essere controllati da ciascun sottosistema utilizzando diversi meccanismi di controllo degli accessi. In questo modo, se un sottosistema subisce una compromissione, possono essere ridotti gli impatti sul set complessivo di dati.",
			name: "Ridurre l'accumulazione dei dati",
			source: "PIAF Oggetti Connessi p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Il sistema può limitare l'accesso ai dati in base al principio detto 'need to know'. Il sistema può separare i dati sensibili e applicare politiche specifiche di controllo degli accessi.<br>Il sistema può, inoltre, crittografare i dati sensibili per proteggerne la riservatezza durante la trasmissione e l'archiviazione. Dovrebbe essere protetto anche l'accesso ai file temporanei nascosti che vengono generati durante l'elaborazione dei dati.",
			name: "Restrizioni d'accesso ai dati",
			source: "PIAF Oggetti Connessi p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Ridurre la gravità dei rischi limitando la raccolta di dati personali a ciò che è strettamente necessario in relazione a una finalità definita. Evitare la raccolta di dati non necessari, l'utilizzazione di dati che non sono correlati alla finalità, e impatti eccessivi sulle persone.",
			name: "Minimizzazione della raccolta di dati personali",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Ridurre la gravità dei rischi minimizzando i dati in quanto tali, attraverso misure volte a ridurne la sensibilità.",
			name: "Minimizzazione dei dati in quanto tali",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_OPP: {
			description: "L'interessato ha il diritto di opporsi in qualsiasi momento, per motivi connessi alla sua situazione particolare, al trattamento dei dati personali che lo riguardano in conformità con l'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 21 del [GDPR]</a>",
			name: "Diritto di opposizione",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Procedura implementata per integrare la protezione dei dati personali in ogni nuova attività di trattamento (certificazioni, norme di riferimento, gestione dei rischi per gli interessati sulla base di metodi indicati dal Garante o di approcci interni, ecc.).",
			name: "Gestione di progetto",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Persona alla quale si riferiscono i dati oggetto del trattamento.",
			name: "Interessato",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: "Gli interessati hanno il diritto di ricevere in un formato strutturato, di uso comune e leggibile da un dispositivo automatico i dati personali che li riguardano forniti a un titolare del trattamento, e hanno il diritto di trasmettere tali dati a un altro titolare del trattamento senza impedimenti da parte del titolare del trattamento cui i dati personali sono stati comunicati, alle condizioni descritte nell'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 20 del [GDPR]</a>",
			name: "Diritto alla portabilità dei dati",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Trattamento dei dati personali in modo tale che i dati personali non possano più essere attribuiti a un interessato specifico senza l'utilizzo di informazioni aggiuntive, a condizione che tali informazioni aggiuntive siano conservate separatamente e soggette a misure tecniche e organizzative intese a  garantire che i dati personali non siano attribuiti a una persona fisica identificata o identificabile. <br>La pseudonimizzazione riduce il rischio di correlazione di un set di dati con l'identità originale di un individuo,<strong> è un'utile misura di sicurezza, ma non un metodo di anonimizzazione</strong>",
			name: "Pseudonimizzazione",
			source: "GDPR Art. 4.5 e linee guida G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_it.pdf"
		},
		PIA_DEF_PWD: {
			description: "L'autenticazione basata sull'impiego di un identificativo e di una password rappresenta una metodica semplice e non costosa per il controllo degli accessi. Tuttavia, è una metodica caratterizzata da un basso livello di sicurezza.<br>Le indicazioni fornite dal Garante quanto a dimensioni e complessità delle password variano in rapporto alle misure ulteriori implementate per rafforzare il processo di autenticazione.<br>Per esempio, se la procedura di autenticazione si fonda esclusivamente sull'impiego di una password, allora si dovrà utilizzare almeno una password complessa, di lunghezza adeguata, comprendente caratteri alfanumerici, maiuscoli e minuscoli.  In presenza di misure ulteriori associate all'utilizzo di una password (limitazioni all'accesso, raccolta di altri dati, impiego di supporti in possesso dell'utente) si potranno ridurre lunghezza e complessità della password poiché tali misure offrono un livello di sicurezza equivalente all'impiego della sola password.",
			name: "Password",
			source: "Guide Bleu 2017 p7: https://www.cnil.fr/fr/authentification-par-mot-de-passe-les-mesures-de-securite-elementaires"
		},
		PIA_DEF_RECT: {
			description: "L'interessato ha il diritto di ottenere dal titolare del trattamento la rettifica dei dati personali inesatti che lo riguardano senza ingiustificato ritardo. <br>Tenuto conto delle finalità del trattamento, l'interessato ha il diritto di ottenere l'integrazione dei dati personali incompleti, anche fornendo una dichiarazione integrativa.",
			name: "Diritto di rettifica",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Regolamento relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati ( <a target=\\\"_blank\\\" href=\\\"http://eur-lex.europa.eu/legal-content/IT/TXT/PDF/?uri=CELEX:32016R0679&from=IT\\\">UE 2016-679</a> ) adottato il 27 Aprile 2016 dall'Unione Europea e che entrerà in vigore il 25/05/2018, abrogando la direttiva 95/46/CE.",
			name: "GDPR (Regolamento generale sulla protezione dei dati)",
			source: "Titolo GDPR"
		},
		PIA_DEF_RT: {
			description: "La persona fisica o giuridica, l'autorità pubblica, il servizio o altro organismo che, singolarmente o insieme ad altri, determina le finalità i mezzi del trattamento; quando le finalità e i mezzi di tale trattamento sono determinati dal diritto dell'Unione o degli Stati membri, il titolare del trattamento o i criteri specifici applicabili alla sua designazione possono essere stabiliti dal diritto dell'Unione o degli Stati membri.<br>Per maggiori informazioni sugli obblighi del titolare del trattamento vedi <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 4.7 del [GDPR]</a>",
			name: "Titolare del trattamento",
			source: "GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Persona, interna o esterna all'organismo o all'ente, operante in via accidentale o intenzionale (esempio: amministratore IT, utente, attaccante esterno, concorrente),  o fonte non umana (acqua, materiali pericolosi, virus informatici generici) che può essere all'origine di un rischio.",
			name: "Fonte di rischio",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "La persona fisica o giuridica, l'autorità pubblica, il servizio o altro organismo che tratta dati personali per conto del titolare del trattamento, vedi  <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">Art. 4.8 del [GDPR]</a>.<br>Il responsabile del trattamento e chiunque agisca sotto la sua autorità o sotto quella del titolare del trattamento, che abbia accesso a dati personali, non può trattare tali dati se non è istruito in tal senso dal titolare del trattamento, salvo che lo richieda il diritto dell'Unione o di uno Stato membro. Vedi l'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 29 del [GDPR]</a>.",
			name: "Responsabile del trattamento",
			source: "GDPR Art. 4.8 e 29"
		},
		PIA_DEF_SUPT: {
			description: "<strong>Materiali e supporti elettronici per i dati</strong> : computer, reti di comunicazioni, chiavi USB, hard disk...<br><strong>Software</strong> : sistemi operativi, sistemi di messaggistica, basi di dati, applicativi...<br><strong>Canali informatici</strong> : cavi, WiFi, fibra ottica<br><br><strong>Persone fisiche</strong> : utenti, amministratori IT, decisori...<br><strong>Supporti cartacei</strong> : pubblicazioni a stampa, fotocopie, manoscritti...<br><strong>Canali di trasmissione cartacei</strong> : spedizione postale, circuiti di validazione...",
			name: "Tipologia dei supporti dei dati",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Violazione di sicurezza che comporta accidentalmente o in modo illecito la distruzione, la perdita, la modifica, la divulgazione non autorizzata o l'accesso non autorizzato ai dati personali trasmessi, conservati o altrimenti trattati.",
			name: "Violazione dei dati personali",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "La probabilità esprime la possibilità che un rischio si realizzi. Dipende principalmente dal livello di vulnerabilità delle risorse di supporto quando sottoposte alle minacce e dalla capacità delle fonti di rischio di sfruttare tali vulnerabilità.",
			name: "Probabilità",
			source: "PIA1 pg 6"
		},
		PIA_EX_DC: {
			description: "Dati utilizzati per un sistema di scoring, risultato dell'applicazione di scoring...",
			name: "Dati di calcolo"
		},
		PIA_EX_DCPC: {
			description: "<strong>Dati identificativi</strong>: stato civile, età, cittadinanza, doppia cittadinanza, indirizzo postale, capacità giuridica ecc. <br><strong>Vita personale</strong>: stato civile, numero di figli, residenza, tipo di abitazione, situazione alloggiativa, durata della situazione alloggiativa, categoria socio-professionale, ecc. <br><strong>Vita professionale</strong>: occupazione, tipo di contratto, categoria socio-professionale, nome del datore di lavoro, anzianità lavorativa, disoccupazione ecc. <br><strong>Dati di ubicazione</strong>: spostamenti, dati GPS, GSM ecc. <br><strong>Altro</strong>: numero di telefono, indirizzo email, ecc.",
			name: "Dati personali comuni",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Opinioni filosofiche, politiche, religiose, sindacali, vita sessuale, dati sanitari, origine razziale o etnica, dati relativi alla salute o alla vita sessuale, reati, condanne, misure di sicurezza <br>Vedi gli <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">artt. 9 e 10 del [GDPR]</a>.",
			name: "Dati relativi a reati e dati personali sensibili"
		},
		PIA_EX_DCPS: {
			description: "Codice Fiscale, Dati Biometrici, Dati Bancari",
			name: "Dati personali percepiti come sensibili"
		},
		PIA_EX_HUME: {
			description: "Possono essere: <br>- una terza parte malintenzionata o ignara che sfrutta la sua vicinanza fisica per accedere fraudolentemente al servizio <br>- un attaccante che prende di mira un utente sfruttando la sua conoscenza dell'utente e alcune informazioni su quest'ultimo <br>- un attaccante che prende di mira una delle società incaricate del trattamento sfruttando la sua conoscenza di tali società, così da consentirgli di minarne l'immagine <br>- una terza parte autorizzata che sfrutta i privilegi di accesso per accedere illegittimamente alle informazioni. Le motivazioni possono essere molteplici: dallo scherzo alla molestia, fino al dolo, alla vendetta, allo spionaggio, alla speranza di lucro, all'acquisizione di dati per fini di ulteriore sfruttamento.",
			name: "Fonti umane esterne"
		},
		PIA_EX_HUMI: {
			description: "Possono essere: <br>- un dipendente malintenzionato che usa la sua vicinanza al sistema, le sue competenze, i suoi privilegi e un tempo a disposizione potenzialmente considerevole, ovvero un dipendente che si renda responsabile di una negligenza a  causa di un'insufficiente formazione e sensibilizzazione. <br>- un utente o il suo entourage, negligente o malintenzionato, che ha accesso al servizio. <br>Le motivazioni possono essere molteplici: confusione, errore, negligenza, vendetta, volontà di provocare allarme, malevolenza, possibilità di lucro, spionaggio",
			name: "Fonti umane interne"
		},
		PIA_EX_IMPI: {
			description: "Gli interessati potrebbero subire  conseguenze significative, che dovrebbero essere in grado di superare, ma con difficoltà reali e significative <br>Esempi di impatti: <br>- fisici: grave affezione fisica che provochi danni a lungo termine (aggravamento dello stato di salute a seguito di una errata assunzione di responsabilità o del mancato rispetto di controindicazioni), alterazione dell'integrità fisica, ecc. <br>- materiali: perdite monetarie non indennizzate, perdita di opportunità uniche e non ricorrenti (mutui immobiliari, studi, tirocini o occupazioni, interdizione da esami scolastici), perdita dell'abitazione, del posto di lavoro, ecc. <br>- psicologici: grave disturbo psicologico (depressione, fobie), senso di violazione della privacy e di un danno irreparabile, esposizione a ricatti, cyberbullismo e molestie psicologiche, ecc.",
			name: "Impatto significativo"
		},
		PIA_EX_IMPL: {
			description: "Gli interessati potrebbero sperimentare inconvenienti significativi, superabili nonostante alcune difficoltà. <br>Esempi di impatti: <br>- fisici: minore affezione fisica (es: malattia lieve a seguito del mancato rispetto di  controindicazioni), diffamazione che dia luogo a rappresaglie fisiche, ecc. <br>- materiali: pagamenti non pianificati (ad esempio multe non dovute), negazione dell'accesso a servizi amministrativi o commerciali, pubblicità online mirata su un aspetto di vita privata che la persona voleva mantenere riservata ecc. <br>- psicologici: disturbo psicologico minore ma oggettivo, senso di violazione della privacy senza danni irreparabili, intimidazione sui social network ecc.",
			name: "Impatto limitato"
		},
		PIA_EX_IMPM: {
			description: "Gli interessati potrebbero sperimentare conseguenze significative, anche irrimediabili, che potrebbero non superare. <br>Esempi di impatti: <br>- fisici: affezione fisica a lungo termine o permanente, alterazione permanente dell'integrità fisica, decesso <br>- materiali: rischio finanziario, indebitamento ingente, impossibilità di lavorare, incapacità di ricollocazione, smarrimento di elementi di prova nell'ambito di un  contenzioso, perdita di accesso a infrastrutture vitali (acqua, elettricità, ecc. <br>- psicologici: disturbo psicologico a lungo termine o permanente, sanzione penale, allontanamento, perdita di legami familiari, perdita della capacità di agire, cambio di stato amministrativo e/o perdita dell'autonomia legale (tutela) ecc.",
			name: "Impatto massimo"
		},
		PIA_EX_IMPN: {
			description: "Gli interessati non subiranno alcun impatto o potrebbero incontrare qualche inconveniente, superabile senza difficoltà<br>Esempi: <br>- impatti fisici: mal di testa passeggero <br>- impatti materiali: perdita di tempo dovuta a ripetizione delle procedure o all'attesa della loro effettuazione,  riutilizzo dei dati a scopo di pubblicità mirata per beni di consumo corrente ecc. <br>- impatti psicologici: semplice fastidio, impressione di violazione della privacy senza danno reale (intrusione commerciale) ecc.",
			name: "Impatto trascurabile"
		},
		PIA_EX_NHUM: {
			description: "Possono essere un incidente o un sinistro verificatosi presso uno dei soggetti incaricati del trattamento (interruzioni di corrente, incendio, inondazione, ecc.)",
			name: "Fonti non umane"
		},
		PIA_EX_VRAI: {
			description: "Appare possibile che le fonti di rischio considerate concretizzino una minaccia basandosi sulle caratteristiche dei supporti (ad esempio: furto di supporti cartacei conservati in uffici dell'organizzazione ove l'accesso è controllato da un incaricato all'ingresso).",
			name: "Probabilità significativa"
		},
		PIA_EX_VRAL: {
			description: "Appare difficile che le fonti di rischio considerate concretizzino una minaccia basandosi sulle caratteristiche dei supporti (ad esempio: furto di supporti cartacei conservati in un locale dell'organizzazione il cui accesso è controllato tramite badge).",
			name: "Probabilità limitata"
		},
		PIA_EX_VRAM: {
			description: "Appare estremamente facile per le fonti di rischio considerate concretizzare una minaccia basandosi sulle caratteristiche dei supporti (ad esempio: furto di supporti cartacei conservati in un locale dell'organizzazione pubblicamente accessibile).",
			name: "Probabilità massima"
		},
		PIA_EX_VRAN: {
			description: "Appare impossibile che le fonti di rischio considerate concretizzino una minaccia basandosi sulle caratteristiche dei supporti (ad esempio: furto di supporti cartacei conservati in un locale dell'organizzazione il cui accesso è controllato tramite badge e codice d'ingresso).",
			name: "Probabilità trascurabile"
		},
		PIA_LGL_CONS: {
			description: "Si tratta di permettere ai soggetti interessati di dare un consenso libero, specifico e informato; verificare che una delle basi legali del trattamento sia il consenso, come previsto all'art. 6 del <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">[GDPR]</a>",
			name: "Consenso della persona interessata",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Definire e descrivere l'ambito in dettaglio: <br>- i dati personali in questione, i loro destinatari e i periodi di conservazione <br>- descrizione dei processi e delle risorse dedicate alla gestione dei dati personali per l'intero ciclo di vita dei dati stessi (dalla raccolta alla cancellazione). ",
			name: "Dati oggetto di trattamento",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Fornire una breve descrizione del trattamento in esame, la sua natura, le finalità, il contesto, le relative problematiche. Identificare il titolare del trattamento e gli eventuali responsabili. Elencare le regole o gli standard di riferimento applicabili al trattamento, sia utili sia obbligatori, in particolare i codici di condotta approvati (vedi Art. 40 del <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">[GDPR]</a>) e le certificazioni inerenti la protezione dei dati (vedi art. 42 del <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">[GDPR]</a>)",
			name: "Descrizione del trattamento",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Persona fisica o giuridica, autorità pubblica, servizio o qualsiasi altro organismo che riceve comunicazione di dati personali, indipendentemente dal fatto che si tratti di un terzo. Tuttavia le autorità pubbliche che possono ricevere comunicazione di dati personali nel corso di una determinata indagine in conformità col diritto dell'Unione o di uno Stato membro non sono considerate destinatari; il trattamento di tali dati da parte delle autorità pubbliche in questione è conforme alle norme sulla protezione dei dati applicabili in base alle finalità del trattamento. Vedi l'art. 4.9 del <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">[GDPR]</a>",
			name: "Destinatario",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "Deve essere definito un periodo di conservazione per ciascun tipo di dato motivandolo in rapporto alle esigenze del trattamento e/o all'esistenza di vincoli di legge. Occorre distinguere tra dati correnti e dati archiviati, il cui accesso sarà limitato ai soli soggetti interessati. È necessario implementare un meccanismo di soppressione per archiviare i dati correnti o eliminare i dati archiviati al termine del loro periodo di conservazione. Inoltre è necessario eliminare le tracce funzionali e i log tecnici che non possono essere conservati a tempo indeterminato",
			name: "Periodo di conservazione",
			source: "PIAF Oggetti Connessi p12"
		},
		PIA_LGL_FIN: {
			description: "I dati personali devono essere raccolti per scopi specificati, espliciti e legittimi e <strong> non ulteriormente trattati in modo incompatibile con tali scopi.</strong> <br>Vedi l'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 5.1 b) del [GDPR]</a>",
			name: "Finalità della raccolta e dell'utilizzazione dei dati",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- L'interessato ha acconsentito al trattamento dei propri dati personali per uno o più scopi specifici. <br>- Il trattamento è necessario per l'esecuzione di un contratto di cui l'interessato è parte o per l'esecuzione di misure adottate su richiesta dell'interessato prima di stipulare un contratto  <br>- Il trattamento è necessario per adempiere a un obbligo legale a cui è soggetto il titolare del trattamento <br><br>-  Il trattamento è necessario per tutelare gli interessi vitali dell'interessato o di un'altra persona fisica <br>- Il trattamento è necessario per l'esecuzione di un compito svolto nell'interesse pubblico o connesso all'esercizio di pubblici poteri conferiti al titolare del trattamento <br>- Il trattamento è necessario ai fini degli interessi legittimi perseguiti dal titolare del trattamento o da una terza parte, eccetto laddove prevalgano gli interessi o i diritti e le libertà fondamentali dell'interessato che richiedono la protezione dei dati personali, in particolare se l'interessato è un minore <br>Vedi l'<a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">art. 6 del [GDPR]</a> ",
			name: "Fondamenti di liceità",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Si tratta di garantire l'informazione delle persone e quindi di evitare la raccolta di dati a loro insaputa, verificando che il trattamento non sia soggetto a un'eccezione all'obbligo di informativa o a condizioni particolari.",
			name: "Informare i soggetti interessati",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Si tratta di ridurre la gravità dei rischi limitando la raccolta di dati personali al minimo necessario per la specifica finalità. Evitare di raccogliere dati non necessari, di utilizzare dati che non abbiano alcun rapporto con la specifica finalità e di produrre impatti eccessivi sulle persone.",
			name: "Minimizzazione dei dati",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Deve essere stipulato un contratto con ciascun responsabile del trattamento, esponendo tutti gli aspetti previsti dall'art. 28 del [GDPR]: durata, ambito, finalità, istruzioni di trattamento documentate, autorizzazione preventiva qualora si ricorra a sub-responsabili del trattamento, fornitura di documentazione che dimostri la conformità al [GDPR], notifica tempestiva di eventuali violazioni dei dati, ecc.",
			name: "Responsabili del trattamento",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Le risorse su cui si basano i trattamenti dei dati personali. Nota: possono comprendere hardware, software, reti, persone, supporti cartacei o documentazione. ",
			name: "Risorse dedicate al trattamento dei dati",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Specificare il luogo di conservazione delle varie tipologie di dati oggetto di trattamento. A seconda del Paese in questione, si dovrà giustificare la scelta di conservare i dati al di fuori dell'UE e indicare le salvaguardie legali  implementate al fine di garantire un'adeguata protezione dei dati oggetto di trasferimento oltre frontiera. Cioè: <br>- Verso uno Stato membro dell'Unione Europea. <br>- Verso un Paese con protezione adeguata riconosciuta dall'UE <br>- Verso gli Stati Uniti a una società che ha aderito al Privacy Shield <br>- Verso un altro Paese <br>Vedi gli <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">artt. 44-49 del [GDPR]</a>",
			name: "Trasferimenti di dati",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Esistenza di misure che consentano  una visione globale e aggiornata dello stato di protezione dei dati e della conformità con il GDPR (verifica della conformità dei trattamenti, obiettivi e indicatori, responsabilità, ecc.).",
			name: "Vigilanza sulla protezione dei dati",
			placeholder: "Descrivere i processi finalizzati a svolgere verifiche periodiche sui trattamenti di dati.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Esistenza di una procedura volta a ridurre i rischi per le libertà e la vita privata degli interessati  potenzialmente conseguenti all'accesso legittimo ai dati da parte di terzi (identificazione dei soggetti terzi, contratto di outsourcing, convenzione, BCR, ecc.)",
			name: "Gestione dei terzi che accedono ai dati",
			placeholder: "Indicare, per i terzi autorizzati ad accedere ai dati, i controlli e le misure di sicurezza implementati su tali accessi.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Esistenza di un'organizzazione idonea a guidare e verificare la protezione dei dati personali all'interno della struttura (designazione di un DPO/RPD, creazione di un organo di monitoraggio, ecc.)",
			name: "Politica di tutela della privacy",
			placeholder: "Descrivere come è strutturata l'organizzazione interna ai fini della tutela della vita privata.",
			source: "PIAF Oggetti Connessi p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Esistenza di procedure che descrivono i metodi volti a tenere conto della protezione dei dati personali in ogni nuovo trattamento (certificazioni, specifiche di riferimento, gestione del rischio per la persona interessata secondo una metodologia interna o indicata dall'autorità di controllo, ecc.)",
			name: "Integrare la protezione della privacy nei progetti",
			placeholder: "Descrivere in che modo si garantisce che la protezione dei dati personali sia tenuta in considerazione fin dalla fase iniziale di un nuovo progetto.",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Esistenza di un piano che preveda  le <strong> misure di sensibilizzazione </strong> adottate al momento della presa in carico di un dipendente, e di una procedura che descriva le <strong> misure adottate una volta cessato il rapporto di lavoro con i soggetti che accedono ai dati </strong>.",
			name: "Gestione del personale",
			placeholder: "Indicare le iniziative di sensibilizzazione del personale in materia di protezione dei dati attuate all'interno dell'azienda o dell'organismo.",
			source: "PIAF Oggetti Connessi p24"
		},
		PIA_ORG_POL: {
			description: "Il titolare del trattamento deve disporre di una base documentale che formalizzi gli obiettivi e le regole da applicare nel campo della protezione dei dati (piano d'azione, revisione periodica delle politiche in materia di protezione dati, ecc.)",
			name: "Gestione delle politiche di tutela della privacy",
			placeholder: "Descrivere i metodi di gestione della base documentale per impostare gli obiettivi e le regole per la protezione dei dati.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Esistenza di una politica che definisce i processi volti a controllare i rischi che i trattamenti comportano per i diritti e le libertà degli interessati (censimento dei trattamenti di dati personali, dei dati trattati, dei supporti utilizzati, valutazione del rischio, definizione di misure esistenti o previste ecc.)",
			name: "Gestione dei rischi",
			placeholder: "Descrivere i processi atti al controllo dei rischi che le operazioni di trattamento comportano per i diritti e le libertà degli interessati.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Esistenza di un'organizzazione operativa per rilevare e gestire eventi che possono influire sulle libertà e sulla riservatezza degli interessati (definizione delle responsabilità, piano di reazione, caratterizzazione delle violazioni ecc.)",
			name: "Gestire gli incidenti di sicurezza e le violazioni dei dati personali",
			placeholder: "Descrivere i processi operativi volti a individuare e gestire gli eventi in grado di incidere sulle libertà e la privacy degli interessati.",
			source: "PIAF Oggetti Connessi p24 e PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Esistenza di politiche di backup tali da assicurare la disponibilità e/o l'integrità dei dati personali, tutelandone la confidenzialità (periodicità dei backup, cifratura del canale di trasmissione dati, test di integrità, ecc.).",
			name: "Backup",
			placeholder: "Indicare come sono gestiti e conservati i backup.",
			source: "PIAF Oggetti Connessi p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Misure adottate per ridurre la possibilità che le caratteristiche del software (sistemi operativi, applicazioni aziendali, software per ufficio, impostazioni ecc.) vengano sfruttate per danneggiare i dati personali (aggiornamenti, protezione fisica e accessi, lavoro su uno spazio di rete protetto, controlli di integrità, logging, ecc.).",
			name: "Gestione postazioni",
			placeholder: "Descrivere le misure adottate al fine di ridurre i rischi di attacchi ai software utilizzati per il trattamento.",
			source: "PIAF Oggetti Connessi p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "I dati personali comunicati a o gestiti da responsabili del trattamento devono beneficiare di garanzie sufficienti. <strong>Utilizzare esclusivamente responsabili del trattamento che offrono garanzie sufficienti</strong> (in particolare quanto a conoscenze specialistiche, affidabilità e risorse). Esigere che il responsabile comunichi la propria politica di sicurezza dei sistemi informativi. <br>Adottare e documentare misure (audit di sicurezza, visite agli impianti, ecc.) che consentano di <strong>assicurare l'effettività delle garanzie offerte dal responsabile del trattamento <strong> in materia di protezione dei dati. Tali garanzie comprendono, in particolare,: <br>- la cifratura dei dati in base alla loro sensibilità ovvero, in assenza di cifratura, l'esistenza di procedure tali da garantire che il responsabile del trattamento non acceda ai dati affidatigli<br>- la cifratura delle trasmissioni dei dati (p.es.: connessioni tipo HTTPS, VPN, ecc.)<br>- garanzie in materia di protezione della rete, tracciabilità (log, audit), gestione delle autorizzazioni, autenticazione, ecc.<br><strong>Prevedere un contratto con i responsabili del trattamento</strong>, ove siano definiti, in particolare, oggetto, durata, finalità del trattamento e obblighi delle parti contraenti. Accertarsi che tale contratto contenga, in particolare, disposizioni relative a quanto segue: <br>- gli obblighi dei responsabili in materia di riservatezza dei dati personali affidati<br>- requisiti minimi di autenticazione degli utenti<br>- clausole in materia di restituzione e/o distruzione dei dati allo scadere del contratto<br>- regole per la gestione e la notifica di eventuali incidenti. Queste ultime dovrebbero prevedere la comunicazione al titolare del trattamento qualora sia individuata una violazione di sicurezza o si verifichi un incidente di sicurezza, da effettuarsi con la massima celerità possibile qualora la violazione riguardi dati personali.<br>- Qualora si ricorra a un fornitore di servizi di cloud computing:<br>\t1. Specificare con chiarezza quali dati e quali trattamenti si collocheranno nel cloud ;<br>\t2. Definire le rispettive esigenze di sicurezza tecnica e giuridica ;<br>\t3. Effettuare uno studio dei rischi al fine di individuare le misure di sicurezza adeguate ;<br>\t4. Individuare il tipo di cloud idoneo al trattamento previsto ;<br>\t5. Scegliere un fornitore che dia garanzie sufficienti ;<br>\t6. Riesaminare la politica di sicurezza interna ;<br>\t7. Monitorare gli sviluppi nel tempo.",
			name: "Contratto con il responsabile del trattamento",
			placeholder: "Descrivere le garanzie contrattuali a tutela dei dati personali affidati a responsabili del trattamento.",
			source: "Guide Bleu 2017 p19 et https://www.cnil.fr/fr/cloud-computing-les-conseils-de-la-cnil-pour-les-entreprises-qui-utilisent-ces-nouveaux-services"
		},
		PIA_SEC_EXP: {
			description: "Politiche volte a limitare la probabilità e la gravità dei rischi per le risorse utilizzate durante l'operatività (documentare le procedure operative, inventariazione e aggiornamento di software e hardware, correzione di vulnerabilità, duplicazione dei dati, limitazioni all'accesso fisico al materiale, ecc.).",
			name: "Vulnerabilità",
			placeholder: "Descrivere gli strumenti impiegati per garantire l'aggiornamento e il livello di sicurezza dei software utilizzati.",
			source: "PIAF Oggetti Connessi p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Esistenza di misure messe in atto per rilevare tempestivamente incidenti relativi a dati personali e disporre di elementi utilizzabili per studiarli o per fornire prove nel contesto di indagini (politica di registrazione eventi, rispetto degli obblighi di protezione dei dati ecc.)",
			name: "Tracciabilità",
			placeholder: "Descrivere le misure implementate per rilevare incidenti che riguardano dati personali",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Esistenza di una politica di manutenzione fisica dei dispositivi, specificando l'eventuale ricorso all'outsourcing. <br>Dovrà comprendere la manutenzione remota, ove autorizzata, e specificare i metodi di gestione dei materiali difettosi.",
			name: "Manutenzione",
			placeholder: "Descrivere come è gestita la manutenzione fisica dei dispositivi",
			source: "PIAF Oggetti Connessi p23"
		},
		PIA_SEC_MAL: {
			description: "Misure volte a proteggere l'accesso a reti pubbliche (Internet) o non controllate (di partner) nonché postazioni e server contro malware che potrebbe compromettere la sicurezza dei dati personali.",
			name: "Lotta contro il malware",
			placeholder: "Descrivere i controlli implementati contro il codice malevolo (malware) quando si accede a reti con un livello di sicurezza inferiore.",
			source: "PIAF Oggetti Connessi p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Esistenza di misure adottate per ridurre il rischio che le caratteristiche delle apparecchiature (server, postazioni fisse, portatili, periferiche, dispositivi di comunicazione, supporti rimovibili ecc.) siano utilizzate per danneggiare i dati personali (inventario, compartimentalizzazione, ridondanza, limiti per l'accesso ecc.)",
			name: "Sicurezza dell'hardware",
			placeholder: "Descrivere metodi e strumenti utilizzati per limitare i rischi posti alla sicurezza fisica di server e postazioni PC",
			source: "PIAF Oggetti Connessi p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "A seconda del tipo di rete sulla quale il trattamento è effettuato (isolata, privata o Internet), il titolare del trattamento deve implementare sistemi di protezione adeguati: firewall, sonde anti-intrusione o altri dispositivi (attivi o passivi) volti a garantire la sicurezza della rete.",
			name: "Sicurezza dei canali informatici",
			placeholder: "Indicare i controlli di sicurezza della rete sulla quale il trattamento è effettuato",
			source: "PIAF Oggetti Connessi p23"
		},
		PIA_SEC_PHY: {
			description: "Esistenza di un controllo degli accessi fisici ai locali che ospitano il trattamento (zonizzazione, accompagnamento di visitatori, assegnazione di badge, porte chiuse, e così via).<br>Indicare se sono in atto procedure di allarme in caso di irruzione.",
			name: "Controllo degli accessi fisici",
			placeholder: "Indicare in che modo si realizza  il controllo dell'accesso fisico ai locali che ospitano il trattamento.",
			source: "PIAF Oggetti Connessi p23"
		},
		PIA_SEC_PROT: {
			description: "Esistenza di misure per ridurre o evitare i rischi connessi a fonti non umane (fenomeni climatici, incendi, danni provocati dall'acqua, incidenti interni o esterni, animali, ecc.) che potrebbero influire sulla sicurezza dei dati personali (misure preventive, di rilevamento, protezione, ecc.)",
			name: "Protezione contro fonti di rischio non umane",
			placeholder: "Descrivere le misure adottate per ridurre o prevenire i rischi connessi a fonti non umane",
			source: "PIAF Oggetti Connessi p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Esistenza di misure per evitare che fonti di rischio, umane o non umane, anche se scarsamente probabili, arrechino pregiudizio ai dati personali (merci pericolose, aree geografiche pericolose, trasferimento dati al di fuori dell'UE, ecc.)",
			name: "Prevenzione delle fonti di rischio",
			placeholder: "Descrivere metodi e strumenti utilizzati per evitare rischi di carattere generale",
			source: "PIAF Oggetti Connessi p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Metodi e strumenti implementati per ridurre il rischio che le caratteristiche di un sito web siano sfruttate al fine di pregiudicare dati personali (disciplinare generale di sicurezza, cifratura TLS dei flussi di dati, politica di rilascio dei cookie, audit di sicurezza, ecc.) .",
			name: "Sicurezza dei siti web",
			placeholder: "Descrivere metodi e strumenti  implementati per proteggere i siti web.",
			source: "PIAF Oggetti Connessi p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Indicare qui i meccanismi di anonimizzazione implementati, le garanzie da essi introdotte contro l'eventuale reidentificazione e per quali finalità sono implementati.<br>",
			name: "Anonimizzazione",
			placeholder: "Indicare qui i meccanismi di anonimizzazione implementati",
			source: "PIAF Oggetti Collegati p21"
		},
		PIA_TEC_ARCH: {
			description: "Politiche di conservazione e gestione di archivi elettronici contenenti dati personali, finalizzate a tutelarne, in particolare, la validità giuridica per tutto il periodo necessario (versamento, conservazione, migrazione, accessibilità, eliminazione, politiche di archiviazione, protezione della confidenzialità, ecc.).",
			name: "Archiviazione",
			placeholder: "Indicare qui l'insieme dei meccanismi implementati per la conservazione e la gestione di archivi elettronici contenenti dati personali",
			source: "PIAF Oggetti Collegati p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "I mezzi implementati per <strong>assicurare la confidenzialità dei dati archiviati (in database, file, backup ecc.), così come le procedure per gestire chiavi crittografiche (creazione, archiviazione, aggiornamento in caso di sospetta compromissione ecc.).<br>Specificare i mezzi crittografici impiegati per i flussi di dati (VPN, TLS, ecc.) implementati nel trattamento.",
			name: "Crittografia",
			placeholder: "Descrivere qui gli strumenti crittografici implementati per assicurare la confidenzialità e l'integrità dei dati",
			source: "PIAF Oggetti Connessi p21"
		},
		PIA_TEC_CLO: {
			description: "Metodi utilizzati per il partizionamento del trattamento.",
			name: "Partizionamento",
			placeholder: "Indicare qui se sono pianificati partizionamenti del trattamento e come sono  effettuati.",
			source: "PIAF Oggetti Collegati p21"
		},
		PIA_TEC_CTLA: {
			description: "Descrivere in che modo sono definiti e attribuiti i profili degli utenti. Specificare i mezzi di <strong>autenticazione</strong> implementati precisando, ove applicabile, le regole per le password (lunghezza minima, caratteri richiesti, durata della validità, numero di tentativi prima del blocco dell'account,  ecc.).",
			name: "Controllo degli accessi logici",
			placeholder: "Indicare qui come sono definiti e attribuiti i profili degli utenti.",
			source: "PIAF Oggetti Connessi p21"
		},
		PIA_TEC_LOG: {
			description: "Politiche che definiscono la tracciabilità degli eventi e la gestione dei relativi log.",
			name: "Tracciabilità",
			placeholder: "Indicare qui se gli eventi sono registrati e il periodo di conservazione delle registrazioni.",
			source: "PIAF Oggetti Connessi p22"
		},
		PIA_TEC_MINI: {
			description: "Si possono utilizzare i seguenti metodi: filtraggio e rimozione, riduzione del potenziale identificativo attraverso trasformazione, riduzione della natura identificativa del dato, riduzione dell'accumulazione dei dati, limitazione dell'accesso ai dati",
			name: "Minimizzazione dei dati",
			placeholder: "Indicare qui i metodi implementati per ridurre il potenziale identificativo dei dati personali",
			source: "PIAF Oggetti Connessi p40"
		},
		PIA_TEC_PAP: {
			description: "Politiche relative ai documenti cartacei contenenti dati personali utilizzati nell'ambito del trattamento. Tali politiche descrivono come i documenti sono stampati, archiviati, distrutti e condivisi.",
			name: "Sicurezza dei documenti cartacei",
			placeholder: "Indicare qui le procedure relative al ciclo di vita dei documenti cartacei contenenti dati personali",
			source: "PIAF Oggetti Connessi p22"
		},
		PIA_VAL_ACT: {
			description: "Il piano d'azione descrive la strategia, gli strumenti e le misure concrete da implementare per consentire l'intervento delle misure correttive. Per ogni step è necessario indicare un responsabile e definire la tempistica.",
			name: "Piano d'azione",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Questo grafico illustra i rischi generati dal trattamento e i rischi residui alla luce delle misure correttive complessivamente previste. Se le misure complementari descritte nel piano d'azione sono implementate correttamente, la probabilità e/o la gravità dei rischi residui dovrebbero ridursi.",
			name: "Mappatura dei rischi",
			source: "PIAF Oggetti Connessi p34"
		},
		PIA_VAL_CONC: {
			description: "L'articolo 35.9 del <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">[GDPR]</a> stabilisce che il titolare del trattamento raccolga il parere degli interessati, se del caso. <br>Il parere può essere raccolto con vari mezzi, a seconda del contesto (studio interno o esterno riguardante lo scopo e i mezzi del trattamento, interpello dei rappresentanti del personale o dei sindacati, sondaggio svolto fra i possibili futuri clienti del titolare). <br><strong> Se il titolare del trattamento decide di ignorare</strong> le opinioni degli interessati, deve annotare <strong> la motivazione di tale decisione</strong>.<br>Se il titolare del trattamento ritiene che <strong>sia irrilevante raccogliere l'opinione degli interessati, deve sempre annotare la motivazione</strong>.",
			name: "Parere degli interessati",
			source: "GDPR Art. 35.9 e PIAF Oggetti Connessi p38"
		},
		PIA_VAL_DPO: {
			description: "L'articolo 35-2 del <a target=\"_blank\" href=\"http://www.garanteprivacy.it/documents/10160/0/Regolamento+UE+2016+679.+Con+riferimenti+ai+considerando\">[GDPR]</a> prevede che il titolare del trattamento dei dati chieda il parere del responsabile della protezione dei dati durante una valutazione dell'impatto sulla protezione dei dati. <br><strong> Questo parere potrebbe essere sfavorevole all'attuazione del trattamento, senza che ciò limiti il potere decisionale del titolare del trattamento</strong>.",
			name: "Parere del Responsabile della protezione dei dati",
			source: "GDPR Art. 35.2 e PIAF Oggetti Connessi p37"
		},
		PIA_VAL_RT: {
			description: "<strong>Il titolare del trattamento decide formalmente</strong> sull'accettabilità delle misure prescelte, dei rischi residui e del piano d'azione, in modo motivato, alla luce delle problematiche precedentemente identificate e del parere degli stakeholder. La PIA può dunque essere: <br>- validata <br>- da migliorare (spiegare come) <br>- rigettata (insieme con il trattamento in considerazione). <br>Ove opportuno, si dovrà procedere a un riesame delle singole fasi della PIA ai fini della sua validazione. <br>La decisione non pregiudica la valutazione della conformità che può essere effettuata, se del caso, dall'autorità per la protezione dei dati, ad esempio nell'ambito di una consultazione preliminare o dei controlli da essa svolti.",
			name: "Convalida da parte del titolare",
			source: "PIAF Oggetti Connessi p40"
		}
	},
	title: "Archivio"
};
var measures$a = {
	add: "Crea una misura (oppure utilizza una misura fra quelle proposte nell'Archivio qui a destra)",
	default_placeholder: "Descrivi le misure attuali o pianificate per garantire la sicurezza dei dati.",
	edit: "Modifica misura",
	placeholder_title: "Denominazione misura",
	remove: "Cancella misura"
};
var misc$a = {
	display: "Mostra / Nascondi"
};
var modals$a = {
	abandon_pia: {
		additional_text: "L'archiviazione non è definitiva; è possibile riprendere la PIA se necessario.",
		content: "Sei sicura/o di voler <br>terminare il trattamento?"
	},
	action_plan_no_evaluation: {
		content: "È necessario iniziare la valutazione dell'analisi per creare il piano di azione.",
		review_section: "Valuta una sezione"
	},
	archive: "Archivia",
	archive_pia: {
		archive: "Archivia AIIA",
		content: "<span class='strong'>Attenzione,</span><br>Sei sicura/o di voler<br>archiviare questa PIA ?"
	},
	ask_for_evaluation: {
		content: "<span class='strong'>Congratulazioni,</span><br>la sezione è <br>disponibile per la valutazione."
	},
	back_to_edition: {
		content: "Questa sezione viene ripresentata per correzioni. <br>È necessario apportare correzioni in vari campi <br>per consentire un'efficace valutazione."
	},
	back_to_evaluation: {
		content: "Questa sezione viene ripresentata per valutazione. <br>È necessario apportare correzioni in vari campi <br>per consentire un'efficace validazione."
	},
	back_to_home: "Torna alla home",
	cancel: "Annulla",
	close: "Chiudi",
	completed_edition: {
		content: "Analisi completata, sottoporre la PIA a valutazione."
	},
	completed_evaluation: {
		content: "Valutazione completata, sottoporre la PIA a validazione."
	},
	"continue": "Continua",
	declare_measures: {
		content: "Spiacente, <br>prima di valutare rischi,<br>occorre  dichiarare le<br>misure esistenti o pianificate.",
		declare: "Dichiarare le misure esistenti o pianificate"
	},
	dpo_missing_evaluations: {
		comment: "Inserisci un commento",
		content: "È necessario completare la valutazione dell'analisi per accedere alla pagina del DPO/RPD.",
		remove: "Cancella",
		review_section: "Valuta una sezione"
	},
	general_error: {
		content: "C'è stato un errore e ci dispiace molto."
	},
	import_wrong_pia_file: {
		content: "Il file importato non corrisponde a un file di tipo PIA"
	},
	import_wrong_structure_file: {
		content: "Il file importato non corrisponde a un file di tipo Modello"
	},
	knowledge: {
		content: "Sei sicura/o di voler cancellare questo elemento?",
		remove: "Cancella questo elemento"
	},
	knowledges: {
		content: "Sei sicuro di voler cancellare questa base di conoscenza?",
		remove: "Cancella questa base di conoscenza"
	},
	modal_select_text_pia: {
		content: "I contenuti della PIA sono stati copiati negli appunti."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Attenzione, </span><br>Deve essere indicata almeno una misura: non è possibile cancellare."
	},
	recover_version: {
		"continue": "Continua",
		message: "Continuando, ripristinerai questa versione del report: {{date}}.<br><br>La versione corrente verrà salvata.",
		title: "Ripristina una versione precedente"
	},
	refuse_pia: {
		content: "<span class='strong'>PIA rigettata,</span><br>sono necessarie correzioni in più campi.<br>Torna alla modalità valutazione<br>per apportare le correzioni."
	},
	remove_attachment: {
		comment: "Inserisci un commento",
		content: "<span class='strong'>Attenzione,</span><br>sei sicura/o di voler<br>cancellare questo allegato?",
		keep: "Mantieni",
		remove: "Cancella"
	},
	remove_measure: {
		content: "<span class='strong'>Attenzione,</span><br>sei sicura/o di voler <br>cancellare questa misura?",
		keep: "Mantieni questa <br>misura",
		remove: "Cancella questa <br>misura"
	},
	remove_pia: {
		content: "<span class='strong'>Attenzione,</span><br>sei sicura/o di voler<br>cancellare definitivamente questa PIA?",
		remove: "Cancella questa PIA"
	},
	remove_question: {
		content: "Sei sicura/o di voler cancellare la domanda?",
		keep: "Annulla",
		remove: "Cancella"
	},
	remove_structure: {
		content: "<span class='strong'>Attenzione,</span><br>sei sicura/o di voler<br>cancellare questo modello?",
		remove: "Cancella questo modello"
	},
	same_comment: {
		content: "<span class='strong'>Attenzione,</span><br>Inserire un commento diverso dall'ultimo inserito."
	},
	signed_pia_validation: {
		content: "<span class='strong'>La PIA è accettata</span><br>Terminare validazione della PIA allegando<br>il report firmato dal responsabile della validazione.",
		download_pia: "Scarica report PIA"
	},
	simple_pia_validation: {
		content: "La PIA deve essere validata"
	},
	start_evaluation: "Inizia valutazione",
	unarchive_pia: {
		content: "<span class='strong'>Attenzione,</span><br>sei sicura/o di voler togliere<br>dall'archivio questa PIA ?",
		unarchive: "Togli dall'archivio questa PIA"
	},
	update_server_url_nok: {
		content: "Non è possibile connettersi al server: verificare l'URL inserito.",
		introspect: "Il Client ID e il Client SECRET non sono stati validati dal server, si prega di verificarli."
	},
	update_server_url_ok: {
		content: "L'indirizzo del server è stato aggiornato."
	},
	validate_evaluation: {
		content: "<span class='strong'>Congratulazioni,</span><br>la valutazione di questa sezione è conclusa.<br>Devono essere valutate anche le altre sezioni per poter accedere alla validazione della PIA."
	},
	validate_evaluation_to_correct: {
		content: "Spiacente,<br>Diversi campi necessitano di correzioni.<br>Torna alla modalità modifica<br>per apportare correzioni."
	},
	users: {
		"delete": {
			content: "<span class='strong'>Attenzione,</span><br>sei sicura/o di voler<br>cancellare questo utente?",
			confirm: "Cancella questo utente",
			pia_exist: "Questo utente è assegnato a una o più PIA, dovrai ri-assegnare gli utenti su queste."
		}
	}
};
var onboarding$a = {
	dashboard: {
		step1: {
			description: "Fai click sul simbolo <strong>+</strong> per creare la tua prima PIA.",
			title: "Crea una PIA"
		},
		step2: {
			description: "<p>Gli <strong>editori</strong> scrivono la prima versione dell'analisi.</p><p>Sono, per esempio, i project managers associati al trattamento dei dati.</p>",
			title: "Ruoli nella PIA"
		},
		step3: {
			description: "<p>I <strong>revisori</strong> Sono coinvolti nella seconda fase.</p><p>Usano la loro esperienza legale o tecnica con verificare la qualità e l'adeguatezza del trattamento.</p><p>Sono, per esempio, il DPO/RPD, esperti legali, ...</p>",
			title: "Ruoli nella PIA"
		},
		step4: {
			description: "<p>Il <strong>validatore</strong> accetta o rifiuta l'attuazione del trattamento. Deve firmare l'analisi.</p><p>È il controllore, per esempio, il CEO.</p>",
			title: "Ruoli nella PIA"
		},
		step5: {
			description: "<p>I <strong>iodelli</strong> sono una funzionalità avanzata. Sono usati per creare basi pre-compilate per l'analisi.</p><p>Puoi creare i modelli nella sezione dedicata accessibile dal menù in alto.</p>",
			title: "Modelli"
		}
	},
	entry: {
		step1: {
			description: "Per spostarti da una parte all'altra dell'analisi, usa il menù di navigazione a sinistra.",
			title: "Naviga"
		},
		step2: {
			description: "Questo è usato per spiegare lo scopo del trattamento e come sarà attuato.",
			title: "Contesto"
		},
		step3: {
			description: "Questi mirano ad assicurare che il trattamento sia conforme al GDPR.",
			title: "Principi fondamentali"
		},
		step4: {
			description: "Questo descrive le misure di sicurezza già pianificate per le operazioni del trattamento e rende possibile valutare il potenziale impatto sugli interessati del trattamento.",
			title: "Rischi"
		},
		step5: {
			description: "Questo permette al DPO/RPD di esprimere la sua opinione riguardo l'attuazione del trattamento e permette al controllore di accettare o rifiutare.",
			title: "Validazione"
		},
		step6: {
			description: "<p>Fornisce assestenza contestuale nello svolgere l'analisi ed è basato sul GDPR, la guida sulla sicurezza e le guide per il PIA del CNIL</p><p>Oltre a questi contenuti, puoi anche creare la tua base di conoscenza per semplificare l'accesso alle informazioni specifiche della tua organizzazione.</p>",
			title: "La base di conoscenza"
		},
		step7: {
			description: "In qualunque momento durante l'analisi, puoi scaricarla in vari formati per condividerla con i tuoi colleghi.",
			title: "Esporta la tua PIA"
		}
	},
	evaluation: {
		step1: {
			description: "La valutazione può riguardare una intera sezione o può essere fatta per ciascun elemento della sezione.",
			title: "Valuta la PIA"
		},
		step2: {
			description: "<p>Questa valutazione indica agli editori che mancano elementi per effettuare una valutazione pertinente.</p><p>Il valutatore deve indicarli nel campo associato <strong>commento di valutazione</strong>. L'editor farà le correzioni necessarie.</p>",
			title: "Da correggere"
		},
		step3: {
			description: "<p>Questa valutazione indica gli elementi del trattamento da rivedere. Sono dettagliati nel campo del <strong>piano d'azione/azione correttiva</strong>.</p><p>Queste misure verranno automaticamente aggiunte alla parte Piano d'azione dell'analisi. È necessario implementarli il prima possibile.</p>",
			title: "Migliorabile"
		},
		step4: {
			description: "Questa valutazione significa che questa parte del trattamento può essere attuata senza modificazioni.",
			title: "Accettabile"
		},
		step5: {
			description: "Se la valutazione di una sezione non è ancora iniziata, la richiesta può essere annullata per fare cambiamenti alla descrizione del trattamento.",
			title: "Annulla una richiesta"
		}
	},
	general: {
		done: "Conferma",
		next: "Avanti",
		skip: "Salta"
	},
	validated: {
		step1: {
			description: "Un'analisi completa e validata può essere consultata in qualsiasi momento attraverso una interfaccia dedicata.",
			title: "Consulta una PIA validata"
		},
		step2: {
			description: "È necessario revisionare regolarmente un'analisi. Puoi modificarla o doplicarla in qualsiasi momento per revisionare il contenuto in accordo con le evoluzioni del trattamento.",
			title: "Aggiorna una PIA validata"
		}
	}
};
var opinions$a = {
	content: ", tenuto conto di quanto segue :",
	dpo_lock: "Completare le altre sezioni prima di chiedere il parere del DPO/RPD.",
	dpo_opinion: "Parere DPO/RPD",
	edit: "Modifica",
	people_opinion: "Parere degli interessati",
	placeholder_concerned_people_name: "Nome/i degli interessati",
	placeholder_dpo_name: "Nome/i DPO/RPD",
	placeholder_dpo_opinion: "Specifichi le motivazioni della sua scelta.",
	placeholder_people_opinion: "Descrivere come sono stati raccolti e analizzati i pareri. Se i pareri non sono stati richiesti, specificare le motivazioni.",
	placeholder_search_content: "Motivare la mancata richiesta del  parere degli interessati.",
	treatment_lock: "Completare le altre sezioni prima di chiedere il parere degli interessati.",
	treatment_nok: "Il trattamento non dovrebbe essere implementato.",
	treatment_ok: "Il trattamento può essere implementato."
};
var pia$a = {
	attachments: {
		add: "Aggiungi",
		download: "Scarica allegato",
		loading: "Caricamento...",
		remove: "Cancella",
		title: "Allegati",
		no_attachment: "Non ci sono allegati disponibili"
	},
	footer: {
		ask_evaluation: "Richiedi una revisione",
		mandatory_fields: "Tutti i campi sono obbligatori",
		structure_add_question: "Aggiungi una domanda",
		subsection_validated: "Sezione rivista, in attesa di validazione finale",
		validate_evaluation: "Valida revisione"
	},
	header: {
		display_action_plan: "Mostra<br>il piano d'azione",
		edition: "Modifica",
		evaluation: "Revisione",
		preview: "Anteprima"
	},
	sections: {
		based_on_structure_name: "Basato sul modello:",
		homepage_link: "Torna al pannello di controllo",
		refuse_pia: "Rifiuta AIIA",
		status: {
			evaluation: {
				cancel: "annullare la richiesta di revisione.",
				cancel_button: "Annulla richiesta di revisione",
				content: "Questa sezione è in attesa di revisione. Se desidera modificare i contenuti sottoposti a revisione, è necessario  ",
				title: "In attesa di revisione"
			},
			validation: {
				cancel: "annullare la richiesta di validazione.",
				cancel_button: "Annulla richiesta di validazione",
				content: "La revisione di questa sezione è conclusa e si attende la validazione dell'intera PIA. Se desidera modificare la revisione, è necessario ",
				title: "In attesa di validazione."
			}
		},
		validate_pia: "Validazione PIA"
	},
	statuses: [
		"In corso",
		"Rifiutata",
		"Validata",
		"Validata e firmata",
		"Archiviata",
		"In attesa di convalida"
	]
};
var questions$a = {
	edit: "Modifica domanda",
	gauges: [
		"(Indefinito)",
		"Trascurabile",
		"Limitato",
		"Importante",
		"Massimo"
	],
	placeholder_title: "Titolo della domanda (obbligatorio)",
	remove: "Eliminare la domanda"
};
var rejection_page$a = {
	applied_adjustments: "Modifiche apportate",
	applied_adjustments_placeholder: "Descrivere le modifiche apportate alla PIA.",
	button: {
		abandon_treatment: "Interrompere il trattamento",
		reject_pia: "Rigettare la AIIA",
		send_for_validation: "Ripresentare per approvazione"
	},
	previous_rejection: "PIA già rigettata",
	rejection_reason: "Motivazioni rifiuto AIIA",
	rejection_reason_placeholder: "Descrivere le motivazioni della mancata validazione della AIIA",
	title: "Cronologia validazione"
};
var sections$a = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Presentare sinteticamente il trattamento: denominazione, finalità, risultati attesi, contesto di utilizzo, ecc.",
						title: "Quale è il trattamento in considerazione?"
					},
					"2": {
						placeholder: "Descrivere le responsabilità dei soggetti coinvolti: il titolare del trattamento, gli eventuali responsabili e contitolari.",
						title: "Quali sono le responsabilità connesse al trattamento?"
					},
					"3": {
						placeholder: "Elencare gli standard rilevanti applicabili al trattamento, in quanto utili o obbligatori, specialmente i codici di condotta approvati e le certificazioni in materia di protezione dati.",
						title: "Ci sono standard applicabili al trattamento?"
					}
				},
				short_help: "Questa sezione permette di individuare e presentare l'oggetto dell'analisi.",
				title: "Panoramica del trattamento"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Elencare i dati raccolti e trattati indicando il periodo di conservazione, i destinatari e le persone che possono accedervi.",
						title: "Quali sono i dati trattati?"
					},
					"2": {
						placeholder: "Descrivere il ciclo di vita dei dati (dalla raccolta alla distruzione, passando per la loro conservazione, i vari step del trattamento, l'archiviazione, ecc.), servendosi per esempio di un diagramma di flusso dei dati (che potete allegare) e fornendo una dettagliata descrizione di ciascun processo effettuato.",
						title: "Qual è il ciclo di vita del trattamento dei dati (descrizione funzionale)?"
					},
					"3": {
						placeholder: "Elencare le risorse che ospitano i dati oggetto del trattamento (sistemi operativi, server, software, reti, persone, supporti cartacei ecc.)",
						title: "Quali sono le risorse di supporto ai dati?"
					}
				},
				short_help: "Questa sezione permette di definire e descrivere nei dettagli il trattamento in oggetto.",
				title: "Dati, processi e risorse di supporto"
			}
		},
		short_help: "Questa sezione permette una visione complessiva del trattamento o dei trattamenti di dati perosnali in questione.",
		title: "Contesto"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Spiegare perché le finalità del trattamento sono specifiche, esplicite e legittime.",
						short_title: "Finalità",
						title: "Gli scopi del trattamento sono specifici, espliciti e legittimi?"
					},
					"2": {
						placeholder: "Presentare le basi legali del trattamento (ad esempio consenso, esecuzione di un contratto, obbligo legale, interessi vitali ecc.)",
						short_title: "Basi legali",
						title: "Quali sono le basi legali che rendono lecito il trattamento?"
					},
					"3": {
						placeholder: "Spiegare perché ogni dato raccolto è necessario per le finalità del trattamento.",
						short_title: "Adeguatezza dei dati",
						title: "I dati raccolti sono adeguati, pertinenti e limitati a quanto è necessario in relazione alle finalità per cui sono trattati (minimizzazione dei dati)?"
					},
					"4": {
						placeholder: "Descrivere le misure previste per garantire  la qualità dei dati.",
						short_title: "Esattezza dei dati",
						title: "I dati sono esatti e aggiornati?"
					},
					"5": {
						placeholder: "Spiegare perché il periodo di conservazione previsto per ogni dato sia necessario al raggiungimento delle finalità del trattamento, salva l'esistenza di un altro obbligo di legge che imponga uno specifico termine di conservazione.",
						short_title: "Periodo di conservazione",
						title: "Qual è il periodo di conservazione dei dati?"
					}
				},
				short_help: "Questa sezione permette di dimostrare la legittimità del trattamento e dei dati trattati.",
				title: "Proporzionalità e necessità"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Descrivere le informazioni che si prevede di fornire agli interessati e gli strumenti utilizzati a tale scopo.",
						short_title: "Informativa",
						title: "Come sono informati del trattamento gli interessati?"
					},
					"2": {
						placeholder: "Descrivere le modalità previste per ottenere il consenso degli interessati.",
						short_title: "Raccolta del consenso",
						title: "Ove applicabile: come si ottiene il consenso degli interessati?"
					},
					"3": {
						placeholder: "Descrivere le modalità volte a consentire agli interessati di accedere ai propri dati e di riceverli o trasmetterli.",
						short_title: "Diritto di accesso e diritto alla portabilità dei dati",
						title: "Come fanno gli interessati a esercitare i loro diritti di accesso e di portabilità dei dati?"
					},
					"4": {
						placeholder: "Descrivere le modalità volte a consentire agli interessati di rettificare e cancellare i loro dati.",
						short_title: "Diritto di rettifica e diritto di cancellazione",
						title: "Come fanno gli interessati a esercitare i loro diritti di rettifica e di cancellazione (diritto all'oblio)?"
					},
					"5": {
						placeholder: "Descrivere le modalità volte a consentire agli interessati di limitare il trattamento dei propri dati e di opporsi a tale trattamento.",
						short_title: "Diritto di limitazione e diritto di opposizione",
						title: "Come fanno gli interessati a esercitare i loro diritti di limitazione e di opposizione?"
					},
					"6": {
						placeholder: "Per ogni responsabile del trattamento, descrivere l'ambito delle rispettive responsabilità e specificare i riferimenti ai contratti, ai codici di condotta e alle certificazioni ove sono fissati gli obblighi loro incombenti.",
						short_title: "Responsabili del trattamento",
						title: "Gli obblighi dei responsabili del trattamento sono definiti con chiarezza e disciplinati da un contratto?"
					},
					"7": {
						placeholder: "Per ogni Paese extra-Ue dove i dati sono conservati o trattati, indicare e descrivere se si tratti di un Paese di cui è stata riconosciuta l'adeguatezza ovvero descrivere le condizioni che si applicano al trasferimento.",
						short_title: "Trasferimenti di dati",
						title: "In caso di trasferimento di dati al di fuori dell'Unione europea, i dati godono di una protezione equivalente?"
					}
				},
				short_help: "Questa sezione permette di dimostrare l'implementazione degli strumenti necessari per consentire agli interessati di esercitare i loro diritti.",
				title: "Misure a tutela dei diritti degli interessati"
			}
		},
		short_help: "Questa sezione permette di generare lo schema di adeguamento secondo i principi di protezione dei dati personali.",
		title: "Principi Fondamentali"
	},
	"3": {
		items: {
			"1": {
				short_help: "Questa sezione permette di indicare le misure  (esistenti o pianificate) che contribuiscono alla sicurezza dei dati",
				title: "Misure esistenti o pianificate"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Inserire i possibili impatti",
						title: "Quali potrebbero essere i principali impatti sugli interessati se il rischio si dovesse concretizzare?"
					},
					"2": {
						placeholder: "Inserire le minacce",
						title: "Quali sono le principali minacce che potrebbero concretizzare il rischio?"
					},
					"3": {
						placeholder: "Inserire le fonti di rischio",
						title: "Quali sono le fonti di rischio?"
					},
					"4": {
						placeholder: "Cliccare qui per selezionare le misure che contribuiscono a mitigare il rischio.",
						title: "Quali misure fra quelle individuate  contribuiscono a mitigare il rischio?"
					},
					"5": {
						placeholder: "Indicare qui le motivazioni per la gravità stimata del rischio.",
						title: "Come stimereste la gravità del rischio, specialmente alla luce degli impatti potenziali e delle misure pianificate?"
					},
					"6": {
						placeholder: "Indicare qui le motivazioni per la probabilità stimata del rischio.",
						title: "Come stimereste la probabilità del rischio, specialmente con riguardo alle minacce, alle fonti di rischio e alle misure pianificate?"
					}
				},
				short_help: "Analizzare le cause e le conseguenze di accesso illegittimo ai dati, stimandone la gravità e la probabilità,",
				title: "Accesso illegittimo ai dati"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Inserire gli impatti potenziali",
						title: "Quali sarebbero i principali impatti sugli  interessati se il rischio si dovesse concretizzare?"
					},
					"2": {
						placeholder: "Inserire le minacce",
						title: "Quali sono le principali minacce che potrebbero consentire la concretizzazione del rischio?"
					},
					"3": {
						placeholder: "Inserire le fonti di rischio",
						title: "Quali sono le fonti di rischio?"
					},
					"4": {
						placeholder: "Cliccare qui per selezionare le misure che contribuiscono a mitigare lo specifico rischio.",
						title: "Quali misure, fra quelle individuate, contribuiscono a mitigare il rischio?"
					},
					"5": {
						placeholder: "Indicare qui le motivazioni per la gravità stimata del rischio.",
						title: "Come stimereste la gravità del rischio, in particolare alla luce degli impatti potenziali e delle misure pianificate?"
					},
					"6": {
						placeholder: "Indicare qui le motivazioni per la probabilità stimata del rischio.",
						title: "Come stimereste la probabilità del rischio, specialmente con riguardo a minacce, fonti di rischio e misure  pianificate?"
					}
				},
				short_help: "Analizzare le cause e le conseguenze di modifiche indesiderate dei dati, e stimare la gravità e la probabilità dell'evento.",
				title: "Modifiche indesiderate dei dati"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Inserire gli impatti potenziali",
						title: "Quali potrebbero essere gli impatti principali sugli interessati se il rischio dovesse concretizzarsi?"
					},
					"2": {
						placeholder: "Inserire le minacce",
						title: "Quali sono le principali minacce che potrebbero consentire la materializzazione del rischio?"
					},
					"3": {
						placeholder: "Inserire le fonti di rischio",
						title: "Quali sono le fonti di rischio?"
					},
					"4": {
						placeholder: "Cliccare qui per selezionare le misure che contribuiscono a mitigare lo specifico rischio.",
						title: "Quali misure, fra quelle individuate, contribuiscono a mitigare il rischio?"
					},
					"5": {
						placeholder: "Indicare qui le motivazioni per la gravità stimata del rischio.",
						title: "Come stimereste la gravità del rischio, specialmente alla luce degli impatti potenziali e delle misure pianificate?"
					},
					"6": {
						placeholder: "Indicare qui le motivazioni per la probabilità stimata del rischio.",
						title: "Come stimereste la probabilità del rischio, specialmente con riguardo alle minacce, alle fonti di rischio e alle misure pianificate?"
					}
				},
				short_help: "Analizzare le cause e le conseguenze di una  perdita di dati stimandone la gravità e la probabilità.",
				title: "Perdita di dati"
			},
			"5": {
				short_help: "Questa visualizzazione permette una panoramica globale e sintetica degli effetti prodotti dalle misure sulle componenti di rischio che esse contribuiscono a mitigare.",
				title: "Panoramica dei rischi"
			}
		},
		short_help: "Questa sezione permette di valutare i rischi per la riservatezza, alla luce delle misure esistenti o pianificate.",
		title: "Rischi"
	},
	"4": {
		items: {
			"1": {
				short_help: "Questa visualizzazione permette di confrontare il posizionamento del rischio prima e dopo l'applicazione delle misure aggiuntive.",
				title: "Mappatura del rischio"
			},
			"2": {
				short_help: "Pianificare in dettaglio l'implementazione di misure aggiuntive come individuate nel corso della PIA. Questa sezione viene aggiornata automaticamente in funzione delle valutazioni condotte su ciascun elemento di cui si compone la valutazione di impatto",
				title: "Piano d'azione"
			},
			"3": {
				short_help: "Presentare il parere reso dal responsabile della protezione dei dati (DPO). Presentare il parere dei soggetti interessati o di loro rappresentanti.",
				title: "Pareri di DPO/RPD e interessati"
			},
			"4": {
				title: "Validazione della PIA"
			},
			"5": {
				title: "PIA rigettata"
			}
		},
		short_help: "Questa sezione permette di preparare e formalizzare la convalida PIA.",
		title: "Convalida"
	}
};
var settings$a = {
	content: "Inserire l'indirizzo (URL) del server remoto:",
	title: "Impostazioni",
	update: "Aggiorna URL"
};
var summary$a = {
	action_plan: {
		fundamental_principles: "Principi fondamentali",
		implementation_date: "Data prevista di implementazione",
		implementation_responsible: "Responsabile dell'implementazione",
		measures: "Misure esistenti o pianificate",
		no_action_plan: "Nessun piano d'azione registrato.",
		risks: "Rischi",
		title: "Piano d'azione"
	},
	actions: {
		complete_download: "Scarica il report completo",
		complete_download_desc: "Esporta un archivio .zip tutti i report (.doc e immagini), allegati e piano d'azione in formato .csv.",
		individual_download: "Scarica elementi del report",
		individual_download_desc: "Esporta elementi specifici del report.",
		individual_download_pdf: "Scarica il report PIA (.pdf)",
		individual_download_doc: "Testi (.doc)",
		individual_download_images: "Elementi grafici (.png) che includono la panoramica del rischio, la mappatura del rischio e il piano di azione.",
		individual_download_json: "Report nel formato di file importabile nell'applicazione PIA (per esempio installata nel PC di un collega) (.json file)",
		individual_download_select: "Seleziona gli elementi da esportare:",
		individual_to_download: "Scarica",
		print: "Stampa il report",
		print_and_download: "Stampa e scarica"
	},
	attachments: "Allegati",
	concerned_people_name: "Nomi degli interessati",
	concerned_people_opinion: "Pareri degli interessati",
	concerned_people_searched_opinion: "Richiesta del parere degli interessati",
	concerned_people_status: "Posizione degli interessati",
	concerned_people_unsearched_opinion_comment: "Motivazione della mancata richiesta del parere degli interessati",
	content_choice: [
		"Il trattamento non dovrebbe essere implementato.",
		"Il trattamento può essere implementato."
	],
	creation_date: "Data di creazione",
	csv_action_plan_comment: "Commento sul piano di azione",
	csv_evaluation_comment: "Commento sulla valutazione",
	csv_file_title: "Piano di azione",
	csv_implement_date: "Data stimata di implementazione",
	csv_people_in_charge: "Persona responsabile",
	csv_section: "Sezione",
	csv_title_object: "Titolo",
	download_csv: "Piano di azione (.csv)",
	dpo_name: "Nome del DPO/RPD",
	dpo_opinion: "Parere del DPO/RPD",
	dpo_status: "Posizione del DPO/RPD",
	gauges: {
		"1": "Trascurabile",
		"2": "Limitata",
		"3": "Importante",
		"4": "Massima"
	},
	modification_made: "Modifiche apportate",
	people_search_status_nok: "Non è stato chiesto il parere degli interessati.",
	people_search_status_ok: "È stato chiesto il parere degli interessati.",
	pia_assessor: "Nome valutatore",
	pia_author: "Nome autore",
	pia_name: "Nome della AIIA",
	pia_validator: "Nome validatore",
	preview_dpo_opinion: "Opinioni del DPO/RPD e degli interessati",
	preview_edition: "Modifica",
	preview_evaluation: "Valutazione",
	preview_no_data: "Nessun dato da mostrare.",
	preview_status: "Stato",
	preview_subtitle: "Informazioni generali",
	preview_title: "Anteprima",
	preview_validation: "Validazione",
	preview_validation_section: "Validazione",
	preview_guests: "Ospiti",
	previous_page: "Torna alla pagina precedente",
	rejection_reason: "Motivazione del rigetto",
	revision: {
		current_version: "Versione corrente",
		pia_version: "Versioni della AIIA",
		restore_version: "Ripristina",
		revision: "Versioni e revisioni",
		save: "Crea una nuova versione",
		show: "Mostra le {{length}} versioni"
	},
	risks_cartography_title: "Mappatura dei rischi",
	risks_overview_title: "Panoramica dei rischi",
	title: "Informazioni sulla PIA"
};
var users$a = {
	add_new_user: "Aggiungi un nuovo utente",
	cancel: "Annulla",
	choose_profile: "Scegli un profilo per questo utente",
	"continue": "Continua",
	data: "Data",
	edit_user: "Modifica un utente",
	email: "Email",
	first_name: "Nome",
	functional_admin: "Amministratore Funzionale",
	last_name: "Cognome",
	new_user_button: "Nuovo utente",
	profile: "Profilo",
	remove: "Elimina",
	remove_current_user_error_message: "Non puoi cancellare il tuo account",
	remove_last_functional_admin_error_message: "Non puoi cancellare questo utente perché deve esserci almeno un account da Amministratore Tecnico.",
	remove_user_with_linked_pias_error_message: "Molte PIA sono collegate a questo utente, quindi non lo puoi cancellare.",
	technical_admin: "Amministratore Tecnico",
	update: "Aggiorna",
	user: "Utente",
	state: "Stato dell'account",
	errors: {
		edit_user: {
			"406": "Le informazioni fornite creando l'account non sono valide."
		}
	},
	"delete": {
		confirm: "Rimuovi utente",
		content: "Sei sicura/o di voler cancellare questo utente?"
	},
	access_locked: {
		"false": "Attivo",
		"true": "In attesa dell'attivazione"
	},
	role: {
		label: "Ruoli",
		author: "Autore",
		evaluator: "Valutatore",
		validator: "Validatore",
		guest: "Ospite"
	}
};
var validation_page$a = {
	add_signed_pia: "Aggiungere PIA validata e firmata",
	after_reading: "Avendo letto integralmente la PIA relativa al trattamento di dati connessi all'attività di ",
	button: {
		rejection: "Negare la validazione",
		signed_validation: "Validazione con firma <br>",
		simple_validation: "Validazione semplice <br>"
	},
	confirmation1: "Dichiaro che la descrizione del contesto del mio trattamento corrisponde alla realtà.",
	confirmation2: "Dichiaro di essere consapevole dei rischi esistenti in funzione delle misure attualmente implementate o previste.",
	confirmation3: "Convalido le misure correttive indicate.",
	confirmation4: "Mi impegno a implementare quanto prima le misure correttive indicate.",
	latest_signed_attachment: "Ultimo allegato firmato",
	mandatory_fields: "Campi obbligatori",
	remove_attachment: "Elimina allegato",
	responsible: "Responsabile della validazione della PIA: ",
	signed_attachments_history: "Cronologia allegati firmati",
	tools: {
		dashboard: "Bacheca",
		display_pia: "Visualizza PIA"
	},
	validated_pia_with_signature: "PIA validata e firmata",
	waiting_for_signature: "In attesa di firma PIA"
};
var it = {
	about: about$a,
	action_plan: action_plan$a,
	authentication: authentication$a,
	cartography: cartography$a,
	comments: comments$a,
	conflict: conflict$a,
	date: date$a,
	errors: errors$a,
	evaluations: evaluations$a,
	header: header$a,
	help: help$a,
	homepage: homepage$a,
	knowledge_base: knowledge_base$a,
	measures: measures$a,
	misc: misc$a,
	modals: modals$a,
	onboarding: onboarding$a,
	opinions: opinions$a,
	"overview-risks": {
	important: "Importante",
	limited: "Limitata",
	maximal: "Massima",
	measures: "Misure",
	negligible: "Trascurabile",
	potential_impacts: "Impatti potenziali",
	"risk-access_x": "Gravità",
	"risk-access_y": "Probabilità",
	"risk-change_x": "Gravità",
	"risk-change_y": "Probabilità",
	"risk-disappearance_x": "Gravità",
	"risk-disappearance_y": "Probabilità",
	sources: "Fonti",
	threat: "Minaccia"
},
	pia: pia$a,
	questions: questions$a,
	rejection_page: rejection_page$a,
	sections: sections$a,
	settings: settings$a,
	summary: summary$a,
	users: users$a,
	validation_page: validation_page$a
};

var about$9 = {
	contribute: "Jei norite prisidėti prie programos vertimo į kitas kalbas ar norite pagerinti esamą vertimą, rekomenduojame <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\"> perskaityti instrukcijas</a>.",
	description: "Ši programa yra sukurta <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, Prancūzijos duomenų apsaugos inspekcijos, siekiant padėti jos vartotojams užtikrinti asmens duomenų tvarkymo atitiktį BDAR reikalavimams. Ją suprogramavo <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Jei norite prisidėti prie šio projekto tolimesnio vystymo, jūs galite atsisiųti programos išeities kodą iš Github, jį modifikuoti ir dalintis su bendruomene.",
	licences: "Bibliotekų licencijos:",
	title: "Apie PDAV programą",
	translators: "PIA programa yra išversta į daugiau nei aštuonioliką kalbų. Programos prancūzišką ir anglišką versijas sukūrė CNIL. Programos versijas kitomis kalbomis parengė šie asmenys:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Versijos Nr."
};
var action_plan$9 = {
	acceptable_measures: "Tinkamos apsaugos priemonės",
	edit: "Redaguoti",
	improvable_measures: "Taisytinos apsaugos priemonės",
	measures: "Planuojamos arba įgyvendintos apsaugos priemonės",
	no_action_plan: "Veiksmų planas neparengtas",
	placeholder_person_in_charge: "Už įgyvendinimą atsakingas asmuo",
	principles: "Pagrindiniai principai",
	risk1: "Neteisėta prieiga prie duomenų",
	risk2: "Nepageidaujamas duomenų pakeitimas",
	risk3: "Duomenų pradingimas",
	risks: "Rizikos",
	title: "Apžvalga"
};
var authentication$9 = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Ši programa Ši <strong>Prancūzijos duomenų apsaugos inspekcijos (CNIL) </strong> sukurta programa, skirta padėti duomenų valdytojams užtikrinti asmens duomenų tvarkymo atitikti BDAR reikalavimams. Jos pagalba galima tinkamai atlikti poveikio duomenų apsaugai vertinimą, naudojant PIA programos metodiką.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Pradėti",
	start_app: "Nauotis PIA programa (Beta ver.)",
	subtitle1: "Platforma, skirta PDAV sukūrimui <br> ir valdymui",
	subtitle2: "Įrankiai ir žodynėliai",
	title: "Poveikio duomenų apsaugai vertinimas",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$9 = {
	important: "Reikšmingas",
	legend1: "Planuojamos arba įgyvendintos apsaugos priemonės",
	legend2: "Įgyvendinta pakeistų apsaugos priemonių pagalba",
	legend3: "Neteisėta prieiga prie duomenų (NP)",
	legend4: "Nepageidaujamas duomenų pakeitimas (NDP)",
	legend5: "Duomenų praradimas (DP)",
	likelihood_axe: "Rizikos pasireiškimo tikimybė",
	limited: "Ribotas",
	maximal: "Maksimalus",
	negligible: "Nežymus",
	risk1_access: "(NP)",
	risk2_modification: "(NDP)",
	seriousness_axe: "Rizikos dydis"
};
var comments$9 = {
	comment: "Komentaras",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "Komentaras(-ai)",
	new_comment: "Komentuoti",
	placeholder_new_comment: "Palikti komentarą",
	send: "Siųsti"
};
var conflict$9 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$9 = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$9 = {
	content: "Jei susiduriate su problemomis, besinaudodami PIA programa, ar turite pasiūlymų, kaip ją galima būtų patobulinti, galite mums parašyti, užpildydami šią formą: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Nerastas puslapis."
};
var evaluations$9 = {
	acceptable: "Tinkamas",
	action_plan_comment: "Veiksmų planas / ką reikėtų pataisyti",
	evaluation_comment: "Vertinimo komentaras",
	gauges: {
		"0": "(Nenustatytas)",
		"1": "Nedidelis",
		"2": "Ribotas",
		"3": "Reikšmingas",
		"4": "Maksimalus",
		likelihood: "Atsižvelgdamas į veiksmų planą, kaip vertintumėte iš naujo <span class='red-highlight'>šios rizikos dydį</span>?",
		seriousness: "Atsižvelgdamas į veiksmų planą, kaip vertintumėte <span class='red-highlight'>šios rizikos dydį</span>?"
	},
	improvable: "Tobulintinas",
	placeholder_acceptable: "Atsižvelgiant į turimą informaciją, įgyvendintos priemonės yra pakankamos tvarkomų asmens duomenų apsaugai užtikrinti.",
	placeholder_improvable1: "Atsižvelgiant į turimą informaciją, reikėtų imtis papildomų priemonių, siekiant pagerinti tvarkomų asmens  duomenų apsaugą.",
	placeholder_improvable2: "Pateikite savo komentarą.",
	placeholder_to_correct: "Pateiktos informacijos nepakanka įvertinimui. PDAV grąžinimas jo rengėjui tobulinimui, būtina atsižvelgti į pateiktas pastabas.",
	status: [
		"Nebaigtas",
		"Taisytinas",
		"Tobulintinas",
		"Tinkamas"
	],
	title: "Vertinimas",
	to_correct: "Taisytinas"
};
var header$9 = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "PDAV pavyzdys",
		title: "Pagalba"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Pagalba",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "CNIL vertimas",
		community_translations: "Bendruomenės pasiūlytas vertimas",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Vertimas, patikrintas ES valstybės narės duomenų apsaugos inspekcijos",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Originali versija",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Poveikio duomenų apsaugai vertinimas",
	structures: "PDAV šablonas",
	tools: {
		about: "Apie",
		accessibility: "Regėjimo sutrikimą turintiems (padidinto ryškumo spalvos, daltonismas)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Nustatymai",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$9 = {
	definition: {
		data1: {
			content: "Turinys rengiamas",
			title: "Naudokite PIA programą"
		},
		data2: {
			qa1: {
				content: "When encountering those display issues, close the application and reload it. It usually fixes the issue. You won’t lose the information you have entered ; it is  automatically saved as you type.",
				title: "I get display issues such as icons being stuck in one state or missing elements from the interface"
			},
			qa2: {
				content: "This known issue is currently being fixed. If you encounter this problem, we recommend that you fill in the justification field of the estimated level of severity and / or likelihood. You will be able to edit the gauge once the bug is fixed.",
				title: "I can’t edit the gauges for evaluating the severity and likelihood of a risk"
			},
			qa3: {
				content: "Several bugs have been observed when importing a PIA, and in particular the level gauges for evaluating the severity and likelihood of a risk may disappear. In this case, please refer to the above mentioned issue. Besides, a PIA may not appear on the dashboard after importing it. This is a display issue and you just need to refresh the page.",
				title: "I encounter issues when importing a PIA"
			},
			qa4: {
				content: "This is only a display bug and it has no effect on the text you enter in a field. This visual problem will be fixed soon.",
				title: "When I copy / paste text, it is highlighted."
			},
			qa5: {
				content: "In order to evaluate a section, it is mandatory to fill in all the fields. Please check if this is the case. When editing a risk, you must have at least one technical or organizational measure that mitigates the risk in order to ask for an evaluation of the risk.",
				title: "I can’t evaluate a section"
			},
			qa6: {
				content: "Please close the PIA you are editing and re-open it. The content should then be displayed in the language you have selected.",
				title: "When switching language, the texts are not translated"
			},
			qa7: {
				content: "For the moment, the navigation menu icons are not refreshed after refusing a PIA. You have to check each section and change the information and/or evaluation according to the reasons for refusing the PIA. Once all section have been reviewed, you should be able to request PIA validation again.",
				title: "I have refused to validate a PIA but I don’t know what to do now"
			},
			title: "Žinomos problemos (LT - Bus išversta į lietuvių k. vėliau arba būtume dėkingi, jei patys prisidėtumėte prie vertimo)"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Pagalba"
};
var homepage$9 = {
	cards: {
		author: "Redagavimas",
		category: "TO TRANSLATE - Category",
		creation_status: "Sukūrimas",
		date: "Data",
		evaluation: "Tikrinimas",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Importuoti PDAV",
		import_structure: "Importuoti šabloną",
		item: {
			consult_pia: "Peržiūrėti",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Redaguoti",
			edit_structure: "Redaguoti šabloną",
			tools: {
				action_plan: "Peržiūrėti<br>veiksmų planą",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Daryti kopiją",
				"export": "Eksportas",
				more_options: "Daugiau funkcijų",
				pia: "Atidaryti<br>PDAV",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Naujas PDAV",
		new_structure: "Naujas šablonas",
		or: "arba",
		pia_name: "PDAV",
		placeholder_author: "Vardas, Pavardė",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Vardas, Pavardė",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Importuoti PDAV",
		placeholder_import_structure: "Importuoti šabloną",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Naujas PDAV",
		placeholder_new_structure: "Naujas šablonas",
		placeholder_pia_name: "PDAV pavadinimas",
		placeholder_sector_name: "Sektoriaus pavadinimas",
		placeholder_start: "Turi būti užpildyti visi laukai",
		placeholder_structure: "Standartinis šablonas",
		placeholder_structure_name: "Šablono pavadinimas",
		placeholder_validation: "Vardas, Pavardė",
		sector_name: "Susijęs sektorius",
		start: "Start",
		status: "Statusas",
		structure: "Šablonas",
		structure_name: "Šablono pavadinimas",
		title_close_creation: "Uždaryti",
		validation: "Tvirtinimas"
	},
	filters: {
		assessor: "Tikrintoją",
		author: "Autorių",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Pradėti !<br><br> Tam, kad pradėti<br> spausk Naujas PDAV",
		card_rocket_content_structure: "Pradėk ! Tam, kad pradėti rengti <br>šabloną, spausk +",
		category: "TO TRANSLATE - Category",
		date: "Datą",
		import_pia: "Importuoti PDAV",
		import_structure: "Importuoti šabloną",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Pradėti ! Tam, kad pradėti <br>PDAV, spausk +",
		list_rocket_content_structure: "Pradėk ! Tam, kad pradėti rengti <br>šabloną, spausk +",
		name: "Pavadinimą",
		new_pia: "Naujas PDAV",
		new_structure: "Naujas šablonas",
		sector_name: "Susijęs sektorius",
		sort: "Rūšiuoti",
		sort_by: "pagal",
		status: "Statusą",
		validator: "Tvirtintoją"
	},
	lists: {
		column_actions: "Veiksmai",
		column_author: "Redagavimas",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Sukurtas",
		column_evaluation: "Tikrinimas",
		column_pia: "PDAV",
		column_progression: "Progresas",
		column_sector_name: "Susijęs sektorius",
		column_status: "Statusas",
		column_structure: "Šablonas",
		column_structure_name: "Šablonas",
		column_updated_at: "Paskutinį kartą atidarytas",
		column_validation: "Tvirtinimas",
		item: {
			tools: {
				action_plan: "Peržiūrėti veiksmų planą",
				archive: "TO TRANSLATE - Archive",
				consult: "Peržiūrėti",
				duplicate: "Kopijuoti",
				edit: "Redaguoti",
				"export": "Eksportuoti",
				pia: "Atidaryti PDAV",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$9 = {
	add_measure: "Įvesti",
	add_measure_hint: "Galite pasirinkti priemonę iš Pagalboje pateikto jų sąrašo.",
	category: {
		definition: "Apibrėžimas",
		example: "Pavyzdys",
		general_measure: "Fizinės (techninės) apsaugos priemonės",
		measure_on_data: "Loginės apsaugos priemonės",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Organizacinės apsaugos priemonės",
		principle: "Principas"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Visi",
		definitions: "Apibrėžimai",
		general_measures: "Fizinės (techninės) apsaugos priemonės",
		measures_on_data: "Loginės apsaugos priemonės",
		no_result: "Rezultatų nerasta.",
		organizational_measures: "Organizacinės apsaugos priemonės",
		title: "Filtrai"
	},
	placeholder_add_measure: "Įvesti šią priemonę",
	placeholder_help: "Įvedimo pagalba",
	search: "Paieška",
	slugs: {
		PIA_DEF_ACC: {
			description: "Duomenų subjektas turi teisę iš duomenų valdytojo gauti patvirtinimą, ar su juo susiję asmens duomenys yra tvarkomi, o jei tokie asmens duomenys yra tvarkomi, turi teisę susipažinti su asmens duomenimis ir toliau nurodyta informacija žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">15 str. [BDAR]</a>",
			name: "Teisė susipažinti",
			source: "BDAR 15 str."
		},
		PIA_DEF_ANO: {
			description: "Veiksmai, kurių pagalba asmens duomenys nuasmeninami taip, kad iš nuasmenintų duomenų duomenų subjekto tapatybė negali arba nebegali būti nustatyta, žr. <a target=\"_blank\" href=\" http://ec.europa.eu/justice/article-29/documentation/opinion-recommendation/files/2014/wp216_lt.pdf\">WP216 nuomonė</a>.",
			name: "Duomenų nuasmeninimas",
			source: "Measures_US ir 29 Darbo Grupės nuomonė žr. http://ec.europa.eu/justice/article-29/documentation/opinion-recommendation/files/2014/wp216_lt.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Procedūros, skirtos elektroninių duomenų archyvų išsaugojimui ir valdymui, siekiant turėti archyvinius duomenis, kurių gali prireikti ateityje dėl teisėtų interesų (pvz. galimuose ginčuose ir pan.). Archyvai turi būti saugomi saugiai, o prieiga prie jų turi būti ribojama ir kontroliuojama. Ypač tada, kai jie susiję su specialių kategorijų duomenimis, kurių apsaugos pažeidimas gali sukelti didelę žalą duomenų subjektams.",
			name: "Archyvavimas",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Autentifikavimosi metu vartotojas privalo įrodyti savo tapatybę. Kiekvienas, teisę į prieigą prie duomenų turintis asmuo, turi turėti unikalų savo identifikatorių. Autentifikuotis galima: :<br>-slaptažodžio pagalba;<br>-el. parašo ar el. bankininkystės pagalba;<br>- savo biometrinių duomenų pagalba.<br>Primintina, kad pagal BDAR biometrinių duomenų naudojimas leidžiamas, turint duomenų subjekto galiojantį sutikimą.<br><strong> Autentifikavimasis laikomas stipriu, jei naudojami mažiausiai keli autentifikavimosi būdai.</strong>",
			name: "Autentifikavimasis",
			source: "Measures_US Loginė prieigos kontrolė"
		},
		PIA_DEF_CHIF: {
			description: "Kokių šifravimo priemonių imamasi. Šifravimas – tai procesas, kurio metu pradinis tekstas (duomenys) paverčiamas į neskaitomą formą, vadinamą šifruotu tekstu (angl. ciphertext) arba kartais kriptograma (angl. cryptogram). Iššifravimas tai atvirkštinis procesas kai iš šifruoto teksto (duomenų) atstatomas pradinis. Šifras tai algoritmas, skirtas šifravimui ir iššifravimui. Dažniausiai šifras valdomas raktu – slapta informacijos dalele, kuri turi įtakos šifruoto teksto gamybai. Protokolas detaliai apibrėžia kaip šifrai (ir kiti kriptografiniai primityvai) turi būti naudojami siekiant norimų rezultatų. Protokolų, šifrų, raktų valdymo bei vartotojo vykdomų veiksmų visuma sudaro kriptosistemą.",
			name: "Duomenų šifravimas",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Duomenų loginis ir fizinis skaidymas (angl. partitioning) į skirtingas laikmenas mažina riziką, kad pažeidimo atveju bus pažeisti ar pavogti visi duomenys.",
			name: "Duomenų skaidymas",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Bet koks laisva valia duotas, konkretus ir nedviprasmiškas tinkamai informuoto duomenų subjekto valios išreiškimas pareiškimu arba vienareikšmiais veiksmais kuriais jis sutinka, kad būtų tvarkomi su juo susiję asmens duomenys.<br>Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\"> 4 str. 10 d. [BDAR]</a>",
			name: "Sutikimas",
			source: "BDAR 4 str. 10 d."
		},
		PIA_DEF_CTLA: {
			description: "Priemonės, kurių imamasi siekiant užkirsti kelią, kad teisės neturintys asmenys neturėtų prieigos prie tvarkomų asmens duomenų. Jomis gali būti:<br>-<strong>vartotojų profilių administravimas</strong>, atskiriant užduotis ir atsakomybės sritis, kad prieigą prie asmens duomenų turėtų tik tie asmenys, kuriems ji būtina darbinėms funkcijoms atlikti;-<strong>panaikinti darbuotojų, paslaugų teikėjų ar kitų trečiųjų asmenų prieigos prie duomenų teises, kai jie praranda teisę patekti į patalpas ar praranda teisę naudotis kitais bendrovės ištekliais</strong> arba kai jų <strong> darbo sutartis ar paslaugų sutartis pasibaigia</strong>.",
			name: "Loginė prieigos kontrolė",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Bet kokia informacija apie fizinį asmenį, kurio tapatybė nustatyta arba kurio tapatybę galima nustatyti (duomenų subjektas); fizinis asmuo, kurio tapatybę galima nustatyti, yra asmuo, kurio tapatybę tiesiogiai arba netiesiogiai galima nustatyti, visų pirma pagal identifikatorių, kaip antai vardą ir pavardę, asmens identifikavimo numerį, buvimo vietos duomenis ir interneto identifikatorių arba pagal vieną ar kelis to fizinio asmens fizinės, fiziologinės, genetinės, psichinės, ekonominės, kultūrinės ar socialinės tapatybės požymius. <br>Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">4 str. 1 d. [BDAR]</a>",
			name: "Asmens duomenys",
			source: "BDAR 4 str. 1 d."
		},
		PIA_DEF_DEST: {
			description: "Fizinis arba juridinis asmuo, valdžios institucija, agentūra ar kita įstaiga, kuriai atskleidžiami asmens duomenys, nesvarbu, ar tai trečioji šalis ar ne. Tačiau valdžios institucijos, kurios pagal Sąjungos arba valstybės narės teisę gali gauti asmens duomenis vykdydamos konkretų tyrimą, nelaikomos duomenų gavėjais; tvarkydamos tuos duomenis, tos valdžios institucijos laikosi taikomų duomenų tvarkymo tikslus atitinkančių duomenų apsaugos taisyklių. <br>Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">4 str. 9 d. [BDAR]</a>",
			name: "Duomenų gavėjas",
			source: "BDAR 4 str. 9 d."
		},
		PIA_DEF_EFF: {
			description: "Duomenų subjektas turi teisę reikalauti, kad duomenų valdytojas nepagrįstai nedelsdamas ištrintų su juo susijusius asmens duomenis, o duomenų valdytojas yra įpareigotas nepagrįstai nedelsdamas ištrinti asmens duomenis, jei tai galima pagrįsti viena iš šių priežasčių, žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">17 str. [BDAR]</a>",
			name: "Teisė reikalauti ištrinti duomenis",
			source: "BDAR 17 str."
		},
		PIA_DEF_ENJ: {
			description: "Kokios naudos tikimasi organizacijai, duomenų subjektams, visuomenei bendrai ir t.t.",
			name: "Lūkečiai",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Asmens duomenys turi būti tikslūs ir prireikus atnaujinami; turi būti imamasi visų pagrįstų priemonių užtikrinti, kad asmens duomenys, kurie nėra tikslūs, atsižvelgiant į jų tvarkymo tikslus, būtų nedelsiant ištrinami arba ištaisomi (tikslumo principas). <br>Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">5 str. 1 d. d p. [BDAR]</a>",
			name: "Asmens duomenų kokybė",
			source: "BDAR 5 str. 1 d. d p.)"
		},
		PIA_DEF_GRV: {
			description: "Rizikos laipsnis priklauso nuo preliminaraus galimo neigiamo poveikio vertinimo",
			name: "Rizikos laipsnis",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Duomenų subjektas turi teisę reikalauti, kad duomenų valdytojas apribotų duomenų tvarkymą kai taikomas vienas iš šių atvejų, žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">18 str. [BDAR]</a>",
			name: "Teisė apriboti duomenų tvarkymą",
			source: "BDAR 18 str."
		},
		PIA_DEF_LOG: {
			description: "Naudokite veiksmų registravimą, kad būtų galima ankstyvoje stadijoje pastebėti incidentus, juos analizuoti ir surinkti jų tyrimui reikalingus įrodymus.",
			name: "Veiksmų protokolavimas, jų atsekamumas",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Veiksmai, kurie gali paveikti duomenis apdorojančias sistemas ir jose saugomus duomenis bei sukelti žalą duomenų subjektams. Grėsmės gali būti sukeltos sąmoningai arba netyčia.",
			name: "Grėsmės",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Grėsmės susijusios su:-<strong> techninė įranga </strong>, netinkamai naudojama, prižiūrima, pakeista, prarasta (techninės įrangos su jautria informacija naudojimas asmeniniais tikslais, jos naudojimas viešose vietose, įrangos stebėjimas klavišų registravimo priemonėmis ir pan.)<br>-<strong> Programinė įranga </strong>, netinkamai naudojama, prižiūrima, pakeista (naudojimosi teisių išplėtimas, konfigūravimo duomenų rinkimas, kenkėjiškų programų įdiegimas ir pan.)<br>-<strong> Kompiuteriniai tinklai </strong> (tinko duomenų srautų stebėjimas, tinklo duomenų srauto perėmimas ir pan.)<br>-<strong> Žmonės </strong>, sekami, manipuliuojami(netyčinis informacijos atskleidimas, psichologinė manipuliacija, darbdavio pakeitimai)<br>-<strong> Popieriniai dokumentai </strong>, pastebėti, prarasti (nukopijavimas, nufotografavimas, sunaikintų dokumentų atstatymas, korespondencijos vagystė pan kt.) <br>-<strong>Pašto persiuntimas</strong> šnypinėjimas",
			name: "Grėsmės, susijusios su neteisėta prieiga prie duomenų",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Grėsmės susijusios su: </strong><br>- <strong>Hardware</strong> : used inappropriately, overloaded, altered, damaged, lost (storage unit full, processing capacity overload, addition of incompatible hardware resulting in malfunctions,  fire, theft or loss of an asset, etc.)<br>- <strong>Software</strong> : used inappropriately, overloaded, altered, damaged, lost (erasure of data, exceeding of database size, logic bomb, non-renewal of the licence for software used to access data, etc.)<br>- <strong>Computer channels</strong> : overloaded, altered, lost (unauthorised downloading, loss of Internet connection, etc.)<br>- <strong>People</strong> : overloaded, damaged, lost (poor use of skills, disease, retirement, etc.)<br>- <strong>Paper documents</strong> : used inappropriately, damaged, lost (erasure, aging of archived documents, theft or loss of documents, etc.)<br>- <strong>Paper transmission channels</strong> : overloaded, damaged, altered, lost (mail delivery halted by a strike, reassignment of offices or premises, loss of a document delivery company, reorganisation of paper transmission channels, etc.)",
			name: "Grėsmės, dėl kurių gali pradingti asmens duomenys",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Grėsmės susijusios su: </strong><br>- <strong>techninės įrangos</strong> pakeitimais (nesuderintos įrangos prijungimas, sąlygojantis veikimo sutrikimus, svarbių techninės įrangos dalių pašalinimas, atjungimas ir pan.) <br>- <strong>programinės įrangos</strong> netinkamas naudojimas ar pakeitimas (nenorimas duomenų pakeitimas duomenų bazėse, administratoriaus klaidos, sąlygojančios duomenų pakeitimą ir pan.)<br>- <strong>kompiuterinių tinklų </strong> netinkamas naudojimas (perimtų duomenų persiuntimas ir pan.)<br>- <strong>Žmonių</strong> nuovargis ar manipuliacijos jais (atsakomybių, viršijančių žmogaus kompetencijas, suteikimas, stresas, bloga, įtempta atmosfera darbo vietoje, darbo sąlygų bloginimas, neigiami polinkiai ir pan.)<br>- Popierinių dokumentų pakeitimas (skaičių pakeitimas failuose, originalo pakeitimas klastote ir pan.)<br>- <strong>Dokumentų perdavimo kanalų</strong> pakeitimas (tų pačių dokumentų skirtingų versijų siuntimas ir pan.)",
			name: "Grėsmės, dėl kurių gali būti neteisėtai pakeisti asmens duomenys",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Pasirinkite priemonę iš skyriaus 'Planuojamos arba egzistuojančios apsaugos priemonės', esant poreikiui, papildykite jas.",
			name: "Priemonės",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "Importuojant duomenis, gali būti nesąmoningai kaupiami vadinamieji meta-duomenys (pvz. EXIF duomenys, kurie būna prisegti prie paveikslų failų). Tokius meta-duomenis reikėtų identifikuoti ir ištrinti, jei jie nebūtini duomenų tvarkymo tikslui.",
			name: "Filtravimas ir ištrynimas",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Tam tikrais atvejais gavus jautrius duomenis, jie gali būti transformuojami į mažiau jautrius duomenis arba jiems gali būti suteikti pseudonimai. Pavyzdžiui: <br>-jei programoje tvarkomi IP adresai, kad statistiniais tikslais būtų galima nustatyti vartotojo geografinę vietą, tai, nustačius miestą ar regioną, IP adresą būtų galima ištrinti <br>-jei programoje renkami ir tvarkomi vaizdo duomenys, gaunami iš video stebėjimo sistemų, tai žmonių atvaizdus galima būtų retušuoti-jei naudojami išmanieji skaitikliai, tai galima apskaičiuoti bendrą energijos suvartojimą tam tikru laikotarpiu ir energijos suvartojimo neregistruoti realiuoju laiku.",
			name: "Duomenų jautrumo sumažinimas jų transformavimo pagalba",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "IT sistema gali leisti:<br>- vartotojui naudotis paslaugomis ar kitais resursais, neatskleidžiant savo tapatybės (tvarkomi tik anoniminiai vartotojų duomenys)<br>- vartotojui naudotis paslaugomis ar kitais resursais, neatskleidžiant savo tapatybės. Tačiau vartotojui suteikiant pseudonimus <br>- vartotojui naudotis paslaugomis ar kitais resursais be rizikos, kad visi jo skirtingi veiksmai bus tarpusavyje susieti ir apjungti<br>- vartotojui naudotis paslaugomis ar kitais resursais be galimybės trečiosioms šalis stebėti jo elgseną<br> Konkretaus iš minėtų būdų pasirinkimas priklauso nuo nustatytų galimų grėsmių privatumui. Dėl kai kurių grėsmių pseudonimų suteikimas yra tinkamesnis būdas nei duomenų nuasmeninimas (pvz., jei reikalingas veiksmų atsekamumas). Dėl tam tikrų grėsmių galima naudoti keletą būdų.",
			name: "Žmogų indentifikuojančių duomenų sumažinimas",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "IT sistema gali būti suskaidyta į atskiras dalis, turinčiomis atskiras prieigos kontroles. Duomenis taip pat galima paskirstyti tarp šių atskirų posistemių ir kontroliuoti kiekvieną posistemę naudojant skirtingus prieigos kontrolės mechanizmus. Jei viena iš posistemių yra pažeista, poveikis visiems duomenims gali būti reikšmingai sumažintas.",
			name: "Duomenų saugojimo išskaidymas",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Prieigą prie duomenų galima riboti pagal principą \"tik tam, kam būtina\". Sistemoje galima laikyti specialių kategorijų duomenis atskirai ir dar griežčiau riboti prieigą prie jų. Specialių kategorijų duomenys gali būti šifruojami tiek juos saugant, tiek perduodant tinkle. Prieiga prie slapukų surinktų duomenų taip pat turi būti apsaugota.",
			name: "Prieigos prie duomenų ribojimas",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Riziką galima sumažinti, sumažinant tvarkomų asmens duomenų apimtį. Reikia rinkti ir tvarkyti tik tuos duomenis, kurie būtini duomenų tvarkymo tikslui pasiekti.",
			name: "Asmens duomenų apimties mažinimas",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Sumažinti riziką galimą, sumažinant tvarkomų duomenų kiekį ir sumažinant jų jautrumą pseudonimų suteikimo pagalba, ištrinant nebereikalingus duomenis, filtravimo pagalba ir pan.",
			name: "Asmens duomenų kiekio mažinimas",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Duomenų subjektas turi teisę dėl su jo konkrečiu atveju susijusių priežasčių bet kuriuo metu nesutikti, kad su juo susiję asmens duomenys būtų tvarkomi pagal <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">21 str. [BDAR]</a>",
			name: "Teisė nesutikti",
			source: "BDAR 21 str."
		},
		PIA_DEF_PBDS: {
			description: "Priemonės, kurių imamasi diegiant duomenų apsaugos reikalavimus naujuose projektuose.",
			name: "Projekto valdymas",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_PC: {
			description: "Žmogus, kurio asmens duomenys yra tvarkomi.",
			name: "Duomenų subjektas",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: "Duomenų subjektas turi teisę gauti su juo susijusius asmens duomenis, kuriuos jis pateikė duomenų valdytojui susistemintu, įprastai naudojamu ir kompiuterio skaitomu formatu, ir turi teisę persiųsti tuos duomenis kitam duomenų valdytojui, o duomenų valdytojas, kuriam asmens duomenys buvo pateikti, turi nesudaryti tam kliūčių, žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">20 str. [BDAR]</a>",
			name: "Teisė į duomenų perkeliamumą",
			source: "BDAR 20 str."
		},
		PIA_DEF_PSEU: {
			description: "Asmens duomenų tvarkymas taip, kad asmens duomenys nebegalėtų būti priskirti konkrečiam duomenų subjektui nesinaudojant papildoma informacija, jeigu tokia papildoma informacija yra saugoma atskirai ir jos atžvilgiu taikomos techninės bei organizacinės priemonės siekiant užtikrinti asmens duomenų nepriskyrimą fiziniam asmeniui, kurio tapatybė yra nustatyta arba kurio tapatybę galima nustatyti. .<br>Pseudonimų suteikimas sumažina riziką, kad duomenys bus susieti su konkrečiu duomenų subjektu, tai naudingas metodas, tačiau tai nėra tas pats, kas duomenų nuasmeninimas.",
			name: "Pseudonimų duomenims suteikimas",
			source: "BDAR 4 str. 5 d. ir 29 Darbo Grupės nuomonė žr. http://ec.europa.eu/justice/article-29/documentation/opinion-recommendation/files/2014/wp216_lt.pdf"
		},
		PIA_DEF_PWD: {
			description: "Slaptažodžius turi sudaryti ne mažiau kaip aštuoni simboliai. Slaptažodžiai turi būti keičiami, ypač tuomet, jei kyla bent mažiausių abejonių dėl to, kad slaptažodį galėjo sužinoti kitas asmuo. Periodiškai slaptažodžiai gali būti keičiami kas tris, šešis mėnesius arba kartą per metus. Slaptažodžius turėtų sudaryti bent trys iš keturių simbolių rūšių (didžiosios raidės, mažosios raidės, skaitmenys ir specialieji simboliai). Keičiant slaptažodį negalima vietoj jo naudoti penkių paskutinių prieš tai jau naudotų slaptažodžių. Tas pats slaptažodis neturėtų būti naudojamas autentifikuotis skirtingose prieigose. Slaptažodžiai neturėtų būti susiję su asmenine informacija (pvz., vardu ar gimimo data). Nustatykite maksimalų slaptažodžio įvedimo bandymų skaičių su įspėjimu apie autentifikavimosi užblokavimą (laikinai arba kol jis bus rankiniu būdu atblokuotas).",
			name: "Slaptažodžiai",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Duomenų subjektas turi teisę reikalauti, kad duomenų valdytojas nepagrįstai nedelsdamas ištaisytų netikslius su juo susijusius asmens duomenis. Atsižvelgiant į tikslus, kuriais duomenys buvo tvarkomi, duomenų subjektas turi teisę reikalauti, kad būtų papildyti neišsamūs asmens duomenys, be kita ko, pateikdamas papildomą pareiškimą.",
			name: "Teisė reikalauti ištaisyti duomenis",
			source: "BDAR 16 str."
		},
		PIA_DEF_RGPD: {
			description: "Reglamentas (ES) 2016/679 dėl fizinių asmenų apsaugos tvarkant asmens duomenis ir dėl laisvo tokių duomenų judėjimo ir kuriuo panaikinama Direktyva 95/46/EB.",
			name: "BDAR (Bendrasis duomenų apsaugos reglamentas)",
			source: "BDAR pavadinimas"
		},
		PIA_DEF_RT: {
			description: "fizinis arba juridinis asmuo, valdžios institucija, agentūra ar kita įstaiga, kuris vienas ar drauge su kitais nustato duomenų tvarkymo tikslus ir priemones; kai tokio duomenų tvarkymo tikslai ir priemonės nustatyti Sąjungos arba valstybės narės teisės, duomenų valdytojas arba konkretūs jo skyrimo kriterijai gali būti nustatyti Sąjungos arba valstybės narės teise.<br>Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\"> 4 str. 7 d. [BDAR]</a>",
			name: "Duomenų valdytojas",
			source: "BDAR 4 str. 7 d."
		},
		PIA_DEF_SRC: {
			description: "Riziką gali sukelti žmogaus veiksmai ir ne nuo žmogaus priklausantys faktoriai. Tai gali įvykti atsitiktinai arba sukelti tyčia.",
			name: "Rizikos šaltiniai",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Fizinis arba juridinis asmuo, valdžios institucija, agentūra ar kita įstaiga, kuri duomenų valdytojo vardu tvarko asmens duomenis, žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">4 str. 8 d. [BDAR]</a>. Duomenų tvarkytojas tvarko asmens duomenis tik pagal duomenų valdytojo dokumentais įformintus nurodymus, įskaitant susijusius su asmens duomenų perdavimu į trečiąją valstybę ar tarptautinei organizacijai, išskyrus atvejus, kai tai daryti reikalaujama pagal Sąjungos arba valstybės narės teisę, kuri yra taikoma duomenų tvarkytojui, žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">29 str. [BDAR]</a>",
			name: "Duomenų tvarkytojas",
			source: "BDAR 4 str. 8 d. ir 29 str."
		},
		PIA_DEF_SUPT: {
			description: "Ištekliai, nuo kurių priklauso duomenų tvarkymas. Jais gali būti techninė įranga, programinė įranga, tinklas, žmonės, popieriniai dokumentai, dokumentų perdavimo sistemos.",
			name: "Pagalbiniai ištekliai",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Saugumo pažeidimas, dėl kurio netyčia arba neteisėtai sunaikinami, prarandami, pakeičiami, be leidimo atskleidžiami persiųsti, saugomi arba kitaip tvarkomi asmens duomenys arba prie jų be leidimo gaunama prieiga.",
			name: "Asmens duomenų saugumo pažeidimas",
			source: "BDAR 4 str. 12 d."
		},
		PIA_DEF_VRA: {
			description: "Tikimybė, kad įvyks potenciali rizika. Tikimybės dydis priklauso nuo įrangos ir kitų išteklių pažeidžiamumo laipsnio ir riziką sukeliančių šaltinių potencialo juos pažeisti.",
			name: "Tikimybė",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Identifikaciniai duomenys</strong> : vardas, pavardė, amžius,  pilietybė, gyv, vietos adresas, t.t. <br><strong>Asmens gyvenimas</strong> : pmoėgiai, įpročiai, šeimyninė padėtis, t.t. <br><strong>Profesinis gyvenimas </strong> : darbovietė, veiklos pobūdis, išsilavinimas, gyvenimo aprašymas (CV), išsilavinimas, mokymai, profesiniai pasiekimai, apdovanojimai, t.t. <br><strong>Ryšio duomenys </strong> : IP adresas, veiksmų žurnalas (angl. event logs), t.t.<br><strong>Geografinės vietos duomenys</strong> : keliavimo maršrutai, GPS duomenys, GPS duomenys, t.t.<br><strong>Kita informacija</strong> : telefono numeris, el. pašto adresas, t.t.",
			name: "Bendrieji asmens duomenys",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Rasinė ir etninė kilmė, politinės pažiūros, religiniai ir filosofiniai įsitikinimai, narystė profesinėse sąjungose, genetiniai duomenys, biometriniai duomenys, siekiant konkrečiai nustatyti fizinio asmens tapatybę, sveikatos duomenys, duomenys apie fizinio asmens lytinį gyvenimą ir lytinę orientaciją, duomenys apie apkaltinamuosius nuosprendžius ir nusikalstamas veikas, žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">9-10 str. [BDAR]</a>.",
			name: "Specialių kategorijų asmens duomenys"
		},
		PIA_EX_DCPS: {
			description: "Asmens kodas, finansiniai duomenys",
			name: "Jautraus pobūdžio asmens duomenys"
		},
		PIA_EX_HUME: {
			description: "Tai gali būti: <br>- trečiojo asmens įsilaužimas į sistemą<br>- įsilaužėlis, kuris disponuoja tam tikra informacija apie vartotoją<br>- įsilaužėlis, kuris disponuoja tam tikra informacija apie įmonę, kuri yra duomenų valdytoja ar duomenų tvarkytoja<br>- įgaliota trečioji šalis, kuri savo turimą prisijungimą naudoja, siekdama neteisėtai gauti prieigą prie duomenų.",
			name: "Išorinės žmogiškos rizikos"
		},
		PIA_EX_HUMI: {
			description: "Tai gali būti: <br>- darbuotojų neatsargumas ar apsileidimas, mokymų ir įgūdžių trūkumas <br>-  nesąžiningumas, galimybė darbuotojo artimiesiems ar jo draugams pasinaudoti darbiniais įrankiais ir gauti prieigą prie duomenų<br>- įvairūs kiti galimi motyvai: suklydimas, aplaidumas, piktybiški ketinimai, kerštas, komercinis šnipinėjimas.",
			name: "Vidinės žmogiškosios rizikos"
		},
		PIA_EX_IMPI: {
			description: "Duomenų subjektai gali patirti reikšmingas neigiamas pasekmes, kurias pašalinti yra įmanoma, bet gana sunku ir tam reikia didelių pastangų. <br> Pasekmių pvz.:<br>- fizinės: rimti fiziniai negalavimai, sukeliantys ilgalaikes neigiamas pasekmes (sveikatos pablogėjimas dėl netinkamos priežiūros arba kontraindikacijų nepaisymas); fizinio neliečiamumo pažeidimas (nelaimingas atsitikimas namuose, darbe ir kt.) <br>- materialinės: neteisėtai pasisavinti pinigai, kurių susigrąžinti nebeįmanoma; prarastos galimybės (būsto kredito, studijų, stažuočių, įdarbinimo, draudimas laikyti egzaminą); būsto praradimas; darbo netekimas; t.t.;<br>- moralinės: rimti psichologiniai negalavimai (depresija, fobijos); privatumo pažeidimas su neatitaisoma žala; šantažavimas; patyčios; priekabiavimas ir t.t.",
			name: "Reikšmingas poveikis"
		},
		PIA_EX_IMPL: {
			description: "Duomenų subjektai gali patirti reikšmingus nepatogumus, tačiau juos galima pašalinti, nors ir su tam tikrais sunkumais. <br>Pasekmių pvz.:<br>- fizinės: lengvas susirgimas, laiku nenustačius diagnozės; šmeižtas, sukeliantis neigiamus fizinius ir psichologinius išgyvenimus;<br>- materialinės: nenumatyti mokėjimai dėl per klaidą paskirtos baudos; atsisakymas suteikti viešąsias ar kitokias paslaugas; nepageidaujamų el. laiškų gavimas, jei tai kenkia dalykinei reputacijai;<br>- moralinės: nežymūs, bet objektyvūs psichologiniai negalavimai; dvasiniai išgyvenimai; privatumo pažeidimo jausmas; bauginimas (klaidingų žinių sąmoningas skleidimas) socialiniuose tinkluose ir kt.",
			name: "Ribotas poveikis"
		},
		PIA_EX_IMPM: {
			description: "Duomenų subjektai gali susidurti su labai reikšmingomis neigiamomis pasekmėmis, kur žala gali būti neatitaisoma. <br>Poveikio pvz.: <br> - fizinės: ilgalaikiai arba nuolatiniai fiziniai negalavimai, fiziniai kūno sutrukimai, neįgalumas, mirtis, kt.<br>- materialiniai: finansinė rizika, didelės skolos, nedarbingumas, negalėjimas persikelti į kitą gyvenamąją vietą, įrodymų praradimas teisminiame ginče, galimybės naudotis svarbia infrastruktūra praradimas (vanduo, elektra, internetu), ir kt. <bt>- moralinis: ilgalaikiai arba nuolatiniai psichologiniai negalavimai, baudžiamosios sankcijos, pagrobimas, šeimyninių ryšių nutrūkimas, negalėjimas atvykti į teismą ir kt.",
			name: "Maksimalus poveikis"
		},
		PIA_EX_IMPN: {
			description: "Tai nepaveiks duomenų subjektų arba sukels jiems nedidelių nepatogumų, kuriuos jie nesunkiai gali įveikti. <br>Pasekmių pvz.:<br>- nedidelis galvos skausmas;<br>- laiko praradimas kartojant formalumus arba laukiant jų įvykdymo, nepageidaujamų el. laiškų gavimas, viešai prieinamų duomenų naudojimas tikslinei tiesioginei rinkodarai ir t.t.<br>- sukeltas pyktis, dvasinis diskomfortas, pažeisto privatumo jausmas, nesukeliantis realių nuostolių ir t.t.",
			name: "Nedidelis poveikis"
		},
		PIA_EX_NHUM: {
			description: "Tai gali būti incidentas ar nelaimė pas duomenų valdytoją (elektros dingimas, gaisras, potvynis, techninis sutrikimas ir pan.).",
			name: "Ne nuo žmogaus priklausančios rizikos"
		},
		PIA_EX_VRAI: {
			description: "Atsižvelgiant į rizikos šaltinius tikėtina, kad tai gali sukelti žalą asmenims (pvz., dokumentų vagystė iš saugomos patalpos, į kurią pateikimą kontroliuoja tik biuro priimamojo sekretorė).",
			name: "Reikšminga tikimybė"
		},
		PIA_EX_VRAL: {
			description: "Atsižvelgiant į rizikos šaltinius sunkiai tikėtina, kad tai galėtų sukelti kokią nors žalą asmenims (pvz., dokumentų vagystė iš saugomos patalpos, į kurią pateikimas kontroliuojamas kortelių skaitytuvo pagalba).",
			name: "Ribota tikimybė"
		},
		PIA_EX_VRAM: {
			description: "Atsižvelgiant į rizikos šaltinius labai tikėtina, kad tai sukels žalą asmenims (pvz., dokumentų, saugomų visiems prieinamoje vietoje, į kurią patekimas nekontroliuojamas, vagystė).",
			name: "Maksimali tikimybė"
		},
		PIA_EX_VRAN: {
			description: "Atsižvelgiant į rizikos šaltinius neįmanoma nuspėti, kad tai galėtų sukelti kokią nors žalą asmenims (pvz., dokumentų vagystė iš saugomos patalpos, į kurią patekti galima tik su asmeniniu įėjimo kodu ir pažymėjimu).",
			name: "Nereikšminga tikimybė"
		},
		PIA_LGL_CONS: {
			description: "Sutikimas turi būti suteiktas laisva valia, konkretus, informacija pagrįstas ir vienareikšmis nurodymas. Nustatykite, ar duomenų tvarkymas remiasi kitu nei sutikimas teisiniu pagrindu pagal <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">[BDAR]</a> 6 str.",
			name: "Sutikimas",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Detaliau aprašykite duomenų tvarkymą ir susijusius procesus: <br>- asmens duomenų kategorijas, asmens duomenų gavėjus, asmens duomenų saugojimo trukmę <br>- procesai ir įmonės tvarkos, padedantys tvarkyti nuo asmens duomenis nuo jų gavimo iki ištrynimo.",
			name: "Duomenys ir procesai",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Trumpai aprašykite planuojamą asmens duomenų tvarkymą, jo pobūdį, apimtį, tikslus, nurodykite kokie asmenys dalyvaus, asmens duomenų tvarkyme. Taip pat nurodykite duomenų valdytojus ir tvarkytojus. Nurodykite duomenų tvarkymą reglamentuojančias tvarkas ir teisės normas, kurių privaloma laikytis, taip pat patvirtintus elgesio kodeksus, kai jie taikomi. (žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">[BDAR] 40 str.</a>) ir duomenų apsaugos sertifikavimas (žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[BDAR] 42 str.</a>)",
			name: "Duomenų tvarkymo aprašymas",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Fizinis arba juridinis asmuo, valdžios institucija, agentūra ar kita įstaiga, kuriai atskleidžiami asmens duomenys, nesvarbu, ar tai trečioji šalis ar ne. Tačiau valdžios institucijos, kurios pagal Sąjungos arba valstybės narės teisę gali gauti asmens duomenis vykdydamos konkretų tyrimą, nelaikomos duomenų gavėjais; tvarkydamos tuos duomenis, tos valdžios institucijos laikosi taikomų duomenų tvarkymo tikslus atitinkančių duomenų apsaugos taisyklių. Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">[BDAR]</a> 4 str. 9 p.",
			name: "Duomenų gavėjai",
			source: "BDAR 4 str. 9 d."
		},
		PIA_LGL_DUR: {
			description: "Duomenų saugojimo trukmė turi būti nustatyta kiekvienai asmens duomenų kategorijai ir pagrįsta teisiniais reikalavimais ir/ar duomenų tvarkymo poreikiais. Tam tikslui, reikia skirti tvarkomus duomenis nuo suarchyvuotų duomenų, prieigą prie pastarųjų gali būti suteikta tik ribotam ratui atsakingų asmenų. Turi būti įgyvendinta duomenų ištrynimo tvarka tam, kad būtų galima suarchyvuoti duomenis ir juos ištrinti, kai sueina duomenų saugojimo terminas. Prieigos registracijos duomenys (logs) taip pat turi būti ištrinti, o techniniai protokolų duomenys negali būtų saugoti neribotai.",
			name: "Saugojimo trukmė",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Asmens duomenys turi būti renkami nustatytais, aiškiai apibrėžtais bei teisėtais tikslais ir toliau netvarkomi su tais tikslais nesuderinamu būdu.</strong> <br>Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\"> 5 str. 1 d. b p.) [BDAR]</a>",
			name: "Su asmens duomenų tvarkymu susiję principai",
			source: "BDAR 5 str. 1 d. b p.)"
		},
		PIA_LGL_FOND: {
			description: "- duomenų subjektas davė sutikimą, kad jo asmens duomenys būtų tvarkomi vienu ar keliais konkrečiais tikslais <br>- tvarkyti duomenis būtina siekiant įvykdyti sutartį, kurios šalis yra duomenų subjektas, arba siekiant imtis veiksmų duomenų subjekto prašymu prieš sudarant sutartį <br>-tvarkyti duomenis būtina, kad būtų įvykdyta duomenų valdytojui taikoma teisinė prievolė <br>- tvarkyti duomenis būtina siekiant apsaugoti gyvybinius duomenų subjekto ar kito fizinio asmens interesus <br>- tvarkyti duomenis būtina siekiant atlikti užduotį, vykdomą viešojo intereso labui arba vykdant duomenų valdytojui pavestas viešosios valdžios funkcijas <br>- tvarkyti duomenis būtina siekiant teisėtų duomenų valdytojo arba trečiosios šalies interesų, išskyrus atvejus, kai tokie duomenų subjekto interesai arba pagrindinės teisės ir laisvės, dėl kurių būtina užtikrinti asmens duomenų apsaugą, yra už juos viršesni, ypač kai duomenų subjektas yra vaikas <br> Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">str. 6 of [BDAR]</a>",
			name: "Duomenų tvarkymo teisinis pagrindas",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Duomenų subjektai privalo būti informuoti. Siekite užtikrinti, kad duomenų tvarkymas nebūtų grindžiamas išimtimi ar ypatingomis sąlygomis.",
			name: "Duomenų subjektų informavimas",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Siekiant sumažinti kylančias rizikas, reikia mažinti tvarkomų duomenų kiekį, tvarkyti tik tuos duomenis, kurių būtini duomenų tvarkymo tikslų pasiekimui. Venkite nereikalingų asmens duomenų rinkimo ir tvarkymo.",
			name: "Duomenų kiekio mažinimas",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Susitarimas dėl asmens duomenų tvarkymo turi būti pasirašytas su kiekvienu duomenų tvarkytoju. Susitarime turi būti nurodytos [BDAR] 28 str. nustatytos sąlygos: trukmė; tvarkymo apimtis; tikslas; dokumentuoti nurodymai apie asmens duomenų tvarkymą; išankstinis patvirtinimas, pasitelkiant pagalbinį tvarkytoją; dokumentų, patvirtinančių atitiktį [BDAR] reikalavimams, pateikimas; skubus informavimas apie duomenų saugumo pažeidimą; t.t.",
			name: "Duomenų tvarkytojo pasitelkimas",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Priemonės, kurios būtinos asmens duomenų tvarkymui. Pvz. jomis gali būti, techninė kompiuterinė įranga, programinė įranga, kompiuterinis tinklas, žmonės, popieriniai dokumentai, popierinių dokumentų perdavimo būdai ir pan.",
			name: "Pagalbinės priemonės",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Nurodykite šalis, kuriuose bus tvarkomi asmens duomenys. Priklausomai nuo pasirinktos šalies, Jums reikės teisiškai pagrįsti asmens duomenų teikimą į jas ir nurodyti, kokių teisinių bei techninių ir organizacinių apsaugos priemonių buvo imtasi, siekiant užtikrinti tinkamą asmens duomenų, kurie yra teikiami į kitas šalis, apsaugą. Tokiomis priemonėmis gali būti: <br>- Europos Sąjungos<br>- šalies pripažinimas, kad ji užtikrina tinkamą asmens duomenų apsaugą <br>- Duomenų teikimas į JAV, ten esančiai bendrovei, kuri yra prisijungusi prie Privacy Shield programos <br>- Dėl kitų šalių <br>žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\"> [BDAR] 44-49 str. </a>",
			name: "Duomenų teikimas į trečiąsias šalis",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Kokių veiksmų imamais, kad duomenų apsaugos priemonės atitiktų gerąją praktiką ir duomenų apsaugos teisės aktų reikalavimus (asmens duomenų apsaugos auditai, duomenų tvarkymo tikslų peržiūra, atsakomybių kontrolė).",
			name: "Duomenų apsaugos priemonių stebėjimas",
			placeholder: "Nurodykite, ar stebimas duomenų apsaugos priemonių efektyvumas ir tinkamumas esamai situacijai.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Kokios tvarkos egzistuoja ir kokių veiksmų imamasi, siekiant užkirsti kelią neteisėtam trečiųjų šalių asmens duomenų tvarkymui (trečiųjų šalių identifikavimas, susitarimas dėl duomenų tvarkymo ir teikimo, sutartiniai įsipareigojimai, elgesio kodeksai, binding corporate rules ir pan.)",
			name: "Santykiai su trečiosiomis šalimis",
			placeholder: "Nurodykite, kokia atliekama duomenų tvarkytojų patikimumo patikra.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Ar paskirtas organizacijoje asmuo, atsakingas už duomenų apsaugos teisės aktų reikalavimų įgyvendinimą ir kontrolę (duomenų apsaugos pareigūno paskyrimas, komandos, atsakingos už duomenų apsaugos valdymą, subūrimas ir pan.).",
			name: "Duomenų apsaugos organizacija",
			placeholder: "Nurodykite, ar aprašytos su duomenų apsauga susijusios atsakomybės ir funkcijos.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Tvarkos, skirtos užtikrinti asmens duomenų apsaugą visose naujose duomenų tvarkymo operacijose, egzistavimas.",
			name: "Duomenų apsaugos taikymas projektuose",
			placeholder: "Nurodykite, kokių veiksmų imamasi, siekiant užtikrinti asmens duomenų apsaugą, naujo projekto pradžioje, kuriame planuojama tvarkyti asmens duomenis",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Tvarka, kurioje aprašomi darbuotojų mokymai, siekiant juos supažindinti su asmens duomenų tvarkymo ir apsaugos taisyklėmis bei skatinant juos turėti daugiau sąmoningumo duomenų apsaugos ir privatumo apsaugos klausimais.",
			name: "Personalo valdymas",
			placeholder: "Ar darbuotojams yra daromi mokymai?",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Duomenų valdytojas privalo turėti pasitvirtinęs vidines taisykles (tvarkas), kuriuose būtų nustatytos duomenų apsaugos įgyvendinimo taisyklės ir procedūros (veiksmų planas, atsakingi asmenys, tvarkų revizijos ir pan.).",
			name: "Tvarkos",
			placeholder: "Nurodykite dokumentus, kuriuose būtų aprašyta duomenų apsaugos tikslai ir taisyklės.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Taisyklės ir procesai, skirti su duomenų subjektų teisių ir laisvių pažeidimu susijusios rizikos valdymui (duomenų tvarkymo procesų, tvarkomų duomenų, naudojamų priemonių nustatymas, rizikos vertinimas, esamų ir planuojamų priemonių vertinimas ir pan.).",
			name: "Rizikų privatumui valdymas",
			placeholder: "Nurodykite procesus, kurių pagalba siekiama kontroliuoti duomenų subjektams kylančias privatumo pažeidimo rizikas, susijusias su organizacijoje tvarkomais duomenimis",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Atsakingų asmenų, kurie atpažintų ir valdytų asmens duomenų saugos pažeidimus, paskyrimas (atsakomybių nustatymas, reakcijos laikai, saugos pažeidimų aprašymas ir pan.).",
			name: "Duomenų apsaugos pažeidimų valdymas",
			placeholder: "Aprašykite, kaip nustatomi asmens duomenų apsaugos pažeidimai ir kokių veiksmų tuomet imamasi",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Aprašykite tvarkas, skirtas užtikrinti duomenų prieinamumą ir vientisumą, tuo pačiu užtikrinant jų konfidencialumą (atsarginių kopijų darymo periodiškumas, perduodamų duomenų šifravimas, duomenų vientisumo testai ir pan.).",
			name: "Atsarginės kopijos",
			placeholder: "Nurodykite, kaip valdomos atsarginės duomenų kopijos. Įvertinkite ar jos saugomos saugioje vietoje",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Aprašykite, kokių priemonių imamasi, kad nebūtų įsilaužta į personalinius kompiuterius ir juose įdiegtą programinę įrangą bei nebūtų pažeisti ten tvarkomi asmens duomenys (automatinis užraktas, periodiniai programinės įrangos atnaujinimai, fizinė sauga, prieigos kontrolė, išsilaužimo testai, veiksmų protokolavimas ir pan.)",
			name: "Personalinių kompiuterių administravimas",
			placeholder: "Nurodykite, kaip kontroliuojami personaliniai kompiuteriai",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "Duomenų tvarkytojas, kuriam perduodami asmens duomenys ar kuris juos tvarko, turi suteikti pakankamas garantijas. Tam būtina sudaryti susitarimą. <strong>Naudokitės tik patikimų duomenų tvarkytojų paslaugomis </strong> (ypač atsižvelkite į technines kompetencijas, patikimumą ir jo turimus resursus). Reikalaukite, kad tiekėjas pateiktų informacinių sistemų saugumo gaires. <br>Atlikite patikrą ir ją dokumentuokite (saugumo auditai, patalpų apžiūra) tam, kad įsitikintumėte, jog duomenų tvarkytojo suteiktos duomenų apsaugos garantijos iš tiesų egzistuoja. Garantijos apima: <br>- duomenų šifravimas, priklausomai nuo jų jautrumo lygio arba, jei tai neaktualu, buvimas procedūrų, kurių pagalba užtikrinama, kad paslaugų teikėjas neturėtų fizinės prieigos prie tvarkomų duomenų,<br>- perduodamų duomenų šifravimas (pvz.: HTTPS protokolo pagalba, VPN, t.t.)<br>- tinklo apsaugos garantijos, įvykių atsekamumo galimybė (protokolai, auditai), autorizavimosi valdymas, tapatybės nustatymas ir t.t.<strong>susitarimo su duomenų tvarkytoju sudarymas</strong>, jame turi būtų apibrėžtas susitarimo tikslas, trukmė, duomenų tvarkymo tikslas ir susitarimo šalių įsipareigojimai. Įsitikinkite, kad sutartyje būtų šios sąlygos:<br>- tvarkytojo konfidencialumo įsipareigojimas jo tvarkomų asmens duomenų atžvilgiu<br>- minimalūs reikalavimai vartotojų tapatybės nustatymui<br>- reikalavimai dėl duomenų grąžinimo, sunaikinimo ar ištrynimo, kai susitarimas pasibaigia<br>- pranešimų apie duomenų apsaugos pažeidimus ir incidentus taisyklės. Tokį pranešimą duomenų valdytojas turi gauti nedelsiant, per kiek įmanomai trumpiausią terminą. <br>- Naudojant debesų kompiuterijos paslaugas:<br>\t1. aiškiai nurodykite asmens duomenų kategorijas ir duomenų tvarkymo veiksmus, kurie yra perkelti į debesis;<br>\t2. savo pačių nustatyti techniniai ir teisiniai saugos reikalavimai;<br>\t3. atlikite rizikos vertinimą tam, kad nustatytumėte tinkamas saugumo priemones;<br>\t4. nustatykite, kokio tipo debesų paslaugos naudojamos tvarkant duomenis;<br>\t5. pasirinkite tokį tiekėją, kuris suteikia pakankamas garantijas;<br>\t6. patikrinkite atitiktį vidinėms saugos gairėms;<br>\t7. stebėkite pasikeitimus sutartinių santykių metu.",
			name: "Susitarimai dėl duomenų tvarkymo",
			placeholder: "Nurodykite, kokie reikalavimai taikomi duomenų tvarkytojui (prieglobos tiekėjui, administratoriui, specifinių paslaugų teikėjui)",
			source: "žr. https://ico.org.uk/media/for-organisations/documents/1540/cloud_computing_guidance_for_organisations.pdf"
		},
		PIA_SEC_EXP: {
			description: "Aprašykite tvarkas, reglamentuojančias neigiamo poveikio techninei ir programinei įrangai, kurių pagalba tvarkomi asmens duomenys, sumažinimą.",
			name: "Eksploatavimo sauga",
			placeholder: "Nurodykite, kaip atnaujinama programinė įranga (operacinės sistemos, kompiuterinės programos, antivirusinės programos ir t.t.) ir kaip įdiegiami programinės įrangos saugumo spragų pataisymai",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Ar naudojamos priemonės tinklo stebėsenai realiame laike tam, kad būtų užkirstas kelias įtartinai veiklai tinkle ir fiksuoti reikiamus įrodymus.",
			name: "Tinklo stebėjimas",
			placeholder: "Nurodykite, kokios priemonės ir kontrolė naudojama, siekiant nustatyti su asmens duomenis susijusius incidentus",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Nurodyti tvarkas, reglamentuojančias techninės įrangos priežiūrą ir saugą, nurodant ar tokios paslaugos perkamos iš išorinių paslaugų teikėjų. <br> Nurodyti, ar leidžiama nuotoliniu būdu teikti programinės įrangos priežiūros paslaugas. Nurodyti, kaip elgiamasi su sugedusia įranga.",
			name: "Priežiūra",
			placeholder: "Nurodykite, kaip prižiūrite techninę įrangą",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Aprašykite, kokių priemonių imamasi, kad į personalinius kompiuterius ir serverius nepatektų kenkėjiškų programų, besinaudojant mažiau saugiais tinklais.",
			name: "Kenkėjiškų programų prevencija",
			placeholder: "Nurodykite kokių apsaugos priemonių imamasi, siekiant sumažinti riziką naudojantis mažiau saugiai tinklais",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Nurodykite, kokių priemonių imamasi, kad naudojamos sistemos (serveriai, personaliniai kompiuteriai, nešiojami kompiuteriai, komunikacijų įrenginiai ir kita techninė įranga) nebūtų naudojamos asmens duomenų neteisėtam sugadinimui (saugus duomenų saugojimas, duomenų atskyrimas, fizinis tvarkomų duomenų sumažinimas, prieigos prie duomenų ribojimas ir pan.).",
			name: "Techninės įrangos sauga",
			placeholder: "Nurodykite, kokios saugos priemonės taikomos naudojamai techninei įrangai",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Duomenų valdytojas turi įdiegti tinkamas saugumo sistemas, kurios priklausomai nuo to, koks tinklas yra naudojamas (uždaras, privatus ar internetas): ugniasienė, įsibrovimų nustatymo sistema arba kita aktyvi ar pasyvi įranga, naudojama tinklo saugumui užtikrinti.",
			name: "Tinklo saugumas",
			placeholder: "Nurodykite, kaip užtikrinamas saugumas tinkle, kuriame atliekamas asmens duomenų tvarkymas",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Ar naudojama praėjimo kontrolė į patalpas, kur vyksta duomenų tvarkymas (patalpų išskaidymas, lankytojų palyda, nešiojimas matomoje vietoje pažymėjimų, rakinamos durys, vaizdo stebėsena ir pan.). Nurodykite ar yra įdiegta signalizacija.",
			name: "Fizinė praėjimo kontrolė",
			placeholder: "Nurodykite, ar naudojama fizinė praėjimo kontrolė patalpose, kur vyksta duomenų tvarkymas",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Priemonės, skirtos sumažinti nuo žmogaus elgesio nepriklausančias rizikas (gaisras, potvynis, nelaimingi atsitikimai ir pan.), kas gali pažeisti duomenų saugumą (kokių prevencinių priemonių imamasi, aplinkos monitorinimas, apsauga ir pan.)",
			name: "Apsauga nuo ne nuo žmogaus priklausančių rizikų",
			placeholder: "Nurodykite, kokių priemonių imamasi, siekiant išvengti ar riboti nuo žmogaus nepriklausančių rizikų",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Priemonės, skirtos nuo žmogaus elgesio priklausančių ir nepriklausančių rizikų išvengimui, siekiant užtikrinti asmens duomenų apsaugą (potvynio zona, pavojinga geografinė teritorija, žemės drebėjimas, asmens duomenų teikimas už ES ribų ir pan.)",
			name: "Rizikos šaltinių užkardymas",
			placeholder: "Nurodykite, kokių rizikos, susijusios su gamtos nelaimėmis, prevencijos priemonių imtasi",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Aprašykite, kokių priemonių imamasi, siekiant apsaugoti interneto svetaines ir jose tvarkomus asmens duomenis (bendros saugumo gairės, duomenų perdavimo TLS šifravimas, slapukų naudojimo gairės, saugumo auditai ir pan.)",
			name: "Interneto svetainių sauga",
			placeholder: "Nurodykite, kaip apsaugotos interneto svetainės",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Nurodykite, ar vykdomas duomenų nuasmeninimas, ar yra įdiegta tam skirta tvarka. Detalizuokite nuasmeninimo procedūrą. <br> Atminkite, kad nuasmeninimas ir pseudonimų suteikimas duomenims yra ne tas pats.",
			name: "Nuasmeninimas",
			placeholder: "Nurodykite duomenų nuasmeninimo procedūrą",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Aprašykite archyvavimo procedūrą ir tvarką (duomenų pateikimą archyvavimui, archyvų saugojimą, prieigos prie jų tvarką, suarchyvuotų duomenų atskyrimą ir pan.). Jei taikoma, aprašykite suarchyvuotų duomenų perdavimo valstybiniams archyvams tvarką.",
			name: "Archyvavimas",
			placeholder: "Nurodykite, ar yra įdiegta duomenų vientisumo kontrolės tvarka, kokia ji ir koks jos tikslas.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Priemonės, skirtos duomenų, saugomų duomenų bazėse, kompiuterių failuose, atsarginėse kopijose, <strong> konfidencialumo užtikrinimui</strong>. Taip pat šifravimo raktų administravimo procedūros (jų sukūrimas, saugojimas, keitimas, kai įtariama, kad duomenys galėjo būti pažeisti ir t.t.).<br> Nurodykite, kokie šifravimo mechanizmai naudojami duomenų srautų konfidencialumo užtikrinimui (VPN, TLS, pan.).",
			name: "Šifravimas",
			placeholder: "Nurodykite priemones, kurios yra įgyvendintos, siekiant užtikrinti duomenų konfidencialumą",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Duomenų atskyrimas padeda sumažinti galimybę sujungti duomenis bei sumažina neteisėtos prieigos prie visų saugomų duomenų riziką.",
			name: "Duomenų atskyrimas",
			placeholder: "Nurodykite, ar planuojamas duomenų atskyrimas ir kaip jis vykdomas",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Nurodykite, kaip sukuriami vartotojų profiliai ir suteikiamos jiems atitinkamos teisės bei rolės. Kokie yra įgyvendinti <strong>autentifikavimosi</strong> būdai. Kokios taisyklės yra taikomos slaptažodžių valdymui (minimalus ilgis, privalomas formatas, galiojimo terminas, leistinas nepavykusių prisijungimų skaičius iki paskyros blokavimo ir t.t.)",
			name: "Prieigos kontrolė",
			placeholder: "Nurodykite, kaip nustatote ir suteikiate vartotojams profilius",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Taisyklės, kurios taikomos veiksmų registravimui ir įrašų (log) valdymui.",
			name: "Veiksmų registravimas (angl. logging)",
			placeholder: "Nurodykite, ar vedamas veiksmų registravimo žurnalas ir kiek laiko jo įrašai yra saugomi",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Duomenų apimties sumažinimo galima siekti tokiomis priemonėmis: filtravimas ir sunaikinimas, jautrumo sumažinimas konvertavimo pagalba, identifikuojančių duomenų kiekio sumažinimas, duomenų apjungimo vengimas, prieigos prie duomenų ribojimas ir pan.",
			name: "Asmens duomenų tvarkymo apimties mažinimas",
			placeholder: "Nurodykite, kokių priemonių imamasi tam, kad sumažinti su tvarkomų asmens duomenų kiekį ir apimtis",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Jei duomenų tvarkymas atliekamas su popieriniais dokumentais, nurodykite kaip jie yra saugomi, atspausdinami, sunaikinami ir kaip jais yra keičiamasi su kitais asmenimis.",
			name: "Popierinių dokumentų apsauga",
			placeholder: "Nurodykite, kaip tvarkomi popieriniai dokumentai ir kaip užtikrinamas jų vientisumas?",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Veiksmų plane nurodoma ankstesniuose žingsniuose vertintojo pasiūlytos priemonės, resursai ir patobulinimai, kuriuos reikia įgyvendinti ir įdiegti. Kiekvienai užduočiai reikia paskirti atsakingą asmenį ir nustatyti užduoties atlikimo terminą.",
			name: "Veiksmų planas",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Grafikas parodo duomenų tvarkymo metu kylančias rizikas ir kitas rizikas, atsižvelgiant į taikytas technines ir organizacines priemones. Jame parodoma, kad įgyvendinus veiksmų plane nurodytas priemones rizikų įvykimo tikimybė gali būti sumažinta.",
			name: "Rizikų nurodymas",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Atitinkamais atvejais duomenų valdytojas turėtų siekti išsiaiškinti duomenų subjektų ar jų atstovų nuomonę apie numatytą duomenų tvarkymą, nepažeisdamas komercinių ar viešųjų interesų apsaugos arba duomenų tvarkymo operacijų saugumo reikalavimų. Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">[GDPR]</a> 35 str. 9 d.<br>Tokia nuomonė gali būti gaunama įvairiais būdais (vidinės ir išorinės studijos apie duomenų tvarkymo tikslą ir būdus, klausimynai darbuotojų atstovams, potencialių duomenų valdytojo klientų apklausos).<strong>Jei duomenų valdytojas nusprendžia elgtis priešingai nei mano duomenų subjektai</strong>, jis privalo <strong> tokį savo sprendimą pagrįsti raštu</strong>. Jei duomenų valdytojas nusprendžia, <strong> kad duomenų subjektų nuomonės išsiaiškinimas nėra svarbus, tokį sprendimą jis taip pat turėtų pagrįsti raštu</strong>.",
			name: "Duomenų subjekto nuomonė",
			source: "BDAR 35 str. 9 d. ir PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "Atliekant poveikio duomenų apsaugai vertinimą, duomenų valdytojas turėtų konsultuotis su duomenų apsaugos pareigūnu, jei toks yra paskirtas. Žr. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679&from=LT\">[GDPR]</a> 35 str. 2 d. <br> <strong>Jo nuomonė gali prieštarauti planuojamam duomenų tvarkymui, tačiau tai neturėtų riboti duomenų valdytojo diskrecijos priimant sprendimus</strong>.",
			name: "DAP nuomonė",
			source: "BDAR 35 str. 2 d. ir PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "<strong>Duomenų valdytojas turi nuspręsti</strong>, ar, atsižvelgiant į nustatytas problemas ir jų poveikį duomenų subjektams, jo pasirinktos priemonės, susijusios rizikos ir veiksmų planas yra priimtinos. PDAV gali būti: <br>- patvirtintas<br>- dalinis patvirtinimas (nurodykite, kas turi būti pagerinta)<br>- atmestas (nurodykite to priežastis). Jei būtina, reikėtų dar kartą patikrinti ankstesnius žingsnius ir juos papildyti tam, kad PDAV galėtų būti patvirtintas. Šis sprendimas neįtakoja atitinkamo duomenų apsaugos inspekcijos vertinimo, pvz. vykstant išankstinėms konsultacijoms.",
			name: "Galutinis patvirtinimas",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Pagalba"
};
var measures$9 = {
	add: "Sukurti priemonę (arba pasirinkti priemonę iš Pagalbos)",
	default_placeholder: "Aprašyti esamą ar naują priemonę, skirtą duomenų apsaugai užtikrinti.",
	edit: "Redaguoti priemonę",
	placeholder_title: "Priemonės pavadinimas",
	remove: "Ištrinti priemonę"
};
var misc$9 = {
	display: "Parodyti / Nerodyti"
};
var modals$9 = {
	abandon_pia: {
		additional_text: "Archyvavimas nėra negrįžtamas veiksmas. Jūs galėsite pratęsti analizę ateityje.",
		content: "Ar norite nutraukti darbą?"
	},
	action_plan_no_evaluation: {
		content: "Norint parengti veiksmų planą, reikia pradėti analizės peržiūrą.",
		review_section: "Dalies peržiūra"
	},
	archive: "Archyvuoti",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "Ši dalis paruošta peržiūrai."
	},
	back_to_edition: {
		content: "Ši dalis buvo grąžinta redagavimui.<br> Tam tikri laukai turi būti pataisyti prieš atliekant peržiūrą."
	},
	back_to_evaluation: {
		content: "Ši dalis buvo grąžinta peržiūrai.<br> Tam tikri laukai turi būti peržiūrėti prieš atliekant patvirtinimą."
	},
	back_to_home: "Atgal į pradžią",
	cancel: "Atsisakyti",
	close: "Uždaryti",
	completed_edition: {
		content: "PDAV pabaigtas, jį reikia peržiūrėti."
	},
	completed_evaluation: {
		content: "PDAV peržiūrėtas, jį reikia patvirtinti."
	},
	"continue": "Tęsti",
	declare_measures: {
		content: "Prieš vertinant rizikas, reikia nurodyti esamas arba planuojamas priemones.",
		declare: "Nurodyti esamas arba planuojamas priemones"
	},
	dpo_missing_evaluations: {
		comment: "Komentuoti",
		content: "Norint pereiti prie DPA dalies, reikia pabaigti analizės peržiūrą.",
		remove: "Ištrinti",
		review_section: "Peržiūra"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Importuotas failas skiriasi nuo PDAV ataskaitos failo"
	},
	import_wrong_structure_file: {
		content: "Importuotas failas skiriasi nuo PDAV ataskaitos failo"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "PDAV turinys buvo nukopijuotas į kompiuterio laikiną atmintį."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Įspėjimas,</span><br>Mažiausiai bent vieną priemonę reikia nurodyti: ištrynimas negalimas."
	},
	recover_version: {
		"continue": "Tęsti",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "Kadangi atsisakėte tvirtinti PDAV, jis yra grąžintas tobulinimui."
	},
	remove_attachment: {
		comment: "Komentuoti",
		content: "<span class='strong'>Įspėjimas,</span><br>Ar tikrai norite <br>ištrinti šį priedelį?",
		keep: "Palikti",
		remove: "Ištrinti"
	},
	remove_measure: {
		content: "<span class='strong'>Įspėjimas,</span><br>Ar tikrai norite <br>ištrinti šią priemonę?",
		keep: "Palikti <br>šią priemonę",
		remove: "Ištrinti <br>šią priemonę"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Ištrinti šį PDAV"
	},
	remove_question: {
		content: "Ar tikrai norite ištrinti klausimą?",
		keep: "Atsisakyti",
		remove: "Ištrinti"
	},
	remove_structure: {
		content: "<span class='strong'>Įspėjimas,</span><br>ar tikrai norite <br>ištrinti šabloną?",
		remove: "Ištrinti šabloną"
	},
	same_comment: {
		content: "<span class='strong'>Įspėjimas,</span><br>Įveskite kitą nei prieš tai buvusį komentarą."
	},
	signed_pia_validation: {
		content: "Tam, kad būtų galima patvirtinti PDAV, pridėkite pasirašytą ataskaitą.",
		download_pia: "Atsisiųsti ataskaitą"
	},
	simple_pia_validation: {
		content: "Jūs patvirtinote PDAV."
	},
	start_evaluation: "Pradėti peržiūrą",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Serverio adresas yra atnaujintas."
	},
	validate_evaluation: {
		content: "Ši dalis paruošta PDAV tvirtinimui."
	},
	validate_evaluation_to_correct: {
		content: "Deja,<br>Tam tikri laukeliai turi būti pataisyti.<br>Grįžti į redagavimo būseną tam, kad atlikti pakeitimus."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$9 = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$9 = {
	content: ", atsižvelgiant kad :",
	dpo_lock: "Norint pateikti DPA nuomonę, reikia pabaigti užpildyti kitas PDAV dalis.",
	dpo_opinion: "DPA nuomonė",
	edit: "Redaguoti",
	people_opinion: "Susijusių žmonių (duomenų subjektų) nuomonė",
	placeholder_concerned_people_name: "Duomenų subjektų vardai, pavardės, kontaktiniai duomenys",
	placeholder_dpo_name: "DPA vardas, pavardė",
	placeholder_dpo_opinion: "Nurodykite tokio sprendimo priežastis.",
	placeholder_people_opinion: "Nurodykite, kaip buvo atsiklausta žmonių nuomonės ir kaip ji buvo analizuojama. Jei nebuvo prašoma nuomonės, nurodykite to priežastis.",
	placeholder_search_content: "Nurodykite priežastis, kurios pateisintų tai, kad nebuvo siekiama gauti duomenų subjektų nuomonės.",
	treatment_lock: "Norint pateikti susijusių duomenų subjektų nuomones, reikia užpildyti kitas dalis.",
	treatment_nok: "Asmens duomenų tvarkymas neturėtų būti vykdomas.",
	treatment_ok: "Asmens duomenų tvarkymas gali būti vykdomas."
};
var pia$9 = {
	attachments: {
		add: "Pridėti",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Pašalinti",
		title: "Priedai",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Prašyti peržiūros",
		mandatory_fields: "Turi būti užpildyti visi laukai",
		structure_add_question: "Pridėti",
		subsection_validated: "Ši dalis peržiūrėta, laukiama galutinio patvirtinimo",
		validate_evaluation: "Patvirtinti peržiūrą"
	},
	header: {
		display_action_plan: "Peržiūrėti<br>veiksmų planą",
		edition: "Redaguoti",
		evaluation: "Įvertinimas",
		preview: "Peržiūra"
	},
	sections: {
		based_on_structure_name: "Remiantis šablonu:",
		homepage_link: "Atgal į apžvalgą",
		refuse_pia: "Atmesti PDAV",
		status: {
			evaluation: {
				cancel: "atsiakyti prašymo dėl peržiūros.",
				cancel_button: "Atsisakyti prašymo dėl peržiūros",
				content: "Ši dalis dar nebuvo peržiūrėta. Jei norite redaguoti peržiūrai pateiktą turinį, Jūs turite",
				title: "Laukiama peržiūros"
			},
			validation: {
				cancel: "atsisakyti prašymo dėl patvirtinimo.",
				cancel_button: "Atsisakyti prašymo dėl patvirtinimo",
				content: "Ši dalis jau peržiūrėta, laukiama patvirtinimo.  Jei norite padaryti pakeitimus peržiūroje, Jūs turite ",
				title: "Laukiama patvirtinimo."
			}
		},
		validate_pia: "Tvirtinti PDAV"
	},
	statuses: [
		"Vykdomas",
		"Atmestas",
		"Preliminarus patvirtinimas",
		"Galutinis patvirtinimas",
		"Suarchyvuota",
		"Laukiama patvirtinimo"
	]
};
var questions$9 = {
	edit: "Redaguoti klausimą",
	gauges: [
		"(Nenustatytas)",
		"Nedidelis",
		"Ribotas",
		"Reikšmingas",
		"Maksimalus"
	],
	placeholder_title: "Klausimo pavadinimas",
	remove: "Ištrinti klausimą"
};
var rejection_page$9 = {
	applied_adjustments: "Siūlomi pakeitimai",
	applied_adjustments_placeholder: "Nurodykite siūlomus PDAV pakeitimus.",
	button: {
		abandon_treatment: "Nutraukti rengimą",
		reject_pia: "Atmesti PDAV",
		send_for_validation: "Iš naujo persiųsti tvirtinimui"
	},
	previous_rejection: "Ankstesnis atsisakymas",
	rejection_reason: "Atsisakymo tvirtinti priežastys",
	rejection_reason_placeholder: "Nurodykite atsisakymo tvirtinti PDAV priežastis.",
	title: "Patvirtinimų istorija"
};
var sections$9 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Nurodykite trumpą duomenų tvarkymo aprašymą: pavadinimas, tikslas, sritis, naudos gavėjai, t.t.",
						title: "Kokie yra asmens duomenų tvarkymo tikslai?"
					},
					"2": {
						placeholder: "Nurodykite atsakingus asmenis ir jų atsakomybių sritis: duomenų valdytojas, bendri duomenų valdytojai, galimi duomenų tvarkytojai, jų pagalbiniai duomenų tvarkytojai, tretieji asmenys kaip galimi duomenų gavėjai.",
						title: "Kas tvarko asmens duomenis?"
					},
					"3": {
						placeholder: "Nurodykite duomenų tvarkymo procesams taikomus standartus ar taisykles, kaip pvz. taikomus elgesio kodeksus, įgytus duomenų tvarkymo sertifikatus.",
						title: "Kokie vidiniai dokumentai, taisyklės ar teisės aktai reglamentuoja asmens duomenų tvarkymą?"
					}
				},
				short_help: "Šioje dalyje pateikiamas analizės tikslas.",
				title: "Apžvalga"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Nurodykite kokie asmens duomenys (pvz., pavardė, el. pašto adresas, asmens kodas, sveikatos duomenys, genetiniai duomenys, t.t.) renkami ir tvarkomi. Nurodykite jų saugojimo terminą, gavėjus ir asmenis, turinčius teisę juos tvarkyti.",
						title: "Kokie konkrečiai asmens duomenys (kategorijos) tvarkomi?"
					},
					"2": {
						placeholder: "Nurodykite duomenų tvarkymo etapus (nuo duomenų rinkimo iki duomenų sunaikinimo, aprašykite kiekvieno etapo specifiką, duomenų saugojimą ir pan.), galite naudoti diagramas (pridėkite jas kaip priedelius), detaliai aprašykite duomenų tvarkymo metu atliekamus veiksmus.",
						title: "Kokie yra duomenų tvarkymo etapai (stadijos)?"
					},
					"3": {
						placeholder: "Nurodykite pagalbines priemones (pvz., operacinė sistema, verslo valdymo sistemos, programinė įranga (kompiuterio programos), duomenų bazės, serveriai, tinklo įranga, ryšio tiekėjai ir pan.)",
						title: "Kokios techninės ar kitos pagalbinės priemonės naudojamos duomenų tvarkymui?"
					}
				},
				short_help: "Šioje dalyje galima detalizuoti duomenų tvarkymo apimtį.",
				title: "Duomenys, procesai ir pagalbinės priemonės"
			}
		},
		short_help: "Šioje dalyje detaliai aprašomas asmens duomenų tvarkymas.",
		title: "Kontekstas"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Nurodykite, kodėl manote, kad duomenys tvarkomi nustatytais, aiškiai apibrėžtais bei teisėtais tikslais.",
						short_title: "Tikslai",
						title: "Ar asmens duomenys tvarkomi nustatytais, aiškiai apibrėžtais bei teisėtais tikslais (tikslo apribojimo principas)?"
					},
					"2": {
						placeholder: "Nurodykite, kokie yra duomenų tvarkymo teisiniai pagrindai (pvz., sutikimas, sutarties vykdymas, teisinės prievolės vykdymas, gyvybinių interesų apsauga ir pan.)",
						short_title: "Teisinis pagrindas",
						title: "Kokiais teisiniais pagrindais vadovaujantis galima teigti, kad duomenų tvarkymas teisėtas?"
					},
					"3": {
						placeholder: "Nurodykite, kodėl konkrečiam duomenų tvarkymo tikslui reikalingas konkretus asmens duomuo.",
						short_title: "Duomenų adekvatumas",
						title: "Ar renkami asmens duomenys adekvatūs, tinkami ir tik tokie, kurių reikia siekiant tikslų (duomenų kiekio mažinimo principas)?"
					},
					"4": {
						placeholder: "Nurodykite, kokių priemonių imamasi, siekiant užtikrinti duomenų kokybę.",
						short_title: "Duomenų tikslumas",
						title: "Ar tvarkomi asmens duomenys tikslūs ir prireikus atnaujinami (tikslumo principas)?"
					},
					"5": {
						placeholder: "Nurodykite, kokios teisinės prievolės (įstatymo reikalavimai) ir duomenų tvarkymo poreikiai lemia tokią duomenų saugojimo trukmę.",
						short_title: "Saugojimo trukmė",
						title: "Kokia yra asmens duomenų saugojimo trukmė?"
					}
				},
				short_help: "Šioje dalyje pagrindžiamas duomenų tvarkymo teisėtumas.",
				title: "Proporcingumas ir būtinybė"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Nurodykite, kokia informacija pateikiama duomenų subjektams ir kokiu būdu.",
						short_title: "Duomenų subjektams pateikiama informacija",
						title: "Kaip duomenų subjektai informuojami apie duomenų tvarkymą?"
					},
					"2": {
						placeholder: "Nurodykite, kaip patikrinama, ar yra gautas duomenų subjekto galiojantis sutikimas.",
						short_title: "Sutikimo gavimas",
						title: "Kaip gaunamas duomenų subjektų sutikimas (jei toks yra naudojamas)?"
					},
					"3": {
						placeholder: "Nurodykite, kaip užtikrinamos duomenų subjektų teisės susipažinti su duomenimis, juos gauti ir į duomenų perkeliamumą.",
						short_title: "Teisė susipažinti ir teisė į duomenų perkeliamumą",
						title: "Kaip duomenų subjektai gali susipažinti su duomenimis ir įgyvendinti savo teisę į duomenų perkeliamumą?"
					},
					"4": {
						placeholder: "Nurodykite, kaip užtikrinamos duomenų subjektų teisės į duomenų ištaisymą ir ištrynimą.",
						short_title: "Teisė ištaisyti ir ištrinti",
						title: "Kaip duomenų subjektai gali ištaisyti duomenis ir reikalauti juos ištrinti (teisė būti pamirštam)?"
					},
					"5": {
						placeholder: "Nurodykite, kaip užtikrinamosš duomenų subjektų teisės apriboti duomenų tvarkymą ir prieštarauti dėl jų tvarkymo.",
						short_title: "Teisė apriboti ir prieštarauti",
						title: "Kaip duomenų subjektai gali apriboti duomenų tvarkymą ir prieštarauti jų tvarkymui?"
					},
					"6": {
						placeholder: "Kiekvieno duomenų tvarkytojo atveju nurodykite jo įsipareigojimus (trukmė, apimtis, tikslas, kokie yra dokumentuoti valdytojo nurodymai, išankstinis sutikimas dėl pagalbinių duomenų tvarkytojų ir t.t.), nurodykite tvarkytojui taikomas sutartis, elgesio kodeksus ir sertifikatus.",
						short_title: "Sutartis dėl duomenų tvarkymo",
						title: "Ar duomenų tvarkytojų įsipareigojimai yra aiškiai nustatyti ir reglamentuojami sutartimi?"
					},
					"7": {
						placeholder: "Kiekvienos už Europos Sąjungos ribų esančios šalies, kurioje yra saugomi ir tvarkomi asmens duomenys, atveju nurodykite, kokia tai šalis, ar ji pripažinta kaip užtikrinanti tinkamo lygio apsaugą, aprašykite duomenų teikimo sąlygas.",
						short_title: "Duomenų teikimas",
						title: "Ar asmens duomenys tinkamai apsaugomi, tuo atveju jei jie teikiami už Europos Sąjungos ribų?"
					}
				},
				short_help: "Šioje dalyje nurodoma, kaip užtikrinamas duomenų subjektų teisių įgyvendinimas.",
				title: "Duomenų subjektų teisėms apsaugoti skirtos priemonės"
			}
		},
		short_help: "Šioje dalyje aprašoma atitiktis pagrindiniams duomenų tvarkymo teisėtumo principams.",
		title: "Pagrindiniai principai"
	},
	"3": {
		items: {
			"1": {
				short_help: "Šioje dalyje galima nurodyti esamas ar planuojamas priemones, skirtas duomenų apsaugai.",
				title: "Planuojamos arba esamos duomenų apsaugos priemonės"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Nurodykite neigiamą poveikį",
						title: "Kokie būtų <span class='green-highlight'>neigiami poveikiai duomenų subjektams,</span> jei tokia rizika pasireikštų?"
					},
					"2": {
						placeholder: "Nurodykite grėsmes",
						title: "Kas gali sukelti tokią riziką, nurodykite galimas<span class='green-highlight'> grėsmes</span>"
					},
					"3": {
						placeholder: "Nurodykite rizikos šaltinius",
						title: "Kokie yra tokios rizikos <span class='green-highlight'>šaltiniai</span>?"
					},
					"4": {
						placeholder: "Pasirinkite priemones",
						title: "Kurios iš nurodytų <span class='green-highlight'>apsaugos priemonių</span> padėtų užkirsti kelią tokios rizikos pasireiškimui?"
					},
					"5": {
						placeholder: "Pagrįskite numanomą rizikos dydį",
						title: "Kaip įvertintumėte <span class='green-highlight'>rizikos dydį</span>, ypač atsižvelgiant į galimą neigiamą poveikį ir planuojamas taikyti apsaugos priemones?"
					},
					"6": {
						placeholder: "Pagrįskite numanomą tikimybę",
						title: "Kaip įvertintumėte <span class='green-highlight'>tokios rizikos tikimybę </span>, ypač atsižvelgiant į grėsmes, rizikos šaltinius ir planuojamas apsaugos priemones?"
					}
				},
				short_help: "Pateikite neteisėtos prieigos prie duomenų priežasčių ir pasekmių analizę ir įvertinkite to tikimybę bei galimą neigiamą poveikį.",
				title: "Neteisėta prieiga prie duomenų"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Nurodykite neigiamą poveikį",
						title: "Kokie būtų <span class='green-highlight'>neigiami poveikiai duomenų subjektams,</span> jei tokia rizika pasireikštų? Kokie būtų <span class='green-highlight'>neigiami poveikiai duomenų subjektams,</span> jei tokia rizika pasireikštų?"
					},
					"2": {
						placeholder: "Nurodykite grėsmes",
						title: "Kas gali sukelti tokią riziką, nurodykite galimas<span class='green-highlight'>grėsmes</span>"
					},
					"3": {
						placeholder: "Nurodykite rizikos šaltinius",
						title: "Kokie yra tokios rizikos <span class='green-highlight'>šaltiniai</span>?"
					},
					"4": {
						placeholder: "Pasirinkite priemones",
						title: "Kurios iš nurodytų <span class='green-highlight'>apsaugos priemonių</span> padėtų užkirsti kelią tokios rizikos pasireiškimui?"
					},
					"5": {
						placeholder: "Pagrįskite numanomą rizikos dydį",
						title: "Kaip įvertintumėte <span class='green-highlight'>rizikos dydį</span>, ypač atsižvelgiant į galimą neigiamą poveikį ir planuojamas taikyti apsaugos priemones?"
					},
					"6": {
						placeholder: "Pagrįskite numanomą tikimybę",
						title: "Kaip vertinate <span class='green-highlight'>tokios rizikos tikimybę </span>, ypač atsižvelgiant į grėsmes, rizikos šaltinius ir planuojamas apsaugos priemones?"
					}
				},
				short_help: "Pateikite nepageidaujamo duomenų pakeitimo priežasčių ir pasekmių analizę bei įvertinkite to tikimybę bei galimą neigiamą poveikį.",
				title: "Nepageidaujamas duomenų pakeitimas"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Nurodykite neigiamą poveikį",
						title: "Kokie būtų <span class='green-highlight'>neigiami poveikiai duomenų subjektams,</span> jei tokia rizika pasireikštų? Kokie būtų <span class='green-highlight'>neigiami poveikiai duomenų subjektams,</span> jei tokia rizika pasireikštų?"
					},
					"2": {
						placeholder: "Nurodykite grėsmes",
						title: "Kas gali sukelti tokią riziką, nurodykite galimas<span class='green-highlight'>grėsmes</span>"
					},
					"3": {
						placeholder: "Nurodykite rizikos šaltinius",
						title: "Kokie yra tokios rizikos <span class='green-highlight'>šaltiniai</span>?"
					},
					"4": {
						placeholder: "Pasirinkite priemones",
						title: "Kurios iš nurodytų <span class='green-highlight'>apsaugos priemonių</span> padėtų užkirsti kelią tokios rizikos pasireiškimui?"
					},
					"5": {
						placeholder: "Pagrįskite numanomą rizikos dydį",
						title: "Kaip įvertintumėte <span class='green-highlight'>rizikos dydį</span>, ypač atsižvelgiant į galimą neigiamą poveikį ir planuojamas taikyti apsaugos priemones?"
					},
					"6": {
						placeholder: "Pagrįskite numanomą tikimybę",
						title: "Kaip vertinate <span class='green-highlight'>tokios rizikos tikimybę </span>, ypač atsižvelgiant į grėsmes, rizikos šaltinius ir planuojamas apsaugos priemones?"
					}
				},
				short_help: "Pateikite duomenų dingimo priežasčių ir pasekmių analizę ir įvertinkite to tikimybę bei galimą neigiamą poveikį.",
				title: "Duomenų pradingimas"
			},
			"5": {
				short_help: "Šis grafikas padės susidaryti bendrą vaizdą apie naudojamų apsaugos priemonių efektyvumą, siekiant kontroliuoti rizikas.",
				title: "Rizikų apžvalga"
			}
		},
		short_help: "Šioje dalyje įvertinamos galimos rizikos duomenų apsaugai, atsižvelgiant į planuojamas ir esamas apsaugos priemones, skirtas apsaugoti duomenis.",
		title: "Rizikos"
	},
	"4": {
		items: {
			"1": {
				short_help: "Šis grafikas padės tarpusavyje palyginti rizikas prieš ir po papildomų apsaugos priemonių pritaikymo.",
				title: "Rizikų susiejimas (angl. mapping)"
			},
			"2": {
				short_help: "Detaliai suplanuokite papildomų apsaugos priemonių, kurių poreikis nustatytas atliekant PDAV, įgyvendinimą. Veiksmų planas bus automatiškai atnaujinamas, jei PDAV tikrinimo metu bus padaryti papildymai.",
				title: "Veiksmų planas"
			},
			"3": {
				short_help: "Nurodykite, kokį patarimą pateikė asmuo, atsakingas už asmens duomenų apsaugą, pateikite duomenų subjektų ir/ar jų atstovų nuomones.",
				title: "DPA ir susijusių duomenų subjektų nuomonės"
			},
			"4": {
				title: "Patvirtinti PDAV"
			},
			"5": {
				title: "Nepatvirtinti PDAV"
			}
		},
		short_help: "Šioje dalyje atliekamas PDAV patvirtinimas",
		title: "Patvirtinimas"
	}
};
var settings$9 = {
	content: "Nurodykite serverio nuorodą (URL):",
	title: "Nustatymai",
	update: "Atnaujinkite URL nuorodą"
};
var summary$9 = {
	action_plan: {
		fundamental_principles: "Pagrindiniai principai",
		implementation_date: "Planuojamas įgyvendinimo terminas",
		implementation_responsible: "Už įgyvendinimą atsakingas asmuo",
		measures: "Esamos arba planuojamos priemonės",
		no_action_plan: "Veiksmų planas neparengtas.",
		risks: "Rizikos",
		title: "Veiksmų planas"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Priedeliai",
	concerned_people_name: "Duomenų subjektų vardai, pavardės",
	concerned_people_opinion: "Duomenų subjektų nuomonės",
	concerned_people_searched_opinion: "Duomenų subjektų nuomonė",
	concerned_people_status: "Duomenų subjektų statusas",
	concerned_people_unsearched_opinion_comment: "Priežastys, dėl kurių duomenų subjektų nuomonės nebuvo prašoma",
	content_choice: [
		"Tvarkymas neturėtų būti vykdomas.",
		"Tvarkymas gali būti vykdomas."
	],
	creation_date: "Data",
	csv_action_plan_comment: "Komentaras veiksmų planui",
	csv_evaluation_comment: "Komentaro įvertinimas",
	csv_file_title: "Veiksmų planas",
	csv_implement_date: "Planuojamas įgyvendinimo terminas",
	csv_people_in_charge: "Atsakingas asmuo",
	csv_section: "Dalis",
	csv_title_object: "Pavadinimas",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "DPA vardas, pavardė",
	dpo_opinion: "DPA nuomonė",
	dpo_status: "DPA paskyrimo detalės (išorinis, vidinis)",
	gauges: {
		"1": "Nežymi",
		"2": "Ribota",
		"3": "Reikšminga",
		"4": "Maksimali"
	},
	modification_made: "Padaryti pakeitimai",
	people_search_status_nok: "Duomenų subjektų nuomonės nebuvo prašoma.",
	people_search_status_ok: "Duomenų subjektų nuomonės buvo prašoma.",
	pia_assessor: "Vertintojo vardas, pavardė, el. pašto adresas",
	pia_author: "Rengėjo vardas, pavardė, el. pašto adresas",
	pia_name: "PDAV",
	pia_validator: "Tvirtintojo vardas, pavardė, el. pašto adresas",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Atgal į ankstesnį puslapį",
	rejection_reason: "Atmetimo priežastys",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Rizikų tarpusavio sąsajos",
	risks_overview_title: "Rizikų apžvalga",
	title: "PDAV informacija"
};
var users$9 = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$9 = {
	add_signed_pia: "Pridėti pasirašytą PDAV",
	after_reading: "Perskaičius PDAV dėl asmens duomenų tvarkymo: ",
	button: {
		rejection: "Netvirtinti PDAV",
		signed_validation: "Tvirtinti PDAV <br>(pasirašant)",
		simple_validation: "Tvirtinti PDAV <br>(nepasirašant)"
	},
	confirmation1: "Patvirtintu, kad PDAV aprašytas asmens duomenų tvarkymas atitinka tikrovę.",
	confirmation2: "Patvirtinu, kad man žinomos likusios rizikos, susijusios su planuojamomis arba jau įgyvendintomis priemonėmis.",
	confirmation3: "Aš patvirtinu veiksmų plane nurodytus taisytinus veiksmus.",
	confirmation4: "Įsipareigoju, įgyvendinti nurodytus taisytinus veiksmus kaip galima skubiau.",
	latest_signed_attachment: "Paskutinis pridėtas priedelis",
	mandatory_fields: "Visi laukeliai turi būti pažymėti",
	remove_attachment: "Ištrinti priedelį",
	responsible: "Asmuo, atsakingas už PDAV įvertinimą:",
	signed_attachments_history: "Pridėtų priedelių istorija",
	tools: {
		dashboard: "Apžvalga",
		display_pia: "Parodyti PDAV ataskaitą"
	},
	validated_pia_with_signature: "Patvirtinta",
	waiting_for_signature: "Laukiama PDAV pasirašymo"
};
var lt = {
	about: about$9,
	action_plan: action_plan$9,
	authentication: authentication$9,
	cartography: cartography$9,
	comments: comments$9,
	conflict: conflict$9,
	date: date$9,
	errors: errors$9,
	evaluations: evaluations$9,
	header: header$9,
	help: help$9,
	homepage: homepage$9,
	knowledge_base: knowledge_base$9,
	measures: measures$9,
	misc: misc$9,
	modals: modals$9,
	onboarding: onboarding$9,
	opinions: opinions$9,
	"overview-risks": {
	important: "Reikšmingas",
	limited: "Ribotas",
	maximal: "Maksimalus",
	measures: "Priemonės",
	negligible: "Nežymus",
	potential_impacts: "Galimos pasekmės (poveikis)",
	"risk-access_x": "Didelė",
	"risk-access_y": "Tikimybė",
	"risk-change_x": "Didelė",
	"risk-change_y": "Tikimybė",
	"risk-disappearance_x": "Didelė",
	"risk-disappearance_y": "Tikimybė",
	sources: "Šaltiniai",
	threat: "Grėsmės"
},
	pia: pia$9,
	questions: questions$9,
	rejection_page: rejection_page$9,
	sections: sections$9,
	settings: settings$9,
	summary: summary$9,
	users: users$9,
	validation_page: validation_page$9
};

var about$8 = {
	contribute: "Als u wilt helpen om de software te vertalen in een andere taal of om de bestaande vertalingen te verbeteren, raden we u aan om <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">de pagina met de te volgen stappen te lezen</a>.",
	description: "Deze tool is oorspronkelijk ontworpen door de <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, de Franse autoriteit voor gegevensbescherming, om de verwerker te helpen voldoen aan de AVG. De tool werd ontwikkeld door <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>De software is gratis en open. Als u wilt meewerken aan dit project, kunt u de broncode downloaden van Github, wijzigen en delen met de community.",
	licences: "Bibliotheeklicenties",
	title: "Over de PIA-software",
	translators: "De PIA-software is momenteel beschikbaar in 18 talen. De Franse en Engelse versies werden gemaakt door de CNIL. De andere versie zijn het resultaat van de bijdrages van de volgende personen:",
	translators_name: "<ul><li>Kroatisch: <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Tsjechisch: Jiří Grohmann, Manuel d’Orso ;</li><li>Deens: <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Nederlands: Ruud van Driel, Manuel d’Orso, Andi Vercruyssen ;</li><li>Engels: <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estisch: Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Fins: <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>Frans: <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Duits: <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a>, Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Grieks: <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hongaars: <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italiaans: Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Litouws: Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Noors: <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Pools: <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a>, Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguees: <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Roemeens: <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spaans: <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Versienummer"
};
var action_plan$8 = {
	acceptable_measures: "Aanvaardbare maatregelen",
	edit: "Bewerk",
	improvable_measures: "Verbeterbare maatregelen",
	measures: "Geplande of bestaande maatregelen",
	no_action_plan: "Geen actieplan vastgelegd.",
	placeholder_person_in_charge: "Implementatieverantwoordelijke",
	principles: "Fundamentele principes",
	risk1: "Onrechtmatige toegang tot gegevens",
	risk2: "Ongewenste wijziging van gegevens",
	risk3: "Verdwijnen van gegevens",
	risks: "Risico's",
	title: "Overzicht"
};
var authentication$8 = {
	"12_characters": "12 tekens",
	account_recovery: "Wachtwoordherstel",
	activation_code: "Activatiecode",
	cancel: "Annuleren",
	confirm: "Bevestigen",
	confirmation: "Bevestiging",
	"continue": "Verdergaan",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "Registreren",
	create_account2: "Account aanmaken",
	description: "De PIA-software van de <strong> Franse autoriteit voor gegevensbescherming (CNIL) </strong> is bedoeld als ondersteuningsmiddel voor de verwerkingsverantwoordelijken bij de implementatie van de verplichtingen van de AVG. De software begeleidt de uitvoering van een gegevensbeschermingseffectbeoordeling en wil het gebruik van de door de CNIL ontwikkelde PIA-richtlijnen vergemakkelijken.",
	email: "E-mailadres",
	email_placeholder: "E-mailadres",
	forgotten_password: "Vergeten?",
	login: "Aanmelden",
	lowercase: "Kleine letter",
	password: "Wachtwoord",
	password_security: "Wachtwoordsterkte",
	recovery_code: "Code resetten",
	recovery_code_message: "Er werd een e-mail met een code verzonden naar dit e-mailadres. Gelieve de code in het veld hieronder in te voeren.",
	recovery_code_not_sent: "Code niet ontvangen?",
	saved_password: "Je wachtwoord werd opgeslagen. Je kunt nu aanmelden.",
	sign_in: "Aanmelden",
	sign_in_button: "Aanmelden",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "Speciaal teken",
	number: "TO TRANSLATE - Number",
	start: "Beginnen",
	start_app: "De PIA-software openen (Beta)",
	subtitle1: "Een platform om uw PIA's te maken en te beheren",
	subtitle2: "Toegang tot tools en woordenlijsten",
	title: "Privacy Impact Assessment",
	transaction_error: "Kan uw verzoek niet verwerken.",
	uppercase: "Hoofdletter",
	wrong_activation_code: "(verkeerd)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "Verkeerd e-mailadres",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$8 = {
	important: "Belangrijk",
	legend1: "Geplande of bestaande maatregelen",
	legend2: "Met de geïmplementeerde corrigerende maatregelen",
	legend3: "(I) Onrechtmatige toegang tot gegevens",
	legend4: "(U) Ongewenste wijziging van gegevens",
	legend5: "(D) Gegevens verdwijnen",
	likelihood_axe: "Waarschijnlijkheid van het risico",
	limited: "Beperkt",
	maximal: "Maximaal",
	negligible: "Verwaarloosbaar",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Ernst van het risico"
};
var comments$8 = {
	comment: "Commentaar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "reactie(s)",
	new_comment: "Commentaar",
	placeholder_new_comment: "Laat een reactie achter",
	send: "Verzenden"
};
var conflict$8 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$8 = {
	april: "april",
	august: "augustus",
	december: "december",
	"earlier-in-this-month": "Eerder deze maandEarlier this month",
	"earlier-in-this-week": "Eerder deze week",
	february: "februari",
	january: "januari",
	july: "juli",
	june: "juni",
	march: "maart",
	may: "mei",
	november: "november",
	october: "oktober",
	september: "september",
	today: "vandaag",
	yesterday: "gisteren"
};
var errors$8 = {
	content: "Als u andere problemen ondervindt of verbetersuggesties heeft, <br> kunt u deze via dit formulier terugsturen: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Pagina niet gevonden."
};
var evaluations$8 = {
	acceptable: "Aanvaardbaar",
	action_plan_comment: "Actieplan / corrigerende maatregelen",
	evaluation_comment: "Evaluatiecommentaar",
	gauges: {
		"0": "(Niet bepaald)",
		"1": "Verwaarloosbaar",
		"2": "Beperkt",
		"3": "Belangrijk",
		"4": "Maximaal",
		likelihood: "Rekening houdend met het actieplan, hoe herevalueert u de <span class='red-highlight'>waarschijnlijkheid van dit risico</span>?",
		seriousness: "Rekening houdend met het actieplan, hoe herevalueert u de <span class='red-highlight'>ernst van dit risico</span>?"
	},
	improvable: "Verbeterbaar",
	placeholder_acceptable: "Volgens de beschikbare informatie zijn de geïmplementeerde maatregelen toereikend om goed te voldoen aan de gegevensbeschermingsvereisten.",
	placeholder_improvable1: "Volgens de beschikbare informatie moeten aanvullende maatregelen worden genomen om de gegevensbescherming van de verwerking te verbeteren.",
	placeholder_improvable2: "Voer uw opmerkingen in.",
	placeholder_to_correct: "De verstrekte informatie is niet voldoende om ze goed te evalueren. Stuur terug naar de redacteur om de originele inzending te verbeteren.",
	status: [
		"Hangende",
		"Te corrigeren",
		"Verbeterbaar",
		"Aanvaardbaar"
	],
	title: "Evaluatie",
	to_correct: "Te corrigeren"
};
var header$8 = {
	archives: "PIA archief",
	current_pias: "Huidige PIA's",
	exit_full_screen_mode: "Druk F11 om het volledige scherm te sluiten.",
	help: {
		issue_reporting: "Een probleem melden",
		manual: "Gebruikershandleiding",
		pia_example_link: "PIA-voorbeeld",
		title: "Help"
	},
	homepage_link: "Mijn PIA's",
	knowledge_base_link: "Kennisbank",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Vertalingen door de CNIL",
		community_translations: "Vertalingen door de community",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Vertalingen nagekeken door de Europese gegevens-beschermingsautoriteiten",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Originele versie",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Privacy Impact Assessment",
	structures: "PIA-sjablonen",
	tools: {
		about: "Over",
		accessibility: "Toegang voor slechtzienden (kleuren met hoog contrast, daltonisme)",
		onboarding: "Tutortial herstarten",
		settings: "Instellingen",
		url_setting: "Server URL configuratie",
		users: "Gebruikers"
	}
};
var help$8 = {
	definition: {
		data1: {
			content: "Inhoud in opmaak",
			title: "Gebruik de PIA-tool"
		},
		data2: {
			qa1: {
				content: "Wanneer u deze weergaveproblemen ondervindt, sluit u de toepassing en laadt u deze opnieuw. Dit lost meestal het probleem op. U verliest de informatie die u hebt ingevoerd niet; ze wordt automatisch opgeslagen terwijl u typt.",
				title: "Ik krijg weergaveproblemen zoals pictogrammen die in één toestand vastzitten of elementen uit de interface missen"
			},
			qa2: {
				content: "Dit gekende probleem wordt momenteel opgelost. Als u dit probleem ondervindt, raden we u aan het veld voor de rechtvaardiging van het geschatte niveau van ernst en/of waarschijnlijkheid in te vullen. U kunt de meter bewerken zodra de fout is hersteld.",
				title: "Ik kan de meters niet bewerken voor het evalueren van de ernst en de waarschijnlijkheid van een risico"
			},
			qa3: {
				content: "Verschillende fouten zijn waargenomen bij het importeren van een PIA, en met name de niveaumeters voor het evalueren van de ernst en de waarschijnlijkheid van een risico kunnen verdwijnen. Raadpleeg in dit geval het bovengenoemde probleem. Trouwens, een PIA verschijnt mogelijk niet op het dashboard na het importeren. Dit is een weergaveprobleem en u hoeft alleen de pagina te vernieuwen.",
				title: "Ik ondervind problemen bij het importeren van een PIA"
			},
			qa4: {
				content: "Dit is slechts een weergavebug en het heeft geen effect op de tekst die u in een veld invoert. Dit visuele probleem zal snel worden opgelost.",
				title: "Wanneer ik tekst kopieer / plak, wordt deze gemarkeerd."
			},
			qa5: {
				content: "Om een sectie te evalueren, is het verplicht om alle velden in te vullen. Controleer of dit het geval is. Wanneer u een risico bewerkt, moet u ten minste één technische of organisatorische maatregel hebben die het risico beperkt, zodat u om een evaluatie van het risico kunt vragen.",
				title: "Ik kan een gedeelte niet evalueren"
			},
			qa6: {
				content: "Sluit de PIA die u aan het bewerken bent en open hem opnieuw. De inhoud moet vervolgens worden weergegeven in de taal die u hebt geselecteerd.",
				title: "Bij het wisselen van taal worden de teksten niet vertaald"
			},
			qa7: {
				content: "Voorlopig worden de iconen van het navigatiemenu niet vernieuwd na het weigeren van een PIA. U moet elke sectie controleren en de informatie en/of evaluatie aanpassen aan de redenen voor het weigeren van de PIA. Nadat alle secties zijn beoordeeld, kunt u PIA-validatie opnieuw aanvragen.",
				title: "Ik heb geweigerd om een PIA te valideren, maar ik weet niet wat ik nu moet doen"
			},
			title: "Bekende Problemen"
		},
		footer: "Als u andere problemen tegenkomt of suggesties heeft voor verbetering, kunt u deze via dit formulier terugsturen: <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Help"
};
var homepage$8 = {
	cards: {
		author: "Redactie",
		category: "Categorie",
		creation_status: "Creatie",
		date: "Datum",
		evaluation: "Reviewen",
		guest: "Gast(en)",
		import_pia: "PIA importeren",
		import_structure: "Sjabloon importeren",
		item: {
			consult_pia: "Raadplegen",
			consult_structure: "Sjabloon raadplegen",
			edit_pia: "Aanpassen",
			edit_structure: "Sjabloon aanpassen",
			tools: {
				action_plan: "Toon<br>actieplan",
				archive: "Archief",
				duplicate: "Dupliceren",
				"export": "Exporteren",
				more_options: "Meer opties",
				pia: "PIA<br>tonen",
				remove: "Verwijderen",
				unarchive: "Archiveren ongedaan maken"
			},
			validate_pia: "Valideren"
		},
		knowledges: {
			edit: "Kennisbank bewerken",
			"import": "Kennisbank importeren",
			"new": "Kennisbank maken",
			placeholder_author: "Auteur",
			placeholder_contributors: "Medewerker",
			placeholder_entry_number: "Aantal trefwoorden",
			placeholder_name: "Naam kennisbank"
		},
		knowledges_entry: {
			all_sections: "Alle secties",
			choose_category: "Categorie kiezen",
			contents: "Inhoud",
			create: "Dit element maken",
			linked_to: "Gelinkt aan",
			"new": "Elementen maken",
			placeholder_category: "Categorie",
			placeholder_description: "Zet hier je beschrijving...",
			placeholder_name: "Elementnaam",
			placeholder_updated_at: "Laatst aangepast"
		},
		new_pia: "Nieuwe AIIA",
		new_structure: "Nieuw sjabloon",
		or: "of",
		pia_name: "PIA",
		placeholder_author: "Voornaam Achternaam",
		placeholder_category: "Categorie",
		placeholder_evaluation: "Voornaam Achternaam",
		placeholder_import_knowledgeBase: "Kennisbank importeren",
		placeholder_import_pia: "PIA importeren",
		placeholder_import_structure: "Sjabloon importeren",
		placeholder_new_knowledgeBase: "Nieuwe kennisbank",
		placeholder_new_pia: "Nieuwe AIIA",
		placeholder_new_structure: "Nieuw sjabloon",
		placeholder_pia_name: "Titel AIIA",
		placeholder_sector_name: "Naam verwante sector",
		placeholder_start: "Alle velden moeten worden ingevuld",
		placeholder_structure: "Standaardsjabloon",
		placeholder_structure_name: "Naam sjabloon",
		placeholder_validation: "Voornaam achternaam",
		sector_name: "Verwante sector",
		start: "Beginnen",
		status: "Status",
		structure: "Sjabloon",
		structure_name: "Naam van het sjabloon",
		title_close_creation: "Sluiten",
		validation: "Valideren"
	},
	filters: {
		assessor: "Reviewer",
		author: "Auteur",
		card: "Weergave: fiches",
		card_rocket_content: "Aan de slag! <br> <br> Om een PIA te starten, <br> klikt u op Nieuwe AIIA",
		card_rocket_content_structure: "Aan de slag!<br><br>Om een sjabloon <br>te starten, klikt u <br> op de +",
		category: "Categorie",
		date: "Datum",
		import_pia: "PIA importeren",
		import_structure: "Sjabloon importeren",
		list: "Weergave: lijst",
		list_rocket_content: "Aan de slag! Om een PIA te starten, klik op de +",
		list_rocket_content_structure: "Aan de slag! Om een sjabloon<br>te starten, klikt u op de +",
		name: "Naam",
		new_pia: "Nieuwe AIIA",
		new_structure: "Nieuw sjabloon",
		sector_name: "Verwante sector",
		sort: "Sorteren",
		sort_by: "op",
		status: "Status",
		validator: "Validator"
	},
	lists: {
		column_actions: "Acties",
		column_author: "Redactie",
		column_category: "Categorie",
		column_creation: "Gemaakt",
		column_evaluation: "Reviewen",
		column_pia: "PIA",
		column_progression: "Voortgang",
		column_sector_name: "Verwante sector",
		column_status: "Status",
		column_structure: "Sjabloon",
		column_structure_name: "Sjabloon",
		column_updated_at: "Laatst geopend",
		column_validation: "Valideren",
		item: {
			tools: {
				action_plan: "Actieplan tonen",
				archive: "Archiveren",
				consult: "Raadplegen",
				duplicate: "Dupliceren",
				edit: "Aanpassen",
				"export": "Exporteren",
				pia: "PIA tonen",
				remove: "Verwijderen",
				unarchive: "Archiveren ongedaan maken"
			}
		}
	},
	search_filter: "Zoeken",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$8 = {
	add_measure: "Toevoegen",
	add_measure_hint: "U kunt ook een maatregel uit de kennisbank toevoegen.",
	category: {
		definition: "Definitie",
		example: "Voorbeeld",
		general_measure: "Fysieke beveiligingsmaatregelen",
		measure_on_data: "Logische beveiligingsmaatregelen",
		method: "Methodologie",
		organizational_measure: "Organisatorische maatregelen",
		principle: "Principe"
	},
	choose_knowledge_base: "Kies je kennisbank",
	default_knowledge_base: "CNIL Kennisbank",
	filters: {
		all: "Allemaal",
		definitions: "Definities",
		general_measures: "Fysieke beveiligingsmaatregelen",
		measures_on_data: "Logische beveiligingsmaatregelen",
		no_result: "Geen resultaat gevonden.",
		organizational_measures: "Organisatorische maatregelen",
		title: "Filters"
	},
	placeholder_add_measure: "Voeg deze maatregel toe",
	placeholder_help: "Invoerhulpmiddelen",
	search: "Zoeken",
	slugs: {
		PIA_DEF_ACC: {
			description: "De betrokkene heeft het recht van de verwerkingsverantwoordelijke te verlangen dat persoonsgegevens worden verwerkt en, indien dat het geval is, toegang tot de persoonsgegevens en de informatie als <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 15 van de [AVG]</a>",
			name: "Recht van inzage",
			source: "AVG Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Proces waarbij de identificerende kenmerken uit persoonsgegevens worden verwijderd. Om de robuustheid van anonimiseringsprocessen te beoordelen. Zie de <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 richtlijnen</a>.",
			name: "Anonimisering",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Procedures voor het bewaren en beheren van de elektronische archieven die de persoonsgegevens bevatten die bedoeld zijn om hun waarde te waarborgen (specifiek hun juridische waarde) gedurende de gehele vereiste periode (overdracht, opslag, migratie, toegankelijkheid, verwijdering, archiveringsbeleid, bescherming van vertrouwelijkheid, enz.).",
			name: "Archiveren",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Elke persoon met legitieme toegang tot persoonsgegevens (werknemers, contractanten en andere derden) moet worden geïdentificeerd door een unieke identificatie. Kies een authenticatiemethode om sessies te openen die geschikt zijn voor de context, het risiconiveau en de verwachte robuustheid. Aanbevelingen: als de risico's niet verhoogd zijn, kan een wachtwoord worden gebruikt; gebruik echter, als de risico's groter zijn, een eenmalige wachtwoordfiche, maar wijzig het standaard activeringswachtwoord of, als een deel van het wachtwoord per sms wordt verzonden, een kaart met een pincode, een elektronisch certificaat of een andere vorm van sterk authenticatie.",
			name: "Authenticatie",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Encryptiemaatregelen die persoonsgegevens voor iedereen zonder toegangsbevoegdheid onbegrijpelijk maken met (symmetrische of asymmetrische codering, gebruik van openbare algoritmes waarvan bekend is dat ze sterk zijn, authenticatiecertificaat, enz.).",
			name: "Encryptie",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Gegevensorganisatiemethoden die de mogelijkheid verkleinen dat persoonsgegevens kunnen worden gecorreleerd en dat een schending van alle persoonsgegevens kan optreden. Bijvoorbeeld door de persoonsgegevens te identificeren die alleen voor elk bedrijfsproces nuttig zijn en logisch van elkaar te scheiden.",
			name: "Gegevens partitioneren",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Elke vrij gegeven, specifieke, geïnformeerde en ondubbelzinnige indicatie van de wensen van de betrokkene waarmee hij of zij, door een verklaring of een duidelijke bevestigende handeling, instemt met de verwerking van persoonsgegevens die op hem of haar betrekking hebben. <br> Zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 4.10 van de [AVG]</a>",
			name: "Toestemming",
			source: "AVG Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Middelen die worden geïmplementeerd om de risico's te beperken dat onbevoegde personen elektronisch toegang krijgen tot persoonsgegevens, het vereist onder andere om: <br> - <strong> Gebruikersprofielen beheren </strong> door taken en verantwoordelijkheidsdomeinen te scheiden (bij voorkeur op gecentraliseerde wijze) om de toegang tot persoonsgegevens exclusief aan geautoriseerde gebruikers te beperken door het toepassen van need-to-know en leastprivilege-principes. <br> - Trek de rechten van werknemers, contractpartijen en andere derden in wanneer ze niet langer geautoriseerd zijn voor toegang een pand of een bron </strong> of wanneer hun <strong> arbeidscontract eindigt </strong>.",
			name: "Logische toegangscontrole",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Alle informatie met betrekking tot een geïdentificeerde of identificeerbare natuurlijke persoon ('gegevenssubject'); een identificeerbare natuurlijke persoon is iemand die direct of indirect kan worden geïdentificeerd, met name door te verwijzen naar een identificator zoals een naam, een identificatienummer, locatiegegevens, een online-identificator of een of meer factoren die specifiek zijn voor de fysieke, fysiologische, genetische, mentale, economische, culturele of sociale identiteit van die natuurlijke persoon. <br> zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 4.1 van de [AVG]</a>",
			name: "Persoonsgegevens",
			source: "AVG Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Natuurlijke of rechtspersoon, overheidsinstantie, agentschap of een andere instantie waaraan de persoonsgegevens worden verstrekt, ongeacht of deze derden zijn of niet. Overheidsinstanties die in het kader van een bepaald onderzoek persoonsgegevens kunnen ontvangen in overeenstemming met de wetgeving van de Unie of de lidstaten, worden echter niet als ontvangers beschouwd; de verwerking van die gegevens door die overheidsinstanties moet in overeenstemming zijn met de toepasselijke gegevensbeschermingsregels overeenkomstig de doeleinden van de verwerking. <br> See<a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 4.9 van de [AVG]</a>",
			name: "Ontvanger",
			source: "AVG Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "De betrokkene heeft het recht van de verwerkingsverantwoordelijke onverwijld persoonsgegevens te wissen en de verwerkingsverantwoordelijke is verplicht om persoonsgegevens zonder onnodige vertraging te wissen, zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 17 van de [AVG]</a>",
			name: "Recht op gegevenswissing",
			source: "AVG Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Verwachte voordelen (voor de organisatie, voor de betrokkenen, voor de samenleving in het algemeen, enz.).",
			name: "Inzet",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Persoonsgegevens moeten nauwkeurig zijn en, waar nodig, worden bijgewerkt; elke redelijke stap moet worden gezet om ervoor te zorgen dat persoonsgegevens die onnauwkeurig zijn, rekening houdend met de doeleinden waarvoor ze worden verwerkt, onverwijld worden gewist of gecorrigeerd ('nauwkeurigheid'). <br> zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 5.1 d) van [AVG]</a>",
			name: "Quality of data",
			source: "AVG Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Het prioriteitsniveau vertegenwoordigt de omvang van een risico. Het hangt voornamelijk af van de schadelijke aard van de potentiële gevolgen.",
			name: "Prioriteitsniveau",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "De betrokkene heeft het recht om van de verwerker een beperking van de verwerking te verkrijgen, zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 18 van de [AVG]</a>",
			name: "Recht op beperking van de verwerking",
			source: "AVG Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Stel een logging-architectuur in om vroegtijdige detectie van incidenten met persoonsgegevens toe te staan en om informatie te hebben die kan worden gebruikt om deze te analyseren of om bewijs te leveren in verband met onderzoeken.",
			name: "Toezicht",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Procedure bestaande uit een of meer individuele acties op gegevensondersteunende activa. Het wordt, opzettelijk of anderszins, gebruikt door risicobronnen en kan een gevreesde gebeurtenis veroorzaken.",
			name: "Bedreiging",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Bedreigingen met betrekking tot: - <strong> Hardware </strong>, ongepast gebruikt, waargenomen, gewijzigd, verloren (gebruik of transport van gevoelige hardware voor persoonlijke doeleinden, het kijken naar het scherm van een persoon zonder hun medeweten in de trein, het volgen door een hardware-gebaseerd systeem) key logger, etc.) <br> - <strong> Software </strong>, ongepast gebruikt, waargenomen, gewijzigd (verhogen van privileges, verzameling van configuratiegegevens, infectie door schadelijke code, etc.) <br> - <strong> Computerkanalen </strong> waargenomen (onderschepping van Ethernet-verkeer, enz.) <br> - <strong> Mensen </strong>, waargenomen, gemanipuleerd, verloren (onbedoelde openbaarmaking van informatie, social engineering, opdrachtwijzigingen) <br> - <strong> Papendocumenten </strong> waargenomen, verloren (lezen, diefstal van e-mail, enz.) <br> - <strong> kanalen voor papiertransmissie </strong> waargenomen (lezing van handtekeningenboeken in omloop, enz.)",
			name: "Bedreigingen die kunnen leiden tot een onrechtmatige toegang",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong> Bedreigingen met betrekking tot: </strong> <br> - <strong> Hardware </strong>: ongepast gebruikt, overbelast, gewijzigd, beschadigd, verloren (volledige opslagruimte, overbelasting van verwerkingscapaciteit, toevoeging van incompatibele hardware met storingen als gevolg, brand, diefstal of verlies van een actief, enz.) <br> - <strong> Software </strong>: ongepast gebruikt, overbelast, gewijzigd, beschadigd, verloren (wissen van gegevens, overschrijding van databasegrootte, logische bom, niet-verlenging van de licentie voor software die wordt gebruikt voor toegang tot gegevens, enz.) <br> - <strong> Computerkanalen </strong>: overbelast, gewijzigd, verloren (ongeautoriseerd downloaden, verlies van internetverbinding, etc.) <br> - < sterk> Mensen </strong>: overbelast, beschadigd, verloren (slecht gebruik van vaardigheden, ziekte, pensionering, etc.) <br> - <strong> Papendocumenten </strong>: ongepast gebruikt, beschadigd, zoekraken (wissen, verouderen van gearchiveerde documenten, diefstal of verlies van documenten, enz.) <br> - <strong> Papieren verzendkanalen </strong>: overbelast, beschadigd, gewijzigd, verloren (e-mailbezorging onderbroken door een waarschuwing, verplaatsing van kantoren of gebouwen, verlies van een documentleverancier, reorganisatie van papiertransmissiekanalen, enz.)",
			name: "Bedreigingen die kunnen leiden tot het verdwijnen van persoonlijke gegevens",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong> Bedreigingen met betrekking tot: </strong> <br> - <strong> Hardware </strong> gewijzigd (toevoeging van incompatibele hardware resulterend in storingen, verwijdering van essentiële onderdelen, enz.) <br> - <strong> Software </strong> ongepast of gewijzigd gebruikt (ongewenste wijzigingen aan gegevens in databases, operatorfouten die gegevens wijzigen, enz.) <br> - <strong> computerkanalen </strong> ongepast gebruikt (opnieuw verzenden van onderschepte gegevens, enz.) <br> - <strong> Mensen </strong> overbelast of manipuleert (toewijzing van personeel aan taken buiten hun mogelijkheden, stress of negatieve veranderingen in arbeidsomstandigheden, invloed, etc.) <br> - Papieren documenten die zijn gewijzigd (wijzigingen in figuren in een bestand, vervanging van een origineel door een vervalsing, enz.) <br> - <strong> kanalen voor papiertransmissie </strong> die zijn gewijzigd (van het ene handtekeningboek naar het andere overschakelen, meerdere conflicterende documenten verzenden, enz.)",
			name: "Bedreigingen die kunnen leiden tot een ongewenste wijziging van persoonlijke gegevens",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Te kiezen uit diegenen die beschikbaar zijn in sectie \\'Geplande of bestaande maatregelen \\', die u eventueel kunt invullen.",
			name: "Maatregelen",
			source: "Geen"
		},
		PIA_DEF_MIN1: {
			description: "Wanneer gegevens worden geïmporteerd, kunnen verschillende soorten metagegevens (zoals EXIF-gegevens met een bijgevoegd afbeeldingsbestand) onopzettelijk worden verzameld. <br> Dergelijke metadata moeten worden geïdentificeerd en geëlimineerd als ze niet nodig zijn voor de gespecificeerde doelen.",
			name: "Filteren en verwijderen",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Zodra gevoelige gegevens zijn ontvangen, als onderdeel van een reeks algemene informatie of alleen voor statistische doeleinden zijn verzonden, kunnen deze worden omgezet in een minder gevoelige vorm of gepseudonimiseerd. Bijvoorbeeld: <br> - als het systeem het IP-adres verzamelt om de locatie van de gebruiker te bepalen voor een statistisch doel, kan het IP-adres worden verwijderd nadat de stad of district is afgeleid <br> - als het systeem videogegevens ontvangt van surveillance camera's, kan het mensen herkennen die zich in de scène bevinden of bewegen en deze vervagen. - Als het systeem een slimme meter is, kan het het gebruik van energie gedurende een bepaalde periode samenvoegen, zonder het in realtime op te nemen",
			name: "Gevoeligheid verminderen via conversie",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Het systeem kan ervoor zorgen dat: <br> - de gebruiker kan een bron of service gebruiken zonder het risico van het bekendmaken van zijn / haar identiteit (anonieme gegevens) <br> - de gebruiker kan een bron of service gebruiken zonder het risico te lopen zijn / zijn haar identiteit, maar blijft identificeerbaar en verantwoordelijk voor dit gebruik (pseudoniemgegevens) <br> - de gebruiker kan meerdere bronnen of services gebruiken zonder het risico dat deze verschillende soorten gebruik aan elkaar worden gekoppeld (gegevens kunnen niet worden gecorreleerd) <br> - de gebruiker kan een bron of service gebruiken zonder het risico van anderen, in het bijzonder derde partijen, om te kunnen constateren dat de bron of dienst wordt gebruikt (niet-observeerbaarheid) <br> De keuze van een methode uit de bovenstaande lijst moet worden gemaakt op basis van de geïdentificeerde bedreigingen. Voor sommige vormen van bedreiging van privacy is pseudonimisering geschikter dan anonimisering (bijvoorbeeld als er een traceerbaarheid nodig is). Bovendien zullen sommige bedreigingen van de privacy worden aangepakt met behulp van een combinatie van methoden.",
			name: "Het verminderen van de identificatie van de aard van de gegevens",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Het systeem kan worden opgeeeld in onafhankelijke onderdelen met aparte toegangscontrolefuncties. De gegevens kunnen ook worden verdeeld tussen deze twee onafhankelijke subsystemen and worden aangestuurd door elke subsysteem gebruikmakend van verschillende toegangcontrolemechanismen. De impact op alle data kan zo worden gereduceerd als een subsysteem gecompromitteerd geraakt.",
			name: "Vermindering van gegevensaccumulatie",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Het systeem kan de gegevenstoegang beperken volgens het \\'need to know \\' -principe. Het systeem kan de gevoelige gegevens scheiden en specifieke toegangscontrolebeleid toepassen. Het systeem kan ook gevoelige gegevens coderen om hun vertrouwelijkheid tijdens verzending en opslag te beschermen. Toegang tot tijdelijke cookies die worden geproduceerd tijdens de gegevensverwerking moet ook worden beschermd.",
			name: "Gegevenstoegang beperken",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Verminder de ernst van risico's door de hoeveelheid persoonlijke gegevens te beperken tot wat strikt noodzakelijk is om een bepaald doel te bereiken, anders worden de gegevens niet verzameld.",
			name: "Het minimaliseren van de hoeveelheid persoonlijke gegevens",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "De ernst van de risico's verminderen door de gegevens zelf te minimaliseren, door maatregelen te nemen om hun gevoeligheid te verminderen, zoals het filteren en verwijderen van onnodige gegevens, het pseudonimiseren van gegevens, enz.",
			name: "Minimalisatie van gegevens zelf",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "De betrokkene heeft het recht om op grond van zijn specifieke situatie te allen tijde bezwaar te maken tegen de verwerking van persoonsgegevens die op hem betrekking hebben, overeenkomstig <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 21 van de [AVG]</a>",
			name: "Recht van bezwaar",
			source: "AVG Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Maatregelen die zijn genomen om de bescherming van persoonsgegevens in alle nieuwe verwerkingsactiviteiten te integreren (vertrouwde namen, richtlijnen, allerlei methodologieën voor risicobeheer of andere interne methodologie).",
			name: "Project Management",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Personen op wie de verwerkingde gegevens betrekking hebben .",
			name: "Betrokkene",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " De betrokkene heeft het recht om de persoonsgegevens die hem of haar betreffen en die hij aan een verantwoordelijke heeft verstrekt, in een gestructureerd, veelgebruikt en machinaal leesbaar formaat te ontvangen en heeft het recht deze gegevens aan een andere verwerker door te geven zonder belemmering van de verwerker waaraan de persoonlijke gegevens zijn verstrekt, zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 20 van de [AVG]</a>",
			name: "Recht op overdraagbaarheid van gegevens",
			source: "AVG Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Verwerking van persoonsgegevens op een zodanige wijze, dat de persoonsgegevens niet langer aan een specifieke gegevenssubject kunnen worden toegeschreven zonder het gebruik van aanvullende informatie, op voorwaarde dat die aanvullende informatie afzonderlijk wordt bewaard en onderworpen is aan technische en organisatorische maatregelen om te gegevens worden niet toegeschreven aan een geïdentificeerde of identificeerbare natuurlijke persoon. <br> Pseudonimisering vermindert de koppelbaarheid van een gegevensset met de oorspronkelijke identiteit van een betrokkene; als zodanig is het een nuttige beveiligingsmaatregel, maar geen methode voor anonimisering.",
			name: "Pseudonimisering",
			source: "AVG Art. 4.5 and guidelines G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Wachtwoorden bestaan uit minimaal acht tekens; moet worden vernieuwd als er de minste bezorgdheid bestaat dat ze mogelijk in gevaar zijn gebracht en mogelijk periodiek (elke zes maanden of eenmaal per jaar) en een minimum van drie van de vier soorten tekens moeten bevatten (hoofdletters, kleine letters, cijfers en speciale tekens); wanneer een wachtwoord wordt gewijzigd, worden de laatste vijf wachtwoorden mogelijk niet opnieuw gebruikt; hetzelfde wachtwoord mag niet worden gebruikt voor verschillende toegangen; wachtwoorden mogen niet gerelateerd zijn aan iemands persoonlijke informatie (inclusief naam of geboortedatum). Definieer een maximum aantal pogingen waarna een waarschuwing wordt verzonden en de verificatie wordt geblokkeerd (tijdelijk of totdat deze handmatig wordt gedeblokkeerd).",
			name: "Wachtwoorden",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "De betrokkene heeft het recht van de verwerkingsverantwoordelijke onverwijld de rectificatie van onjuiste persoonsgegevens die op hem of haar betrekking hebben, te verkrijgen. Rekening houdend met de doeleinden van de verwerking heeft de betrokkene het recht onvolledige persoonsgegevens te vervolledigen, onder meer door een aanvullende verklaring te verstrekken.",
			name: "Recht op rectificatie",
			source: "AVG Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Verordening betreffende de bescherming van natuurlijke personen in verband met de verwerking van persoonsgegevens en betreffende het vrije verkeer van die gegevens en tot intrekking van Richtlijn 95/46 / EG.",
			name: "Algemene verordening gegevensbescherming (AVG)",
			source: "Europese privacywetgeving AVG"
		},
		PIA_DEF_RT: {
			description: "Natuurlijke of rechtspersoon, overheidsinstantie, agentschap of andere instantie die, alleen of samen met anderen, de doeleinden en middelen voor de verwerking van persoonsgegevens bepaalt; wanneer het doel en de middelen van een dergelijke verwerking worden bepaald door de wetgeving van de Unie of de lidstaat, kan de verwerkingsverantwoordelijke of de specifieke criteria voor de aanwijzing ervan door de wetgeving van de Unie of de lidstaten worden geregeld <br>zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 4.7 van de [AVG]</a>",
			name: "Verwerkingsverantwoordelijke",
			source: "AVG Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Persoon of niet-menselijke bron die een risico kan veroorzaken. Deze bron kan per ongeluk of opzettelijk werken.",
			name: "Risicobron",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Natuurlijke of rechtspersoon, overheidsinstantie, agentschap of andere instantie die persoonsgegevens namens de verantwoordelijke voor de verwerking verwerkt, zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 4.8 van de [AVG]</a>.<br>De verwerker en eenieder die onder het gezag van de verwerkingsverantwoordelijke of van de verwerker handelt en toegang heeft tot persoonsgegevens, verwerkt deze uitsluitend in opdracht van de verwerkingsverantwoordelijke, tenzij hij Unierechtelijk of lidstaatrechtelijk tot de verwerking gehouden is., zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 29 van de [AVG]</a>.",
			name: "Verwerker",
			source: "AVG Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Activum waarop persoonlijke gegevens vertrouwen. Dit kunnen hardware, software, netwerken, mensen, papier- of papiertransmissiekanalen zijn",
			name: "Ondersteunende activa",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Overtreding van de beveiliging die leidt tot de accidentele of onrechtmatige vernietiging, verlies, wijziging, ongeautoriseerde openbaarmaking van of toegang tot doorgegeven, opgeslagen of anderszins verwerkte persoonsgegevens.",
			name: "Inbreuk op persoonsgegevens",
			source: "AVG Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Waarschijnlijkheid drukt de mogelijkheid uit, dat een risico zich voordoet. Het hangt in de eerste plaats af van het niveau van kwetsbaarheden van de ondersteunende activa wanneer deze worden bedreigd en van het niveau van mogelijkheden van de risicobronnen om deze te exploiteren.",
			name: "Waarschijnlijkheid",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Data voor een score-systeem, resultaat van de toepassing van de score...",
			name: "Berekende data"
		},
		PIA_EX_DCPC: {
			description: "<strong> Identificatiegegevens </strong>: burgerlijke staat, identiteit, leeftijd, etc. <br> <strong> Persoonlijk leven </strong>: leefgewoonten, burgerlijke staat, enz. <br> <strong> Professioneel leven </strong>: cv, onderwijs en professionele training, onderscheidingen, etc. <br> <strong> Verbindingsgegevens </strong>: IP-adressen, gebeurtenislogboeken, enz. <br> <strong> Locatiegegevens </strong>: reizen, GPS-gegevens, GSM-gegevens, enz. <br> <strong> Overige </strong>: telefoonnummer, e-mailadres, etc.",
			name: "Gemeenschappelijke persoonsgegevens",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Filosofische, politieke, religieuze en vakbondsvisies, seksleven, gezondheidsgegevens, ras of etnische afkomst, gegevens over gezondheid of seksleven, overtredingen, veroordelingen, veiligheidsmaatregelen, zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 9 and 10 van de [AVG]</a>.",
			name: "Overtuigingen en gevoelige persoonsgegevens"
		},
		PIA_EX_DCPS: {
			description: "burgerservicenummer (BSN), biometrische gegevens, bankgegevens",
			name: "Persoonsgegevens die als gevoelig worden ervaren"
		},
		PIA_EX_HUME: {
			description: "Het kan een van de volgende zijn: <br> - een bedrieglijke of naïeve buur, door een fysieke nabijheid te hebben, de gegevens van het apparaat te hacken; <br> - een hacker die een gebruiker richt door gebruik te maken van de kennis die hij / zij heeft van de gebruiker en sommige van de informatie over hem / haar; <br> - een hacker die zich op een van de bedrijven richt door gebruik te maken van de kennis die hij / zij heeft van de bedrijven die hun imago kunnen ondermijnen; <br> - een geautoriseerd extern bedrijf dat zijn bevoorrechte toegang tot onrechtmatig gebruikt toegang tot informatie.",
			name: "Externe menselijke bronnen"
		},
		PIA_EX_HUMI: {
			description: "Het kan een van beide zijn: <br> - een nalatige of malafide medewerker, nabijheid van het systeem, vaardigheden, privileges en beschikbare tijd zijn potentieel hoog, mogelijk gebrek aan training en bewustzijn <br> - Onachtzame of schurkenstaten gebruiker of mensen in de omgeving <br> Verschillende motieven zijn mogelijk, waaronder: onhandigheid, fouten, nalatigheid, kwaadaardige bedoelingen, wraak, spionage",
			name: "Interne menselijke bronnen"
		},
		PIA_EX_IMPI: {
			description: "Betrokkenen kunnen aanzienlijke gevolgen ondervinden, die ze moeten kunnen overwinnen, zij het met echte en ernstige problemen <br> Voorbeelden: <br> - fysiek: ernstige fysieke kwalen veroorzaakt schade op de lange termijn (verslechtering van de gezondheid als gevolg van onjuiste zorg of veronachtzaming van contra-indicaties), lteratie van fysieke integriteit, bijvoorbeeld na een aanslag, een ongeval thuis, werk, etc. <br> - materiaal: verduistering van niet-gecompenseerd, gericht, uniek en niet-recurrent, gemiste kansen (huislening, weigering van studies, stages of tewerkstelling, onderzoeksverbod), verlies van huisvesting, verlies van werk, etc. <br> - moraal: ernstige psychische aandoeningen (depressie, ontwikkeling van een fobie), gevoel van inbreuk op privacy met onomkeerbare schade, slachtoffer van chantage, cyberpesten en intimidatie, enz.",
			name: "Aanzienlijke ernst"
		},
		PIA_EX_IMPL: {
			description: "Betrokkenen kunnen aanzienlijke ongemakken tegenkomen, die ze kunnen overwinnen ondanks een paar problemen <br> Voorbeelden: <br> - fysiek: kleine lichamelijke kwalen (kleine ziekte als gevolg van het negeren van contra-indicaties), laster die resulteert in fysieke of psychologische vergelding, enz. <br> - materiaal: onverwachte betalingen (boetes die ten onrechte zijn opgelegd), ontzegging van toegang tot administratieve of commerciële diensten, Ontvangst van ongevraagde gerichte mailings die de reputatie van betrokkenen kunnen schaden enz. <br> - moraal: onbeduidend maar objectief psychische aandoeningen, gevoel van inbreuk op de privacy zonder onomkeerbare schade, intimidatie op sociale netwerken, enz.",
			name: "Beperkte ernst"
		},
		PIA_EX_IMPM: {
			description: "Betrokkenen kunnen aanzienlijke, of zelfs onomkeerbare, gevolgen ondervinden, die ze mogelijk niet overwinnen. Voorbeelden: <br> - fysiek: langdurige of permanente fysieke kwalen, blijvende beschadiging van fysieke integriteit, overlijden <br> - materiaal: financieel risico, aanzienlijke schulden, onvermogen om te werken, onvermogen om te verhuizen, verlies van bewijs in de context van geschillen, verlies van toegang tot vitale infrastructuur (water, elektriciteit), enz. <br> - moraal: langdurige of permanente psychische aandoeningen, strafrechtelijke sanctie, ontvoering, verlies van familiebanden, onvermogen om te vervolgen, verandering van administratieve status en/of verlies van juridische autonomie (voogdij), enz.",
			name: "Maximale ernst"
		},
		PIA_EX_IMPN: {
			description: "Betrokkenen worden ofwel niet beïnvloed of kunnen enkele ongemakken tegenkomen die ze zonder enig probleem zullen overwinnen. Voorbeelden: <br> - fysiek: voorbijgaande hoofdpijn <br> - materiaal: tijdverlies bij het herhalen van formaliteiten of wachten op waaraan ze moeten voldoen, ontvangst van ongevraagde e-mail (bijv. spams), hergebruik van gegevens die op websites worden gepubliceerd met het doel van gerichte advertenties, enz., <br> - moraal: loutere ergernis, gevoel van inbreuk op privacy zonder echte of objectieve schade (commerciële inbraak), etc.",
			name: "Verwaarloosbare ernst"
		},
		PIA_EX_NHUM: {
			description: "Incident of schade bij een van de organisatie (stroomstoring, brand, overstroming, etc.)",
			name: "Niet-menselijke bronnen"
		},
		PIA_EX_VRAI: {
			description: "Het lijkt mogelijk dat de geselecteerde risicobronnen de dreiging materialiseren door gebruik te maken van de eigenschappen van ondersteunende activa (bijvoorbeeld diefstal van papieren documenten die zijn opgeslagen in kantoren en die niet toegankelijk zijn zonder eerst bij de receptie in te checken).",
			name: "Aanzienlijke waarschijnlijkheid"
		},
		PIA_EX_VRAL: {
			description: "Het lijkt moeilijk voor de geselecteerde risicobronnen om de dreiging te materialiseren door gebruik te maken van de eigenschappen van ondersteunende activa (bijvoorbeeld: diefstal van papieren documenten die zijn opgeslagen in een kamer die wordt beschermd door een badgelezer).",
			name: "Beperkte waarschijnlijkheid"
		},
		PIA_EX_VRAM: {
			description: "Het lijkt uiterst gemakkelijk voor de geselecteerde risicobronnen om de dreiging te materialiseren door gebruik te maken van de eigenschappen van ondersteunende activa (bijvoorbeeld diefstal van papieren documenten die zijn opgeslagen in de openbare lobby).",
			name: "Maximale kans"
		},
		PIA_EX_VRAN: {
			description: "Het lijkt niet mogelijk dat de geselecteerde risicobronnen de dreiging materialiseren door gebruik te maken van de eigenschappen van ondersteunende activa (bijvoorbeeld diefstal van papieren documenten die zijn opgeslagen in een ruimte die wordt beschermd door een badgelezer en toegangscode).",
			name: "Verwaarloosbare waarschijnlijkheid"
		},
		PIA_LGL_CONS: {
			description: "Stel de betrokkenen in staat om een vrije, specifieke en geïnformeerde keuze te maken. Bepaal of de verwerking berust op een andere wettelijke basis dan toestemming overeenkomstig Art. 6 van de <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">[AVG]</a>",
			name: "Toestemming",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Definieer en beschrijf de scope in detail: <br> - de betreffende persoonlijke gegevens, hun ontvangers en hun opslagduur <br> - beschrijving van de processen en persoonlijke gegevens die de assets ondersteunen voor de gehele levenscyclus van persoonlijke gegevens (van verzameling tot wissen).",
			name: "Gegevens en processen",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Presenteer een korte schets van de verwerking in kwestie, de aard, reikwijdte, context, doelen en inzetten. Identificeer de verwerkingsverantwoordelijke en eventuele verwerkers. Maak een lijst van de standaardreferenties die van toepassing zijn op de verwerking en die noodzakelijk zijn of moeten worden nageleefd, met name de goedgekeurde gedragscodes (zie artikel 40 van het Reglement). <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">[AVG]</a>) en certificeringen met betrekking tot gegevensbescherming (zie Art. 42 van de <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">[AVG]</a>)",
			name: "Beschrijving van de verwerking",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Natuurlijke of rechtspersoon, overheidsinstantie, agentschap of een andere instantie waaraan de persoonsgegevens worden verstrekt, ongeacht of deze derden zijn of niet. Overheidsinstanties die in het kader van een bepaald onderzoek persoonsgegevens kunnen ontvangen in overeenstemming met de wetgeving van de Unie of de lidstaten, worden echter niet als ontvangers beschouwd; de verwerking van die gegevens door die overheidsinstanties moet in overeenstemming zijn met de toepasselijke gegevensbeschermingsregels overeenkomstig de doeleinden van de verwerking. zie Art. 4.9 van de <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">[AVG]</a>",
			name: "Ontvanger",
			source: "AVG art 4.9"
		},
		PIA_LGL_DUR: {
			description: "Er moet een opslagduur worden gedefinieerd voor elk type gegevens en worden gerechtvaardigd door de wettelijke vereisten en/of verwerkingsbehoeften. Er wordt dus een onderscheid gemaakt tussen gemeenschappelijke gegevens en gearchiveerde gegevens, waartoe de toegang beperkt blijft tot alleen de betrokken belanghebbenden. Een wismechanisme moet worden geïmplementeerd om gemeenschappelijke gegevens te archiveren of gearchiveerde gegevens te wissen aan het einde van de opslagduur. Functionele sporen moeten ook worden verwijderd, evenals technische logboeken die mogelijk niet voor onbepaalde tijd worden opgeslagen",
			name: "Opslagduur",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Persoonsgegevens worden verzameld voor specifieke, expliciete en legitieme doeleinden en <strong> niet verder verwerkt op een manier die onverenigbaar is met die doeleinden.</strong> <br>Zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">Art. 5.1 b) van de [AVG]</a>",
			name: "Beginselen met betrekking tot de verwerking van persoonsgegevens",
			source: "AVG art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- De betrokkene heeft toestemming gegeven voor de verwerking van zijn of haar persoonsgegevens voor een of meer specifieke doeleinden. - Verwerking is noodzakelijk voor de uitvoering van een contract waarbij de betrokkene partij is of om stappen te ondernemen op verzoek van de betrokkene voorafgaand aan het aangaan van een contract <br> -verwerking is noodzakelijk voor de naleving van een wettelijke verplichting waaraan de verwerkingsverantwoordelijke onderworpen is - Verwerking is nodig om de vitale belangen van de betrokkene of van een andere persoon te beschermen natuurlijke persoon <br> - Verwerking is noodzakelijk voor de uitvoering van een taak die wordt uitgevoerd in het openbaar belang of bij de uitoefening van het openbaar gezag door de verwerkingsverantwoordelijke <br> - Verwerking is noodzakelijk met het oog op de legitieme belangen die door de verwerkingsverantwoordelijke worden nagestreefd of door een derde partij, behalve wanneer dergelijke belangen worden opgeheven door de belangen of fundamentele rechten en vrijheden van de betrokkene die bescherming van persoonsgegevens vereisen, met name wanneer de dat een onderwerp is een kind - Zie<a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">art. 6 of [AVG]</a> ",
			name: "Verantwoording van de rechtmatigheid",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Zorg ervoor dat betrokkenen op de hoogte zijn. Controleer of de verwerking niet onder een uitzondering valt en niet onderhevig is aan specifieke voorwaarden.",
			name: "Informeren van betrokkenen",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Het is belangrijk om de ernst van de risico's te verminderen door het aantal persoonsgegevens dat wordt verwerkt te beperken door deze gegevens te beperken tot wat strikt noodzakelijk is voor de doeleinden waarvoor ze worden verwerkt (anders zouden ze niet moeten worden verzameld). Dan wordt het ook mogelijk om de gegevens zelf te minimaliseren, via controles die gericht zijn op het verminderen van hun gevoeligheid.",
			name: "Dataminimalisatie",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Er moet een verwerkingscontract worden ondertekend met elke verwerker, waarin alle aspecten worden uiteengezet die zijn vastgelegd in Art. 28 van de [AVG]: duur, reikwijdte, doel, gedocumenteerde verwerkingsinstructies, voorafgaande toestemming wanneer een verwerker is ingeschakeld, verstrekking van documentatie die bewijs levert van de naleving van de [AVG], onmiddellijke kennisgeving van een inbreuk op de gegevens, enz.",
			name: "Subcontracting",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Activum waarop persoonlijke gegevens vertrouwen. Opmerking: dit kunnen hardware, software, netwerken, mensen, papier- of papiertransmissiekanalen zijn.",
			name: "Ondersteunende activa",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Afhankelijk van het land in kwestie, moet u de keuze voor externe hosting rechtvaardigen en aangeven welke juridische toezichtregelingen zijn geïmplementeerd om te zorgen voor een adequate bescherming van de betrokkene bij een grensoverschrijdende doorgifte. Dat wil zeggen: <br> - Europese Unie <br> - Land erkend als voldoende bescherming door de EU <br> - Overdracht naar de Verenigde Staten aan een bedrijf dat zich bij het privacyschild heeft aangesloten - Ander land <br> Zie <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">art. 44 tot 49 van de [AVG]</a>",
			name: "Transfers",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "Geplande beheersmaatregelen zijn de naamtregelen die origineel werdn genomen, voor enige analyse door de beoordelaar. Corrigerende maatregelen die worden aangeraden door de beoordelaar zullen worden opgenomen in het actieplan en zullen een tweede beoordeling toelaten van de ernst en de waarschijnlijkheid van het risico.",
			name: "Geplande en corrigerende beheersmaatregelen",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Bestaan van een beleid en processen om een organisatie te realiseren, die in staat is om de bescherming van persoonlijke gegevens die zich daarin bevinden, te beheren en controleren.",
			name: "Toezicht",
			placeholder: "Geef hier aan of de effectiviteit en toereikendheid van privacymaatregelen worden bewaakt.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Bestaan van een beleid en processen die het risico verminderen, dat legitieme toegang tot persoonsgegevens door derden, de burgerlijke vrijheden en privacy van de betrokkenen kan beïnvloeden.",
			name: "Betrekkingen met derden",
			placeholder: "Geef hier voor verwerkers aan, die toegang tot gegevens nodig hebben, de beveiligingscontroles en regelingen die met betrekking tot die toegang zijn uitgevoerd.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Geef aan of een persoon verantwoordelijk is voor de handhaving van privacywetten en -voorschriften. Geef aan of er een toezichtcomité (of gelijkwaardig) verantwoordelijk is voor de begeleiding en follow-up van acties met betrekking tot de bescherming van privacy.",
			name: "Organisatie",
			placeholder: "Geef aan of de rollen en verantwoordelijkheden voor gegevensbescherming zijn gedefinieerd.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Het bestaan van een formeel beleid welke de bescherming van persoonlijke gegevens in alle nieuwe verwerkingsactiviteiten waarborgt.",
			name: "Integratie van privacybescherming in projecten",
			placeholder: "Beschrijf hier hoe privacybescherming is geïntegreerd in projecten",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Het bestaan van een beleid, dat bewustmakingscontroles beschrijft, wordt uitgevoerd met betrekking tot een nieuwe personen en welke controles worden uitgevoerd wanneer personen die toegang hebben gehad tot gegevens hun baan verlaten.",
			name: "Personeelsmanagement",
			placeholder: "Geef hier aan welke bewustmakingscontroles worden uitgevoerd met betrekking tot werknemers.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Beschrijf belangrijke aspecten met betrekking tot gegevensbescherming binnen een documentaire basis die het gegevensbeschermingsbeleid vormt en in een vorm die geschikt is voor elk type inhoud (risico's, belangrijkste beginselen die moeten worden gevolgd, doelstellingen, toe te passen regels, enz.) en elk communicatiedoel (gebruikers, IT-afdeling, beleidsmakers, enz.).",
			name: "Policy",
			placeholder: "Beschrijf hier de documentaire basis met gegevensbeschermingsdoelen en -regels.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Beleid dat processen beschrijft om de risico's te beheersen die door de organisatie worden uitgevoerd met betrekking tot gegevensbescherming en de privacy van betrokkenen (een kaart maken van de risico's, enz.).",
			name: "Privacyrisico's beheren",
			placeholder: "Beschrijf hier processen om de risico's van verwerkingen te beheersen op basis van gegevensbescherming en gegevensbescherming.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Bestaan van een operationele organisatie die incidenten kan detecteren en behandelen die van invloed kunnen zijn op de burgerlijke vrijheden en privacy van de betrokkenen.",
			name: " Beleid incidenten en datalekken",
			placeholder: "Geef hier aan of IT-incidenten onderworpen zijn aan een gedocumenteerde en geteste beheersprocedure.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Beleid en middelen geïmplementeerd om de beschikbaarheid en/of integriteit van de persoonlijke gegevens te waarborgen, met behoud van hun vertrouwelijkheid.",
			name: "Backups",
			placeholder: "Geef hier aan hoe back-ups worden beheerd. Maak duidelijk of ze op een veilige plaats zijn opgeslagen.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Controle maatregelen geïmplementeerd op werkstations (automatische vergrendeling, regelmatige updates, configuratie, fysieke beveiliging, enz.) Om de mogelijkheid om softwareleigenschappen (besturingssystemen, bedrijfsapplicaties enz.) te misbruiken om persoonlijke gegevens nadelig te beïnvloeden.",
			name: "Werkstations beheren",
			placeholder: "Beschrijf hier de maatregelen die op de werkstations zijn geïmplementeerd",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "Regel de inkooprelaties via een contract ondertekend intuitu personæ. <br> - Verplicht de verwerker om zijn informatiesysteembeveiligingsbeleid (PSSI) samen met alle ondersteunende documenten van zijn informatiebeveiligingscertificaten door te sturen en de documenten bij het contract te voegen. Zorg ervoor dat de maatregelen op grond van de PSSI voldoen aan de aanbevelingen van de CNIL in dit verband. <br> - Bepaal en stel op contractuele basis nauwkeurig vast welke bewerkingen de verwerker op zijn persoonlijke gegevens moet uitvoeren: <br> 1 ) De gegevens waartoe deze toegang heeft of die er naartoe worden verzonden. <br> 2) De bewerkingen die moeten worden uitgevoerd op de gegevens. <br> 3) De duur waarvoor het de gegevens mag opslaan. <br> 4) Alle ontvangers waarvoor de gegevensbeheerder de gegevens moet verzenden. <br> 5) De bewerkingen die moeten worden uitgevoerd aan het einde van de service (permanente verwijdering van gegevens of retournering van de gegevens in het kader van omkeerbaarheid en vernietiging) van gegevens bij de verwerker). <br> 6) De beveiligingsdoelstellingen die zijn ingesteld door de gegevensbeheerder. <br> - Bepaal op contractuele basis de verantwoordelijkheidsdeling met betrekking tot de juridische processen gericht op het toestaan ​​van de betrokkenen om hun rechten uit te oefenen. <br> - Expliciet verbieden of reguleren van het gebruik van tier-2-verwerkers. <br> - Verduidelijken in het contract dat de naleving van de verplichtingen inzake gegevensbescherming een bindende vereiste van het contract is.",
			name: "Verwerkingscontracten",
			placeholder: "Beschrijf hier specifieke maatregelen voor verwerkers (host, onderhoudsbedrijf, beheerder, gespecialiseerde serviceproviders, enz.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Beleid geïmplementeerd om de mogelijkheid en de impact van risico's op activa die persoonlijke gegevens ondersteunen te verkleinen.",
			name: "Operationele beveiliging",
			placeholder: "Beschrijf hier, hoe de software-updates (besturingssystemen, applicaties, enz.) en de toepassing van patches voor het corrigeren van beveiligingsmaatregelen worden uitgevoerd.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Monitor inbraakdetectiesystemen en inbraakpreventiesystemen om netwerkverkeer (bedrade netwerken, wifi, radiogolven, glasvezel, enz.) in realtime te analyseren en eventuele verdachte activiteiten te detecteren die wijzen op een cyberaanvalscenario.",
			name: "Netwerkactiviteit controleren",
			placeholder: "Hier worden middelen en maatregelen aangegeven die zijn geïmplementeerd om incidenten met persoonsgegevens te detecteren",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Beleid dat beschrijft hoe fysiek onderhoud van hardware wordt beheerd en waarin wordt vermeld of dit wordt uitbesteed. <br> Geef aan of extern onderhoud van apps is toegestaan en volgens welke regelingen. Geef aan of defecte apparatuur op een specifieke manier wordt beheerd.",
			name: "Onderhoud",
			placeholder: "Beschrijf hier hoe fysiek onderhoud van hardware wordt beheerd",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controle maatregelen geïmplementeerd op werkstations en servers om hen te beschermen tegen kwaadwillende software tijdens toegang tot minder beveiligde netwerken.",
			name: "Vasthouden aan schadelijke software",
			placeholder: "Beschrijf hier de controle maatregelen die zijn geïmplementeerd om risico's te verminderen tijdens het gebruik van minder beveiligde netwerken.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Geef hier de maatregelen aan die betrekking hebben op de fysieke beveiliging van servers en werkstations (beveiligde opslag, beveiligingskabels, vertrouwelijkheidsfilters, veilig wissen vóór het afdanken, enz.).",
			name: "Hardwarebeveiliging",
			placeholder: "Geef hier de maatregelen aan die betrekking hebben op de fysieke beveiliging van servers en werkstations",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Afhankelijk van het type netwerk waarop de verwerking wordt uitgevoerd (geïsoleerd, privé of internet). Geef op welk firewallsysteem, inbraakdetectiesystemen of andere actieve of passieve apparaten de netwerkbeveiliging moeten waarborgen.",
			name: "Netwerkbeveiliging",
			placeholder: "Geef hier de beveiligingscontroles van het netwerk aan waarop de verwerking wordt uitgevoerd",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Beleid om fysieke beveiliging te waarborgen (bestemmingsplan, escorteren van bezoekers, dragen van pasjes, vergrendelde deuren en dergelijke). Geef aan of er sprake is van waarschuwingsprocedures bij een inbraak.",
			name: "Fysieke toegangscontrole",
			placeholder: "Geef hier aan hoe fysieke toegangscontrole wordt uitgevoerd met betrekking tot het pand dat de verwerking accommodeert.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Beleid dat de middelen voor brandpreventie, detectie en bestrijding beschrijft. Vermeld waar van toepassing de middelen om waterschade te voorkomen. Specificeer ook de middelen voor het bewaken en ontlasten van de voedingsspanning.",
			name: "Bescherming tegen niet-menselijke risicobronnen",
			placeholder: "Hier aangeven betekent middelen vermijden om niet-menselijke bronnen van risico's te beperken.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Documentatie over het implantatiegebied, die niet mag worden blootgesteld aan milieurampen (overstromingsgebied, nabijheid van chemische industrieën, aardbevingen of vulkanische zones, enz.). Geef aan of gevaarlijke producten in hetzelfde gebied worden opgeslagen.",
			name: "Risico's vermijden",
			placeholder: "Geef hier aan of het implantatiegebied onderhevig is aan milieurampen",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementatie van ANSSI-aanbevelingen voor het beveiligen van websites.",
			name: "Websitebeveiliging",
			placeholder: "Geef hier de controle maatregelen aan die zijn geïmplementeerd om websites te beveiligen.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Geef hier aan of anonimiseringsmechanismen zijn geïmplementeerd, welke en waarvoor. <br> Vergeet niet om een duidelijk onderscheid te maken tussen anonieme en pseudonieme gegevens.",
			name: "Anonimisering",
			placeholder: "Geef hier geïmplementeerde anonimiseringsmechanismen aan",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Beschrijf, waar van toepassing, hier de processen van archiefbeheer (levering, opslag, raadpleging, enz.) onder uw verantwoordelijkheid. Geef de archiveringsrollen op (bronnen van oorsprong, overmakende instanties, enz.) En het archiveringsbeleid. Geef aan of gegevens binnen het bereik van openbare archieven kunnen vallen.",
			name: "Archiveren",
			placeholder: "Geef hier aan of er mechanismen worden geïmplementeerd voor integriteitscontrole van opgeslagen gegevens, welke en voor welk doel.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Middelen geïmplementeerd die <strong> zorgen voor de vertrouwelijkheid </strong> van opgeslagen gegevens (in de database, in platte bestanden, back-ups, enz.), evenals de procedure voor het beheren van coderingssleutels (creatie, opslag, wijziging in het geval van vermoede gevallen van compromittering van gegevens, enz.). Beschrijf de coderingsmiddelen die worden gebruikt voor gegevensstromen (VPN, TLS, enz.) die bij de verwerking zijn geïmplementeerd.",
			name: "Encryptie",
			placeholder: "Beschrijf hier de middelen die zijn geïmplementeerd om de vertrouwelijkheid van gegevens te waarborgen",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Implementatie van gegevenspartitionering helpt om de mogelijkheid te verkleinen dat persoonlijke gegevens kunnen worden gecorreleerd en dat een schending van alle persoonlijke gegevens kan optreden.",
			name: "Partitiegegevens",
			placeholder: "Geef hier aan of partitionering van de verwerking is gepland en hoe dit wordt uitgevoerd.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Methoden voor het definiëren en toewijzen van gebruikersprofielen. Geef de geïmplementeerde <strong> authenticatie </strong> op. Geef, waar van toepassing, de regels op die van toepassing zijn op wachtwoorden (minimale lengte, vereiste tekens, geldigheidsduur, aantal mislukte pogingen, voordat toegang tot het account vergrendeld is, enz.).",
			name: "Logische toegangscontrole",
			placeholder: "Geef hier aan hoe gebruikersprofielen zijn gedefinieerd en toegewezen.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Beleid dat traceerbaarheid en logbeheer definieert.",
			name: "Traceerbaarheid (logging)",
			placeholder: "Geef hier aan of gebeurtenissen worden vastgelegd en hoelang deze sporen worden opgeslagen.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "De volgende methoden kunnen worden gebruikt: filteren en verwijderen, gevoeligheid verminderen via conversie, de identificerende aard van gegevens verminderen, gegevensaccumulatie reduceren, gegevenstoegang beperken",
			name: "Minimaliseren van de hoeveelheid persoonlijke gegevens",
			placeholder: "Geef hier aan of de hoeveelheid persoonlijke gegevens wordt beperkt om de ernst van risico's te verminderen",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Als er papieren documenten met gegevens worden gebruikt tijdens de verwerking, kunt u hier aangeven hoe u ze afdrukt, opslaat, vernietigd en uitwisselt.",
			name: "Papieren documentbeveiliging",
			placeholder: "Geef hier aan of er mechanismen zijn geïmplementeerd voor integriteitscontrole van papieren documenten, welke en voor welk doel.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Corrigerende controles voorgesteld door de beoordelaar in eerdere stappen, opstellen van een actieplan met voor elke actie de manager, frequentie, moeilijkheidsgraad, kosten en voortgang.",
			name: "Actieplan",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Grafiek die de goede beveiligingspraktijken illustreert, met een conformiteitswaarde die aan elk wordt toegeschreven op basis van zijn beoordeling in vorige stappen.",
			name: "Risico's in kaart brengen",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "In voorkomend geval wint de verwerkingsverantwoordelijke het standpunt van de betrokkenen of hun vertegenwoordigers in over de voorgenomen verwerking, onverminderd de bescherming van commerciële of openbare belangen of de beveiliging van verwerkingshandelingen. Zie Art. 39.2 van de <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">[AVG]</a><br>Deze standpunten kunnen op verschillende manieren worden verzameld, afhankelijk van de context (intern of extern onderzoek naar de verwerkingsmethoden en het doel, vraag onder aandacht van personeelsvertegenwoordigers of vakbonden brengen, enquête onder toekomstige klanten van de gegevensverwerker). <strong> Als de gegevensbeheerder besluit de meningen van de betrokkenen te negeren </strong>, moet hij <strong> de motivering voor dit besluit noteren </strong>. Wanneer de verwerkingsverantwoordelijke meent dat <strong> het verzamelen van de standpunten van de betrokkenen niet relevant is, moet hij ook de motivering daarvan noteren</strong>.",
			name: "Het oordeel van de betrokkene",
			source: "AVG Art. 39.9 en PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "De verwerkingsverantwoordelijke zoekt de functionaris voor gegevensbescherming (FG), indien aangewezen, bij het uitvoeren van een gegevensbeschermingseffectbeoordeling. Zie Art. 39.2 van de <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/NL/TXT/HTML/?uri=CELEX:32016R0679&from=NL\">[AVG]</a><br> <strong>Deze opvatting kan tegen de verwerking zijn die wordt geïmplementeerd, zonder de beslissing van de verantwoordelijke voor dat alles te beperken</strong>.",
			name: "mening DPO",
			source: "AVG Art. 39.2 en PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Bepaal of de geselecteerde controles, restrisico's en actieplan aanvaardbaar zijn, met motiveringen, met het oog op de eerder geïdentificeerde belangen en standpunten van de belanghebbenden. Op deze manier kan de PIA zijn: <br> - gevalideerd <br> - afhankelijk van verbetering (leg uit op welke manier) <br> - geweigerd (samen met de verwerking in kwestie). Herhaal waar nodig de voorgaande stappen zodat de PIA kan worden gevalideerd. Deze beslissing loopt niet vooruit op de conformiteitsbeoordeling die eventueel wordt uitgevoerd door de autoriteit voor gegevensbescherming (de CNIL in Frankrijk), als onderdeel van bijvoorbeeld voorafgaande formaliteiten of controles.",
			name: "Formele validatie",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Kennisbank"
};
var measures$8 = {
	add: "Voeg een lege maatregel toe (of gebruik de kennisbank)",
	default_placeholder: "Beschrijf de bestaande of beoogde maatregelen om de gegevensbeveiliging te waarborgen.",
	edit: "Bewerk maatregel",
	placeholder_title: "Titel maatregel",
	remove: "Verwijder maatregel"
};
var misc$8 = {
	display: "Laten zien / verbergen"
};
var modals$8 = {
	abandon_pia: {
		additional_text: "Archiveren is niet definitief en je kunt zo nodig op de PIA terugkomen.",
		content: "Wilt u de verwerking opgeven?"
	},
	action_plan_no_evaluation: {
		content: "U moet beginnen met het evalueren van de analyse om het actieplan te maken.",
		review_section: "Controleer een sectie"
	},
	archive: "Archief",
	archive_pia: {
		archive: "PIA archiveren",
		content: "<span class='strong'>Opgelet,</span><br>Ben je zeker dat je <br>deze PIA wilt archiveren?"
	},
	ask_for_evaluation: {
		content: "Dit gedeelte kan worden beoordeeld."
	},
	back_to_edition: {
		content: "Deze sectie is teruggestuurd voor bewerking. <br>Verschillende velden moeten worden gecorrigeerd<br> om de juiste beoordeling mogelijk te maken."
	},
	back_to_evaluation: {
		content: "Dit gedeelte is ter beoordeling teruggestuurd. <br>Verschillende velden moeten worden beoordeeld<br> om de juiste validatie mogelijk te maken."
	},
	back_to_home: "Terug naar begin",
	cancel: "Annuleer",
	close: "Afsluiten",
	completed_edition: {
		content: "De PIA is volledig bewerkt, en moet opnieuw gevalideerd worden."
	},
	completed_evaluation: {
		content: "De PIA is volledig gereviewed, en moet nog gevalideerd worden."
	},
	"continue": "Vervolgen",
	declare_measures: {
		content: "Voordat u risico's evalueert, <br> moet u de bestaande of geplande maatregelen opgeven.",
		declare: "Geef bestaande of geplande maatregelen op"
	},
	dpo_missing_evaluations: {
		comment: "Commentaar",
		content: "U moet de controle van de analyse voltooien om toegang te krijgen tot de DPO-pagina.",
		remove: "Verwijderen",
		review_section: "Controleer een sectie"
	},
	general_error: {
		content: "Onze excuses. Er heeft zich een fout voorgedaan."
	},
	import_wrong_pia_file: {
		content: "Het geïmporteerde bestand stemt niet overeen met een bestand van het type PIA"
	},
	import_wrong_structure_file: {
		content: "Het geïmporteerde bestand stemt niet overeen met een bestand van het type sjabloon"
	},
	knowledge: {
		content: "Ben je zeker dat je dit element wilt verwijderen?",
		remove: "Dit element verwijderen"
	},
	knowledges: {
		content: "Ben je zeker dat je deze kennisbank wilt verwijderen?",
		remove: "Deze kennisbank verwijderen"
	},
	modal_select_text_pia: {
		content: "De inhoud van de PIA is gekopieerd naar het klembord."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Opgelet! </span> <br> Ten minste één meting moet worden ingevuld: verwijderen is niet mogelijk."
	},
	recover_version: {
		"continue": "Vervolgen",
		message: "Door verder te gaan, zul je deze rapportversie terugzetten: {{date}}.<br><br>De huidige versie zal worden opgeslagen.",
		title: "Eerdere versie terugzetten"
	},
	refuse_pia: {
		content: "Aangezien u de PIA hebt afgewezen, wordt deze ter beoordeling teruggestuurd om de vereiste wijzigingen aan te brengen."
	},
	remove_attachment: {
		comment: "Commentaar",
		content: "<span class='strong'>Opgelet! </span> <br> Weet u zeker dat u deze bijlage wilt verwijderen?",
		keep: "Aanhouden",
		remove: "Verwijderen"
	},
	remove_measure: {
		content: "<span class='strong'>Opgelet! </span> <br> Weet u zeker dat u deze meting wilt verwijderen?",
		keep: "Bewaar deze <br> maatregel",
		remove: "Verwijder deze maatregel"
	},
	remove_pia: {
		content: "<span class='strong'>Opgelet,</span><br>Weet u zeker dat u deze PIA wilt verwijderen?",
		remove: "Deze PIA verwijderen"
	},
	remove_question: {
		content: "Wilt u de vraag verwijderen?",
		keep: "Annuleren",
		remove: "Verwijderen"
	},
	remove_structure: {
		content: "<span class='strong'>Opgelet!</span><br>Ben u zeker dat u <br>dit sjabloon wilt verwijderen?",
		remove: "Dit sjabloon verwijderen"
	},
	same_comment: {
		content: "<span class='strong'>Opgelet! </span> <br> Voer een andere opmerking in dan de laatst opgenomen."
	},
	signed_pia_validation: {
		content: "Bevestig het ondertekende rapport om de PIA te valideren.",
		download_pia: "Download rapport"
	},
	simple_pia_validation: {
		content: "U hebt de PIA gevalideerd."
	},
	start_evaluation: "Start review",
	unarchive_pia: {
		content: "<span class='strong'>Opgelet,</span><br>Ben je zeker dat je het archiveren <br>van deze PIA ongedaan wilt maken?",
		unarchive: "Archiveren PIA ongedaan maken"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Het serveradres werd geüpdatet."
	},
	validate_evaluation: {
		content: "Dit gedeelte is klaar voor het valideren van de PIA."
	},
	validate_evaluation_to_correct: {
		content: "Sorry, maar er zijn meerdere velden die moeten worden gecorrigeerd. <br> Keer terug naar de bewerkingsmodus om correcties aan te brengen."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$8 = {
	dashboard: {
		step1: {
			description: "Klik op <strong>+</strong> om je eerste PIA te maken.",
			title: "PIA maken"
		},
		step2: {
			description: "<p><strong>Redacteurs</strong> schrijven de eerste versie van de analyse.</p><p>Dat kan bijv. de projectmanager zijn die te maken heeft met de verwerking.</p>",
			title: "PIA rollen"
		},
		step3: {
			description: "<p><strong>Reviewers</strong> zijn betrokken bij de tweede fase.</p><p>Zij gebruiken hun juridische of technische expertise om de kwaliteit en de naleving van de verwerking te controleren.</p><p>Dat kan bijv. de DPO of de juridisch expert zijn.</p>",
			title: "PIA rollen"
		},
		step4: {
			description: "<p>De <strong>validator</strong> aanvaardt of verwerpt de implementatie van de verwerking en moet de analyse ondertekenen.</p><p>Het gaat om de verantwoordelijke, bijv. de CEO.</p>",
			title: "PIA rollen"
		},
		step5: {
			description: "<p><strong>Sjablonen</strong> zijn een geavanceerde functie. Ze worden gebruik om een vooringevulde basis voor de analyse te maken.</p><p>Je kunt sjablonen maken door naar deze sectie te gaan in het menu bovenaan.</p>",
			title: "Sjablonen"
		}
	},
	entry: {
		step1: {
			description: "Gebruik het linker navigatiemenu om van het ene deel van de analyse naar het andere te gaan.",
			title: "Verkennen"
		},
		step2: {
			description: "Dit wordt gebruikt om het doel van de verwerking toe te lichten en hoe dit zal worden geïmplemteneerd.",
			title: "Context"
		},
		step3: {
			description: "Deze zijn erop gericht ervoor te zorgen dat de verwerking conform de GDPR verloopt.",
			title: "Fundamentele principes"
		},
		step4: {
			description: "Deze beschrijven die reeds geplande beveiligingsmaatregelen voor de verwerking en laten toe de potentiële impact op de betrokkenen in te schatten.",
			title: "Risico's"
		},
		step5: {
			description: "Dit laat de DPO toe zijn of haar mening te geven over de implemtentatie van de verwerkingte geven, en de verantwoordelijke om deze te aanvaarden of verwerpen.",
			title: "Validatie"
		},
		step6: {
			description: "<p>Deze geeft contextuele ondersteuning bij het uitvoeren van de analyse en is gebaseerd op de GDPR, de beveligingsgids en de PIA-gidsen van de CNIL</p><p>Daarnaast kun je je eigen kennisbanken maken om gemakkelijk specifieke informatie over de organisatie te raadplegen.</p>",
			title: "De kennisbank"
		},
		step7: {
			description: "Je kunt de analyse op eender welk moment downloaden in verschillende formaten om ze te delen met je collega's.",
			title: "PIA exporteren"
		}
	},
	evaluation: {
		step1: {
			description: "De evaluatie kan een volledige sectie in rekening brengen, of focussen op een onderdeel van een sectie.",
			title: "PIA evalueren"
		},
		step2: {
			description: "<p>Deze evaluatie signaleert aan de redacteurs dat er elementen ontbreken om een goede beoordeling te maken.</p><p>De beoordeleaar moet deze aanduiden in het verwante <strong>evaluatie commentaar</strong> veld. De redacteur zal de nodige aanpassingen doen.</p>",
			title: "Te corrigeren"
		},
		step3: {
			description: "<p>Deze evaluatie geeft de verwerkingselementen aan die moeten worden herzien. Ze worden beschrijven in het <strong>actieplan / verbeteractie</strong> veld.</p><p>Deze maatregelen worden automatisch toegevoegd aan het actieplan-gedeelte van de analyse. Deze moeten zo snel mogelijk worden geïmplementeerd.</p>",
			title: "Te verbeteren"
		},
		step4: {
			description: "Deze evaluatie geeft aan dat dit gedeelte van de verwerking zonder aanpassingen kan worden geïmplementeerd.",
			title: "Aanvaardbaar"
		},
		step5: {
			description: "Als de evaluatie van een sectie nog niet is aangevat, kan het verzoek voor evaluatie worden geannuleerd om aanpassingen te maken aan de beschrijving van de verwerking.",
			title: "Een verzoek annuleren"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "Een volledige en gevalideerde analyse kun je op eender welk moment consulteren via de interface.",
			title: "Een gevalideerde PIA raadplegen"
		},
		step2: {
			description: "Een analyse moet regelmatig gereviewed worden. Je kunt ze op eender welk moment aanpassen of dupliceren om de inhoud te reviewen in overeenstemming met de evolutie van de verwerking.",
			title: "Een gevalideerde PIA updaten"
		}
	}
};
var opinions$8 = {
	content: ", overweegt dat:",
	dpo_lock: "Vul de andere secties in voordat u het oordeel van de DPO kunt invullen.",
	dpo_opinion: "Mening DPO",
	edit: "Bewerk",
	people_opinion: "Advies betrokken mensen",
	placeholder_concerned_people_name: "Naam/namen betrokken mensen",
	placeholder_dpo_name: "Naam/namen DPO",
	placeholder_dpo_opinion: "Geef de redenen voor uw keuze.",
	placeholder_people_opinion: "Beschrijf hoe de meningen zijn verzameld en wat de analyse is. Als de meningen niet zijn opgevraagd, vermeld dan de redenen.",
	placeholder_search_content: "Geef de reden waarom de mening van de betrokken personen niet is gevraagd.",
	treatment_lock: "Vul de andere secties in voordat u de mening van de betrokken personen kunt invullen.",
	treatment_nok: "De verwerking mag niet worden gebruikt.",
	treatment_ok: "De verwerking zou kunnen worden geïmplementeerd."
};
var pia$8 = {
	attachments: {
		add: "Toevoegen",
		download: "Bijlage downloaden",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Verwijderen",
		title: "Bijlagen",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Vraag een beoordeling",
		mandatory_fields: "Alle velden moeten worden ingevuld",
		structure_add_question: "Een vraag toevoegen",
		subsection_validated: "Subsectie beoordeeld, in afwachting van definitieve validatie",
		validate_evaluation: "Beoordeling valideren"
	},
	header: {
		display_action_plan: "Toon<br>actieplan",
		edition: "Opmaak",
		evaluation: "Evaluatie",
		preview: "Voorbeeld"
	},
	sections: {
		based_on_structure_name: "Gebaseerd op het sjabloon:",
		homepage_link: "Terug naar dashboard",
		refuse_pia: "Geweigerde AIIA",
		status: {
			evaluation: {
				cancel: "het reviewverzoek annuleren.",
				cancel_button: "Annuleer reviewverzoek",
				content: "Dit onderdeel is nog niet gereviewed. Indien u deze inhoud, die ingediend is voor review, wenst aan te passen moet u ",
				title: "Wachten op review."
			},
			validation: {
				cancel: "Het validatieverzoek annuleren.",
				cancel_button: "Annuleer het validatieverzoek",
				content: "Dit onderdeel is gereviewed en wacht op de algemene PIA validatie. Indien u de review wenst aan te passen moet u ",
				title: "Wachten op validatie."
			}
		},
		validate_pia: "PIA Valideren"
	},
	statuses: [
		"In opmaak",
		"Afgekeurd",
		"Gevalideerd (eenvoudig)",
		"Gevalideerd (ondertekend)",
		"Gearchiveerd",
		"Wacht op validatie"
	]
};
var questions$8 = {
	edit: "Vraag bewerken",
	gauges: [
		"(Niet bepaald)",
		"Verwaarloosbaar",
		"Beperkt",
		"Belangrijk",
		"Maximaal"
	],
	placeholder_title: "Title van de vraag (verplicht)",
	remove: "De vraag verwijderen"
};
var rejection_page$8 = {
	applied_adjustments: "Voorgestelde aanpassingen",
	applied_adjustments_placeholder: "Beschrijf de aanpassingen uitgevoerd aan de PIA.",
	button: {
		abandon_treatment: "Verlaat verwerking",
		reject_pia: "Verwerp AIIA",
		send_for_validation: "Opnieuw versturen voor validatie"
	},
	previous_rejection: "Vorige verwerping",
	rejection_reason: "Reden voor verwerping",
	rejection_reason_placeholder: "Beschrijf de reden voor verwerping van de PIA.",
	title: "Historiek validatie"
};
var sections$8 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Presenteer een korte schets van de verwerking: de naam, doelen, inzet, gebruikscontext, etc.",
						title: "Welke verwerking wordt overwogen?"
					},
					"2": {
						placeholder: "Beschrijf de verantwoordelijkheden van de belanghebbenden: de gegevensbeheerder, de mogelijke gegevensverwerkers en gezamenlijke verwerkingsverantwoordelijke(n).",
						title: "Welke verantwoordelijkheden zijn verbonden aan de verwerking?"
					},
					"3": {
						placeholder: "Maak een lijst van de relevante normen die van toepassing zijn op de verwerking, met name goedgekeurde gedragscodes en certificeringen van gegevensbescherming.",
						title: "Zijn er normen van toepassing op de verwerking?"
					}
				},
				short_help: "In dit deel kunt u het voorwerp van het onderzoek identificeren en uiteenzetten.",
				title: "Overzicht"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Maak een lijst van de verzamelde en verwerkte gegevens. Definieer voor elk de opslagduur, de ontvangers en personen met toegang daartoe.",
						title: "Welke gegevens worden verwerkt?"
					},
					"2": {
						placeholder: "Presenteer en beschrijf hoe het product in het algemeen werkt (van de gegevensverzameling tot de vernietiging van gegevens, de verschillende verwerkingsfasen, opslag, enz.), met behulp van bijvoorbeeld een diagram van gegevensstromen (voeg toe in bijlage) en een gedetailleerde beschrijving van de uitgvoerde processen.",
						title: "Hoe werkt de levenscyclus van gegevens en processen?"
					},
					"3": {
						placeholder: "Maak een lijst van de ondersteunende gegevens (besturingssystemen, bedrijfstoepassingen, databasebeheersystemen, kantoorsuites, protocollen, configuraties, enz.)",
						title: "Wat zijn de ondersteunende activa van de gegevens?"
					}
				},
				short_help: "In dit deel kunt u de omvang van de verwerking in detail definiëren en beschrijven.",
				title: "Gegevens, processen en ondersteunende activa"
			}
		},
		short_help: "Dit gedeelte geeft u een duidelijk beeld van de verwerking(en) van de betreffende persoonsgegevens.",
		title: "Context"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Leg uit waarom de verwerkingsdoeleinden gespecificeerd, expliciet en legitiem zijn.",
						short_title: "Doeleinden",
						title: "Zijn de verwerkingsdoeleinden gespecificeerd, expliciet en legitiem?"
					},
					"2": {
						placeholder: "Vertaling nog niet gebeurd",
						short_title: "Rechtsgrondslag",
						title: "Wat is de wettelijke basis om de verwerking rechtmatig te maken?"
					},
					"3": {
						placeholder: "Leg uit waarom elk van de verzamelde gegevens noodzakelijk is voor uw doeleinden.",
						short_title: "Adequate gegevens",
						title: "Zijn de gegevens adequaat, relevant en beperkt tot wat nodig is met betrekking tot de doeleinden waarvoor ze worden verwerkt ('gegevensminimalisatie')?"
					},
					"4": {
						placeholder: "Beschrijf welke stappen worden ondernomen om de kwaliteit van de gegevens te waarborgen.",
						short_title: "Gegevens nauwkeurigheid",
						title: "Zijn de gegevens juist en worden ze up-to-date gehouden?"
					},
					"5": {
						placeholder: "Leg uit waarom de opslagduur wordt gerechtvaardigd door wettelijke vereisten en/of verwerkingsbehoeften.",
						short_title: "Opslagduur",
						title: "Wat is de opslagduur van de gegevens?"
					}
				},
				short_help: "In dit deel kunt u de legitimiteit van uw verwerking en van de verwerkte gegevens aantonen.",
				title: "Evenredigheid en noodzakelijkheid"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Beschrijf welke informatie aan de betrokkenen wordt gegeven en met welke middelen dit gebeurt.",
						short_title: "Informatie voor de betrokkenen",
						title: "Hoe worden de betrokkenen geïnformeerd over de verwerking?"
					},
					"2": {
						placeholder: "Beschrijf de maatregelen die zijn getroffen om toestemming te verkrijgen van de betrokkenen.",
						short_title: "Verkrijgen van toestemming",
						title: "Hoe wordt de toestemming van betrokkenen verkregen?"
					},
					"3": {
						placeholder: "Beschrijf de maatregelen die bedoeld zijn om betrokkenen toegang te verlenen tot hun gegevens en deze te ontvangen en te verzenden.",
						short_title: "Recht op toegang en gegevensportabiliteit",
						title: "Hoe kunnen betrokkenen hun recht op toegang en gegevensportabiliteit uitoefenen?"
					},
					"4": {
						placeholder: "Beschrijf de maatregelen die bedoeld zijn om betrokkenen in staat te stellen hun gegevens te corrigeren en te wissen.",
						short_title: "Recht op rectificatie en verwijdering",
						title: "Hoe kunnen betrokkenen hun recht op rectificatie en verwijdering uitoefenen?"
					},
					"5": {
						placeholder: "Beschrijf de maatregelen die bedoeld zijn om betrokkenen het recht te verlenen om de de verwerking van hun gegevens te laten beperken en om bezwaar te maken tegen de verwerking van hun gegevens.",
						short_title: "Recht op beperking en bezwaar",
						title: "Hoe kunnen betrokkenen hun recht op beperking uitoefenen en bezwaar maken?"
					},
					"6": {
						placeholder: "Beschrijf voor elke verwerker zijn verantwoordelijkheden (duur, reikwijdte, doel, gedocumenteerde verwerkingsinstructies, voorafgaande toestemming) en verstrek de contracten, gedragscodes en certificeringen die zijn taken en verplichtingen bepalen.",
						short_title: "Subcontracting",
						title: "Zijn de verplichtingen van de verwerkers duidelijk geïdentificeerd en geregeld door een contract?"
					},
					"7": {
						placeholder: "Voor elk land buiten de Europese Unie waar gegevens worden opgeslagen of verwerkt, geeft u dit op en geeft u aan of wordt erkend dat dit een adequaat niveau van gegevensbescherming biedt of beschrijft u de bepalingen met betrekking tot de overdracht.",
						short_title: "Transfers",
						title: "Zijn de gegevens in het geval van gegevensoverdracht buiten de Europese Unie voldoende beschermd?"
					}
				},
				short_help: "Met dit deel kunt u aantonen dat u de nodige middelen inzet om de betrokkenen in staat te stellen om hun rechten uit te oefenen.",
				title: "Rechten van de betrokkenen"
			}
		},
		short_help: "In dit gedeelte kunt u het nalevingskader voor privacyprincipes opstellen.",
		title: "Fundamentele principes"
	},
	"3": {
		items: {
			"1": {
				short_help: "In deze sectie kunt u bestaande of geplande controlemaatregelen identificeren die bijdragen aan gegevensbeveiliging.",
				title: "Bestaande of geplande maatregelen"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Voer de potentiële gevolgen in.",
						title: "Wat kunnen de belangrijkste gevolgen voor de betrokkenen zijn als het risico zou optreden?"
					},
					"2": {
						placeholder: "Voer de bedreigingen in.",
						title: "Wat zijn de belangrijkste bedreigingen die tot het risico kunnen leiden?"
					},
					"3": {
						placeholder: "Voer de risicobronnen in.",
						title: "Wat zijn de risicobronnen?"
					},
					"4": {
						placeholder: "Klik hier om controlemaatregelen te selecteren die het risico aanpakken.",
						title: "Welke van de geïdentificeerde maatregelen dragen bij aan het aanpakken van het risico?"
					},
					"5": {
						placeholder: "Rechtvaardig hier de geschatte ernst van het risico.",
						title: "Hoe schat u de ernst van het risico, met name op basis van de potentiële effecten en geplande maatregelen?"
					},
					"6": {
						placeholder: "Rechtvaardig hier de geschatte waarschijnlijkheid.",
						title: "Hoe schat u de waarschijnlijkheid van het risico, vooral met betrekking tot bedreigingen, risicobronnen en geplande maatregelen?"
					}
				},
				short_help: "Analyseer de oorzaken en gevolgen van onrechtmatige toegang tot gegevens en schat de ernst en waarschijnlijkheid ervan in.",
				title: "Onrechtmatige toegang tot gegevens"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Voer de potentiële gevolgen in",
						title: "Wat kunnen de belangrijkste gevolgen voor de betrokkenen zijn als het risico zou optreden?"
					},
					"2": {
						placeholder: "Voer de bedreigingen in",
						title: "Wat zijn de belangrijkste bedreigingen die tot het risico kunnen leiden?"
					},
					"3": {
						placeholder: "Voer de risicobronnen in",
						title: "Wat zijn de risicobronnen?"
					},
					"4": {
						placeholder: "Klik hier om controlemaatregelen te selecteren die het risico aanpakken.",
						title: "Welke van de geïdentificeerde controles dragen bij aan het aanpakken van het risico?"
					},
					"5": {
						placeholder: "Rechtvaardig hier de geschatte ernst van het risico.",
						title: "Hoe schat u de ernst van het risico, met name op basis van de potentiële effecten en geplande controles?"
					},
					"6": {
						placeholder: "Rechtvaardig hier de geschatte waarschijnlijkheid.",
						title: "Hoe schat u de waarschijnlijkheid van het risico, vooral met betrekking tot bedreigingen, risicobronnen en geplande controles?"
					}
				},
				short_help: "Analyseer de oorzaken en gevolgen van een ongewenste wijziging van de gegevens en schat de ernst en waarschijnlijkheid ervan in.",
				title: "Ongewenste wijziging van gegevens"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Voer de potentiële gevolgen in",
						title: "Wat kunnen de belangrijkste gevolgen voor de betrokkenen zijn als het risico zou optreden?"
					},
					"2": {
						placeholder: "Voer de bedreigingen in",
						title: "Wat zijn de belangrijkste bedreigingen die tot het risico kunnen leiden?"
					},
					"3": {
						placeholder: "Voer de risicobronnen in",
						title: "Wat zijn de risicobronnen?"
					},
					"4": {
						placeholder: "Klik hier om controlemaatregelen te selecteren die het risico aanpakken.",
						title: "Welke van de geïdentificeerde controles dragen bij aan het aanpakken van het risico?"
					},
					"5": {
						placeholder: "Rechtvaardig hier de geschatte ernst van het risico.",
						title: "Hoe schat u de ernst van het risico, met name op basis van de potentiële effecten en geplande controles?"
					},
					"6": {
						placeholder: "Rechtvaardig hier de geschatte waarschijnlijkheid.",
						title: "Hoe schat u de waarschijnlijkheid van het risico, vooral met betrekking tot bedreigingen, risicobronnen en geplande controles?"
					}
				},
				short_help: "Analyseer de oorzaken en gevolgen van gegevensverlies en schat de ernst en waarschijnlijkheid ervan in.",
				title: "Verdwijnen van gegevens"
			},
			"5": {
				short_help: "Met deze visualisatie kunt u een globaal en synthetisch beeld hebben van de effecten van de besturing op de risico's die zij aanpakken.",
				title: "Overzicht risico's"
			}
		},
		short_help: "In dit gedeelte kunt u de privacyrisico's beoordelen, rekening houdend met bestaande of geplande controles.",
		title: "Risico's"
	},
	"4": {
		items: {
			"1": {
				short_help: "Met deze visualisatie kunt u de positionering van de risico's onderling vergelijken, voor en na toepassing van de aanvullende maatregelen.",
				title: "Risicokaart"
			},
			"2": {
				short_help: "Plan in detail de implementatie van de extra maatregelen die werden geïdentificeerd tijdens de PIA.",
				title: "Actieplan"
			},
			"3": {
				short_help: "Presenteer het advies van de persoon die verantwoordelijk is voor gegevensbescherming en privacykwesties (afgevaardigde gegevensbescherming indien aanwezig). Presenteer de standpunten van de betrokkenen of hun vertegenwoordigers.",
				title: "Mening van DPO en betrokkenen"
			},
			"4": {
				title: "Valideer de PIA"
			},
			"5": {
				title: "Weiger de PIA"
			}
		},
		short_help: "In dit gedeelte kunt u de PIA-validatie voorbereiden en formaliseren.",
		title: "Validatie"
	}
};
var settings$8 = {
	content: "Geef het adres (de URL) op van de externe server:",
	title: "Instellingen",
	update: "URL bijwerken"
};
var summary$8 = {
	action_plan: {
		fundamental_principles: "Fundamentele principes",
		implementation_date: "Verwachte datum van implementatie",
		implementation_responsible: "Verantwoordelijk voor implementatie",
		measures: "Bestaande of geplande maatregelen",
		no_action_plan: "Geen actieplan vastgelegd.",
		risks: "Risico's",
		title: "Actieplan"
	},
	actions: {
		complete_download: "Volledig verslag downloaden",
		complete_download_desc: "Exporteer in een .zip-archief de volledige inhoud van het verslag (.doc en afbeeldingen), de bijlagen en het actieplan in .csv-formaat.",
		individual_download: "Alle elementen van het verslag downloaden",
		individual_download_desc: "Bepaalde elementen van het verslag exporteren.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "Teksten (.doc)",
		individual_download_images: "Visuele elementen (.png) waaronder het risico-overzicht, de risico-mapping en het actieplan.",
		individual_download_json: "Rapport om in de PIA tool te importeren (.json)",
		individual_download_select: "Te exporteren elementen selecteren:",
		individual_to_download: "Downloaden",
		print: "Verslag afdrukken",
		print_and_download: "Afdrukken en downloaden"
	},
	attachments: "Bijlagen",
	concerned_people_name: "Namen van betrokken mensen",
	concerned_people_opinion: "Meningen van betrokken mensen",
	concerned_people_searched_opinion: "Zoeken naar de mening van betrokken mensen",
	concerned_people_status: "Statussen van betrokken mensen",
	concerned_people_unsearched_opinion_comment: "Reden waarom de mening van betrokken mensen niet werd gevraagd",
	content_choice: [
		"De verwerking mag niet gebeuren.",
		"De verwerking zou kunnen worden geïmplementeerd."
	],
	creation_date: "Aanmaakdatum",
	csv_action_plan_comment: "Commentaar actieplan",
	csv_evaluation_comment: "Evaluatie commentaar",
	csv_file_title: "actieplan",
	csv_implement_date: "Geschatte implementatiedatum",
	csv_people_in_charge: "Leidinggevende",
	csv_section: "Sectie",
	csv_title_object: "Titel",
	download_csv: "Actieplan (.csv)",
	dpo_name: "naam DPO",
	dpo_opinion: "mening DPO",
	dpo_status: "status DPO",
	gauges: {
		"1": "Verwaarloosbaar",
		"2": "Beperkt",
		"3": "Belangrijk",
		"4": "Maximaal"
	},
	modification_made: "Aanpassingen aangebracht",
	people_search_status_nok: "Mening van betrokken mensen werd niet gevraagd.",
	people_search_status_ok: "Mening van betrokken mensen werd gevraagd.",
	pia_assessor: "Naam van de beoordelaar",
	pia_author: "Auteursnaam",
	pia_name: "PIA",
	pia_validator: "Naam validator",
	preview_dpo_opinion: "Mening van DPO en betrokkenen",
	preview_edition: "Redactie",
	preview_evaluation: "Reviewen",
	preview_no_data: "Geen gegevens weer te geven.",
	preview_status: "Status",
	preview_subtitle: "Algemene informatie",
	preview_title: "Preview",
	preview_validation: "Valideren",
	preview_validation_section: "Validatie",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Terug naar de vorige pagina",
	rejection_reason: "Reden van verwerping",
	revision: {
		current_version: "Huidige versie",
		pia_version: "PIA versies",
		restore_version: "Terugzetten",
		revision: "Versies en herziening",
		save: "Nieuwe versie maken",
		show: "De {{length}} versies weergeven"
	},
	risks_cartography_title: "Risicokaart",
	risks_overview_title: "Overzicht risico's",
	title: "PIA informatie"
};
var users$8 = {
	add_new_user: "Nieuwe gebruiker toevoegen",
	cancel: "Annuleren",
	choose_profile: "Kies een profiel voor deze gebruiker",
	"continue": "Verdergaan",
	data: "Gegevens",
	edit_user: "Gebruiker aanpassen",
	email: "E-mailadres",
	first_name: "Voornaam",
	functional_admin: "Functioneel beheerder",
	last_name: "Naam",
	new_user_button: "Nieuwe gebruiker",
	profile: "Profiel",
	remove: "Verwijderen",
	remove_current_user_error_message: "Je kunt je eigen account niet verwijderen.",
	remove_last_functional_admin_error_message: "Je kunt deze gebruiker niet verwijderen omdat er tenminste één technisch beheerder account moet zijn.",
	remove_user_with_linked_pias_error_message: "Je kunt deze gebruiker niet verwijderen omdat er meerdere PIA's aan gelinkt zijn.",
	technical_admin: "Technisch beheerder",
	update: "Updaten",
	user: "Gebruiker",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "Gebruiker verwijderen",
		content: "Ben je zeker dat je deze gebruiker wilt verwijderen?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$8 = {
	add_signed_pia: "Voeg de ondertekende PIA toe",
	after_reading: "Na het lezen van de volledige PIA betreffende de gegevensverwerking gelinkt aan ",
	button: {
		rejection: "PIA verwerpen",
		signed_validation: "PIA valideren <br>(ondertekenen)",
		simple_validation: "PIA valideren <br>(eenvoudig)"
	},
	confirmation1: "Ik erken ik dat de context van de verwerking beschreven in de PIA overeenstemt met de werkelijkheid.",
	confirmation2: "Ik erken ik dat ik bewust ben van de risico's gebaseerd op de bestaande en de te implementeren maatregelen.",
	confirmation3: "Ik bekrachtig de corrigerende acties die in het actieplan zijn aangegeven.",
	confirmation4: "Ik verbind mij ertoe om de aangegeven corrigerende maatregelen zo snel mogelijk te implementeren.",
	latest_signed_attachment: "Laatst ondertekende bijlage",
	mandatory_fields: "Alle checkboxen moeten aangevinkt zijn",
	remove_attachment: "Verwijder de bijlage",
	responsible: "Verantwoordelijke voor de validatie van de PIA: ",
	signed_attachments_history: "Historiek ondertekende bijlages",
	tools: {
		dashboard: "Dashboard",
		display_pia: "Toon PIA"
	},
	validated_pia_with_signature: "Gevalideerd (ondertekend)",
	waiting_for_signature: "Wachten op ondertekende PIA"
};
var nl = {
	about: about$8,
	action_plan: action_plan$8,
	authentication: authentication$8,
	cartography: cartography$8,
	comments: comments$8,
	conflict: conflict$8,
	date: date$8,
	errors: errors$8,
	evaluations: evaluations$8,
	header: header$8,
	help: help$8,
	homepage: homepage$8,
	knowledge_base: knowledge_base$8,
	measures: measures$8,
	misc: misc$8,
	modals: modals$8,
	onboarding: onboarding$8,
	opinions: opinions$8,
	"overview-risks": {
	important: "Belangrijk",
	limited: "Beperkt",
	maximal: "Maximaal",
	measures: "Measures",
	negligible: "Verwaarloosbaar",
	potential_impacts: "Potientiële impacten",
	"risk-access_x": "Ernst",
	"risk-access_y": "Waarschijnlijkheid",
	"risk-change_x": "Ernst",
	"risk-change_y": "Waarschijnlijkheid",
	"risk-disappearance_x": "Ernst",
	"risk-disappearance_y": "Waarschijnlijkheid",
	sources: "Bronnen",
	threat: "Bedreiging"
},
	pia: pia$8,
	questions: questions$8,
	rejection_page: rejection_page$8,
	sections: sections$8,
	settings: settings$8,
	summary: summary$8,
	users: users$8,
	validation_page: validation_page$8
};

var about$7 = {
	contribute: "If you wish to contribute to the translation of the software in another language or improve the existing translations, we recommend you to read <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">this page</a> describing the steps to follow.",
	description: "This tool is originally designed by the <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, the French Data Protection Authority, to help data processor to be compliant with the GDPR. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>This software is free and open. If you wish to get involved in this project, you are welcome to download the source code from Github, modify it and share it with the community.",
	licences: "Library licences:",
	title: "About the Tool AIIA",
	translators: "The PIA software is currently available in eighteen languages. The French and English versions are provided by the CNIL. The others versions result from the contributions of the following individuals:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Version number"
};
var action_plan$7 = {
	acceptable_measures: "Acceptable measures",
	edit: "Edit",
	improvable_measures: "Improvable measures",
	measures: "Existing or planned measures",
	no_action_plan: "No action plan recorded.",
	placeholder_person_in_charge: "Implementation responsible",
	principles: "OBLIGATIONS & RESPONSIBILITIES",
	risk1: "Illegitimate access to data",
	risk2: "Unwanted modification of data",
	risk3: "Data disappearance",
	risks: "Risks",
	title: "Nature, scope, context, purpose"
};
var authentication$7 = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Denne programvaren fra den <strong>franske databeskyttelsesmyndigheten (CNIL)</strong> er ment å hjelpe databehandlingsansvarlig å behandle personopplysninger i overenstemmelse med GDPR. Programvaren er ment som en hjelp i vurderingen av personvernkonsekvenser (DPIA) gjennom å fasilitere for bruk av PIA-metodikken utviklet av CNIL.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	start: "Start",
	start_app: "Tilgang til PIAs programvare (Beta)",
	subtitle1: "Et program for å opprette <br> og administrere AIIA",
	number: "TO TRANSLATE - Number",
	subtitle2: "Tilgang til verktøy og ordlister",
	title: "Vurdering av personvernkonsekvenser",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$7 = {
	important: "Important",
	legend1: "Existing or planned measures",
	legend2: "With the corrective measures implemented",
	legend3: "(I)llegitimate access to data",
	legend4: "(U)nwanted modification of data",
	legend5: "(D)ata disappearance",
	likelihood_axe: "Risk likelihood",
	limited: "Limited",
	maximal: "Maximum",
	negligible: "Negligible",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Risk seriousness"
};
var comments$7 = {
	comment: "Comment",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "comment(s)",
	new_comment: "Comment",
	placeholder_new_comment: "Leave a comment",
	send: "Send"
};
var conflict$7 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$7 = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$7 = {
	content: "If you encounter other problems or if you have suggestions for improvement,<br>you can send them back via this form: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Page not found."
};
var evaluations$7 = {
	acceptable: "Acceptable",
	action_plan_comment: "Action plan / corrective actions",
	evaluation_comment: "Evaluation comment",
	gauges: {
		"0": "(Undefined)",
		"1": "Negligible",
		"2": "Limited",
		"3": "Important",
		"4": "Maximum",
		likelihood: "Taking into account the action plan, how do you re-evaluate the <span class='red-highlight'>likelihood of this risk</span>?",
		seriousness: "Taking into account the action plan, how do you re-evaluate the <span class='red-highlight'>seriousness of this risk</span>?"
	},
	improvable: "Improvable",
	placeholder_acceptable: "TO BE TRANSLATED - According to the available information, the measures implemented are adequate to properly meet the requirements for protecting the data.",
	placeholder_improvable1: "TO BE TRANSLATED - According to the available information, additional measures are to be implemented in order to improve the data protection of the processing.",
	placeholder_improvable2: "TO TRANSLATE - Enter your comments.",
	placeholder_to_correct: "TO BE TRANSLATED - The information provided are not sufficient to properly evaluate them. Send back to the editor to improve the original submission.",
	status: [
		"Pending",
		"To correct",
		"Improvable",
		"Acceptable"
	],
	title: "Evaluation",
	to_correct: "To correct"
};
var header$7 = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Eksempel på vurdering av personvernkonsekvenser",
		title: "Hjelp"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Kunnskapsdatabase",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "TO BE TRANSLATED - CNIL provided translations",
		community_translations: "TO BE TRANSLATED - Community provided translations",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "TO BE TRANSLATED - Translation revised by European DPA",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "TO BE TRANSLATED - Original version",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "Vurdering av personvernkonsekvenser",
	logo_title: "PIA",
	structures: "PIA templates",
	tools: {
		about: "Om",
		accessibility: "Tilgjengelighet for synshemmede (høykontrastfarger, daltonisme)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Innstillinger",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$7 = {
	definition: {
		data1: {
			content: "Content being written",
			title: "Use the PIA tool"
		},
		data2: {
			qa1: {
				content: "When encountering those display issues, close the application and reload it. It usually fixes the issue. You won’t lose the information you have entered ; it is  automatically saved as you type.",
				title: "I get display issues such as icons being stuck in one state or missing elements from the interface"
			},
			qa2: {
				content: "This known issue is currently being fixed. If you encounter this problem, we recommend that you fill in the justification field of the estimated level of severity and / or likelihood. You will be able to edit the gauge once the bug is fixed.",
				title: "I can’t edit the gauges for evaluating the severity and likelihood of a risk"
			},
			qa3: {
				content: "Several bugs have been observed when importing a PIA, and in particular the level gauges for evaluating the severity and likelihood of a risk may disappear. In this case, please refer to the above mentioned issue. Besides, a PIA may not appear on the dashboard after importing it. This is a display issue and you just need to refresh the page.",
				title: "I encounter issues when importing a PIA"
			},
			qa4: {
				content: "This is only a display bug and it has no effect on the text you enter in a field. This visual problem will be fixed soon.",
				title: "When I copy / paste text, it is highlighted."
			},
			qa5: {
				content: "In order to evaluate a section, it is mandatory to fill in all the fields. Please check if this is the case. When editing a risk, you must have at least one technical or organizational measure that mitigates the risk in order to ask for an evaluation of the risk.",
				title: "I can’t evaluate a section"
			},
			qa6: {
				content: "Please close the PIA you are editing and re-open it. The content should then be displayed in the language you have selected.",
				title: "When switching language, the texts are not translated"
			},
			qa7: {
				content: "For the moment, the navigation menu icons are not refreshed after refusing a PIA. You have to check each section and change the information and/or evaluation according to the reasons for refusing the PIA. Once all section have been reviewed, you should be able to request PIA validation again.",
				title: "I have refused to validate a PIA but I don’t know what to do now"
			},
			title: "Known Issues"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Help"
};
var homepage$7 = {
	cards: {
		author: "Forfatter",
		category: "TO TRANSLATE - Category",
		creation_status: "Opprettelse",
		date: "Dato",
		evaluation: "Saksbehandling",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Importer AIIA",
		import_structure: "TO TRANSLATE - Import template",
		item: {
			consult_pia: "TO TRANSLATE - Consult",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Regiger",
			edit_structure: "TO TRANSLATE - Edit template",
			tools: {
				action_plan: "Vis<br>handlingsplan",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Dupliser",
				"export": "Eksporter",
				more_options: "Flere valg",
				pia: "Vis<br>PIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Ny AIIA",
		new_structure: "TO TRANSLATE - New template",
		or: "or",
		pia_name: "PIA",
		placeholder_author: "Fornavn, etternavn",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Fornavn, etternavn",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Importer AIIA",
		placeholder_import_structure: "TO TRANSLATE - Import template",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Ny AIIA",
		placeholder_new_structure: "TO TRANSLATE - New template",
		placeholder_pia_name: "PIA-tittel",
		placeholder_sector_name: "TO TRANSLATE - Associated sector's name",
		placeholder_start: "Alle felt må fylles ut",
		placeholder_structure: "TO TRANSLATE - Default template",
		placeholder_structure_name: "TO TRANSLATE - Template's title",
		placeholder_validation: "Fornavn, etternavn",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		start: "Start",
		status: "Status",
		structure: "TO TRANSLATE - Template",
		structure_name: "TO TRANSLATE - Template's name",
		title_close_creation: "Lukk",
		validation: "Forankring"
	},
	filters: {
		assessor: "Saksbehandler",
		author: "Forfatter",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Kom i gang !<br><br>For å starte en PIA,<br> klikk på Ny AIIA",
		card_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous !<br><br>Pour commencer<br>un modèle, cliquez<br> sur le +",
		category: "TO TRANSLATE - Category",
		date: "Dato",
		import_pia: "Importer AIIA",
		import_structure: "TO BE TRANSLATED - Importer modèle",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Kom i gang ! For å starte <br>en PIA, klikk på +",
		list_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous ! Pour commencer<br>un modèle, cliquez sur le +",
		name: "Navn",
		new_pia: "Ny AIIA",
		new_structure: "TO BE TRANSLATED - Nouveau modèle",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		sort: "Sorter",
		sort_by: "etter",
		status: "Status",
		validator: "Ansvarlig"
	},
	lists: {
		column_actions: "Handlinger",
		column_author: "Rediger",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Opprettet",
		column_evaluation: "Evaluer",
		column_pia: "PIA",
		column_progression: "Fremgang",
		column_sector_name: "TO TRANSLATE - Associated sector",
		column_status: "Status",
		column_structure: "TO TRANSLATE - Template",
		column_structure_name: "TO TRANSLATE - Template",
		column_updated_at: "Sist åpnet",
		column_validation: "Valider",
		item: {
			tools: {
				action_plan: "Vis handlingsplan",
				archive: "TO TRANSLATE - Archive",
				consult: "TO BE TRANSLATED - Consult",
				duplicate: "Dupliser",
				edit: "Rediger",
				"export": "Eksporter",
				pia: "Vis AIIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$7 = {
	add_measure: "Legg til",
	add_measure_hint: "Du kan også legge til tiltak fra kunnskapsbasen.",
	category: {
		definition: "Definisjon",
		example: "Eksempel",
		general_measure: "Fysisk informasjonssikkerhet",
		measure_on_data: "Teknisk informasjonssikkerhet",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Styringssystemer",
		principle: "Prinsipp"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Alle",
		definitions: "Definisjoner",
		general_measures: "Fysisk informasjonssikkerhet",
		measures_on_data: "Teknisk informasjonssikkerhet",
		no_result: "Ingen resultater funnet.",
		organizational_measures: "Styringssystemer",
		title: "Filtre"
	},
	placeholder_add_measure: "Legg til dette tiltaket",
	placeholder_help: "Hjelpemiddel",
	search: "Søk",
	slugs: {
		PIA_DEF_ACC: {
			description: "The data subject shall have the right to obtain from the controller confirmation as to whether or not personal data concerning him or her are being processed, and, where that is the case, access to the personal data and the information described in <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 of [GDPR]</a>",
			name: "Right of access",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Process removing the identifying characteristics from personal data. To assess the robustness of an anonymisation processes, see the <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Anonymisation",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Procedures preserving and managing the electronic archives containing the personal data intended to ensure their value (specifically, their legal value) throughout the entire period necessary (transfer, storage, migration, accessibility, elimination, archiving policy, protection of confidentiality, etc.).",
			name: "Archiving",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Every person with legitimate access to personal data (employees, contracting parties and other third parties) should be identified by a unique identifier. Choose an authentication method to open sessions that is appropriate to the context, the risk level and the robustness expected. Recommendations: if the risks are not elevated, a password may be used; however, if the risks are higher, use a one-time password token but change the default activation password, or, when part of the password is sent by SMS, a card with a PIN code, an electronic certificate or any other form of strong authentication.",
			name: "Authentication",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Measure making personal data unintelligible to anyone without access authorization (symmetric or asymmetric encryption, use of public algorithms known to be strong, authentication certificate, etc.).",
			name: "Encryption",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Data organisation methods that reduce the possibility that personal data can be correlated and that a breach of all personal data may occur. For instance, by identifying the personal data useful only to each business process and logically separating them.",
			name: "Data partitioning",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Any freely given, specific, informed and unambiguous indication of the data subject's wishes by which he or she, by a statement or by a clear affirmative action, signifies agreement to the processing of personal data relating to him or her.<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.10 of [GDPR]</a>",
			name: "Consent",
			source: "GDPR Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Means implemented to limit the risks that unauthorized persons will access personal data electronically, it requires among other things to : <br>- <strong>manage users' profiles</strong> by separating tasks and areas of responsibility (preferably in centralised fashion) to limit access to personal data exclusively to authorised users by applying need-to-know and least-privilege principles;<br>- <strong>withdraw the rights of employees, contracting parties and other third parties when they are no longer authorised to access a premises or a resource</strong> or when their <strong>employment contract ends</strong>.",
			name: "Logical access controls",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Any information relating to an identified or identifiable natural person (‘data subject’); an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.1 of [GDPR]</a>",
			name: "Personal data",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Natural or legal person, public authority, agency or another body, to which the personal data are disclosed, whether a third party or not. However, public authorities which may receive personal data in the framework of a particular inquiry in accordance with Union or Member State law shall not be regarded as recipients; the processing of those data by those public authorities shall be in compliance with the applicable data protection rules according to the purposes of the processing. <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.9 of [GDPR]</a>",
			name: "Recipient",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: " The data subject shall have the right to obtain from the controller the erasure of personal data concerning him or her without undue delay and the controller shall have the obligation to erase personal data without undue delay, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 17 of [GDPR]</a>",
			name: "Right to erasure",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Expected benefits (for the organisation, for the data subjects, for society in general, etc.).",
			name: "Stakes",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Personal data shall be accurate and, where necessary, kept up to date; every reasonable step must be taken to ensure that personal data that are inaccurate, having regard to the purposes for which they are processed, are erased or rectified without delay (‘accuracy’). <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 d) of [GDPR]</a>",
			name: "Quality of data",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Severity represents the magnitude of a risk. It primarily depends on the prejudicial nature of the potential impacts.",
			name: "Severity",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "The data subject shall have the right to obtain from the controller restriction of processing, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 18 of [GDPR]</a>",
			name: "Right to restricting of processing",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Set up a logging architecture to allow early detection of incidents involving personal data and to have information that can be used to analyze them or provide proof in connection with investigations.",
			name: "Surveillance",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Procedure comprising one or more individual actions on data supporting assets. It is used, intentionally or otherwise, by risk sources and may cause a feared event.",
			name: "Threat",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Threats regarding: - <strong>Hardware</strong>, used inappropriately, observed, altered, lost (use or transportation of sensitive hardware for personal purposes, watching a person's screen without their knowledge while on the train, tracking by a hardware-based key logger, etc.)<br> - <strong>Software</strong>, used inappropriately, observed, altered (raising of privileges, collection of configuration data, infection by malicious code, etc.)<br>- <strong>Computer channels</strong> observed (Interception of Ethernet traffic, etc.)<br>- <strong>People</strong>, observed, manipulated, lost (Unintentional disclosure of information, social engineering, assignment changes)<br>- <strong>Paper documents</strong> observed, lost (reading, theft of mail, etc.)<br>- <strong>Paper transmission channels</strong> observed (reading of signature books in circulation, etc.)",
			name: "Threats that can lead to an illegitimate access",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Threats regarding : </strong><br>- <strong>Hardware</strong> : used inappropriately, overloaded, altered, damaged, lost (storage unit full, processing capacity overload, addition of incompatible hardware resulting in malfunctions,  fire, theft or loss of an asset, etc.)<br>- <strong>Software</strong> : used inappropriately, overloaded, altered, damaged, lost (erasure of data, exceeding of database size, logic bomb, non-renewal of the licence for software used to access data, etc.)<br>- <strong>Computer channels</strong> : overloaded, altered, lost (unauthorised downloading, loss of Internet connection, etc.)<br>- <strong>People</strong> : overloaded, damaged, lost (poor use of skills, disease, retirement, etc.)<br>- <strong>Paper documents</strong> : used inappropriately, damaged, lost (erasure, aging of archived documents, theft or loss of documents, etc.)<br>- <strong>Paper transmission channels</strong> : overloaded, damaged, altered, lost (mail delivery halted by a strike, reassignment of offices or premises, loss of a document delivery company, reorganisation of paper transmission channels, etc.)",
			name: "Threats that can lead to a disappearance of personal data",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Threats regarding : </strong><br>- <strong>Hardware</strong> altered (addition of incompatible hardware resulting in malfunctions, removal of essential components, etc.)<br>- <strong>Software</strong> used inappropriately or altered (Unwanted modifications to data in databases, operator errors that modify data, etc.)<br>- <strong>Computer channels</strong> used inappropriately (resending of intercepted data, etc.)<br>- <strong>People</strong> overloaded or manipulates (assignment of staff to tasks beyond their abilities, stress or negative changes in working conditions, influence, etc.)<br>- Paper documents that have been altered (changes to figures in a file, replacement of an original by a forgery, etc.)<br>- <strong>Paper transmission channels</strong> that have been altered (change from one signature book to another, sending of multiple conflicting documents, etc.)",
			name: "Threats that can lead to an unwanted modification of personal data",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "To be chosen among those available in section \"Existing or planned measures\", which you may complete if needed.",
			name: "Measures",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "When data are being imported, different types of metadata (such as EXIF data with an image file attached) can unintentionally be collected. <br>Such metadata must be identified and eliminated if they are unnecessary for the purposes specified.",
			name: "Filtering and removal",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Once sensitive data have been received, as part of a series of general information or transmitted for statistical purposes only, these can be converted into a less sensitive form or pseudonymised. For example : <br>- if the system collects the IP address to determine the user's location for a statistical purpose, the IP address can be deleted once the city or district has been deduced<br>- if the system receives video data from surveillance cameras, it can recognise people who are standing or moving in the scene and blur them<br>- if the system is a smart meter, it can aggregate the use of energy over a certain period, without recording it in real time",
			name: "Reducing sensitivity via conversion",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "The system can ensure that: <br>- the user can use a resource or service without the risk of disclosing his/her identity (anonymous data)<br>- the user can use a resource or service without the risk of disclosing his/her identity, but remain identifiable and responsible for this use (pseudonymous data)<br>- the user can make multiple uses of resources or services without the risk of these different uses being linked together (data cannot be correlated)<br>- the user can use a resource or service without the risk of others, third parties in particular, being able to observe that the resource or service is being used (non-observability)<br>The choice of a method from the list above must be made on the basis of the threats identified. For some types of threat to privacy, pseudonymization will be more appropriate than anonymisation (for example, if there is a traceability need). In addition, some threats to privacy will be addressed using a combination of methods.",
			name: "Reducing the identifying nature of data",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "The system can be organised into independent parts with separate access control functions. The data can also be divided between these independent sub-systems and controlled by each sub-system using different access control mechanisms. If a sub-system is compromised, the impacts on all of the data can thus be reduced.",
			name: "Reducing data accumulation",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "The system can limit data access according to the \"need to know\" principle. The system can separate the sensitive data and apply specific access control policies. The system can also encrypt sensitive data to protect their confidentiality during transmission and storage. Access to temporary cookies which are produced during the data processing must also be protected.",
			name: "Restricting data access",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Reduce the severity of risks by limiting the amount of personal data to what is strictly necessary to achieve a defined purpose, otherwise the data shall be not collected.",
			name: "Minimising the amount of personal data",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "TO BE TRANSLATED - Reduce the severity of risks by minimizing the data themselves, by taking measures aimed at reducing their sensitivity such as filtering and removing unnecessary data, pseudonymising data, etc.",
			name: "TO BE TRANSLATED - Minimization of data themselves",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "The data subject shall have the right to object, on grounds relating to his or her particular situation, at any time to processing of personal data concerning him or her, pursuant to <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 21 of [GDPR]</a>",
			name: "Right to object",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Measures taken to integrate the protection of personal data in all new processing operations (trusted names, guidelines, CNIL methodology for risk management or other internal methodology).",
			name: "Project Management",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Persons to whom the data covered by the processing relate.",
			name: "Data subject",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " The data subject shall have the right to receive the personal data concerning him or her, which he or she has provided to a controller, in a structured, commonly used and machine-readable format and have the right to transmit those data to another controller without hindrance from the controller to which the personal data have been provided, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 20 of [GDPR]</a>",
			name: "Right to data portability",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Processing of personal data in such a manner that the personal data can no longer be attributed to a specific data subject without the use of additional information, provided that such additional information is kept separately and is subject to technical and organisational measures to ensure that the personal data are not attributed to an identified or identifiable natural person.<br>Pseudonymisation  reduces  the  linkability  of  a  dataset  with  the  original  identity  of  a  data subject; as such, it is a useful security measure but not a method of anonymisation.",
			name: "Pseudonymisation",
			source: "GDPR Art. 4.5 and guidelines G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Passwords shall be composed of a minimum of eight characters; must be renewed if there is the least concern that they may have been compromised and, possibly, periodically (every six months or once a year) and must include a minimum of three of the four kinds of characters (capital letters, lower case letters, numerals and special characters); when a password is changed, the last five passwords may not be reused; the same password should not be used for different accesses; passwords should not be related to one's personal information (including name or date of birth.). Define a maximum number of attempts beyond which a warning is issued and authentication is blocked (temporarily or until it is manually unblocked).",
			name: "Password",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "The data subject shall have the right to obtain from the controller without undue delay the rectification of inaccurate personal data concerning him or her. Taking into account the purposes of the processing, the data subject shall have the right to have incomplete personal data completed, including by means of providing a supplementary statement.",
			name: "Right to rectification",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Regulation on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC.",
			name: "GDPR (General Data Protection Regulation",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Natural or legal person, public authority, agency or other body which, alone or jointly with others, determines the purposes and means of the processing of personal data; where the purposes and means of such processing are determined by Union or Member State law, the controller or the specific criteria for its nomination may be provided for by Union or Member State law.<br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.7 of [GDPR]</a>",
			name: "Controller",
			source: "GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Person or non-human source that can cause a risk. This source may act accidentally or deliberately.",
			name: "Risk source",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Natural or legal person, public authority, agency or other body which processes personal data on behalf of the controller, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 of [GDPR]</a>.<br>The processor and any person acting under the authority of the controller or of the processor, who has access to personal data, shall not process those data except on instructions from the controller, unless required to do so by Union or Member State law, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 29 of [GDPR]</a>.",
			name: "Processor",
			source: "GDPR Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Asset on which personal data rely. This may be hardware, software, networks, people, paper or paper transmission channels",
			name: "Supporting assets",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Breach of security leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, personal data transmitted, stored or otherwise processed.",
			name: "Personal data breach",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Likelihood expresses the possibility of a risk occurring. It primarily depends on the level of vulnerabilities of the supporting assets when under threat and the level of capabilities of the risk sources to exploit them.",
			name: "Likelihood",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Identification data</strong> : Civil status, identity, age, etc. <br><strong>Personal life</strong> : living habits, marital status, etc. <br><strong>Professional life </strong> : résumé, education and professional training, awards, etc. <br><strong>Connection data </strong> : IP addresses, event logs, etc.<br><strong>Location data</strong> : travels, GPS data, GSM data, etc.<br><strong>Others</strong> : phone number, email address, etc.",
			name: "Common personal data",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Philosophical, political, religious and trade-union views, sex life, health data, racial or ethnic origin, data concerning health or sex life, offenses, convictions, security measures, see <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Convictions and sensitive personal data"
		},
		PIA_EX_DCPS: {
			description: "Social security number (NIR), biometric data, bank data",
			name: "Personal data perceived as sensitive"
		},
		PIA_EX_HUME: {
			description: "It could be either:<br>- a rogue or naive neighbor, by having a physical proximity, hacking into the device's data;<br>- a hacker targeting a user by using the knowledge he/she has of the user and some of the information concerning him/her;<br>- a hacker targeting one of the companies by using the knowledge he/she has of the companies that can undermine their image;<br>- an authorised third party company using its privileged access to illegitimately access information.",
			name: "External human sources"
		},
		PIA_EX_HUMI: {
			description: "It could be either:<br>- a negligent or rogue employee, proximity of the system, skills, privileges and available time are potentially high, possible lack of training and awareness<br>- negligent or rogue user, family member or friend having access to the service.<br> Various motives are possible, including : clumsiness, error, negligence game, malicious intent, revenge, spying",
			name: "Internal human sources"
		},
		PIA_EX_IMPI: {
			description: "Data subjects may encounter significant consequences, which they should be able to overcome albeit with real and serious difficulties. For example: <br>- physical : serious physical ailments causing long-term harm (worsening of health due to improper care, or disregard of contraindications), lteration of physical integrity for example following an assault, an accident at home, work, etc.<br>- material : misappropriation of money not compensated, targeted, unique and non-recurring, lost opportunities  (home loan, refusal of studies, internships or employment, examination ban), loss of housing, loss of employment, etc.;<br>- moral : serious psychological ailments (depression, development of a phobia), feeling of invasion of privacy with irreversible damage, victim of blackmailing, cyberbullying and harassment, etc.",
			name: "Significant impact"
		},
		PIA_EX_IMPL: {
			description: "Data subjects may encounter significant inconveniences, which they will be able to overcome despite a few difficulties. For example:<br>- physical : minor physical ailments (minor illness due to disregard of contraindications), defamation resulting in physical or psychological retaliation, etc.;<br>- material : unanticipated payments (fines imposed erroneously), denial of access to administrative or commercial services, receipt of unsolicited targeted mailings likely to damage the reputation of data subjects, etc.;<br>- moral : minor but objective psychological ailments, feeling of invasion of privacy without irreversible damage, intimidation on social networks, etc.",
			name: "Limited impact"
		},
		PIA_EX_IMPM: {
			description: "Data subjects may encounter significant, or even irreversible, consequences, which they may not overcome. For example:<br>- physical : long-term or permanent physical ailments, permanent impairment of physical integrity, death;<br>- material : financial risk, substantial debts, inability to work, inability to relocate, loss of evidence in the context of litigation, loss of access to vital infrastructure (water, electricity), etc.<br>- moral : long-term or permanent psychological ailments, criminal penalty, abduction, loss of family ties, inability to sue, change of administrative status and/or loss of legal autonomy (guardianship), etc.",
			name: "Maximum impact"
		},
		PIA_EX_IMPN: {
			description: "Data subjects either will not be affected or may encounter a few inconveniences, which they will overcome without any problem. For example:<br>- physical : transient headaches;<br>- material : loss of time in repeating formalities or waiting for them to be fulfilled, receipt of unsolicited mail (e.g.: spams), reuse of data published on websites for the purpose of targeted advertising , etc.;<br>- moral : mere annoyance, feeling of invasion of privacy without real or objective harm (commercial intrusion), etc.",
			name: "Negligible impact"
		},
		PIA_EX_NHUM: {
			description: "Incident or damage at one of the organisation (power cut, fire, flood, etc.)",
			name: "Non-human sources"
		},
		PIA_EX_VRAI: {
			description: "It seems possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in offices that cannot be accessed without first checking in at the reception).",
			name: "Significant likelihood"
		},
		PIA_EX_VRAL: {
			description: "It seems difficult for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader).",
			name: "Limited likelihood"
		},
		PIA_EX_VRAM: {
			description: "It seems extremely easy for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in the public lobby).",
			name: "Maximum likelihood"
		},
		PIA_EX_VRAN: {
			description: "It does not seem possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader and access code).",
			name: "Negligible likelihood"
		},
		PIA_LGL_CONS: {
			description: "Allow data subjects to make a free, specific and informed choice. Determine whether the processing relies on a legal basis other than consent pursuant to Art. 6 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Consent",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Define and describe the scope in detail:<br>- the personal data concerned, their recipients and storage durations<br>- description of the processes and personal data supporting assets for the entire personal data life cycle (from collection to erasure).",
			name: "Data and processes",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Present a brief outline of the processing under consideration, its nature, scope, context, purposes and stakes. Identify the data controller and any processors. List the standard references applicable to the processing, which are necessary or must be complied with , not least the approved codes of conduct (see Art. 40 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) and certifications regarding data protection (see Art. 42 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Processing's description",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Natural or legal person, public authority, agency or another body, to which the personal data are disclosed, whether a third party or not. However, public authorities which may receive personal data in the framework of a particular inquiry in accordance with Union or Member State law shall not be regarded as recipients; the processing of those data by those public authorities shall be in compliance with the applicable data protection rules according to the purposes of the processing. see Art. 4.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Recipient",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "A storage duration must be defined for each type of data and justified by the legal requirements and/or processing needs. Thus a distinction is made between common data and archived data, to which access will be limited to only the stakeholders concerned. An erasure mechanism must be implemented to archive common data or purge archived data at the end of their storage duration. Functional traces will also have to be purged, as will technical logs which may not be stored indefinitely",
			name: "Storage Durations",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Personal data shall be collected for specified, explicit and legitimate purposes and <strong>not further processed in a manner that is incompatible with those purposes.</strong> <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) of [GDPR]</a>",
			name: "Principles relating to processing of personal data",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Den registrerte har gitt uttrykkelig samtykke til behandling av slike personopplysninger for ett eller flere spesifikke formål <br>- Behandlingen er nødvendig for å oppfylle en avtale som den registrerte er part i, eller for å gjennomføre tiltak på den registrertes anmodning før en avtaleinngåelse <br>- Behandlingen er nødvendig for å oppfylle en rettslig forpliktelse som påhviler den behandlingsansvarlige <br>- Behandlingen er nødvendig for å verne den registrertes eller en annen fysisk persons vitale interesser <br>- Behandlingen er nødvendig for å utføre en oppgave i allmennhetens interesse eller utøve offentlig myndighet som den behandlingsansvarlige er pålagt <br>- Behandlingen er nødvendig for formål knyttet til de berettigede interessene som forfølges av den behandlingsansvarlige eller en tredjepart, med mindre den registrertes interesser eller grunnleggende rettigheter og friheter går foran og krever vern av personopplysninger, særlig dersom den registrerte er et barn<br> Se <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR] artikkel 6</a> ",
			name: "Behandlingsgrunnlag",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Ensure that the subjects are informed. Confirm that the processing is not covered by an exception and is not subject to specific conditions.",
			name: "Informing data subjects",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "It is important to reduce the severity of the risks by minimising the number of personal data that will be processed, by limiting such data to what is strictly necessary for the purposes for which they are processed (otherwise they should not be collected). Then, it also becomes possible to minimise the data themselves, via controls aimed at reducing their sensitivity.",
			name: "Data minimisation",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "I tråd med artikkel 28 i [GDPR] skal det inngås en databehandleravtale med enhver databehandler, der varighet, omfang, formål, behandlingsinstrukser, forhåndsgodkjenning av databehandlere, overenstemmelse med [GDPR], avvikshåndtering, etc. dokumenteres",
			name: "Underleverandører",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Asset on which personal data rely. Note: this may be hardware, software, networks, people, paper or paper transmission channels.",
			name: "Supporting asset",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Depending on the country in question, you will have to justify the choice of remote hosting and indicate the legal supervision arrangements implemented in order to ensure adequate protection of the data subject to a cross-border transfer. That is :<br>- European Union<br>- Country recognised as providing adequate protection by the EU<br>- Transfer to the United States to a company which has joined the Privacy Shield<br>- Other country <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 to 49 of [GDPR]</a>",
			name: "Utlevering",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Existence of a policy and processes to obtain an organisation able to manage and control the protection of personal data held within it.",
			name: "Supervision",
			placeholder: "Indicate here whether the effectiveness and adequacy of privacy controls are monitored.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Existence of a policy and processes reducing the risk that legitimate access to personal data by third parties may pose to the data subjects' civil liberties and privacy.",
			name: "Relations with third parties",
			placeholder: "Indicate here, for processors requiring access to data, the security controls and arrangements carried out as regards such access.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Specify whether a person is responsible for the enforcement of privacy laws and regulations. Specify whether there is a monitoring committee (or equivalent) responsible for the guidance and follow-up of actions concerning the protection of privacy.",
			name: "Organisation",
			placeholder: "Indicate if the roles and responsibilities for data protection are defined.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Existence of a policy designed integrate the protection of personal data in all new processing operations.",
			name: "Integrating privacy protection in projects",
			placeholder: "Describe here how privacy protection is integrated in projects",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Existence of a policy describing awareness-raising controls are carried out with regard to a new recruit and what controls are carried out when persons who have been accessing data leave their job.",
			name: "Personnel management",
			placeholder: "Indicate here what awareness-raising controls are carried out with regard to employees.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Set out important aspects relating to data protection within a documentary base making up the data protection policy and in a form suited to each type of content (risks, key principles to be followed, target objectives, rules to be applied, etc.) and each communication target (users, IT department, policymakers, etc.).",
			name: "Policy",
			placeholder: "Describe here the documentary base setting out data protection objectives and rules.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Policy describing processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects (building a map of the risks, etc.).",
			name: "Managing privacy risks",
			placeholder: "Describe here processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Existence of an operational organisation that can detect and treat incidents that may affect the data subjects' civil liberties and privacy.",
			name: " Managing personal data violations",
			placeholder: "Indicate here whether IT incidents are subject to a documented and tested management procedure.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Policies and means implemented to ensure the availability and/or integrity of the personal data, while maintaining their confidentiality.",
			name: "Backups",
			placeholder: "Indicate here how backups are managed. Clarify whether they are stored in a safe place.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Controls implemented on workstations (automatic locking, regular updates, configuration, physical security, etc.) to reduce the possibility to exploit software properties (operating systems, business applications etc.) to adversely affect personal data.",
			name: "Managing workstations",
			placeholder: "Describe here the controls implemented on workstations",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "TO BE TRANSLATED - <strong>Only use subcontractors which are able to provide sufficient guarantees</strong> (in particular in terms of specialised knowledge, reliability and resources). Require service providers to communicate their information system security policy before signing a contract with them. <br>Take and document the means (security audits, installation visits, etc.) used to <strong>ensure the effectiveness of the guarantees offered by the subcontractor</strong> in terms of data protection. These guarantees include: <br>- encryption of data according to its sensitivity or, at least, the existence of procedures guaranteeing that the service company does not have access to the data; <br>- encryption of data transmissions (e.g.: HTTPS type connection, VPN, etc.); <br>- guarantees in terms of network protection, traceability (logs, audits), access rights management, authentication, etc. <br><strong>Sign a contract with the subcontractors</strong>, which defines the subject, the length and the purpose of the processing, as well as obligations of each party. Ensure that it contains, in particular, provisions targeting: <br>- their obligation in terms of <strong>confidentiality of the entrusted personal data</strong>;<br>- <strong>minimal standards in terms of user authentication</strong>;<br>- <strong>conditions of restitution of data and/or its destruction at end of the contract</strong>;<br>- <strong>incident management and notification rules. </strong> They should include notification of the data controller whenever a security breach or a security incident is discovered, which should happen as soon as possible when it concerns personal data.",
			name: "Processing contracts",
			placeholder: "Describe here specific measures for processors (host, maintenance company, administrator, specialist service providers, etc.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Policies implemented to reduce the possibility and the impact of risks on assets supporting personal data.",
			name: "Operating security",
			placeholder: "Describe here how the software updates (operating systems, applications, etc.) and application of security corrective controls patches are carried out.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Monitor intrusion detection systems and intrusion prevention systems in order to analyze network (wired networks, Wi-Fi, radio waves, fiber optics, etc.) traffic in real time and detect any suspicious activity suggestive of a cyber attack scenario.",
			name: "Monitoring network activity",
			placeholder: "Indicate here means and controls implemented to detect incidents involving personal data",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Policies describing how physical maintenance of hardware is managed, stating whether this is contracted out.<br> Indicate whether the remote maintenance of apps is authorized, and according to what arrangements. Specify whether defective equipment is managed in a specific manner.",
			name: "Maintenance",
			placeholder: "Describe here how physical maintenance of hardware is managed",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controls implemented on workstations and servers to protect them from malicious software while accessing less secure networks.",
			name: "Clamping down on malicious software",
			placeholder: "Describe here the controls implemented to reduce risks while accessing less secure networks.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Indicate here the controls bearing on the physical security of servers and workstations (secure storage, security cables, confidentiality filters, secure erasure prior to scrapping, etc.).",
			name: "Hardware security",
			placeholder: "Indicate here the controls bearing on the physical security of servers and workstations",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Depending on the type of network on which the processing is carried out (isolated, private or Internet). Specify which firewall system, intrusion detection systems or other active or passive devices are in charge of ensuring network security.",
			name: "Network security",
			placeholder: "Indicate here the security controls of network on which the processing is carried out",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Policies to ensure physical security (zoning, escorting of visitors, wearing of passes, locked doors and so on).Indicate whether there are warning procedures in place in the event of a break-in.",
			name: "Physical access control",
			placeholder: "Indicate here how physical access control is carried out regarding the premises accommodating the processing.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Policies describing the means of fire prevention, detection and fighting. Where applicable, indicate the means of preventing water damage.Also specify the means of power supply monitoring and relief.",
			name: "Protecting against non-human sources of risks",
			placeholder: "Indicate here means to avoid to limit non-human sources of risks.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Documentation on implantation area, which should not be subject to environmental disasters (flood zone, proximity to chemical industries, earthquake or volcanic zone, etc.).Specify if dangerous products are stored in the same area.",
			name: "Avoiding sources of risk",
			placeholder: "Indicate here whether the implantation area is subject to environmental disasters",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementation of ANSSI's Recommendations for securing websites.",
			name: "Website security",
			placeholder: "Indicate here controls implemented to protect websites.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Indicate here whether anonymisation mechanisms are implemented, which ones and for what purpose. <br>Remember to clearly distinguish between anonymous and pseudonymous data.",
			name: "Anonymisation",
			placeholder: "Indicate here implemented anonymisation mechanisms",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Where applicable, describe here the processes of archive management (delivery, storage, consultation, etc.) under your responsibility. Specify the archiving roles (offices of origin, transferring agencies, etc.) and the archiving policy. State if data may fall within the scope of public archives.",
			name: "Archiving",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of stored data, which ones and for what purpose.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Means implemented for <strong>ensuring the confidentiality</strong> of data stored (in the database, in flat files, backups, etc.), as well as the procedure for managing encryption keys (creation, storage, change in the event of suspected cases of data compromise, etc.).<br> Describe the encryption means employed for data flows (VPN, TLS, etc.) implemented in the processing events.",
			name: "Encryption",
			placeholder: "Describe here the means implemented for ensuring the confidentiality of data",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Implementation of data partitioning helps to reduce the possibility that personal data can be correlated and that a breach of all personal data may occur.",
			name: "Partitioning data",
			placeholder: "Indicate here if processing partitioning is planned, and how this is carried out.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Methods to define and attribute users profiles. Specify the <strong>authentication</strong> means implemented . Where applicable, specify the rules applicable to passwords (minimum length, required characters, validity duration, number of failed attempts before access to account is locked, etc.).",
			name: "Logical access control",
			placeholder: "Indicate here how users profiles are defined and attributed.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Policies that define traceability and log management.",
			name: "Traceability (logging)",
			placeholder: "Indicate here whether events are logged and how long these traces are stored for.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "The following methods could be used : Filtering and removal, Reducing sensitivity via conversion, Reducing the identifying nature of data, Reducing data accumulation, Restricting data access",
			name: "Minimising the amount of personal data",
			placeholder: "Indicate here means implemented to reduce the severity of risks by limiting the amount of personal data",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Where paper documents containing data are used during the processing, indicate here how they are printed, stored, destroyed and exchanged.",
			name: "Paper document security",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of paper documents, which ones and for what purpose.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "corrective controls suggested by the assessor in previous steps, drawing up an action plan setting out, for each action, its manager, frequency, difficulty, cost and progress.",
			name: "Action plan",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Graph illustrating the good security practices, with a conformity value attributed to each on the basis of its assessment in previous steps.",
			name: "Mapping of risks",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Where appropriate, the controller shall seek the views of data subjects or their representatives on the intended processing, without prejudice to the protection of commercial or public interests or the security of processing operations. See Art. 39.2 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br>These views may be gathered by diverse means, depending on the context (internal or external study on the processing methods and purpose, question for the attention of staff representatives or trade unions, survey among future customers of the data processor). <strong>Where the data controller decides to go against the views of the data subjects</strong>, he must note down <strong>the justification for this decision</strong>. Where the data controller considers that <strong>gathering the views of the data subjects is not relevant, he must also note down the justification thereof</strong>.",
			name: "Data subject's opinion",
			source: "GDPR Art. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "The controller shall seek the advice of the data protection officer, where designated, when carrying out a data protection impact assessment. See Art. 39.2 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>This view may be against the processing being implemented, without restricting the decision of the data controller for all that</strong>.",
			name: "DPO's opinion",
			source: "GDPR Art. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Decide on whether the selected controls, residual risks and action plan are acceptable, with justifications, in view of the previously identified stakes and views of the stakeholders. In this way, the PIA may be:<br>- validated<br>- conditional on improvement (explain in what way)<br>- refused (along with the processing under consideration). Where necessary, repeat the previous steps so that the PIA can be validated. This decision does not prejudge the compliance assessment which may be carried out, where applicable, by the Data Protection Authority (the CNIL in France), as part of preliminary formalities or checks for example.",
			name: "Formal validation",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "kunnskapsbase"
};
var measures$7 = {
	add: "Legg til et tiltak (eller bruk kunnskapsbasen)",
	default_placeholder: "Beskriv eksisterende eller tiltenkte tiltak for å sikre informasjonssikkerheten.",
	edit: "Rediger tiltak",
	placeholder_title: "Tittel på tiltak",
	remove: "Slett tiltak"
};
var misc$7 = {
	display: "Show / Hide"
};
var modals$7 = {
	abandon_pia: {
		additional_text: "TO BE TRANSLATED - Archiving is not definitive and the PIA can go back to it if needed.",
		content: "TO BE TRANSLATED - Do you wish to give up the processing?"
	},
	action_plan_no_evaluation: {
		content: "TO BE TRANSLATED - You need to begin the review of the analysis to create the action plan.",
		review_section: "TO BE TRANSLATED - Review a section"
	},
	archive: "Archive",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "TO BE TRANSLATED - This section is ready to be reviewed."
	},
	back_to_edition: {
		content: "TO BE TRANSLATED - This section has been sent back for editing.<br> Several fields must be corrected<br> to enable its proper review."
	},
	back_to_evaluation: {
		content: "TO BE TRANSLATED - This section has been sent back for review.<br> Several fields must be reviewed<br> to enable its proper validation."
	},
	back_to_home: "Back to home",
	cancel: "Cancel",
	close: "Close",
	completed_edition: {
		content: "TO BE TRANSLATED - The PIA has been fully edited and has to be reviewed."
	},
	completed_evaluation: {
		content: "TO BE TRANSLATED - The PIA has been fully reviewed and can be validated."
	},
	"continue": "Continue",
	declare_measures: {
		content: "Before evaluating risks,<br>you must report the<br>existing or planned measures.",
		declare: "Declare existing or planned measures"
	},
	dpo_missing_evaluations: {
		comment: "TO BE TRANSLATED - Comment",
		content: "TO BE TRANSLATED - You need to complete the review of the analysis to access the DPO page.",
		remove: "Remove",
		review_section: "TO BE TRANSLATED - Review a section"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type PIA"
	},
	import_wrong_structure_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type Modèle"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "TO BE TRANSLATED - The content of the PIA has been copied to clipboard."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Warning,</span><br>At least one measure must be filled: no deletion possible."
	},
	recover_version: {
		"continue": "Continue",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "TO BE TRANSLATED - As you have rejected the PIA, it is sent back for review to make the required changes."
	},
	remove_attachment: {
		comment: "TO BE TRANSLATED - Comment",
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>remove this attachment?",
		keep: "Keep",
		remove: "Remove"
	},
	remove_measure: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to <br>remove this measure?",
		keep: "Keep this <br>measure",
		remove: "Remove this <br>measure"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "TO TRANSLATE - Remove this PIA"
	},
	remove_question: {
		content: "TO BE TRANSLATED - Souhaitez-vous supprimer la question ?",
		keep: "TO BE TRANSLATED - Annuler",
		remove: "TO BE TRANSLATED - Supprimer"
	},
	remove_structure: {
		content: "TO BE TRANSLATED - <span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer ce modèle ?",
		remove: "TO BE TRANSLATED - Supprimer ce modèle"
	},
	same_comment: {
		content: "<span class='strong'>Warning,</span><br>Please enter a comment different from the last recorded."
	},
	signed_pia_validation: {
		content: "TO BE TRANSLATED - To approve the PIA, attach the signed report.",
		download_pia: "Download report"
	},
	simple_pia_validation: {
		content: "TO BE TRANSLATED - You have approved the PIA."
	},
	start_evaluation: "TO BE TRANSLATED - Start review",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "TO BE TRANSLATED - The server address has been updated."
	},
	validate_evaluation: {
		content: "TO BE TRANSLATED - This section is ready for validating the PIA."
	},
	validate_evaluation_to_correct: {
		content: "Sorry,<br>Several fields must be corrected.<br>Return to edition mode<br>to make corrections."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$7 = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$7 = {
	content: ", consider that :",
	dpo_lock: "Please complete the other sections before you can fill the DPO opinion.",
	dpo_opinion: "DPO opinion",
	edit: "Edit",
	people_opinion: "Concerned people opinion",
	placeholder_concerned_people_name: "Concerned people name(s)",
	placeholder_dpo_name: "DPO name(s)",
	placeholder_dpo_opinion: "Specify the reasons for your choice.",
	placeholder_people_opinion: "Describe how the opinions were collected and what the analysis is. If the notices have not been sought, state the reasons.",
	placeholder_search_content: "Justify the reason why the opinion of the persons concerned has not been requested.",
	treatment_lock: "Please complete the other sections before you can fill the opinions of the persons concerned.",
	treatment_nok: "The processing operation should not be used.",
	treatment_ok: "The processing operation could be implemented."
};
var pia$7 = {
	attachments: {
		add: "Legg til",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Fjern",
		title: "Vedlegg",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Forespør saksbehandling",
		mandatory_fields: "Alle felter må fylles ut",
		structure_add_question: "TO BE TRANSLATED - Ajouter une question",
		subsection_validated: "Underavsnitt saksbehandlet. Avventer endelig validering",
		validate_evaluation: "Valider saksbehandling"
	},
	header: {
		display_action_plan: "Vis<br>handlingsplan",
		edition: "TO BE TRANSLATED - Edition",
		evaluation: "TO BE TRANSLATED - Evaluation",
		preview: "Forhåndsvis"
	},
	sections: {
		based_on_structure_name: "TO BE TRANSLATED - Basé sur le modèle :",
		homepage_link: "Tilbake til hovedside",
		refuse_pia: "Avvist AIIA",
		status: {
			evaluation: {
				cancel: "avbryte forespørselen om saksbehandling.",
				cancel_button: "Avbryt forespørsel om saksbehandling",
				content: "Denne delen har ennå ikke blitt saksbehandlet. Hvis du ønsker å redigere innholdet som sendes til saksbehandling, må du ",
				title: "Avventer saksbehandling"
			},
			validation: {
				cancel: "avbryte forespørselen om validering.",
				cancel_button: "Avbryt forespørsel om validering",
				content: "Denne delen har blitt saksbehandlet og venter på den generelle PIA-valideringen. Hvis du ønsker å endre saksbehandlingen, må du ",
				title: "Avventer validering."
			}
		},
		validate_pia: "Valider PIA"
	},
	statuses: [
		"Pågår",
		"Avvist",
		"Enkel validering",
		"Signert validation",
		"Arkrivert",
		"Avventer validering"
	]
};
var questions$7 = {
	edit: "Edit question",
	gauges: [
		"(Undefined)",
		"Negligible",
		"Limited",
		"Important",
		"Maximum"
	],
	placeholder_title: "TO BE TRANSLATED - Titre de la question (obligatoire)",
	remove: "TO BE TRANSLATED - Supprimer la question"
};
var rejection_page$7 = {
	applied_adjustments: "TO BE TRANSLATED - Adjustments proposed",
	applied_adjustments_placeholder: "TO BE TRANSLATED - Describe the changes brought to the PIA.",
	button: {
		abandon_treatment: "TO BE TRANSLATED - Abandon processing",
		reject_pia: "TO BE TRANSLATED - Reject AIIA",
		send_for_validation: "TO BE TRANSLATED - Resend for approval"
	},
	previous_rejection: "TO BE TRANSLATED - Previous refusal",
	rejection_reason: "TO BE TRANSLATED - Refusal reason",
	rejection_reason_placeholder: "TO BE TRANSLATED - Describe the reasons for refusing the PIA.",
	title: "TO BE TRANSLATED - Validation history"
};
var sections$7 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Present a brief outline of the processing: its name, purposes, stakes, context of use, etc.",
						title: "Which is the processing under consideration?"
					},
					"2": {
						placeholder: "Describe the responsabilities of the stakeholders: the data controller, the possible data processors and joint controllers.",
						title: "What are the responsibilities linked to the processing?"
					},
					"3": {
						placeholder: "List the relevant standards applicable to the processing, especially approved codes of conduct and data protection certifications.",
						title: "Are there standards applicable to the processing?"
					}
				},
				short_help: "List the data (end-user, common, training data, test data, functional, diagnostic, telemetry) collected and processed. Define for each the storage durations, the recipients and persons with access thereto.",
				title: "Nature, scope, context, purpose"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "List the data collected and processed. Define for each the storage durations, the recipients and persons with access thereto.",
						title: "What are the data processed?"
					},
					"2": {
						placeholder: "Present and describe how the product generally works (from the data collection to the data destruction, the different processing stages, storage, etc.), using for example a diagram of data flows (add it as an attachment) and a detailed description of the processes carried out.",
						title: "How does the life cycle of data and processes work?"
					},
					"3": {
						placeholder: "List the data supporting assets (operating systems, business applications, database management systems, office suites, protocols, configurations, etc.)",
						title: "What are the AI system supporting assets?"
					}
				},
				short_help: "This part allows you to define and describe the scope of the processing in detail.",
				title: "Data, AI system and supporting assets"
			}
		},
		short_help: "This section gives you a clear view of the AI system and processing of personal data in question.",
		title: "Context"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Explain why the processing purposes are specified, explicit and legitimate.",
						short_title: "Purposes",
						title: "Are the processing purposes specified, explicit and legitimate?"
					},
					"2": {
						placeholder: "Describe what is/are the legal basis of your processing (ex: consent, performance of a contract, compliance with a legal obligation, protecting the vital intests, etc.)",
						short_title: "Legal basis",
						title: "What are the legal basis making the processing lawful?"
					},
					"3": {
						placeholder: "Explain why each of the data collected is necessary for the purposes of your processing.",
						short_title: "Adequate data",
						title: "Are the data collected adequate, relevant and limited to what is necessary in relation to the purposes for which they are processed ('data minimisation')?"
					},
					"4": {
						placeholder: "Describe which are the steps taken to ensure the quality of the data.",
						short_title: "Data accuracy",
						title: "Are the data accurate and kept up to date?"
					},
					"5": {
						placeholder: "Explain why the storage durations are justified by legal requirements and/or processing needs.",
						short_title: "Storage duration",
						title: "What are the storage duration of the data?"
                    },
                    "6": {
                        placeholder: "Explain 6.",
                        short_title: "Storage 6",
                        title: "What are 6?"
                    },
                    "7": {
                        placeholder: "Explain 7.",
                        short_title: "Storage 7",
                        title: "What are 7?"
                    },
                    "8": {
                        placeholder: "Explain 8.",
                        short_title: "Storage 8",
                        title: "What are 8?"
                    },
                    "9": {
                        placeholder: "Explain 9.",
                        short_title: "Storage 9",
                        title: "What are 9?"
                    },
                    "10": {
                        placeholder: "Explain 10.",
                        short_title: "Storage 10",
                        title: "What are 10?"
                    }
				},
				short_help: "This part allows you to demonstrate the legitimacy of your processing operation and of the data processed.",
				title: "Proportionality and necessity"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Describe what is the information given to the data subjects and what are the means to do it.",
						short_title: "Information for the data subjects",
						title: "How are the data subjects informed on the processing?"
					},
					"2": {
						placeholder: "Describe the controls intended to ensure that users' consent has been obtained.",
						short_title: "Obtaining consent",
						title: "If applicable, how is the consent of data subjects obtained?"
					},
					"3": {
						placeholder: "Describe the controls intended for enabling data subjects to access, receive and transmit their data.",
						short_title: "Right of access and to data portability",
						title: "How can data subjects exercise their rights of access and to data portability?"
					},
					"4": {
						placeholder: "Describe the controls intended for enabling data subjects to rectify and erase their data.",
						short_title: "Right to rectification and erasure",
						title: "How can data subjects exercise their rights to rectification and erasure?"
					},
					"5": {
						placeholder: "Describe the controls intended for enabling data subjects to restrict and to object to the processing of their data.",
						short_title: "Right to restriction and to object",
						title: "How can data subjects exercise their rights to restriction and to object?"
					},
					"6": {
						placeholder: "For each processor, describe his responsibilities (duration, scope, purpose, documented processing instructions, prior authorisation) and provide the contracts, codes of conduct and certifications determining its missions and obligations.",
						short_title: "Subcontracting",
						title: "Are the obligations of the processors clearly identified and governed by a contract?"
					},
					"7": {
						placeholder: "For each country outside the European Union where data are stored or processed, name it and tell if it is acknowledged as offering an adequate level of data protection or describe the provisions concerning the transfer.",
						short_title: "Transfers",
						title: "In the case of 5 data transfer outside the European Union, are the data adequately protected?"
					}
				},
				short_help: "This part allows you to demonstrate that you are implementing the necessary means to enable the persons concerned to exercise their rights.",
				title: "Controls to protect the personal rights of data subjects"
			}
		},
		short_help: "Build a compliance framework for protecting fundamental rights, safety, health and ensuring regulatory compliance.",
		title: "OBLIGATIONS & RESPONSIBILITIES"
	},
	"3": {
		items: {
			"1": {
				short_help: "Identify the controls (existing or planned) that contribute to protecting rights and ensuring compliance.",
				title: "Existing or planned measures"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Enter the potential impacts",
						title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
					},
					"2": {
						placeholder: "Enter the threats",
						title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
					},
					"3": {
						placeholder: "Enter the risk sources",
						title: "What are the risk <span class='green-highlight'>sources</span>?"
					},
					"4": {
						placeholder: "Click to select controls which address the risk.",
						title: "Which of the identified <span class='green-highlight'>controls</span> contribute to addressing the risk?"
					},
					"5": {
						placeholder: "Justify here the estimated severity of the risk.",
						title: "How do you estimate the <span class='green-highlight'>risk severity</span>, especially according to potential impacts and planned controls?"
					},
					"6": {
						placeholder: "Justify here the estimated likelihood.",
						title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned controls?"
					}
				},
				short_help: "Analyze the causes and consequences of illegitimate access to data, and estimate its severity and likelihood.",
				title: "Illegitimate access to data"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Enter the potential impacts",
						title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
					},
					"2": {
						placeholder: "Enter the threats",
						title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
					},
					"3": {
						placeholder: "Enter the risk sources",
						title: "What are the risk <span class='green-highlight'>sources</span>?"
					},
					"4": {
						placeholder: "Click here to select controls which address the risk.",
						title: "Which of the identified <span class='green-highlight'>controls</span> contribute to addressing the risk?"
					},
					"5": {
						placeholder: "Justify here the estimated severity of the risk.",
						title: "How do you estimate the <span class='green-highlight'>risk severity</span>, especially according to potential impacts and planned controls?"
					},
					"6": {
						placeholder: "Justify here the estimated likelihood.",
						title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned controls?"
					}
				},
				short_help: "Analyze the causes and consequences of an undesired change in data, and estimate its seriousness and likelihood.",
				title: "Unwanted modification of data"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Enter the potential impacts",
						title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
					},
					"2": {
						placeholder: "Enter the threats",
						title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
					},
					"3": {
						placeholder: "Enter the risk sources",
						title: "What are the risk <span class='green-highlight'>sources</span>?"
					},
					"4": {
						placeholder: "Click here to select controls which address the risk.",
						title: "Which of the identified <span class='green-highlight'>controls</span> contribute to addressing the risk?"
					},
					"5": {
						placeholder: "Justify here the estimated severity of the risk.",
						title: "How do you estimate the <span class='green-highlight'>risk severity</span>, especially according to potential impacts and planned controls?"
					},
					"6": {
						placeholder: "Justify here the estimated likelihood.",
						title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned controls?"
					}
				},
				short_help: "Analyze the causes and consequences of data loss, and estimate its seriousness and likelihood.",
				title: "Data disappearance"
			},
			"5": {
				short_help: "This visualisation allows you to have a global and synthetic view on the controls effects on the risks they address.",
				title: "Risks overview"
			}
		},
		short_help: "This section allows you to assess the privacy risks, taking into account existing or planned controls.",
		title: "Risks"
	},
	"4": {
		items: {
			"1": {
				short_help: "Use this visualisation to compare the positioning of the risks, both before and after application of the complementary controls.",
				title: "Risk mapping"
			},
			"2": {
				short_help: "Plan in detail the implementation of the additional controls identified during the PIA. The action plan is automatically updated when evaluating the different elements comprised in the PIA.",
				title: "Action plan"
			},
			"3": {
				short_help: "Present the advice of the person in charge of data protection and privacy issues (data protection delegate if there is one). Present the views of the data subjects or their representatives.",
				title: "DPO and concerned persons opinions"
			},
			"4": {
				title: "TO BE TRANSLATED - Validate the PIA"
			},
			"5": {
				title: "TO BE TRANSLATED - Rejected PIA"
			}
		},
		short_help: "This section allows you to prepare and formalise the PIA validation.",
		title: "Validation"
	}
};
var settings$7 = {
	content: "Please, provide the address (URL) of the remote server:",
	title: "Settings",
	update: "Update URL"
};
var summary$7 = {
	action_plan: {
		fundamental_principles: "OBLIGATIONS & RESPONSIBILITIES",
		implementation_date: "Expected date of implementation",
		implementation_responsible: "Responsible for implementation",
		measures: "Existing or planned measures",
		no_action_plan: "No action plan recorded.",
		risks: "Risks",
		title: "Action plan"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Attachments",
	concerned_people_name: "Concerned people opinions",
	concerned_people_opinion: "Concerned people opinions",
	concerned_people_searched_opinion: "Search of concerned people opinion",
	concerned_people_status: "Concerned people statuses",
	concerned_people_unsearched_opinion_comment: "Reason why concerned people opinion wasn't requested",
	content_choice: [
		"The processing operation should not be used.",
		"The processing operation could be implemented."
	],
	creation_date: "Creation date",
	csv_action_plan_comment: "TO BE TRANSLATED - Action plan comment",
	csv_evaluation_comment: "TO BE TRANSLATED - Evaluation comment",
	csv_file_title: "TO BE TRANSLATED - action-plan",
	csv_implement_date: "TO BE TRANSLATED - Estimated implementation date",
	csv_people_in_charge: "TO BE TRANSLATED - Person in charge",
	csv_section: "TO BE TRANSLATED - Section",
	csv_title_object: "TO BE TRANSLATED - Title",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "DPO's name",
	dpo_opinion: "DPO's opinion",
	dpo_status: "DPO's status",
	gauges: {
		"1": "Negligible",
		"2": "Limited",
		"3": "Important",
		"4": "Maximum"
	},
	modification_made: "Modifications made",
	people_search_status_nok: "Concerned people opinion wasn't requested.",
	people_search_status_ok: "Concerned people opinion was requested.",
	pia_assessor: "Assessor's name",
	pia_author: "Author's name",
	pia_name: "PIA",
	pia_validator: "Validator's name",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Back to previous page",
	rejection_reason: "Rejection reason",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "TO BE TRANSLATED - Risk mapping",
	risks_overview_title: "TO BE TRANSLATED - Risks overview",
	title: "PIA information"
};
var users$7 = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$7 = {
	add_signed_pia: "TO BE TRANSLATED - Add the signed AIIA",
	after_reading: "TO BE TRANSLATED - After reading full PIA relating to the data processing linked to ",
	button: {
		rejection: "TO BE TRANSLATED - Reject AIIA",
		signed_validation: "TO BE TRANSLATED - Approve PIA <br>(signed)",
		simple_validation: "TO BE TRANSLATED - Approve PIA <br>(direct)"
	},
	confirmation1: "TO BE TRANSLATED - I attest that the context of the processing described in the PIA is consistent with the reality.",
	confirmation2: "TO BE TRANSLATED - I attest that I am aware of the risks depending on the existing or planned measures.",
	confirmation3: "TO BE TRANSLATED - I ratify the corrective actions indicated in the action plan.",
	confirmation4: "TO BE TRANSLATED - I commit to implement as quickly as possible the indicated corrective actions.",
	latest_signed_attachment: "TO BE TRANSLATED - Last signed attachment",
	mandatory_fields: "TO BE TRANSLATED - All boxes must be checked",
	remove_attachment: "TO BE TRANSLATED - Remove the attachment",
	responsible: "TO BE TRANSLATED - Person accountable for validating the PIA: ",
	signed_attachments_history: "TO BE TRANSLATED - Signed attachments history",
	tools: {
		dashboard: "TO BE TRANSLATED - Dashboard",
		display_pia: "TO BE TRANSLATED - Display report"
	},
	validated_pia_with_signature: "TO BE TRANSLATED - Approved",
	waiting_for_signature: "TO BE TRANSLATED - Pending signed PIA"
};
var no = {
	about: about$7,
	action_plan: action_plan$7,
	authentication: authentication$7,
	cartography: cartography$7,
	comments: comments$7,
	conflict: conflict$7,
	date: date$7,
	errors: errors$7,
	evaluations: evaluations$7,
	header: header$7,
	help: help$7,
	homepage: homepage$7,
	knowledge_base: knowledge_base$7,
	measures: measures$7,
	misc: misc$7,
	modals: modals$7,
	onboarding: onboarding$7,
	opinions: opinions$7,
	"overview-risks": {
	important: "Important",
	limited: "Limited",
	maximal: "Maximal",
	measures: "Measures",
	negligible: "Negligible",
	potential_impacts: "Potential impacts",
	"risk-access_x": "Severity",
	"risk-access_y": "Likelihood",
	"risk-change_x": "Severity",
	"risk-change_y": "Likelihood",
	"risk-disappearance_x": "Severity",
	"risk-disappearance_y": "Likelihood",
	sources: "Sources",
	threat: "Threat"
},
	pia: pia$7,
	questions: questions$7,
	rejection_page: rejection_page$7,
	sections: sections$7,
	settings: settings$7,
	summary: summary$7,
	users: users$7,
	validation_page: validation_page$7
};

var about$6 = {
	contribute: "W razie zainteresowania tłumaczeniem na inny język lub w celu poprawienia obecnych tłumaczeń, polecamy <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">zapoznanie się ze stroną opisującą, co należy w tym celu zrobić</a>.",
	description: "To narzędzie zostało pierwotnie opracowane przez <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, francuski organ nadzorczy ochrony danych, dla wsparcia administratorów danych w ich staraniach o zgodność z RODO. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>To narzędzie jest wolne i otwarte. Można uczestniczyć w pracy nad nim pobierając kod źródłowy z Github, modyfikując go i rozpowszechniając wśród zainteresowanych.",
	licences: "Licencje bibliotek:",
	title: "O narzędziu AIIA",
	translators: "Aplikacja PIA jest obecnie dostępna w osiemnaście językach. CNIL opracowała wersję francuską i angielską. Pozostałe wersje stanowią wynik pracy następujących osób:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a>, Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>), Michał Kapica ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Numer wersji"
};
var action_plan$6 = {
	acceptable_measures: "Środki do zaakceptowania",
	edit: "Edit",
	improvable_measures: "Środki do ulepszenia",
	measures: "Środki istniejące lub przewidziane",
	no_action_plan: "Brak zarejestrowanego planu działania.",
	placeholder_person_in_charge: "Osoba odpowiedzialna za wdrożenie",
	principles: "Podstawowe zasady",
	risk1: "Dostęp nieupoważniony do danych",
	risk2: "Modyfikacja niepożądana danych",
	risk3: "Zniknięcie danych",
	risks: "Ryzyka",
	title: "Przegląd"
};
var authentication$6 = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Aplikacja <strong>francuskiego organu nadzorczego CNIL</strong> ma na celu pomóc administratorom danych osiągnąć i wykazać zgodność z RODO. Pomaga należycie przeprowadzić ocenę skutków dla ochrony danych, ułatwiając skorzystanie z metodologii PIA opracowanej przez CNIL.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Start",
	start_app: "Aplikacja PIA (Beta)",
	subtitle1: "Platforma tworzenia <br> i zarządzania AIIA",
	subtitle2: "Narzędzia i słowniki",
	title: "Privacy impact assessment",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$6 = {
	important: "Poważne",
	legend1: "Środki istniejące lub przewidziane",
	legend2: "Z wdrożonymi środkami naprawczymi",
	legend3: "(D)ostęp nieupoważniony do danych",
	legend4: "(M)odyfikacja niepożądana danych",
	legend5: "(Z)niknięcie danych",
	likelihood_axe: "Prawdopodobieństwo ryzyka",
	limited: "Ograniczone",
	maximal: "Maksymalne",
	negligible: "Pomijalne",
	risk1_access: "(D)",
	risk2_modification: "(M)",
	seriousness_axe: "Istotność ryzyka"
};
var comments$6 = {
	comment: "Komentarz",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "komentarz(e)",
	new_comment: "Komentarz",
	placeholder_new_comment: "Można wpisać komentarz",
	send: "Wstaw komentarz"
};
var conflict$6 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$6 = {
	april: "Kwiecień",
	august: "Sierpień",
	december: "Grudzień",
	"earlier-in-this-month": "Wcześniej w tym miesiącu",
	"earlier-in-this-week": "Wcześniej w tym tygodniu",
	february: "Luty",
	january: "Styczeń",
	july: "Lipiec",
	june: "Czerwiec",
	march: "Marzec",
	may: "Maj",
	november: "Listopad",
	october: "Październik",
	september: "Wrzesień",
	today: "Dzisiaj",
	yesterday: "Wczoraj"
};
var errors$6 = {
	content: "Jeżeli wystąpią inne problemy lub mają Państwo sugestie dotyczące ulepszeń, prosimy skorzystać z formularza <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>.",
	title: "Brak strony."
};
var evaluations$6 = {
	acceptable: "Do zaakceptowania",
	action_plan_comment: "Plan działania / działania naprawcze",
	evaluation_comment: "Komentarz do oceny",
	gauges: {
		"0": "(Niezdefiniowane)",
		"1": "Pomijalne",
		"2": "Ograniczone",
		"3": "Poważne",
		"4": "Maksymalne",
		likelihood: "Biorąc pod uwagę plan działania, jak można ponownie ocenić <span class='red-highlight'>prawdopodobieństwo tego ryzyka</span>?",
		seriousness: "Biorąc pod uwagę plan działania, jak można ponownie ocenić <span class='red-highlight'>istotność tego ryzyka</span>?"
	},
	improvable: "Do ulepszenia",
	placeholder_acceptable: "Można wpisać komentarz wyjaśniający, w jakim zakresie wdrożone środki są wystarczające dla spełnienia wymagań dotyczących ochrony danych osobowych.",
	placeholder_improvable1: "Można wpisać komentarz wyjaśniający, które dodatkowe środki należy uwzględnić w celu ulepszenia ochrony danych osobowych w ramach przetwarzania.",
	placeholder_improvable2: "Można wpisać komentarz.",
	placeholder_to_correct: "Można wpisać komentarz wyjaśniający, dlaczego dostarczone informacje nie są wystarczające dla przeprowadzenia oceny. Tę sekcję nalezy odesłać do edycji w celu uzupełnienia pierwotnej propozycji.",
	status: [
		"Oczekujące",
		"Do poprawienia",
		"Do ulepszenia",
		"Do zaakceptowania"
	],
	title: "Ocena",
	to_correct: "Do poprawienia"
};
var header$6 = {
	archives: "Archiwa AIIA",
	current_pias: "Aktualne AIIA",
	exit_full_screen_mode: "Naciśnij F11, aby wyjść z trybu pełnoekranowego.",
	help: {
		issue_reporting: "Zgłoś problem",
		manual: "Podręcznik użytkownika",
		pia_example_link: "Przykład AIIA",
		title: "Pomoc"
	},
	homepage_link: "Moje AIIA",
	knowledge_base_link: "Baza wiedzy",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Wersje przetłumaczone przez CNIL",
		community_translations: "Wersja przetłumaczone przez społeczność",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Tłumaczenia zweryfikowane przez krajowe organy nadzorcze",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Wersja oryginalna",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Ocena skutków dla ochrony prywatności",
	structures: "Szablony AIIA",
	tools: {
		about: "O aplikacji",
		accessibility: "Dostępność dla osób słabowidzących (kolory o mocnym kontraście, dopasowane do daltonizmu)",
		onboarding: "Uruchom ponownie samouczek",
		settings: "Ustawienia",
		url_setting: "Konfiguracja adresu URL serwera",
		users: "TO TRANSLATE - Users"
	}
};
var help$6 = {
	definition: {
		data1: {
			content: "Treść w trakcie pisania",
			title: "Korzystanie z narzędzia PIA"
		},
		data2: {
			qa1: {
				content: "Napotykając problemy z wyświetlaniem, należy zamknąć aplikację i ją ponownie uruchomić. To zazwyczaj pomoże naprawić ten rodzaj błędów. Dane zostaną zapisane zatem nie dojdzie do ich utraty.",
				title: "Napotkano problemy z wyświetlaniem, np. ikony nie są odświeżane lub brakuje elementów interfejsu."
			},
			qa2: {
				content: "Ten błąd jest znany i zostanie poprawiony. W razie napotkania tego problemu należy wpisać w pole uzasadnienia szacowany poziom istotności lub przwdopodobieństwa oraz jego uzasadnienie.",
				title: "Nie można edytować wskaźników prawdopodobieństwa i istotności ryzyka."
			},
			qa3: {
				content: "Zaobserwowano kilka problemów przy ładowaniu danej PIA, w szczególności brak wskaźników oceny istotności i prawdopodobieństwa ryzyka. W takim przypadku należy zapoznać się z poprzednim pytaniem. Jeżeli dana ocena PIA nie pojawia się na tablicy PIA, należy odświeżyć stronę, by ją zobaczyć.",
				title: "Występują problemy z importem wybranej PIA."
			},
			qa4: {
				content: "Jest to błąd wyświetlania i nie wpływa na informacje podane w trakcie PIA. Ten problem zostanie wkrótce naprawiony.",
				title: "Po wykonaniu kopiuj/wklej, tekst pojawia się podświetlony."
			},
			qa5: {
				content: "By zażądać oceny określonej sekcji, wszystkie pola muszą być wypełnione. Należy sprawdzić, czy tak jest. W trakcie edycji danego ryzyka, wymagane jest wskazanie co najmniej jednego środka technicznego lub organizacyjnego mitygującego to ryzyko.",
				title: "Nie można ocenić określonej sekcji"
			},
			qa6: {
				content: "Należy zamknąć i ponownie otworzyć edytowaną PIA. Zawartość powinna wyświetlić się w wybranym języku.",
				title: "Przy zmianie języka, opisy nie są przetłumaczone"
			},
			qa7: {
				content: "Obecnie ikony menu nawigacji nie są odświeżane po odmowie zatwierdzenia. Należy ponownie sprawdzić informacje i ocenę w każdej sekcji pod kątem powodów odmowy i poprosić o nową ocenę. Po przeglądzie wszystkich sekcji, będzie można ponownie wystąpic o zatwierdzenie danej oceny PIA.",
				title: "Co dalej po odmowie zatwierdzenia PIA?"
			},
			title: "Znane błędy"
		},
		footer: "Jeśli masz inne problemy lub propozycje ulepszeń, możesz wysłać je do nas za pomocą tego formularza <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Pomoc"
};
var homepage$6 = {
	cards: {
		author: "Edytowanie",
		category: "Kategoria",
		creation_status: "Utworzenie",
		date: "Data",
		evaluation: "Ocena",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Import AIIA",
		import_structure: "Import szablonu",
		item: {
			consult_pia: "Konsultacja",
			consult_structure: "Konsultacja szablonu",
			edit_pia: "Edycja",
			edit_structure: "Edycja szablonu",
			tools: {
				action_plan: "Wyświetlenie<br>planu działania",
				archive: "Archiwum",
				duplicate: "Duplikacja",
				"export": "Eksport",
				more_options: "Więcej opcji",
				pia: "Wyświetlenie<br>PIA",
				remove: "Usuń",
				unarchive: "Niearchiwizuj"
			},
			validate_pia: "Zatwierdź"
		},
		knowledges: {
			edit: "Edytuj bazę",
			"import": "Importuj bazę",
			"new": "Utwórz bazę",
			placeholder_author: "Imię, nazwisko",
			placeholder_contributors: "Współtwórcy",
			placeholder_entry_number: "Liczba wpisów",
			placeholder_name: "Tytuł bazy"
		},
		knowledges_entry: {
			all_sections: "Wszystkie sekcje",
			choose_category: "Wybierz kategorię",
			contents: "Zawartość",
			create: "Utwórz ten element",
			linked_to: "Połączony z",
			"new": "Utwórz element",
			placeholder_category: "Kategoria",
			placeholder_description: "Twój opis...",
			placeholder_name: "Nazwa elementu",
			placeholder_updated_at: "Ostatnio zaktualizowany"
		},
		new_pia: "Nowa AIIA",
		new_structure: "Nowy szablon",
		or: "or",
		pia_name: "PIA",
		placeholder_author: "Imię, nazwisko",
		placeholder_category: "Kategoria",
		placeholder_evaluation: "Imię, nazwisko",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Import AIIA",
		placeholder_import_structure: "Import szablonu",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Nowa AIIA",
		placeholder_new_structure: "Nowy szablon",
		placeholder_pia_name: "Tytuł AIIA",
		placeholder_sector_name: "Nazwa powiązanego sektora",
		placeholder_start: "Należy wypełnić wszystkie pola",
		placeholder_structure: "Domyślny szablon",
		placeholder_structure_name: "Tytuł szablonu",
		placeholder_validation: "Imię, nazwisko",
		sector_name: "Sektor",
		start: "Start",
		status: "Status",
		structure: "Szablon",
		structure_name: "Nazwa szablonu",
		title_close_creation: "Zamknięcie",
		validation: "Zatwierdzenie"
	},
	filters: {
		assessor: "Oceniającego",
		author: "Autora",
		card: "Widok karty",
		card_rocket_content: "Zaczynajmy!<br><br>By rozpocząć PIA,<br> należy kliknąć Nowa AIIA",
		card_rocket_content_structure: "Zaczynajmy!<br><br> By rozpocząć <br>szablon, prosimy kliknąć<br> +",
		category: "Kategoria",
		date: "Daty",
		import_pia: "Import AIIA",
		import_structure: "Import szablonu",
		list: "Widok listy",
		list_rocket_content: "Zaczynajmy! By rozpocząć <br>PIA, prosimy kliknąć +",
		list_rocket_content_structure: "Zaczynajmy! By rozpocząć <br>szablon, prosimy kliknąć +",
		name: "Nazwiska",
		new_pia: "Nowa AIIA",
		new_structure: "Nowy szablon",
		sector_name: "Sektor powiązany",
		sort: "Sortowanie",
		sort_by: "według",
		status: "Statusu",
		validator: "Zatwierdzającego"
	},
	lists: {
		column_actions: "Działania",
		column_author: "Edytowanie",
		column_category: "Kategoria",
		column_creation: "Utworzenie",
		column_evaluation: "Ocena",
		column_pia: "PIA",
		column_progression: "Postęp",
		column_sector_name: "Sektor powiązany",
		column_status: "Status",
		column_structure: "Szablon",
		column_structure_name: "Szablon",
		column_updated_at: "Data otwarcia",
		column_validation: "Zatwierdzenie",
		item: {
			tools: {
				action_plan: "Wyświetlenie planu działania",
				archive: "Archiwum",
				consult: "Konsultacja",
				duplicate: "Duplikacja",
				edit: "Edycja",
				"export": "Eksport",
				pia: "Wyświetlenie AIIA",
				remove: "Usuń",
				unarchive: "Niearchiwizuj"
			}
		}
	},
	search_filter: "Szukaj",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$6 = {
	add_measure: "Dodanie",
	add_measure_hint: "Można dodać środek ochrony z bazy wiedzy.",
	category: {
		definition: "Definicja",
		example: "Przykład",
		general_measure: "Środek ochrony fizycznej",
		measure_on_data: "Środek ochrony logicznej",
		method: "Metodologia",
		organizational_measure: "Środek organizacyjny",
		principle: "Zasada"
	},
	choose_knowledge_base: "Wybierz swoją bazę wiedzy",
	default_knowledge_base: "Baza wiedzy CNIL (domyślnie)",
	filters: {
		all: "Wszystkie",
		definitions: "Definicje",
		general_measures: "Środki ochrony fizycznej",
		measures_on_data: "Środki ochrony logicznej",
		no_result: "Nie znaleziono.",
		organizational_measures: "Środki organizacyjne",
		title: "Filtry"
	},
	placeholder_add_measure: "Dodanie środka",
	placeholder_help: "Pomoc",
	search: "Szukanie",
	slugs: {
		PIA_DEF_ACC: {
			description: "Osoba, której dane dotyczą, jest uprawniona do uzyskania od administratora potwierdzenia, czy przetwarzane są dane osobowe jej dotyczące, a jeżeli ma to miejsce, jest uprawniona do uzyskania dostępu do nich oraz informacji opisanych w <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 [RODO]</a>",
			name: "Prawo dostępu",
			source: "RODO Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Celem anonimizacji jest wyeliminowanie możliwości identyfikacji danych osobowych. Sposób anonimizacji należy opracować za każdym razem od nowa uwzględniając określone zastosowanie. W celu oceny właściwego sposobu anonimizacji, wytyczna <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_pl.pdf\">G29</a> proponuje trzy kryteria :<br>- <strong>Wyodrębnienie : </strong>czy jest możliwość wydzielenia określonej osoby fizycznej ?<br>- <strong>Możliwość tworzenia powiązań : </strong>czy jest możliwe powiązanie ze sobą zestawów odrębnych zestawów danych dotyczących tej samej osoby fizycznej ?<br>- <strong>Wnioskowanie :</strong> czy można wydedukować informacje dotyczące określonej osoby fizycznej ? <br>Zatem : <strong>zestaw danych, z którego nie można ani wyodrębnić ani utworzyć powiązań ani wnioskować, jest a priori anonimowy</strong> ;<br>zestaw danych, w przypadku którego <strong>co najmniej jedno z trzech kryteriów nie jest spełnione </strong>będzie można uznać za anonimowe tylko w wyniku szczegółowej analizy ryzyka ponownej identyfikacji.",
			name: "Anonimizacja",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_pl.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Należy archiwizować dane, które nie są już wykorzystywane na co dzień, lecz których termin przechowywania jeszcze nie upłynął, np. dane, które są przechowywane na wypadek spraw spornych.<br><strong>Archiwa należy zabezpieczyć </strong>, szczególnie jeżeli zawierają dane wrażliwe lub dane, które mogą mieć poważne skutki dla osób, których te dane dotyczą.",
			name: "Archiwizacja",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Każda osoba, która ma prawo dostępu do danych osobowych (pracownicy, dostawcy oraz inne strony trzecie), powinna być rozpoznawana za pomocą unikalnego identyfikatora. Należy dobrać metodę identyfikacji właściwą dla kontekstu, poziomu ryzyka i oczekiwanej odporności. Zalecenia: jeżeli ryzyko jest niskie, można korzystać tylko z tego co wiemy, czyli np. hasła; jeżeli ryzyko jest wysokie, należy korzystać także z tego co mamy, czyli np. tokena i/lub z tego, co nas charakteryzuje, czyli np. odcisku palca lub podpisu.",
			name: "Identyfikacja",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Szyfrowanie wiadomości pozwala zapewnić, że jedynie nadawca i prawowity odbiorca będą znali jej treść. Po zaszyfrowaniu żaden człowiek ani maszyna nie odczyta wiadomości bez znajomości klucza (szyfrowanie symetryczne lub asymetryczne, korzystanie z publicznych algorytmów uznanych za sile, certyfikat uwierzytelniający, itd.).",
			name: "Szyfrowanie",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Zestaw metod pozwalających ograniczyć prawdopodobieństwo korelacji danych osobowych i doprowadzenia do naruszenia wszystkich danych osobowych.<br>Można np. zidentyfikować dane osobowe potrzebne dla każdego procesu biznesowego i je logicznie rozdzielić, itd.",
			name: "Partycjonowanie danych",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Dobrowolne, konkretne, świadome i jednoznaczne okazanie woli, którym osoba, której dane dotyczą, w formie oświadczenia lub wyraźnego działania potwierdzającego, przyzwala na przetwarzanie dotyczących jej danych osobowych.<br><a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 4.11 [RODO]</a>",
			name: "Zgoda",
			source: "RODO Art. 4.11"
		},
		PIA_DEF_CTLA: {
			description: "Należy ograniczyć ryzyko, że osoby nieupoważnione uzyskają dostęp do danych osobowych w postaci elektronicznej.<br>W tym celu należy:<br>- <strong>zdefiniować profile użytkowników</strong> w systemach rozdzielając zadania i zakresy odpowiedzialności, by ograniczyć dostęp użytkowników wyłącznie do danych osobowych ściśle niezbędnych do wykonania swoich obowiązków. <br>- <strong>usuwać uprawnienia użytkownikom, gdy tylko nie są już upoważnieni do dostępu do danego pomieszczenia lub zasobu informatycznego</strong>, jak również <strong>na koniec ich umowy o pracę lub kontraktu.</strong> <br>- <strong> dokonywać co roku przeglądu upoważnień</strong> w celu identyfikacji i usunięcia kont nieużywanych oraz dostosowania przyznanych praw do funkcji każdego użytkownika.",
			name: "Kontrola dostępu logicznego",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Informacje o zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej („osobie, której dane dotyczą”); możliwa do zidentyfikowania osoba fizyczna to osoba, którą można bezpośrednio lub pośrednio zidentyfikować, w szczególności na podstawie identyfikatora takiego jak imię i nazwisko, numer identyfikacyjny, dane o lokalizacji, identyfikator internetowy lub jeden bądź kilka szczególnych czynników określających fizyczną, fizjologiczną, genetyczną, psychiczną, ekonomiczną, kulturową lub społeczną tożsamość osoby fizycznej. <br><a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 4.1 [RODO]</a>",
			name: "Dane osobowe",
			source: "RODO Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Osoba fizyczna lub prawna, organ publiczny, jednostka lub inny podmiot, któremu ujawnia się dane osobowe, niezależnie od tego, czy jest stroną trzecią. Organy publiczne, które mogą otrzymywać dane osobowe w ramach konkretnego postępowania zgodnie z prawem Unii lub prawem państwa członkowskiego, nie są jednak uznawane za odbiorców; przetwarzanie tych danych przez te organy publiczne musi być zgodne z przepisami o ochronie danych mającymi zastosowanie stosownie do celów przetwarzania. <br><a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 4.9 [RODO]</a>",
			name: "Odbiorca",
			source: "RODO Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Osoba, której dane dotyczą, ma prawo żądania od administratora niezwłocznego usunięcia dotyczących jej danych osobowych, a administrator ma obowiązek bez zbędnej zwłoki usunąć dane osobowe - <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 17 [RODO]</a>",
			name: "Prawo do usunięcia danych",
			source: "RODO Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Motywacje, które doprowadziły do wdrożenia czynności przetwarzania, oczekiwane korzyści (dla organizacji, dla osób, których dane dotyczą, dla społeczeństwa, itd.).",
			name: "Stawki przetwarzania",
			source: "PIA1 p4 przypis 8"
		},
		PIA_DEF_EXA: {
			description: "Dane osobowe muszą być prawidłowe i w razie potrzeby uaktualniane; należy podjąć wszelkie rozsądne działania, aby dane osobowe, które są nieprawidłowe w świetle celów ich przetwarzania, zostały niezwłocznie usunięte lub sprostowane („prawidłowość”). <br><a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 5.1 d) [RODO]</a>",
			name: "Jakość danych",
			source: "RODO Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Istotność oznacza wielkość ryzyka. Przede wszystkim zależy od szkodliwego charakteru potencjalnych skutków.",
			name: "Istotność",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Osoba, której dane dotyczą, ma prawo żądania od administratora ograniczenia przetwarzania - <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 18 [RODO]</a>",
			name: "Prawo do ograniczenia przetwarzania",
			source: "RODO Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Należy prowadzić rejestrowanie działań mających znaczenia dla funkcjonowania systemu w celu <strong>identyfikacji nieupoważnionego dostępu do</strong> lub <strong>niewłaściwego wykorzystania</strong> danych osobowych, bądź w celu ustalenia źródła incydentu. W tym celu należy dokumentować zdarzenia w dziennikach systemów (logach), <strong>rejestrując istotne zdarzenia</strong> oraz <strong>gwarantując, że nie będzie można zmodyfikować zapisów tych zdarzeń.</strong>",
			name: "Logi",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Tryb działania składający się z jednego lub kilku pojedynczych oddziaływań na nośniki danych. Zagrożenie może zostać wykorzystane, świadomie lub nie, przez źródła ryzyka i może wtedy doprowadzić do niepożądanego zdarzenia.",
			name: "Zagrożenie",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "<strong>Zagrożenia dotyczące:</strong><br>- <strong>Sprzętu</strong> wykorzystywanego w sposób niewłaściwy, obserwowanego, modyfikowanego lub zgubionego (korzystanie z nośnika zawierającego dane wrażliwe dla własnych celów lub nieprzystosowanego do danego sposobu transportu, obserwowanie ekranu bez wiedzy zainteresowanego, podłączenie key-loggera, itp.)<br>- <strong>Oprogramowania</strong>, wykorzystywanego w sposób niewłaściwy, obserwowanego, modyfikowanego (zwiększenie przywilejów, zbieranie danych konfiguracyjnych, zainfekowanie złośliwym kodem, itp.)<br>- <strong>Kanałów informatycznych</strong> obserwowanych (podsłuch ruchu w sieci, itp.)<br>- <strong>Osób</strong> obserwowanych, manipulowanych lub zagubionych (nieumyślne ujawnienie informacji, social engineering, zmiana pracodawcy, itp.)<br>- <strong>Dokumentów papierowych</strong>, obserwowanych lub zgubionych (fotokopie, zapomniane wydruki, kradzież poczty, itp.)<br>- <strong>Kanałów przesyłu papieru</strong> obserwowanych.",
			name: "Zagrożenia, które mogą doprowadzić do nieuprawnionego dostępu",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Zagrożenia dotyczące:</strong><br>- <strong>Sprzętu</strong> niewłaściwie wykorzystywanego, przeciążonego, zmienionego, uszkodzonego, utraconego (zapełnienie jednostki pamięci, atak DDOS, modyfikacja doprowadzająca do awarii, pożar, kradzież lub utrata, itp.)<br>- <strong>Oprogramowania</strong> niewłaściwie wykorzystywanego, przeciążonego, zmienionego, uszkodzonego, utraconego (skasowanie danych, bomba logiczna, nieodnowiona licencja, itp.)<br>- <strong>Kanałów informatycznych</strong> przeciążonych, zmienionych, utraconych (nieupoważnione pobieranie, utrata połączenia z internetem, itp.)<br>- <strong>Osób</strong> przepracowanych, osłabionych, utraconych (kiepskie wykorzystanie kompetencji, choroba, emerytura, itp.)<br>- <strong>Dokumentów papierowych</strong> niewłaściwie wykorzystywanych, uszkodzonych, utraconych (usunięcie, starzenie się archiwów, kradzież lub utrata dokumentów, itp.)<br>- <strong>Kanałów przesyłu papieru</strong> przeciążonych, uszkodzonych, utraconych (strajk poczty, zmiana lokalizacji, zaginięcie przesyłki, reorganizacja, itp.).",
			name: "Zagrożenia, które mogą doprowadzić do braku dostępności danych osobowych",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Zagrożenia dotyczące:</strong><br>- <strong>Sprzętu</strong> zmodyfikowanego (podłączenie sprzętu niekompatybilnego, odłączenie sprzętu niezbędnego do pracy, itp.)<br>- <strong>Oprogramowania</strong> wykorzystywanego w sposób niewłaściwy lub zmodyfikowanego (błąd przetwarzania, nieodpowiednie modyfikacje, itp.)<br>- <strong>Kanałów informatycznych</strong> wykorzystywanych niewłaściwie (ponowne wysłanie przechwyconej transmisji, itp.)<br>- <strong>Osób</strong> przepracowanych lub manipulowanych (obowiązki przerastające kompetencje, stres lub negatywne zmiany w miejscu pracy, negatywny wpływ, itp.)<br>- <strong>Dokumentów papierowych</strong> zmodyfikowanych (modyfikacja dokumentu, podmiana na fałszywy, itp.)<br>- <strong>Kanałów przesyłu papieru</strong> zmodyfikowanych (zamiana podpisów, wysłanie wielu sprzecznych dokumentów, itp.).",
			name: "Zagrożenia, które mogą doprowadzić do niepożądanej modyfikacji danych osobowych",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Należy wybrać spośród tych wymienionych w sekcji \"Środki planowane lub istniejące\", które można uzupełnić w razie potrzeby.",
			name: "Środki",
			source: "Brak"
		},
		PIA_DEF_MIN1: {
			description: "W przypadku importu danych, różne rodzaje metadanych (takie jak dane EXIF dołączone do pliku graficznego) mogą być zbierane nieumyślnie.<br>Te metadane należy zidentyfikować i usunąć, jeżeli nie są niezbędne dla wyznaczonych celów przetwarzania.",
			name: "Filtrowanie i usuwanie",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Po otrzymaniu danych wrażliwych, wchodzących w skład zestawu informacji ogólnych lub przesłanych jedynie dla celów statystycznych, można je zamienić w postać mniej wrażliwą bądź spseudonimizowaną. Na przykład:<br>- jeżeli system zbiera adresy IP w celu ustalenia lokalizacji użytkownika dla celów statystycznych, można usuwać adres IP po ustaleniu miasta lub dzielnicy;<br>- jeżeli system otrzymuje dane wideo z kamer monitoringu, można rozpoznać osoby stojące lub będące w ruchu i je zamazać;<br>- jeżeli system jest licznikiem inteligentnym, może agregować zużycie energii elektrycznej w okreslonym czasie, bez zapisów w czasie rzeczywistym.",
			name: "Zmniejszenie wrażliwości poprzez konwersję",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "System może zapewnić, że: <br>- użytkownik skorzysta z zasobu lub usługi bez ryzyka ujawnienia swojej tożsamości (dane anonimowe);<br>- użytkownik skorzysta z zasobu lub usługi bez ryzyka ujawnienia swojej tożsamości, lecz będzie identyfikowalny i odpowiedzialny za skorzystanie z nich (dane spseudonimizowane)<br>- użytkownik skorzysta wielokrotnie z zasobów i usług bez ryzyka powiązania tych różnych zastosowań (danych nie można skorelować)<br>- użytkownik skorzysta z zasobu lub usługi bez ryzyka, że inni, w szczególności strony trzecie, będą mogły obserwować, do czego zasób lub usługa są wykorzystywane (nieobserwowalność)<br>Wybór metody z powyższej listy powinien zależeć od zidentyfikowanych zagrożeń. Dla niektórych zagrożeń dla prywatności, pseudonimizacja będzie bardziej stosowna niż anonimizacja (np. jeżeli jest potrzeba prześledzenia korzystania). Ponadto, obsługa niektórych zagrożeń dla prywatności będzie wymagała kombinacji kilku metod.",
			name: "Ograniczenie charakteru identyfikacyjnego danych",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "System można tak zorganizować, by składał się z niezależnych części z oddzielnymi funkcjami kontroli dostępu. Dane można także podzielić pomiędzy te niezależne podsystemy, zaś każdy podsystem może je kontrolować korzystając z różnych mechanizmów kontroli dostępu. Jeżeli podsystem zostanie naruszony, można w ten sposób ograniczyć skutki dla całości danych.",
			name: "Ograniczenie kumulacji danych",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "System może ograniczać dostęp do danych zgodnie z zasadą \"wiedzy koniecznej\". System może rozdzielać dane wrażliwe i zastosować określone polityki kontroli dostępu. System może także szyfrować dane wrażliwe, by chronić ich poufność w czasie transmisji i przechowywania. Należy także chronić dostęp do tymczasowych plików ciasteczek (cookies) generowanych w trakcie przetwarzania.",
			name: "Ograniczenie dostępu do danych",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Ograniczenie istotności ryzyka poprzez ograniczenie danych osobowych do tego, co absolutnie niezbędne do wyznaczonego celu, w przeciwnym wypadku dane nie powinny być zbierane.",
			name: "Minimalizacja danych osobowych",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Zmniejszenie wagi zagrożeń poprzez minimalizację samych danych. Minimalizacji danych można dokonać poprzez podjęcie działań mających na celu zmniejszenie ich wrażliwości, takich jak: filtrowanie i usuwanie niepotrzebnych danych, stosowanie pseudonimizacji danych itp.",
			name: "Minimalizacja samych danych",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Osoba, której dane dotyczą, ma prawo w dowolnym momencie wnieść sprzeciw – z przyczyn związanych z jej szczególną sytuacją – wobec przetwarzania dotyczących jej danych osobowych, zgodnie z <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 21 [RODO]</a>",
			name: "Prawo do sprzeciwu",
			source: "RODO Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Działania podejmowane, by uwzględnić ochronę danych osobowych w każdej nowej czynności przetwarzania (znaki zaufania, wytyczne, metodologia CNIL zarządzania ryzykiem).",
			name: "Zarządzanie projektami",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Osoba, której dotyczą dane podlegające przetwarzaniu.",
			name: "Osoba, której dane dotyczą",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " Osoba, której dane dotyczą, ma prawo otrzymać w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego dane osobowe jej dotyczące, które dostarczyła administratorowi, oraz ma prawo przesłać te dane osobowe innemu administratorowi bez przeszkód ze strony administratora, któremu dostarczono te dane osobowe - <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 20 [RODO]</a>",
			name: "Prawo do przenoszenia danych",
			source: "RODO Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Przetworzenie danych osobowych w taki sposób, by nie można ich było już przypisać konkretnej osobie, której dane dotyczą, bez użycia dodatkowych informacji, pod warunkiem że takie dodatkowe informacje są przechowywane osobno i są objęte środkami technicznymi i organizacyjnymi uniemożliwiającymi ich przypisanie zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej.<br>Pseudonimizacja ogranicza możliwość powiązania zbioru danych z oryginalną tożsamością osoby, której dane dotyczą; jest to przydatny środek bezpieczeństwa ale nie metoda anonimizacji.",
			name: "Pseudonimizacja",
			source: "RODO Art. 4.5 oraz wytyczne str. 22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Uwierzytelnianie za pomocą nazwy i hasła użytkownika stanowi prosty i tani sposób kontroli dostępu. Jednakże dla wyższego poziomu ochrony zaleca się m.in., by:<br>wymagano hasła złożonego z co najmniej 8 znaków obejmujących duże i małe litery oraz cyfry i znaki specjalne;<br>przy zmianie hasła - uniemożliwiać skorzystanie z ostatnich pięciu haseł;<br> używać różnych haseł do różnych dostępów;<br>hasła nie były powiązane z danymi osobistymi (np. data urodzenia własna czy dziecka.<br>Należy określić maksymalną liczbę nieudanych prób logowania się przed zablokowaniem konta użytkownika.",
			name: "Hasło",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Osoba, której dane dotyczą, ma prawo żądania od administratora niezwłocznego sprostowania dotyczących jej danych osobowych, które są nieprawidłowe. Z uwzględnieniem celów przetwarzania, osoba, której dane dotyczą, ma prawo żądania uzupełnienia niekompletnych danych osobowych, w tym poprzez przedstawienie dodatkowego oświadczenia - <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 16 [RODO]</a>",
			name: "Prawo do sprostowania danych",
			source: "RODO Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Rozporządzenie w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.",
			name: "RODO (Ogólne Rozporządzenie o Ochronie Danych)",
			source: "Tytuł RODO"
		},
		PIA_DEF_RT: {
			description: "Osoba fizyczna lub prawna, organ publiczny, jednostka lub inny podmiot, który samodzielnie lub wspólnie z innymi ustala cele i sposoby przetwarzania danych osobowych; jeżeli cele i sposoby takiego przetwarzania są określone w prawie Unii lub w prawie państwa członkowskiego, to również w prawie Unii lub w prawie państwa członkowskiego może zostać wyznaczony administrator lub mogą zostać określone konkretne kryteria jego wyznaczania.<br><a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 4.7 [RODO]</a>",
			name: "Administrator",
			source: "RODO Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Osoba, z wewnątrz lub zewnątrz organizacji, działająca w sposób niezamierzony lub świadomy (np. administrator IT, użytkownik, osoba atakująca z zewnątrz, konkurencja) lub źródło nieosobowe (np. woda, materiały niebezpieczne, wirus komputerowy), które mogą stanowić ryzyko.",
			name: "Źródło ryzyka",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Osoba fizyczna lub prawna, organ publiczny, jednostka lub inny podmiot, który przetwarza dane osobowe w imieniu administratora <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 4.8 [RODO]</a>.<br>Podmiot przetwarzający oraz każda osoba działająca z upoważnienia administratora lub podmiotu przetwarzającego i mająca dostęp do danych osobowych przetwarzają je wyłącznie na polecenie administratora, chyba że wymaga tego prawo Unii lub prawo państwa członkowskiego <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 29 [RODO]</a>.",
			name: "Podmiot przetwarzający",
			source: "RODO Art. 4.8 i 29"
		},
		PIA_DEF_SUPT: {
			description: "<strong>Sprzęt i nośniki danych osobowych</strong>: komputery, przekaźniki, klucze USB, dyski twarde...<br><strong>Oprogramowanie</strong>: systemy eksploatacyjne, komunikatory, bazy danych, aplikacje biznesowe...<br><strong>Kanały informacyjne</strong>: kable, WiFi, światłowody<br><br><strong>Osoby</strong>: użytkownicy, administratorzy systemów, decydenci...<br><strong>Nośniki papierowe</strong>: wydruki, fotokopie, rękopisy...<br><strong>Kanały przesyłania papieru</strong>: poczta, obieg dokumentów...",
			name: "Zasoby wspierające",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Naruszenie ochrony prowadzące do przypadkowego lub nielegalnego zniszczenia, utraty, zmiany, nieuprawnionego ujawnienia danych osobowych przesyłanych, przechowywanych bądź przetwarzanych w dowolny inny sposób.",
			name: "Naruszenie ochrony danych",
			source: "RODO Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Prawdopodobieństwo oznacza możliwość ziszczenia się ryzyka. Przede wszystkim zależy od podatności zasobów na zagrożenia oraz zdolności źródeł ryzyka do ich wykorzystania.",
			name: "Prawdopodobieństwo",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Dane identyfikacyjne</strong>: stan cywilny, wiek, narodowość, adres pocztowy, itd. <br><strong>Życie osobiste</strong>: stan cywilny, liczba dzieci, rodzaj mieszkania, długość zamieszkania w danym miejscu, itd. <br><strong>Życie zawodowe</strong>: zawód, wykształcenie i kompetencje zawodowe, miejsce pracy, długość stażu pracy, bezrobocie, itd. <br><strong>Dane połączeniowe</strong>: adresy IP, logi zdarzeń, itd.<br><strong>Dane lokalizacyjne</strong>: podróże, dane GP, dane GSM, itd.<br><strong>Inne</strong>: numer telefonu, adres email, itd.",
			name: "Zwykłe dane osobowe",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Poglądy filozoficzne, polityczne, religijne i związkowe, życie seksualne, dane zdrowotne, pochodzenia rasowego lub etnicznego, dotyczące wykroczeń, skazań, środki bezpieczeństwa - <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/PL/TXT/HTML/?uri=CELEX:32016R0679&from=PL\">Art. 9 i 10 [RODO]</a>.",
			name: "Skazania i dane wrażliwe"
		},
		PIA_EX_DCPS: {
			description: "Numer PESEL, dane biometryczne, dane bankowe",
			name: "Dane osobowe postrzegane jako wrażliwe"
		},
		PIA_EX_HUME: {
			description: "Może rozchodzić się o:<br>- osobę trzecią mającą złe zamiary lub nieobeznanego, wykorzystującego bliskość fizyczną, by podstępnie uzyskać dostęp do usługi;<br>- hakera obierającego za cel użytkownika wykorzystując swoją znajomość użytkownika i pewnych informacji o nim;<br>- hakera obierającego za cel jedną z firm przetwarzających wykorzystując swoją znajomość firmy do ewentualnego naruszenia jej wizerunku;<br>- upoważniony podmiot trzeci wykorzystujący swój dostęp uprzywilejowany do bezprawnego dostępu do informacji.<br>Ich motywacje mogą być różne: zabawa, chęć dokuczenia, zła wola, zemsta, szpiegostwo, chęć zysku, pozyskanie danych w celu ich wykorzystania.",
			name: "Źródła osobowe zewnętrzne"
		},
		PIA_EX_HUMI: {
			description: "Może rozchodzić się o:<br>- pracownika niedbałego lub mającego złe zamiary, wykorzystującego bliskość systemu, swoje kompetencje, przywileje i dostępny czas potencjalnie wysokie lub dopuszczającego się zaniedbania wskutek braku przeszkolenia lub świadomości;<br>- użytkownika lub jego otoczenie, niedbałego lub mającego złe zamiary, z dostępem do usługi.<br>Ich motywacje mogą być różne: bezmyślność, błąd, zaniedbanie, zemsta, chęć zaalarmowania, zła wola, chęć zysku, szpiegostwo.",
			name: "Źródła osobowe wewnętrzne"
		},
		PIA_EX_IMPI: {
			description: "Osoby, których dane dotyczą, mogą doznać znaczących konsekwencji, z którymi powinny sobie poradzić ale przy realnych i istotnych trudnościach.<br>Przykłady skutków:<br>- fizyczne: poważna dolegliwość fizyczna powodująca długotrwałą szkodę (pogorszenie stanu zdrowia wskutek złej opieki lub zlekceważenia przeciwwskazań), naruszenie integralności cielesnej (np. w wyniku napadu, wypadku w domu lub w pracy), itd.<br>- materialne: kradzież pieniędzy bez odszkodowania, stracone niepowtarzalne i unikalne szanse (odmowa kredytu mieszkaniowego, studiów, stażu lub pracy, zakaz zdawania egzaminu), utrata mieszkania, utrata pracy, itd.<br>- moralne: poważna dolegliwość psychiczna (depresja, fobia), uczucie naruszenia prywatności z poczuciem krzywdy nie do naprawienia, ofiara szantażu, cyberbullying i nękanie moralne, itd.",
			name: "Skutki poważne"
		},
		PIA_EX_IMPL: {
			description: "Osoby, których dane dotyczą, mogą doznać znaczących niedogodności, z którymi sobie poradzą pomimo różnych trudności.<br>Przykłady skutków:<br>- fizyczne: drobna dolegliwość fizyczna (np.: choroba na skutek zlekceważenia przeciwwskazań), zniesławienie doprowadzające do fizycznego odwetu, itd.<br>- materialne: nieplanowane płatności (np.: grzywny błędnie nałożone), odmowa dostępu do usług administracyjnych lub komercyjnych, marketing ukierunkowany dotyczący aspektu życia, który dana osoba chciałaby zachować dla siebie, itd.<br>- moralne: drobna lecz obiektywna dolegliwość psychiczna, uczucie naruszenia prywatności bez poczucia krzywdy nie do naprawienia, zastraszenie w mediach społecznościowych, itd.",
			name: "Skutki ograniczone"
		},
		PIA_EX_IMPM: {
			description: "Osoby, których dane dotyczą, mogą doznać znaczących konsekwencji, wręcz nie do naprawienia, z którymi sobie nie poradzą.<br>Przykłady skutków:<br>- fizyczne: długotrwała lub trwała dolegliwość fizyczna, trwałe naruszenie integralności fizycznej, zgon<br>- materialne: ryzyko finansowe, znaczące długi, niemożność podjęcia pracy, niemożność zmiany miejsca zamieszkania, utrata dowodów w sprawie sądowej, utrata dostępu do kluczowej infrastruktury (woda, prąd), itd.<br>- moralne: długotrwała lub trwała dolegliwość psychiczna, sankcje karne, porwanie, utrata więzi rodzinnych, niemożność pozwania przed sądem, zmiana statusu administracyjnego i/lub utrata autonomii prawnej (kuratela), itd.",
			name: "Skutki maksymalne"
		},
		PIA_EX_IMPN: {
			description: "Osoby, których dane dotyczą, nie poniosą żadnych skutków lub doznają drobnych niedogodności, z którymi sobie poradzą bez problemu.<br>Przykłady skutków:<br>- fizyczne: przemijający ból głowy<br>- materialne: strata czasu na ponowne dopełnienie formalności lub czekanie na ich dopełnienie, ponowne wykorzystanie danych ze stron internetowych dla marketingu ukierunkowanego, itd.,<br>- moralne: drobna przykrość, uczucie naruszenia prywatności bez poczucia realnej krzywdy (natrętność handlowa), etc.",
			name: "Skutki pomijalne"
		},
		PIA_EX_NHUM: {
			description: "Może rozchodzić się o incydent lub szkodę u jednego z podmiotów przetwarzających (przerwa w zasilaniu, pożar, zalanie, itd.).",
			name: "Źródła nieosobowe"
		},
		PIA_EX_VRAI: {
			description: "Wydaje się możliwe, że wybrane źródła ryzyka doprowadzą do zmaterializowania się zagrożenia poprzez wykorzystanie zasobów (np.: kradzież wydruków składowanych w pomieszczeniach biurowych podmiotu, do którego dostępu pilnuje osoba w recepcji).",
			name: "Prawdopodobieństwo poważne"
		},
		PIA_EX_VRAL: {
			description: "Wydaje się trudne, by wybrane źródła ryzyka doprowadziły do zmaterializowania się zagrożenia poprzez wykorzystanie zasobów (np.: kradzież wydruków składowanych w pomieszczeniu, do którego dostęp zabezpieczono czytnikiem kart).",
			name: "Prawdopodobieństwo ograniczone"
		},
		PIA_EX_VRAM: {
			description: "Wydaje się oczywiste, że wybrane źródła ryzyka doprowadzą do zmaterializowania się zagrożenia poprzez wykorzystanie zasobów (np.: kradzież wydruków składowanych w holu ogólnym w siedzibie podmiotu).",
			name: "Prawdopodobieństwo maksymalne"
		},
		PIA_EX_VRAN: {
			description: "Nie wydaje się możliwe, by wybrane źródła ryzyka doprowadzą do zmaterializowania się zagrożenia poprzez wykorzystanie zasobów (np.: kradzież wydruków składowanych w pomieszczeniu, do którego dostęp zabezpieczono czytnikiem kart i kodem dostępu).",
			name: "Prawdopodobieństwo pomijalne"
		},
		PIA_LGL_CONS: {
			description: "Należy umożliwić osobom, których dane dotyczą, dokonanie dobrowolnego, konkretnego i świadomego wyboru. Należy sprawdzić, czy podstawą prawną przetwarzania nie jest zgoda, zgodnie z artykułem 6 RODO (obowiązek prawny, ochrona życia, zadanie służby publicznej, umowa lub działania na żądanie osoby, której dane dotyczą, interes prawny).",
			name: "Zgoda",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Należy szczegółowo określić i opisać zasięg: <br> - rozpatrywane dane osobowe, ich odbiorcy oraz czas przechowywania ;<br> - opis procesów i nośników danych dla całego cyklu życia danych (od ich zebrania aż do ich usunięcia).",
			name: "Przetwarzane dane",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Należy w sposób syntetyczny opisać rozważane przetwarzanie, jego cele i wyzwania. Należy zidentyfikować administratora danych i ewentualne podmioty przetwarzające. Należy spisać zasady odnoszące się do tego przetwarzania, przydatne lub wymagające przestrzegania, w tym zatwierdzone kodeksy postępowania (art. 40 RODO) oraz certyfikacje w zakresie ochrony danych (art. 42 RODO).",
			name: "Opis przetwarzania",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Osoba fizyczna lub prawna, organ publiczny, jednostka lub inny podmiot, któremu ujawnia się dane osobowe, niezależnie od tego, czy jest stroną trzecią. Organy publiczne, które mogą otrzymywać dane osobowe w ramach konkretnego postępowania zgodnie z prawem Unii lub prawem państwa członkowskiego, nie są jednak uznawane za odbiorców; przetwarzanie tych danych przez te organy publiczne musi być zgodne z przepisami o ochronie danych mającymi zastosowanie stosownie do celów przetwarzania (art. 4 pkt 9 RODO).",
			name: "Odbiorcy",
			source: "RODO art 4.9"
		},
		PIA_LGL_DUR: {
			description: "Należy zdefiniować czas przechowywania każdego rodzaju danych i uzasadnić ten czas potrzebami przetwarzania i/lub wymogami prawnymi. W ten sposób rozróżnia się dane bieżące i dane zarchiwizowane, do których dostęp będzie zawężony tylko do stosownych aktorów. Należy wdrożyć mechanizm usuwania w celu archiwizacji danych bieżących bądź wyczyścić dane zarchiwizowane na koniec okresu przechowywania. Należy także wyczyścić ślady użytkowe, takie jak logi techniczne, których nie można przechowywać w nieskończoność.",
			name: "Czas przechowywania danych",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Dane osobowe powinny być zbierane w konkretnych, wyraźnych i prawnie uzasadnionych celach i <strong> nieprzetwarzane dalej w sposób niezgodny z tymi celami</strong>; <br> Tak jak zapisano w art. 5b RODO.",
			name: "Cele zbierania i wykorzystania danych osobowych",
			source: "RODO art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Osoba, której dane dotyczą, wyraziła zgodę na przetwarzanie swoich danych osobowych w jednym lub większej liczbie określonych celów <br> - Przetwarzanie jest niezbędne do wykonania umowy, której stroną jest osoba, której dane dotyczą, lub do podjęcia działań na żądanie osoby, której dane dotyczą, przed zawarciem umowy <br> - Przetwarzanie jest niezbędne do wypełnienia obowiązku prawnego ciążącego na administratorze <br> - Przetwarzanie jest niezbędne do ochrony żywotnych interesów osoby, której dane dotyczą, lub innej osoby fizycznej <br> - Przetwarzanie jest niezbędne do wykonania zadania realizowanego w interesie publicznym lub w ramach sprawowania władzy publicznej powierzonej administratorowi <br> - Przetwarzanie jest niezbędne do celów wynikających z prawnie uzasadnionych interesów realizowanych przez administratora lub przez stronę trzecią, z wyjątkiem sytuacji, w których nadrzędny charakter wobec tych interesów mają interesy lub podstawowe prawa i wolności osoby, której dane dotyczą, wymagające ochrony danych osobowych, w szczególności gdy osoba, której dane dotyczą, jest dzieckiem. Należy zapoznać się z art. 6 Rozporządzenia 2016/679.",
			name: "Podstawa prawna",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Należy zagwarantować informowanie osób, by uniknąć zbierania danych bez ich wiedzy. Należy upewnić się, że przetwarzanie nie jest objęte wyjątkiem lub nie podlega szczególnym warunkom.",
			name: "Informowanie osób, których dane dotyczą",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Należy zmniejszyć istotność ryzyka ograniczając zbieranie danych osobowych do absolutnie niezbędnych dla danego celu; unikając zbierania danych niepotrzebnych, korzystania z danych bez związku z celem oraz nadmiernych skutków dla osób.",
			name: "Minimalizacja danych",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Z każdym z podmiotów przetwarzających należy zawrzeć umowę o powierzeniu przetwarzania doprecyzowującą wszystkie elementy przewidziane w artykule 28 RODO: czas trwania, zasięg, udokumentowane instrukcje przetwarzania, wcześniejsze upoważnienie na wypadek korzystania z podmiotu przetwarzającego, udostępnienie całej dokumentacji udowadniającej przestrzeganie RODO, zgłaszanie niezwłocznie każdego naruszenia ochrony danych, itd.",
			name: "Powierzenie przetwarzania",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Aktywa, które wspomagają dane. Uwaga: to może być sprzęt, oprogramowanie, kanały informatyczne, osoby, nośniki papierowe bądź kanały przesyłu papieru.",
			name: "Aktywa wspomagające",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Należy szczegółowo określić położenie geograficzne miejsca składowania poszczególnych danych podlegających przetwarzaniu. W zależności od danego państwa, należy uzasadnić wybór umieszczenia poza Unią Europejską oraz wskazać procedury ram prawnych wprowadzone w celu zapewnienia odpowiedniej ochrony danych będących przedmiotem transferu transgranicznego.<br> To znaczy:<br>- W państwie Unii Europejskiej<br>- W państwie uznanym jako adekwatny przez Unię Europejską<br>- Przekazywanie do Stanów Zjednoczonych do spółki handlowej, która przystąpiła do Privacy Shield<br>- Inne państwa <br>Zgodnie z artykułami 44-49 RODO.",
			name: "Przekazywanie danych",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Wprowadzenie środków pozwalających uzyskiwać całościową i aktualną wizję stanu ochrony danych i zgodności z RODO (kontrola zgodności czynności przetwarzania, celów i wskaźników, zakresy odpowiedzialności, itd.).",
			name: "Nadzór",
			placeholder: "Należy wskazać, czy skuteczność i adekwatność mechanizmów kontrolnych dotyczących prywatności są monitorowane.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Wprowadzenie procedury mającej na celu ograniczenie ryzyka, że dozwolony dostęp stron trzecich do danych osobowych może mieć wpływ na prawa i wolności osób, których dane dotyczą (identyfikacja stron trzecich, umowy powierzenia, porozumienia, BCR, itd.).",
			name: "Relacje ze stronami trzecimi",
			placeholder: "Należy określić wdrożone procedury i środki odnoszące się do dostępu stron trzecich do danych osobowych w razie potrzeby.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Istnienie struktury organizacyjnej zdolnej do kierowania i nadzorowania ochrony danych osobowych (wyznaczenie IOD, powołanie komitetu monitorującego, itd.).",
			name: "Organizacja",
			placeholder: "Należy wskazać, czy określono role i odpowiedzialności za ochronę danych osobowych.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Wprowadzenie procedur opisujących metody uwzględniania ochrony danych osobowych w przypadku każdej nowej czynności przetwarzania.",
			name: "Uwzględnianie ochrony prywatności w projektach",
			placeholder: "Należy opisać, w jaki sposób ochrona prywatności jest uwzględniana w projektach.",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Wprowadzenie planu wyznaczającego <strong>sposoby uświadamiania</strong> podejmowane w stosunku do nowego pracownika oraz procedury opisującej <strong>środki podejmowane w stosunku do osób odchodzących z pracy</strong>.",
			name: "Zarządzanie pracownikami",
			placeholder: "Nalezy wskazać, jakie działania uświadamiające są podejmowane w stosunku do pracowników.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Administrator powinien dysponować dokumentacją wyznaczającą formalnie cele i zasady, które będą stosowane dla ochrony danych osobowych (plan działania, regularne przeglądy polityki, ryzyka, itd.) oraz adresatów (użytkownicy, dział IT, itd.).",
			name: "Polityka ochrony danych osobowych",
			placeholder: "Należy opisać dokumentację wyznaczającą cele i zasady ochrony danych osobowych.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Polityka wyznaczająca proces kontroli ryzyka, że czynności przetwarzania w organizacji mogą wpłynąć na prawa i wolności osób, których dane dotyczą (rejestr czynności przetwarzania danych osobowych, danych, nośników, ocena ryzyka, ustalenie istniejących i planowanych środków, itd.).",
			name: "Zarządzanie ryzykiem",
			placeholder: "Należy opisać procesy kontroli ryzyka, że czynności przetwarzania mogą wpłynąć na prawa i wolności osób, których dane dotyczą.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Wprowadzenie operacyjnej struktury organizacyjnej pozwalającej wykrywać i obsługiwać zdarzenia, które mogą mieć wpływ na prawa i wolności osób, których dane dotyczą (określenie odpowiedzialności, plan reagowania, klasyfikacja naruszeń, itd.).",
			name: " Zarządzanie naruszeniami ochrony danych osobowych",
			placeholder: "Należy wskazać, czy wdrożono udokumentowaną i przetestowaną procedurę zarządzania incydentami IT.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Polityki kopii zapasowych i środki pozwalające zapewnić dostępność i/lub integralność danych osobowych, jak również ich poufność (regularność kopii zapasowych, szyfrowanie kanału transmisji danych, test integralności, itd.).",
			name: "Kopie zapasowe",
			placeholder: "Należy opisać, w jaki sposób kopie zapasowe są zarządzane. Należy wyjaśnić, czy są przechowywane w bezpiecznym miejscu.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Środki wdrożone na stacjach roboczych (automatyczna blokada, regularne aktualizacje, konfiguracja, bezpieczeństwo fizyczne, itd.) w celu ograniczenia prawdopodobieństwa, że właściwości oprogramowania (systemy operacyjne, aplikacje biznesowe, oprogramowanie biurowe, parametryzacje itp.) zostaną wykorzystane do naruszenia danych osobowych.",
			name: "Zarządzanie stacjami roboczymi",
			placeholder: "Należy opisać środki ochrony wdrożone na stacjach roboczych.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "Dane osobowe ujawnione podmiotom przetwarzającym lub zarządzane przez nich powinny korzystać z odpowiednich gwarancji. <strong>Należy korzystać z usług wyłącznie podmiotów przetwarzających, które zapewniają wystarczające gwarancje</strong> (w szczególności jeżeli chodzi o wiedzę fachową, wiarygodność i zasoby). Należy wymagać od usługodawcy ujawnienia swojej polityki bezpieczeństwa systemów informatycznych.<br>Należy podjąć działania (audyty bezpieczeństwa, oględziny instalacji, itd.), które pozwolą <strong>zapewnić skuteczność gwarancji oferowanych przez podmiot przetwarzający<strong> w sprawie ochrony danych i je dokumentować. Te gwarancje obejmują m.in.:<br> - szyfrowanie danych w zależności od ich wrażliwości lub w przypadku braku szyfrowania istnienie procedur gwarantujących, że usługodawca nie ma dostępu do danych, które zostały mu powierzone<br>- szyfrowanie transmisji danych (np. połączeń typu HTTPS, VPN, itd.)<br>- gwarancje dotyczące ochrony sieci, logów systemowych (dzienniki, ścieżki audytowe), zarządzania upoważnieniami, uwierzytelnianiem, itd.<br><strong>Należy opracować taką umowę z podmiotami przetwarzającymi</strong>, która określa m.in. przedmiot, czas trwania, cel przetwarzania i zobowiązania stron oraz upewnić się, że zawiera w szczególności postanowienia ustalające:<br>- ich zobowiązania w kwestii poufności powierzonych danych osobowych<br>- minimalne wymogi dotyczące uwierzytelniania użytkowników<br>- warunki zwrotu i/lub zniszczenia danych na końcu umowy<br>- zasady zarządzania incydentami i ich notyfikacji. Te zasady powinny obejmować zawiadomienie administratora w przypadku wykrycia naruszenia bezpieczeństwa lub incydentu bezpieczeństwa i to w najkrótszym możliwym czasie w przypadku naruszenia ochrony danych osobowych<br>- W przypadku korzystania z dostawcy cloud computing należy:<br>\t1. dokładnie zidentyfikować dane i czynności przetwarzania, które zostaną przeniesione do chmury ;<br>\t2. określić swoje wymagania dotyczące bezpieczeństwa technicznego i prawnego;<br>\t3. przeprowadzić analizę ryzyka w celu identyfikacji odpowiednich środków bezpieczeństwa;<br>\t4. zidentyfikować rodzaj chmury właściwy dla przewidywanego rodzaju przetwarzania;<br>\t5. wybrać usługodawcę wykazujący się wystarczającymi gwarancjami;<br>\t6. dokonać przeglądu wewnętrznej polityki bezpieczeństwa;<br>\t7. śledzić zmiany w czasie.",
			name: "Umowa powierzenia przetwarzania",
			placeholder: "Należy opisać gwarancje umowne zapewniające ochronę danych osobowych powierzonych podmiotowi przetwarzającemu.",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Polityki pozwalające ograniczyć prawdopodobieństwo i istotność ryzyk dotyczących narzędzi wykorzystywanych w trakcie eksploatacji (należy dokumentować procedury eksploatacyjne, wykaz i aktualizację oprogramowania i materiałów, korygowanie podatności, duplikowanie danych, ograniczenie dostępu fizycznego do sprzętu, itd.).",
			name: "Zabezpieczenie eksploatacji",
			placeholder: "Należy opisać środki wdrożone dla zagwarantowania aktualizacji i poziomu bezpieczeństwa wykorzystanego oprogramowania.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Środki wdrożone w celu umożliwienia wczesnego wykrywania incydentów dotyczących danych osobowych i analizy ruchu w sieciach (sieci kablowe, Wi-Fi, radiolinie, światłowody, itd.) w czasie rzeczywistym w celu wykrycia aktywności sugerującej cyberatak.",
			name: "Monitorowanie aktywności sieci",
			placeholder: "Należy opisać środki wdrożone w celu umożliwienia wykrycia incydentów dotyczących danych osobowych.",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Polityka konserwacji fizycznej sprzętu, określającej ewentualne skorzystanie z podwykonawców.<br>Powinna regulować konserwację zdalną, jeżeli jest dozwolona, oraz określać metody postępowania ze sprzętem wadliwym.",
			name: "Konserwacja",
			placeholder: "Należy opisać, w jaki sposób zarządza się konserwacją fizyczną sprzętu.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Środki ochrony wdrożone na stacjach roboczych i serwerach w celu ich ochrony przed złośliwym oprogramowaniem w trakcie korzystania z sieci słabo zabezpieczonych.",
			name: "Zwalczanie złośliwego oprogramowania",
			placeholder: "Należy opisać środki ochrony przed kodem złośliwym w czasie dostępu do sieci o niskim poziomie bezpieczeństwa.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Środki wdrożone w celu ograniczenia prawdopodobieństwa, że właściwości sprzętu (serwerów, stacji roboczych, urządzeń mobilnych, peryferyjnych, przełączników, itd.) zostaną wykorzystane w celu naruszenia danych osobowych (spis inwentaryzacyjny, partycjonowanie, redundancja sprzętowa, ograniczenie dostępu, itd.).",
			name: "Zabezpieczenie sprzętu (hardware)",
			placeholder: "Należy opisać środki wdrożone w celu ograniczenia ryzyka ataku na sprzęt wykorzystywany do przetwarzania.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "W zależności od rodzaju sieci, w której odbywa się przetwarzanie (izolowana, prywatna czy internet), administrator powinien wdrożyć odpowiednie systemy ochrony: zapora ogniowa, system wykrywania włamania lub inne urządzenia aktywne lub pasywne, które mają za zadanie zapewnić bezpieczeństwo sieci.",
			name: "Bezpieczeństwo sieci",
			placeholder: "Należy opisać, w jakiej sieci odbywa się przetwarzanie oraz za pomocą jakiego sprzętu została zabezpieczona.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Polityki kontroli dostępu fizycznego do pomieszczeń, w których odbywa się przetwarzanie (wyznaczanie stref, towarzyszenie gościom, noszenie identyfikatorów, zamykane drzwi, itd.). <br> Należy wskazać, czy wdrożono procedury alarmowania o włamaniu.",
			name: "Kontrola dostępu fizycznego",
			placeholder: "Należy opisać, jak realizowana jest kontrola dostępu fizycznego do miejsc, w których odbywa się przetwarzanie.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Środki wdrożone w celu ograniczenia lub uniknięcia nieosobowych źródeł ryzyka (zjawiska pogodowe, pożar, zalanie, wypadki wewnętrzne lub zewnętrzne, zwierzęta, zasilanie, itd.), które mogą naruszyć dane osobowe.",
			name: "Ochrona przed nieosobowymi źródłami ryzyka",
			placeholder: "Nalezy opisać środki wdrożone w celu ograniczenia lub uniknięcia nieosobowych źródeł ryzyka.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Środki, które pozwolą zapobiec, by źródła ryzyka, których można uniknąć, mogły naruszyć dane osobowe (niebezpieczne produkty, niebezpieczne strefy geograficzne, przekazywanie danych osobowych poza UE, itd.).",
			name: "Unikanie źródeł ryzyka",
			placeholder: "Należy wskazać, czy obszar przetwarzania znajduje się w strefie klęsk żywiołowych.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Wdrożenie rekomendacji dotyczących bezpieczeństwa stron www.",
			name: "Bezpieczeństwo stron www",
			placeholder: "Należy opisać środki wprowadzone w celu ochrony stron www.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Należy wskazać, czy wdrożono mechanizmy anonimizacji, które i w jakim celu. <br>Należy pamiętać o rozróżnieniu danych zanonimizowanych i poddanych pseudonimizacji.",
			name: "Anonimizacja",
			placeholder: "Należy opisać wdrożone mechanizmy anonimizacji",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Polityka przechowywania i zarządzania archiwami elektronicznymi zawierającymi dane osobowe mającymi zagwarantować jakość tych danych, w tym prawną, podczas całego wymaganego okresu (deponowanie, składowanie, migracja, dostępność, eliminowanie, polityka archiwizacji, ochrona poufności, itd.).",
			name: "Archiwizacja",
			placeholder: "Należy opisać wszystkie procedury przechowywania i zarządzania archiwami elektronicznymi zawierającymi dane osobowe.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Środki wprowadzone w celu <strong>zapewnienia poufności danych</strong> przechowywanych (w bazie danych, w plikach prostych, w kopiach, itp.) jak również procedury zarządzania kluczami szyfrującymi (tworzenie, przechowywanie, modyfikowanie w razie podejrzenie kompromitacji, itd.). <br>Należy szczegółowo opisać środki szyfrowania stosowane przy przepływach danych (VPN, TLS, itd.) następujących w trakcie przetwarzania.",
			name: "Szyfrowanie",
			placeholder: "Należy opisać środki kryptograficzne wdrożone w celu zapewnienia poufności i integralności danych",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Wdrożenie partycjonowania pomaga ograniczyć prawdopodobieństwo, że dane osobowe będzie można powiązać ze sobą oraz że dojdzie do naruszenia wszystkich danych.",
			name: "Partycjonowanie danych",
			placeholder: "Należy wskazać, czy przewiduje się partycjonowanie przetwarzania i jak będzie realizowane.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Opis sposobu, w jaki profile użytkowników są definiowane i przydzielane. Należy szczegółowo opisać wdrożone środki <strong>uwierzytelniania</strong> uściślając, gdy ma to zastosowanie, reguły stosowane dla haseł (minimalna długość, obowiązkowa składnia, okres ważności, liczba nieudanych prób przed blokadą konta, itd.).",
			name: "Kontrola dostępu logicznego",
			placeholder: "Należy opisać, jak są definiowane i przydzielane profile użytkowników.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Polityki tworzenia logów zdarzeń i przechowywania pozostawianych zapisów.",
			name: "Dzienniki systemowe (logi)",
			placeholder: "Należy wskazać, czy zdarzenia są zapisywane w dziennikach oraz okres przechowywania tych zapisów.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Można wykorzystać następujące sposoby: filtrowanie i usunięcie, ograniczenie wrażliwości poprzez konwersję, ograniczenie charakteru identyfikacyjnego danych, ograniczenie gromadzenia danych, ograniczenie dostępu do danych.",
			name: "Minimalizacja danych osobowych",
			placeholder: "Należy opisać metody ograniczania ryzyka poprzez ograniczanie zakresu danych",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Polityki opisujące, jak w trakcie przetwarzania drukowane, przechowywane, niszczone i wymieniane są dokumenty papierowe zawierające dane osobowe.",
			name: "Zabezpieczenie dokumentów papierowych",
			placeholder: "Należy opisać procedury dotyczące cyklu życia dokumentów papierowych zawierających dane osobowe.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Plan działania stanowi opis strategii, środków i pracowników, z których należy skorzystać, by zdefiniowane środki zapobiegawcze zaczęły działać. Dla każdego zadania należy wyznaczyć osobę odpowiedzialną, koszty, trudności i postęp.",
			name: "Plan działania",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Wykres przedstawiający ryzyka generowane przez czynność przetwarzania oraz ryzyko szczątkowe po podjęciu wszystkich działań naprawczych. Wykazuje, że prawidłowe wdrożenie środków opisanych w planie działania może prowadzić do ograniczenia prawdopodobieństwa i/lub istotności ryzyka.",
			name: "Mapowanie ryzyka",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Zgodnie z art. 35 ust.9 administrator zasięga opinii osób, których dane dotyczą, gdy ma to zastosowanie.<br>Te opinie można zebrać w różny sposób, w zależności od kontekstu (badanie wewnętrzne lub zewnętrzne dotyczące celu i sposobów przetwarzania, pytanie do przedstawicieli pracowników lub związków zawodowych, ankieta wśród przyszłych klientów administratora).<strong>Jeżeli administrator postanowi pominąć opinie zainteresowanych</strong>, powinien udokumentować <strong>uzasadnienie swojej decyzji.</strong>. Jeżeli administrator uzna, że <strong>zebranie opinii zainteresowanych nie jest istotne, to także powinien udokumentować uzasadnienie</strong>.",
			name: "Opinia osób, których dane dotyczą",
			source: "RODO Art. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "Zgodnie z artykułem 35 ust.2 RODO, administrator konsultuje się z inspektorem ochrony danych w trakcie oceny skutków dla ochrony danych.<br><strong>Ta opinia może być niekorzystna dla wdrożenia przetwarzania, co jednak nie ogranicza decyzji administratora.</strong>.",
			name: "Opinia IOD",
			source: "RODO Art. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "<strong>Administrator formalnie decyduje</strong> o dopuszczalności wybranych środków, ryzyku szczątkowym i planie działania, podając argumenty, pod kątem uprzednio zidentyfikowanych wyzwań i opinii zainteresowanych stron. PIA może zatem:<br>- zatwierdzić ;<br>- poprawić (wyjaśnić co) ;<br>- odrzucić (podobnie jak rozważane przetwarzanie).<br>W przeciwnym wypadku należy dokonać przeglądu poprzednich etapów, by można było zatwierdzić PIA.<br>Ta decyzja nie przesądza w żadnym stopniu o ocenie zgodności, której może dokonać, w razie potrzeby, organ nadzorczy ochrony danych osobowych, na przykład w ramach wcześniejszych formalności lub kontroli.",
			name: "Formalne zatwierdzenie",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Baza wiedzy"
};
var measures$6 = {
	add: "Utworzenie środka (lub dodanie środka z bazy wiedzy po prawej)",
	default_placeholder: "Należy opisać istniejące lub planowane środki dla zapewnienia bezpieczeństwa danych.",
	edit: "Edycja środka",
	placeholder_title: "Nazwa środka ochrony",
	remove: "Usunięcie środka"
};
var misc$6 = {
	display: "Pokazanie / Ukrycie"
};
var modals$6 = {
	abandon_pia: {
		additional_text: "Rezygnacja nie musi być ostateczna. Jeśli zajdzie potrzeba można wrócić do tej oceny.",
		content: "Czy chcesz zrezygnować z przetwarzania?"
	},
	action_plan_no_evaluation: {
		content: "Musisz przejrzeć analizę by rozpocząć plan działania.",
		review_section: "Przegląd sekcji"
	},
	archive: "Archiwizacja",
	archive_pia: {
		archive: "Archiwizuj AIIA",
		content: "<span class='strong'>Uwaga</span><br>Czy na pewno chcesz<br>zarchiwizować tą PIA?"
	},
	ask_for_evaluation: {
		content: "Ta sekcja jest gotowa do sprawdzenia."
	},
	back_to_edition: {
		content: "Sekcja została odesłana do ponownej edycji."
	},
	back_to_evaluation: {
		content: "Sekcja została odesłana do ponownej oceny."
	},
	back_to_home: "Powrót do powitania",
	cancel: "Anuluj",
	close: "Zamknięcie",
	completed_edition: {
		content: "Dokonano całkowitej analizy PIA, obecnie należy dokonać jej oceny."
	},
	completed_evaluation: {
		content: "Dokonano całkowitej analizy PIA, obecnie należy dokonać jej zatwierdzenia."
	},
	"continue": "Dalsza praca",
	declare_measures: {
		content: "Przed oceną ryzyka<br>należy zadeklarować środki<br>istniejące lub przewidziane.",
		declare: "Deklarowane środki istniejące lub przewidziane"
	},
	dpo_missing_evaluations: {
		comment: "Komentarz",
		content: "Musisz zatwierdzić wszystkie sekcje by przejść do strony poświęconej uwagom Inspektora Ochrony Danych",
		remove: "Usunięcie",
		review_section: "Przegląd sekcji"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Zaimportowany plik nie odpowiada plikowi PIA"
	},
	import_wrong_structure_file: {
		content: "Zaimportowany plik nie odpowiada plikowi szablonu"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Zawartość została skopiowana do schowka."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Uwaga</span><br>Należy opisać co najmniej jeden środek: usunięcie niemożliwe."
	},
	recover_version: {
		"continue": "Dalsza praca",
		message: "Kontynuując, przywrócisz wersję raportu: {{date}}.<br><br>Bieżąca wersja zostanie zapisana.",
		title: "Przywróć poprzednią wersję"
	},
	refuse_pia: {
		content: "Ponieważ odrzuciłeś PIA, zostaje ona odesłana do sprawdzenia w celu wprowadzenia wymaganych zmian."
	},
	remove_attachment: {
		comment: "Komentarz",
		content: "Czy na pewno chcesz usunąć ten załącznik?",
		keep: "Zachowaj",
		remove: "Usuń"
	},
	remove_measure: {
		content: "Czy na pewno ten środek ma być usunięty?",
		keep: "Zachowanie <br>środka",
		remove: "Usunięcie <br>środka"
	},
	remove_pia: {
		content: "<span class='strong'>Uwaga</span><br>Czy na pewno chcesz<br>trwale usunąć tą PIA?",
		remove: "Usuń PIA"
	},
	remove_question: {
		content: "Czy na pewno chcesz usunąć pytanie?",
		keep: "Zachowaj",
		remove: "Usuń"
	},
	remove_structure: {
		content: "<span class='strong'>Uwaga,</span><br>Czy na pewno chcesz<br>usunąć szablon?",
		remove: "Usunięcie szablonu"
	},
	same_comment: {
		content: "<span class='strong'>Uwaga</span><br>Należy wprowadzić inny komentarz niż ostatnio zarejestrowany."
	},
	signed_pia_validation: {
		content: "Aby zatwierdzić PIA, dołącz podpisany raport.",
		download_pia: "Pobranie raportu"
	},
	simple_pia_validation: {
		content: "Masz zatwierdzone PIA."
	},
	start_evaluation: "Rozpoczęcie oceny",
	unarchive_pia: {
		content: "<span class='strong'>Uwaga</span><br>Czy na pewno chcesz<br>cofnąć archiwizację tej PIA?",
		unarchive: "Niearchiwizuj PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Adres serwera został zaktualizowany."
	},
	validate_evaluation: {
		content: "<span class='strong'>Gratulacje,</span><br>ocena tej sekcji została zakończona.<br>Pozostałe sekcje również muszą zostać ocenione, aby móc zatwierdzić PIA"
	},
	validate_evaluation_to_correct: {
		content: "Odesłano do edycji w celu naniesienia poprawek."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$6 = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$6 = {
	content: ", uważa(ją), że:",
	dpo_lock: "Należy wypełnić pozostałe sekcje przed zasięgnięciem opinii IOD.",
	dpo_opinion: "Opinia IOD",
	edit: "Edycja",
	people_opinion: "Opinia osób, których dane dotyczą",
	placeholder_concerned_people_name: "Nazwisko(a) osoby(osób), których dane dotyczą",
	placeholder_dpo_name: "Nazwisko(a) IOD",
	placeholder_dpo_opinion: "Należy podać powody wyboru.",
	placeholder_people_opinion: "Należy opisać, jak zbierano opinie i co dała ich analiza. Jeżli nie zbierano opinii, należy podać powody.",
	placeholder_search_content: "Należy uzasadnić, dlaczego nie zbierano opinii osób, których dane dotyczą.",
	treatment_lock: "Należy uzupełnić pozostałe sekcje przed wpisaniem opinii osób, których dane dotyczą.",
	treatment_nok: "Tego przetwarzania nie należy wdrażać.",
	treatment_ok: "To przetwarzanie można wdrożyć."
};
var pia$6 = {
	attachments: {
		add: "Dodaj załącznik",
		download: "Pobierz załącznik",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Usuń",
		title: "Załączniki",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Skierowanie do oceny",
		mandatory_fields: "Należy wypełnić wszystkie pola",
		structure_add_question: "Dodaj pytanie",
		subsection_validated: "Część oceniona, czeka na końcowe zatwierdzenie",
		validate_evaluation: "Zatwierdzenie oceny"
	},
	header: {
		display_action_plan: "Wyświetlenie<br>planu działania",
		edition: "Edycja",
		evaluation: "Ewaluacja",
		preview: "Przegląd"
	},
	sections: {
		based_on_structure_name: "Na podstawie szablonu:",
		homepage_link: "Powrót do powitania",
		refuse_pia: "Odrzucona AIIA",
		status: {
			evaluation: {
				cancel: "anuluj prośbę o ocenę.",
				cancel_button: "Anuluj prośbę o ocenę",
				content: "Jeszcze nie dokonano oceny tej części. Jeżeli zachodzi potrzeba zmiany treści przedstawionej do oceny,",
				title: "Oczekiwanie na ocenę."
			},
			validation: {
				cancel: "anuluj prośbę o zatwierdzenie.",
				cancel_button: "Anuluj prośbę o zatwierdzenie",
				content: "Ta część została oceniona i czeka na końcowe zatwierdzenie PIA. Jeśli chcesz wyedytować tą sekcję ",
				title: "Oczekiwanie na zatwierdzenie."
			}
		},
		validate_pia: "Zatwierdzenie PIA"
	},
	statuses: [
		"W toku",
		"Odrzucona",
		"Zatwierdzenie proste",
		"Zatwierdzenie podpisane",
		"Zarchiwizowana",
		"Czeka na potwierdzenie"
	]
};
var questions$6 = {
	edit: "Edycja pytania",
	gauges: [
		"(Niezdefiniowane)",
		"Pomijalne",
		"Ograniczone",
		"Poważne",
		"Maksymalne"
	],
	placeholder_title: "Tytuł pytania (obowiązkowy)",
	remove: "Usuń pytanie"
};
var rejection_page$6 = {
	applied_adjustments: "Wniesione zmiany",
	applied_adjustments_placeholder: "Opisz zmiany wprowadzone do PIA.",
	button: {
		abandon_treatment: "Odstąpienie od przetwarzania",
		reject_pia: "Odrzucenie AIIA",
		send_for_validation: "Wyślij ponownie do zatwierdzenia"
	},
	previous_rejection: "Poprzednia odmowa",
	rejection_reason: "Uzasadnienie odmowy",
	rejection_reason_placeholder: "Opisz powody odmowy zatwierdzenia PIA.",
	title: "Historia zatwierdzania"
};
var sections$6 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Należy przedstawić syntetyczny opis przetwarzania: jego nazwę, cele, wyzwania (co wniesie), kontekst wykorzystania, itd.",
						title: "Jakie przetwarzanie stanowi przedmiot oceny?"
					},
					"2": {
						placeholder: "Należy opisać zakres odpowiedzialności zaangażowanych stron: administratora danych, ewentualnych podmiotów przetwarzających oraz współadministratorów.",
						title: "Jakie odpowiedzialności są związane z tym przetwarzaniem?"
					},
					"3": {
						placeholder: "Należy wymienić standardy mające zastosowanie w przypadku tego przetwarzania, w szczególności zatwierdzone kodeksy postępowania oraz certyfikaty związane z ochroną danych osobowych.",
						title: "Jakie standardy mają zastosowanie?"
					}
				},
				short_help: "Ta sekcja pozwala zidentyfikować i przedstawić przedmiot oceny.",
				title: "Przegląd"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Należy wymienić dane zbierane i przetwarzane, podając czas ich przechowywania, odbiorców oraz osoby, które mogą mieć do nich dostęp.",
						title: "Jakie dane są przetwarzane?"
					},
					"2": {
						placeholder: "Należy opisać cykl życia danych (od ich zbierania do ich zniszczenia poprzez ich przechowywanie, poszczególne etapy przetwarzania, archiwizację, itp.) np. za pomocą schematów przepływu danych (można je dołączyć jako załącznik) oraz szczegółowego opisu każdego wdrożonego procesu.",
						title: "Jak wygląda cykl życia danych (opis funkcjonalny)?"
					},
					"3": {
						placeholder: "Należy wymienić wykorzystywane aktywa (systemy operacyjne, aplikacje zawodowe, oprogramowanie biurowe, protokoły, konfiguracje, itd.)",
						title: "Jakie aktywa będą wykorzystywane?"
					}
				},
				short_help: "Ta sekcja pozwala zdefiniować i szczegółowo opisać zakres przetwarzania.",
				title: "Dane, procesy i aktywa"
			}
		},
		short_help: "Ta sekcja pozwala uzyskać jasną wizję rozważanego przetwarzania danych osobowych.",
		title: "Kontekst"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Należy uzasadnić, że dane osobowe zbierane są w konkretnych, wyraźnych i prawnie usprawiedliwionych celach.",
						short_title: "Cele",
						title: "Czy cele przetwarzania są konkretne, wyraźne i prawnie usprawiedliwione?"
					},
					"2": {
						placeholder: "Należy przedstawić podstawy prawne przetwarzania (np.: zgoda, wykonanie umowy, obowiązek prawny, żywotne interesy, itd.).",
						short_title: "Podstawa prawna",
						title: "Jakie są podstawy prawne, które określają zgodność przetwarzania z prawem?"
					},
					"3": {
						placeholder: "Należy wyjaśnić, dlaczego poszczególne zbierane dane są niezbędne do celów, w których są przetwarzane.",
						short_title: "Adekwatne dane",
						title: "Czy zbierane dane są adekwatne, stosowne oraz ograniczone do tego, co niezbędne do celów, w których są przetwarzane (minimalizacja danych)?"
					},
					"4": {
						placeholder: "Należy opisać, w jaki sposób zapewnia się jakość danych.",
						short_title: "Prawidłowość danych",
						title: "Czy dane są prawidłowe i w razie potrzeby uaktualniane?"
					},
					"5": {
						placeholder: "Należy wyjaśnić, w jaki sposób okres przechowywania poszczególnych danych jest niezbędny dla osiągania celów przetwarzania lub spłnienia wymogów prawnych.",
						short_title: "Okres przechowywania",
						title: "Jaki jest okres przechowywania danych?"
					}
				},
				short_help: "Ta sekcja pozwala wykazać legalność przetwarzania i przetwarzanych danych.",
				title: "Proporcjonalność i konieczność"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Należy opisać, w jaki sposób osoby, których dane dotyczą, są informowane o przetwarzaniu.",
						short_title: "Informacje dla osób, których dane dotyczą",
						title: "Jak osoby, których dane dotyczą, są informowane o przetwarzaniu?"
					},
					"2": {
						placeholder: "Należy opisać procedury uzyskiwania zgody osób, których dane dotyczą.",
						short_title: "Uzyskanie zgody",
						title: "Jak uzyskuje się zgody osób, których dane dotyczą?"
					},
					"3": {
						placeholder: "Należy opisać procedury umożliwiające osobom, których dane dotyczą, uzyskanie dostępu do swoich danych, ich otrzymanie i przekazanie.",
						short_title: "Prawo dostępu i do przenoszenia danych",
						title: "W jaki sposób osoby, których dane dotyczą, mogą wyegzekwować prawo dostępu do danych i prawo do przenoszenia danych?"
					},
					"4": {
						placeholder: "Należy opisać procedury umożliwiające osobom, których dane dotyczą, sprostowanie i usunięcie swoich danych.",
						short_title: "Prawo do sprostowania i usunięcia",
						title: "W jaki sposób osoby, których dane dotyczą, mogą wyegzekwować prawo do sprostowania i prawo do usunięcia danych?"
					},
					"5": {
						placeholder: "Należy opisać procedury umożliwiające osobom, których dane dotyczą, ograniczenie przetwarzania swoich danych i prawo do sprzeciwu wobec przetwarzania swoich danych osobowych.",
						short_title: "Prawo do ograniczenia przetwarzania i sprzeciwu",
						title: "W jaki sposób osoby, których dane dotyczą, mogą wyegzekwować prawo do ograniczenia przetwarzania i prawo do sprzeciwu?"
					},
					"6": {
						placeholder: "Dla każdego podmiotu przetwarzającego, należy opisać jego zakresy odpowiedzialności (czas trwania, zakres, cel, udokumentowane instrukcje przetwarzania, uprzednia zgoda) i przedstawić stosowne zapisy umów, kodeksy postępowania oraz certyfikacje określające ich zobowiązania.",
						short_title: "Powierzenie przetwarzania",
						title: "Czy zobowiązania podmiotów przetwarzających zostały jasno określone i zawarte w umowie?"
					},
					"7": {
						placeholder: "Dla każdego państwa poza obszarem Unii Europejskiej, w którym dane są przechowywane lub przetwarzane, należy podać jego nazwę i zaznaczyć, czy jest uznawane jako oferujące odpowiedni stopień ochrony danych osobowych lub opisać postanowienia dotyczące przekazywania.",
						short_title: "Przekazywanie danych",
						title: "W przypadku przekazywania danych poza obszar Unii Europejskiej, czy dane są adekwatnie chronione?"
					}
				},
				short_help: "Ta sekcja pozwala wykazać, że wdrażane są środki niezbędne dla wykonywania praw osób, których dane dotyczą.",
				title: "Środki ochrony praw osób, których dane dotyczą"
			}
		},
		short_help: "Ta sekcja pozwala zbudować zgodność z zasadami ochrony danych.",
		title: "Podstawowe zasady"
	},
	"3": {
		items: {
			"1": {
				short_help: "Ta sekcja pozwala zidentyfikować środki (istniejące lub przewidziane), które mają wpływ na bezpieczeństwo danych.",
				title: "Środki istniejące lub przewidziane"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Należy przedstawić potencjalne skutki",
						title: "Jakie mogą być główne skutki dla osób, których dane dotyczą, jeżeli ryzyko się zdarzy?"
					},
					"2": {
						placeholder: "Należy przedstawić zagrożenia",
						title: "Jakie są główne zagrożenia, które mogą doprowadzić do zdarzenia się ryzyka?"
					},
					"3": {
						placeholder: "Należy przedstawić źródła ryzyka",
						title: "Jakie są źródła ryzyka?"
					},
					"4": {
						placeholder: "Klikając w tym miejscu należy wybrać środki pozwalające zająć się ryzykiem.",
						title: "Które ze zidentyfikowanych środków pozwoli zająć się ryzykiem?"
					},
					"5": {
						placeholder: "Należy uzasadnić szacowaną istotność ryzyka.",
						title: "Jaka jest szacowana istotność ryzyka, w zależności od potencjalnych skutków i przewidzianych środków?"
					},
					"6": {
						placeholder: "Należy uzasadnić szacowane prawdopodobieństwo ryzyka.",
						title: "Jakie jest szacowane prawdopodobieństwo ryzyka, szczególnie w odniesieniu do zagrożeń, źródeł ryzyka i przewidzianych środków?"
					}
				},
				short_help: "Należy dokonać analizy przyczyn i konsekwencji nieupoważnionego dostępu do danych i oszacować jego istotność oraz prawdopodobieństwo.",
				title: "Nieupoważniony dostęp do danych"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Należy przedstawić potencjalne skutki",
						title: "Jakie mogą być główne skutki dla osób, których dane dotyczą, jeżeli ryzyko się zdarzy?"
					},
					"2": {
						placeholder: "Należy przedstawić zagrożenia",
						title: "Jakie są główne zagrożenia, które mogą doprowadzić do zdarzenia się ryzyka?"
					},
					"3": {
						placeholder: "Należy przedstawić źródła ryzyka",
						title: "Jakie są źródła ryzyka?"
					},
					"4": {
						placeholder: "Klikając w tym miejscu należy wybrać środki pozwalające zająć się ryzykiem.",
						title: "Które ze zidentyfikowanych środków pozwoli zająć się ryzykiem?"
					},
					"5": {
						placeholder: "Należy uzasadnić szacowaną istotność ryzyka.",
						title: "Jaka jest szacowana istotność ryzyka, w zależności od potencjalnych skutków i przewidzianych środków?"
					},
					"6": {
						placeholder: "Należy uzasadnić szacowane prawdopodobieństwo ryzyka.",
						title: "Jakie jest szacowane prawdopodobieństwo ryzyka, szczególnie w odniesieniu do zagrożeń, źródeł ryzyka i przewidzianych środków?"
					}
				},
				short_help: "Należy dokonać analizy przyczyn i konsekwencji niepożądanej modyfikacji danych i oszacować jego istotność oraz prawdopodobieństwo.",
				title: "Niepożądana modyfikacja danych"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Należy przedstawić potencjalne skutki",
						title: "Jakie mogą być główne skutki dla osób, których dane dotyczą, jeżeli ryzyko się zdarzy?"
					},
					"2": {
						placeholder: "Należy przedstawić zagrożenia",
						title: "Jakie są główne zagrożenia, które mogą doprowadzić do zdarzenia się ryzyka?"
					},
					"3": {
						placeholder: "Należy przedstawić źródła ryzyka",
						title: "Jakie są źródła ryzyka?"
					},
					"4": {
						placeholder: "Klikając w tym miejscu należy wybrać środki pozwalające zająć się ryzykiem.",
						title: "Które ze zidentyfikowanych środków pozwoli zająć się ryzykiem?"
					},
					"5": {
						placeholder: "Należy uzasadnić szacowaną istotność ryzyka.",
						title: "Jaka jest szacowana istotność ryzyka, w zależności od potencjalnych skutków i przewidzianych środków?"
					},
					"6": {
						placeholder: "Należy uzasadnić szacowane prawdopodobieństwo ryzyka.",
						title: "Jakie jest szacowane prawdopodobieństwo ryzyka, szczególnie w odniesieniu do zagrożeń, źródeł ryzyka i przewidzianych środków?"
					}
				},
				short_help: "Należy dokonać analizy przyczyn i konsekwencji utraty danych i oszacować jego istotność oraz prawdopodobieństwo.",
				title: "Zniknięcie danych"
			},
			"5": {
				short_help: "Ta wizualizacja pozwala uzyskać globalny i syntetyczny obraz działania środków na ryzyka, na które mają wpłynąć.",
				title: "Obraz ryzyka"
			}
		},
		short_help: "Ta sekcja pozwala oceny ryzyka dla prywatności, przy uwzględnieniu środków istniejących lub przewidzianych.",
		title: "Ryzyka"
	},
	"4": {
		items: {
			"1": {
				short_help: "Ta wizualizacja pozwala porównać wzajemne pozycjonowanie się ryzyk, przed i po wdrożeniu dodatkowych środków.",
				title: "Mapa ryzyka"
			},
			"2": {
				short_help: "Należy szczegółowo zaplanować wdrożenie dodatkowych środków określonych w trakcie PIA.",
				title: "Plan działania"
			},
			"3": {
				short_help: "Należy przedstawić rady osoby odpowiedzialnej za bezpieczeństwo danych i prywatność (inspektora ochrony danych, jeżeli został powołany). Należy przedstawić poglądy osób, których dane dotyczą lub ich przedstawicieli.",
				title: "Opinie IOD i osób, których dane dotyczą"
			},
			"4": {
				title: "Zatwierdzenie PIA"
			},
			"5": {
				title: "Odmowa zatwierdzenia PIA"
			}
		},
		short_help: "Ta sekcja pozwala przygotować i sformalizować zatwierdzenie PIA.",
		title: "Zatwierdzenie"
	}
};
var settings$6 = {
	content: "Prosimy o podanie adresu (URL) zdalnego serwera:",
	title: "Ustawienia",
	update: "Aktualizacja URL"
};
var summary$6 = {
	action_plan: {
		fundamental_principles: "Podstawowe zasady",
		implementation_date: "Planowana data wdrożenia",
		implementation_responsible: "Osoba odpowiedzialna za wdrożenie",
		measures: "Środki istniejące lub przewidziane",
		no_action_plan: "Brak zarejestrowanego planu działania.",
		risks: "Ryzyka",
		title: "Plan działania"
	},
	actions: {
		complete_download: "Pobierz pełny raport",
		complete_download_desc: "Eksportuj do archiwum .zip całą zawartość raportu (.doc i zdjęcia), załączniki oraz plan działania w formacie .csv.",
		individual_download: "Pobierz elementy raportu",
		individual_download_desc: "Eksportuj określone elementy raportu.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "Tekst (.doc)",
		individual_download_images: "Elementy graficzne (.png), w tym obraz ryzyka, mapa ryzykathe i plan działania.",
		individual_download_json: "Raport w formacie do zaimportowania do narzędzia PIA (plik .json)",
		individual_download_select: "Wybierz elementy do eksportu:",
		individual_to_download: "Pobierz",
		print: "Drukuj raport",
		print_and_download: "Drukuj i pobierz"
	},
	attachments: "Załączniki",
	concerned_people_name: "Nazwiska osób, których dane dotyczą",
	concerned_people_opinion: "Opinie osób, których dane dotyczą",
	concerned_people_searched_opinion: "Potrzebne opinie osób, których dane dotyczą",
	concerned_people_status: "Status osób, których dane dotyczą",
	concerned_people_unsearched_opinion_comment: "Powód, dla którego nie zwrócono się o opinię do osób, których dane dotyczą.",
	content_choice: [
		"Tego przetwarzania nie należy wdrażać.",
		"To przetwarzanie można wdrożyć."
	],
	creation_date: "Data utworzenia",
	csv_action_plan_comment: "Komentarz do planu działania",
	csv_evaluation_comment: "Komentarz do oceny",
	csv_file_title: "Plan działania",
	csv_implement_date: "Szacowana data wdrożenia",
	csv_people_in_charge: "Osoba odpowiedzialna",
	csv_section: "Sekcja",
	csv_title_object: "Tytuł",
	download_csv: "Plan działania (.csv)",
	dpo_name: "Nazwisko IOD",
	dpo_opinion: "Opinia IOD",
	dpo_status: "Status IOD",
	gauges: {
		"1": "Pomijalne",
		"2": "Ograniczone",
		"3": "Poważne",
		"4": "Maksymalne"
	},
	modification_made: "Wniesione modyfikacje",
	people_search_status_nok: "Nie poproszono o opinię osób, których dane dotyczą.",
	people_search_status_ok: "Poproszono o opinię osób, których dane dotyczą.",
	pia_assessor: "Nazwisko oceniającego",
	pia_author: "Nazwisko autora",
	pia_name: "Nazwa AIIA",
	pia_validator: "Nazwisko zatwierdzającego",
	preview_dpo_opinion: "Opinie IOD i osób, których dane dotyczą",
	preview_edition: "Edytowanie",
	preview_evaluation: "Ocena",
	preview_no_data: "Brak danych do wyświetlenia.",
	preview_status: "Status",
	preview_subtitle: "Informacje ogólne",
	preview_title: "Przegląd",
	preview_validation: "Zatwierdzenie",
	preview_validation_section: "Zatwierdzenie",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Powrót do poprzedniej strony",
	rejection_reason: "Powód odmowy",
	revision: {
		current_version: "Obecna wersja",
		pia_version: "Wersje AIIA",
		restore_version: "Przywróć",
		revision: "Wersje i zmiany",
		save: "Utwórz nową wersję",
		show: "Wyświetl wersję {{length}}"
	},
	risks_cartography_title: "Mapowanie ryzyka",
	risks_overview_title: "Przegląd ryzyka",
	title: "Informacje o PIA"
};
var users$6 = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$6 = {
	add_signed_pia: "Załącz podpisane AIIA",
	after_reading: "Po całościowym zapoznaniu się z PIA odnoszącą się do przetwarzania danych związanych z czynnością:",
	button: {
		rejection: "Odrzuć AIIA",
		signed_validation: "Zatwierdź PIA i podpisz",
		simple_validation: "Zatwierdź PIA"
	},
	confirmation1: "Potwierdzam, że kontekst przetwarzania opisany w PIA jest zgodny z rzeczywistością.",
	confirmation2: "Potwierdzam, że mam świadomość ryzyk zależnych od obecnych bądź planowanych środków ochrony.",
	confirmation3: "Zatwierdzam środki naprawcze wskazane w planie działania.",
	confirmation4: "Zobowiazuję się do jak najszybszego wdrożenia wskazanych środków naprawczych.",
	latest_signed_attachment: "Ostatni podpisany załącznik",
	mandatory_fields: "Należy zaznaczyć wszystkie pola",
	remove_attachment: "Usuń załącznik",
	responsible: "Osoba odpowiedzialna za zatwierdzenie PIA: ",
	signed_attachments_history: "Historia podpisanych załączników",
	tools: {
		dashboard: "Panel główny",
		display_pia: "Wyświetl PIA"
	},
	validated_pia_with_signature: "Zaakceptowane",
	waiting_for_signature: "Oczekiwanie na podpisanie PIA"
};
var pl = {
	about: about$6,
	action_plan: action_plan$6,
	authentication: authentication$6,
	cartography: cartography$6,
	comments: comments$6,
	conflict: conflict$6,
	date: date$6,
	errors: errors$6,
	evaluations: evaluations$6,
	header: header$6,
	help: help$6,
	homepage: homepage$6,
	knowledge_base: knowledge_base$6,
	measures: measures$6,
	misc: misc$6,
	modals: modals$6,
	onboarding: onboarding$6,
	opinions: opinions$6,
	"overview-risks": {
	important: "Poważne",
	limited: "Ograniczone",
	maximal: "Maksymalne",
	measures: "Środki",
	negligible: "Pomijalne",
	potential_impacts: "Potencjalne skutki",
	"risk-access_x": "Istotność",
	"risk-access_y": "Prawdopodobieństwo",
	"risk-change_x": "Istotność",
	"risk-change_y": "Prawdopodobieństwo",
	"risk-disappearance_x": "Istotność",
	"risk-disappearance_y": "Prawdopodobieństwo",
	sources: "Źródła",
	threat: "Zagrożenie"
},
	pia: pia$6,
	questions: questions$6,
	rejection_page: rejection_page$6,
	sections: sections$6,
	settings: settings$6,
	summary: summary$6,
	users: users$6,
	validation_page: validation_page$6
};

var about$5 = {
	contribute: "Se deseja contribuir com a tradução do software em outro idioma ou melhorar as traduções existentes, recomendamos que <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">leia a página descrevendo os passos a seguir</a>.",
	description: "Esta ferramenta foi originalmente desenhada pelo <a target=\"_blank\" href=\"https://www.cnil.fr\">Comissão Nacional da Informática e das Liberdades (CNIL)</a>, Autoridade Francesa de Proteção de Dados, para ajudar o subcontratante a ser compatível com o GDPR. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Este software é gratuito e de código aberto. Caso pretenda se envolver neste projeto, poderá baixar o código fonte do Github, modificá-lo e compartilhá-lo com a comunidade.",
	licences: "Licensas das bibliotecas:",
	title: "Sobre a Ferramenta AIIA",
	translators: "O software PIA está atualmente disponível em dezoito idiomas. As versões francesa e inglesa são fornecidas pelo CNIL. As outras versões resultam das contribuições dos seguintes indivíduos:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Número da versão"
};
var action_plan$5 = {
	acceptable_measures: "Medidas aceitáveis",
	edit: "Editar",
	improvable_measures: "Medidas improváveis",
	measures: "Medidas existentes ou planejadas",
	no_action_plan: "Nenhum plano de ação registado.",
	placeholder_person_in_charge: "Implementação responsável",
	principles: "Princípios fundamentais",
	risk1: "Acesso ilegítimo de dados",
	risk2: "Modificação indesejada de dados",
	risk3: "Desaparecimento de dados",
	risks: "Riscos",
	title: "Visão geral"
};
var authentication$5 = {
	"12_characters": "12 caracteres",
	account_recovery: "Recuperar senha",
	activation_code: "Código de ativação",
	cancel: "Cancelar",
	confirm: "Confirmar",
	confirmation: "Confirmação",
	"continue": "Continuar",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "Criar conta",
	create_account2: "Criar conta",
	description: "Este software da <strong>Comissão Nacional da Informática e das Liberdades (CNIL)</strong> pretende guiar os responsáveis pelo tratamento na construção e demonstração da conformidade para com o RGPD. Através da metodologia desenvolvida pela CNIL, esta ferramenta ajuda na avaliação de risco dos dados pessoais da organização.",
	email: "Email",
	email_placeholder: "Email",
	forgotten_password: "Esqueci minha senha",
	login: "Login",
	lowercase: "Letras minúsculas",
	password: "Senha",
	password_security: "Segurança da senha",
	recovery_code: "Código de recuperação",
	recovery_code_message: "Um email contente um código foi enviado para este email. Por favor digite o código no campo abaixo.",
	recovery_code_not_sent: "Não recebeu o código?",
	saved_password: "Sua senha foi salva. Você pode agora fazer o login.",
	sign_in: "Login",
	sign_in_button: "Login",
	sign_out_button: "Sair",
	special_character: "Caracter especial",
	number: "TO TRANSLATE - Number",
	start: "Início",
	start_app: "Acessar ao software PIA (Beta)",
	subtitle1: "Uma plataforma para criar <br> e gerir as análises de AIIA",
	subtitle2: "Acessar a ferramentas e glossários",
	title: "Avaliação de impacto sobre a proteção de dados",
	transaction_error: "Não foi possível processar seu pedido.",
	uppercase: "Letras maiúsculas",
	wrong_activation_code: "(errado)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "Email errado",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "Email ou senha errados."
		},
		create_account: {
			uuid: {
				"404": "Código de ativação errado",
				"406": "Esta conta já foi ativada"
			},
			password: {
				"404": "Usuário não encontrado",
				"406": "A senha não satisfaz os requesitos necessários."
			}
		},
		account_recovery: {
			email: {
				"404": "Usuário não encontrado",
				"423": "Conta bloqueada"
			},
			uuid: {
				"404": "Código de verificação errado"
			},
			password: {
				"404": "Usuário não encontrado",
				"406": "A senha não satisfaz os requesitos necessários."
			}
		},
		unauthorized: "Você não tem permissão para acessar esse recurso.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$5 = {
	important: "Importante",
	legend1: "Medidas existentes ou planejadas",
	legend2: "Com as medidas corretivas implementadas",
	legend3: "Acesso (i)legítimo aos dados",
	legend4: "Modificação (in)desejada dos dados",
	legend5: "Desaparecimento dos dados",
	likelihood_axe: "Probabilidade de risco",
	limited: "Limitado",
	maximal: "Máximo",
	negligible: "Insignificante",
	risk1_access: "(I)",
	risk2_modification: "(IN)",
	seriousness_axe: "Gravidade de risco"
};
var comments$5 = {
	comment: "Comentar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "comentário(s)",
	new_comment: "Comentário",
	placeholder_new_comment: "Deixe um comentário",
	send: "Enviar"
};
var conflict$5 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$5 = {
	april: "Abril",
	august: "Agosto",
	december: "Dezembro",
	"earlier-in-this-month": "Início do mês",
	"earlier-in-this-week": "Início da semana",
	february: "Fevereiro",
	january: "Janeiro",
	july: "Julho",
	june: "Junho",
	march: "Março",
	may: "Maio",
	november: "Novembro",
	october: "Outubro",
	september: "Setembro",
	today: "Hoje",
	yesterday: "Ontem"
};
var errors$5 = {
	content: "Se encontrar outros problemas ou se tiver sugestões de melhoria,<br>pode enviá-los através deste formulário: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Página não encontrada."
};
var evaluations$5 = {
	acceptable: "Aceitável",
	action_plan_comment: "Plano de ação/ações corretivas",
	evaluation_comment: "Comentário de avaliação",
	gauges: {
		"0": "(Indefinido)",
		"1": "Insignificante",
		"2": "Limitado",
		"3": "Importante",
		"4": "Máximo",
		likelihood: "Tendo em conta o plano de ação, como reavalia a <span class='red-highlight'>probabilidade deste risco</span>?",
		seriousness: "Tendo em conta o plano de ação, como reavalia a <span class='red-highlight'>gravidade deste risco</span>?"
	},
	improvable: "Improvável",
	placeholder_acceptable: "De acordo com as informações disponíveis, as medidas implementadas são adequadas para atender apropriadamente aos requisitos de proteção dos dados.",
	placeholder_improvable1: "De acordo com as informações disponíveis, devem ser implementadas medidas adicionais para melhorar a protecção dos dados do tratamento.",
	placeholder_improvable2: "Digite seus comentários.",
	placeholder_to_correct: "As informações fornecidas não são suficientes para avaliá-las corretamente. Envie de volta ao editor para melhorar a submissão original.",
	status: [
		"Pendente",
		"A corrigir",
		"Improvável",
		"Aceitável"
	],
	title: "Avaliação",
	to_correct: "A corrigir"
};
var header$5 = {
	archives: "Arquivos AIIA",
	current_pias: "PIAs atuais",
	exit_full_screen_mode: "Pressione F11 para sair do modo tela cheia.",
	help: {
		issue_reporting: "Reportar um problema",
		manual: "Manual do usuário",
		pia_example_link: "Exemplo AIIA",
		title: "Ajuda"
	},
	homepage_link: "Painel",
	knowledge_base_link: "Base de conhecimento",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Traduções fornecidas pela CNIL",
		community_translations: "Traduções fornecidas pela comunidade",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Traduções revistas pela ADP europeia",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Versão original",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Avaliação de Impacto da Proteção de Dados",
	structures: "Modelos de AIIA",
	tools: {
		about: "Sobre",
		accessibility: "Acessibilidade para pessoas com deficiência visual (cores de alto contraste, daltonismo)",
		onboarding: "Reiniciar tutorial",
		settings: "Definições",
		url_setting: "Configurar URL do servidor",
		users: "Usuários"
	}
};
var help$5 = {
	definition: {
		data1: {
			content: "Contéudo sendo escrito",
			title: "Use a ferramente PIA"
		},
		data2: {
			qa1: {
				content: "Ao encontrar esses problemas de exibição, feche o aplicativo e recarregue-o. Normalmente corrige o problema. Não perderá as informações inseridas; ele é salvo automaticamente enquanto digita.",
				title: "Eu recebo problemas de exibição, como ícones que estão presos em um estado ou elementos ausentes da interface"
			},
			qa2: {
				content: "Este problema está sendo corrigido. Caso encontre este erro, recomendamos que preencha o campo Justificação do nível de gravidade e/ou probabilidade estimado. É possível editar este campo assim que o bug for corrigido.",
				title: "Não consigo editar os campos para avaliar a gravidade e a probabilidade de um risco"
			},
			qa3: {
				content: "Vários erros foram observados durante a importação de uma análise PIA e, em particular, os indicadores de nível para avaliar a gravidade e a probabilidade de um risco podem desaparecer. Neste caso, por favor, consulte o problema acima mencionado. Além disso, uma análise PIA pode não aparecer no painel depois de importá-lo. Este é um problema de exibição e só precisa atualizar a página.",
				title: "Eu encontro problemas ao importar uma análise PIA"
			},
			qa4: {
				content: "Este é apenas um bug de exibição e não afeta o texto digitado em um campo. Este problema visual será corrigido em breve.",
				title: "Quando copio/colo texto, ele é sublinhado."
			},
			qa5: {
				content: "Para avaliar uma seção, é obrigatório preencher todos os campos. Por favor, verifique se este é o caso. Ao editar um risco, deve ter pelo menos uma medida técnica ou organizacional que mitigue o risco, a fim de solicitar uma avaliação do risco.",
				title: "Não consigo avaliar uma seção"
			},
			qa6: {
				content: "Por favor, feche a análise PIA que está editando e abra-o novamente. O conteúdo deve então ser exibido no idioma que selecionou.",
				title: "Ao trocar de idioma, os textos não são traduzidos"
			},
			qa7: {
				content: "Os ícones do menu de navegação não são atualizados após recusar uma análise PIA. Deve verificar cada seção e alterar as informações e/ou avaliações de acordo com aos motivos de recusa da análise PIA. Depois de toda a seção tiver sido revista, poderá solicitar a validação da análise PIA novamente.",
				title: "Recusei a validar uma análise PIA mas não sei o que fazer agora"
			},
			title: "Problemas conhecidos"
		},
		footer: "Se souber de outros problemas ou tiver sugestões de melhoria, pode enviá-los através deste formulário <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Ajuda"
};
var homepage$5 = {
	cards: {
		author: "Editar",
		category: "Categoria",
		creation_status: "Criação",
		date: "Data",
		evaluation: "Revisão",
		guest: "Convidado(s)",
		import_pia: "Importar análise AIIA",
		import_structure: "Importar modelo",
		item: {
			consult_pia: "Consultar",
			consult_structure: "Consultar modelo",
			edit_pia: "Editar",
			edit_structure: "Editar modelo",
			tools: {
				action_plan: "Exibir<br>plano de ação",
				archive: "Arquivar",
				duplicate: "Duplicar",
				"export": "Exportar",
				more_options: "Mais opções",
				pia: "Exibir análise <br>PIA",
				remove: "Deletar",
				unarchive: "Desarquivar TO TRANSLATE - Unarchive"
			},
			validate_pia: "Validar"
		},
		knowledges: {
			edit: "Editar uma base",
			"import": "Importar uma base",
			"new": "Criar uma base",
			placeholder_author: "Autor",
			placeholder_contributors: "Contribuidores",
			placeholder_entry_number: "Número de entradas",
			placeholder_name: "Nome da base"
		},
		knowledges_entry: {
			all_sections: "Todas as seções",
			choose_category: "Selecione uma categoria",
			contents: "Conteúdos",
			create: "Criar este elemento",
			linked_to: "Associado a",
			"new": "Criar um elemento",
			placeholder_category: "Categoria",
			placeholder_description: "Sua descrição aqui...",
			placeholder_name: "Nome do elemento",
			placeholder_updated_at: "Atualizado pela última vez"
		},
		new_pia: "Nova análise AIIA",
		new_structure: "Novo modelo",
		or: "ou",
		pia_name: "PIA",
		placeholder_author: "Primeiro Nome, último nome",
		placeholder_category: "Categoria",
		placeholder_evaluation: "Primeiro Nome, último nome",
		placeholder_import_knowledgeBase: "Importar base",
		placeholder_import_pia: "Importar análise AIIA",
		placeholder_import_structure: "Importar modelo",
		placeholder_new_knowledgeBase: "Nova base",
		placeholder_new_pia: "Nova análise AIIA",
		placeholder_new_structure: "Novo modelo",
		placeholder_pia_name: "Título da análise AIIA",
		placeholder_sector_name: "Título do setor associado",
		placeholder_start: "Todos os campos devem ser preenchidos",
		placeholder_structure: "Modelo predefinido",
		placeholder_structure_name: "Título do modelo",
		placeholder_validation: "Primeiro Nome, último nome",
		sector_name: "Setor associado",
		start: "Início",
		status: "Estado",
		structure: "Modelo",
		structure_name: "Nome do modelo",
		title_close_creation: "Fechar",
		validation: "Validação"
	},
	filters: {
		assessor: "Revisor",
		author: "Autor",
		card: "Visualizar como cartões",
		card_rocket_content: "Iniciar !<br><br>Para iniciar uma análise PIA,<br> clicar na Nova análise AIIA",
		card_rocket_content_structure: "Comece !<br><br>Para começar<br>um modelo, clique<br> no +",
		category: "Categoria",
		date: "Data",
		import_pia: "Importar AIIA",
		import_structure: "Importar modelo",
		list: "Visualizar como lista",
		list_rocket_content: "Iniciar ! Para iniciar <br>uma análise PIA, clicar no +",
		list_rocket_content_structure: "Comece ! Para começar<br>um modelo, clique no +",
		name: "Nome",
		new_pia: "Nova análise AIIA",
		new_structure: "Novo modelo",
		sector_name: "Sector associado",
		sort: "Ordenar",
		sort_by: "Ordernar por ",
		status: "Status",
		validator: "Validador"
	},
	lists: {
		column_actions: "Ações",
		column_author: "Editar",
		column_category: "Categoria",
		column_creation: "Criado",
		column_evaluation: "Revisão",
		column_pia: "PIA",
		column_progression: "Progresso",
		column_sector_name: "Setor associado",
		column_status: "Estado",
		column_structure: "Modelo",
		column_structure_name: "Modelo",
		column_updated_at: "Último aberto",
		column_validation: "Validação",
		item: {
			tools: {
				action_plan: "Exibir plano de ação",
				archive: "Arquivar",
				consult: "Consultar",
				duplicate: "Duplicar",
				edit: "Editar",
				"export": "Exportar",
				pia: "Exibir análise AIIA",
				remove: "Deletar",
				unarchive: "Desarquivar"
			}
		}
	},
	search_filter: "Buscar",
	no_entries: {
		pia: "Nenhum PIA criado e/ou associado",
		archive: "Nenhum arquivo PIA "
	}
};
var knowledge_base$5 = {
	add_measure: "Adicionar",
	add_measure_hint: "Podes adicionar também uma medida a partir da base de conhecimento.",
	category: {
		definition: "Definição",
		example: "Exemplo",
		general_measure: "Controle de segurança física",
		measure_on_data: "Controle de segurança lógica",
		method: "Metodologia",
		organizational_measure: "Controle organizacional",
		principle: "Princípio"
	},
	choose_knowledge_base: "Escolha sua base de conhecimento",
	default_knowledge_base: "Base de conhecimento CNIL",
	filters: {
		all: "Todos",
		definitions: "Definições",
		general_measures: "Controles de segurança física",
		measures_on_data: "Controles de segurança lógica",
		no_result: "Nenhum resultado encontrado.",
		organizational_measures: "Controles organizacionais",
		title: "Filtros"
	},
	placeholder_add_measure: "Adicionar esta medida",
	placeholder_help: "Ajuda no preenchimento",
	search: "Pesquisar",
	slugs: {
		PIA_DEF_ACC: {
			description: "O titular dos dados terá o direito de obter, da confirmação do responsável pelo tratamento, se os dados pessoais que lhe dizem respeito estão ou não a ser processados e, se for esse o caso, o acesso aos dados pessoais e às informações descritas no <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 15 de [RGPD]</a>",
			name: "Direito ao acesso",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Processo de remoção das características de identificação dos dados pessoais. Avaliar a robustez de um processo de anonimização, ver <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">diretrizes do WP29</a>.",
			name: "Anonimização",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Procedimentos que preservam e gerenciam os arquivos eletrónicos contendo os dados pessoais destinados a garantir seu valor (especificamente, seu valor legal) durante todo o período necessário (transferência, armazenamento, migração, acessibilidade, eliminação, política de arquivo, proteção de confidencialidade, etc.).",
			name: "Arquivo",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Todas as pessoas com acesso legítimo a dados pessoais (funcionários, partes contratantes e outros terceiros) devem ser identificadas por um identificador único. Escolha um método de autenticação para abrir sessões apropriadas ao contexto, ao nível de risco e à robustez esperada. Recomendações: se os riscos não forem elevados, uma senha pode ser usada; no entanto, se os riscos forem maiores, use um token de senha descartável, mas altere a senha de ativação padrão ou, quando parte da senha for enviada por SMS, um cartão com um código PIN, um certificado eletrónico ou qualquer outra forma de autenticação.",
			name: "Autenticação",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Medir dados pessoais ininteligíveis para qualquer pessoa sem autorização de acesso (criptografia simétrica ou assimétrica, uso de algoritmos públicos conhecidos como fortes, certificado de autenticação, etc.).",
			name: "Cifragem",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Métodos de organização de dados que reduzem a possibilidade de que os dados pessoais possam ser correlacionados e que uma violação de todos os dados pessoais possa ocorrer. Por exemplo, identificando os dados pessoais úteis apenas para cada processo de negócios e logicamente separando-os.",
			name: "Particionamento de dados",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Qualquer manifestação de vontade, livre, específica, informada e explícita, pela qual o titular dos dados aceita, mediante declaração ou ato positivo inequívoco, que os dados pessoais que lhe dizem respeito sejam objeto de tratamento.<br>Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 4.11 de [RGPD]</a>",
			name: "Consentimento",
			source: "GDPR Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Meios implementados para limitar os riscos que pessoas não autorizadas acessarão dados pessoais eletronicamente, requer, entre outras coisas: <br>- <strong>gerenciar perfis de usuários</strong>separando tarefas e áreas de responsabilidade (de preferência de forma centralizada) para limitar o acesso a dados pessoais exclusivamente a usuários autorizados, aplicando princípios de necessidade de conhecer e de privilégios mínimos; <br>- <strong>retirar os direitos de funcionários, partes contratantes e outros terceiros quando eles não estiverem mais autorizados a acessar um local ou recurso</strong> ou quando o seu <strong>contrato de trabalho termina</strong>.",
			name: "Controlos de acesso lógico",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Qualquer informação relativa a uma pessoa singular identificada ou identificável ('titular de dados'); uma pessoa singular identificável é aquela que pode ser identificada, direta ou indiretamente, em particular por referência a um identificador como um nome, um número de identificação, dados de localização, um identificador online ou a um ou mais fatores específicos (físico, fisiológico, identidade genética, mental, económica, cultural ou social) dessa pessoa singular. <br>Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 4.1 de [RGPD]</a>",
			name: "Dados pessoais",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Pessoa natural ou jurídica, autoridade pública, agência ou outro órgão, para o qual os dados pessoais são divulgados, sejam terceiros ou não. No entanto, as autoridades públicas que possam receber dados pessoais no quadro de um inquérito específico em conformidade com a legislação da União ou do Estado-Membro não são consideradas destinatários; o tratamento desses dados por essas autoridades públicas deve estar em conformidade com as regras de proteção de dados aplicáveis, de acordo com os objetivos do tratamento. <br>Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 4.9 de [RGPD]</a>",
			name: "Destinatário",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "O titular dos dados terá o direito de obter do responsável pelo tratamento o apagamento de dados pessoais que lhe digam respeito sem demora injustificada e o responsável pelo tratamento terá a obrigação de apagar os dados pessoais sem demora injustificada, ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 17 de [RGPD]</a>",
			name: "Direito de apagar",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Benefícios esperados (para a organização, para os titulares dos dados, para a sociedade em geral, etc.).",
			name: "Participações",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Os dados pessoais devem ser precisos e, quando necessário, mantidos atualizados; cada passo razoável deve ser tomado para garantir que os dados pessoais que são imprecisos, tendo em conta as finalidades para os quais são processados, sejam apagados ou corrigidos sem demora ('precisão'). <br>Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 5.1 d) de [RGPD]</a>",
			name: "Qualidade dos dados",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Gravidade representa a magnitude de um risco. Depende principalmente da natureza prejudicial dos possíveis impactos.",
			name: "Gravidade",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "O titular dos dados terá o direito de obter do responsável pelo tratamento a restrição do tratamento, ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 18 de [RGPD]</a>",
			name: "Direito à restrição do tratamento",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Configurar uma arquitetura de registo para permitir a deteção precoce de incidentes envolvendo dados pessoais e para ter informações que possam ser usadas para analisá-los ou fornecer provas relacionadas a investigações.",
			name: "Vigilância",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Procedimento que compreende uma ou mais ações individuais em dados que suportam ativos. É usado, intencionalmente ou não, por fontes de risco e pode causar um evento temido.",
			name: "Ameaça",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Ameaças sobre: - <strong>Hardware</strong>, usado de forma inadequada, observado, alterado, perdido (uso ou transporte de hardware sensível para fins pessoais, assistir a tela de uma pessoa sem seu conhecimento enquanto estiver no trem, rastreamento por um registador de chaves baseado em hardware, etc.)<br> - <strong>Software</strong>, usado de forma inadequada, observado, alterado (aumento de privilégios, coleta de dados de configuração, infecção por código malicioso, etc.) <br>- <strong>Canais de computador</strong> observados (Intercepção de tráfego Ethernet, etc.)<br>- <strong>Pessoas</strong>, observado, manipulado, perdido (divulgação não intencional de informações, engenharia social, mudanças de atribuição)<br>- <strong>Documentos em papel</strong> observado, perdido (leitura, roubo de correspondência, etc.)<br>- <strong>Canais de transmissão de papel</strong> observados (leitura de livros de assinatura em circulação, etc.)",
			name: "Ameaças que podem levar a um acesso ilegítimo",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Ameaças sobre: </strong><br>- <strong>Hardware</strong> : usado indevidamente, sobrecarregado, alterado, danificado, perdido (unidade de armazenamento cheia, sobrecarga de capacidade de adição de hardware incompatível, resultando em mau funcionamento, incêndio, roubo ou perda de um ativo, etc.)<br>- <strong>Software</strong> : usado de forma inadequada, sobrecarregada, alterada, danificada, perdida (apagamento de dados, excesso de tamanho do banco de dados, bomba lógica, não renovação da licença para software usado para acessar dados, etc.)<br>- <strong>Canais de computador</strong> : sobrecarregado, alterado, perdido (download não autorizado, perda de conexão com a Internet, etc.)<br>- <strong>Pessoas</strong> : sobrecarregado, danificado, perdido (mau uso de habilidades, doença, aposentadoria, etc.)<br>- <strong>Documentos em papel</strong> : usado de forma inadequada, danificado, perdido (apagamento, envelhecimento de documentos arquivados, roubo ou perda de documentos, etc.)<br>- <strong>Canais de transmissão em papel</strong> : sobrecarregado, danificado, alterado, perdido (entrega de correio interrompida por uma greve, reatribuição de escritórios ou instalações, perda de uma empresa de entrega de documentos, reorganização de canais de transmissão de papel, etc.)",
			name: "Ameaças que levam ao desaparecimento de dados pessoais",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Ameaças sobre : </strong><br>- <strong>Hardware</strong> alterado (adição de hardware incompatível resultando em mau funcionamento, remoção de componentes essenciais, etc.)<br>- <strong>Software</strong> usado de forma inadequada ou alterada (modificações indesejadas nos dados em bancos de dados, erros do operador que modificam dados etc.)<br>- <strong>Canais de computador</strong> usado de forma inadequada (reenvio de dados interceptados, etc.)<br>- <strong>Pessoas</strong> sobrecarregado ou manipula (atribuição de pessoal para tarefas além de suas habilidades, stress ou mudanças negativas nas condições de trabalho, influência, etc.)<br>- Documentos em papel que foram alterados (alterações em figuras de um arquivo, substituição de um original por uma falsificação, etc.)<br>- <strong>Canais de transmissão em papel</strong> que foram alterados (mudança de um livro de assinaturas para outro, envio de múltiplos documentos conflitantes, etc.)",
			name: "Ameaças que podem levar a uma modificação indesejada de dados pessoais",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Para ser escolhido entre os disponíveis na seção 'Medidas planejadas ou existentes', que pode preencher se necessário.",
			name: "Medidas",
			source: "Nenhuma"
		},
		PIA_DEF_MIN1: {
			description: "Quando os dados estão sendo importados, diferentes tipos de metadados (como dados EXIF com um arquivo de imagem anexado) podem ser recolhidos inadvertidamente. <br> Esses metadados devem ser identificados e eliminados se forem desnecessários para os fins especificados.",
			name: "Filtração e remoção",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Uma vez recebidos os dados sensíveis, como parte de uma série de informações gerais ou transmitidos apenas para fins estatísticos, estes podem ser convertidos para uma forma menos sensível ou pseudonimizada. Por exemplo: <br>- Se o sistema recolher o endereço IP para determinar a localização do usuário para fins estatísticos, o endereço IP poderá ser excluído assim que a cidade ou distrito for deduzido.<br>- Se o sistema receber dados de vídeo de câmaras de vigilância, ele poderá reconhecer pessoas em pé ou em movimento na cena e borrá-las.<br>- se o sistema for um medidor inteligente, ele pode agregar o uso de energia durante um certo período, sem gravá-lo em tempo real",
			name: "Redução da sensibilidade via conversão",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "O sistema pode garantir que: <br>- o usuário pode usar um recurso ou serviço sem o risco de revelar sua identidade (dados anónimos)<br>- o usuário pode usar um recurso ou serviço sem o risco de revelar sua identidade, mas permanecer identificável e responsável por esse uso (dados pseudônimos)<br>- o usuário pode fazer múltiplos usos de recursos ou serviços sem o risco de esses diferentes usos serem vinculados (dados não podem ser correlacionados)<br>- o usuário pode usar um recurso ou serviço sem o risco de outros, em particular terceiros, serem capazes de observar que o recurso ou serviço está sendo usado (não observável)<br>A escolha de um método da lista acima deve ser feita com base nas ameaças identificadas. Para alguns tipos de ameaça à privacidade, a pseudonimização será mais apropriada do que a anonimização (por exemplo, se houver uma necessidade de rastreabilidade). Além disso, algumas ameaças à privacidade serão abordadas usando uma combinação de métodos.",
			name: "Redução da natureza identificadora dos dados",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "O sistema pode ser organizado em partes independentes com funções separadas de controle de acesso. Os dados também podem ser divididos entre esses subsistemas independentes e controlados por cada subsistema usando diferentes mecanismos de controle de acesso. Se um subsistema for comprometido, os impactos em todos os dados podem ser reduzidos.",
			name: "Redução da acumulação de dados",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "O sistema pode limitar o acesso aos dados de acordo com o princípio de 'necessidade de saber'. O sistema pode separar os dados confidenciais e aplicar políticas específicas de controle de acesso. O sistema também pode criptografar os dados para proteger sua confidencialidade durante a transmissão e o armazenamento. O acesso a cookies temporários produzidos durante o tratamento de dados também deve ser protegido.",
			name: "Restrição do acesso de dados",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Reduzir a gravidade dos riscos, limitando a quantidade de dados pessoais ao estritamente necessário para alcançar um propósito definido, caso contrário os dados não serão recolhidos.",
			name: "Minimizar a quantidade de dados pessoais",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Reduzir a gravidade dos riscos minimizando os dados, adotando medidas que visem reduzir sua sensibilidade, como filtrar e remover dados desnecessários, pseudonimizando os dados, etc.",
			name: "Minimização dos dados pessoais",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "O titular dos dados tem o direito de se opor, por motivos relacionados com a sua situação particular, a qualquer momento ao tratamento de dados pessoais que lhe digam respeito, nos termos do <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 21 de [GDPR]</a>",
			name: "Direito à oposição",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Medidas tomadas para integrar a proteção de dados pessoais em todas as novas operações de tratamento (nomes confiáveis, diretrizes, metodologia CNIL para gerenciamento de risco ou outra metodologia interna).",
			name: "Gerenciamento de projetos",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Pessoas a quem os dados abrangidos pelo tratamento dizem respeito.",
			name: "Titular de dados",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: "O titular dos dados tem o direito de receber os dados pessoais que lhe são fornecidos, que forneceu a um responsável pelo tratamento, num formato estruturado, normalmente utilizado e legível por máquina, e tem o direito de os transmitir para outro responsável pelo tratamento sem impedimento do primeiro responsável pelo tratamento para o qual os dados pessoais foram fornecidos, ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 20 de [RGPD]</a>",
			name: "Direito à portabilidade dos dados",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Tratamento de dados pessoais de tal maneira que os mesmos dados não possam mais ser atribuídos a um indivíduo de dados específico sem o uso de informações adicionais, desde que essas informações adicionais sejam mantidas separadamente e estejam sujeitas a medidas técnicas e organizacionais para garantir que os dados pessoais não são atribuídos a uma pessoa singular identificada ou identificável.<br>A pseudonimização reduz a vinculação de um conjunto de dados com a identidade original de um sujeito de dados; como tal, é uma medida de segurança útil, mas não um método de anonimização.",
			name: "Pseudonimização",
			source: "GDPR Art. 4.5 and guidelines G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "As senhas devem ser compostas de oito caracteres, no mínimo; devem ser renovadas se houver a mínima preocupação de que possam ter sido comprometidas e, possivelmente, periodicamente (a cada seis meses ou uma vez por ano) e devem incluir no mínimo três dos quatro tipos de caracteres (maiúsculas, minúsculas, numerais e caracteres especiais); quando uma senha é alterada, as últimas cinco senhas não podem ser reutilizadas; a mesma senha não deve ser usada para acessos diferentes; as senhas não devem estar relacionadas às informações pessoais (incluindo nome ou data de nascimento). Defina um número máximo de tentativas além do qual um aviso é emitido e a autenticação é bloqueada (temporariamente ou até que seja manualmente desbloqueada).",
			name: "Senha",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "O titular dos dados terá o direito de obter do responsável pelo tratamento, sem demora injustificada, a retificação de dados pessoais incorretos que lhe digam respeito. Tendo em conta os fins do tratamento, o titular dos dados tem o direito de fornecer dados pessoais incompletos, incluindo meios através de uma declaração suplementar.",
			name: "Direito à retificação",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Regulamento relativo à protecção das pessoas singulares no que diz respeito ao tratamento de dados pessoais e à livre circulação desses dados e que revoga a Directiva 95/46/CE.",
			name: "RGPD (Regulamento Geral de Proteção de Dados)",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Pessoa singular ou coletiva, autoridade pública, agência ou outro organismo que, individualmente ou em conjunto com outros (responsáveis conjuntos), determina os fins e meios do tratamento de dados pessoais. Se os fins e os meios desse tratamento forem determinados pela legislação da União ou do Estado-Membro, o responsável pelo tratamento ou os critérios específicos para a sua nomeação podem ser estabelecidos pelo direito da União ou do Estado-Membro.<br>Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 4.7 de [RGPD]</a>",
			name: "Responsável pelo tratamento",
			source: "Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Pessoa ou fonte não humana que pode causar um risco. Esta fonte pode agir acidentalmente ou deliberadamente.",
			name: "Fonte de risco",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Pessoa singular ou coletiva, autoridade pública, agência ou outro organismo que processa dados pessoais em nome do responsável pelo tratamento, ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 4.8 de [RGPD]</a>.<br>O subcontratante e qualquer pessoa que atue sob a autoridade do responsável pelo tratamento ou do subcontratante, que tenha acesso a dados pessoais, não devem processar esses dados, salvo instruções do responsável pelo tratamento, a menos que tal seja exigido pela legislação da União ou do Estado-Membro, ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 29 de [RGPD]</a>.",
			name: "Subcontratante",
			source: "GDPR Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Ativo em que os dados pessoais dependem. Pode ser hardware, software, redes, pessoas, papel ou canais de transmissão de papel",
			name: "Ativos de suporte",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Violação de segurança que leva à destruição acidental ou ilegal, perda, alteração, divulgação não autorizada ou acesso a dados pessoais transmitidos, armazenados ou processados de outra forma.",
			name: "Violação de dados pessoais",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Probabilidade expressa a possibilidade de ocorrer um risco. Depende principalmente do nível de vulnerabilidades dos ativos de suporte quando sob ameaça e do nível de recursos das fontes de risco para explorá-los.",
			name: "Probabilidade",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Dados para um sistema de pontuação, resultado da aplicação da pontuação....",
			name: "Dados calculados"
		},
		PIA_EX_DCPC: {
			description: "<strong>Dados de identificação</strong> : Estado civil, identidade, idade, etc. <br><strong>Vida pessoal</strong> : hábitos de vida, estado civil, etc. <br><strong>Vida profissional </strong> : currículo, educação e formação profissional, prémios, etc. <br><strong>Dados de conexão </strong> : Endereços IP, logs de eventos, etc.<br><strong>Dados de localização</strong> : viagens, dados GPS, dados GSM, etc.<br><strong>Outros</strong> : número de telefone, endereço de e-mail, etc.",
			name: "Dados pessoais comuns",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Opiniões filosóficas, políticas, religiosas e sindicais, vida sexual, dados de saúde, origem racial ou étnica, dados relativos à saúde ou à vida sexual, crimes, condenações, medidas de segurança, ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 9 e 10 de [RGPD]</a>.",
			name: "Convições e dados pessoais sensíveis"
		},
		PIA_EX_DCPS: {
			description: "Número de segurança social (NISS), dados biométricos, dados bancários",
			name: "Dados pessoais percebidos como sensíveis"
		},
		PIA_EX_HUME: {
			description: "Pode ser qualquer:<br>- vagabundo ou vizinho ingénuo, por ter uma proximidade física, invadindo os dados do dispositivo;<br>- um hacker que tenha como alvo um usuário usando o conhecimento que ele tem do usuário e algumas informações sobre ele/ela;<br>- um hacker visando uma das empresas usando o conhecimento que possui das empresas que podem prejudicar sua imagem;<br>- uma empresa terceirizada autorizada, utilizando seu acesso privilegiado a informações acessadas ilegitimamente.",
			name: "Fontes humanas externas"
		},
		PIA_EX_HUMI: {
			description: "Pode ser qualquer:<br>- funcionário negligente ou desonesto, proximidade do sistema, habilidades, privilégios e tempo disponível são potencialmente altos, possível falta de treino e consciencialização<br>- usuário negligente ou desonesto, membro da família ou amigo tendo acesso ao serviço.<br> Vários motivos são possíveis, incluindo: falta de jeito, erro, jogo de negligência, intenção maliciosa, vingança, espionagem",
			name: "Fontes humanas internas"
		},
		PIA_EX_IMPI: {
			description: "Os titulares de dados podem encontrar consequências significativas, que devem ser capazes de superar, embora com dificuldades reais e graves. Por exemplo: <br> - físico: doenças físicas graves que causam danos a longo prazo (agravamento da saúde devido a cuidados inadequados, ou desconsideração de contraindicações), lteração da integridade física, por exemplo, após um assalto, um acidente em casa, trabalho, etc. <br>material: apropriação indevida de dinheiro não compensado, direcionado, único e não recorrente, oportunidades perdidas (empréstimo imobiliário, recusa de estudos, estágios ou emprego, proibição de exame), perda de moradia, perda de emprego, etc;<br> - moral: doenças psicológicas graves (depressão, desenvolvimento de fobia), sensação de invasão de privacidade com danos irreversíveis, vítima de chantagem, cyberbullying e assédio, etc.",
			name: "Impacto significativo"
		},
		PIA_EX_IMPL: {
			description: "Os titulares de dados podem encontrar inconvenientes significativos, que poderão superar apesar de algumas dificuldades. Por exemplo:<br>- físico : doenças físicas menores (doença menor devido ao desrespeito às contra-indicações), difamação resultando em retaliação física ou psicológica, etc.;<br>- material : pagamentos imprevistos (multas impostas erradamente), recusa de acesso a serviços administrativos ou comerciais, receção de correspondências diretas não solicitadas susceftíveis de prejudicar a reputação dos titulares de dados, etc.;<br>- moral : doenças psicológicas menores, mas objetivas, sentimento de invasão de privacidade sem danos irreversíveis, intimidação nas redes sociais, etc.",
			name: "Impacto limitado"
		},
		PIA_EX_IMPM: {
			description: "Os titulares dos dados podem encontrar consequências significativas, ou mesmo irreversíveis, que podem não superar. Por exemplo:<br>- física: doenças físicas permanentes ou a longo prazo, comprometimento permanente da integridade física, morte; <br> - material: risco financeiro, dívidas substanciais, incapacidade para o trabalho, incapacidade de realocação, perda de provas no contexto de litígios, perda de acesso a infraestruturas vitais (água, electricidade), etc. <br> - moral: doenças psicológicas a longo prazo ou permanentes, pena criminal, rapto, perda de laços familiares, incapacidade de processar, mudança de estatuto administrativo e/ou perda de autonomia legal (tutela), etc.",
			name: "Impacto máximo"
		},
		PIA_EX_IMPN: {
			description: "Os titulares dos dados não serão afetados ou não poderão encontrar alguns inconvenientes, que serão superados sem qualquer problema. Por exemplo:<br>- físico : dores de cabeça transitórias;<br>- material : perda de tempo na repetição de formalidades ou espera pelo preenchimento, recebimento de correspondências não solicitadas (ex .: spams), reutilização de dados publicados em sites para fins de publicidade direcionada, etc.;<br>- moral : mera irritação, sensação de invasão de privacidade sem dano real ou objetivo (invasão comercial), etc.",
			name: "Impacto insignificante"
		},
		PIA_EX_NHUM: {
			description: "Incidente ou dano em uma das organizações (corte de energia, incêndio, inundação, etc.)",
			name: "Fontes não humanas"
		},
		PIA_EX_VRAI: {
			description: "Parece possível que as fontes de risco selecionadas materializem a ameaça explorando as propriedades de ativos de suporte (por exemplo, roubo de documentos em papel armazenados em escritórios que não podem ser acessados sem primeiro fazer o check-in na receção).",
			name: "Probabilidade significativa"
		},
		PIA_EX_VRAL: {
			description: "Parece difícil para as fontes de risco selecionadas materializar a ameaça explorando as propriedades dos ativos de suporte (por exemplo, roubo de documentos em papel armazenados em uma sala protegida por um leitor de crachá).",
			name: "Probabilidade limitada"
		},
		PIA_EX_VRAM: {
			description: "Parece extremamente fácil para as fontes de risco selecionadas materializar a ameaça, explorando as propriedades de ativos de suporte (por exemplo, roubo de documentos em papel armazenados no átrio público).",
			name: "Probabilidade máxima"
		},
		PIA_EX_VRAN: {
			description: "Não parece possível que as fontes de risco selecionadas materializem a ameaça explorando as propriedades de ativos de suporte (por exemplo, roubo de documentos em papel armazenados em uma sala protegida por um leitor de crachá e código de acesso).",
			name: "Probabilidade insignificante"
		},
		PIA_LGL_CONS: {
			description: "Permitir que os titulares de dados façam uma escolha livre, específica e informada. Determinar se o tratamento depende de uma base legal que não seja o consentimento para o Art. 6 de <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">[RGPD]</a>",
			name: "Consentimento",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Defina e descreva o âmbito em detalhes:<br>-os dados pessoais em causa, os seus destinatários e os períodos de armazenamento <br>-descrição dos processos e dados pessoais que suportam ativos para todo o ciclo de vida dos dados pessoais (da recolha ao apagamento).",
			name: "Dados e processos",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Apresenta um breve resumo do tratamento sob consideração, a sua natureza, âmbito, contexto, finalidades e riscos. Identifique o responsável pelo tratamento e quaisquer subcontratantes. Listar as referências padrão aplicáveis ao tratamento, que são necessárias ou devem ser cumpridas, e não menos importante, os códigos de conduta aprovados (ver Art. 40 de <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">[RGPD]</a>) e certificações com referência a proteção de dados (ver Art. 42 de <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">[RGPD]</a>)",
			name: "Descrição do tratamento",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Pessoa legal ou natural, autoridade pública, agência ou outro corpo, a qual os dados pessoais são divulgados, seja um terceiro ou não. No entanto, as autoridades públicas que possam receber dados pessoais no âmbito de um inquérito particular de acordo com a legislação da União ou do Estado-Membro não são consideradas destinatários; o tratamento desses dados por essas autoridades públicas deve estar em conformidade com as regras de proteção de dados aplicáveis, de acordo com os objetivos do tratamento. Ver Art. 4.9 de <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">[RGPD]</a>",
			name: "Destinatário",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "Um período de armazenamento deve ser definido para cada tipo de dados e justificado pelos requisitos legais e/ou necessidades de tratamento. Assim, faz-se uma distinção entre dados comuns e dados arquivados, aos quais o acesso será limitado apenas às partes interessadas. Um mecanismo de eliminação deve ser implementado para arquivar dados comuns ou limpar dados arquivados no final do período de armazenamento. Os traços funcionais também terão que ser eliminados, assim como os registos técnicos que não podem ser armazenados indefinidamente",
			name: "Períodos de armazenamento",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Os dados pessoais devem recolhidos para finalidades determinadas, explícitas e legítimas, <strong>não podendo ser tratados posteriormente de uma forma incompatível com essas finalidades.</strong> <br>Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">Art. 5.1 b) de [RGPD]</a>",
			name: "Princípios relativos ao tratamento de dados pessoais",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Este titular de dados tem dado consentimento para o tratamento dos seus dados pessoais para uma ou mais finalidades específicas <br>- Tratamento é necessário para a execução de um contrato no qual o titular dos dados é parte ou para diligências pré-contratuais a pedido do titular dos dados <br>-Tratamento é necessário para a conformidade com obrigação legal a qual o responsável pelo tratamento é sujeito <br>- Tratamento é necessário para proteger os interesses vitais do titular de dados ou outra pessoa natural <br>- Tratamento é necessário para a execução da tarefa nos interesses públicos ou no exercício da autoridade oficial investida no responsável pelo tratamento <br>- Tratamento é necessário para as finalidades dos interesses legítimos seguidos pelo responsável pelo tratamento ou pelo terceiro,excepto onde tais interesses são ignorados pelos interesses ou direitos e liberdades fundamentais do titular de dados que requer proteção dos dados, particularmente onde o titular é uma criança<br> Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">art. 6 de [RGPD]</a> ",
			name: "Justificação da legalidade",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Assegure-se de que os titulares estejam informados. Confirme se o tratamento não está coberto por uma exceção e não está sujeito a condições específicas.",
			name: "Informar os titulares dos dados",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "É importante reduzir a gravidade dos riscos, minimizando o número de dados pessoais que serão processados, limitando esses dados ao estritamente necessário para os fins para os quais são processados (caso contrário, não devem ser recolhidos). Então, também é possível minimizar os dados por meio de controles que visam reduzir sua sensibilidade.",
			name: "Minimização de dados",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Um contrato de tratamento deve ser assinado com cada subcontratante, estabelecendo todos os aspectos estipulados no Art. 28 de [RGPD] do : duração, âmbito, finalidade, instruções de tratamento documentadas, autorização prévia onde um subcontratante está envolvido, fornecimento de qualquer documentação que comprove a conformidade com o RGPD, notificação imediata de qualquer violação de dados, etc.",
			name: "Subcontratação",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Ativo de que dependem os dados pessoais. Nota: pode ser hardware, software, redes, pessoas, papel ou canais de transmissão de papel.",
			name: "Ativo de suporte",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Dependendo do país, terá que justificar a escolha da hospedagem remota e indicar as disposições legais de supervisão implementadas, a fim de garantir a proteção adequada dos dados sujeitos a uma transferência transfronteiriça. Isto é :<br>- União Europeia<br>- País reconhecido pela UE por fornecer proteção adequada<br>- Transferência para os Estados Unidos para uma empresa que aderiu ao Privacy Shield<br>- Outro país <br>Ver <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">art. 44 ao 49 do [RGPD]</a>",
			name: "Transferências",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Existência de uma política e processos para obter uma organização capaz de gerenciar e controlar a proteção de dados pessoais contidos nela.",
			name: "Supervisão",
			placeholder: "Indique aqui se a eficácia e a adequação dos controles de privacidade são monitorizadas.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Existência de uma política e processos que reduzam o risco de que o acesso legítimo a dados pessoais por terceiros possa representar para as liberdades civis e privacidade das pessoas em causa.",
			name: "Relações com terceiros",
			placeholder: "Indique aqui, para os subcontratantes que requerem acesso aos dados, os controles e arranjos de segurança executados em relação a esse acesso.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Especifique se uma pessoa é responsável pelo cumprimento das leis e regulamentos de privacidade. Especifique se existe um comité de monitoramento (ou equivalente) responsável pela orientação e acompanhamento de ações relativas à proteção da privacidade.",
			name: "Organização",
			placeholder: "Indique se as funções e responsabilidades para proteção de dados estão definidas.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Existência de uma política projetada que integra a proteção de dados pessoais em todas as novas operações de tratamento.",
			name: "Integração da proteção de privacidade em projetos",
			placeholder: "Descreva aqui como a proteção da privacidade é integrada nos projetos",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "A existência de uma política descrevendo os controles de consciencialização é realizada em relação a um novo recrutador e quais controles são executados quando as pessoas, que têm acesso a dados, deixam seu trabalho.",
			name: "Gestão de pessoal",
			placeholder: "Indique aqui que controles de consciencialização são realizados em relação aos funcionários.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Estabelecer aspectos importantes relativos à proteção de dados dentro de uma base documental que compõe a política de proteção de dados e de uma forma adequada a cada tipo de conteúdo (riscos, princípios-chave a serem seguidos, objetivos alvo, regras a serem aplicadas, etc.) e alvo de comunicação (usuários, departamento de TI, formuladores de políticas, etc.).",
			name: "Política",
			placeholder: "Descreva aqui a base documental que estabelece objetivos e regras de proteção de dados.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Política descrevendo processos para controlar os riscos que as operações de tratamento realizadas pela organização representam na proteção de dados e na privacidade dos sujeitos de dados (criar mapa dos riscos, etc.).",
			name: "Gerenciamento de riscos de privacidade",
			placeholder: "Descreva aqui os processos para controlar os riscos que as operações de tratamento realizadas pela organização representam na proteção de dados e na privacidade dos sujeitos de dados.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Existência de uma organização operacional que possa detetar e tratar incidentes que possam afetar as liberdades civis e a privacidade dos titulares de dados.",
			name: " Gerenciamento de violações de dados pessoais",
			placeholder: "Indique aqui se os incidentes de TI estão sujeitos a um procedimento de gerenciamento documentado e testado.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Políticas e meios implementados para garantir a disponibilidade e/ou integridade dos dados pessoais, mantendo sua confidencialidade.",
			name: "Backups",
			placeholder: "Indique aqui como os backups são gerenciados. Esclareça se eles estão armazenados em um local seguro.",
			source: "PIAF Connected Objects p23 & PIA3 p27 - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Controlos implementados em estações de trabalho (bloqueio automático, atualizações regulares, configuração, segurança física, etc.) para reduzir a possibilidade de explorar propriedades de software (sistemas operacionais, aplicativos de negócios, etc.) para afetar adversamente os dados pessoais.",
			name: "Gestão de estações de trabalho",
			placeholder: "Descreva aqui os controles implementados nas estações de trabalho",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "Os dados de carácter pessoal comunicados ou geridos por subcontratantes devem beneficiar de garantias suficientes. <strong>Use apenas subcontratantes que sejam capazes de fornecer garantias suficientes</strong> (em particular, em termos de conhecimento especializado, confiabilidade e recursos). Exija aos fornecedores de serviços que comuniquem a sua política de segurança de sistemas de informação antes de assinar um contrato com eles. <br>Tome e documente os meios (autorias de segurança, visitas a instalações, etc.) que <strong>assegurem a eficácia das garantias oferecidas pelo subcontratante</strong> em termos de protecção de dados. Estas garantais incluem: <br>- cifragem de dados de acordo com a sua sensibilidade ou, pelo menos, a existência de procedimentos que garantam que a empresa de prestação de serviços não tenha acesso aos dados; <br>- cifragem das transmissões de dados (e.g.: conexão via HTTPS, VPN, etc.); <br>- guarantias em termos de protecção de rede, rastreabilidade (registos, auditorias), gestão de acessos, autenticação, etc. <br><strong>Assine um contrato com os subcontratantes</strong> que defina o assunto, a duração e a finalidade do tratamento assim como as obrigações de cada parte. Assegure-se que contém, em particular, disposições que visam: <br>- a sua obrigação em termos de <strong>confidencialidade dos dados pessoais confiados</strong>;<br>- <strong>normas mínimas em termos de autenticação de utilizadores</strong>;<br>- <strong>condições de restituição e/ou destruição de dados no final do contrato</strong>;<br>- <strong>regras de gestão e notificação de incidentes. </strong> Devem incluir a notificação do responsável pelo tratamento sempre que uma violação de dados ou um incidente de segurança for descoberto, devendo tal ocorrer o mais depressa possível quando se trata de dados pessoais.<br>- No caso de usar um fornecedor de computação na nuvem :<br>\t1. identificar claramente os dados e os tratamentos na nuvem ;<br>\t2. definit as suas próprias exigências de segurança técnica e jurídica ;<br>\t3. conduzir uma análise dos riscos a fim de se identificarem as medidas de segurança apropriadas ;<br>\t4. identificar o tipo de nuvem relevante para o tratamento previsto ;<br>\t5. escolher um fornecedor com garantias suficientes ;<br>\t6. rever a política de segurança interna ;<br>\t7. monitorizar a evolução ao longo do tempo.",
			name: "Processando contratos",
			placeholder: "Descreva aqui medidas específicas para subcontratantes (hospedeiro, empresa de manutenção, administrador, fornecedores de serviços especializados, etc.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Políticas implementadas para reduzir a possibilidade e o impacto dos riscos nos ativos que suportam dados pessoais.",
			name: "Segurança operacional",
			placeholder: "Descreva aqui como as atualizações de software (sistemas operacionais, aplicativos, etc.) e a aplicação de patches de controles corretivos de segurança são executados.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Monitorizar sistemas de deteção de invasão e sistemas de prevenção contra a invasão para analisar o tráfego de rede (redes com fio, Wi-Fi, ondas de rádio, fibra ótica, etc.) em tempo real e detetar qualquer atividade suspeita sugestiva de um cenário de ataque cibernético.",
			name: "Monitorização da atividade de rede",
			placeholder: "Indicar aqui meios e controles implementados para detetar incidentes envolvendo dados pessoais",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Políticas a descrever como a manutenção física do hardware é gerida, afirmando se isso é contratado.<br> Indique se a manutenção remota de aplicativos está autorizada e de acordo com que arranjos. Especifique se o equipamento defeituoso é de uma maneira específica.",
			name: "Manutenção",
			placeholder: "Descreva aqui como a manutenção física do hardware é gerida",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controlos implementados em estações de trabalho e servidores para protegê-los de softwares mal-intencionados enquanto acedam redes menos seguras.",
			name: "Comprimir o software malicioso",
			placeholder: "Descreva aqui os controles implementados para reduzir os riscos ao acessar redes menos seguras.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Indique aqui os controles relacionados à segurança física de servidores e estações de trabalho (armazenamento seguro, cabos de segurança, filtros de confidencialidade, eliminação segura antes de ser desfeito, etc.).",
			name: "Segurança de hardware",
			placeholder: "Indique aqui os controles relacionados à segurança física de servidores e estações de trabalho",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Dependendo do tipo de rede em que o tratamento é realizado (isolado, privado ou Internet), especifique qual sistema de firewall, sistemas de deteção de intrusão ou outros dispositivos, ativos ou passivos, responsáveis por garantir a segurança da rede.",
			name: "Segurança de rede",
			placeholder: "Indique aqui os controles de segurança da rede em que o tratamento é realizado",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Políticas para garantir a segurança física (zoneamento, escolta de visitantes, uso de passes, portas trancadas, etc.). Indique se há procedimentos de alerta em caso de uma invasão.",
			name: "Controlo de acesso físico",
			placeholder: "Indique aqui como o controle de acesso físico é realizado em relação às instalações que acomodam o tratamento.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Políticas que descrevem os meios de prevenção, deteção e combate a incêndios. Se for aplicável, indique os meios para evitar danos causados pela água. Também especifique os meios de monitoramento e alívio da fonte de alimentação.",
			name: "Proteção contra fontes não-humanas de riscos",
			placeholder: "Indique aqui meios para evitar limitar fontes não-humanas de riscos.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Documentação sobre a área de implantação, que não deve estar sujeita a desastres ambientais (zona de inundação, proximidade a indústrias químicas, terramoto ou zona vulcânica, etc.) Especifique se produtos perigosos são armazenados na mesma área.",
			name: "Evitar fontes de risco",
			placeholder: "Indique aqui se a área de implantação está sujeita a desastres ambientais",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementação das Recomendações da ANSSI para proteger websites.",
			name: "Segurança do website",
			placeholder: "Indique aqui os controles implementados para proteger websites.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Indique aqui se os mecanismos de anonimização são implementados, quais e com que finalidade. <br>Lembre-se de distinguir claramente entre dados anónimos e pseudónimos.",
			name: "Anonimização",
			placeholder: "Indique aqui os mecanismos de anonimização implementados",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Se for aplicável, descreva aqui os processos de gestão de arquivo (entrega, armazenamento, consulta, etc.) sob sua responsabilidade. Especifique as funções de arquivo (escritórios de origem, agências de transferência etc.) e a política de arquivo. Refira se os dados podem estar incluídos no âmbito de arquivo público.",
			name: "Arquivo",
			placeholder: "Indique quais os mecanismos que são implementados para a monitorização da integridade dos dados armazenados e para que finalidade.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Meios implementados para <strong>assegurar a confidencialidade</strong> dos dados guardados (no banco de dados, em arquivos simples, backups, etc.), bem como o procedimento para gerir chaves de criptografia (criação, armazenamento, alteração no caso de casos suspeitos de comprometimento de dados, etc.).<br> Descrever os meios de criptografia empregados nos fluxos de dados (VPN, TLS, etc.) implementados no tratamento.",
			name: "Cifragem",
			placeholder: "Descreva aqui os meios implementados para garantir a confidencialidade dos dados",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "A implementação da partição de dados ajuda a reduzir a possibilidade de que os dados pessoais possam ser correlacionados e que uma violação de todos os dados pessoais possa ocorrer.",
			name: "Partição de dados",
			placeholder: "Indique aqui se a partição do tratamento está planejado e como isso é realizado.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Métodos para definir e atribuir perfis de usuários. Especifique os meios de <strong>autenticação</strong> implementados. Quando aplicável, especifique as regras aplicáveis às senhas (duração mínima, caracteres necessários, duração da validade, número de tentativas falhadas antes que o acesso à conta seja bloqueado, etc.).",
			name: "Controlo de acesso lógico",
			placeholder: "Indique aqui como os perfis dos usuários são definidos e atribuídos.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Políticas que definem a rastreabilidade e a gestão de log.",
			name: "Rastreabilidade (logging)",
			placeholder: "Indique aqui se os eventos são registados e por quanto tempo esses rastreamentos são armazenados.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Os seguintes métodos podem ser usados: Filtragem e remoção, Redução da sensibilidade por conversão, Redução da natureza de identificação dos dados, Redução da acumulação de dados, Restrição do acesso a dados",
			name: "de dados pessoais",
			placeholder: "Indicar aqui meios implementados para reduzir a gravidade dos riscos, limitando a quantidade de dados pessoais.",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Quando documentos em papel contêm dados são usados durante o tratamento, indique aqui como eles são impressos, armazenados, destruídos e trocados.",
			name: "Segurança do documento em papel",
			placeholder: "Indique aqui se os mecanismos são implementados para monitoramento de integridade de documentos em papel, quais e para que finalidade.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Controlos corretivos sugeridos pelo avaliador nas etapas anteriores, elaborando um plano de ação definindo, para cada ação, seu gerente, frequência, dificuldade, custo e progresso.",
			name: "Plano de ação",
			source: "Nenhum"
		},
		PIA_VAL_CART: {
			description: "Gráfico que ilustra as boas práticas de segurança, com um valor de conformidade atribuído a cada uma com base em sua avaliação em etapas anteriores.",
			name: "Mapeamento de riscos",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Quando for apropriado, o responsável pelo tratamento solicita a opinião dos titulares de dados ou dos seus representantes sobre o tratamento pretendido, sem prejuízo da protecção dos interesses comerciais ou públicos ou da segurança das operações de tratamento. Ver Art. 39.2 de <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">[RGPD]</a><br> <strong>Esses pontos de vista podem ser reunidos por diversos meios, dependendo do contexto (estudo interno ou externo sobre os métodos de tratamento e finalidade, pergunta para a atenção dos representantes do pessoal ou sindicatos, pesquisa entre os futuros clientes do subcontratante). Quando o responsável pelo tratamento decide ir contra as opiniões dos titulares dos dados</strong>, ele deve anotar <strong>a justificação para essa decisão</strong>. Quando o responsável pelo tratamento considera que <strong>reunir as opiniões dos titulares dos dados não é relevante, ele deve também anotar a justificação disso</strong>.",
			name: "Opinião dos titulares dos dados",
			source: "GDPR Art. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "O responsável pelo tratamento deve solicitar o parecer do encarregado da proteção de dados, quando efetuar uma avaliação de impacto sobre a proteção de dados. Ver Art. 39.2 de <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/PT/TXT/HTML/?uri=CELEX:32016R0679\">[RGPD]</a><br> <strong>Essa visão pode ser contra o tratamento que está sendo implementado, sem restringir a decisão do responsável pelo tratamento para todos que</strong>.",
			name: "Opinião do Encarregado da Proteção de Dados (DPO)",
			source: "GDPR Art. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Decidir se os controles selecionados, os riscos residuais e o plano de ação são aceitáveis, com justificações, tendo em vista as participações e visões anteriormente identificadas das partes interessadas. Desta forma, a análise PIA pode ser:<br>- validada<br>- condicionada, em melhoria (explique de que maneira)<br>- recusada (juntamente com o tratamento em consideração). Se necessário, repita os passos anteriores para que a análise PIA possa ser validada. Esta decisão não prejudica a avaliação da conformidade que pode ser efetuada, se for aplicável, pela Autoridade de Proteção de Dados (CNIL em França), como parte das formalidades preliminares ou dos controles, por exemplo.",
			name: "Validação Formal",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Base de conhecimento"
};
var measures$5 = {
	add: "Adicionar uma medida vazia (caso contrário, usar a base de conhecimento)",
	default_placeholder: "Descrever as medidas existentes ou planejadas para assegurar a segurança de dados.",
	edit: "Editar medida",
	placeholder_title: "Título de medida",
	remove: "Apagar medida"
};
var misc$5 = {
	display: "Mostrar/Esconder"
};
var modals$5 = {
	abandon_pia: {
		additional_text: "O arquivo não é definitivo e pode voltar à análise PIA se for necessário.",
		content: "Tem certeza que quer<br>desistir deste tratamento?"
	},
	action_plan_no_evaluation: {
		content: "Precisa de começar a revisão da análise para poder criar um plano de acção.",
		review_section: "Rever uma seção"
	},
	archive: "Arquivar",
	archive_pia: {
		archive: "Arquivar AIIA",
		content: "<span class='strong'>Warning,</span><br>Tem certeza que deseja <br>arquivar este PIA ?"
	},
	ask_for_evaluation: {
		content: "<span class='strong'>Parabéns</span><br>, a subseção está agora <br>disponível para avaliação."
	},
	back_to_edition: {
		content: "Esta seção foi enviada de volta para edição. <br> Vários campos devem ser corrigidos<br> para permitir sua revisão adequada."
	},
	back_to_evaluation: {
		content: "Esta seção foi enviada de volta para revisão.<br> Devem ser revistos vários campos<br> para permitir sua validação adequada."
	},
	back_to_home: "Voltar para o menu",
	cancel: "Cancelar",
	close: "Fechar",
	completed_edition: {
		content: "A análise PIA foi editada, deve ser revista."
	},
	completed_evaluation: {
		content: "A análise PIA foi revista, deve ser validada."
	},
	"continue": "Continuar",
	declare_measures: {
		content: "Atenção, <br>antes de avaliar os riscos<br>, deve relatar as <br>medidas existentes ou planejadas.",
		declare: "Declarar medidas existentes ou planejadas"
	},
	dpo_missing_evaluations: {
		comment: "Comentar",
		content: "É preciso completar a revisão da análise para acessar a página do DPO.",
		remove: "Remover",
		review_section: "Rever uma seção"
	},
	general_error: {
		content: "Pedimos desculpas, ocorreu um erro."
	},
	import_wrong_pia_file: {
		content: "O arquivo importado não corresponde a um arquivo do tipo PIA"
	},
	import_wrong_structure_file: {
		content: "O arquivo importado não corresponde a um arquivo do tipo Modelo"
	},
	knowledge: {
		content: "Tem certeza que deseja deletar este elemento?",
		remove: "Deletar este elemento"
	},
	knowledges: {
		content: "Tem certeza que deseja deletar esta base de conhecimento?",
		remove: "Deletar esta base de conhecimento"
	},
	modal_select_text_pia: {
		content: "O conteúdo da análise PIA foi copiado para a área de transferência."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Atenção,</span> Pelo menos uma medida deve ser preenchida: não é possível excluir<br>."
	},
	recover_version: {
		"continue": "Continuar",
		message: "Caso continue, irá restaurar essa versão do documento: {{date}}.<br><br>A versão atual será salva.",
		title: "Restaurar uma versão anterior"
	},
	refuse_pia: {
		content: "<span class='strong'>Como rejeitou a análise PIA,</span><br>esta regressou à revisão para corrigir as alterações necessárias."
	},
	remove_attachment: {
		comment: "Comentar",
		content: "<span class='strong'>Atenção</span><br>, tem certeza que quer <br>remover este anexo?",
		keep: "Manter",
		remove: "Remover"
	},
	remove_measure: {
		content: "<span class='strong'>Atenção,</span><br> Tem certeza que quer <br>remover esta medida?",
		keep: "Manter esta <br>medida",
		remove: "Remover esta <br>medida"
	},
	remove_pia: {
		content: "<span class='strong'>Atenção,</span><br> Tem certeza que quer <br>remover permanentemente esta PIA?",
		remove: "Remover esta análise PIA"
	},
	remove_question: {
		content: "Tem a certeza que deseja apagar a pergunta ?",
		keep: "Cancelar",
		remove: "Apagar"
	},
	remove_structure: {
		content: "<span class='strong'>Atenção,</span><br>Tem certeza que deseja <br>apagar este modelo ?",
		remove: "Apagar este modelo"
	},
	same_comment: {
		content: "<span class='strong'>Atenção,</span> Por favor insira um comentário diferente do último gravado<br>."
	},
	signed_pia_validation: {
		content: "<span class='strong'>A análise PIA é aceite</span><br> Finalize a validação da análise PIA anexando<br>o relatório assinado pela pessoa responsável.",
		download_pia: "Download do relatório PIA"
	},
	simple_pia_validation: {
		content: "A análise PIA foi validada."
	},
	start_evaluation: "Começar a revisão",
	unarchive_pia: {
		content: "<span class='strong'>Atenção,</span><br>Tem certeza que deseja <br>desarquivar esta PIA ?",
		unarchive: "Desarquivar PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "O endereço do servidor foi atualizado."
	},
	validate_evaluation: {
		content: "<span class='strong'>Parabéns</span><br>, terminou de avaliar esta seção. <br>Outras partes da ferramenta PIA também devem ser avaliadas para poder validar a análise PIA."
	},
	validate_evaluation_to_correct: {
		content: "Atenção, <br>vários campos devem ser corrigidos. <br>Retorne ao modo de edição<br>para fazer correções."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$5 = {
	dashboard: {
		step1: {
			description: "Clique no <strong>+</strong> para criar seu primeiro PIA.",
			title: "Criar um PIA"
		},
		step2: {
			description: "<p><strong>Editores</strong> escrevem a primeira versão da análise.</p><p>Eles são, por exemplo, os gerentes do projeto associados ao processamento de dados.</p>",
			title: "Personas do PIA"
		},
		step3: {
			description: "<p><strong>Revisores</strong> são envolvidos na segunda fase.</p><p>Se utilizam de sua expertise legal ou técnica para checar a qualidade e alinhamento do processo.</p><p>Eles são, por exemplo, DPO, especialistas legais, ...</p>",
			title: "Personas do PIA"
		},
		step4: {
			description: "<p>O <strong>validador</strong> aceita ou rejeita a implementação do processo. Ele precisa assinar a análise.</p><p> Ele é o controlador, ex: o CEO.</p>",
			title: "Personas do PIA"
		},
		step5: {
			description: "<p><strong>Modelos</strong> são uma ferramenta avançada. São utilizados para criar uma base pré-preenchida para a análise.</p><p>Você pode criar modelos na seção associada no menu superior.</p>",
			title: "Modelos"
		}
	},
	entry: {
		step1: {
			description: "Para mover de uma parte da análise para a outra, utilize o menu de navegação à esquerda.",
			title: "Navegação"
		},
		step2: {
			description: "É utilizado para explicar o propósito do processo e como será implementado.",
			title: "Contexto"
		},
		step3: {
			description: "Têm o objetivo de garantir que o processo está de acordo com a LGPD.",
			title: "Princípios fundamentais"
		},
		step4: {
			description: "Descrevem as medidas de segurança já planejadas para a operação do processo e tornar possível a avaliação de potenciais impactos nos dados.",
			title: "Riscos"
		},
		step5: {
			description: "Permite o DPO expressar sua opinião na implementação do processo e o controlador aceitá-lo ou recusá-lo.",
			title: "Validação"
		},
		step6: {
			description: "<p>Provê assistência contextual para a análise e é baseada na LGPD, no guia de segurança e guias de PIA do CNIL</p><p>Além disso, também é possível criar sua próprias bases de conhecimento para acessar facilmente informações específicas da sua organização.</p>",
			title: "A base de conhecimento"
		},
		step7: {
			description: "A qualquer momento durante a análise, é possível fazer o download da análise em diversos formatos para compartilhá-la com seus colegas.",
			title: "Exportar seu PIA"
		}
	},
	evaluation: {
		step1: {
			description: "A avaliação pode considerar uma seção inteira, ou cada elemento da seção.",
			title: "Avaliar a PIA"
		},
		step2: {
			description: "<p>Este status indica aos editores que há elementos faltantes para uma avaliação relevante.</p><p> O avaliador precisa indicá-los no campo <strong>comentário de avaliação</strong>. O editor fará as correções necessárias.</p>",
			title: "A corrigir"
		},
		step3: {
			description: "<p>Este status indica que os elementos do processo devem ser revisados. Eles são detalhados nos campos <strong>plano de ação/ações corretivas</strong>.</p><p>Estas medidas serão automaticamente adicionadas à seção do plano de ação da análise. É necessário implementá-las o mais breve possível.</p>",
			title: "Improvável"
		},
		step4: {
			description: "Este status significa que esta parte do processo pode ser implementada sem modificações.",
			title: "Aceitável"
		},
		step5: {
			description: "Se a avaliação da seção ainda não começou, o pedido de avaliação pode ser cancelado para realização de mudanças na descrição do processo.",
			title: "Cancelar pedido de avaliaçaõ"
		}
	},
	general: {
		done: "Confirmar",
		next: "Próximo",
		skip: "Pular"
	},
	validated: {
		step1: {
			description: " Uma análise completa e validada pode ser consultada a qualquer momento pela interface dedicada.",
			title: "Consultar um PIA validado"
		},
		step2: {
			description: "É necessário revisar regularmente a análise. Você pode editar ou duplicar a qualquer momento para revisar o conteúdo de acordo com a evolução do processo.",
			title: "Atualizar um PIA validado"
		}
	}
};
var opinions$5 = {
	content: ", considerar que :",
	dpo_lock: "Por favor, preencha as outras seções antes de preencher a opinião do DPO.",
	dpo_opinion: "Opinião do DPO",
	edit: "Editar",
	people_opinion: "Opinião de partes interessadas",
	placeholder_concerned_people_name: "Nome(s) de parte(s) interessada(s)",
	placeholder_dpo_name: "Nome do DPO",
	placeholder_dpo_opinion: "Especifique as razões da sua escolha.",
	placeholder_people_opinion: "Descreva como as opiniões foram recolhidas e qual é a análise. Se os avisos não foram solicitados, indique as razões.",
	placeholder_search_content: "Justifique a razão pela qual o parecer das pessoas em causa não foi solicitado.",
	treatment_lock: "Por favor, preencha as outras seções antes de poder preencher as opiniões das pessoas envolvidas.",
	treatment_nok: "O tratamento não pode ser usado.",
	treatment_ok: "O tratamento pode ser implementado."
};
var pia$5 = {
	attachments: {
		add: "Adicionar",
		download: "Download do anexo",
		loading: "Carregando...",
		remove: "Remover",
		title: "Anexos",
		no_attachment: "Nenhum anexo disponível"
	},
	footer: {
		ask_evaluation: "Pedir revisão",
		mandatory_fields: "Todos os campos devem estar preenchidos",
		structure_add_question: "Adicionar uma pergunta",
		subsection_validated: "Subseção revista, esperando pela validação final",
		validate_evaluation: "Validar revisão"
	},
	header: {
		display_action_plan: "Exibir<br>plano de ação",
		edition: "Edição",
		evaluation: "Avaliação",
		preview: "Pré-visualização"
	},
	sections: {
		based_on_structure_name: "Baseado no modelo :",
		homepage_link: "Voltar para o painel",
		refuse_pia: "Análise PIA recusada",
		status: {
			evaluation: {
				cancel: "cancelar o pedido de revisão.",
				cancel_button: "Cancelar pedido de revisão",
				content: "Esta parte ainda não foi revista. Caso deseje editar o conteúdo submetido para revisão terá que ",
				title: "Aguarda revisão."
			},
			validation: {
				cancel: "cancelar o pedido de validação.",
				cancel_button: "Cancelar pedido de validação",
				content: "Esta parte foi revista e aguarda validação completa da análise PIA. Se desejar mudar a revisão, terá de ",
				title: "Aguarda validação."
			}
		},
		validate_pia: "Validar análise PIA"
	},
	statuses: [
		"Em progresso",
		"Rejeitado",
		"Validação simples",
		"Validação assinada",
		"Arquivado",
		"Aguarda validação"
	]
};
var questions$5 = {
	edit: "Editar pergunta",
	gauges: [
		"(Indefinido)",
		"Insignificante",
		"Limitado",
		"Significativo",
		"Máximo"
	],
	placeholder_title: "Título da pergunta (obrigatório)",
	remove: "Apagar a pergunta"
};
var rejection_page$5 = {
	applied_adjustments: "Ajustamentos propostos",
	applied_adjustments_placeholder: "Descrever as mudanças produzidas pela análise PIA.",
	button: {
		abandon_treatment: "Abandono do tratamento",
		reject_pia: "Rejeitar análise AIIA",
		send_for_validation: "Reenvio para aprovação"
	},
	previous_rejection: "Recusa anterior",
	rejection_reason: "Motivo de recusa",
	rejection_reason_placeholder: "Descrever os motivos da recusa da análise PIA.",
	title: "História de validação"
};
var sections$5 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Descreva a finalidade de tratamento, incluindo nome, objetivos e benefícios dessa finalidade, contexto de utilização, etc.",
						title: "Qual é a finalidade de tratamento considerada no âmbito da análise?"
					},
					"2": {
						placeholder: "Descreva as responsabilidades de todos os intervenientes envolvidos na finalidade de tratamento, identificando a entidade que atua como responsável pelo tratamento, entidades subcontratadas que tratem estes dados, terceiros autorizados, entre outros. <br><br>Responsável pelo tratamento é a pessoa singular ou coletiva, a autoridade pública, a agência ou outro organismo que, individualmente ou em conjunto com outras (responsáveis conjuntos), determina as finalidades e os meios de tratamento de dados pessoais. <br><br>No caso de existirem responsáveis conjuntos pelo tratamento, estes determinam por acordo entre si e de modo transparente as respetivas responsabilidades pelo cumprimento do RGPD, nomeadamente no que diz respeito ao exercício dos direitos do titular dos dados e aos respetivos deveres de fornecer as informações requeridas pelo RGPD, a menos e na medida em que as suas responsabilidades respetivas sejam determinadas pelo direito da União ou do Estado-Membro a que se estejam sujeitos.",
						title: "Quais são as responsabilidades inerentes ao tratamento de dados pessoais?"
					},
					"3": {
						placeholder: "Para esta finalidade de tratamento identifique as normas seguidas pela organização, especialmente códigos de conduta aprovados, certificações de proteção de dados e/ou segurança da informação, cláusulas de subcontratação com indicação expressa da forma de utilização dos dados, entre outros.",
						title: "Quais são as normas aplicáveis à finalidade de tratamento?"
					}
				},
				short_help: "Esta seção permite identificar e apresentar o objeto de estudo.",
				title: "Visão geral"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Identifique as categorias de dados recolhidos e processados (p.ex. nome, data nascimento, morada, etc.) e identifique o prazo de conservação destes dados, caso exista, por tipo de dados. No caso de não existir um prazo definido, este facto deverá ser indicado.",
						title: "Quais são os dados pessoais tratados?"
					},
					"2": {
						placeholder: "Apresente e descreva como os dados são processados (desde a recolha de dados até a destruição dos mesmos, as diferentes fases de tratamento, armazenamento, etc.). Se for aplicável, anexe exemplos de fluxogramas. Também é necessário identificar os tipos de operações de tratamento, tendo em contra os seguintes pontos: <br>-recolha <br>-registo <br>-organização <br>-estruturação <br>-conservação <br>-adaptação ou alteração <br>-recuperação <br>-consulta <br>-utilização <br>-divulgação por transmissão, difusão ou qualquer outra forma de disponibilização <br>-comparação ou interconexão <br>-limitação <br>-apagamento ou destruição <br>-outros.",
						title: "Como funciona o ciclo de vida dos dados pessoais e dos processos inerentes?"
					},
					"3": {
						placeholder: "Identifique os ativos de informação de que dependem os dados pessoais: <br>-equipamento informático <br>-software <br>-redes <br>-pessoas intervenientes (cargos desempenhados na organização) <br>-suportes de informação em papel. <br><br>Para a finalidade de tratamento, devem ser indicados os tipos de meios utilizados para o tratamento de dados. Estes podem ser: <br>-<strong>Meios de tratamento automatizados</strong>: devem ser indicados todos os meios tecnológicos (softwares, sistemas, sites) utilizadas no tratamento dos dados pessoais; <br>-<strong>Meios de tratamento não automatizados</strong>: devem ser indicadas as operações manuais (preenchimento de formulários em papel, criação de cópias de documentos e/ou digitalização, arquivo físico em papel, entre outros) realizadas para a finalidade de tratamento. <br><br>Para esta finalidade, devem ser identificados equipamentos físicos como computadores portáteis ou impressoras, aplicações utilizadas, se é utilizado um servidor próprio ou cloud, quem manuseia documentos em papel e como os ativos são transmitidos na organização.",
						title: "Quais são os ativos de informação utilizados na finalidade de tratamento?"
					}
				},
				short_help: "Esta seção permite definir e descrever o âmbito do tratamento em detalhes.",
				title: "Dados, processos e ativos de suporte"
			}
		},
		short_help: "Esta seção fornece uma visão clara do(s) tratamento(s) de dados pessoais em questão.",
		title: "Contexto"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Justifique porque a finalidade é específica, explícita e legítima.",
						short_title: "Objetivos",
						title: "A finalidade de tratamento é específica, explícita e legítima?"
					},
					"2": {
						placeholder: "Identifique qual é o fundamento de tratamento de dados (consentimento, contrato, obrigação jurídica, interesses vitais do titular dos dados, funções de interesse público, interesses legítimos). <br><br>É necessário identificar o periodo da aplicabilidade do fundamento para tratamento de dados pessoais, que pode variar ao longo do ciclo de vida dos dados pessoais descrito na resposta à pergunta Q.5. “Como funciona o ciclo de vida dos dados pessoais e dos processos inerentes?”. <br><br>Por exemplo, o fundamento para tratamento de dados pessoais pode passar da execução de contrato, pela obrigação jurídica para conservação dos documentos específicos e acabando no consentimento após a cessação do prazo de conservação legalmente definido. <br><br>Para que o tratamento seja lícito, os dados pessoais deverão ser tratados com base no consentimento do titular dos dados em causa ou noutro fundamento legítimo, previsto por lei, incluindo a necessidade de serem cumpridas as obrigações legais a que o responsável pelo tratamento se encontre sujeito, a necessidade de serem executados contratos em que o titular dos dados seja parte ou a fim de serem efetuadas as diligências pré-contratuais que o titular dos dados solicitar. <br><br>Deve, portanto, verificar-se pelo menos um dos seguintes fundamentos: <br>-O titular dos dados deu o seu <strong>consentimento</strong> para o tratamento dos seus dados pessoais para uma ou mais finalidades específicas; <br>-O tratamento é necessário para a <strong>execução de um contrato</strong> no qual o titular dos dados é parte, ou para diligências pré-contratuais a pedido do titular dos dados; <br>-O tratamento é necessário para o cumprimento de uma <strong>obrigação jurídica</strong> a que o responsável pelo tratamento esteja sujeito; <br>-O tratamento é necessário para a defesa de <strong>interesses vitais</strong> do titular dos dados ou de outra pessoa singular; <br>-O tratamento é necessário ao exercício de <strong>funções de interesse público</strong> ou ao exercício da autoridade pública de que está investido o responsável pelo tratamento; <br>-O tratamento é necessário para efeito dos <strong>interesses legítimos</strong> prosseguidos pelo responsável pelo tratamento ou por terceiros, exceto se prevalecerem os interesses ou direitos e liberdades do titular. <br><br><strong>Os interesses legítimos devem ser devidamente justificados e validados por advogados </strong>. Podem ser identificados os seguintes interesses legítimos prosseguidos: <br>-Tratamento dos dados pessoais dos clientes em casos quando as relações contratuais não são devidamente formalizadas <br>-Tratamento dos dados pessoais dos titulares dos dados que estão ao serviço do responsável pelo tratamento independentemente da existência da remuneração; <br>-Tratamento dos dados pessoais para efeitos de comercialização direta; <br>-Tratamento dos dados pessoais para assegurar a segurança da rede e das informações; <br>-Tratamento dos dados pessoais no âmbito do grupo de empresas; <br>-Indicação de eventuais atos criminosos ou ameaças à segurança pública a autoridades competentes; <br>-Tratamento de dados pessoais necessário à prevenção e controle da fraude; <br>-Transferências não repetitivas que apenas digam respeito a um número limitado de titulares de dados.",
						short_title: "Base legal",
						title: "Qual é o fundamento para tratamento de dados pessoais?"
					},
					"3": {
						placeholder: "Justifique a necessidade de recolha dos dados pessoais de acordo com o objectivo do tratamento e a respetiva finalidade. Esta análise deverá ser feita por tipo de dados identificados na pergunta Q.4 'Quais são os dados pessoais tratados?'.",
						short_title: "Dados adequados",
						title: "Os dados pessoais recolhidos são adequados, relevantes e limitados para o propósito de tratamento realizado (princípio da minimização de dados)?"
					},
					"4": {
						placeholder: "Descreva quais são as medidas implementadas para garantir que os dados pessoais são atualizados. Devem ser adotadas todas as medidas adequadas para que os dados inexatos, tendo em conta a finalidade para que são tratados, sejam apagados ou retificados sem demora injustificada.",
						short_title: "Precisão de dados",
						title: "Os dados pessoais estão atualizados e são fidedignos?"
					},
					"5": {
						placeholder: "Identifique o prazo de conservação dos dados pessoais e justifique o mesmo pelos requisitos legais e/ou pelas necessidades de negócio. É importante considerar os prazos da conservação por tipos de dados identificados na resposta à pergunta Q.4. “Quais são os dados pessoais tratados?”, pois a justificação do mesmo pode variar em função do tipo de dados em questão. <br>Descreva medidas implementadas para garantir a eliminação e/ou anonimização dos dados no fim do prazo identificado ou indique a ausência das mesmas.",
						short_title: "Duração dos dados",
						title: "Qual é o prazo da conservação dos dados?"
					}
				},
				short_help: "Esta seção permite demonstrar a legitimidade do seu tratamento e dos dados processados.",
				title: "Proporcionalidade e necessidade"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Indique se as informações devidas ao abrigo do direito de informação estão a ser prestadas ou não ao titular de dados. Em caso afirmativo, identifique as informações que são fornecidas ao titular e quais os meios para fazer isso aquando da recolha de dados pessoais.",
						short_title: "Informação para os titulares dos dados",
						title: "Como é que os titulares dos dados são informados sobre o tratamento dos seus dados?"
					},
					"2": {
						placeholder: "Se for aplicável, descreva os controles previstos para obtenção do consentimento dos titulares de dados.",
						short_title: "Obtenção do consentimento",
						title: "Como é obtido o consentimento dos titulares de dados?"
					},
					"3": {
						placeholder: "Descreva os controles previstos para garantir que os titulares exerçam os direitos de obter do responsável pelo tratamento a confirmação de que os dados pessoais que lhe digam respeito são ou não objeto de tratamento e, se for esse o caso, o direito de aceder aos seus dados pessoais, bem como o direito de portabilidade.",
						short_title: "Direito de acesso e portabilidade de dados",
						title: "Como é garantido o acesso e portabilidade de dados pessoais?"
					},
					"4": {
						placeholder: "O titular de dados tem o direito de obter sem demora injustificada, do responsável pelo tratamento a retificação dos dados pessoais inexatos que lhe digam respeito. Tendo em conta as finalidades do tratamento, o titular dos dados tem direito a que os seus dados pessoais incompletos sejam completos, incluindo por meio de uma declaração adicional. O titular dos dados tem o direito de se opor a qualquer momento, por motivos relacionados com a sua situação particular, ao tratamento dos dados pessoais que lhe digam respeito para: <br>-Exercício de funções de interesse público; <br>-Efeito dos interesses legítimos prosseguidos pelo responsável pelo tratamento ou por terceiros; <br>-Fins que não sejam aqueles para os quais os dados pessoais foram recolhidos. <br><br>O responsável pelo tratamento cessa o tratamento dos dados pessoais, a não ser que apresente razões imperiosas e legítimas para esse tratamento que prevaleçam sobre os interesses, direitos e liberdades do titular dos dados, ou para efeitos de declaração, exercício ou defesa de um direito num processo judicial. Deverão ser descritos os controles existentes que permitem aos titulares dos dados o exercício deste direito.",
						short_title: "Direito à retificação e apagamento",
						title: "Como é garantida a atualização/retificação e apagamento dos dados pessoais pedida pelo titular dos mesmos?"
					},
					"5": {
						placeholder: "Descreva os controles destinados a permitir que os titulares restrinjam e se oponham ao tratamento dos seus dados pessoais. <br><br>O titular dos dados tem o direito de obter do responsável pelo tratamento a limitação do tratamento, se se aplicar uma das seguintes situações: <br>-Contestar a exatidão dos dados pessoais, durante um período que permita ao responsável pelo tratamento verificar a sua exatidão; <br>-O tratamento for ilícito e o titular dos dados se opuser ao apagamento dos dados pessoais e solicitar, em contrapartida, a limitação da sua utilização; <br>-O responsável pelo tratamento já não precisar dos dados pessoais para fins de tratamento, mas esses dados sejam requeridos pelo titular para efeitos de declaração, exercício ou defesa de um direito num processo judicial; <br>-Se tiver oposto ao tratamento, até se verificar que os motivos legítimos do responsável pelo tratamento prevalecem sobre os do titular dos dados.",
						short_title: "Direito à restrição e à oposição",
						title: "Como é garantida a limitação do tratamento dos dados pessoais pedido pelo titular dos mesmos?"
					},
					"6": {
						placeholder: "Para cada subcontratante descreva as suas responsabilidades (objeto e a duração do tratamento, a natureza e finalidade do tratamento, o tipo de dados pessoais e as categorias dos titulares dos dados) e forneça os contratos, códigos de conduta e certificações que determinam as obrigações e direitos do responsável pelo tratamento.",
						short_title: "Subcontratação",
						title: "As obrigações dos subcontratantes são claramente identificadas e reguladas por contrato ou outro ato normativo?"
					},
					"7": {
						placeholder: "Quando os dados pessoais são transferidos da União Europeia para responsáveis pelo tratamento, para subcontratantes ou para outros destinatários em países terceiros ou para organizações internacionais, o nível de proteção das pessoas singulares assegurado na União Europeia pelo RGPD deverá continuar a ser garantido, inclusive nos casos de posterior transferência de dados pessoais do País terceiro ou da organização internacional em causa para responsáveis pelo tratamento, subcontratantes desse país terceiro ou de outro, ou para uma organização internacional. <br>Para cada país fora da União Europeia onde os dados são armazenados ou processados, este deverá ser identificado nesta pergunta e ter a indicação se está disponível um nível adequado de protecção de dados ou o titular de dados tem o direito de obter sem demora injustificada, do responsável pelo tratamento a retificação dos dados pessoais inexatos que lhe digam respeito. Tendo em conta as finalidades do tratamento, o titular dos dados tem direito a que os seus dados pessoais incompletos sejam completos, incluindo por meio de uma declaração adicional. O titular dos dados tem o direito de se opor a qualquer momento, por motivos relacionados com a sua situação particular, ao tratamento dos dados pessoais que lhe digam respeito para: as disposições relativas à transferência.",
						short_title: "Transferências",
						title: "No caso de transferência de dados fora da União Europeia, os dados são adequadamente protegidos?"
					}
				},
				short_help: "Esta seção permite demonstrar que estão a ser implementadas todas as medidas que permitem assegurar o exercício dos direitos ao titular dos dados pessoais.",
				title: "Controlos para proteger os direitos pessoais dos titulares dos dados"
			}
		},
		short_help: "Esta seção permite que crie a estrutura de conformidade para os princípios de privacidade.",
		title: "Princípios fundamentais"
	},
	"3": {
		items: {
			"1": {
				short_help: "Esta seção permite identificar controles (existentes ou planejados) que contribuem para a segurança de dados.",
				title: "Medidas planejadas ou existentes"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Insira os possíveis impactos",
						title: " Quais poderiam ser os principais <span class='green-highlight'>impactos nos dados dos titulares</span> se o risco ocorrer?"
					},
					"2": {
						placeholder: "Insira as ameaças",
						title: "Quais são os principais <span class='green-highlight'>ameaças</span>que poderiam levar ao risco? "
					},
					"3": {
						placeholder: "Insira as fontes de risco",
						title: "Quais são as <span class='green-highlight'>fontes</span>de risco?"
					},
					"4": {
						placeholder: "Clique para selecionar controles que abordam o risco.",
						title: "Quais são os <span class='green-highlight'>controles</span> identificados que contribuem para abordar o risco?"
					},
					"5": {
						placeholder: "Justifique aqui a gravidade estimada do risco.",
						title: "Como estimas a <span class='green-highlight'>gravidade do risco</span>, especialmente de acordo com impactos potenciais e controles planejados?"
					},
					"6": {
						placeholder: "Justifique aqui a probabilidade estimada do risco.",
						title: "Como estimas a <span class='green-highlight'>probabilidade de risco</span>, especialmente em relação a ameaças, fontes de risco e controles planejados?"
					}
				},
				short_help: "Analisar as causas e consequências do acesso ilegítimo aos dados e estimar sua gravidade e probabilidade.",
				title: "Acesso ilegítimo dos dados"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Inserir os impactos potenciais",
						title: "Quais poderiam ser os <span class='green-highlight'>impactos nos dados dos titulares </span> se o risco ocorrer?"
					},
					"2": {
						placeholder: "Inserir as ameaças",
						title: "Quais são as principais <span class='green-highlight'>ameaças</span> que poderiam levar ao risco?"
					},
					"3": {
						placeholder: "Inserir as fontes de risco",
						title: "Quais são as <span class='green-highlight'>fontes</span>de risco?"
					},
					"4": {
						placeholder: "Clique aqui para selecionar controles que abordam o risco.",
						title: "Quais são os <span class='green-highlight'>controles</span> identificados que contribuem para abordar o risco?"
					},
					"5": {
						placeholder: "Justifique aqui a gravidade estimada do risco.",
						title: "Como estimas a <span class='green-highlight'>gravidade do risco</span>, especialmente de acordo com impactos potenciais e controles planejados?"
					},
					"6": {
						placeholder: "Justifique aqui a probabilidade estimada do risco.",
						title: "Como estimas a <span class='green-highlight'>probabilidade do risco</span>, especialmente em relação a ameaças, fontes de risco e controles planejados?"
					}
				},
				short_help: "Analisar as causas e consequências de uma alteração indesejada nos dados e estimar sua gravidade e probabilidade.",
				title: "Modificação indesejada dos dados"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Isnerir os impactos potenciais",
						title: "Quais são os principais <span class='green-highlight'>impactos nos dados dos titulares</span> se o risco ocorrer?"
					},
					"2": {
						placeholder: "Inserir as ameaças",
						title: "Quais são as principais <span class='green-highlight'>ameaças</span> que poderiam levar ao risco"
					},
					"3": {
						placeholder: "Inserir as fontes de risco",
						title: "Quais são as <span class='green-highlight'>fontes</span>de risco?"
					},
					"4": {
						placeholder: "Clique aqui para selecionar controles que abordam o risco.",
						title: "Quais são os <span class='green-highlight'>controles</span> identificados que contribuem para abordar o risco?"
					},
					"5": {
						placeholder: "Justifica aqui a gravidade estimada.",
						title: "Como estima a <span class='green-highlight'>gravidade de risco</span>, especialmente de acordo com impactos potenciais e controles planejados?"
					},
					"6": {
						placeholder: "Justifica aqui a probabilidade estimada.",
						title: "Como estima a <span class='green-highlight'>probabilidade do risco</span>, especialmente em relação a ameaças, fontes de risco e controles planejados?"
					}
				},
				short_help: "Analisar as causas e consequências da perda de dados e estimar sua gravidade e probabilidade.",
				title: "Desaparecimento de dados"
			},
			"5": {
				short_help: "Esta visualização permite que tenha uma visão global e sintética dos efeitos dos controles sobre os riscos que eles abordam.",
				title: "Visão geral dos riscos"
			}
		},
		short_help: "Esta seção permite avaliar os riscos de privacidade, tendo em conta os controles existentes ou planejados.",
		title: "Riscos"
	},
	"4": {
		items: {
			"1": {
				short_help: "Esta visualização permite comparar a relação entre o posicionamento dos riscos entre si, antes e depois da aplicação dos controles complementares.",
				title: "Mapeamento dos riscos"
			},
			"2": {
				short_help: "Planeie em detalhes a implementação dos controles adicionais identificados durante a análise PIA. O plano de ação é atualizado automaticamente ao avaliar os diferentes elementos contidos na análise PIA.",
				title: "Plano de ação"
			},
			"3": {
				short_help: "Apresente o conselho da pessoa encarregada da proteção de dados e questões de privacidade (delegado de proteção de dados, se houver). Apresentar as opiniões dos titulares de dados ou seus representantes.",
				title: "DPO e opiniões de partes interessadas"
			},
			"4": {
				title: "Validar análise PIA"
			},
			"5": {
				title: "Análise PIA rejeitada"
			}
		},
		short_help: "Esta seção permite-lhe preparar e formalizar a validação PIA.",
		title: "Validação"
	}
};
var settings$5 = {
	content: "Por favor, forneça o endereço (URL) do servidor remoto:",
	title: "Configurações",
	update: "Atualizar URL"
};
var summary$5 = {
	action_plan: {
		fundamental_principles: "Princípios fundamentais",
		implementation_date: "Data esperada de implementação",
		implementation_responsible: "Responsável pela implementação",
		measures: "Medidas existentes e planejadas",
		no_action_plan: "Nenhum plano de ação registado.",
		risks: "Riscos",
		title: "Plano de ação"
	},
	actions: {
		complete_download: "Download do relatório completo",
		complete_download_desc: "Exportar todo o conteúdo do relatório num .zip (.doc e imagens), anexos e o plano de ação em formato .csv.",
		individual_download: "Descarregar elementos do relatório",
		individual_download_desc: "Exportar elementos específicos do relatório.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "Textos (.doc)",
		individual_download_images: "Elementos visuais (.png) incluindo resumo de riscos, mapeamento de riscos e o plano de ação.",
		individual_download_json: "Arquivo para importar na ferramenta PIA (arquivo .json)",
		individual_download_select: "Selecionar elementos a exportar:",
		individual_to_download: "Download",
		print: "Imprimir o relatório",
		print_and_download: "Imprimir e download"
	},
	attachments: "Anexos",
	concerned_people_name: "Opiniões de partes interessadas",
	concerned_people_opinion: "Opiniões de partes interessadas",
	concerned_people_searched_opinion: "Procura da opinião de partes interessadas",
	concerned_people_status: "Status de pessoas em questão",
	concerned_people_unsearched_opinion_comment: "Razão pela qual a opinião de partes interessadas não foi pedida",
	content_choice: [
		"O tratamento não deve ser usado.",
		"O tratamento deve ser implementado."
	],
	creation_date: "Data de criação",
	csv_action_plan_comment: "Comentar o plano de acção",
	csv_evaluation_comment: "Comentar a avaliação",
	csv_file_title: "plano-acção",
	csv_implement_date: "Data de implementação estimada",
	csv_people_in_charge: "Pessoa responsável",
	csv_section: "Secção",
	csv_title_object: "Título",
	download_csv: "Plano de ação (.csv)",
	dpo_name: "Nome do DPO",
	dpo_opinion: "Opinião do DPO",
	dpo_status: "Estado do DPO",
	gauges: {
		"1": "Insignificante",
		"2": "Limitado",
		"3": "Importante",
		"4": "Máximo"
	},
	modification_made: "Modificações feitas",
	people_search_status_nok: "A opinião das partes em questão não foi solicitada.",
	people_search_status_ok: "A opinião das partes em questão foi solicitada.",
	pia_assessor: "Nome do assessor",
	pia_author: "Nome do autor",
	pia_name: "PIA",
	pia_validator: "Nome do validador",
	preview_dpo_opinion: "Opinião do DPO e dos titulares dos dados",
	preview_edition: "Editar",
	preview_evaluation: "Avaliação",
	preview_no_data: "Sem dados para visualizar.",
	preview_status: "Estado",
	preview_subtitle: "Informação Geral",
	preview_title: "Pré-visualizar",
	preview_validation: "Validação",
	preview_validation_section: "Validação",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Voltar para a página anterior",
	rejection_reason: "Motivo da rejeição",
	revision: {
		current_version: "Versão atual",
		pia_version: "Versões do AIIA",
		restore_version: "Restaurar",
		revision: "Versões e revisões",
		save: "Criar nova versão",
		show: "Exibir as {{length}} versões"
	},
	risks_cartography_title: "Mapeamento de riscos",
	risks_overview_title: "Visão geral dos riscos",
	title: "Informação PIA"
};
var users$5 = {
	add_new_user: "Adicionar novo usuário",
	cancel: "Cancelar",
	choose_profile: "Escolher um perfil para este usuário",
	"continue": "Continuar",
	data: "Dados",
	edit_user: "Editar um usuário",
	email: "Email",
	first_name: "Primeiro nome",
	functional_admin: "Administrador funcional",
	last_name: "Último nome",
	new_user_button: "Novo usuário",
	profile: "Perfil",
	remove: "Deletar",
	remove_current_user_error_message: "Não é possível deletar a própria conta.",
	remove_last_functional_admin_error_message: "Não é possícel deletar este usuário porque pelo menos uma conta de Administrador Técnico precisa existir.",
	remove_user_with_linked_pias_error_message: "Vários PIAs estão associados a este usuário, então não é possível removê-lo.",
	technical_admin: "Administrador técnico",
	update: "Atualizar",
	user: "Usuário",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "A informação provida na criação na conta é inválida."
		}
	},
	"delete": {
		confirm: "Remover usuário",
		content: "Tem certeza que deseja deletar este usuário?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$5 = {
	add_signed_pia: "Adicionar a análise PIA subscrita",
	after_reading: "Depois de ler a análise PIA completa relativa ao tratamento de dados ligado a",
	button: {
		rejection: "Rejeitar análise AIIA",
		signed_validation: "Aprovar análise PIA <br>(assinado)",
		simple_validation: "Aprovar análise PIA <br>(direto)"
	},
	confirmation1: "Eu atesto que o contexto do tratamento descrito na análise PIA é consistente com a realidade.",
	confirmation2: "Eu atesto que estou ciente dos riscos dependendo das medidas existentes ou planejadas.",
	confirmation3: "Ratifico as ações corretivas indicadas no plano de ação.",
	confirmation4: "Eu comprometo-me a implementar as ações corretivas indicadas o mais rápido possível.",
	latest_signed_attachment: "Último anexo subscrito",
	mandatory_fields: "Todas as caixas devem ser verificadas",
	remove_attachment: "Remover o anexo",
	responsible: "Responsável pela validação da análise PIA:",
	signed_attachments_history: "Histórico de anexos subscritos",
	tools: {
		dashboard: "Painel",
		display_pia: "Exibir análise PIA"
	},
	validated_pia_with_signature: "Aprovado",
	waiting_for_signature: "Análise PIA subscrita pendente"
};
var pt = {
	about: about$5,
	action_plan: action_plan$5,
	authentication: authentication$5,
	cartography: cartography$5,
	comments: comments$5,
	conflict: conflict$5,
	date: date$5,
	errors: errors$5,
	evaluations: evaluations$5,
	header: header$5,
	help: help$5,
	homepage: homepage$5,
	knowledge_base: knowledge_base$5,
	measures: measures$5,
	misc: misc$5,
	modals: modals$5,
	onboarding: onboarding$5,
	opinions: opinions$5,
	"overview-risks": {
	important: "Significativo",
	limited: "Limitado",
	maximal: "Máximo",
	measures: "Medidas",
	negligible: "Insignificante",
	potential_impacts: "Impactos potenciais",
	"risk-access_x": "Gravidade",
	"risk-access_y": "Probabilidade",
	"risk-change_x": "Gravidade",
	"risk-change_y": "Probabilidade",
	"risk-disappearance_x": "Gravidade",
	"risk-disappearance_y": "Probabilidade",
	sources: "Fontes",
	threat: "Ameaças"
},
	pia: pia$5,
	questions: questions$5,
	rejection_page: rejection_page$5,
	sections: sections$5,
	settings: settings$5,
	summary: summary$5,
	users: users$5,
	validation_page: validation_page$5
};

var about$4 = {
	contribute: "Dacă doriți să contribuiți la traducerea software-ului într-o altă limbă sau să îmbunătății traducerile existente, recomandăm să <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\"> citiți pagina cu descrierea pașilor de urmat</a>.",
	description: "Acest instrument a fost inițial proiectat de <a target=\"_blank\" href=\"https://www.cnil.fr\">Comisia Națională pentru Informatică și Libertate (CNIL)</a>,  Autoritatea Franceză de Protecția Datelor, pentru a ajuta procesatorul de date să fie în conformitate cu GDPR. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Acest software este gratuit. Dacă doriți să va implicați în acest proiect, sunteți bineveniți să descărcați codul sursă din Github, să îl modificați și să îl distribuiți comunității.",
	licences: "Bibliotecă licențe:",
	title: "Despre instrumentul AIIA",
	translators: "Software-ul PIA este momentan disponibil în optsprezece limbi. Versiunile în franceză și engleză sunt furnizate de către CNIL. Celelalte versiuni sunt rezultat al contribuției următoarelor persoane:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Versiunea"
};
var action_plan$4 = {
	acceptable_measures: "Măsuri acceptabile",
	edit: "Edit",
	improvable_measures: "Măsuri de îmbunătățit",
	measures: "Măsuri planificate sau existente",
	no_action_plan: "Niciun plan de acțiune înregistrat.",
	placeholder_person_in_charge: "Responsabil implementare",
	principles: "Principii fundamentale",
	risk1: "Acces nelegitim la date",
	risk2: "Modificări nedorite ale datelor",
	risk3: "Dispariția datelor",
	risks: "Riscuri",
	title: "Prezentare generală"
};
var authentication$4 = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Acest software creat de către <strong>Autoritatea Franceza pentru Protecția Datelor (CNIL)</strong> este menit să îndrume auditorii în crearea și demonstrarea conformității cu politica GDPR. Acesta ajută la realizarea corectă a analizei impactului asupra confidențialității datelor facilitând utilizarea metodei PIA dezvoltată de către CNIL.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Început",
	start_app: "Acces software (Beta)",
	subtitle1: "O platformă pentru a crea <br> și administra your PIAs",
	subtitle2: "Acces instrumente și glosare",
	title: "Analiza impactului asupra confidențialității datelor",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$4 = {
	important: "Important",
	legend1: "Măsuri planificate sau existente",
	legend2: "Cu măsurile corective implementate",
	legend3: "(I)Acces nelegitim la date",
	legend4: "(U)Modificări nedorite ale datelor",
	legend5: "(D)Dispariția datelor",
	likelihood_axe: "Probabilitatea riscului",
	limited: "Limitat",
	maximal: "Maxim",
	negligible: "Neglijabil",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Severitatea riscului"
};
var comments$4 = {
	comment: "Comentariu",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "comentariu(ii)",
	new_comment: "Comentariu",
	placeholder_new_comment: "Adăugare comentariu",
	send: "Trimitere"
};
var conflict$4 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$4 = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$4 = {
	content: "Dacă întâmpinați alte probleme sau dacă aveți sugestii de îmbunătățire<br>, le puteți transmite înapoi prin intermediul acestuia formular: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Pagina nu a fost găsită."
};
var evaluations$4 = {
	acceptable: "Acceptabil",
	action_plan_comment: "Plan de acțiune / acțiuni corective",
	evaluation_comment: "Comentariu evaluare",
	gauges: {
		"0": "(Nedefinit)",
		"1": "Neglijabil",
		"2": "Limitat",
		"3": "Important",
		"4": "Maxim",
		likelihood: "Ținând cont de planul de acțiune, cum este reevaluată <span class='red-highlight'>probabilitatea de concretizare a acestui risc</span>?",
		seriousness: "Ținând cont de planul de acțiune, cum este reevaluată <span class='red-highlight'>gravitatea acestui risc</span>?"
	},
	improvable: "De îmbunătățit",
	placeholder_acceptable: "Conform informațiilor disponibile, măsurile implementate sunt corespunzătoare pentru a îndeplini în mod adecvat cerințele cu privire la protecția datelor.",
	placeholder_improvable1: "Conform informațiilor disponibile, trebuie puse în aplicare măsuri suplimentare pentru a îmbunătății protecția datelor în cadrul procesului de prelucrare.",
	placeholder_improvable2: "Introduceți comentariile dvs.",
	placeholder_to_correct: "Informațiile furnizate nu sunt suficiente pentru a fi evaluate în mod corespunzător. Retransmiteți-le către editor pentru îmbunătății informațiile prezentate inițial.",
	status: [
		"În așteptare",
		"De corectat",
		"De îmbunătățit",
		"Acceptabil"
	],
	title: "Evaluare",
	to_correct: "De corectat"
};
var header$4 = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "exemplu AIIA",
		title: "Ajutor"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Baza de cunoaștere",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Traduceri oferite de către CNIL",
		community_translations: "Traduceri oferite de către Comunitate",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "TO BE TRANSLATED - Translation revised by European DPA",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Versiune Originală",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Analiza impactului asupra confidențialității datelor",
	structures: "PIA templates",
	tools: {
		about: "Despre",
		accessibility: "Accesibilitate deficiențe vizuale (contrast ridicat, daltonism)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Setări",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$4 = {
	definition: {
		data1: {
			content: "Content being written",
			title: "Utilizați instrumentul PIA"
		},
		data2: {
			qa1: {
				content: "Când întâmpinați aceste probleme de afișare, închideți aplicația și reîncărcați-o. De obicei se remediază problema. Nu se va pierde nicio informație introdusă; informațiile se salvează automat pe măsură ce sunt introduse.",
				title: "Am probleme legate de afișare, cum ar fi pictogramele blocate într-o singură stare sau lipsa elementelor de pe interfață"
			},
			qa2: {
				content: "Această problemă cunoscută este în curs de a fi rezolvată. Dacă întâmpinați această problemă, recomandăm completarea câmpului ce conține justificarea nivelului estimat de severitate și/ sau probabilitate. Odată ce bug-ul va fi rezolvat, se va putea edita indicatorul de nivel.",
				title: "Nu pot edita indicatoarele de nivel pentru evaluarea severității și probabilității unui risc"
			},
			qa3: {
				content: "Au fost identificate câteva probleme atunci când este importată o PIA, și în special indicatoarele de nivel pentru evaluarea severității și probabilității unui risc ar putea să dispară. În acest caz, vă rugăm să consultați problema de mai sus. În plus, este posibil ca o PIA să nu apară în panoul de comandă dupa ce este importată. Aceasta este o problema de afișare și se rezolvă prin reîncărcarea paginii.",
				title: "Întâmpin probleme atunci când vreau să import o PIA"
			},
			qa4: {
				content: "Acesta este singura problemă de afișare ce nu are efect asupra textului inserat. Problema vizuală va fi rezolvată în curând.",
				title: "Când copiez și inserez un text, acesta este evidențiat."
			},
			qa5: {
				content: "Pentru a evalua o secțiune, este obligatorie completarea tuturor câmpurilor. Verificați daca este aceasta este situația. La editarea unui risc, este necesar să existe cel puțin o măsură tehnică sau organizațională care elimină riscul, astfel încât să se poată solicita o evaluare a riscului.",
				title: "Nu pot evalua o secțiune"
			},
			qa6: {
				content: "Vă rugăm să închideți și să redeschideți PIA ce este editată. Conținutul ar trebui să fie afișat în limba selectată.",
				title: "Când se comută limba, textele nu sunt traduse"
			},
			qa7: {
				content: "Momentan, pictogramele meniului de navigare nu sunt reactualizate dupa refuzarea PIA. Trebuie să verificați fiecare secțiune și să modificați informațiile și/sau evaluarea conform căreia PIA a fost refuzată. Odată ce toate secțiunile au fost revizuite, ar trebui sa se poată solicita din nou validarea PIA.",
				title: "Am refuzat să validez PIA dar nu stiu ce ar trebui să fac în continuare"
			},
			title: "Probleme identificate"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Ajutor"
};
var homepage$4 = {
	cards: {
		author: "Editare",
		category: "TO TRANSLATE - Category",
		creation_status: "Creare",
		date: "Dată",
		evaluation: "Evaluare",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Inserare AIIA",
		import_structure: "TO TRANSLATE - Import template",
		item: {
			consult_pia: "Consultare",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Editare",
			edit_structure: "TO TRANSLATE - Edit template",
			tools: {
				action_plan: "Afișare<br>plan de acțiune",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Creare<br>copie",
				"export": "Export fișier",
				more_options: "Mai multe opțiuni",
				pia: "Afișare<br>PIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Creare AIIA",
		new_structure: "TO TRANSLATE - New template",
		or: "sau",
		pia_name: "PIA",
		placeholder_author: "Prenume, Nume",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Prenume, Nume",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Inserare AIIA",
		placeholder_import_structure: "TO TRANSLATE - Import template",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Creare AIIA",
		placeholder_new_structure: "TO TRANSLATE - New template",
		placeholder_pia_name: "Titlu AIIA",
		placeholder_sector_name: "TO TRANSLATE - Associated sector's name",
		placeholder_start: "Toate câmpurile trebuie completate",
		placeholder_structure: "TO TRANSLATE - Default template",
		placeholder_structure_name: "TO TRANSLATE - Template's title",
		placeholder_validation: "Prenume, Nume",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		start: "Inițiere",
		status: "Stare",
		structure: "TO TRANSLATE - Template",
		structure_name: "TO TRANSLATE - Template's name",
		title_close_creation: "Închide",
		validation: "Aprobare"
	},
	filters: {
		assessor: "Evaluator",
		author: "Autor",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Incepeți!<br><br>Pentru a iniția PIA,<br> accesați Creare AIIA",
		card_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous !<br><br>Pour commencer<br>un modèle, cliquez<br> sur le +",
		category: "TO TRANSLATE - Category",
		date: "Dată",
		import_pia: "Inserare AIIA",
		import_structure: "TO BE TRANSLATED - Importer modèle",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Incepeți ! Pentru a iniția <br>PIA, accesați +",
		list_rocket_content_structure: "TO BE TRANSLATED - Lancez-vous ! Pour commencer<br>un modèle, cliquez sur le +",
		name: "Nume",
		new_pia: "Creare AIIA",
		new_structure: "TO BE TRANSLATED - Nouveau modèle",
		sector_name: "TO BE TRANSLATED - Secteur associé",
		sort: "Sortare",
		sort_by: "după",
		status: "Stare",
		validator: "Aprobator"
	},
	lists: {
		column_actions: "Acțiuni",
		column_author: "Editare",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Creare",
		column_evaluation: "Evaluare",
		column_pia: "PIA",
		column_progression: "Progres",
		column_sector_name: "TO TRANSLATE - Associated sector",
		column_status: "Stare",
		column_structure: "TO TRANSLATE - Template",
		column_structure_name: "TO TRANSLATE - Template",
		column_updated_at: "Ultima accesare",
		column_validation: "Aprobare",
		item: {
			tools: {
				action_plan: "Afișare plan de acțiune",
				archive: "TO TRANSLATE - Archive",
				consult: "Consultare",
				duplicate: "Creare<br>copie",
				edit: "Editare",
				"export": "Export fișier",
				pia: "Afișare AIIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$4 = {
	add_measure: "Adăugare",
	add_measure_hint: "Poti adăuga o acțiune sugerată în Baza de cunoaștere.",
	category: {
		definition: "Definition",
		example: "Exemplu",
		general_measure: "Control fizic al securității",
		measure_on_data: "Control logic al securității",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Control organizațional",
		principle: "Principle"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Toate",
		definitions: "Definiții",
		general_measures: "Physical Security controls",
		measures_on_data: "Logical security controls",
		no_result: "No result found.",
		organizational_measures: "Organisational controls",
		title: "Filtre"
	},
	placeholder_add_measure: "Adaugă această acțiune",
	placeholder_help: "Sugestii de inserare",
	search: "Căutare",
	slugs: {
		PIA_DEF_ACC: {
			description: "Persoana vizată va avea dreptul să obțină de la controller confirmarea cu privire la faptul că datele cu caracter personal care o privesc sunt sau nu procesate, și, dacă este cazul, este facilitat accesul la datele cu caracter personal și la informațiile descrise în <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 din [GDPR]</a>",
			name: "Dreptul de acces",
			source: "GDPR Art. 15"
		},
		PIA_DEF_ANO: {
			description: "Proces de eliminare a caracteristicii datelor cu caracter personal de a fi identificate. Pentru a evalua stabilitatea procesului de anonimizare, a se vedea <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Anonimizarea",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Proceduri de păstrare și gestionare a arhivelor electronice ce conțin date cu caracter personal destinate să asigure valoare acestora (mai exact, valoarea juridică) pe întreaga perioadă necesară (transfer, depozitare, migrare, accesibilitate, eliminare, politică de arhivare, protecția confidențialității, etc.).",
			name: "Arhivarea",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Fiecare persoană care are acces legitim la date cu caracter personal (angajați, părți contractante și alte părți terțe) ar trebui să se identifice printr-un identificator unic. Se alege o metodă de autentificare pentru deschiderea sesiunilor potrivită contextului, nivelului de risc și amplitudinii așteptate. Recomandări: dacă riscurile nu sunt mari, este posibilă utilizarea unei parole; cu toate acestea, dacă riscurile sunt ridicate, se utilizează un token pentru parole unice dar se modifică parola de activare prestabilită, sau, atunci când o parte din parolă este trimisă prin SMS, se utilizează un card cu un cod PIN, un certificat electronic sau orice altă formă puternică de autentificare.",
			name: "Autentificare",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Măsură ce face ca datele cu caracter personal să fie neinteligibile pentru oricine nu deține autorizație de acces (criptare simetrică sau asimetrică, utilizarea de algoritmi publici puternici, certificat de autentificare, etc.).",
			name: "Criptare",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Metode de organizare a datelor ce reduc posibilitatea de corelare a datelor cu caracter personal și de apariție a breșelor în protecția datelor cu caracter personal. De exemplu, prin identificarea datelor cu caracter personal utile numai fiecărui proces de business și prin separarea logică a acestora.",
			name: "Divizarea datelor",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Orice indicație liber oferită, specifică, informată și lipsită de ambiguitate, cu privire la dorințele persoanei vizate, prin care el sau ea, printr-o declarație sau printr-o acțiune clară, afirmativă, exprimă acordul în legătură cu procesarea datelor cu caracter personal.<br>A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.10 din [GDPR]</a>",
			name: "Consimțământ",
			source: "GDPR Art. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Mijloace implementate pentru limitarea riscului ca persoanele neautorizate să acceseze electronic datele cu caracter personal, necesită printre altele: <br>- <strong>gestionarea profilurilor utilizatorilor</strong> prin separarea sarcinilor și a zonelor de responsabilitate (preferabil într-o manieră centralizată) astfel încât accesul la datele cu caracter personal să fie limitat exclusiv către utilizatorii autorizați prin aplicarea principiilor need-to-know și least-privilege;<br>- <strong>restrângerea drepturilor angajațiilor, părților contractante și ale altor părți terțe atunci când nu mai sunt autorizate să acceseze sediul sau o resursă</strong> sau atunci când <strong>se încheie contractul</strong>.",
			name: "Controale de acces logic",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Orice informație cu privire la o persoană fizică identificată sau identificabilă (‘persoana vizată’); o persoană fizică identificabilă este aceea care poate fi identificată, direct sau indirect, în special prin referire la un identificator precum nume , un număr de identificare, date cu privire la locație, un identificator online sau unul sau mai mulți factori fizici, fiziologici, genetici, mentali, economici, culturali sau de indentitate socială a acelei persoane fizice. <br>A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.1 din [GDPR]</a>",
			name: "Date cu caracter personal",
			source: "GDPR Art 4.1"
		},
		PIA_DEF_DEST: {
			description: "Persoană fizică sau juridică, autoritate publică, agenție sau altă organizație, căreia datele cu caracter personal îi sunt dezvăluite, indiferent dacă este vorba despre o terță parte sau nu. Cu toate acestea, autoritățile publice care ar putea primi date cu caracter personal în cadrul unei anchete în conformitate cu legislația Uniunii Europene sau a unui stat membru nu vor fi considerate beneficiari; prelucrarea datelor de către acele autorități publice trebuie să fie conform normelor de protecție a datelor și conform scopurilor procesării. <br>A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.9 din [GDPR]</a>",
			name: "Beneficiar",
			source: "GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Persoana vizată va avea dreptul să obțină din partea controller-ului ștergerea datelor cu caracter personal care o privesc fără întârzieri nejustificate, iar controller-ul va avea obligația de a șterge datele cu caracter personal fără întârzieri nejustificate, a se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 17 din [GDPR]</a>",
			name: "Drept de ștergere",
			source: "GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Beneficiile preconizate (pentru organizație, pentru persoanele vizate, pentru societate în general, etc.).",
			name: "Mizele",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Datele cu caracter personal trebuie să fie corecte și, acolo unde este cazul, să fie actualizate; trebuie luate toate măsurile rezonabile pentru a garanta faptul că toate datele inexacte, ținând cont de motivul pentru care sunt prelucrate, să fie șterse sau rectificate (‘exactitate’). <br>A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 d) din [GDPR]</a>",
			name: "Calitatea datelor",
			source: "GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Severitatea reprezintă magnitudinea riscului. Depinde în primul rând de natura prejudiciabilă a potențialurilor impacturi.",
			name: "Severitate",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Persoana vizată va avea dreptul de a obține din partea controller-ului limitarea prelucrării datelor, a se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 18 din [GDPR]</a>",
			name: "Dreptul la limitarea prelucrării",
			source: "GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Se creează  o arhitectură de autentificare care să permită depistarea timpurie a incidentelor care implică date cu caracter personal și colectarea de informații pentru a fi analizate sau care furnizează dovezi în legătură cu investigația.",
			name: "Supraveghere",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Procedeu care cuprinde una sau mai multe acțiuni individuale asupra activelor suport de date. Este utilizat, intenționat sau nu, de către sursele de risc și poate provoca un eveniment nedorit.",
			name: "Amenințare",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Amenințări cu privire la: - <strong>Echipamente hardware</strong>, utilizate necorespunzător, supravegheate, modificate, pierdute (utilizarea sau transportul echipamentelor hardware sensibile în scopuri personale, vizualizarea ecranului unei persoane fără ca aceasta să știe în timpul unei călătorii cu trenul, supravegherea printr-un keylogger bazat pe un echipament hardware, etc.)<br> - <strong>Software</strong>, utilizat necorespunzător, supravegheat, modificat(sporirea privilegiilor, colectarea datelor de configurare, infectarea cu cod rău intenționat, etc.)<br>- <strong>Rețele de comunicații</strong> supravegheate (interceptarea traficului Ethernet, etc.)<br>- <strong>Persoane</strong>, supravegheate, manipulate, pierdute (dezvăluirea neintenționată a informațiilor, inginerie socială, modificări de atribuire)<br>- <strong>Documente fizice</strong> supravegheate, pierdute (citire, furtul de corespondență, etc.)<br>- <strong>Canale de transmitere a documentelor</strong> supravegheate (citirea registrelor de semnatură aflate în circulație, etc.)",
			name: "Amenințări care pot duce la un acces nelegitim",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Amenințări cu privire la : </strong><br>- <strong> Echipamente hardware</strong> : utilizate necorespunzător, supraîncărcate, modificate, deteriorate, pierdute (unitate de stocare plină, supraîncărcarea capacității de procesare, adăugarea unor echipamente hardware care nu sunt compatibile acest lucru ducând la defecțiuni, incendiu, furt sau pierdere, etc.)<br>- <strong>Software</strong> : utilizare neadecvată, supraîncărcare, alterare, distrugere, pierdere (ștergerea datelor, depășirea mărimii bazei de date, programe rău intenționate, expirarea licenței pentru software-ul utilizat pentru accesarea datelor, etc.)<br>- <strong>Rețele de comunicații</strong> : supraîncărcate, modificate, pierdute (download neautorizat, pierderea conexiunii la Internet, etc.)<br>- <strong>Persoane</strong> : supraîncărcate, deteriorate, pierdute (utilizarea slabă a compentețelor, boli, pensionare, etc.)<br>- <strong>Documente fizice</strong> : utilizare neadecvată, deteriorare, pierdere (ștergere,învechirea documentelor arhivate, furt sau pierdere, etc.)<br>- <strong>Canale de transmitere a documentelor</strong> : supraîncărcate, distruse, alterate, pierdute (expedierea blocată de o grevă, realocarea birourilor sau a sediilor, pierderea unui document în timpul livrării, reorganizarea canalelor de transmitere, etc.)",
			name: "Amenințări care pot duce la dispariția datelor cu caracter personal",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Amenințări cu privire la : </strong><br>- <strong>Echipamente hardware</strong> modificate(adăugarea unor echipamente hardware ce nu sunt compatibile având ca rezultat defecțiuni ale acestora, îndepărtarea unor componente esențiale, etc.)<br>- <strong>Software</strong> utilizat necorespunzător sau modificat (modificări nedorite ale datelor în cadrul bazei de date, erori ale operatorului care duce la modificarea datelor, etc.)<br>- <strong>Rețele de comunicații</strong> utilizate necorespunzător (retransmitere datelor interceptate, etc.)<br>- <strong>Persoane</strong> supraîncărcate sau manipulate (atribuirea personalului de sarcini dincolo de abilitățile dețiunte, stres sau schimbări negative cu privire la condițiile de muncă, influență, etc.)<br>- Documente fizice care au fost modificate (modificări ale cifrelor dintr-un document, înlocuirea unui original printr-un fals, etc.)<br>- <strong>Canale de transmitere a documentelor</strong> ce au fost modificate (schimbarea de la un registru de semnatură la un altul, transmiterea mai multor documente contradictorii, etc.)",
			name: "Amenințări care pot duce la modificarea nedorită a datelor cu caracter personal",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Selectate dintre cele disponibile în secțiunea \"Măsuri planificate sau existente\", ce se pot completa dacă este necesar.",
			name: "Măsuri",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "Atunci când datele sunt importate, pot fi colectate neintenționat diferite tipuri de metadate(cum ar fi datele de tip EXIF cu un fișier imagine atașat). <br>Astfel de metadate trebuie identificate și eliminate dacă nu sunt necesare pentru scopurile specificate.",
			name: "Filtrare și eliminare",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Odată ce datele sensibile au fost primite, ca parte a unei serii de informații generale sau transmise numai în scopuri statistice, acestea pot fi transformate sub o formă mai puțin sensibilă sau pot fi pseudonimizate. De exemplu : <br>- dacă sistemul colectează adresa IP pentru determinarea locației utilizatorului în scop statistic, adresa IP poate fi ștearsă odată ce orașul sau zona a fost dedusă<br>- dacă sistemul primește date video din parte camerelor de supraveghere, poate identifica persoanele care stau sau se mișcă în cadru și le poate estompa<br>- dacă sistemul este un aparat de măsură inteligent, acesta poate cumula cantitatea de energie utilizată într-o anumită perioadă, fără a înregistra aceste date în timp real",
			name: "Reducerea sensibilității prin conversie",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Sistemul poate face ca: <br>- utilizatorul să poată utiliza o resursă sau serviciu fără riscul de a-și dezvălui identitatea(date anonime)<br>- utilizatorul să poată utiliza o resursă sau un serviciu, fără riscul de a-și dezvălui identitatea, dar rămâne identificabil și responsabil (date pseudonime)<br>- utilizatorul să poată efectua multiple utilizări ale resurselor sau serviciilor fără riscul ca acestea să fie corelate (datele nu pot fi corelate)<br>- utilizatorul să poată folosi o resursă sau un serviciu fără riscul ca alte persoane, în special terți, să aibă posibilitatea de a observa că resursa sau serviciul este utilizat. (non-observabilitate)<br>Alegerea unei metode din lista de mai sus trebuie efectuată în baza amenințărilor identificate. Pentru unele amenințări la adresa vieții private, pseudonimizarea va fi mai potrivită decât anonimizarea (de exemplu, dacă este nevoie de trasabilitate). În completare, unele amenințări cu privire la adresa vieții private vot fi abordate printr-o combinație de metode.",
			name: "Diminuarea caracteristicii datelor de a fi identificate",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Sistemul poate fi organizat în părți independente cu funcții separate de control al accesului. Datele pot fi, de asemenea, separate între aceste sub-sisteme independente și controlate de către fiecare sub-sistem folosind mecanisme de control al accesului diferite. Dacă un sub-sistem este compromis  a sub-system is compromised, impactul asupra tuturor celorlalte date poate fi redus.",
			name: "Diminuarea acumulării de date",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Sistemul poate limita accesul la date în conformitate cu principiul \"need to know\" . Sistemul poate separa datele sensibile și poate aplica politici specifice de control al accesului. De asemenea, sistemul poate cripta datele sensibile pentru a proteja confidențialitatea acestora în timpul transmiterii și stocării. Accesul la cookie-urile temporare ce sunt produse în timpul procesării datelor trebuie, de asemenea, protejat.",
			name: "Restricționarea accesului la date",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Se reduce gravitatea riscurilor prin limitarea datelor cu caracter personal colectate doar la ceea ce este strict necesar pentru atingerea scopului stabilit, în caz contrar acestea nu vor fi colectate.",
			name: "Minimalizarea datelor",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "TO BE TRANSLATED - Reduce the severity of risks by minimizing the data themselves, by taking measures aimed at reducing their sensitivity such as filtering and removing unnecessary data, pseudonymising data, etc.",
			name: "TO BE TRANSLATED - Minimization of data themselves",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: "Persoana vizată va avea dreptul de a se opune, în orice moment, din motive legate de situația sa particulară, prelucrării datelor cu caracter personal ce o privesc, în conformitate cu <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 21 din [GDPR]</a>",
			name: "Dreptul la obiecție",
			source: "GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Măsurile luate pentru integrarea protecției datelor cu caracter personal în toate noile operațiuni de prelucrare(persoane de încredere, linii directoare, metodologii de management al riscului sau alte metodologii interne).",
			name: "Management de proiect",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Persoanele ale căror date sunt colectate și prelucrate.",
			name: "Persoana vizată",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " Persoana vizată va avea dreptul de a primi datele cu caracter personal care o privesc, pe care le-a furnizat controller-ului, într-un format electronic, structurat, utilizat în mod obișnuit. Aceasta are dreptul de a transmite acele date către un alt controller fără a fi împiedicată de către controller-ul ce a deținut datele până în acel moment. A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 20 din [GDPR]</a>",
			name: "Dreptul la portabilitatea datelor",
			source: "GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Prelucrarea datelor cu caracter personal, astfel încât datele să nu se mai poată atribui persoanei vizate fără utilizarea unor informații suplimentare, cu condiția ca aceste informații suplimentare să fie păstrate separat și să facă obiectul unor măsuri tehnice și organizatorice care să asigure faptul că datele cu caracter personal nu sunt atribuite unei persoane fizice indentificate sau identificabile.<br>Pseudonimizarea reduce conexiunea unui set de date cu identitatea originală a persoanei vizate; așadar, este o măsură utilă de securitate, dar nu este o metodă de anonimizare.",
			name: "Pseudonimizare",
			source: "GDPR Art. 4.5 and guidelines G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Parolele vor fi compuse din cel puțin opt caractere; trebuie reînnoite dacă există cea mai mică îngrijorare că acestea au fost compromise și, eventual, reînnoite periodic (la fiecare șase luni sau o dată pe an) și trebuie să includă cel puțin trei din cele patru tipuri de caractere (majuscule, litere mici, cifre și caractere speciale); când o parolă este modificată, ultimele cinci parole nu pot fi reutilizate; aceeași parolă nu ar trebui utilizată pentru nivele de acces diferite; parolele nu ar trebui să aibă legătură cu informații personale (nume sau data nașterii). Se stabilește un număr maxim de încercări după care se emite un avertisment și autentificarea este blocată (temporar sau până când este deblocată manual).",
			name: "Parolă",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Persoana vizată are dreptul de a obține de la controller, fără întârzieri nejustificate, rectificarea datelor cu caracter personal inexacte în legătură cu aceasta. Ținând cont de scopurile prelucrării, persoana vizată va avea dreptul de a completa datele cu caracter personal care sunt incomplete, inclusiv prin furnizarea unei declarații suplimentare.",
			name: "Dreptul la rectificare",
			source: "GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Regulament referitor la protecția persoanelor fizice cu privire la prelucrarea datelor cu caracter personal și libera circulație a acestor date, ce abrogă Directiva 95/46/EC.",
			name: "GDPR (Regulamentul general privind protecția datelor)",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Persoană fizică sau juridică, autoritate publică, agenție sau altă organizație care, singură sau în comun cu alte organizații/persoane, stabilește scopurile și mijloacele de prelucrare a datelor cu caracter personal; în cazul în care scopurile și mijloacele prelucrării datelor sunt determinate de către legislația Uniunii Europene sau a statelor membre, controller-ul sau criteriile specifice de numire a acestuia pot fi prevăzute de către legislația UE sau a statului membru.<br>A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.7 din [GDPR]</a>",
			name: "Controller-ul",
			source: "GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Persoană sau sursă non-umană care poate provoca un risc. Această sursă poate acționa accidental sau în mod deliberat.",
			name: "Sursa de risc",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Persoana fizică sau juridică, autoritate publică, agenție sau alt organism care prelucrează date cu caracter personal în numele controller-ului, a se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 din [GDPR]</a>.<br>Procesatorul și orice persoană care acționează sub autoritatea controller-ului sau a procesatorului, și are acces la date cu caracter personal, va putea procesa acele date doar în baza instrucțiunilor primite din partea controller-ului, cu excepția cazului în care acest lucru este impus de către legislația UE sau a unui stat membru, a se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 29 din [GDPR]</a>.",
			name: "Procesator",
			source: "GDPR Art. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: " Activul de care datele cu caracter personal depind. Acesta poate fi de natură hardware, software, rețele, oameni, hârtie sau canale de transmitere a documentelor.",
			name: "Active suport",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Încălcarea securității care duce la distrugerea accidentală sau ilicită a datelor, pierderea, modificarea, divulgarea neautorizată, sau accesul la datele cu caracter personal, date transmise, stocate sau prelucrate.",
			name: "Încălcarea securității datelor",
			source: "GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Probabilitatea semnifică posibilitatea apriției unui risc. Depinde în primul rând de nivelul de vulnerabilitate a activelor suport atunci când se află sub amenințare și de nivelul capacităților surselor de risc de a le exploata.",
			name: "Probabilitate",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Date de identificare</strong> : Stare civilă, identitate, Vârstă, etc. <br><strong>Viață personală</strong> : obiceiuri de trai, stare civilă, etc. <br><strong>Viață profesională </strong> : CV, educație și pregătire profesională, premii, etc. <br><strong>Datele de conectare</strong> : adresă IP , log-uri, etc.<br><strong>Date cu privire la locație</strong> : călătorii, date GPS, date GSM, etc.<br><strong>Altele</strong> :număr de telefon, adresă email, etc.",
			name: "Date cu caracter personal comune",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Opinii de natură filosofică, politică, religioasă și sindicală, viață sexuală,  date privind sănătatea, rasă sau origine etnică, date cu privire la viața sexuală sau sănătate, infracțiuni, condamnări, măsuri de securitate, a se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 și 10 din [GDPR]</a>.",
			name: "Condamnări penale și date cu caracter personal sensibile"
		},
		PIA_EX_DCPS: {
			description: "Cod numeric personal (CNP), date biometrice, date bancare",
			name: "Date cu caracter personal considerate sensibile"
		},
		PIA_EX_HUME: {
			description: "Ar putea fi:<br>- un vecin rău intenționat sau naiv care, având proximitate fizică, să acceseze neautorizat datele dispozitivului;<br>- un hacker care vizează un utilizator prin utilizarea cunoștințelor pe care le are despre acel utilizator și a informațiilor cu privire la acesta;<br>- un hacker ce vizează o organizație prin utilizarea cunoștințelor pe care le are despre aceasta, informații care îi pot submina imaginea;<br>- o companie terță autorizată ce se folosește de accesul său privilegiat într-un mod nelegitim și rău intenționat.",
			name: "Surse umane din afara organizației"
		},
		PIA_EX_HUMI: {
			description: "Ar putea fi:<br>- un angajat neglijent sau rău intenționat, proximitatea sistemului, aptitudinile, privilegiile și timpul disponibil potențial ridicate, o posibilă lipsă de instruire și conștientizare<br>- un utilizator neglijent sau rău intenționat, membru al familiei sau prieten care are acces la serviciu.<br> Sunt posibile diverse motive, ce includ : neîndemânare, eroare, neglijență, acțiuni rău intenționate, răzbunare, spionaj",
			name: "Surse umane din interiorul organizației"
		},
		PIA_EX_IMPI: {
			description: "Persoanele vizate ar putea întâmpina consecințe semnificative, pe care ar trebui să le poată depăși, însă cu dificultăți reale și grave. De exemplu: <br>- fizic : afecțiuni fizice grave care provoacă vătămări pe termen lung (agravarea sănătății din cauza îngrijirii necorespunzătoare, sau  a desconsiderării contraindicațiilor), alterarea integrității fizice (de exemplu: ca urmare a unui atac, un incident petrecut acasa, la locul de muncă, etc.<br>- material: delapidare ce nu a fost compensată, direcționată, unică și care nu este recurentă, oportunități pierdute  (credite imobiliare, refuzul studiilor, internship-urilor sau angajării, interdicția examinării), pierderea locuinței, pierderea locului de muncă, etc.;<br>- moral : afecțiuni psihologice grave (depresie, dezvoltarea unei fobii), sentimentul de invadare a vieții private cu daune ireversibile, victima șantajului, hărțuire sau hărțuire în mediul virtual, etc.",
			name: "Impact semnificativ"
		},
		PIA_EX_IMPL: {
			description: "Persoanele vizate ar putea întâmpina inconveniente semnificative, pe care le vor putea depăși în ciuda unor dificultăți. De exemplu:<br>- fizic : afecțiuni fizice minore (afecțiune minoră din cauza desconsiderării contraindicațiilor), defăimarea care are ca rezultat represalii fizice sau psihologice, etc.;<br>- material : plăți neașteptate (amenzi aplicate eronat), refuzul accesului la servicii administrative sau comerciale, primirea de mesaje nesolicitate care ar putea deteriora reputația persoanelor vizate, etc.;<br>- moral : afecțiuni psihice minore, dar concrete, sentimentul de încălcare a vieții private, dar fără daune ireversibile, intimidarea pe rețelele de socializare, etc.",
			name: "Impact limitat"
		},
		PIA_EX_IMPM: {
			description: "Persoanele vizate ar putea întâmpina consecințe semnificative sau chiar ireversibile, pe care nu le-ar putea depăși. De exemplu:<br>- fizic : afecțiuni fizice pe termen lung sau permanente, afectarea permanentă a integrității fizice, deces;<br>- material : risc financiar, datorii substanțiale, incapacitate de muncă, incapacitatea de a se mutaa, pierderea doveziilor în cazul litigiilor, pierderea accesului la utilități publice vitale (apă, electricitate), etc.<br>- moral : afecțiuni psihologice pe termen lung sau permanente, pedeapsă penală, răpire, pierderea legăturilor de familie, incapacitate de a acționa în judecată, modificarea statutului administrativ și/sau pierderea autonomiei juridice (tutela), etc.",
			name: "Impact maxim"
		},
		PIA_EX_IMPN: {
			description: "Persoanele vizate fie nu vor fi afectate, fie vor întâmpina câteva inconveniente, care pot fi depășite fără nicio problemă. De exemplu:<br>- fizic : dureri de cap tranzitorii;<br>- material : pierderea timpului în repetarea formalităților sau în așteptarea îndeplinirii acestora, primirea de mesaje nesolicitate (ex: spams), reutilizarea datelor publicate pe site-uri web în scopul publicității direcționate , etc.;<br>- moral : simpla enervare, sentimentul de invadare a vieții personale fără prejudicii concrete (intruziune comercială), etc.",
			name: "Impact neglijabil"
		},
		PIA_EX_NHUM: {
			description: "Incident sau defecțiune produsă la una din companii (pană de curent, incendiu, inundație, etc.)",
			name: "Surse ce nu sunt de natură umană"
		},
		PIA_EX_VRAI: {
			description: "Pare posibil pentru sursele de risc selctate să materializeze amenințarea prin exploatarea caracteristicilor activelor suport (e.g.: furtul documentelor pe suport de hârtie păstrate în birouri, care nu pot fi accesate fără o primă verificare la recepție).",
			name: "Probabilitate semnificativă"
		},
		PIA_EX_VRAL: {
			description: "Pare dificil pentru sursele de risc selctate să materializeze amenințarea prin exploatarea caracteristicilor activelor suport (ex: furtul documentelor pe suport de hârtie depozitate într-o cameră protejată de un cititor de carduri de acces).",
			name: "Probabilitate limitată"
		},
		PIA_EX_VRAM: {
			description: "Pare extrem de facil pentru sursele de risc selctate să materializeze amenințarea prin exploatarea caracteristicilor activelor suport (e.g.: furtul documentelor pe suport de hârtie depozitate într-un coridor public).",
			name: "Probabilitate maximă"
		},
		PIA_EX_VRAN: {
			description: "Nu pare posibil pentru sursele de risc selectate să materializeze amenințarea prin exploatarea caracteristicilor activelor suport (ex: furtul documentelor pe suport de hârtie depozitate într-o cameră protejată de un cititor de carduri de acces și un cod de acces).",
			name: "Probabilitate neglijabilă"
		},
		PIA_LGL_CONS: {
			description: "Permiteți persoanelor vizate să facă o alegere liberă, informată și clar definită. Determinați dacă prelucrarea se bazează pe un temei juridic, altul decât consimțîmântul ce se regăsește în cadrul Art. 6 din <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Consimțământ",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Definiți și descrieți în detaliu scopul colectării datelor:<br>- datele cu caracter personal în cauză, destinatarii și durata de stocare<br>- descrierea proceselor și a activelor suport pentru date cu caracter personal pentru întregul ciclu de viață al datelor personale (de la colectare la ștergere).",
			name: "Procese și date",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Prezentați o scurtă descriere a prelucrării în cauză, natura sa, scopul, contextul, motivele și consecințele. Identificați controller-ul și procesatorul datelor. Enumerați recomandările standard aplicabile prelucrării datelor, ce sunt necesare sau care trebuie să fie respectate, și nu în ultimul rând codurile de conduită aprobate(A se vedea Art. 40 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) și certificări privind protecția datelor (A se vedea Art. 42 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Descrierea prelucrării datelor",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Persoana fizică sau juridică, autoritate publică, agenție sau altă organizație, către care datele cu caracter personal sunt dezvăluite, indiferent dacă este sau nu o terță parte. Cu toate acestea, autoritățile publice care pot primi date cu caracter personal în contextul unei anchete, în conformitate cu legislația UE sau a statelor membre, nu sunt considerate destinatari/beneficiari; prelucrarea acelor date de către respectivele autorități publice trebuie să fie în conformitate cu normele aplicabile privind protecția datelor, ținând cont de scopul procesării datelor. A se vedea Art. 4.9 din <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Destinatar/Beneficiar",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "O durată de depozitare trebuie definită pentru fiecare tip de date și justificată prin cerințele legale și/sau de necesitățile de prelucrare. Astfel, se face o distincție între datele comune și datele arhivate, pentru care accesul va fi limitat doar la persoanele direct interesate. Un mecanism de eliminare trebuie implementat cu scopul de a arhiva datele comune sau pentru curățarea datelor arhivate la finalul perioadei de stocare. De asemenea, orice altă urmă de utilizare va trebui ștearsă, precum și jurnalele tehnice (logs) care nu sunt stocate pe o perioadă nedeterminată",
			name: "Durata de stocare",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Datele cu caracter personal vor fi colectate pentru scopurile specificate, explicite și legitime și <strong>nu vor fi prelucrate într-o manieră incompatibilă cu acele scopuri.</strong> <br>A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) din [GDPR]</a>",
			name: "Principiile referitoare la prelucrarea datelor cu caracter personal",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Subiectul datelor a oferit consimțământul pentru prelucrarea datelor sale personale pentru unul sau mai multe scopuri <br>- Prelucrarea este necesară pentru executarea unui contract in care persoana vizată este parte sau cu scopul de a lua măsuri la cererea persoanei vizate, înainte de a iniția un contract <br>-Prelucrarea este necesară în vederea îndeplinirii conformității cu o obligație legală care îi revine controller-ului datelor <br>- Prelucrarea este necesară pentru protejarea intereselor vitale ale persoanei vizate sau ale unei alte persoane fizice <br>- Prelucrarea este necesară pentru îndeplinirea unei sarcini realizate în interes public sau în cadrul exercitării autorității publice încredințate controller-ului <br>- Prelucrarea este necesară în scopul intereselor legitime urmărite de catre controller sau de o terță parte, cu excepția cazului în care aceste interese sunt depășite de către interesele sau de drepturile și libertățile fundamentale ale persoanei vizate, drepturi și libertăți ce necesită protecția datelor cu caracter personal, în special atunci când persoana vizată este un copil<br> A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 6 of [GDPR]</a> ",
			name: "Justificarea caracterului legal",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Se asigură informarea persoanelor vizate. Confirmați faptul că prelucrarea nu este acoperită de o excepție și nu este supusă unor condiții specifice.",
			name: "Informarea persoanelor vizate",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Este important să se reducă gravitatea riscurilor prin reducerea numărului de date cu caracter personal ce vor fi prelucrate, limitând datele la ceea ce este strict necesar pentru scopurile pentru care sunt procesate(în caz contrar, acestea nu ar trebui colectate). Ulterior, devine posibilă minimalizarea datelor, prin intermediul unor controale menite să reducă sensibilitatea acestora.",
			name: "Minimalizarea datelor",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Este necesară semnarea unui contract de prelucrare a datelor cu fiecare procesator de date, stabilindu-se toate aspectele mentionate in Art. 28 din [GDPR]: durata, scopul, motivul, instrucțiuni de procesare documentate, autorizare prealabilă acolo unde un procesator este implicat, furnizarea oricărei documentații care să ateste respectarea normelor [GDPR], notificarea promptă a oricărei încălcări a datelor, etc.",
			name: "Subcontractare",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Activul de care datele cu caracter personal depind. Notă: acesta poate fi de natură hardware, software, rețele, oameni, hârtie sau canale de transmitere a documentelor.",
			name: "Activ suport",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "În funcție de țara în cauza, va trebui să justificați alegerea stocării datelor la distanță și să indicați măsurile legale de supraveghere implementate pentru asigurarea unei protecții adecvate a datelor în cazul unui transfer transfrontalier. Care este:<br>- Uniunea Europeana<br>- Țară recunoscută de UE ca asigurând o protecție a datelor adecvată<br>- Transfer către Statele Unite, către o companie care s-a alăturat Scutului de confidențialitate UE-SUA<br>- Altă țară <br>A se vedea <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 to 49 of [GDPR]</a>",
			name: "Transferuri",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Existența unor politici și a unor procese cu scopul de a obține o organizație capabilă să gestioneze și să controleze protecția datelor cu caracter personal pe care le deține.",
			name: "Supraveghere",
			placeholder: "Se indică aici dacă este monitorizată eficacitatea controalelor de confidențialitate și cât de adecvate sunt acestea.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Existența unei politici și a unor procese care să diminueze riscul asupra libertăților civile și a vieții private a persoanelor vizate în cazul unui acces legitim la date cu caracter personal al terților.",
			name: "Relațiile cu terții",
			placeholder: "Se indică aici, pentru procesatorii care solicită accesul la date, controalele de securitate și măsurile adoptate cu privire la un astfel de acces.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Se specifică dacă există o persoană responsabilă de aplicarea legilor și regulamentelor cu privire la confidențialitate. Se specifică dacă există un comitet de monitorizare (sau echivalentul acestuia) responsabil pentru îndrumarea și monitorizarea acțiunilor privind protecția vieții private.",
			name: "Organizația",
			placeholder: "Se indică dacă sunt definite rolurile și responsabilitățile cu privire la protecția datelor.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Existența unei politici menite să integreze protecția datelor cu caracter personal în toate operațiunile noi de prelucrare.",
			name: "Integrarea confidențialității datelor în cadrul proiectelor",
			placeholder: "Se descrie aici modalitatea în care confidențialitatea datelor este integrată în cadrul proiectelor",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Existența unei politici care să descrie modalitățile de conștientizare, cu privire la datele cu caracter personal, a noilor angajați și pentru momentul în care o persoană ce a avut acces la date părăsește compania.",
			name: "Managementul personalului",
			placeholder: "Se indică aici ce fel de modalități de conștientizare sunt realizate cu privire la angajați.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Se stabilesc aspecte importante cu privire la protecția datelor în cadrul unei baze documentar,e ce alcătuiește politica de protecție a datelor, într-o formă potrivită fiecărui tip de conținut (riscuri, principii cheie de urmărit, obiective vizate, reguli care trebuie aplicate, etc.) și fiecărei direcții de comunicare (utilizatori, departament IT, etc.).",
			name: "Politică",
			placeholder: "Se descrie aici baza documentară care stabilește regulile și obiectivele cu privire la protecția datelor.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Politica ce descrie procesele de control a riscurilor, riscuri pe care le prezintă operațiunile de prelucrare a datelor efectuate de către organizație în ceea ce privește protecția datelor și a vieții private a persoanelor vizate (ilustrarea unei hărți a riscurilor, etc.).",
			name: "Gestionarea riscurilor cu privire la confidențialitate",
			placeholder: "Sunt descrise aici procesele pentru controlul riscurilor pe care operațiunile de prelucrare a datelor, efectuate de către organizație, le prezintă în ceea ce privește protecția datelor și a vieții private a persoanelor vizate.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Existența unei organizații operaționale care să poată identifica și gestiona incidentele ce pot afecta libertățile civile și viața privată a persoanelor vizate.",
			name: "Gestionarea încălcării confidențialității datelor cu caracter personal",
			placeholder: "Se indică aici dacă incidentele IT sunt supuse unei proceduri testate și documentate de gestionare.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Politicile și metodele implementate pentru a asigura disponibilitatea și/sau integritatea datelor cu caracter personal, păstrând în același timp confidențialitatea acestora.",
			name: "Copiile de sigurnață",
			placeholder: "Se indică aici cum sunt gestionate copiile de sigurnață. Se clarifică dacă acestea sunt stocate într-un loc sigur.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Modalitățiile de control implementate pe stațiile de lucru (blocare automată, actualizări regulate, configurare, securitate fizică, etc.) pentru a reduce posibilitatea de a exploata proprietățiile software-ului (sisteme de operare, aplicații specifice etc.) pentru a influența negativ datele cu caracter personal.",
			name: "Gestionarea stațiilor de lucru",
			placeholder: "Sunt descrise aici modalitățile de control implementate pe stațiile de lucru",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "TO BE TRANSLATED - <strong>Only use subcontractors which are able to provide sufficient guarantees</strong> (in particular in terms of specialised knowledge, reliability and resources). Require service providers to communicate their information system security policy before signing a contract with them. <br>Take and document the means (security audits, installation visits, etc.) used to <strong>ensure the effectiveness of the guarantees offered by the subcontractor</strong> in terms of data protection. These guarantees include: <br>- encryption of data according to its sensitivity or, at least, the existence of procedures guaranteeing that the service company does not have access to the data; <br>- encryption of data transmissions (e.g.: HTTPS type connection, VPN, etc.); <br>- guarantees in terms of network protection, traceability (logs, audits), access rights management, authentication, etc. <br><strong>Sign a contract with the subcontractors</strong>, which defines the subject, the length and the purpose of the processing, as well as obligations of each party. Ensure that it contains, in particular, provisions targeting: <br>- their obligation in terms of <strong>confidentiality of the entrusted personal data</strong>;<br>- <strong>minimal standards in terms of user authentication</strong>;<br>- <strong>conditions of restitution of data and/or its destruction at end of the contract</strong>;<br>- <strong>incident management and notification rules. </strong> They should include notification of the data controller whenever a security breach or a security incident is discovered, which should happen as soon as possible when it concerns personal data.",
			name: "Contracte de prelucrare",
			placeholder: "Sunt descrise aici măsurile specifice pentru procesatori (host, compania de mentenanța, administrator, furnizori de servicii de specialitate, etc.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Politici implementate pentru diminuarea posibilității apariției riscurilor și a impactului acestora asupra activelor suport pentru datele cu caracter personal.",
			name: "Securitatea operațională",
			placeholder: "Se descrie aici modalitatea de efectuare a actualizărilor de software (sisteme de operare, aplicații, etc.) și de aplicare a patch-urilor pentru efectuarea acțiunilor corective la nivelul securității.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Se monitorizează sistemele de detectare și de prevenire a intruziunilor, cu scopul de a analiza traficul din rețea în timp real (rețele prin cablu, Wi-Fi, unde radio, fibră optică, etc.) și pentru a detecta orice activitate suspectă care să indice un atac cibernetic.",
			name: "Monitorizarea activității rețelei",
			placeholder: "Se indică aici mijloacele și controalele implementate pentru detectarea incidentelor care implică date cu caracter personal",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Politici care descriu modul în care este gestionată mentenanța fizică a echipamentelor hardware, specificând dacă această operațiune este contractată sau nu.<br> Se specifică dacă mentenanța de la distanță a aplicaților este autorizată, și în conformitate cu ce dispoziții se realizează. Se specifică dacă echipamentul defect este gestionat într-o manieră particulară.",
			name: "Mentenanță",
			placeholder: "Se descrie aici modalitatea în care este gestionată mentenanța echipamentelor hardware",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controalele implementate pe stațiile de lucru și servere pentru a le oferi protecție împotriva software-ului rău intenționat în momentul accesării unor rețele mai puțin sigure.",
			name: "Limitarea răspândirii software-ului rău intenționat",
			placeholder: "Se descriu aici controalele implementate pentru diminuarea riscurilor ce pot apărea în timpul accesării rețelelor mai puțin sigure.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Se descriu aici controalele efectuate cu privire la securitatea fizică a serverelor și a stațiilor de lucru (stocare sigură, cabluri de securitate, filtre pentru confidențialitate, securitatea procesului de eliminare a datelor, etc.).",
			name: "Securitatea echipamentelor hardware",
			placeholder: "Se indică aici controalele efectuate cu privire la securitatea fizică a serverelor și a stațiilor de lucru",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "În funcție de tipul de rețea în care are loc prelucrarea datelor (izolată, privată sau Internet). Se specifică ce sistem de firewall, sisteme de detectare a intruziunilor sau alte echipamente active sau pasive sunt responsabile de asigurarea securității rețelei.",
			name: "Securitatea rețelei",
			placeholder: "Se indică aici controalele de securitate ale rețelei în care se efectuează prelucrarea datelor",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Politici care să asigure securitatea fizică (zonare, escortarea vizitatorilor, utilizarea legitimaților, uși blocate, etc.).Se specifică dacă există proceduri de avertizare în cazul unei pătrunderi în incintă prin efracție.",
			name: "Controlul accesului fizic",
			placeholder: "Se indică aici modul în care se realizează controlul accesului fizic în spațiile care găzduiesc procesul de prelucrare al datelor.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Politici care descriu mijloacele de prevenire, detectare și combatere a incendiilor. Dacă este cazul, se indică mijloacele de prevenire a daunelor provocate de apă. De asemenea, se specifică mijloacele de monitorizare și de asistență a alimentării cu energie electrică",
			name: "Protecția împotriva surselor materiale de risc",
			placeholder: "Se indică aici modalitățile de evitare a surselor materiale de risc.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Studierea zonei de amplasare, care nu ar trebui să prezinte riscul apariției unor dezastre ecologice (inundații, proximitatea zonelor industriale, cutremur sau zonă cu activitate vulcanică, etc.).Se specifică dacă sunt substanțe periculoase depozitate în aceeași zonă.",
			name: "Evitarea surselor de risc",
			placeholder: "Se indică aici dacă zona de amplasare prezintă riscul apariției unor dezastre ecologice",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementarea recomandărilor ANSSI pentru protejarea website-urilor.",
			name: "Securitatea website-ului",
			placeholder: "Se indică aici controalele implementate pentru protecția website-urilor.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Se indică mecanismele de anonimizare implementate, care sunt acelea și cărui scop servesc. <br>A nu se uita să se distingă clar între datele anonime și datele pseudonime.",
			name: "Anonimizare",
			placeholder: "Se indică aici mecanismele de anonimizare implementate",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Dacă este cazul, se descriu aici procesele de management al arhivelor (livrare, depozitare, consultare, etc.) aflate sub responsabilitatea dumneavoastră. Specificați rolurile corespunzătoare procesului de arhivare (birourile de origine, agențiile de transfer, etc.) și politica de arhivare. Se menționează dacă datele ar putea intra sub incidența arhivelor publice.",
			name: "Arhivarea",
			placeholder: "Se indică aici dacă sunt implementate mecanisme pentru monitorizarea integrității datelor stocate, care sunt acestea și ce scop au.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Metode implementate pentru <strong>asigurarea confidențialității</strong> datelor stocate (în baza de date, in fișiere plate, backup-uri, etc.), precum și procedura pentru gestionarea cheilor de criptare (crearea, stocarea, modificarea în caz de suspiciuni de compromitere a datelor, etc.).<br> Sunt descrise metodele de criptare utilizate pentru fluxurile de date (VPN, TLS, etc.) implementate în procesare.",
			name: "Criptare",
			placeholder: "Sunt descrise aici metodele implementate pentru asigurarea confidențialității datelor",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Implementarea partiționarii datelor contribuie la reducerea posibilității ca datele cu caracter personal să poată fi corelate și astfel să ducă la apariția unei breșe în securitatea tuturor datelor cu caracter personal.",
			name: "Partiționarea datelor",
			placeholder: "Se indică aici dacă partiționarea procesării este planificată, și cum se va efectua acest lucru.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Metode de definire și atribuire a profilurilor de utilizator. Se specifică metodele de <strong>autentificare</strong> implementate. Dacă este cazul, se specifică regulile aplicabile parolelor (lungimea minimă, caracterele necesare, durata validității, numărul de încercări eșuate înainte ca accesul la cont să fie blocat, etc.).",
			name: "Controlul accesului",
			placeholder: "Se indică aici modul în care profilurile de utilizator sunt definite și atribuite.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Politici care definesc trasabilitatea și managementul log-urilor.",
			name: "Trasabilitate (logging)",
			placeholder: "Se indică dacă evenimentele sunt înregistrate și cât timp sunt stocate acestea.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Se pot utiliza următoarele metode: Filtrare și eliminare, Diminuarea sensibilității datelor utilizând conversia, Diminuarea caracteristicii datelor de a fi identificate, Diminuarea acumulării de date, Restricționarea accesului la date",
			name: "Minimalizarea numărului de date cu caracter personal",
			placeholder: "Se indică aici metodele implementate pentru a reduce gravitatea riscurilor, prin limitarea cantității de date cu caracter personal colectate",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Dacă documentele pe suport de hârtie, ce conțin date cu caracter personal, sunt utilizate în timpul prelucrării, se indică modul în care sunt printate, stocate, distruse și transmise.",
			name: "Securitatea documentelor pe suport de hârtie",
			placeholder: "Se indică aici dacă sunt implementate mecanisme pentru monitorizarea integrității documentelor fizice, care sunt acestea și ce scop au.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "Controale corective sugerate de către evaluator în etapele anterioare, elaborarea unui plan de acțiune ce stabilește, pentru fiecare acțiune, managerul, frecvența, dificultatea, costul  și evoluția.",
			name: "Plan de acțiune",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Grafic ce ilustrează bunele practici de securitate, cu o valoare de conformitate atribuită fiecăreia în baza evaluării sale în etapele anterioare.",
			name: "Maparea riscurilor",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Unde este posibil, controller-ul va solicita punctul de vedere al persoanelor vizate sau al reprezentanților acestora, cu privire la intenția de prelucrare a datelor, fără a prejudicia protecția intereselor comerciale sau publice sau securitatea operațiunilor de prelucrare. A se vedea Art. 39.2 din <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br>Aceste opinii pot fi colectate prin diverse mijloace, în funcție de context (studiu intern sau extern privind scopul și metodele de prelucrare, întrebare adresată reprezentanților personalului sau sindicatelor, sondaj în rândul viitorilor clienți ai procesatorului de date). <strong>În cazul în care controller-ul decide să se opună punctelor de vedere ale persoanelor vizate</strong>, el trebuie <strong>să justifice această decizie</strong>. În cazul în care controller-ul consideră că <strong>nu este relevantă colectarea punctelor de vedere ale persoanelor vizate, trebuie să justifice această decizie</strong>.",
			name: "Opinia persoanei vizate",
			source: "GDPR Art. 39.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "Controller-ul va solicita îndrumarea Ofițerului de Protecție a Datelor (DPO - data protection officer), acolo unde persoana desemnată există, atunci când efectuează o evaluare a impactului privind protecția datelor. A se vedea Art. 39.2 din <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>Această opinie poate fi în neconcordanță cu procesul de prelucrare ce se implementează, fără a restricționa decizia controller-ului datelor cu privire la acesta</strong>.",
			name: "Opinia DPO-ului",
			source: "GDPR Art. 39.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Se stabilește dacă controalele selectate, riscurile reziduale și planul de acțiune sunt acceptabile, justificându-se decizia, având în vedere consecințele anterior identificate și opiniile părților interesate. Astfel, PIA poate fi:<br>- validată<br>- condiționată de îmbunătățire (se explică în ce mod)<br>- respinsă (împreună cu prelucrarea în cauză). Unde este necesar, se repetă pașii anteriori, astfel încât PIA să poată fi validată. Această decizie nu prejudiciază evaluarea conformității care poate fi efectuată, unde este cazul, de către Autoritatea pentru Protecția Datelor (ANSPDCP), ca parte a formalităților sau controalelor preliminare, de exemplu.",
			name: "Validare oficială",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Baza de cunoaștere"
};
var measures$4 = {
	add: "Adaugă o acțiune necompletată (in caz contrar, utilizează baza de cunoaștere)",
	default_placeholder: "Descrie acțiunile existente sau planificate pentru a asigura securitatea datelor.",
	edit: "Editează acțiunea",
	placeholder_title: "Titlul acțiunii",
	remove: "Șterge acțiunea"
};
var misc$4 = {
	display: "Afișează / Ascunde"
};
var modals$4 = {
	abandon_pia: {
		additional_text: "TO BE TRANSLATED - Archiving is not definitive and the PIA can go back to it if needed.",
		content: "Sunteți sigur că doriți să renunțați<br>give up this processing operation?"
	},
	action_plan_no_evaluation: {
		content: "Veuillez commencer l'évaluation de l'analyse pour génerer le plan d'actions.",
		review_section: "Évaluer une section"
	},
	archive: "Arhivare",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "<span class='strong'>Felicitări,</span><br>acestă secțiune este acum<br>disponibilă pentru evaluare."
	},
	back_to_edition: {
		content: "La partie est renvoyée en édition,<br>des informations doivent être ajoutées<br>pour permettre son évaluation."
	},
	back_to_evaluation: {
		content: "La partie est renvoyée en évaluation,<br>des informations doivent être réévaluées<br>pour permettre sa validation."
	},
	back_to_home: "Înapoi către ecran principal",
	cancel: "Anulare",
	close: "Închide",
	completed_edition: {
		content: "PIA a fost completată, trebuie evaluată."
	},
	completed_evaluation: {
		content: "PIA a fost evaluată, trebuie validată."
	},
	"continue": "Continua",
	declare_measures: {
		content: "Ne pare rău,<br>înainte de a evalua riscurile,<br>trebuie să raportați<br>măsurile existente sau planificate.",
		declare: "Declarați măsurile existente sau planificate"
	},
	dpo_missing_evaluations: {
		comment: "Commentaire",
		content: "Veuillez compléter l'évaluation de l'analyse pour accéder à la page des DPO.",
		remove: "Supprimer",
		review_section: "Évaluer une section"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type PIA"
	},
	import_wrong_structure_file: {
		content: "TO BE TRANSLATED - Le fichier importé ne correspond pas à un fichier de type Modèle"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Le contenu du Rapport PIA a été copié dans votre presse-papier."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Atenție,</span><br>Trebuie completată cel puțin o măsură: nu este posibilă ștergerea."
	},
	recover_version: {
		"continue": "Continua",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "<span class='strong'>PIA respinsă,</span><br>Câteva câmpuri trebuie corectate.<br>Reveniți la modul de evaluare<br>pentru a face corecții."
	},
	remove_attachment: {
		comment: "Commentaires",
		content: "<span class='strong'>Atenție,</span><br>Sunteți sigur că vreți să<br>eliminați fișierul atașat?",
		keep: "Păstrează",
		remove: "Elimină"
	},
	remove_measure: {
		content: "<span class='strong'>Atenție,</span><br>Sigur doriți să <br>eliminați această măsură?",
		keep: "Păstrează această <br>măsură",
		remove: "Elimină această <br>măsură"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Eliminați PIA"
	},
	remove_question: {
		content: "TO BE TRANSLATED - Souhaitez-vous supprimer la question ?",
		keep: "TO BE TRANSLATED - Annuler",
		remove: "TO BE TRANSLATED - Supprimer"
	},
	remove_structure: {
		content: "TO BE TRANSLATED - <span class='strong'>Attention,</span><br>Êtes-vous sûr de vouloir<br>supprimer ce modèle ?",
		remove: "TO BE TRANSLATED - Supprimer ce modèle"
	},
	same_comment: {
		content: "<span class='strong'>Atenție,</span><br>Introduceți un comentariu diferit de cel înregistrat anterior."
	},
	signed_pia_validation: {
		content: "<span class='strong'>PIA este acceptată</span><br>Finalizați validarea PIA prin atașarea<br>unui raport semnat de către persoana responsabilă.",
		download_pia: "Descarcă raport PIA"
	},
	simple_pia_validation: {
		content: "PIA a fost validată."
	},
	start_evaluation: "Începeți evaluarea",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Adresa server-ului a fost actualizată."
	},
	validate_evaluation: {
		content: "<span class='strong'>Felicitări,</span><br>ați finalizat evaluarea acestei secțiuni.<br>Alte secțiuni ale PIA trebuie, de asemenea, evaluate pentru a putea valida PIA."
	},
	validate_evaluation_to_correct: {
		content: "Ne pare rău,<br>Câteva câmpuri trebuie corectate.<br>Reveniți la modul editare<br>pentru a face corecții."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$4 = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$4 = {
	content: ", considerând că :",
	dpo_lock: "Este necesară completarea celorlalte secțiuni înainte de completarea opiniei DPO.",
	dpo_opinion: "Opinia DPO",
	edit: "Editare",
	people_opinion: "Opinia persoanelor implicate",
	placeholder_concerned_people_name: "Nume persoane implicate",
	placeholder_dpo_name: "Nume DPO",
	placeholder_dpo_opinion: "Specificați motivele pentru alegerea dvs..",
	placeholder_people_opinion: "Descrieți cum au fost colectate opiniile și rezultatul analizei. Dacă nu au fost solicitate opinii, explicați motivele.",
	placeholder_search_content: "Justificați motivul pentru care opinia persoanelor implicate nu a fost solicitată.",
	treatment_lock: "Este necesară completarea celorlalte secțiuni înainte de a putea completa opiniile persoanelor implicate.",
	treatment_nok: "Soluția nu ar trebui utilizată.",
	treatment_ok: "Solutia poate fi implementată."
};
var pia$4 = {
	attachments: {
		add: "Adăugare",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Ștergere",
		title: "Fișiere atașate",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Solicită evaluarea",
		mandatory_fields: "Toate câmpurile trebuie completate",
		structure_add_question: "TO BE TRANSLATED - Ajouter une question",
		subsection_validated: "Sub-secțiune evaluată, în așteptarea validării finale",
		validate_evaluation: "Validează evaluarea"
	},
	header: {
		display_action_plan: "Afișare<br>plan de acțiune",
		edition: "Versiune",
		evaluation: "Evaluare",
		preview: "Vizualizare"
	},
	sections: {
		based_on_structure_name: "TO BE TRANSLATED - Basé sur le modèle :",
		homepage_link: "Inapoi către Panou de comandă",
		refuse_pia: "PIA Respinse",
		status: {
			evaluation: {
				cancel: "anulezi solicitarea de evaluare.",
				cancel_button: "Anulează solicitarea de evaluare",
				content: "Această secțiune nu a fost încă evaluată. Dacă dorești editarea conținutului prezentat pentru evaluare este necesar să ",
				title: "In așteptarea evaluării."
			},
			validation: {
				cancel: "anulezi solicitarea de validare.",
				cancel_button: "Anulează solicitarea de validare",
				content: "Această secțiune a fost evaluată și așteaptă aprobarea generală a PIA. Dacă dorești să modifici evaluarea, este necesar să",
				title: "In așteptarea aprobării."
			}
		},
		validate_pia: "PIA Validate"
	},
	statuses: [
		"In curs de desfășurare",
		"Respins",
		"Simple validation",
		"Signed validation",
		"Arhivat",
		"In așteptarea validării"
	]
};
var questions$4 = {
	edit: "Editați întrebarea",
	gauges: [
		"(Nedefinit)",
		"Neglijabil",
		"Limitat",
		"Important",
		"Maxim"
	],
	placeholder_title: "TO BE TRANSLATED - Titre de la question (obligatoire)",
	remove: "TO BE TRANSLATED - Supprimer la question"
};
var rejection_page$4 = {
	applied_adjustments: "Ajustările propuse",
	applied_adjustments_placeholder: "Descrieți modificările aduse la PIA.",
	button: {
		abandon_treatment: "Abandonarea procesării",
		reject_pia: "Respinge AIIA",
		send_for_validation: "Retransmitere pentru aprobare"
	},
	previous_rejection: "Respingerea anterioară",
	rejection_reason: "Justificare respingere",
	rejection_reason_placeholder: "Descrieți motivele pentru respingere PIA.",
	title: "Istoric validare"
};
var sections$4 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Presentați un scurt plan al prelucrării: numele său, scopul, mizele, contextul utilizării, etc.",
						title: "Care este modalitatea de procesare luată în considerare?"
					},
					"2": {
						placeholder: "Descrieți responsabilitățiile părților interesate: controller-ul, posibili procesatori de date și controlleri comuni.",
						title: "Care sunt responsabilitățiile legate de procesare?"
					},
					"3": {
						placeholder: "Enumerați standardele relevante aplicabile procesării, mai ales codurile de conduită aprobate și certificările de protecție a datelor.",
						title: "Există standarde aplicabile procesării?"
					}
				},
				short_help: "Acestă secțiune permite identificarea și prezentarea obiectului studiului.",
				title: "Prezentare generală"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Enumerați datele colectate și procesate. Se definește pentru fiecare tip: durata de stocare, beneficiarii și persoanele care au acces la acestea.",
						title: "Care sunt datele prelucrate?"
					},
					"2": {
						placeholder: "Se prezintă și este descris fluxul de funcționare (de la colectarea datelor la distrugerea acestora, diferitele stagii de procesare, depozitare, etc.), utilizând, de exemplu, o diagramă a fluxurilor de date (adăugată ca fișier atașat) și o descriere detaliată a proceselor desfășurate.",
						title: "Cum funcționează ciclul de viață al datelor și al proceselor?"
					},
					"3": {
						placeholder: "Enumerați activele suport pentru date (sisteme de operare, aplicații, sisteme de management a bazelor de date, birouri, protocale, configurații, etc.)",
						title: "Care sunt activele suport pentru date?"
					}
				},
				short_help: "Acestă secțiune permite definirea și descrierea detaliată a scopului procesării.",
				title: "Date, procese și active suport"
			}
		},
		short_help: "Această secțiune vă oferă o imagine clară a modalității de procesare a datelor cu caracter personal în cauză.",
		title: "Contextul"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Explicați de ce scopurile procesării sunt specificate, clare și legitime.",
						short_title: "Scopuri",
						title: "Sunt scopurile procesării specificate, clare și legitime?"
					},
					"2": {
						placeholder: "Descrieți care este/sunt fundamentul/tele legale pentru procesare (ex: consimțîmânt, îndeplinirea unei obligații contractuale, respectarea unei obligații legale, protejarea unor interese vitale, etc.)",
						short_title: "Fundamente juridice",
						title: "Care sunt fundamentele juridice care fac ca procesarea să fie legală?"
					},
					"3": {
						placeholder: "Explicați de ce fiecare tip de dată colectată este necesară pentru scopul procesării.",
						short_title: "Date adecvate",
						title: "Sunte datele colectate adecvate, relevante și limitate la ceea ce este necesar în legătură cu scopul procesării acestora ('minimalizarea datelor')?"
					},
					"4": {
						placeholder: "Descrieți care sunt pașii pentru a se asigura calitata datelor.",
						short_title: "Acuratețea datelor",
						title: "Sunt datele corecte și actualizate?"
					},
					"5": {
						placeholder: "Explicați de ce duratele de stocare se justifică prin cerințe legale și/sau nevoi ce țin de procesare.",
						short_title: "Durata de stocare",
						title: "Care este durata de stocare a datelor?"
					}
				},
				short_help: "Această secțiune permite demonstrarea legitimității modului de procesare și a datelor procesate.",
				title: "Proporționalitate și necesitate"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Descrieți care sunt informațiile furnizate persoanelor vizate și care sunt modalitățile de efectuare a acestui lucru.",
						short_title: "Informații pentru persoanele vizate",
						title: "Cum sunt informate persoanele vizate cu privire la procesarea datelor?"
					},
					"2": {
						placeholder: "Descrieți metodele destinate să asigure obținerea consimțîmântului utilizatorilor.",
						short_title: "Obținerea consimțîmântului",
						title: "Dacă este cazul, cum se obține consimțîmântul persoanelor vizate?"
					},
					"3": {
						placeholder: "Descrieți metodele destinate să permită persoanelor vizate să acceseze, să primească și să transmită datele.",
						short_title: "Dreptul de acces și de portabilitate a datelor",
						title: "Cum pot să își exercite persoanele vizate dreptul acestora de a accesa și transfera datele?"
					},
					"4": {
						placeholder: "Descrieți metodele destinate pentru a permite persoanelor vizate să rectifice și să șteargă date.",
						short_title: "Dreptul de rectificare și de ștergere",
						title: "Modul în care persoanele vizate își pot exercita drepturile de rectificare și de ștergere?"
					},
					"5": {
						placeholder: "Descrieți metodele destinate să permită persoanelor vizate să restricționeze și să obiecteze cu privire la procesarea datelor.",
						short_title: "Dreptul de restricție și de obiecție",
						title: "Cum pot persoanele vizate să își exercite dreptul de restricție și de obiecție?"
					},
					"6": {
						placeholder: "Pentru fiecare procesator, descrieți responsabilitățile acestuia (durata, scopul, motivul, instrucțiunile de procesare documentate, autorizare prealabilă)și furnizați contractele, codurile de conduită și certificările certifications ce determină misiunile și obligațiile sale.",
						short_title: "Subcontractarea",
						title: "Sunt obligațiile procesatorilor clar identificate și determinate într-un contract?"
					},
					"7": {
						placeholder: "Pentru fiecare țară din afara Uniunii Europene, unde datele sunt stocate sau procesate, este necesar să se menționeze țara și dacă aceasta oferă un nivel adecvat al protecției datelor sau daca este cazul, să se menționeze precauțiile luate cu privire la transferul datelor.",
						short_title: "Transferuri",
						title: "În cazul transferului datelor în afara Uniunii Europene, sunt datele protejate corespunzător?"
					}
				},
				short_help: "Această secțiune permite demonstrarea implementării tuturor modalităților necesare pentru a permite persoanelor implicate să își exercite drepturile.",
				title: "Controale pentru protejarea drepturilor personale ale persoanelor vizate"
			}
		},
		short_help: "Această secțiune permite construirea unui cadru de conformitate cu privire la principiile ce țin de protecția vieții private.",
		title: "Principii fundamentale"
	},
	"3": {
		items: {
			"1": {
				short_help: "Această secțiune permite identificarea măsurilor (existente sau planificate) care contribuie la asigurarea securității datelor.",
				title: "Măsuri planificate sau existente"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Introduceți potențialele impacturi",
						title: "Care ar putea fi principalele <span class='green-highlight'>impacturi asupra persoanelor vizate</span> dacă riscul s-ar materializa?"
					},
					"2": {
						placeholder: "Introduceți amenințările",
						title: "Care sunt principalele <span class='green-highlight'>amenințări</span> care ar putea determina producerea riscului?"
					},
					"3": {
						placeholder: "Introduceți sursele de risc",
						title: "Care sunt<span class='green-highlight'>sursele</span> de risc?"
					},
					"4": {
						placeholder: "Faceți click pentru a selecta măsurile care ajută la combaterea riscului.",
						title: "Care dintre <span class='green-highlight'>metodele</span> identificate contribuie la combaterea riscului?"
					},
					"5": {
						placeholder: "Justificați aici severitatea estimată a riscului.",
						title: "Cum estimați<span class='green-highlight'>severitatea riscului</span>, mai ales în funcție de impacturile potențiale și metodele planificate?"
					},
					"6": {
						placeholder: "Justificați aici probabilitatea estimată.",
						title: "Cum apreciați <span class='green-highlight'>probabilitatea riscului</span>, mai ales luând în considerare amenințările, sursele de risc și măsurile planificate?"
					}
				},
				short_help: "Analizați cauzele și consecințele pe care aceesul nelegitim la date îl poate avea și estimați severitatea și probabilitatea acestuia.",
				title: "Accesul nelegimtim la date"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Introduceți potențialele impacturi",
						title: "Care ar putea fi principalele <span class='green-highlight'>impacturi asupra persoanelor vizate</span> în cazul în care riscul s-ar materializa?"
					},
					"2": {
						placeholder: "Introduceți amenințările",
						title: "Care sunt principalele <span class='green-highlight'>amenințări</span> care ar putea determina producerea riscului?"
					},
					"3": {
						placeholder: "Introduceți sursele de risc",
						title: "Care sunt <span class='green-highlight'>sursele</span> de risc?"
					},
					"4": {
						placeholder: "Faceți click pentru a selecta măsurile care ajută la combaterea riscului.",
						title: "Care dintre <span class='green-highlight'>metodele</span> identificate contribuie la combaterea riscului?"
					},
					"5": {
						placeholder: "Justificați aici severitatea estimată a riscului.",
						title: "Cum estimați <span class='green-highlight'>severitatea riscului</span>, mai ales luând în considerare impacturile potențiale și măsurile planificate?"
					},
					"6": {
						placeholder: "Justificați aici probabilitatea estimată.",
						title: "Cum apreciați <span class='green-highlight'>probabilitatea riscului</span>, mai ales luând în considerare amenințările, sursele de risc și măsurile planificate?"
					}
				},
				short_help: "Analizați cauzele și consecințele unor modificări nedorite ale datelor, și estimați gravitatea și probabilitatea acestora.",
				title: "Modificarea nedorită a datelor"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Introduceți impacturile potențiale",
						title: "Care ar putea fi principalele<span class='green-highlight'>impacturi asupra persoanelor vizate</span> în cazul în care riscul s-ar materializa??"
					},
					"2": {
						placeholder: "Introduceți amenințările",
						title: "Care sunt principalele<span class='green-highlight'>amenințări</span> care ar putea determina producerea riscului?"
					},
					"3": {
						placeholder: "Introduceți sursele de risc",
						title: "Care sunt <span class='green-highlight'>sursele</span>de risc?"
					},
					"4": {
						placeholder: "Faceți click pentru a selecta măsurile care ajută la combaterea riscului",
						title: "Care din <span class='green-highlight'>metodele</span> identificate contribuie la combaterea riscului?"
					},
					"5": {
						placeholder: "Justificați aici severitatea estimată a riscului.",
						title: "Cum estimați <span class='green-highlight'>severitatea riscului</span>, mai ales luând în considerare impacturile potențiale și măsurile planificate?"
					},
					"6": {
						placeholder: "Justificați aici probabilitatea estimată.",
						title: "Cum apreciați <span class='green-highlight'>probabilitatea riscului</span>, mai ales luând în considerare amenințările, sursele de risc și măsurile planificate?"
					}
				},
				short_help: "Analizați cauzele și consecințele pierderii de date și estimați gravitatea și probabilitatea producerii acesteia.",
				title: "Dispariția datelor"
			},
			"5": {
				short_help: "Acest mod de prezentare vă permite o viziune globală și sintetizată cu privire la efectele măsurilor de control asupra riscurilor specificate.",
				title: "Prezentarea riscurilor"
			}
		},
		short_help: "Această secțiune permite evaluarea riscurilor cu privire la confidențialitate, luând în considerare măsurile existente sau planificate.",
		title: "Riscuri"
	},
	"4": {
		items: {
			"1": {
				short_help: "Acest mod de prezentare vă permite compararea poziționarii tuturor riscurilor, înainte și după aplicarea modalităților de control complementare.",
				title: "Maparea riscurilor"
			},
			"2": {
				short_help: "Planificați în detaliu implementarea metodelor de control suplimentare identificate în timpul PIA. Planul de acțiune este actualizat automat când sunt evaluate diferite elemente cuprinse în cadrul PIA.",
				title: "Plan de acțiune"
			},
			"3": {
				short_help: "Prezentați sfaturile persoanei responsabile cu protecția datelor și probleme de confidențialitate (delegată pentru protecția datelor, dacă exsistă). Prezentați punctele de vedere ale persoanelor vizate sau ale reprezentanților acestora.",
				title: "DPO și opiniile persoanelor implicate"
			},
			"4": {
				title: "Validați PIA"
			},
			"5": {
				title: "Respingeți PIA"
			}
		},
		short_help: "Această secțiune permite pregătirea și formalizarea validării PIA.",
		title: "Validare"
	}
};
var settings$4 = {
	content: "Vă rugăm să furnizați adresa (URL) server-ului de la distanță:",
	title: "Setări",
	update: "Actualizare URL"
};
var summary$4 = {
	action_plan: {
		fundamental_principles: "Principii fundamentale",
		implementation_date: "Data prevăzută pentru implementare",
		implementation_responsible: "Responsabil pentru implementare",
		measures: "Măsuri existente sau planificate",
		no_action_plan: "Niciun plan de acțiune înregistrat.",
		risks: "Riscuri",
		title: "Plan de acțiune"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Fișiere atașate",
	concerned_people_name: "Numele persoanelor implicate",
	concerned_people_opinion: "Opiniile persoanelor implicate",
	concerned_people_searched_opinion: "Căutați opinia persoanelor implicate",
	concerned_people_status: "Starea persoanelor implicate",
	concerned_people_unsearched_opinion_comment: "Motivul pentru care opinia persoanelor implicate nu a fost solicitată",
	content_choice: [
		"Soluțiile nu ar trebui utilizate.",
		"Soluțiile ar putea fi implementate."
	],
	creation_date: "Data creării",
	csv_action_plan_comment: "TO BE TRANSLATED - Action plan comment",
	csv_evaluation_comment: "TO BE TRANSLATED - Evaluation comment",
	csv_file_title: "action-plan",
	csv_implement_date: "TO BE TRANSLATED - Estimated implementation date",
	csv_people_in_charge: "TO BE TRANSLATED - Person in charge",
	csv_section: "TO BE TRANSLATED - Section",
	csv_title_object: "TO BE TRANSLATED - Title",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Nume DPO",
	dpo_opinion: "Opinie DPO",
	dpo_status: "Stare DPO",
	gauges: {
		"1": "Neglijabil",
		"2": "Limitat",
		"3": "Important",
		"4": "Maxim"
	},
	modification_made: "Modificările efectuate",
	people_search_status_nok: "Opinia persoanelor implicate nu a fost solicitată.",
	people_search_status_ok: "Opinia persoanelor implicate a fost solicitată.",
	pia_assessor: "Numele evaluatorului",
	pia_author: "Numele autorului",
	pia_name: "PIA",
	pia_validator: "Numele aprobatorului",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Înapoi la pagina anterioară",
	rejection_reason: "Motivul respingerii",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "TO BE TRANSLATED - Risk mapping",
	risks_overview_title: "TO BE TRANSLATED - Risks overview",
	title: "Informații PIA"
};
var users$4 = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$4 = {
	add_signed_pia: "Adaugă PIA semnată",
	after_reading: "După parcurgerea întregii PIA cu privire la procesarea datelor referitor la",
	button: {
		rejection: "Respinge AIIA",
		signed_validation: "Aprobă PIA <br>(signed)",
		simple_validation: "Aprobă PIA <br>(direct)"
	},
	confirmation1: "Atest faptul că contextul procesării descrise în PIA este în concordanță cu realitatea.",
	confirmation2: "Atest faptul că sunt conștient de riscuri în funcție de măsurile existente sau planificate.",
	confirmation3: "Confirm acțiunile corective indicate în planul de acțiune.",
	confirmation4: "Mă angajez să pun în aplicare cât mai repede posibil acțiunile corective indicate.",
	latest_signed_attachment: "Ultimul fișier atașat semnat",
	mandatory_fields: "Toate opțiunile trebuie să fie bifate",
	remove_attachment: "Elimină fișierul atașat",
	responsible: "Persoana responsabilă cu validarea PIA: ",
	signed_attachments_history: "Istoric fișiere atașate semnate",
	tools: {
		dashboard: "Panou de comandă",
		display_pia: "Afișază PIA"
	},
	validated_pia_with_signature: "Aprobat",
	waiting_for_signature: "În așteptare PIA semnată"
};
var ro = {
	about: about$4,
	action_plan: action_plan$4,
	authentication: authentication$4,
	cartography: cartography$4,
	comments: comments$4,
	conflict: conflict$4,
	date: date$4,
	errors: errors$4,
	evaluations: evaluations$4,
	header: header$4,
	help: help$4,
	homepage: homepage$4,
	knowledge_base: knowledge_base$4,
	measures: measures$4,
	misc: misc$4,
	modals: modals$4,
	onboarding: onboarding$4,
	opinions: opinions$4,
	"overview-risks": {
	important: "Important",
	limited: "Limitat",
	maximal: "Maxim",
	measures: "Măsuri",
	negligible: "Neglijabil",
	potential_impacts: "Impacturi potențiale",
	"risk-access_x": "Severitate",
	"risk-access_y": "Probabilitate",
	"risk-change_x": "Severitate",
	"risk-change_y": "Probabilitate",
	"risk-disappearance_x": "Severitate",
	"risk-disappearance_y": "Probabilitate",
	sources: "Surse",
	threat: "Amenințări"
},
	pia: pia$4,
	questions: questions$4,
	rejection_page: rejection_page$4,
	sections: sections$4,
	settings: settings$4,
	summary: summary$4,
	users: users$4,
	validation_page: validation_page$4
};

var about$3 = {
	contribute: "Ako želite pridonijeti prijevodu softvera na drugi jeziku ili poboljšati postojeće prijevode, preporučujemo vam da <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">pročitate stranicu koja opisuje korake koje je potrebno slijediti.</a>.",
	description: "Ovaj alat izvorno je osmišljen od strane <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, francuskog tijela za zaštitu podataka, kako bi pomogao izvršiteljima obrade da budu sukladni s OUZP-om. It was developed by <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Ovaj softver je besplatan i otvoren. Ako se želite uključiti u ovaj projekt, dobrodošli ste preuzeti izvorni kod tvrtke Github, mijenjati ga i dijeliti s zajednicom.",
	licences: "Licence biblioteka:",
	title: "O alatu za PUP AIIA",
	translators: "Softver za PUP trenutno je dostupan na osamnaest jezika. Inačice na francuskom i engleskom jeziku omogućio je CNIL. Druge inačice rezultat su doprinosa sljedećih pojedinaca:",
	translators_name: "<ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German  : <a target=\"_blank\" href=\"https://github.com/https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Verzija broj"
};
var action_plan$3 = {
	acceptable_measures: "Prihvatljive mjere",
	edit: "Uredi",
	improvable_measures: "Mjere koje se daju poboljšati",
	measures: "Planirane ili postojeće mjere",
	no_action_plan: "Nije zabilježen akcijski plan.",
	placeholder_person_in_charge: "Odgovoran za provedbu",
	principles: "Temeljna načela",
	risk1: "Nezakonit pristup podacima",
	risk2: "Neželjena izmjena podataka",
	risk3: "Nestanak podataka",
	risks: "Rizici",
	title: "Pregled"
};
var authentication$3 = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Ovaj softver koji je izradio <strong>French Data Protection Authority (CNIL)</strong> namijenjen je kao smjernica voditeljima obrade u stvaranju i dokazivanju usklađenosti s OUZP-om. On pomaže pravilno provesti procjenu učinka na zaštitu podataka olakšavanjem korištenja metode za PUP koja je razvijena od strane CNIL-a.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Početak",
	start_app: "Pristupite softveru za PUP (Beta)",
	subtitle1: "Platforma za stvaranje <br> i upravljanje Vašim PUP-ovima",
	subtitle2: "Pristupni alati i rječnici",
	title: "Procjena učinka na privatnost",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$3 = {
	important: "Važan",
	legend1: "Postojeće ili planirane mjere",
	legend2: "Uz provođenje korektivnih mjera",
	legend3: "(N)ezakonit pristup podacima",
	legend4: "Neželjena (i)zmjena podataka",
	legend5: "Nestanak (p)odataka",
	likelihood_axe: "Vjerojatnost rizika",
	limited: "Ograničen",
	maximal: "Maksimalan",
	negligible: "Nizak",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Ozbiljnost rizika"
};
var comments$3 = {
	comment: "Komentar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "komentar(a)",
	new_comment: "Komentar",
	placeholder_new_comment: "Ostavi komentar",
	send: "Pošalji"
};
var conflict$3 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$3 = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$3 = {
	content: "IAko naiđete na druge probleme ili ako imate prijedloge za poboljšanje, <br> možete ih poslati putem ovog obrasca:: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Stranica nije pronađena."
};
var evaluations$3 = {
	acceptable: "Prihvatljiv",
	action_plan_comment: "Akcijski plan / aktivnosti ispravljanja",
	evaluation_comment: "Komentar procjene",
	gauges: {
		"0": "(Nedefinirano)",
		"1": "Zanemariva",
		"2": "Ograničena",
		"3": "Važna",
		"4": "Maksimalna",
		likelihood: "Uzimajući u obzir akcijski plan, koju bi novu procjenu dali <span class='red-highlight'> vjerojatnosti ovog rizika</span>?",
		seriousness: "Uzimajući u obzir akcijski plan, koju bi novu procjenu dali <span class='red-highlight'> ozbiljnosti ovog rizika</span>?"
	},
	improvable: "Može se poboljšati",
	placeholder_acceptable: "Prema dostupnim informacijama, primijenjene mjere odgovaraju pravilnom ispunjavanju zahtjeva za zaštitu podataka.",
	placeholder_improvable1: "Prema raspoloživim informacijama, potrebno je provesti dodatne mjere kako bi se poboljšala zaštita podataka obrade.",
	placeholder_improvable2: "Unesite svoje komentare.",
	placeholder_to_correct: "Dostavljene informacije nisu dovoljne njihovo ispravno procjenjivanje. Pošaljite natrag uređivaču kako bi poboljšao izvorni podnesak.",
	status: [
		"Rješava se",
		"Za ispraviti",
		"Može se poboljšati",
		"Prihvatljiv"
	],
	title: "Procjena",
	to_correct: "Za ispraviti"
};
var header$3 = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "TO TRANSLATE - Press F11 to exit full screen mode.",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Primjer PUP-a",
		title: "Pomoć"
	},
	homepage_link: "TO TRANSLATE - My AIIAs",
	knowledge_base_link: "Baza znanja",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Prijevodi od strane CNIL-a",
		community_translations: "Prijevodi od strane zajednice",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Prijevod revidiran od strane europskog tijela za zaštitu podataka",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Izvorna verzija",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Procjena učinka na privatnost",
	structures: "PIA template",
	tools: {
		about: "O programu",
		accessibility: "Pristupačnost za slabovidne osobe (boje visokog kontrasta, daltonizam)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Postavke",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$3 = {
	definition: {
		data1: {
			content: "Sadržaj se piše",
			title: "Koristite alat za PUP"
		},
		data2: {
			qa1: {
				content: "Prilikom susreta s problemima u prikazu zatvorite aplikaciju i ponovno je učitajte. To obično rješava problem. Nećete izgubiti informacije koje ste unijeli, jer se one automatski spremaju dok ih upisujete.",
				title: "Imam problema kod prikaza, tako da su ikona zaglavljene u nekom statusu ili nedostaju elementi sučelja"
			},
			qa2: {
				content: "Ovaj poznati problem trenutačno se rješava. Ako naiđete na taj problem, preporučujemo da popunite polje opravdanja ocijenjene razine ozbiljnosti i/ili vjerojatnosti. Mjeru ćete moći uređivati nakon što problem bude otklonjen.",
				title: "Ne mogu uređivati mjeru procjene ozbiljnosti i vjerojatnosti rizika"
			},
			qa3: {
				content: "Tijekom uvoza PUP-a uočeno je nekoliko pogrešaka u programu, a naročito mogu nestati mjere za procjenu ozbiljnosti i vjerojatnosti rizika, te u tom slučaju molimo pogledajte gore navedeni problem. Također, PUP se možda neće pojaviti na kontrolnoj ploči nakon uvoza. Ovo je problem u prikazu i potrebno je samo osvježiti stranicu.",
				title: "Susrećem se s problemima pri uvozu PUP-a"
			},
			qa4: {
				content: "Ovo je samo grešak u prikazu i nema utjecaja na tekst koji unesete u polje. Taj vizualni problem uskoro će biti riješen.",
				title: "Kada kopiram / zaljepljujem tekst, on je istaknut."
			},
			qa5: {
				content: "Da biste procijenili odjeljak, obavezno ispunite sva polja. Provjerite je li to slučaj. Prilikom uređivanja rizika morate imati barem jednu tehničku ili organizacijsku mjeru koja smanjuje rizik kako bi zatražili procjenu rizika.",
				title: "Ne mogu dati procjenu za odjeljak"
			},
			qa6: {
				content: "Zatvorite PUP koji uređujete i ponovno ga otvorite. Sadržaj bi trebao biti prikazan na jeziku koji ste odabrali.",
				title: "Pri prebacivanju na drugi jezik, tekstovi nisu prevedeni"
			},
			qa7: {
				content: "Ikone navigacijskih izbornika trenutno se ne osvježavaju nakon odbijana PUP-a. Morate provjeriti svaki odjeljak i promijeniti informacije i/ili procjenu prema razlozima za odbijanje PUP-a. Nakon što su svi odjeljci pregledani, trebali biste biti u mogućnosti ponovno zatražiti potvrdu PUP-a.",
				title: "Odbio sam potvrditi PUP, ali ne znam što sada moram raditi"
			},
			title: "Poznati problemi"
		},
		footer: "TO BE TRANSLATED - If you have any other problems or suggestions for improvement, you can send them to us via this form <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Pomoć"
};
var homepage$3 = {
	cards: {
		author: "Uređivanje",
		category: "TO TRANSLATE - Category",
		creation_status: "Stvaranje",
		date: "Datum",
		evaluation: "Pregled",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Uvezi PUP",
		import_structure: "Uvezi obrazac",
		item: {
			consult_pia: "Pogledaj",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Uredi",
			edit_structure: "Uredi obrazac",
			tools: {
				action_plan: "Prikaži<br>akcijski plan",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Stvori kopiju",
				"export": "Izvezi",
				more_options: "Više opcija",
				pia: "Prikaži<br>PUP",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Novi PUP",
		new_structure: "Novi obrazac",
		or: "ili",
		pia_name: "PUP",
		placeholder_author: "Ime, prezime",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Ime, prezime",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Uvezi PUP",
		placeholder_import_structure: "Uvezi obrazac",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Novi PUP",
		placeholder_new_structure: "Novi obrazac",
		placeholder_pia_name: "Naziv PUP-a",
		placeholder_sector_name: "Naziv sektora",
		placeholder_start: "Sva polja moraju biti popunjena",
		placeholder_structure: "Zadani obrazac",
		placeholder_structure_name: "Naziv obrasca",
		placeholder_validation: "Ime, prezime",
		sector_name: "Pridruženi sektor",
		start: "Početak",
		status: "Status",
		structure: "Obrazac",
		structure_name: "Naziv obrasca",
		title_close_creation: "Zatvori",
		validation: "Potvrda"
	},
	filters: {
		assessor: "Recenzentu",
		author: "Autoru",
		card: "TO TRANSLATE - Card view",
		card_rocket_content: "Započnite!<br><br>Kako bi započeli s PUP-om,<br> kliknite na Novi PUP",
		card_rocket_content_structure: "Započnite! Kako bi započeli s <br>obrascem, kliknite na +",
		category: "TO TRANSLATE - Category",
		date: "Datumu",
		import_pia: "Uvezi PUP",
		import_structure: "Uvezi obrazac",
		list: "TO TRANSLATE - List view",
		list_rocket_content: "Započnite! Kako bi započeli s <br>PUP-om, kliknite na +",
		list_rocket_content_structure: "Započnite! Kako bi započeli s <br>obrascem, kliknite na +",
		name: "Imenu",
		new_pia: "Novi PUP",
		new_structure: "Novi obrazac",
		sector_name: "Pridruženi sektor",
		sort: "Sortiraj",
		sort_by: "po",
		status: "Statusu",
		validator: "Potvrditelju"
	},
	lists: {
		column_actions: "Radnje",
		column_author: "Uređivanje",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Stvoren",
		column_evaluation: "Pregled",
		column_pia: "PUP",
		column_progression: "Napredak",
		column_sector_name: "Pridruženi sektor",
		column_status: "Status",
		column_structure: "Obrazac",
		column_structure_name: "Obrazac",
		column_updated_at: "Zadnje otvoren",
		column_validation: "Potvrda",
		item: {
			tools: {
				action_plan: "Prikaži akcijski plan",
				archive: "TO TRANSLATE - Archive",
				consult: "Pogledaj",
				duplicate: "Stvori kopiju",
				edit: "Uredi",
				"export": "Izvezi",
				pia: "Prikaži PUP",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$3 = {
	add_measure: "Dodaj",
	add_measure_hint: "Dodati možete i mjere iz baze znanja.",
	category: {
		definition: "Definicija",
		example: "Example",
		general_measure: "Kontrole fizičke sigurnosti",
		measure_on_data: "Kontrole logičke sigurnosti",
		method: "TO TRANSLATE - Methodology",
		organizational_measure: "Organizacijske kontrole",
		principle: "Princip"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Sve",
		definitions: "Definicije",
		general_measures: "Kontrole fizičke sigurnosti",
		measures_on_data: "Kontrole logičke sigurnosti",
		no_result: "Pretraga nije dala rezultata.",
		organizational_measures: "Organizacijske kontrole",
		title: "Filteri"
	},
	placeholder_add_measure: "Dodaj ovu mjeru",
	placeholder_help: "Pomoći kod unosa",
	search: "Traži",
	slugs: {
		PIA_DEF_ACC: {
			description: "Ispitanik ima pravo dobiti od voditelja obrade potvrdu obrađuju li se osobni podaci koji se odnose na njega te ako se takvi osobni podaci obrađuju, pristup osobnim podacima i informacijama opisanim u <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 15 of [GDPR]</a>",
			name: "Pravo na pristup",
			source: "OUZP čl. 15"
		},
		PIA_DEF_ANO: {
			description: "Postupak uklanjanja identifikacijskih osobina iz osobnih podataka. Da biste procijenili robusnost postupka anonimizacije, pogledajte <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf\">WP29 guidelines</a>.",
			name: "Anonimizacija",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Postupci za čuvanje i upravljanje elektroničkim arhivima koji sadrže osobne podatke kojima se osigurava njihova vrijednost (posebice njihova pravna vrijednost) tijekom cijelog potrebnog razdoblja (prijenos, pohrana, migracija, pristupačnost, uklanjanje, pravila arhiviranja, zaštita povjerljivosti itd..).",
			name: "Arhiviranje",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Svaku osobu koja ima legitiman pristup osobnim podacima (zaposlenici, ugovorne strane i ostale treće strane) treba identificirati jedinstvenim identifikatorom. Odaberite način autentikacije za otvaranje sjednica prikladan za kontekst, razinu rizika i očekivanu robusnost. Preporuke: ako rizici nisu povišeni, može se koristiti lozinka; Međutim, ako su rizici veći, upotrijebite jednokratnu token lozinku, ali promijenite zadanu lozinku za aktivaciju ili, kada se dio lozinke šalje SMS-om, karticom s PIN-om, elektroničkim certifikatom ili bilo kojim drugim oblikom jake autentikacije.",
			name: "Autentikacija",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Mjera činjenja osobnih podataka nerazumljivim bilo kome bez odobrenja za pristup (simetrična ili asimetrična enkripcija, korištenje javnih algoritama za koje se zna da su jaki, autentikacijski certifikati, itd.).",
			name: "Enkripcija",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Metode organizacije podataka koje smanjuju mogućnost da se osobni podaci mogu povezati i da se može dogoditi povreda svih osobnih podataka. Na primjer, prepoznavanjem osobnih podataka koji su korisni samo za pojedini poslovni proces i njihovo logičko razdvajanje.",
			name: "Particioniranje podataka",
			source: "pia3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Svako dobrovoljno, posebno, informirano i nedvosmisleno izražavanje želja ispitanika kojim on izjavom ili jasnom potvrdnom radnjom daje privolu za obradu osobnih podataka koji se na njega odnose.<br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.10 of [GDPR]</a>",
			name: "Privola",
			source: "OUZP čl. 4.10"
		},
		PIA_DEF_CTLA: {
			description: "Sredstva koja se primjenjuju kako bi ograničili rizici da će neovlaštene osobe pristupiti osobnim podacima elektroničkim putem; to, između ostalog, zahtijeva: <br> - <strong> upravljanje profilima korisnika </ strong> odvajanjem zadataka i područja odgovornosti (po mogućnosti na centraliziran način) radi ograničavanja pristupa osobnim podacima isključivo na ovlaštene korisnike primjenom načela nužnog znanja i najmanjih ovlasti, <br> - <strong> povlačenje prava zaposlenika, ugovornih strana i drugih trećih osoba kada više nemaju ovlasti za pristup prostorima ili resursu </ strong> ili kada završi njihov ugovor o radu <strong></strong>.",
			name: "Kontrole logičkog pristupa",
			source: "pia3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Svi podaci koji se odnose na pojedinca čiji je identitet utvrđen ili se može utvrditi (\"ispitanik\"); pojedinac čiji se identitet može utvrditi jest osoba koja se može identificirati izravno ili neizravno, osobito uz pomoć identifikatora kao što su ime, identifikacijski broj, podaci o lokaciji, mrežni identifikator ili uz pomoć jednog ili više čimbenika svojstvenih za fizički, fiziološki, genetski, mentalni, ekonomski, kulturni ili socijalni identitet tog pojedinca. <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.1 of [GDPR]</a>",
			name: "Osobni podaci",
			source: "OUZP čl. 4.1"
		},
		PIA_DEF_DEST: {
			description: "Fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo kojem se otkrivaju osobni podaci, neovisno o tome je li on treća strana. Međutim, tijela javne vlasti koja mogu primiti osobne podatke u okviru određene istrage u skladu s pravom Unije ili države članice ne smatraju se primateljima; obrada tih podataka koju obavljaju ta tijela javne vlasti mora biti u skladu s primjenjivim pravilima o zaštiti podataka prema svrhama obrade. <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Čl. 4.9 of [GDPR]</a>",
			name: "Primatelj",
			source: "OUZP čl. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Ispitanik ima pravo od voditelja obrade ishoditi brisanje osobnih podataka koji se na njega odnose bez nepotrebnog odgađanja te voditelj obrade ima obvezu obrisati osobne podatke bez nepotrebnog odgađanja, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 17 of [GDPR]</a>",
			name: "Pravo na brisanje",
			source: "OUZP čl. 17"
		},
		PIA_DEF_ENJ: {
			description: "Očekivane prednosti (za organizaciju, za ispitanike, za društvo općenito, itd.).",
			name: "Ulozi",
			source: "pia1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Osobni moraju biti točni i prema potrebi ažurni; mora se poduzeti svaka razumna mjera radi osiguravanja da se osobni podaci koji nisu točni, uzimajući u obzir svrhe u koje se obrađuju, bez odlaganja izbrišu ili isprave („točnost”). <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">čl. 5.1 d) of [GDPR]</a>",
			name: "Kvaliteta podataka",
			source: "OUZP čl. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Ozbiljnost predstavlja jačinu rizika. Ona prvenstveno ovisi o štetnoj prirodi potencijalnih utjecaja.",
			name: "Ozbiljnost",
			source: "pia1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Ispitanik ima pravo od voditelja obrade ishoditi ograničenje obrade, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 18 of [GDPR]</a>",
			name: "Pravo na ograničenje obrade",
			source: "OUZP čl. 18"
		},
		PIA_DEF_LOG: {
			description: "Postavite arhitekturu zapisivanja kako bi se omogućilo rano otkrivanje incidenta koji uključuju osobne podatke i koje se može koristiti za njihovu analizu ili dokazivanje u vezi s istragama.",
			name: "Nadziranje",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Postupak koji obuhvaća jednu ili više pojedinačnih radnji na pomoćnim sredstvima za podatke. Upotrebljavaju je, namjerno ili na neki drugi način, izvori rizika i može izazvati strahovani događaj.",
			name: "Prijetnja",
			source: "pia1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Prijetnje vezane uz: - <strong> Hardver </ strong> koji je korišten neprikladno, promatran, izmijenjen, izgubljen (upotreba ili prijevoz osjetljivog hardvera u osobne svrhe, gledanje zaslona osobe bez njenog znanja tijekom putovanja vlakom, praćenje putem hardverskog snimača ključeva itd.) <br> - <strong> Softver </ strong> koji je korišten neprikladno, promatran, promijenjen (podizanje ovlasti, prikupljanje konfiguracijskih podataka, infekcija zlonamjernim kodom itd.) <br>- <strong> Računalne kanale </strong> koji su promatrani (Presretanje Ethernet prometa, itd.)<br>- Ljude </ strong> koji su promatrani, manipulirani, izgubljeni (nenamjerno otkrivanje informacija, socijalni inženjering, promjene u zadacima) <br>- <strong> Papirnate dokumente </strong> koji su promatrani, izgubljeni (čitanje, krađa pošte itd.) <br>- <strong> Papirnate prijenosne kanale </ strong> (čitanje knjiga potpisa u optjecaju i sl.)",
			name: "Prijetnje koje mogu dovesti do nezakonitog pristupa",
			source: "piaF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Prijetnje vezane uz: </strong> <br> - <strong> Hardver </strong>: upotrebljava se neprikladno, preopterećen je, izmijenjen, oštećen ili izgubljen (jedinica za pohranu puna, preopterećenje kapaciteta obrade, dodavanje nekompatibilnog hardvera što rezultira kvarovima, ili gubitak imovine itd.) <br> - <strong> Softver </strong>: upotrebljava se neprikladno, preopterećen je, izmijenjen, oštećen ili izgubljen (brisanje podataka, prekoračenje veličine baze podataka, logička bomba, <strong> Računalne kanale </strong>: preopterećeni, izmijenjeni, izgubljeni (neovlašteno preuzimanje, gubitak internetske veze i sl.) <br>- <strong> Ljude </strong> : preopterećeni, oštećeni ili izgubljeni (loša upotreba vještina, bolesti, mirovina, itd.)<br>- <strong> Papirnate dokumente </strong>: korišteni neprikladno, oštećeni, izgubljeni (brisanje, starenje arhiviranih dokumenata, krađa ili gubitak dokumenata, itd.)<br>- <strong> Papirnate prijenosne kanale </strong>: preopterećeni, oštećeni, izmijenjeni, izgubljeni (dostava pošte zaustavljena štrajkom, preraspodjelama unutar ureda ili prostorija, gubitak tvrtke za dostavu dokumenata, reorganizacije paprirnatih prijenosnih kanala itd.)",
			name: "Prijetnje koje mogu dovesti do nestanka osobnih podataka",
			source: "piaF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Prijetnje vezane uz: </strong><br> - <strong>Hardver </strong> izmijenjen (dodavanje nekompatibilnog hardvera koji je doveo do kvarova, uklanjanja nužnih komponenti itd.) <br>- <strong>Softver</strong> korišten neprimjereno ili izmijenjen (neželjene izmjene podataka u bazama podataka, pogreške operatera koje mijenjaju podatke itd.) <br>- <strong> Računalne kanale </strong> korištene neprimjereno (ponovno slanje presretanih podataka itd.) <br>- <strong>Ljude </strong> preopterećene ili manipulirane (dodjeljivanje osoblju zadataka izvan njihovih sposobnosti, stres ili negativne promjene uvjeta rada, utjecaja itd.) <br> - Papirnate dokumente koji su izmijenjeni (izmjene brojeva u datoteci, zamjena izvornika krivotvorinom, itd.) <br>- <strong> Papirnate prijenosne kanale </ strong> koji su izmijenjeni (promjena iz jedne potpisne knjige u drugu, slanje više proturječnih dokumenata itd..)",
			name: "Prijetnje koje mogu dovesti do neželjenih izmjena osobnih podataka",
			source: "piaF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Treba ih odabrati između onih dostupnih u odjeljku \"Planirane ili postojeće mjere\", koji možete dopuniti ako je potrebno.",
			name: "Mjere",
			source: "None"
		},
		PIA_DEF_MIN1: {
			description: "Kad se uvoze podaci, mogu se nenamjerno prikupljati različite vrste metapodataka (kao što su EXIF podaci kod slikovnih datoteka). <br> Takvi metapodaci moraju biti identificirani i uklonjeni ako nisu potrebni za navedene svrhe.",
			name: "Filtriranje i uklanjanje",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Nakon što su primljeni osjetljivi podaci, kao dio niza općih informacija ili koji se prenose samo u statističke svrhe, oni se mogu pretvoriti u manje osjetljivi oblik ili pseudonimizirani. Na primjer: <br> - ako sustav prikuplja IP adresu kako bi utvrdio lokaciju korisnika za statističku svrhu, IP adresa može biti izbrisana nakon što je donesen zaključak o gradu ili okrugu - <br> ako sustav prima video podatke iz nadzornih kamera može prepoznati ljude koji stoje ili se kreću na sceni i zamutiti ih<br> - ako je sustav pametno brojilo, može skupljati energiju tijekom određenog razdoblja, a da je ne snima u stvarnom vremenu",
			name: "Smanjenje osjetljivosti putem pretvorbe",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Sustav može osigurati da: <br>- korisnik može koristiti resurs ili uslugu bez rizika otkrivanja identiteta (anonimnih podataka) <br>- korisnik može koristiti resurs ili uslugu bez rizika otkrivanja njegovog/njezinog identiteta, ali ostaju prepoznatljivi i odgovorni za to korištenje (pseudonimni podaci) <br>- korisnik može izvršiti višestruku upotrebu resursa ili usluga bez rizika da se te različite upotrebe povezuju zajedno (podaci se ne mogu povezati) <br>- korisnik može koristiti resurs ili uslugu bez rizika od drugih, osobito trećih osoba, koje mogu primijetiti korištenje resursa ili usluge (neobavezanost) <br> Izbor metode s gornjeg popisa mora biti napravljen na temelju utvrđenih prijetnji. Za neke vrste prijetnji po privatnost, pseudonimizacija će biti prikladnija od anonimizacije (na primjer, ako postoji potreba za sljedivosti). Osim toga, neke prijetnje po privatnost riješit će se pomoću kombinacije metoda.",
			name: "Smanjenje identificirajuće prirode podataka",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Sustav se može organizirati u nezavisne dijelove s posebnim funkcijama kontrole pristupa. Podaci se također mogu podijeliti između tih nezavisnih podsustava i svaki podsustav može ih kontrolirati koristeći različite mehanizme kontrole pristupa. Ako je podsustav kompromitiran, utjecaji na cjelokupne podatke mogu se smanjiti.",
			name: "Smanjenje akumulacije podataka",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Sustav može ograničiti pristup podacima prema principu \"nužnog znanja\". Sustav može odvojiti osjetljive podatke i primijeniti određene politike kontrole pristupa. Sustav također može enkriptirati osjetljive podatke kako bi zaštitila njihova povjerljivost tijekom prijenosa i pohrane. Također je potrebno zaštititi pristup privremenim kolačićima koji se proizvode tijekom obrade podataka.",
			name: "Ograničavanje pristupa podacima",
			source: "piaF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Smanjite ozbiljnost rizika smanjivanjem količine osobnih podataka koji će se obrađivati ograničavanjem tih podataka na samo one koji su strogo nužni u svrhe za koje se obrađuju (inače ih se ne smije prikupljati).",
			name: "Smanjenje količine podataka",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Reduce the severity of risks by minimizing the data themselves, by taking measures aimed at reducing their sensitivity such as filtering and removing unnecessary data, pseudonymising data, etc.",
			name: "Smanjenje količine samih podataka",
			source: "pia3 p64"
		},
		PIA_DEF_OPP: {
			description: "Ispitanik ima pravo na temelju svoje posebne situacije u svakom trenutku uložiti prigovor na obradu osobnih podataka koji se odnose na njega, sukladno <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 21 of [GDPR]</a>",
			name: "Pravo na prigovor",
			source: "OUZP čl. 21"
		},
		PIA_DEF_PBDS: {
			description: "Mjere poduzete za integraciju zaštite osobnih podataka u sve nove aktivnosti obrade (pouzdana imena, smjernice, CNIL metodologija za upravljanje rizikom ili druga interna metodologija).",
			name: "Upravljanje projektima",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Osobe na koje se odnose podaci obuhvaćeni obradom.",
			name: "Ispitanik",
			source: "pia1 p9"
		},
		PIA_DEF_PORT: {
			description: "Ispitanik ima pravo zaprimiti osobne podatke koji se odnose na njega, a koje je pružio voditelju obrade u strukturiranom, uobičajeno upotrebljavanom i strojno čitljivom formatu te ima pravo prenijeti te podatke drugom voditelju obrade bez ometanja od strane voditelja obrade kojem su osobni podaci pruženi, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 20 of [GDPR]</a>",
			name: "Pravo na prenosivost podataka",
			source: "OUZP čl. 20"
		},
		PIA_DEF_PSEU: {
			description: "Obrada osobnih podataka na način da se osobni podaci više ne mogu pripisati određenom ispitaniku bez uporabe dodatnih informacija, pod uvjetom da se takve dodatne informacije drže odvojeno te da podliježu tehničkim i organizacijskim mjerama kako bi se osiguralo da se osobni podaci ne mogu pripisati pojedincu čiji je identitet utvrđen ili se može utvrditi.<br>Pseudonimizacija smanjuje povezivost skupova podataka s izvornim identitetom ispitanika; kao takva je korisna mjera sigurnosti, ali ne i metoda anonimizacije.",
			name: "Pseudonimizacija",
			source: "OUZP čl. 4.5 i smjernice G29 p22 http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Lozinke moraju biti sastavljene od najmanje osam znakova; moraju se obnoviti ako postoji najmanja zabrinutost da bi one mogli biti ugrožene, a eventualno i povremeno (svakih šest mjeseci ili jednom godišnje) i moraju sadržavati najmanje tri od četiri vrste znakova (velika slova, mala slova, brojevi i posebni znakovi); kada se promijeni lozinka, posljednjih pet lozinki ne smiju se ponovno koristiti; istu lozinku ne smije se koristiti za različite pristupe; lozinke ne bi trebale biti povezane s osobnim podacima (uključujući ime ili datum rođenja). Odredite maksimalni broj pokušaja nakon kojih se izdaje upozorenje i autentikacija blokira (privremeno ili dok se ručno ne deblokira).",
			name: "Lozinka",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Ispitanik ima pravo bez nepotrebnog odgađanja ishoditi od voditelja obrade ispravak netočnih osobnih podataka koji se na njega odnose. Uzimajući u obzir svrhe obrade, ispitanik ima pravo dopuniti nepotpune osobne podatke, među ostalim i davanjem dodatne izjave.",
			name: "Pravo na ispravak",
			source: "OUZP čl. 16"
		},
		PIA_DEF_RGPD: {
			description: "Uredba o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ.",
			name: "OUZP (Opća uredba o zaštiti podataka, engl. GDPR - General Data Protection Regulation",
			source: "GDPR title"
		},
		PIA_DEF_RT: {
			description: "Fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo koje samo ili zajedno s drugima određuje svrhe i sredstva obrade osobnih podataka; kada su svrhe i sredstva takve obrade utvrđeni pravom Unije ili pravom države članice, voditelj obrade ili posebni kriteriji za njegovo imenovanje mogu se predvidjeti pravom Unije ili pravom države članice.<br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">čl. 4.7 [GDPR]</a>",
			name: "Voditelj obrade",
			source: "OUZP čl. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Osoba ili ne-ljudski izvor koji može uzrokovati rizik. Taj izvor može djelovati slučajno ili namjerno.",
			name: "Izvor rizika",
			source: "pia1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo koje obrađuje osobne podatke u ime voditelja obrade, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 4.8 of [GDPR]</a>.<br>Izvršitelj obrade i bilo koja osoba koja djeluje pod vodstvom voditelja obrade ili izvršitelja obrade koja ima pristup osobnim podacima, ne obrađuje te podatke ako to ne zatraži voditelj obrade, osim ako to nalaže pravo Unije ili pravo države članice, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 29 of [GDPR]</a>.",
			name: "Izvršitelj obrade",
			source: "OUZP čl. 4.8 and 29"
		},
		PIA_DEF_SUPT: {
			description: "Sredstvo na koje se osobni podaci oslanjaju. To može biti hardver, softver, mreže, ljudi, papir ili papirnati prijenosni kanali",
			name: "Pomoćna sredstva",
			source: "pia1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Povreda sigurnosti koja dovodi do slučajnog ili nezakonitog uništenja, gubitka, izmjene, neovlaštenog otkrivanja ili pristupa osobnim podacima koji su preneseni, pohranjeni ili na drugi način obrađeni.",
			name: "Povreda osobnih podataka",
			source: "OUZP čl. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Vjerojatnost izražava mogućnost nastanka rizika. Ona prvenstveno ovisi o razini ranjivosti pomoćnih sredstava prilikom prijetnji i razini sposobnosti izvora rizika da ih iskoriste.",
			name: "Vjerojatnost",
			source: "pia1 page 6"
		},
		PIA_EX_DC: {
			description: "TO BE TRANSLATED - Data for a score system, result of the application of the score....",
			name: "TO BE TRANSLATED - Calculated data"
		},
		PIA_EX_DCPC: {
			description: "<strong>Podaci o identitetu </strong>: građanski status, identitet, dob, itd. <strong> Osobni život </strong>: životne navike, bračni status, <strong> Podaci o vezi </strong>: IP adrese, zapisi o događajima itd. <br> <strong> Podaci o lokaciji </strong>: putovanja, GPS podaci, GSM podaci itd. <Strong> Ostalo </strong>: telefonski broj, adresa e-pošte itd.",
			name: "Zajednički osobni podaci",
			source: "pia2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Filozofski, politički, vjerski i sindikalni stavovi, seksualni život, podaci o zdravlju, rasno ili etničko podrijetlo, podaci o zdravlju ili seksualnom životu, kaznena djela, osude, sigurnosne mjere, pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 9 and 10 of [GDPR]</a>.",
			name: "Kaznene osude i osjetljivi osobni podaci"
		},
		PIA_EX_DCPS: {
			description: "Broj socijalnog osiguranja (NIR), biometrijski podaci, bankovni podaci",
			name: "Osobni podaci koji se percipiraju kao osjetljivi"
		},
		PIA_EX_HUME: {
			description: "To mogu biti: <br>- odmetnuti ili naivan susjed koji uslijed fizičke blizine hakira podatke uređaja;<br>- haker koji cilja korisnika pomoću znanja koje ima o korisniku i nekih od informacija o njemu/njoj;<br>- haker koji cilja jednu tvrtku pomoću znanja koje posjeduje o tvrtkama koje može potkopati njihov ugled;<br>- ovlaštena tvrtka treće strane koja koristi povlašteni pristup za nezakonit pristup informacijama.",
			name: "Vanjski ljudski izvori"
		},
		PIA_EX_HUMI: {
			description: "Mogu biti ili:<br>- zaposlenik koji je nemaran ili se odmetnuo, blizina sustava, vještine, ovlasti i vrijeme koje je na raspolaganju su potencijalno visoki, mogući nedostatak obuke i svjesnosti<br>- nepažljiv ili odmetnuti korisnik, član obitelji ili prijatelj koji ima pristup usluzi.<br> Mogući su različiti motivi, uključujući: nespretnost, pogrešku, igru nemarnosti, zlu namjeru, osvetu, špijunažu",
			name: "Unutarnji ljudski izvori"
		},
		PIA_EX_IMPI: {
			description: "Ispitanici mogu imati značajne posljedice koje bi trebali biti u stanju nadvladati, ali s pravim i ozbiljnim poteškoćama. Na primjer: <br>- fizičke: ozbiljna tjelesna oboljenja koje uzrokuju dugotrajnu štetu (pogoršanje zdravlja zbog nepravilne skrbi ili zanemarivanja kontraindikacija), izmjena fizičkog integriteta, primjerice nakon napada, nesreće kod kuće, rada itd. <br>- materijalne: zloupotreba novca koji nije nadoknađen, ciljana, jedinstvena i neponavljajuća, izgubljene mogućnosti (kućni zajam, odbijanje studija, stažiranja ili zapošljavanja, zabrana izlaska na ispit), gubitak stanovanja, gubitak zaposlenja itd.;<br>- moralne: ozbiljne psihičke bolesti (depresija, razvoj fobije), osjećaj invazije privatnosti s nepovratnim oštećenjem, žrtva ucjene, internetskog zlostavljanja i uznemiravanja itd.",
			name: "Značajan utjecaj"
		},
		PIA_EX_IMPL: {
			description: "Ispitanici mogu naići na značajne neugodnosti, koje će moći nadvladati unatoč nekoliko poteškoća. Na primjer:<br>- fizičke: manja tjelesna oboljenja (manje bolesti zbog nepoštivanja kontraindikacija), gubitka ugleda koji rezultira fizičkom ili psihološkom odmazdom itd.;<br>- materijalne: neočekivana plaćanja (pogrešno nametnute novčane kazne), uskraćivanje pristupa administrativnim ili komercijalnim uslugama, primanje neželjene ciljane pošte koja bi mogla oštetiti ugled ispitanika, itd.;<br>- moralne: manje, ali objektivne psihološke boli, osjećaj invazije privatnosti bez nepovratne štete, zastrašivanje na društvenim mrežama itd..",
			name: "Ograničen utjecaj"
		},
		PIA_EX_IMPM: {
			description: "Ispitanici se mogu se susresti sa značajnim ili čak nepovratnim posljedicama koje oni ne mogu nadvladati. Na primjer:<br>- fizičkim: dugotrajna ili trajna fizička oboljenja, trajno oštećenje tjelesne cjelovitosti, smrt;<br>- materijalnim: financijski rizik, znatna dugovanja, nemogućnost rada, nemogućnost preseljenja, gubitak dokaza u kontekst parnica, gubitak pristupa vitalnoj infrastrukturi (voda, struja), itd.<br>- moralnim: dugotrajna ili trajna psihička oboljenja, kaznene sankcije, otmica, gubitak obiteljskih veza, nemogućnost tužbe, promjena upravnog statusa i/ili gubitak pravne autonomije (skrbništvo) itd.",
			name: "Maksimalan utjecaj"
		},
		PIA_EX_IMPN: {
			description: "Ispitanici ili neće biti pogođeni ili mogu naići na par neugodnosti koje će nadvladati bez ikakvih problema. Na primjer:<br>- fizičke: prolazne glavobolje;<br>- materijalne: gubitak vremena u ponavljanju formalnosti ili čekanju na njihovo ispunjavanje, primanje neželjenih pošte (npr. spam pošta), ponovna upotreba podataka objavljenih na web stranicama za svrhe ciljanog oglašavanja, itd.;<br>- moral: puka smetnja, osjećaj invazije privatnosti bez stvarne ili objektivne štete (komercijalni upad) itd.",
			name: "Zanemariv utjecaj"
		},
		PIA_EX_NHUM: {
			description: "Incident ili oštećenje u jednoj od organizacija (struja, požar, poplava itd.)",
			name: "Ne-ljudski izvori"
		},
		PIA_EX_VRAI: {
			description: "Čini se mogućim da bi odabrani izvori rizika ostvarili prijetnju iskorištavanjem svojstava pomoćnih sredstava (npr. krađe papirnatih dokumenata pohranjenih u uredima kojima se ne može pristupiti bez prijave na recepciji).",
			name: "Značajna vjerojatnost"
		},
		PIA_EX_VRAL: {
			description: "Čini se da bi odabrani izvori rizika teško mogli ostvariti prijetnju iskorištavanjem svojstava pomoćnih sredstava (npr. krađa papirnatih dokumenata pohranjenih u prostoriji zaštićenoj čitačem značke).",
			name: "Ograničena vjerojatnost"
		},
		PIA_EX_VRAM: {
			description: "Čini se da bi odabrani izvori rizika iznimno lako mogli ostvariti prijetnju iskorištavanjem svojstava prateće imovine (npr. krađe papirnatih dokumenata pohranjenih u javnom predvorju).",
			name: "Maksimalna vjerojatnost"
		},
		PIA_EX_VRAN: {
			description: "Ne čini se mogućim da bi odabrani izvori rizika mogli ostvariti prijetnju iskorištavanjem svojstava pomoćnih sredstava (npr. krađa papirnatih dokumenata pohranjenih u prostoriji zaštićenoj čitačem značke i pristupnim kodom).",
			name: "Zanemariva vjerojatnost"
		},
		PIA_LGL_CONS: {
			description: "Dopustite ispitanicima naprave slobodan, specifičan i informirani izbor. Utvrditi da li se obrada temelji na pravnoj osnovi, osim privole na temelju čl. 6. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Privola",
			source: "pia3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Detaljno definirajte i opišite opseg :<br>- predmetne osobne podatke, njihove primatelje i trajanja pohrane<br>- opis postupaka i pomoćnih sredstava za osobne podatke tijekom cijelog životno ciklusa osobnih podataka (od prikupljanja do brisanja).",
			name: "Podaci i postupci",
			source: "pia1 p6"
		},
		PIA_LGL_DESC: {
			description: "Navedite kratak pregled razmatrane obrade, njegnu prirodu, opseg, kontekst, svrhe i uloge. Odredite voditelja obrade i sve izvršitelje obrade. Navedite standardne reference koje se primjenjuju na tu obradu, a koje su nužne ili se moraju poštovati, ne zanemarujući odobrene kodekse ponašanja (pogledajte članak 40. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) and certifications regarding data protection (see Art. 42 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Opis obrade",
			source: "pia1 p4"
		},
		PIA_LGL_DEST: {
			description: "Fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo kojem se otkrivaju osobni podaci, neovisno o tome je li on treća strana. Međutim, tijela javne vlasti koja mogu primiti osobne podatke u okviru određene istrage u skladu s pravom Unije ili države članice ne smatraju se primateljima; obrada tih podataka koju obavljaju ta tijela javne vlasti mora biti u skladu s primjenjivim pravilima o zaštiti podataka prema svrhama obrade. see Art. 4.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Primatelj",
			source: "OUZP čl. 4.9"
		},
		PIA_LGL_DUR: {
			description: "Trajanje pohrane mora biti definirano za svaku vrstu podataka i opravdano pravnim zahtjevima i/ili potrebama obrade. Dakle, postoji razlika između zajedničkih podataka i arhiviranih podataka, kojima će pristup imati samo zainteresirani dionici. Potrebno je uvesti mehanizam brisanja za arhiviranje zajedničkih podataka ili čišćenja arhiviranih podataka na kraju njihovog trajanja pohrane. Također, očistiti se moraju i funkcionalni tragovi, kao i tehnički zapisi koji se ne smiju pohranjivati na neodređeno vrijeme",
			name: "Trajanje pohrane",
			source: "piaF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Osobni podaci prikupljaju se u posebne, izričite i zakonite svrhe te se dalje ne smiju obrađivati na način koji nije u skladu s tim svrhama.</strong> <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) of [GDPR]</a>",
			name: "Načela koja se odnose na obradu osobnih podataka",
			source: "OUZP čl. 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Ispitanik je dao privolu za obradu njegovih ili njezinih osobnih podataka za za jednu ili više specifičnih svrha <br> - Obrada je neophodna za izvršenje ugovora u kojem je ispitanik ugovorna strana ili kako bi se poduzeli koraci na zahtjev ispitanika prije sklapanja ugovora <br> - Obrada je neophodna za ispunjavanje zakonske obveze koja obvezuje voditelja obrade <br>- Obrada je neophodna kako bi se zaštitili vitalni interesi ispitanika ili druge fizičke osobe <br>- Obrada je neophodna za obavljanje zadatka koji se obavlja u javnom interesu ili u obavljanju službene ovlasti koja je dana voditelju obrade <br>- Obrada je neophodna u svrhu legitimnih interesa voditelja obrade ili treće strane, osim ako su takvi interesi nadjačani interesima ili temeljnim pravima i slobodama ispitanika koje zahtijevaju zaštitu osobnih podataka, osobito ako je ispitanik  dijete<br> Pogledaj <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 6 of [GDPR]</a> ",
			name: "Opravdanje zakonitosti",
			source: "pia2 p4"
		},
		PIA_LGL_INFO: {
			description: "Osigurajte da su ispitanici obaviješteni. Potvrdite da obrada nije obuhvaćena iznimkom i ne podliježe posebnim uvjetima.",
			name: "Obavještavanje ispitanika",
			source: "pia3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "Važno je smanjiti ozbiljnost rizika smanjivanjem količine osobnih podataka koji će se obrađivati ograničavanjem tih podataka na samo one koji su strogo nužni u svrhe za koje se obrađuju (inače ih se ne smije prikupljati). Nadalje, također postaje moguće smanjiti i same podatke, putem kontrola usmjerenih na smanjenje njihove osjetljivosti.",
			name: "Načelo smanjenja količine podataka",
			source: "piaF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "Ugovor o obradi mora biti potpisan sa svakim izvršiteljem obrade i navoditi aspekte propisane čl. 28. [GDPR]: trajanje, opseg, svrhu, dokumentirane upute za obradu, prethodno odobrenje kad je angažiran izvršitelj obrade, pružanje bilo koje dokumentacije koja dokazuje sukladnost s [GDPR], promptno obavještavanje o povredi podataka itd..",
			name: "Podizvođači",
			source: "pia2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Sredstvo na koje se osobni podaci oslanjaju. Napomena: ovo može biti hardver, softver, mreže, ljudi, papir ili papirnati prijenosni kanali.",
			name: "Pomoćno sredstvo",
			source: "pia1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Ovisno o državi u pitanju, morat ćete opravdati izbor udaljenog hostinga i naznačiti aranžmane nadzora zakonitosti koji su provedeni kako bi se osigurala odgovarajuća zaštita podataka podložnih prekograničnom prijenosu. To jest: <br> - Europska unija <br> - Država priznata od strane EU-a kao ona koja pruža odgovarajuće zaštitu <br> - Prijenos u Sjedinjene Države društvu koje se pridružilo Privacy Shield okviru <br> - Druga država <br>Pogledajte <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 to 49 of [GDPR]</a>",
			name: "Prijenosi",
			source: "piaF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "(TRANSLATION REQUIRED) Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "(TRANSLATION REQUIRED) Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Postojanje pravila i postupaka za dobivanje organizacije koja može upravljati i kontrolirati zaštitu osobnih podataka koji se kod nje nalaze.",
			name: "Nadzor",
			placeholder: "Ovdje navedite da li se nadzire učinkovitost i primjerenost kontrola privatnosti.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Postojanje pravila i postupaka koji smanjuju rizik da legitimni pristup osobnim podacima od strane trećih osoba može predstavljati rizik za građanske slobode i privatnost ispitanika.",
			name: "Odnosi s trećim stranama",
			placeholder: "Ovdje za izvršitelje obrade koji zahtijevaju pristup podacima navedite sigurnosne kontrole i dogovore koji se provode u vezi s takvim pristupom.",
			source: "pia3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Navedite da li postoji osoba odgovorna za provođenje zakona i propisa o privatnosti. Navedite postoji li nadzorni odbor (ili slično tijelo) odgovoran za usmjeravanje i praćenje radnji vezanih uz zaštitu privatnosti.",
			name: "Organizacija",
			placeholder: "Ovdje navedite da li su definirane uloge i odgovornosti za zaštitu podataka.",
			source: "piaF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Postojanje pravila osmišljenih za integriranje zaštite osobnih podataka u sve nove aktivnosti obrade.",
			name: "Integriranje zaštite privatnosti u projektima",
			placeholder: "Ovdje opišite kako je zaštita privatnosti integrirana u projekte",
			source: "pia3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Postojanje pravila koja opisuju kontrolu podizanja svijesti i provode se prilikom novog zapošljavanja i koje se kontrole provode kada osobe koje imaju pristup podacima napuštaju svoj posao.",
			name: "Upravljanje osobljem",
			placeholder: "Ovdje navedite koje se kontrole podizanja svijesti provode u odnosu na zaposlenike.",
			source: "piaF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Navedite važne aspekte koji se odnose na zaštitu podataka u dokumentarnoj bazi koji čine pravila o zaštiti podataka i u obliku koji odgovara svakoj vrsti sadržaja (rizici, ključna načela koje treba slijediti, zadani ciljevi, pravila koja se primjenjuju, itd.) i svakom cilju komunikacije (korisnici, informatički odjel, stvaratelji pravila, itd.).",
			name: "Pravila",
			placeholder: "Ovdje opišite dokumentarnu bazu koja navodi ciljeve i pravila zaštite podataka.",
			source: "pia3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Pravila koja opisuju postupke kojima se kontroliraju rizici koji uslijed aktivnosti obrade koje provodi organizacija nastaju za zaštitu podataka i privatnost ispitanika (izgradnja karte rizika itd.).",
			name: "Upravljanje rizicima za privatnost",
			placeholder: "Ovdje opišite postupke za kontrolu rizika koje aktivnosti obrade koju organizacija provodi predstavljaju za zaštitu podataka i privatnost ispitanika.",
			source: "pia3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Postojanje operativne organizacije koja može otkriti i popravljati incidente koji mogu utjecati na građanske slobode i privatnost ispitanika.",
			name: " Upravljanje povredama osobnih podataka",
			placeholder: "Ovdje navedite jesu li IT incidenti podložni dokumentiranom i testiranom postupku upravljanja.",
			source: "piaF Connected Objects p24 and pia3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Pravila i sredstva koja se provode kako bi se osigurala dostupnost i/ili cjelovitost osobnih podataka uz istovremeno zadržavanje njihove tajnosti.",
			name: "Sigurnosne kopije",
			placeholder: "Ovdje navedite kako se upravlja sigurnosnim kopijama. Pojasnite jesu li pohranjene na sigurnom mjestu.",
			source: "piaF Connected Objects p23 & pia3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Kontrole implementirane na radnim stanicama (automatsko zaključavanje, redovita ažuriranja, konfiguracija, fizička sigurnost itd.) kako bi se smanjila mogućnost iskorištavanja softverskih svojstava (operativni sustavi, poslovne aplikacije i sl.) s nepovoljnim utjecajem na osobne podatke.",
			name: "Upravljanje radnim stanicama",
			placeholder: "Ovdje opišite kontrole koje se provode na radnim stanicama",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "TO BE TRANSLATED - Les données à caractère personnel communiquées à ou gérées par des sous-traitants doivent bénéficier de garanties suffisantes. <strong>Faire appel uniquement à des sous-traitants présentant des garanties suffisantes</strong> (notamment en termes de connaissances spécialisées, de fiabilité et de resources). Exiger la communication par le prestataire de sa politique de sécurité des systèmes d’information. <br>Prendre et documenter les moyens (audits de sécurité, visite des installations, etc.) permettant d’<strong>assurer l’effectivité des garanties offertes par le sous-traitant<strong> en matière de protection des données. Ces garanties incluent notamment :<br> - le chiffrement des données selon leur sensibilité ou à défaut l’existence de procédures garantissant que la société de prestation n’a pas accès aux données qui lui sont confiées<br>- le chiffrement des transmissions de données (ex : connexion de type HTTPS, VPN, etc.)<br>- des garanties en matière de protection du réseau, de traçabilité (journaux, audits), de gestion des habilitations, d’authentification, etc.<br><strong>Prévoir un contrat avec les sous-traitants</strong>, qui définit notamment l’objet, la durée, la finalité du traitement et les obligations des parties. S’assurer qu’il contient en particulier des dispositions fixant :<br>- leur obligation en matière de confidentialité des données personnelles confiées<br>- des contraintes minimales en matière d’authentification des utilisateurs<br>- les conditions de restitution et/ou de destruction des données en fin du contrat<br>- les règles de gestion et de notification des incidents. Celles-ci devraient comprendre une information du responsable de traitement en cas de découverte de faille de sécurité ou d’incident de sécurité et cela dans les plus brefs délais lorsqu’il s’agit d’une violation de données à caractère personnel.<br>- Dans le cas de l’utilisation de fournisseur de cloud computing :<br>\t1. identifier clairement les données et les traitements qui passeront dans le cloud ;<br>\t2. définir ses propres exigences de sécurité technique et juridique ;<br>\t3. conduire une étude de risques afin d'identifier les mesures de sécurité appropriées ;<br>\t4. identifier le type de cloud pertinent pour le traitement envisagé ;<br>\t5. choisir un prestataire présentant des garanties suffisantes ;<br>\t6. revoir la politique de sécurité interne ;<br>\t7. surveiller les évolutions dans le temps.",
			name: "Ugovori o izvršavanju obrade",
			placeholder: "Ovdje opišite specifične mjere za izvršitelje obrade (društvo koje pruža usluge poslužitelja, drušvo za održavanje, administrator, specijalizirani pružatelji usluga itd.)",
			source: "Mjere_SAD nabava: identificirane i podložne ugovoru"
		},
		PIA_SEC_EXP: {
			description: "Pravila uvedena kako bi se smanjla mogućnost i učinak rizika na sredstva koja podupiru osobne podatke.",
			name: "Operativna sigurnost",
			placeholder: "Ovdje opišite kako se provode ažuriranja softvera (operativnih sustava, aplikacija itd.) i primjena sigurnosnih ispravljajućih zakrpa za sigurnosne ispravke.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Nadzor sustava za otkrivanje upada i sustava za sprečavanje upada radi analiziranja mrežnog prometa (žičane mreže, Wi-Fi, radio valovi, svjetlovodi itd.) u stvarnom vremenu i otkrivanje sumnjivih aktivnosti koje ukazuju na scenarij kibernetičkog napada.",
			name: "Praćenje aktivnosti mreže",
			placeholder: "Ovdje navedite sredstva i kontrole koje se provode za otkrivanje incidenta koji uključuju osobne podatke",
			source: "pia3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Pravila koja opisuju kako se upravlja fizičkim održavanjem hardvera, navodeći je li to podugovoreno. <br> Navedite je li dopušteno daljinsko održavanje aplikacija i prema kakvim dogovorima. Navedite da li se defektnom opremom upravlja na određeni način.",
			name: "Održavanje",
			placeholder: "Ovdje opišite kako se upravlja fizičkim održavanjem hardvera",
			source: "piaF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Kontrole implementirane na radnim stanicama i poslužiteljima kako bi ih zaštitili od zlonamjernog softvera dok se pristupaju manje sigurnim mrežama.",
			name: "Suzbijanje zlonamjernog softvera",
			placeholder: "Ovdje opišite kontrole koje se provode kako bi se smanjili rizici pri pristupu manje sigurnim mrežama.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Ovdje navedite kontrole od utjecaja na fizičku sigurnost poslužitelja i radnih stanica (sigurnosna pohrana, sigurnosni kabeli, filtri povjerljivosti, sigurnosno brisanje prije uklanjanja, itd.).",
			name: "Sigurnost hardvera",
			placeholder: "Ovdje navedite kontrole koje su od utjecaja na fizičku sigurnost poslužitelja i radnih stanica",
			source: "piaF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Ovisno o vrsti mreže na kojoj se obrada izvršava (izolirana, privatna ili internetska). Navedite koji je sustav vatrozida, odnosno koji su sustavi za otkrivanje upada ili drugi aktivni ili pasivni uređaji zaduženi za osiguranje sigurnosti mreže.",
			name: "Mrežna sigurnost",
			placeholder: "Ovdje navedite sigurnosne kontrole mreže na kojoj se obrada izvršava",
			source: "piaF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Pravila kako bi se osigurala fizička sigurnost (zoniranje, pratnja za posjetitelje, nošenje kartica za prolaz, zaključana vrata itd.). Navedite postoje li postupci upozoravanja u slučaju provale.",
			name: "Kontrola fizičkog pristupa",
			placeholder: "Ovdje navedite kako se provodi kontrola fizičkog pristupa u prostorijama u kojima se obrada izvršava.",
			source: "piaF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Pravila koja opisuju sredstva za sprečavanje, otkrivanje i borbu protiv požara. Ako je primjenjivo, navedite sredstva za sprečavanje oštećenja od vode. Također navedite sredstva za nadzor napajanja i pomoć.",
			name: "Zaštita od ne-ljudskih izvora rizika",
			placeholder: "Ovdje navedite sredstva za ograničavanje ne-ljudskih izvora rizika.",
			source: "piaF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Dokumentacija o području implantacije, koje ne bi trebalo biti podložno katastrofama u okolišu (zona poplava, blizina kemijskih industrija, potresi ili vulkanske zone itd.) Navedite da li su na istom području pohranjeni opasni proizvodi.",
			name: "Izbjegavanje izvora rizika",
			placeholder: "Ovdje navedite je li područje implantacije podložno ekološkim katastrofama",
			source: "piaF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementacija preporuka ANSSI-ja za osiguravanje mrežnih stranica.",
			name: "Sigurnost mrežnih stranica",
			placeholder: "Ovdje navedite kontrole provedene za zaštitu mrežnih stranica.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Ovdje navedite da li se provode mehanizmi anonimizacije, koji oni i za koju svrhu. <br> Ne zaboravite jasno razlikovati anonimizirane i pseudonimizirane podatke.",
			name: "Anonimizacija",
			placeholder: "Ovdje navedite implementirane anonimizacijske mehanizme",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Gdje je to moguće, ovdje opišite postupke upravljanja arhivom (isporuka, pohrana, pregled, itd.) koji su pod Vašom odgovornošću. Navedite uloge arhiviranja (uredi podrijetla, agencije za prijenos, itd.) i pravila arhiviranja. Navedite da li podaci padaju unutar okvira javnih arhiva.",
			name: "Arhiviranje",
			placeholder: "Ovdje navedite da li su uvedeni mehanizmi za praćenje integriteta pohranjenih podataka, kojih i u koju svrhu.",
			source: "piaF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Sredstva implementirana za <strong> osiguravanje povjerljivosti </ strong>  pohranjenih podataka (u bazi podataka, ravnim datotekama, sigurnosnim kopijama itd.), kao i postupak za upravljanje enkripcijskim ključevima (stvaranje, pohrana, promjena u slučaju sumnja na slučajeve kompromitiranja podataka i sl.). <br> Opišite načine enkripcije koji se koriste za tokove podataka (VPN, TLS, itd.), a koji su implementirani u obradi.",
			name: "Enkripcija",
			placeholder: "Opišite ovdje provedena sredstva za osiguranje povjerljivosti podataka",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Provedba particioniranja podataka pomaže smanjiti mogućnost da se osobni podaci mogu povezati i da se može pojaviti povreda svih osobnih podataka.",
			name: "Particioniranje podataka",
			placeholder: "Ovdje navedite da li se planira particioniranje obrade i kako se ono provodi.",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Metode za definiranje i pripisivanje korisničkih profila. Navedite način <strong> autentikacije </ strong> Gdje je to moguće, odredite pravila koja se primjenjuju na zaporke (minimalna duljina, zahtijevani znakovi, trajanje valjanosti, broj neuspjelih pokušaja prije zaključavanja pristupa računu i sl.).",
			name: "Kontrola logičkog pristupa",
			placeholder: "Ovdje navedite kako su definirani i kako se pripisuju korisnički profili.",
			source: "piaF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Pravila koja uređuju sljedivost i upravljanje zapisnicima.",
			name: "Sljedivost (stvaranje zapisa)",
			placeholder: "Ovdje navedite da li događaji bilježe i koliko dugo se ti tragovi čuvaju.",
			source: "piaF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "Mogu se koristiti sljedeće metode: Filtriranje i uklanjanje, smanjenje osjetljivosti putem pretvorbe, smanjenje otkrivajuće prirode podataka, smanjenje akumulacije podataka, ograničavanje pristupa podacima",
			name: "Smanjenje količine osobnih podataka",
			placeholder: "Ovdje navedite sredstva koja su provedena kako bi se smanjila ozbiljnost rizika ograničavanjem količine osobnih podataka",
			source: "piaF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Tamo gdje se tijekom obrade koriste papirnati dokumenti koji sadrže podatke, ovdje navedite kako se ispisuju, pohranjuju, uništavaju i razmjenjuju.",
			name: "Sigurnost papirnatih dokumenata",
			placeholder: "Ovdje navedite jesu li uvedeni mehanizmi za praćenje integriteta papirnatih dokumenata, koji su i za koju svrhu.",
			source: "piaF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "korektivne kontrole koje predlaže procjenitelj u prijašnjim koracima, uz izradu akcijskog plana kojim se određuje, za svaku radnju, njen voditelj, učestalost, težina, trošak i napredak.",
			name: "Akcijski plan",
			source: "Ne postoji"
		},
		PIA_VAL_CART: {
			description: "Grafikon koji ilustrira dobre sigurnosne prakse, s vrijednostima usklađenosti koje se dodjeljuju svakoj od njih na temelju njihove procjene u prijašnjim koracima.",
			name: "Mapiranje rizika",
			source: "piaF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Gdje je to primjereno, voditelj obrade zatražit će mišljenja ispitanika ili njihovih predstavnika o namjeravanoj obradi, ne dovodeći u pitanje zaštitu komercijalnih ili javnih interesa ili sigurnost postupaka obrade. Vidi čl. 35 st. 9 od <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> Ta se mišljenja mogu prikupljati različitim sredstvima, ovisno o kontekstu (unutarnje ili vanjsko istraživanje o metodama obrade i svrsi, pitanja za predstavnike osoblja ili sindikate, ankete među budućim klijentima voditelja obrade. <strong> Kada voditelj obrade odluči ići protiv stavova ispitanika </ strong>, on mora zabilježiti <strong> opravdanje ove odluke </ strong>. Ako voditelj obrade smatra da <strong> prikupljanje mišljenja ispitanika nije relevantno, mora također zabilježiti opravdanje za to</strong>.",
			name: "Mišljenje ispitanika",
			source: "OUZP čl. 35.9 and piaF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "Voditelj obrade tražit će savjet službenika za zaštitu podataka, kad je određen, pri provođenju procjene učinka na zaštitu podataka. Pogledajte čl. 35. st. 2 <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>Ovo gledište može biti protiv obrade koja se provodi, bez ograničavanja odluke voditelja obrade za to</strong>.",
			name: "Mišljenje SZP-a",
			source: "OUZP čl. 35.2 and piaF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Odlučite jesu li odabrane kontrole, rezidualni rizici i akcijski plan prihvatljivi, s opravdanjima, s obzirom na prethodno utvrđene uloge i mišljenja dionika. Na taj način, PUP može biti: <br>- potvrđen<br>- uvjetovan poboljšanjem (objasniti na koji način) <br> - odbijen (uz obradu koja je predmetom razmatranja). Tamo gdje je potrebno, ponovite prethodne korake kako bi PUP bio potvrđen. Ova odluka ne prejudicira ocjenu sukladnosti koja se može provesti, ako je to primjenjivo, od strane Tijela za zaštitu podataka (CNIL u Francuskoj), kao dio preliminarnih formalnosti ili provjera, na primjer.",
			name: "Formalna potvrda",
			source: "piaF Connected Objects p40"
		}
	},
	title: "Baza znanja"
};
var measures$3 = {
	add: "Dodaj praznu mjeru (u suprotnom koristi bazu znanja)",
	default_placeholder: "Opišite postojeće ili namjeravane mjere kako bi osigurali sigurnost podataka.",
	edit: "Uredi mjeru",
	placeholder_title: "Naziv mjere",
	remove: "Izbriši mjeru"
};
var misc$3 = {
	display: "Prikaži / sakrij"
};
var modals$3 = {
	abandon_pia: {
		additional_text: "Arhiviranje nije definitivno i PUP se može vratiti ako je potrebno.",
		content: "Želite li odustati od obrade?"
	},
	action_plan_no_evaluation: {
		content: "Morate započeti pregled analize kako biste izradili akcijski plan.",
		review_section: "Pregledajte odjeljak"
	},
	archive: "Arhiviraj",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "Ovaj odjeljak spreman je za pregled."
	},
	back_to_edition: {
		content: "Ovaj odjeljak poslan je nazada na uređivanje.<br> Potrebno je ispraviti nekoliko polja<br> kako bi se omogućio pravilan pregled."
	},
	back_to_evaluation: {
		content: "Ovaj odjeljak poslan je nazada na pregled.<br> Potrebno je pregledati nekoliko polja<br> kako bi se omogućilo pravilno potvrđivanje."
	},
	back_to_home: "Povratak kući",
	cancel: "Poništi",
	close: "Zatvori",
	completed_edition: {
		content: "PUP je u potpunosti uređen i treba ga pregledati."
	},
	completed_evaluation: {
		content: "PUP je u potpunosti pregledan i može ići na potvrdu."
	},
	"continue": "Nastavi",
	declare_measures: {
		content: "Prije procjene rizika,<br> morate prijaviti postojeće ili planirane mjere.",
		declare: "Objavi postojeće ili planirane mjere"
	},
	dpo_missing_evaluations: {
		comment: "Komentar",
		content: "Morate dovršiti pregled analize da biste pristupili stranici SZP-a.",
		remove: "Ukloni",
		review_section: "Pregledajte odjeljak"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Uvezena datoteka ne odgovara datoteci izvještaja PUP-a"
	},
	import_wrong_structure_file: {
		content: "Uvezena datoteka ne odgovara datoteci obrasca PUP-a"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Sadržaj PUP-a kopiran je u međuspremnik."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Warning,</span><br>Upozorenje, </ span> <br> barem jedna mjera mora biti unesena: brisanje nije moguće."
	},
	recover_version: {
		"continue": "Nastavi",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "Kako ste odbili PUP, on je ponovno poslan na pregled kako bi se izvršile potrebne promjene."
	},
	remove_attachment: {
		comment: "Komentar",
		content: "<span class='strong'>Upozorenje, </span><br> Jeste li sigurni da želite ukloniti ovaj privitak?",
		keep: "Zadrži",
		remove: "Ukloni"
	},
	remove_measure: {
		content: "<span class='strong'>Upozorenje,</span><br> jeste li sigurni da želite<br> ukloniti ovu mjeru?",
		keep: "Zadrži ovu <br>mjeru",
		remove: "Ukloni ovu <br>mjeru"
	},
	remove_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Ukloni ovaj PUP"
	},
	remove_question: {
		content: "Jeste li sigurni da želite obrisati pitanje?",
		keep: "Poništi",
		remove: "Izbriši"
	},
	remove_structure: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want<br>to delete the template?",
		remove: "Delete template"
	},
	same_comment: {
		content: "<span class='strong'>Upozorenje,</span><br> molimo unesite komentar koji se razlikuje od posljednje zabilježenog."
	},
	signed_pia_validation: {
		content: "Da biste odobrili PUP, priložite potpisano izvješće.",
		download_pia: "Preuzmi izvješće"
	},
	simple_pia_validation: {
		content: "Odobrili ste PUP."
	},
	start_evaluation: "Započni pregled",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Adresa poslužitelja je ažurirana."
	},
	validate_evaluation: {
		content: "Ovaj odjeljak spreman je za potvrdu PUP-a."
	},
	validate_evaluation_to_correct: {
		content: "Žao nam je,<br> potrebno je ispraviti nekoliko polja.<br>Povratak na način uređivanja<br> radi unošenja ispravaka."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$3 = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$3 = {
	content: ", razmotrite sljedeće :",
	dpo_lock: "Molimo ispunite ostale odjeljke prije ispunjavanja mišljenja SZP-a.",
	dpo_opinion: "Mišljenje SZP-a",
	edit: "Uredi",
	people_opinion: "Mišljenje dotičnih osoba",
	placeholder_concerned_people_name: "Ime(na) dotičnih osoba",
	placeholder_dpo_name: "Ime(na) SZP-a",
	placeholder_dpo_opinion: "Navedite razloge za vaš izbor.",
	placeholder_people_opinion: "Opišite kako su mišljenja prikupljena i koja je analiza. Ako se obavijesti ne traže, navedite razloge.",
	placeholder_search_content: "Opravdajte razlog zašto mišljenje dotičnih osoba nije zatraženo.",
	treatment_lock: "Molimo ispunite ostale odjeljke prije ispunjavanja mišljenja dotičnih osoba.",
	treatment_nok: "Tretman se ne smije koristiti.",
	treatment_ok: "Tretman se ne može provesti."
};
var pia$3 = {
	attachments: {
		add: "Dodaj",
		download: "TO TRANSLATE - Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Ukloni",
		title: "Prilozi",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Zatraži pregled",
		mandatory_fields: "Sva polja moraju biti popunjena",
		structure_add_question: "Dodaj",
		subsection_validated: "Pododjeljak je pregledan i očekuje konačnu potvrdu",
		validate_evaluation: "Izvrši potvrdu pregleda"
	},
	header: {
		display_action_plan: "Prikaži<br>akcijski plan",
		edition: "Izdanje",
		evaluation: "Evaluacija",
		preview: "Kratki pregled"
	},
	sections: {
		based_on_structure_name: "Na temelju obrasca:",
		homepage_link: "Povratak na kontrolnu ploču",
		refuse_pia: "Odbijeni PUP",
		status: {
			evaluation: {
				cancel: "poništi zahtjev za pregled.",
				cancel_button: "Poništi zahtjev za pregled",
				content: "Ovaj dio još nije pregledan. Ako želite urediti sadržaj koji je poslan na pregled, morate",
				title: "Čeka na pregled."
			},
			validation: {
				cancel: "poništiti zahtjev za potvrdu.",
				cancel_button: "Poništi zahtjev za potvrdu",
				content: "Ovaj dio je pregledan, te čeka na potvrdu cjelokupnog PUP-a. Ako želite izmijeniti pregled, morate",
				title: "Čeka na potvrdu."
			}
		},
		validate_pia: "Potvrdi  PUP"
	},
	statuses: [
		"U tijeku",
		"Odbijen",
		"Jednostavna potvrda",
		"Potpisana potvrda",
		"Arhiviran",
		"Čeka na potvrdu"
	]
};
var questions$3 = {
	edit: "Uredi pitanje",
	gauges: [
		"(Nedefinirano)",
		"Zanemariv",
		"Ograničen",
		"Bitan",
		"Maksimalan"
	],
	placeholder_title: "Question title (mandatory)",
	remove: "Delete question"
};
var rejection_page$3 = {
	applied_adjustments: "Predložene prilagodbe",
	applied_adjustments_placeholder: "Opišite promjene koje su unesene u PUP.",
	button: {
		abandon_treatment: "Obustavi obradu",
		reject_pia: "Odbij PUP",
		send_for_validation: "Pošalji na ponovno odobrenje"
	},
	previous_rejection: "Prethodno odbijanje",
	rejection_reason: "Razlog odbijanja",
	rejection_reason_placeholder: "Opišite razloge za odbijanje PUP-a.",
	title: "Povijest potvrđivanja"
};
var sections$3 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Prikažite kratak pregled obrade: njegovo ime, svrhe, uloge, kontekst uporabe itd.",
						title: "Koja je obrada koja se razmatra?"
					},
					"2": {
						placeholder: "Opišite odgovornosti dionika: voditelja obrade, mogućih izvršitelja obrade i zajedničkih voditelja obrade.",
						title: "Koje su odgovornosti povezane s obradom?"
					},
					"3": {
						placeholder: "Navedite relevantne standarde primjenjive na obradu, posebno odobrene kodekse ponašanja i certifikate zaštite podataka.",
						title: "Postoje li standardi primjenjivi na obradu?"
					}
				},
				short_help: "Ovaj dio vam omogućuje prepoznavanje i predstavljanje objekta razmatranja.",
				title: "Pregled"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Popišite prikupljene i obrađene podatke. Za svaki odredite trajanje pohrane, primatelje i osobe kojima je dan pristup.",
						title: "Koji se podaci obrađuju?"
					},
					"2": {
						placeholder: "Prikažite i opišite kako proizvod općenito funkcionira (od prikupljanja podataka do uništavanja podataka, različitih faza obrade, pohrane itd.), na primjer pomoću dijagrama tokova podataka (dodajte ih kao privitak) i detaljnog opisa provedenih postupaka.",
						title: "Kako funkcionira životni ciklus podataka i postupaka?"
					},
					"3": {
						placeholder: "Navedite podatke o pomoćnim sredstvima (operativni sustavi, poslovne aplikacije, sustavi za upravljanje bazama podataka, uredske stanice, protokoli, konfiguracije itd.)",
						title: "O kojim se pomoćnim sredstvima radi?"
					}
				},
				short_help: "Ovaj vam dio omogućuje detaljno definiranje i opis opsega obrade.",
				title: "Podaci, procesi i pomoćna sredstva"
			}
		},
		short_help: "Ovaj odjeljak daje jasan pregled tretmana osobnih podataka u pitanju.",
		title: "Kontekst"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Objasnite zašto su svrhe obrade posebne, izričite i zakonite.",
						short_title: "Svrhe",
						title: "Da li je svrha obrade posebna, izričita i zakonita?"
					},
					"2": {
						placeholder: "Opišite koja je pravna osnova vaše obrade (npr. privola, izvršenje ugovora, poštovanje zakonske obveze, zaštita vitalnih interesa, itd.)",
						short_title: "Pravna osnova",
						title: "Koja je pravna osnova koja obradu čini zakonitom?"
					},
					"3": {
						placeholder: "Objasnite zašto je svaki prikupljeni podatak nužan za potrebe vaše obrade.",
						short_title: "Adekvatni podaci",
						title: "Da li su prikupljeni podaci primjereni, relevantni i ograničeni na ono što je nužno u odnosu na svrhe u koje se obrađuju ('smanjenje količine podataka')?"
					},
					"4": {
						placeholder: "Opišite koji su koraci poduzeti kako bi se osigurala kvaliteta podataka.",
						short_title: "Točnost podataka",
						title: "Jesu li podaci točni i ažurni?"
					},
					"5": {
						placeholder: "Objasnite zašto su trajanja pohrane opravdana zakonskim zahtjevima i/ili potrebama za obradom.",
						short_title: "Trajanje pohrane",
						title: "Koliko je trajanje pohrane podataka?"
					}
				},
				short_help: "Ovaj dio vam omogućuje da pokažete zakonitost vašeg tretmana i obrađenih podataka.",
				title: "Proporcionalnost i nužnost"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Opišite koje su informacije dane ispitanicima i koja su sredstva za to.",
						short_title: "Informacije za ispitanike",
						title: "Kako su voditelji obrade obaviješteni o obradi?"
					},
					"2": {
						placeholder: "Opišite kontrole namijenjene za osiguranje privole ispitanika.",
						short_title: "Dobivanje privole",
						title: "Ako je primjenjivo, kako se dobiva privola ispitanika?"
					},
					"3": {
						placeholder: "Opišite kontrole namijenjene za omogućavanje ispitanicima da pristupe svojim podacima, da ih prime i da ih prenesu.",
						short_title: "Pravo pristupa i prenosivosti podataka",
						title: "Kako ispitanici mogu ostvariti svoja prava pristupa i prenosivosti podataka?"
					},
					"4": {
						placeholder: "Opišite kontrole namijenjene omogućavanju ispitanicima da isprave i izbrišu svoje podatke.",
						short_title: "Pravo na ispravak i brisanje",
						title: "Kako ispitanici mogu ostvariti svoja prava na ispravak i brisanje?"
					},
					"5": {
						placeholder: "Opišite kontrole namijenjene omogućavanju ispitanicima da ograniče i prigovore obradi njihovih podataka.",
						short_title: "Pravo na ograničenje i prigovor",
						title: "Kako ispitanici mogu ostvariti svoja prava na ograničenje i prigovor?"
					},
					"6": {
						placeholder: "Za svakog izvršitelja obrade, opišite njegove odgovornosti (trajanje, opseg, svrhu, dokumentirane upute za obradu i prethodno odobrenje) te navedite ugovore, kodekse ponašanja i certifikate koji određuju njegove zadaće i obveze.",
						short_title: "Podugovaranje",
						title: "Jesu li obveze izvršitelja obrade jasno identificirane i uređene ugovorom?"
					},
					"7": {
						placeholder: "Navedite svaku državu izvan Europske unije gdje se podaci pohranjuju ili obrađuju, te navedite je li priznato da ona nudi odgovarajuću razinu zaštite podataka ili opišite odredbe o prijenosu.",
						short_title: "Prijenosi",
						title: "U slučaju prijenosa podataka izvan Europske unije, jesu li podaci primjereno zaštićeni?"
					}
				},
				short_help: "Ovaj dio vam omogućuje da pokažete da provodite neophodna sredstva kako bi omogućili dotičnim osobama da ostvaruju svoja prava.",
				title: "Kontrole radi zaštite osobnih prava nositelja podataka"
			}
		},
		short_help: "Ovaj odjeljak omogućuje vam izgradnju okvira usklađenosti za načela privatnosti.",
		title: "Temeljna načela"
	},
	"3": {
		items: {
			"1": {
				short_help: "Ovaj odjeljak omogućuje vam da navedete kontrole (postojeće ili planirane) koje pridonose sigurnosti podataka.",
				title: "Planirane ili postojeće mjere"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Unesite moguće utjecaje +",
						title: "Koji bi mogli biti glavni <span class='green-highlight'> utjecaji na ispitanike </span> ako se rizik pojavi?"
					},
					"2": {
						placeholder: "Unesite prijetnje +",
						title: "Koje su glavne <span class='green-highlight'> prijetnje </span> koje bi mogle dovesti do rizika?"
					},
					"3": {
						placeholder: "Unesite izvore rizika +",
						title: "Koji su izvori <span class='green-highlight'> rizika </span>"
					},
					"4": {
						placeholder: "Kliknite da biste odabrali kontrole koje odgovaraju na rizik.",
						title: "Koja od navedenih <span class='green-highlight'> kontrola </span> doprinosi odgovoru na rizik?"
					},
					"5": {
						placeholder: "Ovdje opravdajte procijenjenu ozbiljnost rizika.",
						title: "Kako procjenjujete <span class='green-highlight'> ozbiljnost rizika </span>, posebno prema potencijalnim utjecajima i planiranim kontrolama?"
					},
					"6": {
						placeholder: "Ovdje opravdajte procijenjenu vjerojatnost.",
						title: "Kako procjenjujete vjerojatnost rizika <span class='green-highlight'> </span>, posebno u odnosu na prijetnje, izvore rizika i planirane kontrole?"
					}
				},
				short_help: "Analizirajte uzroke i posljedice nezakonitog pristupa podacima i procijenite njegovu ozbiljnosti i vjerojatnost.",
				title: "Nezakoniti pristup podacima"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Unesite moguće utjecaje +",
						title: "Koji bi mogli biti glavni <span class='green-highlight'> utjecaji na ispitanike </span> ako se rizik pojavi?"
					},
					"2": {
						placeholder: "Unesite prijetnje +",
						title: "Koje su glavne <span class='green-highlight'> prijetnje </span> koje bi mogle dovesti do rizika?"
					},
					"3": {
						placeholder: "Unesite izvore rizika +",
						title: "Koji su izvori <span class='green-highlight'> rizika </span>?"
					},
					"4": {
						placeholder: "Kliknite ovdje za odabir kontrola koje odgovaraju na rizik.",
						title: "Koja od navedenih <span class='green-highlight'> kontrola </span> doprinosi odgovoru na rizik?"
					},
					"5": {
						placeholder: "Ovdje opravdajte procijenjenu ozbiljnost rizika.",
						title: "Kako procjenjujete <span class='green-highlight'> ozbiljnost rizika </span>, posebno u odnosu na potencijalne utjecaje i planirane kontrole?"
					},
					"6": {
						placeholder: "Ovdje opravdajte procijenjenu vjerojatnost.",
						title: "Kako procjenjujete <span class='green-highlight'> vjerojatnost rizika </span>, posebno u odnosu na prijetnje, izvore rizika i planirane kontrole?"
					}
				},
				short_help: "Analizirajte uzroke i posljedice neželjenih izmjena u podacima i procijenite njihovu ozbiljnost i vjerojatnost.",
				title: "Neželjena izmjena podataka"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "unesite moguće utjecaje +",
						title: "Koji bi mogli biti glavni <span class='green-highlight'> utjecaji na ispitanike </span> ako se rizik pojavi?"
					},
					"2": {
						placeholder: "Unesite prijetnje +",
						title: "Koje su glavne <span class='green-highlight'> prijetnje </span> koje bi mogle dovesti do rizika?"
					},
					"3": {
						placeholder: "Upišite izvore rizika +",
						title: "Koji su izvori <span class='green-highlight'> rizika </span>?"
					},
					"4": {
						placeholder: "Kliknite ovdje za odabir kontrola koje odgovaraju na rizik.",
						title: "Koja od navedenih <span class='green-highlight'> kontrola </span> doprinosi odgovoru na rizik?"
					},
					"5": {
						placeholder: "Ovdje opravdajte procijenjenu ozbiljnost rizika.",
						title: "Kako procjenjujete <span class='green-highlight'> ozbiljnost rizika </span>, posebno u odnosu na potencijalne utjecaje i planirane kontrole?"
					},
					"6": {
						placeholder: "Ovdje opravdajte procijenjenu vjerojatnost.",
						title: "Kako procjenjujete <span class='green-highlight'> vjerojatnost rizika </span>, posebno u odnosu na prijetnje, izvore rizika i planirane kontrole?"
					}
				},
				short_help: "Analizirajte uzroke i posljedice gubitka podataka i procijenite njegovu ozbiljnost i vjerojatnost.",
				title: "Nestanak podataka"
			},
			"5": {
				short_help: "Ova vizualizacija omogućuje vam globalno i sintetičko gledanje na učinke kontrola na rizike na koje odgovaraju.",
				title: "Pregled rizika"
			}
		},
		short_help: "Ovaj odjeljak omogućuje vam procjenu rizika privatnosti, uzimajući u obzir postojeće ili planirane kontrole.",
		title: "Rizici"
	},
	"4": {
		items: {
			"1": {
				short_help: "Ova vizualizacija omogućuje usporedbu položaja rizika između njih međusobno, te prije i poslije primjene komplementarnih kontrola.",
				title: "Mapiranje rizika"
			},
			"2": {
				short_help: "Detaljno isplanirajte provedbu dodatnih kontrola utvrđenih tijekom PUP-a. Akcijski plan se automatski ažurira prilikom procjene različitih elemenata od kojih se PUP sastoji.",
				title: "Akcijski plan"
			},
			"3": {
				short_help: "Prikažite savjet osobe zadužene za zaštitu podataka i pitanja privatnosti (službenik za zaštitu podataka ako postoji). Prikažite stavove ispitanika ili njihovih predstavnika.",
				title: "SZP i mišljenja dotičnih osoba"
			},
			"4": {
				title: "Potvrdite PUP"
			},
			"5": {
				title: "Odbijeni PUP"
			}
		},
		short_help: "Ovaj odjeljak omogućuje Vam pripremu i formalizaciju potvrda za PUP.",
		title: "Potvrda"
	}
};
var settings$3 = {
	content: "Molimo navedite adresu (URL) udaljenog poslužitelja:",
	title: "Postavke",
	update: "Ažuriraj URL"
};
var summary$3 = {
	action_plan: {
		fundamental_principles: "Temeljna načela",
		implementation_date: "Očekivani datum provedbe",
		implementation_responsible: "Odgovoran za provedbu",
		measures: "Postojeće ili planirane mjere",
		no_action_plan: "Nije zabilježen akcijski plan.",
		risks: "Rizici",
		title: "Akcijski plan"
	},
	actions: {
		complete_download: "TO TRANSLATE - Download the full report",
		complete_download_desc: "TO TRANSLATE - Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "TO TRANSLATE - Download elements of the report",
		individual_download_desc: "TO TRANSLATE - Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "TO TRANSLATE - Texts (.doc)",
		individual_download_images: "TO TRANSLATE - Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "TO TRANSLATE - Select elements to export:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "TO TRANSLATE - Print the report",
		print_and_download: "TO TRANSLATE - Print and download"
	},
	attachments: "Prilozi",
	concerned_people_name: "Mišljenja dotičnih osoba",
	concerned_people_opinion: "Mišljenja dotičnih osoba",
	concerned_people_searched_opinion: "Traženje mišljenja dotičnih osoba",
	concerned_people_status: "Statusi dotičnih osoba",
	concerned_people_unsearched_opinion_comment: "Razlog zašto nije zatraženo mišljenje dotične osobe",
	content_choice: [
		"Tretman se ne smije koristiti.",
		"Tretman bi se mogao provesti."
	],
	creation_date: "Datum stvaranja",
	csv_action_plan_comment: "Komentar akcijskog plana",
	csv_evaluation_comment: "Komentar procjene",
	csv_file_title: "Akcijski plan",
	csv_implement_date: "Procijenjeni datum provedbe",
	csv_people_in_charge: "Odgovorna osoba",
	csv_section: "Odjeljak",
	csv_title_object: "Naslov",
	download_csv: "TO TRANSLATE - Action plan (.csv)",
	dpo_name: "Ime SZP-a",
	dpo_opinion: "Mišljenje SZP-a",
	dpo_status: "Status SZP-a",
	gauges: {
		"1": "Zanemariv",
		"2": "Ograničen",
		"3": "Važan",
		"4": "Maksimalan"
	},
	modification_made: "Izmjene napravljene",
	people_search_status_nok: "Nije zatraženo mišljenje dotične osobe.",
	people_search_status_ok: "Zatraženo je mišljenje dotične osobe.",
	pia_assessor: "Ime procjenitelja",
	pia_author: "Ime autora",
	pia_name: "PUP",
	pia_validator: "Ime potvrditelja",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "TO TRANSLATE - Editing",
	preview_evaluation: "TO TRANSLATE - Evaluation",
	preview_no_data: "TO TRANSLATE - No data to display.",
	preview_status: "TO TRANSLATE - Status",
	preview_subtitle: "TO TRANSLATE - General information",
	preview_title: "TO TRANSLATE - Preview",
	preview_validation: "TO TRANSLATE - Validation",
	preview_validation_section: "TO TRANSLATE - Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Natrag na prethodnu stranicu",
	rejection_reason: "Razlog odbijanja",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Mapiranje rizika",
	risks_overview_title: "Pregled rizika",
	title: "Informacije o PUP-u"
};
var users$3 = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$3 = {
	add_signed_pia: "Dodaj potpisani PUP",
	after_reading: "Nakon čitanja cijelog PUP-a koji se odnosi na obradu podataka povezanih s",
	button: {
		rejection: "Odbij PUP",
		signed_validation: "Odobri PUP <br>(uz potpis)",
		simple_validation: "Odobri PUP <br>(izravno)"
	},
	confirmation1: "Potvrđujem da je kontekst obrade opisan u PUP-u u skladu sa stvarnosti.",
	confirmation2: "Potvrđujem da sam svjestan rizika, ovisno o postojećim ili planiranim mjerama.",
	confirmation3: "Potvrđujem korektivne radnje navedene u akcijskom planu.",
	confirmation4: "Obvezujem se što brže provesti navedene korektivne radnje.",
	latest_signed_attachment: "Zadnji potpisani privitak",
	mandatory_fields: "Sve kućice moraju biti označene",
	remove_attachment: "Ukloni privitak",
	responsible: "Osoba odgovorna za potvrđivanje PUP-a: ",
	signed_attachments_history: "Povijest potpisanih privitaka",
	tools: {
		dashboard: "Kontrolna ploča",
		display_pia: "Prikaži izvještaj"
	},
	validated_pia_with_signature: "Odobreno",
	waiting_for_signature: "Čeka se na potpis PUP-a"
};
var sl = {
	about: about$3,
	action_plan: action_plan$3,
	authentication: authentication$3,
	cartography: cartography$3,
	comments: comments$3,
	conflict: conflict$3,
	date: date$3,
	errors: errors$3,
	evaluations: evaluations$3,
	header: header$3,
	help: help$3,
	homepage: homepage$3,
	knowledge_base: knowledge_base$3,
	measures: measures$3,
	misc: misc$3,
	modals: modals$3,
	onboarding: onboarding$3,
	opinions: opinions$3,
	"overview-risks": {
	important: "Važan",
	limited: "Ograničen",
	maximal: "Maksimalan",
	measures: "Mjere",
	negligible: "Zanemariv",
	potential_impacts: "Potencijalni utjecaji",
	"risk-access_x": "Ozbiljnost",
	"risk-access_y": "Vjerojatnost",
	"risk-change_x": "Ozbiljnost",
	"risk-change_y": "Vjerojatnost",
	"risk-disappearance_x": "Ozbiljnost",
	"risk-disappearance_y": "Vjerojatnost",
	sources: "Izvori",
	threat: "Prijetnje"
},
	pia: pia$3,
	questions: questions$3,
	rejection_page: rejection_page$3,
	sections: sections$3,
	settings: settings$3,
	summary: summary$3,
	users: users$3,
	validation_page: validation_page$3
};

var about$2 = {
	contribute: "Om du vill bidra med översättning av denna mjukvara till ett annat språk eller förbättra redan gjorda översättningar så välkomnar vi dig till <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">läs där hur det går till </a>.",
	description: "Detta verktyg är ursprungligen utvecklat av <a target=\\\"_blank\\\" href=\\\"https://www.cnil.fr\\\">Commission Nationale Informatique et Liberté (CNIL)</a>, den franska datainspektionen, för att hjälpa personuppgiftsansvariga att säkerställa att behandlingar överensstämmer med den allmänna dataskyddsförordningen (DSF, även refererad till som \"GDPR\"). Verktyget är utvecklat av <a href=\\\"https://atnos.com\\\" target=\\\"_blank\\\">ATNOS</a>.<br>Detta verktyg är utvecklat med öppen källkod enligt licenstypen GPLv3. Om du vill bidra till detta projekt så är du välkommen att ladda ner källkoden från Github, modifiera den och dela den i forumet.",
	licences: "Bibliotekslicenser:",
	title: "Om PIA-verktyget",
	translators: "PIA-verktyget är för närvarande tillgängligt på 19 språk. De franska och engelska versionerna är producerade av CNIL. Övriga versioner är resultat av följande individers översättningsarbete:",
	translators_name: "<li>Svenska : Per von Bahr, Sopra Steria AB ;</li><ul><ul><li>Croatian : <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Czech : Jiří Grohmann, Manuel d’Orso ;</li><li>Danish : <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Dutch : Ruud van Driel, Manuel d’Orso ;</li><li>English : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Estonian : Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Finnish : <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>French : <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>German : <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Greek : <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Hungarian : <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Italian : Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lithuanian : Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norwegian : <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Polish : <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portuguese : <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Romanian : <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spanish : <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Versionsnummer"
};
var action_plan$2 = {
	acceptable_measures: "Acceptabla åtgärder",
	edit: "Redigera",
	improvable_measures: "Förbättringsbara åtgärder",
	measures: "Planerade eller befintliga åtgärder",
	no_action_plan: "Ingen registrerad åtgärdsplan",
	placeholder_person_in_charge: "Ansvarig för utförandet",
	principles: "Fundamentala principer",
	risk1: "Obehörig åtkomst till personuppgifter",
	risk2: "Oönskade förändringar av personuppgifter",
	risk3: "Förlust av personuppgifter",
	risks: "Risker",
	title: "Översikt"
};
var authentication$2 = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Denna mjukvara som är producerad av <strong>Commission Nationale de l'Informatique et des Libertés (CNIL)</strong> är utvecklad för att hjälpa personuppgiftsansvariga att uppfylla och vidmakthålla överensstämmelse med DSF (GDPR) i sin behandling av personuppgifter. Den ger stöd för att utföra en standardiserad konsekvensanalys (PIA/DPIA) med hjälp av en metodik utvecklad av CNIL",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Start",
	start_app: "Starta konsekvensanalysen (Beta)",
	subtitle1: "En plattform för att utföra <br> samt att hantera utförda konsekvensanalyser (PIA - Privacy Impact Assessment)",
	subtitle2: "Verktyg och ordlistor",
	title: "Konsekvensanalys avseende hanterande av personuppgifter",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$2 = {
	important: "Viktigt",
	legend1: "Planerade eller befintliga åtgärder",
	legend2: "Med utförda åtgärder",
	legend3: "(O)behörig åtkomst till personuppgifter",
	legend4: "(I)cke önskade förändringar av personuppgifter",
	legend5: "(F)örlust av personuppgifter",
	likelihood_axe: "Sannolikhet för risk",
	limited: "Begränsad",
	maximal: "Maximal",
	negligible: "Obetydlig",
	risk1_access: "(O)",
	risk2_modification: "(I)",
	seriousness_axe: "Riskens allvarlighetsgrad"
};
var comments$2 = {
	comment: "Kommentar",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "Kommentarer (antal)",
	new_comment: "Kommentera",
	placeholder_new_comment: "Skriv en kommentar",
	send: "Skicka"
};
var conflict$2 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$2 = {
	april: "TO TRANSLATE - April",
	august: "TO TRANSLATE - August",
	december: "TO TRANSLATE - December",
	"earlier-in-this-month": "TO TRANSLATE - Earlier this month",
	"earlier-in-this-week": "TO TRANSLATE - Earlier this week",
	february: "TO TRANSLATE - February",
	january: "TO TRANSLATE - January",
	july: "TO TRANSLATE - July",
	june: "TO TRANSLATE - June",
	march: "TO TRANSLATE - March",
	may: "TO TRANSLATE - May",
	november: "TO TRANSLATE - November",
	october: "TO TRANSLATE - October",
	september: "TO TRANSLATE - September",
	today: "TO TRANSLATE - Today",
	yesterday: "TO TRANSLATE - Yesterday"
};
var errors$2 = {
	content: "Om du stöter på andra problem eller om du har förslag på förbättringar, <br> så kan du beskriva och sända dem via detta formulär: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Finner inte sidan."
};
var evaluations$2 = {
	acceptable: "Godkänd",
	action_plan_comment: "Åtgärdsplan / Korrigeringsåtgärder",
	evaluation_comment: "Granskningskommentarer",
	gauges: {
		"0": "(Odefinierad)",
		"1": "Obetydlig",
		"2": "Begränsad",
		"3": "Allvarlig",
		"4": "Maximal",
		likelihood: "Med hänsyn tagen till att åtgärdsplanen följts, hur bedömer du <span class='red-highlight'>sannolikheten för att den resterande risken inträffar</span> ?",
		seriousness: "Med hänsyn tagen till att åtgärdsplanen följts, hur bedömer du <span class='red-highlight'> allvarlighetsgraden för den resterande risken  </span> ?"
	},
	improvable: "Kan förbättras",
	placeholder_acceptable: "Ge en förklarande kommentar kring varför de åtgärder som utförts är tillräckliga för att ge ett tillräckligt skydd av personuppgifterna",
	placeholder_improvable1: "Ge en förklarande kommentar kring vilka ytterligare åtgärder som bör utföras för att ge ett tillräckligt skydd av personuppgifterna",
	placeholder_improvable2: "Skriv dina kommentarer.",
	placeholder_to_correct: "Ge en förklarande kommentar kring varför dessa åtgärder inte ger ett tillräckligt skydd av personuppgifterna. Återsändes till PIA-utföraren för att kompletteras med ytterligare åtgärder.",
	status: [
		"Ofärdigt",
		"Att korrigera",
		"Förbättringsbart",
		"Godkänt"
	],
	title: "Utvärdering",
	to_correct: "Att korrigera"
};
var header$2 = {
	archives: "TO TRANSLATE - PIA Archives",
	current_pias: "TO TRANSLATE - Current PIAs",
	exit_full_screen_mode: "Tryck på F11 för att lämna fullskärmsläge",
	help: {
		issue_reporting: "TO TRANSLATE - Report an issue",
		manual: "TO TRANSLATE - User manual",
		pia_example_link: "Konsekvensanalysexempel",
		title: "TO TRANSLATE - Help"
	},
	homepage_link: "Hem",
	knowledge_base_link: "Kunskapsbas",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "Traductions fournies par la CNIL",
		community_translations: "Traductions fournies par la communauté",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Traduction révisée par les ADP européenne",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Version originelle",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "PIA - Konsekvensanalys",
	logo_title: "PIA - Konsekvensanalys",
	structures: "PIA - mallar",
	tools: {
		about: "Om",
		accessibility: "Tillgänglighet för funktionsvariationer (skarpa kontrastfärger, anpassning till färgblindhet)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Inställningar",
		url_setting: "TO TRANSLATE - Server URL configuration",
		users: "TO TRANSLATE - Users"
	}
};
var help$2 = {
	definition: {
		data1: {
			content: "Innehåll under pågående bearbetning",
			title: "Använd PIA verktyget"
		},
		data2: {
			qa1: {
				content: "Om du får problem med skärmbilden så starta om programmet. Detta åtgärdar normalt problemet. Allt som skrivits in sparas kontinuerligt så vid denna åtgärd riskerar du inte att förlora det som redan skrivits in i verktyget.",
				title: "Jag har problem med att t.ex. symboler eller ikoner inte uppdateras eller att det fattas knappar eller annat i menyer eller andra gränssnitt."
			},
			qa2: {
				content: "Detta problem är känt och håller på att åtgärdas. Om du stöter på detta problem rekommenderar vi att du fyller i fältet \"Justification\" med hur allvarligt det varit samt hur ofta det uppstår. Du kommer att kunna justera dina värden när felet är avklarat.",
				title: "Jag kan inte editera skalorna för sannolikhet och graden av risk"
			},
			qa3: {
				content: "Flera fel har noterats i samband med import av en PIA. Speciellt kopplat till presentationen av sannolikhet och risk där information försvinner. För att avhjälpa detta kan du återgå till det föregående steget i PIAn och sedan stega tillbaka till graferna. Om problemet inte avhjälpts så ladda om bilden.",
				title: "Jag har problem kopplat till importen av en PIA"
			},
			qa4: {
				content: "Detta är ett fel kopplat till visualiseringen av informationen som lagts i PIAn, men påverkar inte alls den data som matats in. Detta problem kommer snart att vara avhjälpt.",
				title: "När jag kopierar in text visas den som understruken eller fet text"
			},
			qa5: {
				content: "För att begära en utvärdering krävs att alla fält fyllts i. Var vänlig att kontrollera att detta gjorts. Vad gäller riskbedömningen så måste en teknisk eller organisatorisk åtgärd för att minimera risken angivas.",
				title: "Jag kan inte sända en begäran om att utvärdera en sektion"
			},
			qa6: {
				content: "Stäng den PIA du arbetar med och öppna den igen. Innehållet kommer då att presenteras på det valda språket.",
				title: "När jag byter språk ändras texterna inte till den valda språket"
			},
			qa7: {
				content: "För tillfället uppdateras inte ikonerna i navigationsmenyn till vänster efter en nekad PIA. Du måste gå igenom varje avsnitt för att läsa grunder för avslag och anpassa åtgärderna för att kunna begära en förnyad utvärdering. När alla avsnitt kontrollerats och, vid behov, justerats kan du på nytt begära att få PIAn utvärderad.",
				title: "PIAn har inte blivit godkänd, men jag vet inte vad nästa steg är"
			},
			title: "Kända problem"
		},
		footer: "Om du stöter på andra problem eller om du har förslag på förbättringar, så kan du beskriva och sända dem via detta formulär: <a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "Hjälp"
};
var homepage$2 = {
	cards: {
		author: "Datainsamlare",
		category: "TO TRANSLATE - Category",
		creation_status: "Skapa",
		date: "Datum",
		evaluation: "Utvärdera",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Importera AIIA",
		import_structure: "Importera mall",
		item: {
			consult_pia: "Konsultera",
			consult_structure: "TO TRANSLATE - Consult template",
			edit_pia: "Redigera",
			edit_structure: "Redigera mall",
			tools: {
				action_plan: "Visa <br> åtgärdsplan",
				archive: "TO TRANSLATE - Archive",
				duplicate: "Duplicera",
				"export": "Exportera",
				more_options: "Fler val",
				pia: "Visa <br>PIAn",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			},
			validate_pia: "TO TRANSLATE - Validate"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Ny AIIA",
		new_structure: "Ny mall",
		or: "eller",
		pia_name: "PIA",
		placeholder_author: "Förnamn, efternamn",
		placeholder_category: "TO TRANSLATE - Category",
		placeholder_evaluation: "Förnamn, efternamn",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Importera AIIA",
		placeholder_import_structure: "Importera mall",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Ny AIIA",
		placeholder_new_structure: "Ny mall",
		placeholder_pia_name: "PIA´s namn",
		placeholder_sector_name: "Namn på sektionen",
		placeholder_start: "Alla fält måste fyllas i",
		placeholder_structure: "Standardmall",
		placeholder_structure_name: "Mallnamn",
		placeholder_validation: "Förnamn, efternamn",
		sector_name: "Tillhörande sektion",
		start: "Start",
		status: "Status",
		structure: "Mall",
		structure_name: "Mallnamn",
		title_close_creation: "Stäng",
		validation: "Validering"
	},
	filters: {
		assessor: "Utvärderare",
		author: "Datainsamlare",
		card: "Kort",
		card_rocket_content: "Starta! <br><br>För att börja<br>en PIA, klicka<br> på +",
		card_rocket_content_structure: "Starta! <br><br>För att börja<br>en mall, klicka<br> på +",
		category: "TO TRANSLATE - Category",
		date: "Datum",
		import_pia: "Importera AIIA",
		import_structure: "Importera en mall",
		list: "lista",
		list_rocket_content: "Starta! För att börja<br>en PIA, klicka på +",
		list_rocket_content_structure: "Starta! För att börja<br>en mall, klicka på +",
		name: "Namn",
		new_pia: "Ny AIIA",
		new_structure: "Ny mall",
		sector_name: "Tillhörande sektion",
		sort: "Sortera",
		sort_by: "efter",
		status: "Status",
		validator: "Godkännare"
	},
	lists: {
		column_actions: "Alternativ",
		column_author: "Datainsamlare",
		column_category: "TO TRANSLATE - Category",
		column_creation: "Skapad",
		column_evaluation: "Utvärdering",
		column_pia: "PIA",
		column_progression: "Framåtskridande",
		column_sector_name: "Tillhörande sektion",
		column_status: "Status",
		column_structure: "Mall",
		column_structure_name: "Mall",
		column_updated_at: "Senast öppnad",
		column_validation: "Godkännande",
		item: {
			tools: {
				action_plan: "Visa åtgärdsplan",
				archive: "TO TRANSLATE - Archive",
				consult: "Konsultera",
				duplicate: "Duplicera",
				edit: "Redigera",
				"export": "Exportera",
				pia: "Via AIIA",
				remove: "TO TRANSLATE - Delete",
				unarchive: "TO TRANSLATE - Unarchive"
			}
		}
	},
	search_filter: "TO TRANSLATE - Search",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$2 = {
	add_measure: "Lägg till",
	add_measure_hint: "Du kan också lägga till en åtgärd från kunskapsdatabasen",
	category: {
		definition: "Definition",
		example: "Exempel",
		general_measure: "Allmän säkerhetsåtgärd för systemet (fysisk)",
		measure_on_data: "Logisk säkerhetsåtgärd för personuppgifterna",
		method: "Metodik",
		organizational_measure: "Organisatorisk åtgärd",
		principle: "Princip"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Alla",
		definitions: "Definitioner",
		general_measures: "Allmäna säkerhetsåtgärder för systemet (fysisk)",
		measures_on_data: "Logiska säkerhetsåtgärder för personuppgifterna",
		no_result: "Inga resultat hittades.",
		organizational_measures: "Organisatoriska åtgärder",
		title: "Filter"
	},
	placeholder_add_measure: "Lägg till denna åtgärd",
	placeholder_help: "Inmatningshjälp",
	search: "Sök",
	slugs: {
		PIA_DEF_ACC: {
			description: "Den registrerade ska ha rätt att erhålla bekräftelse från den personuppgiftsansvarige att personuppgifter om honom / henne behandlas och få tillgång till sådana personuppgifter samt andra uppgifter som anges i<a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:32016R0679&rid=1\">artikel 15 i Dataskyddsförordningen (GDPR)</a>.",
			name: "Rätt till tillgång",
			source: "ADSF/GDPR Art. 15, Den registrerades rätt till tillgång "
		},
		PIA_DEF_ANO: {
			description: "Syftet med en anonymiseringslösning är att ta bort den identifierande karaktären av personuppgifter. En anonymiseringslösning måste byggas från fall till fall och anpassas till avsedd användning. För att hjälpa till att utvärdera en bra anonymiseringslösning föreslår EDPB i <a target=\"_blank\" href=\"https://ec.europa.eu/justice/article-29/documentation/opinion-recommendation/files/2014/wp216_sv.pdf\">G29</a> tre kriterier:<br>- <strong>Särskiljbarhet: </strong>Är det  möjligt att särskilja en person?<br>- <strong>Länkbarhet: </strong>Är det möjligt att kombinera olika uppsättningar data om samma person?<br>- <strong>Inferens (Härledning):</strong> Kan information om en person härledas? <br>Således: <strong>Data för vilken det är omöjligt att särskilja, länka till eller Inferera/härleda till en fysisk person är att ses som anonym</strong> ;<br>Data för vilken <strong>åtminstone ett av de tre kriterierna inte uppfylls </strong>kan endast betraktas som anonym efter en detaljerad riskanalys gällande identifiering är utförd.",
			name: "Anonymisering",
			source: "https://ec.europa.eu/justice/article-29/documentation/opinion-recommendation/files/2014/wp216_sv.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Uppgifter som inte längre används dagligen men som ännu inte har nått sin maximala lagringsperiod, till exempel för att de bevaras i händelse av tvister, bör arkiveras.<br><br><strong>Arkiv måste vara säkra </strong>, särskilt om de arkiverade uppgifterna är känslig personlig information eller personlig information som kan ha allvarliga effekter på de registrerade.",
			name: "Arkivering",
			source: "Datainspektionen"
		},
		PIA_DEF_AUTH: {
			description: "Autentisering är en <strong>metod genom vilken användaren styrker sin identitet</strong>, för det finns det flera mekanismer som kategoriseras enligt vilka tekniker de involverar:<br>- Vad man vet, till exempel ett lösenord;<br>- Vad man har, till exempel ett digitalt certifikat;<br>- En egenskap, till exempel ett fingeravtryck eller hur man skriver en handskriven signatur.<br>Dataskyddsförordningen förskriver ett förhandsgodkännande av Datainspektionen vid användning av biometri <br><strong>Autentiseringen av en användare beskrivs som stark när den använder en kombination av minst två av dessa kategorier.</strong>",
			name: "Autentisering",
			source: "Datainspektionen"
		},
		PIA_DEF_CHIF: {
			description: "TO TRANSLATE - Measure making personal data unintelligible to anyone without access authorization (symmetric or asymmetric encryption, use of public algorithms known to be strong, authentication certificate, etc.).",
			name: "Kryptering",
			source: "https://www.cnil.fr/fr/comprendre-les-grands-principes-de-la-cryptologie-et-du-chiffrement"
		},
		PIA_DEF_CLO: {
			description: "En uppsättning metoder för att minska möjligheten att korrelera eller härleda personuppgifter och orsaka brott dataskyddsförordningen.<br>Vi kan till exempel begränsa de specifika personuppgifterna till varje sektion/enhet, separera dem logiskt, etc.",
			name: "Segmentering av personuppgifter",
			source: "Källa saknas"
		},
		PIA_DEF_CONS: {
			description: "varje slag av frivillig, specifik, informerad och otvetydig viljeyttring, genom vilken den registrerade, antingen genom ett uttalande eller genom en entydig bekräftande handling, godtar behandling av personuppgifter som rör honom eller henne",
			name: "Samtycke",
			source: "ADSF/GDPR Art. 4.11"
		},
		PIA_DEF_CTLA: {
			description: "Det består i att begränsa riskerna för att obehöriga får tillgång till personuppgifter i digital form.<br>För att göra detta måste du:<br>- <strong>definiera behörighetsprofiler</strong> i system genom att separera uppgifter och ansvarsområden för att begränsa användarnas åtkomst till att vara endast data strikt nödvändigt för att fullgöra sina uppdrag. <br>- <strong>ta bort behörighet för användaråtkomst så snart de inte längre är berättigade till åtkomst till en lokal eller IT-resurs</strong>och<strong>i slutet av deras kontrakt.</strong> <br>- <strong> Genomföra en årlig granskning av rättigheterna</strong> för att identifiera och ta bort oanvända konton och omvärdera rättigheter som beviljas för varje användares funktioner.",
			name: "Logisk åtkomstkontroll",
			source: "Källa saknas, men ISO 27001 kan användas"
		},
		PIA_DEF_DCP: {
			description: "varje upplysning som avser en identifierad eller identifierbar fysisk person (nedan kallad en registrerad), varvid en identifierbar fysisk person är en person som direkt eller indirekt kan identifieras särskilt med hänvisning till en identifierare som ett namn, ett identifikationsnummer, en lokaliseringsuppgift eller online-identi­fikatorer eller en eller flera faktorer som är specifika för den fysiska personens fysiska, fysiologiska, genetiska, psykiska, ekonomiska, kulturella eller sociala identitet",
			name: "Personuppgifter ",
			source: "ADSF/GDPR Art. 4.1"
		},
		PIA_DEF_DEST: {
			description: "en fysisk eller juridisk person, offentlig myndighet, institution eller annat organ till vilket personupp­gifterna utlämnas, vare sig det är en tredje part eller inte; offentliga myndigheter som kan komma att motta personuppgifter inom ramen för ett särskilt uppdrag i enlighet med unionsrätten eller medlemsstaternas nationella rätt ska dock inte betraktas som mottagare; offentliga myndigheters behandling av dessa uppgifter ska vara förenlig med tillämpliga bestämmelser för dataskydd beroende på behandlingens syfte",
			name: "Mottagare",
			source: "ADSF/GDPR Art. 4.9"
		},
		PIA_DEF_EFF: {
			description: "Den registrerade ska ha rätt att av den personuppgiftsansvarige utan onödigt dröjsmål få sina personuppgifter raderade och den personuppgiftsansvarige ska vara skyldig att utan onödigt dröjsmål radera personuppgifter om något av följande gäller: <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:32016R0679&rid=1\">Art. 17 av [ADSF/GDPR]</a>",
			name: "Rätt till radering (”rätten att bli bortglömd”)",
			source: "ADSF/GDPR Art. 17"
		},
		PIA_DEF_ENJ: {
			description: "Dessa är de motiv som leder till genomförandet av behandlingen, de förväntade fördelarna (för organisationen, för de berörda människorna, för samhället i allmänhet ...).",
			name: "Skäl för behandling",
			source: "<a target=\"_blank\" href=\"https://www.cnil.fr/en/PIA-privacy-impact-assessment-en\"/a>"
		},
		PIA_DEF_EXA: {
			description: "Personuppgifter ska vara korrekta och om nödvändigt uppdaterade. Alla rimliga åtgärder måste vidtas för att säkerställa att personuppgifter som är felaktiga i förhållande till de ändamål för vilka de behandlas raderas eller rättas utan dröjsmål (korrekthet)",
			name: "Datakvalitet",
			source: "ADSF/GDPR Art. 5.1 d)"
		},
		PIA_DEF_GRV: {
			description: "Allvarlighetsgraden är storleken på en risk. Det beror i huvudsak på den skadliga karaktären av de potentiella effekterna",
			name: "Allvarlighetsgrad",
			source: "<a target=\"_blank\" href=\"https://www.cnil.fr/en/PIA-privacy-impact-assessment-en\"/a>"
		},
		PIA_DEF_LIM: {
			description: "Den registrerade ska ha rätt att av den personuppgiftsansvarige kräva att behandlingen begränsas om något av följande alternativ är tillämpligt: se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:32016R0679&rid=1\">Art. 18 av [ADSF/GDPR]</a>",
			name: "Rätt till begränsning av behandling",
			source: "ADSF/GDPR Art. 18"
		},
		PIA_DEF_LOG: {
			description: "Enhet för loggning av behandlingar som utförs på datorsystemet för att <strong>identifiera bedräglig åtkomst</strong> eller <strong>missbruk</strong> av personuppgifter eller för att avgöra ursprunget till en incident. Några av de behandlingar som utförs på datorsystem bör registreras. För att göra detta måste ett logg- och incidenthanteringssystem införas. Den måste <strong>registrera relevanta händelser</strong> och <strong>se till att dessa poster inte kan ändras.</strong> I alla fall bör du inte <strong>förvara dessa loggar under en alltför lång tid.</strong>",
			name: "Loggning och spårbarhet",
			source: "Källa saknas / CNIL"
		},
		PIA_DEF_MEN: {
			description: "En situation där en eller flera skeenden negativt kan påverka data i systemen eller dess stödsystem. Hotet kan genomföras med eller utan avsikt av riskkällor och kan orsaka en oönskad händelse.",
			name: "Hot",
			source: "Källa saknas"
		},
		PIA_DEF_MENA: {
			description: "Hot mot: </strong><br>- <strong>Komponenter</strong>, felaktigt använda, observerade, modifierade eller förlorade (användning av ett lagringsmedia som innehåller känsliga uppgifter för personligt bruk eller för överföring på ett olämpligt sätt, visa en skärm, lägga till övervakningskomponenter osv.)<br>- <strong>Programvara</strong>, används olämpligt, observeras eller ändras (höjning av privilegier, insamling av konfigurationsdata, installation av fjärrskrivbord, etc.)<br>- <strong>Nätverk</strong> Övervakning av nät (avlyssning av nättrafik, etc.)<br>- <strong>Människor</strong>, avlyssnade, manipulerade eller illojala (ofrivilligt avslöjande, som ett resultat av påtryckningar eller genom nätfiske, byte av arbetsgivare, etc.)<br>- <strong>Pappersdokumentation</strong>, illegalt inhämtad eller förlorad (fotokopiering, glömd utskrift, dokument till återvinning, e-poststöld osv.)<br>- <strong>Postgång</strong> illegalt inhämtad information under postgången",
			name: "Hot som kan leda till olaglig tillgång till data",
			source: "Källa saknas"
		},
		PIA_DEF_MENI: {
			description: "<strong>Hot: </strong><br>- <strong></strong> Utrustning: felaktigt använd, överbelastad, modifierad, försämrad, förlorad (fulla lagringsmedia, DOS-attack, förändring som leder till avbrott, brand, stöld eller förlust, etc.)<br>- <strong></strong> Programvara: felaktigt använd, överbelastad, förändrad, försämrad, förlorad (radering av data, datainmatning, logikfel, ej förnyad licens, etc.)<br>- <strong>Datornätverk</strong> : överbelastat, försämrat, förlorat (obehörig nedladdning, avbruten internetåtkomst, etc.)<br>- <strong>Människor</strong> : överbelastad, försämrad, förlorad (missbruk av kompetens, sjukfrånvaro, avslutad anställning, etc.)<br>- <strong>Pappersdokument</strong> : felaktigt använda, skadade, förlorade (radering, förstörelse, stöld eller förlust, etc.)<br>- <strong>Postgång</strong> : försämrad, ändrad, förlorad (poststrejk, byte av lokaler, förlust av dokument, omorganisation, etc.)",
			name: "Hot som kan leda till att data inte är tillgängliga",
			source: "Källa saknas"
		},
		PIA_DEF_MENM: {
			description: "<strong>Hot mot: </strong><br>- <strong>Hårdvara</strong> hårdvara som har modifierats (nya icke kompatibla komponenter, avlägsnande av en väsentlig komponent, etc.)<br>- <strong>Programvara</strong> Felaktigt använd eller modifierad (hantering av störningar, olämpliga förändingar, etc.)<br>- <strong>Nätverk</strong> som används felaktigt (avlyssnat , etc.)<br>- <strong>Människor</strong> överarbetade eller manipulerade (okontrollerad arbetsuppgift, störning av arbetsförhållanden, inflytande, etc.)<br>-Pappersdokument som har ändrats (manipulering av dokument, utbyte till förfalskning osv.)<br>- <strong>Postgång</strong> som har manipulerats (utbyte av dokument, skicka motstridiga dokument, etc.)",
			name: "Hot som kan leda till en oönskad ändring av personuppgifterna",
			source: "Källa saknas"
		},
		PIA_DEF_MES: {
			description: "Välj mellan de tillgängliga i avsnittet \"Befintliga eller planerade åtgärder\", som du kan utföra vid behov.",
			name: "Åtgärder",
			source: "Källa saknas"
		},
		PIA_DEF_MIN1: {
			description: "När du importerar data kan olika typer av metadata (till exempel EXIF-data som är kopplade till en bildfil) oavsiktligt samlas in.<br>Dessa metadata måste identifieras och tas bort om det inte är nödvändigt för de angivna syftena.",
			name: "Filtrering och radering",
			source: "Källa saknas"
		},
		PIA_DEF_MIN2: {
			description: "Efter inhämtning av känslig information, som bi-information till allmän information eller som överförts endast för statistiska ändamål, kan dessa konverteras till mindre känslig information eller pseudonymiseras. Till exempel:<br>- om systemet samlar in IP-adressen för att bestämma användarens plats för statistiska ändamål kan IP-adressen trunkeras efter informationen om stad eller stadsdel;<br>- Om systemet tar emot videodata från övervakningskameror där individer kan utskiljas så kan dessa göras suddiga;<br>- Om systemet är del av ett intelligent styrsystem i ett hem kan man välja att aggregera data i stället för att registrera den i realtid.",
			name: "Minimering genom förändring",
			source: "Källa saknas"
		},
		PIA_DEF_MIN3: {
			description: "Systemet kan säkerställa att:<br>- Användaren kan använda en resurs eller tjänst utan risk för att avslöja sin identitet (anonymiserad data);<br>- Användaren kan använda en resurs eller tjänst utan att avslöja sin identitet, men förblir spårbar och ansvarig för denna användning (pseudonymiserad data);<br>- Användaren kan använda resurser eller tjänster upprepade gånger utan risk att dessa tillfällen kan kopplas samman (ingen ackumulerad data);<br>- Användaren kan använda en resurs eller tjänst utan risk för att andra, särskilt tredje parter, kan se att resursen eller tjänsten används (icke-observerbarhet).<br>Valet av en metod från listan ovan måste bero på de identifierade hoten. För vissa typer av integritetshot är pseudonymisering lämpligare än anonymisering (till exempel om det finns ett behov av spårbarhet). Dessutom kommer vissa integritetshot att hanteras genom en kombination av flera metoder.",
			name: "Minskning personuppgifternas särkaraktär",
			source: "Källa saknas"
		},
		PIA_DEF_MIN4: {
			description: "Systemet kan struktureras i oberoende delar med separata åtkomstkontrollfunktioner. Uppgifterna kan också distribueras mellan dessa oberoende delsystem och kontrolleras av varje delsystem med hjälp av olika åtkomstkontrollmekanismer. Om ett delsystem äventyras kan därmed negativ påverkan på övergripande data reduceras.",
			name: "Minskning av dataackumulering",
			source: "Källa saknas"
		},
		PIA_DEF_MIN5: {
			description: "Systemet kan begränsa tillgången till data enligt principen \"behov att veta\". Systemet kan separera känslig information och tillämpa specifika åtkomstkontrollpolicyer.<br>Systemet kan också kryptera känslig information för att skydda konfidentialiteten under överföring och lagring. Tillgång till temporära dolda filer som uppstår under databehandling bör också skyddas.",
			name: "Begränsning av åtkomst till data",
			source: "Källa saknas"
		},
		PIA_DEF_MINC: {
			description: "Minska allvarligheten av riskerna genom att begränsa insamlingen av personuppgifter till det som är absolut nödvändigt för ett definierat syfte; undvika insamling av onödiga uppgifter, användning av data som inte är relaterade till syftet och som riskerar onödiga konsekvenser för individer.",
			name: "Minimera mängden av personuppgifter",
			source: "Källa saknas"
		},
		PIA_DEF_MIND: {
			description: "Minska riskernas allvarlighetsgrad genom att minimera själva personuppgifterna, genom åtgärder för att minska deras känslighet, till exempel filtrering och borttagning av onödiga data, pseudonymisering av data etc.",
			name: "Minimering av personuppgifterna",
			source: "Källa saknas"
		},
		PIA_DEF_OPP: {
			description: "Den registrerade ska, av skäl som hänför sig till hans eller hennes specifika situation, ha rätt att när som helst göra invändningar mot behandling av personuppgifter avseende honom eller henne i enlighet med<a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:32016R0679&rid=1\">artikel 21 i [ADSF/GDPR]</a>.",
			name: "Rätt att göra invändningar",
			source: "ADSF/GDPR Art. 21"
		},
		PIA_DEF_PBDS: {
			description: "Åtgärder för att ta hänsyn till skyddet av personuppgifter redan i utformningen av ny behandling (certifiering, erkända uppförandekoder, PIA, Privacu by design eller en intern metod, etc.), inklusive: <br> - Använd riskhanteringsmetoden PIA/DPIA så snart en tjänst eller applikation har utvecklats. <br> - Etablera IT-certifieringar (för processer, produkter, ledningssystem, organisationer, personer, etc.). <br> - Använd beprövade och accepterade uppförandekoder och standarder.",
			name: "Projektledning",
			source: "Källa saknas"
		},
		PIA_DEF_PC: {
			description: "Person vars personuppgifter behandlas.",
			name: "Den registrerade",
			source: "Källa saknas"
		},
		PIA_DEF_PORT: {
			description: "Den registrerade ska ha rätt att få ut de personuppgifter som rör honom eller henne och som han eller hon har tillhandahållit den personuppgiftsansvarige i ett strukturerat, allmänt använt och maskinläsbart format och ha rätt att överföra dessa uppgifter till en annan personuppgiftsansvarig utan att den personuppgiftsansvarige som tillhandahållits personuppgifterna hindrar detta under de villkor som beskrivs i<a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:32016R0679&rid=1\">Artikel 20 i [ADSF/GDPR]</a>.",
			name: "Rätt till dataportabilitet",
			source: "ADSF/GDPR Art. 20"
		},
		PIA_DEF_PSEU: {
			description: "Behandling av personuppgifter på ett sätt som innebär att personuppgifterna inte längre kan tillskrivas en specifik registrerad utan att kompletterande uppgifter används, under förutsättning att dessa kompletterande uppgifter förvaras separat och är föremål för tekniska och organisatoriska åtgärder som säkerställer att personuppgifterna inte tillskrivs en identifierad eller identifierbar fysisk person.<br>Pseudonymisering reducerar risken för att koppla en uppsättning data till den registrerades ursprungliga identitet; som sådan är <strong>en användbar säkerhetsåtgärd, men inte en metod för anonymisering.</strong>",
			name: "Pseudonymisering",
			source: "ADSF/GDPR Art. 4.5"
		},
		PIA_DEF_PWD: {
			description: "Autentisering med hjälp av hemliga användarnamn och lösenord ett enkelt och billigt sätt att kontrollera åtkomst. Men denna autentiseringsmetod har en låg säkerhetsnivå. <br> Minimikrav vad gäller lösenordets längd och komplexitet beror på de ytterligare åtgärder som genomförs för att göra autentiseringsprocessen mer pålitlig: <br> Om autentisering enbart är baserat på ett lösenord, betyder detta åtminstone användning av ett komplext lösenord med minst 12 tecken som består av stora bokstäver, siffror och specialtecken. Ytterligare åtgärder för att ange ett lösenord (begränsningar av åtkomst, inkludering av annan information, kontakt med helpdesk för inloggning etc.) kan minska kravet på lösenordets längd och komplexitet då de säkerställer en säkerhetsnivå som motsvarar ett lösenord.",
			name: "Lösenord",
			source: "Källa saknas"
		},
		PIA_DEF_RECT: {
			description: "Den registrerade ska ha rätt att av den personuppgiftsansvarige utan onödigt dröjsmål få felaktiga personuppgifter som rör honom eller henne rättade. <br>Med beaktande av ändamålet med behandlingen, ska den registrerade ha rätt att komplettera ofullständiga personuppgifter, bland annat genom att tillhandahålla ett kompletterande utlåtande.",
			name: "Rätt till rättelse",
			source: "ADSF/GDPR Art. 16"
		},
		PIA_DEF_RGPD: {
			description: "Förordning om skydd för fysiska personer med avseende på behandling av personuppgifter och om det fria flödet av sådana uppgifter. (<a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:32016R0679&rid=1\">EU 2016-679</a>), antagen den 27 april 2016 av Europeiska unionen. Den träder i kraft den 25/05/2018 och upphäver direktiv 95/46 / EG.",
			name: "ADSF (allmän Dataskyddsförordning, GDPR)",
			source: "ADSF/GDPR titel"
		},
		PIA_DEF_RT: {
			description: "En fysisk eller juridisk person, offentlig myndighet, institution eller annat organ som ensamt eller tillsammans med andra bestämmer ändamålen och medlen för behandlingen av personuppgifter; om ändamålen och medlen för behandlingen bestäms av  unionsrätten eller medlemsstaternas nationella rätt kan  den personuppgiftsansvarige  eller de särskilda kriterierna  för hur denne ska  utses  föreskrivas i unionsrätten eller i medlemsstaternas nationella rätt.<br>För mer information om personuppgiftsansvarigs skyldigheter, se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/PDF/?uri=CELEX:32016R0679&rid=1\">kap. 4 av [ADSF/GDPR]</a>",
			name: "Personuppgiftsansvarig",
			source: "ADSF/GDPR Art. 4.7"
		},
		PIA_DEF_SRC: {
			description: "Person, intern eller extern för organisationen, som agerar oavsiktligt eller avsiktligt (ex: IT-administratör, användare, extern angripare, konkurrent) eller icke-mänsklig källa (t.ex. vatten, farliga material, datavirus), kan vara en riskkälla.",
			name: "Riskkälla",
			source: "Källa saknas"
		},
		PIA_DEF_ST: {
			description: "Personuppgiftsbiträde är en fysisk eller juridisk person, offentlig myndighet, institution eller annat organ som behandlar personuppgifter för den personuppgiftsansvariges räkning <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Artikel 4.8 i ADSF/GDPR</a>. <br>Personuppgiftsbiträdet och personer som utför arbete under den personuppgiftsansvariges eller personuppgiftsbiträdets överinseende, och som får tillgång till personuppgifter, får endast behandla dessa på instruktion från den personuppgift­ sansvarige, såvida han eller hon inte är skyldig att göra det enligt unionsrätten eller medlemsstaternas nationella rätt.\n <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Artikel 29 i ADSF/GDPR</a>.",
			name: "Personuppgiftsbiträde",
			source: "ADSF/GDPR Art. 4.8 och Art. 29"
		},
		PIA_DEF_SUPT: {
			description: "<strong>Hårdvara och lagringsmedia</strong> : datorer, routrar, USB-minnen, hårddiskar...<br><strong></strong> Programvara: operativsystem, meddelandesystem, databaser, affärsprogram...<br><strong></strong> Nätverk: kablar, WiFi, fiberoptik<br><br><strong>Personer</strong> : användare, IT-administratörer, beslutsfattare...<br><strong></strong> Tryckt media: utskrifter, fotokopior, handskrivna dokument...<br><strong>Postgång</strong> : utskick, attesteringsdokument...",
			name: "Bearbetningsaktiviteter",
			source: "Källa saknas"
		},
		PIA_DEF_VIOL: {
			description: "En säkerhetsincident som leder till oavsiktlig eller olaglig förstöring, förlust eller ändring eller till obehörigt röjande av eller obehörig åtkomst till de personuppgifter som överförts, lagrats eller på annat sätt behandlats",
			name: "Personuppgiftsincident",
			source: "ADSF/GDPR Art. 4.12"
		},
		PIA_DEF_VRA: {
			description: "Sannolikheten återspeglar möjligheten att en risk uppstår. Det beror främst på sårbarheten för de dataresurser som används i termer av hot och riskkällor.",
			name: "Sannolikhet",
			source: "Källa saknas"
		},
		PIA_EX_DC: {
			description: "Data från ett Scoringsystem, resultat från tillämpning av scoringpoäng ...",
			name: "Scoring"
		},
		PIA_EX_DCPC: {
			description: "<strong>Personuppgifter</strong> : civilstånd, ålder, nationalitet, dubbelt medborgarskap, postadress, rättslig förmåga ... <br><strong>Privatliv</strong> : partner, antal barn, bostadsort, typ av bostad, boendetid ... <br><strong>Yrkesliv</strong> : arbetsgivare, typ av anställning, anställningstid, arbetslöshet ... <br><strong>Anslutningsdata</strong> : IP-adress, händelseloggar ...<br><strong>Positionsdata</strong> : förflyttningar, GPS-data, GSM positionering. ..<br><strong>Annat</strong> : telefonnummer, e-postadress ...",
			name: "Normala personuppgifter",
			source: "Källa saknas"
		},
		PIA_EX_DCPR: {
			description: "Ras eller etniskt ursprung, politiska åsikter, religiös eller filosofisk övertygelse eller medlemskap i fackförening och behandling av genetiska uppgifter, biometriska uppgifter för att entydigt identifiera en fysisk person, uppgifter om hälsa eller uppgifter om en fysisk persons sexualliv eller sexuella läggning samt behandling av personuppgifter som rör fällande domar i brottmål och överträdelser eller därmed sammanhängande säkerhetsåtgärder<br>Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art. 9</a> <br> och <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art.10</a> av [ADSF/GDPR]",
			name: "Brottshistorik och särskilda kategorier av personuppgifter"
		},
		PIA_EX_DCPS: {
			description: "Personnummer, biometriska uppgifter, bankuppgifter ...",
			name: "Särskilda kategorier av personuppgifter"
		},
		PIA_EX_HUME: {
			description: "Detta kan vara: <br> - en skadlig eller okunnig tredje part som använder sin fysiska närhet för att illegalt få åtkomst till tjänsten.<br> - en angripare, som med specifik kunskap om personen, riktar sig mot en enskild användare för att ta sig in i systemet <br > - en angripare som attackerar ett personuppgiftsbiträde för att få tag på personuppgifter eller skada den personuppgiftsansvariges rykte. <br> - en tredje part som har behörig tillgång, men använder den för andra syften t.ex. utnyttjar information de inte har behörighet till. <br> Motiven kan vara olika: <br> spänning, irritation, ondska, hämnd, spionage, girighet eller att utnyttja personuppgifter för annat syfte.",
			name: "Extern mänsklig riskkälla"
		},
		PIA_EX_HUMI: {
			description: "Det kan vara: <br> - en illvillig eller försumlig anställd som använder sin åtkomst till systemet, använder sina kunskaper, systemrättigheter och tid eller helt enkelt är försumlig på grund av bristande utbildning och förståelse <br>- en illvillig eller försumlig användare eller någon i dennes omgivning som får tillgång till personuppgifterna. <br> Skälen kan variera: oskicklighet, misstag, försumlighet, hämnd, illvilja, girighet, spionage.",
			name: "Intern mänsklig riskkälla"
		},
		PIA_EX_IMPI: {
			description: "De registrerade kan få betydande konsekvenser som de bör kunna övervinna, om än med verkliga och allvarliga svårigheter. Till exempel: <br> - fysisk: allvarliga fysiska sjukdomar som orsakar långvarig skada (försämring av hälsan på grund av felaktig vård, eller att man bortsett från kontraindikationer), förlust av fysisk integritet till exempel efter ett övergrepp, en olycka hemma, arbete, etc. . <br> - materiella: felanvändning av pengar som inte kompenseras, missade riktade eller unika erbjudanden eller engångserbjudanden, förlorade möjligheter (bostadslån, förlorad studieplats, missad praktik eller anställning, missat examenstillfälle), bostadsförlust, förlust av anställning osv .; <br> - psykiska: allvarliga psykologiska problem (depression, fobiutveckling), känsla av kränkt privatliv med oåterkallelig skada, utsatt för utpressning, cybermobbning och trakasserier, etc.",
			name: "Allvarlig konsekvens"
		},
		PIA_EX_IMPL: {
			description: "De registrerade kan uppleva betydande besvär, som de kommer att kunna övervinna trots vissa svårigheter<br>Exempel på effekter:<br>- fysiskt: mindre fysiska besvär (t.ex.: mild sjukdom efter att inte kontraindikationer respekterats), förtal som orsakar fysiska repressalier etc.<br>- materiella: felaktiga betalningar (t.ex. felaktiga böter), nekande av tillgång till administrativa eller kommersiella tjänster, riktad online-annonsering som kränker personens privatliv , etc.<br>- psykiska: mindre men uppenbara psykologiska obehag, känsla av kränkt integritet utan irreparabel skada, hot mot sociala nätverk, etc.",
			name: "Begränsad konsekvens"
		},
		PIA_EX_IMPM: {
			description: "Den registrerade kan uppleva betydande, till och med oåterkalleliga, konsekvenser som de inte kan hantera<br>Exempel på påverkan:<br>- fysiska: långvarigt eller permanent fysisk skada, permanent försämring av fysisk integritet, död<br>- materiella: ekonomisk risk, oöverkomliga skulder, oförmåga att flytta, förlust av bevis i tvister, förlust av tillgång till vital infrastruktur (vatten, el), etc.<br>- psykiska: långvarigt eller permanent psykiskt lidande, straffrättslig påföljd, kidnappning, förlust av familjeband, hinder att gå till domstol, ändring av civilstatus och / eller förlust av laglig autonomi (vårdnad, omyndigförklarad) etc.",
			name: "Maximal konsekvens"
		},
		PIA_EX_IMPN: {
			description: "Den registrerade kommer inte att påverkas eller kan uppleva vissa besvär som de kommer att kunna hantera utan svårigheter.<br>Exempel på effekter:<br>- Fysisk: tillfällig stress eller huvudvärk<br>- Materiella: Onödig väntetid eller att man tvingas skriva in samma data igen för att få tillgång till konsumtionsprodukter osv.,<br>- Psykiska: lätt irritation, känsla av intrång i privatlivet utan verklig skada (kommersiell intrång), etc.",
			name: "Obetydlig konsekvens"
		},
		PIA_EX_NHUM: {
			description: "Det kan vara en incident eller en katastrof som sker i någon av de organisationer som ansvarar för behandlingen (strömavbrott, brand, översvämning etc.)",
			name: "Icke-mänsklig riskkälla"
		},
		PIA_EX_VRAI: {
			description: "För de valda riskkällorna verkar det vara möjligt att orsaka skada på den berörda personen (till exempel genom stöld av pappersdokument lagrade på kontor för en organisation där dessa kontrolleras av en person i receptionen).",
			name: "Betydande sannolikhet"
		},
		PIA_EX_VRAL: {
			description: "För de valda riskkällorna verkar det svårt att skada den registrerade (t.ex. stöld av pappersdokument från ett rum vars åtkomst är skyddad med kortläsare).",
			name: "Begränsad sannolikhet"
		},
		PIA_EX_VRAM: {
			description: "Dessa risker kommer med mycket stor sannolikhet att inträffa och drabba den registrerade (till exempel att pappersdokument lagrade i den offentliga lobbyn blir stulna).",
			name: "Maximal sannolikhet"
		},
		PIA_EX_VRAN: {
			description: "Det är inte sannolikt att valda riskkällor skulle kunna inträffa och utgöra ett hot mot den registrerade (t.ex.: stöld av pappersmedia lagrat i en lokal vars åtkomst styrs av passerkort och kod).",
			name: "Obetydlig sannolikhet"
		},
		PIA_LGL_CONS: {
			description: "TO TRANSLATE - Allow data subjects to make a free, specific and informed choice. Determine whether the processing relies on a legal basis other than consent pursuant to Art. 6 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Inhämtande av samtycke",
			source: "Källa saknas"
		},
		PIA_LGL_DATA: {
			description: "Definiera och beskriv personuppgifterna i detalj: <br> - vilka personuppgifter som hanteras, vem som hanterar dem och dess lagringsperiod;<br> - en beskrivning av processer och datahantering för hela datalivscykeln (från insamling till radering).",
			name: "Personuppgifter som behandlas",
			source: "Källa saknas"
		},
		PIA_LGL_DESC: {
			description: "Beskriv den berörda behandlingen, syfte och skäl på ett syntetiskt sätt. Identifiera personuppgiftsansvarig och eventuella personuppgiftsbiträden.  Identifiera de eventuella standarder som tillämpas eller planeras tillämpas på behandling , särskilt de godkända uppförandekoderna<br>se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art. 40 i [ADSF/GDPR]</a>) <br>och dataskyddscertifieringar (se <a target=\"_blank\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art. 42 i [ADSF/GDPR]</a>).",
			name: "Behandlingsbeskrivning",
			source: "Källa saknas"
		},
		PIA_LGL_DEST: {
			description: "En fysisk eller juridisk person, offentlig myndighet, institution eller annat organ till vilket personupp­gifterna utlämnas, vare sig det är en tredje part eller inte; offentliga myndigheter som kan komma att motta personuppgifter inom ramen för ett särskilt uppdrag i enlighet med unionsrätten eller medlemsstaternas nationella rätt ska dock inte betraktas som mottagare; offentliga myndigheters behandling av dessa uppgifter ska vara förenlig med tillämpliga bestämmelser för dataskydd beroende på behandlingens syfte. Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art. 4,9 av [ADSF/GDPR]</a>",
			name: "Mottagare",
			source: "ASDF/GDPR Art. 4.9"
		},
		PIA_LGL_DUR: {
			description: "För varje typ av personuppgift måste en lagringsperiod definieras och motiveras av lagkrav och/eller bearbetningskrav. En åtskillnad görs mellan aktivt använda personuppgifter och arkiverade personuppgifter. Tillträde till det senare måste begränsas till en liten krets av behöriga personer. En gallringsmekanism måste implementeras för att arkivera aktiva personuppgifter eller radera arkiverade personuppgifter i slutet av den definierade lagringsperioden. Alla spår av personuppgifterna måste raderas liksom loggar vilka inte heller får lagras på obestämd tid.",
			name: "Datalagringsperiod",
			source: "Källa saknas"
		},
		PIA_LGL_FIN: {
			description: "Personuppgifter ska samlas in för särskilda, uttryckligt angivna och berättigade ändamål och <strong>inte senare behandlas på ett sätt som är oförenligt med dessa ändamål</strong>; <br> Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art. 5.1 b) i [ADSF/GDPR]</a>",
			name: "Principer för behandling av personuppgifter",
			source: "ADSF/GDPR Art. 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- Den registrerade har lämnat sitt samtycke till att dennes personuppgifter behandlas för ett eller flera specifika ändamål. <br> - Behandlingen är nödvändig för att fullgöra ett avtal i vilket den registrerade är part eller för att vidta åtgärder på begäran av den registrerade innan ett sådant avtal ingås. <br> - Behandlingen är nödvändig för att fullgöra en rättslig förpliktelse som åvilar den personuppgiftsansvarige. <br> - Behandlingen är nödvändig för att skydda intressen som är av grundläggande betydelse för den registrerade eller för en annan fysisk person. <br> - Behandlingen är nödvändig för att utföra en uppgift av allmänt intresse eller som ett led i den personuppgiftsan­ svariges myndighetsutövning. <br> - Behandlingen är nödvändig för ändamål som rör den personuppgiftsansvariges eller en tredje parts berättigade intressen, om inte den registrerades intressen eller grundläggande rättigheter och friheter väger tyngre och kräver skydd av personuppgifter, särskilt när den registrerade är ett barn. Se<a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art. 6 av [ADSF/GDPR]</a>",
			name: "Laglig behandling av personuppgifter",
			source: "ADSF/GDPR Art.6"
		},
		PIA_LGL_INFO: {
			description: "Se till att den registrerade blir informerad. Se även till att behandlingen inte omfattas av ett legalt undantag och inte omfattas av några speciella villkor.",
			name: "Information till den registrerade",
			source: "Källa saknas"
		},
		PIA_LGL_MINI: {
			description: "Syftet är att minska riskernas allvarlighetsgrad genom att begränsa insamlingen av personuppgifter till det minimum som är nödvändigt för behandlingen. Undvika insamling av onödiga personuppgifter eller användning av personuppgifter som inte är nödvändiga för behandlingen eller riskerar allt för stora konsekvenser för den registrerade.",
			name: "Dataminimering",
			source: "Källa saknas"
		},
		PIA_LGL_ST: {
			description: "Ett biträdesavtal måste tecknas med varje personuppgiftsbiträde som skall innefatta allt som beskrivs i Art. 28 i ADSF/GDPR: varaktighet, omfattning, syfte, behandlingsinstruktioner, godkännandeprocess vid anlitande av ett underbiträde, tillhandahållande av all dokumentation som visar att ADSF/GDPR följs, att alla incidenter blir rapporterade etc.",
			name: "Personuppgiftsbiträden",
			source: "Källa saknas"
		},
		PIA_LGL_SUPT: {
			description: "Aktiviteter och utrustning som stöder behandlingen av personuppgifter. Det kan vara hårdvara, programvara, nätverk, personer, pappersmedia eller överföring av papper.",
			name: "Understödjande informationsaktiviteter",
			source: "Källa saknas"
		},
		PIA_LGL_TRAN: {
			description: "Specificera den geografiska placeringen av lagring och behandling av de olika personuppgifterna. Beroende av vilket land det gäller måste du motivera valet av lagring/behandling utanför Europeiska unionen och ange vilka rättsliga ramverk som säkerställer ett adekvat skydd för de personuppgifter som överförs. <br> Exempelvis.: <br> -till ett EU-land <br> -till ett land som erkänts som adekvat av Europeiska unionen <br> -till ett Amerikanskt företag som är godkänt enligt Privacy Shield- <br>- till tredjeländer eller internationella organisationer <br> i enlighet med <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Artiklarna 44 – 49 i [ADSF/GDPR]</a>",
			name: "Överföring av personupplysningar",
			source: "https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679 Art. 44-49"
		},
		PIA_METHOD_MES: {
			description: "Existerande åtgärder är de som planerades före utvärderarens PIA/konsekvensanalys. De planerade eller korrigerade åtgärderna som utvärderaren rekommenderar kommer att anges i handlingsplanen och möjliggör en andra/justerad bedömning av allvarlighetsgraden och sannolikheten.",
			name: "Planerade och existerande åtgärder",
			source: "Källa saknas"
		},
		PIA_ORG_AUD: {
			description: "Förekomst av rutiner och tillsyn för att ge en övergripande och aktuell uppfattning om dataskyddet och efterlevnaden av ADSF/GDPR (kontrollera att behandlingar överensstämmer med ADSF/GDPR, måluppfyllnad och riskindikatorer, ansvar etc.).",
			name: "Rutiner och tillsyn av integritetsskyddande åtgärder",
			placeholder: "Beskriv här de processer som säkerställer regelbundna rutiner och tillsyn av personuppgiftsbehandlingen.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Förekomst av ett förfarande för att minska riskerna som den berättigade åtkomsten till informationen av tredjeparter kan innebära för de registrerade personernas friheter och privatliv (identifiering av tredjeparter, personuppgiftsbiträdesavtal, existerande konventioner, BCR, etc.) .",
			name: "Hantering av tredje parter som har tillgång till personuppgifterna.",
			placeholder: "Ange här skälen till att tredjepart har fått tillgång till personuppgifter, villkoren och säkerhetsåtgärderna som har genomförts kring dessa åtkomster.",
			source: "Källa saknas"
		},
		PIA_ORG_ORG: {
			description: "Beskriv den organisation som styr och kontrollerar skyddet för personuppgifter inom organisationen (utnämnande av en DSO, CIO, skapande av en ADSF/GDPR-förvaltningsorganisation, etc.).",
			name: "Dataskyddsorganisation",
			placeholder: "Beskriv roll- och ansvarsstruktur gällande att hantera integritetsfrågor i din organisation.",
			source: "Källa saknas"
		},
		PIA_ORG_PBD: {
			description: "Beskriver de metoder som används för att garantera skyddet av personuppgifter i all ny behandling (cerifieringar, standarder, konsekvensanalys för den registrerade eller intern metod, etc.).",
			name: "Inbyggd integritet (Privacy by design and default)",
			placeholder: "Beskriv här de metoder som används för att garantera personuppgifters integritet i ett nytt projekt.",
			source: "Källa saknas"
		},
		PIA_ORG_PERS: {
			description: "Befintliga regler om utbildning och <strong> medvetenhet </ strong> för nyanställda i början av sin anställning/funktion och för personer som haft tillgång till personuppgifter när de lämnade organisationen </strong>.",
			name: "Aktiviteter för att öka medvetenheten",
			placeholder: "Ange här vilka medvetandehöjande aktiviteter kring ADSF/GDPR som genomförts med de anställda.",
			source: "Källa saknas"
		},
		PIA_ORG_POL: {
			description: "Den personuppgiftsansvarige måste ha en dokumentbas som definierar vilka integritetspolisys och riktlinjer som ska tillämpas inom området \"Dataskydd\" (handlingsplan, regelbunden översyn av integritetspolicy och riktlinjer, etc.).",
			name: "Integritetspolicy och riktlinjer",
			placeholder: "Beskriv er dokumentation kring integritetspolicys och riktlinjer.",
			source: "Källa saknas"
		},
		PIA_ORG_RMGT: {
			description: "Befintliga regler och förfaranden för att hantera de risker som organisationens behandling av de registrerades personuppgifter utsätter deras rättigheter och friheter för (identifiering av behandlingsmetoder, bearbetningsdata, driftsresurser, riskbedömning, identifiering av befintliga eller planerade åtgärder etc.).",
			name: "Hantera risker",
			placeholder: "Beskriv processerna för att hantera de risker som organisationens integritetspolicy och riktlinjer beskriver.",
			source: "Källa saknas"
		},
		PIA_ORG_VIOL: {
			description: "Förekomsten av en process för att upptäcka och hantera händelser som kan påverka de registrerades friheter och integritet (definition av ansvar, åtgärdsplan, karakterisera kränkningar, etc.).",
			name: "Hantera personuppgiftsincidenter och dataöverträdelser",
			placeholder: "Beskriv de operativa processer som finns för att upptäcka och hantera dataintrång",
			source: "Källa saknas"
		},
		PIA_SEC_BKP: {
			description: "Förekomst av en säkerhetskopieringsrutin/back-uprutin för att säkerställa tillgänglighet och/eller personuppgifternas integritet, samtidigt som de skyddar deras konfidentialitet (regelbundenhet för säkerhetskopior, kryptering av dataöverföringskanal/nätverk, integritetstest, etc.). ).",
			name: "Säkerhetskopiering",
			placeholder: "Ange här hur säkerhetskopior/back-uper hanteras och underhålls.",
			source: "Källa saknas"
		},
		PIA_SEC_COMP: {
			description: "Åtgärder som vidtas för att minska möjligheten att mjukvaror (operativsystem, affärsapplikationer, kontorsprogram, inställningar etc.) kan utnyttjas för att skada personuppgifter (mjukvaruuppdateringar, fysiskt skydd och åtkomstkontroll, arbete på ett krypterat nätverk, integritetskontroller, loggning, etc.).",
			name: "Arbetsstationshantering",
			placeholder: "Beskriv här de åtgärder som vidtagits för att minska risken för attacker mot mjukvara som används vid behandlingen.",
			source: "Källa saknas"
		},
		PIA_SEC_CTR: {
			description: "Personuppgifter som överförs till eller hanteras av personuppgiftsbiträdet måste omgärdas av tillräckliga garantier. Detta kräver ett personuppgiftsbiträdesavtal. <Strong> Använd bara personuppgiftsbiträden med tillräcklig tillförlitlighet </strong> (särskilt när det gäller expertis, tillförlitlighet och resurser). Personuppgiftsansvarigs säkerhetspolicy och personuppgiftspolicy skall delges personuppgiftsbiträdet. <br> Dokumentera planerade åtgärder (säkerhetsrevisioner, anläggningsbesök, etc.) för att säkerställa att överenskomna åtgärder utförs </strong> i enlighet med personuppgiftsbiträdets utfästelser. Dessa åtgärder inkluderar: <br> - kryptering av data i förhållande till deras känslighet eller, om detta inte är fallet, förekomsten av förfaranden för att säkerställa att personuppgiftsbiträdet inte har tillgång till de uppgifter som de behandlar, <br> - krypteringen av överföringar av data (t.ex.: HTTPS-anslutning, VPN, etc.) <br> - Garantier för nätverksintegritet, spårbarhet (protokoll, revisioner), godkännandehantering, autentisering etc. <strong> Tillhandahållande av ett personuppgiftsbiträdesavtal </ som klargör förhållandet mellan parterna, varaktigheten, syftet med behandlingen och skyldigheter. Se särskilt till att det innehåller bestämmelser som inkluderar: <br> - skyldighet att upprätthålla sekretess för personuppgifter som har anförtrotts. - - minimikrav för användarautentisering <br> - villkoren för återlämnande av personuppgifter och/eller dess gallring / Radera personuppgifter vid kontraktsslut <br> - reglerna för hantering och anmälan av incidenter för personuppgifter. Dessa bör innehålla vilken information som skall lämnas till den personuppgiftsansvarige i händelse av en personuppgiftsincident eller ett personuppgiftsbrott, samt att det sker i omedelbar anslutning till ett intrång. <br> - När du använder en molnleverantör: <br> 1. Tydligt definiera vilka personuppgifter och vilken behandling som ska läggas ut till molnet; <br> 2. Definiera dina egna tekniska och juridiska säkerhetskrav; <br> 3. Genomföra en riskstudie för att identifiera lämpliga säkerhetsåtgärder; <br> 4. Identifiera relevant typ av moln för avsedd bearbetning; <br> 5. Välj en leverantör med tillräckliga garantier; <br> 6. Granska intern säkerhetspolicy; <br> 7. Kontinuerligt övervaka förändringar under drift.",
			name: "Personuppgiftsbiträdesavtal",
			placeholder: "Beskriv här innehållet i personuppgiftsbiträdesavtalet, i det fall ett biträde används.",
			source: "Källa saknas"
		},
		PIA_SEC_EXP: {
			description: "Riktlinjer för att begränsa sannolikheten för risker för utrustning (dokumentation av driftsförfaranden, inventering och uppdatering av programvara och hårdvara, åtgärder mot säkerhetsproblem, redundans av data, begränsning av fysisk tillgång till servrar, etc.).",
			name: "Driftssäkerhet",
			placeholder: "Beskriv här de metoder som har implementerats för att garantera säkerhetsnivån för den använda programvaran.",
			source: "Källa saknas"
		},
		PIA_SEC_LOG: {
			description: "Förekomst av åtgärder som vidtagits för att tidigt kunna upptäcka incidenter rörande personuppgifter och att kunna dokumentera dem för att analysera dem eller för att tillhandahålla bevis i samband med utredningar (arkitektur och loggningsrutiner, efterlevnad av skyldigheter angående skydd av personuppgifter, etc.).",
			name: "Spårbarhet",
			placeholder: "Beskriv här de åtgärder som vidtagits för att kunna upptäcka incidenter rörande personuppgifter.",
			source: "Källa saknas"
		},
		PIA_SEC_MAIN: {
			description: "Förekomst av en policy för fysiskt underhåll av utrustningen, som specificerar om/hur underleverantörer kan användas.<br>Det bör innehålla regler för fjärrskrivbord, om det är godkänt samt specificera metoderna för hantering av kasserat material.",
			name: "Underhåll",
			placeholder: "Beskriv här hur det fysiska underhållet av utrustningen hanteras.",
			source: "Källa saknas"
		},
		PIA_SEC_MAL: {
			description: "Åtgärder för att skydda tillgången till offentliga (Internet) eller okontrollerade (partner) nätverk, samt arbetsstationer och servrar mot skadlig kod som kan påverka säkerheten för personuppgifter.",
			name: "Bekämpa skadlig programvara",
			placeholder: "Beskriv här skyddsåtgärderna mot skadlig kod vid åtkomst till nätverk med lägre säkerhetsnivå.",
			source: "Källa saknas"
		},
		PIA_SEC_MAT: {
			description: "Förekomst av åtgärder som vidtas för att minska möjligheten att utrustningens egenskaper (servrar, fasta arbetsstationer, bärbara datorer, kringutrustning, routrar, accesspunkter, flyttbara media etc.) utnyttjas för att skada personuppgifter (inventering, avdelning, redundans) hårdvara, begränsa åtkomst, etc.).",
			name: "Hårdvarusäkerhet",
			placeholder: "Beskriv här de metoder och medel som används för att begränsa riskerna för attacker mot utrustningen som används i behandlingen.",
			source: "Källa saknas"
		},
		PIA_SEC_NET: {
			description: "Beroende på vilken typ av nätverk som behandlingen utförs på (isolerade, privata eller Internet), måste ansvarig använda adekvata skyddssystem: brandväggar, intrångsdetektering eller andra aktiva eller passiva metoder för att säkerställa nätverkets säkerhet.",
			name: "Nätverkssäkerhet",
			placeholder: "Ange här i vilken typ av nätverk behandlingen utförs och utrustningen som säkerställer dess integritet.",
			source: "Källa saknas"
		},
		PIA_SEC_PHY: {
			description: "Förekomst av en fysisk åtkomstkontroll till lokalerna där behandlingen utförs (zonindelning, övervakade besök, identifierande kläder eller ID-brickor, låsta dörrar etc.).<br>Ange om det finns några inbrottsalarm.",
			name: "Fysisk åtkomstkontroll",
			placeholder: "Ange här hur fysisk åtkomstkontroll utförs i lokalerna där behandlingen utförs.",
			source: "Källa saknas"
		},
		PIA_SEC_PROT: {
			description: "Förekomst av åtgärder för att minska eller undvika risker relaterade till icke-mänskliga källor (klimatfenomen, brand, vattenskador, inre eller yttre olyckor, djur etc.) som kan påverka säkerheten för personuppgifter (förebyggande åtgärder, möjlighet till upptäckt, skydd, etc.).",
			name: "Skydd mot icke-mänskliga riskkällor",
			placeholder: "Beskriv här de åtgärder som vidtas för att minska eller undvika risker relaterade till icke-mänskliga källor.",
			source: "Källa saknas"
		},
		PIA_SEC_SRC: {
			description: "Förekomsten av åtgärder för att förhindra mänskliga eller icke-mänskliga riskkällor för skydd av personuppgifter (farliga produkter, farliga geografiska områden, dataöverföring utanför EU, etc.).",
			name: "Undvikande av riskkällor",
			placeholder: "Beskriv vilka metoder och medel som används för att undvika riskkällor.",
			source: "Källa saknas"
		},
		PIA_SEC_WEB: {
			description: "Använda metoder och medel för att minska möjligheten att webbplatsen utnyttjas för att kränka personuppgifter (allmänna säkerhetsrutiner, SSL-kryptering, cookiepolicy, säkerhetsuppdateringar, etc.) .",
			name: "Skydd av webbplatsen",
			placeholder: "Beskriv här de metoder och medel som används för att skydda webbplatserna.",
			source: "Svensk källa saknas"
		},
		PIA_TEC_ANO: {
			description: "Beskriv mekanismerna för anonymisering, hur de är utformade och för vilket syfte de implementeras och hur de förhindrar eventuell återidentifiering. Observera skillnaden mellan anonymisering och pseudonymisering",
			name: "Anonymisering",
			placeholder: "Beskriv här hur anonymisering har implementerats",
			source: "Svensk källa saknas"
		},
		PIA_TEC_ARCH: {
			description: "Beskriv lagringspolicyn såväl som processerna för att hantera arkiv som innehåller personuppgifter (leverans av data, lagring, åtkomsträttigheter, bortskaffande). Beskriv arkiveringens roll och rättsliga grunder samt säkerhetsåtgärder. Beskriv vid behov reglerna för inlämnande till statsarkiv.",
			name: "Arkivering",
			placeholder: "Här anges alla arkiverings/back-up metoder som används för bevarande och hantering av elektroniska arkiv som innehåller personuppgifter.",
			source: "Svensk källa saknas"
		},
		PIA_TEC_CHIF: {
			description: "Implementerade metoder för att <strong>säkerställa konfidentialiteten för</strong>personuppgifter lagrade (i databasen, i filer, i säkerhetskopior osv.) Samt hanteringsmetoder för krypteringsnycklarna (skapande, lagrande, ändringar i händelse av misstankar om kompromettering etc.). <br><br> Detaljbeskriv krypteringen som används för dataöverföring (VPN, TLS, etc.) som ingår i processen.",
			name: "Kryptering",
			placeholder: "Beskriv här krypteringsmetoder som implementerats för att säkerställa personuppgifternas konfidentialitet och integritet",
			source: "Svensk källa saknas"
		},
		PIA_TEC_CLO: {
			description: "Genomförande av dataseparering hjälper till att minska risken för att personuppgifter kombineras, vilket minskar risken för obehörig åtkomst till all lagrade personuppgifter",
			name: "Dataseparering",
			placeholder: "Ange här om en uppdelning av behandlingen i mindre separerade delar är planerad och hur den uppnås.",
			source: "Svensk källa saknas"
		},
		PIA_TEC_CTLA: {
			description: "Beskriv definitionen och tilldelningen av användarprofiler, dess roller och rättigheter. Var även vänlig att specificera de använda <strong> autentiseringsmetoderna </ strong> i detalj och, om applicerbart, ange  lösenordsregler (minimilängd, obligatorisk struktur, giltighetstid, antal misslyckade inloggningsförsök innan kontot låses, etc.).",
			name: "Logisk åtkomstkontroll",
			placeholder: "Ange här hur användarprofiler och rättigheter definieras och tilldelas.",
			source: "Svensk källa saknas"
		},
		PIA_TEC_LOG: {
			description: "Loggning och journalföringspolicy för behandlingar.",
			name: "Loggningsförfaranden",
			placeholder: "Ange här om behandlingarna är loggade och hur länge dessa loggar sparas.",
			source: "Svensk källa saknas"
		},
		PIA_TEC_MINI: {
			description: "Personuppgifternas känslighetsgrad kan minskas med följande metoder: filtrering och borttagning, minskning av känslighet genom transformation, minskning av datakaraktär, minskning av datainsamling, begränsning av datatillgång",
			name: "Dataminimering",
			placeholder: "Ange vilka åtgärder som har vidtagits för att minska riskernas allvarlighetsgrad genom att minimera personuppgifter.",
			source: "Svensk källa saknas"
		},
		PIA_TEC_PAP: {
			description: "TO TRANSLATE - Where paper documents containing data are used during the processing, indicate here how they are printed, stored, destroyed and exchanged.",
			name: "Säkerhet för hantering av  pappersdokument",
			placeholder: "Ange här procedurerna och livscykeln för pappersdokument som innehåller personuppgifter.",
			source: "Svensk källa saknas"
		},
		PIA_VAL_ACT: {
			description: "Handlingsplanen är listan över åtgärder, resurser och ansvar som PIAn föreslog i de tidigare stegen, som måste genomföras för att implementera de identifierade korrigerande åtgärderna. För varje åtgärd är det nödvändigt att namnge en ansvarig person och sätta tidsfrister.",
			name: "Handlingsplan",
			source: "Svensk källa saknas"
		},
		PIA_VAL_CART: {
			description: "Denna graf visar de risker som uppstår vid behandlingen och de återstående riskerna med beaktande av alla korrigerande åtgärder. Det visar att om de kompletterande åtgärderna som beskrivs i handlingsplanen genomförs på ett adekvat sätt kan sannolikheten och / eller allvarlighetsgraden för de återstående riskerna minskas.",
			name: "Riskkartläggning",
			source: "Svensk källa saknas"
		},
		PIA_VAL_CONC: {
			description: "Den personuppgiftsansvarige ska, när det är lämpligt, inhämta synpunkter från de registrerade eller deras företrädare om den avsedda behandlingen, utan att det påverkar skyddet av kommersiella eller allmänna intressen eller behandlingens säkerhet. Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Artikel 35.9 i [ADSF/GDPR]</a><br>Detta yttrande kan inhämtas på olika sätt, beroende på sammanhanget (intern eller extern utredning om syftet med behandlingen, fråga till de registrerades representant eller fackförbund, enkät till personuppgiftsansvariges framtida kund).<br><strong>Om den personuppgiftsansvarige</strong> motsätter sig de registrerade personernas åsikt, måste han <strong>dokumentera skälen till sitt beslut.</strong><br>Om den ansvariga anser att<br> yttrande från de registrerade personerna inte krävs, måste han också <strong>dokumentera motiveringen.</strong>",
			name: "De registrerade personernas yttrande",
			source: "ADSF/GDPR Art. 35.9"
		},
		PIA_VAL_DPO: {
			description: "Den personuppgiftsansvarige ska rådfråga dataskyddsombudet, om ett sådant utsetts, vid genomförande av en konsekvensbedömning avseende dataskydd. Se <a target=\"_blank\" href=\"https://eur-lex.europa.eu/legal-content/SV/TXT/?qid=1573479695804&uri=CELEX:32016R0679\">Art. 35 Art 2. i [ADSF/GDPR]</a><br> <strong>DSO kan motsätta sig att behandlingen genomförs men kan inte hindra den personuppgiftsansvarigs beslut</strong>.",
			name: "Ställningstagande av DSO",
			source: "ADSF/GDPR Art. 35.2"
		},
		PIA_VAL_RT: {
			description: "<strong>Den personuppgiftsansvariga personen beslutar formellt</strong>om de utvalda åtgärderna, de återstående riskerna och om den antagna handlingsplanen är acceptabla med tanke på de tidigare identifierade problemen och de registrerade personernas yttrande. PIAn kan vara:<br>- godkänd;<br>- förbättringsbar (förklara på vilket sätt)<br>- underkänd (således även den planerade behandlingen).<br>Om det behövs, granska och slutför tidigare steg för att godkänna PIAn.<br>Detta beslut påverkar inte på något sätt den bedömning som kan göras av behörig dataskyddsmyndighet (t.ex. Datainspektionen i Sverige) i ett tillsynsförfarande!",
			name: "Godkännande av DSO",
			source: "Svensk källa saknas"
		}
	},
	title: "Kunskapsdatabas"
};
var measures$2 = {
	add: "Skapa en åtgärd (eller hämta en föreslagen åtgärd från kunskapsdatabasen)",
	default_placeholder: "Beskriv existerande eller planerade åtgärder för att säkerställa skyddet för personuppgifter.",
	edit: "Editera åtgärd",
	placeholder_title: "Åtgärdens namn",
	remove: "Radera åtgärd"
};
var misc$2 = {
	display: "Visa / Dölj"
};
var modals$2 = {
	abandon_pia: {
		additional_text: "Arkiveringen hindrar inte möjligheten att <br>återuppta bearbetningen och göra förändringar i PIAn.",
		content: "Vill du avsluta bearbetningen?"
	},
	action_plan_no_evaluation: {
		content: "Var vänlig starta utvärderingen av analysen för att skapa en åtgärdsplan.",
		review_section: "Utvärdera en sektion"
	},
	archive: "Arkivera",
	archive_pia: {
		archive: "TO TRANSLATE - Archive AIIA",
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "Denna sektion är klar för att utvärderas"
	},
	back_to_edition: {
		content: "Denna sektion är återsänd för bearbetning<br>kompletterande information erfordras <br>för att den skall kunna utvärderas"
	},
	back_to_evaluation: {
		content: "Avsnittet är sänt för utvärdering,<br>informationen behöver utvärderas igen<br>för att kunna godkännas. "
	},
	back_to_home: "Tillbaka till startsida",
	cancel: "Avbryt",
	close: "Stäng",
	completed_edition: {
		content: "Alla delar har behandlats. <br> PIAn skall nu utvärderas."
	},
	completed_evaluation: {
		content: "Alla sektioner är nu utvärderade.<br>PIAn är färdig för godkännande."
	},
	"continue": "Fortsätt",
	declare_measures: {
		content: "Innan du kan bedöma riskerna<br>måste du beskriva existerande eller<br>planerade åtgärder.",
		declare: "Beskriv existerande eller planerade åtgärder"
	},
	dpo_missing_evaluations: {
		comment: "Kommentarer",
		content: "Du måste färdigställa utvärderingen för att få tillgång till DSO sidan.",
		remove: "Radera",
		review_section: "Utvärdera en sektion"
	},
	general_error: {
		content: "TO TRANSLATE - All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "Den importerade filen är inte en korrekt PIA-fil"
	},
	import_wrong_structure_file: {
		content: "Den importerade filen är inte en korrekt mall-fil"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "Innehållet i PIAn är kopierat till urklipp"
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Varning,</span><br>Åtminstone en åtgärd måste läggas till: Radering kan inte göras."
	},
	recover_version: {
		"continue": "Fortsätt",
		message: "TO TRANSLATE - By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "TO TRANSLATE - Restore a previous version"
	},
	refuse_pia: {
		content: "Efter ditt underkännande sänds PIAn<br>tillbaka för utvärdering och för att utföra<br> nödvändiga kompletterande åtgärder."
	},
	remove_attachment: {
		comment: "Kommentarer",
		content: "<span class='strong'>Varning,</span><br>Är du säker på att du vill<br> radera bilagan?",
		keep: "Behåll",
		remove: "Radera"
	},
	remove_measure: {
		content: "<span class='strong'>Varning,</span><br>Är du säker på att du vill<br>radera denna åtgärd?",
		keep: "Behåll denna <br>åtgärd",
		remove: "Radera denna <br>åtgärd"
	},
	remove_pia: {
		content: "<span class='strong'>Varning,</span><br>Är du säker på att du vill<br>radera denna PIA?",
		remove: "Radera denna PIA"
	},
	remove_question: {
		content: "Vill du radera frågan?",
		keep: "Behåll",
		remove: "Radera"
	},
	remove_structure: {
		content: "<span class='strong'>Varning,</span><br>Är du säker på att du vill<br>radera denna mall?",
		remove: "Radera mallen"
	},
	same_comment: {
		content: "<span class='strong'>Varning,</span><br>Skriv en kommentar som skiljer sig från den senast sparade."
	},
	signed_pia_validation: {
		content: "För att färdigställa detta godkännande <br>skall en signerad rapport läggas som bilaga.",
		download_pia: "Visa rapporten"
	},
	simple_pia_validation: {
		content: "Du godkänner PIAn."
	},
	start_evaluation: "Starta utvärderingen",
	unarchive_pia: {
		content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "TO TRANSLATE - Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "Serveradressen har uppdaterats"
	},
	validate_evaluation: {
		content: "Denna sektion är färdig<br>för godkännandeprocessen."
	},
	validate_evaluation_to_correct: {
		content: "Tyvärr<br> Flera fält behöver korrigeras.<br>Återgå till bearbetningsläge<br>för att korrigera."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$2 = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$2 = {
	content: ", överväger att:",
	dpo_lock: "Var vänlig och fyll i övriga sektioner innan DSO´s överväganden fylls i.",
	dpo_opinion: "DSO´s ståndpunkt",
	edit: "Redigera",
	people_opinion: "Berörda personers synpunkter",
	placeholder_concerned_people_name: "Berörd(a) person(er)s namn",
	placeholder_dpo_name: "DSO´s namn",
	placeholder_dpo_opinion: "Beskriv grunden för ditt val",
	placeholder_people_opinion: "Beskriv hur synpunkterna samlats in och vad analysen gett. Om synpunkter inte inhämtats, beskriv varför så inte skett.",
	placeholder_search_content: "Beskriv varför följande person(er)s synpunkt(er) inte har efterfrågats.",
	treatment_lock: "Var vänlig fyll i de övriga sektionerna före dess att berörd(a) person(er)s synpunkt(er) inhämtas.",
	treatment_nok: "Denna behandling bör inte utföras.",
	treatment_ok: "Denna behandling kan genomföras."
};
var pia$2 = {
	attachments: {
		add: "Lägg till",
		download: "Ladda ner bilaga",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Radera",
		title: "Bilagor",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Begär en utvärdering",
		mandatory_fields: "Alla fält måste fyllas i",
		structure_add_question: "Lägg till en fråga",
		subsection_validated: "Delsektion utvärderad, väntar på slutligt godkännande",
		validate_evaluation: "Godkänn utvärderingen"
	},
	header: {
		display_action_plan: "Visa<br>handlingsplan",
		edition: "Redigering",
		evaluation: "Utvärdering",
		preview: "Förhandsvisning"
	},
	sections: {
		based_on_structure_name: "Baserad på mallen:",
		homepage_link: "Tillbaka till startsidan",
		refuse_pia: "Underkänd AIIA",
		status: {
			evaluation: {
				cancel: "avbryta begäran om utvärdering.",
				cancel_button: "Avbryt begäran om utvärdering",
				content: "Utvärderingen av denna sektion har inte påbörjats. Om du vill ändra i innehållet så måste du",
				title: "Väntar på utvärdering"
			},
			validation: {
				cancel: "avbryta begäran om godkännande.",
				cancel_button: "Avbryt begäran om godkännande",
				content: "Denna sektion är avslutad och väntar på slutligt godkännande av utvärderingen. Om du vill ändra innehållet i utvärderingen så måste du",
				title: "Väntar på godkännande"
			}
		},
		validate_pia: "TO TRANSLATE - Validate PIA"
	},
	statuses: [
		"Under behandling",
		"Underkänd",
		"Enkelt godkännande (utan signatur)",
		"Signerat godkännande",
		"Arkiverad",
		"Väntar på godkännande"
	]
};
var questions$2 = {
	edit: "Redigera frågan",
	gauges: [
		"(Odefinierat)",
		"Obetydlig",
		"Begränsad",
		"Allvarlig",
		"Maximal"
	],
	placeholder_title: "Frågetitel (obligatorisk)",
	remove: "Radera frågan"
};
var rejection_page$2 = {
	applied_adjustments: "Genomförda ändringar",
	applied_adjustments_placeholder: "Beskriv ändringar i PIAn",
	button: {
		abandon_treatment: "Avbryt behandlingen",
		reject_pia: "Underkänn PIAn",
		send_for_validation: "Sänd igen för godkännande"
	},
	previous_rejection: "Tidigare underkännande",
	rejection_reason: "Grund för underkännande",
	rejection_reason_placeholder: "Beskriv skälen för underkännandet av PIAn.",
	title: "Godkännandehistorik"
};
var sections$2 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Beskriv behandlingen på ett systematiskt sätt: Dess namn, dess syfte, dess förväntade resultat, i vilken kontext behandlingen utförs, mm.",
						title: "Vilken behandling skall utvärderas?"
					},
					"2": {
						placeholder: "Beskriv de ansvarsförhållanden som kommer att uppstå mellan involverade parter: Personuppgiftsansvarig, biträde, underbiträde och eventuella gemensamt personuppgiftsansvariga.",
						title: "Hur är ansvaret för behandlingen fördelat mellan parter?"
					},
					"3": {
						placeholder: "Lista relevanta standarder som är tillämpliga på behandlingen, särskilt godkända riktlinjer, uppförandekoder och certifieringar.",
						title: "Tillämpas någon norm, standard eller certifiering på behandlingen?"
					}
				},
				short_help: "Denna del låter dig identifiera och presentera utredningens objekt.",
				title: "Översikt"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Beskriv de uppgifter som samlas in och behandlas genom att ange lagringsperioder, mottagare och vilka personer som har tillgång till dem.",
						title: "Vilka personuppgifter behandlas?"
					},
					"2": {
						placeholder: "Beskriv den personliga informationens livscykel (från insamling till radering genom lagring, bearbetningssteg, arkivering etc.), till exempel med hjälp av ett dataflödesschema (kan läggas till som bilaga) och en beskrivning av varje genomförd process.",
						title: "Hur ser livscykeln ut för personuppgifterna (funktionell beskrivning)?"
					},
					"3": {
						placeholder: "Lista databärarna för din behandling (datorsystem, servrar, programvara, nätverk, personer, papper etc.).",
						title: "Vilka är databärarna?"
					}
				},
				short_help: "Denna sektion låter dig beskriva  behandlingen och dess avgränsningar i detalj.",
				title: "Personuppgifter, processer och lagring"
			}
		},
		short_help: "Det här avsnittet ger dig en bild av den (de) behandling (behandlingar) av personuppgifter som beaktas.",
		title: "Kontext"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Förklara hur syftena med behandlingen är bestämda, uttryckliga och legitima.",
						short_title: "Grunder",
						title: "Är syftet med behandlingen bestämda, uttryckliga och legitima?"
					},
					"2": {
						placeholder: "Presentera grunden (erna) för din behandling (t.ex. samtycke, uppfyllande av avtal, legala krav, intresseavvägning etc.).",
						short_title: "Legal grund",
						title: "På vilken(a) laglig(a) grund(er) baserar du din behandling?"
					},
					"3": {
						placeholder: "Förklara varför varje insamlad personuppgift är nödvändig för din behandling.",
						short_title: "Dataminimering",
						title: "Är de insamlade personuppgifterna tillräckliga, relevanta och begränsade till vad som är nödvändigt för de syften som de behandlas för (dataminimering)?"
					},
					"4": {
						placeholder: "Beskriv planerade åtgärder för att säkerställa kvaliteten på uppgifterna.",
						short_title: "Riktighet",
						title: "Är den personliga informationen korrekt och hålls uppdaterad?"
					},
					"5": {
						placeholder: "Förklara hur den avsedda lagringsperioden för varje personuppgift är nödvändig för att uppfylla syftet med din behandling i de fall det inte finns något specificerat lagligt krav för lagringsperioden.",
						short_title: "Lagringsperiod",
						title: "Vilken är lagringstiden för personuppgifterna?"
					}
				},
				short_help: "Denna del låter dig visa på vilken laglig grund behandlingen utförs och personuppgifterna behandlas.",
				title: "Proportionalitet och nödvändighet"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Beskriv vilken information som förväntas tillhandahållas till registrerade personer hur de får tillgång till den.",
						short_title: "Information till registrerade",
						title: "Hur informeras de registrerade personerna om att behandling av personuppgifter utförs?"
					},
					"2": {
						placeholder: "Beskriv hur det säkerställs att samtycke inhämtas.",
						short_title: "Inhämtning av samtycke",
						title: "I förekommande fall, hur erhålls de berörda personernas samtycke?"
					},
					"3": {
						placeholder: "Beskriv hur den registrerade får tillgång till sina personuppgifter, får registerutdrag och kan utöva sin rättighet till dataportabilitet.",
						short_title: "Rätt till tillgång och dataportabilitet",
						title: "Hur kan den registrerade utöva sin rätt till tillgång och rätt till portabilitet?"
					},
					"4": {
						placeholder: "Beskriv hur den registrerade kan rätta eller, om det är relevant, minimera eller radera sina personuppgifter.",
						short_title: "Rätt till rättelse och radering",
						title: "Hur kan de registrerade utöva sin rätt till rättelse och rätten att raderas (rätten att glömmas)?"
					},
					"5": {
						placeholder: "Beskriv hur den registrerade kan begära begränsning av behandlingen av sina personuppgifter samt invända mot behandlingen av sina personuppgifter.",
						short_title: "Begränsnings- och invändningsrätt",
						title: "Hur kan den registrerade utöva sin begränsningsrätt och invändningsrätt?"
					},
					"6": {
						placeholder: "För varje underleverantör, beskriv omfattningen av dess ansvar och ange referenser till kontrakt, uppförandekoder och certifieringar som anger dess skyldigheter.",
						short_title: "Underbiträde",
						title: "Är underbiträdenas skyldigheter tydligt definierade och avtalade?"
					},
					"7": {
						placeholder: "För varje land utanför Europeiska unionen där data lagras eller behandlas, identifiera dem och ange om de av EU erkänns ha en tillräckligt hög skyddsnivå för personuppgifter eller beskriv de klausuler som styr överföringen.",
						short_title: "Tredjelandsöverföring",
						title: "Om personuppgifter överförs till land utanför EU (\"Tredjeland\"), skyddas uppgifterna då på ett adekvat sätt?"
					}
				},
				short_help: "Denna sektion låter dig beskriva att du genomför nödvändiga åtgärder för att göra det möjligt för de registrerade personerna att utöva sina rättigheter.",
				title: "Åtgärder för att garantera de registrerades rättigheter"
			}
		},
		short_help: "Denna sektion ger dig möjlighet att bygga ramverk för att uppfylla de krav som DSF (GDPR) stipulerar. ",
		title: "Grundläggande principer"
	},
	"3": {
		items: {
			"1": {
				short_help: "Denna sektion låter dig identifiera och beskriva de åtgärder (befintliga eller planerade) som bidrar till personuppgiftssäkerhet.",
				title: "Befintliga eller planerade åtgärder"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Ange de potentiella konsekvenserna",
						title: "Vilka kan vara de viktigaste <span class='green-highlight'>konsekvenserna för de registrerade personerna</span> om risken inträffar?"
					},
					"2": {
						placeholder: "Beskriv hoten",
						title: "Vilka är de viktigaste <span class='green-highlight'>hoten</span> som kan leda till risken?"
					},
					"3": {
						placeholder: "Ange riskkällorna",
						title: "Vilka är<span class='green-highlight'>källorna</span> för risken?"
					},
					"4": {
						placeholder: "Klicka här för att välja de åtgärder som hjälper till att undanröja denna risk.",
						title: "Vilka är de <span class='green-highlight'>initiala åtgärderna</span>bland de beskrivna som hjälper till att undanröja risken?"
					},
					"5": {
						placeholder: "Beskriv den bedömda allvarlighetsgraden för risken.",
						title: "Hur uppskattar du <span class='green-highlight'>riskens allvarlighetsgrad</span>, särskilt när det gäller potentiella konsekvenser och i förhållande till planerade åtgärder?"
					},
					"6": {
						placeholder: "Beskriv här den uppskattade sannolikheten.",
						title: "Hur uppskattar du <span class='green-highlight'>sannolikheten för risken</span>, särskilt när det gäller hot, riskkällor och i förhållande planerade åtgärder?"
					}
				},
				short_help: "Analysera orsakerna till och konsekvenserna av olaglig tillgång till data och uppskatta deras allvarlighetsgrad och sannolikhet.",
				title: "Otillåten tillgång till data"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Beskriv de potentiella konsekvenserna",
						title: "Vilka kan vara de viktigaste <span class='green-highlight'>konsekvenserna för de registrerade personerna</span> om risken skulle inträffa?"
					},
					"2": {
						placeholder: "Beskriv hoten",
						title: "Vilka är de viktigaste <span class='green-highlight'>hoten</span> som kan leda till att risken uppstår?"
					},
					"3": {
						placeholder: "Beskriv riskkällorna",
						title: "Vilka är<span class='green-highlight'>källorna</span> till riskerna?"
					},
					"4": {
						placeholder: "Klicka här för att välja de åtgärder som hjälper till att hantera denna risk.",
						title: "Vilka av de beskrivna<span class='green-highlight'>åtgärderna</span>, hjälper till att hantera risken?"
					},
					"5": {
						placeholder: "Motivera här den uppskattade allvarlighetsgraden.",
						title: "Hur uppskattar du <span class='green-highlight'>riskens allvarlighetsgrad</span>, särskilt när det gäller potentiella konsekvenser i förhållande till planerade åtgärder?"
					},
					"6": {
						placeholder: "Beskriv här den uppskattade sannolikheten.",
						title: "Hur uppskattar du <span class='green-highlight'>sannolikheten för risk</span>, särskilt när det gäller hot, riskkällor och i förhållande till planerade åtgärder?"
					}
				},
				short_help: "Analysera orsakerna till och konsekvenserna av en oönskad ändring av personuppgifter och uppskatta hur allvarliga och sannolika dessa är.",
				title: "Oönskad ändring av personuppgifter"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Ange de potentiella konsekvenserna",
						title: "Vilka kan vara de viktigaste <span class='green-highlight'>konsekvenserna för de registrerade personerna</span> om risken inträffar?"
					},
					"2": {
						placeholder: "Beskriv hoten",
						title: "Vilka är de viktigaste <span class='green-highlight'>hoten</span> som kan leda till att risken inträffar?"
					},
					"3": {
						placeholder: "Beskriv riskkällorna",
						title: "Vilka är <span class='green-highlight'>källorna</span> till risken?"
					},
					"4": {
						placeholder: "Klicka här för att välja de åtgärder som hjälper till att hantera denna risk.",
						title: "Vilka bland de beskrivna<span class='green-highlight'>åtgärderna</span>, hjälper till att hantera risken?"
					},
					"5": {
						placeholder: "Beskriv här den uppskattade allvarlighetsgraden för risken.",
						title: "Hur uppskattar du <span class='green-highlight'>riskens allvarlighetsgrad</span>, särskilt när det gäller potentiella konsekvenser med hänsyn taget till planerade åtgärder?"
					},
					"6": {
						placeholder: "Beskriv här den uppskattade sannolikheten.",
						title: "Hur uppskattar du <span class='green-highlight'>sannolikheten för risk</span>, särskilt när det gäller hot, riskkällor och planerade åtgärder?"
					}
				},
				short_help: "Analysera orsakerna till och konsekvenserna av förlorade personuppgifter och uppskatta deras allvarlighetsgrad och sannolikhet.",
				title: "Förlust av personuppgifter"
			},
			"5": {
				short_help: "Denna visualisering gör att du kan skapa dig en övergripande bild av vilken verkan åtgärderna har på komponenterna i riskerna som de skall hantera.",
				title: "TO TRANSLATE - Risks overview"
			}
		},
		short_help: "Det här avsnittet låter dig bedöma dataskyddsriskerna med hänsyn till befintliga eller planerade kontroller.",
		title: "Risker"
	},
	"4": {
		items: {
			"1": {
				short_help: "Denna visualisering låter dig jämföra bedömningen av risker före och efter tillämpning av kompletterande åtgärder.",
				title: "Riskkartläggning"
			},
			"2": {
				short_help: "Detaljplanera genomförandet av de kompletterande åtgärder som identifierats under PIA. Handlingsplanen uppdateras automatiskt när kompletteringar görs som en del av PIA-granskningen.",
				title: "Handlingsplan"
			},
			"3": {
				short_help: "Inhämta råd från DPO: Dokumentera den registrerades eller deras representants åsikt.",
				title: "DPO och den registrerades åsikter"
			},
			"4": {
				title: "Godkänn PIA"
			},
			"5": {
				title: "Underkänn PIA"
			}
		},
		short_help: "Det här avsnittet låter dig förbereda och formalisera PIA-valideringen.",
		title: "Godkännande"
	}
};
var settings$2 = {
	content: "Vänligen ange adressen (URL) för fjärrservern:",
	title: "Inställningar",
	update: "Uppdatera URL"
};
var summary$2 = {
	action_plan: {
		fundamental_principles: "Fundamentala principer",
		implementation_date: "Förväntat genomförandedatum",
		implementation_responsible: "Ansvarig för genomförandet",
		measures: "Befintliga eller planerade åtgärder",
		no_action_plan: "Ingen handlingsplan registrerad.",
		risks: "Risker",
		title: "Handlingsplan"
	},
	actions: {
		complete_download: "Ladda ner den fullständiga rapporten",
		complete_download_desc: "Exportera allt rapportinnehåll (.doc och bilder) i ett .zip-arkiv, bilagor och handlingsplanen i ett .csv-format.",
		individual_download: "Ladda ner delar av rapporten",
		individual_download_desc: "Exportera specifika delar av rapporten.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "Texter (.doc)",
		individual_download_images: "Grafiska element (.png) inklusive risköversikt, kartläggning av risker och handlingsplan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "Välj avsnitt som ska exporteras:",
		individual_to_download: "TO TRANSLATE - Download",
		print: "Skriv ut rapporten",
		print_and_download: "Skriva ut och ladda ner"
	},
	attachments: "Bilagor",
	concerned_people_name: "Berörda personers namn",
	concerned_people_opinion: "Berörda personers åsikter",
	concerned_people_searched_opinion: "Inhämta berörda personers åsikt",
	concerned_people_status: "Berörda personers status",
	concerned_people_unsearched_opinion_comment: "Anledningen till att de berörda personernas åsikt inte begärdes",
	content_choice: [
		"Behandlingen bör inte genomföras",
		"Behandlingen kan genomföras"
	],
	creation_date: "Skapandedatum",
	csv_action_plan_comment: "Kommentar till handlingsplanen",
	csv_evaluation_comment: "Kommentar till utvärderingen",
	csv_file_title: "Handlingsplan",
	csv_implement_date: "Uppskattat genomförandedatum",
	csv_people_in_charge: "Ansvarig för genomförandet",
	csv_section: "Avsnitt",
	csv_title_object: "Titel",
	download_csv: "Handlingsplan (.csv)",
	dpo_name: "DSO´s namn",
	dpo_opinion: "DSO´s åsikt",
	dpo_status: "DSO´s status",
	gauges: {
		"1": "Obetydlig",
		"2": "Begränsad",
		"3": "Allvarlig",
		"4": "Maximal"
	},
	modification_made: "Gjorda ändringar",
	people_search_status_nok: "Registrerade personers åsikt har inte tagits i beaktande",
	people_search_status_ok: "Registrerade personers åsikt har tagits i beaktande",
	pia_assessor: "Utvärderarens namn",
	pia_author: "Utförarens namn",
	pia_name: "Namn på PIAn",
	pia_validator: "Godkännarens namn",
	preview_dpo_opinion: "Åsikter från DSO samt representant för de registrerade",
	preview_edition: "Redigera",
	preview_evaluation: "Utvärdering",
	preview_no_data: "Ingen data att visa.",
	preview_status: "Status",
	preview_subtitle: "Allmän information",
	preview_title: "Förhandsvisning",
	preview_validation: "Godkännande",
	preview_validation_section: "Godkännande",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Tillbaka till föregående sida",
	rejection_reason: "Skäl för underkännande",
	revision: {
		current_version: "TO TRANSLATE - Current version",
		pia_version: "TO TRANSLATE - PIA versions",
		restore_version: "TO TRANSLATE - Restore",
		revision: "TO TRANSLATE - Versions and revision",
		save: "TO TRANSLATE - Create a new version",
		show: "TO TRANSLATE - Display the {{length}} versions"
	},
	risks_cartography_title: "Riskkartläggning",
	risks_overview_title: "Risköversikt",
	title: "PIA-information"
};
var users$2 = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$2 = {
	add_signed_pia: "Lägg till en signerad version av PIAn",
	after_reading: "Efter att ha läst hela PIAn avseende den personuppgiftsbehandling som är kopplad till:",
	button: {
		rejection: "Underkänn AIIA",
		signed_validation: "Godkänn PIA <br>(signerad)",
		simple_validation: "Godkänn PIA <br>(direkt)"
	},
	confirmation1: "Jag intygar att beskrivningen av behandlingen som dokumenteras i PIA överensstämmer med verkligheten.",
	confirmation2: "Jag intygar att jag är medveten om riskerna kopplade till befintliga eller planerade åtgärder.",
	confirmation3: "Jag bekräftar de korrigerande åtgärder som anges i handlingsplanen.",
	confirmation4: "Jag åtar mig att genomföra de angivna korrigerande åtgärderna så snabbt som möjligt.",
	latest_signed_attachment: "Senast signerad bilaga",
	mandatory_fields: "Alla rutor måste vara markerade",
	remove_attachment: "Ta bort bilaga",
	responsible: "Person ansvarig för godkännande av PIA:",
	signed_attachments_history: "Historik signerade bilagor",
	tools: {
		dashboard: "Översikt",
		display_pia: "Visa rapport"
	},
	validated_pia_with_signature: "Godkänd",
	waiting_for_signature: "Väntar på att PIA-rapporten har undertecknats"
};
var sv = {
	about: about$2,
	action_plan: action_plan$2,
	authentication: authentication$2,
	cartography: cartography$2,
	comments: comments$2,
	conflict: conflict$2,
	date: date$2,
	errors: errors$2,
	evaluations: evaluations$2,
	header: header$2,
	help: help$2,
	homepage: homepage$2,
	knowledge_base: knowledge_base$2,
	measures: measures$2,
	misc: misc$2,
	modals: modals$2,
	onboarding: onboarding$2,
	opinions: opinions$2,
	"overview-risks": {
	important: "Viktig",
	limited: "Begränsad",
	maximal: "Maximal",
	measures: "Åtgärder",
	negligible: "Obetydlig",
	potential_impacts: "Möjliga konsekvenser",
	"risk-access_x": "Allvarlighetsgrad",
	"risk-access_y": "Sannolikhetsgrad",
	"risk-change_x": "Allvarlighet",
	"risk-change_y": "Sannolikhet",
	"risk-disappearance_x": "Allvarlighet",
	"risk-disappearance_y": "Sannolikhet",
	sources: "Källor",
	threat: "Hot"
},
	pia: pia$2,
	questions: questions$2,
	rejection_page: rejection_page$2,
	sections: sections$2,
	settings: settings$2,
	summary: summary$2,
	users: users$2,
	validation_page: validation_page$2
};

var about$1 = {
	contribute: "Ja vēlaties piedalīties programmatūras tulkošanā citā valodā vai uzlabot esošos tulkojumus, iesakām <a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">izlasīt lapu, kurā aprakstītas veicamās darbības</a>.",
	description: "Šo rīku sākotnēji ir izstrādājusi <a target=\"_blank\" href=\"https://www.cnil.fr\">Commission Nationale Informatique et Liberté (CNIL)</a>, Francijas Datu aizsardzības iestāde, lai palīdzētu datu pārzinim ievērot VDAR. To izstrādāja <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>Šī programmatūra ir bezmaksas un atvērta. Ja vēlaties iesaistīties šajā projektā, Ja vēlaties iesaistīties šajā projektā, lūdzu lejupielādējiet pirmkodu no Github, modificējiet to un informējiet mūs.",
	licences: "Licences:",
	title: "Par PIA rīku",
	translators: "PIA programmatūra pašlaik ir pieejama astoņpadsmit valodās. Franču un angļu valodas versiju nodrošina CNIL. Pārējo valodu versiju pamatā ir šādu personu ieguldījums:",
	translators_name: "<ul><li>Horvātu valoda: <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">B2KapitalBA</a> ;</li><li>Čehu valoda: Jiří Grohmann, Manuel d’Orso ;</li><li>Dāņu valoda: <a target=\"_blank\" href=\"https://github.com/moolsen\">Michael Drews Olsen</a> ;</li><li>Nīderlandiešu valoda: Ruud van Driel, Manuel d’Orso ;</li><li>Angļu valoda: <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Igauņu valoda: Eva Arumets, Lauri Bender, Rebeka Dronia, Kärol Kibena, Simon Suuban, <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">Urmas Kukk, <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">PrivacyAssessment1</a> ;</li><li>Somu valoda: <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">Tietosuojavaltuutetun toimisto</a> ;</li><li>Franču valoda: <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a> ;</li><li>Vācu valoda: <a target=\"_blank\" href=\"https://github.com/kosmas58\">Kosmas Schütz</a> , Corina Scheiter (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>) ;</li><li>Grieķu valoda: <a target=\"_blank\" href=\"https://tzellis.gr\">Dimitris Tzellis</a> ;</li><li>Ungāru valoda: <a target=\"_blank\" href=\"https://naih.hu/\">Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</a> ;</li><li>Itāļu valoda: Manuel d’Orso, Gianluca Markos, Antonio Caselli (<a target=\"_blank\" href=\"http://gpdp.it\">Garante per la Protezione dei Dai Personali (GPDP)</a>) ;</li><li>Lietuviešu valoda: Paulius Galubickas (<a target=\"_blank\" href=\"http://galubickas.lt\">Law firm Galubickas</a>) ;</li><li>Norvēģu valoda: <a target=\"_blank\" href=\"https://www.datatilsynet.no\">Datatilsynet</a> ;</li><li>Poļu valoda: <a target=\"_blank\" href=\"https://github.com/JoannaKar\">Joanna Karczewska</a> , Michal Mazur (<a target=\"_blank\" href=\"https://giodo.gov.pl\">Generalny Inspektor Ochrony Danych Osobowych (GIODO)</a>) ;</li><li>Portugāļu valoda: <a target=\"_blank\" href=\"https://github.com/bagois\">Barbara Gois</a> ;</li><li>Rumāņu valoda: <a target=\"_blank\" href=\"https://github.com/webmyday\">webmyday</a> ;</li><li>Spāņu valoda: <a target=\"_blank\" href=\"https://github.com/ylachgar\">ylachgar</a> .</li></ul>",
	version_number: "Versija Nr."
};
var action_plan$1 = {
	acceptable_measures: "Pieļaujamie pasākumi",
	edit: "Rediģēt",
	improvable_measures: "Uzlabojamie pasākumi",
	measures: "Plānotie vai esošie pasākumi",
	no_action_plan: "Nav reģistrēts neviens rīcības plāns.",
	placeholder_person_in_charge: "Par ieviešanu atbildīgā persona",
	principles: "Pamatprincipi",
	risk1: "Nelikumīga piekļuve datiem",
	risk2: "Nevēlama datu modificēšana",
	risk3: "Datu pazaudēšana",
	risks: "Riski",
	title: "Pārskats"
};
var authentication$1 = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "Šī <strong>Francijas Datu aizsardzības iestādes(CNIL)</strong> programmatūra ir paredzēta, lai palīdzētu datu pārziņiem veidot un demonstrēt atbilstību VDAR. Tā palīdz pienācīgi veikt datu aizsardzības ietekmes novērtējumu, izmantojot CNIL izstrādāto PIA metodi.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "Sākt",
	start_app: "Piekļuve PIA programmatūrai(Beta)",
	subtitle1: "Platforma, lai izveidotu <br> un pārvaldītu savus AIIA",
	subtitle2: "Piekļuves rīki un glosāriji",
	title: "Ietekmes uz privātumu novērtējums",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography$1 = {
	important: "Svarīgi",
	legend1: "Plānotie vai esošie pasākumi",
	legend2: "Ar īstenotajiem korektīvajiem pasākumiem",
	legend3: "(N)elikumīga piekļuve datiem",
	legend4: "(N)evēlama datu modificēšana",
	legend5: "(D)Datu pazaudēšana",
	likelihood_axe: "Riska iespējamība",
	limited: "Ierobežota",
	maximal: "Maksimāla",
	negligible: "Nenozīmīga",
	risk1_access: "(I)",
	risk2_modification: "(U)",
	seriousness_axe: "Riska nopietnība"
};
var comments$1 = {
	comment: "Komentārs",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "komentārs(i)",
	new_comment: "Jauns komentārs",
	placeholder_new_comment: "Atstāt komentāru",
	send: "Sūtīt"
};
var conflict$1 = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date$1 = {
	april: "Aprīlis",
	august: "Augusts",
	december: "Decembris",
	"earlier-in-this-month": "Šī mēneša sākumā",
	"earlier-in-this-week": "Šīs nedēļas sākumā",
	february: "Februāris",
	january: "Janvāris",
	july: "Jūlijs",
	june: "Jūnijs",
	march: "Marts",
	may: "Maijs",
	november: "Novembris",
	october: "Oktobris",
	september: "Septembris",
	today: "Šodiena",
	yesterday: "Vakardiena"
};
var errors$1 = {
	content: "Ja Jūs esat saskāries ar citām problēmām vai ja Jums ir ieteikumi uzlabojumiem,,<br>Jūs varat par to informēt, aizpildot un nosūtot šo formu: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "Lapa nav atrasta."
};
var evaluations$1 = {
	acceptable: "Pieļaujams",
	action_plan_comment: "Rīcības plāns / korektīvie pasākumi",
	evaluation_comment: "Novērtējuma komentārs",
	gauges: {
		"0": "(Neskaidrs)",
		"1": "Nenozīmīgs",
		"2": "Ierobežots",
		"3": "Būtisks",
		"4": "Maksimāls",
		likelihood: "Ņemot vērā rīcības plānu, kā jūs atkārtoti novērtējat <span class='red-highlight'>šī riska iespējamību</span>?",
		seriousness: "Ņemot vērā rīcības plānu, kā jūs atkārtoti novērtējat <span class='red-highlight'>šī riska nopietnību</span>?"
	},
	improvable: "Uzlabojams",
	placeholder_acceptable: "Saskaņā ar pieejamo informāciju īstenotie pasākumi ir atbilstoši, lai pienācīgi atbilstu datu aizsardzības prasībām.",
	placeholder_improvable1: "Saskaņā ar pieejamo informāciju ir jāveic papildu pasākumi, lai uzlabotu apstrādes datu aizsardzību.",
	placeholder_improvable2: "Ievadiet savus komentārus.",
	placeholder_to_correct: "Sniegtā informācija nav pietiekama, lai to pienācīgi novērtētu. Nosūtiet atpakaļ redaktoram, lai uzlabotu sākotnējos argumentus.",
	status: [
		"Gaida",
		"Labot",
		"Uzlabojams",
		"Pieļaujams"
	],
	title: "Novērtējums",
	to_correct: "Labot"
};
var header$1 = {
	archives: "PIA Arhīvi",
	current_pias: "Pašreizējie AIIA",
	exit_full_screen_mode: "Nospiediet F11, lai izietu no pilnekrāna režīma.",
	help: {
		issue_reporting: "Ziņot par problēmu",
		manual: "Lietotāja rokasgrāmata",
		pia_example_link: "PIA piemērs",
		title: "Palīdzība"
	},
	homepage_link: "Mani AIIA",
	knowledge_base_link: "Zināšanu bāze",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "CNIL nodrošinātie tulkojumi",
		community_translations: "Kopienas nodrošinātie tulkojumi",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "Tulkojumu rediģēja Eiropas datu aizsardzības iestāde",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "Sākotnējā versija",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "privacy impact assessment",
	logo_title: "Ietekmes uz privātumu novērtējums",
	structures: "PIA formas",
	tools: {
		about: "Par",
		accessibility: "Piekļuves nodrošināšana personām ar redzes traucējumiem (augsta kontrasta krāsas, daltonisms)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "Iestatījumi",
		url_setting: "Servera URL konfigurācija",
		users: "TO TRANSLATE - Users"
	}
};
var help$1 = {
	definition: {
		data1: {
			content: "Saturs tiek rakstīts",
			title: "PIA rīka lietošana"
		},
		data2: {
			qa1: {
				content: "Ja rodas problēmas ar attēlojumu, aizveriet lietojumprogrammu un ielādējiet to atkārtoti. Parasti tas novērš problēmu. Jūs nezaudēsiet ievadīto informāciju, tā tiek automātiski saglabāta rakstīšanas laikā.",
				title: "Man rodas tādas attēlojuma problēmas kā ikonas, kas ir iestrēgušas vienā stāvoklī, vai saskarnē trūkst elementu"
			},
			qa2: {
				content: "Šī problēma pašlaik tiek novērsta. Ja rodas šī problēma, ieteicams aizpildīt aprēķinātā nopietnības un/vai iespējamības pakāpes pamatojuma lauku. Kad kļūda būs novērsta, varēsiet rediģēt kritēriju.",
				title: "Es nevaru rediģēt kritērijus, lai novērtētu riska nopietnību un iespējamību"
			},
			qa3: {
				content: "Importējot PIA, tika novērotas vairākas kļūdas, un jo īpaši var pazust kritēriji riska nopietnības un iespējamības novērtēšanai. Šajā gadījumā, lūdzu, skatiet iepriekš minēto jautājumu. Turklāt PIA pēc tās importēšanas var neparādīties informācijas panelī.  Šī ir attēlošanas problēma, un Jums tikai jāpārlādē lapa.",
				title: "Importējot PIA, rodas problēmas"
			},
			qa4: {
				content: "Šī ir tikai attēlojuma kļūda, un tā neietekmē attiecīgaja laukā ievadīto tekstu. Šī vizuālā problēma drīz tiks novērsta.",
				title: "Kopējot / ielīmējot tekstu, tas tiek izcelts"
			},
			qa5: {
				content: "Lai novērtētu sadaļu, obligāti jāaizpilda visi lauki. Lūdzu, pārbaudiet, vai tas tā ir izdarīts. Rediģējot risku, jums ir jābūt vismaz vienam tehniskam vai organizatoriskam pasākumam, kas mazina risku, lai pieprasītu riska novērtējumu.",
				title: "Es nevaru novērtēt sadaļu"
			},
			qa6: {
				content: "Lūdzu, aizveriet rediģējamo PIA un atveriet to no jauna. Pēc tam saturam ir jāparādās Jūsu izvēlētajā valodā.",
				title: "Nomainot citu valodu, teksti neparādās attiecīgajā valodā"
			},
			qa7: {
				content: "Pagaidām navigācijas izvēlnes ikonas netiek atjauninātas pēc PIA atteikuma. Jums jāpārbauda katra sadaļa un jānomaina informācija un/vai novērtējums atbilstoši iemesliem, kāpēc PIA tiek atteikts. Kad visas sadaļas ir pārskatītas, Jums vajadzētu būt iespējai vēlreiz pieprasīt PIA validāciju.",
				title: "Esmu atteicies validēt PIA, bet nezinu, ko darīt tagad"
			},
			title: "Zināmās problēmas"
		},
		footer: "Ja Jums rodas kādas citas problēmas vai ir ieteikumi uzlabojumiem, varat apmeklēt <a target=\"_blank\" href=\"https://github.com/LINCnil/pia\">Github resository</a> un iesniegt problēmas aprakstu vai jautājumus."
	},
	title: "Palīdzība"
};
var homepage$1 = {
	cards: {
		author: "Rediģēšana",
		category: "Kategorija",
		creation_status: "Izveidošana",
		date: "Datums",
		evaluation: "Pārskatīšana",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "Importēt AIIA",
		import_structure: "Importēt veidni",
		item: {
			consult_pia: "Konsultēties",
			consult_structure: "Skatīt veidni",
			edit_pia: "Rediģēt",
			edit_structure: "Rediģēt veidni",
			tools: {
				action_plan: "Rādīt<br>rīcības plānu",
				archive: "Arhivēt",
				duplicate: "Dublēt",
				"export": "Eksportēt",
				more_options: "Citas opcijas",
				pia: "Rādīt<br>PIA",
				remove: "Dzēst",
				unarchive: "Atarhivēt"
			},
			validate_pia: "Validēt"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "Jauns AIIA",
		new_structure: "Jauna veidne",
		or: "vai",
		pia_name: "PIA",
		placeholder_author: "Vārds, uzvārds",
		placeholder_category: "Kategorija",
		placeholder_evaluation: "Vārds, uzvārds",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "Importēt AIIA",
		placeholder_import_structure: "Importēt veidni",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "Jauns AIIA",
		placeholder_new_structure: "Jauna veidne",
		placeholder_pia_name: "PIA nosaukums",
		placeholder_sector_name: "Saistītās nozares nosaukums",
		placeholder_start: "Jāaizpilda visi lauki",
		placeholder_structure: "Veidne pēc noklusējuma",
		placeholder_structure_name: "Veidnes nosaukums",
		placeholder_validation: "Vārds, uzvārds",
		sector_name: "Nozare",
		start: "Sākt",
		status: "Statuss",
		structure: "Veidne",
		structure_name: "Veidnes nosaukums",
		title_close_creation: "Aizvērt",
		validation: "Validācija"
	},
	filters: {
		assessor: "Pārbaudītājs",
		author: "Iniciators",
		card: "Kartes skats",
		card_rocket_content: "Sāciet darbu!<br>Lai sāktu PIA,<br> noklikšķiniet uz +",
		card_rocket_content_structure: "Sāciet darbu! Lai sāktu <br>veidni, noklikšķiniet uz +",
		category: "Kategorija",
		date: "Datums",
		import_pia: "Importēt AIIA",
		import_structure: "Importēt veidni",
		list: "Saraksta skats",
		list_rocket_content: "Sāciet darbu! <br>Lai sāktu PIA, noklikšķiniet uz +",
		list_rocket_content_structure: "Sāciet darbu! Lai sāktu <br>veidni, noklikšķiniet uz +",
		name: "Nosaukums",
		new_pia: "Jauns AIIA",
		new_structure: "Jauna veidne",
		sector_name: "Saistītās nozares nosaukums",
		sort: "Kārtot",
		sort_by: "pēc",
		status: "Statuss",
		validator: "Validētājs"
	},
	lists: {
		column_actions: "Darbības",
		column_author: "Rediģēšana",
		column_category: "Kategorija",
		column_creation: "Izveidots",
		column_evaluation: "Pārskatīšana",
		column_pia: "PIA",
		column_progression: "Progress",
		column_sector_name: "Saistītā nozares",
		column_status: "Statuss",
		column_structure: "Veidne",
		column_structure_name: "Veidne",
		column_updated_at: "Pēdējoreiz atvērts",
		column_validation: "Validācija",
		item: {
			tools: {
				action_plan: "Parādīt rīcības plānu",
				archive: "Arhivēt",
				consult: "Konsultēties",
				duplicate: "Dublēt",
				edit: "Rediģēt",
				"export": "Eksportēt",
				pia: "Parādīt AIIA",
				remove: "Dzēst",
				unarchive: "Atarhivēt"
			}
		}
	},
	search_filter: "Meklēšana",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base$1 = {
	add_measure: "Pievienot",
	add_measure_hint: "Jūs varat arī pievienot pasākumu atbilstoši savām zināšanām.",
	category: {
		definition: "Definīcija",
		example: "Piemērs",
		general_measure: "Objektu drošības kontrole",
		measure_on_data: "Datorprogrammu drošības kontrole",
		method: "Metodoloģija",
		organizational_measure: "Organizatoriskā kontrole",
		principle: "Princips"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "Visi",
		definitions: "Definīcijas",
		general_measures: "Objektu drošības kontrole",
		measures_on_data: "Datorprogrammu drošības kontrole",
		no_result: "Rezultāts nav atrasts.",
		organizational_measures: "rganizatoriskās kontroles",
		title: "Filtri"
	},
	placeholder_add_measure: "Pievienojiet šo pasākumu",
	placeholder_help: "Ierakstu palīgi",
	search: "Meklēt",
	slugs: {
		PIA_DEF_ACC: {
			description: "Datu subjektam ir tiesības saņemt no pārziņa apstiprinājumu par to, vai attiecībā uz datu subjektu tiek vai netiek apstrādāti personas dati, un, ja tiek, datu subjektam ir tiesības piekļūt attiecīgajiem datiem un informācijai, kas noteikta <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 15. pantā</a>",
			name: "Piekļuves tiesības",
			source: "VDAR 15. pants"
		},
		PIA_DEF_ANO: {
			description: "Process, kas no personas datiem noņem identifikācijas pazīmes. Lai novērtētu anonimizācijas procesu noturību, lūdzu skatīt <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/ files / 2014 / wp216_en.pdf\"> 29. panta darba grupas vadlīnijas </a>.",
			name: "Anonimitāte",
			source: "Measures_US and G29 guidelines http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_ARCH: {
			description: "Procedūras elektronisko arhīvu saglabāšanai un pārvaldībai, kas satur personas datus, kuru mērķis ir nodrošināt to vērtību (konkrēti, juridisko vērtību) visā nepieciešamajā periodā (pārsūtīšana, glabāšana, migrēšana, pieejamība, iznīcināšana, arhivēšanas politika, konfidencialitātes aizsardzība utt.).",
			name: "Arhivēšana",
			source: "Measures_USE Archiving"
		},
		PIA_DEF_AUTH: {
			description: "Ikviena persona, kurai ir likumīga piekļuve personas datiem (darbinieki, līgumslēdzējas puses un citas trešās personas), būtu jāidentificē ar unikālu identifikatoru. Sesiju atvēršanai izvēlieties autentifikācijas metodi, kas ir piemērota kontekstam, riska līmenim un sagaidāmajam noturīgumam. Ieteikumi: ja risks nav paaugstināts, var izmantot paroli; tomēr, ja riski ir lielāki, izmantojiet vienreizēju paroles marķierierīci, bet nomainiet noklusējuma aktivizācijas paroli vai, ja daļa paroles tiek nosūtīta ar SMS, karti ar PIN kodu, elektronisku sertifikātu vai jebkuru citu spēcīgu autentifikācijas veidu.",
			name: "Autentifikācija",
			source: "Measures_US Logical Access Control"
		},
		PIA_DEF_CHIF: {
			description: "Pasākums, kas padara personas datus nesaprotamus ikvienam bez sankcionētas piekļuves (simetriska vai asimetriska šifrēšana; tādu publiski pieejamu algoritmu izmantošana, par kuriem zināms, ka tie ir spēcīgi; autentifikācijas sertifikāts utt.).",
			name: "Šifrēšana",
			source: "Measures_US Encryption"
		},
		PIA_DEF_CLO: {
			description: "Datu organizēšanas metodes, kas samazina iespēju savstarpēji sasaistīt personas datus un ka var notikt personas datu pārkāpums. Piemēram, identificējot tikai katram biznesa procesam noderīgus personas datus un tos loģiski nodalot.",
			name: "Datu sadalīšana",
			source: "PIA3 p19 - WIKI"
		},
		PIA_DEF_CONS: {
			description: "Jebkura brīvi sniegta, konkrēta, apzināta un viennozīmīga norāde uz datu subjekta vēlmēm, ar kuru viņš paziņojuma vai skaidri apstiprinošas darbības veidā sniedz piekrišanu savu personas datu apstrādei.<br>Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR]4. panta 11. punktu</a>",
			name: "Piekrišana",
			source: "VDAR 4. panta 11. punkts"
		},
		PIA_DEF_CTLA: {
			description: "Līdzekļi, kas ieviesti, lai ierobežotu risku, ka nepiederošas personas piekļūst personas datiem elektroniski, tai skaitā <br>- <strong>pārvaldot lietotāju profilus,</strong> sadalot uzdevumus un atbildības jomas (vēlams centralizētā veidā), lai nodrošinātu piekļuvi personas datiem tikai sankcionētiem lietotājiem, piemērojot zinātvajadzības un mazāko tiesību principus,<br>- <strong>anulējot darbinieku, līgumslēdzēju pušu un citu trešo personu tiesības gadījumos, kad viņiem vairs nav atļauts piekļūt telpām vai citiem resursiem</strong> vai kad viņu <strong>darba līgums ir beidzies</strong>.",
			name: "loģiskās piekļuves kontroles",
			source: "PIA3 p43 - WIKI"
		},
		PIA_DEF_DCP: {
			description: "Jebkura informācija, kas attiecas uz identificētu vai identificējamu fizisku personu (“datu subjekts”); identificējama fiziska persona ir tāda, kuru var tieši vai netieši identificēt, jo īpaši atsaucoties uz identifikatoru, piemēram, minētās personas vārdu, uzvārdu, identifikācijas numuru, atrašanās vietas datiem, tiešsaistes identifikatoru vai vienu vai vairākiem minētajai fiziskajai personai raksturīgiem fiziskās, fizioloģiskās, ģenētiskās, garīgās, ekonomiskās, kultūras vai sociālās identitātes faktoriem. <br>Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR] 4. panta 1. punktu</a>",
			name: "Personas dati",
			source: "VDAR 4. panta 1. punkts"
		},
		PIA_DEF_DEST: {
			description: "Fiziska vai juridiska persona, publiska iestāde, aģentūra vai cita struktūra, kurai izpauž personas datus – neatkarīgi no tā, vai tā ir trešā persona vai nav. Tomēr publiskas iestādes, kas var saņemt personas datus saistībā ar konkrētu izmeklēšanu saskaņā ar Savienības vai dalībvalsts tiesību aktiem, netiek uzskatītas par saņēmējiem; minēto datu apstrāde, ko veic minētās publiskās iestādes, atbilst piemērojamiem datu aizsardzības noteikumiem saskaņā ar apstrādes nolūkiem. <br>Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR] 4. panta 9.punktu</a>",
			name: "Saņēmējs",
			source: "VDAR 4. panta 9. punkts"
		},
		PIA_DEF_EFF: {
			description: "Datu subjektam ir tiesības panākt, lai pārzinis bez nepamatotas kavēšanās dzēstu datu subjekta personas datus, un pārziņa pienākums ir bez nepamatotas kavēšanās dzēst personas datus. Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 17. pantu</a>",
			name: "Tiesības uz dzēšanu",
			source: "VDAR 17. pants"
		},
		PIA_DEF_ENJ: {
			description: "Paredzamie ieguvumi (organizācijai, datu subjektiem, sabiedrībai kopumā utt.).",
			name: "Ieguldījums",
			source: "PIA1 p4 footnote 8"
		},
		PIA_DEF_EXA: {
			description: "Personas dati ir precīzi un, ja vajadzīgs, atjaunināti; ir jāveic visi saprātīgi pasākumi, lai nodrošinātu, ka neprecīzi personas dati, ņemot vērā nolūkus, kādos tie tiek apstrādāti, bez kavēšanās tiktu dzēsti vai laboti (“precizitāte”). <br>Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 5. panta 1. punkta d) apakšpunktu</a>",
			name: "Datu kvalitāte",
			source: "VDAR 5. panta 1.punkta d) apakšpunkts"
		},
		PIA_DEF_GRV: {
			description: "Nopietnība norāda riska lielumu. Tā galvenokārt ir atkarīga no potenciālās ietekmes kaitīgā rakstura.",
			name: "Nopietnība",
			source: "PIA1 page 6"
		},
		PIA_DEF_LIM: {
			description: "Datu subjektam ir tiesības panākt, lai pārzinis ierobežotu apstrādi. Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 18. pantu</a>",
			name: "Tiesības ierobežot apstrādi",
			source: "VDAR 18. pants"
		},
		PIA_DEF_LOG: {
			description: "Izveidojiet reģistrēšanas arhitektūru, lai varētu savlaicīgi atklāt ar personas datiem saistītus incidentus un lai iegūtu informāciju, ko var izmantot, lai tos analizētu vai sniegtu pierādījumus saistībā ar izmeklēšanu.",
			name: "Uzraudzība",
			source: "Measures_US Surveillance"
		},
		PIA_DEF_MEN: {
			description: "Procedūra, kas ietver vienu vai vairākas atsevišķas darbības attiecībā uz datus atbalstošiem līdzekļiem. To izmanto riska avoti tīši vai citādi, un var izraisīt bažas.",
			name: "Apdraudējums",
			source: "PIA1 p12 - WIKI"
		},
		PIA_DEF_MENA: {
			description: "Apdraudējums, kas saistīts ar: <strong>aparatūru</strong>, kas tiek neatbilstoši izmantota, tiek novērota, pārveidota, nozaudēta (sensitīvas aparatūras izmantošana vai transportēšana personiskām vajadzībām, citai personai piederoša ekrāna novērošana bez viņa ziņas vilcienā, izsekošana, izmantojot taustiņu pierakstītāju utt.)<br> - <strong>Programmatūru</strong>, kas tiek neatbilstoši izmantota, tiek novērota, pārveidota (priekšrocību palielināšana, konfigurācijas datu vākšana, inficēšana ar ļaunprātīgu kodu utt.)<br>- <strong>Datorkanāliem</strong> tie tiek novēroti (Ethernet tīklā pārraidīto datu pārtveršana utt.)<br>- <strong>Cilvēkiem</strong>, tiek novēroti, manipulēti, pazuduši (nejauša informācijas izpaušana, sociālā inženierija, izmaiņas veicamajos uzdevumos)<br>- <strong>Papīra dokumentiem</strong> tiek aplūkoti, pazaudēti (lasīšana, pasta nolaupīšana utt.)<br>- <strong>Papīra pārsūtīšanas kanāliem</strong> tiek novēroti (apritē esošu parakstu žurnālu lasīšana utt.)",
			name: "Apdraudējums, kas var izraisīt nelikumīgu piekļuvi",
			source: "PIAF Connected objects p44 and 45"
		},
		PIA_DEF_MENI: {
			description: "<strong>Draudi, kas saistīti ar: </strong><br>- <strong>aparatūru</strong>, kas tiek neatbilstoši izmantota, pārslogota, pārveidota, bojāta, nozaudēta (atmiņas bloks ir pilns, apstrādes jaudas pārslodze, nesaderīgas aparatūras pievienošana, kas izraisa darbības traucējumus, ugunsgrēks, zādzība vai kādas lietas nozaudēšana utt.)<br>- <strong>Programmatūru</strong>, kas tiek neatbilstoši izmantota, pārslogota, pārveidota, bojāta, nozaudēta (datu dzēšana, datu bāzes lieluma pārsniegšana, loģiskā bumba, licences neatjaunošana programmatūrai, kura tiek izmantota, lai piekļūtu datiem utt.)<br>- <strong>Datorkanāliem</strong> : pārslogoti, pārveidoti, zaudēti (neatļauta lejupielāde, interneta savienojuma zaudēšana utt.)<br>- <strong>Cilvēkiem</strong> tie ir pārslogoti, diskreditēti, pazuduši (slikta prasmju izmantošana, slimošana, pensionēšanās utt.)<br>- <strong>Papīra dokumentiem</strong> tie tiek neatbilstoši izmantoti, sabojāti, nozaudēti (dzēšana, arhivēto dokumentu novecošana, dokumentu zādzība vai nozaudēšana utt.)<br>- <strong>Papīra pārsūtīšanas kanāliem</strong> tie ir pārslogoti, pārveidoti, bojāti, pazuduši(pasta piegāde tiek pārtraukta sakarā ar streiku, biroja vai telpu maiņa, dokumentu piegādes uzņēmuma zaudēšana, papīra pārsūtīšanas kanālu reorganizācija utt.)",
			name: "Draudi, kas var izraisīt personas datu pazušanu",
			source: "PIAF Connected Objects p44 and 45, WIKI"
		},
		PIA_DEF_MENM: {
			description: "<strong>Draudi, kas saistīti ar: </strong><br>- <strong>aparatūru</strong> tā ir pārveidota (nesaderīgas aparatūras pievienošana, kas izraisa darbības traucējumus, būtisku komponentu noņemšana utt.)<br>- <strong>Programmatūru</strong> tā tiek neatbilstoši izmantota vai pārveidota (nevēlamas datu izmaiņas datu bāzēs, operatora kļūdas, kas modificē datus utt.)<br>- <strong>Datorkanāliem</strong>, kas tiek neatbilstoši izmantoti (atvienoto datu atkārtota nosūtīšana utt.)<br>- <strong>Cilvēkiem</strong> pārslogoti vai manipulē (personāla piešķiršana uzdevumiem, kas pārsniedz viņu iespējas, stress vai negatīvas izmaiņas darba apstākļos, ietekmējamība utt.)<br>- Papīra dokumenti, kas ir pārveidoti (izmaiņas failā esošajos ciparos, oriģināla aizstāšana ar viltojumu utt.)<br>- <strong>Papīra pārsūtīšanas kanāliem</strong>, kas ir nomainīti (pāreja no viena parakstu žurnāla uz citu, vairāku konfliktējoša satura dokumentu nosūtīšana utt.)",
			name: "Draudi, kas var izraisīt nevēlamu personas datu modificēšanu",
			source: "PIAF Connected Objects p43 and 44, WIKI"
		},
		PIA_DEF_MES: {
			description: "Jāizvēlas starp tām, kas pieejamas sadaļā \"Plānotie vai esošie pasākumi\", kuras vajadzības gadījumā varat izpildīt.",
			name: "Pasākumi",
			source: "Nav"
		},
		PIA_DEF_MIN1: {
			description: "Importējot datus, var nejauši savākt dažādu tipu metadatus (piemēram, EXIF datus ar pievienotu attēla failu). <br>Šādi metadati ir jāidentificē un jāizņem, ja tie nav vajadzīgi norādītajiem mērķiem.",
			name: "Filtrēšana un noņemšana",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN2: {
			description: "Kad sensitīvi dati ir saņemti kā daļa no vispārīgas informācijas vai nosūtīti tikai statistikas vajadzībām, tos var konvertēt mazāk sensitīvā formā vai pseidonimizēt. Piemēram: <br>- ja sistēma statistikas vajadzībām apkopo IP adreses, lai noteiktu lietotāja atrašanās vietu, IP adresi var izdzēst, kad ir izsecināta pilsēta vai rajons<br>- ja sistēma saņem video datus no novērošanas kamerām, tā var atpazīt cilvēkus, kas atrodas vai pārvietojas notikuma vietā, un aizmiglot viņus<br>- ja sistēma ir viedskaitītājs, tā var apkopot enerģijas izmantošanu noteiktā laikposmā, neierakstot to reālā laikā",
			name: "Sensitivitātes pakāpes samazināšana, izmantojot pārveidošanu",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN3: {
			description: "Sistēma var nodrošināt, ka: <br>- lietotājs var izmantot resursu vai pakalpojumu, neriskējot atklāt savu identitāti (anonīmi dati)<br>- lietotājs var izmantot resursu vai pakalpojumu, neriskējot izpaust savu identitāti, taču joprojām ir identificējams un atbildīgs par to izmantošanu (pseidonīmi dati)<br>- lietotājs var vairākkārt izmantot resursus vai pakalpojumus, neriskējot, ka šie dažādi lietojumi tiks sasaistīti kopā (datus nevar savstarpēji sasaistīt)<br>- lietotājs var izmantot resursu vai pakalpojumu, neriskējot, ka citi, jo ​​īpaši trešās puses spēj novērot, ka resurss vai pakalpojums tiek izmantots (neievērojamība)<br>Metode no iepriekš minētā saraksta jāizvēlas, pamatojoties uz identificētajiem apdraudējumiem. Dažiem privātuma apdraudējuma veidiem pseidonimizācija būs piemērotāka nekā anonimizācija (piemēram, ja ir nepieciešama izsekojamība). Turklāt daži privātuma apdraudējumi tiks novērsti, izmantojot metožu kombināciju.",
			name: "Datu identificējošā rakstura samazināšana",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN4: {
			description: "Sistēmu var organizēt neatkarīgās daļās ar atsevišķi nodalītām piekļuves kontroles funkcijām. Datus var arī sadalīt starp šīm neatkarīgajām apakšsistēmām un kontrolēt katru apakšsistēmu, izmantojot dažādus piekļuves kontroles mehānismus. Ja apakšsistēma ir apdraudēta, tādējādi var mazināt ietekmi uz visiem datiem.",
			name: "Datu uzkrāšanas samazināšana",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MIN5: {
			description: "Sistēma var ierobežot piekļuvi datiem saskaņā ar zinātvajadzības principu. Sistēma var nodalīt sensitīvos datus un piemērot īpašas piekļuves kontroles politikas. Sistēma var arī šifrēt sensitīvus datus, lai aizsargātu to konfidencialitāti pārsūtīšanas un glabāšanas laikā. Ir jāaizsargā arī piekļuve pagaidu sīkdatnēm, kas tiek radītas datu apstrādes laikā.",
			name: "Datu piekļuves ierobežošana",
			source: "PIAF Connected objects p42 - WIKI"
		},
		PIA_DEF_MINC: {
			description: "Samaziniet risku nopietnību, ierobežojot personas datu apjomu līdz tam, kas ir absolūti nepieciešams noteikta mērķa sasniegšanai, pretējā gadījumā datus nevāc.",
			name: "Personas datu apjoma samazināšana līdz minimumam",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "Samaziniet risku nopietnību, līdz minimumam samazinot pašus datus, veicot pasākumus, lai samazinātu to sensivitāti, piemēram, filtrējot un noņemot nevajadzīgus datus, pseidonimizējot datus utt.",
			name: "Pašu datu samazināšana",
			source: "PIA3 p64"
		},
		PIA_DEF_OPP: {
			description: " Datu subjektam, balstoties uz iemesliem saistībā ar viņa īpašo situāciju, ir tiesības jebkurā laikā iebilst pret savu personas datu apstrādi saskaņā ar <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 21.pants</a>",
			name: "Tiesības iebilst",
			source: "VDAR 21. pants"
		},
		PIA_DEF_PBDS: {
			description: "Pasākumi, kas veikti, lai integrētu personas datu aizsardzību visās jaunajās apstrādes darbībās (uzticami nosaukumi, vadlīnijas, CNIL metodoloģija riska pārvaldībai vai cita iekšēja metodika).",
			name: "Projekta vadība",
			source: "Measures_US"
		},
		PIA_DEF_PC: {
			description: "Personas, uz kurām attiecas dati, uz ko attiecas apstrāde.",
			name: "Datu subjekts",
			source: "PIA1 p9"
		},
		PIA_DEF_PORT: {
			description: " Datu subjektam ir tiesības saņemt personas datus attiecībā uz sevi, kurus viņš sniedzis pārzinim, strukturētā, plaši izmantotā un mašīnlasāmā formātā un ir tiesības minētos datus nosūtīt citam pārzinim, un pārzinis, kuram attiecīgie personas dati sniegti, tam nerada nekādus šķēršļus. Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 20. pants</a>",
			name: "Right to data portability",
			source: "VDAR 20. pants"
		},
		PIA_DEF_PSEU: {
			description: "Personas datu apstrāde, ko veic tādā veidā, lai personas datus vairs nav iespējams saistīt ar konkrētu datu subjektu bez papildu informācijas izmantošanas, ar noteikumu, ka šāda papildu informācija tiek turēta atsevišķi un tai piemēro tehniskus un organizatoriskus pasākumus, lai nodrošinātu, ka personas dati netiek saistīti ar identificētu vai identificējamu fizisku personu.<br>Pseidonimizācija samazina datu kopas sasaisti ar datu subjekta sākotnējo identitāti; tā ir noderīgs drošības līdzeklis, bet tā nav anonimizācijas metode.",
			name: "Pseidonimizācija",
			source: "VDAR 4. panta 5. punkts un 29. panta darba grupas vadlīnijas (22.lpp.) http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_en.pdf"
		},
		PIA_DEF_PWD: {
			description: "Paroles sastāv no vismaz astoņām rakstzīmēm; tās ir jāatjauno, ja ir vismazākās bažas, ka tās varētu būt apdraudētas, un, ja iespējams, periodiski (ik pēc sešiem mēnešiem vai reizi gadā), un tajās jāiekļauj vismaz trīs no četrām rakstzīmju šķirām (lielie burti, mazie burti, cipari un speciālās rakstzīmes); nomainot paroli, pēdējās piecas paroles nedrīkst atkārtoti izmantot; vienu un to pašu paroli nevajadzētu izmantot dažādām piekļuvēm; paroles nedrīkst būt saistītas ar personisku informāciju (ieskaitot vārdu vai dzimšanas datumu). Nosakiet maksimālo mēģinājumu skaitu, pēc kuriem tiek izteikts brīdinājums un autentifikācija tiek bloķēta (īslaicīgi vai līdz brīdim, kad tā tiek manuāli atbloķēta).",
			name: "Parole",
			source: "Mesure_US"
		},
		PIA_DEF_RECT: {
			description: "Datu subjektam ir tiesības panākt, lai pārzinis bez nepamatotas kavēšanās labotu neprecīzus datu subjekta personas datus. Ņemot vērā apstrādes nolūkus, datu subjektam ir tiesības panākt, lai nepilnīgi personas dati tiktu papildināti, tostarp sniedzot papildu paziņojumu.",
			name: "Tiesības labot",
			source: "VDAR 16. pants"
		},
		PIA_DEF_RGPD: {
			description: "Regula par fizisku personu aizsardzību attiecībā uz personas datu apstrādi un šādu datu brīvu apriti un ar ko atceļ Direktīvu 95/46/EK.",
			name: "VDAR (Vispārīgā datu aizsardzības regula)",
			source: "VDAR nosaukums"
		},
		PIA_DEF_RT: {
			description: "Fiziska vai juridiska persona, publiska iestāde, aģentūra vai cita struktūra, kas viena pati vai kopīgi ar citām nosaka personas datu apstrādes nolūkus un līdzekļus; ja šādas apstrādes nolūkus un līdzekļus nosaka ar Savienības vai dalībvalsts tiesību aktiem, pārzini vai tā iecelšanas konkrētos kritērijus var paredzēt Savienības vai dalībvalsts tiesību aktos.<br>Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 4. panta 7. punkts</a>",
			name: "Pārzinis",
			source: "VDAR 4. panta 7. punkts"
		},
		PIA_DEF_SRC: {
			description: "Persona vai avots, kas nav cilvēks, kas var radīt risku. Šis avots var rīkoties nejauši vai apzināti.",
			name: "Riska avots",
			source: "PIA1 p11 - WIKI"
		},
		PIA_DEF_ST: {
			description: "Fiziska vai juridiska persona, publiska iestāde, aģentūra vai cita struktūra, kura pārziņa vārdā apstrādā personas datus. Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 4. panta 8. punkts</a>.<br>Apstrādātājs un jebkura persona, kas darbojas pārziņa vai apstrādātāja pakļautībā un kam ir piekļuve personas datiem, neapstrādā minētos datus citādi, kā vien saskaņā ar pārziņa norādījumiem, ja vien to darīt nepieprasa Savienības vai dalībvalsts tiesību akti. Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 29. pants</a>.",
			name: "Apstrādātājs",
			source: "VDAR 4. panta 8. punkts un 29. pants"
		},
		PIA_DEF_SUPT: {
			description: "Līdzeklis, uz kuru balstās personas dati. Tā var būt aparatūra, programmatūra, tīkli, cilvēki, dokumenti vai dokumentu nosūtīšanas kanāli.",
			name: "Papildlīdzekļi",
			source: "PIA1 p10"
		},
		PIA_DEF_VIOL: {
			description: "Drošības pārkāpums, kura rezultātā notiek nejauša vai nelikumīga nosūtīto, uzglabāto vai citādi apstrādāto personas datu iznīcināšana, nozaudēšana, pārveidošana, neatļauta izpaušana vai piekļuve tiem.",
			name: "Personas datu aizsardzības pārkāpums",
			source: "VDAR 4. panta 12. punkts"
		},
		PIA_DEF_VRA: {
			description: "Varbūtība izsaka riska iestāšanās iespēju. Tas galvenokārt ir atkarīgs no apdraudēto līdzekļu neaizsargātības līmeņa un riska avotu spējas tos izmantot.",
			name: "Varbūtība",
			source: "PIA1 page 6"
		},
		PIA_EX_DC: {
			description: "Dati par vērtēšanas sistēmu, rezultātu piemērošana.",
			name: "Aprēķinātie dati"
		},
		PIA_EX_DCPC: {
			description: "<strong>Identifikācijas dati</strong>: ģimenes stāvoklis, identitāte, vecums utt. <br><strong>Privātā dzīve</strong>: dzīves paradumi, ģimenes stāvoklis utt. <br><strong>Darbs</strong>: CV, izglītība un profesionālā apmācība, apbalvojumi utt. <br><strong>Sakari</strong>: IP adreses, notikumu reģistri utt. <br><strong>Atrašanās vietas dati</strong>: ceļojumi, GPS dati, GSM dati utt. <br><strong>Citi</strong>: tālruņa numurs, e-pasta adrese utt.",
			name: "Kopējie personas dati",
			source: "PIA2 old version - WIKI"
		},
		PIA_EX_DCPR: {
			description: "Filozofiski, politiski, reliģiski un arodbiedrību uzskati, seksuālā dzīve, dati par veselību, rase vai etniskā izcelsme, dati par veselību vai dzimumdzīvi, pārkāpumi, sodāmība, drošības pasākumi. Skat. <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[VDAR] 9. un 10. pants</a>.",
			name: "Pārliecība un sensitīvi personas dati"
		},
		PIA_EX_DCPS: {
			description: "Sociālās nodrošināšanas numurs (NIR), biometriskie dati, bankas dati.",
			name: "Personas dati, kuri tiek uztverti kā sensitīvi"
		},
		PIA_EX_HUME: {
			description: "Tie varētu būt:<br>- negodīgs vai naivs kaimiņš, kurš ielaužas ierīces datos;<br>- hakeris, kas vēršas pret lietotāju, izmantojot zināšanas, kas viņam/viņai ir par lietotāju, un citu informāciju par viņu;<br>- hakeris, kas vēršas pret kādu no uzņēmumiem, izmantojot zināšanas, kas viņam/viņai ir par uzņēmumu, kas var iedragāt tā tēlu;<br>- pilnvarots trešās puses uzņēmums, kas izmanto tā priviliģēto piekļuvi, lai nelikumīgi piekļūtu informācijai.",
			name: "Ārējie cilvēciskie avoti"
		},
		PIA_EX_HUMI: {
			description: "Tie varētu būt:<br>- nolaidīgs vai negodīgs darbinieks, sistēmas tuvums, prasmes, privilēģijas un pieejamais laiks ir potenciāli augsts, iespējamais apmācību un izpratnes trūkums;<br>- nolaidīgs vai negodīgs lietotājs, ģimenes loceklis vai draugs, kuram ir piekļuve pakalpojumam.<br> Dažādi motīvi ir iespējami, tai skaitā neveiklība, kļūda, nolaidība, spēle, ļaunprātīgs nodoms, atriebība, spiegošana.",
			name: "Iekšējie cilvēciskie avoti"
		},
		PIA_EX_IMPI: {
			description: "Datu subjektiem var rasties būtiskas sekas, kaut arī ar reālām un nopietnām grūtībām viņiem tās vajadzētu spēt pārvarēt. Piemēram:<br>- fiziskas: nopietnas fiziskas kaites, kas rada ilgtermiņa kaitējumu (veselības pasliktināšanās nepareizas aprūpes vai kontrindikāciju neievērošanas dēļ), fiziskās integritātes maiņa, piemēram, pēc uzbrukuma, nelaimes gadījuma mājās, darbā utt.;<br>- materiālās: mērķtiecīga, unikāla un vienreizēja naudas nelikumīga piesavināšanās, kura netiek atmaksāta, zaudētas iespējas (aizdevums mājai, atteikšanās no studijām, prakses vai nodarbinātības, eksāmenu kārtošanas aizliegums), mājokļa zaudēšana, darba zaudēšana utt.;<br>- morālās: nopietnas psiholoģiskas kaites (depresija, fobijas attīstība), privātuma aizskāruma sajūta ar neatgriezenisku kaitējumu, šantāžas, kiberiebiedēšanas un uzmākšanās upuris utt.",
			name: "Būtiska ietekme"
		},
		PIA_EX_IMPL: {
			description: "Datu subjekti var saskarties ar ievērojamām neērtībām, kuras viņi spēs pārvarēt, neskatoties uz dažām grūtībām. Piemēram:<br>- fiziskas: nelielas fiziskas kaites (neliela saslimšana kontrindikāciju neievērošanas dēļ), neslavas celšana, kas izraisa fizisku vai psiholoģisku atriebību utt.;<br>- materiālās: neparedzēti maksājumi (kļūdaini uzlikti naudas sodi), piekļuves liegšana administratīviem vai komercpakalpojumiem, nevēlamu mērķtiecīgu komercpaziņojumu saņemšana, kas var kaitēt datu subjektu reputācijai utt.;<br>- morālās: nelielas, bet objektīvas psiholoģiskas kaites, privātuma aizskāruma sajūta bez neatgriezeniska kaitējuma, iebiedēšana sociālajos tīklos utt.",
			name: "Ierobežota ietekme"
		},
		PIA_EX_IMPM: {
			description: "Datu subjektiem var rasties nozīmīgas vai pat neatgriezeniskas sekas, kuras tie nevar pārvarēt. Piemēram:<br>- fiziskas: ilgstošas ​​vai pastāvīgas fiziskas kaites, pastāvīga fiziskās integritātes pasliktināšanās, nāve;<br>- materiālās: finansiāls risks, lieli parādi, nespēja strādāt, nespēja pārvietoties, pierādījumu zaudēšana tiesvedības kontekstā, piekļuves zaudēšana vitāli svarīgai infrastruktūrai (ūdens, elektrība) utt.;<br>- morālās: ilgstošas ​​vai pastāvīgas psiholoģiskas kaites, kriminālsods, nolaupīšana, ģimenes saišu zaudēšana, nespēja iesūdzēt tiesā, administratīvā statusa maiņa un/vai juridiskās autonomijas (aizbildnība) zaudēšana utt.",
			name: "Maksimāla ietekme"
		},
		PIA_EX_IMPN: {
			description: "Datu subjekti vai nu netiks skarti, vai arī viņiem var rasties dažas neērtības, kuras viņi bez problēmām pārvarēs. Piemēram:<br>- fiziskas: pārejošas galvassāpes;<br>- materiālās: laika zaudēšana, atkārtojot formalitātes vai gaidot to nokārtošanu, nepieprasītu pastu saņemšana (piemēram, surogātpasts), tīmekļa vietnēs publicētu datu atkārtota izmantošana mērķtiecīgas reklāmas nolūkos utt.;<br>- morālās: tikai aizkaitinājums, sajūta par privātās dzīves aizskārumu bez reāla vai objektīva kaitējuma (komerciāla rakstura uzbāšanās) utt.",
			name: "Nenozīmīga ietekme"
		},
		PIA_EX_NHUM: {
			description: "Incident or damage at one of the organisation (power cut, fire, flood, etc.)",
			name: "Non-human sources"
		},
		PIA_EX_VRAI: {
			description: "It seems possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in offices that cannot be accessed without first checking in at the reception).",
			name: "Significant likelihood"
		},
		PIA_EX_VRAL: {
			description: "It seems difficult for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader).",
			name: "Limited likelihood"
		},
		PIA_EX_VRAM: {
			description: "It seems extremely easy for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in the public lobby).",
			name: "Maximum likelihood"
		},
		PIA_EX_VRAN: {
			description: "It does not seem possible for the selected risk sources to materialize the threat by exploiting the properties of supporting assets (e.g.: theft of paper documents stored in a room protected by a badge reader and access code).",
			name: "Negligible likelihood"
		},
		PIA_LGL_CONS: {
			description: "Allow data subjects to make a free, specific and informed choice. Determine whether the processing relies on a legal basis other than consent pursuant to Art. 6 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Consent",
			source: "PIA3 p11 - WIKI"
		},
		PIA_LGL_DATA: {
			description: "Define and describe the scope in detail:<br>- the personal data concerned, their recipients and storage durations<br>- description of the processes and personal data supporting assets for the entire personal data life cycle (from collection to erasure).",
			name: "Data and processes",
			source: "PIA1 p6"
		},
		PIA_LGL_DESC: {
			description: "Present a brief outline of the processing under consideration, its nature, scope, context, purposes and stakes. Identify the data controller and any processors. List the standard references applicable to the processing, which are necessary or must be complied with , not least the approved codes of conduct (see Art. 40 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>) and certifications regarding data protection (see Art. 42 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>)",
			name: "Processing's description",
			source: "PIA1 p4"
		},
		PIA_LGL_DEST: {
			description: "Natural or legal person, public authority, agency or another body, to which the personal data are disclosed, whether a third party or not. However, public authorities which may receive personal data in the framework of a particular inquiry in accordance with Union or Member State law shall not be regarded as recipients; the processing of those data by those public authorities shall be in compliance with the applicable data protection rules according to the purposes of the processing. see Art. 4.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a>",
			name: "Recipient",
			source: "GDPR art 4.9"
		},
		PIA_LGL_DUR: {
			description: "A storage duration must be defined for each type of data and justified by the legal requirements and/or processing needs. Thus a distinction is made between common data and archived data, to which access will be limited to only the stakeholders concerned. An erasure mechanism must be implemented to archive common data or purge archived data at the end of their storage duration. Functional traces will also have to be purged, as will technical logs which may not be stored indefinitely",
			name: "Storage Durations",
			source: "PIAF Connected Objects p12"
		},
		PIA_LGL_FIN: {
			description: "Personal data shall be collected for specified, explicit and legitimate purposes and <strong>not further processed in a manner that is incompatible with those purposes.</strong> <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">Art. 5.1 b) of [GDPR]</a>",
			name: "Principles relating to processing of personal data",
			source: "GDPR art 5.1 b)"
		},
		PIA_LGL_FOND: {
			description: "- The data subject has given consent  to the processing of his or her personal data for one or more specific purposes <br>- Processing is necessary for the performance of a contract to which the data subject is party or in order to take steps at the request of the data subject prior to entering into a contract <br>-Processing is necessary for compliance with a legal obligation to which the controller is subject <br>- Processing is necessary in order to protect the vital interests of the data subject or of another natural person <br>- Processing is necessary for the performance of a task carried out in the public interest or in the exercise of official authority vested in the controller <br>- Processing is necessary for the purposes of the legitimate interests pursued by the controller or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject which require protection of personal data, in particular where the data subject is a child<br> See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 6 of [GDPR]</a> ",
			name: "Justification of lawfulness",
			source: "PIA2 p4"
		},
		PIA_LGL_INFO: {
			description: "Ensure that the subjects are informed. Confirm that the processing is not covered by an exception and is not subject to specific conditions.",
			name: "Informing data subjects",
			source: "PIA3 p8 - WIKI"
		},
		PIA_LGL_MINI: {
			description: "It is important to reduce the severity of the risks by minimising the number of personal data that will be processed, by limiting such data to what is strictly necessary for the purposes for which they are processed (otherwise they should not be collected). Then, it also becomes possible to minimise the data themselves, via controls aimed at reducing their sensitivity.",
			name: "Data minimisation",
			source: "PIAF Connected Objects p10 - WIKI"
		},
		PIA_LGL_ST: {
			description: "A processing contract must be signed with each processor, setting out all of the aspects stipulated in Art. 28 of the [GDPR]: duration, scope, purpose, documented processing instructions, prior authorisation where a processor is engaged, provision of any documentation providing evidence of compliance with the [GDPR], prompt notification of any data breach, etc.",
			name: "Subcontracting",
			source: "PIA2 p10"
		},
		PIA_LGL_SUPT: {
			description: "Asset on which personal data rely. Note: this may be hardware, software, networks, people, paper or paper transmission channels.",
			name: "Supporting asset",
			source: "PIA1 p10"
		},
		PIA_LGL_TRAN: {
			description: "Depending on the country in question, you will have to justify the choice of remote hosting and indicate the legal supervision arrangements implemented in order to ensure adequate protection of the data subject to a cross-border transfer. That is :<br>- European Union<br>- Country recognised as providing adequate protection by the EU<br>- Transfer to the United States to a company which has joined the Privacy Shield<br>- Other country <br>See <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">art. 44 to 49 of [GDPR]</a>",
			name: "Transfers",
			source: "PIAF Connected Objects p18"
		},
		PIA_METHOD_MES: {
			description: "Planned controls are those originally put in place, before any analysis by the assessor. Corrective measures advised by the assessor will be stated in the action plan and will enable a second assessment of the severity and likelihood of the risk.",
			name: "Planned and corrective controls",
			source: ""
		},
		PIA_ORG_AUD: {
			description: "Existence of a policy and processes to obtain an organisation able to manage and control the protection of personal data held within it.",
			name: "Supervision",
			placeholder: "Indicate here whether the effectiveness and adequacy of privacy controls are monitored.",
			source: "PIA3 p76 - WIKI"
		},
		PIA_ORG_EXT: {
			description: "Existence of a policy and processes reducing the risk that legitimate access to personal data by third parties may pose to the data subjects' civil liberties and privacy.",
			name: "Relations with third parties",
			placeholder: "Indicate here, for processors requiring access to data, the security controls and arrangements carried out as regards such access.",
			source: "PIA3 p48 - WIKI"
		},
		PIA_ORG_ORG: {
			description: "Specify whether a person is responsible for the enforcement of privacy laws and regulations. Specify whether there is a monitoring committee (or equivalent) responsible for the guidance and follow-up of actions concerning the protection of privacy.",
			name: "Organisation",
			placeholder: "Indicate if the roles and responsibilities for data protection are defined.",
			source: "PIAF Connected Objects p24 - WIKI"
		},
		PIA_ORG_PBD: {
			description: "Existence of a policy designed integrate the protection of personal data in all new processing operations.",
			name: "Integrating privacy protection in projects",
			placeholder: "Describe here how privacy protection is integrated in projects",
			source: "PIA3 p79 - WIKI"
		},
		PIA_ORG_PERS: {
			description: "Existence of a policy describing awareness-raising controls are carried out with regard to a new recruit and what controls are carried out when persons who have been accessing data leave their job.",
			name: "Personnel management",
			placeholder: "Indicate here what awareness-raising controls are carried out with regard to employees.",
			source: "PIAF Connected Objects p24"
		},
		PIA_ORG_POL: {
			description: "Set out important aspects relating to data protection within a documentary base making up the data protection policy and in a form suited to each type of content (risks, key principles to be followed, target objectives, rules to be applied, etc.) and each communication target (users, IT department, policymakers, etc.).",
			name: "Policy",
			placeholder: "Describe here the documentary base setting out data protection objectives and rules.",
			source: "PIA3 p78 - WIKI"
		},
		PIA_ORG_RMGT: {
			description: "Policy describing processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects (building a map of the risks, etc.).",
			name: "Managing privacy risks",
			placeholder: "Describe here processes to control the risks that processing operations performed by the organisation pose on data protection and the privacy of data subjects.",
			source: "PIA3 p77 - WIKI"
		},
		PIA_ORG_VIOL: {
			description: "Existence of an operational organisation that can detect and treat incidents that may affect the data subjects' civil liberties and privacy.",
			name: " Managing personal data violations",
			placeholder: "Indicate here whether IT incidents are subject to a documented and tested management procedure.",
			source: "PIAF Connected Objects p24 and PIA3 p36 - WIKI"
		},
		PIA_SEC_BKP: {
			description: "Policies and means implemented to ensure the availability and/or integrity of the personal data, while maintaining their confidentiality.",
			name: "Backups",
			placeholder: "Indicate here how backups are managed. Clarify whether they are stored in a safe place.",
			source: "PIAF Connected Objects p23 & PIA3 p27  - WIKI"
		},
		PIA_SEC_COMP: {
			description: "Controls implemented on workstations (automatic locking, regular updates, configuration, physical security, etc.) to reduce the possibility to exploit software properties (operating systems, business applications etc.) to adversely affect personal data.",
			name: "Managing workstations",
			placeholder: "Describe here the controls implemented on workstations",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_CTR: {
			description: "<strong>Only use subcontractors which are able to provide sufficient guarantees</strong> (in particular in terms of specialised knowledge, reliability and resources). Require service providers to communicate their information system security policy before signing a contract with them. <br>Take and document the means (security audits, installation visits, etc.) used to <strong>ensure the effectiveness of the guarantees offered by the subcontractor</strong> in terms of data protection. These guarantees include: <br>- encryption of data according to its sensitivity or, at least, the existence of procedures guaranteeing that the service company does not have access to the data; <br>- encryption of data transmissions (e.g.: HTTPS type connection, VPN, etc.); <br>- guarantees in terms of network protection, traceability (logs, audits), access rights management, authentication, etc. <br><strong>Sign a contract with the subcontractors</strong>, which defines the subject, the length and the purpose of the processing, as well as obligations of each party. Ensure that it contains, in particular, provisions targeting: <br>- their obligation in terms of <strong>confidentiality of the entrusted personal data</strong>;<br>- <strong>minimal standards in terms of user authentication</strong>;<br>- <strong>conditions of restitution of data and/or its destruction at end of the contract</strong>;<br>- <strong>incident management and notification rules. </strong> They should include notification of the data controller whenever a security breach or a security incident is discovered, which should happen as soon as possible when it concerns personal data.",
			name: "Processing contracts",
			placeholder: "Describe here specific measures for processors (host, maintenance company, administrator, specialist service providers, etc.)",
			source: "Measures_US Procurement: identified and governed by a contract"
		},
		PIA_SEC_EXP: {
			description: "Policies implemented to reduce the possibility and the impact of risks on assets supporting personal data.",
			name: "Operating security",
			placeholder: "Describe here how the software updates (operating systems, applications, etc.) and application of security corrective controls patches are carried out.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_LOG: {
			description: "Monitor intrusion detection systems and intrusion prevention systems in order to analyze network (wired networks, Wi-Fi, radio waves, fiber optics, etc.) traffic in real time and detect any suspicious activity suggestive of a cyber attack scenario.",
			name: "Monitoring network activity",
			placeholder: "Indicate here means and controls implemented to detect incidents involving personal data",
			source: "PIA3 p67 - WIKI"
		},
		PIA_SEC_MAIN: {
			description: "Policies describing how physical maintenance of hardware is managed, stating whether this is contracted out.<br> Indicate whether the remote maintenance of apps is authorized, and according to what arrangements. Specify whether defective equipment is managed in a specific manner.",
			name: "Maintenance",
			placeholder: "Describe here how physical maintenance of hardware is managed",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_MAL: {
			description: "Controls implemented on workstations and servers to protect them from malicious software while accessing less secure networks.",
			name: "Clamping down on malicious software",
			placeholder: "Describe here the controls implemented to reduce risks while accessing less secure networks.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_SEC_MAT: {
			description: "Indicate here the controls bearing on the physical security of servers and workstations (secure storage, security cables, confidentiality filters, secure erasure prior to scrapping, etc.).",
			name: "Hardware security",
			placeholder: "Indicate here the controls bearing on the physical security of servers and workstations",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_NET: {
			description: "Depending on the type of network on which the processing is carried out (isolated, private or Internet). Specify which firewall system, intrusion detection systems or other active or passive devices are in charge of ensuring network security.",
			name: "Network security",
			placeholder: "Indicate here the security controls of network on which the processing is carried out",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PHY: {
			description: "Policies to ensure physical security (zoning, escorting of visitors, wearing of passes, locked doors and so on).Indicate whether there are warning procedures in place in the event of a break-in.",
			name: "Physical access control",
			placeholder: "Indicate here how physical access control is carried out regarding the premises accommodating the processing.",
			source: "PIAF Connected Objects p23"
		},
		PIA_SEC_PROT: {
			description: "Policies describing the means of fire prevention, detection and fighting. Where applicable, indicate the means of preventing water damage. Also specify the means of power supply monitoring and relief.",
			name: "Protecting against non-human sources of risks",
			placeholder: "Indicate here means to avoid to limit non-human sources of risks.",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_SRC: {
			description: "Documentation on implantation area, which should not be subject to environmental disasters (flood zone, proximity to chemical industries, earthquake or volcanic zone, etc.).Specify if dangerous products are stored in the same area.",
			name: "Avoiding sources of risk",
			placeholder: "Indicate here whether the implantation area is subject to environmental disasters",
			source: "PIAF Connected Objects p23 - WIKI"
		},
		PIA_SEC_WEB: {
			description: "Implementation of ANSSI's Recommendations for securing websites.",
			name: "Website security",
			placeholder: "Indicate here controls implemented to protect websites.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_ANO: {
			description: "Indicate here whether anonymisation mechanisms are implemented, which ones and for what purpose. <br>Remember to clearly distinguish between anonymous and pseudonymous data.",
			name: "Anonymisation",
			placeholder: "Indicate here implemented anonymisation mechanisms",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_ARCH: {
			description: "Where applicable, describe here the processes of archive management (delivery, storage, consultation, etc.) under your responsibility. Specify the archiving roles (offices of origin, transferring agencies, etc.) and the archiving policy. State if data may fall within the scope of public archives.",
			name: "Archiving",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of stored data, which ones and for what purpose.",
			source: "PIAF Connected Objects p22 - WIKI"
		},
		PIA_TEC_CHIF: {
			description: "Means implemented for <strong>ensuring the confidentiality</strong> of data stored (in the database, in flat files, backups, etc.), as well as the procedure for managing encryption keys (creation, storage, change in the event of suspected cases of data compromise, etc.).<br> Describe the encryption means employed for data flows (VPN, TLS, etc.) implemented in the processing others.",
			name: "Encryption",
			placeholder: "Describe here the means implemented for ensuring the confidentiality of data",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CLO: {
			description: "Implementation of data partitioning helps to reduce the possibility that personal data can be correlated and that a breach of all personal data may occur.",
			name: "Partitioning data",
			placeholder: "Indicate here if processing partitioning is planned, and how this is carried out.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_CTLA: {
			description: "Methods to define and attribute users profiles. Specify the <strong>authentication</strong> means implemented . Where applicable, specify the rules applicable to passwords (minimum length, required characters, validity duration, number of failed attempts before access to account is locked, etc.).",
			name: "Logical access control",
			placeholder: "Indicate here how users profiles are defined and attributed.",
			source: "PIAF Connected Objects p21"
		},
		PIA_TEC_LOG: {
			description: "Policies that define traceability and log management.",
			name: "Traceability (logging)",
			placeholder: "Indicate here whether events are logged and how long these traces are stored for.",
			source: "PIAF Connected Objects p22"
		},
		PIA_TEC_MINI: {
			description: "The following methods could be used : Filtering and removal, Reducing sensitivity via conversion, Reducing the identifying nature of data, Reducing data accumulation, Restricting data access",
			name: "Minimising the amount of personal data",
			placeholder: "Indicate here means implemented to reduce the severity of risks by limiting the amount of personal data",
			source: "PIAF Connected Objects p40"
		},
		PIA_TEC_PAP: {
			description: "Where paper documents containing data are used during the processing, indicate here how they are printed, stored, destroyed and exchanged.",
			name: "Paper document security",
			placeholder: "Indicate here whether mechanisms are implemented for integrity monitoring of paper documents, which ones and for what purpose.",
			source: "PIAF Connected Objects p22"
		},
		PIA_VAL_ACT: {
			description: "corrective controls suggested by the assessor in previous steps, drawing up an action plan setting out, for each action, its manager, frequency, difficulty, cost and progress.",
			name: "Action plan",
			source: "None"
		},
		PIA_VAL_CART: {
			description: "Graph illustrating the good security practices, with a conformity value attributed to each on the basis of its assessment in previous steps.",
			name: "Mapping of risks",
			source: "PIAF Connected Objects p34"
		},
		PIA_VAL_CONC: {
			description: "Where appropriate, the controller shall seek the views of data subjects or their representatives on the intended processing, without prejudice to the protection of commercial or public interests or the security of processing operations. See Art. 35.9 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br>These views may be gathered by diverse means, depending on the context (internal or external study on the processing methods and purpose, question for the attention of staff representatives or trade unions, survey among future customers of the data processor). <strong>Where the data controller decides to go against the views of the data subjects</strong>, he must note down <strong>the justification for this decision</strong>. Where the data controller considers that <strong>gathering the views of the data subjects is not relevant, he must also note down the justification thereof</strong>.",
			name: "Data subject's opinion",
			source: "GDPR Art. 35.9 and PIAF Connected Objects p38"
		},
		PIA_VAL_DPO: {
			description: "The controller shall seek the advice of the data protection officer, where designated, when carrying out a data protection impact assessment. See Art. 35.2 of the <a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&from=EN\">[GDPR]</a><br> <strong>This view may be against the processing being implemented, without restricting the decision of the data controller for all that</strong>.",
			name: "DPO's opinion",
			source: "GDPR Art. 35.2 and PIAF Connected Objects p37"
		},
		PIA_VAL_RT: {
			description: "Decide on whether the selected controls, residual risks and action plan are acceptable, with justifications, in view of the previously identified stakes and views of the stakeholders. In this way, the PIA may be:<br>- validated<br>- conditional on improvement (explain in what way)<br>- refused (along with the processing under consideration). Where necessary, repeat the previous steps so that the PIA can be validated. This decision does not prejudge the compliance assessment which may be carried out, where applicable, by the Data Protection Authority (the CNIL in France), as part of preliminary formalities or checks for example.",
			name: "Formal validation",
			source: "PIAF Connected Objects p40"
		}
	},
	title: "Knowledge base"
};
var measures$1 = {
	add: "Add an empty measure (otherwise, use the knowledge base)",
	default_placeholder: "Describe the existing or intended measures to ensure data security.",
	edit: "Edit measure",
	placeholder_title: "Measure title",
	remove: "Delete measure"
};
var misc$1 = {
	display: "Show / Hide"
};
var modals$1 = {
	abandon_pia: {
		additional_text: "Archiving is not definitive and the PIA can go back to it if needed.",
		content: "Do you wish to give up the processing?"
	},
	action_plan_no_evaluation: {
		content: "You need to begin the review of the analysis to create the action plan.",
		review_section: "Review a section"
	},
	archive: "Archive",
	archive_pia: {
		archive: "Archive AIIA",
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>archive this PIA ?"
	},
	ask_for_evaluation: {
		content: "This section is ready to be reviewed."
	},
	back_to_edition: {
		content: "This section has been sent back for editing.<br> Several fields must be corrected<br> to enable its proper review."
	},
	back_to_evaluation: {
		content: "This section has been sent back for review.<br> Several fields must be reviewed<br> to enable its proper validation."
	},
	back_to_home: "Back to home",
	cancel: "Cancel",
	close: "Close",
	completed_edition: {
		content: "The PIA has been fully edited and has to be reviewed."
	},
	completed_evaluation: {
		content: "The PIA has been fully reviewed and can be validated."
	},
	"continue": "Continue",
	declare_measures: {
		content: "Before evaluating risks,<br>you must report the<br>existing or planned measures.",
		declare: "Declare existing or planned measures"
	},
	dpo_missing_evaluations: {
		comment: "Comment",
		content: "You need to complete the review of the analysis to access the DPO page.",
		remove: "Remove",
		review_section: "Review a section"
	},
	general_error: {
		content: "All our apologies an error has occurred."
	},
	import_wrong_pia_file: {
		content: "The imported file doesn't correspond to a PIA report file."
	},
	import_wrong_structure_file: {
		content: "The imported file doesn't correspond to a PIA template file."
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "The content of the PIA has been copied to clipboard."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>Warning,</span><br>At least one measure must be filled: no deletion possible."
	},
	recover_version: {
		"continue": "Continue",
		message: "By continuing, you will restore this report version: {{date}}.<br><br>The current version will be saved.",
		title: "Restore a previous version"
	},
	refuse_pia: {
		content: "As you have rejected the PIA, it is sent back for review to make the required changes."
	},
	remove_attachment: {
		comment: "Comment",
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>remove this attachment?",
		keep: "Keep",
		remove: "Remove"
	},
	remove_measure: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to <br>remove this measure?",
		keep: "Keep this <br>measure",
		remove: "Remove this <br>measure"
	},
	remove_pia: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>remove permanently this PIA?",
		remove: "Remove this PIA"
	},
	remove_question: {
		content: "Are you sure you want to delete the question?",
		keep: "Cancel",
		remove: "Delete"
	},
	remove_structure: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want<br>to delete the template?",
		remove: "Delete template"
	},
	same_comment: {
		content: "<span class='strong'>Warning,</span><br>Please enter a comment different from the last recorded."
	},
	signed_pia_validation: {
		content: "To approve the PIA, attach the signed report.",
		download_pia: "Download report"
	},
	simple_pia_validation: {
		content: "You have approved the PIA."
	},
	start_evaluation: "Start review",
	unarchive_pia: {
		content: "<span class='strong'>Warning,</span><br>Are you sure you want to<br>unarchive this PIA ?",
		unarchive: "Unarchive PIA"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "The server address has been updated."
	},
	validate_evaluation: {
		content: "This section is ready for validating the PIA."
	},
	validate_evaluation_to_correct: {
		content: "Sorry,<br>Several fields must be corrected.<br>Return to edition mode<br>to make corrections."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding$1 = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions$1 = {
	content: ", consider that :",
	dpo_lock: "Please complete the other sections before you can fill the DPO opinion.",
	dpo_opinion: "DPO opinion",
	edit: "Edit",
	people_opinion: "Concerned people opinion",
	placeholder_concerned_people_name: "Concerned people name(s)",
	placeholder_dpo_name: "DPO name(s)",
	placeholder_dpo_opinion: "Specify the reasons for your choice.",
	placeholder_people_opinion: "Describe how the opinions were collected and what the analysis is. If the opinions have not been sought, state the reasons.",
	placeholder_search_content: "Justify the reason why the opinion of the persons concerned has not been requested.",
	treatment_lock: "Please complete the other sections before you can fill the opinions of the persons concerned.",
	treatment_nok: "The processing operation should not be used.",
	treatment_ok: "The processing operation could be implemented."
};
var pia$1 = {
	attachments: {
		add: "Add",
		download: "Download the attachment",
		loading: "TO TRANSLATE - Uploading...",
		remove: "Remove",
		title: "Attachments",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "Ask for review",
		mandatory_fields: "All fields must be filled",
		structure_add_question: "Add a question",
		subsection_validated: "Subsection reviewed, awaiting final validation",
		validate_evaluation: "Validate review"
	},
	header: {
		display_action_plan: "Display<br>action plan",
		edition: "Edition",
		evaluation: "Evaluation",
		preview: "Preview"
	},
	sections: {
		based_on_structure_name: "Based on template:",
		homepage_link: "Back to dashboard",
		refuse_pia: "Refused AIIA",
		status: {
			evaluation: {
				cancel: "cancel the review request.",
				cancel_button: "Cancel the review request",
				content: "This part has not yet been reviewed. If you wish to edit the content submitted for review you have to ",
				title: "Waiting for review."
			},
			validation: {
				cancel: "cancel the validation request.",
				cancel_button: "Cancel the validation request",
				content: "This part has been reviewed and is waiting for the overall PIA validation. If you wish to change the review, you have to ",
				title: "Waiting for validation."
			}
		},
		validate_pia: "Validate PIA"
	},
	statuses: [
		"In progress",
		"Rejected",
		"Simple validation",
		"Signed validation",
		"Archived",
		"Waiting for validation"
	]
};
var questions$1 = {
	edit: "Edit question",
	gauges: [
		"(Undefined)",
		"Negligible",
		"Limited",
		"Important",
		"Maximum"
	],
	placeholder_title: "Question title (mandatory)",
	remove: "Delete question"
};
var rejection_page$1 = {
	applied_adjustments: "Adjustments proposed",
	applied_adjustments_placeholder: "Describe the changes brought to the PIA.",
	button: {
		abandon_treatment: "Abandon processing",
		reject_pia: "Reject AIIA",
		send_for_validation: "Resend for approval"
	},
	previous_rejection: "Previous refusal",
	rejection_reason: "Refusal reason",
	rejection_reason_placeholder: "Describe the reasons for refusing the PIA.",
	title: "Validation history"
};
var sections$1 = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Present a brief outline of the processing: its name, purposes, stakes, context of use, etc.",
						title: "What is the processing under consideration?"
					},
					"2": {
						placeholder: "Describe the responsibilities of the stakeholders: the data controller, the possible data processors and joint controllers.",
						title: "What are the responsibilities linked to the processing?"
					},
					"3": {
						placeholder: "List the relevant standards applicable to the processing, especially approved codes of conduct and data protection certifications.",
						title: "Are there standards applicable to the processing?"
					}
				},
				short_help: "List the data (end-user, common, training data, test data, functional, diagnostic, telemetry) collected and processed. Define for each the storage durations, the recipients and persons with access thereto.",
				title: "Nature, scope, context, purpose"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "List the data (end-user, common, training data, test data, functional, diagnostic, telemetry) collected and processed. Define for each the storage durations, the recipients and persons with access thereto.",
						title: "What are the data types processed?"
					},
					"2": {
						placeholder: "Present and describe how the AI system or product generally works (from training and test data, and data collection to the data destruction, the different processing stages, storage, etc.), using for example a data flow diagram (add it as an attachment) and a detailed description of the AI system processes carried out.",
						title: "How does the life cycle of data and processes work?"
					},
					"3": {
						placeholder: "List the data supporting assets (operating systems, business applications, database management systems, office suites, protocols, configurations, etc.)",
						title: "What are the AI system supporting assets?"
					}
				},
				short_help: "This part allows you to define and describe the scope of the processing in detail.",
				title: "Data, AI system and supporting assets"
			}
		},
		short_help: "This section gives you a clear view of the AI system and processing of personal data in question.",
		title: "Context"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "Explain why the processing purposes are specified, explicit and legitimate.",
						short_title: "Intended Purposes",
						title: "Are the processing intended purposes specified, explicit and legitimate?"
					},
					"2": {
						placeholder: "Describe what is/are the legal basis of your processing (ex: consent, performance of a contract, compliance with a legal obligation, protecting the vital intests, etc.)",
						short_title: "Legal basis",
						title: "What are the legal basis making the processing lawful?"
					},
					"3": {
						placeholder: "Explain why each of the data collected is necessary for the purposes of your processing.",
						short_title: "Adequate data",
						title: "Are the data collected adequate, relevant and limited to what is necessary in relation to the purposes for which they are processed ('data minimisation')?"
					},
					"4": {
						placeholder: "Describe which are the steps taken to ensure the quality of the data.",
						short_title: "Data accuracy",
						title: "Are the data accurate and kept up to date?"
					},
					"5": {
						placeholder: "Explain why the storage durations are justified by legal requirements and/or processing needs.",
						short_title: "Storage duration",
						title: "What are the storage duration of the data?"
                    },
                    "6": {
                        placeholder: "Explain 6.",
                        short_title: "Storage 6",
                        title: "What are 6?"
                    },
                    "7": {
                        placeholder: "Explain 7.",
                        short_title: "Storage 7",
                        title: "What are 7?"
                    },
                    "8": {
                        placeholder: "Explain 8.",
                        short_title: "Storage 8",
                        title: "What are 8?"
                    },
                    "9": {
                        placeholder: "Explain 9.",
                        short_title: "Storage 9",
                        title: "What are 9?"
                    },
                    "10": {
                        placeholder: "Explain 10.",
                        short_title: "Storage 10",
                        title: "What are 10?"
                    }
				},
				short_help: "This part allows you to demonstrate the legitimacy of your processing operation and of the data processed.",
				title: "Proportionality and necessity"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Describe what is the information given to the data subjects and what are the means to do it.",
						short_title: "Information for the data subjects",
						title: "How are the data subjects informed on the processing?"
					},
					"2": {
						placeholder: "Describe the controls intended to ensure that users' consent has been obtained.",
						short_title: "Obtaining consent",
						title: "If applicable, how is the consent of data subjects obtained?"
					},
					"3": {
						placeholder: "Describe the controls intended for enabling data subjects to access, receive and transmit their data.",
						short_title: "Right of access and to data portability",
						title: "How can data subjects exercise their rights of access and to data portability?"
					},
					"4": {
						placeholder: "Describe the controls intended for enabling data subjects to rectify and erase their data.",
						short_title: "Right to rectification and erasure",
						title: "How can data subjects exercise their rights to rectification and erasure?"
					},
					"5": {
						placeholder: "Describe the controls intended for enabling data subjects to restrict and to object to the processing of their data.",
						short_title: "Right to restriction and to object",
						title: "How can data subjects exercise their rights to restriction and to object?"
					},
					"6": {
						placeholder: "For each processor, describe his responsibilities (duration, scope, purpose, documented processing instructions, prior authorisation) and provide the contracts, codes of conduct and certifications determining its missions and obligations.",
						short_title: "Subcontracting",
						title: "Are the obligations of the processors clearly identified and governed by a contract?"
					},
					"7": {
						placeholder: "For each country outside the European Union where data are stored or processed, name it and tell if it is acknowledged as offering an adequate level of data protection or describe the provisions concerning the transfer.",
						short_title: "Transfers",
						title: "In the case of 6 data transfer outside the European Union, are the data adequately protected?"
					}
				},
				short_help: "This part allows you to demonstrate that you are implementing the necessary means to enable the persons concerned to exercise their rights.",
				title: "Controls to protect the personal rights of data subjects"
			}
		},
		short_help: "This section allows you to build the compliance framework for privacy principles.",
		title: "OBLIGATIONS & RESPONSIBILITIES"
	},
	"3": {
		items: {
			"1": {
				short_help: "This section allows you to identify controls (existing or planned) that contribute to data security.",
				title: "Existing or planned measures"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "Enter the potential impacts",
						title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
					},
					"2": {
						placeholder: "Enter the threats",
						title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
					},
					"3": {
						placeholder: "Enter the risk sources",
						title: "What are the risk <span class='green-highlight'>sources</span>?"
					},
					"4": {
						placeholder: "Click here to select controls which address the risk.",
						title: "Which of the identified <span class='green-highlight'>planned controls</span> contribute to addressing the risk?"
					},
					"5": {
						placeholder: "Justify here the estimated severity of the risk.",
						title: "How do you estimate the <span class='green-highlight'>risk severity</span>, especially according to potential impacts and planned controls?"
					},
					"6": {
						placeholder: "Justify here the estimated likelihood.",
						title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned controls?"
					}
				},
				short_help: "Analyze the causes and consequences of illegitimate access to data, and estimate its severity and likelihood.",
				title: "Illegitimate access to data"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "Enter the potential impacts",
						title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
					},
					"2": {
						placeholder: "Enter the threats",
						title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
					},
					"3": {
						placeholder: "Enter the risk sources",
						title: "What are the risk <span class='green-highlight'>sources</span>?"
					},
					"4": {
						placeholder: "Click here to select controls which address the risk.",
						title: "Which of the identified <span class='green-highlight'>controls</span> contribute to addressing the risk?"
					},
					"5": {
						placeholder: "Justify here the estimated severity of the risk.",
						title: "How do you estimate the <span class='green-highlight'>risk severity</span>, especially according to potential impacts and planned controls?"
					},
					"6": {
						placeholder: "Justify here the estimated likelihood.",
						title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned controls?"
					}
				},
				short_help: "Analyze the causes and consequences of an undesired change in data, and estimate its seriousness and likelihood.",
				title: "Unwanted modification of data"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "Enter the potential impacts",
						title: "What could be the main <span class='green-highlight'>impacts on the data subjects</span> if the risk were to occur?"
					},
					"2": {
						placeholder: "Enter the threats",
						title: "What are the main <span class='green-highlight'>threats</span> that could lead to the risk?"
					},
					"3": {
						placeholder: "Enter the risk sources",
						title: "What are the risk <span class='green-highlight'>sources</span>?"
					},
					"4": {
						placeholder: "Click here to select controls which address the risk.",
						title: "Which of the identified <span class='green-highlight'>controls</span> contribute to addressing the risk?"
					},
					"5": {
						placeholder: "Justify here the estimated severity of the risk.",
						title: "How do you estimate the <span class='green-highlight'>risk severity</span>, especially according to potential impacts and planned controls?"
					},
					"6": {
						placeholder: "Justify here the estimated likelihood.",
						title: "How do you estimate the <span class='green-highlight'>likelihood of the risk</span>, especially in respect of threats, sources of risk and planned controls?"
					}
				},
				short_help: "Analyze the causes and consequences of data loss, and estimate its seriousness and likelihood.",
				title: "Data disappearance"
			},
			"5": {
				short_help: "This visualisation allows you to have a global and synthetic view on the controls effects on the risks they address.",
				title: "Risks overview"
			}
		},
		short_help: "This section allows you to assess the privacy risks, taking into account existing or planned controls.",
		title: "Risks"
	},
	"4": {
		items: {
			"1": {
				short_help: "This visualisation allows you to compare the positioning of the risks between them, before and after application of the complementary controls.",
				title: "Risk mapping"
			},
			"2": {
				short_help: "Plan in detail the implementation of the additional controls identified during the PIA. The action plan is automatically updated when evaluating the different elements comprised in the PIA.",
				title: "Action plan"
			},
			"3": {
				short_help: "Present the advice of the person in charge of data protection and privacy issues (data protection delegate if there is one). Present the views of the data subjects or their representatives.",
				title: "DPO and data subjects' opinions"
			},
			"4": {
				title: "Validate the PIA"
			},
			"5": {
				title: "Rejected PIA"
			}
		},
		short_help: "This section allows you to prepare and formalise the PIA validation.",
		title: "Validation"
	}
};
var settings$1 = {
	content: "Please, provide the address (URL) of the remote server:",
	title: "Settings",
	update: "Update URL"
};
var summary$1 = {
	action_plan: {
		fundamental_principles: "OBLIGATIONS & RESPONSIBILITIES",
		implementation_date: "Expected date of implementation",
		implementation_responsible: "Responsible for implementation",
		measures: "Existing or planned measures",
		no_action_plan: "No action plan recorded.",
		risks: "Risks",
		title: "Action plan"
	},
	actions: {
		complete_download: "Download the full report",
		complete_download_desc: "Export in a .zip archive all the report content (.doc and pictures), attachments and the action plan in a .csv format.",
		individual_download: "Download elements of the report",
		individual_download_desc: "Export specific elements of the report.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "Texts (.doc)",
		individual_download_images: "Visual elements (.png) including the risk overview, the risk mapping and the action plan.",
		individual_download_json: "TO TRANSLATE - Report to import into the PIA tool (.json file)",
		individual_download_select: "Select elements to export:",
		individual_to_download: "Download",
		print: "Print the report",
		print_and_download: "Print and download"
	},
	attachments: "Attachments",
	concerned_people_name: "Concerned people opinions",
	concerned_people_opinion: "Concerned people opinions",
	concerned_people_searched_opinion: "Search of concerned people opinion",
	concerned_people_status: "Concerned people statuses",
	concerned_people_unsearched_opinion_comment: "Reason why concerned people opinion wasn't requested",
	content_choice: [
		"The treatment should not be used.",
		"The treatment could be implemented."
	],
	creation_date: "Creation date",
	csv_action_plan_comment: "Action plan comment",
	csv_evaluation_comment: "Evaluation comment",
	csv_file_title: "action-plan",
	csv_implement_date: "Estimated implementation date",
	csv_people_in_charge: "Person in charge",
	csv_section: "Section",
	csv_title_object: "Title",
	download_csv: "Action plan (.csv)",
	dpo_name: "DPO's name",
	dpo_opinion: "DPO's opinion",
	dpo_status: "DPO's status",
	gauges: {
		"1": "Negligible",
		"2": "Limited",
		"3": "Important",
		"4": "Maximum"
	},
	modification_made: "Modifications made",
	people_search_status_nok: "Concerned people opinion wasn't requested.",
	people_search_status_ok: "Concerned people opinion was requested.",
	pia_assessor: "Assessor's name",
	pia_author: "Author's name",
	pia_name: "PIA",
	pia_validator: "Validator's name",
	preview_dpo_opinion: "TO TRANSLATE - DPO and data subjects opinion",
	preview_edition: "Editing",
	preview_evaluation: "Evaluation",
	preview_no_data: "No data to display.",
	preview_status: "Status",
	preview_subtitle: "General information",
	preview_title: "Preview",
	preview_validation: "Validation",
	preview_validation_section: "Validation",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "Back to previous page",
	rejection_reason: "Rejection reason",
	revision: {
		current_version: "Current version",
		pia_version: "PIA versions",
		restore_version: "Restore",
		revision: "Versions and revision",
		save: "Create a new version",
		show: "Display the {{length}} versions"
	},
	risks_cartography_title: "Risk mapping",
	risks_overview_title: "Risks overview",
	title: "PIA information"
};
var users$1 = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page$1 = {
	add_signed_pia: "Add the signed AIIA",
	after_reading: "After reading full PIA relating to the data processing linked to ",
	button: {
		rejection: "Reject AIIA",
		signed_validation: "Approve PIA <br>(signed)",
		simple_validation: "Approve PIA <br>(direct)"
	},
	confirmation1: "I attest that the context of the processing described in the PIA is consistent with the reality.",
	confirmation2: "I attest that I am aware of the risks depending on the existing or planned measures.",
	confirmation3: "I ratify the corrective actions indicated in the action plan.",
	confirmation4: "I commit to implement as quickly as possible the indicated corrective actions.",
	latest_signed_attachment: "Last signed attachment",
	mandatory_fields: "All boxes must be checked",
	remove_attachment: "Remove the attachment",
	responsible: "Person accountable for validating the PIA: ",
	signed_attachments_history: "Signed attachments history",
	tools: {
		dashboard: "Dashboard",
		display_pia: "Display report"
	},
	validated_pia_with_signature: "Approved",
	waiting_for_signature: "Pending signed PIA"
};
var lv = {
	about: about$1,
	action_plan: action_plan$1,
	authentication: authentication$1,
	cartography: cartography$1,
	comments: comments$1,
	conflict: conflict$1,
	date: date$1,
	errors: errors$1,
	evaluations: evaluations$1,
	header: header$1,
	help: help$1,
	homepage: homepage$1,
	knowledge_base: knowledge_base$1,
	measures: measures$1,
	misc: misc$1,
	modals: modals$1,
	onboarding: onboarding$1,
	opinions: opinions$1,
	"overview-risks": {
	important: "Important",
	limited: "Limited",
	maximal: "Maximal",
	measures: "Measures",
	negligible: "Negligible",
	potential_impacts: "Potential impacts",
	"risk-access_x": "Severity",
	"risk-access_y": "Likelihood",
	"risk-change_x": "Severity",
	"risk-change_y": "Likelihood",
	"risk-disappearance_x": "Severity",
	"risk-disappearance_y": "Likelihood",
	sources: "Sources",
	threat: "Threats"
},
	pia: pia$1,
	questions: questions$1,
	rejection_page: rejection_page$1,
	sections: sections$1,
	settings: settings$1,
	summary: summary$1,
	users: users$1,
	validation_page: validation_page$1
};

var about = {
	contribute: "إذا كنت ترغب في المساهمة في ترجمة الأداة أو في تحسين الترجمات المتوفرة، ندعوك إلى < a href=\"https://github.com/LINCnil/pia/tree/master/src/assets/i18n\" target=\"_blank\">قراءة الصفحة التي تصف الخطوات التي ينبغي اتباعها</a>.",
	description: "صممت هذه الأداة في الأصل من طرف <a target=\"_blank\" href=\"https://www.cnil.fr\">اللجنة الوطنية للمعلوماتية والحريات (CNIL)</a>، وهي الهيئة المعنية بحماية البيانات في فرنسا، بهدف دعم المسؤولين عن معالجة البيانات في امتثالهم للائحة العامة لحماية البيانات. وقد تم تطويرها من قِبل <a href=\"https://atnos.com\" target=\"_blank\">ATNOS</a>.<br>إن هذه الأداة متاحة بشكل حر ومفتوحة بموجب الترخيص GPLv3. هذا ويمكنك المساهمة فيها من خلال تحميل الشفرة المصدرية وتعديلها وإعادة توزيعها على الجمهور.",
	licences: "تراخيص المكتبات:",
	title: "بشأن أداة تقييم أثر حماية البيانات (PIA)",
	translators: "إن الأداة متاحة حالياً بثمان عشرة لغة. وقد قامت اللجنة الوطنية للمعلوماتية والحريات بتزويد النسختين الفرنسية والإنجليزية. في المقابل، فإن النسخ الأخرى هي ثمرة مساهمات الأشخاص التالية أسماؤهم:",
	"translator’s_name": "<ul><li>الألمانية: <a target=\"_blank\" href=\"https://github.com/kosmas58\">كوسماس شوتز</a>، كورينا شايتر (<a target=\"_blank\" href=\"https://www.datenschutz-bayern.de/\">BayLfD</a>)؛</li><li>الإنجليزية: <a target=\"_blank\" href=\"https://www.cnil.fr\">CNIL</a>؛</li><li>الكرواتية: <a target=\"_blank\" href=\"https://github.com/B2KapitalBA\">(B2KapitalBA)</a>؛</li><li>الدنماركية <a target=\"_blank\" href=\"https://github.com/moolsen\">مايكل دروس أولسن</a>؛</li><li>الإسبانية:  <a target=\"_blank\" href=\"https://github.com/ylachgar\">(ylachgar)</a>؛</li><li>الإستونية: إيفا أروميتس، لوري بندر، ريبيكا درونيا، كارول كيبينا، سايمون سوبان، , <a target=\"_blank\" href=\"https://kochpartners.ee/en/people/urmas-kukk/\">أورماس كوك، <a target=\"_blank\" href=\"https://github.com/PrivacyAssessment1\">(PrivacyAssessment1)</a>؛</li><li> الفنلندية: <a target=\"_blank\" href=\"https://tietosuoja.fi/etusivu\">مكاب المفوض المعني بحماية البيانات</a>؛</li><li>الفرنسية: <a target=\"_blank\" href=\"https://www.cnil.fr\">اللجنة الوطنية للمعلوماتية والحريات</a>؛</li><li>اليونانية: <a target=\"_blank\" href=\"https://tzellis.gr\">ديميتريس تزيليس</a>؛</li><li>المجرية: <a target=\"_blank\" href=\"https://naih.hu\">الهيئة الوطنية المجرية لحماية البيانات وحرية المعلومات</a>؛</li><li>الإيطالية: مانويل دورسو، جيانلوكا ماركوس،أنطونيو كازيلي (<a target=\"_blank\" href=\"http://gpdp.it\">الهيئة الإيطالية لحماية البيانات</a>)؛</li><li>الليتوانية: بوليوس غالوبيكاس (<a target=\"_blank\" href=\"http://galubickas.lt\">مكتب المحاماة غالوبيكاس</a>)؛</li><li>الهولندية: رود فان درايل، مانويل دورسو؛</li><li>النرويجية: <a target=\"_blank\" href=\"https://www.datatilsynet.no\">الهيئة النرويجية لحماية البيانات</a>؛</li><li>البولندية: <a target=\"_blank\" href=\"https://github.com/JoannaKar\">جوانا كارشيفسكا</a>، ميشال مازور ((<a target=\"_blank\" href=\"https://giodo.gov.pl\">مكتب رئيس حماية البيانات الشخصية</a>)؛</li><li>البرتغالية: <a target=\"_blank\" href=\"https://github.com/bagois\">باربرا غويش</a>؛</li><li>الرومانية: <a target=\"_blank\" href=\"https://github.com/webmyday\">(webmyday)</a>؛</li><li>التشيكية: جيري غروهمان، مانويل دورسو. </ul></li>",
	version_number: "رقم النسخة"
};
var action_plan = {
	acceptable_measures: "التدابير المقبولة",
	edit: "تعديل",
	improvable_measures: "التدابير القابلة للتحسين",
	measures: "التدابير الموجودة أو المرتقبة",
	no_action_plan: "لا وجود لخطة عمل مسجلة",
	placeholder_person_in_charge: "المسؤول عن التنفيذ",
	principles: "المبادئ الأساسية",
	risk1: "الوصول غير المشروع للبيانات",
	risk2: "التعديل غير المرغوب فيه للبيانات",
	risk3: "اختفاء البيانات",
	risks: "المخاطر",
	title: "نظرة عامة"
};
var authentication = {
	"12_characters": "TO TRANSLATE - 12 characters",
	account_recovery: "TO TRANSLATE - Password recovery",
	activation_code: "TO TRANSLATE - Activation code",
	cancel: "TO TRANSLATE - Cancel",
	confirm: "TO TRANSLATE - Confirm",
	confirmation: "TO TRANSLATE - Confirmation",
	"continue": "TO TRANSLATE - Continue",
	activate_account: "TO TRANSLATE - activate account",
	create_account: "TO TRANSLATE - Sign up",
	create_account2: "TO TRANSLATE - Create account",
	description: "يُعد برنامج تقييم أثر حماية البيانات الذي أطلقته </strong>اللجنة الوطنية للمعلوماتية والحريات</strong> جزءاً من نهج يدعم المسؤولين عن معالجة البيانات في تنفيذ التزامات اللائحة العامة لحماية البيانات. إنه يدعم عملية تحليل الأثر المتعلقة بحماية البيانات كما يرمي إلى تيسير اعتماد دلائل برنامج تقييم أثر حماية البيانات التابعة للجنة الوطنية للمعلوماتية والحريات.",
	email: "TO TRANSLATE - Email",
	email_placeholder: "TO TRANSLATE - Email",
	forgotten_password: "TO TRANSLATE - Forgotten ?",
	login: "TO TRANSLATE - Login",
	lowercase: "TO TRANSLATE - Lowercase",
	password: "TO TRANSLATE - Password",
	password_security: "TO TRANSLATE - Password security",
	recovery_code: "TO TRANSLATE - Reset code",
	recovery_code_message: "TO TRANSLATE - An email containing a code has been sent to this email. Please enter the code in the field below.",
	recovery_code_not_sent: "TO TRANSLATE - Unreceived code?",
	saved_password: "TO TRANSLATE - Your password is saved. You can now sign in.",
	sign_in: "TO TRANSLATE - Sign in",
	sign_in_button: "TO TRANSLATE - Sign in",
	sign_out_button: "TO TRANSLATE - Sign out",
	special_character: "TO TRANSLATE - Special character (!@#$%^&*()?...)",
	number: "TO TRANSLATE - Number",
	start: "البداية",
	start_app: "الولوج إلى أداة تقييم أثر حماية البيانات (مرحلة بيتا)",
	subtitle1: "منصة من أجل إنشاء <br> وإدارة أدواتكم الخاصة بتقييم أثر حماية البيانات،",
	subtitle2: "الولوج إلى الأدوات والمسارد",
	title: "تحليل أثر <br> حماية البيانات",
	transaction_error: "TO TRANSLATE - Unable to process your request.",
	uppercase: "TO TRANSLATE - Uppercase",
	wrong_activation_code: "TO TRANSLATE - (wrong)",
	wrong_confirmation: "TO TRANSLATE - Passwords are not the same",
	wrong_email: "TO TRANSLATE - Wrong email",
	sso: "TO TRANSLATE - SSO connection",
	errors: {
		sign_in: {
			"400": "TO TRANSLATE - Wrong email or password."
		},
		create_account: {
			uuid: {
				"404": "TO TRANSLATE - Wrong activation code",
				"406": "TO TRANSLATE - This account is already activated"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		account_recovery: {
			email: {
				"404": "TO TRANSLATE - User not found",
				"423": "TO TRANSLATE - Account locked"
			},
			uuid: {
				"404": "TO TRANSLATE - Wrong recovery code"
			},
			password: {
				"404": "TO TRANSLATE - User not found",
				"406": "TO TRANSLATE - The password does not meet the password policy requirements."
			}
		},
		unauthorized: "TO TRANSLATE - You are not allowed to access this resource.",
		incompatibility: "TO TRANSLATE - Version incompatibility between your server (pia-back) and your application (pia). Please contact your IT department."
	}
};
var cartography = {
	important: "مهمة",
	legend1: "التدابير الموجودة أو المبرمجة",
	legend2: "مع التدابير التصحيحية المفعلة",
	legend3: "(الوصول) غير المشروع للبيانات",
	legend4: "(التعديل) غير المرغوب فيه للبيانات",
	legend5: "(اختفاء) البيانات",
	likelihood_axe: "احتمال وقوع المخاطر",
	limited: "محدود",
	maximal: "عال",
	negligible: "ضعيف",
	risk1_access: "(الوصول)",
	risk2_modification: "(التعديل)",
	seriousness_axe: "شدة المخاطر"
};
var comments = {
	comment: "تعليق",
	written_by: "TO TRANSLATE - Written by",
	comments_count: "التعليق(ات)",
	new_comment: "القيام بالتعليق",
	placeholder_new_comment: " الإدلاء بتعليق",
	send: "الإرسال"
};
var conflict = {
	keep_initial: "TO TRANSLATE - Keep initial content",
	keep_new: "TO TRANSLATE - Update with new content",
	initial_content: "TO TRANSLATE - Initial content",
	merge: "TO TRANSLATE - Merge both contents",
	new_content: "TO TRANSLATE - New content",
	title: "TO TRANSLATE - Conflict detected"
};
var date = {
	april: "أبريل",
	august: "أغسطس",
	december: "ديسمبر",
	"earlier-in-this-month": "في وقت سابق من هذا الشهر",
	"earlier-in-this-week": "في وقت سابق من هذا الأسبوع",
	february: "فبراير",
	january: "يناير",
	july: "يوليو",
	june: "يونيو",
	march: "مارس",
	may: "مايو",
	november: "نوفمبر",
	october: "أكتوبر",
	september: "سبتمبر",
	today: "اليوم",
	yesterday: "أمس"
};
var errors = {
	content: "إذا صادفتم مشاكل أخرى أو لديكم اقتراحات لتحسين الأداة،<br>يمكنكم إطلاعنا عليها من خلال هذا الاستبيان: <a href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\" target=\"_blank\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>",
	title: "الصفحة غير موجودة."
};
var evaluations = {
	acceptable: "مقبول",
	action_plan_comment: "خطة العمل/التدابير التصحيحية",
	evaluation_comment: "تعليق تقييمي",
	gauges: {
		"0": "(غير محددة)",
		"1": "ضعيفة",
		"2": "محدودة",
		"3": "مهمة",
		"4": "شديدة",
		likelihood: "أخذاً بعين الاعتبار خطة العمل، كيف يمكن إعادة تقييم <span class='red-highlight'>احتمال وقوه هذا الخطر</span>؟",
		seriousness: "أخذاً بعين الاعتبار خطة العمل، كيف يمكن إعادة تقييم <span class='red-highlight'>شدة هذا الخطر</span>؟"
	},
	improvable: "قابل للتحسين",
	placeholder_acceptable: "أدلوا بتعليقاتكم من أجل تفسير كيف أن التدابير المفعلة كافية للاستجابة لمتطلبات حماية البيانات.",
	placeholder_improvable1: "أدلوا بتعليقاتكم من أجل توضيح تدابير أخرى ينبغي إضافتها من أجل تحسين حماية البيانات.",
	placeholder_improvable2: "أدلوا بتعليقاتكم.",
	placeholder_to_correct: " أدلوا بتعليقاتكم من أجل تفسير سبب كون المعلومات المقدمة غير كافية للتمكن من تقييمها. وسيتم إرسال هذا الجزء إلى التعديل من أجل إثراء العرض الأولي.",
	status: [
		"قيد الانتظار",
		"يستوجب التصحيح",
		"قابل للتحسين",
		"مقبول"
	],
	title: "التقييم",
	to_correct: "يستوجب التصحيح"
};
var header = {
	archives: "تقييمات أثر حماية البيانات المحفوظة",
	current_pias: "تقييمات أثر حماية البيانات النشطة",
	exit_full_screen_mode: "اضغط على زر F11 للخروج من وضع ملء الشاشة",
	help: {
		issue_reporting: "التبليغ عن خطأ برمجي",
		manual: "دليل المستخدم",
		pia_example_link: "مثال لتقييم أثر حماية البيانات",
		title: "المساعدة"
	},
	homepage_link: "تقييماتي الخاصة بأثر حماية البيانات",
	knowledge_base_link: "قاعدة البيانات",
	languages: {
		ar: "العربية",
		bg: "български",
		cnil_translations: "الترجمات التي أنجزتها اللجنة الوطنية للمعلوماتية والحريات",
		community_translations: "الترجمات التي أنجزها الجماعة",
		cz: "Česky",
		de: "Deutsch",
		dk: "Dansk",
		dpa_translations: "الترجمة التي تم اعتمادها في تقييم حماية البيانات ",
		el: "Ελληνικά",
		en: "English",
		es: "Español",
		et: "Eesti keel",
		fi: "Suomi",
		fr: "Français",
		hr: "Hrvatski",
		hu: "Magyar",
		it: "Italiano",
		lt: "Lietuviškai",
		lv: "Latviešu valoda",
		nl: "Nederlands",
		no: "Norsk",
		official_translation: "النسخة الأصلية",
		pl: "Polski",
		pt: "Português",
		ro: "Română",
		sl: "Slovenščina",
		sv: "Svenska"
	},
	logo_subtitle: "تقييم أثر الخصوصية",
	logo_title: "تقييم أثر حماية البيانات",
	structures: "نماذج تقييم أثر حماية البيانات",
	tools: {
		about: "عن",
		accessibility: "إمكانية وصول ذوي الإعاقة البصرية (ألوان ذات تباين قوي، ملائمة لعمى الألوان)",
		onboarding: "TO TRANSLATE - Restart tutorial",
		settings: "الإعدادات",
		url_setting: "ضبط خادم محدد موقع الموارد المُوحّد(URL)",
		users: "TO TRANSLATE - Users"
	}
};
var help = {
	definition: {
		data1: {
			content: "محتوى في طور الإعداد",
			title: "استخدام أداة تقييم أثر حماية البيانات"
		},
		data2: {
			qa1: {
				content: "عندما تواجه مشاكل على مستوى العرض، يرجى الخروج من التطبيق وإعادة تشغيله، سيسمح هذا الأمر عموماً بتصحيح هذا النوع من المشاكل. كما يتم حفظ بياناتك في الوقت الحقيقي، لذلك لن تفقد أي معلومات تم إدخالها.",
				title: "أواجه مشاكل على مستوى العرض، كعدم تحديث الأيقونات أو غياب عناصر في الواجهة."
			},
			qa2: {
				content: "هذا الخطأ البرمجي معروف وهو قيد المعالجة. في حال واجهت هذا المشكل، يرجى تحديد تقديركم حول ما مدى فداحته أو واحتمال وقوعه في خانة التفسير، بالإضافة إلى شرح هذا التقدير.",
				title: "لا يمكنني تعديل مقاييس تقييم مدى خطورة واحتمال حدوث خطر ما"
			},
			qa3: {
				content: "تمت ملاحظة العديد من الأخطاء أثناء توريد تقييم أثر حماية البيانات، لا سيما اختفاء مقاييس تقييم مدى خطورة واحتمال حدوث خطر ما. في هذه الحالة، انظر السؤال السابق. إذا لم ترَ تقييمك الخاص بأثر حماية البيانات فلن يظهر في لوحة التحكم الخاصة بتقييمات أثر حماية البيانات، قم بتحديث الصفحة وسيظهر لك.",
				title: "أواجه مشاكل في توريد تقييم لأثر حماية البيانات"
			},
			qa4: {
				content: "هذا مجرد خطأ في العرض ولا يؤثر على المعلومات التي تم إدخالها في تقييم أثر حماية البيانات بأي شكل من الأشكال. سيتم تصحيح هذا المشكل بسرعة.",
				title: "عندما أقوم بالنسخ واللصق، يظهر النص بشكل بارز"
			},
			qa5: {
				content: "لطلب تقييم جزء ما، يجب إكمال ملء جميع الخانات. يرجى التحقق مما إذا كان الأمر كذلك. عند تنقيح أحد المخاطر، من الضروري الإشارة إلى إجراء تقني أو تنظيمي واحد على الأقل لمعالجة المخاطر.",
				title: "لا أستطيع طلب تقييم جزء ما"
			},
			qa6: {
				content: "أغلق تقييم أثر حماية البيانات الذي تقوم بتعديله وافتحه من جديد. ستظهر المحتويات باللغة المختارة.",
				title: " عند تغيير اللغة، لا تتم ترجمة النصوص"
			},
			qa7: {
				content: "حالياً، لا يتم تحديث الأيقونات الموجودة في قائمة التصفح   في الجانب الأيسر بعد رفض التأكيد. يجب إعادة زيارة كل قسم، والتحقق من المعلومات والتقييم حسب أسباب الرفض، وطلب التأكيد مرة أخرى. بعد أن تتم مراجعة جميع الأقسام، سيكون من الممكن إعادة تأكيد تقييم أثر حماية البيانات.",
				title: "لقد رفضت تأكيد تقييم أثر حماية البيانات، لكن لا أعرف ماذا أفعل بعد ذلك "
			},
			title: "الأخطاء البرمجية المعروفة"
		},
		footer: "إذا واجهت مشاكل أخرى أو إذا كانت لديك اقتراحات لإدخال مزيد من التحسينات، فيمكنك إرسالها إلينا عبر هذا النموذج<a target=\"_blank\" href=\"https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia\">https://www.cnil.fr/fr/webform/vos-retours-sur-loutil-pia</a>."
	},
	title: "المساعدة"
};
var homepage = {
	cards: {
		author: "الإدخال",
		category: "الفئة",
		creation_status: "الإنشاء",
		date: "التاريخ",
		evaluation: "التقييم",
		guest: "TO TRANSLATE - Guest(s)",
		import_pia: "استيراد تقييم أثر حماية البيانات",
		import_structure: "استيراد نموذج",
		item: {
			consult_pia: "الاطلاع",
			consult_structure: "الاطلاع على النموذج",
			edit_pia: "التنقيح",
			edit_structure: "تنقيح النموذج",
			tools: {
				action_plan: "عرض<br> خطة العمل",
				archive: "الأرشفة",
				duplicate: "النسخ",
				"export": "التوريد",
				more_options: "المزيد من الخيارات",
				pia: "عرض تقييم أثر حماية البيانات",
				remove: "الحذف",
				unarchive: "الإزالة من الأرشيف"
			},
			validate_pia: "التأكيد"
		},
		knowledges: {
			edit: "TO TRANSLATE - Edit the base",
			"import": "TO TRANSLATE - Import a base",
			"new": "TO TRANSLATE - Create a base",
			placeholder_author: "TO TRANSLATE - Author",
			placeholder_contributors: "TO TRANSLATE - Contributors",
			placeholder_entry_number: "TO TRANSLATE - Number of entries",
			placeholder_name: "TO TRANSLATE - Base's name"
		},
		knowledges_entry: {
			all_sections: "TO TRANSLATE - All sections",
			choose_category: "TO TRANSLATE - Choose a category",
			contents: "TO TRANSLATE - Contents",
			create: "TO TRANSLATE - Create this element",
			linked_to: "TO TRANSLATE - Linked to",
			"new": "TO TRANSLATE - Create an element",
			placeholder_category: "TO TRANSLATE - Category",
			placeholder_description: "TO TRANSLATE - Your description here...",
			placeholder_name: "TO TRANSLATE - Element's name",
			placeholder_updated_at: "TO TRANSLATE - Last updated"
		},
		new_pia: "تقييم جديد لأثر حماية البيانات",
		new_structure: "نموذج جديد",
		or: "أو",
		pia_name: "تقييم أثر حماية البيانات",
		placeholder_author: "الاسم، النسب",
		placeholder_category: "الفئة",
		placeholder_evaluation: "الاسم، النسب",
		placeholder_import_knowledgeBase: "TO TRANSLATE - Import base",
		placeholder_import_pia: "استيراد تقييم أثر حماية البيانات",
		placeholder_import_structure: "استيراد النموذج",
		placeholder_new_knowledgeBase: "TO TRANSLATE - New base",
		placeholder_new_pia: "تقييم جديد لأثر حماية البيانات",
		placeholder_new_structure: "نموذج جديد",
		placeholder_pia_name: "اسم تقييم أثر حماية البيانات",
		placeholder_sector_name: "اسم عنوان القطاع ذي الصلة",
		placeholder_start: "يجب ملء جميع الخانات",
		placeholder_structure: "النموذج التلقائي",
		placeholder_structure_name: "اسم النموذج",
		placeholder_validation: "الاسم، النسب",
		sector_name: "القطاع ذو الصلة",
		start: "البداية",
		status: "الوضع",
		structure: "النموذج",
		structure_name: "اسم النموذج",
		title_close_creation: "الإغلاق",
		validation: "التأكيد"
	},
	filters: {
		assessor: "المُقيِّم",
		author: "المحرر",
		card: "عرض البطاقة",
		card_rocket_content: "انطلق! <br><br>لبدء<br>تقييم أثر حماية البيانات، اضغط<br>على رمز +",
		card_rocket_content_structure: "انطلق! <br><br>لبدء<br>نموذج، اضغط<br>على رمز +",
		category: "الفئة",
		date: "التاريخ",
		import_pia: "استيراد تقييم أثر حماية البيانات",
		import_structure: "استيراد نموذج",
		list: "عرض القائمة",
		list_rocket_content: "انطلق! <br><br>لبدء<br> تقييم أثر حماية البيانات ، اضغط<br>على رمز +",
		list_rocket_content_structure: "انطلق! <br><br>لبدء<br>نموذج، اضغط<br>على رمز +",
		name: "الاسم",
		new_pia: "تقييم جديد لأثر حماية البيانات",
		new_structure: "نموذج جديد",
		sector_name: "الحقل ذو الصلة",
		sort: "الترتيب",
		sort_by: "حسب",
		status: "الوضع",
		validator: "المدقق"
	},
	lists: {
		column_actions: "الإجراءات",
		column_author: "إدخال",
		column_category: "الفئة",
		column_creation: "إنشاء",
		column_evaluation: "تقييم",
		column_pia: "تقييم أثر حماية البيانات",
		column_progression: "التدرج",
		column_sector_name: "القطاع ذو الصلة",
		column_status: "الوضع",
		column_structure: "النموذج",
		column_structure_name: "النموذج",
		column_updated_at: "تم تعديله في",
		column_validation: "التأكيد",
		item: {
			tools: {
				action_plan: "عرض خطة العمل",
				archive: " الأرشفة",
				consult: "اطلاع",
				duplicate: "نسخ",
				edit: "تعديل",
				"export": "توريد",
				pia: "عرض تقييم أثر خصوصية البيانات",
				remove: "الحذف",
				unarchive: "الإزالة من الأرشيف"
			}
		}
	},
	search_filter: "بحث معمق",
	no_entries: {
		pia: "TO TRANSLATE - No PIA created and/or assigned",
		archive: "TO TRANSLATE - No PIA archive"
	}
};
var knowledge_base = {
	add_measure: "إضافة",
	add_measure_hint: "يمكن أيضاً إضافة تدبير انطلاقاً من قاعدة المعارف",
	category: {
		definition: "تعريف",
		example: "مثال",
		general_measure: "التدبير العام لأمن النظام",
		measure_on_data: "تدبير بشأن البيانات",
		method: "المنهجية",
		organizational_measure: "التدبير التنظيمي",
		principle: "المبدأ"
	},
	choose_knowledge_base: "TO TRANSLATE - Choose your knowledge base",
	default_knowledge_base: "TO TRANSLATE - CNIL's knowledge base",
	filters: {
		all: "الكل",
		definitions: "تعاريف",
		general_measures: "تدابير عامة لأمن النظام",
		measures_on_data: "تدابير بشأن البيانات",
		no_result: "لا توجد أي نتيجة",
		organizational_measures: "التدابير التنظيمية",
		title: "المرشحات"
	},
	placeholder_add_measure: "أضف هذا التدبير",
	placeholder_help: "مساعدة بشأن الإدخال",
	search: "بحث",
	slugs: {
		PIA_DEF_ACC: {
			description: "لصاحب البيانات الحق في الحصول من المسؤول عن المعالجة على تأكيد بأنه يتم أو لا يتم معالجة بيانات شخصية تعنيه، وعندما تكون هذه البيانات خاضعة للمعالجة، فإنه يحق للشخص المعني الوصول إليها إضافة إلى معلومات أخرى محددة في <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article15\">article 15 du RGPD</a>.<br>هناك بعض الاستثناءات متعلقة بالوصول إلى الملفات الطبية، انظر <a target=\"_blank\" href=\"https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000773559\">Décret 2002-637</a>، وممارسة الحق في الوصول من طرف أصحاب السلطة الأبوية بالنسبة للقاصرين، أو الممثلين القانونيين بالنسبة للأشخاص الخاضعين لتدبير وصاية، انظر <a target=\"_blank\" href=\"https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000886460\">Article 58 de la loi Informatique et Libertés</a>.",
			name: "الحق في الوصول",
			source: "المادة 15 من اللائحة العامة لحماية البيانات للاطلاع على التعريف، وصفحة ويكي المسماة 'Exercice_des_droits_d’accès_et_à_la_portabilité' للاطلاع على الاستثناءات في القانون الفرنسي"
		},
		PIA_DEF_ANO: {
			description: "إن الهدف من حلٍّ لإخفاء الهوية هو تجريد البيانات الشخصية من كل ما يمكِّن من التعرف على هوية صاحب البيانات بها. ويجب أن يتم بناء الحلول من هذا القبيل وفقاً لكل حالة على حدة وتكييفها مع الاستعمالات المرتقبة لها. من أجل المساعدة على تقييم حل جيد لإخفاء الهوية، يقترح <a target=\"_blank\" href=\"http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_fr.pdf\">G29</a> ثلاثة معايير: التفريد:<br>- <strong>: </strong>هل مازال من الممكن عزل شخص معين؟<br>- <strong>الترابط: </strong>وهل يمكن ربط مجموعات من البيانات المتميزة التي تهم نفس الشخص فيما بينها؟<br>- <strong>والاستدلال: </strong> هل يمكن استخلاص معلومات عن صاحب البيانات؟ <br>وعليه: <strong>تُعد أي مجموعة من البيانات لا يمكن تفريدها وربطها والاستدلال بها عن هوية صاحب البيانات مخفية الهوية مبدئياً</strong>؛<br>لا يمكن اعتبار أي مجموعة بيانات <strong>لم تستفِ معياراً واحداً على الأقل من المعايير الثلاثة </strong>مخفية الهوية إلا بعد تحليل مفصل لمخاطر إعادة تحديد الهوية.",
			name: "إخفاء الهوية",
			source: "صفحة ويكي للمرحلة الأولى، وموقع اللجنة الوطنية للمعلوماتية والحريات للتعريف وتوصيات فريق العمل المعني بالمادة 29 https://www.cnil.fr/fr/le-g29-publie-un-avis-sur-les-techniques-danonymisation-0"
		},
		PIA_DEF_ARCH: {
			description: "يجب أرشفة البيانات التي لم تعد تُستخدم يومياً ولكن لم تتجاوز بعد مدة الاحتفاظ بها، مثلاً لأنه يتم الاحتفاظ بها من أجل الدعاوى القضائية. <br><br><strong>يجب تأمين الأرشيفات </strong>خصوصاً إذا كانت البيانات المؤرشفة بيانات حساسة أو بيانات يمكن أن يكون لها آثار وخيمة على أصحاب البيانات.",
			name: "الأرشفة",
			source: "الدليل الأزرق 2017، ص. 17"
		},
		PIA_DEF_AUTH: {
			description: "المصادقة هي <strong>عملية يقدم من خلالها المستخدم إثباتاً لهويته</strong>، ولهذا توجد عدة آليات مصنفة وفقاً لما إذا كانت تنطوي على: <br>- ما يعرفه الشخص، مثل كلمة السر؛<br>- ما يملكه الشخص، مثل بطاقة ذكية؛<br>- خاصية متميزة لدى الشخص، مثل بصمة الأصبع أو الطريقة التي يوقع بها بخط اليد. <br>وللتذكير، يخضع قانون المعلوماتية والحريات لاستخدام القياسات الحيوية عند الموافقة المسبقة للجنة الوطنية للمعلوماتية والحريات<br><strong>ويتم اعتبار مصادقة شخص ما على أنها قوية عندما تنطوي على اثنين من هذه الفئات على الأقل.</strong>",
			name: "المصادقة",
			source: "الدليل الأزرق، ص. 7"
		},
		PIA_DEF_CHIF: {
			description: "يسمح تشفير رسالةٍ ما بضمان أن تقتصر معرفة محتواها على الجهة المرسلة والجهة(ات) المتلقية المشروعة. وهو بمثابة ظرف رقمي مختوم. فبمجرد تشفير الرسالة، لا يمكن الوصول إليها ولا يمكن قراءتها، سواء من قبل البشر أو الآلات، إلا من خلال التوفر على المفتاح الخاص. <br>وهناك صنفان رئيسيان من التشفير: التشفير المتماثل والتشفير غير المتماثل.<strong>-<br>يسمح التشفير المتماثل</strong> بتشفير وفك تشفير محتوى الرسالة بواسطة مفتاح واحد يسمى 'المفتاح السري', ويتسم التشفير المتماثل على وجه الخصوص بالسرعة إلا أنه يستوجب اتفاق الجهة المرسلة والجهة المتلقية حول مفتاح سري مشترك أو إرساله عبر قناة أخرى. ويجب اختيار هذه الأخيرة بعناية، وإلا فإنه يمكن للأشخاص الخطأ الحصول على المفتاح السري، وهو ما لا يضمن سرية الرسالة بعد ذلك. <strong>-<br>أما التشفير غير المتماثل</strong> فيفترض أن الجهة المتلقية (المستقبلية) تملك زوجاً من المفاتيح (أحدهما مفتاح خاص والآخر عام)، وأن لدى الجهات المرسلة المحتملة إمكانية إلى مفتاحه العام. في هذه الحالة، تستخدم الجهة المرسلة المفتاح العام للجهة المتلقية لتشفير الرسالة بينما تستخدم الجهة المتلقية مفتاحها الخاص لفك تشفيرها. ومن بين مزايا المفتاح العام أنه يمكن أن يكون معروفاً لدى الجميع وأن يتم نشره. ولكن يتوجب توخي الحذر: يجب أن تثق الجهات المرسلة في أصل المفتاح العام، وأن تكون متيقنة من أنه خاص بالجهة المتلقية. ومن بين نقاطه القوية الأخرى أنه لا حاجة لمشاركة نفس المفتاح السري! فالتشفير غير المتماثل يلغي الحاجة إلى ذلك، إلا أنه أبطأ.",
			name: "التشفير",
			source: "الصفحة 23 من الدليل الأزرق لسنة 2017 https://www.cnil.fr/fr/comprendre-les-grands-principes-de-la-cryptologie-et-du-chiffrement"
		},
		PIA_DEF_CLO: {
			description: "مجموعة من الطرق التي تسمح بالحد من إمكانية ربط البيانات ذات الطابع الشخصي والتسبب في خرق البيانات ككل. <br> يمكننا على سبيل المثال تحديد البيانات الخاصة بكل مهنة وفصلها بشكل منطقي، وما إلى ذلك.",
			name: "فصل البيانات",
			source: "WIKI Cloisonnement_des_données_(par_rapport_au_reste_du_système_d’information)"
		},
		PIA_DEF_CONS: {
			description: "أي إرادة واضحة وحرة ومحددة ومستنيرة ولا لبس فيها، والتي يقبل من خلالها صاحب البيانات، بواسطة تصريح أو فعل إيجابي واضح، بأن تخضع البيانات ذات الطابع الشخصي التي تخصه للمعالجة.",
			name: "موافقة صاحب البيانات",
			source: "المادة 10.4 من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_CTLA: {
			description: "يتعلق الأمر بالحد من مخاطر وصول أشخاص غير مرخص لهم إلى البيانات ذات الطابع الشخصي. <br>ولذلك، يتعين<strong>-<br>:تحديد ملفات  الترخيص</strong>في الأنظمة من خلال فصل المهام ونطاقات المسؤولية، من  أجل جعل وصول المستخدمين مقتصراً على البيانات الضرورية فقط لإتمام مهامهم. <strong>-<br>حذف تراخيص وصول المستخدمين حالما لم يعد مرخص لهم بالوصول إلى مكان أو مصدر معلوماتي</strong>، وعند<strong>انتهاء عقودهم. <strong>-<br></strong>مراجعة سنوية  للتراخيصالمؤكدة </strong>  من أجل تحديد وحذف الحسابات غير المستعملة وترتيب الحقوق الممنوحة حسب مهام كل مستخدم.",
			name: "مراقبة الوصول المنطقي",
			source: "WIKI Contrôle_des_accès_logiques والصفحة 9 من الدليل الأزرق لسنة 2017 بشأن الاحتياطات"
		},
		PIA_DEF_DCP: {
			description: "أي معلومات تتعلق بشخص طبيعي محدد أو قابل للتحديد (يشار إليه فيما يلي بـ'صاحب البيانات')؛ إن 'الشخص الطبيعي القابل للتحديد' هو الشخص الذي يمكن التعرف على هويته بشكل مباشر أو غير مباشر، خاصة من خلال الرجوع إلى أحد المعرفات مثل الاسم أو رقم التعريف أو بيانات الموقع أو معرف على الإنترنت أو إلى عنصر محدِّد أو أكثر لهويته الجسدية أو الفيزيولوجية أو الجينية أو النفسية أو الاقتصادية أو الثقافية أو الاجتماعية.",
			name: "البيانات ذات الطابع الشخصي",
			source: " المادة 1.4 من اللائحة العام لحماية البيانات"
		},
		PIA_DEF_DEST: {
			description: "شخص طبيعي أو اعتباري، أو سلطة عامة أو وكالة أو هيئة أخرى تتلقى بيانات ذات طابع شخصي، سواء تعلق الأمر يطرف ثالث أم لا. ومع ذلك، لا تعتبر السلطات العامة التي قد تتلقى بيانات ذات طابع شخصي في إطار مهمة تحقيق خاصة، بمقتضى قانون الاتحاد أو قانون دولة عضو، بمثابة جهات متلقية؛ وتكون معالجة هذه البيانات من قبل السلطات العامة المعنية مطابقة للقواعد المعمول بها في مجال حماية البيانات وفقاً لأغراض المعالجة.",
			name: "الجهة المتلقية للبيانات",
			source: "المادة 9.4 من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_EFF: {
			description: "من حق صاحب البيانات على المسؤول عن المعالجة محو بياناته ذات الطابع الشخصي في أقرب الآجال، وفقاً للمادة 17 من اللائحة العامة لحماية البيانات<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article17\">article 17 du RGPD</a>",
			name: "الحق في المحو (الحق في النسيان)",
			source: "المادة 17 من اللائحة العامة لحماية البيانات (مقتضبة)"
		},
		PIA_DEF_ENJ: {
			description: "يتعلق الأمر بالدوافع المفضية للمعالجة، والمنافع المتوخاة منها (بالنسبة للهيئة، وأصحاب البيانات، والمجتمع ككل...).",
			name: "رهانات المعالجة",
			source: "الصحفة 6 من تقييم أثر حماية البيانات 1 (الهامش8 أسفل الصفحة)"
		},
		PIA_DEF_EXA: {
			description: "يجب أن تكون البيانات ذات الطابع الشخصي مضبوطة، ويجب تحديثها إذا لزم الأمر، كما يجب أخذ كافة التدابير المعقولة من أجل ضمان محو أو تصحيح البيانات ذات الطابع الشخصي غير الدقيقة دون تأخير (الدقة)، مع مراعاة الأغراض التي تتم معالجتها من أجلها، وفقاً للمادة 1.5(د) من اللائحة العامة لحماية البيانات<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article5\">article 5.1 d)</a>.",
			name: "جودة البيانات",
			source: "المادة 1.5(د) من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_GRV: {
			description: "تمثل الخطورة حجم الخطر، وتتوقف بالأساس على الطبيعة الضارة للأثار المحتملة",
			name: "الخطورة",
			source: "الصفحة 9 من تقييم أثر حماية البيانات"
		},
		PIA_DEF_LIM: {
			description: "من حق صاحب البيانات على المسؤول عن المعالجة تقييد المعالجة، وفقاً للمادة 18 من اللائحة العامة لحماية البيانات<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article18\">article 18 du RGPD</a>",
			name: "الحق في تقييد المعالجة",
			source: " المادة 18 من اللائحة العامة لحماية البيانات (مقتضبة)"
		},
		PIA_DEF_LOG: {
			description: " تدبير يسمح بتسجيل الإجراءات المنفذة على النظام المعلوماتي من أجل التمكن من<strong>تحديد وصول احتيالي</strong> أو<strong>إساءة استعمال</strong>للبيانات الشخصية، أو تحديد منشأ الواقعة. يتعين تسجيل بعض الإجراءات التي يتم تنفيذها على النظم المعلوماتية. وللقيام بذلك، يجب وضع تدبير لإدارة الآثار والوقائع. ويجب أن<strong> يسجل هذا الأخير الأحداث ذات الصلة</strong>وأن<strong> يضمن عدم إمكانية إحداث تغيير على هذه التسجيلات. </strong>في جميع الأحوال، يجب<strong> عدم الاحتفاظ بهذه العناصر لفترة مبالغ فيها.<</strong",
			name: "حفظ السجلات",
			source: "الصفحة 10 من الدليل الأزرق لسنة 2017"
		},
		PIA_DEF_MEN: {
			description: "وضع تشغيلي يتكون من إجراء وحدوي واحد أو أكثر على وسائط البيانات. ويمكن استخدام التهديد، عن قصد أو بغير قصد، من قبل مصادر المخاطر، ويمكن أن يتسبب بعد ذلك في حدث يبعث على القلق. ",
			name: "التهديد",
			source: "الصفحة 11 من تقييم أثر حماية البيانات 1"
		},
		PIA_DEF_MENA: {
			description: "التهديدات المتعلقة بـ: <strong>-<br></strong> المعدات</strong>، التي يتم استخدامها بشكل غير ملائم أو مراقبتها أو تعديلها أو فقدانها (استخدام واسطة تحتوي على بيانات حساسة لأسباب شخصية أو أثناء النقل غير المناسب، أو مراقبة شاشة، أو إضافة معدات مخصصة لاسترجاع البيانات وما إلى ذلك)؛ <strong>-<br>البرامجيات</strong>، التي يتم استخدامها بشكل غير ملائم، أو مراقبتها أو تعديلها (رفع الامتيازات أو تجميع بيانات الضبط، أو تثبيت أداة تحكم عن بعد، وما إلى ذلك)؛ -<br> <strong> القنوات المعلوماتية </strong>التي تتم مراقبتها (اعتراض تدفق الشبكة، وما إلى ذلك)؛ -<br> <strong>الأشخاص</strong> المراقَبون أو المستدرَجون أو التائهون (الإفصاح غير الطوعي، نتيجة للضغط أو من خلال التصيد الاحتيالي، تغيُّر صاحب العمل، وما إلى ذلك)؛ <strong>-<br>المستندات الورقية</strong>، التي تتم مراقبتها أو فقدانها (نسخ أو مطبوعات منسية أو استرجاع مستندات مهملة أو سرقة البريد، وما إلى ذلك)؛ <strong>-<br> القنوات الورقية</strong>التي تتم مراقبتها",
			name: "التهديدات التي قد تتسبب في وصول غير المشروع للبيانات",
			source: "WIKI Menaces_pouvant_mener_à_un_accès_illégitime_à_des_données synthétisé"
		},
		PIA_DEF_MENI: {
			description: "<strong> التهديدات المتعلقة بـ: </strong>-<br> <strong>المعدات</strong>: التي تُستخدم بشكل غير ملائم أو المثقلة أو المعدلة أو التالفة أو المفقودة (تخزين مملوء عن آخره أو هجوم الحرمان من الخدمة ((DOS أو تعديل يؤدي إلى عطل أو حريق أو سرقة أو ضياع، وما إلى ذلك) <strong>-<br> البرمجيات</strong>: المستخدمة بشكل غير ملائم أو المثقلة أو المعدلة أو التالفة أو المفقودة (محو البيانات أو إدخال البيانات أو القنبلة المنطقية أو عدم تجديد الترخيص، وما إلى ذلك) <br>-<strong> القنوات المعلوماتية</strong>: المثقلة أو التالفة أو المفقودة (تنزيل غير مصرح به أو قطع الوصول إلى الإنترنت أو إيقاف التشغيل، وما إلى ذلك) <strong>-<br>الأشخاص</strong>: المثقَلون أو المستدرَجون أو التائهون (سوء استخدام المهارات أو الغياب أو المغادرة، وما إلى ذلك) <strong>-<br> المستندات الورقية </strong>: المُساء استخدامها أو التالفة أو المفقودة (محو أو إتلاف أو سرقة أو ضياع، وما إلى ذلك) <strong>-<br> القنوات الورقية</strong>: التالفة أو المعدلة أو المفقودة (إضراب مكاتب البريد أو تغيير الموقع أو اختفاء حاملة مستندات أو إعادة التنظيم، وما إلى ذلك)",
			name: "التهديدات التي قد تتسبب في عدم توفر البيانات",
			source: "WIKI Menaces_pouvant_mener_à_une_disparition_de_données"
		},
		PIA_DEF_MENM: {
			description: "<strong> التهديدات المتعلقة بـ: <strong>-<br></strong>المعدات</strong> التي تم تعديلها (إضافة معدات غير متوافقة أو إزالة عنصر أساسي وما إلى ذلك) <br>-<strong>البرمجيات</strong>المستخدمة بطريقة غير ملائمة أو المعدلة (خطأ في المناولة أو تعديلات غير ملائمة، وما إلى ذلك) <strong>-<br>القنوات المعلوماتية</strong> المستخدمة بطريقة غير ملائمة (إعادة إرسال التدفق الذي تم اعتراضه، وما إلى ذلك) <strong>-<br>الأشخاص</strong>  المثقلَون أو المستدرَجون (مهمة غير متحكم فيها أو تعطيل ظروف العمل أو التأثير وما إلى ذلك) -<br>المستندات الورقية التي تم تعديلها (تعديل المستند أو استبداله بآخر مزور، وما إلى ذلك) <strong>-<br> القنوات الورقية</strong> التي تم تعديلها (إبدال الأحرف الأولى أو إرسال رسائل متناقضة وما إلى ذلك)",
			name: "تهديدات قد تتسبب في تعديل غير مشروع للبيانات",
			source: "WIKI Menaces_pouvant_mener_à_une_modification_non_désirées_de_données"
		},
		PIA_DEF_MES: {
			description: "TO TRANSLATE - To be chosen among those available in section \"Existing or planned measures\", which you may complete if needed.",
			name: "التدبير",
			source: "لا يوجد"
		},
		PIA_DEF_MIN1: {
			description: "أثناء استيراد البيانات، قد يتم جمع أنواع مختلفة من البيانات الوصفية (مثل بيانات EXIF ​​المرفقة بملف صورة) دون قصد<br>.يجب تحديد هذه البيانات الوصفية والتخلص منها إذا لم تكن هناك حاجة لها لتحقيق الأغراض المحددة.",
			name: "التصفية والسحب",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN2: {
			description: " بعد تلقي البيانات الحساسة، والتي تشكل جزءاً من حزمة معلومات عامة أو تم إرسالها لأغراض إحصائية فقط، يمكن تحويل هذه البيانات إلى صيغة أقل حساسية أو استخدام اسم مستعار فيما يتعلق بها. على سبيل المثال: -<br>إذا كان النظام يجمع عنوان بروتوكول الإنترنت (IP) لتحديد موقع المستخدم لغرض إحصائي، فيمكن حذف عنوان بروتوكول الإنترنت بعد استخلاص المدينة أو المنطقة؛ <br>- إذا تلقى النظام بيانات فيديو من كاميرات المراقبة، يمكنه التعرف على الأشخاص الواقفين أو المتحركين في المشهد وإخفاء ملامحهم؛<br>- إذا كان النظام عبارة عن عداد ذكي، فيمكنه تجميع حجم استخدام الطاقة خلال فترة معينة، دون تسجيلها في الوقت الفعلي.",
			name: "التقليل من الحساسية من خلال عمليات التحويل",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN3: {
			description: "يمكن للنظام أن يضمن للمستخدم ما يلي-<br>: يمكن للمستخدم استخدام مورد أو خدمة دون المخاطرة بالكشف عن هويته (بيانات مجهولة المصدر)؛ -<br>يمكن للمستخدم استخدام مورد أو خدمة دون الكشف عن هويته، لكنه يظل قابلاً للتحديد ومسؤولاً عن هذا الاستخدام (بيانات تحمل اسماً مستعاراً) ؛-<br>يمكن للمستخدم استخدام عدة موارد أو خدمات دون المخاطرة بإمكانية ربط هذه الاستخدامات معاً (بيانات غير قابلة للربط فيما بينها)؛-<br>يمكن للمستخدم استعمال مورد أو خدمة دون المخاطرة بإمكانية تمكن الآخرين، ولا سيما الأغيار، من معرفة أن المورد أو الخدمة قيد استخدام (غير قابلة للمراقبة) <br>.يجب أن يتوقف اختيار طريقة من القائمة أعلاه على التهديدات المحددة. فبالنسبة لأنواع معينة من تهديدات التي تمس الحياة الخاصة، سيكون استعمال اسم مستعار أكثر ملاءمة من إخفاء مصدر البيانات (على سبيل المثال، إذا كانت هناك ضرورة للتتبع). بالإضافة إلى ذلك، ستتم معالجة بعض التهديدات المتعلقة بالحياة الخاصة بتوليفة من عدة طرق.",
			name: "تخفيف الخاصية البيانات المحدِّدة للهوية",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN4: {
			description: "يمكن هيكلة النظام من خلال تقسيمه إلى أجزاء مستقلة مع وجود وظائف منفصلة للتحكم في الوصول. ويمكن أيضاً توزيع البيانات بين هذه النظم الفرعية المستقلة والتحكم بها بواسطة كل نظام فرعي باستخدام آليات مختلفة للتحكم في الوصول. وعليه، إذا تم اختراق نظام فرعي، فسيكون من الممكن الحد من التأثيرات على جميع البيانات.",
			name: " تقليل تراكم البيانات",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIN5: {
			description: "يمكن للنظام تقييد الوصول إلى البيانات على أساس مبدأ 'الحاجة إلى المعرفة'. ويمكن للنظام فصل البيانات الحساسة وتطبيق سياسات معينة للتحكم في الوصول<br>.يمكن للنظام أيضاً تشفير البيانات الحساسة لحماية سريتها أثناء الإرسال والتخزين. ويجب أيضاً حماية الوصول إلى الملفات المخفية المؤقتة التي يتم إنتاجها أثناء معالجة البيانات.",
			name: "تقييد الوصول إلى البيانات",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MINC: {
			description: "التقليل من شدة المخاطر من خلال جعل جمع البيانات ذات الطابع الشخصي مقتصراً على ما هو ضروري فقط فيما يتعلق بغرض محدد؛ تجنب جمع البيانات غير الضرورية، واستخدام البيانات غير المرتبطة بالغرض والتي لها آثار شديدة بالنسبة لأشخاص.",
			name: "تقليل الجمع إلى الحد الأدنى",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_MIND: {
			description: "تقليل شدة المخاطر عن طريق تقليل البيانات نفسها إلى الحد الأدنى، من خلال اتخاذ تدابير لتقليل حساسيتها، على سبيل المثال تصفية وسحب البيانات غير الضرورية، واستخدام أسماء مستعارة للبيانات، وما إلى ذلك",
			name: "تقليل البيانات بعينها",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_DEF_OPP: {
			description: "يحق لصاحب البيانات الاعتراض في أي وقت، لأسباب تتعلق بوضعه الخاص، على معالجة بيانات ذات طابع شخصي تخصه وفقاً للمادة 21 من اللائحة العامة لحماية البيانات <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article21\">article 21 du RGPD</a>.",
			name: "الحق في الاعتراض",
			source: "المادة 21 من اللائحة العامة لحماية البيانات (مقتضبة)"
		},
		PIA_DEF_PBDS: {
			description: "النهج الذي يتمثل في أخذ حماية البيانات ذات الطابع الشخصي بعين الاعتبار في أي معالجة جديدة (علامات الثقة والأطر المرجعية وإدارة المخاطر لصاحب البيانات وفقاً لمنهجية المركز الوطني للمعلوماتية والحريات أو طريقة داخلية، وما إلى ذلك)، خاصة: <br>- استخدام نهج إدارة المخاطر الخاص بالمركز الوطني للمعلوماتية والحريات منذ مرحلة الإعداد لخدمة ما أو تصميم تطبيق ما. <br>- تفضيل استخدام علامات الثقة في مجالي أمن النظم المعلوماتية و'تكنولوجيا المعلومات والحريات' (الإجراءات والمنتجات وأنظمة الإدارة والهيئات والأشخاص، وما إلى ذلك).<br>- تفضيل استخدام أطر مرجعية مثبتة ومعترف بها.",
			name: "إدارة المشروع",
			source: "WIKI Gestion_des_projets - les recommandations ne sont pas citées"
		},
		PIA_DEF_PC: {
			description: "الشخص الذي تتعلق به البيانات موضوع المعالجة.",
			name: "صاحب البيانات",
			source: "الصفحة 11 من تقييم أثر حماية البيانات 1"
		},
		PIA_DEF_PORT: {
			description: "يحق لأصحاب البيانات الحصول على البيانات ذات الطابع الشخصي المتعلقة بهم والتي قدموها إلى المسؤول عن معالجة، في صيغة مهيكلة وشائعة الاستخدام وقابلة للقراءة الآلية، وله الحق في نقل هذه البيانات إلى مسؤول معالجة آخر، دون أن يعيق المسؤول عن المعالجة الذي أرسلت له أول الأمر ذلك وفقاً للشروط المحددة في المادة 20 من اللائحة العامة لحماية البيانات <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article20\">Article 20 du RGPD</a>.",
			name: "الحق في قابلية نقل البيانات",
			source: "المادة 20 من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_PSEU: {
			description: "معالجة البيانات ذات الطابع الشخصي بطريقة لا يمكن نسبها إلى صاحب بيانات معين دون اللجوء إلى معلومات إضافية، شريطة الاحتفاظ بهذه المعلومات الإضافية بشكل منفصل وإخضاعها للتدابير التقنية والتنظيمية من أجل ضمان ألا تُنسب البيانات ذات الطابع الشخصي إلى شخص طبيعي محدد أو قابل للتحديد.<br> يقلل استخدام الأسماء المستعارة من مخاطر ربط مجموعة من البيانات بالهوية الأصلية لصاحب البيانات؛ وعليه،<strong> فإنه يُعد إجراءً أمنياً مفيداً، ولكنه ليس طريقة لإخفاء المصدر..</strong>",
			name: "استخدام اسم مستعار",
			source: "المادة 5.4 من اللائحة العامة لحماية البيانات بالنسبة للتعريف، الصفحة 22 من المبادئ التوجيهية لفريق عمل المادة 29 (29G) لتوضيح الفرق بينه وبين إخفاء مصدر البيانات http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2014/wp216_fr.pdf"
		},
		PIA_DEF_PWD: {
			description: "استناداً إلى إدارة السرية، تعد المصادقة بواسطة اسم المستخدم وكلمة المرور طريقة بسيطة وغير مكلفة للتحكم في الوصول. إلا أن طريقة المصادقة هذه تعد ذات مستوىً أمني منخفض.<br> ويختلف الحد الأدنى من المتطلبات التي يضعها المركز الوطني للمعلوماتية والحريات من حيث حجم وتعقيد كلمة المرور باختلاف الإجراءات الإضافية الموضوعة لجعل عملية المصادقة أكثر موثوقية:<br> وبالتالي، إذا كانت المصادقة تعتمد حصرياً على كلمة مرور، فهذا يقتضي ضمناً على الأقل استخدام كلمة مرور معقدة تتكون من 12 عنصراً على الأقل تتضمن أحرفاً كبيرة وصغيرة وأرقاماً ورموزاً خاصة. وتتيح الإجراءات التكميلية لإدخال كلمة مرور (القيود على الوصول وجمع البيانات الأخرى والواسطة التي يمتلكها المستخدم) تقليص طول كلمة المرور وتعقيدها، لأن هذه الإجراءات تضمن نفس مستوى أمن كلمة المرور وحدها.",
			name: "كلمة المرور",
			source: "الصفحة 7 من الدليل الأزرق لسنة 2017 : https://www.cnil.fr/fr/authentification-par-mot-de-passe-les-mesures-de-securite-elementaires"
		},
		PIA_DEF_RECT: {
			description: "من حق صاحب البيانات على المسؤول عن المعالجة تصحيح البيانات ذات الطابع الشخصي غير الدقيقة المتعلقة به في أقرب وقت ممكن.<br> وأخذاً بعين الاعتبار أغراض المعالجة، يحق لصاحب البيانات طلب استكمال البيانات الشخصية غير المكتملة، بما في ذلك من خلال تقديم تصريح إضافي.",
			name: "الحق في التصحيح",
			source: "المادة 16 من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_RGPD: {
			description: "اللائحة المتعلقة بحماية الأشخاص الطبيعيين فيما يتعلق بمعالجة البيانات ذات الطابع الشخصي وحرية نقلها(<a target=\"_blank\" href=\"http://eur-lex.europa.eu/legal-content/FR/TXT/PDF/?uri=CELEX:32016R0679&from=DE\">UE 2016-679</a>), التي تم  اعتمادها في 27 أبريل 2016 من قبل الاتحاد الأوروبي، ودخلت حيز التطبيق في 25 مايو 2018، مُلغية بذلك الأمر التوجيهي رقم 95/46/CE",
			name: "اللائحة العامة لحماية البيانات",
			source: "ترويسة اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_RT: {
			description: "شخص طبيعي أو اعتباري أو سلطة عامة أو وكالة أو هيئة أخرى تحدد بمفردها أو بالاشتراك مع آخرين أغراض ووسائل معالجة البيانات ذات الطابع الشخصي؛ عندما تحدَّد أغراض ووسائل مثل هذه الإجراءات بموجب قانون الاتحاد أو قانون دولة عضو، يجوز تعيين المسؤول عن معالجة البيانات أو وضع المعايير الخاصة بتعيينه من قبل الاتحاد أو قانون دولة عضو. <br>لمزيد من المعلومات حول التزامات المسؤول عن معالجة البيانات، يرجى الرجوع إلى <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Section1\">chap. IV du [RGPD]</a>",
			name: "المسؤول عن معالجة البيانات",
			source: "المادة 7.4 من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_SRC: {
			description: "شخص، من داخل أو خارج الهيئة، يقوم بأعمال عن طريق الخطأ أو عن عمد (على سبيل المثال: مسؤول معلوماتي أو مستخدم أو مهاجم الخارجي أو منافس)، أو مصدر غير بشري (على سبيل المثال: المياه أو المواد الخطرة أو فيروس حاسوبي غير استهدافي) الذي يمكن أن يكون مصدر الخطر.",
			name: "مصدر الخطر",
			source: " الصفحة 12 من تقييم أثر حماية البيانات و WIKI Types_et_exemples_de_sources_de_risques synthétisés"
		},
		PIA_DEF_ST: {
			description: "شخص طبيعي أو اعتباري أو سلطة عامة أو وكالة أو هيئة أخرى تعالج البيانات ذات الطابع الشخصي نيابة عن المسؤول عن المعالجة <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre1#Article4\">Article 4.8 du RGPD</a>.<br> لا يجوز للمتعاقد من الباطن وأي شخص يتصرف تحت إمرة المسؤول عن المعالجة أو إمرة المتعاقد من الباطن الذي لديه إمكانية الوصول إلى البيانات ذات الطابع الشخصي معالجة هذه البيانات إلا بناءً على تعليمات المسؤول عن المعالجة، ما لم يستوجب قانون الاتحاد أو قانون دولة عضو ذلك <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article29\">Article 29 du RGPD</a>.",
			name: "المتعاقد من الباطن",
			source: "المادتان 8.4 و29 من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_SUPT: {
			description: "<strong> المعدات ووسائط البيانات الإلكترونية </strong>: الحواسيب ومرحلات الاتصالات وذاكرات البيانات (USB) والأقراص الصلبة... <strong><br>البرامجيات</strong>: أنظمة التشغيل والمراسلة وقواعد البيانات والتطبيقات الخاصة بالأعمال... <strong><br> القنوات المعلوماتية</strong>: الكابلات والشبكة اللاسلكية (واي فاي) والألياف الضوئية<strong><br><br>الأشخاص</strong>: المستخدمون ومسؤولو المعلوميات وصناع القرار... br> ><strong> الوسائط الورقية</strong>: المطبوعات والنسخ والمستندات المكتوبة بخط اليد... <strong><br> قنوات نقل الوثائق الورقية</strong>: البريد ودائرة التحقق...",
			name: "نوعية وسائط البيانات ذات الطابع الشخصي",
			source: "WIKI Types_et_exemples_de_supports_des_données"
		},
		PIA_DEF_VIOL: {
			description: "اختراق أمني يؤدي بشكل عرضي أو غير قانوني إلى تدمير البيانات ذات الطابع الشخصي المنقولة أو المخزنة أو التي تتم معالجتها بطريقة أخرى أو فقدانها أو تغييرها أو الكشف غير المصرح به عنها أو الوصول إليها.",
			name: "اختراق البيانات",
			source: "المادة 12.4 من اللائحة العامة لحماية البيانات"
		},
		PIA_DEF_VRA: {
			description: "تعكس الاحتمالية إمكانية حدوث خطر ما. وتتوقف بشكل أساسي على ضعف الوسائط أمام التهديدات وقدرة مصادر المخاطر على استغلالها.",
			name: "الاحتمالية",
			source: "الصفحة 12 من تقييم أثر حماية البيانات 1"
		},
		PIA_EX_DC: {
			description: "بيانات نظام تنقيط، نتيجة تطبيق التنقيط... ",
			name: "البيانات المحسوبة"
		},
		PIA_EX_DCPC: {
			description: "<strong> بيانات التعريف </strong>: الحالة الاجتماعية والسن والجنسية والجنسية المزدوجة والعنوان البريدي والأهلية القانونية... <br>< <strongالحياة الشخصية </strong>: الحالة الاجتماعية وعدد الأطفال وقسم الإقامة ونوعها وحالة السكن والأقدمية في السكن والفئة الاجتماعية والمهنية... <strong><br>الحياة المهنية</strong>: الوظيفة ونوع العقد والفئة الاجتماعية والمهنية واسم صاحب العمل والأقدمية في التوظيف والبطالة... br>><strong>بيانات الاتصال</strong>: عنوان بروتوكول الإنترنت (IP)، وسجلات الأحداث... <strong><br> بيانات الموقع </strong>: التنقل وبيانات نظام تحديد المواقع (GPS) والنظام العالمي للاتصالات المتنقلة (GSM)... <strong><br> أمور أخرى </strong>: رقم الهاتف وعنوان البريد الإلكتروني ... ",
			name: "البيانات الجارية",
			source: "WIKI Types_de_données"
		},
		PIA_EX_DCPR: {
			description: "الآراء الفلسفية والسياسية والدينية والنقابية، والحياة الجنسية، والبيانات المتعلقة بالصحة والأصول العرقية أو الإثنية والحياة الجنسية والمخالفات والإدانات والتدابير الأمنية. <br>يرجى الرجوع إلى <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article9\">art. 9</a> <br> et <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article10\">art.10</a> du [RGPD]",
			name: "بيانات المخالفات والبيانات الحساسة"
		},
		PIA_EX_DCPS: {
			description: "رقم الضمان الاجتماعي والبيانات البيومترية والبيانات البنكية...",
			name: "بيانات يُنظر إليها على أنها حساسة"
		},
		PIA_EX_HUME: {
			description: "يمكن أن يتعلق الأمر بـ: <br>- طرف ثالث يستخدم قربه المادي، سواء بسوء نية أو عن جهالة، للوصول إلى الخدمة بطريقة احتيالية <br>- مهاجم يستهدف مستخدماً بالاعتماد على معرفته بالمستخدم وبعض المعلومات المتعلقة به <br>- مهاجم يستهدف إحدى الشركات المسؤولة عن المعالجة من خلال معرفته بأمور عن الشركات قد تسمح بمهاجمة صورتها<br>- مؤسسة من الأغيار تستغل ترخيصها باستخدام امتيازات الوصول للولوج إلى معلومات بصورة غير مشروعة. يمكن أن تكون الدوافع متعددة: كاللهو أو الإزعاج أو الخبث أو الانتقام أو التجسس أو الجشع أو الحصول على البيانات بقصد استغلالها",
			name: "مصدر بشري خارجي"
		},
		PIA_EX_HUMI: {
			description: "يمكن أن يتعلق الأمر بـ: -<br>موظف ذي نية سيئة يستخدم قربه من النظام ومهاراته والامتيازات المقدمة له والوقت المتاح الذي يحتمل أن يكون طويلاً أو يرتكب خطأً ناتجاً عن الإهمال بسبب نقص محتمل في التدريب والوعي. -<br>مستخدم أو محيطه، بسبب الإهمال أو النوايا السيئة، والذي يمتلك إمكانية الوصول إلى الخدمة <br>.يمكن أن تكون دوافعه متعددة: الطيش أو الخطأ أو الإهمال أو الانتقام أو إرادة التغيير أو الخبث أو الجشع أو التجسس",
			name: "مصدر بشري داخلي"
		},
		PIA_EX_IMPI: {
			description: "قد يواجه أصحاب البيانات عواقب وخيمة، والتي يمكنهم التغلب عليها ولكن مع صعوبات حقيقية وكبيرة <br> أمثلة على الآثار :-<br>الجسدية: مرض جسدي خطير يسبب ضرراً طويل الأمد (تفاقم الحالة الصحية بعد سوء الرعاية أو عدم الامتثال لموانع الاستعمال)، والإضرار بالسلامة الجسدية، وما إلى ذلك -<br> .المادية: اختلاسات أموال غير قابلة للتعويض، وفرص استهدافية وفريدة وغير متكررة، ومفقودات (الرهن العقاري أو الدراسات أو التداريب أو التوظيف أو الحظر من المشاركة في امتحان)، وفقدان الإقامة، وفقدان الوظيفة، وما إلى ذلك-<br> . المعنوية: حالة نفسية خطيرة (اكتئاب أو رهاب)، الشعور بانتهاك الخصوصية والضرر الذي لا يمكن تداركه، ضحية الابتزاز والتنمر الإلكتروني والمضايقات المعنوية، وما إلى ذلك.",
			name: "أثر مهم"
		},
		PIA_EX_IMPL: {
			description: "قد يواجه أصحاب البيانات متاعب كبيرة، والتي يمكنهم التغلب عليها بالرغم من وجود بعض الصعوبات<br>أمثلة على الآثار:<br>- الجسدية: مرض جسدية طفيفة (مثال: مرض حميد ناتج عن عدم احترام تعليمات موانع الاستعمال)، أو التشهير المؤدي إلى الانتقام الجسدي، أو ما إلى ذلك.<br>- المادية: مدفوعات غير مرتقبة (مثال: غرامات مغلوطة)، أو رفض منح الوصول إلى خدمات إدارية أو تجارية، أو إعلان استهدافي على الإنترنت بشأن أحد جوانب الحياة الخاصة التي كان صاحب البيانات يرغب في الإبقاء على سريتها، أو ما إلى ذلك.<br>- المعنوية: حالة نفسية طفيفة ولكن موضوعية، والشعور بأن الحياة الخاصة قد انتهكت دون أي ضرر غير قابل للإنصاف، والتنمر على شبكات التواصل الاجتماعي، وما إلى ذلك",
			name: "أثر محدود"
		},
		PIA_EX_IMPM: {
			description: "قد يعاني أصحاب البيانات من عواقب وخيمة، بل عواقب لا يمكن تخطيها، وقد لا يتمكنون من التغلب عليها.<br>أمثلة على الآثار: -<br>الجسدية: مرض جسدي مزمن أو مستديم، أو تغيير دائم في السلامة الجسدية، أو الوفاة-<br> المادية: مخاطر مالية، أو ديون كبيرة، أو عدم القدرة على العمل، أو عدم القدرة على تغيير المسكن، أو فقدان الأدلة في سياق دعوى قضائية، فقدان إمكانية الوصول إلى بنية تحتية حيوية (الماء والكهرباء)، أو ما إلى ذلك. -<br>المعنوية: مرض نفسي مزمن أو مستديم، أو عقوبة جنائية، أو اختطاف، أو فقدان الارتباط الأسري، أو عدم القدرة على اللجوء إلى القضاء، أو تغير الوضع الإداري و/أو فقدان الاستقلالية القانونية (الوصاية)، أو ما إلى ذلك",
			name: "أقصى أثر"
		},
		PIA_EX_IMPN: {
			description: "لن يتأثر أصحاب البيانات، أو قد يواجهون بعض المتاعب التي يمكنهم التغلب عليها دون أي صعوبات.<br>أمثلة عن الآثار: -<br>الجسدية: صداع عابر-<br> المادية: ضياع الوقت لتكرير بعض الإجراءات أو للانتظار من أجل إنجازها، أو إعادة استخدام البيانات لأغراض الإعلانات المستهدفة لمنتوجات الاستخدام اليومي، أو ما إلى ذلك،-<br> المعنوية: انزعاج بسيط، أو الشعور بالمساس بالخصوصية دون حدوث أي انتهاك فعلي (التطفل التجاري)، وما إلى ذلك",
			name: "أثر ضعيف"
		},
		PIA_EX_NHUM: {
			description: "يمكن أن يتعلق الأمر بحادثة أو كارثة لدى إحدى الهيئات المسؤولة عن المعالجة (انقطاع التيار أو حريق أو فيضان أو ما إلى ذلك.)",
			name: "مصدر غير بشري"
		},
		PIA_EX_VRAI: {
			description: "يبدو من الممكن لمصادر المخاطر الموجودة تنفيذ التهديد بناءً على خصائص الوسائط المستخدَمة (مثال: سرقة الوسائط الورقية المخزنة في مكاتب أحد الهيئات التي يكون الوصول إليها خاضعاً لمراقبة موظف الاستقبال).",
			name: "احتمالية هامة"
		},
		PIA_EX_VRAL: {
			description: "يبدو من الصعب لمصادر المخاطر الموجودة تنفيذ التهديد بناءً على خصائص الوسائط المستخدَمة (مثال: سرقة الوسائط الورقية المخزنة في مكان بالهيئة يكون الوصول إليه مراقَباً بواسطة شارة).",
			name: "احتمالية محدودة"
		},
		PIA_EX_VRAM: {
			description: "يبدو من السهل للغاية لمصادر المخاطر الموجودة تنفيذ التهديد بناءً على خصائص الوسائط المستَخدمة (مثال: سرقة الوسائط الورقية المخزنة في الردهة العامة للهيئة).",
			name: "احتمالية قصوى"
		},
		PIA_EX_VRAN: {
			description: "لا يبدو ممكناً أن تنفذ مصادر المخاطر الموجودة التهديد بناءً على خصائص الوسائط المستخدَمة (مثال: سرقة الوسائط الورقية المخزنة في مكان بالهيئة يكون الوصول إليه مراقَباً بواسطة شارة ورمز دخول).",
			name: "احتمالية ضئيلة"
		},
		PIA_LGL_CONS: {
			description: "يتعلق الأمر بالسماح باتخاذ اختيار حر ومحدد ومستنير؛ والتأكد من أن الموافقة قائمة على أحد الأسس القانونية للمعالجة، كما هو منصوص عليه في المادة 6 من اللائحة العامة لحماية البيانات <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article6\">article 6 du RGPD</a> (التزام قانوني أو الحفاظ على الحياة أو مهمة تصب في مصلحة عامة، عقد أو تدبير متخذ مع الشخص، أو مصلحة مشروعة).",
			name: "الحصول على موافقة مستخدم الخدمة",
			source: "WIKI Recueil_du_consentement"
		},
		PIA_LGL_DATA: {
			description: "تحديد ووصف النطاق بالتفصيل: <br>- البيانات الشخصية المعنية ومستلميها وفترات الاحتفاظ بها؛<br>- وصف للعمليات ووسائط البيانات على مدى دورة حياة البيانات بأكملها (بدءا بتجميعها ووصولاً إلى محوها).",
			name: "البيانات المعالَجة",
			source: " الصفحة 6 من تقييم أثر حماية البيانات 1"
		},
		PIA_LGL_DESC: {
			description: "عرض نوع المعالجة المزمع إنجازها والأهداف والتحديات بطريقة توليفية. تحديد المسؤول عن المعالجة وكذا المتعاقدين من الباطن المحتملين. تحديد الأطر المرجعية المنطبقة على المعالجة، سواء المفيدة منها أو تلك التي يجب مراعاتها، خصوصاً مدونات السلوك المعتمدة <br>Cf. <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapite4#Article40\">art. 40 du [RGPD]</a>) <br> <br>وشهادات حماية البيانات (cf. <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article42\">art. 42 du [RGPD]</a>).",
			name: "وصف المعالجة",
			source: "الصفحة 6 من تقييم أثر حماية البيانات 1"
		},
		PIA_LGL_DEST: {
			description: "شخص طبيعي أو اعتباري، أو سلطة عامة أو وكالة أو هيئة أخرى تتلقى بيانات ذات طابع شخصي، سواء تعلق الأمر بطرف ثالث أم لا. ومع ذلك، لا تعتبر السلطات العامة التي قد تتلقى بيانات ذات طابع شخصي في إطار مهمة تحقيق خاصة، بمقتضى قانون الاتحاد أو قانون دولة عضو، بمثابة جهات متلقية؛ وتكون معالجة هذه البيانات من قبل السلطات العامة المعنية مطابقة للقواعد المعمول بها في مجال حماية البيانات وفقا لأغراض المعالجة.، كما هو مذكور في <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre1#Article4\">art. 4.9 du [RGPD]</a>",
			name: "الجهات المتلقية",
			source: "المادة 9.4 من اللائحة العامة لحماية البيانات"
		},
		PIA_LGL_DUR: {
			description: "يجب تحديد المدة التي يُحتفظ فيها بكل نوع من البيانات وتبريرها باحتياجات المعالجة و/ أو قيود قانونية. وبالتالي، يتم التمييز بين البيانات الحالية والبيانات المؤرشفة التي سيقتصر الوصول إليها على الجهات المعنية فقط. ويجب وضع آلية حذف لأرشفة البيانات الحالية أو إزالة البيانات المؤرشفة عند انتهاء فترة الاحتفاظ بها. كما يجب أيضاً إزالة الآثار الوظيفية، تماماً مثل السجلات التقنية التي لا يمكن الاحتفاظ بها إلى أجل غير مسمى.",
			name: "مدة الاحتفاظ بالبيانات",
			source: "الصفحة 10 من إطار عمل تقييم أثر حماية البيانات - الأشياء المتصلة "
		},
		PIA_LGL_FIN: {
			description: "يجب جمع البيانات الشخصية لأغراض محددة وصريحة ومشروعة، و<strong>لا تتم معالجتها لاحقاً بطريقة لا تتوافق مع هذه الأغراض</strong>؛ <br>كما هو مشار إليه في <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article5\">art. 5b du [RGPD]</a>",
			name: "أغراض جمع البيانات واستخدامها",
			source: "المادة 5(ب) من اللائحة العامة لحماية البيانات"
		},
		PIA_LGL_FOND: {
			description: "- وافق صاحب البيانات على معالجة بياناته الشخصية من أجل غرض واحد أو عدة أغراض محددة <br> - حيث تكون المعالجة ضرورية من أجل تنفيذ عقد يكون صاحب البيانات طرفاً فيه أو لتنفيذ تدابير ما قبل التعاقد بطلب من هذا الأخير <br> - تكون المعالجة ضرورية للامتثال لالتزام قانوني محدد في قانون الاتحاد أو قانون الدولة العضو التي يخضع لأحدهما المسؤول عن المعالجة <br> - تكون المعالجة ضرورية لحماية المصالح الحيوية لصاحب البيانات أو لشخص طبيعي آخر <br> - تكون المعالجة ضرورية لأداء مهمة تتعلق بالمصلحة العامة أو بممارسة السلطة العامة المنوطة بالمسؤول عن المعالجة <br> - تكون المعالجة ضرورية لأغراض المصالح المشروعة التي يسعى إليها المسؤول عن المعالجة أو طرف ثالث، ما لم تطغى المصالح أو الحقوق والحريات الأساسية لصاحب البيانات التي تستوجب حماية البيانات ذات الطابع الشخصي، لا سيما عندما يكون صاحب البيانات طفلاً. انظر <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2#Article6\">art. 6 du [RGPD]</a>",
			name: "الأساس القانوني",
			source: "الصفحة 4 من تقييم أثر حماية البيانات 2 / WIKI Fondement_:_licéité_du_traitement,_interdiction_du_détournement_de_finalité"
		},
		PIA_LGL_INFO: {
			description: "يتعلق الأمر بضمان إبلاغ الأشخاص وبالتالي تجنب جمع البيانات دون علمهم؛ والتأكد من أن المعالجة ليست خاضعة لاستثناء أو شروط معينة.",
			name: "إبلاغ مستخدم الخدمة بشأن استخدام بياناته",
			source: "WIKI Information_des_personnes_concernées_(traitement_loyal_et_transparent)"
		},
		PIA_LGL_MINI: {
			description: "يتعلق الأمر بالحد من شدة المخاطر من خلال اقتصار جمع البيانات الشخصية على ما هو ضروري تماماً فيما يتعلق بغرض محدد؛ تجنب جمع البيانات غير الضرورية وعدم استخدام البيانات التي ليست لها صلة بالغرض المقصود وتجنب الآثار المبالغ فيها بالنسبة للأشخاص.",
			name: "تقليل البيانات إلى الحد الأدنى",
			source: "WIKI Minimisation_des_données_:_adéquates,_pertinentes_et_limitées"
		},
		PIA_LGL_ST: {
			description: "يجب أن يتم إبرام عقد تعاقد من الباطن مع كل واحد من المتعاقدين من الباطن، مع تحديد جميع العناصر المنصوص عليها في المادة 28 من اللائحة العامة لحماية البيانات: المدة، والنطاق، والغرض، وتعليمات المعالجة الموثَّقة، والترخيص المسبق في حالة اللجوء إلى متعاقد من الباطن، وإتاحة كافة الوثائق التي تقدم دليلاً على احترام اللائحة العامة لحماية البيانات، والإخطار في أقرب الآجال بأي خرق للبيانات، وما إلى ذلك",
			name: "التعاقد من الباطن",
			source: "الصفحة 10 من تقييم أثر حماية البيانات 2 / WIKI Sous-traitance_:_identifiée_et_contractualisée"
		},
		PIA_LGL_SUPT: {
			description: "الشيء الذي يحتوي على البيانات. ملاحظة: قد يكون عبارة عن معدات أو برمجيات أو قنوات معلوماتية أو أشخاصاً أو وسائط ورقية أو قنوات نقل الأوراق.",
			name: "وسائط البيانات",
			source: "الصفحة 12 من تقييم أثر حماية البيانات 1"
		},
		PIA_LGL_TRAN: {
			description: "إعطاء تفاصيل بشأن الموقع الجغرافي لتخزين بيانات المعالجة المختلفة. وحسب البلد المعني، يجب تعليل اختيار مكان استضافة يقع خارج الاتحاد الأوروبي وتوضيح كيفيات التأطير القانوني مرجع النظر من أجل ضمان حماية كافية للبيانات التي يتم نقلها عبر الحدود. <br> وهذا يعني: <br> - في بلد داخل الاتحاد الأوروبي <br> - في بلد يعترف الاتحاد الأوروبي بكفاءته <br> - إرسال البيانات إلى شركة في الولايات المتحدة تلتزم باتفاق 'درع الخصوصية' <br>- بلدان أخرى <br> وفقاً لـ<a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre5#Article44\">articles 44 à 49 du [RGPD]</a>",
			name: "نقل البيانات",
			source: "WIKI Transferts_:_respect_des_obligations_en_mati%C3%A8re_de_transfert_de_donn%C3%A9es_en_dehors_de_l%E2%80%99Union_europ%C3%A9enne et PIAF Objets connectés p17"
		},
		PIA_METHOD_MES: {
			description: "التدابير الأولية هي التدابير المقرَّرة في الأصل، قبل التحليل الذي يقوم به المقيم. أما التدابير المكمِّلة أو التصحيحية الموصى بها من طرف المقيِّم فسيتم تحديدها في خطة العمل وستمكِّن من إجراء تقييم ثانٍ للخطورة والاحتمالية.",
			name: "التدابير الأولية والتدابير التصحيحية",
			source: "WIKI Menaces_pouvant_mener_à_une_modification_non_désirées_de_données"
		},
		PIA_ORG_AUD: {
			description: "وجود تدابير تسمح بامتلاك نظرة شاملة ومحينة لوضع حماية البيانات والامتثال للائحة العامة لحماية البيانات (مراقبة مدى امتثال المعالجات والأهداف والمؤشرات والمسؤوليات، وما إلى ذلك).",
			name: "الإشراف على حماية الحياة الخاصة",
			placeholder: "يرجى تحديد العمليات التي تضمن مراقبة منتظمة لمعالجات البيانات.",
			source: "WIKI Supervision"
		},
		PIA_ORG_EXT: {
			description: "وجود إجراء يرمي إلى الحد من المخاطر التي قد تشكلها عمليات الوصول المشروعة إلى البيانات من قبل الأغيار على حريات أصحاب البيانات وحياتهم الخاصة (تحديد الأغيار، وعقد التعاقد من الباطن، والاتفاقية، وقواعد الشركة الملزمة، وما إلى ذلك).",
			name: "إدارة الأغيار التي تصل إلى البيانات",
			placeholder: "يرجى تحديد، بالنسبة للأغيار الذين لديهم حق الوصول إلى البيانات، والكيفيات والتدابير الأمنية الموضوعة لهذا الوصول.",
			source: "WIKI Relations_avec_les_tiers"
		},
		PIA_ORG_ORG: {
			description: "وجود منظمة مؤهلة لإدارة ومراقبة حماية البيانات ذات الطابع الشخصي داخل الهيئة (تعيين مفوض معني بحماية البيانات/المسؤول عن حماية البيانات، إحداث لجنة متابعة، وما إلى ذلك).",
			name: "تنظيم سياسة حماية الحياة الخاصة",
			placeholder: "يرجى تحديد كيفية تنظيم حماية الحياة الخاصة داخل الهيئة التي تنتمي إليها.",
			source: "WIKI Organisation"
		},
		PIA_ORG_PBD: {
			description: "وجود إجراءات تصف الكيفيات المخصصة لأخذ حماية البيانات ذات الطابع الشخصي بعين الاعتبار في كل معالجة جديدة (علامات الثقة والأطر المرجعية وإدارة المخاطر على صاحب البيانات وفقاً لمنهجية اللجنة الوطنية للمعلوماتية والحريات أو طريقة داخلية، وما إلى ذلك)",
			name: "إدماج حماية الحياة الخاصة في المشاريع",
			placeholder: "يرجى تحديد الطرق التي تضمن مراعاة حماية البيانات ذات الطابع الشخصي منذ مرحلة بدء مشروع جديد.",
			source: "WIKI Gestion_des_projets"
		},
		PIA_ORG_PERS: {
			description: "وجود خطة تؤطر <strong> تدابير التوعية</strong> المتخَّذة عند التحاق شخص بوظيفته وإجراء يصف <strong>التدابير المتخذة عند مغادرة الأشخاص الذين يصلون إلى البيانات</strong>.",
			name: "إدارة الموظفين",
			placeholder: "يرجى تحديد التدابير التي تتضمنها سياستكم المتعلقة بالموارد البشرية التي تستجيب لقضايا المعلوماتية والحريات في هيئاتكم.",
			source: "الصفحة 24 من إطار عمل تقييم أثر حماية البيانات – الأشياء المتصلة"
		},
		PIA_ORG_POL: {
			description: "يجب على المسؤول عن المعالجة أن يتوفر على قاعدة وثائقية محدِّدة للأهداف والقواعد الواجب تطبيقها في مجال 'المعلوماتية والحريات' (خطة العمل، والمراجعة المنتظمة لسياسة 'المعلوماتية والحريات', وما إلى ذلك).",
			name: "إدارة سياسة حماية الحياة الخاصة",
			placeholder: "يرجى تحديد أساليب إدارة القاعدة الوثائقية المؤطِّرة لتنظيم حماية الحياة الخاصة داخل هيئتكم.",
			source: "WIKI Politique_(gestion_des_règles)"
		},
		PIA_ORG_RMGT: {
			description: "وجود سياسة محدِّدة للعمليات المخصصة للتصدي للمخاطر التي يشكلها المسؤولون عن المعالجة التابعون للمؤسسة على حقوق أصحاب البيانات وحرياتهم (إحصاء معالجات البيانات الشخصية والبيانات والوسائط، تقييم المخاطر، تحديد التدابير القائمة أو المرتقبة، وما إلى ذلك).",
			name: "إدارة المخاطر",
			placeholder: "يرجى تحديد العمليات المخصصة للتحكم في المخاطر التي تشكلها معالجات الهيئة على حقوق أصحاب البيانات وحرياتهم.",
			source: "WIKI Gestion_des_risques"
		},
		PIA_ORG_VIOL: {
			description: "وجود تنظيم تشغيلي يمكن من كشف ومعالجة الأحداث التي يُحتمل أن تؤثر على حريات أصحاب البيانات وحياتهم الخاصة (تحديد المسؤوليات وخطة الاستجابة وتصنيف الانتهاكات، وما إلى ذلك).",
			name: "إدارة الحوادث الأمنية وانتهاكات البيانات",
			placeholder: "يرجى تحديد العمليات التشغيلية المخصصة لكشف ومعالجة الأحداث التي يُحتمل أن تؤثر على حريات أصحاب البيانات وحياتهم الخاصة.",
			source: "WIKI Gestion_des_incidents_et_des_violations_de_données"
		},
		PIA_SEC_BKP: {
			description: " إن وجود سياسة النسخ الاحتياطي تمكن من ضمان توافر و/أو سلامة البيانات ذات الطابع الشخصي، مع حماية سريتها (انتظام النسخ الاحتياطي، وتشفير قنوات نقل البيانات، واختبار السلامة، وما إلى ذلك).",
			name: "النسخ الاحتياطي للبيانات",
			placeholder: "يرجى تحديد كيف تتم إدارة عمليات النسخ الاحتياطي للبيانات والاحتفاظ بها.",
			source: "WIKI Sauvegardes"
		},
		PIA_SEC_COMP: {
			description: "التدابير المتخذة من أجل تقليل احتمال عدم استغلال خصائص البرمجيات (أنظمة التشغيل، تطبيقات الأعمال، البرمجيات المكتبية، الإعدادات...) لغرض المساس بالبيانات ذات الطابع الشخصي (التحديثات، الحماية المادية والمتعلقة بعمليات الوصول، العمل على إنشاء فضاء على الشبكة للنسخ الاحتياطي، ومراقبو السلامة، حفظ السجلات، وما إلى ذلك).",
			name: "إدارة محطات العمل",
			placeholder: "يرجى تحديد التدابير المتخذة من أجل تقليل مخاطر الهجمات على البرمجيات المستخدَمة في المعالجة.",
			source: "WIKI Gestion_des_postes_de_travail"
		},
		PIA_SEC_CTR: {
			description: "يجب أن تستفيد البيانات ذات الطابع الشخصي التي يتم إرسالها إلى المتعاقدين من الباطن أو تتم إدارتها من قبلهم من الضمانات الكافية. <strong>الاستعانة فقط بالمتعاقدين من الباطن الذين يقدمون ضمانات كافية</strong> (لا سيما فيما يخص المعارف المتخصصة والموثوقية والموارد). مطالبة مزود الخدمة بتقديم المعلومات بشأن سياسة أمن أنظمة المعلومات الخاصة به. <br>أخذ المبادرة والتوثيق (عمليات التدقيق الأمني​ وزيارة المرافق، وما إلى ذلك) ما يسمح<strong>بضمان فعالية الضمانات التي يقدمها المتعاقد من الباطن</strong> فيما يتعلق بحماية البيانات. وتشمل هذه الضمانات على وجه الخصوص: <br>- تشفير البيانات حسب حساسيتها، أو في حالة عدم إمكانية التشفير، وجود إجراءات تضمن عدم وصول الشركة المقدمة للخدمة إلى البيانات الموكلة إليها <br>- تشفير عمليات نقل البيانات (مثلا بواسطة بروتوكول نقل النص التشعبي الآمن (HTTPS)، الشبكة الخاصة الافتراضية (VPN)، وما إلى ذلك.) <br>- ضمانات خاصة بمجال حماية الشبكة، وإمكانية التتبع (السجلات، التدقيق) وإدارة التخويل، والمصادقة، وما إلى ذلك. <strong><br>اشتراط عقد مع المتعاقدين من الباطن</strong> والذي يحدد على وجه الخصوص موضوع المعالجة ومدتها والغرض منها وكذا التزامات الأطراف. التأكد من أن العقد يحتوي على أحكام تنص بصفة خاصة على: <br>- التزامهم من حيث سرية البيانات الشخصية الموكلة <br>- الحد الأدنى من القيود فيما يتعلق بالتحقق من هوية المستخدمين <br>- شروط استرجاع و/أو إتلاف البيانات في نهاية العقد<br>- قواعد إدارة الحوادث والإبلاغ عنها. يجب أن تتضمن هذه الأخيرة معلومات عن المسؤول عن المعالجة في حالة اكتشاف ثغرة أمنية أو حادث أمني وهذا في أقرب وقت ممكن عندما يتعلق الأمر بخرق بيانات ذات طابع شخصي. <br>- في حال استخدام مقدم الخدمة الحوسبة السحابية: <br>.t1 تحديد البيانات والمعالجات التي ستُجرى في السحابة بوضوح؛ <br>.t2 تحديد المتطلبات الأمنية التقنية والقانونية الخاصة به؛ <br>.t3 إجراء دراسة المخاطر لتحديد التدابير الأمنية المناسبة؛ <br>.t4 تحديد نوع السحابة ذات الصلة المعالجة المتوخى إجراؤها؛ <br>.t5 اختيار مقدم خدمة يتوفر على ضمانات كافية؛ <br>.t6 مراجعة سياسة الأمن الداخلي؛ <br>.t7 مراقبة التغييرات مع مرور الوقت.",
			name: "عقد التعاقد من الباطن",
			placeholder: "يرجى تحديد الضمانات التعاقدية التي تضمن حماية البيانات الشخصية الموكلة إلى المتعاقدين من الباطن.",
			source: " الصفحة 19 من الدليل الأزرق لسنة 2017 وhttps://www.cnil.fr/fr/cloud-computing-les-conseils-de-la-cnil-pour-les-entreprises-qui-utilisent-ces-nouveaux-services"
		},
		PIA_SEC_EXP: {
			description: "سياسات للحد من احتمالية وشدة المخاطر التي تؤثر على الموجودات المستخدَمة كوسائط في عملية التشغيل (توثيق إجراءات عملية التشغيل وجرد وتحديث البرمجيات والأجهزة، وتصحيح نقاط الضعف، ونسخ البيانات، والحد من الوصول المادي إلى المعدات، وما إلى ذلك)",
			name: "تأمين عملية التشغيل",
			placeholder: "يرجى تحديد الوسائل المستخدَمة لضمان تحديث البرمجيات المستخدمة ومستوى أمنها.",
			source: "WIKI Sécurité_de_l'exploitation"
		},
		PIA_SEC_LOG: {
			description: "وجود تدابير موضوعة للسماح بكشف الحوادث المتعلقة بالبيانات ذات الطابع الشخصي في وقت مبكر وللتوفر على عناصر قابلة للتشغيل في الدراسات أو في تقديم أدلة في إطار التحقيقات (هندسة حفظ السجلات وسياستها، احترام الالتزامات المتعلقة بحماية البيانات ذات الطابع الشخصي، وما إلى ذلك).",
			name: " التكملة",
			placeholder: "يرجى تحديد التدابير الموضوعة للتَّمكن من كشف الحوادث المتعلقة بالبيانات ذات الطابع الشخصي.",
			source: "WIKI Surveillance"
		},
		PIA_SEC_MAIN: {
			description: "وجود سياسة للصيانة المادية للمعدات، مع تحديد إمكانية اللجوء إلى التعاقد من الباطن عند الاقتضاء. <br>ويجب أن تؤطر هذه السياسة عملية الصيانة عن بعد في حال كانت هذه الأخيرة مسموحاً بها وأن تحدد أساليب إدارة المعدات المعطلة.",
			name: "الصيانة",
			placeholder: "يرجى تحديد كيفية إدارة الصيانة المادية للمعدات.",
			source: "الصفحة 25 من إطار عمل تقييم أثر حماية البيانات – الأشياء المتصلة"
		},
		PIA_SEC_MAL: {
			description: "التدابير الموجهة لحماية عمليات الوصول إلى شبكات عامة (الإنترنت) أو غير مُتحكَّم فيها (الشركاء) وكذا محطات العمل والخوادم من البرمجيات الخبيثة التي قد تمس بأمن البيانات ذات الطابع الشخصي.",
			name: "مكافحة البرمجيات الخبيثة",
			placeholder: "يرجى تحديد تدابير الحماية من البرمجيات الخبيثة أثناء الوصول إلى شبكات ذات مستوى أمني متدنٍ.",
			source: "WIKI Lutte_contre_les_logiciels_malveillants"
		},
		PIA_SEC_MAT: {
			description: "وجود تدابير لتقليل احتمالية استغلال خصائص المعدات (الخوادم أو المحطات الثابتة أو أجهزة الكمبيوتر المحمولة أو الأجهزة الطرفية أو مرحلات الاتصالات أو الوسائط القابلة للإزالة، إلخ.) للمس بالبيانات ذات الطابع الشخصي (الجرد وفصل البيانات والأجهزة الزائدة عن الحاجة والحد من الوصول، وما إلى ذلك)،",
			name: "أمن المعدات",
			placeholder: "يرجى تحديد الطرق والوسائل المستَخدمة للحد من مخاطر الهجمات على المعدات التي يستخدمها المسؤول عن المعالجة.",
			source: "WIKI Sécurité_des_matériels"
		},
		PIA_SEC_NET: {
			description: "اعتماداً على نوع الشبكة التي يتم إجراء المعالجة عليها (معزولة أو خاصة أو الإنترنت)، يجب على المسؤول عن المعالجة وضع أنظمة حماية مناسبة: جدران الحماية أو تحقيقات كشف عمليات الاقتحام أو ما إلى ذلك من الأجهزة النشطة أو الخاملة المسؤولة عن ضمان أمن الشبكة.",
			name: "تأمين القنوات المعلوماتية",
			placeholder: "يرجى تحديد نوع الشبكة التي يتم إجراء المعالجة عليها والتجهيزات التي تضمن أمنها.",
			source: "الصفحة 25 من إطار عمل تقييم أثر حماية البيانات – الأشياء المتصلة"
		},
		PIA_SEC_PHY: {
			description: "وجود نظام لمراقبة الوصول المادي إلى الأماكن المستضيفة للمعالجة (التنطيق، مرافقة الزوار، حمل الشارة، قفل الأبواب، وما إلى ذلك). <br>يرجى تحديد ما إذا كانت توجد وسائل إنذار في حال حدوث اقتحام.",
			name: "الأمن المادي",
			placeholder: "يرجى تحديد الطريقة التي تتم بها مراقبة الوصول المادي إلى أماكن استضافة المعالجة.",
			source: "الصفحة 25 من إطار عمل تقييم أثر حماية البيانات – الأشياء المتصلة"
		},
		PIA_SEC_PROT: {
			description: "وجود تدابير للحد من المخاطر المرتبطة بالمصادر غير البشرية أو تجنبها (ظواهر مناخية أو حريق أو ضرر ناتج عن المياه أو حوادث داخلية أو خارجية أو حيوانات، وما إلى ذلك.) التي يمكن أن تؤثر على أمن البيانات ذات الطابع الشخصي (التدابير الوقائية أو الكشف أو الحماية، وما إلى ذلك).",
			name: "الحماية من مصادر المخاطر غير البشرية",
			placeholder: "يرجى تحديد التدابير المتخذة من أجل الحد من المخاطر المرتبطة بالمصادر غير البشرية أو تجنبها.",
			source: "WIKI Protection_contre_les_sources_de_risques_non_humaines"
		},
		PIA_SEC_SRC: {
			description: "وجود تدابير لتجنب أن تمس مصادر المخاطر، سواء بشرية كانت أو غير بشرية، التي يمكن عدم مواجهتها، البيانات الشخصية (المنتجات الخطرة أو المناطق الجغرافية الخطرة أو نقل البيانات إلى خارج الاتحاد الأوروبي، وما إلى ذلك).",
			name: "الابتعاد عن مصادر المخاطر",
			placeholder: "يرجى تحديد الطرق والوسائل المستخدمة لتجنب المخاطر الممكن تجنبها.",
			source: "WIKI Éloignement_des_sources_de_risques"
		},
		PIA_SEC_WEB: {
			description: "الطرق والوسائل المستخدمة للتقليل من احتمالية استغلال خصائص المواقع الإلكترونية للمساس بالبيانات ذات الطابع الشخصي (الإطار المرجعي الأمني العام، تشفير التدفقات بواسطة بروتوكول أمان طبقة النقل (TLS)، سياسة إيداع ملفات تعريف الارتباط، عمليات التدقيق الأمني، وما إلى ذلك).",
			name: "حماية المواقع الإلكترونية",
			placeholder: "يرجى تحديد الطرق والوسائل المستخدمة لحماية المواقع الإلكترونية.",
			source: "WIKI Sécurité_des_sites_web"
		},
		PIA_TEC_ANO: {
			description: "وصف آليات إخفاء الهوية والضمانات التي تقدمها إزاء احتمال إعادة تحديد الهوية لاحقاً، وما هو الغرض الذي يتم استخدامها من أجله.",
			name: "إخفاء الهوية",
			placeholder: "يرجى تحديد آليات إخفاء الهوية المستخدمة",
			source: "لا يوجد"
		},
		PIA_TEC_ARCH: {
			description: "سياسة حفظ وإدارة بالأرشيفات الإلكترونية التي تحتوي على بيانات ذات طابع شخصي تضمن قيمتها، لا سيما القانونية، طوال المدة اللازمة (النقل والتخزين والترحيل والوصول والإزالة وسياسة الأرشفة وحماية السرية، وما إلى ذلك).",
			name: "الأرشفة",
			placeholder: "يرجى تحديد مجمل كيفيات حفظ وإدارة  الأرشيفات الإلكترونية التي تحتوي على بيانات ذات طابع شخصي.",
			source: "WIKI Archivage"
		},
		PIA_TEC_CHIF: {
			description: "الوسائل الموضوعة من أجل<strong>ضمان سرية البيانات</strong> المحتفظ بها (في قواعد البيانات  أو في الملفات المسطحة  أو في النسخ الاحتياطية، وما إلى ذلك) وكذا كيفيات إدارة مفاتيح التشفير (الإنشاء والاحتفاظ والتعديل في حال الاشتباه في المساس بسلامتها، وما إلى ذلك). <br><br> يرجى تحديد وسائل التشفير المستخدمة فيما يتعلق بتدفقات البيانات (الشبكة الخاصة الافتراضية (VPN)، بروتوكول أمان طبقة النقل (TLS)، وما إلى ذلك) المدمجة في عملية المعالجة.",
			name: "التشفير",
			placeholder: "يرجى تحديد الوسائل التشفيرية المستخدمة لضمان سرية البيانات وسلامتها",
			source: "الصفحة 23 من إطار عمل تقييم أثر حماية البيانات – الأشياء المتصلة "
		},
		PIA_TEC_CLO: {
			description: "الطرق المستخدمة لتقسيم عملية المعالجة.",
			name: "تقسيم عملية المعالجة",
			placeholder: "يرجى تحديد ما إذا كان من المقرر تقسيم عملية المعالجة، وكيف يتم إنجاز ذلك.",
			source: "لا يوجد"
		},
		PIA_TEC_CTLA: {
			description: "وصف الطريقة التي يتم بها تحديد ملفات تعريف المستخدمين وإسنادها. ويتعين إعطاء وصف دقيق لطرق <strong>المصادقة</strong> المستخدمة مع تحديد القواعد المنطبقة على كلمات السر عند الاقتضاء (الطول الأدنى والعناصر الإجبارية ومدة الصلاحية وعدد المحاولات الفاشلة قبل تجميد الحساب، وما إلى ذلك).",
			name: "التحكم في الوصول المنطقي",
			placeholder: "يرجى تحديد كيف يتم تحديد ملفات تعريف المستخدمين وإسنادها",
			source: "الصفحة 21 من إطار عمل تقييم أثر حماية البيانات – الأشياء المتصلة"
		},
		PIA_TEC_LOG: {
			description: "سياسات حفظ سجلات الأحداث والاحتفاظ بالآثار التي تخلفها هذه الأخيرة.",
			name: "حفظ السجلات",
			placeholder: "يرجى تحديد ما إذا كانت هناك أحداث تم الاحتفاظ بسجلاتها والمدة التي تم الاحتفاظ بآثارها فيها.",
			source: "لا يوجد "
		},
		PIA_TEC_MINI: {
			description: "يمكن التخفيف من حساسية البيانات من خلال الطرق التالية: التصفية والسحب، وتخفيف الحساسية عبر التحويل، وتقليص الطابع التعريفي للبيانات، وتقليل تراكم البيانات، والحد من الوصول إلى البيانات",
			name: "تقليل البيانات إلى الحد الأدنى",
			placeholder: "قم بوصف الطرق المستخدمة للتخفيف من حساسية البيانات.",
			source: "إطار عمل تقييم أثر حماية البيانات - الأشياء المتصلة ص. 41"
		},
		PIA_TEC_PAP: {
			description: "تُستخدم السياسات المتعلقة بالوثائق الورقية التي تحتوي على البيانات في إطار المعالجة، وهي تبين كيفية طباعتها وتخزينها وإتلافها وتبادلها.",
			name: "تأمين الوثائق الورقية",
			placeholder: "يرجى تحديد الإجراءات المتعلقة بدورة حياة الوثائق الورقية التي تتضمن بيانات ذات طابع شخصي.",
			source: "إطار عمل تقييم أثر حماية البيانات - الأشياء المتصلة ص. 21"
		},
		PIA_VAL_ACT: {
			description: "إن خطة العمل هي وصف للاستراتيجية والوسائل وفرق العمل المطلوبة لتفعيل الإجراءات التصحيحية المحددة. وينبغي تعيين مسؤول وتحديد المواعيد النهائية لكل مهمة.",
			name: "خطة العمل",
			source: "لا توجد"
		},
		PIA_VAL_CART: {
			description: "يمثل هذا الرسم البياني المخاطر الناجمة عن المعالجة والمخاطر المتبقية أخذاً بعين الاعتبار كافة التدابير التصحيحية. ويبين أنه في حال تم تنفيذ التدابير التكميلية المذكورة في خطة العمل بصورة صحيحة، يرجح أن تتقلص درجة احتمال وقوع المخاطر المتبقية و/أو تتقلص شدتها.",
			name: "خريطة المخاطر",
			source: "لا توجد"
		},
		PIA_VAL_CONC: {
			description: " إن المادة <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article35\">35-9 من اللائحة العامة لحماية البيانات</a>، تنص على أن المسؤول عن المعالجة يطلب رأي أصحاب البيانات عند الاقتضاء. <br>يمكن استقاء هذا الرأي من خلال عدة وسائل حسب السياق (دراسة داخلية أو خارجية تهم الغاية من المعالجة ووسائلها، وسؤال ممثلي العاملين أو النقابات، ودراسة استقصائية تشمل العملاء المستقبليين للمسؤول عن المعالجة.<strong><br>في حال قرر المسؤول عن المعالجة الاستغناء</strong> عن رأي أصحاب البيانات، يتعين عليه <strong>تقديم تبرير لقراره. </strong><br>وفي حال اعتبر المسؤول عن المعالجة أن <br>استقاء آراء أصحاب البيانات غير ضروري</strong>، يتعين عليه أيضاً <strong>تقديم تبرير لذلك. </strong>",
			name: "آراء أصحاب البيانات",
			source: "إطار عمل تقييم أثر حماية البيانات - الأشياء المتصلة ص. 39"
		},
		PIA_VAL_DPO: {
			description: "إن المادة <a target=\"_blank\" href=\"https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre4#Article35\">35-2 من اللائحة العامة لحماية البيانات</a>، تنص على أنه يتعين على المسؤول عن المعالجة طلب المشورة من المفوض المعني بحماية البيانات أثناء تحليلٍ للأثر مرتبط بحماية البيانات.<strong><br>يمكن أن يكون هذا الرأي معارضاً للقيام بالمعالجة، لكنه لا يقيد قرار المسؤول عن المعالجة. </strong>",
			name: "رأي المفوض المعني بحماية البيانات",
			source: "إطار عمل تقييم أثر حماية البيانات - الأشياء المتصلة ص. 36"
		},
		PIA_VAL_RT: {
			description: "<strong>يتخذ المسؤول عن المعالجة قراراً رسمياً</strong> بشأن مقبولية التدابير المختارة، والمخاطر المتبقية وخطة العمل بصورة منطقية فيما يتعلق بالرهانات المحددة مسبقاً وآراء الأطراف المعنية. وهكذا يمكن لتقييم أثر حماية البيانات أن: <br>- يُقبل،<br>- يُحسن (مع توضيح الجوانب القابلة للتحسين)؛ <br>- يُرفض (إلى جانب المعالجة).<br>عند الاقتضاء، يتعين مراجعة الخطوات السابقة حتى تتم الموافقة على تقييم أثر حماية البيانات.<br>لا يحكم هذا القرار مسبقاً على تقييم المطابقة الذي يمكن إجراؤه عند الاقتضاء من طرف الهيئة المعنية بحماية البيانات (اللجنة الوطنية للمعلوماتية والحريات في فرنسا)، مثلا في إطار إجراءات شكلية مسبقة أو تدابير مراقبة.",
			name: "تأكيد المسؤول عن المعالجة",
			source: "إطار عمل تقييم أثر حماية البيانات - الأشياء المتصلة ص. 40"
		}
	},
	title: "قاعدة المعارف"
};
var measures = {
	add: "إحداث تدبير (أو إضافة تدبير مقترح في قاعدة المعارف على اليمين)",
	default_placeholder: "قم بوصف التدابير الموجودة أو المرتقبة لضمان أمن البيانات.",
	edit: "تعديل التدبير",
	placeholder_title: "عنوان التدبير",
	remove: "حذف التدبير"
};
var misc = {
	display: "إظهار/إخفاء"
};
var modals = {
	abandon_pia: {
		additional_text: "إن الأرشفة ليست نهائية، وبالتالي يمكنك<br>متابعة التحليل لاحقا إذا دعت الحاجة إلى ذلك.",
		content: "هل ترغب في إنهاء<br>المعالجة؟"
	},
	action_plan_no_evaluation: {
		content: "يُرجى البدء في تقييم التحليل من أجل وضع خطة العمل.",
		review_section: "تقييم أحد الأجزاء"
	},
	archive: "الأرشفة",
	archive_pia: {
		archive: "أرشفة تقييم أثر حماية البيانات هذا",
		content: "<span class='strong'>يرجى الانتباه،</span><br>هل أنت متأكد من رغبتك<br>في أرشفة تقييم أثر حماية البيانات هذا؟"
	},
	ask_for_evaluation: {
		content: "إن الجزء متاح<br>للتقييم."
	},
	back_to_edition: {
		content: "تم إرسال الجزء للتعديل،<br>حيث يجب إضافة المزيد من المعلومات<br>ليتم تقييمه."
	},
	back_to_evaluation: {
		content: "تم إرسال الجزء للتقييم،<br>حيث يجب إعادة تقييم المعلومات<br>ليتم التأكيد عليه."
	},
	back_to_home: "الرجوع إلى صفحة الاستقبال",
	cancel: "إلغاء",
	close: "إغلاق",
	completed_edition: {
		content: "تم تعديل كافة الأجزاء.<br>يجب الآن تقييم التحليل."
	},
	completed_evaluation: {
		content: "تم تقييم كافة الأجزاء.<br>يمكن قبول التحليل."
	},
	"continue": "المواصلة",
	declare_measures: {
		content: "قبل تقييم المخاطر،<br>ينبغي التصريح بالتدابير<br>الموجودة أو المرتقبة.",
		declare: "التصريح بالتدابير الموجودة أو المرتقبة"
	},
	dpo_missing_evaluations: {
		comment: "التعليق",
		content: "يرجى إتمام تقييم التحليل من أجل الولوج إلى صفحة المفوض المعني بحماية البيانات.",
		remove: "الحذف",
		review_section: "تقييم أحد الأجزاء"
	},
	general_error: {
		content: "لقد حدث خطأ ما.<br>نعتذر عن هذا الإزعاج."
	},
	import_wrong_pia_file: {
		content: "إن الملف المُحمل لا يطابق ملفاً من نوع 'تقييم أثر حماية البيانات'"
	},
	import_wrong_structure_file: {
		content: "إن الملف المحمل لا يطابق ملفاً من النوع 'النموذجي'"
	},
	knowledge: {
		content: "TO TRANSLATE - Are you sure you want to delete this element?",
		remove: "TO TRANSLATE - Delete this element"
	},
	knowledges: {
		content: "TO TRANSLATE - Are you sure you want to delete this knowledge base?",
		remove: "TO TRANSLATE - Delete this knowledge base"
	},
	modal_select_text_pia: {
		content: "إن محتوى تقرير تقييم أثر حماية البيانات قد تم نسخه في حافظتك."
	},
	not_enough_measures_to_remove: {
		content: "<span class='strong'>يرجى الانتباه،</span><br>يجب إدخال تدبير واحد على الأقل: الحذف غير ممكن."
	},
	recover_version: {
		"continue": "المواصلة",
		message: "من خلال المواصلة، يمكنك إعادة نسخة {{date}} من هذا التحليل. <br><br>كما سيتم حفظ النسخة الحالية.",
		title: "استرجاع نسخة قديمة"
	},
	refuse_pia: {
		content: "بعد رفضك للتحليل، تم<br> إرساله للتقييم من أجل إجراء<br>التعديلات اللازمة."
	},
	remove_attachment: {
		comment: "التعليقات",
		content: "<span class='strong'>يرجى الانتباه،</span><br>هل أنت متأكد من رغبتك<br>في حذف هذا المرفق؟",
		keep: "الحفظ",
		remove: "الحذف"
	},
	remove_measure: {
		content: "<span class='strong'>يرجى الانتباه،</span><br>هل أنت متأكد من رغبتك<br>في حذف هذا التدبير؟",
		keep: "حفظ هذا <br>التدبير",
		remove: "حذف هذا <br>التدبير"
	},
	remove_pia: {
		content: "<span class='strong'>يرجى الانتباه،</span><br>هل أنت متأكد من رغبتك<br>في حذف تقييم أثر حماية البيانات هذا نهائياً؟",
		remove: "حذف تقييم أثر حماية البيانات هذا"
	},
	remove_question: {
		content: "هل ترغب في حذف السؤال؟",
		keep: "إلغاء",
		remove: "حذف"
	},
	remove_structure: {
		content: "<span class='strong'>يرجى الانتباه،</span><br>هل أنت متأكد من رغبتك<br>في حذف هذا النموذج؟",
		remove: "حذف هذا النموذج"
	},
	same_comment: {
		content: "<span class='strong'>انتباه،</span><br>يرجى الإدلاء بتعليق مختلف عن آخر تعليق مسجل."
	},
	signed_pia_validation: {
		content: "لإتمام تأكيد التحليل،<br>قم بإرفاق التقرير الموقع.",
		download_pia: "إظهار التقرير"
	},
	simple_pia_validation: {
		content: "لقد قمت تأكيد التحليل."
	},
	start_evaluation: "البدء في التقييم",
	unarchive_pia: {
		content: "<span class='strong'>يرجى الانتباه،</span><br>هل أنت متأكد من رغبتك<br>في إزالة تقييم أثر حماية البيانات هذا من الأرشيف؟",
		unarchive: "إزالة تقييم أثر حماية البيانات هذا من الأرشيف"
	},
	update_server_url_nok: {
		content: "TO TRANSLATE - The connection with the server is not possible: please check the filled URL.",
		introspect: "TO TRANSLATE - The Client ID and Client SECRET have not been validated by the server, please check them."
	},
	update_server_url_ok: {
		content: "تم تحديث عنوان الخادم."
	},
	validate_evaluation: {
		content: "إن الجزء جاهز<br>لتأكيد التحليل."
	},
	validate_evaluation_to_correct: {
		content: "عذراً،<br>ينبغي تصحيح عدة خانات.<br>الرجوع إلى التعديل<br>من أجل القيام بالتصحيح."
	},
	users: {
		"delete": {
			content: "TO TRANSLATE - <span class='strong'>Warning,</span><br>Are you sure you want to<br>delete this user ?",
			confirm: "TO TRANSLATE - Delete this user",
			pia_exist: "TO TRANSLATE - This user is assigned to one or more PIAs, you will need to re-assign users on them."
		}
	}
};
var onboarding = {
	dashboard: {
		step1: {
			description: "TO TRANSLATE - Click on the <strong>+</strong> to create your first PIA.",
			title: "TO TRANSLATE - Create a PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p><strong>Editors</strong> write the first version of the analysis.</p><p>They are, for example, the project managers associated with the data processing.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step3: {
			description: "TO TRANSLATE - <p><strong>Reviewers</strong> are involved in a second phase.</p><p>They use their legal or technical expertise to check the quality and compliance of the processing.</p><p>They are, for example, DPO, legal experts, ...</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step4: {
			description: "TO TRANSLATE - <p>The <strong>validator</strong> accepts or rejects the implementation of the processing. He must sign the analysis.</p><p>He is the controller, e.g. the CEO.</p>",
			title: "TO TRANSLATE - AIIA roles"
		},
		step5: {
			description: "TO TRANSLATE - <p><strong>Templates</strong> are an advanced feature. They are used to create a pre-filled basis for the analysis.</p><p>You can create templates by going to the associated section accessible from the top menu.</p>",
			title: "TO TRANSLATE - Templates"
		}
	},
	entry: {
		step1: {
			description: "TO TRANSLATE - To move from one part of the analysis to another, use the left navigation menu.",
			title: "TO TRANSLATE - Browse"
		},
		step2: {
			description: "TO TRANSLATE - This is used to explain the purpose of the processing and how it will be implemented.",
			title: "TO TRANSLATE - Context"
		},
		step3: {
			description: "TO TRANSLATE - These aim to ensure that the processing complies with the GDPR.",
			title: "TO TRANSLATE - OBLIGATIONS & RESPONSIBILITIES"
		},
		step4: {
			description: "TO TRANSLATE - These describe the security measures already planned for the processing operation and make it possible to assess its potential impact on the data subjects.",
			title: "TO TRANSLATE - Risks"
		},
		step5: {
			description: "TO TRANSLATE - This allows the DPO to express her opinion on the implementation of the processing and the controller to accept or refuse it.",
			title: "TO TRANSLATE - Validation"
		},
		step6: {
			description: "TO TRANSLATE - <p>It provides contextual assistance in carrying out the analysis and is based on the GDPR, the security guide and the CNIL's PIA guides</p><p>In addition to these contents, you can also create your own knowledge bases to easily access information specific to your organization.</p>",
			title: "TO TRANSLATE - The knowledge base"
		},
		step7: {
			description: "TO TRANSLATE - At any time during the analysis, you can download the analysis in various formats to share it with your colleagues.",
			title: "TO TRANSLATE - Export your PIA"
		}
	},
	evaluation: {
		step1: {
			description: "TO TRANSLATE - The evaluation can take an entire section into account, or at the level of each element of a section.",
			title: "TO TRANSLATE - Evaluate the PIA"
		},
		step2: {
			description: "TO TRANSLATE - <p>This evaluation indicates to the editors that elements are missing in order to make a relevant assessment.</p><p>The assessor must indicate these in the associated <strong>evaluation comment</strong> field. The editor will make the necessary corrections.</p>",
			title: "TO TRANSLATE - To correct"
		},
		step3: {
			description: "TO TRANSLATE - <p>This assessment indicates the processing elements to be revised. They are detailed in the <strong>action plan / corrective action</strong> field.</p><p>These measures will be automatically added to the action plan part of the analysis. It is necessary to implement them as soon as possible.</p>",
			title: "TO TRANSLATE - Improvable"
		},
		step4: {
			description: "TO TRANSLATE - This assessment means that this part of the processing can be implemented without modification.",
			title: "TO TRANSLATE - Acceptable"
		},
		step5: {
			description: "TO TRANSLATE - If the assessment of a section has not yet begun, the request forassessment may be cancelled to make changes to the processing description.",
			title: "TO TRANSLATE - Cancel a request"
		}
	},
	general: {
		done: "TO TRANSLATE - Confirm",
		next: "TO TRANSLATE - Next",
		skip: "TO TRANSLATE - Skip"
	},
	validated: {
		step1: {
			description: "TO TRANSLATE - A complete and validated analysis can be consulted at any time via a dedicated interface.",
			title: "TO TRANSLATE - Consult a validated PIA"
		},
		step2: {
			description: "TO TRANSLATE - It is necessary to review regularly an analysis. You can edit or duplicate it at any time to review its content according to the processing evolution.",
			title: "TO TRANSLATE - Update a validated PIA"
		}
	}
};
var opinions = {
	content: ", يعتبر(ون) أن:",
	dpo_lock: "يرجى ملء باقي الأجزاء قبل إدخال رأي المفوض المعني بحماية البيانات.",
	dpo_opinion: "رأي المفوض المعني بحماية البيانات",
	edit: "التعديل",
	people_opinion: "آراء أصحاب البيانات",
	placeholder_concerned_people_name: "أسماء أصحاب البيانات",
	placeholder_dpo_name: "أسماء المفوضين المعنيين بحماية البيانات",
	placeholder_dpo_opinion: "حدد الأسباب وراء اختيارك",
	placeholder_people_opinion: "قم بوصف كيفية جمع الآراء وتحليلها. وفي حال لم يتم البحث عن الآراء، يرجى تحديد الأسباب وراء ذلك.",
	placeholder_search_content: "تقديم مبرر لعدم طلب رأي أصحاب البيانات.",
	treatment_lock: "يرجى ملء باقي الأجزاء قبل إدخال رأي أصحاب البيانات.",
	treatment_nok: "لا يمكن تنفيذ المعالجة.",
	treatment_ok: "يمكن تنفيذ المعالجة."
};
var pia = {
	attachments: {
		add: "إضافة",
		download: "تحميل المرفق",
		loading: "TO TRANSLATE - Uploading...",
		remove: "الحذف",
		title: "المرفقات",
		no_attachment: "TO TRANSLATE - No attachment available"
	},
	footer: {
		ask_evaluation: "طلب التقييم",
		mandatory_fields: "يجب ملء كافة الخانات",
		structure_add_question: "إضافة سؤال",
		subsection_validated: "تم تقييم الجزء، في انتظار التأكيد النهائي",
		validate_evaluation: "تأكيد التقييم"
	},
	header: {
		display_action_plan: "إظهار<br>خطة العمل",
		edition: "التعديل",
		evaluation: "التقييم",
		preview: "لمحة"
	},
	sections: {
		based_on_structure_name: "بناء على النموذج:",
		homepage_link: "الرجوع إلى صفحة الاستقبال",
		refuse_pia: "تقييم أثر حماية البيانات  مرفوض",
		status: {
			evaluation: {
				cancel: "إلغاء طلب التقييم.",
				cancel_button: "إلغاء طلب التقييم",
				content: "إن تقييم هذا الجزء لم يبدأ بعد. إذا كنت ترغب في تعديل المحتويات في وضع التعديل، يجب",
				title: "في انتظار التقييم"
			},
			validation: {
				cancel: "إلغاء طلب التأكيد.",
				cancel_button: "إلغاء طلب التأكيد",
				content: "تم تقييم هذا الجزء ولم يتبق سوى التأكيد النهائي على التحليل. إذا كنت ترغب في تعديل التقييمات، يجب",
				title: "في انتظار التأكيد"
			}
		},
		validate_pia: "تأكيد تقييم أثر حماية البيانات"
	},
	statuses: [
		"جارية",
		"مرفوضة",
		"تأكيد عادي",
		"تأكيد بالتوقيع",
		"تمت الأرشفة",
		"في انتظار التأكيد"
	]
};
var questions = {
	edit: "تعديل السؤال",
	gauges: [
		"(غير محددة)",
		"ضعيفة",
		"محدودة",
		"مهمة",
		"قصوى"
	],
	placeholder_title: "عنوان السؤال (إلزامي)",
	remove: "حذف السؤال"
};
var rejection_page = {
	applied_adjustments: "التعديلات المُدخلة",
	applied_adjustments_placeholder: "قم بوصف التعديلات المدخلة على تقييم أثر حماية البيانات.",
	button: {
		abandon_treatment: "إنهاء المعالجة",
		reject_pia: "رفض تقييم أثر حماية البيانات",
		send_for_validation: "الإرسال من أجل الموافقة"
	},
	previous_rejection: "رفض سابق",
	rejection_reason: "سبب الرفض",
	rejection_reason_placeholder: "قم بوصف أسباب رفض الموافقة على تقييم أثر حماية البيانات.",
	title: "سِجل الموافقة"
};
var sections = {
	"1": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "قم بعرض المعالجة بصورة موجزة: اسمها والغاية منها ورهاناتها (الإضافات المنتظرة) وسياق استخدامها وما إلى ذلك",
						title: "ما هي المعالجة التي تتناولها الدراسة؟"
					},
					"2": {
						placeholder: "قم بوصف مسؤوليات الأطراف الفاعلة: المسؤول عن المعالجة، والمتعاقدون المحتملون من الباطن والمسؤولون المشاركون المحتملون.",
						title: "ما هي المسؤوليات المرتبطة بالمعالجة؟"
					},
					"3": {
						placeholder: " حدد المعايير، المفيدة أو التي ينبغي الامتثال لها، الواجبة التطبيق على المعالجة، لاسيما مدونات السلوك المصادق عليها والتراخيص في مجال حماية البيانات.",
						title: "ما هي المعايير الواجبة التطبيق؟"
					}
				},
				short_help: "يُمكّنك هذا الجزء من تحديد موضوع الدراسة وعرضه.",
				title: "نظرة عامة"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "قم بعرض البيانات المُجمعة والمُعالَجة مع تحديد مدة الاحتفاظ بها والجهات المستقبلة والأشخاص الذين بإمكانهم الوصول إليها.",
						title: "ما هي البيانات المعالَجة؟"
					},
					"2": {
						placeholder: "قم بوصف دورة حياة البيانات (بدءاً من تجميعها وحتى إتلافها، مروراً بعملية التخزين، ومختلف مراحل المعالجة، والأرشفة وغيرها , مثلا باستخدام رسم تخطيطي لتدفق البيانات (يمكنك إضافته كمرفق) ووصف كل عملية تم تنفيذها.",
						title: "كيف تسير دورة حياة البيانات (وصف وظيفي)؟"
					},
					"3": {
						placeholder: "قم باستعراض وسائط البيانات الخاصة بمعالجتك (الأنظمة المعلوماتية، والخوادم، والبرامج، والشبكات، والأشخاص، والوسائل الورقية وغيرها).",
						title: "ما هي وسائط البيانات؟"
					}
				},
				short_help: "يُمكّنك هذا الجزء من تحديد ووصف المعالجة المعنية بصورة مفصلة.",
				title: "البيانات والعمليات والوسائط"
			}
		},
		short_help: "يمكّنك هذا الجزء من الحصول على رؤية واضحة لمعالجة البيانات الشخصية المعنية.",
		title: "السياق"
	},
	"2": {
		items: {
			"1": {
				questions: {
					"1": {
						placeholder: "وضح كيف أن الغايات من المعالجة محددة وصريحة ومشروعة.",
						short_title: "الغايات",
						title: "هل الغايات من المعالجة محددة وصريحة ومشروعة؟"
					},
					"2": {
						placeholder: "قم بعرض أسس معالجتك (على سبيل المثال، الموافقة وتنفيذ العقد والالتزام القانوني والمصالح الحيوية وغيرها).",
						short_title: "الأساس",
						title: "ما هي الأسس التي تجعل معالجتك قانونية؟"
					},
					"3": {
						placeholder: "وضح كيف أن كل واحدة من البيانات المجمعة ضرورية لغايات معالجتك.",
						short_title: "بيانات مناسبة",
						title: "هل البيانات المجمعة مناسبة وذات صلة وتقتصر على ما هو ضروري فيما يتعلق بالغايات من معالجتها (تقليل البيانات إلى الحد الأدنى)؟"
					},
					"4": {
						placeholder: "قم بوصف التدابير المرتقبة لضمان جودة البيانات.",
						short_title: "بيانات دقيقة",
						title: "هل البيانات دقيقة ومُحدّثة؟"
					},
					"5": {
						placeholder: "وضح كيف أن مدة الاحتفاظ بالبيانات المرتقبة ضرورية لتحقيق غايات المعالجة، وذلك في غياب التزام قانوني يفرض نوعية احتفاظ محددة.",
						short_title: "مدة الاحتفاظ",
						title: "ما هي مدة الاحتفاظ بالبيانات؟"
					}
				},
				short_help: "يُمكّنك هذا الجزء من إظهار مشروعية معالجتك والبيانات المعالَجة.",
				title: "التناسب والضرورة"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "قم بوصف المعلومة التي يُرتقب تقديمها لأصحاب البيانات والوسائل المختارة لتقديم هذه المعلومة.",
						short_title: "إبلاغ الأشخاص",
						title: "كيف يتم إبلاغ أصحاب البيانات بشأن المعالجة؟"
					},
					"2": {
						placeholder: "قم بوصف الأساليب التي ستُعتمد لنيل موافقة أصحاب البيانات.",
						short_title: "الحصول على الموافقة",
						title: "عند الاقتضاء، كيف يتم الحصول على موافقة أصحاب البيانات؟"
					},
					"3": {
						placeholder: "قم بوصف الأساليب التي ستُعتمد للسماح لأصحاب البيانات بالوصول إلى بياناتهم واستلامها أو إرسالها.",
						short_title: "الحق في الوصول والنقل",
						title: "كيف يمكن لأصحاب البيانات ممارسة حقهم في الوصول إلى البيانات وحقهم في نقلها؟"
					},
					"4": {
						placeholder: "قم بوصف الكيفيات التي ستُعتمد من أجل السماح لأصحاب البيانات بتعديل بياناتهم وحذفها.",
						short_title: "الحق في التعديل والحذف",
						title: "كيف يمكن لأصحاب البيانات ممارسة حقهم في التعديل وحقهم في الحذف (الحق في النسيان)؟"
					},
					"5": {
						placeholder: " قم بوصف الكيفيات التي ستُعتمد من أجل السماح لأصحاب البيانات بتقييد معالجة بياناتهم والاعتراض عليها.",
						short_title: "الحق في التقييد والاعتراض",
						title: "كيف يمكن لأصحاب البيانات ممارسة حقهم في التقييد وحقهم في الاعتراض؟"
					},
					"6": {
						placeholder: " قم بوصف نطاق مسؤوليات كل متعاقد من الباطن ووضح النقاط التي تحدد التزاماته في العقود ومدونات السلوك والتراخيص.",
						short_title: "التعاقد من الباطن",
						title: "هل التزامات المتعاقدين من الباطن محددة ومدرجة في العقود بشكل واضح؟"
					},
					"7": {
						placeholder: "قم بتحديد كل بلد من خارج الاتحاد الأوروبي يتم فيه تخزين أو معالجة البيانات، ووضح ما إذا كان معترفاً به على أنه يتصرف بصورة مناسبة أو قم بوصف البنود التي تؤطر عملية النقل.",
						short_title: "عمليات النقل",
						title: "في حال نقل البيانات إلى خارج الاتحاد الأوروبي، هل البيانات محمية بصورة مماثلة؟"
					}
				},
				short_help: "يُمكّنك هذا الجزء من إظهار أنك توظف الوسائل اللازمة للسماح لأصحاب البيانات بممارسة حقوقهم.",
				title: "تدابير حماية الحقوق"
			}
		},
		short_help: "يُمكّنك هذا الجزء من بناء نظام امتثال لمبادئ حماية الحياة الخاصة.",
		title: "المبادئ الأساسية"
	},
	"3": {
		items: {
			"1": {
				short_help: "يُمكّنك هذا الجزء من استعراض التدابير (الموجودة أو المرتقبة) التي تساهم في الحفاظ على أمن البيانات.",
				title: "التدابير الموجودة أو المرتقبة"
			},
			"2": {
				questions: {
					"1": {
						placeholder: "قم بإدخال الآثار المحتملة",
						title: "ما هي أبرز <span class='green-highlight'>الآثار التي قد يواجهها أصحاب البيانات</span> في حال وقوع المخاطر؟"
					},
					"2": {
						placeholder: "قم بإدخال التهديدات",
						title: "ما هي أبرز <span class='green-highlight'>التهديدات</span> التي قد تؤدي إلى تحقق المخاطر؟"
					},
					"3": {
						placeholder: "قم بإدخال مصادر المخاطر",
						title: "ما هي <span class='green-highlight'>مصادر</span> المخاطر التي قد تكون سبباً فيها؟"
					},
					"4": {
						placeholder: "اضغط هنا لاختيار التدابير المساهمة في معالجة هذه المخاطر.",
						title: "ما هي <span class='green-highlight'>التدابير الأولية</span>، من بين تلك المحددة، التي تساهم في معالجة المخاطر؟"
					},
					"5": {
						placeholder: "علّل الشدة المُقدرة هنا.",
						title: "كيف تُقدر <span class='green-highlight'>شدة المخاطر</span>، لاسيما فيما يتعلق بالآثار المحتملة والتدابير المرتقبة؟"
					},
					"6": {
						placeholder: "علّل درجة الاحتمال المُقدرة هنا.",
						title: "كيف تُقدر <span class='green-highlight'>درجة احتمال وقوع المخاطر</span>، لاسيما فيما يتعلق بالتهديدات ومصادر المخاطر والتدابير المرتقبة؟"
					}
				},
				short_help: "قم بتحليل أسباب وتداعيات الوصول غير المشروع للبيانات، وقدر شدته ودرجة احتمال وقوعه.",
				title: "الوصول غير المشروع للبيانات"
			},
			"3": {
				questions: {
					"1": {
						placeholder: "قم بإدخال الآثار المحتملة",
						title: "ما هي أبرز <span class='green-highlight'>الآثار التي قد يواجهها أصحاب البيانات</span> في حال وقوع المخاطر؟"
					},
					"2": {
						placeholder: "قم بإدخال التهديدات",
						title: "ما هي أبرز <span class='green-highlight'>التهديدات</span> التي قد تؤدي إلى تحقق المخاطر؟"
					},
					"3": {
						placeholder: "قم بإدخال مصادر المخاطر",
						title: "ما هي <span class='green-highlight'>مصادر</span> المخاطر التي قد تكون سبباً فيها؟"
					},
					"4": {
						placeholder: "اضغط هنا لاختيار التدابير المساهمة في معالجة هذه المخاطر.",
						title: "ما هي <span class='green-highlight'>التدابير</span>، من بين تلك المحددة، التي تساهم في معالجة المخاطر؟"
					},
					"5": {
						placeholder: "علّل الشدة المُقدرة هنا.",
						title: "كيف تُقدر <span class='green-highlight'>شدة المخاطر</span>، لاسيما فيما يتعلق بالآثار المحتملة والتدابير المرتقبة؟"
					},
					"6": {
						placeholder: "علّل درجة الاحتمال المُقدرة هنا.",
						title: "كيف تُقدر <span class='green-highlight'>درجة احتمال وقوع المخاطر</span>، لاسيما فيما يتعلق بالتهديدات ومصادر المخاطر والتدابير المرتقبة؟"
					}
				},
				short_help: "قم بتحليل أسباب وتداعيات تعديلٍ غير مرغوبٍ فيه للبيانات، وقدر شدته ودرجة احتمال وقوعه.",
				title: "التعديل غير المرغوب فيه للبيانات"
			},
			"4": {
				questions: {
					"1": {
						placeholder: "قم بإدخال الآثار المحتملة",
						title: "ما هي أبرز <span class='green-highlight'>الآثار التي سيواجهها أصحاب البيانات</span> في حال وقوع المخاطر؟"
					},
					"2": {
						placeholder: "قم بإدخال التهديدات",
						title: "ما هي أبرز <span class='green-highlight'>التهديدات</span> التي قد تؤدي إلى تحقق هذه المخاطر؟"
					},
					"3": {
						placeholder: "قم بإدخال مصادر المخاطر",
						title: "ما هي <span class='green-highlight'>مصادر</span> المخاطر التي قد تكون سبباً فيها؟"
					},
					"4": {
						placeholder: "اضغط هنا لاختيار التدابير المساهمة في معالجة هذه المخاطر.",
						title: "ما هي <span class='green-highlight'>التدابير</span>، من بين تلك المحددة، التي تساهم في معالجة المخاطر؟"
					},
					"5": {
						placeholder: "علّل الشدة المُقدرة هنا.",
						title: "كيف تُقدر <span class='green-highlight'>شدة المخاطر</span>، لاسيما فيما يتعلق بالآثار المحتملة والتدابير المرتقبة؟"
					},
					"6": {
						placeholder: "علّل درجة الاحتمال المُقدرة هنا.",
						title: "كيف تُقدر <span class='green-highlight'>درجة احتمال وقوع المخاطر</span>، لاسيما فيما يتعلق بالتهديدات ومصادر المخاطر والتدابير المرتقبة؟"
					}
				},
				short_help: "قم بتحليل أسباب وتداعيات اختفاء البيانات، وقدر شدته ودرجة احتمال وقوعه.",
				title: "اختفاء البيانات"
			},
			"5": {
				short_help: "يُمكّنك هذا التمثيل البصري من الحصول على نظرة شاملة وموجزة لعمل التدابير فيما يخص مكونات المخاطر التي تساهم في معالجتها.",
				title: "نظرة عامة على المخاطر"
			}
		},
		short_help: "يُمكّنك هذا الجزء من تقييم المخاطر على الحياة الخاصة، مع أخذ التدابير الموجودة أو المرتقبة بعين الاعتبار.",
		title: "المخاطر"
	},
	"4": {
		items: {
			"1": {
				short_help: "يُمكّنك هذا التمثيل البصري من مقارنة تموضع المخاطر مع بعضها، قبل وبعد تطبيق التدابير التكميلية.",
				title: "خريطة المخاطر"
			},
			"2": {
				short_help: "خَطّط بالتفصيل لتنفيذ التدابير التكميلية المحددة خلال تقييم أثر حماية البيانات. يُحدَّث هذا الجزء تلقائيا وفقاً للتقييمات التي يخضع لها كل عنصر من عناصر تحليل الأثر.",
				title: "خطة العمل"
			},
			"3": {
				short_help: "قم بعرض توصية الشخص المسؤول عن جوانب المعلوميات والحريات (المفوض المعني بحماية البيانات إن وُجد). قم كذلك بعرض رأي أصحاب البيانات أو ممثليهم.",
				title: "آراء المفوض المعني بحماية البيانات وأصحاب البيانات "
			},
			"4": {
				title: "المصادقة على تقييم أثر حماية البيانات"
			},
			"5": {
				title: "تقييم أثر حماية البيانات مرفوض"
			}
		},
		short_help: "يُمكّنك هذا الجزء من إعداد تأكيد تقييم أثر حماية البيانات وجعلها رسمية.",
		title: "التأكيد"
	}
};
var settings = {
	content: "يرجى تقديم عنوان (URL) للخادم البعيد:",
	title: "الإعدادات",
	update: "تحديث عنوان (URL)"
};
var summary = {
	action_plan: {
		fundamental_principles: "المبادئ الأساسية",
		implementation_date: "التاريخ المحدد للتنفيذ",
		implementation_responsible: "المسؤول عن التنفيذ",
		measures: "التدابير الموجودة أو المرتقبة",
		no_action_plan: "لا توجد خطة عمل مسجلة.",
		risks: "المخاطر",
		title: "خطة العمل"
	},
	actions: {
		complete_download: "تحميل التحليل كاملاً",
		complete_download_desc: "في أرشيف (.zip)، قم بتحميل+ محتويات الوصف (النص (.doc) والصور) والمرفقات ذات الصلة وخطة العمل بصيغة (.csv).",
		individual_download: "التحميل",
		individual_download_desc: "قم  بتحميل عناصر محددة من التحليل.",
		individual_download_pdf: "TO TRANSLATE - PIA report (.pdf)",
		individual_download_doc: "المحتويات النصية (ملف '.doc')",
		individual_download_images: "عناصر بصرية (ملفات '.png'): نظرة عامة على المخاطر، وخريطة المخاطر، وخطة العمل",
		individual_download_json: " التحليل الذي يتعين توريده في أداة تقييم أثر حماية البيانات (ملف '.json')",
		individual_download_select: "قم باختيار العناصر التي سيتم بتحميلها:",
		individual_to_download: "التحميل",
		print: "طبع التحليل",
		print_and_download: "الطبع والتحميل"
	},
	attachments: "المرفقات",
	concerned_people_name: "أسماء أصحاب البيانات",
	concerned_people_opinion: "آراء أصحاب البيانات",
	concerned_people_searched_opinion: "البحث عن آراء أصحاب البيانات",
	concerned_people_status: "أوضاع أصحاب البيانات",
	concerned_people_unsearched_opinion_comment: "السبب وراء عدم طلب رأي أصحاب البيانات",
	content_choice: [
		"لا يمكن تنفيذ المعالجة.",
		"يمكن تنفيذ المعالجة."
	],
	creation_date: "تاريخ الإنشاء",
	csv_action_plan_comment: "تعليقات خطة العمل",
	csv_evaluation_comment: "تعليقات التقييم",
	csv_file_title: "خطة العمل",
	csv_implement_date: "تاريخ التنفيذ المُقدر",
	csv_people_in_charge: "المسؤول عن التنفيذ",
	csv_section: "الجزء",
	csv_title_object: "عنوان الغرض المعني",
	download_csv: "خطة العمل (ملف '.csv')",
	dpo_name: "اسم المفوض المعني بحماية البيانات",
	dpo_opinion: "رأي المفوض المعني بحماية البيانات",
	dpo_status: "وضع المفوض المعني بحماية البيانات",
	gauges: {
		"1": "ضعيفة",
		"2": "محدودة",
		"3": "مهمة",
		"4": "قصوى"
	},
	modification_made: "التعديلات المدخلة",
	people_search_status_nok: "لم يتم طلب رأي أصحاب البيانات.",
	people_search_status_ok: "تم طلب رأي أصحاب البيانات.",
	pia_assessor: "اسم المُقيّم",
	pia_author: "اسم صاحب الأداة",
	pia_name: "اسم تقييم أثر حماية البيانات",
	pia_validator: "اسم المسؤول عن التأكيد",
	preview_dpo_opinion: "آراء المفوض المعني بحماية البيانات وأصحاب البيانات",
	preview_edition: "الإدخال",
	preview_evaluation: "التقييم",
	preview_no_data: "لا توجد أي معلومات يمكن إظهارها.",
	preview_status: "الوضع",
	preview_subtitle: "معلومات عامة",
	preview_title: "لمحة عن التحليل",
	preview_validation: "التأكيد",
	preview_validation_section: "التأكيد",
	preview_guests: "TO TRANSLATE - Guests",
	previous_page: "الرجوع إلى الصفحة السابقة",
	rejection_reason: "سبب الرفض",
	revision: {
		current_version: "النسخة الحالية",
		pia_version: "نسخ تقييم أثر حماية البيانات",
		restore_version: "الاسترجاع",
		revision: "النسخ والمراجعة",
		save: "إحداث نسخة جديدة",
		show: "إظهار{{length}}  النسخ(ة)"
	},
	risks_cartography_title: "خريطة المخاطر",
	risks_overview_title: "نظرة عامة على المخاطر",
	title: "المعلومات الخاصة بتقييم أثر حماية البيانات"
};
var users = {
	add_new_user: "TO TRANSLATE - Add a new user",
	cancel: "TO TRANSLATE - Cancel",
	choose_profile: "TO TRANSLATE - Choose a profile for this user",
	"continue": "TO TRANSLATE - Continue",
	data: "TO TRANSLATE - Data",
	edit_user: "TO TRANSLATE - Edit an user",
	email: "TO TRANSLATE - Email",
	first_name: "TO TRANSLATE - First name",
	functional_admin: "TO TRANSLATE - Functional administrator",
	last_name: "TO TRANSLATE - Last name",
	new_user_button: "TO TRANSLATE - New user",
	profile: "TO TRANSLATE - Profile",
	remove: "TO TRANSLATE - Delete",
	remove_current_user_error_message: "TO TRANSLATE - You can't delete your own account.",
	remove_last_functional_admin_error_message: "TO TRANSLATE - You cannot delete this user because at least one Technical Administrator account must remain.",
	remove_user_with_linked_pias_error_message: "TO TRANSLATE - Several PIAs are attached to this user, so you cannot delete him.",
	technical_admin: "TO TRANSLATE - Technical administrator",
	update: "TO TRANSLATE - Update",
	user: "TO TRANSLATE - User",
	state: "TO TRANSLATE - Account's state",
	errors: {
		edit_user: {
			"406": "TO TRANSLATE - The information provided when creating the account is invalid."
		}
	},
	"delete": {
		confirm: "TO TRANSLATE - Remove user",
		content: "TO TRANSLATE - Are you sure you want to delete this user?"
	},
	access_locked: {
		"false": "TO TRANSLATE - Active",
		"true": "TO TRANSLATE - Waiting for activation"
	},
	role: {
		label: "TO TRANSLATE - Role(s)",
		author: "TO TRANSLATE - Author",
		evaluator: "TO TRANSLATE - Evaluator",
		validator: "TO TRANSLATE - Validator",
		guest: "TO TRANSLATE - Guest"
	}
};
var validation_page = {
	add_signed_pia: "إضافة تقرير تقييم أثر حماية البيانات مُوقعاً",
	after_reading: "بعد قراءة كاملة لتقييم أثر حماية البيانات المتعلق بمعالجة البيانات المرتبطة بنشاط: ",
	button: {
		rejection: "رفض التأكيد",
		signed_validation: "الحصول على توقيع المسؤول على تقييم أثر حماية البيانات",
		simple_validation: "تأكيد عادي"
	},
	confirmation1: "أؤكد أن وصف سياق معالجتي يتوافق مع الواقع.",
	confirmation2: "أؤكد معرفتي بالمخاطر الموجودة فيما يتعلق بالتدابير المنفذة حالياً أو المرتقبة.",
	confirmation3: "أصادق على التدابير التصحيحية المذكورة.",
	confirmation4: "ألتزم بتنفيذ التدابير التصحيحية المذكورة في أقرب الآجال.",
	latest_signed_attachment: "آخر مرفق موقع",
	mandatory_fields: "يجب تأشير كافة الخانات",
	remove_attachment: "الحذف",
	responsible: "المسؤول عن تأكيد تقييم أثر حماية البيانات:",
	signed_attachments_history: "سِجل المرفقات الموقعة",
	tools: {
		dashboard: "صفحة الاستقبال",
		display_pia: "عرض التقرير"
	},
	validated_pia_with_signature: "تم التأكيد",
	waiting_for_signature: "في انتظار التوقيع على تقرير تقييم أثر حماية البيانات"
};
var ar = {
	about: about,
	action_plan: action_plan,
	authentication: authentication,
	cartography: cartography,
	comments: comments,
	conflict: conflict,
	date: date,
	errors: errors,
	evaluations: evaluations,
	header: header,
	help: help,
	homepage: homepage,
	knowledge_base: knowledge_base,
	measures: measures,
	misc: misc,
	modals: modals,
	onboarding: onboarding,
	opinions: opinions,
	"overview-risks": {
	important: "مهمة",
	limited: "محدودة",
	maximal: "قصوى",
	measures: "التدابير",
	negligible: "ضعيفة",
	potential_impacts: "الآثار المحتملة",
	"risk-access_x": "الشدة",
	"risk-access_y": "درجة الاحتمال",
	"risk-change_x": "الشدة",
	"risk-change_y": "درجة الاحتمال",
	"risk-disappearance_x": "الشدة",
	"risk-disappearance_y": "درجة الاحتمال",
	sources: "المصادر",
	threat: "التهديدات"
},
	pia: pia,
	questions: questions,
	rejection_page: rejection_page,
	sections: sections,
	settings: settings,
	summary: summary,
	users: users,
	validation_page: validation_page
};

class PiaTranslateLoader {
    getTranslation(lang) {
        return Observable.create((observer) => {
            switch (lang) {
                case 'bg':
                    observer.next(bg);
                    break;
                case 'cz':
                    observer.next(cz);
                    break;
                case 'de':
                    observer.next(de);
                    break;
                case 'dk':
                    observer.next(dk);
                    break;
                case 'el':
                    observer.next(el);
                    break;
                case 'en':
                    observer.next(en);
                    break;
                case 'es':
                    observer.next(es);
                    break;
                case 'et':
                    observer.next(et);
                    break;
                case 'fi':
                    observer.next(fi);
                    break;
                case 'fr':
                    observer.next(fr);
                    break;
                case 'hr':
                    observer.next(hr);
                    break;
                case 'hu':
                    observer.next(hu);
                    break;
                case 'it':
                    observer.next(it);
                    break;
                case 'lt':
                    observer.next(lt);
                    break;
                case 'lv':
                    observer.next(lv);
                    break;
                case 'nl':
                    observer.next(nl);
                    break;
                case 'no':
                    observer.next(no);
                    break;
                case 'pl':
                    observer.next(pl);
                    break;
                case 'pt':
                    observer.next(pt);
                    break;
                case 'ro':
                    observer.next(ro);
                    break;
                case 'sl':
                    observer.next(sl);
                    break;
                case 'sv':
                    observer.next(sv);
                    break;
                case 'ar':
                    observer.next(ar);
                    break;
                default:
                    observer.next(fr);
            }
            observer.complete();
        });
    }
}

registerLocaleData(localeBG, 'bg');
registerLocaleData(localeEN, 'en');
registerLocaleData(localeCS, 'cz');
registerLocaleData(localeDA, 'dk');
registerLocaleData(localeDE, 'de');
registerLocaleData(localeEL, 'el');
registerLocaleData(localeES, 'es');
registerLocaleData(localeET, 'et');
registerLocaleData(localeFI, 'fi');
registerLocaleData(localeFR, 'fr');
registerLocaleData(localeHR, 'hr');
registerLocaleData(localeHU, 'hu');
registerLocaleData(localeIT, 'it');
registerLocaleData(localeLT, 'lt');
registerLocaleData(localeLV, 'lv');
registerLocaleData(localeNL, 'nl');
registerLocaleData(localeNB, 'no');
registerLocaleData(localePL, 'pl');
registerLocaleData(localePT, 'pt');
registerLocaleData(localeRO, 'ro');
registerLocaleData(localeSL, 'sl');
registerLocaleData(localeSV, 'sv');
registerLocaleData(localeAR, 'ar');
class PiaI18nModule {
    static forRoot() {
        return {
            ngModule: PiaI18nModule
        };
    }
}
PiaI18nModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PiaI18nModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PiaI18nModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: PiaI18nModule, imports: [CommonModule, i1.TranslateModule], exports: [TranslateModule] });
PiaI18nModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PiaI18nModule, providers: [TranslateService], imports: [CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: PiaTranslateLoader,
                deps: [HttpClient]
            }
        }), TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PiaI18nModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useClass: PiaTranslateLoader,
                                deps: [HttpClient]
                            }
                        })
                    ],
                    exports: [TranslateModule],
                    providers: [TranslateService]
                }]
        }] });

/*
 * Public API Surface of pia-i18n
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PiaI18nModule };
